(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$Lg(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$Lg(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$Sg(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Tg(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Ug = $c79bde28d689cb05$var$Og(!0), $c79bde28d689cb05$var$Vg = $c79bde28d689cb05$var$Og(!1), $c79bde28d689cb05$var$Wg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Xg = null, $c79bde28d689cb05$var$Yg = null, $c79bde28d689cb05$var$Zg = null;
function $c79bde28d689cb05$var$$g() {
    $c79bde28d689cb05$var$Zg = $c79bde28d689cb05$var$Yg = $c79bde28d689cb05$var$Xg = null;
}
function $c79bde28d689cb05$var$ah(a) {
    var b = $c79bde28d689cb05$var$Wg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$ch(a, b) {
    $c79bde28d689cb05$var$Xg = a;
    $c79bde28d689cb05$var$Zg = $c79bde28d689cb05$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$dh = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$eh(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Yg) {
            if (null === $c79bde28d689cb05$var$Xg) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Yg = a;
            $c79bde28d689cb05$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Yg = $c79bde28d689cb05$var$Yg.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$fh = null;
function $c79bde28d689cb05$var$gh(a) {
    null === $c79bde28d689cb05$var$fh ? $c79bde28d689cb05$var$fh = [
        a
    ] : $c79bde28d689cb05$var$fh.push(a);
}
function $c79bde28d689cb05$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$ih(a, d);
}
function $c79bde28d689cb05$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$jh = !1;
function $c79bde28d689cb05$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$ih(a, c);
}
function $c79bde28d689cb05$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$th = {}, $c79bde28d689cb05$var$uh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th), $c79bde28d689cb05$var$vh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th), $c79bde28d689cb05$var$wh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th);
function $c79bde28d689cb05$var$xh(a) {
    if (a === $c79bde28d689cb05$var$th) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$yh(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$wh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$vh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, $c79bde28d689cb05$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, b);
}
function $c79bde28d689cb05$var$zh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$vh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$wh);
}
function $c79bde28d689cb05$var$Ah(a) {
    $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
    var b = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$vh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, c));
}
function $c79bde28d689cb05$var$Bh(a) {
    $c79bde28d689cb05$var$vh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$vh));
}
var $c79bde28d689cb05$var$L = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Dh = [];
function $c79bde28d689cb05$var$Eh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Dh.length; a++)$c79bde28d689cb05$var$Dh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Dh.length = 0;
}
var $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Hh = 0, $c79bde28d689cb05$var$M = null, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$Ih = !1, $c79bde28d689cb05$var$Jh = !1, $c79bde28d689cb05$var$Kh = 0, $c79bde28d689cb05$var$Lh = 0;
function $c79bde28d689cb05$var$P() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Nh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Hh = f;
    $c79bde28d689cb05$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Fh.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Oh : $c79bde28d689cb05$var$Ph;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Jh) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Jh = !1;
            $c79bde28d689cb05$var$Kh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Qh;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Jh);
    }
    $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Rh;
    b = null !== $c79bde28d689cb05$var$N && null !== $c79bde28d689cb05$var$N.next;
    $c79bde28d689cb05$var$Hh = 0;
    $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = $c79bde28d689cb05$var$M = null;
    $c79bde28d689cb05$var$Ih = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$Sh() {
    var a = 0 !== $c79bde28d689cb05$var$Kh;
    $c79bde28d689cb05$var$Kh = 0;
    return a;
}
function $c79bde28d689cb05$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState = $c79bde28d689cb05$var$O = a : $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$O.next = a;
    return $c79bde28d689cb05$var$O;
}
function $c79bde28d689cb05$var$Uh() {
    if (null === $c79bde28d689cb05$var$N) {
        var a = $c79bde28d689cb05$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$N.next;
    var b = null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState : $c79bde28d689cb05$var$O.next;
    if (null !== b) $c79bde28d689cb05$var$O = b, $c79bde28d689cb05$var$N = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$N = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$N.memoizedState,
            baseState: $c79bde28d689cb05$var$N.baseState,
            baseQueue: $c79bde28d689cb05$var$N.baseQueue,
            queue: $c79bde28d689cb05$var$N.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState = $c79bde28d689cb05$var$O = a : $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$O.next = a;
    }
    return $c79bde28d689cb05$var$O;
}
function $c79bde28d689cb05$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$Wh(a) {
    var b = $c79bde28d689cb05$var$Uh(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$M.lanes |= m;
                $c79bde28d689cb05$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$M.lanes |= f, $c79bde28d689cb05$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$Xh(a) {
    var b = $c79bde28d689cb05$var$Uh(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$Yh() {}
function $c79bde28d689cb05$var$Zh(a, b) {
    var c = $c79bde28d689cb05$var$M, d = $c79bde28d689cb05$var$Uh(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$dh = !0);
    d = d.queue;
    $c79bde28d689cb05$var$$h($c79bde28d689cb05$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$O && $c79bde28d689cb05$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$bi(9, $c79bde28d689cb05$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$Q) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Hh & 30) || $c79bde28d689cb05$var$di(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$ei(b) && $c79bde28d689cb05$var$fi(a);
}
function $c79bde28d689cb05$var$ai(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$ei(b) && $c79bde28d689cb05$var$fi(a);
    });
}
function $c79bde28d689cb05$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$ih(a, 1);
    null !== b && $c79bde28d689cb05$var$gi(b, a, 1, -1);
}
function $c79bde28d689cb05$var$hi(a) {
    var b = $c79bde28d689cb05$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ii.bind(null, $c79bde28d689cb05$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$ji() {
    return $c79bde28d689cb05$var$Uh().memoizedState;
}
function $c79bde28d689cb05$var$ki(a, b, c, d) {
    var e = $c79bde28d689cb05$var$Th();
    $c79bde28d689cb05$var$M.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    var e = $c79bde28d689cb05$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$N) {
        var g = $c79bde28d689cb05$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Mh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$bi(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$M.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$bi(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$mi(a, b) {
    return $c79bde28d689cb05$var$ki(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$$h(a, b) {
    return $c79bde28d689cb05$var$li(2048, 8, a, b);
}
function $c79bde28d689cb05$var$ni(a, b) {
    return $c79bde28d689cb05$var$li(4, 2, a, b);
}
function $c79bde28d689cb05$var$oi(a, b) {
    return $c79bde28d689cb05$var$li(4, 4, a, b);
}
function $c79bde28d689cb05$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$li(4, 4, $c79bde28d689cb05$var$pi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$ri() {}
function $c79bde28d689cb05$var$si(a, b) {
    var c = $c79bde28d689cb05$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$ti(a, b) {
    var c = $c79bde28d689cb05$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$ui(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Hh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$dh = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$M.lanes |= c, $c79bde28d689cb05$var$rh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$vi(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Gh.transition;
    $c79bde28d689cb05$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Gh.transition = d;
    }
}
function $c79bde28d689cb05$var$wi() {
    return $c79bde28d689cb05$var$Uh().memoizedState;
}
function $c79bde28d689cb05$var$xi(a, b, c) {
    var d = $c79bde28d689cb05$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$zi(a)) $c79bde28d689cb05$var$Ai(b, c);
    else if (c = $c79bde28d689cb05$var$hh(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$R();
        $c79bde28d689cb05$var$gi(c, a, d, e);
        $c79bde28d689cb05$var$Bi(c, b, d);
    }
}
function $c79bde28d689cb05$var$ii(a, b, c) {
    var d = $c79bde28d689cb05$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$zi(a)) $c79bde28d689cb05$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$hh(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$R(), $c79bde28d689cb05$var$gi(c, a, d, e), $c79bde28d689cb05$var$Bi(c, b, d));
    }
}
function $c79bde28d689cb05$var$zi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$M || null !== b && b === $c79bde28d689cb05$var$M;
}
function $c79bde28d689cb05$var$Ai(a, b) {
    $c79bde28d689cb05$var$Jh = $c79bde28d689cb05$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$Rh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$P,
    useContext: $c79bde28d689cb05$var$P,
    useEffect: $c79bde28d689cb05$var$P,
    useImperativeHandle: $c79bde28d689cb05$var$P,
    useInsertionEffect: $c79bde28d689cb05$var$P,
    useLayoutEffect: $c79bde28d689cb05$var$P,
    useMemo: $c79bde28d689cb05$var$P,
    useReducer: $c79bde28d689cb05$var$P,
    useRef: $c79bde28d689cb05$var$P,
    useState: $c79bde28d689cb05$var$P,
    useDebugValue: $c79bde28d689cb05$var$P,
    useDeferredValue: $c79bde28d689cb05$var$P,
    useTransition: $c79bde28d689cb05$var$P,
    useMutableSource: $c79bde28d689cb05$var$P,
    useSyncExternalStore: $c79bde28d689cb05$var$P,
    useId: $c79bde28d689cb05$var$P,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Oh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ki(4194308, 4, $c79bde28d689cb05$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$xi.bind(null, $c79bde28d689cb05$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$hi,
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$hi(!1), b = a[0];
        a = $c79bde28d689cb05$var$vi.bind(null, a[1]);
        $c79bde28d689cb05$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$M, e = $c79bde28d689cb05$var$Th();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$Q) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Hh & 30) || $c79bde28d689cb05$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$mi($c79bde28d689cb05$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$bi(9, $c79bde28d689cb05$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$Th(), b = $c79bde28d689cb05$var$Q.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Ph = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$si,
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$$h,
    useImperativeHandle: $c79bde28d689cb05$var$qi,
    useInsertionEffect: $c79bde28d689cb05$var$ni,
    useLayoutEffect: $c79bde28d689cb05$var$oi,
    useMemo: $c79bde28d689cb05$var$ti,
    useReducer: $c79bde28d689cb05$var$Wh,
    useRef: $c79bde28d689cb05$var$ji,
    useState: function() {
        return $c79bde28d689cb05$var$Wh($c79bde28d689cb05$var$Vh);
    },
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$Uh();
        return $c79bde28d689cb05$var$ui(b, $c79bde28d689cb05$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$Wh($c79bde28d689cb05$var$Vh)[0], b = $c79bde28d689cb05$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$Yh,
    useSyncExternalStore: $c79bde28d689cb05$var$Zh,
    useId: $c79bde28d689cb05$var$wi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Qh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$si,
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$$h,
    useImperativeHandle: $c79bde28d689cb05$var$qi,
    useInsertionEffect: $c79bde28d689cb05$var$ni,
    useLayoutEffect: $c79bde28d689cb05$var$oi,
    useMemo: $c79bde28d689cb05$var$ti,
    useReducer: $c79bde28d689cb05$var$Xh,
    useRef: $c79bde28d689cb05$var$ji,
    useState: function() {
        return $c79bde28d689cb05$var$Xh($c79bde28d689cb05$var$Vh);
    },
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$Uh();
        return null === $c79bde28d689cb05$var$N ? b.memoizedState = a : $c79bde28d689cb05$var$ui(b, $c79bde28d689cb05$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$Xh($c79bde28d689cb05$var$Vh)[0], b = $c79bde28d689cb05$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$Yh,
    useSyncExternalStore: $c79bde28d689cb05$var$Zh,
    useId: $c79bde28d689cb05$var$wi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c79bde28d689cb05$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$R(), e = $c79bde28d689cb05$var$yi(a), f = $c79bde28d689cb05$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$nh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, e, d), $c79bde28d689cb05$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$R(), e = $c79bde28d689cb05$var$yi(a), f = $c79bde28d689cb05$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$nh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, e, d), $c79bde28d689cb05$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$R(), d = $c79bde28d689cb05$var$yi(a), e = $c79bde28d689cb05$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$nh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, d, c), $c79bde28d689cb05$var$oh(b, a, d));
    }
};
function $c79bde28d689cb05$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$eh(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c79bde28d689cb05$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$eh(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$Ei.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Ni(a, b, c) {
    c = $c79bde28d689cb05$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Oi || ($c79bde28d689cb05$var$Oi = !0, $c79bde28d689cb05$var$Pi = d);
        $c79bde28d689cb05$var$Li(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Qi(a, b, c) {
    c = $c79bde28d689cb05$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Li(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Ri ? $c79bde28d689cb05$var$Ri = new Set([
            this
        ]) : $c79bde28d689cb05$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$mh(-1, 1), b.tag = 2, $c79bde28d689cb05$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Wi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$dh = !1;
function $c79bde28d689cb05$var$Xi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Vg(b, null, c, d) : $c79bde28d689cb05$var$Ug(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$ch(b, e);
    d = $c79bde28d689cb05$var$Nh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$Sh();
    if (null !== a && !$c79bde28d689cb05$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$Zi(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Xi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$bj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$dh = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$Zi(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$cj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj);
            $c79bde28d689cb05$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= d;
    $c79bde28d689cb05$var$Xi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$ch(b, e);
    c = $c79bde28d689cb05$var$Nh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$Sh();
    if (null !== a && !$c79bde28d689cb05$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$Zi(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Xi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$ch(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$ij(a, b), $c79bde28d689cb05$var$Gi(b, c, d), $c79bde28d689cb05$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$eh(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$Hi(b, g, d, l);
        $c79bde28d689cb05$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$jh ? ("function" === typeof m && ($c79bde28d689cb05$var$Di(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$jh || $c79bde28d689cb05$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$eh(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$Hi(b, g, d, k);
        $c79bde28d689cb05$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$jh ? ("function" === typeof y && ($c79bde28d689cb05$var$Di(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$jh || $c79bde28d689cb05$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$jj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$jj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$Zi(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Ug(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Ug(b, null, h, f)) : $c79bde28d689cb05$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$yh(a, b.containerInfo);
}
function $c79bde28d689cb05$var$lj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Xi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$oj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$pj(g, d, 0, null), a = $c79bde28d689cb05$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$nj(c), b.memoizedState = $c79bde28d689cb05$var$mj, a) : $c79bde28d689cb05$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$Pg(h, f) : (f = $c79bde28d689cb05$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$qj(a, b) {
    b = $c79bde28d689cb05$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$sj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Ug(b, a.child, null, c);
    a = $c79bde28d689cb05$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$nj(g);
        b.memoizedState = $c79bde28d689cb05$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Ki(f, d, void 0);
        return $c79bde28d689cb05$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$dh || h) {
        d = $c79bde28d689cb05$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$ih(a, e), $c79bde28d689cb05$var$gi(d, a, e, -1));
        }
        $c79bde28d689cb05$var$tj();
        d = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$bh(a.return, b, c);
}
function $c79bde28d689cb05$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Xi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$vj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$kj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Ah(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$oj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1);
                a = $c79bde28d689cb05$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$dj(a, b, c);
    }
    return $c79bde28d689cb05$var$Zi(a, b, c);
}
var $c79bde28d689cb05$var$zj, $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj;
$c79bde28d689cb05$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Aj = function() {};
$c79bde28d689cb05$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Dj(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$zh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Fj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Aj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Bh(b);
            var e = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
                $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Fj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$L.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$zh(), $c79bde28d689cb05$var$Aj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$ah(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Dj(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Gj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$L.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$fj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Ij(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$zh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Bh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L), null;
        case 4:
            return $c79bde28d689cb05$var$zh(), null;
        case 10:
            return $c79bde28d689cb05$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Jj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Nj = !1;
function $c79bde28d689cb05$var$Oj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Nj;
    $c79bde28d689cb05$var$Nj = !1;
    return n;
}
function $c79bde28d689cb05$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Vj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Vj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Xj = !1;
function $c79bde28d689cb05$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$Zj(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$Zj(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Lj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Xj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Xj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Xj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Xj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Xj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Xj = !0;
            $c79bde28d689cb05$var$Yj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Mj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Yj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Yj(a, b, c);
    }
}
function $c79bde28d689cb05$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Kj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Xj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Xj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$Zj(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$dk(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Pj(3, a, a.return), $c79bde28d689cb05$var$Qj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Pj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Lj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            break;
        case 13:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$fk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$ck(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 4 && $c79bde28d689cb05$var$ak(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$ck(b, a), $c79bde28d689cb05$var$ek(a);
    }
}
function $c79bde28d689cb05$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Uj(a);
                    $c79bde28d689cb05$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Uj(a);
                    $c79bde28d689cb05$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$hk(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$ik(a, b, c);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Jj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Jj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$jk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$jk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$ik(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Jj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$kk(a, b, c);
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Rj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$gk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$jk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Qj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$lk = Math.ceil, $c79bde28d689cb05$var$mk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$fj = 0, $c79bde28d689cb05$var$ej = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$pk = null, $c79bde28d689cb05$var$rh = 0, $c79bde28d689cb05$var$qk = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = null, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$fk = 0, $c79bde28d689cb05$var$Gj = Infinity, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Oi = !1, $c79bde28d689cb05$var$Pi = null, $c79bde28d689cb05$var$Ri = null, $c79bde28d689cb05$var$vk = !1, $c79bde28d689cb05$var$wk = null, $c79bde28d689cb05$var$xk = 0, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = null, $c79bde28d689cb05$var$Ak = -1, $c79bde28d689cb05$var$Bk = 0;
function $c79bde28d689cb05$var$R() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$Ak : $c79bde28d689cb05$var$Ak = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Bk && ($c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Bk;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$gi(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$yk) throw $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$Q) a === $c79bde28d689cb05$var$Q && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$qk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Ck(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Dk(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Dk(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$Q ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Ek.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Ek.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Fk(c, $c79bde28d689cb05$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Gk(a, b) {
    $c79bde28d689cb05$var$Ak = -1;
    $c79bde28d689cb05$var$Bk = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Hk() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$Q ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Ik(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Jk();
        if ($c79bde28d689cb05$var$Q !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Kk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Lk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Mk(a, h);
        }
        $c79bde28d689cb05$var$$g();
        $c79bde28d689cb05$var$mk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Nk(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, d), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Ok(e) && (b = $c79bde28d689cb05$var$Ik(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Nk(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, d), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$fk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Pk.bind(null, a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Pk.bind(null, a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Gk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    var c = $c79bde28d689cb05$var$sk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Kk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Ik(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$tk = c, null !== b && $c79bde28d689cb05$var$Fj(b));
    return a;
}
function $c79bde28d689cb05$var$Fj(a) {
    null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = a : $c79bde28d689cb05$var$tk.push.apply($c79bde28d689cb05$var$tk, a);
}
function $c79bde28d689cb05$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Ck(a, b) {
    b &= ~$c79bde28d689cb05$var$rk;
    b &= ~$c79bde28d689cb05$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Ek(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Hk();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Nk(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, b), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Qk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Rk(a) {
    null !== $c79bde28d689cb05$var$wk && 0 === $c79bde28d689cb05$var$wk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Hk();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$ok.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$ok.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$ok.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Hj() {
    $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$ej.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$ej);
}
function $c79bde28d689cb05$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$zh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Eh();
                break;
            case 5:
                $c79bde28d689cb05$var$Bh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$zh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
                break;
            case 10:
                $c79bde28d689cb05$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Hj();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$Q = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$Pg(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$fj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$pk = null;
    $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$qk = $c79bde28d689cb05$var$rh = 0;
    $c79bde28d689cb05$var$tk = $c79bde28d689cb05$var$sk = null;
    if (null !== $c79bde28d689cb05$var$fh) {
        for(b = 0; b < $c79bde28d689cb05$var$fh.length; b++)if (c = $c79bde28d689cb05$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$fh = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Mk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$$g();
            $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Rh;
            if ($c79bde28d689cb05$var$Ih) {
                for(var d = $c79bde28d689cb05$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Ih = !1;
            }
            $c79bde28d689cb05$var$Hh = 0;
            $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = $c79bde28d689cb05$var$M = null;
            $c79bde28d689cb05$var$Jh = !1;
            $c79bde28d689cb05$var$Kh = 0;
            $c79bde28d689cb05$var$nk.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$pk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Si(f, l, b);
                            $c79bde28d689cb05$var$tj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Vi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ji(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$sk ? $c79bde28d689cb05$var$sk = [
                    f
                ] : $c79bde28d689cb05$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Ni(f, k, b);
                            $c79bde28d689cb05$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Ri || !$c79bde28d689cb05$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Qi(f, h, b);
                                $c79bde28d689cb05$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Sk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Jk() {
    var a = $c79bde28d689cb05$var$mk.current;
    $c79bde28d689cb05$var$mk.current = $c79bde28d689cb05$var$Rh;
    return null === a ? $c79bde28d689cb05$var$Rh : a;
}
function $c79bde28d689cb05$var$tj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$Q || 0 === ($c79bde28d689cb05$var$rh & 268435455) && 0 === ($c79bde28d689cb05$var$qk & 268435455) || $c79bde28d689cb05$var$Ck($c79bde28d689cb05$var$Q, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Ik(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Jk();
    if ($c79bde28d689cb05$var$Q !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Kk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Tk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Mk(a, e);
    }
    $c79bde28d689cb05$var$$g();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$mk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$Q = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Tk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Uk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Lk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Uk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Uk(a) {
    var b = $c79bde28d689cb05$var$Vk(a.alternate, a, $c79bde28d689cb05$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Sk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$nk.current = null;
}
function $c79bde28d689cb05$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Ej(c, b, $c79bde28d689cb05$var$fj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Pk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$ok.transition;
    try {
        $c79bde28d689cb05$var$ok.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Wk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$ok.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Wk(a, b, c, d) {
    do $c79bde28d689cb05$var$Hk();
    while (null !== $c79bde28d689cb05$var$wk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$Q && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$vk || ($c79bde28d689cb05$var$vk = !0, $c79bde28d689cb05$var$Fk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$ok.transition;
        $c79bde28d689cb05$var$ok.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$nk.current = null;
        $c79bde28d689cb05$var$Oj(a, c);
        $c79bde28d689cb05$var$dk(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$hk(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$ok.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$vk && ($c79bde28d689cb05$var$vk = !1, $c79bde28d689cb05$var$wk = a, $c79bde28d689cb05$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Ri = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Oi) throw $c79bde28d689cb05$var$Oi = !1, a = $c79bde28d689cb05$var$Pi, $c79bde28d689cb05$var$Pi = null, a;
    0 !== ($c79bde28d689cb05$var$xk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$zk ? $c79bde28d689cb05$var$yk++ : ($c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = a) : $c79bde28d689cb05$var$yk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Hk() {
    if (null !== $c79bde28d689cb05$var$wk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$xk), b = $c79bde28d689cb05$var$ok.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$ok.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$wk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$wk;
                $c79bde28d689cb05$var$wk = null;
                $c79bde28d689cb05$var$xk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Sj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Qj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$ok.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Xk(a, b, c) {
    b = $c79bde28d689cb05$var$Ji(c, b);
    b = $c79bde28d689cb05$var$Ni(a, b, 1);
    a = $c79bde28d689cb05$var$nh(a, b, 1);
    b = $c79bde28d689cb05$var$R();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Dk(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Ri || !$c79bde28d689cb05$var$Ri.has(d))) {
                a = $c79bde28d689cb05$var$Ji(c, a);
                a = $c79bde28d689cb05$var$Qi(b, a, 1);
                b = $c79bde28d689cb05$var$nh(b, a, 1);
                a = $c79bde28d689cb05$var$R();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$Q === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$fk ? $c79bde28d689cb05$var$Kk(a, 0) : $c79bde28d689cb05$var$rk |= c);
    $c79bde28d689cb05$var$Dk(a, b);
}
function $c79bde28d689cb05$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$R();
    a = $c79bde28d689cb05$var$ih(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Dk(a, c));
}
function $c79bde28d689cb05$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Yk(a, c);
}
function $c79bde28d689cb05$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Yk(a, c);
}
var $c79bde28d689cb05$var$Vk;
$c79bde28d689cb05$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$dh = !1, $c79bde28d689cb05$var$yj(a, b, c);
            $c79bde28d689cb05$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$dh = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$ij(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$ch(b, c);
            e = $c79bde28d689cb05$var$Nh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$kh(b), e.updater = $c79bde28d689cb05$var$Ei, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$Ii(b, d, a, c), b = $c79bde28d689cb05$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$Zk(d);
                a = $c79bde28d689cb05$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$$i(null, b, d, $c79bde28d689cb05$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$kj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$lh(a, b);
                $c79bde28d689cb05$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ji(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ji(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$lj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$Zi(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Ah(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$gj(a, b), $c79bde28d689cb05$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$oj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Ug(b, null, d, c) : $c79bde28d689cb05$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$Yi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$ch(b, c), e = $c79bde28d689cb05$var$eh(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Ci(d, b.pendingProps), e = $c79bde28d689cb05$var$Ci(d.type, e), $c79bde28d689cb05$var$$i(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$ij(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$ch(b, c), $c79bde28d689cb05$var$Gi(b, d, e), $c79bde28d689cb05$var$Ii(b, d, e, c), $c79bde28d689cb05$var$jj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$xj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$dj(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Fk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$$k(a, b, c, d);
}
function $c79bde28d689cb05$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$Zk(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Tg(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Tg(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$pj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$Qg(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$kh(f);
    return a;
}
function $c79bde28d689cb05$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$dl(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$el(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$dl(null);
    c = a.current;
    d = $c79bde28d689cb05$var$R();
    e = $c79bde28d689cb05$var$yi(c);
    f = $c79bde28d689cb05$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$nh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Dk(a, d);
    return a;
}
function $c79bde28d689cb05$var$fl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$R(), g = $c79bde28d689cb05$var$yi(e);
    c = $c79bde28d689cb05$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$nh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$gi(a, e, g, f), $c79bde28d689cb05$var$oh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    $c79bde28d689cb05$var$hl(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$hl(a, b);
}
function $c79bde28d689cb05$var$jl() {
    return null;
}
var $c79bde28d689cb05$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ll(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$ml.prototype.render = $c79bde28d689cb05$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$fl(a, b, null, null);
};
$c79bde28d689cb05$var$ml.prototype.unmount = $c79bde28d689cb05$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Rk(function() {
            $c79bde28d689cb05$var$fl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$pl() {}
function $c79bde28d689cb05$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$gl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$el(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$pl);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$gl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$bl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$pl);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Rk(function() {
        $c79bde28d689cb05$var$fl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$gl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$fl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$ql(c, b, a, e, d);
    return $c79bde28d689cb05$var$gl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Dk(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Rk(function() {
                var b = $c79bde28d689cb05$var$ih(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$R();
                    $c79bde28d689cb05$var$gi(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$il(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$ih(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$R();
            $c79bde28d689cb05$var$gi(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$il(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$yi(a), c = $c79bde28d689cb05$var$ih(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$R();
            $c79bde28d689cb05$var$gi(c, a, b, d);
        }
        $c79bde28d689cb05$var$il(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Qk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Rk;
var $c79bde28d689cb05$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Qk
    ]
}, $c79bde28d689cb05$var$tl = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$ul = {
    bundleType: $c79bde28d689cb05$var$tl.bundleType,
    version: $c79bde28d689cb05$var$tl.version,
    rendererPackageName: $c79bde28d689cb05$var$tl.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$tl.findFiberByHostInstance || $c79bde28d689cb05$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$vl.isDisabled && $c79bde28d689cb05$var$vl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$vl.inject($c79bde28d689cb05$var$ul), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$vl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$sl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$nl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$cl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$nl(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ll(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Rk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$rl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$nl(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$rl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Rk(function() {
        $c79bde28d689cb05$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Qk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$ol(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$rl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRegister("fbE6a", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $b0e6fcd50b7ef685$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $b0e6fcd50b7ef685$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $b0e6fcd50b7ef685$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $b0e6fcd50b7ef685$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $b0e6fcd50b7ef685$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $b0e6fcd50b7ef685$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $b0e6fcd50b7ef685$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRoutes", function () { return $b0e6fcd50b7ef685$export$5d3fca4a98652595; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $b0e6fcd50b7ef685$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $b0e6fcd50b7ef685$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $b0e6fcd50b7ef685$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $b0e6fcd50b7ef685$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $b0e6fcd50b7ef685$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $b0e6fcd50b7ef685$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $b0e6fcd50b7ef685$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $b0e6fcd50b7ef685$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $b0e6fcd50b7ef685$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $b0e6fcd50b7ef685$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $b0e6fcd50b7ef685$export$52b333d321859367; });
/**
 * React Router v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");

var $hUt2Z = parcelRequire("hUt2Z");
function $b0e6fcd50b7ef685$var$_extends() {
    $b0e6fcd50b7ef685$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0e6fcd50b7ef685$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $b0e6fcd50b7ef685$export$3add0d5dce533e2e = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$145dfa71566a64dc = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$var$AwaitContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $b0e6fcd50b7ef685$export$26749e8557646306 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$c7914228fb69b0f5 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$9072aa6dd1f93057 = /*#__PURE__*/ $exYeM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $b0e6fcd50b7ef685$var$RouteErrorContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b0e6fcd50b7ef685$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $hUt2Z.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $hUt2Z.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b0e6fcd50b7ef685$export$9c954a9d03d32f4a() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b0e6fcd50b7ef685$export$45d76561a5302f2b() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $hUt2Z.UNSAFE_invariant)(false);
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b0e6fcd50b7ef685$export$1b3f31771c5d07c() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b0e6fcd50b7ef685$export$6c330e8992e8a295(pattern) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $hUt2Z.UNSAFE_invariant)(false);
    let { pathname: pathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    return $exYeM.useMemo(()=>(0, $hUt2Z.matchPath)(pattern, (0, $hUt2Z.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $b0e6fcd50b7ef685$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $exYeM.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b0e6fcd50b7ef685$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b0e6fcd50b7ef685$var$useNavigateStable() : $b0e6fcd50b7ef685$var$useNavigateUnstable();
}
function $b0e6fcd50b7ef685$var$useNavigateUnstable() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $hUt2Z.UNSAFE_invariant)(false);
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $hUt2Z.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $hUt2Z.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $hUt2Z.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$OutletContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b0e6fcd50b7ef685$export$4138103a3ae699cc() {
    return $exYeM.useContext($b0e6fcd50b7ef685$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(context) {
    let outlet = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $hUt2Z.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $exYeM.useMemo(()=>(0, $hUt2Z.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b0e6fcd50b7ef685$export$5d3fca4a98652595(routes, locationArg) {
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $hUt2Z.UNSAFE_invariant)(false);
    let { navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: parentMatches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $hUt2Z.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $hUt2Z.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $hUt2Z.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $b0e6fcd50b7ef685$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $hUt2Z.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $hUt2Z.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b0e6fcd50b7ef685$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $hUt2Z.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b0e6fcd50b7ef685$var$DefaultErrorComponent() {
    let error = $b0e6fcd50b7ef685$export$ed527bf60f6e05f2();
    let message = (0, $hUt2Z.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $exYeM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $exYeM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $b0e6fcd50b7ef685$var$defaultErrorElement = /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DefaultErrorComponent, null);
class $b0e6fcd50b7ef685$var$RenderErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $b0e6fcd50b7ef685$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b0e6fcd50b7ef685$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $hUt2Z.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $b0e6fcd50b7ef685$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $b0e6fcd50b7ef685$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $exYeM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b0e6fcd50b7ef685$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b0e6fcd50b7ef685$var$DataRouterHook || {});
var $b0e6fcd50b7ef685$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b0e6fcd50b7ef685$var$DataRouterStateHook || {});
function $b0e6fcd50b7ef685$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b0e6fcd50b7ef685$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    !ctx && (0, $hUt2Z.UNSAFE_invariant)(false);
    return ctx;
}
function $b0e6fcd50b7ef685$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext($b0e6fcd50b7ef685$export$145dfa71566a64dc);
    !state && (0, $hUt2Z.UNSAFE_invariant)(false);
    return state;
}
function $b0e6fcd50b7ef685$var$useRouteContext(hookName) {
    let route = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    !route && (0, $hUt2Z.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b0e6fcd50b7ef685$var$useCurrentRouteId(hookName) {
    let route = $b0e6fcd50b7ef685$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $hUt2Z.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b0e6fcd50b7ef685$export$5fc8298006ad9e58() {
    return $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b0e6fcd50b7ef685$export$d0fd4b7106de2769() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b0e6fcd50b7ef685$export$600dc272ed516c15() {
    let dataRouterContext = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseRevalidator);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRevalidator);
    return $exYeM.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b0e6fcd50b7ef685$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseMatches);
    return $exYeM.useMemo(()=>matches.map((m)=>(0, $hUt2Z.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b0e6fcd50b7ef685$export$1448a5050d252c4d() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b0e6fcd50b7ef685$export$fd5d37484eab868d(routeId) {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b0e6fcd50b7ef685$export$fdc00f3f26066d5e() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseActionData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b0e6fcd50b7ef685$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $exYeM.useContext($b0e6fcd50b7ef685$var$RouteErrorContext);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $b0e6fcd50b7ef685$export$78a72ddb39bdd145() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $b0e6fcd50b7ef685$export$17f53340677d5831() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $b0e6fcd50b7ef685$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b0e6fcd50b7ef685$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseBlocker);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $exYeM.useState("");
    let blockerFunction = $exYeM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $b0e6fcd50b7ef685$var$_extends({}, currentLocation, {
                pathname: (0, $hUt2Z.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b0e6fcd50b7ef685$var$_extends({}, nextLocation, {
                pathname: (0, $hUt2Z.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $exYeM.useEffect(()=>{
        let key = String(++$b0e6fcd50b7ef685$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $exYeM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $hUt2Z.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b0e6fcd50b7ef685$var$useNavigateStable() {
    let { router: router } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseNavigateStable);
    let id = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b0e6fcd50b7ef685$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$alreadyWarned = {};
function $b0e6fcd50b7ef685$var$warningOnce(key, cond, message) {
    if (!cond && !$b0e6fcd50b7ef685$var$alreadyWarned[key]) $b0e6fcd50b7ef685$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b0e6fcd50b7ef685$var$START_TRANSITION = "startTransition";
const $b0e6fcd50b7ef685$var$startTransitionImpl = $exYeM[$b0e6fcd50b7ef685$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b0e6fcd50b7ef685$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        if (v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl) $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $exYeM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $b0e6fcd50b7ef685$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b0e6fcd50b7ef685$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hUt2Z.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl ? $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b0e6fcd50b7ef685$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $hUt2Z.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let navigate = $b0e6fcd50b7ef685$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $hUt2Z.resolveTo)(to, (0, $hUt2Z.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $exYeM.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b0e6fcd50b7ef685$export$910ae8079b2c2852(props) {
    return $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b0e6fcd50b7ef685$export$e7b0ac011bb776c6(_props) {
    (0, $hUt2Z.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b0e6fcd50b7ef685$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $hUt2Z.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $hUt2Z.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $exYeM.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $b0e6fcd50b7ef685$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $hUt2Z.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $exYeM.useMemo(()=>{
        let trailingPathname = (0, $hUt2Z.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b0e6fcd50b7ef685$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $b0e6fcd50b7ef685$export$5d3fca4a98652595($b0e6fcd50b7ef685$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b0e6fcd50b7ef685$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$ResolveAwait, null, children));
}
var $b0e6fcd50b7ef685$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b0e6fcd50b7ef685$var$AwaitRenderStatus || {});
const $b0e6fcd50b7ef685$var$neverSettledPromise = new Promise(()=>{});
class $b0e6fcd50b7ef685$var$AwaitErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.error : "_data" in promise ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.success : $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && promise._error instanceof (0, $hUt2Z.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $b0e6fcd50b7ef685$var$neverSettledPromise;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $b0e6fcd50b7ef685$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $b0e6fcd50b7ef685$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b0e6fcd50b7ef685$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $exYeM.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $exYeM.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b0e6fcd50b7ef685$export$e7b0ac011bb776c6) && (0, $hUt2Z.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $hUt2Z.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b0e6fcd50b7ef685$export$daf73786167a7f72(matches) {
    return $b0e6fcd50b7ef685$var$_renderMatches(matches);
}
function $b0e6fcd50b7ef685$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $exYeM.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $exYeM.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $exYeM.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b0e6fcd50b7ef685$export$f30f7e456d254e83(routes, opts) {
    return (0, $hUt2Z.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b0e6fcd50b7ef685$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hUt2Z.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b0e6fcd50b7ef685$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("hUt2Z", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $d09e32d367368ff7$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $d09e32d367368ff7$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $d09e32d367368ff7$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $d09e32d367368ff7$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $d09e32d367368ff7$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $d09e32d367368ff7$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $d09e32d367368ff7$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $d09e32d367368ff7$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $d09e32d367368ff7$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $d09e32d367368ff7$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $d09e32d367368ff7$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $d09e32d367368ff7$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $d09e32d367368ff7$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $d09e32d367368ff7$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $d09e32d367368ff7$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $d09e32d367368ff7$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $d09e32d367368ff7$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $d09e32d367368ff7$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $d09e32d367368ff7$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $d09e32d367368ff7$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $d09e32d367368ff7$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.19.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d09e32d367368ff7$var$_extends() {
    $d09e32d367368ff7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d09e32d367368ff7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d09e32d367368ff7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d09e32d367368ff7$export$e19cd5f9376f8cee || ($d09e32d367368ff7$export$e19cd5f9376f8cee = {}));
const $d09e32d367368ff7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d09e32d367368ff7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d09e32d367368ff7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d09e32d367368ff7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d09e32d367368ff7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d09e32d367368ff7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d09e32d367368ff7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d09e32d367368ff7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d09e32d367368ff7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d09e32d367368ff7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d09e32d367368ff7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d09e32d367368ff7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d09e32d367368ff7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d09e32d367368ff7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d09e32d367368ff7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $d09e32d367368ff7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d09e32d367368ff7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d09e32d367368ff7$var$ResultType || ($d09e32d367368ff7$var$ResultType = {}));
const $d09e32d367368ff7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d09e32d367368ff7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d09e32d367368ff7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d09e32d367368ff7$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d09e32d367368ff7$var$isIndexRoute(route)) {
            let indexRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d09e32d367368ff7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d09e32d367368ff7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $d09e32d367368ff7$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $d09e32d367368ff7$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d09e32d367368ff7$var$flattenRoutes(routes);
    $d09e32d367368ff7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $d09e32d367368ff7$export$30d21fd6d7295f52(pathname);
        matches = $d09e32d367368ff7$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $d09e32d367368ff7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d09e32d367368ff7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d09e32d367368ff7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d09e32d367368ff7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d09e32d367368ff7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d09e32d367368ff7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d09e32d367368ff7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d09e32d367368ff7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d09e32d367368ff7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d09e32d367368ff7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d09e32d367368ff7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d09e32d367368ff7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d09e32d367368ff7$var$paramRe = /^:[\w-]+$/;
const $d09e32d367368ff7$var$dynamicSegmentValue = 3;
const $d09e32d367368ff7$var$indexRouteValue = 2;
const $d09e32d367368ff7$var$emptySegmentValue = 1;
const $d09e32d367368ff7$var$staticSegmentValue = 10;
const $d09e32d367368ff7$var$splatPenalty = -2;
const $d09e32d367368ff7$var$isSplat = (s)=>s === "*";
function $d09e32d367368ff7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d09e32d367368ff7$var$isSplat)) initialScore += $d09e32d367368ff7$var$splatPenalty;
    if (index) initialScore += $d09e32d367368ff7$var$indexRouteValue;
    return segments.filter((s)=>!$d09e32d367368ff7$var$isSplat(s)).reduce((score, segment)=>score + ($d09e32d367368ff7$var$paramRe.test(segment) ? $d09e32d367368ff7$var$dynamicSegmentValue : segment === "" ? $d09e32d367368ff7$var$emptySegmentValue : $d09e32d367368ff7$var$staticSegmentValue), initialScore);
}
function $d09e32d367368ff7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d09e32d367368ff7$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d09e32d367368ff7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $d09e32d367368ff7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d09e32d367368ff7$export$a5c6d149b50c1d86($d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d09e32d367368ff7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d09e32d367368ff7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d09e32d367368ff7$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d09e32d367368ff7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d09e32d367368ff7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d09e32d367368ff7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d09e32d367368ff7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $d09e32d367368ff7$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d09e32d367368ff7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d09e32d367368ff7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d09e32d367368ff7$var$normalizeSearch(search),
        hash: $d09e32d367368ff7$var$normalizeHash(hash)
    };
}
function $d09e32d367368ff7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d09e32d367368ff7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d09e32d367368ff7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $d09e32d367368ff7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $d09e32d367368ff7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $d09e32d367368ff7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d09e32d367368ff7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d09e32d367368ff7$var$_extends({}, toArg);
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d09e32d367368ff7$var$getInvalidPathError("?", "pathname", "search", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "pathname", "hash", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d09e32d367368ff7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d09e32d367368ff7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d09e32d367368ff7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d09e32d367368ff7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d09e32d367368ff7$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $d09e32d367368ff7$export$480182c6abbb2ff6(data, init) {
    return new $d09e32d367368ff7$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $d09e32d367368ff7$export$42a99a7a4bc0e76a extends Error {
}
class $d09e32d367368ff7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d09e32d367368ff7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d09e32d367368ff7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d09e32d367368ff7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d09e32d367368ff7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $d09e32d367368ff7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d09e32d367368ff7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d09e32d367368ff7$var$unwrapTrackedPromise(value) {
    if (!$d09e32d367368ff7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d09e32d367368ff7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d09e32d367368ff7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d09e32d367368ff7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $d09e32d367368ff7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $d09e32d367368ff7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d09e32d367368ff7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d09e32d367368ff7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d09e32d367368ff7$var$validMutationMethods = new Set($d09e32d367368ff7$var$validMutationMethodsArr);
const $d09e32d367368ff7$var$validRequestMethodsArr = [
    "get",
    ...$d09e32d367368ff7$var$validMutationMethodsArr
];
const $d09e32d367368ff7$var$validRequestMethods = new Set($d09e32d367368ff7$var$validRequestMethodsArr);
const $d09e32d367368ff7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d09e32d367368ff7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d09e32d367368ff7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d09e32d367368ff7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d09e32d367368ff7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d09e32d367368ff7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d09e32d367368ff7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $d09e32d367368ff7$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $d09e32d367368ff7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d09e32d367368ff7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $d09e32d367368ff7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d09e32d367368ff7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d09e32d367368ff7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $d09e32d367368ff7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d09e32d367368ff7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($d09e32d367368ff7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d09e32d367368ff7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d09e32d367368ff7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d09e32d367368ff7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d09e32d367368ff7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $d09e32d367368ff7$var$findNearestBoundary(matches).route.id,
            {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($d09e32d367368ff7$var$isErrorResult(result) && $d09e32d367368ff7$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $d09e32d367368ff7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $d09e32d367368ff7$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d09e32d367368ff7$var$_extends({
            matches: updatedMatches || matches
        }, $d09e32d367368ff7$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d09e32d367368ff7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $d09e32d367368ff7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $d09e32d367368ff7$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $d09e32d367368ff7$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isDeferredResult(result)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d09e32d367368ff7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d09e32d367368ff7$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($d09e32d367368ff7$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d09e32d367368ff7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $d09e32d367368ff7$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $d09e32d367368ff7$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d09e32d367368ff7$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d09e32d367368ff7$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$d09e32d367368ff7$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $d09e32d367368ff7$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d09e32d367368ff7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $d09e32d367368ff7$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($d09e32d367368ff7$var$isRedirectResult(actionResult) || $d09e32d367368ff7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($d09e32d367368ff7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $d09e32d367368ff7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($d09e32d367368ff7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($d09e32d367368ff7$var$isDeferredResult(actionResult)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d09e32d367368ff7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d09e32d367368ff7$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d09e32d367368ff7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d09e32d367368ff7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d09e32d367368ff7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $d09e32d367368ff7$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d09e32d367368ff7$var$isDeferredResult(result)) result = await $d09e32d367368ff7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $d09e32d367368ff7$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $d09e32d367368ff7$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $d09e32d367368ff7$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace : $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d09e32d367368ff7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d09e32d367368ff7$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $d09e32d367368ff7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d09e32d367368ff7$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d09e32d367368ff7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $d09e32d367368ff7$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($d09e32d367368ff7$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $d09e32d367368ff7$var$ResultType.redirect,
                        response: $d09e32d367368ff7$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $d09e32d367368ff7$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $d09e32d367368ff7$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $d09e32d367368ff7$var$ResultType.error,
                    error: $d09e32d367368ff7$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $d09e32d367368ff7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d09e32d367368ff7$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d09e32d367368ff7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d09e32d367368ff7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $d09e32d367368ff7$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d09e32d367368ff7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d09e32d367368ff7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                let fogMatches = $d09e32d367368ff7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $d09e32d367368ff7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $d09e32d367368ff7$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = $d09e32d367368ff7$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $d09e32d367368ff7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d09e32d367368ff7$export$4d0306f8f6a4585b = Symbol("deferred");
function $d09e32d367368ff7$export$3336b097a6fbc59a(routes, opts) {
    $d09e32d367368ff7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $d09e32d367368ff7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d09e32d367368ff7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d09e32d367368ff7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d09e32d367368ff7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $d09e32d367368ff7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d09e32d367368ff7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d09e32d367368ff7$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $d09e32d367368ff7$var$isResponse(result) ? result : $d09e32d367368ff7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($d09e32d367368ff7$var$isHandlerResult(e) && $d09e32d367368ff7$var$isResponse(e.result)) {
                if (e.type === $d09e32d367368ff7$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d09e32d367368ff7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $d09e32d367368ff7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($d09e32d367368ff7$var$isDeferredResult(result)) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d09e32d367368ff7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $d09e32d367368ff7$var$_extends({}, context, {
                statusCode: $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $d09e32d367368ff7$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $d09e32d367368ff7$var$isErrorResult(pendingActionResult[1]) ? $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $d09e32d367368ff7$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $d09e32d367368ff7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d09e32d367368ff7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $d09e32d367368ff7$var$callDataStrategyImpl(unstable_dataStrategy || $d09e32d367368ff7$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($d09e32d367368ff7$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $d09e32d367368ff7$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($d09e32d367368ff7$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $d09e32d367368ff7$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d09e32d367368ff7$export$fec11da027c70692(routes, context, error) {
    let newContext = $d09e32d367368ff7$var$_extends({}, context, {
        statusCode: $d09e32d367368ff7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d09e32d367368ff7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $d09e32d367368ff7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d09e32d367368ff7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d09e32d367368ff7$export$cae722b0cc860f13(to ? to : ".", $d09e32d367368ff7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d09e32d367368ff7$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d09e32d367368ff7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d09e32d367368ff7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d09e32d367368ff7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d09e32d367368ff7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d09e32d367368ff7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d09e32d367368ff7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d09e32d367368ff7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d09e32d367368ff7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d09e32d367368ff7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d09e32d367368ff7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d09e32d367368ff7$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $d09e32d367368ff7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $d09e32d367368ff7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($d09e32d367368ff7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d09e32d367368ff7$var$shouldRevalidateLoader(match, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d09e32d367368ff7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d09e32d367368ff7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d09e32d367368ff7$var$shouldRevalidateLoader(fetcherMatch, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d09e32d367368ff7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d09e32d367368ff7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $d09e32d367368ff7$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $d09e32d367368ff7$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $d09e32d367368ff7$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $d09e32d367368ff7$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $d09e32d367368ff7$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $d09e32d367368ff7$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $d09e32d367368ff7$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d09e32d367368ff7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d09e32d367368ff7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d09e32d367368ff7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d09e32d367368ff7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d09e32d367368ff7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $d09e32d367368ff7$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $d09e32d367368ff7$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $d09e32d367368ff7$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $d09e32d367368ff7$var$ResultType.data,
                    result: undefined
                });
            };
            return $d09e32d367368ff7$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$d09e32d367368ff7$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $d09e32d367368ff7$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d09e32d367368ff7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d09e32d367368ff7$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d09e32d367368ff7$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $d09e32d367368ff7$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $d09e32d367368ff7$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type } = handlerResult;
    if ($d09e32d367368ff7$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: e
            };
        }
        if (type === $d09e32d367368ff7$var$ResultType.error) return {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: new $d09e32d367368ff7$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $d09e32d367368ff7$var$ResultType.error) {
        if ($d09e32d367368ff7$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $d09e32d367368ff7$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $d09e32d367368ff7$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: result,
            statusCode: $d09e32d367368ff7$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($d09e32d367368ff7$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $d09e32d367368ff7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($d09e32d367368ff7$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $d09e32d367368ff7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $d09e32d367368ff7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $d09e32d367368ff7$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $d09e32d367368ff7$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d09e32d367368ff7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d09e32d367368ff7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d09e32d367368ff7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d09e32d367368ff7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $d09e32d367368ff7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($d09e32d367368ff7$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d09e32d367368ff7$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d09e32d367368ff7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d09e32d367368ff7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d09e32d367368ff7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d09e32d367368ff7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d09e32d367368ff7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $d09e32d367368ff7$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $d09e32d367368ff7$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d09e32d367368ff7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d09e32d367368ff7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d09e32d367368ff7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d09e32d367368ff7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d09e32d367368ff7$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d09e32d367368ff7$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $d09e32d367368ff7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(path) : path;
    return $d09e32d367368ff7$export$fe53371bee54353d($d09e32d367368ff7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d09e32d367368ff7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d09e32d367368ff7$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $d09e32d367368ff7$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $d09e32d367368ff7$var$ResultType.data || result.type === $d09e32d367368ff7$var$ResultType.error);
}
function $d09e32d367368ff7$var$isRedirectHandlerResult(result) {
    return $d09e32d367368ff7$var$isResponse(result.result) && $d09e32d367368ff7$var$redirectStatusCodes.has(result.result.status);
}
function $d09e32d367368ff7$var$isDeferredResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.deferred;
}
function $d09e32d367368ff7$var$isErrorResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.error;
}
function $d09e32d367368ff7$var$isRedirectResult(result) {
    return (result && result.type) === $d09e32d367368ff7$var$ResultType.redirect;
}
function $d09e32d367368ff7$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $d09e32d367368ff7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d09e32d367368ff7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d09e32d367368ff7$var$isRedirectResponse(result) {
    if (!$d09e32d367368ff7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d09e32d367368ff7$var$isValidMethod(method) {
    return $d09e32d367368ff7$var$validRequestMethods.has(method.toLowerCase());
}
function $d09e32d367368ff7$var$isMutationMethod(method) {
    return $d09e32d367368ff7$var$validMutationMethods.has(method.toLowerCase());
}
async function $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d09e32d367368ff7$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d09e32d367368ff7$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d09e32d367368ff7$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d09e32d367368ff7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d09e32d367368ff7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d09e32d367368ff7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d09e32d367368ff7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d09e32d367368ff7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d09e32d367368ff7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d09e32d367368ff7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d09e32d367368ff7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d09e32d367368ff7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d09e32d367368ff7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $d09e32d367368ff7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $d09e32d367368ff7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d09e32d367368ff7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("9T2YG", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $732b8f71fedff484$export$bf730a2d8bf68b42; }, function (v) { return $732b8f71fedff484$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $732b8f71fedff484$export$bf730a2d8bf68b42;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $732b8f71fedff484$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $732b8f71fedff484$var$p = "function" === typeof Object.is ? Object.is : $732b8f71fedff484$var$n, $732b8f71fedff484$var$q = $exYeM.useSyncExternalStore, $732b8f71fedff484$var$r = $exYeM.useRef, $732b8f71fedff484$var$t = $exYeM.useEffect, $732b8f71fedff484$var$u = $exYeM.useMemo, $732b8f71fedff484$var$v = $exYeM.useDebugValue;
$732b8f71fedff484$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $732b8f71fedff484$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $732b8f71fedff484$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($732b8f71fedff484$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $732b8f71fedff484$var$q(a, c[0], c[1]);
    $732b8f71fedff484$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $732b8f71fedff484$var$v(d);
    return d;
};

});

parcelRegister("2gkJV", function(module, exports) {
$parcel$export(module.exports, "AuthApi", function () { return (parcelRequire("aeAwZ")).AuthApi; });
$parcel$export(module.exports, "CommentApi", function () { return (parcelRequire("aeAwZ")).CommentApi; });
$parcel$export(module.exports, "ConnectApi", function () { return (parcelRequire("aeAwZ")).ConnectApi; });
$parcel$export(module.exports, "CustomerApi", function () { return (parcelRequire("aeAwZ")).CustomerApi; });
$parcel$export(module.exports, "EntityConnectStatus", function () { return (parcelRequire("aeAwZ")).EntityConnectStatus; });
$parcel$export(module.exports, "EntityNotificationConfigScope", function () { return (parcelRequire("aeAwZ")).EntityNotificationConfigScope; });
$parcel$export(module.exports, "EntityNotificationEntityType", function () { return (parcelRequire("aeAwZ")).EntityNotificationEntityType; });
$parcel$export(module.exports, "EntityNotificationEvent", function () { return (parcelRequire("aeAwZ")).EntityNotificationEvent; });
$parcel$export(module.exports, "EntityOnboardingStage", function () { return (parcelRequire("aeAwZ")).EntityOnboardingStage; });
$parcel$export(module.exports, "EntityPostMediaType", function () { return (parcelRequire("aeAwZ")).EntityPostMediaType; });
$parcel$export(module.exports, "EntityPostVisibility", function () { return (parcelRequire("aeAwZ")).EntityPostVisibility; });
$parcel$export(module.exports, "EntityReportComplaintType", function () { return (parcelRequire("aeAwZ")).EntityReportComplaintType; });
$parcel$export(module.exports, "EntityReportEntityType", function () { return (parcelRequire("aeAwZ")).EntityReportEntityType; });
$parcel$export(module.exports, "EntityTipStatus", function () { return (parcelRequire("aeAwZ")).EntityTipStatus; });
$parcel$export(module.exports, "EntityTrackVisibility", function () { return (parcelRequire("aeAwZ")).EntityTrackVisibility; });
$parcel$export(module.exports, "EntityTransactionType", function () { return (parcelRequire("aeAwZ")).EntityTransactionType; });
$parcel$export(module.exports, "EntityUnlockEntityType", function () { return (parcelRequire("aeAwZ")).EntityUnlockEntityType; });
$parcel$export(module.exports, "EntityUnlockStatus", function () { return (parcelRequire("aeAwZ")).EntityUnlockStatus; });
$parcel$export(module.exports, "EntityUserRole", function () { return (parcelRequire("aeAwZ")).EntityUserRole; });
$parcel$export(module.exports, "FileApi", function () { return (parcelRequire("aeAwZ")).FileApi; });
$parcel$export(module.exports, "LikeApi", function () { return (parcelRequire("aeAwZ")).LikeApi; });
$parcel$export(module.exports, "NotificationApi", function () { return (parcelRequire("aeAwZ")).NotificationApi; });
$parcel$export(module.exports, "PostApi", function () { return (parcelRequire("aeAwZ")).PostApi; });
$parcel$export(module.exports, "ReportApi", function () { return (parcelRequire("aeAwZ")).ReportApi; });
$parcel$export(module.exports, "StreamApi", function () { return (parcelRequire("aeAwZ")).StreamApi; });
$parcel$export(module.exports, "SubscriptionApi", function () { return (parcelRequire("aeAwZ")).SubscriptionApi; });
$parcel$export(module.exports, "TipApi", function () { return (parcelRequire("aeAwZ")).TipApi; });
$parcel$export(module.exports, "TrackApi", function () { return (parcelRequire("aeAwZ")).TrackApi; });
$parcel$export(module.exports, "TransactionApi", function () { return (parcelRequire("aeAwZ")).TransactionApi; });
$parcel$export(module.exports, "UnlockApi", function () { return (parcelRequire("aeAwZ")).UnlockApi; });
$parcel$export(module.exports, "UserApi", function () { return (parcelRequire("aeAwZ")).UserApi; });
$parcel$export(module.exports, "Configuration", function () { return (parcelRequire("a1ai3")).Configuration; });
// tslint:disable
/**
 * Ryddm API
 * Ryddm API.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ parcelRequire("aeAwZ");
parcelRequire("a1ai3");

});
parcelRegister("aeAwZ", function(module, exports) {

$parcel$export(module.exports, "EntityConnectStatus", function () { return $2e40eaa235c0814d$export$cd09cf72d1730375; });
$parcel$export(module.exports, "EntityNotificationConfigScope", function () { return $2e40eaa235c0814d$export$e6b04316f6c13ed6; });
$parcel$export(module.exports, "EntityNotificationEntityType", function () { return $2e40eaa235c0814d$export$d7d4185850f8f5b4; });
$parcel$export(module.exports, "EntityNotificationEvent", function () { return $2e40eaa235c0814d$export$9509982552593ae5; });
$parcel$export(module.exports, "EntityOnboardingStage", function () { return $2e40eaa235c0814d$export$6b6c75aa4d504a00; });
$parcel$export(module.exports, "EntityPostMediaType", function () { return $2e40eaa235c0814d$export$513b3049a560168d; });
$parcel$export(module.exports, "EntityPostVisibility", function () { return $2e40eaa235c0814d$export$75814ed959e29300; });
$parcel$export(module.exports, "EntityReportComplaintType", function () { return $2e40eaa235c0814d$export$19c9ca07037bc945; });
$parcel$export(module.exports, "EntityReportEntityType", function () { return $2e40eaa235c0814d$export$47ddd1a5659843fe; });
$parcel$export(module.exports, "EntityTipStatus", function () { return $2e40eaa235c0814d$export$832197bc1252cbbd; });
$parcel$export(module.exports, "EntityTrackVisibility", function () { return $2e40eaa235c0814d$export$fcda3c70f8c953ec; });
$parcel$export(module.exports, "EntityTransactionType", function () { return $2e40eaa235c0814d$export$3527c3c3973190e2; });
$parcel$export(module.exports, "EntityUnlockEntityType", function () { return $2e40eaa235c0814d$export$c489df26e3bedd1c; });
$parcel$export(module.exports, "EntityUnlockStatus", function () { return $2e40eaa235c0814d$export$df944f2236cc8772; });
$parcel$export(module.exports, "EntityUserRole", function () { return $2e40eaa235c0814d$export$419779fd57d8a21f; });
$parcel$export(module.exports, "AuthApi", function () { return $2e40eaa235c0814d$export$4a5ab2a34a4b26f9; });
$parcel$export(module.exports, "CommentApi", function () { return $2e40eaa235c0814d$export$569b2c8fc0552525; });
$parcel$export(module.exports, "ConnectApi", function () { return $2e40eaa235c0814d$export$8dd770e5815a509c; });
$parcel$export(module.exports, "CustomerApi", function () { return $2e40eaa235c0814d$export$db097d7a94bea193; });
$parcel$export(module.exports, "FileApi", function () { return $2e40eaa235c0814d$export$be85d78436eb3caf; });
$parcel$export(module.exports, "LikeApi", function () { return $2e40eaa235c0814d$export$f4d3d044741564bb; });
$parcel$export(module.exports, "NotificationApi", function () { return $2e40eaa235c0814d$export$e8fd42033d129624; });
$parcel$export(module.exports, "PostApi", function () { return $2e40eaa235c0814d$export$51444d8b6a1912f3; });
$parcel$export(module.exports, "ReportApi", function () { return $2e40eaa235c0814d$export$86e5bee652cd816e; });
$parcel$export(module.exports, "StreamApi", function () { return $2e40eaa235c0814d$export$7d740e068388f14a; });
$parcel$export(module.exports, "SubscriptionApi", function () { return $2e40eaa235c0814d$export$79802d927b7d883c; });
$parcel$export(module.exports, "TipApi", function () { return $2e40eaa235c0814d$export$29fe426b57068b65; });
$parcel$export(module.exports, "TrackApi", function () { return $2e40eaa235c0814d$export$2f8f7bdb7e386612; });
$parcel$export(module.exports, "TransactionApi", function () { return $2e40eaa235c0814d$export$392ee3f1e8966c92; });
$parcel$export(module.exports, "UnlockApi", function () { return $2e40eaa235c0814d$export$2b72467a8fb6e56d; });
$parcel$export(module.exports, "UserApi", function () { return $2e40eaa235c0814d$export$2a63ac7615f78125; });
//@ts-nocheck
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Ryddm API
 * Ryddm API.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ 
var $dlIfJ = parcelRequire("dlIfJ");

var $7U1ts = parcelRequire("7U1ts");
const $2e40eaa235c0814d$var$BASE_PATH = "https://localhost".replace(/\/+$/, "");
const $2e40eaa235c0814d$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
class $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    constructor(configuration, basePath = $2e40eaa235c0814d$var$BASE_PATH, fetch = $7U1ts){
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
class $2e40eaa235c0814d$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
var $2e40eaa235c0814d$export$9574cacdb00bcba3;
(function(EntityConnectPayoutStatus) {
    EntityConnectPayoutStatus["Succeeded"] = "succeeded";
    EntityConnectPayoutStatus["Failed"] = "failed";
    EntityConnectPayoutStatus["Incomplete"] = "incomplete";
})($2e40eaa235c0814d$export$9574cacdb00bcba3 || ($2e40eaa235c0814d$export$9574cacdb00bcba3 = {}));
var $2e40eaa235c0814d$export$cd09cf72d1730375;
(function(EntityConnectStatus) {
    EntityConnectStatus["Restricted"] = "restricted";
    EntityConnectStatus["Pending"] = "pending";
    EntityConnectStatus["Enabled"] = "enabled";
    EntityConnectStatus["Complete"] = "complete";
})($2e40eaa235c0814d$export$cd09cf72d1730375 || ($2e40eaa235c0814d$export$cd09cf72d1730375 = {}));
var $2e40eaa235c0814d$export$3928e0b25799b13b;
(function(EntityCustomerPaymentMethodSetupStatus) {
    EntityCustomerPaymentMethodSetupStatus["Succeeded"] = "succeeded";
    EntityCustomerPaymentMethodSetupStatus["Failed"] = "failed";
    EntityCustomerPaymentMethodSetupStatus["Incomplete"] = "incomplete";
})($2e40eaa235c0814d$export$3928e0b25799b13b || ($2e40eaa235c0814d$export$3928e0b25799b13b = {}));
var $2e40eaa235c0814d$export$ce14051f513b837a;
(function(EntityLikeEntityType) {
    EntityLikeEntityType["User"] = "user";
    EntityLikeEntityType["Track"] = "track";
    EntityLikeEntityType["Post"] = "post";
    EntityLikeEntityType["Comment"] = "comment";
})($2e40eaa235c0814d$export$ce14051f513b837a || ($2e40eaa235c0814d$export$ce14051f513b837a = {}));
var $2e40eaa235c0814d$export$e6b04316f6c13ed6;
(function(EntityNotificationConfigScope) {
    EntityNotificationConfigScope["Enabled"] = "enabled";
    EntityNotificationConfigScope["Custom"] = "custom";
    EntityNotificationConfigScope["Disabled"] = "disabled";
})($2e40eaa235c0814d$export$e6b04316f6c13ed6 || ($2e40eaa235c0814d$export$e6b04316f6c13ed6 = {}));
var $2e40eaa235c0814d$export$d7d4185850f8f5b4;
(function(EntityNotificationEntityType) {
    EntityNotificationEntityType["User"] = "user";
    EntityNotificationEntityType["Track"] = "track";
    EntityNotificationEntityType["Post"] = "post";
    EntityNotificationEntityType["Comment"] = "comment";
    EntityNotificationEntityType["Tip"] = "tip";
    EntityNotificationEntityType["Unlock"] = "unlock";
    EntityNotificationEntityType["Subscription"] = "subscription";
    EntityNotificationEntityType["ConnectPayout"] = "connect_payout";
})($2e40eaa235c0814d$export$d7d4185850f8f5b4 || ($2e40eaa235c0814d$export$d7d4185850f8f5b4 = {}));
var $2e40eaa235c0814d$export$9509982552593ae5;
(function(EntityNotificationEvent) {
    EntityNotificationEvent["AppUserFollowCreated"] = "app_user_follow_created";
    EntityNotificationEvent["AppTrackCreated"] = "app_track_created";
    EntityNotificationEvent["AppTrackBlocked"] = "app_track_blocked";
    EntityNotificationEvent["AppTrackLikeCreated"] = "app_track_like_created";
    EntityNotificationEvent["AppPostCreated"] = "app_post_created";
    EntityNotificationEvent["AppPostBlocked"] = "app_post_blocked";
    EntityNotificationEvent["AppPostLikeCreated"] = "app_post_like_created";
    EntityNotificationEvent["AppCommentCreated"] = "app_comment_created";
    EntityNotificationEvent["AppCommentReplyCreated"] = "app_comment_reply_created";
    EntityNotificationEvent["AppCommentBlocked"] = "app_comment_blocked";
    EntityNotificationEvent["AppCommentLikeCreated"] = "app_comment_like_created";
    EntityNotificationEvent["AppTipPaymentSucceeded"] = "app_tip_payment_succeeded";
    EntityNotificationEvent["AppTipPaymentFailed"] = "app_tip_payment_failed";
    EntityNotificationEvent["AppTipCreated"] = "app_tip_created";
    EntityNotificationEvent["AppTrackUnlockPaymentSucceeded"] = "app_track_unlock_payment_succeeded";
    EntityNotificationEvent["AppTrackUnlockPaymentFailed"] = "app_track_unlock_payment_failed";
    EntityNotificationEvent["AppTrackUnlockCreated"] = "app_track_unlock_created";
    EntityNotificationEvent["AppPostUnlockPaymentSucceeded"] = "app_post_unlock_payment_succeeded";
    EntityNotificationEvent["AppPostUnlockPaymentFailed"] = "app_post_unlock_payment_failed";
    EntityNotificationEvent["AppPostUnlockCreated"] = "app_post_unlock_created";
    EntityNotificationEvent["AppSubscriptionPaymentSucceeded"] = "app_subscription_payment_succeeded";
    EntityNotificationEvent["AppSubscriptionPaymentFailed"] = "app_subscription_payment_failed";
    EntityNotificationEvent["AppSubscriptionCreated"] = "app_subscription_created";
    EntityNotificationEvent["AppPayoutPaid"] = "app_payout_paid";
    EntityNotificationEvent["AppPayoutFailed"] = "app_payout_failed";
    EntityNotificationEvent["EmailWelcome"] = "email_welcome";
    EntityNotificationEvent["EmailUserBlocked"] = "email_user_blocked";
    EntityNotificationEvent["EmailTrackBlocked"] = "email_track_blocked";
    EntityNotificationEvent["EmailPostBlocked"] = "email_post_blocked";
    EntityNotificationEvent["EmailCommentBlocked"] = "email_comment_blocked";
    EntityNotificationEvent["EmailUserDeleteConfirmation"] = "email_user_delete_confirmation";
    EntityNotificationEvent["EmailUserDeleted"] = "email_user_deleted";
})($2e40eaa235c0814d$export$9509982552593ae5 || ($2e40eaa235c0814d$export$9509982552593ae5 = {}));
var $2e40eaa235c0814d$export$678975e2ed472613;
(function(EntityNotificationType) {
    EntityNotificationType["Application"] = "application";
    EntityNotificationType["Email"] = "email";
    EntityNotificationType["Push"] = "push";
})($2e40eaa235c0814d$export$678975e2ed472613 || ($2e40eaa235c0814d$export$678975e2ed472613 = {}));
var $2e40eaa235c0814d$export$6b6c75aa4d504a00;
(function(EntityOnboardingStage) {
    EntityOnboardingStage["SelectRole"] = "select_role";
    EntityOnboardingStage["CreateProfile"] = "create_profile";
    EntityOnboardingStage["SelectGenres"] = "select_genres";
    EntityOnboardingStage["FollowArtists"] = "follow_artists";
    EntityOnboardingStage["UploadTracks"] = "upload_tracks";
    EntityOnboardingStage["EnableMonetization"] = "enable_monetization";
    EntityOnboardingStage["ConfigureNotifications"] = "configure_notifications";
    EntityOnboardingStage["AcceptTermsAndConditions"] = "accept_terms_and_conditions";
    EntityOnboardingStage["Finished"] = "finished";
})($2e40eaa235c0814d$export$6b6c75aa4d504a00 || ($2e40eaa235c0814d$export$6b6c75aa4d504a00 = {}));
var $2e40eaa235c0814d$export$513b3049a560168d;
(function(EntityPostMediaType) {
    EntityPostMediaType["Image"] = "image";
    EntityPostMediaType["Video"] = "video";
})($2e40eaa235c0814d$export$513b3049a560168d || ($2e40eaa235c0814d$export$513b3049a560168d = {}));
var $2e40eaa235c0814d$export$75814ed959e29300;
(function(EntityPostVisibility) {
    EntityPostVisibility["Public"] = "public";
    EntityPostVisibility["Subscribers"] = "subscribers";
})($2e40eaa235c0814d$export$75814ed959e29300 || ($2e40eaa235c0814d$export$75814ed959e29300 = {}));
var $2e40eaa235c0814d$export$19c9ca07037bc945;
(function(EntityReportComplaintType) {
    EntityReportComplaintType["Spam"] = "spam";
    EntityReportComplaintType["Fake"] = "fake";
    EntityReportComplaintType["Violence"] = "violence";
    EntityReportComplaintType["Pornography"] = "pornography";
    EntityReportComplaintType["ChildAbuse"] = "child_abuse";
    EntityReportComplaintType["Copyright"] = "copyright";
})($2e40eaa235c0814d$export$19c9ca07037bc945 || ($2e40eaa235c0814d$export$19c9ca07037bc945 = {}));
var $2e40eaa235c0814d$export$47ddd1a5659843fe;
(function(EntityReportEntityType) {
    EntityReportEntityType["Post"] = "post";
    EntityReportEntityType["User"] = "user";
    EntityReportEntityType["Track"] = "track";
    EntityReportEntityType["Comment"] = "comment";
})($2e40eaa235c0814d$export$47ddd1a5659843fe || ($2e40eaa235c0814d$export$47ddd1a5659843fe = {}));
var $2e40eaa235c0814d$export$9e4e35ff0cd7f06;
(function(EntityReportStatus) {
    EntityReportStatus["Open"] = "open";
    EntityReportStatus["Resolved"] = "resolved";
})($2e40eaa235c0814d$export$9e4e35ff0cd7f06 || ($2e40eaa235c0814d$export$9e4e35ff0cd7f06 = {}));
var $2e40eaa235c0814d$export$4283ef5eb5fc6872;
(function(EntityStreamEntityType) {
    EntityStreamEntityType["User"] = "user";
    EntityStreamEntityType["Track"] = "track";
    EntityStreamEntityType["Post"] = "post";
    EntityStreamEntityType["Comment"] = "comment";
})($2e40eaa235c0814d$export$4283ef5eb5fc6872 || ($2e40eaa235c0814d$export$4283ef5eb5fc6872 = {}));
var $2e40eaa235c0814d$export$fdbe6c860c432e91;
(function(EntitySubscriptionStatus) {
    EntitySubscriptionStatus["Active"] = "active";
    EntitySubscriptionStatus["CanceledAtPeriodEnd"] = "canceled_at_period_end";
    EntitySubscriptionStatus["Canceled"] = "canceled";
    EntitySubscriptionStatus["Incomplete"] = "incomplete";
    EntitySubscriptionStatus["IncompleteExpired"] = "incomplete_expired";
})($2e40eaa235c0814d$export$fdbe6c860c432e91 || ($2e40eaa235c0814d$export$fdbe6c860c432e91 = {}));
var $2e40eaa235c0814d$export$832197bc1252cbbd;
(function(EntityTipStatus) {
    EntityTipStatus["Succeeded"] = "succeeded";
    EntityTipStatus["Failed"] = "failed";
    EntityTipStatus["Incomplete"] = "incomplete";
})($2e40eaa235c0814d$export$832197bc1252cbbd || ($2e40eaa235c0814d$export$832197bc1252cbbd = {}));
var $2e40eaa235c0814d$export$fcda3c70f8c953ec;
(function(EntityTrackVisibility) {
    EntityTrackVisibility["Public"] = "public";
    EntityTrackVisibility["Subscribers"] = "subscribers";
})($2e40eaa235c0814d$export$fcda3c70f8c953ec || ($2e40eaa235c0814d$export$fcda3c70f8c953ec = {}));
var $2e40eaa235c0814d$export$4c71f34fd5e7fa97;
(function(EntityTransactionCurrency) {
    EntityTransactionCurrency["Usd"] = "usd";
})($2e40eaa235c0814d$export$4c71f34fd5e7fa97 || ($2e40eaa235c0814d$export$4c71f34fd5e7fa97 = {}));
var $2e40eaa235c0814d$export$1c1195e431d25a2f;
(function(EntityTransactionStatus) {
    EntityTransactionStatus["Succeeded"] = "succeeded";
    EntityTransactionStatus["Failed"] = "failed";
    EntityTransactionStatus["Incomplete"] = "incomplete";
})($2e40eaa235c0814d$export$1c1195e431d25a2f || ($2e40eaa235c0814d$export$1c1195e431d25a2f = {}));
var $2e40eaa235c0814d$export$3527c3c3973190e2;
(function(EntityTransactionType) {
    EntityTransactionType["Tip"] = "tip";
    EntityTransactionType["Unlock"] = "unlock";
    EntityTransactionType["Subscription"] = "subscription";
    EntityTransactionType["Payout"] = "payout";
})($2e40eaa235c0814d$export$3527c3c3973190e2 || ($2e40eaa235c0814d$export$3527c3c3973190e2 = {}));
var $2e40eaa235c0814d$export$c489df26e3bedd1c;
(function(EntityUnlockEntityType) {
    EntityUnlockEntityType["Post"] = "post";
    EntityUnlockEntityType["Track"] = "track";
})($2e40eaa235c0814d$export$c489df26e3bedd1c || ($2e40eaa235c0814d$export$c489df26e3bedd1c = {}));
var $2e40eaa235c0814d$export$df944f2236cc8772;
(function(EntityUnlockStatus) {
    EntityUnlockStatus["Succeeded"] = "succeeded";
    EntityUnlockStatus["Failed"] = "failed";
    EntityUnlockStatus["Incomplete"] = "incomplete";
})($2e40eaa235c0814d$export$df944f2236cc8772 || ($2e40eaa235c0814d$export$df944f2236cc8772 = {}));
var $2e40eaa235c0814d$export$419779fd57d8a21f;
(function(EntityUserRole) {
    EntityUserRole["Fan"] = "fan";
    EntityUserRole["Artist"] = "artist";
    EntityUserRole["Admin"] = "admin";
    EntityUserRole["Empty"] = "";
})($2e40eaa235c0814d$export$419779fd57d8a21f || ($2e40eaa235c0814d$export$419779fd57d8a21f = {}));
var $2e40eaa235c0814d$export$e2c81fe6da469e18;
(function(ServiceConnectLinkType) {
    ServiceConnectLinkType["Onboarding"] = "account_onboarding";
    ServiceConnectLinkType["Update"] = "account_update";
})($2e40eaa235c0814d$export$e2c81fe6da469e18 || ($2e40eaa235c0814d$export$e2c81fe6da469e18 = {}));
const $2e40eaa235c0814d$export$ca1a67fd1d88777 = function(configuration) {
    return {
        /**
     * Exchanges auth provider token with auth service token.
     * @summary Exchanges token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exchangeToken (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling exchangeToken.");
            const localVarPath = `/auth/token/exchange`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Signs new auth service token with extended period of validity.
     * @summary Refreshes token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ refreshToken (options = {}) {
            const localVarPath = `/auth/token/refresh`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$fe9b9a9cf30a5627 = function(configuration) {
    return {
        /**
     * Exchanges auth provider token with auth service token.
     * @summary Exchanges token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exchangeToken (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ca1a67fd1d88777(configuration).exchangeToken(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Signs new auth service token with extended period of validity.
     * @summary Refreshes token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ refreshToken (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ca1a67fd1d88777(configuration).refreshToken(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$c7ea0c10377c62a = function(configuration, fetch, basePath) {
    return {
        /**
     * Exchanges auth provider token with auth service token.
     * @summary Exchanges token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exchangeToken (fields, options) {
            return $2e40eaa235c0814d$export$fe9b9a9cf30a5627(configuration).exchangeToken(fields, options)(fetch, basePath);
        },
        /**
     * Signs new auth service token with extended period of validity.
     * @summary Refreshes token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ refreshToken (options) {
            return $2e40eaa235c0814d$export$fe9b9a9cf30a5627(configuration).refreshToken(options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$4a5ab2a34a4b26f9 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Exchanges auth provider token with auth service token.
   * @summary Exchanges token.
   * @param {ExchangeTokenRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */ exchangeToken(fields, options) {
        return $2e40eaa235c0814d$export$fe9b9a9cf30a5627(this.configuration).exchangeToken(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Signs new auth service token with extended period of validity.
   * @summary Refreshes token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */ refreshToken(options) {
        return $2e40eaa235c0814d$export$fe9b9a9cf30a5627(this.configuration).refreshToken(options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$32f3cfcc496b270 = function(configuration) {
    return {
        /**
     * Blocks comment record.
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockComment (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockComment.");
            const localVarPath = `/comment/admin/comment/block`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates comment.
     * @summary Creates comment.
     * @param {CreateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createComment (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createComment.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes comment.
     * @summary Deletes comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteComment (commentId, options = {}) {
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("commentId", "Required parameter commentId was null or undefined when calling deleteComment.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (commentId !== undefined) localVarQueryParameter["commentId"] = commentId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComment (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getComment.");
            const localVarPath = `/comment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCommentInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getCommentInternal.");
            const localVarPath = `/comment/internal/comment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comments.
     * @summary Retrieves comments.
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComments (postId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling getComments.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comment replies.
     * @summary Retrieves comment replies.
     * @param {string} commentId
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReplies (commentId, postId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("commentId", "Required parameter commentId was null or undefined when calling getReplies.");
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling getReplies.");
            const localVarPath = `/comment/replies`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (commentId !== undefined) localVarQueryParameter["commentId"] = commentId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates comment.
     * @summary Updates comment.
     * @param {UpdateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateComment (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateComment.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$ebd5a72e5df7a200 = function(configuration) {
    return {
        /**
     * Blocks comment record.
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockComment (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).blockComment(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates comment.
     * @summary Creates comment.
     * @param {CreateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createComment (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).createComment(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes comment.
     * @summary Deletes comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteComment (commentId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).deleteComment(commentId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComment (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).getComment(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCommentInternal (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).getCommentInternal(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comments.
     * @summary Retrieves comments.
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComments (postId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).getComments(postId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comment replies.
     * @summary Retrieves comment replies.
     * @param {string} commentId
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReplies (commentId, postId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).getReplies(commentId, postId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates comment.
     * @summary Updates comment.
     * @param {UpdateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateComment (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$32f3cfcc496b270(configuration).updateComment(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$15e2b81be2ba0d7f = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks comment record.
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockComment (fields, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).blockComment(fields, options)(fetch, basePath);
        },
        /**
     * Creates comment.
     * @summary Creates comment.
     * @param {CreateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createComment (fields, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).createComment(fields, options)(fetch, basePath);
        },
        /**
     * Deletes comment.
     * @summary Deletes comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteComment (commentId, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).deleteComment(commentId, options)(fetch, basePath);
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComment (id, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).getComment(id, options)(fetch, basePath);
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCommentInternal (id, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).getCommentInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves comments.
     * @summary Retrieves comments.
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComments (postId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).getComments(postId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves comment replies.
     * @summary Retrieves comment replies.
     * @param {string} commentId
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReplies (commentId, postId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).getReplies(commentId, postId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Updates comment.
     * @summary Updates comment.
     * @param {UpdateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateComment (fields, options) {
            return $2e40eaa235c0814d$export$ebd5a72e5df7a200(configuration).updateComment(fields, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$569b2c8fc0552525 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Blocks comment record.
   * @summary Blocks comment.
   * @param {BlockCommentRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ blockComment(fields, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).blockComment(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates comment.
   * @summary Creates comment.
   * @param {CreateCommentRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ createComment(fields, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).createComment(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes comment.
   * @summary Deletes comment.
   * @param {string} commentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ deleteComment(commentId, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).deleteComment(commentId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comment record by comment id.
   * @summary Retrieves comment.
   * @param {string} id comment id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getComment(id, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).getComment(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comment record by comment id.
   * @summary Retrieves comment.
   * @param {string} id comment id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getCommentInternal(id, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).getCommentInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comments.
   * @summary Retrieves comments.
   * @param {string} postId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getComments(postId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).getComments(postId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comment replies.
   * @summary Retrieves comment replies.
   * @param {string} commentId
   * @param {string} postId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getReplies(commentId, postId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).getReplies(commentId, postId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Updates comment.
   * @summary Updates comment.
   * @param {UpdateCommentRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ updateComment(fields, options) {
        return $2e40eaa235c0814d$export$ebd5a72e5df7a200(this.configuration).updateComment(fields, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$2ad57ce8a40d338c = function(configuration) {
    return {
        /**
     * Creates connect payout.
     * @summary Creates connect payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createConnectPayout (options = {}) {
            const localVarPath = `/connect/artist/connect/payout`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account balance.
     * @summary Retrieves connect balance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectBalance (options = {}) {
            const localVarPath = `/connect/artist/connect/balance`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account by user id.
     * @summary Retrieves connect by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectByUserId (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getConnectByUserId.");
            const localVarPath = `/connect/internal/connect/user-id`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account link.
     * @summary Retrieves connect link.
     * @param {'account_onboarding' | 'account_update'} connectLinkType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLink (connectLinkType, options = {}) {
            // verify required parameter 'connectLinkType' is not null or undefined
            if (connectLinkType === null || connectLinkType === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("connectLinkType", "Required parameter connectLinkType was null or undefined when calling getConnectLink.");
            const localVarPath = `/connect/artist/connect/link`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (connectLinkType !== undefined) localVarQueryParameter["connectLinkType"] = connectLinkType;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account login link.
     * @summary Retrieves connect login link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLoginLink (options = {}) {
            const localVarPath = `/connect/artist/connect/login-link`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect payout record by id.
     * @summary Retrieves connect payout.
     * @param {string} id connect payout id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectPayout (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getConnectPayout.");
            const localVarPath = `/connect/artist/connect/payout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect readiness.
     * @summary Retrieves connect readiness.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectReadiness (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getConnectReadiness.");
            const localVarPath = `/connect/readiness`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account status.
     * @summary Retrieves connect status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectStatus (options = {}) {
            const localVarPath = `/connect/artist/connect/status`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$13a874359e1093f = function(configuration) {
    return {
        /**
     * Creates connect payout.
     * @summary Creates connect payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createConnectPayout (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).createConnectPayout(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account balance.
     * @summary Retrieves connect balance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectBalance (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).getConnectBalance(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account by user id.
     * @summary Retrieves connect by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectByUserId (userId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).getConnectByUserId(userId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account link.
     * @summary Retrieves connect link.
     * @param {'account_onboarding' | 'account_update'} connectLinkType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLink (connectLinkType, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).getConnectLink(connectLinkType, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account login link.
     * @summary Retrieves connect login link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLoginLink (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).getConnectLoginLink(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect payout record by id.
     * @summary Retrieves connect payout.
     * @param {string} id connect payout id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectPayout (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).getConnectPayout(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect readiness.
     * @summary Retrieves connect readiness.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectReadiness (userId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).getConnectReadiness(userId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account status.
     * @summary Retrieves connect status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectStatus (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$2ad57ce8a40d338c(configuration).getConnectStatus(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$d4167ec3416de109 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates connect payout.
     * @summary Creates connect payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createConnectPayout (options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).createConnectPayout(options)(fetch, basePath);
        },
        /**
     * Retrieves connect account balance.
     * @summary Retrieves connect balance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectBalance (options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).getConnectBalance(options)(fetch, basePath);
        },
        /**
     * Retrieves connect account by user id.
     * @summary Retrieves connect by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectByUserId (userId, options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).getConnectByUserId(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves connect account link.
     * @summary Retrieves connect link.
     * @param {'account_onboarding' | 'account_update'} connectLinkType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLink (connectLinkType, options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).getConnectLink(connectLinkType, options)(fetch, basePath);
        },
        /**
     * Retrieves connect account login link.
     * @summary Retrieves connect login link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLoginLink (options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).getConnectLoginLink(options)(fetch, basePath);
        },
        /**
     * Retrieves connect payout record by id.
     * @summary Retrieves connect payout.
     * @param {string} id connect payout id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectPayout (id, options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).getConnectPayout(id, options)(fetch, basePath);
        },
        /**
     * Retrieves connect readiness.
     * @summary Retrieves connect readiness.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectReadiness (userId, options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).getConnectReadiness(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves connect account status.
     * @summary Retrieves connect status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectStatus (options) {
            return $2e40eaa235c0814d$export$13a874359e1093f(configuration).getConnectStatus(options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$8dd770e5815a509c extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates connect payout.
   * @summary Creates connect payout.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ createConnectPayout(options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).createConnectPayout(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account balance.
   * @summary Retrieves connect balance.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectBalance(options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).getConnectBalance(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account by user id.
   * @summary Retrieves connect by user id.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectByUserId(userId, options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).getConnectByUserId(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account link.
   * @summary Retrieves connect link.
   * @param {'account_onboarding' | 'account_update'} connectLinkType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectLink(connectLinkType, options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).getConnectLink(connectLinkType, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account login link.
   * @summary Retrieves connect login link.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectLoginLink(options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).getConnectLoginLink(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect payout record by id.
   * @summary Retrieves connect payout.
   * @param {string} id connect payout id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectPayout(id, options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).getConnectPayout(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect readiness.
   * @summary Retrieves connect readiness.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectReadiness(userId, options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).getConnectReadiness(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account status.
   * @summary Retrieves connect status.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectStatus(options) {
        return $2e40eaa235c0814d$export$13a874359e1093f(this.configuration).getConnectStatus(options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$71469ebb96998ae5 = function(configuration) {
    return {
        /**
     * Creates customer payment method.
     * @summary Creates customer payment method.
     * @param {CreateCustomerPaymentMethodRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethod (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createCustomerPaymentMethod.");
            const localVarPath = `/customer/pm`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates customer payment method setup.
     * @summary Creates customer payment method setup.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethodSetup (options = {}) {
            const localVarPath = `/customer/pm/setup`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes customer customer payment method.
     * @summary Deletes customer customer payment method.
     * @param {string} customerPaymentMethodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCustomerPaymentMethod (customerPaymentMethodId, options = {}) {
            // verify required parameter 'customerPaymentMethodId' is not null or undefined
            if (customerPaymentMethodId === null || customerPaymentMethodId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("customerPaymentMethodId", "Required parameter customerPaymentMethodId was null or undefined when calling deleteCustomerPaymentMethod.");
            const localVarPath = `/customer/pm`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (customerPaymentMethodId !== undefined) localVarQueryParameter["customerPaymentMethodId"] = customerPaymentMethodId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves customer by user id.
     * @summary Retrieves customer by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerByUserId (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getCustomerByUserId.");
            const localVarPath = `/customer/internal/customer/user-id`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves customer default payment method.
     * @summary Retrieves customer default payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethodDefault (options = {}) {
            const localVarPath = `/customer/pm/default`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves customer payment methods.
     * @summary Retrieves customer payment methods.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethods (limit, offset, options = {}) {
            const localVarPath = `/customer/pm`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Sets customer payment method as default.
     * @summary Sets customer payment method as default.
     * @param {SetCustomerPaymentMethodDefaultRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ setCustomerPaymentMethodDefault (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling setCustomerPaymentMethodDefault.");
            const localVarPath = `/customer/pm/default`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$4a4146b511e85d27 = function(configuration) {
    return {
        /**
     * Creates customer payment method.
     * @summary Creates customer payment method.
     * @param {CreateCustomerPaymentMethodRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethod (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$71469ebb96998ae5(configuration).createCustomerPaymentMethod(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates customer payment method setup.
     * @summary Creates customer payment method setup.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethodSetup (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$71469ebb96998ae5(configuration).createCustomerPaymentMethodSetup(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes customer customer payment method.
     * @summary Deletes customer customer payment method.
     * @param {string} customerPaymentMethodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCustomerPaymentMethod (customerPaymentMethodId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$71469ebb96998ae5(configuration).deleteCustomerPaymentMethod(customerPaymentMethodId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves customer by user id.
     * @summary Retrieves customer by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerByUserId (userId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$71469ebb96998ae5(configuration).getCustomerByUserId(userId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves customer default payment method.
     * @summary Retrieves customer default payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethodDefault (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$71469ebb96998ae5(configuration).getCustomerPaymentMethodDefault(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves customer payment methods.
     * @summary Retrieves customer payment methods.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethods (limit, offset, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$71469ebb96998ae5(configuration).getCustomerPaymentMethods(limit, offset, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Sets customer payment method as default.
     * @summary Sets customer payment method as default.
     * @param {SetCustomerPaymentMethodDefaultRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ setCustomerPaymentMethodDefault (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$71469ebb96998ae5(configuration).setCustomerPaymentMethodDefault(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$58166fedf0785aa6 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates customer payment method.
     * @summary Creates customer payment method.
     * @param {CreateCustomerPaymentMethodRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethod (fields, options) {
            return $2e40eaa235c0814d$export$4a4146b511e85d27(configuration).createCustomerPaymentMethod(fields, options)(fetch, basePath);
        },
        /**
     * Creates customer payment method setup.
     * @summary Creates customer payment method setup.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethodSetup (options) {
            return $2e40eaa235c0814d$export$4a4146b511e85d27(configuration).createCustomerPaymentMethodSetup(options)(fetch, basePath);
        },
        /**
     * Deletes customer customer payment method.
     * @summary Deletes customer customer payment method.
     * @param {string} customerPaymentMethodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCustomerPaymentMethod (customerPaymentMethodId, options) {
            return $2e40eaa235c0814d$export$4a4146b511e85d27(configuration).deleteCustomerPaymentMethod(customerPaymentMethodId, options)(fetch, basePath);
        },
        /**
     * Retrieves customer by user id.
     * @summary Retrieves customer by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerByUserId (userId, options) {
            return $2e40eaa235c0814d$export$4a4146b511e85d27(configuration).getCustomerByUserId(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves customer default payment method.
     * @summary Retrieves customer default payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethodDefault (options) {
            return $2e40eaa235c0814d$export$4a4146b511e85d27(configuration).getCustomerPaymentMethodDefault(options)(fetch, basePath);
        },
        /**
     * Retrieves customer payment methods.
     * @summary Retrieves customer payment methods.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethods (limit, offset, options) {
            return $2e40eaa235c0814d$export$4a4146b511e85d27(configuration).getCustomerPaymentMethods(limit, offset, options)(fetch, basePath);
        },
        /**
     * Sets customer payment method as default.
     * @summary Sets customer payment method as default.
     * @param {SetCustomerPaymentMethodDefaultRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ setCustomerPaymentMethodDefault (fields, options) {
            return $2e40eaa235c0814d$export$4a4146b511e85d27(configuration).setCustomerPaymentMethodDefault(fields, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$db097d7a94bea193 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates customer payment method.
   * @summary Creates customer payment method.
   * @param {CreateCustomerPaymentMethodRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ createCustomerPaymentMethod(fields, options) {
        return $2e40eaa235c0814d$export$4a4146b511e85d27(this.configuration).createCustomerPaymentMethod(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates customer payment method setup.
   * @summary Creates customer payment method setup.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ createCustomerPaymentMethodSetup(options) {
        return $2e40eaa235c0814d$export$4a4146b511e85d27(this.configuration).createCustomerPaymentMethodSetup(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes customer customer payment method.
   * @summary Deletes customer customer payment method.
   * @param {string} customerPaymentMethodId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ deleteCustomerPaymentMethod(customerPaymentMethodId, options) {
        return $2e40eaa235c0814d$export$4a4146b511e85d27(this.configuration).deleteCustomerPaymentMethod(customerPaymentMethodId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves customer by user id.
   * @summary Retrieves customer by user id.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ getCustomerByUserId(userId, options) {
        return $2e40eaa235c0814d$export$4a4146b511e85d27(this.configuration).getCustomerByUserId(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves customer default payment method.
   * @summary Retrieves customer default payment method.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ getCustomerPaymentMethodDefault(options) {
        return $2e40eaa235c0814d$export$4a4146b511e85d27(this.configuration).getCustomerPaymentMethodDefault(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves customer payment methods.
   * @summary Retrieves customer payment methods.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ getCustomerPaymentMethods(limit, offset, options) {
        return $2e40eaa235c0814d$export$4a4146b511e85d27(this.configuration).getCustomerPaymentMethods(limit, offset, options)(this.fetch, this.basePath);
    }
    /**
   * Sets customer payment method as default.
   * @summary Sets customer payment method as default.
   * @param {SetCustomerPaymentMethodDefaultRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ setCustomerPaymentMethodDefault(fields, options) {
        return $2e40eaa235c0814d$export$4a4146b511e85d27(this.configuration).setCustomerPaymentMethodDefault(fields, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$df3fa95981fb43d6 = function(configuration) {
    return {
        /**
     * Creates new file.
     * @summary Creates file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createFile (options = {}) {
            const localVarPath = `/file/internal/file`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves file record.
     * @summary Retrieves file.
     * @param {string} id file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getFileInternal.");
            const localVarPath = `/file/internal/file/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves file url and redirects to it.
     * @summary Retrieves file url.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileURL (fileId, options = {}) {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fileId", "Required parameter fileId was null or undefined when calling getFileURL.");
            const localVarPath = `/file/public/file/url`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fileId !== undefined) localVarQueryParameter["fileId"] = fileId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$616f9911b7e0fb3c = function(configuration) {
    return {
        /**
     * Creates new file.
     * @summary Creates file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createFile (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$df3fa95981fb43d6(configuration).createFile(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves file record.
     * @summary Retrieves file.
     * @param {string} id file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileInternal (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$df3fa95981fb43d6(configuration).getFileInternal(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves file url and redirects to it.
     * @summary Retrieves file url.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileURL (fileId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$df3fa95981fb43d6(configuration).getFileURL(fileId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$7a8ca909023cbdbb = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates new file.
     * @summary Creates file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createFile (options) {
            return $2e40eaa235c0814d$export$616f9911b7e0fb3c(configuration).createFile(options)(fetch, basePath);
        },
        /**
     * Retrieves file record.
     * @summary Retrieves file.
     * @param {string} id file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileInternal (id, options) {
            return $2e40eaa235c0814d$export$616f9911b7e0fb3c(configuration).getFileInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves file url and redirects to it.
     * @summary Retrieves file url.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileURL (fileId, options) {
            return $2e40eaa235c0814d$export$616f9911b7e0fb3c(configuration).getFileURL(fileId, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$be85d78436eb3caf extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates new file.
   * @summary Creates file.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */ createFile(options) {
        return $2e40eaa235c0814d$export$616f9911b7e0fb3c(this.configuration).createFile(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves file record.
   * @summary Retrieves file.
   * @param {string} id file id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */ getFileInternal(id, options) {
        return $2e40eaa235c0814d$export$616f9911b7e0fb3c(this.configuration).getFileInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves file url and redirects to it.
   * @summary Retrieves file url.
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */ getFileURL(fileId, options) {
        return $2e40eaa235c0814d$export$616f9911b7e0fb3c(this.configuration).getFileURL(fileId, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$4fa7293aa73553f8 = function(configuration) {
    return {
        /**
     * Creates comment like.
     * @summary Creates comment like.
     * @param {CreateCommentLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentLike (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createCommentLike.");
            const localVarPath = `/like/comment`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates post like.
     * @summary Creates post like.
     * @param {CreatePostLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostLike (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createPostLike.");
            const localVarPath = `/like/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates track like.
     * @summary Creates track like.
     * @param {CreateTrackLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackLike (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTrackLike.");
            const localVarPath = `/like/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates user follow.
     * @summary Creates user follow.
     * @param {CreateUserFollowRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserFollow (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createUserFollow.");
            const localVarPath = `/like/user`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes comment like.
     * @summary Deletes comment like.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCommentLike (commentId, options = {}) {
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("commentId", "Required parameter commentId was null or undefined when calling deleteCommentLike.");
            const localVarPath = `/like/comment`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (commentId !== undefined) localVarQueryParameter["commentId"] = commentId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes post like.
     * @summary Deletes post like.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePostLike (postId, options = {}) {
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling deletePostLike.");
            const localVarPath = `/like/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes track like.
     * @summary Deletes track like.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrackLike (trackId, options = {}) {
            // verify required parameter 'trackId' is not null or undefined
            if (trackId === null || trackId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("trackId", "Required parameter trackId was null or undefined when calling deleteTrackLike.");
            const localVarPath = `/like/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackId !== undefined) localVarQueryParameter["trackId"] = trackId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes user follow.
     * @summary Deletes user follow.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserFollow (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling deleteUserFollow.");
            const localVarPath = `/like/user`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIds (options = {}) {
            const localVarPath = `/like/user/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getFollowedUserIdsInternal.");
            const localVarPath = `/like/internal/like/user/followed-ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that following source user.
     * @summary Retrieves ids of users that following source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowingUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getFollowingUserIdsInternal.");
            const localVarPath = `/like/internal/like/user/following-ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIds (options = {}) {
            const localVarPath = `/like/comment/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getLikedCommentIdsInternal.");
            const localVarPath = `/like/internal/like/comment/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIds (options = {}) {
            const localVarPath = `/like/post/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getLikedPostIdsInternal.");
            const localVarPath = `/like/internal/like/post/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIds (options = {}) {
            const localVarPath = `/like/track/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getLikedTrackIdsInternal.");
            const localVarPath = `/like/internal/like/track/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$f56459552dcdadb0 = function(configuration) {
    return {
        /**
     * Creates comment like.
     * @summary Creates comment like.
     * @param {CreateCommentLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentLike (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).createCommentLike(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates post like.
     * @summary Creates post like.
     * @param {CreatePostLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostLike (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).createPostLike(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates track like.
     * @summary Creates track like.
     * @param {CreateTrackLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackLike (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).createTrackLike(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates user follow.
     * @summary Creates user follow.
     * @param {CreateUserFollowRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserFollow (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).createUserFollow(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes comment like.
     * @summary Deletes comment like.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCommentLike (commentId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).deleteCommentLike(commentId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Deletes post like.
     * @summary Deletes post like.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePostLike (postId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).deletePostLike(postId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Deletes track like.
     * @summary Deletes track like.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrackLike (trackId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).deleteTrackLike(trackId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Deletes user follow.
     * @summary Deletes user follow.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserFollow (userId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).deleteUserFollow(userId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getFollowedUserIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getFollowedUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that following source user.
     * @summary Retrieves ids of users that following source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowingUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getFollowingUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getLikedCommentIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getLikedCommentIdsInternal(userId, limit, offset, random, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getLikedPostIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getLikedPostIdsInternal(userId, limit, offset, random, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getLikedTrackIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$4fa7293aa73553f8(configuration).getLikedTrackIdsInternal(userId, limit, offset, random, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$88c6e0d4f50554a2 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates comment like.
     * @summary Creates comment like.
     * @param {CreateCommentLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentLike (fields, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).createCommentLike(fields, options)(fetch, basePath);
        },
        /**
     * Creates post like.
     * @summary Creates post like.
     * @param {CreatePostLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostLike (fields, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).createPostLike(fields, options)(fetch, basePath);
        },
        /**
     * Creates track like.
     * @summary Creates track like.
     * @param {CreateTrackLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackLike (fields, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).createTrackLike(fields, options)(fetch, basePath);
        },
        /**
     * Creates user follow.
     * @summary Creates user follow.
     * @param {CreateUserFollowRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserFollow (fields, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).createUserFollow(fields, options)(fetch, basePath);
        },
        /**
     * Deletes comment like.
     * @summary Deletes comment like.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCommentLike (commentId, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).deleteCommentLike(commentId, options)(fetch, basePath);
        },
        /**
     * Deletes post like.
     * @summary Deletes post like.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePostLike (postId, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).deletePostLike(postId, options)(fetch, basePath);
        },
        /**
     * Deletes track like.
     * @summary Deletes track like.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrackLike (trackId, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).deleteTrackLike(trackId, options)(fetch, basePath);
        },
        /**
     * Deletes user follow.
     * @summary Deletes user follow.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserFollow (userId, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).deleteUserFollow(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIds (options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getFollowedUserIds(options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIdsInternal (userId, limit, offset, random, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getFollowedUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that following source user.
     * @summary Retrieves ids of users that following source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowingUserIdsInternal (userId, limit, offset, random, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getFollowingUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIds (options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getLikedCommentIds(options)(fetch, basePath);
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIdsInternal (userId, limit, offset, random, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getLikedCommentIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIds (options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getLikedPostIds(options)(fetch, basePath);
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIdsInternal (userId, limit, offset, random, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getLikedPostIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIds (options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getLikedTrackIds(options)(fetch, basePath);
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIdsInternal (userId, limit, offset, random, options) {
            return $2e40eaa235c0814d$export$f56459552dcdadb0(configuration).getLikedTrackIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$f4d3d044741564bb extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates comment like.
   * @summary Creates comment like.
   * @param {CreateCommentLikeRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createCommentLike(fields, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).createCommentLike(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates post like.
   * @summary Creates post like.
   * @param {CreatePostLikeRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createPostLike(fields, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).createPostLike(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates track like.
   * @summary Creates track like.
   * @param {CreateTrackLikeRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createTrackLike(fields, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).createTrackLike(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates user follow.
   * @summary Creates user follow.
   * @param {CreateUserFollowRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createUserFollow(fields, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).createUserFollow(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes comment like.
   * @summary Deletes comment like.
   * @param {string} commentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deleteCommentLike(commentId, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).deleteCommentLike(commentId, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes post like.
   * @summary Deletes post like.
   * @param {string} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deletePostLike(postId, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).deletePostLike(postId, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes track like.
   * @summary Deletes track like.
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deleteTrackLike(trackId, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).deleteTrackLike(trackId, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes user follow.
   * @summary Deletes user follow.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deleteUserFollow(userId, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).deleteUserFollow(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user followed.
   * @summary Retrieves ids of users that source user followed.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getFollowedUserIds(options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getFollowedUserIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user followed.
   * @summary Retrieves ids of users that source user followed.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getFollowedUserIdsInternal(userId, limit, offset, random, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getFollowedUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that following source user.
   * @summary Retrieves ids of users that following source user.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getFollowingUserIdsInternal(userId, limit, offset, random, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getFollowingUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked comment ids.
   * @summary Retrieves liked comment ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedCommentIds(options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getLikedCommentIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked comment ids.
   * @summary Retrieves liked comment ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedCommentIdsInternal(userId, limit, offset, random, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getLikedCommentIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked post ids.
   * @summary Retrieves liked post ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedPostIds(options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getLikedPostIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked post ids.
   * @summary Retrieves liked post ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedPostIdsInternal(userId, limit, offset, random, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getLikedPostIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked track ids.
   * @summary Retrieves liked track ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedTrackIds(options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getLikedTrackIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked track ids.
   * @summary Retrieves liked track ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedTrackIdsInternal(userId, limit, offset, random, options) {
        return $2e40eaa235c0814d$export$f56459552dcdadb0(this.configuration).getLikedTrackIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$75657c5701f02f07 = function(configuration) {
    return {
        /**
     * Retrieves notification record by notification id.
     * @summary Retrieves notification.
     * @param {string} id notification id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotification (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getAppNotification.");
            const localVarPath = `/notification/application/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves application notifications.
     * @summary Retrieves application notifications.
     * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotifications (entityType, limit, offset, options = {}) {
            const localVarPath = `/notification/application`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (entityType !== undefined) localVarQueryParameter["entityType"] = entityType;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Get unread application notifications count.
     * @summary Get unread application notifications count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotificationsUnreadCount (options = {}) {
            const localVarPath = `/notification/application/count`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Gets notification config.
     * @summary Gets notification config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getNotificationConfig (options = {}) {
            const localVarPath = `/notification/config`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Read notification.
     * @summary Read notification.
     * @param {ReadAppNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotification (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling readAppNotification.");
            const localVarPath = `/notification/application/read`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Read all notifications.
     * @summary Read all notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotifications (options = {}) {
            const localVarPath = `/notification/application/read-all`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates notification config.
     * @summary Updates notification config.
     * @param {UpdateNotificationConfigRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateNotificationConfig (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateNotificationConfig.");
            const localVarPath = `/notification/config`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$a9469e214f56a2ac = function(configuration) {
    return {
        /**
     * Retrieves notification record by notification id.
     * @summary Retrieves notification.
     * @param {string} id notification id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotification (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$75657c5701f02f07(configuration).getAppNotification(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves application notifications.
     * @summary Retrieves application notifications.
     * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotifications (entityType, limit, offset, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$75657c5701f02f07(configuration).getAppNotifications(entityType, limit, offset, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Get unread application notifications count.
     * @summary Get unread application notifications count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotificationsUnreadCount (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$75657c5701f02f07(configuration).getAppNotificationsUnreadCount(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Gets notification config.
     * @summary Gets notification config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getNotificationConfig (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$75657c5701f02f07(configuration).getNotificationConfig(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Read notification.
     * @summary Read notification.
     * @param {ReadAppNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotification (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$75657c5701f02f07(configuration).readAppNotification(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Read all notifications.
     * @summary Read all notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotifications (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$75657c5701f02f07(configuration).readAppNotifications(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Updates notification config.
     * @summary Updates notification config.
     * @param {UpdateNotificationConfigRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateNotificationConfig (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$75657c5701f02f07(configuration).updateNotificationConfig(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$555a825217a8a15e = function(configuration, fetch, basePath) {
    return {
        /**
     * Retrieves notification record by notification id.
     * @summary Retrieves notification.
     * @param {string} id notification id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotification (id, options) {
            return $2e40eaa235c0814d$export$a9469e214f56a2ac(configuration).getAppNotification(id, options)(fetch, basePath);
        },
        /**
     * Retrieves application notifications.
     * @summary Retrieves application notifications.
     * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotifications (entityType, limit, offset, options) {
            return $2e40eaa235c0814d$export$a9469e214f56a2ac(configuration).getAppNotifications(entityType, limit, offset, options)(fetch, basePath);
        },
        /**
     * Get unread application notifications count.
     * @summary Get unread application notifications count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotificationsUnreadCount (options) {
            return $2e40eaa235c0814d$export$a9469e214f56a2ac(configuration).getAppNotificationsUnreadCount(options)(fetch, basePath);
        },
        /**
     * Gets notification config.
     * @summary Gets notification config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getNotificationConfig (options) {
            return $2e40eaa235c0814d$export$a9469e214f56a2ac(configuration).getNotificationConfig(options)(fetch, basePath);
        },
        /**
     * Read notification.
     * @summary Read notification.
     * @param {ReadAppNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotification (fields, options) {
            return $2e40eaa235c0814d$export$a9469e214f56a2ac(configuration).readAppNotification(fields, options)(fetch, basePath);
        },
        /**
     * Read all notifications.
     * @summary Read all notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotifications (options) {
            return $2e40eaa235c0814d$export$a9469e214f56a2ac(configuration).readAppNotifications(options)(fetch, basePath);
        },
        /**
     * Updates notification config.
     * @summary Updates notification config.
     * @param {UpdateNotificationConfigRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateNotificationConfig (fields, options) {
            return $2e40eaa235c0814d$export$a9469e214f56a2ac(configuration).updateNotificationConfig(fields, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$e8fd42033d129624 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Retrieves notification record by notification id.
   * @summary Retrieves notification.
   * @param {string} id notification id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getAppNotification(id, options) {
        return $2e40eaa235c0814d$export$a9469e214f56a2ac(this.configuration).getAppNotification(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves application notifications.
   * @summary Retrieves application notifications.
   * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getAppNotifications(entityType, limit, offset, options) {
        return $2e40eaa235c0814d$export$a9469e214f56a2ac(this.configuration).getAppNotifications(entityType, limit, offset, options)(this.fetch, this.basePath);
    }
    /**
   * Get unread application notifications count.
   * @summary Get unread application notifications count.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getAppNotificationsUnreadCount(options) {
        return $2e40eaa235c0814d$export$a9469e214f56a2ac(this.configuration).getAppNotificationsUnreadCount(options)(this.fetch, this.basePath);
    }
    /**
   * Gets notification config.
   * @summary Gets notification config.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getNotificationConfig(options) {
        return $2e40eaa235c0814d$export$a9469e214f56a2ac(this.configuration).getNotificationConfig(options)(this.fetch, this.basePath);
    }
    /**
   * Read notification.
   * @summary Read notification.
   * @param {ReadAppNotificationRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ readAppNotification(fields, options) {
        return $2e40eaa235c0814d$export$a9469e214f56a2ac(this.configuration).readAppNotification(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Read all notifications.
   * @summary Read all notifications.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ readAppNotifications(options) {
        return $2e40eaa235c0814d$export$a9469e214f56a2ac(this.configuration).readAppNotifications(options)(this.fetch, this.basePath);
    }
    /**
   * Updates notification config.
   * @summary Updates notification config.
   * @param {UpdateNotificationConfigRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ updateNotificationConfig(fields, options) {
        return $2e40eaa235c0814d$export$a9469e214f56a2ac(this.configuration).updateNotificationConfig(fields, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$5cb766cdc0787e4b = function(configuration) {
    return {
        /**
     * Blocks post record.
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockPost (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockPost.");
            const localVarPath = `/post/admin/post/block`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new post.
     * @summary Creates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPost (options = {}) {
            const localVarPath = `/post/artist/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes post.
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePost (postId, options = {}) {
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling deletePost.");
            const localVarPath = `/post/artist/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves artist posts.
     * @summary Retrieves artist posts.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistPosts (artistId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'artistId' is not null or undefined
            if (artistId === null || artistId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("artistId", "Required parameter artistId was null or undefined when calling getArtistPosts.");
            const localVarPath = `/post/artist`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves exclusive posts.
     * @summary Retrieves exclusive posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusivePosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/exclusive`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves latest posts.
     * @summary Retrieves latest posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestPosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/latest`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked posts.
     * @summary Retrieves liked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPosts (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/liked`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves popular posts.
     * @summary Retrieves popular posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularPosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/popular`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves post record by post id.
     * @summary Retrieves post.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPost (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getPost.");
            const localVarPath = `/post/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves post by post id.
     * @summary Retrieves post by post id.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPostInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getPostInternal.");
            const localVarPath = `/post/internal/post/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public posts.
     * @summary Retrieves public posts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicPosts (options = {}) {
            const localVarPath = `/post/public/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves recommended posts.
     * @summary Retrieves recommended posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedPosts (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/recommended`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves trending posts.
     * @summary Retrieves trending posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingPosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/trending`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked posts.
     * @summary Retrieves unlocked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPosts (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/unlocked`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Get user posts count.
     * @summary Get user posts count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserPostsCount (options = {}) {
            const localVarPath = `/post/artist/post/count`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates post record.
     * @summary Updates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updatePost (options = {}) {
            const localVarPath = `/post/artist/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$f234a50b39b81833 = function(configuration) {
    return {
        /**
     * Blocks post record.
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockPost (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).blockPost(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates new post.
     * @summary Creates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPost (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).createPost(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes post.
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePost (postId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).deletePost(postId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves artist posts.
     * @summary Retrieves artist posts.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getArtistPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves exclusive posts.
     * @summary Retrieves exclusive posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusivePosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getExclusivePosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves latest posts.
     * @summary Retrieves latest posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getLatestPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked posts.
     * @summary Retrieves liked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPosts (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getLikedPosts(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves popular posts.
     * @summary Retrieves popular posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getPopularPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves post record by post id.
     * @summary Retrieves post.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPost (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getPost(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves post by post id.
     * @summary Retrieves post by post id.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPostInternal (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getPostInternal(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public posts.
     * @summary Retrieves public posts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicPosts (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getPublicPosts(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves recommended posts.
     * @summary Retrieves recommended posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedPosts (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getRecommendedPosts(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves trending posts.
     * @summary Retrieves trending posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getTrendingPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked posts.
     * @summary Retrieves unlocked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPosts (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getUnlockedPosts(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Get user posts count.
     * @summary Get user posts count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserPostsCount (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).getUserPostsCount(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates post record.
     * @summary Updates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updatePost (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$5cb766cdc0787e4b(configuration).updatePost(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$4c1cdc9130b4aa88 = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks post record.
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockPost (fields, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).blockPost(fields, options)(fetch, basePath);
        },
        /**
     * Creates new post.
     * @summary Creates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPost (options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).createPost(options)(fetch, basePath);
        },
        /**
     * Deletes post.
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePost (postId, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).deletePost(postId, options)(fetch, basePath);
        },
        /**
     * Retrieves artist posts.
     * @summary Retrieves artist posts.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistPosts (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getArtistPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves exclusive posts.
     * @summary Retrieves exclusive posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusivePosts (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getExclusivePosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves latest posts.
     * @summary Retrieves latest posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestPosts (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getLatestPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves liked posts.
     * @summary Retrieves liked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPosts (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getLikedPosts(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves popular posts.
     * @summary Retrieves popular posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularPosts (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getPopularPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves post record by post id.
     * @summary Retrieves post.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPost (id, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getPost(id, options)(fetch, basePath);
        },
        /**
     * Retrieves post by post id.
     * @summary Retrieves post by post id.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPostInternal (id, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getPostInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves public posts.
     * @summary Retrieves public posts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicPosts (options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getPublicPosts(options)(fetch, basePath);
        },
        /**
     * Retrieves recommended posts.
     * @summary Retrieves recommended posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedPosts (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getRecommendedPosts(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves trending posts.
     * @summary Retrieves trending posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingPosts (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getTrendingPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked posts.
     * @summary Retrieves unlocked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPosts (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getUnlockedPosts(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Get user posts count.
     * @summary Get user posts count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserPostsCount (options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).getUserPostsCount(options)(fetch, basePath);
        },
        /**
     * Updates post record.
     * @summary Updates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updatePost (options) {
            return $2e40eaa235c0814d$export$f234a50b39b81833(configuration).updatePost(options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$51444d8b6a1912f3 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Blocks post record.
   * @summary Blocks post.
   * @param {BlockPostRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ blockPost(fields, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).blockPost(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new post.
   * @summary Creates post.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ createPost(options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).createPost(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes post.
   * @summary Deletes post.
   * @param {string} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ deletePost(postId, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).deletePost(postId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves artist posts.
   * @summary Retrieves artist posts.
   * @param {string} artistId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getArtistPosts(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getArtistPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves exclusive posts.
   * @summary Retrieves exclusive posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getExclusivePosts(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getExclusivePosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves latest posts.
   * @summary Retrieves latest posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getLatestPosts(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getLatestPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked posts.
   * @summary Retrieves liked posts.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getLikedPosts(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getLikedPosts(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves popular posts.
   * @summary Retrieves popular posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPopularPosts(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getPopularPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves post record by post id.
   * @summary Retrieves post.
   * @param {string} id post id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPost(id, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getPost(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves post by post id.
   * @summary Retrieves post by post id.
   * @param {string} id post id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPostInternal(id, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getPostInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public posts.
   * @summary Retrieves public posts.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPublicPosts(options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getPublicPosts(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves recommended posts.
   * @summary Retrieves recommended posts.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getRecommendedPosts(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getRecommendedPosts(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves trending posts.
   * @summary Retrieves trending posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getTrendingPosts(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getTrendingPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked posts.
   * @summary Retrieves unlocked posts.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getUnlockedPosts(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getUnlockedPosts(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Get user posts count.
   * @summary Get user posts count.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getUserPostsCount(options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).getUserPostsCount(options)(this.fetch, this.basePath);
    }
    /**
   * Updates post record.
   * @summary Updates post.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ updatePost(options) {
        return $2e40eaa235c0814d$export$f234a50b39b81833(this.configuration).updatePost(options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$298ba5a3ce00f2c8 = function(configuration) {
    return {
        /**
     * Creates report complaint.
     * @summary Creates report complaint.
     * @param {CreateReportComplaintRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createReportComplaint (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createReportComplaint.");
            const localVarPath = `/report/complaint`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves report.
     * @summary Retrieves report.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReport (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getReport.");
            const localVarPath = `/report/admin/report/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves report complaint.
     * @summary Retrieves report complaint.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaint (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getReportComplaint.");
            const localVarPath = `/report/admin/report/complaint/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves report complaints.
     * @summary Retrieves report complaints.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaints (reportId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'reportId' is not null or undefined
            if (reportId === null || reportId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("reportId", "Required parameter reportId was null or undefined when calling getReportComplaints.");
            const localVarPath = `/report/admin/report/complaint`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (reportId !== undefined) localVarQueryParameter["reportId"] = reportId;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves reports.
     * @summary Retrieves reports.
     * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReports (entityType, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/report/admin/report`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (entityType !== undefined) localVarQueryParameter["entityType"] = entityType;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Resolves report.
     * @summary Resolves report.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resolveReport (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling resolveReport.");
            const localVarPath = `/report/admin/report/resolve`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$e01283755cdb5707 = function(configuration) {
    return {
        /**
     * Creates report complaint.
     * @summary Creates report complaint.
     * @param {CreateReportComplaintRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createReportComplaint (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$298ba5a3ce00f2c8(configuration).createReportComplaint(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves report.
     * @summary Retrieves report.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReport (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$298ba5a3ce00f2c8(configuration).getReport(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves report complaint.
     * @summary Retrieves report complaint.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaint (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$298ba5a3ce00f2c8(configuration).getReportComplaint(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves report complaints.
     * @summary Retrieves report complaints.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaints (reportId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$298ba5a3ce00f2c8(configuration).getReportComplaints(reportId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves reports.
     * @summary Retrieves reports.
     * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReports (entityType, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$298ba5a3ce00f2c8(configuration).getReports(entityType, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Resolves report.
     * @summary Resolves report.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resolveReport (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$298ba5a3ce00f2c8(configuration).resolveReport(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$8b7678fe62a5c77 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates report complaint.
     * @summary Creates report complaint.
     * @param {CreateReportComplaintRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createReportComplaint (fields, options) {
            return $2e40eaa235c0814d$export$e01283755cdb5707(configuration).createReportComplaint(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves report.
     * @summary Retrieves report.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReport (id, options) {
            return $2e40eaa235c0814d$export$e01283755cdb5707(configuration).getReport(id, options)(fetch, basePath);
        },
        /**
     * Retrieves report complaint.
     * @summary Retrieves report complaint.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaint (id, options) {
            return $2e40eaa235c0814d$export$e01283755cdb5707(configuration).getReportComplaint(id, options)(fetch, basePath);
        },
        /**
     * Retrieves report complaints.
     * @summary Retrieves report complaints.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaints (reportId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$e01283755cdb5707(configuration).getReportComplaints(reportId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves reports.
     * @summary Retrieves reports.
     * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReports (entityType, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$e01283755cdb5707(configuration).getReports(entityType, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Resolves report.
     * @summary Resolves report.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resolveReport (fields, options) {
            return $2e40eaa235c0814d$export$e01283755cdb5707(configuration).resolveReport(fields, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$86e5bee652cd816e extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates report complaint.
   * @summary Creates report complaint.
   * @param {CreateReportComplaintRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ createReportComplaint(fields, options) {
        return $2e40eaa235c0814d$export$e01283755cdb5707(this.configuration).createReportComplaint(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves report.
   * @summary Retrieves report.
   * @param {string} id report id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReport(id, options) {
        return $2e40eaa235c0814d$export$e01283755cdb5707(this.configuration).getReport(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves report complaint.
   * @summary Retrieves report complaint.
   * @param {string} id report id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReportComplaint(id, options) {
        return $2e40eaa235c0814d$export$e01283755cdb5707(this.configuration).getReportComplaint(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves report complaints.
   * @summary Retrieves report complaints.
   * @param {string} reportId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReportComplaints(reportId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$e01283755cdb5707(this.configuration).getReportComplaints(reportId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves reports.
   * @summary Retrieves reports.
   * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReports(entityType, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$e01283755cdb5707(this.configuration).getReports(entityType, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Resolves report.
   * @summary Resolves report.
   * @param {ResolveReportRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ resolveReport(fields, options) {
        return $2e40eaa235c0814d$export$e01283755cdb5707(this.configuration).resolveReport(fields, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$98ce312589c0aec = function(configuration) {
    return {
        /**
     * Creates comment stream.
     * @summary Creates comment stream.
     * @param {CreateCommentStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createCommentStream.");
            const localVarPath = `/stream/comment`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates post stream.
     * @summary Creates post stream.
     * @param {CreatePostStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createPostStream.");
            const localVarPath = `/stream/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates track stream.
     * @summary Creates track stream.
     * @param {CreateTrackStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTrackStream.");
            const localVarPath = `/stream/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates user stream.
     * @summary Creates user stream.
     * @param {CreateUserStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createUserStream.");
            const localVarPath = `/stream/user`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$3b4408a65aba20ad = function(configuration) {
    return {
        /**
     * Creates comment stream.
     * @summary Creates comment stream.
     * @param {CreateCommentStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentStream (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$98ce312589c0aec(configuration).createCommentStream(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates post stream.
     * @summary Creates post stream.
     * @param {CreatePostStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostStream (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$98ce312589c0aec(configuration).createPostStream(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates track stream.
     * @summary Creates track stream.
     * @param {CreateTrackStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackStream (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$98ce312589c0aec(configuration).createTrackStream(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates user stream.
     * @summary Creates user stream.
     * @param {CreateUserStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserStream (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$98ce312589c0aec(configuration).createUserStream(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$85d7fb4fb637ac92 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates comment stream.
     * @summary Creates comment stream.
     * @param {CreateCommentStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentStream (fields, options) {
            return $2e40eaa235c0814d$export$3b4408a65aba20ad(configuration).createCommentStream(fields, options)(fetch, basePath);
        },
        /**
     * Creates post stream.
     * @summary Creates post stream.
     * @param {CreatePostStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostStream (fields, options) {
            return $2e40eaa235c0814d$export$3b4408a65aba20ad(configuration).createPostStream(fields, options)(fetch, basePath);
        },
        /**
     * Creates track stream.
     * @summary Creates track stream.
     * @param {CreateTrackStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackStream (fields, options) {
            return $2e40eaa235c0814d$export$3b4408a65aba20ad(configuration).createTrackStream(fields, options)(fetch, basePath);
        },
        /**
     * Creates user stream.
     * @summary Creates user stream.
     * @param {CreateUserStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserStream (fields, options) {
            return $2e40eaa235c0814d$export$3b4408a65aba20ad(configuration).createUserStream(fields, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$7d740e068388f14a extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates comment stream.
   * @summary Creates comment stream.
   * @param {CreateCommentStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createCommentStream(fields, options) {
        return $2e40eaa235c0814d$export$3b4408a65aba20ad(this.configuration).createCommentStream(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates post stream.
   * @summary Creates post stream.
   * @param {CreatePostStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createPostStream(fields, options) {
        return $2e40eaa235c0814d$export$3b4408a65aba20ad(this.configuration).createPostStream(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates track stream.
   * @summary Creates track stream.
   * @param {CreateTrackStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createTrackStream(fields, options) {
        return $2e40eaa235c0814d$export$3b4408a65aba20ad(this.configuration).createTrackStream(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates user stream.
   * @summary Creates user stream.
   * @param {CreateUserStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createUserStream(fields, options) {
        return $2e40eaa235c0814d$export$3b4408a65aba20ad(this.configuration).createUserStream(fields, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$a054088e26b5b8b8 = function(configuration) {
    return {
        /**
     * Cancels subscription.
     * @summary Cancels subscription.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelSubscription (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling cancelSubscription.");
            const localVarPath = `/subscription/cancel`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new subscription.
     * @summary Creates subscription.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSubscription (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createSubscription.");
            const localVarPath = `/subscription`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to and that ends soon.
     * @summary Retrieves ids of users that source user subscribed to and that ends soon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedAtPeriodEndUserIds (options = {}) {
            const localVarPath = `/subscription/subscribed-at-period-end-ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIds (options = {}) {
            const localVarPath = `/subscription/subscribed-ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getSubscribedUserIdsInternal.");
            const localVarPath = `/subscription/internal/subscription/subscribed-ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that subscribing to source user.
     * @summary Retrieves ids of users that subscribing to source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribingUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getSubscribingUserIdsInternal.");
            const localVarPath = `/subscription/internal/subscription/subscribing-ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves subscription record by subscription id.
     * @summary Retrieves subscription.
     * @param {string} id subscription id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscription (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getSubscription.");
            const localVarPath = `/subscription/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user subscription price.
     * @summary Retrieves user subscription price.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserSubscriptionPrice (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUserSubscriptionPrice.");
            const localVarPath = `/subscription/user/price`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Renews subscription.
     * @summary Renews subscription.
     * @param {RenewSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ renewSubscription (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling renewSubscription.");
            const localVarPath = `/subscription/renew`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$13ba686ae7277c35 = function(configuration) {
    return {
        /**
     * Cancels subscription.
     * @summary Cancels subscription.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelSubscription (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).cancelSubscription(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates new subscription.
     * @summary Creates subscription.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSubscription (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).createSubscription(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to and that ends soon.
     * @summary Retrieves ids of users that source user subscribed to and that ends soon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedAtPeriodEndUserIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).getSubscribedAtPeriodEndUserIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).getSubscribedUserIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).getSubscribedUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that subscribing to source user.
     * @summary Retrieves ids of users that subscribing to source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribingUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).getSubscribingUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves subscription record by subscription id.
     * @summary Retrieves subscription.
     * @param {string} id subscription id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscription (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).getSubscription(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user subscription price.
     * @summary Retrieves user subscription price.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserSubscriptionPrice (userId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).getUserSubscriptionPrice(userId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Renews subscription.
     * @summary Renews subscription.
     * @param {RenewSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ renewSubscription (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$a054088e26b5b8b8(configuration).renewSubscription(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$a14d222a060290a9 = function(configuration, fetch, basePath) {
    return {
        /**
     * Cancels subscription.
     * @summary Cancels subscription.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelSubscription (fields, options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).cancelSubscription(fields, options)(fetch, basePath);
        },
        /**
     * Creates new subscription.
     * @summary Creates subscription.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSubscription (fields, options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).createSubscription(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user subscribed to and that ends soon.
     * @summary Retrieves ids of users that source user subscribed to and that ends soon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedAtPeriodEndUserIds (options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).getSubscribedAtPeriodEndUserIds(options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIds (options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).getSubscribedUserIds(options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIdsInternal (userId, limit, offset, random, options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).getSubscribedUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that subscribing to source user.
     * @summary Retrieves ids of users that subscribing to source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribingUserIdsInternal (userId, limit, offset, random, options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).getSubscribingUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves subscription record by subscription id.
     * @summary Retrieves subscription.
     * @param {string} id subscription id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscription (id, options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).getSubscription(id, options)(fetch, basePath);
        },
        /**
     * Retrieves user subscription price.
     * @summary Retrieves user subscription price.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserSubscriptionPrice (userId, options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).getUserSubscriptionPrice(userId, options)(fetch, basePath);
        },
        /**
     * Renews subscription.
     * @summary Renews subscription.
     * @param {RenewSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ renewSubscription (fields, options) {
            return $2e40eaa235c0814d$export$13ba686ae7277c35(configuration).renewSubscription(fields, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$79802d927b7d883c extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Cancels subscription.
   * @summary Cancels subscription.
   * @param {CancelSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ cancelSubscription(fields, options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).cancelSubscription(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new subscription.
   * @summary Creates subscription.
   * @param {CreateSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ createSubscription(fields, options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).createSubscription(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user subscribed to and that ends soon.
   * @summary Retrieves ids of users that source user subscribed to and that ends soon.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribedAtPeriodEndUserIds(options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).getSubscribedAtPeriodEndUserIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user subscribed to.
   * @summary Retrieves ids of users that source user subscribed to.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribedUserIds(options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).getSubscribedUserIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user subscribed to.
   * @summary Retrieves ids of users that source user subscribed to.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribedUserIdsInternal(userId, limit, offset, random, options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).getSubscribedUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that subscribing to source user.
   * @summary Retrieves ids of users that subscribing to source user.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribingUserIdsInternal(userId, limit, offset, random, options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).getSubscribingUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves subscription record by subscription id.
   * @summary Retrieves subscription.
   * @param {string} id subscription id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscription(id, options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).getSubscription(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user subscription price.
   * @summary Retrieves user subscription price.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getUserSubscriptionPrice(userId, options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).getUserSubscriptionPrice(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Renews subscription.
   * @summary Renews subscription.
   * @param {RenewSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ renewSubscription(fields, options) {
        return $2e40eaa235c0814d$export$13ba686ae7277c35(this.configuration).renewSubscription(fields, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$44a18ac66b7b6b41 = function(configuration) {
    return {
        /**
     * Creates new tip.
     * @summary Creates tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTip (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTip.");
            const localVarPath = `/tip`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves tip record by tip id.
     * @summary Retrieves tip.
     * @param {string} id tip id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTip (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getTip.");
            const localVarPath = `/tip/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$52466198ed381a8b = function(configuration) {
    return {
        /**
     * Creates new tip.
     * @summary Creates tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTip (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$44a18ac66b7b6b41(configuration).createTip(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves tip record by tip id.
     * @summary Retrieves tip.
     * @param {string} id tip id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTip (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$44a18ac66b7b6b41(configuration).getTip(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$4a9cbb4cafff9797 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates new tip.
     * @summary Creates tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTip (fields, options) {
            return $2e40eaa235c0814d$export$52466198ed381a8b(configuration).createTip(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves tip record by tip id.
     * @summary Retrieves tip.
     * @param {string} id tip id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTip (id, options) {
            return $2e40eaa235c0814d$export$52466198ed381a8b(configuration).getTip(id, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$29fe426b57068b65 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates new tip.
   * @summary Creates tip.
   * @param {CreateTipRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TipApi
   */ createTip(fields, options) {
        return $2e40eaa235c0814d$export$52466198ed381a8b(this.configuration).createTip(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves tip record by tip id.
   * @summary Retrieves tip.
   * @param {string} id tip id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TipApi
   */ getTip(id, options) {
        return $2e40eaa235c0814d$export$52466198ed381a8b(this.configuration).getTip(id, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$14504bceefed84d7 = function(configuration) {
    return {
        /**
     * Blocks track record.
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockTrack (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockTrack.");
            const localVarPath = `/track/admin/track/block`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new track.
     * @summary Creates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrack (options = {}) {
            const localVarPath = `/track/artist/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes track.
     * @summary Deletes track.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrack (trackId, options = {}) {
            // verify required parameter 'trackId' is not null or undefined
            if (trackId === null || trackId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("trackId", "Required parameter trackId was null or undefined when calling deleteTrack.");
            const localVarPath = `/track/artist/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackId !== undefined) localVarQueryParameter["trackId"] = trackId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves artist tracks.
     * @summary Retrieves artist tracks.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistTracks (artistId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'artistId' is not null or undefined
            if (artistId === null || artistId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("artistId", "Required parameter artistId was null or undefined when calling getArtistTracks.");
            const localVarPath = `/track/artist`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves exclusive tracks.
     * @summary Retrieves exclusive tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusiveTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/exclusive`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves latest tracks.
     * @summary Retrieves latest tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/latest`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked tracks.
     * @summary Retrieves liked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTracks (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/liked`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves popular tracks.
     * @summary Retrieves popular tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/popular`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public tracks.
     * @summary Retrieves public tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracks (options = {}) {
            const localVarPath = `/track/public/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public tracks by given ids.
     * @summary Retrieves public tracks by given ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracksByIds (trackIds, options = {}) {
            const localVarPath = `/track/public/track/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (trackIds !== undefined) localVarQueryParameter["trackIds"] = trackIds;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves recommended tracks.
     * @summary Retrieves recommended tracks.
     * @param {string} [genres]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedTracks (genres, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/recommended`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (genres !== undefined) localVarQueryParameter["genres"] = genres;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrack (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getTrack.");
            const localVarPath = `/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrackInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getTrackInternal.");
            const localVarPath = `/track/internal/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves tracks author valid state.
     * @summary Retrieves tracks author valid state.
     * @param {string} trackIds
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksAuthorValid (trackIds, userId, options = {}) {
            // verify required parameter 'trackIds' is not null or undefined
            if (trackIds === null || trackIds === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("trackIds", "Required parameter trackIds was null or undefined when calling getTracksAuthorValid.");
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getTracksAuthorValid.");
            const localVarPath = `/track/internal/track/author-valid`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackIds !== undefined) localVarQueryParameter["trackIds"] = trackIds;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves tracks by ids.
     * @summary Retrieves tracks by ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksByIds (trackIds, options = {}) {
            const localVarPath = `/track/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackIds !== undefined) localVarQueryParameter["trackIds"] = trackIds;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves trending tracks.
     * @summary Retrieves trending tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/trending`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked tracks.
     * @summary Retrieves unlocked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTracks (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/unlocked`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Get user tracks count.
     * @summary Get user tracks count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserTracksCount (options = {}) {
            const localVarPath = `/track/artist/track/count`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates track record.
     * @summary Updates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateTrack (options = {}) {
            const localVarPath = `/track/artist/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$6285ceb542196e4d = function(configuration) {
    return {
        /**
     * Blocks track record.
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockTrack (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).blockTrack(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates new track.
     * @summary Creates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrack (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).createTrack(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes track.
     * @summary Deletes track.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrack (trackId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).deleteTrack(trackId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves artist tracks.
     * @summary Retrieves artist tracks.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getArtistTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves exclusive tracks.
     * @summary Retrieves exclusive tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusiveTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getExclusiveTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves latest tracks.
     * @summary Retrieves latest tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getLatestTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked tracks.
     * @summary Retrieves liked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTracks (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getLikedTracks(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves popular tracks.
     * @summary Retrieves popular tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getPopularTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public tracks.
     * @summary Retrieves public tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracks (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getPublicTracks(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public tracks by given ids.
     * @summary Retrieves public tracks by given ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracksByIds (trackIds, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getPublicTracksByIds(trackIds, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves recommended tracks.
     * @summary Retrieves recommended tracks.
     * @param {string} [genres]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedTracks (genres, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getRecommendedTracks(genres, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrack (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getTrack(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrackInternal (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getTrackInternal(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves tracks author valid state.
     * @summary Retrieves tracks author valid state.
     * @param {string} trackIds
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksAuthorValid (trackIds, userId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getTracksAuthorValid(trackIds, userId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves tracks by ids.
     * @summary Retrieves tracks by ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksByIds (trackIds, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getTracksByIds(trackIds, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves trending tracks.
     * @summary Retrieves trending tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getTrendingTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked tracks.
     * @summary Retrieves unlocked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTracks (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getUnlockedTracks(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Get user tracks count.
     * @summary Get user tracks count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserTracksCount (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).getUserTracksCount(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates track record.
     * @summary Updates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateTrack (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$14504bceefed84d7(configuration).updateTrack(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$79af1ab2b3df3649 = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks track record.
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockTrack (fields, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).blockTrack(fields, options)(fetch, basePath);
        },
        /**
     * Creates new track.
     * @summary Creates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrack (options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).createTrack(options)(fetch, basePath);
        },
        /**
     * Deletes track.
     * @summary Deletes track.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrack (trackId, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).deleteTrack(trackId, options)(fetch, basePath);
        },
        /**
     * Retrieves artist tracks.
     * @summary Retrieves artist tracks.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistTracks (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getArtistTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves exclusive tracks.
     * @summary Retrieves exclusive tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusiveTracks (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getExclusiveTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves latest tracks.
     * @summary Retrieves latest tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestTracks (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getLatestTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves liked tracks.
     * @summary Retrieves liked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTracks (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getLikedTracks(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves popular tracks.
     * @summary Retrieves popular tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularTracks (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getPopularTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves public tracks.
     * @summary Retrieves public tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracks (options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getPublicTracks(options)(fetch, basePath);
        },
        /**
     * Retrieves public tracks by given ids.
     * @summary Retrieves public tracks by given ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracksByIds (trackIds, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getPublicTracksByIds(trackIds, options)(fetch, basePath);
        },
        /**
     * Retrieves recommended tracks.
     * @summary Retrieves recommended tracks.
     * @param {string} [genres]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedTracks (genres, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getRecommendedTracks(genres, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrack (id, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getTrack(id, options)(fetch, basePath);
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrackInternal (id, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getTrackInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves tracks author valid state.
     * @summary Retrieves tracks author valid state.
     * @param {string} trackIds
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksAuthorValid (trackIds, userId, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getTracksAuthorValid(trackIds, userId, options)(fetch, basePath);
        },
        /**
     * Retrieves tracks by ids.
     * @summary Retrieves tracks by ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksByIds (trackIds, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getTracksByIds(trackIds, options)(fetch, basePath);
        },
        /**
     * Retrieves trending tracks.
     * @summary Retrieves trending tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingTracks (artistId, limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getTrendingTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked tracks.
     * @summary Retrieves unlocked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTracks (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getUnlockedTracks(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Get user tracks count.
     * @summary Get user tracks count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserTracksCount (options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).getUserTracksCount(options)(fetch, basePath);
        },
        /**
     * Updates track record.
     * @summary Updates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateTrack (options) {
            return $2e40eaa235c0814d$export$6285ceb542196e4d(configuration).updateTrack(options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$2f8f7bdb7e386612 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Blocks track record.
   * @summary Blocks track.
   * @param {BlockTrackRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ blockTrack(fields, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).blockTrack(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new track.
   * @summary Creates track.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ createTrack(options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).createTrack(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes track.
   * @summary Deletes track.
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ deleteTrack(trackId, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).deleteTrack(trackId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves artist tracks.
   * @summary Retrieves artist tracks.
   * @param {string} artistId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getArtistTracks(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getArtistTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves exclusive tracks.
   * @summary Retrieves exclusive tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getExclusiveTracks(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getExclusiveTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves latest tracks.
   * @summary Retrieves latest tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getLatestTracks(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getLatestTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked tracks.
   * @summary Retrieves liked tracks.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getLikedTracks(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getLikedTracks(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves popular tracks.
   * @summary Retrieves popular tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getPopularTracks(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getPopularTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public tracks.
   * @summary Retrieves public tracks.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getPublicTracks(options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getPublicTracks(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public tracks by given ids.
   * @summary Retrieves public tracks by given ids.
   * @param {string} [trackIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getPublicTracksByIds(trackIds, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getPublicTracksByIds(trackIds, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves recommended tracks.
   * @summary Retrieves recommended tracks.
   * @param {string} [genres]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getRecommendedTracks(genres, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getRecommendedTracks(genres, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves track record by track id.
   * @summary Retrieves track.
   * @param {string} id track id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTrack(id, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getTrack(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves track record by track id.
   * @summary Retrieves track.
   * @param {string} id track id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTrackInternal(id, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getTrackInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves tracks author valid state.
   * @summary Retrieves tracks author valid state.
   * @param {string} trackIds
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTracksAuthorValid(trackIds, userId, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getTracksAuthorValid(trackIds, userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves tracks by ids.
   * @summary Retrieves tracks by ids.
   * @param {string} [trackIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTracksByIds(trackIds, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getTracksByIds(trackIds, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves trending tracks.
   * @summary Retrieves trending tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTrendingTracks(artistId, limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getTrendingTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked tracks.
   * @summary Retrieves unlocked tracks.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getUnlockedTracks(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getUnlockedTracks(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Get user tracks count.
   * @summary Get user tracks count.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getUserTracksCount(options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).getUserTracksCount(options)(this.fetch, this.basePath);
    }
    /**
   * Updates track record.
   * @summary Updates track.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ updateTrack(options) {
        return $2e40eaa235c0814d$export$6285ceb542196e4d(this.configuration).updateTrack(options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$db7ab0198431f2e9 = function(configuration) {
    return {
        /**
     * Retrieves income transactions.
     * @summary Retrieves income transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getIncomeTransactions (limit, offset, transactionType, options = {}) {
            const localVarPath = `/transaction/artist/transaction/income`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (transactionType !== undefined) localVarQueryParameter["transactionType"] = transactionType;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves outgoing transactions.
     * @summary Retrieves outgoing transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getOutgoingTransactions (limit, offset, transactionType, options = {}) {
            const localVarPath = `/transaction/outgoing`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (transactionType !== undefined) localVarQueryParameter["transactionType"] = transactionType;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$a136dbc1c4657b7a = function(configuration) {
    return {
        /**
     * Retrieves income transactions.
     * @summary Retrieves income transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getIncomeTransactions (limit, offset, transactionType, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$db7ab0198431f2e9(configuration).getIncomeTransactions(limit, offset, transactionType, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves outgoing transactions.
     * @summary Retrieves outgoing transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getOutgoingTransactions (limit, offset, transactionType, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$db7ab0198431f2e9(configuration).getOutgoingTransactions(limit, offset, transactionType, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$4a088f1f327fddcf = function(configuration, fetch, basePath) {
    return {
        /**
     * Retrieves income transactions.
     * @summary Retrieves income transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getIncomeTransactions (limit, offset, transactionType, options) {
            return $2e40eaa235c0814d$export$a136dbc1c4657b7a(configuration).getIncomeTransactions(limit, offset, transactionType, options)(fetch, basePath);
        },
        /**
     * Retrieves outgoing transactions.
     * @summary Retrieves outgoing transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getOutgoingTransactions (limit, offset, transactionType, options) {
            return $2e40eaa235c0814d$export$a136dbc1c4657b7a(configuration).getOutgoingTransactions(limit, offset, transactionType, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$392ee3f1e8966c92 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Retrieves income transactions.
   * @summary Retrieves income transactions.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */ getIncomeTransactions(limit, offset, transactionType, options) {
        return $2e40eaa235c0814d$export$a136dbc1c4657b7a(this.configuration).getIncomeTransactions(limit, offset, transactionType, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves outgoing transactions.
   * @summary Retrieves outgoing transactions.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */ getOutgoingTransactions(limit, offset, transactionType, options) {
        return $2e40eaa235c0814d$export$a136dbc1c4657b7a(this.configuration).getOutgoingTransactions(limit, offset, transactionType, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1 = function(configuration) {
    return {
        /**
     * Creates new post unlock.
     * @summary Creates post unlock.
     * @param {CreatePostUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostUnlock (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createPostUnlock.");
            const localVarPath = `/unlock/post`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new track unlock.
     * @summary Creates track unlock.
     * @param {CreateTrackUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackUnlock (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTrackUnlock.");
            const localVarPath = `/unlock/track`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlock record by unlock id.
     * @summary Retrieves unlock.
     * @param {string} id unlock id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlock (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getUnlock.");
            const localVarPath = `/unlock/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIds (options = {}) {
            const localVarPath = `/unlock/post/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIdsInternal (userId, limit, offset, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUnlockedPostIdsInternal.");
            const localVarPath = `/unlock/internal/unlock/post/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIds (options = {}) {
            const localVarPath = `/unlock/track/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIdsInternal (userId, limit, offset, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUnlockedTrackIdsInternal.");
            const localVarPath = `/unlock/internal/unlock/track/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$a23f3f0dda2f9a61 = function(configuration) {
    return {
        /**
     * Creates new post unlock.
     * @summary Creates post unlock.
     * @param {CreatePostUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostUnlock (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1(configuration).createPostUnlock(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates new track unlock.
     * @summary Creates track unlock.
     * @param {CreateTrackUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackUnlock (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1(configuration).createTrackUnlock(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlock record by unlock id.
     * @summary Retrieves unlock.
     * @param {string} id unlock id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlock (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1(configuration).getUnlock(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1(configuration).getUnlockedPostIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIdsInternal (userId, limit, offset, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1(configuration).getUnlockedPostIdsInternal(userId, limit, offset, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIds (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1(configuration).getUnlockedTrackIds(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIdsInternal (userId, limit, offset, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$b3dc68dd5d1c8fb1(configuration).getUnlockedTrackIdsInternal(userId, limit, offset, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$7e5a0bf60b34fc4f = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates new post unlock.
     * @summary Creates post unlock.
     * @param {CreatePostUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostUnlock (fields, options) {
            return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(configuration).createPostUnlock(fields, options)(fetch, basePath);
        },
        /**
     * Creates new track unlock.
     * @summary Creates track unlock.
     * @param {CreateTrackUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackUnlock (fields, options) {
            return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(configuration).createTrackUnlock(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves unlock record by unlock id.
     * @summary Retrieves unlock.
     * @param {string} id unlock id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlock (id, options) {
            return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(configuration).getUnlock(id, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIds (options) {
            return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(configuration).getUnlockedPostIds(options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIdsInternal (userId, limit, offset, options) {
            return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(configuration).getUnlockedPostIdsInternal(userId, limit, offset, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIds (options) {
            return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(configuration).getUnlockedTrackIds(options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIdsInternal (userId, limit, offset, options) {
            return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(configuration).getUnlockedTrackIdsInternal(userId, limit, offset, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$2b72467a8fb6e56d extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Creates new post unlock.
   * @summary Creates post unlock.
   * @param {CreatePostUnlockRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ createPostUnlock(fields, options) {
        return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(this.configuration).createPostUnlock(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new track unlock.
   * @summary Creates track unlock.
   * @param {CreateTrackUnlockRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ createTrackUnlock(fields, options) {
        return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(this.configuration).createTrackUnlock(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlock record by unlock id.
   * @summary Retrieves unlock.
   * @param {string} id unlock id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlock(id, options) {
        return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(this.configuration).getUnlock(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked post ids.
   * @summary Retrieves unlocked post ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedPostIds(options) {
        return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(this.configuration).getUnlockedPostIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked post ids.
   * @summary Retrieves unlocked post ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedPostIdsInternal(userId, limit, offset, options) {
        return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(this.configuration).getUnlockedPostIdsInternal(userId, limit, offset, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked track ids.
   * @summary Retrieves unlocked track ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedTrackIds(options) {
        return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(this.configuration).getUnlockedTrackIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked track ids.
   * @summary Retrieves unlocked track ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedTrackIdsInternal(userId, limit, offset, options) {
        return $2e40eaa235c0814d$export$a23f3f0dda2f9a61(this.configuration).getUnlockedTrackIdsInternal(userId, limit, offset, options)(this.fetch, this.basePath);
    }
}
const $2e40eaa235c0814d$export$ad52db59a1eaf662 = function(configuration) {
    return {
        /**
     * Blocks user record.
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockUser (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockUser.");
            const localVarPath = `/user/admin/user/block`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new user.
     * @summary Creates user.
     * @param {CreateUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createUser.");
            const localVarPath = `/user/internal/user`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new user delete confirmation.
     * @summary Creates user delete confirmation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserDeleteConfirmation (options = {}) {
            const localVarPath = `/user/delete-confirmation`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes user profile.
     * @summary Deletes user profile.
     * @param {string} userDeleteConfirmationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserProfile (userDeleteConfirmationCode, options = {}) {
            // verify required parameter 'userDeleteConfirmationCode' is not null or undefined
            if (userDeleteConfirmationCode === null || userDeleteConfirmationCode === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userDeleteConfirmationCode", "Required parameter userDeleteConfirmationCode was null or undefined when calling deleteUserProfile.");
            const localVarPath = `/user/profile`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userDeleteConfirmationCode !== undefined) localVarQueryParameter["userDeleteConfirmationCode"] = userDeleteConfirmationCode;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves followed artists.
     * @summary Retrieves followed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/followed`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves popular artists.
     * @summary Retrieves popular artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/popular`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public artists.
     * @summary Retrieves public artists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicArtists (options = {}) {
            const localVarPath = `/user/public/user/artists`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public user record by user id.
     * @summary Retrieves public user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicUser (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getPublicUser.");
            const localVarPath = `/user/public/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves recommended artists.
     * @summary Retrieves recommended artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/recommended`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves subscribed artists.
     * @summary Retrieves subscribed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/subscribed`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getUser.");
            const localVarPath = `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user record by auth provider id.
     * @summary Retrieves user by auth id.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByAuthId (authId, options = {}) {
            // verify required parameter 'authId' is not null or undefined
            if (authId === null || authId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("authId", "Required parameter authId was null or undefined when calling getUserByAuthId.");
            const localVarPath = `/user/internal/user/auth-id`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (authId !== undefined) localVarQueryParameter["authId"] = authId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByUserId (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUserByUserId.");
            const localVarPath = `/user/internal/user/user-id`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Gets user profile.
     * @summary Gets user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfile (options = {}) {
            const localVarPath = `/user/profile`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves username availability status.
     * @summary Retrieves username availability.
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfileUsernameAvailable (username, options = {}) {
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("username", "Required parameter username was null or undefined when calling getUserProfileUsernameAvailable.");
            const localVarPath = `/user/profile/username/available`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (username !== undefined) localVarQueryParameter["username"] = username;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves users by ids.
     * @summary Retrieves users by ids.
     * @param {string} [userIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByIds (userIds, options = {}) {
            const localVarPath = `/user/ids`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userIds !== undefined) localVarQueryParameter["userIds"] = userIds;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile.
     * @summary Updates user profile.
     * @param {UpdateUserProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfile (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfile.");
            const localVarPath = `/user/profile`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile avatar.
     * @summary Updates user profile avatar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileAvatar (options = {}) {
            const localVarPath = `/user/profile/avatar`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile onboarding stage.
     * @summary Updates user profile onboarding stage.
     * @param {UpdateUserProfileOnboardingStageRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileOnboardingStage (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfileOnboardingStage.");
            const localVarPath = `/user/profile/onboarding`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile role.
     * @summary Updates user profile role.
     * @param {UpdateUserProfileRoleRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileRole (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfileRole.");
            const localVarPath = `/user/profile/role`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile username.
     * @summary Updates user profile username.
     * @param {UpdateUserProfileUsernameRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileUsername (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $2e40eaa235c0814d$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfileUsername.");
            const localVarPath = `/user/profile/username/update`;
            const localVarUrlObj = $dlIfJ.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $dlIfJ.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $2e40eaa235c0814d$export$7b43f41e93e60955 = function(configuration) {
    return {
        /**
     * Blocks user record.
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockUser (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).blockUser(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates new user.
     * @summary Creates user.
     * @param {CreateUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).createUser(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates new user delete confirmation.
     * @summary Creates user delete confirmation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserDeleteConfirmation (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).createUserDeleteConfirmation(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes user profile.
     * @summary Deletes user profile.
     * @param {string} userDeleteConfirmationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserProfile (userDeleteConfirmationCode, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).deleteUserProfile(userDeleteConfirmationCode, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves followed artists.
     * @summary Retrieves followed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getFollowedArtists(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves popular artists.
     * @summary Retrieves popular artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getPopularArtists(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public artists.
     * @summary Retrieves public artists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicArtists (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getPublicArtists(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public user record by user id.
     * @summary Retrieves public user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicUser (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getPublicUser(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves recommended artists.
     * @summary Retrieves recommended artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getRecommendedArtists(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves subscribed artists.
     * @summary Retrieves subscribed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getSubscribedArtists(limit, offset, searchTerm, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser (id, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getUser(id, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user record by auth provider id.
     * @summary Retrieves user by auth id.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByAuthId (authId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getUserByAuthId(authId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByUserId (userId, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getUserByUserId(userId, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Gets user profile.
     * @summary Gets user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfile (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getUserProfile(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves username availability status.
     * @summary Retrieves username availability.
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfileUsernameAvailable (username, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getUserProfileUsernameAvailable(username, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves users by ids.
     * @summary Retrieves users by ids.
     * @param {string} [userIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByIds (userIds, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).getUsersByIds(userIds, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile.
     * @summary Updates user profile.
     * @param {UpdateUserProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfile (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).updateUserProfile(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile avatar.
     * @summary Updates user profile avatar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileAvatar (options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).updateUserProfileAvatar(options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile onboarding stage.
     * @summary Updates user profile onboarding stage.
     * @param {UpdateUserProfileOnboardingStageRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileOnboardingStage (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).updateUserProfileOnboardingStage(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile role.
     * @summary Updates user profile role.
     * @param {UpdateUserProfileRoleRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileRole (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).updateUserProfileRole(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile username.
     * @summary Updates user profile username.
     * @param {UpdateUserProfileUsernameRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileUsername (fields, options) {
            const localVarFetchArgs = $2e40eaa235c0814d$export$ad52db59a1eaf662(configuration).updateUserProfileUsername(fields, options);
            return (fetch = $7U1ts, basePath = $2e40eaa235c0814d$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $2e40eaa235c0814d$export$3d28cb048adea4bd = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks user record.
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockUser (fields, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).blockUser(fields, options)(fetch, basePath);
        },
        /**
     * Creates new user.
     * @summary Creates user.
     * @param {CreateUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser (fields, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).createUser(fields, options)(fetch, basePath);
        },
        /**
     * Creates new user delete confirmation.
     * @summary Creates user delete confirmation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserDeleteConfirmation (options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).createUserDeleteConfirmation(options)(fetch, basePath);
        },
        /**
     * Deletes user profile.
     * @summary Deletes user profile.
     * @param {string} userDeleteConfirmationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserProfile (userDeleteConfirmationCode, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).deleteUserProfile(userDeleteConfirmationCode, options)(fetch, basePath);
        },
        /**
     * Retrieves followed artists.
     * @summary Retrieves followed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedArtists (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getFollowedArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves popular artists.
     * @summary Retrieves popular artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularArtists (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getPopularArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves public artists.
     * @summary Retrieves public artists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicArtists (options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getPublicArtists(options)(fetch, basePath);
        },
        /**
     * Retrieves public user record by user id.
     * @summary Retrieves public user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicUser (id, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getPublicUser(id, options)(fetch, basePath);
        },
        /**
     * Retrieves recommended artists.
     * @summary Retrieves recommended artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedArtists (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getRecommendedArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves subscribed artists.
     * @summary Retrieves subscribed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedArtists (limit, offset, searchTerm, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getSubscribedArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser (id, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getUser(id, options)(fetch, basePath);
        },
        /**
     * Retrieves user record by auth provider id.
     * @summary Retrieves user by auth id.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByAuthId (authId, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getUserByAuthId(authId, options)(fetch, basePath);
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByUserId (userId, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getUserByUserId(userId, options)(fetch, basePath);
        },
        /**
     * Gets user profile.
     * @summary Gets user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfile (options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getUserProfile(options)(fetch, basePath);
        },
        /**
     * Retrieves username availability status.
     * @summary Retrieves username availability.
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfileUsernameAvailable (username, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getUserProfileUsernameAvailable(username, options)(fetch, basePath);
        },
        /**
     * Retrieves users by ids.
     * @summary Retrieves users by ids.
     * @param {string} [userIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByIds (userIds, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).getUsersByIds(userIds, options)(fetch, basePath);
        },
        /**
     * Updates user profile.
     * @summary Updates user profile.
     * @param {UpdateUserProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfile (fields, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).updateUserProfile(fields, options)(fetch, basePath);
        },
        /**
     * Updates user profile avatar.
     * @summary Updates user profile avatar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileAvatar (options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).updateUserProfileAvatar(options)(fetch, basePath);
        },
        /**
     * Updates user profile onboarding stage.
     * @summary Updates user profile onboarding stage.
     * @param {UpdateUserProfileOnboardingStageRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileOnboardingStage (fields, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).updateUserProfileOnboardingStage(fields, options)(fetch, basePath);
        },
        /**
     * Updates user profile role.
     * @summary Updates user profile role.
     * @param {UpdateUserProfileRoleRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileRole (fields, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).updateUserProfileRole(fields, options)(fetch, basePath);
        },
        /**
     * Updates user profile username.
     * @summary Updates user profile username.
     * @param {UpdateUserProfileUsernameRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileUsername (fields, options) {
            return $2e40eaa235c0814d$export$7b43f41e93e60955(configuration).updateUserProfileUsername(fields, options)(fetch, basePath);
        }
    };
};
class $2e40eaa235c0814d$export$2a63ac7615f78125 extends $2e40eaa235c0814d$export$70edad7ad5bb3f5d {
    /**
   * Blocks user record.
   * @summary Blocks user.
   * @param {BlockUserRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ blockUser(fields, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).blockUser(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new user.
   * @summary Creates user.
   * @param {CreateUserRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ createUser(fields, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).createUser(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new user delete confirmation.
   * @summary Creates user delete confirmation.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ createUserDeleteConfirmation(options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).createUserDeleteConfirmation(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes user profile.
   * @summary Deletes user profile.
   * @param {string} userDeleteConfirmationCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ deleteUserProfile(userDeleteConfirmationCode, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).deleteUserProfile(userDeleteConfirmationCode, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves followed artists.
   * @summary Retrieves followed artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getFollowedArtists(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getFollowedArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves popular artists.
   * @summary Retrieves popular artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getPopularArtists(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getPopularArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public artists.
   * @summary Retrieves public artists.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getPublicArtists(options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getPublicArtists(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public user record by user id.
   * @summary Retrieves public user.
   * @param {string} id user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getPublicUser(id, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getPublicUser(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves recommended artists.
   * @summary Retrieves recommended artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getRecommendedArtists(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getRecommendedArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves subscribed artists.
   * @summary Retrieves subscribed artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getSubscribedArtists(limit, offset, searchTerm, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getSubscribedArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user record by user id.
   * @summary Retrieves user.
   * @param {string} id user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUser(id, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getUser(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user record by auth provider id.
   * @summary Retrieves user by auth id.
   * @param {string} authId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserByAuthId(authId, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getUserByAuthId(authId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user record by user id.
   * @summary Retrieves user by user id.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserByUserId(userId, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getUserByUserId(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Gets user profile.
   * @summary Gets user profile.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserProfile(options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getUserProfile(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves username availability status.
   * @summary Retrieves username availability.
   * @param {string} username
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserProfileUsernameAvailable(username, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getUserProfileUsernameAvailable(username, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves users by ids.
   * @summary Retrieves users by ids.
   * @param {string} [userIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUsersByIds(userIds, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).getUsersByIds(userIds, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile.
   * @summary Updates user profile.
   * @param {UpdateUserProfileRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfile(fields, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).updateUserProfile(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile avatar.
   * @summary Updates user profile avatar.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileAvatar(options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).updateUserProfileAvatar(options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile onboarding stage.
   * @summary Updates user profile onboarding stage.
   * @param {UpdateUserProfileOnboardingStageRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileOnboardingStage(fields, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).updateUserProfileOnboardingStage(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile role.
   * @summary Updates user profile role.
   * @param {UpdateUserProfileRoleRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileRole(fields, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).updateUserProfileRole(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile username.
   * @summary Updates user profile username.
   * @param {UpdateUserProfileUsernameRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileUsername(fields, options) {
        return $2e40eaa235c0814d$export$7b43f41e93e60955(this.configuration).updateUserProfileUsername(fields, options)(this.fetch, this.basePath);
    }
}

});
parcelRegister("dlIfJ", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $aoRNc = parcelRequire("aoRNc");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $12kex = parcelRequire("12kex");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $12kex.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $aoRNc.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $12kex.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $12kex.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("aoRNc", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("12kex", function(module, exports) {
"use strict";

var $lwUxr = parcelRequire("lwUxr");

var $kwRoq = parcelRequire("kwRoq");

var $eoauW = parcelRequire("eoauW");
module.exports = {
    formats: $eoauW,
    parse: $kwRoq,
    stringify: $lwUxr
};

});
parcelRegister("lwUxr", function(module, exports) {
"use strict";

var $felPn = parcelRequire("felPn");

var $kuoj3 = parcelRequire("kuoj3");

var $eoauW = parcelRequire("eoauW");
var $fac8717c5c5a1112$var$has = Object.prototype.hasOwnProperty;
var $fac8717c5c5a1112$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $fac8717c5c5a1112$var$isArray = Array.isArray;
var $fac8717c5c5a1112$var$push = Array.prototype.push;
var $fac8717c5c5a1112$var$pushToArray = function(arr, valueOrArray) {
    $fac8717c5c5a1112$var$push.apply(arr, $fac8717c5c5a1112$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $fac8717c5c5a1112$var$toISO = Date.prototype.toISOString;
var $fac8717c5c5a1112$var$defaultFormat = $eoauW.default;
var $fac8717c5c5a1112$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $kuoj3.encode,
    encodeValuesOnly: false,
    format: $fac8717c5c5a1112$var$defaultFormat,
    formatter: $eoauW.formatters[$fac8717c5c5a1112$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $fac8717c5c5a1112$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $fac8717c5c5a1112$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $fac8717c5c5a1112$var$sentinel = {};
var $fac8717c5c5a1112$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($fac8717c5c5a1112$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($fac8717c5c5a1112$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $fac8717c5c5a1112$var$isArray(obj)) obj = $kuoj3.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $fac8717c5c5a1112$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($fac8717c5c5a1112$var$isNonNullishPrimitive(obj) || $kuoj3.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $fac8717c5c5a1112$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $fac8717c5c5a1112$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $fac8717c5c5a1112$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $kuoj3.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($fac8717c5c5a1112$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $fac8717c5c5a1112$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $fac8717c5c5a1112$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $fac8717c5c5a1112$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $felPn();
        valueSideChannel.set($fac8717c5c5a1112$var$sentinel, sideChannel);
        $fac8717c5c5a1112$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $fac8717c5c5a1112$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $fac8717c5c5a1112$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $fac8717c5c5a1112$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $fac8717c5c5a1112$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $eoauW.default;
    if (typeof opts.format !== "undefined") {
        if (!$fac8717c5c5a1112$var$has.call($eoauW.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $eoauW.formatters[format];
    var filter = $fac8717c5c5a1112$var$defaults.filter;
    if (typeof opts.filter === "function" || $fac8717c5c5a1112$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $fac8717c5c5a1112$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $fac8717c5c5a1112$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $fac8717c5c5a1112$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $fac8717c5c5a1112$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $fac8717c5c5a1112$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $fac8717c5c5a1112$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $fac8717c5c5a1112$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $fac8717c5c5a1112$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $fac8717c5c5a1112$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $fac8717c5c5a1112$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $fac8717c5c5a1112$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $fac8717c5c5a1112$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $fac8717c5c5a1112$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $fac8717c5c5a1112$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $fac8717c5c5a1112$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($fac8717c5c5a1112$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $fac8717c5c5a1112$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $felPn();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $fac8717c5c5a1112$var$pushToArray(keys, $fac8717c5c5a1112$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("felPn", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");

var $l28vI = parcelRequire("l28vI");

var $jrvhS = parcelRequire("jrvhS");

var $OG0Ue = parcelRequire("OG0Ue");
var $b169185aab3e5a24$var$$WeakMap = $5XoKB("%WeakMap%", true);
var $b169185aab3e5a24$var$$Map = $5XoKB("%Map%", true);
var $b169185aab3e5a24$var$$weakMapGet = $l28vI("WeakMap.prototype.get", true);
var $b169185aab3e5a24$var$$weakMapSet = $l28vI("WeakMap.prototype.set", true);
var $b169185aab3e5a24$var$$weakMapHas = $l28vI("WeakMap.prototype.has", true);
var $b169185aab3e5a24$var$$mapGet = $l28vI("Map.prototype.get", true);
var $b169185aab3e5a24$var$$mapSet = $l28vI("Map.prototype.set", true);
var $b169185aab3e5a24$var$$mapHas = $l28vI("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $b169185aab3e5a24$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $b169185aab3e5a24$var$listGet = function(objects, key) {
    var node = $b169185aab3e5a24$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $b169185aab3e5a24$var$listSet = function(objects, key, value) {
    var node = $b169185aab3e5a24$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $b169185aab3e5a24$var$listHas = function(objects, key) {
    return !!$b169185aab3e5a24$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $OG0Ue("Side channel does not contain " + $jrvhS(key));
        },
        get: function(key) {
            if ($b169185aab3e5a24$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $b169185aab3e5a24$var$$weakMapGet($wm, key);
            } else if ($b169185aab3e5a24$var$$Map) {
                if ($m) return $b169185aab3e5a24$var$$mapGet($m, key);
            } else {
                if ($o) return $b169185aab3e5a24$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($b169185aab3e5a24$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $b169185aab3e5a24$var$$weakMapHas($wm, key);
            } else if ($b169185aab3e5a24$var$$Map) {
                if ($m) return $b169185aab3e5a24$var$$mapHas($m, key);
            } else {
                if ($o) return $b169185aab3e5a24$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($b169185aab3e5a24$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $b169185aab3e5a24$var$$WeakMap();
                $b169185aab3e5a24$var$$weakMapSet($wm, key, value);
            } else if ($b169185aab3e5a24$var$$Map) {
                if (!$m) $m = new $b169185aab3e5a24$var$$Map();
                $b169185aab3e5a24$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $b169185aab3e5a24$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("5XoKB", function(module, exports) {
"use strict";
var $4565a9698af8efed$var$undefined1;

var $f6Akk = parcelRequire("f6Akk");

var $fpQns = parcelRequire("fpQns");

var $ag3DL = parcelRequire("ag3DL");

var $eFn1R = parcelRequire("eFn1R");

var $6TBlj = parcelRequire("6TBlj");

var $OG0Ue = parcelRequire("OG0Ue");

var $fK7Rv = parcelRequire("fK7Rv");
var $4565a9698af8efed$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $4565a9698af8efed$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $4565a9698af8efed$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $4565a9698af8efed$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($4565a9698af8efed$var$$gOPD) try {
    $4565a9698af8efed$var$$gOPD({}, "");
} catch (e) {
    $4565a9698af8efed$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $4565a9698af8efed$var$throwTypeError = function() {
    throw new $OG0Ue();
};
var $4565a9698af8efed$var$ThrowTypeError = $4565a9698af8efed$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $4565a9698af8efed$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $4565a9698af8efed$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $4565a9698af8efed$var$throwTypeError;
        }
    }
}() : $4565a9698af8efed$var$throwTypeError;

var $4565a9698af8efed$var$hasSymbols = (parcelRequire("1zrnp"))();

var $4565a9698af8efed$var$hasProto = (parcelRequire("8mH7E"))();
var $4565a9698af8efed$var$getProto = Object.getPrototypeOf || ($4565a9698af8efed$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $4565a9698af8efed$var$needsEval = {};
var $4565a9698af8efed$var$TypedArray = typeof Uint8Array === "undefined" || !$4565a9698af8efed$var$getProto ? undefined : $4565a9698af8efed$var$getProto(Uint8Array);
var $4565a9698af8efed$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $4565a9698af8efed$var$needsEval,
    "%AsyncGenerator%": $4565a9698af8efed$var$needsEval,
    "%AsyncGeneratorFunction%": $4565a9698af8efed$var$needsEval,
    "%AsyncIteratorPrototype%": $4565a9698af8efed$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $f6Akk,
    "%eval%": eval,
    "%EvalError%": $fpQns,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $4565a9698af8efed$var$$Function,
    "%GeneratorFunction%": $4565a9698af8efed$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto($4565a9698af8efed$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$4565a9698af8efed$var$hasSymbols || !$4565a9698af8efed$var$getProto ? undefined : $4565a9698af8efed$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $ag3DL,
    "%ReferenceError%": $eFn1R,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$4565a9698af8efed$var$hasSymbols || !$4565a9698af8efed$var$getProto ? undefined : $4565a9698af8efed$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $4565a9698af8efed$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $6TBlj,
    "%ThrowTypeError%": $4565a9698af8efed$var$ThrowTypeError,
    "%TypedArray%": $4565a9698af8efed$var$TypedArray,
    "%TypeError%": $OG0Ue,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $fK7Rv,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($4565a9698af8efed$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $4565a9698af8efed$var$errorProto = $4565a9698af8efed$var$getProto($4565a9698af8efed$var$getProto(e));
    $4565a9698af8efed$var$INTRINSICS["%Error.prototype%"] = $4565a9698af8efed$var$errorProto;
}
var $4565a9698af8efed$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $4565a9698af8efed$var$getProto) value = $4565a9698af8efed$var$getProto(gen.prototype);
    }
    $4565a9698af8efed$var$INTRINSICS[name] = value;
    return value;
};
var $4565a9698af8efed$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $dY0J9 = parcelRequire("dY0J9");

var $l8o8U = parcelRequire("l8o8U");
var $4565a9698af8efed$var$$concat = $dY0J9.call(Function.call, Array.prototype.concat);
var $4565a9698af8efed$var$$spliceApply = $dY0J9.call(Function.apply, Array.prototype.splice);
var $4565a9698af8efed$var$$replace = $dY0J9.call(Function.call, String.prototype.replace);
var $4565a9698af8efed$var$$strSlice = $dY0J9.call(Function.call, String.prototype.slice);
var $4565a9698af8efed$var$$exec = $dY0J9.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $4565a9698af8efed$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $4565a9698af8efed$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $4565a9698af8efed$var$stringToPath = function stringToPath(string) {
    var first = $4565a9698af8efed$var$$strSlice(string, 0, 1);
    var last = $4565a9698af8efed$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $6TBlj("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $6TBlj("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $4565a9698af8efed$var$$replace(string, $4565a9698af8efed$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $4565a9698af8efed$var$$replace(subString, $4565a9698af8efed$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $4565a9698af8efed$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($l8o8U($4565a9698af8efed$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $4565a9698af8efed$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicName)) {
        var value = $4565a9698af8efed$var$INTRINSICS[intrinsicName];
        if (value === $4565a9698af8efed$var$needsEval) value = $4565a9698af8efed$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $OG0Ue("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $6TBlj("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $OG0Ue("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $OG0Ue('"allowMissing" argument must be a boolean');
    if ($4565a9698af8efed$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $6TBlj("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $4565a9698af8efed$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $4565a9698af8efed$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $4565a9698af8efed$var$$spliceApply(parts, $4565a9698af8efed$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $4565a9698af8efed$var$$strSlice(part, 0, 1);
        var last = $4565a9698af8efed$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $6TBlj("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicRealName)) value = $4565a9698af8efed$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $OG0Ue("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($4565a9698af8efed$var$$gOPD && i + 1 >= parts.length) {
                var desc = $4565a9698af8efed$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $l8o8U(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $4565a9698af8efed$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("f6Akk", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("fpQns", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("ag3DL", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("eFn1R", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("6TBlj", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("OG0Ue", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("fK7Rv", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("1zrnp", function(module, exports) {
"use strict";
var $124e4bbb3f3c510d$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $e6ibc = parcelRequire("e6ibc");
module.exports = function hasNativeSymbols() {
    if (typeof $124e4bbb3f3c510d$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $124e4bbb3f3c510d$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $e6ibc();
};

});
parcelRegister("e6ibc", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("8mH7E", function(module, exports) {
"use strict";
var $6171d3ff235c4b4e$var$test = {
    __proto__: null,
    foo: {}
};
var $6171d3ff235c4b4e$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $6171d3ff235c4b4e$var$test
    }).foo === $6171d3ff235c4b4e$var$test.foo && !($6171d3ff235c4b4e$var$test instanceof $6171d3ff235c4b4e$var$$Object);
};

});

parcelRegister("dY0J9", function(module, exports) {
"use strict";

var $a9gvA = parcelRequire("a9gvA");
module.exports = Function.prototype.bind || $a9gvA;

});
parcelRegister("a9gvA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $76378ce80e32fd91$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $76378ce80e32fd91$var$toStr = Object.prototype.toString;
var $76378ce80e32fd91$var$max = Math.max;
var $76378ce80e32fd91$var$funcType = "[object Function]";
var $76378ce80e32fd91$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $76378ce80e32fd91$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $76378ce80e32fd91$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $76378ce80e32fd91$var$toStr.apply(target) !== $76378ce80e32fd91$var$funcType) throw new TypeError($76378ce80e32fd91$var$ERROR_MESSAGE + target);
    var args = $76378ce80e32fd91$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $76378ce80e32fd91$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $76378ce80e32fd91$var$concatty(args, arguments));
    };
    var boundLength = $76378ce80e32fd91$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $76378ce80e32fd91$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("l8o8U", function(module, exports) {
"use strict";
var $f62d1296f319593b$var$call = Function.prototype.call;
var $f62d1296f319593b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $dY0J9 = parcelRequire("dY0J9");
/** @type {import('.')} */ module.exports = $dY0J9.call($f62d1296f319593b$var$call, $f62d1296f319593b$var$$hasOwn);

});


parcelRegister("l28vI", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");

var $jS9v3 = parcelRequire("jS9v3");
var $f50062e307a9927c$var$$indexOf = $jS9v3($5XoKB("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $5XoKB(name, !!allowMissing);
    if (typeof intrinsic === "function" && $f50062e307a9927c$var$$indexOf(name, ".prototype.") > -1) return $jS9v3(intrinsic);
    return intrinsic;
};

});
parcelRegister("jS9v3", function(module, exports) {
"use strict";

var $dY0J9 = parcelRequire("dY0J9");

var $5XoKB = parcelRequire("5XoKB");

var $8hAll = parcelRequire("8hAll");

var $OG0Ue = parcelRequire("OG0Ue");
var $e77a6dec9495dcaa$var$$apply = $5XoKB("%Function.prototype.apply%");
var $e77a6dec9495dcaa$var$$call = $5XoKB("%Function.prototype.call%");
var $e77a6dec9495dcaa$var$$reflectApply = $5XoKB("%Reflect.apply%", true) || $dY0J9.call($e77a6dec9495dcaa$var$$call, $e77a6dec9495dcaa$var$$apply);

var $7dXGV = parcelRequire("7dXGV");
var $e77a6dec9495dcaa$var$$max = $5XoKB("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $OG0Ue("a function is required");
    var func = $e77a6dec9495dcaa$var$$reflectApply($dY0J9, $e77a6dec9495dcaa$var$$call, arguments);
    return $8hAll(func, 1 + $e77a6dec9495dcaa$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $e77a6dec9495dcaa$var$applyBind = function applyBind() {
    return $e77a6dec9495dcaa$var$$reflectApply($dY0J9, $e77a6dec9495dcaa$var$$apply, arguments);
};
if ($7dXGV) $7dXGV(module.exports, "apply", {
    value: $e77a6dec9495dcaa$var$applyBind
});
else module.exports.apply = $e77a6dec9495dcaa$var$applyBind;

});
parcelRegister("8hAll", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");

var $1FJER = parcelRequire("1FJER");

var $607c1a4d22289651$var$hasDescriptors = (parcelRequire("8CDym"))();

var $eJu2D = parcelRequire("eJu2D");

var $OG0Ue = parcelRequire("OG0Ue");
var $607c1a4d22289651$var$$floor = $5XoKB("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $OG0Ue("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $607c1a4d22289651$var$$floor(length) !== length) throw new $OG0Ue("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $eJu2D) {
        var desc = $eJu2D(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($607c1a4d22289651$var$hasDescriptors) $1FJER(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $1FJER(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("1FJER", function(module, exports) {
"use strict";

var $7dXGV = parcelRequire("7dXGV");

var $6TBlj = parcelRequire("6TBlj");

var $OG0Ue = parcelRequire("OG0Ue");

var $eJu2D = parcelRequire("eJu2D");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $OG0Ue("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $OG0Ue("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $OG0Ue("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $OG0Ue("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $OG0Ue("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $OG0Ue("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$eJu2D && $eJu2D(obj, property);
    if ($7dXGV) $7dXGV(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6TBlj("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("7dXGV", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");
/** @type {import('.')} */ var $54280cbbb5bff3df$var$$defineProperty = $5XoKB("%Object.defineProperty%", true) || false;
if ($54280cbbb5bff3df$var$$defineProperty) try {
    $54280cbbb5bff3df$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $54280cbbb5bff3df$var$$defineProperty = false;
}
module.exports = $54280cbbb5bff3df$var$$defineProperty;

});

parcelRegister("eJu2D", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");
var $ab9c92447e4858f1$var$$gOPD = $5XoKB("%Object.getOwnPropertyDescriptor%", true);
if ($ab9c92447e4858f1$var$$gOPD) try {
    $ab9c92447e4858f1$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $ab9c92447e4858f1$var$$gOPD = null;
}
module.exports = $ab9c92447e4858f1$var$$gOPD;

});


parcelRegister("8CDym", function(module, exports) {
"use strict";

var $7dXGV = parcelRequire("7dXGV");
var $64708dc9f5193715$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7dXGV;
};
$64708dc9f5193715$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7dXGV) return null;
    try {
        return $7dXGV([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $64708dc9f5193715$var$hasPropertyDescriptors;

});




parcelRegister("jrvhS", function(module, exports) {
var $e278ceee2711ea6e$var$hasMap = typeof Map === "function" && Map.prototype;
var $e278ceee2711ea6e$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $e278ceee2711ea6e$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $e278ceee2711ea6e$var$mapSize = $e278ceee2711ea6e$var$hasMap && $e278ceee2711ea6e$var$mapSizeDescriptor && typeof $e278ceee2711ea6e$var$mapSizeDescriptor.get === "function" ? $e278ceee2711ea6e$var$mapSizeDescriptor.get : null;
var $e278ceee2711ea6e$var$mapForEach = $e278ceee2711ea6e$var$hasMap && Map.prototype.forEach;
var $e278ceee2711ea6e$var$hasSet = typeof Set === "function" && Set.prototype;
var $e278ceee2711ea6e$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $e278ceee2711ea6e$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $e278ceee2711ea6e$var$setSize = $e278ceee2711ea6e$var$hasSet && $e278ceee2711ea6e$var$setSizeDescriptor && typeof $e278ceee2711ea6e$var$setSizeDescriptor.get === "function" ? $e278ceee2711ea6e$var$setSizeDescriptor.get : null;
var $e278ceee2711ea6e$var$setForEach = $e278ceee2711ea6e$var$hasSet && Set.prototype.forEach;
var $e278ceee2711ea6e$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $e278ceee2711ea6e$var$weakMapHas = $e278ceee2711ea6e$var$hasWeakMap ? WeakMap.prototype.has : null;
var $e278ceee2711ea6e$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $e278ceee2711ea6e$var$weakSetHas = $e278ceee2711ea6e$var$hasWeakSet ? WeakSet.prototype.has : null;
var $e278ceee2711ea6e$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $e278ceee2711ea6e$var$weakRefDeref = $e278ceee2711ea6e$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $e278ceee2711ea6e$var$booleanValueOf = Boolean.prototype.valueOf;
var $e278ceee2711ea6e$var$objectToString = Object.prototype.toString;
var $e278ceee2711ea6e$var$functionToString = Function.prototype.toString;
var $e278ceee2711ea6e$var$$match = String.prototype.match;
var $e278ceee2711ea6e$var$$slice = String.prototype.slice;
var $e278ceee2711ea6e$var$$replace = String.prototype.replace;
var $e278ceee2711ea6e$var$$toUpperCase = String.prototype.toUpperCase;
var $e278ceee2711ea6e$var$$toLowerCase = String.prototype.toLowerCase;
var $e278ceee2711ea6e$var$$test = RegExp.prototype.test;
var $e278ceee2711ea6e$var$$concat = Array.prototype.concat;
var $e278ceee2711ea6e$var$$join = Array.prototype.join;
var $e278ceee2711ea6e$var$$arrSlice = Array.prototype.slice;
var $e278ceee2711ea6e$var$$floor = Math.floor;
var $e278ceee2711ea6e$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $e278ceee2711ea6e$var$gOPS = Object.getOwnPropertySymbols;
var $e278ceee2711ea6e$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $e278ceee2711ea6e$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $e278ceee2711ea6e$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $e278ceee2711ea6e$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $e278ceee2711ea6e$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $e278ceee2711ea6e$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $e278ceee2711ea6e$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $e278ceee2711ea6e$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$e278ceee2711ea6e$var$$floor(-num) : $e278ceee2711ea6e$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $e278ceee2711ea6e$var$$slice.call(str, intStr.length + 1);
            return $e278ceee2711ea6e$var$$replace.call(intStr, sepRegex, "$&_") + "." + $e278ceee2711ea6e$var$$replace.call($e278ceee2711ea6e$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $e278ceee2711ea6e$var$$replace.call(str, sepRegex, "$&_");
}

var $1wVs5 = parcelRequire("1wVs5");
var $e278ceee2711ea6e$var$inspectCustom = $1wVs5.custom;
var $e278ceee2711ea6e$var$inspectSymbol = $e278ceee2711ea6e$var$isSymbol($e278ceee2711ea6e$var$inspectCustom) ? $e278ceee2711ea6e$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($e278ceee2711ea6e$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($e278ceee2711ea6e$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $e278ceee2711ea6e$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($e278ceee2711ea6e$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($e278ceee2711ea6e$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $e278ceee2711ea6e$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $e278ceee2711ea6e$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $e278ceee2711ea6e$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $e278ceee2711ea6e$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $e278ceee2711ea6e$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($e278ceee2711ea6e$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $e278ceee2711ea6e$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($e278ceee2711ea6e$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$e278ceee2711ea6e$var$isRegExp(obj)) {
        var name = $e278ceee2711ea6e$var$nameOf(obj);
        var keys = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $e278ceee2711ea6e$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($e278ceee2711ea6e$var$isSymbol(obj)) {
        var symString = $e278ceee2711ea6e$var$hasShammedSymbols ? $e278ceee2711ea6e$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $e278ceee2711ea6e$var$symToString.call(obj);
        return typeof obj === "object" && !$e278ceee2711ea6e$var$hasShammedSymbols ? $e278ceee2711ea6e$var$markBoxed(symString) : symString;
    }
    if ($e278ceee2711ea6e$var$isElement(obj)) {
        var s = "<" + $e278ceee2711ea6e$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $e278ceee2711ea6e$var$wrapQuotes($e278ceee2711ea6e$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $e278ceee2711ea6e$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($e278ceee2711ea6e$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        if (indent && !$e278ceee2711ea6e$var$singleLineValues(xs)) return "[" + $e278ceee2711ea6e$var$indentedJoin(xs, indent) + "]";
        return "[ " + $e278ceee2711ea6e$var$$join.call(xs, ", ") + " ]";
    }
    if ($e278ceee2711ea6e$var$isError(obj)) {
        var parts = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$e278ceee2711ea6e$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $e278ceee2711ea6e$var$$join.call($e278ceee2711ea6e$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $e278ceee2711ea6e$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($e278ceee2711ea6e$var$inspectSymbol && typeof obj[$e278ceee2711ea6e$var$inspectSymbol] === "function" && $1wVs5) return $1wVs5(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($e278ceee2711ea6e$var$isMap(obj)) {
        var mapParts = [];
        if ($e278ceee2711ea6e$var$mapForEach) $e278ceee2711ea6e$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $e278ceee2711ea6e$var$collectionOf("Map", $e278ceee2711ea6e$var$mapSize.call(obj), mapParts, indent);
    }
    if ($e278ceee2711ea6e$var$isSet(obj)) {
        var setParts = [];
        if ($e278ceee2711ea6e$var$setForEach) $e278ceee2711ea6e$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $e278ceee2711ea6e$var$collectionOf("Set", $e278ceee2711ea6e$var$setSize.call(obj), setParts, indent);
    }
    if ($e278ceee2711ea6e$var$isWeakMap(obj)) return $e278ceee2711ea6e$var$weakCollectionOf("WeakMap");
    if ($e278ceee2711ea6e$var$isWeakSet(obj)) return $e278ceee2711ea6e$var$weakCollectionOf("WeakSet");
    if ($e278ceee2711ea6e$var$isWeakRef(obj)) return $e278ceee2711ea6e$var$weakCollectionOf("WeakRef");
    if ($e278ceee2711ea6e$var$isNumber(obj)) return $e278ceee2711ea6e$var$markBoxed(inspect(Number(obj)));
    if ($e278ceee2711ea6e$var$isBigInt(obj)) return $e278ceee2711ea6e$var$markBoxed(inspect($e278ceee2711ea6e$var$bigIntValueOf.call(obj)));
    if ($e278ceee2711ea6e$var$isBoolean(obj)) return $e278ceee2711ea6e$var$markBoxed($e278ceee2711ea6e$var$booleanValueOf.call(obj));
    if ($e278ceee2711ea6e$var$isString(obj)) return $e278ceee2711ea6e$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$e278ceee2711ea6e$var$isDate(obj) && !$e278ceee2711ea6e$var$isRegExp(obj)) {
        var ys = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        var isPlainObject = $e278ceee2711ea6e$var$gPO ? $e278ceee2711ea6e$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $e278ceee2711ea6e$var$toStringTag && Object(obj) === obj && $e278ceee2711ea6e$var$toStringTag in obj ? $e278ceee2711ea6e$var$$slice.call($e278ceee2711ea6e$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $e278ceee2711ea6e$var$$join.call($e278ceee2711ea6e$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $e278ceee2711ea6e$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $e278ceee2711ea6e$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $e278ceee2711ea6e$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $e278ceee2711ea6e$var$quote(s) {
    return $e278ceee2711ea6e$var$$replace.call(String(s), /"/g, "&quot;");
}
function $e278ceee2711ea6e$var$isArray(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === "[object Array]" && (!$e278ceee2711ea6e$var$toStringTag || !(typeof obj === "object" && $e278ceee2711ea6e$var$toStringTag in obj));
}
function $e278ceee2711ea6e$var$isDate(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === "[object Date]" && (!$e278ceee2711ea6e$var$toStringTag || !(typeof obj === "object" && $e278ceee2711ea6e$var$toStringTag in obj));
}
function $e278ceee2711ea6e$var$isRegExp(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === "[object RegExp]" && (!$e278ceee2711ea6e$var$toStringTag || !(typeof obj === "object" && $e278ceee2711ea6e$var$toStringTag in obj));
}
function $e278ceee2711ea6e$var$isError(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === "[object Error]" && (!$e278ceee2711ea6e$var$toStringTag || !(typeof obj === "object" && $e278ceee2711ea6e$var$toStringTag in obj));
}
function $e278ceee2711ea6e$var$isString(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === "[object String]" && (!$e278ceee2711ea6e$var$toStringTag || !(typeof obj === "object" && $e278ceee2711ea6e$var$toStringTag in obj));
}
function $e278ceee2711ea6e$var$isNumber(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === "[object Number]" && (!$e278ceee2711ea6e$var$toStringTag || !(typeof obj === "object" && $e278ceee2711ea6e$var$toStringTag in obj));
}
function $e278ceee2711ea6e$var$isBoolean(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === "[object Boolean]" && (!$e278ceee2711ea6e$var$toStringTag || !(typeof obj === "object" && $e278ceee2711ea6e$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $e278ceee2711ea6e$var$isSymbol(obj) {
    if ($e278ceee2711ea6e$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$e278ceee2711ea6e$var$symToString) return false;
    try {
        $e278ceee2711ea6e$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$e278ceee2711ea6e$var$bigIntValueOf) return false;
    try {
        $e278ceee2711ea6e$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $e278ceee2711ea6e$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $e278ceee2711ea6e$var$has(obj, key) {
    return $e278ceee2711ea6e$var$hasOwn.call(obj, key);
}
function $e278ceee2711ea6e$var$toStr(obj) {
    return $e278ceee2711ea6e$var$objectToString.call(obj);
}
function $e278ceee2711ea6e$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $e278ceee2711ea6e$var$$match.call($e278ceee2711ea6e$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $e278ceee2711ea6e$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $e278ceee2711ea6e$var$isMap(x) {
    if (!$e278ceee2711ea6e$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $e278ceee2711ea6e$var$mapSize.call(x);
        try {
            $e278ceee2711ea6e$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isWeakMap(x) {
    if (!$e278ceee2711ea6e$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $e278ceee2711ea6e$var$weakMapHas.call(x, $e278ceee2711ea6e$var$weakMapHas);
        try {
            $e278ceee2711ea6e$var$weakSetHas.call(x, $e278ceee2711ea6e$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isWeakRef(x) {
    if (!$e278ceee2711ea6e$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $e278ceee2711ea6e$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isSet(x) {
    if (!$e278ceee2711ea6e$var$setSize || !x || typeof x !== "object") return false;
    try {
        $e278ceee2711ea6e$var$setSize.call(x);
        try {
            $e278ceee2711ea6e$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isWeakSet(x) {
    if (!$e278ceee2711ea6e$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $e278ceee2711ea6e$var$weakSetHas.call(x, $e278ceee2711ea6e$var$weakSetHas);
        try {
            $e278ceee2711ea6e$var$weakMapHas.call(x, $e278ceee2711ea6e$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $e278ceee2711ea6e$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $e278ceee2711ea6e$var$inspectString($e278ceee2711ea6e$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $e278ceee2711ea6e$var$$replace.call($e278ceee2711ea6e$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $e278ceee2711ea6e$var$lowbyte);
    return $e278ceee2711ea6e$var$wrapQuotes(s, "single", opts);
}
function $e278ceee2711ea6e$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $e278ceee2711ea6e$var$$toUpperCase.call(n.toString(16));
}
function $e278ceee2711ea6e$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $e278ceee2711ea6e$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $e278ceee2711ea6e$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $e278ceee2711ea6e$var$indentedJoin(entries, indent) : $e278ceee2711ea6e$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $e278ceee2711ea6e$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($e278ceee2711ea6e$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $e278ceee2711ea6e$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $e278ceee2711ea6e$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $e278ceee2711ea6e$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $e278ceee2711ea6e$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $e278ceee2711ea6e$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $e278ceee2711ea6e$var$arrObjKeys(obj, inspect) {
    var isArr = $e278ceee2711ea6e$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $e278ceee2711ea6e$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $e278ceee2711ea6e$var$gOPS === "function" ? $e278ceee2711ea6e$var$gOPS(obj) : [];
    var symMap;
    if ($e278ceee2711ea6e$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$e278ceee2711ea6e$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($e278ceee2711ea6e$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($e278ceee2711ea6e$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $e278ceee2711ea6e$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($e278ceee2711ea6e$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("1wVs5", function(module, exports) {
"use strict";

});



parcelRegister("kuoj3", function(module, exports) {
"use strict";

var $eoauW = parcelRequire("eoauW");
var $eea976bc869a75c0$var$has = Object.prototype.hasOwnProperty;
var $eea976bc869a75c0$var$isArray = Array.isArray;
var $eea976bc869a75c0$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $eea976bc869a75c0$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($eea976bc869a75c0$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $eea976bc869a75c0$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $eea976bc869a75c0$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($eea976bc869a75c0$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$eea976bc869a75c0$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($eea976bc869a75c0$var$isArray(target) && !$eea976bc869a75c0$var$isArray(source)) mergeTarget = $eea976bc869a75c0$var$arrayToObject(target, options);
    if ($eea976bc869a75c0$var$isArray(target) && $eea976bc869a75c0$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($eea976bc869a75c0$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($eea976bc869a75c0$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $eea976bc869a75c0$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $eea976bc869a75c0$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $eea976bc869a75c0$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $eea976bc869a75c0$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $eea976bc869a75c0$var$limit){
        var segment = string.length >= $eea976bc869a75c0$var$limit ? string.slice(j, j + $eea976bc869a75c0$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $eoauW.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $eea976bc869a75c0$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $eea976bc869a75c0$var$hexTable[0xC0 | c >> 6] + $eea976bc869a75c0$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $eea976bc869a75c0$var$hexTable[0xE0 | c >> 12] + $eea976bc869a75c0$var$hexTable[0x80 | c >> 6 & 0x3F] + $eea976bc869a75c0$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $eea976bc869a75c0$var$hexTable[0xF0 | c >> 18] + $eea976bc869a75c0$var$hexTable[0x80 | c >> 12 & 0x3F] + $eea976bc869a75c0$var$hexTable[0x80 | c >> 6 & 0x3F] + $eea976bc869a75c0$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $eea976bc869a75c0$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $eea976bc869a75c0$var$compactQueue(queue);
    return value;
};
var $eea976bc869a75c0$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $eea976bc869a75c0$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $eea976bc869a75c0$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $eea976bc869a75c0$var$maybeMap = function maybeMap(val, fn) {
    if ($eea976bc869a75c0$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $eea976bc869a75c0$var$arrayToObject,
    assign: $eea976bc869a75c0$var$assign,
    combine: $eea976bc869a75c0$var$combine,
    compact: $eea976bc869a75c0$var$compact,
    decode: $eea976bc869a75c0$var$decode,
    encode: $eea976bc869a75c0$var$encode,
    isBuffer: $eea976bc869a75c0$var$isBuffer,
    isRegExp: $eea976bc869a75c0$var$isRegExp,
    maybeMap: $eea976bc869a75c0$var$maybeMap,
    merge: $eea976bc869a75c0$var$merge
};

});
parcelRegister("eoauW", function(module, exports) {
"use strict";
var $a79b734a1be25fae$var$replace = String.prototype.replace;
var $a79b734a1be25fae$var$percentTwenties = /%20/g;
var $a79b734a1be25fae$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $a79b734a1be25fae$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $a79b734a1be25fae$var$replace.call(value, $a79b734a1be25fae$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $a79b734a1be25fae$var$Format.RFC1738,
    RFC3986: $a79b734a1be25fae$var$Format.RFC3986
};

});



parcelRegister("kwRoq", function(module, exports) {
"use strict";

var $kuoj3 = parcelRequire("kuoj3");
var $ef203688c4c5eff8$var$has = Object.prototype.hasOwnProperty;
var $ef203688c4c5eff8$var$isArray = Array.isArray;
var $ef203688c4c5eff8$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $kuoj3.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $ef203688c4c5eff8$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $ef203688c4c5eff8$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $ef203688c4c5eff8$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $ef203688c4c5eff8$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $ef203688c4c5eff8$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $ef203688c4c5eff8$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $ef203688c4c5eff8$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $ef203688c4c5eff8$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $ef203688c4c5eff8$var$defaults.decoder, charset, "key");
            val = $kuoj3.maybeMap($ef203688c4c5eff8$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $ef203688c4c5eff8$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $ef203688c4c5eff8$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $ef203688c4c5eff8$var$isArray(val) ? [
            val
        ] : val;
        var existing = $ef203688c4c5eff8$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $kuoj3.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $ef203688c4c5eff8$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $ef203688c4c5eff8$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $ef203688c4c5eff8$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $ef203688c4c5eff8$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $ef203688c4c5eff8$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $ef203688c4c5eff8$var$parseObject(keys, val, options, valuesParsed);
};
var $ef203688c4c5eff8$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $ef203688c4c5eff8$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $ef203688c4c5eff8$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $ef203688c4c5eff8$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $ef203688c4c5eff8$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $ef203688c4c5eff8$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $ef203688c4c5eff8$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $ef203688c4c5eff8$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $ef203688c4c5eff8$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $ef203688c4c5eff8$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $ef203688c4c5eff8$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $ef203688c4c5eff8$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $ef203688c4c5eff8$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $kuoj3.isRegExp(opts.delimiter) ? opts.delimiter : $ef203688c4c5eff8$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $ef203688c4c5eff8$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $ef203688c4c5eff8$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $ef203688c4c5eff8$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $ef203688c4c5eff8$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $ef203688c4c5eff8$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $ef203688c4c5eff8$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $ef203688c4c5eff8$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $ef203688c4c5eff8$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $ef203688c4c5eff8$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $kuoj3.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $kuoj3.compact(obj);
};

});



parcelRegister("7U1ts", function(module, exports) {
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
parcelRequire("LFcrK");
module.exports = self.fetch.bind(self);

});
parcelRegister("LFcrK", function(module, exports) {
/* eslint-disable no-prototype-builtins */ var $08f459502688113a$var$g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== "undefined" && $parcel$global || {};
var $08f459502688113a$var$support = {
    searchParams: "URLSearchParams" in $08f459502688113a$var$g,
    iterable: "Symbol" in $08f459502688113a$var$g && "iterator" in Symbol,
    blob: "FileReader" in $08f459502688113a$var$g && "Blob" in $08f459502688113a$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in $08f459502688113a$var$g,
    arrayBuffer: "ArrayBuffer" in $08f459502688113a$var$g
};
function $08f459502688113a$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($08f459502688113a$var$support.arrayBuffer) {
    var $08f459502688113a$var$viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var $08f459502688113a$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $08f459502688113a$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $08f459502688113a$var$normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $08f459502688113a$var$normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $08f459502688113a$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($08f459502688113a$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $08f459502688113a$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $08f459502688113a$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$08f459502688113a$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $08f459502688113a$var$normalizeName(name);
    value = $08f459502688113a$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
$08f459502688113a$export$79b704688b15c0f4.prototype["delete"] = function(name) {
    delete this.map[$08f459502688113a$var$normalizeName(name)];
};
$08f459502688113a$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $08f459502688113a$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$08f459502688113a$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($08f459502688113a$var$normalizeName(name));
};
$08f459502688113a$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$08f459502688113a$var$normalizeName(name)] = $08f459502688113a$var$normalizeValue(value);
};
$08f459502688113a$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$08f459502688113a$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $08f459502688113a$var$iteratorFor(items);
};
$08f459502688113a$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $08f459502688113a$var$iteratorFor(items);
};
$08f459502688113a$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $08f459502688113a$var$iteratorFor(items);
};
if ($08f459502688113a$var$support.iterable) $08f459502688113a$export$79b704688b15c0f4.prototype[Symbol.iterator] = $08f459502688113a$export$79b704688b15c0f4.prototype.entries;
function $08f459502688113a$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function $08f459502688113a$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $08f459502688113a$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $08f459502688113a$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $08f459502688113a$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $08f459502688113a$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
}
function $08f459502688113a$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function $08f459502688113a$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $08f459502688113a$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = "";
        } else if (typeof body === "string") this._bodyText = body;
        else if ($08f459502688113a$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($08f459502688113a$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($08f459502688113a$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($08f459502688113a$var$support.arrayBuffer && $08f459502688113a$var$support.blob && $08f459502688113a$var$isDataView(body)) {
            this._bodyArrayBuffer = $08f459502688113a$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($08f459502688113a$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $08f459502688113a$var$isArrayBufferView(body))) this._bodyArrayBuffer = $08f459502688113a$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if ($08f459502688113a$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if ($08f459502688113a$var$support.blob) this.blob = function() {
        var rejected = $08f459502688113a$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $08f459502688113a$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($08f459502688113a$var$support.blob) return this.blob().then($08f459502688113a$var$readBlobAsArrayBuffer);
        else throw new Error("could not read as ArrayBuffer");
    };
    this.text = function() {
        var rejected = $08f459502688113a$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $08f459502688113a$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($08f459502688113a$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if ($08f459502688113a$var$support.formData) this.formData = function() {
        return this.text().then($08f459502688113a$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $08f459502688113a$var$methods = [
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
];
function $08f459502688113a$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $08f459502688113a$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $08f459502688113a$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $08f459502688113a$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $08f459502688113a$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $08f459502688113a$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new $08f459502688113a$export$79b704688b15c0f4(options.headers);
    this.method = $08f459502688113a$var$normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ("AbortController" in $08f459502688113a$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
$08f459502688113a$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $08f459502688113a$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $08f459502688113a$var$decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $08f459502688113a$var$parseHeaders(rawHeaders) {
    var headers = new $08f459502688113a$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn("Response " + error.message);
            }
        }
    });
    return headers;
}
$08f459502688113a$var$Body.call($08f459502688113a$export$7fa6c5b6f8193917.prototype);
function $08f459502688113a$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $08f459502688113a$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
    this.headers = new $08f459502688113a$export$79b704688b15c0f4(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
$08f459502688113a$var$Body.call($08f459502688113a$export$9f633d56d7ec90d3.prototype);
$08f459502688113a$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $08f459502688113a$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $08f459502688113a$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$08f459502688113a$export$9f633d56d7ec90d3.error = function() {
    var response = new $08f459502688113a$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ""
    });
    response.ok = false;
    response.status = 0;
    response.type = "error";
    return response;
};
var $08f459502688113a$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$08f459502688113a$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($08f459502688113a$var$redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new $08f459502688113a$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $08f459502688113a$export$fe58bcf938607f6a = $08f459502688113a$var$g.DOMException;
try {
    new $08f459502688113a$export$fe58bcf938607f6a();
} catch (err) {
    $08f459502688113a$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $08f459502688113a$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $08f459502688113a$export$fe58bcf938607f6a.prototype.constructor = $08f459502688113a$export$fe58bcf938607f6a;
}
function $08f459502688113a$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $08f459502688113a$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $08f459502688113a$export$fe58bcf938607f6a("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $08f459502688113a$var$parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $08f459502688113a$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request timed out"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $08f459502688113a$export$fe58bcf938607f6a("Aborted", "AbortError"));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === "" && $08f459502688113a$var$g.location.href ? $08f459502688113a$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if ($08f459502688113a$var$support.blob) xhr.responseType = "blob";
            else if ($08f459502688113a$var$support.arrayBuffer) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof $08f459502688113a$export$79b704688b15c0f4 || $08f459502688113a$var$g.Headers && init.headers instanceof $08f459502688113a$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($08f459502688113a$var$normalizeName(name));
                xhr.setRequestHeader(name, $08f459502688113a$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
$08f459502688113a$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$08f459502688113a$var$g.fetch) {
    $08f459502688113a$var$g.fetch = $08f459502688113a$export$e7aa7bc5c1b3cfb3;
    $08f459502688113a$var$g.Headers = $08f459502688113a$export$79b704688b15c0f4;
    $08f459502688113a$var$g.Request = $08f459502688113a$export$7fa6c5b6f8193917;
    $08f459502688113a$var$g.Response = $08f459502688113a$export$9f633d56d7ec90d3;
}

});



parcelRegister("a1ai3", function(module, exports) {

$parcel$export(module.exports, "Configuration", function () { return $9bd79b734db86b46$export$fa89be98fe0936f2; });
// tslint:disable
/**
 * Ryddm API
 * Ryddm API.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ class $9bd79b734db86b46$export$fa89be98fe0936f2 {
    constructor(param = {}){
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
}

});


parcelRegister("dmGpj", function(module, exports) {

var $3sqgR = parcelRequire("3sqgR");

var $fOXQN = parcelRequire("fOXQN");

var $7a12w = parcelRequire("7a12w");

var $2aUn0 = parcelRequire("2aUn0");

var $fcO4w = parcelRequire("fcO4w");

var $kBQdL = parcelRequire("kBQdL");

var $3vEK1 = parcelRequire("3vEK1");

var $3OccL = parcelRequire("3OccL");

var $goDss = parcelRequire("goDss");

var $1kSzD = parcelRequire("1kSzD");

var $c3PRj = parcelRequire("c3PRj");

var $6BgJ6 = parcelRequire("6BgJ6");

var $iMkM4 = parcelRequire("iMkM4");

var $7TpYV = parcelRequire("7TpYV");

var $c3UUM = parcelRequire("c3UUM");

var $6OD7j = parcelRequire("6OD7j");

var $7XQMo = parcelRequire("7XQMo");

var $kyVMf = parcelRequire("kyVMf");

var $25imx = parcelRequire("25imx");

var $aolzG = parcelRequire("aolzG");

var $gJgVd = parcelRequire("gJgVd");

var $6Ew00 = parcelRequire("6Ew00");
$parcel$exportWildcard(module.exports, $3sqgR);
$parcel$exportWildcard(module.exports, $fOXQN);
$parcel$exportWildcard(module.exports, $7a12w);
$parcel$exportWildcard(module.exports, $2aUn0);
$parcel$exportWildcard(module.exports, $fcO4w);
$parcel$exportWildcard(module.exports, $kBQdL);
$parcel$exportWildcard(module.exports, $3vEK1);
$parcel$exportWildcard(module.exports, $3OccL);
$parcel$exportWildcard(module.exports, $goDss);
$parcel$exportWildcard(module.exports, $1kSzD);
$parcel$exportWildcard(module.exports, $c3PRj);
$parcel$exportWildcard(module.exports, $6BgJ6);
$parcel$exportWildcard(module.exports, $iMkM4);
$parcel$exportWildcard(module.exports, $7TpYV);
$parcel$exportWildcard(module.exports, $c3UUM);
$parcel$exportWildcard(module.exports, $6OD7j);
$parcel$exportWildcard(module.exports, $7XQMo);
$parcel$exportWildcard(module.exports, $kyVMf);
$parcel$exportWildcard(module.exports, $25imx);
$parcel$exportWildcard(module.exports, $aolzG);
$parcel$exportWildcard(module.exports, $gJgVd);
$parcel$exportWildcard(module.exports, $6Ew00);

});
parcelRegister("3sqgR", function(module, exports) {

$parcel$export(module.exports, "AlertCard", function () { return (parcelRequire("1brtB")).AlertCard; });
$parcel$export(module.exports, "AlertModal", function () { return (parcelRequire("9kzze")).AlertModal; });
parcelRequire("gblA4");
var $1brtB = parcelRequire("1brtB");
var $9kzze = parcelRequire("9kzze");

var $ic5m0 = parcelRequire("ic5m0");

var $joOpk = parcelRequire("joOpk");
$parcel$exportWildcard(module.exports, $ic5m0);
$parcel$exportWildcard(module.exports, $joOpk);

});
parcelRegister("gblA4", function(module, exports) {

$parcel$export(module.exports, "AlertCard", function () { return (parcelRequire("1brtB")).AlertCard; });
$parcel$export(module.exports, "AlertModal", function () { return (parcelRequire("9kzze")).AlertModal; });

var $1brtB = parcelRequire("1brtB");

var $9kzze = parcelRequire("9kzze");

});
parcelRegister("1brtB", function(module, exports) {

$parcel$export(module.exports, "AlertCard", function () { return $f1a6d5fb9da9379c$export$15f660e0f0f2d11f; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("dmGpj");
var $ic5m0 = parcelRequire("ic5m0");

var $94MU3 = parcelRequire("94MU3");
const $f1a6d5fb9da9379c$export$15f660e0f0f2d11f = ({ alertMessage: alertMessage, onTimeout: onTimeout, onCloseClick: onCloseClick })=>{
    const theme = (0, $hXJcm.u)();
    const { type: type, message: message } = alertMessage;
    const isInfoMessage = type === (0, $ic5m0.AlertMessageType).Info;
    const isWarnMessage = type === (0, $ic5m0.AlertMessageType).Warn;
    const isErrorMessage = type === (0, $ic5m0.AlertMessageType).Error;
    (0, $exYeM.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            onTimeout();
        }, 5000);
        return ()=>clearTimeout(timeoutId);
    });
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: [
            (0, $94MU3.styles)(theme).card.main.shared,
            isInfoMessage && (0, $94MU3.styles)(theme).card.main.info,
            isWarnMessage && (0, $94MU3.styles)(theme).card.main.warn,
            isErrorMessage && (0, $94MU3.styles)(theme).card.main.error,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $94MU3.styles)(theme).card.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $94MU3.styles)(theme).card.content.message,
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $94MU3.styles)(theme).card.close.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $94MU3.styles)(theme).card.close.button,
                    onClick: (e)=>onCloseClick(e),
                    type: "button",
                    "aria-label": "close alert",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CrossCircle, {
                        css: (0, $94MU3.styles)(theme).card.close.icon
                    })
                })
            })
        ]
    });
};
$f1a6d5fb9da9379c$export$15f660e0f0f2d11f.propTypes = {};

});
parcelRegister("4is25", function(module, exports) {

$parcel$export(module.exports, "cards", function () { return (parcelRequire("cRmR4")).cards; });
$parcel$export(module.exports, "icons", function () { return (parcelRequire("9IIBp")).icons; });
$parcel$export(module.exports, "logos", function () { return (parcelRequire("gLoh3")).logos; });

var $cRmR4 = parcelRequire("cRmR4");

var $9IIBp = parcelRequire("9IIBp");

var $gLoh3 = parcelRequire("gLoh3");

});
parcelRegister("cRmR4", function(module, exports) {

$parcel$export(module.exports, "cards", function () { return $ec73013c0ea70113$export$f9417f756858637d; });

var $bznUs = parcelRequire("bznUs");

var $fjVmC = parcelRequire("fjVmC");

var $hSi1n = parcelRequire("hSi1n");

var $k38hO = parcelRequire("k38hO");

var $7VxuW = parcelRequire("7VxuW");

var $fszW0 = parcelRequire("fszW0");

var $4icpY = parcelRequire("4icpY");

var $4J9cM = parcelRequire("4J9cM");

var $4nAvm = parcelRequire("4nAvm");
const $ec73013c0ea70113$export$f9417f756858637d = {
    Amex: $bznUs.default,
    Card: $fjVmC.default,
    Diners: $hSi1n.default,
    Discover: $k38hO.default,
    Eft: $7VxuW.default,
    Jcb: $fszW0.default,
    Mastercard: $4icpY.default,
    UnionPay: $4J9cM.default,
    Visa: $4nAvm.default
};

});
parcelRegister("bznUs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2e3f2eacd12e97b$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $b2e3f2eacd12e97b$var$SvgAmex = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#26A6D1",
                d: "M1 254c0-79.354 0-158.708.227-238.19C6.179 10.012 11.065 4.54 18.32 1.969c.007-.002-.21-.632-.321-.969 1.389 0 2.778 0 4.945.2 2.581.4 4.385.774 6.19.775 114.519.027 229.038.03 343.558-.017 2.103 0 4.205-.625 6.307-.958 1.389 0 2.778 0 4.244.255.687.76 1.22 1.46 1.92 1.742 6.241 2.513 11.33 6.256 14.113 12.643.135.311 1.129.249 1.723.36 0 79.02 0 158.042-.22 237.173a897.575 897.575 0 0 0-12.342 12.246c-.004.004.367.38.562.581-125.354 0-250.708 0-376.19-.22-3.55-4.088-6.956-7.968-10.425-11.793-.206-.227-.912-.002-1.385.013m360.865-93.365-25.44-25.741 39.032-40.048c-1.385-.332-1.975-.596-2.566-.597-16.333-.027-32.667-.101-48.998.077-1.716.018-3.845 1.159-5.04 2.46-3.146 3.428-5.883 7.231-9.061 11.234-4.642-4.79-7.454-8.108-10.721-10.891-1.712-1.458-4.22-2.787-6.375-2.797-36.666-.169-73.332-.087-109.999-.184-2.936-.008-4.51.93-5.702 3.589-2.498 5.567-5.317 10.989-8.356 17.186-3.052-6.058-5.855-11.168-8.214-16.476-1.404-3.158-3.187-4.403-6.774-4.33-12.162.246-24.331.094-36.498.093h-5.8l-.624 7.244c-2.619-7.733-8.503-7.517-14.734-7.314-8.657.282-17.335.22-25.995-.005-3.299-.085-4.986.957-6.456 3.996-11.671 24.126-23.556 48.15-35.354 72.214-.637 1.3-1.09 2.689-1.85 4.592 14.566 0 28.537-.112 42.505.081 3.355.047 5.292-.874 6.319-4.12.697-2.203 1.81-4.296 2.917-6.342.506-.935 1.409-2.285 2.196-2.33 3.816-.22 7.868-.785 11.395.262 1.82.54 2.735 4.173 4.021 6.43.41.72.824 1.477 1.023 2.27.798 3.17 2.854 3.847 5.934 3.815 14.498-.15 28.999-.059 43.499-.08 1.27-.002 2.542-.195 3.888-.306l.897-6.287 1.186-1.166c.685 8.13 5.699 8.218 11.17 7.82 3.482-.252 7.026-.334 10.49.02 5.466.557 9.882-.235 11.402-6.454.036-.145.567-.17 1.134-.321l.8 6.431c.972.102 1.777.259 2.583.26 34 .013 68 .052 101.998-.087 1.9-.008 4.107-1.116 5.63-2.37 3.69-3.033 7.06-6.455 11.163-10.283 2.741 3.016 5.332 5.6 7.606 8.439 2.725 3.401 6.003 4.497 10.372 4.424 14.496-.243 28.998-.048 43.498-.046 1.55 0 3.1-.166 4.649-.255l1.124-1.706a2765.876 2765.876 0 0 1-13.874-12.401z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#20AFDF",
                d: "M378.531 1c-1.633.333-3.735.957-5.838.958-114.52.047-229.04.044-343.559.017-1.804 0-3.608-.375-5.773-.775C141.354 1 259.708 1 378.531 1z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M401 15.527c-.594.362-1.588.424-1.723.113-2.783-6.387-7.872-10.13-14.113-12.643-.7-.282-1.233-.982-1.504-1.742C389.587 1 395.173 1 401 1v14.527zM17.53 1c.582.337.798.967.79.969-7.255 2.57-12.14 8.043-17.093 13.372C1 10.401 1 5.801 1 1h16.53zM389.48 266c-.675-.202-1.046-.577-1.042-.581 4.024-4.062 8.072-8.099 12.341-11.778.221 4.281.221 8.203.221 12.359h-11.52zM1 254.48c.473-.495 1.179-.72 1.385-.493 3.469 3.825 6.876 7.705 9.956 11.793C8.408 266 4.816 266 1 266v-11.52z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FAFDFE",
                d: "M362.114 160.885a5223.48 5223.48 0 0 0 13.625 12.151l-1.124 1.706c-1.55.089-3.1.255-4.649.255-14.5-.002-29.002-.197-43.498.046-4.37.073-7.647-1.023-10.372-4.424-2.274-2.838-4.865-5.423-7.606-8.439-4.102 3.828-7.473 7.25-11.162 10.284-1.524 1.253-3.73 2.361-5.63 2.37-34 .138-68 .1-102 .085-.805 0-1.61-.157-2.582-.259l-.8-6.431c-.567.152-1.098.176-1.134.32-1.52 6.22-5.936 7.012-11.402 6.454-3.464-.353-7.008-.271-10.49-.018-5.471.397-10.485.308-11.17-7.82l-1.186 1.165-.897 6.287c-1.346.11-2.617.304-3.888.306-14.5.021-29-.07-43.5.08-3.079.032-5.135-.646-5.933-3.814-.2-.794-.613-1.551-1.023-2.271-1.286-2.257-2.202-5.89-4.02-6.43-3.528-1.047-7.58-.483-11.396-.263-.787.046-1.69 1.396-2.196 2.331-1.107 2.046-2.22 4.139-2.917 6.343-1.027 3.245-2.964 4.166-6.32 4.12-13.967-.194-27.938-.082-42.505-.082.761-1.903 1.214-3.293 1.851-4.592 11.798-24.065 23.683-48.088 35.354-72.214 1.47-3.039 3.157-4.081 6.456-3.996 8.66.224 17.338.287 25.995.005 6.231-.203 12.115-.419 14.734 7.314l.624-7.244h5.8c12.167 0 24.336.153 36.498-.093 3.587-.073 5.37 1.172 6.774 4.33 2.36 5.308 5.162 10.418 8.214 16.476 3.039-6.197 5.858-11.62 8.356-17.186 1.193-2.66 2.766-3.597 5.702-3.59 36.667.098 73.333.016 109.999.185 2.155.01 4.663 1.34 6.375 2.797 3.267 2.783 6.079 6.102 10.721 10.891 3.178-4.003 5.915-7.806 9.062-11.234 1.194-1.301 3.323-2.442 5.039-2.46 16.331-.178 32.665-.104 48.998-.077.59.001 1.181.265 2.566.597l-39.032 40.048c8.642 8.743 17.04 17.242 25.69 25.991m-238.127-53.15v50.149c-1.614-1.07-2.352-2.287-2.967-3.564-5.123-10.646-10.197-21.315-15.341-31.95-2.606-5.386-4.027-12.842-8.353-15.488-4.533-2.772-11.916-.728-18.031-1.13-3.507-.23-5.288 1.031-6.782 4.219-7.697 16.42-15.656 32.718-23.5 49.069-.605 1.26-1.033 2.604-1.78 4.515 2.441 0 4.29-.276 6.03.047 7.96 1.48 12.987-1.437 14.863-9.45.714-3.053 2.894-3.531 5.686-3.466 6.327.147 12.725.61 18.974-.104 7.125-.815 11.232 1.527 13.197 8.437.491 1.73 2.497 4.251 3.89 4.306 9.61.378 19.243.2 29.54.2v-42.923c6.76 11.455 12.956 22.857 18.095 34.716 2.795 6.45 6.248 9.273 13.39 8.423 3.447-.41 5.29-1.37 6.754-4.442 5.655-11.866 11.533-23.626 17.356-35.411.608-1.232 1.408-2.369 2.118-3.55l.823.272v42.621h14.822v-57.395c-7.776 0-15.242-.16-22.689.153-1.284.053-2.932 1.882-3.646 3.282-3.253 6.37-6.232 12.88-9.311 19.337-2.444 5.126-4.892 10.25-7.75 16.24-6.396-12.366-12.245-23.74-18.182-35.067-.732-1.397-1.927-3.638-2.915-3.642-8.046-.033-16.094.373-24.29 1.596m122.512-1.921H227.4v57.342c1.085.157 1.889.374 2.693.375 18.483.023 36.966.114 55.446-.106 1.996-.024 4.309-1.507 5.894-2.95 5.62-5.118 10.99-10.512 16.613-15.955 5.691 5.69 10.955 10.998 16.282 16.241 1.041 1.025 2.295 2.515 3.507 2.57 5.895.268 11.81.121 17.718.121l.496-1.186-28.878-28.305 29.316-28.147c-5.012 0-8.833.266-12.6-.07-4.353-.39-7.511 1.06-10.485 4.245-4.718 5.053-9.875 9.698-15.437 15.089-4.779-5.024-9.323-9.426-13.411-14.218-3.29-3.856-6.942-5.351-12.091-5.173-11.642.403-23.307.127-35.962.127z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#2AA8D2",
                d: "M124.063 107.26c8.122-.748 16.17-1.154 24.216-1.12.988.003 2.183 2.244 2.915 3.64 5.937 11.328 11.786 22.702 18.181 35.068 2.86-5.99 5.307-11.114 7.75-16.24 3.08-6.458 6.059-12.968 9.312-19.337.714-1.4 2.362-3.229 3.646-3.282 7.447-.313 14.913-.153 22.689-.153v57.395H197.95V120.61l-.823-.271c-.71 1.18-1.51 2.317-2.118 3.549-5.823 11.785-11.701 23.545-17.356 35.41-1.464 3.073-3.307 4.032-6.755 4.443-7.141.85-10.594-1.973-13.39-8.423-5.138-11.86-11.334-23.26-18.093-34.716v42.922c-10.298 0-19.93.18-29.542-.199-1.392-.055-3.398-2.576-3.89-4.306-1.964-6.91-6.07-9.252-13.196-8.437-6.25.715-12.647.25-18.974.104-2.792-.065-4.972.413-5.686 3.466-1.876 8.013-6.903 10.93-14.864 9.45-1.738-.323-3.588-.047-6.03-.047.748-1.91 1.176-3.255 1.78-4.515 7.845-16.351 15.804-32.649 23.5-49.07 1.495-3.187 3.276-4.448 6.783-4.217 6.115.401 13.498-1.643 18.03 1.13 4.327 2.645 5.748 10.101 8.354 15.487 5.144 10.635 10.218 21.304 15.341 31.95.615 1.277 1.353 2.494 2.967 3.564 0-16.716 0-33.433.075-50.624m-39.499 31.508h11.948l-10.674-23.256-10.614 23.256h9.34z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#2CA8D2",
                d: "M247 105.814c12.156 0 23.821.276 35.463-.127 5.149-.178 8.8 1.317 12.09 5.173 4.09 4.792 8.633 9.194 13.412 14.218 5.562-5.391 10.72-10.036 15.437-15.09 2.974-3.184 6.132-4.633 10.485-4.244 3.767.336 7.588.07 12.6.07l-29.316 28.147 28.878 28.305-.496 1.186c-5.908 0-11.823.147-17.718-.12-1.212-.056-2.466-1.546-3.507-2.57-5.327-5.244-10.59-10.551-16.282-16.242-5.624 5.443-10.993 10.837-16.613 15.954-1.585 1.444-3.898 2.927-5.894 2.95-18.48.22-36.963.13-55.446.107-.804-.001-1.608-.218-2.693-.375v-57.342H247m44.03 21.677c-5.724-7.956-13.214-10.958-23.136-9.87-8.182.898-16.541.184-25.05.184v10.5h33.104v11.938h-33.429c0 2.277.171 3.948-.033 5.572-.552 4.39.82 6.2 5.667 5.999 9.481-.393 18.991-.052 28.488-.174 1.718-.022 3.987-.256 5.046-1.332 5.244-5.325 10.168-10.967 15.898-17.258-1.454-1.215-3.75-3.135-6.554-5.56z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F4FAFD",
                d: "M84.091 138.768h-8.867l10.614-23.256 10.674 23.256h-12.42z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FAFDFE",
                d: "M291.284 127.743c2.55 2.172 4.847 4.092 6.301 5.307-5.73 6.291-10.654 11.933-15.898 17.258-1.06 1.076-3.328 1.31-5.046 1.332-9.497.122-19.007-.219-28.488.174-4.848.2-6.22-1.61-5.667-6 .204-1.623.033-3.294.033-5.571h33.429v-11.938h-33.103v-10.5c8.508 0 16.867.714 25.049-.184 9.922-1.088 17.412 1.914 23.39 10.122z"
            })
        ]
    });
var $b2e3f2eacd12e97b$export$2e2bcd8739ae039 = $b2e3f2eacd12e97b$var$SvgAmex;

});

parcelRegister("fjVmC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f7e068a41a9b53a$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $5f7e068a41a9b53a$var$SvgCard = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#322A37",
                d: "M382 266c-.75 0-1.5 0-2.859-.265-2.12-.088-3.63.089-5.141.265-76.02 0-152.042 0-228.62-.165-.832-.055-1.106.055-1.38.165-41.02 0-82.042 0-123.522-.32-1.138-1.087-1.816-1.856-2.333-3.003.95-4.59 2.093-8.72-1.35-12.57-1.158-1.296-1.736-3.572-1.717-5.39.212-20.523.548-41.044.963-61.563.09-4.459.975-8.918.846-13.358-.1-3.394-1.828-6.772-1.747-10.131.127-5.242 1.262-10.453 1.808-15.693.985-9.466-1.975-18.351-4.287-27.31-.673-2.609-1.763-5.11-2.193-7.66 128.083-.002 255.698.003 383.313-.042 2.067-.001 4.133-.61 6.455-.942L401 108c0 45.688 0 91.375-.358 137.548-4.332 8.8-10.022 15.473-18.488 19.514-.163.078-.108.615-.154.938M39.907 154.001c44.368-.01 88.736-.002 133.103-.084 1.976-.004 3.95-.821 6.388-1.756 6.463-4.342 6.72-12.643.468-18.665a57.21 57.21 0 0 1-2.478-2.095c-.977-.133-1.953-.383-2.93-.384-44.422-.019-88.843-.025-133.265.025-1.397.002-2.794.617-4.18 1.613-.006.445-.011.889-.403 1.914-6.945 4.54-6.733 12.93.651 18.465.261.353.522.705.955 1.351.25-.106.501-.212 1.691-.384m317.464-22.61c-.643-.127-1.287-.365-1.93-.366-21.575-.022-43.15-.037-64.726.017-1.235.003-2.469.593-3.707 1.57-.009.439-.017.878-.426 1.851-1.62 1.522-3.24 3.044-5.59 4.831-.327.704-.935 1.406-.938 2.11-.057 15.071-.088 30.142.03 45.212.01 1.233 1.134 2.458 2.197 3.896 1.134 1.294 2.269 2.588 3.729 4.478.665-.002 1.33-.004 2.919-.17 23.025.065 46.05.13 69.517.755.974-.392 1.947-.783 3.12-1.684 1.147-1.296 2.295-2.592 4.219-4.118.396-.662 1.135-1.323 1.138-1.986.07-15.292.094-30.583-.02-45.874-.008-.98-1.213-1.95-2.399-3.308-1.501-1.534-3.003-3.067-4.629-5.242a38.528 38.528 0 0 1-2.504-1.972M72.186 188.72c4.52-3.34 4.7-8.123 2.877-12.503-.91-2.186-4.225-4.611-6.572-4.741-9.6-.53-19.246-.319-28.873-.17-4.653.072-7.28 2.844-7.774 7.405-.56 5.168.97 9.138 6.314 11.943.63.434 1.254 1.24 1.887 1.247 8.874.091 17.749.123 26.621-.005.788-.012 1.558-1.24 2.755-2.213.172.031.343.062.867.632a14.395 14.395 0 0 0 1.898-1.595m28.387-18.231c-.804.408-1.608.817-2.814 1.726-6.638 6.214-5.17 14.27 3.436 18.564.497.378.99 1.083 1.492 1.088 8.64.09 17.281.145 25.92.028.806-.01 1.595-1.229 2.982-2.282 8.106-3.074 9.25-11.107 2.34-18.566-.651.02-1.302.041-2.878.201-10.015-.073-20.03-.147-30.478-.76z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#312936",
                d: "M20 1c120.354 0 240.708 0 361.545.352 5.16 4.32 10.013 8.104 14.44 12.334 2.092 1.998 3.369 4.85 5.015 7.314 0 11.354 0 22.708-.26 34.513-.433.437-.606.425-.866.263-.342-.04-.597.07-1.232.197-1.141.01-1.902.003-2.961-.291-1.777-.419-3.255-.666-4.733-.666-126.576-.018-253.153-.02-379.73.024-1.733 0-3.467.608-5.538.945-.786.01-1.235.008-1.77-.156-.354-.062-.622.037-1.098.225-.478.26-.644.502-.98.852-.462.055-.647.074-.832.094 0-11.688 0-23.375.359-35.547 4.446-8.25 9.123-15.44 17.855-18.797.413-.159.53-1.086.786-1.656z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#EEC67A",
                d: "M401 59c0 14.688 0 29.375-.466 44.532-133.147.458-265.829.446-398.52-.03-.01-12.786-.016-25.107-.012-37.427.003-7.068.01-7.07 6.904-7.07C139.604 59.001 270.302 59 401 59z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#322832",
                d: "M9.999 109.002c.899 2.55 1.989 5.051 2.662 7.66 2.312 8.959 5.272 17.844 4.287 27.31-.546 5.24-1.681 10.45-1.808 15.693-.08 3.359 1.648 6.737 1.747 10.13.129 4.44-.755 8.9-.846 13.359-.415 20.519-.75 41.04-.963 61.562-.019 1.82.559 4.095 1.718 5.391 3.442 3.85 2.298 7.98.996 12.52-7.043-2.302-11.457-6.95-13.892-13.796-.266-.494-.507-.686-.88-1.123C2.306 246.92 1.653 246.46 1 246c0-.75 0-1.5.215-2.746.496-.688.692-.946 1.092-1.566.424-2.108.675-3.919.676-5.73.022-42.315.016-84.631.453-126.95 2.48-.004 4.521-.005 6.563-.006z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#ECC789",
                d: "m2.024 103.967 398.51.034c.466-.001.466.499.29.836-.236.452-.377.63-.345.67.147.185.343.332.521.493 0 0 0 .5-.433.551-1.764.013-3.095-.06-4.426-.06-130.074-.007-260.148-.01-390.222.011-1.64 0-3.28.325-4.919.498 0 0 0-.5.256-.911.426-.981.597-1.552.768-2.122z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#D6BB8D",
                d: "M2.015 103.502c-.162 1.035-.333 1.606-.76 2.337C1 90.312 1 74.625 1.466 58.464 134.953 57.994 267.977 57.997 401 58v.75c-130.698.251-261.396.252-392.094.254-6.895 0-6.901.003-6.904 7.07-.004 12.321.002 24.642.013 37.428z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#795F35",
                d: "M401 57.75c-133.023.247-266.047.244-399.535.246C1 58 1 57.5 1 57.25c.185-.27.37-.29 1.286-.29 133.393.027 266.053.033 398.714.04v.75z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#1D1429",
                d: "M1 107.25c1.64-.423 3.279-.747 4.919-.748 130.074-.021 260.148-.018 390.222-.01 1.331 0 2.662.072 4.426.31.433.198.433.698.433.948-.17.254-.34.259-1.23.258-133.072-.004-265.422-.003-398.021-.017C1.499 107.977 1 108 1 108v-.75z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#1B0519",
                d: "M401 56.75c-132.66.243-265.321.237-398.437.175-.395-.369-.23-.61.493-.853.451-.071.94-.082.94-.082.45.003.898.006 2.15.005 130.48-.011 260.156-.018 389.833-.026.76.007 1.522.013 2.898.008.615-.011 1.084-.052 1.084-.052l.78.056c.259.019.259.519.259.769z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M3.993 249.047c2.342 6.63 6.756 11.278 13.637 13.958 1.032.82 1.71 1.588 2.38 2.676C13.738 266 7.476 266 1 266v-19.531c.652-.01 1.305.45 2.092 1.467.325.833.58 1.017.901 1.111zM401 20.531c-1.646-1.996-2.923-4.847-5.015-6.845-4.427-4.23-9.28-8.014-13.972-12.334C388.261 1 394.523 1 401 1v19.531zM382.47 266c-.424-.323-.48-.86-.316-.938 8.466-4.041 14.156-10.714 18.488-19.045.358 6.574.358 13.164.358 19.983h-18.53zM19.53 1c.215.57.097 1.497-.316 1.656C10.482 6.012 5.805 13.203 1.359 20.985 1 14.409 1 7.819 1 1h18.53z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#48403E",
                d: "M1 108.469c0-.469.5-.492.754-.226.26.435.264.603.26 1.239-.004 44.48 0 88.491.003 132.503-.11.323-.306.581-.802.894C1 198.312 1 153.625 1 108.47z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3B353F",
                d: "M374.417 266c1.094-.176 2.605-.353 4.35-.265-1.156.265-2.545.265-4.35.265z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#D8B580",
                d: "M401 105.75c-.178.09-.374-.058-.521-.243-.032-.04.109-.218.345-.42.176-.087.176.413.176.663z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3B353F",
                d: "M144.25 266c.024-.11.298-.22.661-.165.089.165-.411.165-.661.165z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FDFCFD",
                d: "M365.01 190.003c-1.149 1.296-2.297 2.592-3.973 4.203-1.364.48-2.198.644-3.033.808-23.025-.064-46.05-.129-69.916-.236-1.361-.156-1.882-.27-2.404-.384-1.134-1.294-2.269-2.588-3.595-4.423-.25-17.34-.308-34.14-.367-50.941 1.62-1.523 3.24-3.045 5.53-4.818 24.695-.236 48.721-.222 72.747-.208 1.502 1.534 3.004 3.067 4.777 5.263.26 17.353.246 34.044.233 50.736z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FBFAFC",
                d: "M179.956 134.161c6.162 5.357 5.905 13.658-1.254 18.236-46.184.244-91.67.255-137.158.25-1.494 0-2.989-.171-4.483-.263-7.184-4.886-7.396-13.274.211-18.111 47.011-.326 93.36-.357 139.708-.373.992 0 1.984.17 2.976.261z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F5F2F5",
                d: "M100.998 189.988c-8.409-3.503-9.877-11.56-2.674-18.078 1.27-.497 1.976-.69 2.682-.883 10.015.073 20.03.147 30.854.297a33.9 33.9 0 0 1 2.285.358c6.695 6.823 5.55 14.856-3.31 18.024-10.447.156-20.142.22-29.837.282z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F5F3F5",
                d: "M37.978 189.84c-5.163-1.992-6.693-5.962-6.134-11.13.494-4.56 3.12-7.333 7.774-7.405 9.627-.149 19.274-.36 28.873.17 2.347.13 5.661 2.555 6.572 4.741 1.824 4.38 1.643 9.163-3.405 12.753l-1.723.807c-.171-.032-.342-.063-1.184-.035-10.705.072-20.739.086-30.773.099z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#342C3E",
                d: "M2.023 109.015c-.005-.169-.01-.337-.02-.758 132.345-.252 264.695-.253 397.512-.243-1.6.335-3.667.945-5.734.946-127.615.045-255.23.04-383.313.041l-7.276.005c-.681.001-1.169.009-1.169.009z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#19151C",
                d: "M179.911 133.829c-.947.241-1.939.07-2.93.071-46.35.016-92.698.047-139.516.082-.463-.438-.458-.882.01-1.656 47.144-.335 93.826-.34 140.507-.345.628.505 1.256 1.01 1.929 1.848z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#1A171E",
                d: "M359.937 133.684c-23.964.306-47.99.292-72.485.262-.461-.456-.453-.895.025-1.65 23.808-.322 47.147-.326 70.486-.33.637.465 1.275.931 1.974 1.718z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#010004",
                d: "M37.16 152.71c1.395-.234 2.89-.063 4.384-.063 45.487.005 90.974-.006 136.925-.003-1.51.452-3.483 1.27-5.459 1.273-44.367.082-88.735.075-133.804.104-.7.019-1.162.07-1.162.07-.26-.352-.522-.704-.883-1.382z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#39313C",
                d: "M177.685 131.69c-46.384.296-93.066.3-140.215.302.929-.333 2.326-.948 3.723-.95 44.422-.05 88.843-.044 133.265-.025.977 0 1.953.25 3.227.674z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#161318",
                d: "M365.397 189.888c-.375-16.577-.362-33.268-.352-50.429.645.505 1.85 1.475 1.857 2.454.115 15.29.09 30.582.02 45.874-.002.663-.741 1.324-1.525 2.1z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#1E1821",
                d: "M281.357 139.162c.424 16.668.482 33.468.504 50.705-.643-.793-1.767-2.018-1.776-3.251-.12-15.07-.088-30.14-.03-45.211.002-.705.61-1.407 1.302-2.243z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3B353F",
                d: "M357.667 131.678c-23.043.292-46.382.296-70.188.287.767-.33 2-.92 3.236-.923 21.575-.054 43.15-.039 64.726-.017.643 0 1.287.239 2.226.653z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#261F27",
                d: "M38.068 190.246c9.944-.42 19.978-.433 30.473-.35-.317.76-1.087 1.987-1.875 1.999-8.872.128-17.747.096-26.62.005-.634-.006-1.259-.813-1.978-1.654zM101.096 190.383c9.597-.458 19.292-.52 29.445-.48-.339.762-1.128 1.98-1.935 1.991-8.638.117-17.28.061-25.919-.028-.501-.005-.995-.71-1.59-1.483zM100.79 170.757c-.49.463-1.196.656-2.265.903.44-.355 1.244-.764 2.264-.903z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#18101D",
                d: "M358.225 195.295c.614-.445 1.448-.61 2.712-.835-.544.332-1.517.723-2.712.835z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#261F27",
                d: "M134.036 171.364c-.383.224-.875.13-1.713-.11.304-.167.955-.187 1.713.11zM70.112 190.045c.221-.455.62-.641 1.352-.824-.168.366-.672.73-1.352.824z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#18101D",
                d: "M285.847 194.692c.359-.184.88-.07 1.78.168-.287.126-.952.128-1.78-.168z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3B363D",
                d: "M38.13 154.238c-.086-.147.375-.198.607-.184-.02.12-.27.225-.607.184z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3D273B",
                d: "M395.68 55.682c-129.378.295-259.054.302-389.196.3 1.267-.334 3-.941 4.735-.942 126.576-.044 253.153-.042 379.73-.024 1.477 0 2.955.247 4.732.666zM399.874 55.776c.087.15-.382.19-.617.185.02-.114.275-.224.617-.185zM3.91 55.83c.086.16-.403.17-.647.153.025-.117.293-.216.647-.154z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#282432",
                d: "M2.015 109.482c.008-.467.496-.475.74-.473.244 42.318.25 84.634.228 126.95 0 1.81-.252 3.621-.676 5.73-.294-43.716-.297-87.728-.292-132.207z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#342C3E",
                d: "M3.9 248.83c-.228.123-.483-.061-.745-.564.238-.121.479.071.745.565z"
            })
        ]
    });
var $5f7e068a41a9b53a$export$2e2bcd8739ae039 = $5f7e068a41a9b53a$var$SvgCard;

});

parcelRegister("hSi1n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c71852514f2e24a4$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $c71852514f2e24a4$var$SvgDiners = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#0079BE",
                d: "M1 255c0-80.688 0-161.376.288-242.232a419.034 419.034 0 0 0 9.616-10.352c.249-.277.074-.935.096-1.416 126.355 0 252.71 0 379.22.27 3.21 3.726 6.248 7.198 9.351 10.61.236.259.942.09 1.429.12 0 80.688 0 161.376-.29 242.233a418.18 418.18 0 0 0-9.627 10.353c-.247.275-.065.934-.083 1.414-126.355 0-252.71 0-379.22-.268-3.207-3.722-6.243-7.19-9.344-10.6-.24-.262-.947-.098-1.436-.132m106.243-72.755c18.075 26.648 42.918 40.508 75.413 40.09a1421.56 1421.56 0 0 1 35.986-.007c50.312.626 94.28-45.153 89.713-95.891-3.94-43.782-40.001-80.056-83.948-81.512-16.807-.557-33.66-.462-50.47.035-17.468.517-33.253 6.543-46.99 17.343-35.686 28.058-44.21 79.244-19.704 119.942z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M10.513 1c.465.481.64 1.139.391 1.416-3.073 3.427-6.209 6.8-9.616 9.885C1 8.418 1 4.836 1 1h9.513zM401 11.517c-.487.453-1.193.622-1.429.363-3.103-3.412-6.14-6.884-8.883-10.61C394.258 1 397.515 1 401 1v10.517zM1 255.483c.49-.449 1.197-.613 1.436-.35 3.101 3.408 6.137 6.877 8.876 10.599C7.742 266 4.485 266 1 266v-10.517zM391.487 266c-.47-.48-.65-1.14-.404-1.414 3.077-3.428 6.215-6.799 9.628-9.885.289 3.881.289 7.463.289 11.299h-9.513z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FCFDFE",
                d: "M107.074 181.925c-24.336-40.378-15.813-91.564 19.873-119.622 13.737-10.8 29.522-16.826 46.99-17.343 16.81-.497 33.663-.592 50.47-.035 43.947 1.456 80.007 37.73 83.948 81.512 4.567 50.738-39.4 96.517-89.713 95.891a1421.56 1421.56 0 0 0-35.986.007c-32.495.418-57.338-13.442-75.582-40.41m-5.444-47.44c.116 14.088 3.618 27.275 10.336 39.662 21.025 38.77 68.842 52.1 106.624 29.675 35.722-21.203 49.276-68.363 30.677-106.743-16.872-34.818-53.35-51.796-90.322-42.038-33.28 8.784-57.424 41.815-57.315 79.444z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#027ABE",
                d: "M101.613 133.992c-.092-37.136 24.052-70.167 57.332-78.951 36.972-9.758 73.45 7.22 90.322 42.038 18.599 38.38 5.045 85.54-30.677 106.743-37.782 22.425-85.6 9.095-106.624-29.675-6.718-12.387-10.22-25.574-10.353-40.155m122.952 20.97c14.62-33.803-8.18-64.131-26.855-68.886v95.118c12.364-5.42 21.002-13.837 26.855-26.231m-65.027 25.21c4.387 1.694 2.365-2.131 2.37-3.196.131-29.3.109-58.602.09-87.903 0-1.047-.22-2.094-.407-3.779-19.193 9.142-29.23 23.901-31.24 44.185-2.022 20.395 9.366 40.323 29.187 50.693z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F9FCFD",
                d: "M224.39 155.3c-5.678 12.057-14.316 20.474-26.68 25.894V86.076c18.675 4.755 41.475 35.083 26.68 69.224z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FDFEFE",
                d: "M159.177 180.028c-19.46-10.225-30.848-30.153-28.826-50.548 2.01-20.284 12.047-35.043 31.24-44.185.188 1.685.406 2.732.407 3.779.019 29.301.041 58.602-.09 87.903-.005 1.065 2.017 4.89-2.73 3.051z"
            })
        ]
    });
var $c71852514f2e24a4$export$2e2bcd8739ae039 = $c71852514f2e24a4$var$SvgDiners;

});

parcelRegister("k38hO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $351dd10d10ebc00f$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $351dd10d10ebc00f$var$SvgDiscover = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#E0E6E8",
                d: "M1 249c0-76.688 0-153.375.299-230.218 1.44-1.341 2.476-2.658 3.744-3.69 4.37-3.55 6.928-9.238 13.06-10.8C19.272 3.992 20.044 2.136 21 1c118.02 0 236.042 0 354.199.314.662 1.084 1.216 2.538 1.71 2.518 4.267-.174 6.678 2.823 9.414 5.229 6.642 5.838 12.242 13.218 12.397 21.779.624 34.621.17 69.262-.233 103.948-1.337 1.453-2.329 2.855-3.47 4.574-1.366 2.05-2.582 3.78-3.795 5.512-17.455 24.937-41.133 42.73-67.57 56.716-19.042 10.074-38.82 18.923-58.797 27.015-16.169 6.55-33.057 11.374-49.756 16.542-10.414 3.222-21.038 5.786-31.626 8.412-10.9 2.703-21.868 5.127-32.809 7.666-6.886 1.598-13.776 3.184-20.664 4.775-36.02 0-72.042 0-108.201-.31-1.724-1.424-3.271-2.601-4.91-3.635-1.219-.77-2.85-1.077-3.787-2.072-2.965-3.148-5.595-6.613-8.573-9.748-.764-.804-2.33-.844-3.529-1.235m225.992-135.463c-9.501-7.882-20.308-8.684-31.121-4.175-14.056 5.861-20.467 21.973-13.29 36.093 5.254 10.339 21.432 18.423 36.271 12.679 9.874-3.822 15.826-10.596 17.518-20.765 1.542-9.265-1.507-17.244-9.378-23.832M52.977 158.463c9.705-2.049 17.57-10.927 19.305-21.795 1.725-10.796-2.862-20.265-11.89-25.659-9.672-5.78-20.236-3.809-30.55-3.923-.768-.008-2.227 2.297-2.24 3.538a2204.35 2204.35 0 0 0 .009 45.948c.013 1.185 1.578 3.38 2.4 3.37 7.448-.09 14.89-.567 22.966-1.48m299.805-3.571c3.612 5.61 9.322 7.065 15.936 3.995l-15.68-20.463c.86-.616 1.223-.954 1.65-1.16.443-.215.983-.232 1.42-.455 5.997-3.061 9.199-7.932 8.801-14.7-.376-6.394-2.967-11.97-9.725-13.227-8.14-1.513-16.49-1.888-25.005-2.782v53.702h10.365v-19.724l1.086-.18c3.564 4.808 7.128 9.616 11.152 14.994m-41.277-17.925c2.163 0 4.338-.148 6.486.035 3.202.272 4.41-.895 4.424-4.228.014-3.436-1.083-4.846-4.59-4.7-4.57.189-9.156.046-13.806.046v-12.415h18.696v-8.49H292.99v52.683h29.752v-8.803h-18.842v-14.128h7.604m-183.757 16.227c6.926-9.57 3.491-19.78-6.689-23.72-3.49-1.35-6.987-2.819-10.182-4.732-1.437-.86-3.092-3.068-2.914-4.438.184-1.406 2.395-3.45 3.878-3.595 2.95-.29 6.04.384 9.01.968 1.15.225 2.134 1.288 3.281 2.025l4.86-6.436c-5.299-5.597-11.523-6.784-18.363-6.25-7.47.585-12.851 5.605-14.098 13.29-1.071 6.6 2.331 11.703 9.645 14.64 3.486 1.4 7.139 2.596 10.268 4.588 1.606 1.022 3.299 3.773 3.02 5.412-.334 1.953-2.402 4.33-4.311 5.161-6.454 2.81-11.276-.565-15.604-5.656l-6.016 6c7.296 12.39 27.096 12.276 34.215 2.743m146.047-13.9 13.84-31.768c-8.585-1.62-11.346-.94-13.156 3.245-1.947 4.505-3.698 9.095-5.676 13.586-2.335 5.303-4.821 10.54-7.592 16.568-2.46-5.546-4.44-9.99-6.402-14.44-1.981-4.493-3.956-8.99-5.917-13.491-2.901-6.658-6.002-7.851-13.635-4.988 1.245 2.817 2.482 5.626 3.727 8.43 6.096 13.736 12.13 27.5 18.406 41.154.559 1.216 2.725 2.391 4.095 2.337 1.315-.053 3.094-1.458 3.752-2.74 2.9-5.644 5.47-11.46 8.558-17.893M149.873 109.26c-1.997 1.452-4.08 2.799-5.977 4.37-14.57 12.078-12.986 32.82 3.29 42.39 9.186 5.4 18.747 5.317 28.33 1.514v-10.862c-10.635 6.13-19.546 5.784-25.837-.728-5.566-5.761-6.519-14.554-2.51-21.387 2.99-5.1 7.517-8.352 13.158-8.28 5.157.065 10.29 1.937 15.468 3.02v-9.525c-8.434-4.598-16.769-5.13-25.922-.512m-68.16-2.43c-3.697-.566-4.939.952-4.885 4.715.189 13.33.073 26.664.073 39.997 0 9.641 0 9.645 9.86 8.301.282-.038.528-.34.903-.596v-52.126c-1.85-.105-3.488-.199-5.95-.292z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FF6E02",
                d: "M130.469 266c6.42-1.591 13.309-3.177 20.195-4.775 10.94-2.54 21.91-4.963 32.81-7.666 10.587-2.626 21.211-5.19 31.625-8.412 16.7-5.168 33.587-9.993 49.756-16.542 19.978-8.092 39.755-16.941 58.797-27.015 26.437-13.986 50.115-31.779 67.57-56.716 1.213-1.732 2.43-3.462 4.169-5.4.883 1.655 1.547 3.514 1.551 5.375.067 27.53.025 55.062.093 82.593.005 1.886.673 3.77 1.005 6.083-.072 11.66-8.23 23.579-18.205 27.68-1.94.798-3.24 3.156-4.835 4.795H130.469z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M375.469 266c1.126-1.639 2.426-3.997 4.366-4.795 9.975-4.101 18.133-16.02 18.57-27.926.404-33.298.416-65.921.428-98.544.056-34.633.511-69.274-.113-103.895-.155-8.56-5.755-15.94-12.397-21.78-2.736-2.405-5.147-5.402-9.415-5.228-.493.02-1.047-1.434-1.24-2.518C384.322 1 392.644 1 400.958 1c-.007 88.333-.007 176.667-.007 265H375.47zM1 249.47c1.198-.079 2.765-.039 3.529.765 2.978 3.135 5.608 6.6 8.573 9.748.937.995 2.568 1.302 3.788 2.072 1.638 1.034 3.185 2.21 4.44 3.635C14.414 266 7.828 266 1 266v-16.53zM20.531 1c-.487 1.137-1.259 2.993-2.428 3.291-6.132 1.563-8.69 7.25-13.06 10.802-1.268 1.03-2.304 2.348-3.744 3.22C1 12.402 1 6.804 1 1h19.531z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FE7005",
                d: "M227.286 113.745c7.577 6.38 10.626 14.36 9.084 23.624-1.692 10.17-7.644 16.943-17.518 20.765-14.84 5.744-31.017-2.34-36.271-12.679-7.177-14.12-.766-30.232 13.29-36.093 10.813-4.51 21.62-3.707 31.415 4.383z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#0D0D0D",
                d: "M52.661 158.737c-7.76.638-15.202 1.115-22.65 1.205-.822.01-2.387-2.185-2.4-3.37a2204.35 2204.35 0 0 1-.008-45.948c.012-1.24 1.471-3.546 2.238-3.538 10.315.114 20.879-1.857 30.552 3.923 9.027 5.394 13.614 14.863 11.89 25.659-1.736 10.868-9.6 19.746-19.622 22.07m2.786-38.788c-4.459-1.39-8.88-2.927-13.393-4.108-2.341-.613-3.746.553-3.734 3.207.043 9.629-.072 19.26.136 28.885.024 1.11 1.791 3.183 2.585 3.106 3.893-.378 8.044-.638 11.527-2.214 10.59-4.793 12.975-20 2.88-28.876z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#0B0B0B",
                d: "M352.552 154.606a7415.313 7415.313 0 0 1-10.922-14.71l-1.086.18v19.725h-10.365v-53.702c8.515.894 16.866 1.27 25.005 2.782 6.758 1.257 9.35 6.833 9.725 13.228.398 6.767-2.804 11.638-8.8 14.699-.438.223-.978.24-1.421.454-.427.207-.79.545-1.65 1.161l15.68 20.463c-6.614 3.07-12.324 1.615-16.166-4.28m-3.256-37.619c-1.935-.419-3.898-1.24-5.794-1.106-1.14.081-3.031 1.586-3.107 2.565-.34 4.385-.148 8.812-.148 13.278 5.425.5 10.194.072 12.35-4.453 1.576-3.306 1.488-7.494-3.301-10.284z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#101010",
                d: "M311.016 136.966h-7.115v14.128h18.842v8.803h-29.752v-52.684h29.724v8.491h-18.696v12.415c4.65 0 9.235.143 13.807-.046 3.506-.146 4.603 1.264 4.589 4.7-.014 3.333-1.222 4.5-4.424 4.228-2.148-.183-4.323-.035-6.975-.035z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#0D0D0D",
                d: "M127.491 153.456c-6.862 9.27-26.662 9.383-33.958-3.006l6.016-6c4.328 5.09 9.15 8.466 15.604 5.656 1.91-.831 3.977-3.208 4.31-5.16.28-1.64-1.413-4.391-3.019-5.413-3.13-1.992-6.782-3.188-10.268-4.588-7.314-2.937-10.716-8.04-9.645-14.64 1.247-7.685 6.627-12.705 14.098-13.29 6.84-.534 13.064.653 18.363 6.25l-4.86 6.436c-1.147-.737-2.131-1.8-3.28-2.025-2.972-.584-6.06-1.257-9.011-.968-1.483.146-3.694 2.189-3.878 3.595-.178 1.37 1.477 3.578 2.914 4.438 3.195 1.913 6.692 3.382 10.182 4.732 10.18 3.94 13.615 14.15 6.432 23.983zM273.595 139.633c-2.889 6.093-5.458 11.909-8.358 17.554-.658 1.281-2.437 2.686-3.752 2.739-1.37.054-3.536-1.12-4.095-2.337-6.276-13.653-12.31-27.418-18.406-41.153-1.245-2.805-2.482-5.614-3.727-8.431 7.633-2.863 10.734-1.67 13.635 4.988 1.961 4.502 3.936 8.998 5.917 13.491 1.963 4.45 3.942 8.894 6.402 14.44 2.77-6.028 5.257-11.265 7.592-16.568 1.978-4.491 3.729-9.081 5.676-13.586 1.81-4.186 4.571-4.865 13.156-3.245a8691.678 8691.678 0 0 1-14.04 32.108z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#0F0F10",
                d: "M150.237 109.145c8.79-4.503 17.124-3.97 25.558.627v9.525c-5.178-1.083-10.311-2.955-15.468-3.02-5.64-.072-10.168 3.18-13.159 8.28-4.008 6.833-3.055 15.626 2.51 21.387 6.292 6.512 15.203 6.858 25.838.728v10.862c-9.583 3.803-19.144 3.887-28.33-1.514-16.276-9.57-17.86-30.312-3.29-42.39 1.896-1.571 3.98-2.918 6.34-4.485z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#161617",
                d: "M82.126 106.83c2.05.092 3.688.186 5.538.29v52.127c-.375.256-.621.558-.903.596-9.86 1.344-9.86 1.34-9.86-8.3 0-13.334.116-26.668-.073-39.998-.054-3.763 1.188-5.281 5.298-4.716z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F9852C",
                d: "M398.487 134.788c.334 32.57.322 65.193-.055 98.062-.724-1.638-1.392-3.522-1.397-5.408-.068-27.531-.026-55.062-.093-82.593-.004-1.861-.668-3.72-1.4-5.693.616-1.513 1.608-2.915 2.945-4.368z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#D6DBDE",
                d: "M55.772 120.135c9.77 8.69 7.387 23.898-3.204 28.69-3.483 1.577-7.634 1.837-11.527 2.215-.794.077-2.561-1.996-2.585-3.106-.208-9.625-.093-19.256-.136-28.885-.012-2.654 1.393-3.82 3.734-3.207 4.514 1.181 8.934 2.718 13.718 4.293z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#CFD4D7",
                d: "M349.702 117.096c4.383 2.681 4.47 6.869 2.895 10.175-2.156 4.525-6.925 4.953-12.35 4.453 0-4.466-.191-8.893.148-13.278.076-.98 1.968-2.484 3.107-2.565 1.896-.134 3.86.687 6.2 1.215z"
            })
        ]
    });
var $351dd10d10ebc00f$export$2e2bcd8739ae039 = $351dd10d10ebc00f$var$SvgDiscover;

});

parcelRegister("7VxuW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee58c55afed5409e$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $ee58c55afed5409e$var$SvgEft = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#8D1339",
                d: "M1 251c0-79.021 0-158.043.347-237.436C5.805 9.775 9.936 6.381 14.003 2.912c.507-.433.673-1.265.997-1.912 124.355 0 248.71 0 373.45.353 3.877 4.267 7.348 8.199 10.884 12.07.349.381 1.101.394 1.666.577 0 79.688 0 159.376-.352 239.44-3.828 5.059-7.52 9.472-13.435 11.24-.186.056-.147.863-.213 1.32-123.688 0-247.376 0-371.442-.353-5.548-4.017-10.527-7.842-12.923-14.068-.135-.35-1.071-.393-1.635-.579M257.53 30.073c-7.378 9.024-10.524 19.517-10.557 31.015-.048 16.655.004 33.31.068 49.965.01 2.652.018 5.358.51 7.948 4.145 21.815 20.807 35.772 43.36 35.904 31.643.185 63.288.051 94.932.042 1.129 0 2.257-.132 3.594-.215v-38.414h-100.97c0-6.874.313-13.185-.1-19.448-.32-4.843 1.578-5.816 6.021-5.79 28.312.17 56.626.097 84.94.053 7.054-.011 9.67-2.6 9.745-9.592.084-7.827.036-15.656.022-23.484-.044-24.69-19.34-44.047-44.084-44.142-16.82-.064-33.644-.152-50.463.032-14.256.157-26.688 4.94-37.017 16.126M223.779 238.23c.74-1.101 1.834-2.106 2.162-3.319 2.512-9.295 5.402-18.535 7.11-27.985 1.255-6.939-3.63-11.798-10.806-11.955-8.32-.182-16.648-.068-24.973-.045-8.993.025-13.918 3.744-16.315 12.319-4.12 14.73-8.219 29.464-12.307 44.202-.383 1.38-.63 2.8-1.042 4.669 2.965 0 5.491-.308 7.912.067 4.44.689 6.362-.935 7.487-5.36 3.193-12.562 6.862-25.006 10.526-37.442.498-1.689 1.974-4.327 3.112-4.389 7.383-.398 14.798-.204 22.758-.204-1.626 6.06-3.16 11.304-4.41 16.615-.745 3.158-2.467 4.37-5.644 4.285-5.29-.142-10.588-.039-16.091-.039l-3.449 13.811c7.7 0 14.742.541 21.644-.206 4.053-.438 7.885-2.925 12.326-5.024m-131.29 5.384h14.245l3.393-12.972H72.173c.778-8.146 1.81-9.152 8.684-9.111 6.663.04 13.326.1 19.989.145 13.06.087 14.396-1.182 15.212-14.42.49-7.94-3.29-12.287-11.323-12.49a552.988 552.988 0 0 0-25.485-.068c-8.168.17-13.026 4.02-15.247 11.854a586.4 586.4 0 0 0-5.468 20.746c-2.388 9.77 2.42 16.031 12.469 16.243 6.827.144 13.659.055 21.486.073m209.028 0c7.489-.016 14.978-.018 22.466-.052 12.059-.053 18.451-6.197 18.994-18.224.34-7.524-3.557-12.097-11.067-12.457-5.645-.27-11.314-.022-16.97-.09-1.73-.02-3.455-.324-5.12-.491-.283-4.188 1.645-5.184 4.86-5.15 8.654.091 17.309.087 25.961-.032 1.292-.018 3.415-.554 3.712-1.372 1.258-3.471 1.973-7.14 2.967-11.054-13.081 0-25.397-.31-37.69.1-9.56.318-15.335 7.868-14.856 18.25.361 7.828 5.49 11.831 15.325 11.897 5.912.04 11.825.007 17.824.007-.873 5.156-.872 5.225-5.344 5.244-10.435.043-20.87.014-31.442.014l-3.1 13.434c4.542 0 8.516 0 13.48-.024m-10.803-35.494c.67-8.379-3.225-12.944-11.663-13.147-8.322-.2-16.654-.068-24.981-.043-8.187.024-13.214 3.462-15.608 11.28a278.538 278.538 0 0 0-5.595 21.22c-2.139 9.645 2.503 15.642 12.418 15.997 7.983.287 15.993.26 23.978-.008 8.524-.288 13.409-4.34 15.711-12.722 1.981-7.214 3.694-14.501 5.74-22.577M146.82 184.23h5.956l2.963-12.545c-4.164 0-7.783-.011-11.402.002-9.438.033-14.602 3.866-17.093 12.774-4.788 17.121-9.542 34.252-14.305 51.38-.685 2.462-1.344 4.932-2.095 7.695h14.05c2.727-9.901 5.466-19.809 8.178-29.724.733-2.681 1.575-4.876 5.086-5.098 8.425-.534 8.424-.672 10.59-8.898.378-1.435.656-2.895 1.03-4.564l-10.71-.587c.379-8.147 1.463-9.696 7.752-10.435m21.573.8c-7.337.38-11.905 3.734-14.045 11.176-4.319 15.02-8.35 30.12-12.472 45.195-.155.566-.02 1.211-.02 2.245 3.23 0 6.223-.22 9.168.058 3.303.312 4.62-.98 5.395-4.165 1.766-7.265 3.968-14.424 6.034-21.614 2.475-8.615 2.494-8.602 11.644-8.785.802-.016 1.6-.214 2.554-.349l3.124-13.608h-10.77c.638-2.949 1.303-5.35 1.597-7.798.086-.716-.883-1.558-2.21-2.355z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M1 251.473c.564-.287 1.5-.245 1.635.106 2.396 6.226 7.375 10.051 12.455 14.068C10.406 266 5.813 266 1 266v-14.527zM14.526 1c.15.647-.016 1.48-.523 1.912-4.067 3.47-8.198 6.863-12.656 10.184C1 9.07 1 5.141 1 1h13.526zM387.474 266c-.408-.457-.447-1.264-.26-1.32 5.914-1.768 9.606-6.181 13.434-10.772.352 4.022.352 7.951.352 12.092h-13.526zM401 13.523c-.565.294-1.317.281-1.666-.1-3.536-3.871-7.007-7.803-10.415-12.07C392.926 1 396.852 1 401 1v12.523z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FEFDFE",
                d: "M257.771 29.808c10.089-10.922 22.52-15.704 36.777-15.86 16.819-.185 33.642-.097 50.463-.033 24.744.095 44.04 19.453 44.084 44.142.014 7.828.062 15.657-.022 23.484-.076 6.991-2.69 9.58-9.746 9.592-28.313.044-56.627.117-84.939-.052-4.443-.027-6.342.946-6.022 5.789.414 6.263.101 12.574.101 19.448h100.97v38.414c-1.337.083-2.465.215-3.594.215-31.644.01-63.289.143-94.932-.042-22.553-.132-39.215-14.09-43.36-35.904-.492-2.59-.5-5.296-.51-7.948-.064-16.655-.116-33.31-.068-49.965.033-11.498 3.179-21.99 10.798-31.28M327.5 64.13h19.427V51.227h-5.087c-14.294 0-28.59-.155-42.88.046-12.668.18-11.097-2.902-10.889 11.886.004.258.372.51.73.971H327.5z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FDFAFB",
                d: "M223.524 238.497c-4.186 1.832-8.018 4.319-12.071 4.757-6.902.747-13.944.206-21.644.206l3.449-13.81c5.503 0 10.8-.104 16.091.038 3.177.086 4.9-1.127 5.643-4.285 1.252-5.311 2.785-10.556 4.41-16.615-7.96 0-15.374-.194-22.757.204-1.138.062-2.614 2.7-3.112 4.39-3.664 12.435-7.333 24.879-10.526 37.44-1.125 4.426-3.046 6.05-7.487 5.361-2.42-.375-4.947-.067-7.912-.067.413-1.87.659-3.288 1.042-4.669 4.088-14.738 8.188-29.473 12.307-44.202 2.397-8.575 7.322-12.294 16.315-12.319 8.325-.023 16.653-.137 24.973.045 7.176.157 12.061 5.016 10.807 11.955-1.709 9.45-4.599 18.69-7.111 27.985-.328 1.213-1.423 2.218-2.417 3.586z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FCF8F9",
                d: "M91.991 243.613c-7.328-.017-14.16.072-20.987-.072-10.048-.212-14.857-6.473-12.469-16.243a586.4 586.4 0 0 1 5.468-20.746c2.221-7.835 7.079-11.684 15.247-11.854a552.988 552.988 0 0 1 25.485.068c8.033.203 11.813 4.55 11.323 12.49-.816 13.238-2.152 14.507-15.212 14.42-6.663-.044-13.326-.106-19.99-.145-6.873-.041-7.905.965-8.683 9.111h37.954l-3.393 12.972-14.743-.001m9.847-34.38c-1.18-.531-2.349-1.484-3.545-1.52-5.451-.165-10.913.031-16.366-.108-3.646-.093-5.14 1.491-4.772 5.38 7.13 0 14.223.128 21.301-.128 1.143-.041 2.224-1.786 3.382-3.625z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FCF9FA",
                d: "M301.023 243.626c-4.469.012-8.443.012-12.986.012l3.1-13.434c10.573 0 21.008.03 31.443-.014 4.472-.019 4.471-.088 5.344-5.244-6 0-11.912.033-17.824-.007-9.835-.066-14.964-4.07-15.325-11.897-.479-10.382 5.296-17.932 14.857-18.25 12.292-.41 24.608-.1 37.689-.1-.994 3.914-1.709 7.583-2.967 11.054-.297.818-2.42 1.354-3.712 1.372-8.652.119-17.307.123-25.96.032-3.216-.034-5.144.962-4.861 5.15 1.665.167 3.39.47 5.12.491 5.656.068 11.325-.18 16.97.09 7.51.36 11.406 4.933 11.067 12.457-.543 12.027-6.935 18.17-18.994 18.224-7.488.034-14.977.036-22.961.064z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FDFCFC",
                d: "M290.608 208.53c-1.939 7.666-3.652 14.953-5.633 22.167-2.302 8.381-7.187 12.434-15.71 12.722-7.986.269-15.996.295-23.98.008-9.914-.355-14.556-6.352-12.417-15.998a278.538 278.538 0 0 1 5.595-21.218c2.394-7.819 7.421-11.257 15.608-11.281 8.327-.025 16.659-.158 24.981.043 8.438.203 12.334 4.768 11.556 13.557m-38.49.932-5.726 19.487c8.089 0 15.027.087 21.959-.09 1.108-.027 2.87-1.013 3.166-1.931 1.892-5.857 3.457-11.82 5.186-17.945-8.726 0-16.318 0-24.585.479z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FCFAFA",
                d: "M146.387 184.231c-5.856.738-6.94 2.287-7.32 10.434l10.71.587c-.373 1.669-.651 3.13-1.03 4.564-2.165 8.226-2.164 8.364-10.59 8.898-3.51.222-4.352 2.417-5.085 5.098-2.712 9.915-5.451 19.823-8.177 29.724h-14.051c.751-2.763 1.41-5.233 2.095-7.696 4.763-17.127 9.517-34.258 14.305-51.379 2.491-8.908 7.655-12.741 17.093-12.774 3.619-.013 7.238-.002 11.402-.002l-2.963 12.545-6.39.001z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FCF9FA",
                d: "M168.813 185.036c.906.791 1.875 1.633 1.789 2.35-.294 2.446-.959 4.848-1.596 7.797h10.77l-3.125 13.608c-.954.135-1.752.333-2.554.349-9.15.183-9.169.17-11.644 8.785-2.066 7.19-4.268 14.35-6.034 21.614-.774 3.185-2.092 4.477-5.395 4.165-2.945-.278-5.938-.058-9.168-.058 0-1.034-.135-1.679.02-2.245 4.122-15.075 8.153-30.176 12.472-45.195 2.14-7.442 6.708-10.796 14.465-11.17z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#90183D",
                d: "M327 64.13h-38.2c-.357-.46-.725-.713-.729-.97-.208-14.79-1.779-11.708 10.89-11.887 14.29-.201 28.585-.046 42.879-.046h5.087V64.13H327z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#8F163B",
                d: "M101.814 209.673c-1.134 1.398-2.215 3.143-3.358 3.184-7.078.256-14.17.129-21.301.129-.368-3.89 1.126-5.474 4.772-5.381 5.453.14 10.915-.057 16.366.108 1.196.036 2.364.989 3.52 1.96z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#90183D",
                d: "M252.455 209.222c7.93-.239 15.522-.239 24.248-.239-1.729 6.125-3.294 12.088-5.186 17.945-.296.918-2.058 1.904-3.166 1.932-6.932.176-13.87.089-21.96.089 2.054-6.99 3.89-13.238 6.064-19.727z"
            })
        ]
    });
var $ee58c55afed5409e$export$2e2bcd8739ae039 = $ee58c55afed5409e$var$SvgEft;

});

parcelRegister("fszW0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0ae298b55678d09$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $a0ae298b55678d09$var$SvgJcb = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F3F3F3",
                d: "M1 250c0-79.021 0-158.043.28-237.24 3.422-3.355 6.596-6.501 9.658-9.753.344-.365.057-1.324.062-2.007 124.688 0 249.376 0 374.236.312 6.103 4.268 12.035 8.218 14.316 15.579.052.17.946.078 1.448.109 0 77.355 0 154.71-.306 232.237-3.826 4.552-7.298 8.972-10.895 13.287-1.09 1.307-2.523 2.326-3.799 3.476-123.021 0-246.043 0-369.238-.3-6.34-4.065-11.944-8.34-14.313-15.628-.053-.164-.947-.054-1.449-.072m101.863-82.234-26.294-3.272v68.329c16.778 0 33.239.098 49.696-.103 2.55-.032 5.23-1.13 7.602-2.259 13.153-6.26 19.09-17.136 19.112-31.342.082-52.825.038-105.65.027-158.477 0-1.455-.167-2.911-.291-4.955h-5.605c-12.332 0-24.69.513-36.989-.118-18.938-.972-33.681 13.88-33.813 32.944-.18 25.995-.1 51.993.059 77.988.01 1.546 1.416 4.09 2.674 4.46 7.913 2.32 15.878 5.173 24 5.902 10.606.953 16.749-5.755 16.863-16.45.1-9.497.026-18.996.028-28.495v-8.667h26.465c0 13.439.292 26.436-.087 39.414-.34 11.633-6.042 19.353-17.358 22.139-8.138 2.004-16.755 2.063-26.09 2.962M240 69.5V36.014c-17.175 0-33.838-.72-50.405.235-12.527.721-24.37 12.46-25.276 25.403-1.13 16.158-.271 32.455-.271 48.53 4.092-1.95 8.219-4.58 12.728-5.951 17.23-5.242 34.574-3.856 51.832.124 1.028.237 2.5 1.527 2.57 2.422.293 3.68.123 7.396.123 10.282-8.903-1.957-17.035-4.515-25.345-5.401-14.55-1.553-24.504 7.466-24.95 21.477-.475 14.955 8.088 24.348 23.057 23.758 7.32-.288 14.562-2.836 21.812-4.482 1.668-.379 3.223-1.255 5.484-2.166 0 2.854-.278 4.883.053 6.807.946 5.498-1.423 7.34-6.755 8.283-21.026 3.719-41.624 4.924-61-7.255v74.995c12.65 0 24.96.041 37.27-.022 4.49-.023 9.085.274 13.446-.556 15.417-2.934 25.583-16.15 25.606-32.998.058-43 .02-86 .02-129.999m84.41 93V35.966c-2.254-.108-3.88-.25-5.506-.253-12.827-.018-25.655-.04-38.483-.001-18.511.055-32.102 13.43-32.417 32.064-.177 10.492-.06 20.99-.033 31.485.003 1.091.288 2.182.48 3.543 14.27 0 28.244-.13 42.214.08 4.097.061 8.372.51 12.225 1.801 5.894 1.975 9.035 6.567 9.214 12.934.178 6.29-2.62 10.848-8.123 13.8-1.174.63-2.361 1.237-3.887 2.034 2.929 1.095 5.383 1.729 7.567 2.877 9.828 5.165 11.441 18.435 2.495 24.881-3.784 2.727-9.096 4.21-13.837 4.55-9.613.691-19.31.22-28.973.226-6.284.003-12.568 0-19.078 0v67.085c14.274 0 28.233.008 42.192-.002 20.624-.014 33.69-12.89 33.917-33.586.131-11.993.03-23.99.033-36.984m-46.167-6.669c1.804-.165 3.68-.068 5.397-.546 4.34-1.209 6.005-4.562 5.838-8.73-.17-4.253-2.367-7.65-6.745-7.978-6.373-.477-12.807-.123-19.24-.123v17.377h14.75m7.705-30.423c2.744-6.43 1.01-11.921-4.657-12.585-5.857-.686-11.857-.153-17.85-.153v15.962c4.849 0 9.347.313 13.775-.114 2.806-.27 5.506-1.644 8.732-3.11z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M401 16.529c-.502.44-1.396.531-1.448.362-2.28-7.361-8.213-11.31-13.848-15.579C390.927 1 395.854 1 401 1v15.529zM386.473 266c.803-1.15 2.237-2.17 3.326-3.476 3.597-4.315 7.07-8.735 10.895-12.82.306 5.551.306 10.807.306 16.296h-14.527zM1 250.471c.502-.453 1.396-.563 1.45-.4 2.368 7.29 7.973 11.564 13.844 15.63C11.073 266 6.145 266 1 266v-15.529zM10.513 1c.482.683.769 1.642.425 2.007-3.062 3.252-6.236 6.398-9.657 9.285C1 8.418 1 4.836 1 1h9.513z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#285998",
                d: "M103.328 167.78c8.87-.913 17.486-.972 25.624-2.976 11.316-2.786 17.018-10.506 17.358-22.139.379-12.978.087-25.975.087-39.414h-26.465v8.667c-.002 9.499.073 18.998-.028 28.496-.114 10.694-6.257 17.402-16.862 16.45-8.123-.73-16.088-3.582-24.001-5.903-1.258-.37-2.665-2.914-2.674-4.46-.16-25.995-.238-51.993-.059-77.988.132-19.064 14.875-33.916 33.813-32.944 12.3.63 24.657.118 36.989.118h5.605c.124 2.044.29 3.5.291 4.955.011 52.826.055 105.652-.027 158.477-.022 14.206-5.96 25.083-19.112 31.342-2.371 1.129-5.052 2.227-7.602 2.259-16.457.201-32.918.103-49.696.103v-68.329c8.868 1.104 17.58 2.188 26.76 3.286z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#CA483A",
                d: "M240 70c0 43.5.037 86.5-.021 129.499-.023 16.848-10.189 30.064-25.606 32.998-4.36.83-8.957.533-13.446.556-12.31.063-24.62.022-37.27.022V158.08c19.376 12.179 39.974 10.974 61 7.255 5.332-.943 7.701-2.785 6.755-8.283-.33-1.924-.053-3.953-.053-6.807-2.261.911-3.816 1.787-5.484 2.166-7.25 1.646-14.491 4.194-21.812 4.482-14.969.59-23.532-8.803-23.056-23.758.445-14.011 10.399-23.03 24.95-21.477 8.31.886 16.441 3.444 25.344 5.4 0-2.885.17-6.601-.122-10.28-.071-.896-1.543-2.186-2.571-2.423-17.258-3.98-34.601-5.366-51.832-.124-4.509 1.371-8.636 4-12.728 5.952 0-16.076-.858-32.373.271-48.53.905-12.944 12.749-24.683 25.276-25.404 16.567-.955 33.23-.235 50.405-.235V70z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#489952",
                d: "M324.41 163c-.004 12.495.097 24.49-.034 36.484-.226 20.697-13.293 33.572-33.917 33.586-13.96.01-27.918.002-42.192.002v-67.085c6.51 0 12.794.003 19.078 0 9.663-.005 19.36.465 28.973-.226 4.74-.34 10.053-1.823 13.837-4.55 8.946-6.446 7.333-19.716-2.495-24.881-2.184-1.148-4.638-1.782-7.567-2.877 1.526-.797 2.713-1.404 3.887-2.034 5.503-2.952 8.3-7.51 8.123-13.8-.18-6.367-3.32-10.959-9.214-12.934-3.853-1.29-8.128-1.74-12.225-1.801-13.97-.21-27.945-.08-42.213-.08-.193-1.361-.478-2.452-.48-3.543-.027-10.495-.145-20.993.032-31.485.315-18.634 13.906-32.009 32.417-32.064 12.828-.039 25.656-.017 38.483.001 1.626.003 3.252.145 5.506.253V163z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#4F9D59",
                d: "M277.773 155.831h-14.281v-17.377c6.433 0 12.867-.354 19.24.123 4.378.327 6.574 3.725 6.745 7.977.167 4.169-1.497 7.522-5.838 8.731-1.716.478-3.593.381-5.866.546z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#519E5A",
                d: "M285.708 125.702c-2.987 1.172-5.687 2.545-8.493 2.816-4.428.427-8.926.114-13.776.114V112.67c5.994 0 11.994-.533 17.85.153 5.667.664 7.402 6.154 4.42 12.879z"
            })
        ]
    });
var $a0ae298b55678d09$export$2e2bcd8739ae039 = $a0ae298b55678d09$var$SvgJcb;

});

parcelRegister("4icpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468c468bff04ca51$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $468c468bff04ca51$var$SvgMastercard = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#311E02",
                d: "M1 244c0-73.354 0-146.708.315-220.653 5.2-9.429 11.427-16.91 20.947-21.099.36-.158.497-.82.738-1.248 118.354 0 236.708 0 355.653.315 9.316 5.312 17.103 11.234 21.1 20.945.147.358.82.498 1.247.74 0 73.354 0 146.708-.315 220.653-5.2 9.43-11.429 16.908-20.948 21.098-.36.159-.496.821-.737 1.249-118.354 0-236.708 0-355.653-.315-9.314-5.313-17.104-11.233-21.1-20.945-.147-.358-.82-.498-1.247-.74m200.688-32.117c.712-.043 1.425-.086 2.646.363 33.314 24.616 75.422 27.214 109.848 6.778 34.042-20.208 52.355-59.16 46.699-99.327-7.648-54.308-58.115-92.762-112.64-85.493-17.629 2.35-33.677 8.905-47.91 20.911-.682.064-1.363.128-2.577-.298-.533-.4-1.06-.808-1.6-1.198-32.945-23.854-76.092-25.781-109.553-4.896-34.674 21.643-52.136 61.369-44.822 101.97 9.567 53.117 58.537 89.186 111.935 82.105 17.646-2.34 33.693-8.909 47.974-20.915z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M22.531 1c.228.428.09 1.09-.269 1.248-9.52 4.188-15.746 11.67-20.947 20.63C1 15.74 1 8.481 1 1h21.531zM379.469 266c-.228-.428-.091-1.09.268-1.249 9.52-4.19 15.749-11.668 20.948-20.63C401 251.26 401 258.52 401 266h-21.531zM401 22.531c-.428.227-1.1.087-1.247-.27-3.997-9.712-11.784-15.634-20.631-20.946C386.26 1 393.519 1 401 1v21.531zM1 244.469c.428-.227 1.1-.087 1.247.27 3.996 9.713 11.786 15.633 20.631 20.946C15.74 266 8.481 266 1 266v-21.531z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F69E1B",
                d: "M201.01 55.013c13.554-11.904 29.602-18.458 47.23-20.809 54.526-7.269 104.993 31.185 112.64 85.493 5.657 40.166-12.656 79.119-46.698 99.327-34.426 20.436-76.534 17.838-109.887-7.274 2.323-2.841 4.696-5.175 7.046-7.531 19.374-19.43 28.698-43.263 28.343-70.298-.422-32.072-13.762-58.496-38.674-78.908z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#EA001B",
                d: "M200.977 211.993c-13.57 11.896-29.617 18.465-47.263 20.805-53.398 7.08-102.368-28.988-111.935-82.104-7.314-40.602 10.148-80.328 44.822-101.97 33.46-20.886 76.608-18.959 109.554 4.895.54.39 1.066.798 1.657 1.703-4.569 5.285-9.639 9.713-13.754 14.898-34.76 43.8-27.202 106.506 16.92 141.773z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FF5F00",
                d: "M201.333 211.938c-44.477-35.212-52.035-97.919-17.275-141.718 4.115-5.185 9.185-9.613 14.02-14.653.89-.324 1.571-.388 2.592-.503 25.252 20.361 38.592 46.785 39.014 78.857.355 27.035-8.969 50.869-28.343 70.298-2.35 2.356-4.723 4.69-7.3 7.284-.928.294-1.64.337-2.708.435z"
            })
        ]
    });
var $468c468bff04ca51$export$2e2bcd8739ae039 = $468c468bff04ca51$var$SvgMastercard;

});

parcelRegister("4J9cM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ca3b56c0bbc4d5d$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $7ca3b56c0bbc4d5d$var$SvgUnionPay = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#046862",
                d: "M371 1c2.042 0 4.083 0 6.475.382.608.973.73 1.954 1.145 2.097 9.67 3.361 16.162 9.917 19.958 19.35.248.615 1.59.79 2.422 1.171 0 72.688 0 145.375-.36 218.458-.97 1.129-1.807 1.768-2.157 2.61-3.418 8.235-9.266 14.099-17.16 18.102-1.261.64-2.223 1.872-3.323 2.83-.75 0-1.5 0-2.822-.347-2.43-.77-4.29-1.56-6.15-1.562-48.637-.072-97.275-.061-145.934-.469.585-2.442 1.344-4.449 1.773-6.524 3.609-17.467 7.156-34.946 10.723-52.42 1.35-6.618 2.765-13.223 4.04-19.855 1.896-9.86 3.694-19.74 5.844-29.799 1.023-1.14 2.054-1.992 2.387-3.063.982-3.148 2.253-6.36 2.382-9.587.28-6.99 4.169-7.584 10.044-7.71 11.126-.24 21-3.913 25.371-15.38 4.673-12.26 1.647-19.913-12.35-20.644-4.787-.25-9.586-.283-14.366-.84 1.887-9.64 3.712-18.863 5.644-28.064a8700.498 8700.498 0 0 1 10-47c1.427-6.607 3.02-13.178 4.997-19.774 28.947-.01 57.432.027 85.917-.093 1.836-.008 3.667-1.218 5.5-1.869m-58.242 173.2-3.388 6.417c9.94 2.628 15.664-1 19.56-8.914 2.545-5.172 5.794-9.998 8.724-14.981 6.677-11.36 13.351-22.72 20.085-34.18-11.439-2.545-15.922 4.57-20.083 12.93l-1.49-13.817-13.26 1.981c.757 5.295 1.2 10.384 2.254 15.344 2.19 10.31 1.818 19.995-5.568 28.363-2.008 2.276-4.05 4.522-6.834 6.857m-34.586-29.734c.387 7.285 4.058 11.05 11.18 11.084 6.059.028 12.135-.053 18.167-.537 1.357-.108 3.322-1.875 3.71-3.245 1.706-6.03 2.987-12.184 4.323-18.315.787-3.609 1.389-7.258 2.108-11.07-7.235-.03-13.69 3.706-20.184-.14-.882-.523-2.586.165-3.854.503-8.486 2.26-14.124 9.913-15.45 21.72z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#DD2524",
                d: "M26 266c-.444 0-.889 0-1.432-.331-.565-.77-.956-1.374-1.507-1.622-10.755-4.847-19.223-11.564-20.37-24.44-.022-.251-1.104-.407-1.691-.607 0-70.02 0-140.042.358-210.57.653-.61 1.194-.688 1.207-.82.993-9.696 6.437-16.29 14.466-21.23C19.516 4.85 21.686 2.807 24 1c.444 0 .889 0 1.875.32 1.843.737 3.15 1.532 4.446 1.515 13.796-.178 27.589-.664 41.384-.713 21.138-.074 42.277.128 63.43.607-2.575 12.89-5.117 25.396-7.762 37.88-5.747 27.118-11.546 54.225-17.698 81.47-5.294.461-8.636 2.227-7.795 8.03.11.755-.402 1.592-.587 2.4-1.648 7.212-3.287 14.425-4.993 21.922 2.238.258 4.177.48 6.07 1.125a36392.833 36392.833 0 0 1-14.179 67.508c-2.871 13.623-5.748 27.245-8.765 41.004-.256.376-.376.611-.966.844-16.62-.269-32.778-.578-48.937-.723-1.169-.01-2.348 1.18-3.523 1.811m71.008-147.341 5.068-19.615H88.134c-2.06 9.561-3.74 19.047-6.238 28.312-1.427 5.29-3.327 10.924-6.687 15.037-1.845 2.26-7.193 2.24-10.888 2.02-.996-.06-2.628-4.701-2.397-7.088.599-6.21 1.882-12.378 3.244-18.484 1.46-6.542 3.323-12.995 5.16-20.062-5.113 0-9.612-.351-13.994.207-1.378.176-2.616 2.693-3.585 4.336-.524.887-.26 2.208-.497 3.301-2.394 11.019-4.913 22.012-7.199 33.053-1.303 6.297.34 10.967 6.508 12.694 6.482 1.816 13.655 2.044 20.447 1.64 7.84-.465 14.612-4.441 17.68-11.93 2.988-7.293 4.644-15.131 7.32-23.421z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#36807A",
                d: "M223.115 264.026c48.638.004 97.276-.007 145.913.065 1.86.002 3.72.792 5.775 1.562-50.157.347-100.511.347-151.364.049-.521-.497-.545-.695-.511-1.09.057-.196.187-.586.187-.586z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M401 23.531c-.833.089-2.174-.087-2.422-.702-3.796-9.433-10.288-15.989-19.958-19.35-.414-.143-.537-1.124-.708-2.097C385.593 1 393.186 1 401 1v22.531zM23.531 1c-1.845 1.808-4.015 3.85-6.5 5.38C9 11.32 3.558 17.913 2.565 27.61c-.013.132-.554.21-1.207.35C1 19.08 1 10.16 1 1h22.531zM1 239.469c.587-.269 1.669-.113 1.69.137 1.148 12.877 9.616 19.594 20.371 24.441.551.248.942.852 1.173 1.622C16.401 266 8.802 266 1 266v-26.531zM378.469 266c.631-.958 1.593-2.19 2.855-2.83 7.893-4.003 13.741-9.867 17.16-18.101.349-.843 1.186-1.482 2.157-2.142.359 7.666.359 15.259.359 23.073h-22.531z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#36807A",
                d: "M370.531 1c-1.364.65-3.195 1.861-5.03 1.869-28.486.12-56.971.084-85.99-.128-.534-.213-.668-.658-.438-.796A8.63 8.63 0 0 0 280 1h90.531z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#4F5E7E",
                d: "M222.87 264.809c.024.198.048.396.1.893-47.658.298-95.345.298-143.487.023-.49-.454-.524-.634-.56-.814.127-.232.247-.467.931-.7 2.037.233 3.502.662 4.967.662 46.017.005 92.033-.033 138.05-.064z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#4F5F7E",
                d: "M279.531 1c.236.269.004.537-.91.951-47.98.131-95.279.117-142.621-.16-.03-.438-.015-.615 0-.791h143.531z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#E35756",
                d: "M135.531 1c.454.176.44.353.233.845-.192.315-.643.49-.643.49-21.139-.085-42.278-.287-63.416-.213-13.795.049-27.588.535-41.384.713-1.296.017-2.603-.778-4.113-1.516C62.354 1 98.708 1 135.531 1zM78.46 264.912c.499.179.534.359.554.813C61.646 266 44.292 266 26.47 266c.706-.632 1.885-1.822 3.054-1.811 16.16.145 32.317.454 48.937.723z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#17325F",
                d: "M135.135 2.73c-.014-.395.437-.57.673-.623 47.534-.04 94.833-.025 142.583-.017.452-.007.586.438.659.66-1.445 6.808-3.037 13.38-4.463 19.987a8700.498 8700.498 0 0 0-10 46.999c-1.933 9.2-3.758 18.424-6.069 28.223-2.757.626-5.119.966-7.385.64-3.884-.558-5.197 1.421-5.972 4.753-2.801 12.045-5.774 24.05-8.642 36.08-1.168 4.897-2.234 9.818-3.426 15.078l12.07.701c-1.839 9.872-3.637 19.751-5.532 29.612-1.276 6.632-2.69 13.237-4.041 19.854-3.567 17.475-7.114 34.954-10.723 52.42-.429 2.076-1.188 4.083-1.773 6.525.021.404-.109.794-.166.99-46.074.228-92.09.266-138.107.261-1.465 0-2.93-.429-4.824-.8 2.446-13.764 5.323-27.386 8.194-41.01 4.713-22.361 9.422-44.724 14.55-67.635 5.54.042 7.854-2.094 8.279-7.384.368-4.582 1.536-9.176 2.995-13.55.484-1.449 2.972-2.23 4.544-3.317.43 1.539 1.433 3.175 1.19 4.6-1.054 6.213-2.47 12.366-3.823 18.871 4.09 0 7.385.133 10.656-.086.906-.06 2.343-1.03 2.518-1.812 1.768-7.874 3.685-15.745 4.808-23.723.706-5.014-2.092-7.915-7.036-7.029-5.726 1.027-11.222.423-16.823-.052 5.778-27.112 11.577-54.219 17.324-81.337 2.645-12.484 5.187-24.99 7.762-37.88m18.693 126.42-2.155-1.484c1.303-1.241 3.067-2.165 3.44-3.482.414-1.461-.413-4.719-.75-4.725-3.482-.072-7.214-.306-10.393.842-2.856 1.032-4.722 3.69-1.423 6.924.55.54-.136 2.343-.943 3.456-.86 2.343-1.92 4.634-2.537 7.04-1.418 5.521-2.62 11.098-3.984 16.977 3.85 0 7.335.253 10.75-.132 1.25-.14 3.075-1.61 3.364-2.786 1.768-7.209 3.17-14.508 4.63-22.63m3.908 20.252c2.986 6.342 12.544 6.866 19.693 5.035 9.819-2.516 13.358-10.06 14.795-19.32.85-5.467-1.042-10.022-5.971-12.17-6.995-3.047-18.147-.935-23.01 4.918-2.459 2.96-3.968 6.708-6.703 10.311-2.487 3.934-2.23 8.253 1.196 11.226m48.477 2.58c1.254-5.486 2.72-10.936 3.685-16.473.64-3.667 2.472-4.633 6.92-3.784l-4.14 22.947c3.519 0 6.693.317 9.747-.15 1.291-.197 3.022-1.86 3.37-3.17 1.736-6.56 3.093-13.222 4.557-19.854 1.444-6.541-1.353-10.027-8.025-9.616-2.917.18-6.634 2.477-8.526 1.353-5.307-3.154-9.66.526-14.217.045-1.23 5.702-2.29 10.832-3.452 15.94-1.14 5.012-2.384 10.001-3.692 15.462 3.712 0 6.518.21 9.27-.084 1.496-.16 2.901-1.174 4.503-2.615z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F6F8F8",
                d: "M245.474 155.024c-4.067-.031-7.824-.25-12.38-.514 1.19-5.26 2.257-10.181 3.425-15.078 2.868-12.03 5.84-24.035 8.642-36.08.775-3.332 2.088-5.311 5.972-4.753 2.266.326 4.628-.014 7.371-.215 5.218-.027 10.017.006 14.804.256 13.997.731 17.023 8.383 12.35 20.644-4.371 11.467-14.245 15.14-25.371 15.38-5.875.126-9.765.72-10.044 7.71-.129 3.228-1.4 6.44-2.382 9.587-.333 1.07-1.364 1.924-2.387 3.063m9.521-33.245c-.99 3.057.183 4.64 3.304 4.07 2.875-.526 5.819-1.257 8.43-2.522 4.383-2.123 5.905-6.358 5.294-10.773-.702-5.064-5.052-5.428-9.21-5.43h-4.287c-.6 2.606-1.083 4.849-1.64 7.073-.562 2.248-1.197 4.478-1.89 7.582z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F4F8F8",
                d: "M313.137 174.162c2.405-2.297 4.447-4.543 6.455-6.819 7.386-8.368 7.758-18.052 5.568-28.363-1.054-4.96-1.497-10.05-2.255-15.344l13.261-1.981 1.49 13.817c4.16-8.36 8.644-15.475 20.083-12.93-6.734 11.46-13.408 22.82-20.085 34.18-2.93 4.983-6.18 9.809-8.725 14.981-3.895 7.914-9.62 11.542-19.56 8.914 1.153-2.183 2.271-4.3 3.768-6.455z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F4F7F7",
                d: "M278.173 144.043c1.325-11.384 6.963-19.037 15.45-21.297 1.267-.338 2.971-1.026 3.853-.504 6.494 3.847 12.95.11 20.184.141-.72 3.812-1.321 7.461-2.108 11.07-1.336 6.131-2.617 12.285-4.324 18.315-.387 1.37-2.352 3.137-3.71 3.245-6.031.484-12.107.565-18.166.537-7.122-.033-10.793-3.8-11.179-11.507m15.325 4.027c5.34-.772 8.272-5.28 8.011-13.136-.053-1.593-1.649-3.135-2.534-4.701-1.682 1.011-4.033 1.634-4.895 3.121-1.442 2.489-2.336 5.479-2.688 8.352-.242 1.98.822 4.119 2.106 6.364z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#FDF6F5",
                d: "M96.79 119.005c-2.458 7.944-4.114 15.782-7.102 23.074-3.068 7.49-9.84 11.466-17.68 11.932-6.792.403-13.965.175-20.447-1.64-6.167-1.728-7.811-6.398-6.508-12.695 2.286-11.041 4.805-22.034 7.199-33.053.237-1.093-.027-2.414.497-3.301.97-1.643 2.207-4.16 3.585-4.336 4.382-.558 8.88-.207 13.994-.207-1.837 7.067-3.7 13.52-5.16 20.062-1.362 6.106-2.645 12.274-3.244 18.484-.23 2.387 1.4 7.028 2.397 7.088 3.695.22 9.043.24 10.888-2.02 3.36-4.113 5.26-9.746 6.687-15.037 2.498-9.265 4.179-18.75 6.238-28.312h13.942c-1.731 6.7-3.4 13.157-5.285 19.96z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F6F4F5",
                d: "M109.675 122.079c5.975.342 11.47.946 17.197-.08 4.944-.887 7.742 2.014 7.036 7.028-1.123 7.978-3.04 15.849-4.808 23.723-.175.782-1.612 1.751-2.518 1.812-3.271.219-6.566.086-10.656.086 1.353-6.505 2.77-12.658 3.824-18.872.242-1.424-.761-3.06-1.191-4.599-1.572 1.087-4.06 1.868-4.544 3.318-1.459 4.373-2.627 8.967-2.995 13.549-.425 5.29-2.739 7.426-8.232 6.963-2.311-.095-4.25-.318-6.488-.576 1.706-7.497 3.345-14.71 4.993-21.921.185-.809.696-1.646.587-2.402-.841-5.802 2.5-7.568 7.795-8.03z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F3F4F6",
                d: "M206.134 152.388c-1.524 1.035-2.929 2.05-4.425 2.209-2.752.294-5.558.084-9.27.084 1.308-5.46 2.552-10.45 3.692-15.462 1.162-5.108 2.222-10.238 3.452-15.94 4.557.481 8.91-3.199 14.217-.045 1.892 1.124 5.609-1.173 8.526-1.353 6.672-.411 9.469 3.075 8.025 9.616-1.464 6.632-2.821 13.293-4.558 19.854-.347 1.31-2.078 2.973-3.37 3.17-3.053.467-6.227.15-9.746.15l4.14-22.947c-4.448-.849-6.28.117-6.92 3.784-.965 5.537-2.431 10.987-3.763 16.88z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F6F7F8",
                d: "M157.335 137.964c1.939-3.392 3.448-7.14 5.907-10.1 4.863-5.853 16.015-7.965 23.01-4.917 4.929 2.147 6.82 6.702 5.971 12.17-1.437 9.259-4.976 16.803-14.795 19.319-7.15 1.831-16.707 1.307-19.982-5.686-.23-4.03-.17-7.408-.11-10.786m12.659 4.085c.267.583.605 1.145.785 1.754.384 1.302.685 2.628 1.02 3.944 1.474-.825 3.766-1.314 4.27-2.538 1.61-3.916 2.748-8.063 3.626-12.214.225-1.067-1.047-3.402-1.869-3.521-1.304-.19-3.565.618-4.086 1.668-1.588 3.199-2.537 6.715-3.746 10.907z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#EFF0F3",
                d: "M153.892 130.002c-1.525 7.27-2.927 14.568-4.695 21.777-.289 1.176-2.115 2.645-3.365 2.786-3.414.385-6.9.132-10.75.132 1.365-5.879 2.567-11.456 3.985-16.978.617-2.405 1.678-4.696 3.345-6.93 4.365-.19 7.922-.488 11.48-.787z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#EBEDF1",
                d: "M153.86 129.576c-3.526.725-7.083 1.023-11.102 1.265-.347-1.274.34-3.077-.211-3.617-3.299-3.235-1.433-5.892 1.423-6.924 3.18-1.148 6.91-.914 10.392-.842.338.006 1.165 3.264.75 4.725-.372 1.317-2.136 2.24-3.439 3.482.864.595 1.51 1.04 2.187 1.91z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#092457",
                d: "M156.937 138.07c.339 3.272.279 6.65.234 10.49-2.862-2.132-3.12-6.45-.234-10.49z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#106E68",
                d: "M255.04 121.346c.65-2.671 1.284-4.9 1.847-7.149.556-2.224 1.039-4.467 1.64-7.073h4.286c4.158.002 8.508.366 9.21 5.43.61 4.415-.911 8.65-5.294 10.773-2.611 1.265-5.555 1.996-8.43 2.522-3.121.57-4.293-1.013-3.258-4.503z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#17716B",
                d: "M293.096 147.981c-.882-2.156-1.946-4.295-1.704-6.275.352-2.873 1.246-5.863 2.688-8.352.862-1.487 3.213-2.11 4.895-3.121.885 1.566 2.481 3.108 2.534 4.701.261 7.856-2.67 12.364-8.413 13.047z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#29426C",
                d: "M170 141.65c1.204-3.793 2.153-7.309 3.741-10.508.52-1.05 2.782-1.858 4.086-1.668.822.12 2.094 2.454 1.869 3.521-.878 4.151-2.017 8.298-3.627 12.214-.503 1.224-2.795 1.713-4.269 2.538-.335-1.316-.636-2.642-1.02-3.944-.18-.61-.518-1.171-.78-2.154z"
            })
        ]
    });
var $7ca3b56c0bbc4d5d$export$2e2bcd8739ae039 = $7ca3b56c0bbc4d5d$var$SvgUnionPay;

});

parcelRegister("4nAvm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab267640b66b9ddc$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $ab267640b66b9ddc$var$SvgVisa = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#0C1727",
                d: "M1 244c0-73.354 0-146.708.32-220.641C6.498 13.898 12.726 6.407 22.307 2.272c.35-.15.468-.836.694-1.272 118.354 0 236.708 0 355.641.32 6.672 4.493 13.563 7.679 17.524 14.446 1.463 2.499 3.215 4.828 4.835 7.234 0 73.354 0 146.708-.32 220.641-5.176 9.462-11.404 16.953-20.986 21.087-.349.151-.468.836-.694 1.272-118.354 0-236.708 0-355.641-.32-6.67-4.493-13.564-7.675-17.519-14.45-1.46-2.5-3.218-4.825-4.84-7.23m361.564-84.103c-5.376-23.508-10.846-46.996-16.034-70.545-.87-3.95-2.222-5.724-6.512-5.38-4.962.397-9.984.227-14.972.061-7.771-.259-12.763 3.16-15.882 10.333-12.136 27.912-24.508 55.721-36.765 83.58-.615 1.398-.97 2.91-1.65 4.994 5.373 0 9.914-.484 14.314.099 9.605 1.271 16.498-.901 18.032-11.787.4-2.84 2.494-3.415 5.16-3.358 6.821.145 13.648.046 20.473.046 10.094 0 10.035.015 12.53 9.628.417 1.603 1.55 4.263 2.448 4.303 7.689.344 15.4.197 23.78.197-1.715-7.784-3.212-14.574-4.922-22.171m-161.29 21.4c10.89 3.144 22.03 3.6 33.191 2.494 9.559-.948 18.51-3.87 26.331-9.839 12.15-9.272 18.164-31.935-.5-44.25-3.877-2.557-8.067-4.638-12.117-6.932-3.471-1.967-7.175-3.614-10.372-5.954-5.287-3.867-4.915-8.976 1.12-11.565 3.842-1.647 8.394-2.675 12.52-2.394 6.81.466 13.533 2.215 20.512 3.463.856-4.466 1.657-9.561 2.846-14.564.954-4.014-.62-5.757-4.381-6.673-12.706-3.093-25.518-3.739-38 .18-6.2 1.946-12.455 5.091-17.468 9.184-13.477 11.003-12.842 28.94 1.051 39.368 4.616 3.464 10.007 5.9 15.053 8.788 2.886 1.651 6.003 2.983 8.644 4.957 5.262 3.931 4.702 10.3-1.171 13.33-2.305 1.189-5 1.953-7.586 2.203-8.903.863-17.624-.026-25.936-3.648-1.927-.84-3.922-1.525-6.466-2.504-.998 5.792-1.5 11.1-2.902 16.16-1.344 4.846-.1 7.34 5.631 8.196m-76.139-90.675-23.384 59.805c-6.572-22.687-21.825-36.612-39.467-49.8 0 1.87-.187 2.714.027 3.44 7.341 24.897 14.753 49.773 22.05 74.683.809 2.761 2.31 3.613 5.038 3.556 6.493-.137 13.004-.297 19.48.052 4.177.225 6.145-1.358 7.75-5.139 12.427-29.255 25.075-58.415 37.637-87.612.697-1.619 1.237-3.304 2.189-5.874-7.952 0-15.082.344-22.16-.116-5.065-.329-7.886 1.387-9.16 7.005m30.73 62.657-4.996 28.988c7.34 0 13.837-.418 20.253.128 5.472.466 7.018-1.81 7.824-6.765 3.77-23.17 7.91-46.28 11.883-69.416 1.23-7.165 2.348-14.35 3.673-22.478-7.924 0-15.033.168-22.128-.07-3.624-.12-4.87 1.33-5.438 4.751-3.542 21.353-7.278 42.673-11.071 64.862M77.12 83.066h-42.37l-.481 1.852c26.525 6.879 48.39 19.989 61.574 44.967.166-1.522.182-2.957-.105-4.328a6203.654 6203.654 0 0 0-6.846-32.19c-1.55-7.214-3.447-8.98-11.772-10.3z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M22.531 1c.243.436.124 1.121-.225 1.272C12.726 6.407 6.496 13.898 1.32 22.89 1 15.74 1 8.48 1 1h21.531zM379.469 266c-.243-.436-.124-1.121.225-1.272 9.582-4.134 15.81-11.625 20.985-20.618.321 7.15.321 14.41.321 21.89h-21.531zM401 22.531c-1.62-1.937-3.372-4.266-4.835-6.765C392.204 9 385.313 5.813 379.11 1.321 386.26 1 393.52 1 401 1v21.531zM1 244.469c1.622 1.936 3.38 4.262 4.84 6.761 3.955 6.775 10.848 9.957 17.05 14.45C15.74 266 8.48 266 1 266v-21.531z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3361AA",
                d: "M362.671 160.3c1.603 7.194 3.1 13.984 4.815 21.768-8.38 0-16.091.147-23.78-.197-.897-.04-2.03-2.7-2.447-4.303-2.496-9.613-2.437-9.629-12.531-9.628-6.825 0-13.652.1-20.474-.046-2.665-.057-4.76.517-5.16 3.358-1.533 10.886-8.426 13.058-18.031 11.787-4.4-.583-8.94-.1-14.315-.1.68-2.083 1.036-3.595 1.651-4.992 12.257-27.86 24.629-55.669 36.765-83.58 3.12-7.174 8.11-10.593 15.882-10.334 4.988.166 10.01.336 14.972-.062 4.29-.343 5.642 1.432 6.512 5.38 5.188 23.55 10.658 47.038 16.141 70.95m-28.74-13.822-7.081-33.502-1.329.12-13.578 35.225c7.925-.365 14.826-.684 21.987-1.843z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3361A9",
                d: "M200.88 181.194c-5.337-.753-6.581-3.247-5.237-8.093 1.402-5.06 1.904-10.368 2.902-16.16 2.544.98 4.539 1.664 6.466 2.504 8.312 3.622 17.033 4.51 25.936 3.648 2.586-.25 5.281-1.014 7.586-2.203 5.873-3.03 6.433-9.399 1.171-13.33-2.64-1.974-5.758-3.306-8.644-4.957-5.046-2.888-10.437-5.324-15.053-8.788-13.893-10.428-14.528-28.365-1.05-39.368 5.012-4.093 11.266-7.238 17.467-9.184 12.482-3.919 25.294-3.273 38-.18 3.762.916 5.335 2.66 4.381 6.673-1.19 5.003-1.99 10.097-2.846 14.564-6.98-1.248-13.702-2.997-20.513-3.463-4.125-.281-8.677.747-12.518 2.394-6.036 2.59-6.408 7.698-1.121 11.565 3.197 2.34 6.9 3.987 10.372 5.954 4.05 2.294 8.24 4.375 12.117 6.933 18.664 12.314 12.65 34.977.5 44.25-7.82 5.967-16.772 8.89-26.331 9.838-11.16 1.106-22.302.65-33.584-2.597z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#3361AA",
                d: "M125.285 90.26c1.124-5.256 3.945-6.972 9.01-6.643 7.078.46 14.208.116 22.16.116-.952 2.57-1.492 4.255-2.189 5.874-12.562 29.197-25.21 58.357-37.636 87.612-1.606 3.78-3.574 5.364-7.75 5.14-6.477-.35-12.988-.19-19.481-.053-2.729.057-4.23-.795-5.038-3.556-7.297-24.91-14.709-49.786-22.05-74.684-.214-.725-.027-1.57-.027-3.44 17.642 13.189 32.895 27.114 39.467 49.8 8.076-20.653 15.73-40.229 23.534-60.167zM155.926 152.85c3.732-21.76 7.468-43.08 11.01-64.433.567-3.42 1.814-4.872 5.438-4.75 7.095.237 14.204.07 22.128.07-1.325 8.128-2.443 15.312-3.673 22.477-3.973 23.137-8.113 46.246-11.883 69.416-.806 4.954-2.352 7.23-7.824 6.765-6.416-.546-12.913-.128-20.253-.128 1.748-10.14 3.372-19.564 5.057-29.417z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#F4B10C",
                d: "M77.57 83.088c7.876 1.299 9.773 3.065 11.323 10.279a6203.654 6203.654 0 0 1 6.846 32.19c.287 1.371.271 2.806.105 4.328-13.184-24.978-35.05-38.088-61.574-44.967l.48-1.852c14.124 0 28.248 0 42.82.022z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fill: "#0D192A",
                d: "M333.8 146.9c-7.031.738-13.932 1.057-21.857 1.422l13.578-35.225 1.329-.12c2.36 11.167 4.72 22.334 6.95 33.922z"
            })
        ]
    });
var $ab267640b66b9ddc$export$2e2bcd8739ae039 = $ab267640b66b9ddc$var$SvgVisa;

});


parcelRegister("9IIBp", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $a4b06c93ab525a8b$export$df03f54e09e486fa; });

var $HJqQl = parcelRequire("HJqQl");

var $afB4L = parcelRequire("afB4L");

var $bgBnA = parcelRequire("bgBnA");

var $ayc3b = parcelRequire("ayc3b");

var $anO0a = parcelRequire("anO0a");

var $4EH7L = parcelRequire("4EH7L");

var $aHJ0S = parcelRequire("aHJ0S");

var $l6B3g = parcelRequire("l6B3g");

var $bMH5G = parcelRequire("bMH5G");

var $5VODs = parcelRequire("5VODs");

var $ggZb0 = parcelRequire("ggZb0");

var $hYm0y = parcelRequire("hYm0y");

var $eboOC = parcelRequire("eboOC");

var $gbyFM = parcelRequire("gbyFM");

var $6yHLP = parcelRequire("6yHLP");

var $12Y3j = parcelRequire("12Y3j");

var $e5vRj = parcelRequire("e5vRj");

var $4yTkG = parcelRequire("4yTkG");

var $dggHi = parcelRequire("dggHi");

var $h0l5p = parcelRequire("h0l5p");

var $kpIXU = parcelRequire("kpIXU");

var $451NM = parcelRequire("451NM");

var $3TDuz = parcelRequire("3TDuz");

var $efESP = parcelRequire("efESP");

var $61oFW = parcelRequire("61oFW");

var $7AYoW = parcelRequire("7AYoW");

var $7QU0u = parcelRequire("7QU0u");

var $lVjAG = parcelRequire("lVjAG");

var $3uHuq = parcelRequire("3uHuq");

var $i1NAy = parcelRequire("i1NAy");

var $cgMOk = parcelRequire("cgMOk");

var $2IZPf = parcelRequire("2IZPf");

var $9xos9 = parcelRequire("9xos9");

var $bcAUF = parcelRequire("bcAUF");

var $3JltI = parcelRequire("3JltI");

var $1MRYQ = parcelRequire("1MRYQ");

var $8E3kj = parcelRequire("8E3kj");

var $lpTjQ = parcelRequire("lpTjQ");

var $bdLup = parcelRequire("bdLup");

var $7O8Gg = parcelRequire("7O8Gg");

var $54xmw = parcelRequire("54xmw");

var $1pJxv = parcelRequire("1pJxv");

var $Rj9UJ = parcelRequire("Rj9UJ");

var $l8GQU = parcelRequire("l8GQU");

var $dhg3Z = parcelRequire("dhg3Z");

var $a4CR7 = parcelRequire("a4CR7");

var $cKee6 = parcelRequire("cKee6");

var $a5ZJ8 = parcelRequire("a5ZJ8");
const $a4b06c93ab525a8b$export$df03f54e09e486fa = {
    AlertTriangle: $HJqQl.default,
    ArrowLeft: $afB4L.default,
    ArrowRight: $bgBnA.default,
    Bell: $ayc3b.default,
    CaretDown: $anO0a.default,
    CheckCircle: $4EH7L.default,
    CheckSquare: $aHJ0S.default,
    Check: $l6B3g.default,
    Clock: $bMH5G.default,
    CommentFilled: $5VODs.default,
    Comment: $ggZb0.default,
    CreditCardIncome: $hYm0y.default,
    CreditCardOutgoing: $eboOC.default,
    CreditCard: $gbyFM.default,
    CrossCircle: $6yHLP.default,
    CrossSquare: $12Y3j.default,
    Crown: $e5vRj.default,
    DollarCircle: $4yTkG.default,
    Download: $dggHi.default,
    Edit: $h0l5p.default,
    Fire: $kpIXU.default,
    HeartBroken: $451NM.default,
    HeartFilled: $3TDuz.default,
    Heart: $efESP.default,
    ImageDownload: $61oFW.default,
    Lock: $7AYoW.default,
    MenuDots: $3uHuq.default,
    MenuLines: $i1NAy.default,
    MusicNote: $7QU0u.default,
    MusicNotes: $lVjAG.default,
    Pause: $cgMOk.default,
    PlayCircle: $2IZPf.default,
    Play: $bcAUF.default,
    PlayCircleBold: $9xos9.default,
    PlusCircle: $3JltI.default,
    Posts: $1MRYQ.default,
    Ryddm: $8E3kj.default,
    Scope: $lpTjQ.default,
    Search: $bdLup.default,
    SignOut: $7O8Gg.default,
    Speaker: $54xmw.default,
    Time: $1pJxv.default,
    Trash: $Rj9UJ.default,
    Unlock: $l8GQU.default,
    Upload: $dhg3Z.default,
    UserCircle: $a4CR7.default,
    UserPlus: $cKee6.default,
    User: $a5ZJ8.default
};

});
parcelRegister("HJqQl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83b676eb08cca66f$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $83b676eb08cca66f$var$SvgAlertTriangle = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        viewBox: "0 0 511.999 463.377",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M289.639 9.137c12.411 7.25 23.763 18.883 33.037 34.913l.97 1.813 1.118 1.941 174.174 302.48c33.712 56.407-1.203 113.774-66.174 112.973v.12H73.485c-.895 0-1.78-.04-2.657-.112-59.104-.799-86.277-54.995-61.909-106.852.842-1.805 1.816-3.475 2.816-5.201L189.482 43.959l-.053-.032c9.22-15.786 20.717-27.457 33.411-34.805C243.788-3 268.711-3.086 289.639 9.137zM255.7 339.203c13.04 0 23.612 10.571 23.612 23.612 0 13.041-10.572 23.613-23.612 23.613-13.041 0-23.613-10.572-23.613-23.613s10.572-23.612 23.613-23.612zm17.639-35.379c-.794 19.906-34.506 19.931-35.278-.006-3.41-34.108-12.129-111.541-11.853-143.591.284-9.874 8.469-15.724 18.939-17.955 3.231-.686 6.781-1.024 10.357-1.019 3.595.008 7.153.362 10.387 1.051 10.818 2.303 19.309 8.392 19.309 18.446l-.043 1.005-11.818 142.069zM37.596 369.821 216.864 59.942c21.738-37.211 56.225-38.289 78.376 0l176.298 306.166c17.177 28.285 10.04 66.236-38.774 65.488H73.485c-33.017.756-52.841-25.695-35.889-61.775z",
            fill: "#FFF"
        })
    });
var $83b676eb08cca66f$export$2e2bcd8739ae039 = $83b676eb08cca66f$var$SvgAlertTriangle;

});

parcelRegister("afB4L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $408726134c498030$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $408726134c498030$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "arrow_left_svg__feather arrow_left_svg__feather-arrow-left",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M19 12H5M12 19l-7-7 7-7"
        })
    });
var $408726134c498030$export$2e2bcd8739ae039 = $408726134c498030$var$SvgArrowLeft;

});

parcelRegister("bgBnA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb9893e7b2dcf39$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $ebb9893e7b2dcf39$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "arrow_right_svg__feather arrow_right_svg__feather-arrow-right",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M5 12h14M12 5l7 7-7 7"
        })
    });
var $ebb9893e7b2dcf39$export$2e2bcd8739ae039 = $ebb9893e7b2dcf39$var$SvgArrowRight;

});

parcelRegister("ayc3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b39c4e63c8dac2f1$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $b39c4e63c8dac2f1$var$SvgBell = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 28 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.001.667C8.294.667 3.668 5.293 3.668 11v.94c0 .928-.275 1.837-.79 2.61l-1.532 2.297c-1.777 2.666-.42 6.29 2.671 7.133 1.007.275 2.023.508 3.045.698l.003.007C8.09 27.42 10.83 29.334 14 29.334s5.911-1.914 6.937-4.65l.002-.006a37.949 37.949 0 0 0 3.046-.698c3.091-.843 4.448-4.467 2.67-7.133l-1.53-2.297a4.706 4.706 0 0 1-.791-2.61V11C24.335 5.293 19.708.667 14 .667Zm4.502 24.383a37.95 37.95 0 0 1-9.004 0c.948 1.362 2.597 2.284 4.502 2.284 1.905 0 3.554-.922 4.502-2.284ZM5.668 11a8.333 8.333 0 0 1 16.667 0v.94c0 1.323.392 2.618 1.126 3.72l1.532 2.297a2.695 2.695 0 0 1-1.534 4.094 35.947 35.947 0 0 1-18.916 0 2.695 2.695 0 0 1-1.533-4.094l1.532-2.298a6.707 6.707 0 0 0 1.126-3.72V11Z",
            fill: "#FFF"
        })
    });
var $b39c4e63c8dac2f1$export$2e2bcd8739ae039 = $b39c4e63c8dac2f1$var$SvgBell;

});

parcelRegister("anO0a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e67d4ac5e10c981c$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $e67d4ac5e10c981c$var$SvgCaretDown = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 320 512",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "m310.6 246.6-127.1 128c-7.1 6.3-15.3 9.4-23.5 9.4s-16.38-3.125-22.63-9.375l-127.1-128C.224 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75s3.12 25.75-6.08 34.85z",
            fill: "#FFF"
        })
    });
var $e67d4ac5e10c981c$export$2e2bcd8739ae039 = $e67d4ac5e10c981c$var$SvgCaretDown;

});

parcelRegister("4EH7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e88cdab05807ecbd$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $e88cdab05807ecbd$var$SvgCheckCircle = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M15.03 9.53a.75.75 0 0 0-1.06-1.06L9.5 12.94l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l5-5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 .75C5.063.75.25 5.563.25 11.5S5.063 22.25 11 22.25s10.75-4.813 10.75-10.75S16.937.75 11 .75ZM1.75 11.5a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0Z",
                fill: "#FFF"
            })
        ]
    });
var $e88cdab05807ecbd$export$2e2bcd8739ae039 = $e88cdab05807ecbd$var$SvgCheckCircle;

});

parcelRegister("aHJ0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b515abeed96b6e2$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $2b515abeed96b6e2$var$SvgCheckSquare = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M15.03 9.03a.75.75 0 0 0-1.06-1.06L9.5 12.44l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l5-5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.057.25h-.114c-2.309 0-4.118 0-5.53.19-1.444.194-2.584.6-3.479 1.494C1.04 2.83.634 3.97.44 5.414.25 6.825.25 8.634.25 10.943v.114c0 2.309 0 4.118.19 5.53.194 1.444.6 2.584 1.494 3.479.895.895 2.035 1.3 3.48 1.494 1.411.19 3.22.19 5.529.19h.114c2.309 0 4.118 0 5.53-.19 1.444-.194 2.584-.6 3.479-1.494.895-.895 1.3-2.035 1.494-3.48.19-1.411.19-3.22.19-5.529v-.114c0-2.309 0-4.118-.19-5.53-.194-1.444-.6-2.584-1.494-3.479-.895-.895-2.035-1.3-3.48-1.494-1.411-.19-3.22-.19-5.529-.19ZM2.995 2.995c.57-.57 1.34-.897 2.619-1.069 1.3-.174 3.008-.176 5.386-.176s4.086.002 5.386.176c1.279.172 2.05.5 2.62 1.069.569.57.896 1.34 1.068 2.619.174 1.3.176 3.008.176 5.386s-.002 4.086-.176 5.386c-.172 1.279-.5 2.05-1.069 2.62-.57.569-1.34.896-2.619 1.068-1.3.174-3.008.176-5.386.176s-4.086-.002-5.386-.176c-1.279-.172-2.05-.5-2.62-1.069-.569-.57-.896-1.34-1.068-2.619-.174-1.3-.176-3.008-.176-5.386s.002-4.086.176-5.386c.172-1.279.5-2.05 1.069-2.62Z",
                fill: "#FFF"
            })
        ]
    });
var $2b515abeed96b6e2$export$2e2bcd8739ae039 = $2b515abeed96b6e2$var$SvgCheckSquare;

});

parcelRegister("l6B3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $668e54db3c1477a8$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $668e54db3c1477a8$var$SvgCheck = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M41.938 8.625a2 2 0 0 0-1.626.938L21.5 38.343 9.312 27.814a1.992 1.992 0 0 0-2.03-.52 1.998 1.998 0 0 0-.595 3.52l13.938 12.062a2.005 2.005 0 0 0 1.582.453 2.01 2.01 0 0 0 1.387-.89L43.687 11.75a1.997 1.997 0 0 0-1.75-3.125Z",
            fill: "#FFF"
        })
    });
var $668e54db3c1477a8$export$2e2bcd8739ae039 = $668e54db3c1477a8$var$SvgCheck;

});

parcelRegister("bMH5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24c952fa396b9739$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $24c952fa396b9739$var$SvgClock = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "clock_svg__feather clock_svg__feather-clock",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M12 6v6l4 2"
            })
        ]
    });
var $24c952fa396b9739$export$2e2bcd8739ae039 = $24c952fa396b9739$var$SvgClock;

});

parcelRegister("5VODs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04d5047bf642b717$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $04d5047bf642b717$var$SvgCommentFilled = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M21.5 11C21.5 5.063 16.687.25 10.75.25S0 5.063 0 11c0 1.718.404 3.345 1.122 4.787.107.215.13.435.08.62l-.595 2.226c-.408 1.524.986 2.918 2.51 2.51l2.226-.596a.885.885 0 0 1 .62.08 10.709 10.709 0 0 0 4.787 1.123c5.937 0 10.75-4.813 10.75-10.75Z",
            fill: "#FFF"
        })
    });
var $04d5047bf642b717$export$2e2bcd8739ae039 = $04d5047bf642b717$var$SvgCommentFilled;

});

parcelRegister("ggZb0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32949ec8df7309eb$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $32949ec8df7309eb$var$SvgComment = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.75 11C21.75 5.063 16.937.25 11 .25S.25 5.063.25 11c0 1.718.404 3.345 1.122 4.787.107.215.13.435.08.62l-.595 2.226c-.408 1.524.986 2.918 2.51 2.51l2.226-.596a.885.885 0 0 1 .62.08A10.709 10.709 0 0 0 11 21.75c5.937 0 10.75-4.813 10.75-10.75ZM11 1.75a9.25 9.25 0 0 1 0 18.5 9.208 9.208 0 0 1-4.118-.965 2.383 2.383 0 0 0-1.676-.187l-2.227.596a.55.55 0 0 1-.673-.674l.596-2.226a2.383 2.383 0 0 0-.187-1.676A9.209 9.209 0 0 1 1.75 11 9.25 9.25 0 0 1 11 1.75Z",
            fill: "#FFF"
        })
    });
var $32949ec8df7309eb$export$2e2bcd8739ae039 = $32949ec8df7309eb$var$SvgComment;

});

parcelRegister("hYm0y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359351ee93553b4c$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $359351ee93553b4c$var$SvgCreditCardIncome = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 29 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.777.167h5.484c2.45 0 4.391 0 5.91.204 1.563.21 2.828.653 3.826 1.65.998.998 1.44 2.264 1.651 3.827.12.897.17 1.941.19 3.15a1.007 1.007 0 0 1 .005.307c.01.754.01 1.57.01 2.453v.075a1 1 0 1 1-2 0c0-.594 0-1.149-.003-1.667H2.188c-.002.518-.002 1.073-.002 1.667 0 2.543.002 4.349.186 5.719.18 1.341.518 2.114 1.083 2.679.564.564 1.337.902 2.678 1.082 1.37.185 3.177.187 5.72.187h5.333a1 1 0 0 1 0 2h-5.409c-2.45 0-4.391 0-5.91-.204-1.563-.21-2.829-.653-3.826-1.651C1.043 20.647.6 19.382.39 17.819c-.204-1.52-.204-3.46-.204-5.91v-.151c0-.882 0-1.699.01-2.453A1.009 1.009 0 0 1 .2 8.999c.02-1.21.07-2.254.19-3.151.21-1.563.653-2.829 1.65-3.826C3.039 1.024 4.305.58 5.868.37c1.519-.205 3.46-.205 5.91-.204Zm-9.557 8h24.597a20.824 20.824 0 0 0-.151-2.053c-.18-1.341-.519-2.114-1.083-2.678-.564-.565-1.337-.903-2.679-1.083-1.37-.184-3.176-.187-5.718-.187h-5.334c-2.542 0-4.348.003-5.719.187-1.341.18-2.114.518-2.678 1.083C2.89 4 2.552 4.773 2.372 6.114c-.08.594-.126 1.27-.152 2.053ZM23.852 23.5a1 1 0 0 1-1-1v-5.586l-.96.96a1 1 0 0 1-1.414-1.415l2.667-2.666a1 1 0 0 1 1.414 0l2.667 2.666a1 1 0 0 1-1.414 1.415l-.96-.96V22.5a1 1 0 0 1-1 1ZM5.52 17.166a1 1 0 0 1 1-1h5.333a1 1 0 1 1 0 2H6.52a1 1 0 0 1-1-1Zm8.666 0a1 1 0 0 1 1-1h.667a1 1 0 1 1 0 2h-.667a1 1 0 0 1-1-1Z",
            fill: "#FFF"
        })
    });
var $359351ee93553b4c$export$2e2bcd8739ae039 = $359351ee93553b4c$var$SvgCreditCardIncome;

});

parcelRegister("eboOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b73711fb2cb835b0$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $b73711fb2cb835b0$var$SvgCreditCardOutgoing = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 29 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.591 0h5.484c2.45 0 4.391 0 5.91.204 1.564.21 2.829.653 3.827 1.651.997.998 1.44 2.263 1.65 3.826.121.897.17 1.942.19 3.151a1.007 1.007 0 0 1 .005.307c.01.754.01 1.57.01 2.453v.075a1 1 0 1 1-2 0c0-.595 0-1.15-.003-1.667H2.003C2 10.518 2 11.072 2 11.667c0 2.542.002 4.348.186 5.719.18 1.341.519 2.114 1.083 2.678.564.564 1.337.903 2.679 1.083 1.37.184 3.176.186 5.719.186H17a1 1 0 0 1 0 2h-5.409c-2.45 0-4.39 0-5.91-.204-1.563-.21-2.828-.653-3.826-1.65-.998-.998-1.44-2.264-1.65-3.827C0 16.133 0 14.192 0 11.742v-.15c0-.883 0-1.7.01-2.453a1.009 1.009 0 0 1 .004-.307c.02-1.21.07-2.254.19-3.15.21-1.564.653-2.83 1.651-3.827C2.853.857 4.118.415 5.681.205 7.201 0 9.141 0 11.591 0ZM2.035 8h24.597a20.822 20.822 0 0 0-.152-2.052c-.18-1.342-.518-2.115-1.082-2.679-.565-.564-1.338-.902-2.68-1.083C21.349 2.002 19.543 2 17 2h-5.333c-2.543 0-4.349.002-5.72.186-1.34.18-2.114.519-2.678 1.083-.564.564-.902 1.337-1.083 2.679-.08.594-.125 1.27-.151 2.052Zm21.632 5.333a1 1 0 0 1 1 1v5.586l.96-.96a1 1 0 1 1 1.413 1.415l-2.666 2.666a1 1 0 0 1-1.414 0l-2.667-2.666a1 1 0 0 1 1.414-1.414l.96.96v-5.587a1 1 0 0 1 1-1ZM5.333 17a1 1 0 0 1 1-1h5.334a1 1 0 1 1 0 2H6.333a1 1 0 0 1-1-1ZM14 17a1 1 0 0 1 1-1h.667a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Z",
            fill: "#FFF"
        })
    });
var $b73711fb2cb835b0$export$2e2bcd8739ae039 = $b73711fb2cb835b0$var$SvgCreditCardOutgoing;

});

parcelRegister("gbyFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $028316ccb74c3c7c$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $028316ccb74c3c7c$var$SvgCreditCard = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        fill: "#FFF",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 456.548 456.548",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M433.467 81.51H23.081C10.334 81.51 0 91.844 0 104.591v26.274h456.548v-26.274c0-12.747-10.334-23.081-23.081-23.081zM0 351.957c0 12.747 10.334 23.081 23.081 23.081h410.385c12.747 0 23.081-10.334 23.081-23.081V198.355H0v153.602zm196.171-28.447h-29c-8.284 0-15-6.716-15-15s6.716-15 15-15h29c8.284 0 15 6.716 15 15s-6.716 15-15 15zm152.296-30h47c8.284 0 15 6.716 15 15s-6.716 15-15 15h-47c-8.284 0-15-6.716-15-15s6.716-15 15-15zm-45.296 15c0 8.284-6.716 15-15 15h-29c-8.284 0-15-6.716-15-15s6.716-15 15-15h29c8.284 0 15 6.716 15 15zm-244.297-72h224c8.284 0 15 6.716 15 15s-6.716 15-15 15h-224c-8.284 0-15-6.716-15-15s6.716-15 15-15zm0 57h47c8.284 0 15 6.716 15 15s-6.715 15-15 15h-47c-8.284 0-15-6.716-15-15s6.716-15 15-15z"
        })
    });
var $028316ccb74c3c7c$export$2e2bcd8739ae039 = $028316ccb74c3c7c$var$SvgCreditCard;

});

parcelRegister("6yHLP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b0047cc4ae8619d$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $5b0047cc4ae8619d$var$SvgCrossCircle = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M18.06 15.94a1.5 1.5 0 1 0-2.12 2.12L19.878 22l-3.94 3.94a1.5 1.5 0 1 0 2.122 2.12L22 24.122l3.94 3.94a1.5 1.5 0 0 0 2.12-2.122L24.122 22l3.94-3.94a1.5 1.5 0 1 0-2.122-2.12L22 19.878l-3.94-3.94Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22 .5C10.126.5.5 10.126.5 22S10.126 43.5 22 43.5 43.5 33.874 43.5 22 33.874.5 22 .5ZM3.5 22C3.5 11.783 11.783 3.5 22 3.5S40.5 11.783 40.5 22 32.217 40.5 22 40.5 3.5 32.217 3.5 22Z",
                fill: "#FFF"
            })
        ]
    });
var $5b0047cc4ae8619d$export$2e2bcd8739ae039 = $5b0047cc4ae8619d$var$SvgCrossCircle;

});

parcelRegister("12Y3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f44170b8899cf8f3$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $f44170b8899cf8f3$var$SvgCrossSquare = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M9.03 7.97a.75.75 0 0 0-1.06 1.06L9.94 11l-1.97 1.97a.75.75 0 1 0 1.06 1.06L11 12.06l1.97 1.97a.75.75 0 0 0 1.06-1.06L12.06 11l1.97-1.97a.75.75 0 1 0-1.06-1.06L11 9.94 9.03 7.97Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.057.25h-.114c-2.309 0-4.118 0-5.53.19-1.444.194-2.584.6-3.479 1.494C1.04 2.83.634 3.97.44 5.414.25 6.825.25 8.634.25 10.943v.114c0 2.309 0 4.118.19 5.53.194 1.444.6 2.584 1.494 3.479.895.895 2.035 1.3 3.48 1.494 1.411.19 3.22.19 5.529.19h.114c2.309 0 4.118 0 5.53-.19 1.444-.194 2.584-.6 3.479-1.494.895-.895 1.3-2.035 1.494-3.48.19-1.411.19-3.22.19-5.529v-.114c0-2.309 0-4.118-.19-5.53-.194-1.444-.6-2.584-1.494-3.479-.895-.895-2.035-1.3-3.48-1.494-1.411-.19-3.22-.19-5.529-.19ZM2.995 2.995c.57-.57 1.34-.897 2.619-1.069 1.3-.174 3.008-.176 5.386-.176s4.086.002 5.386.176c1.279.172 2.05.5 2.62 1.069.569.57.896 1.34 1.068 2.619.174 1.3.176 3.008.176 5.386s-.002 4.086-.176 5.386c-.172 1.279-.5 2.05-1.069 2.62-.57.569-1.34.896-2.619 1.068-1.3.174-3.008.176-5.386.176s-4.086-.002-5.386-.176c-1.279-.172-2.05-.5-2.62-1.069-.569-.57-.896-1.34-1.068-2.619-.174-1.3-.176-3.008-.176-5.386s.002-4.086.176-5.386c.172-1.279.5-2.05 1.069-2.62Z",
                fill: "#FFF"
            })
        ]
    });
var $f44170b8899cf8f3$export$2e2bcd8739ae039 = $f44170b8899cf8f3$var$SvgCrossSquare;

});

parcelRegister("e5vRj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee8e999d023f27fb$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $ee8e999d023f27fb$var$SvgCrown = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.828 1.828c-.192.286-.411.732-.74 1.407L6.284 6.928c-.159.325-.297.608-.429.823-.135.22-.314.455-.592.595-.25.127-.533.173-.812.129-.315-.05-.554-.229-.74-.402-.182-.167-.385-.398-.615-.66l-.02-.023c-.487-.554-.822-.935-1.082-1.177a1.515 1.515 0 0 0-.265-.211.22.22 0 0 0-.09.065c.003 0-.044.096-.041.468.003.39.053.933.126 1.71l.184 1.948c.152 1.62.262 2.783.448 3.665.183.872.424 1.388.783 1.755.35.358.8.563 1.549.672.774.113 1.785.115 3.222.115h2.175c1.437 0 2.448-.002 3.222-.115.75-.11 1.2-.314 1.55-.672.358-.367.6-.883.782-1.755.185-.882.296-2.046.448-3.665l.184-1.948c.073-.777.123-1.32.126-1.71.003-.372-.044-.467-.042-.468l.005.005a.223.223 0 0 0-.094-.07c-.052.029-.137.09-.265.21-.26.243-.595.624-1.082 1.178l-.02.023a9.46 9.46 0 0 1-.614.66c-.187.173-.426.352-.74.402a1.339 1.339 0 0 1-.813-.129c-.278-.14-.457-.374-.592-.595a10.39 10.39 0 0 1-.43-.823L9.91 3.235c-.33-.675-.55-1.121-.741-1.407a1.14 1.14 0 0 0-.17-.21 1.14 1.14 0 0 0-.17.21Zm.206-.235-.008.003c.005-.003.008-.004.008-.003Zm-.063.003-.008-.003s.003 0 .008.003Zm-1.138-.438C8.074.799 8.433.4 8.998.4c.566 0 .924.4 1.166.758.245.363.5.887.803 1.508l1.81 3.71c.176.359.289.588.386.747a.71.71 0 0 0 .114.154.14.14 0 0 0 .07.014.712.712 0 0 0 .124-.099c.13-.12.291-.302.547-.594l.023-.026c.459-.522.833-.948 1.141-1.236.158-.148.324-.284.499-.381.177-.1.4-.18.655-.157.378.033.714.225.95.509.284.343.316.823.312 1.238-.003.448-.06 1.042-.129 1.781l-.19 2.018c-.148 1.572-.264 2.804-.464 3.76-.205.976-.512 1.747-1.1 2.348-.596.61-1.328.888-2.233 1.02-.87.128-1.97.128-3.348.128H7.863c-1.378 0-2.477 0-3.348-.127-.905-.133-1.637-.412-2.234-1.021-.587-.601-.894-1.373-1.099-2.347-.2-.957-.316-2.189-.464-3.761l-.19-2.018c-.07-.739-.126-1.333-.13-1.781-.003-.415.03-.895.313-1.238.236-.284.572-.476.95-.51.255-.021.477.058.655.158.175.097.34.233.499.381.308.288.682.714 1.14 1.236l.024.026c.256.292.417.474.547.594.071.066.11.091.124.099a.14.14 0 0 0 .07-.014.703.703 0 0 0 .114-.154c.097-.159.21-.388.385-.747l1.81-3.71c.304-.62.56-1.145.804-1.508Z",
            fill: "#FFF"
        })
    });
var $ee8e999d023f27fb$export$2e2bcd8739ae039 = $ee8e999d023f27fb$var$SvgCrown;

});

parcelRegister("4yTkG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15e4d57df830dfbd$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $15e4d57df830dfbd$var$SvgDollarCircle = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 1.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM.25 11C.25 5.063 5.063.25 11 .25S21.75 5.063 21.75 11 16.937 21.75 11 21.75.25 16.937.25 11ZM11 4.25a.75.75 0 0 1 .75.75v.317c1.63.292 3 1.517 3 3.183a.75.75 0 0 1-1.5 0c0-.844-.873-1.75-2.25-1.75-1.376 0-2.25.906-2.25 1.75s.874 1.75 2.25 1.75c1.937 0 3.75 1.333 3.75 3.25 0 1.666-1.37 2.891-3 3.183V17a.75.75 0 0 1-1.5 0v-.317c-1.63-.292-3-1.517-3-3.183a.75.75 0 0 1 1.5 0c0 .844.874 1.75 2.25 1.75 1.377 0 2.25-.906 2.25-1.75s-.873-1.75-2.25-1.75c-1.937 0-3.75-1.333-3.75-3.25 0-1.666 1.37-2.891 3-3.183V5a.75.75 0 0 1 .75-.75Z",
            fill: "#FFF"
        })
    });
var $15e4d57df830dfbd$export$2e2bcd8739ae039 = $15e4d57df830dfbd$var$SvgDollarCircle;

});

parcelRegister("dggHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07b02915371ebe93$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $07b02915371ebe93$var$SvgDownload = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "download_svg__feather download_svg__feather-download",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"
        })
    });
var $07b02915371ebe93$export$2e2bcd8739ae039 = $07b02915371ebe93$var$SvgDownload;

});

parcelRegister("h0l5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aa310867228eb5f$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $0aa310867228eb5f$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1 1.391a3.896 3.896 0 0 1 5.509 5.51l-7.594 7.594c-.428.428-.69.69-.98.917a5.996 5.996 0 0 1-1.108.684c-.334.159-.685.276-1.259.467l-2.672.891-.642.214a1.598 1.598 0 0 1-2.022-2.022l1.105-3.314c.191-.574.308-.925.467-1.259a5.99 5.99 0 0 1 .685-1.107c.227-.292.488-.553.916-.98L11.1 1.39ZM2.96 15.884l-.844-.845.728-2.185c.212-.636.3-.895.414-1.135.14-.295.313-.573.513-.83.164-.21.356-.404.83-.879l5.891-5.89a6.05 6.05 0 0 0 1.349 2.04 6.05 6.05 0 0 0 2.04 1.348l-5.891 5.89c-.474.475-.668.667-.878.83-.258.201-.536.373-.83.514-.24.114-.5.202-1.136.414l-2.185.728Zm12.116-9.572a4.025 4.025 0 0 1-.455-.129 4.536 4.536 0 0 1-1.72-1.084c-.599-.6-.916-1.236-1.084-1.72a4.028 4.028 0 0 1-.13-.455l.473-.472a2.396 2.396 0 0 1 3.388 3.388l-.472.472ZM.25 21a.75.75 0 0 1 .75-.75h16v1.5H1A.75.75 0 0 1 .25 21Z",
            fill: "#FFF"
        })
    });
var $0aa310867228eb5f$export$2e2bcd8739ae039 = $0aa310867228eb5f$var$SvgEdit;

});

parcelRegister("kpIXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe80f11519833790$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $fe80f11519833790$var$SvgFire = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 15 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.383.608a1.827 1.827 0 0 1 2.05.104c2.128 1.54 4.566 4.284 4.566 8.177 0 3.045-1.308 5.003-2.974 6.179-1.023.722-2.167 1.14-3.2 1.352a3.303 3.303 0 0 1-1.301.17c-.131.006-.257.01-.378.01-1.169 0-2.896-.388-4.344-1.556C1.33 13.856.2 11.901.2 8.89c0-2.462 1.3-4.117 2.524-5.05a1.45 1.45 0 0 1 1.603-.132c.468.255.795.747.854 1.324l.069.67a.85.85 0 0 0 .296.576.295.295 0 0 0 .152.067c.029.002.075-.002.143-.046.522-.34.919-.95 1.186-1.669a5.998 5.998 0 0 0 .373-1.963v-.258c0-.779.396-1.446.984-1.8Zm.121 14.653c-.34.066-.665.107-.963.126a2.835 2.835 0 0 1-1.282-.45c-.468-.322-.86-.852-.86-1.782 0-1.121.694-1.973 1.432-2.52a.126.126 0 0 1 .004.031v.01c0 .181 0 .457.034.744.034.285.107.636.288.944.126.215.32.397.583.474a.977.977 0 0 0 .697-.062c.364-.173.625-.533.735-.912.33.268.627.688.627 1.291 0 .963-.358 1.496-.75 1.804-.172.134-.36.233-.545.302Zm2.31-.843c.176-.101.35-.211.52-.33 1.356-.958 2.465-2.555 2.465-5.2 0-3.35-2.098-5.778-4.07-7.204-.26-.188-.52-.172-.727-.047-.22.132-.403.405-.403.77v.26a7.19 7.19 0 0 1-.448 2.38c-.313.841-.832 1.721-1.657 2.257-.588.382-1.221.272-1.673-.07-.427-.322-.709-.851-.766-1.41l-.069-.67a.498.498 0 0 0-.235-.394c-.089-.049-.187-.054-.3.032C2.437 5.566 1.4 6.9 1.4 8.89c0 2.676.986 4.277 2.157 5.222.318.256.654.467.993.64-.219-.44-.35-.969-.35-1.596 0-1.682 1.056-2.858 1.959-3.514.41-.298.903-.289 1.28-.06.363.22.597.626.597 1.085 0 .188 0 .4.025.611l.014.1c.128-.295.364-.524.643-.645.334-.145.76-.142 1.115.125.56.421 1.167 1.177 1.167 2.298 0 .475-.067.895-.186 1.263Z",
            fill: "#FFF"
        })
    });
var $fe80f11519833790$export$2e2bcd8739ae039 = $fe80f11519833790$var$SvgFire;

});

parcelRegister("451NM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c524df8e9fe3af55$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $c524df8e9fe3af55$var$SvgHeartBroken = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 122 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.296 10.575C16.006 14.822 9.2 24.923 9.2 36.968c0 12.305 5.035 21.79 12.254 29.918 5.95 6.7 13.152 12.252 20.176 17.668 1.668 1.286 3.327 2.564 4.956 3.848 2.945 2.323 5.573 4.36 8.106 5.84 1.158.678 2.213 1.186 3.183 1.54l4.074-16.294-9.519-9.518a4.2 4.2 0 0 1-.22-5.704L66.026 48.15 50.159 36.818a4.2 4.2 0 0 1-1.316-5.297l7.032-14.06c-10.883-10.032-22.1-10.762-30.579-6.886Zm39.168 8.491-6.502 13.002L74.64 43.982a4.2 4.2 0 0 1 .748 6.151L61.119 66.78l8.45 8.45a4.2 4.2 0 0 1 1.105 3.989l-3.82 15.284c.149-.084.3-.17.454-.26 2.532-1.48 5.16-3.518 8.106-5.84 1.629-1.285 3.287-2.563 4.956-3.85 7.023-5.415 14.226-10.967 20.175-17.666 7.219-8.13 12.255-17.614 12.255-29.92 0-12.044-6.806-22.145-16.097-26.392-8.91-4.073-20.846-3.06-32.239 8.491ZM61 10.77C48.052-.815 33.554-2.435 21.804 2.936 9.394 8.608.8 21.78.8 36.968c0 14.926 6.219 26.314 14.373 35.496 6.53 7.354 14.524 13.508 21.583 18.944 1.6 1.232 3.153 2.427 4.63 3.591 2.868 2.261 5.947 4.673 9.068 6.496 3.12 1.823 6.68 3.305 10.546 3.305 3.866 0 7.426-1.482 10.546-3.305 3.12-1.823 6.2-4.235 9.068-6.496 1.477-1.164 3.029-2.359 4.63-3.591 7.059-5.436 15.052-11.59 21.582-18.944 8.155-9.182 14.374-20.57 14.374-35.496 0-15.188-8.595-28.36-21.004-34.032C88.446-2.435 73.947-.814 61 10.769Z",
            fill: "#FFF"
        })
    });
var $c524df8e9fe3af55$export$2e2bcd8739ae039 = $c524df8e9fe3af55$var$SvgHeartBroken;

});

parcelRegister("3TDuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f34a4d7e3e9112$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $01f34a4d7e3e9112$var$SvgHeartFilled = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M.333 4.091c0 3.242 2.68 4.97 4.641 6.516.693.546 1.36 1.06 2.026 1.06.667 0 1.333-.514 2.025-1.06 1.962-1.546 4.642-3.274 4.642-6.516S10-1.449 7 1.667C4-1.45.333.85.333 4.091Z",
            fill: "#FFF"
        })
    });
var $01f34a4d7e3e9112$export$2e2bcd8739ae039 = $01f34a4d7e3e9112$var$SvgHeartFilled;

});

parcelRegister("efESP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fdebaa4b2f2c6e2$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $4fdebaa4b2f2c6e2$var$SvgHeart = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.316 1.94c-1.34.606-2.32 2.05-2.32 3.77 0 1.758.725 3.113 1.766 4.274.857.957 1.895 1.75 2.908 2.524.24.184.479.366.714.55.424.332.803.623 1.168.834.365.212.66.308.91.308.249 0 .543-.096.908-.308.365-.211.744-.502 1.168-.834.235-.184.474-.366.715-.55 1.012-.774 2.05-1.567 2.907-2.524 1.04-1.161 1.766-2.516 1.766-4.274 0-1.72-.98-3.164-2.32-3.77-1.3-.59-3.048-.434-4.709 1.277a.608.608 0 0 1-.872 0C7.364 1.507 5.616 1.35 4.315 1.94Zm5.145.027C7.595.313 5.506.081 3.812.848 2.024 1.658.785 3.54.785 5.71c0 2.132.896 3.76 2.072 5.071.94 1.05 2.093 1.93 3.11 2.706.23.176.455.347.667.513.414.323.857.668 1.307.928.45.26.963.472 1.52.472s1.07-.211 1.52-.472c.45-.26.893-.605 1.307-.928.213-.166.436-.337.667-.513 1.017-.776 2.17-1.655 3.11-2.706 1.176-1.312 2.072-2.939 2.072-5.071 0-2.17-1.239-4.051-3.027-4.862-1.694-.767-3.783-.535-5.649 1.12Z",
            fill: "#FFF"
        })
    });
var $4fdebaa4b2f2c6e2$export$2e2bcd8739ae039 = $4fdebaa4b2f2c6e2$var$SvgHeart;

});

parcelRegister("61oFW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $082ed1746f9d5ef5$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $082ed1746f9d5ef5$var$SvgImageDownload = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.666 6.167a1 1 0 0 1 1 1v9.585l2.293-2.292a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414l2.293 2.292V7.167a1 1 0 0 1 1-1Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 6.167h-.077c-3.078 0-5.49 0-7.372.253-1.926.259-3.446.8-4.64 1.992-1.193 1.193-1.733 2.713-1.992 4.64-.253 1.882-.253 4.294-.253 7.372v.152c0 3.078 0 5.49.253 7.372.259 1.927.8 3.447 1.993 4.64 1.193 1.193 2.713 1.733 4.639 1.992 1.882.253 4.294.253 7.372.253h.153c3.078 0 5.49 0 7.372-.253 1.926-.259 3.446-.8 4.64-1.992 1.192-1.193 1.733-2.713 1.992-4.64.253-1.882.253-4.294.253-7.372V20.5a1 1 0 1 0-2 0c0 3.171-.002 5.449-.236 7.182l-.028.202-3.699-3.329a5 5 0 0 0-6.22-.374l-.397.28a1.667 1.667 0 0 1-2.137-.186l-5.72-5.72a4.067 4.067 0 0 0-5.553-.185l-.676.592c.006-2.39.04-4.205.234-5.644.23-1.704.665-2.732 1.425-3.492.76-.76 1.787-1.195 3.492-1.424 1.733-.233 4.01-.235 7.181-.235a1 1 0 1 0 0-2ZM7.9 27.682c.23 1.704.665 2.732 1.425 3.492.76.76 1.787 1.195 3.492 1.424 1.733.233 4.01.235 7.181.235 3.171 0 5.449-.002 7.182-.235 1.705-.229 2.732-.665 3.492-1.424.325-.325.59-.699.806-1.154a1.006 1.006 0 0 1-.149-.11l-4.298-3.868a3 3 0 0 0-3.732-.225l-.397.28a3.667 3.667 0 0 1-4.701-.408l-5.72-5.72a2.067 2.067 0 0 0-2.822-.093L7.667 21.62c.003 2.598.03 4.54.234 6.062Z",
                fill: "#FFF"
            })
        ]
    });
var $082ed1746f9d5ef5$export$2e2bcd8739ae039 = $082ed1746f9d5ef5$var$SvgImageDownload;

});

parcelRegister("7AYoW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57ec0669a598481c$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $57ec0669a598481c$var$SvgLock = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.667 5.369V4.5a4.5 4.5 0 0 1 9 0v.869c.15.01.293.024.428.042.6.08 1.105.253 1.506.655.401.4.574.906.655 1.506.077.578.077 1.313.077 2.225v.073c0 .912 0 1.647-.077 2.225-.081.6-.254 1.105-.655 1.506s-.906.574-1.507.655c-.577.077-1.312.077-2.224.077H4.463c-.911 0-1.646 0-2.224-.077-.6-.081-1.105-.254-1.507-.655-.401-.401-.574-.906-.654-1.507C0 11.518 0 10.783 0 9.87v-.073c0-.912 0-1.647.078-2.225.08-.6.253-1.105.654-1.506.402-.402.907-.574 1.507-.655.134-.018.276-.032.428-.042Zm1-.869a3.5 3.5 0 1 1 7 0v.836c-.25-.003-.515-.003-.797-.003H4.463c-.282 0-.547 0-.796.003V4.5ZM1.439 6.773c.185-.185.444-.305.933-.37.504-.069 1.171-.07 2.128-.07h5.333c.957 0 1.625.001 2.128.07.49.065.748.185.933.37.184.184.305.443.37.932.068.504.07 1.171.07 2.128 0 .957-.002 1.625-.07 2.128-.065.49-.185.748-.37.933-.184.184-.444.305-.933.37-.503.068-1.17.07-2.128.07H4.5c-.957 0-1.624-.002-2.128-.07-.49-.065-.748-.185-.933-.37-.184-.184-.304-.444-.37-.933C1 11.458 1 10.791 1 9.833c0-.957.001-1.624.069-2.128.066-.489.186-.748.37-.932Z",
            fill: "#FFF"
        })
    });
var $57ec0669a598481c$export$2e2bcd8739ae039 = $57ec0669a598481c$var$SvgLock;

});

parcelRegister("7QU0u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e18d944ebd6e9c6d$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $e18d944ebd6e9c6d$var$SvgMusicNote = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "music_note_svg__feather music_note_svg__feather-music",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M9 18V5l12-2v13"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("circle", {
                cx: 6,
                cy: 18,
                r: 3
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("circle", {
                cx: 18,
                cy: 16,
                r: 3
            })
        ]
    });
var $e18d944ebd6e9c6d$export$2e2bcd8739ae039 = $e18d944ebd6e9c6d$var$SvgMusicNote;

});

parcelRegister("lVjAG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73c5481cb7897891$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $73c5481cb7897891$var$SvgMusicNotes = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 121 117",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M40.965 9.51c2.546 2.104 5.79 3.09 8.335 3.09a4.2 4.2 0 1 1 0 8.4c-4.035 0-8.688-1.349-12.6-4.175V50.4c0 .893-.28 1.721-.755 2.402C33.708 60.32 26.745 65.8 18.5 65.8 8.448 65.8.3 57.652.3 47.6s8.148-18.2 18.2-18.2c3.608 0 6.971 1.05 9.8 2.861V0h8.4c0 4.468 1.839 7.507 4.265 9.51ZM28.3 47.6c0-5.412-4.388-9.8-9.8-9.8-5.413 0-9.8 4.388-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8Zm74.607-36.73c-3.762.959-8.687 3.008-15.834 6l-11.2 4.687c-3.417 1.43-5.67 2.38-7.325 3.294-1.566.864-2.244 1.515-2.676 2.163-.431.648-.77 1.525-.962 3.303-.204 1.88-.21 4.325-.21 8.029v11.45l47.598-19.039c-.01-6.208-.083-10.68-.577-14.021-.556-3.759-1.509-5.046-2.543-5.734-1.034-.689-2.589-1.07-6.271-.132ZM120.7 33.502v-.196c0-7.31 0-13.271-.67-17.8-.692-4.682-2.238-8.861-6.198-11.497-3.961-2.636-8.413-2.448-12.999-1.279-4.436 1.13-9.935 3.432-16.679 6.255l-11.726 4.908c-3.161 1.323-5.84 2.444-7.941 3.605-2.237 1.235-4.163 2.691-5.608 4.862-1.444 2.17-2.044 4.51-2.32 7.05-.26 2.387-.26 5.29-.26 8.717v17.778a4.148 4.148 0 0 0 0 .193V82.66a18.115 18.115 0 0 0-9.8-2.861c-10.05 0-18.2 8.148-18.2 18.2s8.15 18.2 18.2 18.2c10.052 0 18.2-8.148 18.2-18.2 0-.952-.072-1.887-.213-2.8h.214V58.843l47.6-19.04v31.658a18.116 18.116 0 0 0-9.8-2.861c-10.052 0-18.2 8.148-18.2 18.2s8.148 18.2 18.2 18.2c10.051 0 18.2-8.148 18.2-18.2 0-.655-.035-1.301-.102-1.938h.102V33.695a6.221 6.221 0 0 0 0-.193ZM102.5 77c-5.413 0-9.8 4.388-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8 0-5.412-4.388-9.8-9.8-9.8Zm-56 11.2c-5.413 0-9.8 4.388-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8 0-5.412-4.388-9.8-9.8-9.8Z",
            fill: "#FFF"
        })
    });
var $73c5481cb7897891$export$2e2bcd8739ae039 = $73c5481cb7897891$var$SvgMusicNotes;

});

parcelRegister("3uHuq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58be8f78e835e97f$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $58be8f78e835e97f$var$SvgMenuDots = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 20 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M.25 3a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM3 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM7.25 3a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM10 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM17 .25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM15.75 3a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
            fill: "#FFF"
        })
    });
var $58be8f78e835e97f$export$2e2bcd8739ae039 = $58be8f78e835e97f$var$SvgMenuDots;

});

parcelRegister("i1NAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe8d4724bea4e497$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $fe8d4724bea4e497$var$SvgMenuLines = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "menu_lines_svg__feather menu_lines_svg__feather-menu",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M3 12h18M3 6h18M3 18h18"
        })
    });
var $fe8d4724bea4e497$export$2e2bcd8739ae039 = $fe8d4724bea4e497$var$SvgMenuLines;

});

parcelRegister("cgMOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20c0e04c2b0b3f51$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $20c0e04c2b0b3f51$var$SvgPause = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M0 4C0 2.114 0 1.172.586.586 1.172 0 2.114 0 4 0c1.886 0 2.828 0 3.414.586C8 1.172 8 2.114 8 4v12c0 1.886 0 2.828-.586 3.414C6.828 20 5.886 20 4 20c-1.886 0-2.828 0-3.414-.586C0 18.828 0 17.886 0 16V4ZM12 4c0-1.886 0-2.828.586-3.414C13.172 0 14.114 0 16 0c1.886 0 2.828 0 3.414.586C20 1.172 20 2.114 20 4v12c0 1.886 0 2.828-.586 3.414C18.828 20 17.886 20 16 20c-1.886 0-2.828 0-3.414-.586C12 18.828 12 17.886 12 16V4Z",
            fill: "#FFF"
        })
    });
var $20c0e04c2b0b3f51$export$2e2bcd8739ae039 = $20c0e04c2b0b3f51$var$SvgPause;

});

parcelRegister("2IZPf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13c7ea315ada8e2c$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $13c7ea315ada8e2c$var$SvgPlayCircle = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 11.7,
                stroke: "#FFF",
                strokeWidth: 0.6
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M8.875 6.375 17.625 12l-8.75 5.625V6.375Z",
                fill: "#FFF",
                stroke: "#FFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $13c7ea315ada8e2c$export$2e2bcd8739ae039 = $13c7ea315ada8e2c$var$SvgPlayCircle;

});

parcelRegister("9xos9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2485bd9dee73fb44$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $2485bd9dee73fb44$var$SvgPlayCircleBold = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#FFF",
        className: "play_circle_bold_svg__bi play_circle_bold_svg__bi-play-circle",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"
            })
        ]
    });
var $2485bd9dee73fb44$export$2e2bcd8739ae039 = $2485bd9dee73fb44$var$SvgPlayCircleBold;

});

parcelRegister("bcAUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45a58d21af27d9c1$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $45a58d21af27d9c1$var$SvgPlay = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M13.163 4.837C16.388 7.03 18 8.125 18 10c0 1.875-1.612 2.97-4.837 5.163a46.431 46.431 0 0 1-2.585 1.65c-.711.416-1.518.847-2.352 1.27-3.217 1.63-4.826 2.446-6.269 1.543-1.442-.902-1.574-2.792-1.836-6.57A45.156 45.156 0 0 1 0 10c0-.94.047-1.987.121-3.055.262-3.779.394-5.668 1.836-6.57C3.4-.529 5.01.286 8.226 1.916c.834.423 1.64.854 2.352 1.27a46.385 46.385 0 0 1 2.585 1.65Z",
            fill: "#FFF"
        })
    });
var $45a58d21af27d9c1$export$2e2bcd8739ae039 = $45a58d21af27d9c1$var$SvgPlay;

});

parcelRegister("3JltI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d6c2936e516f4cb$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $4d6c2936e516f4cb$var$SvgPlusCircle = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M11.75 8a.75.75 0 0 0-1.5 0v2.25H8a.75.75 0 0 0 0 1.5h2.25V14a.75.75 0 0 0 1.5 0v-2.25H14a.75.75 0 0 0 0-1.5h-2.25V8Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 .25C5.063.25.25 5.063.25 11S5.063 21.75 11 21.75 21.75 16.937 21.75 11 16.937.25 11 .25ZM1.75 11a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0Z",
                fill: "#FFF"
            })
        ]
    });
var $4d6c2936e516f4cb$export$2e2bcd8739ae039 = $4d6c2936e516f4cb$var$SvgPlusCircle;

});

parcelRegister("1MRYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc2c29b475be614f$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $dc2c29b475be614f$var$SvgPosts = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 122 122",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M55.093.8h11.814c7.659 0 13.832 0 18.687.652 5.04.678 9.284 2.128 12.655 5.499 2.241 2.24 3.633 4.868 4.514 7.859 1.184.018 2.173.07 3.084.214a18.2 18.2 0 0 1 15.129 15.129c.225 1.422.225 3.035.224 5.284v51.125c.001 2.25.001 3.863-.224 5.285a18.201 18.201 0 0 1-15.129 15.129c-.911.144-1.9.196-3.084.214-.881 2.991-2.273 5.618-4.514 7.859-3.37 3.371-7.615 4.821-12.655 5.498-4.855.653-11.028.653-18.687.653H55.093c-7.659 0-13.832 0-18.687-.653-5.04-.677-9.285-2.127-12.655-5.498-2.241-2.241-3.633-4.868-4.514-7.859-1.184-.018-2.174-.07-3.084-.214a18.2 18.2 0 0 1-15.129-15.13C.799 90.427.799 88.813.8 86.563V35.437c0-2.25-.001-3.862.224-5.284a18.2 18.2 0 0 1 15.129-15.13c.91-.143 1.9-.195 3.084-.213.88-2.991 2.273-5.618 4.514-7.86 3.37-3.37 7.614-4.82 12.655-5.498C41.261.8 47.434.8 55.093.8ZM17.89 23.269a6.292 6.292 0 0 0-.424.052 9.8 9.8 0 0 0-8.146 8.146c-.108.68-.121 1.571-.121 4.333v50.4c0 2.761.013 3.653.12 4.333a9.8 9.8 0 0 0 8.147 8.146c.13.02.267.038.424.052-.291-4.191-.291-9.174-.291-15.024V38.292c0-5.85 0-10.832.29-15.023ZM26 78.477V83.4c0 8.038.009 13.644.578 17.874.552 4.109 1.563 6.285 3.112 7.835 1.55 1.55 3.726 2.561 7.835 3.113 4.23.569 9.837.578 17.875.578h11.2c8.038 0 13.645-.009 17.875-.578 4.109-.552 6.285-1.563 7.835-3.113.85-.851 1.54-1.891 2.078-3.336L83.85 94.651c-2.819-2.974-6.713-3.178-9.68-.734l-1.23 1.014c-5.13 4.228-12.193 3.397-16.447-1.59l-17.7-20.756c-1.961-2.299-4.757-2.353-6.758-.3L26 78.477Zm69.883 16.661-5.936-6.264c-5.76-6.08-14.641-6.777-21.118-1.44l-1.23 1.014c-1.432 1.18-3.297 1.104-4.715-.558l-17.7-20.756c-5.106-5.987-13.645-6.375-19.164-.712l-.02.02V38.6c0-8.039.009-13.645.578-17.875.552-4.109 1.563-6.285 3.112-7.835 1.55-1.55 3.726-2.56 7.835-3.113C41.755 9.21 47.362 9.2 55.4 9.2h11.2c8.038 0 13.645.009 17.875.577 4.109.553 6.285 1.563 7.835 3.113 1.55 1.55 2.56 3.726 3.112 7.835.569 4.23.578 9.836.578 17.875v44.8c0 4.662-.003 8.506-.117 11.738Zm8.226 3.593c.157-.014.294-.031.424-.052a9.8 9.8 0 0 0 8.146-8.146c.108-.68.121-1.572.121-4.333V35.8c0-2.762-.013-3.654-.121-4.333a9.8 9.8 0 0 0-8.146-8.146 6.303 6.303 0 0 0-.424-.052c.291 4.19.291 9.174.291 15.023v45.415c0 5.85 0 10.833-.291 15.024ZM74.999 26a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4Zm-12.6 4.2c0-6.959 5.642-12.6 12.6-12.6 6.96 0 12.6 5.641 12.6 12.6S81.96 42.8 75 42.8c-6.958 0-12.6-5.641-12.6-12.6Z",
            fill: "#FFF"
        })
    });
var $dc2c29b475be614f$export$2e2bcd8739ae039 = $dc2c29b475be614f$var$SvgPosts;

});

parcelRegister("8E3kj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $317cea3d69ca77ce$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $317cea3d69ca77ce$var$SvgRyddm = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 30 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M1.648 38.636h22.49",
                stroke: "#FFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M9.866 18.771V38.51M5.308 22.253l-1.64 1.24a2.874 2.874 0 0 0-.753 3.733l1.656 2.856 1.738 2.606a2.873 2.873 0 0 1-.692 3.912L3.01 38.51",
                stroke: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("ellipse", {
                cx: 9.464,
                cy: 9.255,
                rx: 9.464,
                ry: 9.255,
                transform: "matrix(.99516 -.09827 .10281 .9947 9.261 2.497)",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "m16.088 16.468-3.267-4.132-9.223 9.24c-.824.944.222 2.335 1.358 1.805l.237-.111 10.895-6.802Z",
                fill: "#FFF",
                stroke: "#FFF",
                strokeWidth: 0.431
            })
        ]
    });
var $317cea3d69ca77ce$export$2e2bcd8739ae039 = $317cea3d69ca77ce$var$SvgRyddm;

});

parcelRegister("lpTjQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e001e377dd4f78f$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $7e001e377dd4f78f$var$SvgScope = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.8 2.297c.447-.253.718-.405.927-.49a.791.791 0 0 1 .183-.055.079.079 0 0 1 .033 0c.004 0 .01.002.027.015a.764.764 0 0 1 .127.135c.137.175.294.438.552.877l1.049 1.786c.258.44.411.704.496.908.04.093.051.146.055.171l.001.017v.002l-.001.002-.011.016a.76.76 0 0 1-.137.125c-.18.135-.448.29-.895.543l-3.735 2.12c-.423.24-.675.381-.87.46a.704.704 0 0 1-.16.05h-.015l-.003-.001a.708.708 0 0 1-.124-.13c-.129-.165-.277-.414-.523-.833l-1.12-1.907c-.253-.43-.402-.689-.486-.888a.706.706 0 0 1-.054-.176v-.003l.002-.002.002-.003.004-.006a.708.708 0 0 1 .128-.117c.172-.13.43-.279.865-.525l3.684-2.09ZM18.326.301c-.428-.113-.816-.023-1.16.116-.313.126-.671.33-1.066.553l-3.762 2.136c-.381.216-.731.414-.993.614-.287.218-.56.504-.675.927l-3.48 1.975-.04.022c-.38.217-.73.415-.993.615-.287.218-.56.504-.675.928l-3.427 1.945-.04.022c-.394.224-.752.428-1.02.631-.295.223-.573.513-.69.944-.118.432-.024.822.118 1.163.13.309.337.662.564 1.05l.046.078c.228.387.435.74.643 1.005.228.29.522.56.951.674.428.113.817.023 1.16-.115.314-.127.672-.33 1.066-.554l3.455-1.96.019.004c.417.112.795.025 1.124-.108.048-.019.096-.04.145-.063L6.31 20.71a.75.75 0 1 0 1.382.582l3.31-7.858 3.308 7.858a.75.75 0 1 0 1.382-.582l-3.818-9.069 2.145-1.217.02.005c.417.112.795.025 1.124-.108.299-.12.64-.314 1.01-.525l3.814-2.164c.394-.223.753-.427 1.021-.63.294-.223.572-.513.69-.944.118-.432.024-.823-.119-1.163-.13-.31-.337-.663-.564-1.05L19.942 2.02l-.023-.04c-.227-.387-.434-.74-.642-1.004-.229-.292-.522-.562-.952-.675ZM2.794 11.437 5.79 9.735c.106.199.23.41.361.632l.023.04.618 1.052c.116.196.226.384.334.555l-2.976 1.69c-.446.252-.717.404-.927.489a.79.79 0 0 1-.182.056c-.023.002-.03 0-.033 0h-.001c-.004-.002-.01-.003-.027-.016a.757.757 0 0 1-.126-.135c-.138-.175-.294-.438-.552-.877-.258-.44-.412-.704-.497-.908a.73.73 0 0 1-.055-.171V12.12l.011-.016a.767.767 0 0 1 .138-.125c.179-.136.447-.29.894-.543Zm8.185-5.241-3.05 1.73c-.434.247-.692.396-.864.526a.71.71 0 0 0-.135.126l-.001.002V8.594a.71.71 0 0 0 .054.165c.083.2.233.457.486.888l.595 1.014c.246.42.395.668.524.833a.7.7 0 0 0 .124.13l.002.001h.003a.702.702 0 0 0 .172-.05c.195-.079.447-.22.87-.46l.774-.44.754-.427 1.551-.88c-.107-.171-.218-.359-.333-.555L11.34 6.829c-.131-.223-.255-.435-.361-.633Z",
            fill: "#FFF"
        })
    });
var $7e001e377dd4f78f$export$2e2bcd8739ae039 = $7e001e377dd4f78f$var$SvgScope;

});

parcelRegister("bdLup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $157977cfb48db973$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $157977cfb48db973$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.5 5.75a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.25 14.5c0-5.66 4.59-10.25 10.25-10.25S24.75 8.84 24.75 14.5c0 2.56-.939 4.902-2.491 6.698l3.271 3.272a.75.75 0 1 1-1.06 1.06l-3.272-3.271A10.21 10.21 0 0 1 14.5 24.75c-5.66 0-10.25-4.59-10.25-10.25Z",
            fill: "#FFF"
        })
    });
var $157977cfb48db973$export$2e2bcd8739ae039 = $157977cfb48db973$var$SvgSearch;

});

parcelRegister("7O8Gg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $126b54ce2eb23868$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $126b54ce2eb23868$var$SvgSignOut = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "sign_out_svg__feather sign_out_svg__feather-log-out",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
        })
    });
var $126b54ce2eb23868$export$2e2bcd8739ae039 = $126b54ce2eb23868$var$SvgSignOut;

});

parcelRegister("54xmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7e2495054319716$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $f7e2495054319716$var$SvgSpeaker = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M.003 7.715C.04 5.873.059 4.952.671 4.164c.112-.144.275-.315.413-.431.752-.636 1.746-.636 3.733-.636.71 0 1.065 0 1.403-.092.07-.02.14-.042.209-.067.33-.121.627-.33 1.22-.746C9.987.547 11.156-.275 12.138.082c.188.069.37.168.533.29.848.635.913 2.115 1.042 5.073A71.13 71.13 0 0 1 13.793 8c0 .522-.032 1.46-.08 2.555-.13 2.958-.194 4.438-1.042 5.073-.163.122-.345.221-.533.29-.982.357-2.15-.465-4.49-2.11-.592-.416-.889-.625-1.22-.746a2.61 2.61 0 0 0-.208-.066c-.338-.093-.693-.093-1.403-.093-1.987 0-2.98 0-3.733-.636a3.145 3.145 0 0 1-.413-.43c-.612-.79-.63-1.71-.668-3.552a14.06 14.06 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.49 1.552a.66.66 0 0 1 .97.094l-.529.471.53-.47.002.002.003.004.007.009a2.572 2.572 0 0 1 .079.112c.047.071.111.173.186.305.149.264.339.652.526 1.171C19.64 4.291 20 5.851 20 8c0 2.15-.36 3.71-.736 4.75-.187.52-.377.907-.526 1.172a4.655 4.655 0 0 1-.265.417l-.007.009-.003.003-.001.002s-.001.001-.531-.47l.53.471a.66.66 0 0 1-.971.094.77.77 0 0 1-.09-1.035l.03-.041c.026-.04.07-.11.125-.207a6.28 6.28 0 0 0 .422-.943c.314-.871.644-2.252.644-4.222 0-1.97-.33-3.35-.644-4.222a6.28 6.28 0 0 0-.422-.942 3.152 3.152 0 0 0-.157-.253M15.757 4.416c.333-.197.753-.07.938.286l-.603.357.603-.357v.001l.001.001.002.003.003.007.01.018.024.053c.018.042.042.099.07.17.053.145.12.35.185.62.13.54.252 1.337.252 2.425 0 1.089-.122 1.886-.252 2.426-.065.27-.132.475-.186.619a3.04 3.04 0 0 1-.094.223l-.009.018-.003.007-.002.003v.002s-.001.001-.604-.356l.603.357c-.185.355-.605.483-.938.286-.33-.196-.45-.638-.272-.991l.004-.01.035-.085c.032-.086.08-.23.13-.438.1-.416.208-1.09.208-2.06 0-.971-.108-1.645-.208-2.06a3.757 3.757 0 0 0-.165-.524l-.004-.01c-.179-.354-.058-.795.272-.991Z",
                fill: "#FFF"
            })
        ]
    });
var $f7e2495054319716$export$2e2bcd8739ae039 = $f7e2495054319716$var$SvgSpeaker;

});

parcelRegister("1pJxv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6454db8a90948738$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $6454db8a90948738$var$SvgTime = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.998 1.6a7.4 7.4 0 1 0 0 14.8 7.4 7.4 0 0 0 0-14.8ZM.398 9a8.6 8.6 0 1 1 17.2 0 8.6 8.6 0 0 1-17.2 0Zm8.6-3.8a.6.6 0 0 1 .6.6V8.75l1.825 1.825a.6.6 0 0 1-.849.848l-2-2A.6.6 0 0 1 8.398 9V5.8a.6.6 0 0 1 .6-.6Z",
            fill: "#FFF"
        })
    });
var $6454db8a90948738$export$2e2bcd8739ae039 = $6454db8a90948738$var$SvgTime;

});

parcelRegister("Rj9UJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $776a5b4e26c714b5$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $776a5b4e26c714b5$var$SvgTrash = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M7.878 3.25a2.251 2.251 0 0 1 4.244 0 .75.75 0 1 0 1.415-.5 3.751 3.751 0 0 0-7.073 0 .75.75 0 1 0 1.414.5ZM.75 5a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5h-17A.75.75 0 0 1 .75 5ZM3.117 6.752a.75.75 0 0 1 .798.698l.46 6.9c.09 1.347.154 2.285.294 2.99.137.685.327 1.047.6 1.303.274.256.648.422 1.34.512.714.093 1.654.095 3.004.095h.774c1.35 0 2.29-.002 3.004-.095.692-.09 1.066-.256 1.34-.512.273-.256.463-.618.6-1.303.14-.705.204-1.643.294-2.99l.46-6.9a.75.75 0 1 1 1.497.1l-.464 6.952c-.085 1.282-.154 2.318-.316 3.132-.169.845-.455 1.551-1.047 2.104-.591.554-1.315.793-2.17.904-.822.108-1.86.108-3.146.108h-.878c-1.286 0-2.324 0-3.146-.108-.855-.111-1.579-.35-2.17-.904-.592-.553-.878-1.26-1.047-2.104-.162-.814-.23-1.85-.316-3.132L2.418 7.55a.75.75 0 0 1 .699-.798Z",
            fill: "#FFF"
        })
    });
var $776a5b4e26c714b5$export$2e2bcd8739ae039 = $776a5b4e26c714b5$var$SvgTrash;

});

parcelRegister("l8GQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46fff7e6d709f3e7$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $46fff7e6d709f3e7$var$SvgUnlock = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.167 1a3.5 3.5 0 0 0-3.5 3.5v.836c.249-.003.514-.003.796-.003H9.87l2.225.078c.6.08 1.105.253 1.506.655.401.4.574.906.655 1.506.077.578.077 1.313.077 2.225v.073c0 .912 0 1.647-.077 2.225-.081.6-.254 1.105-.655 1.506s-.906.574-1.507.655c-.577.077-1.312.077-2.224.077H4.463c-.911 0-1.646 0-2.224-.077-.6-.081-1.105-.254-1.507-.655-.401-.401-.574-.906-.654-1.507C0 11.518 0 10.783 0 9.87v-.073c0-.912 0-1.647.078-2.225.08-.6.253-1.105.654-1.506.402-.402.907-.574 1.507-.655a6.8 6.8 0 0 1 .428-.042V4.5a4.5 4.5 0 0 1 8.888-1h-1.033A3.501 3.501 0 0 0 7.167 1ZM1.439 6.773c.185-.185.444-.305.933-.37.504-.069 1.171-.07 2.128-.07h5.333c.957 0 1.625.001 2.128.07.49.065.748.185.933.37.184.184.305.443.37.932.068.504.07 1.171.07 2.128 0 .957-.002 1.625-.07 2.128-.065.49-.185.748-.37.933-.184.184-.444.305-.933.37-.503.068-1.17.07-2.128.07H4.5c-.957 0-1.624-.002-2.128-.07-.49-.065-.748-.185-.933-.37-.184-.184-.304-.444-.37-.933C1 11.458 1 10.791 1 9.833c0-.957.001-1.624.069-2.128.066-.489.186-.748.37-.932Z",
            fill: "#FFF"
        })
    });
var $46fff7e6d709f3e7$export$2e2bcd8739ae039 = $46fff7e6d709f3e7$var$SvgUnlock;

});

parcelRegister("dhg3Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d7c1d8a2d5b5f87$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $1d7c1d8a2d5b5f87$var$SvgUpload = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "upload_svg__feather upload_svg__feather-upload",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"
        })
    });
var $1d7c1d8a2d5b5f87$export$2e2bcd8739ae039 = $1d7c1d8a2d5b5f87$var$SvgUpload;

});

parcelRegister("a4CR7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a51d5e1593600f1$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $0a51d5e1593600f1$var$SvgUserCircle = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM11 5.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.25 11C.25 5.063 5.063.25 11 .25S21.75 5.063 21.75 11 16.937 21.75 11 21.75.25 16.937.25 11ZM11 1.75a9.25 9.25 0 0 0-6.558 15.773c.18-.973.535-1.89 1.246-2.628C6.753 13.791 8.454 13.25 11 13.25c2.546 0 4.247.541 5.311 1.645.712.738 1.066 1.655 1.247 2.629A9.25 9.25 0 0 0 11 1.75Zm5.194 16.905c-.102-1.212-.365-2.1-.962-2.719-.65-.673-1.853-1.186-4.232-1.186-2.379 0-3.582.513-4.232 1.186-.597.62-.86 1.507-.962 2.72A9.207 9.207 0 0 0 11 20.25a9.208 9.208 0 0 0 5.194-1.595Z",
                fill: "#FFF"
            })
        ]
    });
var $0a51d5e1593600f1$export$2e2bcd8739ae039 = $0a51d5e1593600f1$var$SvgUserCircle;

});

parcelRegister("cKee6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cb99d53fc48fcf8$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $5cb99d53fc48fcf8$var$SvgUserPlus = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.25 4.78C4.25 2.277 6.377.25 9 .25s4.75 2.028 4.75 4.53c0 2.5-2.127 4.528-4.75 4.528S4.25 7.28 4.25 4.78ZM9 1.68c-1.795 0-3.25 1.388-3.25 3.1 0 1.71 1.455 3.098 3.25 3.098s3.25-1.387 3.25-3.099c0-1.711-1.455-3.099-3.25-3.099ZM2.976 12.087c1.58-.847 3.71-1.349 6.024-1.349s4.445.502 6.025 1.349c1.556.834 2.725 2.1 2.725 3.657v.097c.001 1.108.003 2.499-1.276 3.492-.63.488-1.51.836-2.7 1.066-1.193.23-2.748.351-4.774.351s-3.58-.121-4.774-.351c-1.19-.23-2.07-.578-2.7-1.066C.249 18.34.25 16.949.25 15.84v-.097c0-1.558 1.17-2.823 2.726-3.657Zm.735 1.247c-1.34.718-1.96 1.598-1.96 2.41 0 1.247.04 1.95.723 2.48.37.287.99.568 2.05.773 1.057.204 2.502.323 4.476.323 1.974 0 3.42-.12 4.476-.323 1.06-.205 1.68-.486 2.05-.773.684-.53.724-1.233.724-2.48 0-.812-.621-1.692-1.96-2.41-1.317-.706-3.185-1.165-5.29-1.165s-3.973.459-5.289 1.165Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M18.75 6.686c0-.395-.336-.715-.75-.715s-.75.32-.75.715v1.192H16c-.414 0-.75.32-.75.715 0 .395.336.715.75.715h1.25V10.5c0 .395.336.715.75.715s.75-.32.75-.715V9.308H20c.414 0 .75-.32.75-.715 0-.395-.336-.715-.75-.715h-1.25V6.686Z",
                fill: "#FFF"
            })
        ]
    });
var $5cb99d53fc48fcf8$export$2e2bcd8739ae039 = $5cb99d53fc48fcf8$var$SvgUserPlus;

});

parcelRegister("a5ZJ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebe5b83fd31c1d42$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $ebe5b83fd31c1d42$var$SvgUser = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 36 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18 .5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19ZM11.5 10a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM18 22.5c-4.627 0-8.89 1.052-12.049 2.829C2.84 27.079.501 29.732.501 33v.204c-.003 2.324-.006 5.24 2.552 7.323 1.259 1.025 3.02 1.754 5.4 2.236 2.386.483 5.496.737 9.547.737 4.052 0 7.162-.254 9.548-.737 2.38-.482 4.14-1.21 5.4-2.236 2.557-2.083 2.555-5 2.552-7.323V33c0-3.268-2.339-5.92-5.45-7.671C26.89 23.552 22.626 22.5 18 22.5ZM3.5 33c0-1.703 1.243-3.55 3.922-5.057C10.054 26.463 13.79 25.5 18 25.5c4.21 0 7.947.963 10.579 2.443C31.257 29.45 32.5 31.297 32.5 33c0 2.616-.08 4.088-1.447 5.2-.741.604-1.98 1.193-4.1 1.622-2.114.428-5.004.678-8.953.678-3.948 0-6.838-.25-8.952-.678-2.12-.429-3.36-1.018-4.1-1.621C3.58 37.088 3.5 35.616 3.5 33Z",
            fill: "#FFF"
        })
    });
var $ebe5b83fd31c1d42$export$2e2bcd8739ae039 = $ebe5b83fd31c1d42$var$SvgUser;

});


parcelRegister("gLoh3", function(module, exports) {

$parcel$export(module.exports, "logos", function () { return $60e045fb8ef52ff2$export$ad200f2ca1a7d990; });

var $1gh6z = parcelRequire("1gh6z");
const $60e045fb8ef52ff2$export$ad200f2ca1a7d990 = {
    RyddmLogo: $1gh6z.default
};

});
parcelRegister("1gh6z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7a7573e89186a14$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $d7a7573e89186a14$var$SvgRyddmLogo = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 142 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M74.317.558h-5.383a.537.537 0 0 0-.537.537v9.951c0 .558.744.746 1.009.256l5.383-9.951a.537.537 0 0 0-.472-.793Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M78.563.686a.524.524 0 0 0-.622.258l-9.481 17.81a.537.537 0 0 0-.063.252v4.457c0 .296.24.537.537.537h8.495c3.584 0 9.32-4.395 10.037-8.79 1.38-8.462-3.991-12.936-8.903-14.524Zm-7.049 21.116a.537.537 0 0 1-.537-.537v-2.253c0-.092.024-.182.069-.262l8.281-14.81a.512.512 0 0 1 .706-.202c4.007 2.364 6.09 7.94 4.708 11.471-1.992 5.09-5.113 5.85-7.963 6.577a.535.535 0 0 1-.133.016h-5.13Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M99.552.558h-5.384a.537.537 0 0 0-.537.537v9.951c0 .558.745.746 1.01.256l5.383-9.951a.537.537 0 0 0-.472-.793Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M103.798.686a.523.523 0 0 0-.622.258l-9.482 17.81a.538.538 0 0 0-.063.252v4.457c0 .296.24.537.537.537h8.496c3.584 0 9.32-4.395 10.037-8.79 1.38-8.462-3.991-12.936-8.903-14.524Zm-7.049 21.116a.537.537 0 0 1-.537-.537v-2.253c0-.092.024-.182.068-.262l8.282-14.81a.513.513 0 0 1 .706-.202c4.007 2.364 6.091 7.94 4.708 11.471-1.992 5.09-5.113 5.85-7.963 6.577a.54.54 0 0 1-.133.016h-5.13ZM42.524 1.394a.537.537 0 0 1 .447-.836h19.998c.424 0 .68.47.452.827l-9.06 14.148a.537.537 0 0 0-.084.29v7.64c0 .296-.24.537-.537.537h-1.125a.537.537 0 0 1-.537-.537v-7.635a.537.537 0 0 0-.09-.299L42.523 1.394Zm15.913 1.362c.422 0 .679.464.455.822l-5.48 8.75a.537.537 0 0 1-.91 0l-5.479-8.75a.537.537 0 0 1 .455-.822h10.959ZM26.562.558a.537.537 0 0 0-.537.537v22.368c0 .296.24.537.537.537h1.23c.297 0 .538-.24.538-.537v-8.044c0-.297.24-.537.537-.537h4.11c.159 0 .31.07.411.192l7.317 8.734a.537.537 0 0 0 .411.192h2.156c.464 0 .71-.547.402-.893l-7.825-8.821c-.233-.263-.153-.677.132-.883 2.414-1.74 3.16-5.79 2.288-8.45-.72-2.197-3.601-4.395-5.762-4.395h-5.945Zm6.75 11.713a.5.5 0 0 1-.173.03h-4.272a.537.537 0 0 1-.537-.538V3.88c0-.297.24-.537.537-.537h4.36c1.44.146 3.025 2.05 3.025 3.81 0 1.734-.842 4.347-2.94 5.119Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M.96 22.995h13.1",
                stroke: "#F2C94C",
                strokeWidth: 1.868,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M5.747 10.974v11.945",
                stroke: "#F2C94C",
                strokeWidth: 1.868
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "m2.695 13.03-.29.192A2.873 2.873 0 0 0 1.6 17.19l.561.855.505.669a2.873 2.873 0 0 1-.732 4.144l-.904.585",
                stroke: "#F2C94C",
                strokeWidth: 0.431
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("ellipse", {
                cx: 5.515,
                cy: 5.598,
                rx: 5.515,
                ry: 5.598,
                transform: "rotate(-5.857 13.697 -52.159) skewX(-.176)",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "m9.371 9.58-1.903-2.5-5.372 5.591c-.48.572.163 1.397.834 1.07l.095-.045L9.37 9.58Z",
                fill: "#F2C94C",
                stroke: "#F2C94C",
                strokeWidth: 0.431
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M116.889 23.329a.537.537 0 0 0 .52.671h1.636a.536.536 0 0 0 .521-.407l3.707-14.804a.537.537 0 0 1 .981-.147l4.644 7.709a.537.537 0 0 0 .92 0l4.644-7.709a.537.537 0 0 1 .981.147l3.707 14.804c.06.24.275.407.521.407h1.636a.537.537 0 0 0 .52-.671l-5.538-21.472a.537.537 0 0 0-.989-.128l-5.473 9.801a.537.537 0 0 1-.938 0l-5.473-9.8a.537.537 0 0 0-.989.127l-5.538 21.472Z",
                fill: "#F2C94C"
            })
        ]
    });
var $d7a7573e89186a14$export$2e2bcd8739ae039 = $d7a7573e89186a14$var$SvgRyddmLogo;

});



parcelRegister("94MU3", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $639c20ab08213c3b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $639c20ab08213c3b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $639c20ab08213c3b$var$_ref = {
    name: "1i4zziy",
    styles: "display:flex;align-items:center;margin-left:10px"
};
var $639c20ab08213c3b$var$_ref2 = {
    name: "zdrr8d",
    styles: "align-self:center;margin-right:auto"
};
const $639c20ab08213c3b$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;padding:10px 22px;animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.down(50), ";", ""),
                info: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.positive.normal, ";color:", theme.colors.primary.normal, ";", ""),
                warn: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";", ""),
                error: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.negative.normal, ";color:", theme.colors.primary.normal, ";", "")
            },
            content: {
                main: $639c20ab08213c3b$var$_ref2,
                message: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", "")), ";", "")
            },
            close: {
                main: $639c20ab08213c3b$var$_ref,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;cursor:pointer;", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:30px;height:30px;&>path{fill:", theme.colors.primary.normal, ";}", "")
            }
        }
    });

});
parcelRegister("4N3Qt", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $37ceb8a84e04816c$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $37ceb8a84e04816c$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $37ceb8a84e04816c$export$d25ddfdf17c3ad3e; });

var $hXJcm = parcelRequire("hXJcm");

var $exYeM = parcelRequire("exYeM");

var $T7vh0 = parcelRequire("T7vh0");

var $hC5sW = parcelRequire("hC5sW");

var $6ol0g = parcelRequire("6ol0g");
parcelRequire("kJJU8");
parcelRequire("efvJ0");
parcelRequire("3u9AZ");

parcelRequire("5n5FB");
var $37ceb8a84e04816c$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $hXJcm.h).call(props, "css")) return $exYeM.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $hXJcm.E);
    createElementArgArray[1] = (0, $hXJcm.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $exYeM.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $37ceb8a84e04816c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $hXJcm.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6ol0g.serializeStyles)([
        styles
    ], undefined, $exYeM.useContext((0, $hXJcm.T)));
    if (!(0, $hXJcm.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $exYeM.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $exYeM.useRef();
    (0, $hC5sW.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $hC5sW.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $T7vh0.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $37ceb8a84e04816c$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6ol0g.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $37ceb8a84e04816c$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $37ceb8a84e04816c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $37ceb8a84e04816c$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $37ceb8a84e04816c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $T7vh0.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $37ceb8a84e04816c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $hC5sW.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $T7vh0.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $hXJcm.i) && res !== undefined) rules += res;
        }
        if (!(0, $hXJcm.i)) return rules;
    });
    if (!(0, $hXJcm.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $exYeM.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $37ceb8a84e04816c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $hXJcm.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $hXJcm.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6ol0g.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $T7vh0.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $hXJcm.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $37ceb8a84e04816c$var$merge(cache.registered, css, $37ceb8a84e04816c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $exYeM.useContext((0, $hXJcm.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($37ceb8a84e04816c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});

parcelRegister("1SE81", function(module, exports) {

$parcel$export(module.exports, "constants", function () { return (parcelRequire("48E0n")).constants; });
$parcel$export(module.exports, "helpers", function () { return (parcelRequire("48E0n")).helpers; });
$parcel$export(module.exports, "fonts", function () { return (parcelRequire("48E0n")).fonts; });
$parcel$export(module.exports, "typography", function () { return (parcelRequire("48E0n")).typography; });
$parcel$export(module.exports, "mq", function () { return (parcelRequire("48E0n")).mq; });
$parcel$export(module.exports, "kf", function () { return (parcelRequire("48E0n")).kf; });
$parcel$export(module.exports, "z", function () { return (parcelRequire("48E0n")).z; });
$parcel$export(module.exports, "getTheme", function () { return (parcelRequire("48E0n")).getTheme; });
$parcel$export(module.exports, "getGlobal", function () { return (parcelRequire("48E0n")).getGlobal; });
$parcel$export(module.exports, "ThemeName", function () { return (parcelRequire("48E0n")).ThemeName; });
$parcel$export(module.exports, "contentLayout", function () { return (parcelRequire("4vSc9")).contentLayout; });
$parcel$export(module.exports, "contentContainer", function () { return (parcelRequire("h82af")).contentContainer; });
$parcel$export(module.exports, "stripeAppearance", function () { return (parcelRequire("cckVl")).stripeAppearance; });

var $48E0n = parcelRequire("48E0n");

var $4vSc9 = parcelRequire("4vSc9");

var $h82af = parcelRequire("h82af");

var $cckVl = parcelRequire("cckVl");

});
parcelRegister("48E0n", function(module, exports) {

$parcel$export(module.exports, "ThemeName", function () { return $fbce86dfe6cf2af6$export$14cdbe8c6bcbc8a; });
$parcel$export(module.exports, "constants", function () { return $fbce86dfe6cf2af6$export$1a988e7317c65621; });
$parcel$export(module.exports, "mq", function () { return $fbce86dfe6cf2af6$export$38e816254073c913; });
$parcel$export(module.exports, "helpers", function () { return $fbce86dfe6cf2af6$export$cbfd4c4104bf5a27; });
$parcel$export(module.exports, "fonts", function () { return $fbce86dfe6cf2af6$export$f45fbea8fe20ca8a; });
$parcel$export(module.exports, "typography", function () { return $fbce86dfe6cf2af6$export$d846a084e680d8e; });
$parcel$export(module.exports, "kf", function () { return $fbce86dfe6cf2af6$export$2b8c26fdf7ddc4b8; });
$parcel$export(module.exports, "z", function () { return $fbce86dfe6cf2af6$export$df995fae86a55f06; });
$parcel$export(module.exports, "getTheme", function () { return $fbce86dfe6cf2af6$export$89cbf1a0881c8b9c; });
$parcel$export(module.exports, "getGlobal", function () { return $fbce86dfe6cf2af6$export$a4e55266d2135a7f; });

var $4N3Qt = parcelRequire("4N3Qt");
function $fbce86dfe6cf2af6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fbce86dfe6cf2af6$export$14cdbe8c6bcbc8a;
(function(ThemeName) {
    ThemeName["Dark"] = "Dark";
    ThemeName["Light"] = "Light";
})($fbce86dfe6cf2af6$export$14cdbe8c6bcbc8a || ($fbce86dfe6cf2af6$export$14cdbe8c6bcbc8a = {}));
const $fbce86dfe6cf2af6$export$1a988e7317c65621 = {
    app: {
        container: {
            small: "1140px",
            large: "1440px"
        },
        header: {
            desktop: {
                height: "120px"
            },
            mobile: {
                height: "80px"
            }
        },
        player: {
            desktop: {
                height: "100px"
            },
            mobile: {
                height: "80px"
            }
        },
        navigation: {
            desktop: {
                width: "280px",
                height: "100vh"
            }
        },
        content: {
            desktop: {
                padding: "42px"
            },
            mobile: {
                padding: "22px"
            }
        }
    },
    library: {
        navigation: {
            desktop: {
                height: "64px",
                margin: {
                    bottom: "30px"
                }
            },
            mobile: {
                height: "64px",
                margin: {
                    bottom: "30px"
                }
            }
        }
    }
};
const $fbce86dfe6cf2af6$export$38e816254073c913 = {
    mobile: (style)=>/*#__PURE__*/ (0, $4N3Qt.css)("@media only screen and (max-width: 26.563em){", style, ";}", ""),
    tablet: (style)=>/*#__PURE__*/ (0, $4N3Qt.css)("@media only screen and (max-width: 48em){", style, ";}", ""),
    laptop: (style)=>/*#__PURE__*/ (0, $4N3Qt.css)("@media only screen and (max-width: 64em){", style, ";}", ""),
    desktop: (style)=>/*#__PURE__*/ (0, $4N3Qt.css)("@media only screen and (max-width: 90em){", style, ";}", "")
};
const $fbce86dfe6cf2af6$export$cbfd4c4104bf5a27 = {
    resetDefaults: {
        name: "5y8btj",
        styles: "border:none;outline:none;background-image:none;background-color:transparent;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none"
    },
    image: {
        name: "vep67q",
        styles: "display:block;width:100%;height:100%;object-fit:cover"
    },
    // requires fixed width { width: 170px; } | or parent with { display: flex; min-width: 0; }
    textOverflowEllipsis: {
        name: "1a4h0r7",
        styles: "display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
    },
    hideScrollbar: {
        name: "1o67s0f",
        styles: "scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{width:0;height:0;}"
    },
    app: {
        header: {
            width: /*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.navigation.desktop.width, ");", $fbce86dfe6cf2af6$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $4N3Qt.css)("height:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.desktop.height, ";", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.mobile.height, ";", "")), ";", "")
        },
        player: {
            width: /*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.navigation.desktop.width, ");", $fbce86dfe6cf2af6$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $4N3Qt.css)("height:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.desktop.height, ";", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.mobile.height, ";", "")), ";", "")
        },
        playlist: {
            width: /*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.navigation.desktop.width, ");", $fbce86dfe6cf2af6$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n          100vh -\n            (\n              ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.desktop.height, " +\n                ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.desktop.height, "\n            )\n        );", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n            100vh -\n              (\n                ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.mobile.height, " +\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.mobile.height, "\n              )\n          );", "")), ";", "")
        },
        screen: {
            width: {
                full: /*#__PURE__*/ (0, $4N3Qt.css)("width:calc(\n            100vw - (", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.desktop.padding, "*2) -\n              (", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.navigation.desktop.width, ")\n          );", $fbce86dfe6cf2af6$export$38e816254073c913.tablet(/*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - (", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.desktop.padding, "*2));", "")), " ", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - (", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.mobile.padding, "*2));", "")), ";", ""),
                content: /*#__PURE__*/ (0, $4N3Qt.css)("width:calc(\n            100vw -\n              (\n                ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.navigation.desktop.width, " +\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.desktop.padding, "\n              )\n          );", $fbce86dfe6cf2af6$export$38e816254073c913.tablet(/*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.desktop.padding, ");", "")), " ", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.mobile.padding, ");", "")), ";", "")
            },
            height: {
                full: /*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n            100vh -\n              (\n                ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.desktop.height, " +\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.desktop.height, "\n              )\n          );", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n              100vh -\n                (\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.mobile.height, " +\n                    ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.mobile.height, "\n                )\n            );", "")), ";", ""),
                home: /*#__PURE__*/ (0, $4N3Qt.css)("height:calc(100vh - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.desktop.height, ");", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:calc(100vh - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.mobile.height, ");", "")), ";", ""),
                library: /*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n            100vh -\n              (\n                ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.desktop.height, " +\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.desktop.height, " +\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.desktop.height, " +\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.desktop.margin.bottom, "\n              )\n          );", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n              100vh -\n                (\n                  ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.header.mobile.height, " +\n                    ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.player.mobile.height, " +\n                    ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.mobile.height, "+\n                    ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.mobile.margin.bottom, "\n                )\n            );", "")), ";", "")
            }
        },
        padding: {
            full: /*#__PURE__*/ (0, $4N3Qt.css)("padding:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.desktop.padding, ";", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("padding:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.mobile.padding, ";", "")), ";", ""),
            sides: /*#__PURE__*/ (0, $4N3Qt.css)("padding:0px ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.desktop.padding, ";", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("padding:0px ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.mobile.padding, ";", "")), ";", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)("padding-left:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.desktop.padding, ";", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("padding-left:", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.content.mobile.padding, ";", "")), ";", "")
        }
    },
    library: {
        header: {
            width: /*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - ", $fbce86dfe6cf2af6$export$1a988e7317c65621.app.navigation.desktop.width, ");", $fbce86dfe6cf2af6$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n          ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.desktop.height, " +\n            ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.desktop.margin.bottom, "\n        );", $fbce86dfe6cf2af6$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:calc(\n            ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.mobile.height, " +\n              ", $fbce86dfe6cf2af6$export$1a988e7317c65621.library.navigation.mobile.margin.bottom, "\n          );", "")), ";", "")
        }
    }
};
const $fbce86dfe6cf2af6$export$f45fbea8fe20ca8a = {
    primary: "Cera Pro"
};
const $fbce86dfe6cf2af6$export$d846a084e680d8e = {
    h1: "6.1rem",
    h2: "4.9rem",
    h3: "3.9rem",
    h4: "3.1rem",
    h5: "2.5rem",
    h6: "2.0rem",
    p: "1.6rem",
    sp: "1.3rem",
    c: "1rem"
};
const $fbce86dfe6cf2af6$export$2b8c26fdf7ddc4b8 = {
    slideIn: {
        up: (px)=>(0, $4N3Qt.keyframes)`
      from {
        transform: translateY(${px}px);
        opacity: 0;
      }
      to {
        transform: transformY(0px);
        opacity: 1;
      }
    `,
        down: (px)=>(0, $4N3Qt.keyframes)`
      from {
        transform: translateY(-${px}px);
        opacity: 0;
      }
      to {
        transform: transformY(0px);
        opacity: 1;
      }
    `,
        left: (px)=>(0, $4N3Qt.keyframes)`
      from {
        transform: translateX(${px}px);
        opacity: 0;
      }
      to {
        transform: transformX(0px);
        opacity: 1;
      }
    `,
        right: (px)=>(0, $4N3Qt.keyframes)`
      from {
        transform: translateX(-${px}px);
        opacity: 0;
      }
      to {
        transform: transformX(0px);
        opacity: 1;
      }
    `
    },
    load: {
        // width 85 height 50
        bars: (width, height)=>{
            const baseWidth = width / 8;
            const minHeight = 3;
            const quarterHight = height / 4;
            const halfHeight = height / 2;
            return (0, $4N3Qt.keyframes)`
        0% {
          background-size: ${baseWidth}px ${minHeight}px;
        }
        16% {
          background-size: ${baseWidth}px ${height}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px;
        }
        33% {
          background-size: ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px;
        }
        50% {
          background-size: ${baseWidth}px ${quarterHight}px,
            ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px;
        }
        66% {
          background-size: ${baseWidth}px ${minHeight}px, ${baseWidth}px ${quarterHight}px,
            ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px;
        }
        83% {
          background-size: ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${quarterHight}px, ${baseWidth}px ${halfHeight}px,
            ${baseWidth}px ${height}px, ${baseWidth}px ${minHeight}px;
        }
        100% {
          background-size: ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${quarterHight}px,
            ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px;
        }
      `;
        },
        shine: (left, top)=>(0, $4N3Qt.keyframes)`
        to {
          background-position: right ${left}px top ${top}px;
        }
    `
    }
};
const $fbce86dfe6cf2af6$export$df995fae86a55f06 = {
    app: {
        navigation: {
            mobile: "999"
        },
        header: {
            menu: "50"
        },
        modal: "777"
    },
    alert: {
        modal: "888"
    },
    onboarding: {
        backward: "10",
        stepper: {
            progress: "2",
            circle: "4"
        },
        followArtists: {
            overlay: "2"
        }
    },
    library: {
        navigation: {
            arrows: "5"
        }
    },
    components: {
        elements: {
            inputLine: {
                icon: "1"
            }
        }
    },
    features: {
        track: {
            card: {
                overlay: "2",
                menu: "3"
            },
            tile: {
                overlay: "2",
                menu: "3"
            }
        },
        post: {
            card: {
                header: "1",
                footer: "1",
                overlay: "2"
            }
        },
        user: {
            card: {
                selectedGenre: {
                    close: "1"
                }
            }
        },
        audio: {
            player: "20",
            playlist: "15"
        }
    }
};
const $fbce86dfe6cf2af6$export$89cbf1a0881c8b9c = (name)=>name === "Dark" ? {
        colors: {
            primary: {
                light: "#e7e7e7",
                // rgb(231, 231, 231)
                lightHover: "#dbdbdb",
                // rgb(219, 219, 219)
                lightActive: "#b5b5b5",
                // rgb(181, 181, 181)
                normal: "#0f0f0f",
                // rgb(15, 15, 15)
                normalHover: "#0e0e0e",
                // rgb(14, 14, 14)
                normalActive: "#0c0c0c",
                // rgb(12, 12, 12)
                dark: "#0b0b0b",
                // rgb(11, 11, 11)
                darkHover: "#090909",
                // rgb(9, 9, 9)
                darkActive: "#070707",
                // rgb(7, 7, 7)
                darker: "#050505" // rgb(5, 5, 5)
            },
            secondary: {
                light: "#fefefe",
                // rgb(254, 254, 254)
                lightHover: "#fdfdfd",
                // rgb(253, 253, 253)
                lightActive: "#fbfbfb",
                // rgb(251, 251, 251)
                normal: "#f2f2f2",
                // rgb(242, 242, 242)
                normalHover: "#dadada",
                // rgb(218, 218, 218)
                normalActive: "#c2c2c2",
                // rgb(194, 194, 194)
                dark: "#b6b6b6",
                // rgb(182, 182, 182)
                darkHover: "#919191",
                // rgb(145, 145, 145)
                darkActive: "#6d6d6d",
                // rgb(109, 109, 109)
                darker: "#555555" // rgb(85, 85, 85)
            },
            accent: {
                light: "#fefaed",
                // rgb(254, 250, 237)
                lightHover: "#fdf7e4",
                // rgb(253, 247, 228)
                lightActive: "#fbeec8",
                // rgb(251, 238, 200)
                normal: "#f2c94c",
                // rgb(242, 201, 76)
                normalHover: "#dab544",
                // rgb(218, 181, 68)
                normalActive: "#c2a13d",
                // rgb(194, 161, 61)
                dark: "#b69739",
                // rgb(182, 151, 57)+
                darkHover: "#91792e",
                // rgb(145, 121, 46)
                darkActive: "#6d5a22",
                // rgb(109, 90, 34)
                darker: "#55461b" // rgb(85, 70, 27)
            },
            positive: {
                light: "#e6f4ee",
                // rgb(230, 244, 238)
                lightHover: "#d9efe5",
                // rgb(217, 239, 229)
                lightActive: "#b0dec9",
                // rgb(176, 222, 201)
                normal: "#009452",
                // rgb(0, 148, 82)
                normalHover: "#00854a",
                // rgb(0, 133, 74)
                normalActive: "#007642",
                // rgb(0, 118, 66)
                dark: "#006f3e",
                // rgb(0, 111, 62)
                darkHover: "#005931",
                // rgb(0, 89, 49)
                darkActive: "#004325",
                // rgb(0, 67, 37)
                darker: "#00341d" // rgb(0, 52, 29)
            },
            negative: {
                light: "#ffebe8",
                // rgb(255, 235, 232)
                lightHover: "#ffe2dd",
                // rgb(255, 226, 221)
                lightActive: "#fec2b8",
                // rgb(254, 194, 184)
                normal: "#fc3b1b",
                // rgb(252, 59, 27)
                normalHover: "#e33518",
                // rgb(227, 53, 24)
                normalActive: "#ca2f16",
                // rgb(202, 47, 22)
                dark: "#bd2c14",
                // rgb(189, 44, 20)
                darkHover: "#972310",
                // rgb(151, 35, 16)
                darkActive: "#711b0c",
                // rgb(113, 27, 12)
                darker: "#581509" // rgb(88, 21, 9)
            }
        }
    } : {
        colors: {
            primary: {
                light: "#fefefe",
                // rgb(254, 254, 254)
                lightHover: "#fdfdfd",
                // rgb(253, 253, 253)
                lightActive: "#fbfbfb",
                // rgb(251, 251, 251)
                normal: "#f2f2f2",
                // rgb(242, 242, 242)
                normalHover: "#dadada",
                // rgb(218, 218, 218)
                normalActive: "#c2c2c2",
                // rgb(194, 194, 194)
                dark: "#b6b6b6",
                // rgb(182, 182, 182)
                darkHover: "#919191",
                // rgb(145, 145, 145)
                darkActive: "#6d6d6d",
                // rgb(109, 109, 109)
                darker: "#555555" // rgb(85, 85, 85)
            },
            secondary: {
                light: "#e7e7e7",
                // rgb(231, 231, 231)
                lightHover: "#dbdbdb",
                // rgb(219, 219, 219)
                lightActive: "#b5b5b5",
                // rgb(181, 181, 181)
                normal: "#0f0f0f",
                // rgb(15, 15, 15)
                normalHover: "#0e0e0e",
                // rgb(14, 14, 14)
                normalActive: "#0c0c0c",
                // rgb(12, 12, 12)
                dark: "#0b0b0b",
                // rgb(11, 11, 11)
                darkHover: "#090909",
                // rgb(9, 9, 9)
                darkActive: "#070707",
                // rgb(7, 7, 7)
                darker: "#050505" // rgb(5, 5, 5)
            },
            accent: {
                light: "#f3edfc",
                // rgb(243, 237, 252)
                lightHover: "#ede4fb",
                // rgb(237, 228, 251)
                lightActive: "#d9c7f7",
                // rgb(217, 199, 247)
                normal: "#864be5",
                // rgb(134, 75, 229)
                normalHover: "#7944ce",
                // rgb(121, 68, 206)
                normalActive: "#6b3cb7",
                // rgb(107, 60, 183)
                dark: "#6538ac",
                // rgb(101, 56, 172)
                darkHover: "#502d89",
                // rgb(80, 45, 137)
                darkActive: "#3c2267",
                // rgb(60, 34, 103)
                darker: "#2f1a50" // rgb(47, 26, 80)
            },
            positive: {
                light: "#e6f1e6",
                // rgb(230, 241, 230)
                lightHover: "#daead9",
                // rgb(218, 234, 217)
                lightActive: "#b2d4b1",
                // rgb(178, 212, 177)
                normal: "#077502",
                // rgb(7, 117, 2)
                normalHover: "#066902",
                // rgb(6, 105, 2)
                normalActive: "#065e02",
                // rgb(6, 94, 2)
                dark: "#055802",
                // rgb(5, 88, 2)
                darkHover: "#044601",
                // rgb(4, 70, 1)
                darkActive: "#033501",
                // rgb(3, 53, 1)
                darker: "#022901" // rgb(2, 41, 1)
            },
            negative: {
                light: "#f9e9e6",
                // rgb(249, 233, 230)
                lightHover: "#f6ddd9",
                // rgb(246, 221, 217)
                lightActive: "#ebb9b1",
                // rgb(235, 185, 177)
                normal: "#c01e04",
                // rgb(192, 30, 4)
                normalHover: "#ad1b04",
                // rgb(173, 27, 4)
                normalActive: "#9a1803",
                // rgb(154, 24, 3)
                dark: "#901703",
                // rgb(144, 23, 3)
                darkHover: "#731202",
                // rgb(115, 18, 2)
                darkActive: "#560d02",
                // rgb(86, 13, 2)
                darker: "#430b01" // rgb(67, 11, 1)
            }
        }
    };
const $fbce86dfe6cf2af6$export$a4e55266d2135a7f = (name)=>/*#__PURE__*/ (0, $4N3Qt.css)("*,*::before,*::after{box-sizing:inherit;margin:0;padding:0;}html{box-sizing:border-box;font-size:62.5%;background-color:", $fbce86dfe6cf2af6$export$89cbf1a0881c8b9c(name).colors.primary.normal, ";overflow:hidden;@media only screen and (max-width: 48em){font-size:56.25%;}@media only screen and (max-width: 26.563em){font-size:50%;}}body{font-family:", $fbce86dfe6cf2af6$export$f45fbea8fe20ca8a.primary, ",sans-serif,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:", $fbce86dfe6cf2af6$export$d846a084e680d8e.p, ";font-weight:400;line-height:1.4;color:", $fbce86dfe6cf2af6$export$89cbf1a0881c8b9c(name).colors.secondary.normal, ";}#app{position:relative;}::selection{background:", $fbce86dfe6cf2af6$export$89cbf1a0881c8b9c(name).colors.accent.normal, ";color:", $fbce86dfe6cf2af6$export$89cbf1a0881c8b9c(name).colors.primary.normal, ";}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:active,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus,select:-webkit-autofill:active{-webkit-transition-delay:9999s;transition-delay:9999s;}", "");

});

parcelRegister("4vSc9", function(module, exports) {

$parcel$export(module.exports, "contentLayout", function () { return $ded6d779f2ac0841$export$f923184c0f9fe848; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ded6d779f2ac0841$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ded6d779f2ac0841$export$f923184c0f9fe848 = {
    home: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:", (0, $48E0n.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    },
    feed: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:", (0, $48E0n.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    },
    library: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:", (0, $48E0n.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    },
    charts: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:", (0, $48E0n.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    },
    studio: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:", (0, $48E0n.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    },
    user: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:", (0, $48E0n.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    },
    post: {
        current: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("overflow:hidden;padding:0px;margin:0px;", (0, $48E0n.mq).mobile({
                name: "1pgg23o",
                styles: "padding:0px;margin:0px"
            }), ";", ""),
            header: {
                main: {
                    name: "1adafot",
                    styles: "padding-right:0px;max-width:800px"
                },
                title: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                }
            },
            navigation: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";", "")
            },
            container: {
                main: {
                    name: "ddxhyk",
                    styles: "max-width:800px"
                }
            }
        },
        create: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("overflow:hidden;padding:0px;margin-bottom:8px;", (0, $48E0n.mq).mobile({
                name: "4e837x",
                styles: "padding:0px;margin-bottom:0px"
            }), ";", ""),
            header: {
                main: {
                    name: "v4gdnl",
                    styles: "padding-right:0px"
                },
                title: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                }
            },
            navigation: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("overflow:hidden;width:400px;", (0, $48E0n.mq).tablet(/*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - (", (0, $48E0n.constants).app.content.desktop.padding, "*2));", "")), " ", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - (", (0, $48E0n.constants).app.content.mobile.padding, "*2));", "")), ";", "")
            },
            container: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    },
    onboarding: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("overflow:hidden;padding:0px;", (0, $48E0n.mq).mobile({
            name: "3tvnwt",
            styles: "margin-bottom:0px;padding:0px"
        }), ";", ""),
        header: {
            main: {
                name: "v4gdnl",
                styles: "padding-right:0px"
            },
            title: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - ", (0, $48E0n.constants).app.content.desktop.padding, ");overflow:hidden;", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("width:calc(100vw - (", (0, $48E0n.constants).app.content.mobile.padding, "*2));", "")), ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    }
};

});

parcelRegister("h82af", function(module, exports) {

$parcel$export(module.exports, "contentContainer", function () { return $babb63cc81f7c409$export$8f981dffec84ba52; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $babb63cc81f7c409$export$8f981dffec84ba52 = {
    charts: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", "")
    },
    feed: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", "")
    },
    home: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.home, ";", "")
    },
    library: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.library, ";", "")
    },
    notifications: {
        notifications: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        },
        notification: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        }
    },
    post: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
    },
    profile: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
    },
    reports: {
        reports: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        },
        report: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        },
        complaint: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        }
    },
    studio: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", ""),
        createPost: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        },
        createTrack: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        },
        editPost: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        },
        editTrack: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", (0, $48E0n.helpers).app.padding.sides, ";", "")
        }
    },
    user: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.height.full, ";", "")
    }
};

});

parcelRegister("cckVl", function(module, exports) {

$parcel$export(module.exports, "stripeAppearance", function () { return $aa7050a98bc4c0fd$export$f6c7b8928647b07; });
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $aa7050a98bc4c0fd$export$f6c7b8928647b07 = (theme)=>({
        theme: "night",
        // 'stripe' | 'flat'
        labels: "above",
        // 'floating'
        disableAnimations: false,
        variables: {
            // General font styles
            fontFamily: (0, $48E0n.fonts).primary,
            // fontSmooth?: string;
            // fontVariantLigatures?: string;
            // fontVariationSettings?: string;
            // fontLineHeight?: string;
            // Font sizes
            fontSizeBase: (0, $48E0n.typography).sp,
            // fontSizeSm?: string;
            // fontSizeXs?: string;
            // fontSize2Xs?: string;
            // fontSize3Xs?: string;
            // fontSizeLg?: string;
            // fontSizeXl?: string;
            // Font weights
            // fontWeightLight?: string;
            // fontWeightNormal?: string;
            // fontWeightMedium?: string;
            // fontWeightBold?: string;
            // Spacing
            // spacingUnit?: string;
            // spacingGridRow?: string;
            // spacingGridColumn?: string;
            // spacingTab?: string;
            // spacingAccordionItem?: string;
            // Colors
            colorPrimary: theme.colors.accent.normal,
            // colorPrimaryText?: string;
            colorBackground: theme.colors.primary.normal,
            // colorBackgroundText?: string;
            colorText: theme.colors.secondary.normal,
            // colorSuccess?: string;
            // colorSuccessText?: string;
            colorDanger: theme.colors.negative.normal,
            colorDangerText: theme.colors.negative.normal,
            // colorWarning?: string;
            // colorWarningText?: string;
            // Text variations
            // colorTextSecondary?: string;
            colorTextPlaceholder: theme.colors.secondary.dark,
            // Icons
            colorIcon: theme.colors.accent.normal,
            // colorIconHover?: string;
            // colorIconCardError?: string;
            // colorIconCardCvc?: string;
            // colorIconCardCvcError?: string;
            // colorIconCheckmark?: string;
            // colorIconChevronDown?: string;
            // colorIconChevronDownHover?: string;
            // colorIconRedirect?: string;
            // colorIconTab?: string;
            // colorIconTabHover?: string;
            // colorIconTabSelected?: string;
            // colorIconTabMore?: string;
            // colorIconTabMoreHover?: string;
            // Logos
            // colorLogo?: string;
            // colorLogoTab?: string;
            // colorLogoTabSelected?: string;
            // colorLogoBlock?: string;
            // Focus
            focusBoxShadow: "none",
            // focusOutline?: string,
            // Radius
            borderRadius: "14px"
        }
    });

});




parcelRegister("9kzze", function(module, exports) {

$parcel$export(module.exports, "AlertModal", function () { return $97dd0406988a80b1$export$fdc96b94563d4a64; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $1brtB = parcelRequire("1brtB");
var $joOpk = parcelRequire("joOpk");

var $djJdy = parcelRequire("djJdy");
const $97dd0406988a80b1$export$fdc96b94563d4a64 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const messages = (0, $9CcOD.useAppSelector)((0, $joOpk.alertSelectMessages));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $djJdy.styles)().modal.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $djJdy.styles)().modal.content.main,
            children: messages.map((message)=>{
                const { id: messageId } = message;
                return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $djJdy.styles)().modal.content.message,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1brtB.AlertCard), {
                        alertMessage: message,
                        onTimeout: ()=>dispatch((0, $joOpk.alertRemoveMessage)({
                                messageId: messageId
                            })),
                        onCloseClick: ()=>dispatch((0, $joOpk.alertRemoveMessage)({
                                messageId: messageId
                            }))
                    })
                }, `alert-message-${messageId}`);
            })
        })
    });
};
$97dd0406988a80b1$export$fdc96b94563d4a64.propTypes = {};

});
parcelRegister("11A9z", function(module, exports) {
$parcel$export(module.exports, "useComment", function () { return (parcelRequire("5F6ta")).useComment; });
$parcel$export(module.exports, "useConnectPayout", function () { return (parcelRequire("bMcg5")).useConnectPayout; });
$parcel$export(module.exports, "useConnectReady", function () { return (parcelRequire("9a5k4")).useConnectReady; });
$parcel$export(module.exports, "usePost", function () { return (parcelRequire("lBv1N")).usePost; });
$parcel$export(module.exports, "useSubscription", function () { return (parcelRequire("2qAsB")).useSubscription; });
$parcel$export(module.exports, "useSubscriptionPrice", function () { return (parcelRequire("aC0Kg")).useSubscriptionPrice; });
$parcel$export(module.exports, "useTip", function () { return (parcelRequire("hiFdq")).useTip; });
$parcel$export(module.exports, "useTrack", function () { return (parcelRequire("yKMRU")).useTrack; });
$parcel$export(module.exports, "useTracks", function () { return (parcelRequire("d1vGL")).useTracks; });
$parcel$export(module.exports, "useTracksPublic", function () { return (parcelRequire("1UJJS")).useTracksPublic; });
$parcel$export(module.exports, "useUnlock", function () { return (parcelRequire("f7MpX")).useUnlock; });
$parcel$export(module.exports, "useUser", function () { return (parcelRequire("gSFbK")).useUser; });
$parcel$export(module.exports, "useUserPublic", function () { return (parcelRequire("4y2bm")).useUserPublic; });
$parcel$export(module.exports, "useUsers", function () { return (parcelRequire("8a4Bv")).useUsers; });
$parcel$export(module.exports, "useUserStats", function () { return (parcelRequire("2Tvde")).useUserStats; });

$parcel$export(module.exports, "useAppSelector", function () { return (parcelRequire("9CcOD")).useAppSelector; });
$parcel$export(module.exports, "useAppDispatch", function () { return (parcelRequire("glGsK")).useAppDispatch; });
$parcel$export(module.exports, "useFile", function () { return (parcelRequire("hrd7b")).useFile; });
$parcel$export(module.exports, "useInterval", function () { return (parcelRequire("86QaR")).useInterval; });

var $9CcOD = parcelRequire("9CcOD");

var $glGsK = parcelRequire("glGsK");

var $hrd7b = parcelRequire("hrd7b");

var $86QaR = parcelRequire("86QaR");

var $d6Ezf = parcelRequire("d6Ezf");
parcelRequire("LLqcH");

});
parcelRegister("9CcOD", function(module, exports) {

$parcel$export(module.exports, "useAppSelector", function () { return $61ac91310b68d254$export$a7347740d65f620b; });

var $8is9z = parcelRequire("8is9z");
const $61ac91310b68d254$export$a7347740d65f620b = (0, $8is9z.useSelector);

});
parcelRegister("8is9z", function(module, exports) {

$parcel$export(module.exports, "useSelector", function () { return $60a5d7d613f33ae6$export$2105062e25df4afe; });
$parcel$export(module.exports, "Provider", function () { return $60a5d7d613f33ae6$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useDispatch", function () { return $60a5d7d613f33ae6$export$8ad76b76a4c905f8; });

var $exYeM = parcelRequire("exYeM");

var $16RTd = parcelRequire("16RTd");
var $60a5d7d613f33ae6$var$__defProp = Object.defineProperty;
var $60a5d7d613f33ae6$var$__defProps = Object.defineProperties;
var $60a5d7d613f33ae6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $60a5d7d613f33ae6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $60a5d7d613f33ae6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $60a5d7d613f33ae6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $60a5d7d613f33ae6$var$__defNormalProp = (obj, key, value)=>key in obj ? $60a5d7d613f33ae6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $60a5d7d613f33ae6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($60a5d7d613f33ae6$var$__hasOwnProp.call(b, prop)) $60a5d7d613f33ae6$var$__defNormalProp(a, prop, b[prop]);
    if ($60a5d7d613f33ae6$var$__getOwnPropSymbols) {
        for (var prop of $60a5d7d613f33ae6$var$__getOwnPropSymbols(b))if ($60a5d7d613f33ae6$var$__propIsEnum.call(b, prop)) $60a5d7d613f33ae6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $60a5d7d613f33ae6$var$__spreadProps = (a, b)=>$60a5d7d613f33ae6$var$__defProps(a, $60a5d7d613f33ae6$var$__getOwnPropDescs(b));
var $60a5d7d613f33ae6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($60a5d7d613f33ae6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $60a5d7d613f33ae6$var$__getOwnPropSymbols) {
        for (var prop of $60a5d7d613f33ae6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $60a5d7d613f33ae6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $60a5d7d613f33ae6$var$React = // prettier-ignore
// @ts-ignore
"default" in $exYeM ? $exYeM["default"] : $exYeM;
// src/components/Context.ts
var $60a5d7d613f33ae6$var$ContextKey = Symbol.for(`react-redux-context`);
var $60a5d7d613f33ae6$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $60a5d7d613f33ae6$var$getContext() {
    var _a;
    if (!$60a5d7d613f33ae6$var$React.createContext) return {};
    const contextMap = (_a = $60a5d7d613f33ae6$var$gT[$60a5d7d613f33ae6$var$ContextKey]) != null ? _a : $60a5d7d613f33ae6$var$gT[$60a5d7d613f33ae6$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($60a5d7d613f33ae6$var$React.createContext);
    if (!realContext) {
        realContext = $60a5d7d613f33ae6$var$React.createContext(null);
        contextMap.set($60a5d7d613f33ae6$var$React.createContext, realContext);
    }
    return realContext;
}
var $60a5d7d613f33ae6$export$cc80c08dc91f1c00 = /* @__PURE__ */ $60a5d7d613f33ae6$var$getContext();
// src/utils/useSyncExternalStore.ts
var $60a5d7d613f33ae6$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $60a5d7d613f33ae6$var$createReduxContextHook(context = $60a5d7d613f33ae6$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $60a5d7d613f33ae6$var$React.useContext(context);
        return contextValue;
    };
}
var $60a5d7d613f33ae6$var$useReduxContext = /* @__PURE__ */ $60a5d7d613f33ae6$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $60a5d7d613f33ae6$var$useSyncExternalStoreWithSelector = $60a5d7d613f33ae6$var$notInitialized;
var $60a5d7d613f33ae6$var$initializeUseSelector = (fn)=>{
    $60a5d7d613f33ae6$var$useSyncExternalStoreWithSelector = fn;
};
var $60a5d7d613f33ae6$var$refEquality = (a, b)=>a === b;
function $60a5d7d613f33ae6$export$2b53f90d2bd1cbfb(context = $60a5d7d613f33ae6$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $60a5d7d613f33ae6$export$cc80c08dc91f1c00 ? $60a5d7d613f33ae6$var$useReduxContext : $60a5d7d613f33ae6$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $60a5d7d613f33ae6$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $60a5d7d613f33ae6$var$React.useRef(true);
        const wrappedSelector = $60a5d7d613f33ae6$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $60a5d7d613f33ae6$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $60a5d7d613f33ae6$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $60a5d7d613f33ae6$export$2105062e25df4afe = /* @__PURE__ */ $60a5d7d613f33ae6$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $60a5d7d613f33ae6$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $60a5d7d613f33ae6$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $60a5d7d613f33ae6$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $60a5d7d613f33ae6$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $60a5d7d613f33ae6$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $60a5d7d613f33ae6$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $60a5d7d613f33ae6$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $60a5d7d613f33ae6$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $60a5d7d613f33ae6$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $60a5d7d613f33ae6$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $60a5d7d613f33ae6$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $60a5d7d613f33ae6$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $60a5d7d613f33ae6$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $60a5d7d613f33ae6$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $60a5d7d613f33ae6$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $60a5d7d613f33ae6$var$ForwardRef = $60a5d7d613f33ae6$var$REACT_FORWARD_REF_TYPE;
var $60a5d7d613f33ae6$var$Memo = $60a5d7d613f33ae6$var$REACT_MEMO_TYPE;
function $60a5d7d613f33ae6$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $60a5d7d613f33ae6$var$REACT_FRAGMENT_TYPE || type === $60a5d7d613f33ae6$var$REACT_PROFILER_TYPE || type === $60a5d7d613f33ae6$var$REACT_STRICT_MODE_TYPE || type === $60a5d7d613f33ae6$var$REACT_SUSPENSE_TYPE || type === $60a5d7d613f33ae6$var$REACT_SUSPENSE_LIST_TYPE || type === $60a5d7d613f33ae6$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $60a5d7d613f33ae6$var$REACT_LAZY_TYPE || type.$$typeof === $60a5d7d613f33ae6$var$REACT_MEMO_TYPE || type.$$typeof === $60a5d7d613f33ae6$var$REACT_PROVIDER_TYPE || type.$$typeof === $60a5d7d613f33ae6$var$REACT_CONTEXT_TYPE || type.$$typeof === $60a5d7d613f33ae6$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $60a5d7d613f33ae6$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $60a5d7d613f33ae6$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $60a5d7d613f33ae6$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $60a5d7d613f33ae6$var$REACT_FRAGMENT_TYPE:
                        case $60a5d7d613f33ae6$var$REACT_PROFILER_TYPE:
                        case $60a5d7d613f33ae6$var$REACT_STRICT_MODE_TYPE:
                        case $60a5d7d613f33ae6$var$REACT_SUSPENSE_TYPE:
                        case $60a5d7d613f33ae6$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $60a5d7d613f33ae6$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $60a5d7d613f33ae6$var$REACT_CONTEXT_TYPE:
                                    case $60a5d7d613f33ae6$var$REACT_FORWARD_REF_TYPE:
                                    case $60a5d7d613f33ae6$var$REACT_LAZY_TYPE:
                                    case $60a5d7d613f33ae6$var$REACT_MEMO_TYPE:
                                    case $60a5d7d613f33ae6$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $60a5d7d613f33ae6$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $60a5d7d613f33ae6$var$isContextConsumer(object) {
    return $60a5d7d613f33ae6$var$typeOf(object) === $60a5d7d613f33ae6$var$REACT_CONTEXT_TYPE;
}
function $60a5d7d613f33ae6$var$isMemo(object) {
    return $60a5d7d613f33ae6$var$typeOf(object) === $60a5d7d613f33ae6$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $60a5d7d613f33ae6$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $60a5d7d613f33ae6$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $60a5d7d613f33ae6$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $60a5d7d613f33ae6$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $60a5d7d613f33ae6$var$verify(mapStateToProps, "mapStateToProps");
    $60a5d7d613f33ae6$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $60a5d7d613f33ae6$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $60a5d7d613f33ae6$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $60a5d7d613f33ae6$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $60a5d7d613f33ae6$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $60a5d7d613f33ae6$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $60a5d7d613f33ae6$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $60a5d7d613f33ae6$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $60a5d7d613f33ae6$var$verifyPlainObject(value, displayName, methodName) {
    if (!$60a5d7d613f33ae6$var$isPlainObject(value)) $60a5d7d613f33ae6$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $60a5d7d613f33ae6$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $60a5d7d613f33ae6$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $60a5d7d613f33ae6$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $60a5d7d613f33ae6$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $60a5d7d613f33ae6$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $60a5d7d613f33ae6$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $60a5d7d613f33ae6$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $60a5d7d613f33ae6$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $60a5d7d613f33ae6$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $60a5d7d613f33ae6$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $60a5d7d613f33ae6$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $60a5d7d613f33ae6$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $60a5d7d613f33ae6$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $60a5d7d613f33ae6$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $60a5d7d613f33ae6$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $60a5d7d613f33ae6$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $60a5d7d613f33ae6$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $60a5d7d613f33ae6$var$__spreadValues($60a5d7d613f33ae6$var$__spreadValues($60a5d7d613f33ae6$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $60a5d7d613f33ae6$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $60a5d7d613f33ae6$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$60a5d7d613f33ae6$var$defaultMergeProps : typeof mergeProps === "function" ? $60a5d7d613f33ae6$var$wrapMergePropsFunc(mergeProps) : $60a5d7d613f33ae6$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $60a5d7d613f33ae6$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $60a5d7d613f33ae6$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $60a5d7d613f33ae6$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $60a5d7d613f33ae6$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $60a5d7d613f33ae6$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $60a5d7d613f33ae6$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $60a5d7d613f33ae6$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $60a5d7d613f33ae6$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $60a5d7d613f33ae6$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $60a5d7d613f33ae6$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $60a5d7d613f33ae6$var$useIsomorphicLayoutEffect = $60a5d7d613f33ae6$var$canUseDOM || $60a5d7d613f33ae6$var$isReactNative ? $60a5d7d613f33ae6$var$React.useLayoutEffect : $60a5d7d613f33ae6$var$React.useEffect;
// src/utils/shallowEqual.ts
function $60a5d7d613f33ae6$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $60a5d7d613f33ae6$export$d36bdfa510afb180(objA, objB) {
    if ($60a5d7d613f33ae6$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$60a5d7d613f33ae6$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $60a5d7d613f33ae6$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $60a5d7d613f33ae6$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $60a5d7d613f33ae6$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $60a5d7d613f33ae6$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $60a5d7d613f33ae6$var$TYPE_STATICS = {
    [$60a5d7d613f33ae6$var$ForwardRef]: $60a5d7d613f33ae6$var$FORWARD_REF_STATICS,
    [$60a5d7d613f33ae6$var$Memo]: $60a5d7d613f33ae6$var$MEMO_STATICS
};
function $60a5d7d613f33ae6$var$getStatics(component) {
    if ($60a5d7d613f33ae6$var$isMemo(component)) return $60a5d7d613f33ae6$var$MEMO_STATICS;
    return $60a5d7d613f33ae6$var$TYPE_STATICS[component["$$typeof"]] || $60a5d7d613f33ae6$var$REACT_STATICS;
}
var $60a5d7d613f33ae6$var$defineProperty = Object.defineProperty;
var $60a5d7d613f33ae6$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $60a5d7d613f33ae6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $60a5d7d613f33ae6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $60a5d7d613f33ae6$var$getPrototypeOf = Object.getPrototypeOf;
var $60a5d7d613f33ae6$var$objectPrototype = Object.prototype;
function $60a5d7d613f33ae6$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($60a5d7d613f33ae6$var$objectPrototype) {
            const inheritedComponent = $60a5d7d613f33ae6$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $60a5d7d613f33ae6$var$objectPrototype) $60a5d7d613f33ae6$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $60a5d7d613f33ae6$var$getOwnPropertyNames(sourceComponent);
        if ($60a5d7d613f33ae6$var$getOwnPropertySymbols) keys = keys.concat($60a5d7d613f33ae6$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $60a5d7d613f33ae6$var$getStatics(targetComponent);
        const sourceStatics = $60a5d7d613f33ae6$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$60a5d7d613f33ae6$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $60a5d7d613f33ae6$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $60a5d7d613f33ae6$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $60a5d7d613f33ae6$var$useSyncExternalStore = $60a5d7d613f33ae6$var$notInitialized;
var $60a5d7d613f33ae6$var$initializeConnect = (fn)=>{
    $60a5d7d613f33ae6$var$useSyncExternalStore = fn;
};
var $60a5d7d613f33ae6$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $60a5d7d613f33ae6$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $60a5d7d613f33ae6$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $60a5d7d613f33ae6$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $60a5d7d613f33ae6$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $60a5d7d613f33ae6$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $60a5d7d613f33ae6$var$strictEqual(a, b) {
    return a === b;
}
var $60a5d7d613f33ae6$var$hasWarnedAboutDeprecatedPureOption = false;
function $60a5d7d613f33ae6$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $60a5d7d613f33ae6$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $60a5d7d613f33ae6$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $60a5d7d613f33ae6$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $60a5d7d613f33ae6$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $60a5d7d613f33ae6$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $60a5d7d613f33ae6$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $60a5d7d613f33ae6$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $60a5d7d613f33ae6$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $60a5d7d613f33ae6$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $60a5d7d613f33ae6$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                return $60a5d7d613f33ae6$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $60a5d7d613f33ae6$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $60a5d7d613f33ae6$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $60a5d7d613f33ae6$var$__spreadProps($60a5d7d613f33ae6$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $60a5d7d613f33ae6$var$React.useRef(void 0);
            const lastWrapperProps = $60a5d7d613f33ae6$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $60a5d7d613f33ae6$var$React.useRef(void 0);
            const renderIsScheduled = $60a5d7d613f33ae6$var$React.useRef(false);
            const isMounted = $60a5d7d613f33ae6$var$React.useRef(false);
            const latestSubscriptionCallbackError = $60a5d7d613f33ae6$var$React.useRef(void 0);
            $60a5d7d613f33ae6$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $60a5d7d613f33ae6$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $60a5d7d613f33ae6$var$useIsomorphicLayoutEffectWithArgs($60a5d7d613f33ae6$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $60a5d7d613f33ae6$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $60a5d7d613f33ae6$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $60a5d7d613f33ae6$var$React.createElement(WrappedComponent, $60a5d7d613f33ae6$var$__spreadProps($60a5d7d613f33ae6$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $60a5d7d613f33ae6$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $60a5d7d613f33ae6$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $60a5d7d613f33ae6$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $60a5d7d613f33ae6$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $60a5d7d613f33ae6$var$React.createElement(Connect, $60a5d7d613f33ae6$var$__spreadProps($60a5d7d613f33ae6$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $60a5d7d613f33ae6$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $60a5d7d613f33ae6$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $60a5d7d613f33ae6$export$64605811ab45167f = $60a5d7d613f33ae6$var$connect;
// src/components/Provider.tsx
function $60a5d7d613f33ae6$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $60a5d7d613f33ae6$var$React.useMemo(()=>{
        const subscription = $60a5d7d613f33ae6$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $60a5d7d613f33ae6$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $60a5d7d613f33ae6$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $60a5d7d613f33ae6$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $60a5d7d613f33ae6$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $60a5d7d613f33ae6$export$2881499e37b75b9a = $60a5d7d613f33ae6$var$Provider;
// src/hooks/useStore.ts
function $60a5d7d613f33ae6$export$671dba69185d0304(context = $60a5d7d613f33ae6$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $60a5d7d613f33ae6$export$cc80c08dc91f1c00 ? $60a5d7d613f33ae6$var$useReduxContext : // @ts-ignore
    $60a5d7d613f33ae6$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $60a5d7d613f33ae6$export$6ccbb43953eebf8 = /* @__PURE__ */ $60a5d7d613f33ae6$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $60a5d7d613f33ae6$export$bc9b55530897c558(context = $60a5d7d613f33ae6$export$cc80c08dc91f1c00) {
    const useStore2 = context === $60a5d7d613f33ae6$export$cc80c08dc91f1c00 ? $60a5d7d613f33ae6$export$6ccbb43953eebf8 : $60a5d7d613f33ae6$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $60a5d7d613f33ae6$export$8ad76b76a4c905f8 = /* @__PURE__ */ $60a5d7d613f33ae6$export$bc9b55530897c558();
// src/exports.ts
var $60a5d7d613f33ae6$export$712ea50be43a7858 = $60a5d7d613f33ae6$var$defaultNoopBatch;
// src/index.ts
$60a5d7d613f33ae6$var$initializeUseSelector((0, $16RTd.useSyncExternalStoreWithSelector));
$60a5d7d613f33ae6$var$initializeConnect($exYeM.useSyncExternalStore);

});
parcelRegister("16RTd", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9T2YG"));

});



parcelRegister("glGsK", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", function () { return $52117f4ef802d3a0$export$f51d452c10d5b956; });

var $8is9z = parcelRequire("8is9z");
const $52117f4ef802d3a0$export$f51d452c10d5b956 = (0, $8is9z.useDispatch);

});

parcelRegister("hrd7b", function(module, exports) {

$parcel$export(module.exports, "useFile", function () { return $222ee68eddbcb41d$export$1ad42cf9b00bda68; });
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
const $222ee68eddbcb41d$export$1ad42cf9b00bda68 = (fileId, userId)=>{
    const { basePath: basePath } = (0, $jfr0f.apiGetService)();
    // if user id provided
    if (userId) return `${basePath}/file/public/file/url?fileId=${fileId}&userId=${userId}`;
    return `${basePath}/file/public/file/url?fileId=${fileId}`;
};

});
parcelRegister("ewAws", function(module, exports) {

$parcel$export(module.exports, "apiGetService", function () { return (parcelRequire("jfr0f")).apiGetService; });
$parcel$export(module.exports, "apiHandleError", function () { return (parcelRequire("jfr0f")).apiHandleError; });
$parcel$export(module.exports, "dateGetDifferenceSec", function () { return (parcelRequire("ehFe9")).dateGetDifferenceSec; });
$parcel$export(module.exports, "firebaseSignupWithEmailAndPassword", function () { return (parcelRequire("gQ3GG")).firebaseSignupWithEmailAndPassword; });
$parcel$export(module.exports, "firebaseLoginWithEmailAndPassword", function () { return (parcelRequire("gQ3GG")).firebaseLoginWithEmailAndPassword; });
$parcel$export(module.exports, "firebaseLoginWithGoogle", function () { return (parcelRequire("gQ3GG")).firebaseLoginWithGoogle; });
$parcel$export(module.exports, "firebaseLoginWithFacebook", function () { return (parcelRequire("gQ3GG")).firebaseLoginWithFacebook; });
$parcel$export(module.exports, "firebaseSendPasswordResetEmail", function () { return (parcelRequire("gQ3GG")).firebaseSendPasswordResetEmail; });
$parcel$export(module.exports, "firebaseSendVerificationEmail", function () { return (parcelRequire("gQ3GG")).firebaseSendVerificationEmail; });
$parcel$export(module.exports, "firebaseGetEmailVerified", function () { return (parcelRequire("gQ3GG")).firebaseGetEmailVerified; });
$parcel$export(module.exports, "firebaseSignout", function () { return (parcelRequire("gQ3GG")).firebaseSignout; });
$parcel$export(module.exports, "jwtDecode", function () { return (parcelRequire("lLftU")).jwtDecode; });
$parcel$export(module.exports, "jwtGetExpiresInDays", function () { return (parcelRequire("lLftU")).jwtGetExpiresInDays; });
$parcel$export(module.exports, "storageGetAuthToken", function () { return (parcelRequire("vT5yJ")).storageGetAuthToken; });
$parcel$export(module.exports, "storageSetAuthToken", function () { return (parcelRequire("vT5yJ")).storageSetAuthToken; });
$parcel$export(module.exports, "storageGetSentPasswordResetEmailDate", function () { return (parcelRequire("vT5yJ")).storageGetSentPasswordResetEmailDate; });
$parcel$export(module.exports, "storageSetSentPasswordResetEmailDate", function () { return (parcelRequire("vT5yJ")).storageSetSentPasswordResetEmailDate; });
$parcel$export(module.exports, "storageGetSentVerificationEmailDate", function () { return (parcelRequire("vT5yJ")).storageGetSentVerificationEmailDate; });
$parcel$export(module.exports, "storageSetSentVerificationEmailDate", function () { return (parcelRequire("vT5yJ")).storageSetSentVerificationEmailDate; });

var $jfr0f = parcelRequire("jfr0f");

var $ehFe9 = parcelRequire("ehFe9");

var $gQ3GG = parcelRequire("gQ3GG");

var $lLftU = parcelRequire("lLftU");

var $vT5yJ = parcelRequire("vT5yJ");

});
parcelRegister("jfr0f", function(module, exports) {

$parcel$export(module.exports, "apiGetService", function () { return $5985ca50a3041471$export$c8e00e6ceb81bfe0; });
$parcel$export(module.exports, "apiHandleError", function () { return $5985ca50a3041471$export$e060db9f039c9353; });
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
var $a1ai3 = parcelRequire("a1ai3");
parcelRequire("2uUQU");
var $iyiMM = parcelRequire("iyiMM");
var $9VYkD = parcelRequire("9VYkD");
parcelRequire("ewAws");
var $vT5yJ = parcelRequire("vT5yJ");
/**
 * Creates new instance of api client.
 *
 * Takes api base path and jwt token, returns api service.
 *
 * @param {string} basePath - API base path.
 * @param {number} apiKey - API authentication token (JWT).
 * @returns {number} The sum of the two input numbers.
 *
 * @example
 * // Returns api service.
 * const apiService = createApiService('https://api.example.com/api/v1', 'eyJhbGciOiJI...');
 */ const $5985ca50a3041471$var$apiCreateService = (basePath, apiKey)=>({
        basePath: basePath,
        authApi: new (0, $aeAwZ.AuthApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        commentApi: new (0, $aeAwZ.CommentApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        connectApi: new (0, $aeAwZ.ConnectApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        customerApi: new (0, $aeAwZ.CustomerApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        fileApi: new (0, $aeAwZ.FileApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        likeApi: new (0, $aeAwZ.LikeApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        notificationApi: new (0, $aeAwZ.NotificationApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        postApi: new (0, $aeAwZ.PostApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        reportApi: new (0, $aeAwZ.ReportApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        streamApi: new (0, $aeAwZ.StreamApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        subscriptionApi: new (0, $aeAwZ.SubscriptionApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        tipApi: new (0, $aeAwZ.TipApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        trackApi: new (0, $aeAwZ.TrackApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        transactionApi: new (0, $aeAwZ.TransactionApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        unlockApi: new (0, $aeAwZ.UnlockApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        userApi: new (0, $aeAwZ.UserApi)(new (0, $a1ai3.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        }))
    });
// cachedApiService - represents cached api service.
let $5985ca50a3041471$var$cachedApiService;
const $5985ca50a3041471$export$c8e00e6ceb81bfe0 = ()=>{
    // get api url based on environment
    const basePath = "staging" === (0, $9VYkD.Environment).Production ? (0, $iyiMM.API).ProductionURL : (0, $iyiMM.API).StagingURL;
    // if no api service in cache
    if (!$5985ca50a3041471$var$cachedApiService) {
        const apiKey = (0, $vT5yJ.storageGetAuthToken)();
        // create api service and cache it
        $5985ca50a3041471$var$cachedApiService = $5985ca50a3041471$var$apiCreateService(basePath, apiKey ? `Bearer ${apiKey}` : "");
    }
    // updateApiKey - recreates api service with new authentication token and updates cache.
    const updateApiKey = (apiKey)=>{
        $5985ca50a3041471$var$cachedApiService = $5985ca50a3041471$var$apiCreateService(basePath, `Bearer ${apiKey}`);
        // return api service and update function.
        return {
            ...$5985ca50a3041471$var$cachedApiService,
            updateApiKey: updateApiKey
        };
    };
    // return api service and update function.
    return {
        ...$5985ca50a3041471$var$cachedApiService,
        updateApiKey: updateApiKey
    };
};
const $5985ca50a3041471$export$e060db9f039c9353 = async (err, context)=>{
    // if error of type response
    if (err instanceof Response) {
        // parse error
        const data = await err.json();
        const errorCode = err.status;
        const errorMessage = context ? `${context}: ${data.error}` : data.error;
        // if error severity is high
        if (errorCode >= 500) console.error(err); // eslint-disable-line no-console
        console.debug(err); // eslint-disable-line no-console
        return {
            code: errorCode,
            message: errorMessage
        };
    }
    // if error is unknown
    const errorMessage = context ? `${context}: ${err.message}` : err.message;
    console.error(err); // eslint-disable-line no-console
    return {
        code: 0,
        message: errorMessage
    };
};

});
parcelRegister("2uUQU", function(module, exports) {

$parcel$export(module.exports, "API", function () { return (parcelRequire("iyiMM")).API; });
$parcel$export(module.exports, "Environment", function () { return (parcelRequire("9VYkD")).Environment; });
$parcel$export(module.exports, "ExternalLinks", function () { return (parcelRequire("8YIJn")).ExternalLinks; });
$parcel$export(module.exports, "Path", function () { return (parcelRequire("9YTSb")).Path; });
$parcel$export(module.exports, "Params", function () { return (parcelRequire("9YTSb")).Params; });
$parcel$export(module.exports, "Platform", function () { return (parcelRequire("8kVRe")).Platform; });
$parcel$export(module.exports, "StorageKeys", function () { return (parcelRequire("bL329")).StorageKeys; });
$parcel$export(module.exports, "minCommentMessageLength", function () { return (parcelRequire("ck17w")).minCommentMessageLength; });
$parcel$export(module.exports, "maxCommentMessageLength", function () { return (parcelRequire("ck17w")).maxCommentMessageLength; });
$parcel$export(module.exports, "minTipAmount", function () { return (parcelRequire("lyE92")).minTipAmount; });
$parcel$export(module.exports, "maxTipAmount", function () { return (parcelRequire("lyE92")).maxTipAmount; });
$parcel$export(module.exports, "minTipMessageLength", function () { return (parcelRequire("lyE92")).minTipMessageLength; });
$parcel$export(module.exports, "maxTipMessageLength", function () { return (parcelRequire("lyE92")).maxTipMessageLength; });
$parcel$export(module.exports, "minReportComplaintLength", function () { return (parcelRequire("kDwrL")).minReportComplaintLength; });
$parcel$export(module.exports, "maxReportComplaintLength", function () { return (parcelRequire("kDwrL")).maxReportComplaintLength; });
$parcel$export(module.exports, "complaintTypeSelectOptions", function () { return (parcelRequire("kDwrL")).complaintTypeSelectOptions; });
$parcel$export(module.exports, "minPostMessageLength", function () { return (parcelRequire("P3Zb0")).minPostMessageLength; });
$parcel$export(module.exports, "maxPostMessageLength", function () { return (parcelRequire("P3Zb0")).maxPostMessageLength; });
$parcel$export(module.exports, "minPostUnlockPrice", function () { return (parcelRequire("P3Zb0")).minPostUnlockPrice; });
$parcel$export(module.exports, "maxPostUnlockPrice", function () { return (parcelRequire("P3Zb0")).maxPostUnlockPrice; });
$parcel$export(module.exports, "maxPostTracksCount", function () { return (parcelRequire("P3Zb0")).maxPostTracksCount; });
$parcel$export(module.exports, "maxPostMediaFileSize", function () { return (parcelRequire("P3Zb0")).maxPostMediaFileSize; });
$parcel$export(module.exports, "minTrackNameLength", function () { return (parcelRequire("6U1f3")).minTrackNameLength; });
$parcel$export(module.exports, "maxTrackNameLength", function () { return (parcelRequire("6U1f3")).maxTrackNameLength; });
$parcel$export(module.exports, "minTrackUnlockPrice", function () { return (parcelRequire("6U1f3")).minTrackUnlockPrice; });
$parcel$export(module.exports, "maxTrackUnlockPrice", function () { return (parcelRequire("6U1f3")).maxTrackUnlockPrice; });
$parcel$export(module.exports, "maxTrackCoverFileSize", function () { return (parcelRequire("6U1f3")).maxTrackCoverFileSize; });
$parcel$export(module.exports, "maxTrackFileSize", function () { return (parcelRequire("6U1f3")).maxTrackFileSize; });
$parcel$export(module.exports, "minUserNameLength", function () { return (parcelRequire("bs6PN")).minUserNameLength; });
$parcel$export(module.exports, "maxUserNameLength", function () { return (parcelRequire("bs6PN")).maxUserNameLength; });
$parcel$export(module.exports, "minUserUsernameLength", function () { return (parcelRequire("bs6PN")).minUserUsernameLength; });
$parcel$export(module.exports, "maxUserUsernameLength", function () { return (parcelRequire("bs6PN")).maxUserUsernameLength; });
$parcel$export(module.exports, "minUserPasswordLength", function () { return (parcelRequire("bs6PN")).minUserPasswordLength; });
$parcel$export(module.exports, "maxUserAvatarFileSize", function () { return (parcelRequire("bs6PN")).maxUserAvatarFileSize; });
$parcel$export(module.exports, "firebaseConfigProd", function () { return (parcelRequire("lpelr")).firebaseConfigProd; });
$parcel$export(module.exports, "firebaseConfigStag", function () { return (parcelRequire("lpelr")).firebaseConfigStag; });
$parcel$export(module.exports, "musicGenres", function () { return (parcelRequire("jQMGL")).musicGenres; });
$parcel$export(module.exports, "maxTrackGenresCount", function () { return (parcelRequire("jQMGL")).maxTrackGenresCount; });
$parcel$export(module.exports, "maxUserPreferredGenresCount", function () { return (parcelRequire("jQMGL")).maxUserPreferredGenresCount; });
$parcel$export(module.exports, "stripePublishableKeyProd", function () { return (parcelRequire("eJGWm")).stripePublishableKeyProd; });
$parcel$export(module.exports, "stripePublishableKeyStag", function () { return (parcelRequire("eJGWm")).stripePublishableKeyStag; });

var $iyiMM = parcelRequire("iyiMM");

var $9VYkD = parcelRequire("9VYkD");

var $8YIJn = parcelRequire("8YIJn");

var $9YTSb = parcelRequire("9YTSb");

var $8kVRe = parcelRequire("8kVRe");

var $bL329 = parcelRequire("bL329");

var $ck17w = parcelRequire("ck17w");

var $lyE92 = parcelRequire("lyE92");

var $kDwrL = parcelRequire("kDwrL");

var $P3Zb0 = parcelRequire("P3Zb0");

var $6U1f3 = parcelRequire("6U1f3");

var $bs6PN = parcelRequire("bs6PN");

var $lpelr = parcelRequire("lpelr");

var $jQMGL = parcelRequire("jQMGL");

var $eJGWm = parcelRequire("eJGWm");

});
parcelRegister("iyiMM", function(module, exports) {

$parcel$export(module.exports, "API", function () { return $707df31db52f9936$export$2c4e825dc9120f87; });
var $707df31db52f9936$export$2c4e825dc9120f87;
(function(API) {
    API["LocalURL"] = "http://127.0.0.1/api/v1";
    API["StagingURL"] = "https://stag.api.ryddm.com/api/v1";
    API["ProductionURL"] = "https://api.ryddm.com/api/v1";
})($707df31db52f9936$export$2c4e825dc9120f87 || ($707df31db52f9936$export$2c4e825dc9120f87 = {}));

});

parcelRegister("9VYkD", function(module, exports) {

$parcel$export(module.exports, "Environment", function () { return $7bb8364d7015ef2a$export$7dc6752a22ab011a; });
var $7bb8364d7015ef2a$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["Production"] = "production";
    Environment["Staging"] = "staging";
})($7bb8364d7015ef2a$export$7dc6752a22ab011a || ($7bb8364d7015ef2a$export$7dc6752a22ab011a = {}));

});

parcelRegister("8YIJn", function(module, exports) {

$parcel$export(module.exports, "ExternalLinks", function () { return $618abadf428ef47e$export$7c6fdaf98295312b; });
var $618abadf428ef47e$export$7c6fdaf98295312b;
(function(ExternalLinks) {
    ExternalLinks["TermsOfUse"] = "https://ryddm.com/terms";
    ExternalLinks["PrivacyPolicy"] = "https://ryddm.com/privacy-policy";
    ExternalLinks["FAQ"] = "https://support.ryddm.com/support/home";
    ExternalLinks["Support"] = "https://support.ryddm.com/support/home";
    ExternalLinks["Contacts"] = "https://support.ryddm.com/support/home";
})($618abadf428ef47e$export$7c6fdaf98295312b || ($618abadf428ef47e$export$7c6fdaf98295312b = {}));

});

parcelRegister("9YTSb", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return $1997ee37f02ee10b$export$4b2950bdac9b6ee9; });
$parcel$export(module.exports, "Params", function () { return $1997ee37f02ee10b$export$e34ec06faf1ca435; });
var $1997ee37f02ee10b$export$4b2950bdac9b6ee9;
(function(Path) {
    Path["Home"] = "/";
    Path["Feed"] = "/";
    Path["Library"] = "/library";
    Path["Charts"] = "/charts";
    Path["Studio"] = "/studio";
    Path["Reports"] = "/reports";
    Path["Profile"] = "/profile";
    Path["Notifications"] = "/notifications";
    Path["User"] = "/user";
    Path["Post"] = "/post";
    Path["Track"] = "/track";
    Path["Report"] = "/report";
    Path["Complaint"] = "/complaint";
    Path["Notification"] = "/notification";
})($1997ee37f02ee10b$export$4b2950bdac9b6ee9 || ($1997ee37f02ee10b$export$4b2950bdac9b6ee9 = {}));
var $1997ee37f02ee10b$export$e34ec06faf1ca435;
(function(Params) {
    Params["UserID"] = ":userId";
    Params["PostID"] = ":postId";
    Params["TrackID"] = ":trackId";
    Params["ReportID"] = ":reportId";
    Params["ReportComplaintID"] = ":reportComplaintId";
    Params["NotificationID"] = ":notificationId";
})($1997ee37f02ee10b$export$e34ec06faf1ca435 || ($1997ee37f02ee10b$export$e34ec06faf1ca435 = {}));

});

parcelRegister("8kVRe", function(module, exports) {

$parcel$export(module.exports, "Platform", function () { return $c1dd079c72eaa909$export$2dffd0b5373a4389; });
var $c1dd079c72eaa909$export$2dffd0b5373a4389;
(function(Platform) {
    Platform["LocalURL"] = "http://127.0.0.1:1234";
    Platform["StagingURL"] = "https://stag.platform.ryddm.com/";
    Platform["ProductionURL"] = "https://platform.ryddm.com/";
})($c1dd079c72eaa909$export$2dffd0b5373a4389 || ($c1dd079c72eaa909$export$2dffd0b5373a4389 = {}));

});

parcelRegister("bL329", function(module, exports) {

$parcel$export(module.exports, "StorageKeys", function () { return $3246a8b91191da88$export$25c0d5b425a20ec; });
var $3246a8b91191da88$export$25c0d5b425a20ec;
(function(StorageKeys) {
    StorageKeys["AuthToken"] = "@ryddm/authToken";
    StorageKeys["SentPasswordResetEmailDate"] = "@ryddm/sentPasswordResetDate";
    StorageKeys["SentVerificationEmailDate"] = "@ryddm/sentVerificationEmailDate";
})($3246a8b91191da88$export$25c0d5b425a20ec || ($3246a8b91191da88$export$25c0d5b425a20ec = {}));

});

parcelRegister("ck17w", function(module, exports) {

$parcel$export(module.exports, "minCommentMessageLength", function () { return $6a09a2ab8a76af47$export$6bdaa109ce5cf1a0; });
$parcel$export(module.exports, "maxCommentMessageLength", function () { return $6a09a2ab8a76af47$export$4d7981eb409a1905; });
// updating this values will also require to update regex
// in @/utils/validateCommentMessage
const $6a09a2ab8a76af47$export$6bdaa109ce5cf1a0 = 1;
const $6a09a2ab8a76af47$export$4d7981eb409a1905 = 1000;

});

parcelRegister("lyE92", function(module, exports) {

$parcel$export(module.exports, "minTipAmount", function () { return $6b59d7f045e0909a$export$e4f0b0abb9ecb430; });
$parcel$export(module.exports, "maxTipAmount", function () { return $6b59d7f045e0909a$export$8f6d62c74ec1e8f5; });
$parcel$export(module.exports, "minTipMessageLength", function () { return $6b59d7f045e0909a$export$65c0e97e026435f; });
$parcel$export(module.exports, "maxTipMessageLength", function () { return $6b59d7f045e0909a$export$32070f15de013c49; });
const $6b59d7f045e0909a$export$e4f0b0abb9ecb430 = 1;
const $6b59d7f045e0909a$export$8f6d62c74ec1e8f5 = 9;
const $6b59d7f045e0909a$export$65c0e97e026435f = 1;
const $6b59d7f045e0909a$export$32070f15de013c49 = 256;

});

parcelRegister("kDwrL", function(module, exports) {

$parcel$export(module.exports, "minReportComplaintLength", function () { return $ea5f77e3bebfbf27$export$603a6ab7cb18c160; });
$parcel$export(module.exports, "maxReportComplaintLength", function () { return $ea5f77e3bebfbf27$export$afd48bc32b8d2ec7; });
$parcel$export(module.exports, "complaintTypeSelectOptions", function () { return $ea5f77e3bebfbf27$export$17e62d63f017d71; });
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
const $ea5f77e3bebfbf27$export$603a6ab7cb18c160 = 1;
const $ea5f77e3bebfbf27$export$afd48bc32b8d2ec7 = 256;
const $ea5f77e3bebfbf27$export$17e62d63f017d71 = [
    {
        id: "complaint-type-select-option-child-abuse",
        label: "Child Abuse",
        value: (0, $aeAwZ.EntityReportComplaintType).ChildAbuse.toString()
    },
    {
        id: "complaint-type-select-option-copyright",
        label: "Copyright",
        value: (0, $aeAwZ.EntityReportComplaintType).Copyright.toString()
    },
    {
        id: "complaint-type-select-option-fake",
        label: "Fake",
        value: (0, $aeAwZ.EntityReportComplaintType).Fake.toString()
    },
    {
        id: "complaint-type-select-option-pornography",
        label: "Pornography",
        value: (0, $aeAwZ.EntityReportComplaintType).Pornography.toString()
    },
    {
        id: "complaint-type-select-option-spam",
        label: "Spam",
        value: (0, $aeAwZ.EntityReportComplaintType).Spam.toString()
    },
    {
        id: "complaint-type-select-option-violence",
        label: "Violence",
        value: (0, $aeAwZ.EntityReportComplaintType).Violence.toString()
    }
];

});

parcelRegister("P3Zb0", function(module, exports) {

$parcel$export(module.exports, "minPostMessageLength", function () { return $42ebf855aff377da$export$cd306cf9192f67d1; });
$parcel$export(module.exports, "maxPostMessageLength", function () { return $42ebf855aff377da$export$7054c88eaa8ac11a; });
$parcel$export(module.exports, "minPostUnlockPrice", function () { return $42ebf855aff377da$export$8fcba1b80435648c; });
$parcel$export(module.exports, "maxPostUnlockPrice", function () { return $42ebf855aff377da$export$3c2ad8f014095a5f; });
$parcel$export(module.exports, "maxPostTracksCount", function () { return $42ebf855aff377da$export$7e624277da3962ed; });
$parcel$export(module.exports, "maxPostMediaFileSize", function () { return $42ebf855aff377da$export$15d917db408e8a19; });
// updating this values will also require to update regex
// in @/utils/validatePostMessage
const $42ebf855aff377da$export$cd306cf9192f67d1 = 3;
const $42ebf855aff377da$export$7054c88eaa8ac11a = 1000;
const $42ebf855aff377da$export$8fcba1b80435648c = 1;
const $42ebf855aff377da$export$3c2ad8f014095a5f = 9;
const $42ebf855aff377da$export$7e624277da3962ed = 8;
const $42ebf855aff377da$export$15d917db408e8a19 = 33554432;

});

parcelRegister("6U1f3", function(module, exports) {

$parcel$export(module.exports, "minTrackNameLength", function () { return $a2673af10824fa2c$export$e0f090e5dcb713a; });
$parcel$export(module.exports, "maxTrackNameLength", function () { return $a2673af10824fa2c$export$fd6b151279299f8a; });
$parcel$export(module.exports, "minTrackUnlockPrice", function () { return $a2673af10824fa2c$export$da4ccd4f42c5c84c; });
$parcel$export(module.exports, "maxTrackUnlockPrice", function () { return $a2673af10824fa2c$export$d8ccefa8e242ed5f; });
$parcel$export(module.exports, "maxTrackCoverFileSize", function () { return $a2673af10824fa2c$export$9b69e6ad1faf4fca; });
$parcel$export(module.exports, "maxTrackFileSize", function () { return $a2673af10824fa2c$export$8dc9f88d282540cc; });
// updating this values will also require to update regex
// in @/utils/validateTrackName
const $a2673af10824fa2c$export$e0f090e5dcb713a = 3;
const $a2673af10824fa2c$export$fd6b151279299f8a = 100;
const $a2673af10824fa2c$export$da4ccd4f42c5c84c = 1;
const $a2673af10824fa2c$export$d8ccefa8e242ed5f = 9;
const $a2673af10824fa2c$export$9b69e6ad1faf4fca = 8388608;
const $a2673af10824fa2c$export$8dc9f88d282540cc = 25165824;

});

parcelRegister("bs6PN", function(module, exports) {

$parcel$export(module.exports, "minUserUsernameLength", function () { return $01cecc287f0a930d$export$e49088c05a658209; });
$parcel$export(module.exports, "maxUserUsernameLength", function () { return $01cecc287f0a930d$export$9455dadea84e3fa6; });
$parcel$export(module.exports, "minUserNameLength", function () { return $01cecc287f0a930d$export$8bf390e4fd663ba; });
$parcel$export(module.exports, "maxUserNameLength", function () { return $01cecc287f0a930d$export$b4608afd32bdba85; });
$parcel$export(module.exports, "minUserPasswordLength", function () { return $01cecc287f0a930d$export$6c613d41c23a148a; });
$parcel$export(module.exports, "maxUserAvatarFileSize", function () { return $01cecc287f0a930d$export$a09ffeb911428ff; });
// updating this values will also require to update regex
// in @/utils/validateUsername
const $01cecc287f0a930d$export$e49088c05a658209 = 3;
const $01cecc287f0a930d$export$9455dadea84e3fa6 = 16;
const $01cecc287f0a930d$export$8bf390e4fd663ba = 3;
const $01cecc287f0a930d$export$b4608afd32bdba85 = 100;
const $01cecc287f0a930d$export$6c613d41c23a148a = 8;
const $01cecc287f0a930d$export$a09ffeb911428ff = 33554432;

});

parcelRegister("lpelr", function(module, exports) {

$parcel$export(module.exports, "firebaseConfigProd", function () { return $ad238c24654b75ae$export$3c07b9a4ab489d13; });
$parcel$export(module.exports, "firebaseConfigStag", function () { return $ad238c24654b75ae$export$260f1a7b6f980f91; });
const $ad238c24654b75ae$export$3c07b9a4ab489d13 = {
    apiKey: "AIzaSyDuYj58qK8qf4Dz_5nDRjLTE5v_HZyKv5k",
    authDomain: "ryddm-286615.firebaseapp.com",
    databaseURL: "https://ryddm-286615.firebaseio.com",
    projectId: "ryddm-286615",
    storageBucket: "ryddm-286615.appspot.com",
    messagingSenderId: "864316200417",
    appId: "1:864316200417:web:ffe830cc68e0b3f34aeea0",
    measurementId: "G-MBKVM74PPX"
};
const $ad238c24654b75ae$export$260f1a7b6f980f91 = {
    apiKey: "AIzaSyA_2ysu-qullegzw23n7MuVmGKlSO_t4kk",
    authDomain: "ryddmstaging.firebaseapp.com",
    projectId: "ryddmstaging",
    storageBucket: "ryddmstaging.appspot.com",
    messagingSenderId: "1057102064949",
    appId: "1:1057102064949:web:ff160f543d306fbd23707c",
    measurementId: "G-FRSWWVMQJH"
};

});

parcelRegister("jQMGL", function(module, exports) {

$parcel$export(module.exports, "musicGenres", function () { return $2a3773b4f42cb4b8$export$a2ded38cb48fcc09; });
$parcel$export(module.exports, "maxTrackGenresCount", function () { return $2a3773b4f42cb4b8$export$529919e62a58ddc5; });
$parcel$export(module.exports, "maxUserPreferredGenresCount", function () { return $2a3773b4f42cb4b8$export$c7dbd472abd43187; });
const $2a3773b4f42cb4b8$export$a2ded38cb48fcc09 = [
    "Rock",
    "Metal",
    "Alternative",
    "Hip-Hop",
    "Rap",
    "Dance",
    "EDM",
    "Classical",
    "Country",
    "Folk",
    "Jazz",
    "Indie",
    "Industrial",
    "Instrumental",
    "World",
    "Trap",
    "R&B",
    "New Age",
    "Christian",
    "Synthwave",
    "Children Music",
    "Acoustic",
    "Bass",
    "Blues",
    "Electronic",
    "Future Bass",
    "Holiday",
    "House",
    "Latin",
    "Pop",
    "Reggae",
    "Rockabilly"
];
const $2a3773b4f42cb4b8$export$529919e62a58ddc5 = 2;
const $2a3773b4f42cb4b8$export$c7dbd472abd43187 = 3;

});

parcelRegister("eJGWm", function(module, exports) {

$parcel$export(module.exports, "stripePublishableKeyProd", function () { return $c0e3f97dbe4df90a$export$95c96e49940ef90d; });
$parcel$export(module.exports, "stripePublishableKeyStag", function () { return $c0e3f97dbe4df90a$export$5f8822679672cb43; });
const $c0e3f97dbe4df90a$export$95c96e49940ef90d = "pk_live_51HzOCtAnIc3UbsjuaGNKzCiEDhWXoErBBMML7aJMaZFdwO4Vx5XTxjWHRwmfCYaxq4BaePaV9YxWu1nF5eDUdsPz00w9uJzooQ";
const $c0e3f97dbe4df90a$export$5f8822679672cb43 = "pk_test_51HzOCtAnIc3Ubsju2mZYS2u0aMAiNzqHVCcpYeYlu0G3dJUrJYTEtMXtEKt7kL3uxpBcq8Tldfhnh2Jy1ZrHUdim00bpU8xFY7";

});



parcelRegister("ehFe9", function(module, exports) {

$parcel$export(module.exports, "dateGetDifferenceSec", function () { return $fde7d281d39ca39a$export$fae9e2fd8565e6a9; });
/**
 * Calculates difference in seconds between provided dates.
 *
 * Takes past and current data as params, returns difference in seconds.
 *
 * @param {number} pastDate - Date in milliseconds elapsed since the epoch.
 * @param {number} currentDate - Date in milliseconds elapsed since the epoch (default is current date).
 * @returns {number} - Difference between dates in seconds.
 *
 * @example
 * // Returns difference between two dates in seconds.
 * const lastPasswordResetSec = dateGetDifferenceSec(lastIssuedDate);
 */ const $fde7d281d39ca39a$export$fae9e2fd8565e6a9 = (pastDate, currentDate = Date.now())=>Math.floor((currentDate - pastDate) / 1000);

});

parcelRegister("gQ3GG", function(module, exports) {

$parcel$export(module.exports, "firebaseSignupWithEmailAndPassword", function () { return $ccd836f861fc601f$export$1ed15408b0c36796; });
$parcel$export(module.exports, "firebaseLoginWithEmailAndPassword", function () { return $ccd836f861fc601f$export$7ea3f81a63d06d2d; });
$parcel$export(module.exports, "firebaseLoginWithGoogle", function () { return $ccd836f861fc601f$export$596dddd43d76a76c; });
$parcel$export(module.exports, "firebaseLoginWithFacebook", function () { return $ccd836f861fc601f$export$27ab9db94af63bd7; });
$parcel$export(module.exports, "firebaseSendPasswordResetEmail", function () { return $ccd836f861fc601f$export$bc2f170a1316cdef; });
$parcel$export(module.exports, "firebaseSendVerificationEmail", function () { return $ccd836f861fc601f$export$676c02462de282f; });
$parcel$export(module.exports, "firebaseSignout", function () { return $ccd836f861fc601f$export$ce2b67b6cbba1984; });
$parcel$export(module.exports, "firebaseGetEmailVerified", function () { return $ccd836f861fc601f$export$2571cb1371ffdb4a; });
// Import the functions you need from the SDKs you need
parcelRequire("fkNhc");
var $MjY8E = parcelRequire("MjY8E");
parcelRequire("gQOBw");
var $4D4bC = parcelRequire("4D4bC");
parcelRequire("2uUQU");
var $9VYkD = parcelRequire("9VYkD");
var $lpelr = parcelRequire("lpelr");

var $3mbpE = parcelRequire("3mbpE");
// initialize firebase app
const $ccd836f861fc601f$var$app = (0, $MjY8E.initializeApp)("staging" === (0, $9VYkD.Environment).Production ? (0, $lpelr.firebaseConfigProd) : (0, $lpelr.firebaseConfigStag));
// initialize firebase analytics
// export const firebaseAnalytics = getAnalytics(app)
// initialize firebase authentication
const $ccd836f861fc601f$var$firebaseAuth = (0, $4D4bC.o)($ccd836f861fc601f$var$app);
$ccd836f861fc601f$var$firebaseAuth.useDeviceLanguage();
// firebaseHandleError - handles firebase errors.
const $ccd836f861fc601f$var$firebaseHandleError = (err)=>{
    // retrieve firebase error message
    const errorCode = err?.code;
    const errorMessage = (0, $3mbpE.firebaseAuthErrors)[errorCode];
    return errorMessage || "Authentication error occurred.";
};
const $ccd836f861fc601f$export$1ed15408b0c36796 = async (email, password)=>{
    try {
        // create user with email and password
        const res = await (0, $4D4bC.aa)($ccd836f861fc601f$var$firebaseAuth, email, password);
        // send email verification
        await (0, $4D4bC.ag)(res.user);
        // get user id token
        const idToken = await $ccd836f861fc601f$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $ccd836f861fc601f$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $ccd836f861fc601f$export$7ea3f81a63d06d2d = async (email, password)=>{
    try {
        // sign in with email and password
        await (0, $4D4bC.ab)($ccd836f861fc601f$var$firebaseAuth, email, password);
        // get user id token
        const idToken = await $ccd836f861fc601f$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $ccd836f861fc601f$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $ccd836f861fc601f$export$596dddd43d76a76c = async ()=>{
    // initialize google provider
    const googleProvider = new (0, $4D4bC.X)();
    googleProvider.setCustomParameters({
        prompt: "select_account"
    });
    // add required scopes
    googleProvider.addScope("https://www.googleapis.com/auth/userinfo.profile");
    googleProvider.addScope("https://www.googleapis.com/auth/userinfo.email");
    // googleProvider.addScope('https://www.googleapis.com/auth/contacts.readonly')
    try {
        // sign in with popup
        await (0, $4D4bC.c)($ccd836f861fc601f$var$firebaseAuth, googleProvider);
        // get google credentials
        // const creds = GoogleAuthProvider.credentialFromResult(res)
        // get user id token
        const idToken = await $ccd836f861fc601f$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $ccd836f861fc601f$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $ccd836f861fc601f$export$27ab9db94af63bd7 = async ()=>{
    // initialize facebook provider
    const facebookProvider = new (0, $4D4bC.W)();
    facebookProvider.setCustomParameters({
        prompt: "select_account",
        display: "popup"
    });
    // add required scopes
    facebookProvider.addScope("public_profile");
    facebookProvider.addScope("email");
    try {
        // sign in with popup
        await (0, $4D4bC.c)($ccd836f861fc601f$var$firebaseAuth, facebookProvider);
        // get facebook credentials
        // const creds = FacebookAuthProvider.credentialFromResult(res)
        // get user id token
        const idToken = await $ccd836f861fc601f$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $ccd836f861fc601f$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $ccd836f861fc601f$export$bc2f170a1316cdef = async (email)=>{
    try {
        // send email
        await (0, $4D4bC.a5)($ccd836f861fc601f$var$firebaseAuth, email);
        return {
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            errorMessage: errorMessage
        };
    }
};
const $ccd836f861fc601f$export$676c02462de282f = async ()=>{
    try {
        // get current user
        const user = $ccd836f861fc601f$var$firebaseAuth.currentUser;
        // send email verification
        await (0, $4D4bC.ag)(user);
        return {
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            errorMessage: errorMessage
        };
    }
};
const $ccd836f861fc601f$export$ce2b67b6cbba1984 = async ()=>{
    try {
        // sign user out from firebase
        await (0, $4D4bC.C)($ccd836f861fc601f$var$firebaseAuth);
        return {
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            errorMessage: errorMessage
        };
    }
};
// firebaseGetCurrentUserState - wraps observer to get current user state status.
const $ccd836f861fc601f$var$firebaseGetCurrentUserState = ()=>new Promise((res)=>{
        const unsubscribe = (0, $4D4bC.y)($ccd836f861fc601f$var$firebaseAuth, (authUser)=>{
            res(authUser);
            unsubscribe();
        });
    });
const $ccd836f861fc601f$export$2571cb1371ffdb4a = async ()=>{
    try {
        // get current user
        const user = await $ccd836f861fc601f$var$firebaseGetCurrentUserState();
        // reload user data
        await user?.reload();
        // check email verification status
        const emailVerified = $ccd836f861fc601f$var$firebaseAuth.currentUser?.emailVerified;
        return {
            emailVerified: emailVerified,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $ccd836f861fc601f$var$firebaseHandleError(err);
        return {
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};

});
parcelRegister("fkNhc", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("MjY8E")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("MjY8E")).registerVersion; });

var $MjY8E = parcelRequire("MjY8E");
var $b29ef28f0d58131e$var$name = "firebase";
var $b29ef28f0d58131e$var$version = "10.13.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $MjY8E.registerVersion)($b29ef28f0d58131e$var$name, $b29ef28f0d58131e$var$version, "app");

});
parcelRegister("MjY8E", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $0913f93b5b3c9bac$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $0913f93b5b3c9bac$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_isFirebaseServerApp", function () { return $0913f93b5b3c9bac$export$643c8bc6c389f34e; });
$parcel$export(module.exports, "registerVersion", function () { return $0913f93b5b3c9bac$export$d29d5299a7137abc; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $0913f93b5b3c9bac$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $0913f93b5b3c9bac$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $0913f93b5b3c9bac$export$f9962582c9e66d99; });

var $6ExWU = parcelRequire("6ExWU");

var $kZfxc = parcelRequire("kZfxc");

var $2xDiJ = parcelRequire("2xDiJ");

var $ajgRO = parcelRequire("ajgRO");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0913f93b5b3c9bac$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($0913f93b5b3c9bac$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $0913f93b5b3c9bac$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $0913f93b5b3c9bac$var$name$p = "@firebase/app";
const $0913f93b5b3c9bac$var$version$1 = "0.10.10";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$logger = new (0, $kZfxc.Logger)("@firebase/app");
const $0913f93b5b3c9bac$var$name$o = "@firebase/app-compat";
const $0913f93b5b3c9bac$var$name$n = "@firebase/analytics-compat";
const $0913f93b5b3c9bac$var$name$m = "@firebase/analytics";
const $0913f93b5b3c9bac$var$name$l = "@firebase/app-check-compat";
const $0913f93b5b3c9bac$var$name$k = "@firebase/app-check";
const $0913f93b5b3c9bac$var$name$j = "@firebase/auth";
const $0913f93b5b3c9bac$var$name$i = "@firebase/auth-compat";
const $0913f93b5b3c9bac$var$name$h = "@firebase/database";
const $0913f93b5b3c9bac$var$name$g = "@firebase/database-compat";
const $0913f93b5b3c9bac$var$name$f = "@firebase/functions";
const $0913f93b5b3c9bac$var$name$e = "@firebase/functions-compat";
const $0913f93b5b3c9bac$var$name$d = "@firebase/installations";
const $0913f93b5b3c9bac$var$name$c = "@firebase/installations-compat";
const $0913f93b5b3c9bac$var$name$b = "@firebase/messaging";
const $0913f93b5b3c9bac$var$name$a = "@firebase/messaging-compat";
const $0913f93b5b3c9bac$var$name$9 = "@firebase/performance";
const $0913f93b5b3c9bac$var$name$8 = "@firebase/performance-compat";
const $0913f93b5b3c9bac$var$name$7 = "@firebase/remote-config";
const $0913f93b5b3c9bac$var$name$6 = "@firebase/remote-config-compat";
const $0913f93b5b3c9bac$var$name$5 = "@firebase/storage";
const $0913f93b5b3c9bac$var$name$4 = "@firebase/storage-compat";
const $0913f93b5b3c9bac$var$name$3 = "@firebase/firestore";
const $0913f93b5b3c9bac$var$name$2 = "@firebase/vertexai-preview";
const $0913f93b5b3c9bac$var$name$1 = "@firebase/firestore-compat";
const $0913f93b5b3c9bac$var$name = "firebase";
const $0913f93b5b3c9bac$var$version = "10.13.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $0913f93b5b3c9bac$export$9f30fa0c10967f7f = "[DEFAULT]";
const $0913f93b5b3c9bac$var$PLATFORM_LOG_STRING = {
    [$0913f93b5b3c9bac$var$name$p]: "fire-core",
    [$0913f93b5b3c9bac$var$name$o]: "fire-core-compat",
    [$0913f93b5b3c9bac$var$name$m]: "fire-analytics",
    [$0913f93b5b3c9bac$var$name$n]: "fire-analytics-compat",
    [$0913f93b5b3c9bac$var$name$k]: "fire-app-check",
    [$0913f93b5b3c9bac$var$name$l]: "fire-app-check-compat",
    [$0913f93b5b3c9bac$var$name$j]: "fire-auth",
    [$0913f93b5b3c9bac$var$name$i]: "fire-auth-compat",
    [$0913f93b5b3c9bac$var$name$h]: "fire-rtdb",
    [$0913f93b5b3c9bac$var$name$g]: "fire-rtdb-compat",
    [$0913f93b5b3c9bac$var$name$f]: "fire-fn",
    [$0913f93b5b3c9bac$var$name$e]: "fire-fn-compat",
    [$0913f93b5b3c9bac$var$name$d]: "fire-iid",
    [$0913f93b5b3c9bac$var$name$c]: "fire-iid-compat",
    [$0913f93b5b3c9bac$var$name$b]: "fire-fcm",
    [$0913f93b5b3c9bac$var$name$a]: "fire-fcm-compat",
    [$0913f93b5b3c9bac$var$name$9]: "fire-perf",
    [$0913f93b5b3c9bac$var$name$8]: "fire-perf-compat",
    [$0913f93b5b3c9bac$var$name$7]: "fire-rc",
    [$0913f93b5b3c9bac$var$name$6]: "fire-rc-compat",
    [$0913f93b5b3c9bac$var$name$5]: "fire-gcs",
    [$0913f93b5b3c9bac$var$name$4]: "fire-gcs-compat",
    [$0913f93b5b3c9bac$var$name$3]: "fire-fst",
    [$0913f93b5b3c9bac$var$name$1]: "fire-fst-compat",
    [$0913f93b5b3c9bac$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$0913f93b5b3c9bac$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $0913f93b5b3c9bac$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $0913f93b5b3c9bac$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0913f93b5b3c9bac$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $0913f93b5b3c9bac$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($0913f93b5b3c9bac$export$9566bce3835c0f28.has(componentName)) {
        $0913f93b5b3c9bac$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $0913f93b5b3c9bac$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $0913f93b5b3c9bac$export$b4e3c36c855b14b5.values())$0913f93b5b3c9bac$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $0913f93b5b3c9bac$export$fb03ad8d3d5c5f76.values())$0913f93b5b3c9bac$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $0913f93b5b3c9bac$export$9f30fa0c10967f7f) {
    $0913f93b5b3c9bac$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$3685d89b9c3cdfaf() {
    $0913f93b5b3c9bac$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $0913f93b5b3c9bac$var$ERROR_FACTORY = new (0, $2xDiJ.ErrorFactory)("app", "Firebase", $0913f93b5b3c9bac$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0913f93b5b3c9bac$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $6ExWU.Component)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0913f93b5b3c9bac$var$FirebaseServerAppImpl extends $0913f93b5b3c9bac$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $0913f93b5b3c9bac$export$d29d5299a7137abc($0913f93b5b3c9bac$var$name$p, $0913f93b5b3c9bac$var$version$1, "serverapp");
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $0913f93b5b3c9bac$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $0913f93b5b3c9bac$export$31499a9cd224b78c = $0913f93b5b3c9bac$var$version;
function $0913f93b5b3c9bac$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $0913f93b5b3c9bac$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $2xDiJ.getDefaultAppConfig)());
    if (!options) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $0913f93b5b3c9bac$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $2xDiJ.deepEqual)(options, existingApp.options) && (0, $2xDiJ.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $6ExWU.ComponentContainer)(name);
    for (const component of $0913f93b5b3c9bac$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $0913f93b5b3c9bac$var$FirebaseAppImpl(options, config, container);
    $0913f93b5b3c9bac$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $0913f93b5b3c9bac$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $2xDiJ.isBrowser)() && !(0, $2xDiJ.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($0913f93b5b3c9bac$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $0913f93b5b3c9bac$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $6ExWU.ComponentContainer)(nameString);
    for (const component of $0913f93b5b3c9bac$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $0913f93b5b3c9bac$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $0913f93b5b3c9bac$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $0913f93b5b3c9bac$export$f9962582c9e66d99(name = $0913f93b5b3c9bac$export$9f30fa0c10967f7f) {
    const app = $0913f93b5b3c9bac$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $0913f93b5b3c9bac$export$9f30fa0c10967f7f && (0, $2xDiJ.getDefaultAppConfig)()) return $0913f93b5b3c9bac$export$c55cfd413944906d();
    if (!app) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $0913f93b5b3c9bac$export$68ddedf7d44b3bdf() {
    return Array.from($0913f93b5b3c9bac$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $0913f93b5b3c9bac$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($0913f93b5b3c9bac$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $0913f93b5b3c9bac$export$b4e3c36c855b14b5.delete(name);
    } else if ($0913f93b5b3c9bac$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $0913f93b5b3c9bac$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $0913f93b5b3c9bac$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $0913f93b5b3c9bac$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $0913f93b5b3c9bac$var$logger.warn(warning.join(" "));
        return;
    }
    $0913f93b5b3c9bac$export$c930050e7bb63965(new (0, $6ExWU.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $0913f93b5b3c9bac$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $kZfxc.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $0913f93b5b3c9bac$export$c622e99c0ce7b1c9(logLevel) {
    (0, $kZfxc.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$DB_NAME = "firebase-heartbeat-database";
const $0913f93b5b3c9bac$var$DB_VERSION = 1;
const $0913f93b5b3c9bac$var$STORE_NAME = "firebase-heartbeat-store";
let $0913f93b5b3c9bac$var$dbPromise = null;
function $0913f93b5b3c9bac$var$getDbPromise() {
    if (!$0913f93b5b3c9bac$var$dbPromise) $0913f93b5b3c9bac$var$dbPromise = (0, $ajgRO.openDB)($0913f93b5b3c9bac$var$DB_NAME, $0913f93b5b3c9bac$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($0913f93b5b3c9bac$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $0913f93b5b3c9bac$var$dbPromise;
}
async function $0913f93b5b3c9bac$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $0913f93b5b3c9bac$var$getDbPromise();
        const tx = db.transaction($0913f93b5b3c9bac$var$STORE_NAME);
        const result = await tx.objectStore($0913f93b5b3c9bac$var$STORE_NAME).get($0913f93b5b3c9bac$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError)) $0913f93b5b3c9bac$var$logger.warn(e.message);
        else {
            const idbGetError = $0913f93b5b3c9bac$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $0913f93b5b3c9bac$var$logger.warn(idbGetError.message);
        }
    }
}
async function $0913f93b5b3c9bac$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $0913f93b5b3c9bac$var$getDbPromise();
        const tx = db.transaction($0913f93b5b3c9bac$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($0913f93b5b3c9bac$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $0913f93b5b3c9bac$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError)) $0913f93b5b3c9bac$var$logger.warn(e.message);
        else {
            const idbGetError = $0913f93b5b3c9bac$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $0913f93b5b3c9bac$var$logger.warn(idbGetError.message);
        }
    }
}
function $0913f93b5b3c9bac$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $0913f93b5b3c9bac$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $0913f93b5b3c9bac$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $0913f93b5b3c9bac$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $0913f93b5b3c9bac$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $0913f93b5b3c9bac$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $0913f93b5b3c9bac$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $0913f93b5b3c9bac$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $0913f93b5b3c9bac$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $2xDiJ.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $0913f93b5b3c9bac$var$logger.warn(e);
            return "";
        }
    }
}
function $0913f93b5b3c9bac$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $0913f93b5b3c9bac$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $0913f93b5b3c9bac$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($0913f93b5b3c9bac$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($0913f93b5b3c9bac$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $0913f93b5b3c9bac$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $2xDiJ.isIndexedDBAvailable)()) return false;
        else return (0, $2xDiJ.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $0913f93b5b3c9bac$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0913f93b5b3c9bac$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0913f93b5b3c9bac$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $0913f93b5b3c9bac$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $2xDiJ.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0913f93b5b3c9bac$var$registerCoreComponents(variant) {
    $0913f93b5b3c9bac$export$c930050e7bb63965(new (0, $6ExWU.Component)("platform-logger", (container)=>new $0913f93b5b3c9bac$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $0913f93b5b3c9bac$export$c930050e7bb63965(new (0, $6ExWU.Component)("heartbeat", (container)=>new $0913f93b5b3c9bac$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $0913f93b5b3c9bac$export$d29d5299a7137abc($0913f93b5b3c9bac$var$name$p, $0913f93b5b3c9bac$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $0913f93b5b3c9bac$export$d29d5299a7137abc($0913f93b5b3c9bac$var$name$p, $0913f93b5b3c9bac$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $0913f93b5b3c9bac$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $0913f93b5b3c9bac$var$registerCoreComponents("");

});
parcelRegister("6ExWU", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $4d80d01579d5bd6a$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $4d80d01579d5bd6a$export$436a80eea5d5c0c5; });

var $2xDiJ = parcelRequire("2xDiJ");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $4d80d01579d5bd6a$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $4d80d01579d5bd6a$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $2xDiJ.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($4d80d01579d5bd6a$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $4d80d01579d5bd6a$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $4d80d01579d5bd6a$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $4d80d01579d5bd6a$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $4d80d01579d5bd6a$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $4d80d01579d5bd6a$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});
parcelRegister("2xDiJ", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $1d9d263a787f8021$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $1d9d263a787f8021$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $1d9d263a787f8021$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $1d9d263a787f8021$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $1d9d263a787f8021$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $1d9d263a787f8021$export$85f6557964517f1a; });
$parcel$export(module.exports, "getUA", function () { return $1d9d263a787f8021$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $1d9d263a787f8021$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowser", function () { return $1d9d263a787f8021$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWebWorker", function () { return $1d9d263a787f8021$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $1d9d263a787f8021$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $1d9d263a787f8021$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $1d9d263a787f8021$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $1d9d263a787f8021$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $1d9d263a787f8021$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $1d9d263a787f8021$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $1d9d263a787f8021$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $1d9d263a787f8021$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $1d9d263a787f8021$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $1d9d263a787f8021$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $1d9d263a787f8021$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $1d9d263a787f8021$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $1d9d263a787f8021$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $1d9d263a787f8021$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $6qd2L = parcelRequire("6qd2L");
const $1d9d263a787f8021$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $1d9d263a787f8021$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $1d9d263a787f8021$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $1d9d263a787f8021$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $1d9d263a787f8021$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d9d263a787f8021$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $1d9d263a787f8021$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $1d9d263a787f8021$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($1d9d263a787f8021$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $1d9d263a787f8021$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $1d9d263a787f8021$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $1d9d263a787f8021$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $1d9d263a787f8021$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $1d9d263a787f8021$var$stringToByteArray$1(str);
    return $1d9d263a787f8021$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $1d9d263a787f8021$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $1d9d263a787f8021$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $1d9d263a787f8021$export$c62426fdd000a97e = function(str) {
    try {
        return $1d9d263a787f8021$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $1d9d263a787f8021$export$6c40052bed430212(value) {
    return $1d9d263a787f8021$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $1d9d263a787f8021$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$1d9d263a787f8021$var$isValidKey(prop)) continue;
        target[prop] = $1d9d263a787f8021$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $1d9d263a787f8021$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $1d9d263a787f8021$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d9d263a787f8021$var$getDefaultsFromGlobal = ()=>$1d9d263a787f8021$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $1d9d263a787f8021$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $6qd2L === "undefined" || typeof $6qd2L.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $1d9d263a787f8021$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $1d9d263a787f8021$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $1d9d263a787f8021$export$212bb2fc580a90a8 = ()=>{
    try {
        return $1d9d263a787f8021$var$getDefaultsFromGlobal() || $1d9d263a787f8021$var$getDefaultsFromEnvVariable() || $1d9d263a787f8021$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $1d9d263a787f8021$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $1d9d263a787f8021$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $1d9d263a787f8021$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $1d9d263a787f8021$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $1d9d263a787f8021$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d9d263a787f8021$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d9d263a787f8021$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $1d9d263a787f8021$export$4b5284a3025a455(JSON.stringify(header)),
        $1d9d263a787f8021$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $1d9d263a787f8021$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $1d9d263a787f8021$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($1d9d263a787f8021$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $1d9d263a787f8021$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $1d9d263a787f8021$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $1d9d263a787f8021$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context
 */ function $1d9d263a787f8021$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
function $1d9d263a787f8021$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $1d9d263a787f8021$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $1d9d263a787f8021$export$f2f6a8999f8ebd30() {
    return $1d9d263a787f8021$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $1d9d263a787f8021$export$7e7b1a9668aaed8() {
    const ua = $1d9d263a787f8021$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $1d9d263a787f8021$export$202944b2d2824246() {
    return $1d9d263a787f8021$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $1d9d263a787f8021$export$5d1d834fbbf8bab7() {
    return $1d9d263a787f8021$export$588c7fdda06fbb0a.NODE_CLIENT === true || $1d9d263a787f8021$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $1d9d263a787f8021$export$95df08bae54cb4df() {
    return !$1d9d263a787f8021$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $1d9d263a787f8021$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $1d9d263a787f8021$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $1d9d263a787f8021$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $1d9d263a787f8021$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $1d9d263a787f8021$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $1d9d263a787f8021$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $1d9d263a787f8021$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $1d9d263a787f8021$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $1d9d263a787f8021$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $1d9d263a787f8021$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $1d9d263a787f8021$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $1d9d263a787f8021$var$replaceTemplate(template, data) {
    return template.replace($1d9d263a787f8021$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $1d9d263a787f8021$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $1d9d263a787f8021$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $1d9d263a787f8021$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $1d9d263a787f8021$export$c5a53ce6a17cf18d($1d9d263a787f8021$export$c62426fdd000a97e(parts[0]) || "");
        claims = $1d9d263a787f8021$export$c5a53ce6a17cf18d($1d9d263a787f8021$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$5f870fcca7ae6a88 = function(token) {
    const claims = $1d9d263a787f8021$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$701c661ec91095f2 = function(token) {
    const claims = $1d9d263a787f8021$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $1d9d263a787f8021$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$fc970ed23da99565 = function(token) {
    const claims = $1d9d263a787f8021$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d9d263a787f8021$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $1d9d263a787f8021$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $1d9d263a787f8021$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $1d9d263a787f8021$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $1d9d263a787f8021$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($1d9d263a787f8021$var$isObject(aProp) && $1d9d263a787f8021$var$isObject(bProp)) {
            if (!$1d9d263a787f8021$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $1d9d263a787f8021$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $1d9d263a787f8021$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $1d9d263a787f8021$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $1d9d263a787f8021$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $1d9d263a787f8021$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $1d9d263a787f8021$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $1d9d263a787f8021$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $1d9d263a787f8021$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $1d9d263a787f8021$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $1d9d263a787f8021$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($1d9d263a787f8021$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $1d9d263a787f8021$var$noop;
        if (observer.error === undefined) observer.error = $1d9d263a787f8021$var$noop;
        if (observer.complete === undefined) observer.complete = $1d9d263a787f8021$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1d9d263a787f8021$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $1d9d263a787f8021$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $1d9d263a787f8021$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $1d9d263a787f8021$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $1d9d263a787f8021$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $1d9d263a787f8021$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($1d9d263a787f8021$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $1d9d263a787f8021$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($1d9d263a787f8021$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $1d9d263a787f8021$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($1d9d263a787f8021$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $1d9d263a787f8021$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $1d9d263a787f8021$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $1d9d263a787f8021$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $1d9d263a787f8021$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $1d9d263a787f8021$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $1d9d263a787f8021$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $1d9d263a787f8021$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $1d9d263a787f8021$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $1d9d263a787f8021$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $1d9d263a787f8021$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $1d9d263a787f8021$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $1d9d263a787f8021$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($1d9d263a787f8021$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $1d9d263a787f8021$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $1d9d263a787f8021$var$indicator(i);
}
function $1d9d263a787f8021$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d9d263a787f8021$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});



parcelRegister("kZfxc", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $f4758df7279d6c6a$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $f4758df7279d6c6a$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $f4758df7279d6c6a$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $f4758df7279d6c6a$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $f4758df7279d6c6a$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $f4758df7279d6c6a$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($f4758df7279d6c6a$export$243e62d78d3b544d || ($f4758df7279d6c6a$export$243e62d78d3b544d = {}));
const $f4758df7279d6c6a$var$levelStringToEnum = {
    "debug": $f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG,
    "verbose": $f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE,
    "info": $f4758df7279d6c6a$export$243e62d78d3b544d.INFO,
    "warn": $f4758df7279d6c6a$export$243e62d78d3b544d.WARN,
    "error": $f4758df7279d6c6a$export$243e62d78d3b544d.ERROR,
    "silent": $f4758df7279d6c6a$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $f4758df7279d6c6a$var$defaultLogLevel = $f4758df7279d6c6a$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $f4758df7279d6c6a$var$ConsoleMethod = {
    [$f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG]: "log",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE]: "log",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.INFO]: "info",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.WARN]: "warn",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $f4758df7279d6c6a$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $f4758df7279d6c6a$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $f4758df7279d6c6a$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $f4758df7279d6c6a$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $f4758df7279d6c6a$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $f4758df7279d6c6a$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $f4758df7279d6c6a$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $f4758df7279d6c6a$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $f4758df7279d6c6a$export$c622e99c0ce7b1c9(level) {
    $f4758df7279d6c6a$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $f4758df7279d6c6a$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $f4758df7279d6c6a$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $f4758df7279d6c6a$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $f4758df7279d6c6a$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("ajgRO", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $7818c326be87ea84$export$ca0ed41b1a2af7e; });

var $kKOTz = parcelRequire("kKOTz");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7818c326be87ea84$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $kKOTz.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $kKOTz.w)(request.result), event.oldVersion, event.newVersion, (0, $kKOTz.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7818c326be87ea84$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $kKOTz.w)(request).then(()=>undefined);
}
const $7818c326be87ea84$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $7818c326be87ea84$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $7818c326be87ea84$var$cachedMethods = new Map();
function $7818c326be87ea84$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($7818c326be87ea84$var$cachedMethods.get(prop)) return $7818c326be87ea84$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $7818c326be87ea84$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7818c326be87ea84$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7818c326be87ea84$var$cachedMethods.set(prop, method);
    return method;
}
(0, $kKOTz.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("kKOTz", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $f1bf9542bc9ee5ed$export$43caf9889c228507; });
const $f1bf9542bc9ee5ed$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $f1bf9542bc9ee5ed$var$idbProxyableTypes;
let $f1bf9542bc9ee5ed$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $f1bf9542bc9ee5ed$var$getIdbProxyableTypes() {
    return $f1bf9542bc9ee5ed$var$idbProxyableTypes || ($f1bf9542bc9ee5ed$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $f1bf9542bc9ee5ed$var$getCursorAdvanceMethods() {
    return $f1bf9542bc9ee5ed$var$cursorAdvanceMethods || ($f1bf9542bc9ee5ed$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $f1bf9542bc9ee5ed$var$cursorRequestMap = new WeakMap();
const $f1bf9542bc9ee5ed$var$transactionDoneMap = new WeakMap();
const $f1bf9542bc9ee5ed$var$transactionStoreNamesMap = new WeakMap();
const $f1bf9542bc9ee5ed$var$transformCache = new WeakMap();
const $f1bf9542bc9ee5ed$export$407448d2b89b1813 = new WeakMap();
function $f1bf9542bc9ee5ed$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $f1bf9542bc9ee5ed$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $f1bf9542bc9ee5ed$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $f1bf9542bc9ee5ed$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($f1bf9542bc9ee5ed$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $f1bf9542bc9ee5ed$var$transactionDoneMap.set(tx, done);
}
let $f1bf9542bc9ee5ed$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $f1bf9542bc9ee5ed$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $f1bf9542bc9ee5ed$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $f1bf9542bc9ee5ed$export$43caf9889c228507(callback) {
    $f1bf9542bc9ee5ed$var$idbProxyTraps = callback($f1bf9542bc9ee5ed$var$idbProxyTraps);
}
function $f1bf9542bc9ee5ed$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($f1bf9542bc9ee5ed$export$3b14a55fb2447963(this), storeNames, ...args);
        $f1bf9542bc9ee5ed$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($f1bf9542bc9ee5ed$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($f1bf9542bc9ee5ed$export$3b14a55fb2447963(this), args);
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b($f1bf9542bc9ee5ed$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(func.apply($f1bf9542bc9ee5ed$export$3b14a55fb2447963(this), args));
    };
}
function $f1bf9542bc9ee5ed$var$transformCachableValue(value) {
    if (typeof value === "function") return $f1bf9542bc9ee5ed$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $f1bf9542bc9ee5ed$var$cacheDonePromiseForTransaction(value);
    if ($f1bf9542bc9ee5ed$export$23f2a1d2818174ef(value, $f1bf9542bc9ee5ed$var$getIdbProxyableTypes())) return new Proxy(value, $f1bf9542bc9ee5ed$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $f1bf9542bc9ee5ed$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($f1bf9542bc9ee5ed$var$transformCache.has(value)) return $f1bf9542bc9ee5ed$var$transformCache.get(value);
    const newValue = $f1bf9542bc9ee5ed$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $f1bf9542bc9ee5ed$var$transformCache.set(value, newValue);
        $f1bf9542bc9ee5ed$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $f1bf9542bc9ee5ed$export$3b14a55fb2447963 = (value)=>$f1bf9542bc9ee5ed$export$407448d2b89b1813.get(value);

});




parcelRegister("gQOBw", function(module, exports) {
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("4D4bC")).aa; });
$parcel$export(module.exports, "FacebookAuthProvider", function () { return (parcelRequire("4D4bC")).W; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("4D4bC")).o; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("4D4bC")).X; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("4D4bC")).y; });
$parcel$export(module.exports, "sendEmailVerification", function () { return (parcelRequire("4D4bC")).ag; });
$parcel$export(module.exports, "sendPasswordResetEmail", function () { return (parcelRequire("4D4bC")).a5; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("4D4bC")).ab; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("4D4bC")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("4D4bC")).C; });
parcelRequire("eMcUM");

});
parcelRegister("eMcUM", function(module, exports) {

$parcel$export(module.exports, "FacebookAuthProvider", function () { return (parcelRequire("4D4bC")).W; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("4D4bC")).X; });
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("4D4bC")).aa; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("4D4bC")).o; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("4D4bC")).y; });
$parcel$export(module.exports, "sendEmailVerification", function () { return (parcelRequire("4D4bC")).ag; });
$parcel$export(module.exports, "sendPasswordResetEmail", function () { return (parcelRequire("4D4bC")).a5; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("4D4bC")).ab; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("4D4bC")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("4D4bC")).C; });

var $4D4bC = parcelRequire("4D4bC");
parcelRequire("MjY8E");
parcelRequire("2xDiJ");
parcelRequire("kZfxc");

parcelRequire("6ExWU");

});
parcelRegister("4D4bC", function(module, exports) {

$parcel$export(module.exports, "W", function () { return $35ee0d46d0d571c0$export$71cec2538cb2c617; });
$parcel$export(module.exports, "X", function () { return $35ee0d46d0d571c0$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "a5", function () { return $35ee0d46d0d571c0$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "aa", function () { return $35ee0d46d0d571c0$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "ab", function () { return $35ee0d46d0d571c0$export$555508cbc6add439; });
$parcel$export(module.exports, "ag", function () { return $35ee0d46d0d571c0$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "y", function () { return $35ee0d46d0d571c0$export$4a5767248b18ef41; });
$parcel$export(module.exports, "C", function () { return $35ee0d46d0d571c0$export$e7094788287c5e9b; });
$parcel$export(module.exports, "c", function () { return $35ee0d46d0d571c0$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $35ee0d46d0d571c0$export$ae1af26003f05816; });

var $MjY8E = parcelRequire("MjY8E");

var $2xDiJ = parcelRequire("2xDiJ");

var $kZfxc = parcelRequire("kZfxc");

var $4tSb9 = parcelRequire("4tSb9");

var $6ExWU = parcelRequire("6ExWU");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registered for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: "The supplied auth credential is incorrect, malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements."
    };
}
function $35ee0d46d0d571c0$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $35ee0d46d0d571c0$export$2329c99376c9d0a4 = $35ee0d46d0d571c0$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $35ee0d46d0d571c0$export$7f8ddf7c7c20b3cd = $35ee0d46d0d571c0$var$_prodErrorMap;
const $35ee0d46d0d571c0$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $2xDiJ.ErrorFactory)("auth", "Firebase", $35ee0d46d0d571c0$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$logClient = new (0, $kZfxc.Logger)("@firebase/auth");
function $35ee0d46d0d571c0$var$_logWarn(msg, ...args) {
    if ($35ee0d46d0d571c0$var$logClient.logLevel <= (0, $kZfxc.LogLevel).WARN) $35ee0d46d0d571c0$var$logClient.warn(`Auth (${(0, $MjY8E.SDK_VERSION)}): ${msg}`, ...args);
}
function $35ee0d46d0d571c0$var$_logError(msg, ...args) {
    if ($35ee0d46d0d571c0$var$logClient.logLevel <= (0, $kZfxc.LogLevel).ERROR) $35ee0d46d0d571c0$var$logClient.error(`Auth (${(0, $MjY8E.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $35ee0d46d0d571c0$var$createErrorInternal(authOrCode, ...rest);
}
function $35ee0d46d0d571c0$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $35ee0d46d0d571c0$var$createErrorInternal(authOrCode, ...rest);
}
function $35ee0d46d0d571c0$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $35ee0d46d0d571c0$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $2xDiJ.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $35ee0d46d0d571c0$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function $35ee0d46d0d571c0$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $35ee0d46d0d571c0$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $35ee0d46d0d571c0$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $35ee0d46d0d571c0$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $35ee0d46d0d571c0$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $35ee0d46d0d571c0$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $35ee0d46d0d571c0$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $35ee0d46d0d571c0$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $35ee0d46d0d571c0$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $35ee0d46d0d571c0$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $35ee0d46d0d571c0$var$_isHttpOrHttps() {
    return $35ee0d46d0d571c0$var$_getCurrentScheme() === "http:" || $35ee0d46d0d571c0$var$_getCurrentScheme() === "https:";
}
function $35ee0d46d0d571c0$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $35ee0d46d0d571c0$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($35ee0d46d0d571c0$var$_isHttpOrHttps() || (0, $2xDiJ.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $35ee0d46d0d571c0$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $35ee0d46d0d571c0$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $35ee0d46d0d571c0$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $2xDiJ.isMobileCordova)() || (0, $2xDiJ.isReactNative)();
    }
    get() {
        if (!$35ee0d46d0d571c0$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$_emulatorUrl(config, path) {
    $35ee0d46d0d571c0$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== "undefined") return fetch;
        $35ee0d46d0d571c0$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== "undefined") return Headers;
        $35ee0d46d0d571c0$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
        if (typeof Response !== "undefined") return Response;
        $35ee0d46d0d571c0$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $35ee0d46d0d571c0$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$DEFAULT_API_TIMEOUT_MS = new $35ee0d46d0d571c0$var$Delay(30000, 60000);
function $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $35ee0d46d0d571c0$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $35ee0d46d0d571c0$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $2xDiJ.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $35ee0d46d0d571c0$export$2ed0fc6709e59212.fetch()($35ee0d46d0d571c0$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $35ee0d46d0d571c0$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $35ee0d46d0d571c0$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $35ee0d46d0d571c0$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $35ee0d46d0d571c0$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $35ee0d46d0d571c0$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $35ee0d46d0d571c0$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $35ee0d46d0d571c0$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $35ee0d46d0d571c0$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $35ee0d46d0d571c0$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $35ee0d46d0d571c0$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $35ee0d46d0d571c0$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $35ee0d46d0d571c0$var$_emulatorUrl(auth.config, base);
}
function $35ee0d46d0d571c0$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $35ee0d46d0d571c0$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($35ee0d46d0d571c0$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $35ee0d46d0d571c0$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $35ee0d46d0d571c0$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $35ee0d46d0d571c0$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $35ee0d46d0d571c0$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $35ee0d46d0d571c0$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $35ee0d46d0d571c0$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$getRecaptchaParams(auth) {
    return (await $35ee0d46d0d571c0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $35ee0d46d0d571c0$var$getRecaptchaConfig(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$deleteAccount(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $35ee0d46d0d571c0$var$deleteLinkedAccounts(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $35ee0d46d0d571c0$var$getAccountInfo(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $2xDiJ.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $35ee0d46d0d571c0$var$_parseToken(token);
    $35ee0d46d0d571c0$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $35ee0d46d0d571c0$var$utcTimestampToDateString($35ee0d46d0d571c0$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $35ee0d46d0d571c0$var$utcTimestampToDateString($35ee0d46d0d571c0$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $35ee0d46d0d571c0$var$utcTimestampToDateString($35ee0d46d0d571c0$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $35ee0d46d0d571c0$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $35ee0d46d0d571c0$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $35ee0d46d0d571c0$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $2xDiJ.base64Decode)(payload);
        if (!decoded) {
            $35ee0d46d0d571c0$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $35ee0d46d0d571c0$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $35ee0d46d0d571c0$var$_tokenExpiresIn(token) {
    const parsedToken = $35ee0d46d0d571c0$var$_parseToken(token);
    $35ee0d46d0d571c0$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError) && $35ee0d46d0d571c0$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $35ee0d46d0d571c0$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $35ee0d46d0d571c0$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $35ee0d46d0d571c0$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(user, $35ee0d46d0d571c0$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $35ee0d46d0d571c0$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $35ee0d46d0d571c0$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $35ee0d46d0d571c0$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $35ee0d46d0d571c0$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$d24c54395ce0c509(user) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $35ee0d46d0d571c0$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $35ee0d46d0d571c0$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $35ee0d46d0d571c0$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $4tSb9.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$requestStsToken(auth, refreshToken) {
    const response = await $35ee0d46d0d571c0$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $2xDiJ.querystring)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $35ee0d46d0d571c0$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $35ee0d46d0d571c0$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $35ee0d46d0d571c0$var$revokeToken(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $35ee0d46d0d571c0$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $35ee0d46d0d571c0$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $35ee0d46d0d571c0$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $35ee0d46d0d571c0$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $35ee0d46d0d571c0$var$StsTokenManager();
        if (refreshToken) {
            $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $35ee0d46d0d571c0$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $35ee0d46d0d571c0$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$assertStringOrUndefined(assertion, appName) {
    $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $35ee0d46d0d571c0$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $4tSb9.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $35ee0d46d0d571c0$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $35ee0d46d0d571c0$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $35ee0d46d0d571c0$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $35ee0d46d0d571c0$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $35ee0d46d0d571c0$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $35ee0d46d0d571c0$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $35ee0d46d0d571c0$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $35ee0d46d0d571c0$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $MjY8E._isFirebaseServerApp)(this.auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $35ee0d46d0d571c0$var$_logoutIfInvalidated(this, $35ee0d46d0d571c0$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $35ee0d46d0d571c0$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $35ee0d46d0d571c0$var$assertStringOrUndefined(displayName, auth.name);
        $35ee0d46d0d571c0$var$assertStringOrUndefined(email, auth.name);
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $35ee0d46d0d571c0$var$assertStringOrUndefined(phoneNumber, auth.name);
        $35ee0d46d0d571c0$var$assertStringOrUndefined(photoURL, auth.name);
        $35ee0d46d0d571c0$var$assertStringOrUndefined(tenantId, auth.name);
        $35ee0d46d0d571c0$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $35ee0d46d0d571c0$var$assertStringOrUndefined(createdAt, auth.name);
        $35ee0d46d0d571c0$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $35ee0d46d0d571c0$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $35ee0d46d0d571c0$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $35ee0d46d0d571c0$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $35ee0d46d0d571c0$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $35ee0d46d0d571c0$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $35ee0d46d0d571c0$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $35ee0d46d0d571c0$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $35ee0d46d0d571c0$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $35ee0d46d0d571c0$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$instanceCache = new Map();
function $35ee0d46d0d571c0$export$158acd800e1ef08b(cls) {
    $35ee0d46d0d571c0$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    let instance = $35ee0d46d0d571c0$var$instanceCache.get(cls);
    if (instance) {
        $35ee0d46d0d571c0$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $35ee0d46d0d571c0$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$35ee0d46d0d571c0$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$3a6d5c9ae78a2c08 = $35ee0d46d0d571c0$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $35ee0d46d0d571c0$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $35ee0d46d0d571c0$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $35ee0d46d0d571c0$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $35ee0d46d0d571c0$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $35ee0d46d0d571c0$var$PersistenceUserManager($35ee0d46d0d571c0$export$158acd800e1ef08b($35ee0d46d0d571c0$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $35ee0d46d0d571c0$export$158acd800e1ef08b($35ee0d46d0d571c0$export$3a6d5c9ae78a2c08);
        const key = $35ee0d46d0d571c0$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $35ee0d46d0d571c0$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $35ee0d46d0d571c0$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $35ee0d46d0d571c0$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $35ee0d46d0d571c0$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($35ee0d46d0d571c0$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($35ee0d46d0d571c0$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($35ee0d46d0d571c0$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($35ee0d46d0d571c0$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($35ee0d46d0d571c0$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $35ee0d46d0d571c0$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($35ee0d46d0d571c0$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $35ee0d46d0d571c0$var$_isFirefox(ua = (0, $2xDiJ.getUA)()) {
    return /firefox\//i.test(ua);
}
function $35ee0d46d0d571c0$var$_isSafari(userAgent = (0, $2xDiJ.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $35ee0d46d0d571c0$var$_isChromeIOS(ua = (0, $2xDiJ.getUA)()) {
    return /crios\//i.test(ua);
}
function $35ee0d46d0d571c0$var$_isIEMobile(ua = (0, $2xDiJ.getUA)()) {
    return /iemobile/i.test(ua);
}
function $35ee0d46d0d571c0$export$92108d983e8ee699(ua = (0, $2xDiJ.getUA)()) {
    return /android/i.test(ua);
}
function $35ee0d46d0d571c0$var$_isBlackBerry(ua = (0, $2xDiJ.getUA)()) {
    return /blackberry/i.test(ua);
}
function $35ee0d46d0d571c0$var$_isWebOS(ua = (0, $2xDiJ.getUA)()) {
    return /webos/i.test(ua);
}
function $35ee0d46d0d571c0$export$d66dc83d8cfc8dd(ua = (0, $2xDiJ.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $35ee0d46d0d571c0$export$91c6e00c14e7e6fd(ua = (0, $2xDiJ.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $35ee0d46d0d571c0$var$_isIOSStandalone(ua = (0, $2xDiJ.getUA)()) {
    var _a;
    return $35ee0d46d0d571c0$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $35ee0d46d0d571c0$var$_isIE10() {
    return (0, $2xDiJ.isIE)() && document.documentMode === 10;
}
function $35ee0d46d0d571c0$var$_isMobileBrowser(ua = (0, $2xDiJ.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $35ee0d46d0d571c0$export$d66dc83d8cfc8dd(ua) || $35ee0d46d0d571c0$export$92108d983e8ee699(ua) || $35ee0d46d0d571c0$var$_isWebOS(ua) || $35ee0d46d0d571c0$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $35ee0d46d0d571c0$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $35ee0d46d0d571c0$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $35ee0d46d0d571c0$var$_getBrowserName((0, $2xDiJ.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$35ee0d46d0d571c0$var$_getBrowserName((0, $2xDiJ.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $MjY8E.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $35ee0d46d0d571c0$var$_getPasswordPolicy(auth, request = {}) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $35ee0d46d0d571c0$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $35ee0d46d0d571c0$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $35ee0d46d0d571c0$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $35ee0d46d0d571c0$var$Subscription(this);
        this.idTokenSubscription = new $35ee0d46d0d571c0$var$Subscription(this);
        this.beforeStateQueue = new $35ee0d46d0d571c0$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $35ee0d46d0d571c0$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $35ee0d46d0d571c0$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $35ee0d46d0d571c0$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $35ee0d46d0d571c0$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $35ee0d46d0d571c0$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn("FirebaseServerApp could not login user with provided authIdToken: ", err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $MjY8E._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $35ee0d46d0d571c0$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $35ee0d46d0d571c0$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $MjY8E._isFirebaseServerApp)(this.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $2xDiJ.getModularInstance)(userExtern) : null;
        if (user) $35ee0d46d0d571c0$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $35ee0d46d0d571c0$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $MjY8E._isFirebaseServerApp)(this.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $MjY8E._isFirebaseServerApp)(this.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($35ee0d46d0d571c0$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $35ee0d46d0d571c0$var$_getPasswordPolicy(this);
        const passwordPolicy = new $35ee0d46d0d571c0$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $2xDiJ.ErrorFactory)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: "apple.com",
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $35ee0d46d0d571c0$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $35ee0d46d0d571c0$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $35ee0d46d0d571c0$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $35ee0d46d0d571c0$var$PersistenceUserManager.create(this, [
                $35ee0d46d0d571c0$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $35ee0d46d0d571c0$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $35ee0d46d0d571c0$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth) {
    return (0, $2xDiJ.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $35ee0d46d0d571c0$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $2xDiJ.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $35ee0d46d0d571c0$var$externalJSProvider = {
    async loadJS () {
        throw new Error("Unable to load external scripts");
    },
    recaptchaV2Script: "",
    recaptchaEnterpriseScript: "",
    gapiScript: ""
};
function $35ee0d46d0d571c0$var$_setExternalJSProvider(p) {
    $35ee0d46d0d571c0$var$externalJSProvider = p;
}
function $35ee0d46d0d571c0$var$_loadJS(url) {
    return $35ee0d46d0d571c0$var$externalJSProvider.loadJS(url);
}
function $35ee0d46d0d571c0$var$_recaptchaV2ScriptUrl() {
    return $35ee0d46d0d571c0$var$externalJSProvider.recaptchaV2Script;
}
function $35ee0d46d0d571c0$var$_recaptchaEnterpriseScriptUrl() {
    return $35ee0d46d0d571c0$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $35ee0d46d0d571c0$var$_gapiScriptUrl() {
    return $35ee0d46d0d571c0$var$externalJSProvider.gapiScript;
}
function $35ee0d46d0d571c0$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $35ee0d46d0d571c0$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $35ee0d46d0d571c0$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $35ee0d46d0d571c0$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $35ee0d46d0d571c0$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $35ee0d46d0d571c0$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $35ee0d46d0d571c0$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($35ee0d46d0d571c0$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($35ee0d46d0d571c0$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $35ee0d46d0d571c0$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    let url = $35ee0d46d0d571c0$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $35ee0d46d0d571c0$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $35ee0d46d0d571c0$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $35ee0d46d0d571c0$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $35ee0d46d0d571c0$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $35ee0d46d0d571c0$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $35ee0d46d0d571c0$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $35ee0d46d0d571c0$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    const response = await $35ee0d46d0d571c0$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $35ee0d46d0d571c0$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $35ee0d46d0d571c0$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $35ee0d46d0d571c0$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $MjY8E._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $2xDiJ.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $35ee0d46d0d571c0$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($35ee0d46d0d571c0$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    $35ee0d46d0d571c0$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $35ee0d46d0d571c0$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $35ee0d46d0d571c0$var$extractProtocol(url);
    const { host: host, port: port } = $35ee0d46d0d571c0$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $35ee0d46d0d571c0$var$emitEmulatorWarning();
}
function $35ee0d46d0d571c0$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $35ee0d46d0d571c0$var$extractHostAndPort(url) {
    const protocol = $35ee0d46d0d571c0$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $35ee0d46d0d571c0$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $35ee0d46d0d571c0$var$parsePort(port)
        };
    }
}
function $35ee0d46d0d571c0$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $35ee0d46d0d571c0$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $35ee0d46d0d571c0$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $35ee0d46d0d571c0$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $35ee0d46d0d571c0$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $35ee0d46d0d571c0$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$resetPassword(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
async function $35ee0d46d0d571c0$var$updateEmailPassword(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $35ee0d46d0d571c0$var$linkEmailPassword(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $35ee0d46d0d571c0$var$applyActionCode$1(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$signInWithPassword(auth, request) {
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
async function $35ee0d46d0d571c0$var$sendOobCode(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
async function $35ee0d46d0d571c0$var$sendEmailVerification$1(auth, request) {
    return $35ee0d46d0d571c0$var$sendOobCode(auth, request);
}
async function $35ee0d46d0d571c0$var$sendPasswordResetEmail$1(auth, request) {
    return $35ee0d46d0d571c0$var$sendOobCode(auth, request);
}
async function $35ee0d46d0d571c0$var$sendSignInLinkToEmail$1(auth, request) {
    return $35ee0d46d0d571c0$var$sendOobCode(auth, request);
}
async function $35ee0d46d0d571c0$var$verifyAndChangeEmail(auth, request) {
    return $35ee0d46d0d571c0$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$signInWithEmailLink$1(auth, request) {
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
async function $35ee0d46d0d571c0$var$signInWithEmailLinkForLinking(auth, request) {
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$3a1a48c8f6ef640e extends $35ee0d46d0d571c0$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $35ee0d46d0d571c0$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $35ee0d46d0d571c0$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $35ee0d46d0d571c0$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $35ee0d46d0d571c0$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $35ee0d46d0d571c0$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $35ee0d46d0d571c0$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $35ee0d46d0d571c0$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $35ee0d46d0d571c0$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$signInWithIdp(auth, request) {
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$a07804094c3ecf2d extends $35ee0d46d0d571c0$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $35ee0d46d0d571c0$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $35ee0d46d0d571c0$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $4tSb9.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $35ee0d46d0d571c0$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $35ee0d46d0d571c0$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $2xDiJ.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$sendPhoneVerificationCode(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
async function $35ee0d46d0d571c0$var$signInWithPhoneNumber$1(auth, request) {
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
async function $35ee0d46d0d571c0$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $35ee0d46d0d571c0$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $35ee0d46d0d571c0$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $35ee0d46d0d571c0$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, apiRequest), $35ee0d46d0d571c0$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$3722cfe417b6ed86 extends $35ee0d46d0d571c0$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $35ee0d46d0d571c0$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $35ee0d46d0d571c0$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $35ee0d46d0d571c0$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $35ee0d46d0d571c0$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $35ee0d46d0d571c0$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $35ee0d46d0d571c0$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $35ee0d46d0d571c0$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $35ee0d46d0d571c0$var$parseDeepLink(url) {
    const link = (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $35ee0d46d0d571c0$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $35ee0d46d0d571c0$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $35ee0d46d0d571c0$var$parseDeepLink(link);
        try {
            return new $35ee0d46d0d571c0$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$3b513254972cfc9c(link) {
    return $35ee0d46d0d571c0$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $35ee0d46d0d571c0$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $35ee0d46d0d571c0$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $35ee0d46d0d571c0$export$f38c853ae54ed474.parseLink(emailLink);
        $35ee0d46d0d571c0$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $35ee0d46d0d571c0$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $35ee0d46d0d571c0$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $35ee0d46d0d571c0$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $35ee0d46d0d571c0$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $35ee0d46d0d571c0$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $35ee0d46d0d571c0$var$BaseOAuthProvider extends $35ee0d46d0d571c0$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $35ee0d46d0d571c0$export$dc98b0b04f4c7758 extends $35ee0d46d0d571c0$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $35ee0d46d0d571c0$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $35ee0d46d0d571c0$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $35ee0d46d0d571c0$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $35ee0d46d0d571c0$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $35ee0d46d0d571c0$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $35ee0d46d0d571c0$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $35ee0d46d0d571c0$export$71cec2538cb2c617 extends $35ee0d46d0d571c0$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $35ee0d46d0d571c0$export$a07804094c3ecf2d._fromParams({
            providerId: $35ee0d46d0d571c0$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $35ee0d46d0d571c0$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $35ee0d46d0d571c0$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $35ee0d46d0d571c0$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $35ee0d46d0d571c0$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $35ee0d46d0d571c0$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $35ee0d46d0d571c0$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $35ee0d46d0d571c0$export$78acf4525d8a74c4 extends $35ee0d46d0d571c0$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $35ee0d46d0d571c0$export$a07804094c3ecf2d._fromParams({
            providerId: $35ee0d46d0d571c0$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $35ee0d46d0d571c0$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $35ee0d46d0d571c0$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $35ee0d46d0d571c0$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $35ee0d46d0d571c0$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $35ee0d46d0d571c0$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $35ee0d46d0d571c0$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $35ee0d46d0d571c0$export$8743009a87fcb00f extends $35ee0d46d0d571c0$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $35ee0d46d0d571c0$export$a07804094c3ecf2d._fromParams({
            providerId: $35ee0d46d0d571c0$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $35ee0d46d0d571c0$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $35ee0d46d0d571c0$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $35ee0d46d0d571c0$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $35ee0d46d0d571c0$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $35ee0d46d0d571c0$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $35ee0d46d0d571c0$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $35ee0d46d0d571c0$export$f96d196f7728bb5 extends $35ee0d46d0d571c0$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $35ee0d46d0d571c0$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $35ee0d46d0d571c0$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $35ee0d46d0d571c0$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$71511d61b312f219 extends $35ee0d46d0d571c0$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $35ee0d46d0d571c0$export$890c4ad488842ce7(providerId.startsWith($35ee0d46d0d571c0$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $35ee0d46d0d571c0$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $35ee0d46d0d571c0$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $35ee0d46d0d571c0$export$f96d196f7728bb5.fromJSON(json);
        $35ee0d46d0d571c0$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $35ee0d46d0d571c0$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9 extends $35ee0d46d0d571c0$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $35ee0d46d0d571c0$export$a07804094c3ecf2d._fromParams({
            providerId: $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $35ee0d46d0d571c0$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$signUp(auth, request) {
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $35ee0d46d0d571c0$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $35ee0d46d0d571c0$var$providerIdForResponse(idTokenResponse);
        const userCred = new $35ee0d46d0d571c0$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $35ee0d46d0d571c0$var$providerIdForResponse(response);
        return new $35ee0d46d0d571c0$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $35ee0d46d0d571c0$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $35ee0d46d0d571c0$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $35ee0d46d0d571c0$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $35ee0d46d0d571c0$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$MultiFactorError extends (0, $2xDiJ.FirebaseError) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $35ee0d46d0d571c0$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $35ee0d46d0d571c0$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $35ee0d46d0d571c0$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $35ee0d46d0d571c0$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $35ee0d46d0d571c0$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $35ee0d46d0d571c0$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $35ee0d46d0d571c0$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $35ee0d46d0d571c0$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $35ee0d46d0d571c0$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $35ee0d46d0d571c0$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $35ee0d46d0d571c0$var$_assertLinkedStatus(expected, user, provider) {
    await $35ee0d46d0d571c0$var$_reloadWithoutSaving(user);
    const providerIds = $35ee0d46d0d571c0$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(user, $35ee0d46d0d571c0$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $35ee0d46d0d571c0$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $35ee0d46d0d571c0$var$_parseToken(response.idToken);
        $35ee0d46d0d571c0$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $35ee0d46d0d571c0$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $35ee0d46d0d571c0$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $35ee0d46d0d571c0$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$3c2fa207a37baaea(auth, credential) {
    return $35ee0d46d0d571c0$var$_signInWithCredential($35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $35ee0d46d0d571c0$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $35ee0d46d0d571c0$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$6559d589eb85fbb6(user, credential) {
    return $35ee0d46d0d571c0$var$_reauthenticate((0, $2xDiJ.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$signInWithCustomToken$1(auth, request) {
    return $35ee0d46d0d571c0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    const response = await $35ee0d46d0d571c0$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $35ee0d46d0d571c0$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $35ee0d46d0d571c0$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $35ee0d46d0d571c0$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $35ee0d46d0d571c0$var$PhoneMultiFactorInfoImpl extends $35ee0d46d0d571c0$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $35ee0d46d0d571c0$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $35ee0d46d0d571c0$var$TotpMultiFactorInfoImpl extends $35ee0d46d0d571c0$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $35ee0d46d0d571c0$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $35ee0d46d0d571c0$var$recachePasswordPolicy(auth) {
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $35ee0d46d0d571c0$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $35ee0d46d0d571c0$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $35ee0d46d0d571c0$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $35ee0d46d0d571c0$var$resetPassword((0, $2xDiJ.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $35ee0d46d0d571c0$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$a93c5207d687da10(auth, oobCode) {
    await $35ee0d46d0d571c0$var$applyActionCode$1((0, $2xDiJ.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $2xDiJ.getModularInstance)(auth);
    const response = await $35ee0d46d0d571c0$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $35ee0d46d0d571c0$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $35ee0d46d0d571c0$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $35ee0d46d0d571c0$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $35ee0d46d0d571c0$var$MultiFactorInfoImpl._fromServerResponse($35ee0d46d0d571c0$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $35ee0d46d0d571c0$export$c3950d9923825c02((0, $2xDiJ.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $35ee0d46d0d571c0$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $35ee0d46d0d571c0$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $35ee0d46d0d571c0$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $35ee0d46d0d571c0$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$555508cbc6add439(auth, email, password) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $35ee0d46d0d571c0$export$3c2fa207a37baaea((0, $2xDiJ.getModularInstance)(auth), $35ee0d46d0d571c0$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $35ee0d46d0d571c0$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $35ee0d46d0d571c0$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $35ee0d46d0d571c0$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $35ee0d46d0d571c0$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $35ee0d46d0d571c0$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $2xDiJ.getModularInstance)(auth);
    const credential = $35ee0d46d0d571c0$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $35ee0d46d0d571c0$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $35ee0d46d0d571c0$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $35ee0d46d0d571c0$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$createAuthUri(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $35ee0d46d0d571c0$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $35ee0d46d0d571c0$var$_isHttpOrHttps() ? $35ee0d46d0d571c0$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $35ee0d46d0d571c0$var$createAuthUri((0, $2xDiJ.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $35ee0d46d0d571c0$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $35ee0d46d0d571c0$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $35ee0d46d0d571c0$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $35ee0d46d0d571c0$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$var$updateProfile$1(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(userInternal, $35ee0d46d0d571c0$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    if ((0, $MjY8E._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $35ee0d46d0d571c0$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$1a82df3d29112e01(user, newPassword) {
    return $35ee0d46d0d571c0$var$updateEmailOrPassword((0, $2xDiJ.getModularInstance)(user), null, newPassword);
}
async function $35ee0d46d0d571c0$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(user, $35ee0d46d0d571c0$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $35ee0d46d0d571c0$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $35ee0d46d0d571c0$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $35ee0d46d0d571c0$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $35ee0d46d0d571c0$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $35ee0d46d0d571c0$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $35ee0d46d0d571c0$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $35ee0d46d0d571c0$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $35ee0d46d0d571c0$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $35ee0d46d0d571c0$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $35ee0d46d0d571c0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $35ee0d46d0d571c0$var$FederatedAdditionalUserInfoWithUsername extends $35ee0d46d0d571c0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $35ee0d46d0d571c0$var$FacebookAdditionalUserInfo extends $35ee0d46d0d571c0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $35ee0d46d0d571c0$var$GithubAdditionalUserInfo extends $35ee0d46d0d571c0$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $35ee0d46d0d571c0$var$GoogleAdditionalUserInfo extends $35ee0d46d0d571c0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $35ee0d46d0d571c0$var$TwitterAdditionalUserInfo extends $35ee0d46d0d571c0$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $35ee0d46d0d571c0$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $35ee0d46d0d571c0$export$9e5f44173e64f162(auth, persistence) {
    return (0, $2xDiJ.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$625550452a3fa3ec(auth) {
    return $35ee0d46d0d571c0$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$90a7f3efeed30595(auth, password) {
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $2xDiJ.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $35ee0d46d0d571c0$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $2xDiJ.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $2xDiJ.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$df995fae86a55f06(auth) {
    (0, $2xDiJ.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$ef35774e6d314e91(auth, user) {
    return (0, $2xDiJ.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$e7094788287c5e9b(auth) {
    return (0, $2xDiJ.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$96f57966bedc81b4(auth, token) {
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$a9c23c6ac3fc3eca(user) {
    return (0, $2xDiJ.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $35ee0d46d0d571c0$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $35ee0d46d0d571c0$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $35ee0d46d0d571c0$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $35ee0d46d0d571c0$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$35ee0d46d0d571c0$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $35ee0d46d0d571c0$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $35ee0d46d0d571c0$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $35ee0d46d0d571c0$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $35ee0d46d0d571c0$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $35ee0d46d0d571c0$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $35ee0d46d0d571c0$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $2xDiJ.getModularInstance)(auth);
    const errorInternal = error;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $35ee0d46d0d571c0$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $35ee0d46d0d571c0$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$startEnrollPhoneMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
function $35ee0d46d0d571c0$var$finalizeEnrollPhoneMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
function $35ee0d46d0d571c0$var$startEnrollTotpMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
function $35ee0d46d0d571c0$var$finalizeEnrollTotpMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
function $35ee0d46d0d571c0$var$withdrawMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
class $35ee0d46d0d571c0$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$35ee0d46d0d571c0$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $35ee0d46d0d571c0$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $35ee0d46d0d571c0$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $35ee0d46d0d571c0$var$_logoutIfInvalidated(this.user, $35ee0d46d0d571c0$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $35ee0d46d0d571c0$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$493d36ec626b6698(user) {
    const userModular = (0, $2xDiJ.getModularInstance)(user);
    if (!$35ee0d46d0d571c0$var$multiFactorUserCache.has(userModular)) $35ee0d46d0d571c0$var$multiFactorUserCache.set(userModular, $35ee0d46d0d571c0$var$MultiFactorUserImpl._fromUser(userModular));
    return $35ee0d46d0d571c0$var$multiFactorUserCache.get(userModular);
}
const $35ee0d46d0d571c0$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $35ee0d46d0d571c0$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($35ee0d46d0d571c0$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($35ee0d46d0d571c0$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $35ee0d46d0d571c0$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $35ee0d46d0d571c0$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $35ee0d46d0d571c0$var$BrowserLocalPersistence extends $35ee0d46d0d571c0$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $35ee0d46d0d571c0$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($35ee0d46d0d571c0$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $35ee0d46d0d571c0$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $35ee0d46d0d571c0$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$35ee0d46d0d571c0$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$8b22cf2602fb60ce = $35ee0d46d0d571c0$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$BrowserSessionPersistence extends $35ee0d46d0d571c0$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$35ee0d46d0d571c0$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$407448d2b89b1813 = $35ee0d46d0d571c0$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $35ee0d46d0d571c0$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $35ee0d46d0d571c0$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $35ee0d46d0d571c0$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $35ee0d46d0d571c0$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$35ee0d46d0d571c0$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$export$faec65b429be379(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $35ee0d46d0d571c0$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $35ee0d46d0d571c0$export$faec65b429be379("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $35ee0d46d0d571c0$var$_window() {
    return window;
}
function $35ee0d46d0d571c0$var$_setWindowLocation(url) {
    $35ee0d46d0d571c0$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$_isWorker() {
    return typeof $35ee0d46d0d571c0$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $35ee0d46d0d571c0$var$_window()["importScripts"] === "function";
}
async function $35ee0d46d0d571c0$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $35ee0d46d0d571c0$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $35ee0d46d0d571c0$var$_getWorkerGlobalScope() {
    return $35ee0d46d0d571c0$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$DB_NAME = "firebaseLocalStorageDb";
const $35ee0d46d0d571c0$var$DB_VERSION = 1;
const $35ee0d46d0d571c0$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $35ee0d46d0d571c0$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $35ee0d46d0d571c0$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $35ee0d46d0d571c0$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $35ee0d46d0d571c0$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($35ee0d46d0d571c0$var$DB_OBJECTSTORE_NAME);
}
function $35ee0d46d0d571c0$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($35ee0d46d0d571c0$var$DB_NAME);
    return new $35ee0d46d0d571c0$var$DBPromise(request).toPromise();
}
function $35ee0d46d0d571c0$var$_openDatabase() {
    const request = indexedDB.open($35ee0d46d0d571c0$var$DB_NAME, $35ee0d46d0d571c0$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($35ee0d46d0d571c0$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $35ee0d46d0d571c0$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($35ee0d46d0d571c0$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $35ee0d46d0d571c0$var$_deleteDatabase();
                resolve(await $35ee0d46d0d571c0$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $35ee0d46d0d571c0$var$_putObject(db, key, value) {
    const request = $35ee0d46d0d571c0$var$getObjectStore(db, true).put({
        [$35ee0d46d0d571c0$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $35ee0d46d0d571c0$var$DBPromise(request).toPromise();
}
async function $35ee0d46d0d571c0$var$getObject(db, key) {
    const request = $35ee0d46d0d571c0$var$getObjectStore(db, false).get(key);
    const data = await new $35ee0d46d0d571c0$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $35ee0d46d0d571c0$var$_deleteObject(db, key) {
    const request = $35ee0d46d0d571c0$var$getObjectStore(db, true).delete(key);
    return new $35ee0d46d0d571c0$var$DBPromise(request).toPromise();
}
const $35ee0d46d0d571c0$var$_POLLING_INTERVAL_MS = 800;
const $35ee0d46d0d571c0$var$_TRANSACTION_RETRY_COUNT = 3;
class $35ee0d46d0d571c0$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $35ee0d46d0d571c0$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $35ee0d46d0d571c0$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $35ee0d46d0d571c0$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $35ee0d46d0d571c0$var$Receiver._getInstance($35ee0d46d0d571c0$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $35ee0d46d0d571c0$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $35ee0d46d0d571c0$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $35ee0d46d0d571c0$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $35ee0d46d0d571c0$var$_openDatabase();
            await $35ee0d46d0d571c0$var$_putObject(db, $35ee0d46d0d571c0$var$STORAGE_AVAILABLE_KEY, "1");
            await $35ee0d46d0d571c0$var$_deleteObject(db, $35ee0d46d0d571c0$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$35ee0d46d0d571c0$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$35ee0d46d0d571c0$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$35ee0d46d0d571c0$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $35ee0d46d0d571c0$var$getObjectStore(db, false).getAll();
            return new $35ee0d46d0d571c0$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $35ee0d46d0d571c0$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$35ee0d46d0d571c0$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$23f2a1d2818174ef = $35ee0d46d0d571c0$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$startSignInPhoneMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
function $35ee0d46d0d571c0$var$finalizeSignInPhoneMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
function $35ee0d46d0d571c0$var$finalizeSignInTotpMfa(auth, request) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $35ee0d46d0d571c0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$_SOLVE_TIME_MS = 500;
const $35ee0d46d0d571c0$var$_EXPIRATION_TIME_MS = 60000;
const $35ee0d46d0d571c0$var$_WIDGET_ID_START = 1000000000000;
class $35ee0d46d0d571c0$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $35ee0d46d0d571c0$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $35ee0d46d0d571c0$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $35ee0d46d0d571c0$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $35ee0d46d0d571c0$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $35ee0d46d0d571c0$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $35ee0d46d0d571c0$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $35ee0d46d0d571c0$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $35ee0d46d0d571c0$var$_EXPIRATION_TIME_MS);
        }, $35ee0d46d0d571c0$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $35ee0d46d0d571c0$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $35ee0d46d0d571c0$var$_JSLOAD_CALLBACK = $35ee0d46d0d571c0$var$_generateCallbackName("rcb");
const $35ee0d46d0d571c0$var$NETWORK_TIMEOUT_DELAY = new $35ee0d46d0d571c0$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $35ee0d46d0d571c0$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $35ee0d46d0d571c0$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $35ee0d46d0d571c0$export$890c4ad488842ce7($35ee0d46d0d571c0$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $35ee0d46d0d571c0$var$isV2($35ee0d46d0d571c0$var$_window().grecaptcha)) return Promise.resolve($35ee0d46d0d571c0$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $35ee0d46d0d571c0$var$_window().setTimeout(()=>{
                reject($35ee0d46d0d571c0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $35ee0d46d0d571c0$var$NETWORK_TIMEOUT_DELAY.get());
            $35ee0d46d0d571c0$var$_window()[$35ee0d46d0d571c0$var$_JSLOAD_CALLBACK] = ()=>{
                $35ee0d46d0d571c0$var$_window().clearTimeout(networkTimeout);
                delete $35ee0d46d0d571c0$var$_window()[$35ee0d46d0d571c0$var$_JSLOAD_CALLBACK];
                const recaptcha = $35ee0d46d0d571c0$var$_window().grecaptcha;
                if (!recaptcha || !$35ee0d46d0d571c0$var$isV2(recaptcha)) {
                    reject($35ee0d46d0d571c0$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$35ee0d46d0d571c0$var$_recaptchaV2ScriptUrl()}?${(0, $2xDiJ.querystring)({
                onload: $35ee0d46d0d571c0$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $35ee0d46d0d571c0$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($35ee0d46d0d571c0$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $35ee0d46d0d571c0$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $35ee0d46d0d571c0$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $35ee0d46d0d571c0$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $35ee0d46d0d571c0$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $35ee0d46d0d571c0$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $35ee0d46d0d571c0$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $35ee0d46d0d571c0$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $35ee0d46d0d571c0$var$MockReCaptchaLoaderImpl() : new $35ee0d46d0d571c0$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $35ee0d46d0d571c0$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $35ee0d46d0d571c0$export$890c4ad488842ce7($35ee0d46d0d571c0$var$_isHttpOrHttps() && !$35ee0d46d0d571c0$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $35ee0d46d0d571c0$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $35ee0d46d0d571c0$var$getRecaptchaParams(this.auth);
        $35ee0d46d0d571c0$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $35ee0d46d0d571c0$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $35ee0d46d0d571c0$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    const verificationId = await $35ee0d46d0d571c0$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $2xDiJ.getModularInstance)(appVerifier));
    return new $35ee0d46d0d571c0$var$ConfirmationResultImpl(verificationId, (cred)=>$35ee0d46d0d571c0$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $35ee0d46d0d571c0$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $35ee0d46d0d571c0$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $2xDiJ.getModularInstance)(appVerifier));
    return new $35ee0d46d0d571c0$var$ConfirmationResultImpl(verificationId, (cred)=>$35ee0d46d0d571c0$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    if ((0, $MjY8E._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $35ee0d46d0d571c0$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $2xDiJ.getModularInstance)(appVerifier));
    return new $35ee0d46d0d571c0$var$ConfirmationResultImpl(verificationId, (cred)=>$35ee0d46d0d571c0$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $35ee0d46d0d571c0$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $35ee0d46d0d571c0$export$890c4ad488842ce7(verifier.type === $35ee0d46d0d571c0$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $35ee0d46d0d571c0$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $35ee0d46d0d571c0$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $35ee0d46d0d571c0$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $35ee0d46d0d571c0$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $35ee0d46d0d571c0$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $35ee0d46d0d571c0$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    if ((0, $MjY8E._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $35ee0d46d0d571c0$var$_link$1(userInternal, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $35ee0d46d0d571c0$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $35ee0d46d0d571c0$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $35ee0d46d0d571c0$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $2xDiJ.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $35ee0d46d0d571c0$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $35ee0d46d0d571c0$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $35ee0d46d0d571c0$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $35ee0d46d0d571c0$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $35ee0d46d0d571c0$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $35ee0d46d0d571c0$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $35ee0d46d0d571c0$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $35ee0d46d0d571c0$export$158acd800e1ef08b(resolverOverride);
    $35ee0d46d0d571c0$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$IdpCredential extends $35ee0d46d0d571c0$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $35ee0d46d0d571c0$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $35ee0d46d0d571c0$var$_signIn(params) {
    return $35ee0d46d0d571c0$var$_signInWithCredential(params.auth, new $35ee0d46d0d571c0$var$IdpCredential(params), params.bypassAuthState);
}
function $35ee0d46d0d571c0$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $35ee0d46d0d571c0$var$_reauthenticate(user, new $35ee0d46d0d571c0$var$IdpCredential(params), params.bypassAuthState);
}
async function $35ee0d46d0d571c0$var$_link(params) {
    const { auth: auth, user: user } = params;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $35ee0d46d0d571c0$var$_link$1(user, new $35ee0d46d0d571c0$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $35ee0d46d0d571c0$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $35ee0d46d0d571c0$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $35ee0d46d0d571c0$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $35ee0d46d0d571c0$var$_reauth;
            default:
                $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $35ee0d46d0d571c0$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $35ee0d46d0d571c0$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $35ee0d46d0d571c0$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    $35ee0d46d0d571c0$var$_assertInstanceOf(auth, provider, $35ee0d46d0d571c0$var$FederatedAuthProvider);
    const resolverInternal = $35ee0d46d0d571c0$var$_withDefaultResolver(authInternal, resolver);
    const action = new $35ee0d46d0d571c0$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    if ((0, $MjY8E._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($35ee0d46d0d571c0$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $35ee0d46d0d571c0$var$_assertInstanceOf(userInternal.auth, provider, $35ee0d46d0d571c0$var$FederatedAuthProvider);
    const resolverInternal = $35ee0d46d0d571c0$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $35ee0d46d0d571c0$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    $35ee0d46d0d571c0$var$_assertInstanceOf(userInternal.auth, provider, $35ee0d46d0d571c0$var$FederatedAuthProvider);
    const resolverInternal = $35ee0d46d0d571c0$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $35ee0d46d0d571c0$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $35ee0d46d0d571c0$var$PopupOperation extends $35ee0d46d0d571c0$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($35ee0d46d0d571c0$var$PopupOperation.currentPopupAction) $35ee0d46d0d571c0$var$PopupOperation.currentPopupAction.cancel();
        $35ee0d46d0d571c0$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $35ee0d46d0d571c0$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $35ee0d46d0d571c0$export$1fbe638ecf81657e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $35ee0d46d0d571c0$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($35ee0d46d0d571c0$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($35ee0d46d0d571c0$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $35ee0d46d0d571c0$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($35ee0d46d0d571c0$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $35ee0d46d0d571c0$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$35ee0d46d0d571c0$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $35ee0d46d0d571c0$var$redirectOutcomeMap = new Map();
class $35ee0d46d0d571c0$var$RedirectAction extends $35ee0d46d0d571c0$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $35ee0d46d0d571c0$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $35ee0d46d0d571c0$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $35ee0d46d0d571c0$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $35ee0d46d0d571c0$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $35ee0d46d0d571c0$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $35ee0d46d0d571c0$var$pendingRedirectKey(auth);
    const persistence = $35ee0d46d0d571c0$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $35ee0d46d0d571c0$var$_setPendingRedirectStatus(resolver, auth) {
    return $35ee0d46d0d571c0$var$resolverPersistence(resolver)._set($35ee0d46d0d571c0$var$pendingRedirectKey(auth), "true");
}
function $35ee0d46d0d571c0$export$b9a6b53f9be3734() {
    $35ee0d46d0d571c0$var$redirectOutcomeMap.clear();
}
function $35ee0d46d0d571c0$export$a33b77bbdbb8366c(auth, result) {
    $35ee0d46d0d571c0$var$redirectOutcomeMap.set(auth._key(), result);
}
function $35ee0d46d0d571c0$var$resolverPersistence(resolver) {
    return $35ee0d46d0d571c0$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $35ee0d46d0d571c0$var$pendingRedirectKey(auth) {
    return $35ee0d46d0d571c0$export$cf2f7c5792f80b46($35ee0d46d0d571c0$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$2d1720544b23b823(auth, provider, resolver) {
    return $35ee0d46d0d571c0$var$_signInWithRedirect(auth, provider, resolver);
}
async function $35ee0d46d0d571c0$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    $35ee0d46d0d571c0$var$_assertInstanceOf(auth, provider, $35ee0d46d0d571c0$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $35ee0d46d0d571c0$var$_withDefaultResolver(authInternal, resolver);
    await $35ee0d46d0d571c0$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $35ee0d46d0d571c0$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $35ee0d46d0d571c0$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    $35ee0d46d0d571c0$var$_assertInstanceOf(userInternal.auth, provider, $35ee0d46d0d571c0$var$FederatedAuthProvider);
    if ((0, $MjY8E._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $35ee0d46d0d571c0$var$_withDefaultResolver(userInternal.auth, resolver);
    await $35ee0d46d0d571c0$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $35ee0d46d0d571c0$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$39b482c5e57630a8(user, provider, resolver) {
    return $35ee0d46d0d571c0$var$_linkWithRedirect(user, provider, resolver);
}
async function $35ee0d46d0d571c0$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    $35ee0d46d0d571c0$var$_assertInstanceOf(userInternal.auth, provider, $35ee0d46d0d571c0$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $35ee0d46d0d571c0$var$_withDefaultResolver(userInternal.auth, resolver);
    await $35ee0d46d0d571c0$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $35ee0d46d0d571c0$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $35ee0d46d0d571c0$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $35ee0d46d0d571c0$export$35e795649ee09318(auth, resolver) {
    await $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $35ee0d46d0d571c0$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $35ee0d46d0d571c0$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $MjY8E._isFirebaseServerApp)(auth.app)) return Promise.reject($35ee0d46d0d571c0$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(auth);
    const resolver = $35ee0d46d0d571c0$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $35ee0d46d0d571c0$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $35ee0d46d0d571c0$var$prepareUserForRedirect(user) {
    const eventId = $35ee0d46d0d571c0$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $35ee0d46d0d571c0$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $35ee0d46d0d571c0$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$35ee0d46d0d571c0$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$35ee0d46d0d571c0$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($35ee0d46d0d571c0$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $35ee0d46d0d571c0$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($35ee0d46d0d571c0$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($35ee0d46d0d571c0$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $35ee0d46d0d571c0$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $35ee0d46d0d571c0$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $35ee0d46d0d571c0$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $35ee0d46d0d571c0$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $35ee0d46d0d571c0$export$3d12bd131bb975d1(auth, request = {}) {
    return $35ee0d46d0d571c0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $35ee0d46d0d571c0$var$HTTP_REGEX = /^https?/;
async function $35ee0d46d0d571c0$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $35ee0d46d0d571c0$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($35ee0d46d0d571c0$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $35ee0d46d0d571c0$var$matchDomain(expected) {
    const currentUrl = $35ee0d46d0d571c0$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$35ee0d46d0d571c0$var$HTTP_REGEX.test(protocol)) return false;
    if ($35ee0d46d0d571c0$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$NETWORK_TIMEOUT = new $35ee0d46d0d571c0$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $35ee0d46d0d571c0$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $35ee0d46d0d571c0$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $35ee0d46d0d571c0$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $35ee0d46d0d571c0$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $35ee0d46d0d571c0$var$resetUnloadedGapiModules();
                    reject($35ee0d46d0d571c0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $35ee0d46d0d571c0$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $35ee0d46d0d571c0$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $35ee0d46d0d571c0$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $35ee0d46d0d571c0$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $35ee0d46d0d571c0$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($35ee0d46d0d571c0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $35ee0d46d0d571c0$var$_loadJS(`${$35ee0d46d0d571c0$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $35ee0d46d0d571c0$var$cachedGApiLoader = null;
        throw error;
    });
}
let $35ee0d46d0d571c0$var$cachedGApiLoader = null;
function $35ee0d46d0d571c0$var$_loadGapi(auth) {
    $35ee0d46d0d571c0$var$cachedGApiLoader = $35ee0d46d0d571c0$var$cachedGApiLoader || $35ee0d46d0d571c0$var$loadGapi(auth);
    return $35ee0d46d0d571c0$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$PING_TIMEOUT = new $35ee0d46d0d571c0$var$Delay(5000, 15000);
const $35ee0d46d0d571c0$var$IFRAME_PATH = "__/auth/iframe";
const $35ee0d46d0d571c0$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $35ee0d46d0d571c0$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $35ee0d46d0d571c0$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $35ee0d46d0d571c0$var$getIframeUrl(auth) {
    const config = auth.config;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $35ee0d46d0d571c0$var$_emulatorUrl(config, $35ee0d46d0d571c0$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$35ee0d46d0d571c0$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $MjY8E.SDK_VERSION)
    };
    const eid = $35ee0d46d0d571c0$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $2xDiJ.querystring)(params).slice(1)}`;
}
async function $35ee0d46d0d571c0$var$_openIframe(auth) {
    const context = await $35ee0d46d0d571c0$var$_loadGapi(auth);
    const gapi1 = $35ee0d46d0d571c0$var$_window().gapi;
    $35ee0d46d0d571c0$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $35ee0d46d0d571c0$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $35ee0d46d0d571c0$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $35ee0d46d0d571c0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $35ee0d46d0d571c0$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $35ee0d46d0d571c0$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $35ee0d46d0d571c0$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $35ee0d46d0d571c0$var$DEFAULT_WIDTH = 500;
const $35ee0d46d0d571c0$var$DEFAULT_HEIGHT = 600;
const $35ee0d46d0d571c0$var$TARGET_BLANK = "_blank";
const $35ee0d46d0d571c0$var$FIREFOX_EMPTY_URL = "http://localhost";
class $35ee0d46d0d571c0$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $35ee0d46d0d571c0$var$_open(auth, url, name, width = $35ee0d46d0d571c0$var$DEFAULT_WIDTH, height = $35ee0d46d0d571c0$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $35ee0d46d0d571c0$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $2xDiJ.getUA)().toLowerCase();
    if (name) target = $35ee0d46d0d571c0$var$_isChromeIOS(ua) ? $35ee0d46d0d571c0$var$TARGET_BLANK : name;
    if ($35ee0d46d0d571c0$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $35ee0d46d0d571c0$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($35ee0d46d0d571c0$var$_isIOSStandalone(ua) && target !== "_self") {
        $35ee0d46d0d571c0$var$openAsNewWindowIOS(url || "", target);
        return new $35ee0d46d0d571c0$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $35ee0d46d0d571c0$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $35ee0d46d0d571c0$export$c03999cb2f36933f(newWin);
}
function $35ee0d46d0d571c0$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $35ee0d46d0d571c0$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $35ee0d46d0d571c0$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $35ee0d46d0d571c0$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $35ee0d46d0d571c0$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $35ee0d46d0d571c0$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $35ee0d46d0d571c0$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $MjY8E.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $35ee0d46d0d571c0$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $2xDiJ.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $35ee0d46d0d571c0$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$35ee0d46d0d571c0$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$35ee0d46d0d571c0$var$getHandlerBase(auth)}?${(0, $2xDiJ.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $35ee0d46d0d571c0$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$35ee0d46d0d571c0$var$WIDGET_PATH}`;
    return $35ee0d46d0d571c0$var$_emulatorUrl(config, $35ee0d46d0d571c0$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $35ee0d46d0d571c0$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $35ee0d46d0d571c0$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $35ee0d46d0d571c0$export$407448d2b89b1813;
        this._completeRedirectFn = $35ee0d46d0d571c0$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $35ee0d46d0d571c0$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $35ee0d46d0d571c0$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $35ee0d46d0d571c0$export$28f7fcd39efa255(auth, provider, authType, $35ee0d46d0d571c0$var$_getCurrentUrl(), eventId);
        return $35ee0d46d0d571c0$var$_open(auth, url, $35ee0d46d0d571c0$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $35ee0d46d0d571c0$export$28f7fcd39efa255(auth, provider, authType, $35ee0d46d0d571c0$var$_getCurrentUrl(), eventId);
        $35ee0d46d0d571c0$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $35ee0d46d0d571c0$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $35ee0d46d0d571c0$var$_openIframe(auth);
        const manager = new $35ee0d46d0d571c0$export$24baa2b76016ce0e(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $35ee0d46d0d571c0$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($35ee0d46d0d571c0$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $35ee0d46d0d571c0$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$35ee0d46d0d571c0$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $35ee0d46d0d571c0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $35ee0d46d0d571c0$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $35ee0d46d0d571c0$var$_isMobileBrowser() || $35ee0d46d0d571c0$var$_isSafari() || $35ee0d46d0d571c0$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $35ee0d46d0d571c0$export$342063e11d6c3cad = $35ee0d46d0d571c0$var$BrowserPopupRedirectResolver;
class $35ee0d46d0d571c0$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $35ee0d46d0d571c0$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $35ee0d46d0d571c0$var$PhoneMultiFactorAssertionImpl extends $35ee0d46d0d571c0$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $35ee0d46d0d571c0$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $35ee0d46d0d571c0$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $35ee0d46d0d571c0$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $35ee0d46d0d571c0$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $35ee0d46d0d571c0$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $35ee0d46d0d571c0$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $35ee0d46d0d571c0$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $35ee0d46d0d571c0$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $35ee0d46d0d571c0$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $35ee0d46d0d571c0$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $35ee0d46d0d571c0$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $35ee0d46d0d571c0$var$TotpMultiFactorAssertionImpl extends $35ee0d46d0d571c0$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $35ee0d46d0d571c0$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $35ee0d46d0d571c0$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $35ee0d46d0d571c0$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $35ee0d46d0d571c0$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $35ee0d46d0d571c0$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $35ee0d46d0d571c0$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($35ee0d46d0d571c0$var$_isEmptyString(accountName) || $35ee0d46d0d571c0$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($35ee0d46d0d571c0$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($35ee0d46d0d571c0$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $35ee0d46d0d571c0$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $35ee0d46d0d571c0$var$name = "@firebase/auth";
var $35ee0d46d0d571c0$var$version = "1.7.8";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $35ee0d46d0d571c0$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $35ee0d46d0d571c0$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $35ee0d46d0d571c0$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return "web-extension";
        default:
            return undefined;
    }
}
/** @internal */ function $35ee0d46d0d571c0$var$registerAuth(clientPlatform) {
    (0, $MjY8E._registerComponent)(new (0, $6ExWU.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $35ee0d46d0d571c0$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $35ee0d46d0d571c0$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $35ee0d46d0d571c0$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $35ee0d46d0d571c0$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $MjY8E._registerComponent)(new (0, $6ExWU.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $35ee0d46d0d571c0$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $35ee0d46d0d571c0$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $MjY8E.registerVersion)($35ee0d46d0d571c0$var$name, $35ee0d46d0d571c0$var$version, $35ee0d46d0d571c0$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $MjY8E.registerVersion)($35ee0d46d0d571c0$var$name, $35ee0d46d0d571c0$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $35ee0d46d0d571c0$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $35ee0d46d0d571c0$var$authIdTokenMaxAge = (0, $2xDiJ.getExperimentalSetting)("authIdTokenMaxAge") || $35ee0d46d0d571c0$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $35ee0d46d0d571c0$var$lastPostedIdToken = null;
const $35ee0d46d0d571c0$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $35ee0d46d0d571c0$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($35ee0d46d0d571c0$var$lastPostedIdToken === idToken) return;
        $35ee0d46d0d571c0$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $35ee0d46d0d571c0$export$ae1af26003f05816(app = (0, $MjY8E.getApp)()) {
    const provider = (0, $MjY8E._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $35ee0d46d0d571c0$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $35ee0d46d0d571c0$export$342063e11d6c3cad,
        persistence: [
            $35ee0d46d0d571c0$export$23f2a1d2818174ef,
            $35ee0d46d0d571c0$export$8b22cf2602fb60ce,
            $35ee0d46d0d571c0$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $2xDiJ.getExperimentalSetting)("authTokenSyncURL");
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === "boolean" && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $35ee0d46d0d571c0$var$mintCookieFactory(authTokenSyncUrl.toString());
            $35ee0d46d0d571c0$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $35ee0d46d0d571c0$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $2xDiJ.getDefaultEmulatorHost)("auth");
    if (authEmulatorHost) $35ee0d46d0d571c0$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $35ee0d46d0d571c0$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$35ee0d46d0d571c0$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement("script");
            el.setAttribute("src", url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $35ee0d46d0d571c0$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = "text/javascript";
            el.charset = "UTF-8";
            $35ee0d46d0d571c0$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: "https://apis.google.com/js/api.js",
    recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
    recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
$35ee0d46d0d571c0$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});
parcelRegister("4tSb9", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $3433e5a3eb89c040$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};

});




parcelRegister("3mbpE", function(module, exports) {

$parcel$export(module.exports, "firebaseAuthErrors", function () { return $efdbebb1446db778$export$224e941aa7cf4287; });
const $efdbebb1446db778$export$224e941aa7cf4287 = {
    "auth/admin-restricted-operation": "This operation is restricted to administrators only.",
    "auth/argument-error": "",
    "auth/app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
    "auth/app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
    "auth/captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
    "auth/code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
    "auth/cordova-not-ready": "Cordova framework is not ready.",
    "auth/cors-unsupported": "This browser is not supported.",
    "auth/credential-already-in-use": "This credential is already associated with a different user account.",
    "auth/custom-token-mismatch": "The custom token corresponds to a different audience.",
    "auth/requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
    "auth/dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
    "auth/email-change-needs-verification": "Multi-factor users must always have a verified email.",
    "auth/email-already-in-use": "The email address is already in use by another account.",
    "auth/expired-action-code": "The action code has expired. ",
    "auth/cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
    "auth/internal-error": "An internal error has occurred.",
    "auth/invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
    "auth/invalid-app-id": "The mobile app identifier is not registed for the current project.",
    "auth/invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
    "auth/invalid-auth-event": "An internal error has occurred.",
    "auth/invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
    "auth/invalid-continue-uri": "The continue URL provided in the request is invalid.",
    "auth/invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
    "auth/invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
    "auth/invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
    "auth/invalid-email": "The email address is badly formatted.",
    "auth/invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
    "auth/invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
    "auth/invalid-credential": "The supplied auth credential is malformed or has expired.",
    "auth/invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
    "auth/invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
    "auth/invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
    "auth/invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
    "auth/unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
    "auth/invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
    "auth/wrong-password": "The password is invalid or the user does not have a password.",
    "auth/invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
    "auth/invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
    "auth/invalid-provider-id": "The specified provider ID is invalid.",
    "auth/invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
    "auth/invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
    "auth/invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
    "auth/invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
    "auth/multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
    "auth/multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
    "auth/missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
    "auth/auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
    "auth/missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
    "auth/missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
    "auth/missing-continue-uri": "A continue URL must be provided in the request.",
    "auth/missing-iframe-start": "An internal error has occurred.",
    "auth/missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
    "auth/missing-multi-factor-info": "No second factor identifier is provided.",
    "auth/missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
    "auth/missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
    "auth/missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
    "auth/missing-verification-id": "The phone auth credential was created with an empty verification ID.",
    "auth/app-deleted": "This instance of FirebaseApp has been deleted.",
    "auth/account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
    "auth/network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
    "auth/no-auth-event": "An internal error has occurred.",
    "auth/no-such-provider": "User was not linked to an account with the given provider.",
    "auth/null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
    "auth/operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
    "auth/operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
    "auth/popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
    "auth/popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
    "auth/provider-already-linked": "User can only be linked to one identity for the given provider.",
    "auth/quota-exceeded": "The project's quota for this operation has been exceeded.",
    "auth/redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
    "auth/redirect-operation-pending": "A redirect sign-in operation is already pending.",
    "auth/rejected-credential": "The request contains malformed or mismatching credentials.",
    "auth/second-factor-already-in-use": "The second factor is already enrolled on this account.",
    "auth/maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
    "auth/tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
    "auth/timeout": "The operation has timed out.",
    "auth/user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
    "auth/too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
    "auth/unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
    "auth/unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
    "auth/unsupported-persistence-type": "The current environment does not support the specified persistence type.",
    "auth/unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
    "auth/unverified-email": "The operation requires a verified email.",
    "auth/user-cancelled": "The user did not grant your application the permissions it requested.",
    "auth/user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
    "auth/user-disabled": "The user account has been disabled by an administrator.",
    "auth/user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
    "auth/user-signed-out": "The user is signed out.",
    "auth/weak-password": "The password must be 6 characters long or more.",
    "auth/web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
};

});


parcelRegister("lLftU", function(module, exports) {

$parcel$export(module.exports, "jwtGetExpiresInDays", function () { return $3a1a821b63c40965$export$1d2314b1895438e2; });
$parcel$export(module.exports, "jwtDecode", function () { return $3a1a821b63c40965$export$fa1e2fb699b7861e; });
/**
 * Represents decoded API authentication token.
 * @type {JWT}
 */ const $3a1a821b63c40965$export$1d2314b1895438e2 = (token)=>{
    const day = 86400;
    const currentDate = Math.floor(Date.now() / 1000);
    const expiredInDays = Math.floor((token.exp - currentDate) / day);
    return expiredInDays;
};
const $3a1a821b63c40965$export$fa1e2fb699b7861e = (token)=>{
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(window.atob(base64).split("").map((c)=>`%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
    return JSON.parse(jsonPayload);
};

});

parcelRegister("vT5yJ", function(module, exports) {

$parcel$export(module.exports, "storageGetAuthToken", function () { return $22f506b8e6cd7e58$export$7ad25702bbbc2644; });
$parcel$export(module.exports, "storageSetAuthToken", function () { return $22f506b8e6cd7e58$export$1c68b820a330d0f9; });
$parcel$export(module.exports, "storageGetSentPasswordResetEmailDate", function () { return $22f506b8e6cd7e58$export$78e40faf782fa2d3; });
$parcel$export(module.exports, "storageSetSentPasswordResetEmailDate", function () { return $22f506b8e6cd7e58$export$95eca3f72d73e283; });
$parcel$export(module.exports, "storageGetSentVerificationEmailDate", function () { return $22f506b8e6cd7e58$export$114974c8222fd3b8; });
$parcel$export(module.exports, "storageSetSentVerificationEmailDate", function () { return $22f506b8e6cd7e58$export$4246dbd4eb03f04e; });
// config
parcelRequire("2uUQU");
var $bL329 = parcelRequire("bL329");
const $22f506b8e6cd7e58$export$7ad25702bbbc2644 = ()=>localStorage.getItem((0, $bL329.StorageKeys).AuthToken) || "";
const $22f506b8e6cd7e58$export$1c68b820a330d0f9 = (authToken)=>localStorage.setItem((0, $bL329.StorageKeys).AuthToken, authToken);
const $22f506b8e6cd7e58$export$78e40faf782fa2d3 = ()=>localStorage.getItem((0, $bL329.StorageKeys).SentPasswordResetEmailDate) || "";
const $22f506b8e6cd7e58$export$95eca3f72d73e283 = (date)=>localStorage.setItem((0, $bL329.StorageKeys).SentPasswordResetEmailDate, date);
const $22f506b8e6cd7e58$export$114974c8222fd3b8 = ()=>localStorage.getItem((0, $bL329.StorageKeys).SentVerificationEmailDate) || "";
const $22f506b8e6cd7e58$export$4246dbd4eb03f04e = (date)=>localStorage.setItem((0, $bL329.StorageKeys).SentVerificationEmailDate, date);

});



parcelRegister("86QaR", function(module, exports) {

$parcel$export(module.exports, "useInterval", function () { return $a1896ef4145a96fc$export$f4b266cd2aae9cb1; });

var $exYeM = parcelRequire("exYeM");
const $a1896ef4145a96fc$export$f4b266cd2aae9cb1 = (callback, delay)=>{
    const savedCallback = (0, $exYeM.useRef)();
    // remember the latest callback
    (0, $exYeM.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // set up the interval
    (0, $exYeM.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            savedCallback.current?.();
        }, delay);
        return ()=>clearInterval(intervalId);
    }, [
        delay
    ]);
};

});

parcelRegister("d6Ezf", function(module, exports) {

var $exYeM = parcelRequire("exYeM");
const $8698bcc4fa1b65dc$export$e8b771555dc4a003 = (ref)=>{
    const [width, setWidth] = (0, $exYeM.useState)(0);
    const [height, setHeight] = (0, $exYeM.useState)(0);
    const handleResize = (0, $exYeM.useCallback)(()=>{
        if (ref) {
            setWidth(ref.current?.offsetWidth || 0);
            setHeight(ref.current?.offsetHeight || 0);
        }
    }, [
        ref
    ]);
    (0, $exYeM.useEffect)(()=>{
        window.addEventListener("load", handleResize);
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("load", handleResize);
            window.removeEventListener("resize", handleResize);
        };
    }, [
        ref,
        handleResize
    ]);
    return {
        width: width,
        height: height
    };
};

});

parcelRegister("LLqcH", function(module, exports) {

$parcel$export(module.exports, "useComment", function () { return (parcelRequire("5F6ta")).useComment; });
$parcel$export(module.exports, "useConnectPayout", function () { return (parcelRequire("bMcg5")).useConnectPayout; });
$parcel$export(module.exports, "useConnectReady", function () { return (parcelRequire("9a5k4")).useConnectReady; });
$parcel$export(module.exports, "usePost", function () { return (parcelRequire("lBv1N")).usePost; });
$parcel$export(module.exports, "useSubscription", function () { return (parcelRequire("2qAsB")).useSubscription; });
$parcel$export(module.exports, "useSubscriptionPrice", function () { return (parcelRequire("aC0Kg")).useSubscriptionPrice; });
$parcel$export(module.exports, "useTip", function () { return (parcelRequire("hiFdq")).useTip; });
$parcel$export(module.exports, "useTrack", function () { return (parcelRequire("yKMRU")).useTrack; });
$parcel$export(module.exports, "useTracks", function () { return (parcelRequire("d1vGL")).useTracks; });
$parcel$export(module.exports, "useTracksPublic", function () { return (parcelRequire("1UJJS")).useTracksPublic; });
$parcel$export(module.exports, "useUnlock", function () { return (parcelRequire("f7MpX")).useUnlock; });
$parcel$export(module.exports, "useUser", function () { return (parcelRequire("gSFbK")).useUser; });
$parcel$export(module.exports, "useUserPublic", function () { return (parcelRequire("4y2bm")).useUserPublic; });
$parcel$export(module.exports, "useUsers", function () { return (parcelRequire("8a4Bv")).useUsers; });
$parcel$export(module.exports, "useUserStats", function () { return (parcelRequire("2Tvde")).useUserStats; });

var $5F6ta = parcelRequire("5F6ta");

var $bMcg5 = parcelRequire("bMcg5");

var $9a5k4 = parcelRequire("9a5k4");

var $lBv1N = parcelRequire("lBv1N");

var $2qAsB = parcelRequire("2qAsB");

var $aC0Kg = parcelRequire("aC0Kg");

var $hiFdq = parcelRequire("hiFdq");

var $yKMRU = parcelRequire("yKMRU");

var $d1vGL = parcelRequire("d1vGL");

var $1UJJS = parcelRequire("1UJJS");

var $f7MpX = parcelRequire("f7MpX");

var $gSFbK = parcelRequire("gSFbK");

var $4y2bm = parcelRequire("4y2bm");

var $8a4Bv = parcelRequire("8a4Bv");

var $2Tvde = parcelRequire("2Tvde");

});
parcelRegister("5F6ta", function(module, exports) {

$parcel$export(module.exports, "useComment", function () { return $ce14451088e3f7c5$export$4c1f83d02cdf94f9; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $ce14451088e3f7c5$var$getComment = async ({ data: { commentId: commentId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve comment
        const { comment: comment } = await api.commentApi.getComment(commentId);
        // return payload
        return {
            comment: comment,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            comment: undefined,
            error: message
        };
    }
};
const $ce14451088e3f7c5$var$fetcher = (args)=>$ce14451088e3f7c5$var$getComment(args);
const $ce14451088e3f7c5$export$4c1f83d02cdf94f9 = (commentId)=>{
    const shouldFetch = !!commentId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseComment,
        data: {
            commentId: commentId
        }
    } : null, $ce14451088e3f7c5$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        comment: data?.comment,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});
parcelRegister("jSpGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e786fccab33c943f$export$2e2bcd8739ae039; });
parcelRequire("cHilp");

var $exYeM = parcelRequire("exYeM");

var $ePGDo = parcelRequire("ePGDo");

var $8zFFs = parcelRequire("8zFFs");
const $e786fccab33c943f$export$dbab534a48e651ef = (key)=>(0, $8zFFs.serialize)(key)[0];
/// <reference types="react/experimental" />
const $e786fccab33c943f$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $e786fccab33c943f$var$WITH_DEDUPE = {
    dedupe: true
};
const $e786fccab33c943f$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $8zFFs.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $8zFFs.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $exYeM.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $exYeM.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $exYeM.useRef)(key);
    const fetcherRef = (0, $exYeM.useRef)(fetcher);
    const configRef = (0, $exYeM.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $8zFFs.createCacheHelper)(cache, key);
    const stateDependencies = (0, $exYeM.useRef)({}).current;
    const fallback = (0, $8zFFs.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $8zFFs.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $exYeM.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $8zFFs.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $8zFFs.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $8zFFs.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $ePGDo.useSyncExternalStore)((0, $exYeM.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $8zFFs.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $exYeM.useRef)(data);
    const returnedData = keepPreviousData ? (0, $8zFFs.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $8zFFs.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $8zFFs.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $8zFFs.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $8zFFs.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $8zFFs.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $8zFFs.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $exYeM.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $8zFFs.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $8zFFs.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $8zFFs.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $8zFFs.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $8zFFs.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $8zFFs.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $8zFFs.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $8zFFs.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $exYeM.useCallback)((...args)=>{
        return (0, $8zFFs.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $8zFFs.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $8zFFs.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $8zFFs.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $8zFFs.UNDEFINED), $e786fccab33c943f$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $8zFFs.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $8zFFs.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $8zFFs.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $8zFFs.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $8zFFs.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $8zFFs.isUndefined)(data) || (0, $8zFFs.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $8zFFs.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $8zFFs.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $8zFFs.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($e786fccab33c943f$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $exYeM.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $8zFFs.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $8zFFs.IS_REACT_LEGACY) && (0, $8zFFs.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $8zFFs.isUndefined)(req)) {
            const promise = boundMutate(req);
            $e786fccab33c943f$var$use(promise);
        }
        if ((0, $8zFFs.isUndefined)(error)) {
            const promise = revalidate($e786fccab33c943f$var$WITH_DEDUPE);
            if (!(0, $8zFFs.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $e786fccab33c943f$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $e786fccab33c943f$export$4c7bbecdacc3ca2c = (0, $8zFFs.OBJECT).defineProperty((0, $8zFFs.SWRConfig), "defaultValue", {
    value: (0, $8zFFs.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $e786fccab33c943f$export$2e2bcd8739ae039 = (0, $8zFFs.withArgs)($e786fccab33c943f$var$useSWRHandler);

});
parcelRegister("cHilp", function(module, exports) {

});

parcelRegister("ePGDo", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kvD72"));

});
parcelRegister("kvD72", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16; }, function (v) { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eee50ad7e4fe08dc$export$306c0aa65ff9ec16;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $eee50ad7e4fe08dc$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $eee50ad7e4fe08dc$var$k = "function" === typeof Object.is ? Object.is : $eee50ad7e4fe08dc$var$h, $eee50ad7e4fe08dc$var$l = $exYeM.useState, $eee50ad7e4fe08dc$var$m = $exYeM.useEffect, $eee50ad7e4fe08dc$var$n = $exYeM.useLayoutEffect, $eee50ad7e4fe08dc$var$p = $exYeM.useDebugValue;
function $eee50ad7e4fe08dc$var$q(a, b) {
    var d = b(), f = $eee50ad7e4fe08dc$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $eee50ad7e4fe08dc$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $eee50ad7e4fe08dc$var$m(function() {
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $eee50ad7e4fe08dc$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $eee50ad7e4fe08dc$var$p(d);
    return d;
}
function $eee50ad7e4fe08dc$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$eee50ad7e4fe08dc$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $eee50ad7e4fe08dc$var$t(a, b) {
    return b();
}
var $eee50ad7e4fe08dc$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $eee50ad7e4fe08dc$var$t : $eee50ad7e4fe08dc$var$q;
$eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = void 0 !== $exYeM.useSyncExternalStore ? $exYeM.useSyncExternalStore : $eee50ad7e4fe08dc$var$u;

});


parcelRegister("8zFFs", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", function () { return $63e1e9f85d2f147c$export$6db089fe7b26f5b6; });
$parcel$export(module.exports, "OBJECT", function () { return $63e1e9f85d2f147c$export$8b8a958a7f6f130c; });
$parcel$export(module.exports, "isUndefined", function () { return $63e1e9f85d2f147c$export$fce6876652108ab; });
$parcel$export(module.exports, "isFunction", function () { return $63e1e9f85d2f147c$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "mergeObjects", function () { return $63e1e9f85d2f147c$export$2321aea138b44780; });
$parcel$export(module.exports, "SWRGlobalState", function () { return $63e1e9f85d2f147c$export$b94ca9901c60634; });
$parcel$export(module.exports, "createCacheHelper", function () { return $63e1e9f85d2f147c$export$1251d51d9c571b45; });
$parcel$export(module.exports, "IS_REACT_LEGACY", function () { return $63e1e9f85d2f147c$export$ddb64fe6466374f7; });
$parcel$export(module.exports, "IS_SERVER", function () { return $63e1e9f85d2f147c$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "rAF", function () { return $63e1e9f85d2f147c$export$eba6076d3d7d0c06; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $63e1e9f85d2f147c$export$700979bc83e7db82; });
$parcel$export(module.exports, "serialize", function () { return $63e1e9f85d2f147c$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "getTimestamp", function () { return $63e1e9f85d2f147c$export$3c95c4c8b671ef0; });
$parcel$export(module.exports, "revalidateEvents", function () { return $63e1e9f85d2f147c$export$10213d6aa5ce32e6; });
$parcel$export(module.exports, "internalMutate", function () { return $63e1e9f85d2f147c$export$c9d44e5bea4509be; });
$parcel$export(module.exports, "defaultConfig", function () { return $63e1e9f85d2f147c$export$f84bd70098573c5c; });
$parcel$export(module.exports, "SWRConfig", function () { return $63e1e9f85d2f147c$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "withArgs", function () { return $63e1e9f85d2f147c$export$84d44e54e14b0133; });
$parcel$export(module.exports, "subscribeCallback", function () { return $63e1e9f85d2f147c$export$e005210ed621746; });

var $exYeM = parcelRequire("exYeM");
// Shared state between server components and client components
const $63e1e9f85d2f147c$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $63e1e9f85d2f147c$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $63e1e9f85d2f147c$export$8793edee2d425525();
const $63e1e9f85d2f147c$export$8b8a958a7f6f130c = Object;
const $63e1e9f85d2f147c$export$fce6876652108ab = (v)=>v === $63e1e9f85d2f147c$export$6db089fe7b26f5b6;
const $63e1e9f85d2f147c$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $63e1e9f85d2f147c$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $63e1e9f85d2f147c$export$ae936b9d47e5870e = (x)=>$63e1e9f85d2f147c$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $63e1e9f85d2f147c$var$table = new WeakMap();
// counter of the key
let $63e1e9f85d2f147c$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $63e1e9f85d2f147c$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($63e1e9f85d2f147c$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $63e1e9f85d2f147c$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$63e1e9f85d2f147c$var$counter + "~";
        $63e1e9f85d2f147c$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $63e1e9f85d2f147c$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $63e1e9f85d2f147c$var$table.set(arg, result);
        }
        if (constructor == $63e1e9f85d2f147c$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $63e1e9f85d2f147c$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$63e1e9f85d2f147c$export$fce6876652108ab(index = keys.pop()))if (!$63e1e9f85d2f147c$export$fce6876652108ab(arg[index])) result += index + ":" + $63e1e9f85d2f147c$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $63e1e9f85d2f147c$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $63e1e9f85d2f147c$export$b94ca9901c60634 = new WeakMap();
const $63e1e9f85d2f147c$var$EMPTY_CACHE = {};
const $63e1e9f85d2f147c$var$INITIAL_CACHE = {};
const $63e1e9f85d2f147c$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $63e1e9f85d2f147c$export$6e85fd745dc51282 = typeof window != $63e1e9f85d2f147c$var$STR_UNDEFINED;
const $63e1e9f85d2f147c$export$842dfe7a9f24298 = typeof document != $63e1e9f85d2f147c$var$STR_UNDEFINED;
const $63e1e9f85d2f147c$export$a9116928c9d15917 = ()=>$63e1e9f85d2f147c$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $63e1e9f85d2f147c$var$STR_UNDEFINED;
const $63e1e9f85d2f147c$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $63e1e9f85d2f147c$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$63e1e9f85d2f147c$export$fce6876652108ab(key) && cache.get(key) || $63e1e9f85d2f147c$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$63e1e9f85d2f147c$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $63e1e9f85d2f147c$var$INITIAL_CACHE)) $63e1e9f85d2f147c$var$INITIAL_CACHE[key] = prev;
                state[5](key, $63e1e9f85d2f147c$export$2321aea138b44780(prev, info), prev || $63e1e9f85d2f147c$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$63e1e9f85d2f147c$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $63e1e9f85d2f147c$var$INITIAL_CACHE) return $63e1e9f85d2f147c$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$63e1e9f85d2f147c$export$fce6876652108ab(key) && cache.get(key) || $63e1e9f85d2f147c$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $63e1e9f85d2f147c$var$online = true;
const $63e1e9f85d2f147c$var$isOnline = ()=>$63e1e9f85d2f147c$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$63e1e9f85d2f147c$var$onWindowEvent, $63e1e9f85d2f147c$var$offWindowEvent] = $63e1e9f85d2f147c$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $63e1e9f85d2f147c$export$8793edee2d425525,
    $63e1e9f85d2f147c$export$8793edee2d425525
];
const $63e1e9f85d2f147c$var$isVisible = ()=>{
    const visibilityState = $63e1e9f85d2f147c$export$842dfe7a9f24298 && document.visibilityState;
    return $63e1e9f85d2f147c$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $63e1e9f85d2f147c$var$initFocus = (callback)=>{
    // focus revalidate
    if ($63e1e9f85d2f147c$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $63e1e9f85d2f147c$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($63e1e9f85d2f147c$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $63e1e9f85d2f147c$var$offWindowEvent("focus", callback);
    };
};
const $63e1e9f85d2f147c$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $63e1e9f85d2f147c$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $63e1e9f85d2f147c$var$online = false;
    };
    $63e1e9f85d2f147c$var$onWindowEvent("online", onOnline);
    $63e1e9f85d2f147c$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $63e1e9f85d2f147c$var$offWindowEvent("online", onOnline);
        $63e1e9f85d2f147c$var$offWindowEvent("offline", onOffline);
    };
};
const $63e1e9f85d2f147c$export$f5ab8217e0edff04 = {
    isOnline: $63e1e9f85d2f147c$var$isOnline,
    isVisible: $63e1e9f85d2f147c$var$isVisible
};
const $63e1e9f85d2f147c$export$b1857f3440a65373 = {
    initFocus: $63e1e9f85d2f147c$var$initFocus,
    initReconnect: $63e1e9f85d2f147c$var$initReconnect
};
const $63e1e9f85d2f147c$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useId;
const $63e1e9f85d2f147c$export$d2f4d8e74279c212 = !$63e1e9f85d2f147c$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $63e1e9f85d2f147c$export$eba6076d3d7d0c06 = (f)=>$63e1e9f85d2f147c$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $63e1e9f85d2f147c$export$700979bc83e7db82 = $63e1e9f85d2f147c$export$d2f4d8e74279c212 ? (0, $exYeM.useEffect) : (0, $exYeM.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $63e1e9f85d2f147c$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $63e1e9f85d2f147c$export$3723beb60427dc52 = !$63e1e9f85d2f147c$export$d2f4d8e74279c212 && $63e1e9f85d2f147c$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($63e1e9f85d2f147c$var$navigatorConnection.effectiveType) || $63e1e9f85d2f147c$var$navigatorConnection.saveData);
const $63e1e9f85d2f147c$export$dfdc1655ccc5b9cb = (key)=>{
    if ($63e1e9f85d2f147c$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $63e1e9f85d2f147c$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $63e1e9f85d2f147c$var$__timestamp = 0;
const $63e1e9f85d2f147c$export$3c95c4c8b671ef0 = ()=>++$63e1e9f85d2f147c$var$__timestamp;
const $63e1e9f85d2f147c$var$FOCUS_EVENT = 0;
const $63e1e9f85d2f147c$var$RECONNECT_EVENT = 1;
const $63e1e9f85d2f147c$var$MUTATE_EVENT = 2;
const $63e1e9f85d2f147c$var$ERROR_REVALIDATE_EVENT = 3;
var $63e1e9f85d2f147c$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $63e1e9f85d2f147c$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $63e1e9f85d2f147c$var$FOCUS_EVENT,
    MUTATE_EVENT: $63e1e9f85d2f147c$var$MUTATE_EVENT,
    RECONNECT_EVENT: $63e1e9f85d2f147c$var$RECONNECT_EVENT
};
async function $63e1e9f85d2f147c$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $63e1e9f85d2f147c$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($63e1e9f85d2f147c$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $63e1e9f85d2f147c$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $63e1e9f85d2f147c$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $63e1e9f85d2f147c$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $63e1e9f85d2f147c$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($63e1e9f85d2f147c$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $63e1e9f85d2f147c$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$63e1e9f85d2f147c$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $63e1e9f85d2f147c$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $63e1e9f85d2f147c$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($63e1e9f85d2f147c$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $63e1e9f85d2f147c$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $63e1e9f85d2f147c$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($63e1e9f85d2f147c$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $63e1e9f85d2f147c$export$6db089fe7b26f5b6,
                        _c: $63e1e9f85d2f147c$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $63e1e9f85d2f147c$export$6db089fe7b26f5b6,
                    _c: $63e1e9f85d2f147c$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $63e1e9f85d2f147c$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $63e1e9f85d2f147c$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $63e1e9f85d2f147c$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $63e1e9f85d2f147c$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$63e1e9f85d2f147c$export$b94ca9901c60634.has(provider)) {
        const opts = $63e1e9f85d2f147c$export$2321aea138b44780($63e1e9f85d2f147c$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $63e1e9f85d2f147c$export$c9d44e5bea4509be.bind($63e1e9f85d2f147c$export$6db089fe7b26f5b6, provider);
        let unmount = $63e1e9f85d2f147c$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$63e1e9f85d2f147c$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $63e1e9f85d2f147c$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$63e1e9f85d2f147c$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($63e1e9f85d2f147c$export$6db089fe7b26f5b6, $63e1e9f85d2f147c$var$revalidateAllKeys.bind($63e1e9f85d2f147c$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $63e1e9f85d2f147c$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($63e1e9f85d2f147c$export$6db089fe7b26f5b6, $63e1e9f85d2f147c$var$revalidateAllKeys.bind($63e1e9f85d2f147c$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $63e1e9f85d2f147c$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $63e1e9f85d2f147c$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $63e1e9f85d2f147c$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $63e1e9f85d2f147c$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$63e1e9f85d2f147c$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $63e1e9f85d2f147c$export$398604a469f7de9a = (currentData, newData)=>$63e1e9f85d2f147c$export$e9a4e06c7dfb0bd4(currentData) == $63e1e9f85d2f147c$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$63e1e9f85d2f147c$export$69a3209f1a06c04d, $63e1e9f85d2f147c$export$57e795267c26e600] = $63e1e9f85d2f147c$export$4008f5b66f9e0b3c(new Map());
// Default config
const $63e1e9f85d2f147c$export$f84bd70098573c5c = $63e1e9f85d2f147c$export$2321aea138b44780({
    // events
    onLoadingSlow: $63e1e9f85d2f147c$export$8793edee2d425525,
    onSuccess: $63e1e9f85d2f147c$export$8793edee2d425525,
    onError: $63e1e9f85d2f147c$export$8793edee2d425525,
    onErrorRetry: $63e1e9f85d2f147c$var$onErrorRetry,
    onDiscarded: $63e1e9f85d2f147c$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $63e1e9f85d2f147c$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $63e1e9f85d2f147c$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $63e1e9f85d2f147c$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $63e1e9f85d2f147c$export$69a3209f1a06c04d,
    mutate: $63e1e9f85d2f147c$export$57e795267c26e600,
    fallback: {}
}, $63e1e9f85d2f147c$export$f5ab8217e0edff04);
const $63e1e9f85d2f147c$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $63e1e9f85d2f147c$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $63e1e9f85d2f147c$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $63e1e9f85d2f147c$var$SWRConfigContext = (0, $exYeM.createContext)({});
const $63e1e9f85d2f147c$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $exYeM.useContext)($63e1e9f85d2f147c$var$SWRConfigContext);
    const isFunctionalConfig = $63e1e9f85d2f147c$export$f6e2535fb5126e54(value);
    const config = (0, $exYeM.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $exYeM.useMemo)(()=>isFunctionalConfig ? config : $63e1e9f85d2f147c$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $exYeM.useRef)($63e1e9f85d2f147c$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $63e1e9f85d2f147c$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $63e1e9f85d2f147c$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $63e1e9f85d2f147c$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $exYeM.createElement)($63e1e9f85d2f147c$var$SWRConfigContext.Provider, $63e1e9f85d2f147c$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $63e1e9f85d2f147c$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $63e1e9f85d2f147c$var$enableDevtools = $63e1e9f85d2f147c$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $63e1e9f85d2f147c$var$use = $63e1e9f85d2f147c$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $63e1e9f85d2f147c$var$setupDevTools = ()=>{
    if ($63e1e9f85d2f147c$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
};
const $63e1e9f85d2f147c$export$a3295358bff77e = (args)=>{
    return $63e1e9f85d2f147c$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $63e1e9f85d2f147c$export$f1dc0e282d4c1c0 = ()=>{
    return $63e1e9f85d2f147c$export$2321aea138b44780($63e1e9f85d2f147c$export$f84bd70098573c5c, (0, $exYeM.useContext)($63e1e9f85d2f147c$var$SWRConfigContext));
};
const $63e1e9f85d2f147c$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $63e1e9f85d2f147c$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $63e1e9f85d2f147c$export$b94ca9901c60634.get($63e1e9f85d2f147c$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $63e1e9f85d2f147c$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $63e1e9f85d2f147c$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $63e1e9f85d2f147c$export$b94ca9901c60634.get($63e1e9f85d2f147c$export$69a3209f1a06c04d);
            if (key.startsWith($63e1e9f85d2f147c$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($63e1e9f85d2f147c$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $63e1e9f85d2f147c$var$BUILT_IN_MIDDLEWARE = $63e1e9f85d2f147c$var$use.concat($63e1e9f85d2f147c$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $63e1e9f85d2f147c$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $63e1e9f85d2f147c$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $63e1e9f85d2f147c$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $63e1e9f85d2f147c$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($63e1e9f85d2f147c$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $63e1e9f85d2f147c$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $63e1e9f85d2f147c$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $63e1e9f85d2f147c$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$63e1e9f85d2f147c$var$setupDevTools();

});


parcelRegister("entkX", function(module, exports) {

$parcel$export(module.exports, "SWRKeys", function () { return $88f1531ce8f8c8a8$export$7360c809f66e820e; });
// SWRKeys - represents unique keys for swr hooks.
var $88f1531ce8f8c8a8$export$7360c809f66e820e;
(function(SWRKeys) {
    SWRKeys["UseComment"] = "USE_COMMENT";
    SWRKeys["UseConnectPayout"] = "USE_CONNECT_PAYOUT";
    SWRKeys["UseConnectReady"] = "USE_CONNECT_READY";
    SWRKeys["UsePost"] = "USE_POST";
    SWRKeys["UseSubscription"] = "USE_SUBSCRIPTION";
    SWRKeys["UseSubscriptionPrice"] = "USE_SUBSCRIPTION_PRICE";
    SWRKeys["UseTip"] = "USE_TIP";
    SWRKeys["UseTrack"] = "USE_TRACK";
    SWRKeys["UseTracks"] = "USE_TRACKS";
    SWRKeys["UseTracksPublic"] = "USE_TRACKS_PUBLIC";
    SWRKeys["UseUnlock"] = "USE_UNLOCK";
    SWRKeys["UseUser"] = "USE_USER";
    SWRKeys["UseUsers"] = "USE_USERS";
    SWRKeys["UseUserPublic"] = "USE_USER_PUBLIC";
    SWRKeys["UseUserStats"] = "USE_USER_STATS";
})($88f1531ce8f8c8a8$export$7360c809f66e820e || ($88f1531ce8f8c8a8$export$7360c809f66e820e = {}));

});


parcelRegister("bMcg5", function(module, exports) {

$parcel$export(module.exports, "useConnectPayout", function () { return $4908e10fe8473455$export$c427682aaf595823; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $4908e10fe8473455$var$getConnectPayout = async ({ data: { connectPayoutId: connectPayoutId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve connect payout
        const { connectPayout: connectPayout } = await api.connectApi.getConnectPayout(connectPayoutId);
        // return payload
        return {
            connectPayout: connectPayout,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            connectPayout: undefined,
            error: message
        };
    }
};
const $4908e10fe8473455$var$fetcher = (args)=>$4908e10fe8473455$var$getConnectPayout(args);
const $4908e10fe8473455$export$c427682aaf595823 = (connectPayoutId)=>{
    const shouldFetch = !!connectPayoutId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseConnectPayout,
        data: {
            connectPayoutId: connectPayoutId
        }
    } : null, $4908e10fe8473455$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        connectPayout: data?.connectPayout,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("9a5k4", function(module, exports) {

$parcel$export(module.exports, "useConnectReady", function () { return $3321b7c30641f356$export$d925aee74f737a7c; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $3321b7c30641f356$var$getConnectReadiness = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get connect readiness
        const { ready: ready } = await api.connectApi.getConnectReadiness(userId);
        // return payload
        return {
            ready: ready,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            ready: false,
            error: message
        };
    }
};
const $3321b7c30641f356$var$fetcher = (args)=>$3321b7c30641f356$var$getConnectReadiness(args);
const $3321b7c30641f356$export$d925aee74f737a7c = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseConnectReady,
        data: {
            userId: userId
        }
    } : null, $3321b7c30641f356$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        ready: data?.ready,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("lBv1N", function(module, exports) {

$parcel$export(module.exports, "usePost", function () { return $96bf095b1d1bf6e0$export$9158e33c8d0ca687; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $96bf095b1d1bf6e0$var$getPost = async ({ data: { postId: postId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve post
        const { post: post } = await api.postApi.getPost(postId);
        // return payload
        return {
            post: post,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            post: undefined,
            error: message
        };
    }
};
const $96bf095b1d1bf6e0$var$fetcher = (args)=>$96bf095b1d1bf6e0$var$getPost(args);
const $96bf095b1d1bf6e0$export$9158e33c8d0ca687 = (postId)=>{
    const shouldFetch = !!postId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UsePost,
        data: {
            postId: postId
        }
    } : null, $96bf095b1d1bf6e0$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        post: data?.post,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("2qAsB", function(module, exports) {

$parcel$export(module.exports, "useSubscription", function () { return $b268703a411f5b91$export$368b4214baeb914c; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $b268703a411f5b91$var$getSubscription = async ({ data: { subscriptionId: subscriptionId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve subscription
        const { subscription: subscription } = await api.subscriptionApi.getSubscription(subscriptionId);
        // return payload
        return {
            subscription: subscription,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            subscription: undefined,
            error: message
        };
    }
};
const $b268703a411f5b91$var$fetcher = (args)=>$b268703a411f5b91$var$getSubscription(args);
const $b268703a411f5b91$export$368b4214baeb914c = (subscriptionId)=>{
    const shouldFetch = !!subscriptionId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseSubscription,
        data: {
            subscriptionId: subscriptionId
        }
    } : null, $b268703a411f5b91$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        subscription: data?.subscription,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("aC0Kg", function(module, exports) {

$parcel$export(module.exports, "useSubscriptionPrice", function () { return $5eda5c023bebf77d$export$833b744e66986faf; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $5eda5c023bebf77d$var$getSubscriptionPrice = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve subscription price
        const { subscriptionPrice: subscriptionPrice } = await api.subscriptionApi.getUserSubscriptionPrice(userId);
        // return payload
        return {
            subscriptionPrice: subscriptionPrice,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            subscriptionPrice: undefined,
            error: message
        };
    }
};
const $5eda5c023bebf77d$var$fetcher = (args)=>$5eda5c023bebf77d$var$getSubscriptionPrice(args);
const $5eda5c023bebf77d$export$833b744e66986faf = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseSubscriptionPrice,
        data: {
            userId: userId
        }
    } : null, $5eda5c023bebf77d$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        subscriptionPrice: data?.subscriptionPrice,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("hiFdq", function(module, exports) {

$parcel$export(module.exports, "useTip", function () { return $ff246ff683233deb$export$3e8bc5425d7d6093; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $ff246ff683233deb$var$getTip = async ({ data: { tipId: tipId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tip
        const { tip: tip } = await api.tipApi.getTip(tipId);
        // return payload
        return {
            tip: tip,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            tip: undefined,
            error: message
        };
    }
};
const $ff246ff683233deb$var$fetcher = (args)=>$ff246ff683233deb$var$getTip(args);
const $ff246ff683233deb$export$3e8bc5425d7d6093 = (tipId)=>{
    const shouldFetch = !!tipId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseTip,
        data: {
            tipId: tipId
        }
    } : null, $ff246ff683233deb$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        tip: data?.tip,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("yKMRU", function(module, exports) {

$parcel$export(module.exports, "useTrack", function () { return $d117c5a3a9f8f972$export$60a459a981d7d2d9; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $d117c5a3a9f8f972$var$getTrack = async ({ data: { trackId: trackId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve track
        const { track: track } = await api.trackApi.getTrack(trackId);
        // return payload
        return {
            track: track,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            track: undefined,
            error: message
        };
    }
};
const $d117c5a3a9f8f972$var$fetcher = (args)=>$d117c5a3a9f8f972$var$getTrack(args);
const $d117c5a3a9f8f972$export$60a459a981d7d2d9 = (trackId)=>{
    const shouldFetch = !!trackId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseTrack,
        data: {
            trackId: trackId
        }
    } : null, $d117c5a3a9f8f972$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        track: data?.track,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("d1vGL", function(module, exports) {

$parcel$export(module.exports, "useTracks", function () { return $de4c335754a3894b$export$ac24e1f911a9f36c; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $de4c335754a3894b$var$getTracksByIds = async ({ data: { trackIds: trackIds } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // if no track ids provided
    if (trackIds.length === 0) // return empty payload
    return {
        tracks: [],
        count: 0,
        error: ""
    };
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getTracksByIds(trackIds.join(","));
        // return payload
        return {
            tracks: tracks,
            count: count,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error
        return {
            tracks: [],
            count: 0,
            error: message
        };
    }
};
const $de4c335754a3894b$var$fetcher = (args)=>$de4c335754a3894b$var$getTracksByIds(args);
const $de4c335754a3894b$export$ac24e1f911a9f36c = (trackIds)=>{
    const { data: data, isLoading: isLoading } = (0, $jSpGM.default)({
        key: (0, $entkX.SWRKeys).UseTracks,
        data: {
            trackIds: trackIds
        }
    }, $de4c335754a3894b$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        tracks: data?.tracks,
        count: data?.count,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("1UJJS", function(module, exports) {

$parcel$export(module.exports, "useTracksPublic", function () { return $1d1a975284a01a18$export$f5bc4564080a741a; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $1d1a975284a01a18$var$getPublicTracksByIds = async ({ data: { trackIds: trackIds } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // if no track ids provided
    if (trackIds.length === 0) // return empty payload
    return {
        tracks: [],
        count: 0,
        error: ""
    };
    try {
        // retrieve public tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPublicTracksByIds(trackIds.join(","));
        // return payload
        return {
            tracks: tracks,
            count: count,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error
        return {
            tracks: [],
            count: 0,
            error: message
        };
    }
};
const $1d1a975284a01a18$var$fetcher = (args)=>$1d1a975284a01a18$var$getPublicTracksByIds(args);
const $1d1a975284a01a18$export$f5bc4564080a741a = (trackIds)=>{
    const { data: data, isLoading: isLoading } = (0, $jSpGM.default)({
        key: (0, $entkX.SWRKeys).UseTracksPublic,
        data: {
            trackIds: trackIds
        }
    }, $1d1a975284a01a18$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        tracks: data?.tracks,
        count: data?.count,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("f7MpX", function(module, exports) {

$parcel$export(module.exports, "useUnlock", function () { return $59002a792f91aad3$export$ac82547f128fc31b; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $59002a792f91aad3$var$getUnlock = async ({ data: { unlockId: unlockId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve unlock
        const { unlock: unlock } = await api.unlockApi.getUnlock(unlockId);
        // return payload
        return {
            unlock: unlock,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            unlock: undefined,
            error: message
        };
    }
};
const $59002a792f91aad3$var$fetcher = (args)=>$59002a792f91aad3$var$getUnlock(args);
const $59002a792f91aad3$export$ac82547f128fc31b = (unlockId)=>{
    const shouldFetch = !!unlockId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseUnlock,
        data: {
            unlockId: unlockId
        }
    } : null, $59002a792f91aad3$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        unlock: data?.unlock,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("gSFbK", function(module, exports) {

$parcel$export(module.exports, "useUser", function () { return $bd15a056b75299f8$export$23bbbc4533528f03; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $bd15a056b75299f8$var$getUser = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve user
        const { user: user } = await api.userApi.getUser(userId);
        // return payload
        return {
            user: user,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            user: undefined,
            error: message
        };
    }
};
const $bd15a056b75299f8$var$fetcher = (args)=>$bd15a056b75299f8$var$getUser(args);
const $bd15a056b75299f8$export$23bbbc4533528f03 = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseUser,
        data: {
            userId: userId
        }
    } : null, $bd15a056b75299f8$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        user: data?.user,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("4y2bm", function(module, exports) {

$parcel$export(module.exports, "useUserPublic", function () { return $4394578610ef9a2a$export$2a67f4ed498d5944; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $4394578610ef9a2a$var$getPublicUser = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve public user
        const { user: user } = await api.userApi.getPublicUser(userId);
        // return payload
        return {
            user: user,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            user: undefined,
            error: message
        };
    }
};
const $4394578610ef9a2a$var$fetcher = (args)=>$4394578610ef9a2a$var$getPublicUser(args);
const $4394578610ef9a2a$export$2a67f4ed498d5944 = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseUserPublic,
        data: {
            userId: userId
        }
    } : null, $4394578610ef9a2a$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        user: data?.user,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("8a4Bv", function(module, exports) {

$parcel$export(module.exports, "useUsers", function () { return $43338ab6beebf748$export$90f4370c54dd43c9; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $43338ab6beebf748$var$getUsersByIds = async ({ data: { userIds: userIds } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // if no user ids provided
    if (userIds.length === 0) // return empty payload
    return {
        users: [],
        count: 0,
        error: ""
    };
    try {
        // retrieve users
        const { users: users, count: count } = await api.userApi.getUsersByIds(userIds.join(","));
        // return payload
        return {
            users: users,
            count: count,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error
        return {
            users: [],
            count: 0,
            error: message
        };
    }
};
const $43338ab6beebf748$var$fetcher = (args)=>$43338ab6beebf748$var$getUsersByIds(args);
const $43338ab6beebf748$export$90f4370c54dd43c9 = (userIds)=>{
    const { data: data, isLoading: isLoading } = (0, $jSpGM.default)({
        key: (0, $entkX.SWRKeys).UseUsers,
        data: {
            userIds: userIds
        }
    }, $43338ab6beebf748$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        users: data?.users,
        count: data?.count,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("2Tvde", function(module, exports) {

$parcel$export(module.exports, "useUserStats", function () { return $a0a74f54b9a9e232$export$1adece3fb6ad67ff; });

var $jSpGM = parcelRequire("jSpGM");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");

var $entkX = parcelRequire("entkX");
const $a0a74f54b9a9e232$var$getUserStats = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve posts count
        const { count: postsCount } = await api.postApi.getUserPostsCount(userId);
        // retrieve tracks count
        const { count: tracksCount } = await api.trackApi.getUserTracksCount(userId);
        // return payload
        return {
            postsCount: postsCount,
            tracksCount: tracksCount,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return payload
        return {
            postsCount: 0,
            tracksCount: 0,
            error: message
        };
    }
};
const $a0a74f54b9a9e232$var$fetcher = (args)=>$a0a74f54b9a9e232$var$getUserStats(args);
const $a0a74f54b9a9e232$export$1adece3fb6ad67ff = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading } = (0, $jSpGM.default)(shouldFetch ? {
        key: (0, $entkX.SWRKeys).UseUserStats,
        data: {
            userId: userId
        }
    } : null, $a0a74f54b9a9e232$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        postsCount: data?.postsCount,
        tracksCount: data?.tracksCount,
        isLoading: isLoading,
        isError: data?.error
    };
};

});



parcelRegister("djJdy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2b85ad59748d4d55$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $2b85ad59748d4d55$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).alert.modal, ";position:fixed;top:0;left:0;width:100%;", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                message: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("ic5m0", function(module, exports) {

$parcel$export(module.exports, "AlertMessageType", function () { return $045349aba6612fa9$export$ce4c141af0ec0b42; });
var $045349aba6612fa9$export$ce4c141af0ec0b42;
(function(AlertMessageType) {
    AlertMessageType["Info"] = "info";
    AlertMessageType["Warn"] = "warn";
    AlertMessageType["Error"] = "error";
})($045349aba6612fa9$export$ce4c141af0ec0b42 || ($045349aba6612fa9$export$ce4c141af0ec0b42 = {}));

});

parcelRegister("joOpk", function(module, exports) {

$parcel$export(module.exports, "alertSlice", function () { return $a874b80e2d80ba6c$export$347ed57d7b031934; });
$parcel$export(module.exports, "alertAddMessage", function () { return $a874b80e2d80ba6c$export$539a1eed9a97cb62; });
$parcel$export(module.exports, "alertRemoveMessage", function () { return $a874b80e2d80ba6c$export$c1a8b8fb2cbef9fe; });
$parcel$export(module.exports, "alertSelectMessages", function () { return $a874b80e2d80ba6c$export$1a389607ab64f99; });
$parcel$export(module.exports, "alertReducer", function () { return $a874b80e2d80ba6c$export$5edbb3adab4c0050; });

var $dEr3t = parcelRequire("dEr3t");
const $a874b80e2d80ba6c$var$initialState = {
    messages: []
};
const $a874b80e2d80ba6c$export$347ed57d7b031934 = (0, $dEr3t.createSlice)({
    name: "alert",
    initialState: $a874b80e2d80ba6c$var$initialState,
    reducers: {
        // reset state
        alertResetState: ()=>({
                messages: []
            }),
        // add message
        alertAddMessage: (state, action)=>{
            const { message: message } = action.payload;
            // mutate state
            state.messages.push(message);
        },
        // remove message
        alertRemoveMessage: (state, action)=>{
            const { messageId: messageId } = action.payload;
            // mutate state
            state.messages = state.messages.filter((el)=>el.id !== messageId);
        }
    }
});
const { alertAddMessage: $a874b80e2d80ba6c$export$539a1eed9a97cb62, alertRemoveMessage: $a874b80e2d80ba6c$export$c1a8b8fb2cbef9fe } = $a874b80e2d80ba6c$export$347ed57d7b031934.actions;
const $a874b80e2d80ba6c$export$1a389607ab64f99 = (state)=>state.alert.messages;
const $a874b80e2d80ba6c$export$5edbb3adab4c0050 = $a874b80e2d80ba6c$export$347ed57d7b031934.reducer; // export default alertReducer.reducer

});
parcelRegister("dEr3t", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $9f03ff573bc23140$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $9f03ff573bc23140$export$6abd22dc03e5063f; });
$parcel$export(module.exports, "createSlice", function () { return $9f03ff573bc23140$export$4d8d9bd83c24ae8b; });

var $8Ituc = parcelRequire("8Ituc");

var $6kquR = parcelRequire("6kquR");

var $3SHkF = parcelRequire("3SHkF");

var $g0Eue = parcelRequire("g0Eue");

var $6qd2L = parcelRequire("6qd2L");
var $9f03ff573bc23140$var$__defProp = Object.defineProperty;
var $9f03ff573bc23140$var$__defProps = Object.defineProperties;
var $9f03ff573bc23140$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9f03ff573bc23140$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9f03ff573bc23140$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9f03ff573bc23140$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9f03ff573bc23140$var$__defNormalProp = (obj, key, value)=>key in obj ? $9f03ff573bc23140$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9f03ff573bc23140$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9f03ff573bc23140$var$__hasOwnProp.call(b, prop)) $9f03ff573bc23140$var$__defNormalProp(a, prop, b[prop]);
    if ($9f03ff573bc23140$var$__getOwnPropSymbols) {
        for (var prop of $9f03ff573bc23140$var$__getOwnPropSymbols(b))if ($9f03ff573bc23140$var$__propIsEnum.call(b, prop)) $9f03ff573bc23140$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9f03ff573bc23140$var$__spreadProps = (a, b)=>$9f03ff573bc23140$var$__defProps(a, $9f03ff573bc23140$var$__getOwnPropDescs(b));
var $9f03ff573bc23140$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($9f03ff573bc23140$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $9f03ff573bc23140$var$__getOwnPropSymbols) {
        for (var prop of $9f03ff573bc23140$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $9f03ff573bc23140$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $9f03ff573bc23140$var$__publicField = (obj, key, value)=>$9f03ff573bc23140$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $9f03ff573bc23140$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $3SHkF.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $6kquR.isDraft)(value) ? (0, $6kquR.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $9f03ff573bc23140$export$a5d3c27355e35910 = /* @__PURE__ */ $9f03ff573bc23140$export$aab6de9e3dbb1473((0, $3SHkF.weakMapMemoize));
var $9f03ff573bc23140$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $8Ituc.compose;
    return (0, $8Ituc.compose).apply(null, arguments);
};
var $9f03ff573bc23140$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $9f03ff573bc23140$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $9f03ff573bc23140$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(0));
            return $9f03ff573bc23140$var$__spreadValues($9f03ff573bc23140$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $8Ituc.isAction)(action) && action.type === type;
    return actionCreator;
}
function $9f03ff573bc23140$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $9f03ff573bc23140$var$hasMatchFunction(action);
}
function $9f03ff573bc23140$export$ebd532f9034651f3(action) {
    return (0, $8Ituc.isAction)(action) && Object.keys(action).every($9f03ff573bc23140$var$isValidKey);
}
function $9f03ff573bc23140$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $9f03ff573bc23140$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $9f03ff573bc23140$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $9f03ff573bc23140$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $9f03ff573bc23140$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $9f03ff573bc23140$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $9f03ff573bc23140$var$freezeDraftable(val) {
    return (0, $6kquR.isDraftable)(val) ? (0, $6kquR.produce)(val, ()=>{}) : val;
}
function $9f03ff573bc23140$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $9f03ff573bc23140$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $9f03ff573bc23140$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $9f03ff573bc23140$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $9f03ff573bc23140$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $9f03ff573bc23140$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $9f03ff573bc23140$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $9f03ff573bc23140$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $9f03ff573bc23140$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $9f03ff573bc23140$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $9f03ff573bc23140$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $8Ituc.isPlainObject)(val);
}
function $9f03ff573bc23140$export$ada5dca0b571bc7(value, path = "", isSerializable = $9f03ff573bc23140$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $9f03ff573bc23140$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $9f03ff573bc23140$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $9f03ff573bc23140$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$9f03ff573bc23140$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $9f03ff573bc23140$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $9f03ff573bc23140$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $9f03ff573bc23140$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $9f03ff573bc23140$export$1908877435b1d5e9();
        if (thunk) {
            if ($9f03ff573bc23140$var$isBoolean(thunk)) middlewareArray.push((0, $g0Eue.thunk));
            else middlewareArray.push((0, $g0Eue.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $9f03ff573bc23140$export$8fb31c0f05df007b = "RTK_autoBatch";
var $9f03ff573bc23140$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$9f03ff573bc23140$export$8fb31c0f05df007b]: true
            }
        });
var $9f03ff573bc23140$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $9f03ff573bc23140$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $9f03ff573bc23140$var$createQueueWithTimer(10);
var $9f03ff573bc23140$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $9f03ff573bc23140$var$rAF : options.type === "callback" ? options.queueNotification : $9f03ff573bc23140$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$9f03ff573bc23140$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $9f03ff573bc23140$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $9f03ff573bc23140$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($9f03ff573bc23140$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $9f03ff573bc23140$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $9f03ff573bc23140$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $8Ituc.isPlainObject)(reducer)) rootReducer = (0, $8Ituc.combineReducers)(reducer);
    else throw new Error($9f03ff573bc23140$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $8Ituc.compose);
    if (devTools) finalCompose = $9f03ff573bc23140$var$composeWithDevTools($9f03ff573bc23140$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $8Ituc.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $9f03ff573bc23140$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $8Ituc.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $9f03ff573bc23140$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $9f03ff573bc23140$var$isStateFunction(x) {
    return typeof x === "function";
}
function $9f03ff573bc23140$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $9f03ff573bc23140$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($9f03ff573bc23140$var$isStateFunction(initialState)) getInitialState = ()=>$9f03ff573bc23140$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $9f03ff573bc23140$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $6kquR.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $6kquR.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($9f03ff573bc23140$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $6kquR.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $9f03ff573bc23140$var$matches = (matcher, action)=>{
    if ($9f03ff573bc23140$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $9f03ff573bc23140$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$9f03ff573bc23140$var$matches(matcher, action));
    };
}
function $9f03ff573bc23140$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$9f03ff573bc23140$var$matches(matcher, action));
    };
}
function $9f03ff573bc23140$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $9f03ff573bc23140$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $9f03ff573bc23140$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$9f03ff573bc23140$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$9f03ff573bc23140$var$isAsyncThunkArray(asyncThunks)) return $9f03ff573bc23140$export$872dec21e9a69476()(asyncThunks[0]);
    return $9f03ff573bc23140$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $9f03ff573bc23140$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$9f03ff573bc23140$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$9f03ff573bc23140$var$isAsyncThunkArray(asyncThunks)) return $9f03ff573bc23140$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $9f03ff573bc23140$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $9f03ff573bc23140$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $9f03ff573bc23140$export$9dd1fb32974da385($9f03ff573bc23140$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$9f03ff573bc23140$var$isAsyncThunkArray(asyncThunks)) return $9f03ff573bc23140$export$fcc3388fb56de601()(asyncThunks[0]);
    return $9f03ff573bc23140$export$9dd1fb32974da385($9f03ff573bc23140$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $9f03ff573bc23140$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$9f03ff573bc23140$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$9f03ff573bc23140$var$isAsyncThunkArray(asyncThunks)) return $9f03ff573bc23140$export$1da80a6ef1307441()(asyncThunks[0]);
    return $9f03ff573bc23140$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $9f03ff573bc23140$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$9f03ff573bc23140$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$9f03ff573bc23140$var$isAsyncThunkArray(asyncThunks)) return $9f03ff573bc23140$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $9f03ff573bc23140$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $9f03ff573bc23140$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $9f03ff573bc23140$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $9f03ff573bc23140$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $9f03ff573bc23140$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $9f03ff573bc23140$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $9f03ff573bc23140$var$__publicField(this, "_type");
    }
};
var $9f03ff573bc23140$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $9f03ff573bc23140$var$__publicField(this, "_type");
    }
};
var $9f03ff573bc23140$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $9f03ff573bc23140$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $9f03ff573bc23140$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $9f03ff573bc23140$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $9f03ff573bc23140$var$__spreadProps($9f03ff573bc23140$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $9f03ff573bc23140$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $9f03ff573bc23140$var$__spreadProps($9f03ff573bc23140$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $9f03ff573bc23140$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $9f03ff573bc23140$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $9f03ff573bc23140$var$__spreadProps($9f03ff573bc23140$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $9f03ff573bc23140$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($9f03ff573bc23140$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $9f03ff573bc23140$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $9f03ff573bc23140$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $9f03ff573bc23140$var$RejectWithValue) throw result;
                                if (result instanceof $9f03ff573bc23140$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $9f03ff573bc23140$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($9f03ff573bc23140$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $9f03ff573bc23140$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $9f03ff573bc23140$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $9f03ff573bc23140$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $9f03ff573bc23140$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $9f03ff573bc23140$export$343355ed40c51c46 = {
    [$9f03ff573bc23140$var$asyncThunkSymbol]: $9f03ff573bc23140$export$6abd22dc03e5063f
};
var $9f03ff573bc23140$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($9f03ff573bc23140$export$23a094319a4b586 || {});
function $9f03ff573bc23140$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $9f03ff573bc23140$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$9f03ff573bc23140$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(11));
        typeof $6qd2L;
        const reducers = (typeof options.reducers === "function" ? options.reducers($9f03ff573bc23140$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $9f03ff573bc23140$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($9f03ff573bc23140$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $9f03ff573bc23140$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $9f03ff573bc23140$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $9f03ff573bc23140$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $9f03ff573bc23140$var$__spreadValues($9f03ff573bc23140$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $9f03ff573bc23140$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $9f03ff573bc23140$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $9f03ff573bc23140$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $9f03ff573bc23140$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $9f03ff573bc23140$var$__spreadProps($9f03ff573bc23140$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $9f03ff573bc23140$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $9f03ff573bc23140$var$__spreadValues($9f03ff573bc23140$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $9f03ff573bc23140$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $9f03ff573bc23140$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $9f03ff573bc23140$export$affdea4146de9cf5();
function $9f03ff573bc23140$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $9f03ff573bc23140$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $9f03ff573bc23140$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$9f03ff573bc23140$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $9f03ff573bc23140$export$309c7a02b0b0bc62(type, prepareCallback) : $9f03ff573bc23140$export$309c7a02b0b0bc62(type));
}
function $9f03ff573bc23140$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $9f03ff573bc23140$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $9f03ff573bc23140$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $9f03ff573bc23140$var$noop,
        pending: pending || $9f03ff573bc23140$var$noop,
        rejected: rejected || $9f03ff573bc23140$var$noop,
        settled: settled || $9f03ff573bc23140$var$noop
    });
}
function $9f03ff573bc23140$var$noop() {}
// src/entities/entity_state.ts
function $9f03ff573bc23140$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $9f03ff573bc23140$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($9f03ff573bc23140$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $9f03ff573bc23140$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $9f03ff573bc23140$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $9f03ff573bc23140$var$isDraftTyped = (0, $6kquR.isDraft);
function $9f03ff573bc23140$var$createSingleArgumentStateOperator(mutator) {
    const operator = $9f03ff573bc23140$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $9f03ff573bc23140$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $9f03ff573bc23140$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($9f03ff573bc23140$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $6kquR.produce)(state, runMutator);
    };
}
function $9f03ff573bc23140$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $9f03ff573bc23140$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $9f03ff573bc23140$var$getCurrent(value) {
    return (0, $6kquR.isDraft)(value) ? (0, $6kquR.current)(value) : value;
}
function $9f03ff573bc23140$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $9f03ff573bc23140$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $9f03ff573bc23140$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $9f03ff573bc23140$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $9f03ff573bc23140$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $9f03ff573bc23140$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $9f03ff573bc23140$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $9f03ff573bc23140$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $9f03ff573bc23140$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $9f03ff573bc23140$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $9f03ff573bc23140$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $9f03ff573bc23140$var$__spreadValues($9f03ff573bc23140$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$9f03ff573bc23140$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $9f03ff573bc23140$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $9f03ff573bc23140$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $9f03ff573bc23140$var$createStateOperator(addOneMutably),
        addMany: $9f03ff573bc23140$var$createStateOperator(addManyMutably),
        setOne: $9f03ff573bc23140$var$createStateOperator(setOneMutably),
        setMany: $9f03ff573bc23140$var$createStateOperator(setManyMutably),
        setAll: $9f03ff573bc23140$var$createStateOperator(setAllMutably),
        updateOne: $9f03ff573bc23140$var$createStateOperator(updateOneMutably),
        updateMany: $9f03ff573bc23140$var$createStateOperator(updateManyMutably),
        upsertOne: $9f03ff573bc23140$var$createStateOperator(upsertOneMutably),
        upsertMany: $9f03ff573bc23140$var$createStateOperator(upsertManyMutably),
        removeOne: $9f03ff573bc23140$var$createStateOperator(removeOneMutably),
        removeMany: $9f03ff573bc23140$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $9f03ff573bc23140$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $9f03ff573bc23140$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $9f03ff573bc23140$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $9f03ff573bc23140$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $9f03ff573bc23140$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $9f03ff573bc23140$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $9f03ff573bc23140$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($9f03ff573bc23140$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $9f03ff573bc23140$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $9f03ff573bc23140$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $9f03ff573bc23140$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $9f03ff573bc23140$var$getCurrent(state.entities);
        const currentIds = $9f03ff573bc23140$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $9f03ff573bc23140$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $9f03ff573bc23140$var$createStateOperator(addOneMutably),
        updateOne: $9f03ff573bc23140$var$createStateOperator(updateOneMutably),
        upsertOne: $9f03ff573bc23140$var$createStateOperator(upsertOneMutably),
        setOne: $9f03ff573bc23140$var$createStateOperator(setOneMutably),
        setMany: $9f03ff573bc23140$var$createStateOperator(setManyMutably),
        setAll: $9f03ff573bc23140$var$createStateOperator(setAllMutably),
        addMany: $9f03ff573bc23140$var$createStateOperator(addManyMutably),
        updateMany: $9f03ff573bc23140$var$createStateOperator(updateManyMutably),
        upsertMany: $9f03ff573bc23140$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $9f03ff573bc23140$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $9f03ff573bc23140$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $9f03ff573bc23140$var$createSortedStateAdapter(selectId, sortComparer) : $9f03ff573bc23140$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $9f03ff573bc23140$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $9f03ff573bc23140$var$createSelectorsFactory();
    return $9f03ff573bc23140$var$__spreadValues($9f03ff573bc23140$var$__spreadValues($9f03ff573bc23140$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $9f03ff573bc23140$var$task = "task";
var $9f03ff573bc23140$var$listener = "listener";
var $9f03ff573bc23140$var$completed = "completed";
var $9f03ff573bc23140$var$cancelled = "cancelled";
var $9f03ff573bc23140$var$taskCancelled = `task-${$9f03ff573bc23140$var$cancelled}`;
var $9f03ff573bc23140$var$taskCompleted = `task-${$9f03ff573bc23140$var$completed}`;
var $9f03ff573bc23140$var$listenerCancelled = `${$9f03ff573bc23140$var$listener}-${$9f03ff573bc23140$var$cancelled}`;
var $9f03ff573bc23140$var$listenerCompleted = `${$9f03ff573bc23140$var$listener}-${$9f03ff573bc23140$var$completed}`;
var $9f03ff573bc23140$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $9f03ff573bc23140$var$__publicField(this, "name", "TaskAbortError");
        $9f03ff573bc23140$var$__publicField(this, "message");
        this.message = `${$9f03ff573bc23140$var$task} ${$9f03ff573bc23140$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $9f03ff573bc23140$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($9f03ff573bc23140$export$378fa86b259c0280(32));
};
var $9f03ff573bc23140$var$noop2 = ()=>{};
var $9f03ff573bc23140$var$catchRejection = (promise, onError = $9f03ff573bc23140$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $9f03ff573bc23140$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $9f03ff573bc23140$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $9f03ff573bc23140$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $9f03ff573bc23140$export$cb1bdac908fed7f(reason);
    }
};
function $9f03ff573bc23140$var$raceWithSignal(signal, promise) {
    let cleanup = $9f03ff573bc23140$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $9f03ff573bc23140$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $9f03ff573bc23140$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $9f03ff573bc23140$var$noop2;
    });
}
var $9f03ff573bc23140$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $9f03ff573bc23140$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $9f03ff573bc23140$var$createPause = (signal)=>{
    return (promise)=>{
        return $9f03ff573bc23140$var$catchRejection($9f03ff573bc23140$var$raceWithSignal(signal, promise).then((output)=>{
            $9f03ff573bc23140$var$validateActive(signal);
            return output;
        }));
    };
};
var $9f03ff573bc23140$var$createDelay = (signal)=>{
    const pause = $9f03ff573bc23140$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $9f03ff573bc23140$var$assign } = Object;
var $9f03ff573bc23140$var$INTERNAL_NIL_TOKEN = {};
var $9f03ff573bc23140$var$alm = "listenerMiddleware";
var $9f03ff573bc23140$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$9f03ff573bc23140$var$addAbortSignalListener(parentAbortSignal, ()=>$9f03ff573bc23140$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $9f03ff573bc23140$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $9f03ff573bc23140$var$runTask(async ()=>{
            $9f03ff573bc23140$var$validateActive(parentAbortSignal);
            $9f03ff573bc23140$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $9f03ff573bc23140$var$createPause(childAbortController.signal),
                delay: $9f03ff573bc23140$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $9f03ff573bc23140$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$9f03ff573bc23140$var$abortControllerWithReason(childAbortController, $9f03ff573bc23140$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($9f03ff573bc23140$var$noop2));
        return {
            result: $9f03ff573bc23140$var$createPause(parentAbortSignal)(result),
            cancel () {
                $9f03ff573bc23140$var$abortControllerWithReason(childAbortController, $9f03ff573bc23140$var$taskCancelled);
            }
        };
    };
};
var $9f03ff573bc23140$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $9f03ff573bc23140$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $9f03ff573bc23140$var$raceWithSignal(signal, Promise.race(promises));
            $9f03ff573bc23140$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$9f03ff573bc23140$var$catchRejection(take(predicate, timeout));
};
var $9f03ff573bc23140$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $9f03ff573bc23140$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($9f03ff573bc23140$export$378fa86b259c0280(21));
    $9f03ff573bc23140$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $9f03ff573bc23140$var$createListenerEntry = /* @__PURE__ */ $9f03ff573bc23140$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $9f03ff573bc23140$var$getListenerEntryPropsFrom(options);
    const id = $9f03ff573bc23140$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($9f03ff573bc23140$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$9f03ff573bc23140$var$createListenerEntry
});
var $9f03ff573bc23140$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $9f03ff573bc23140$var$abortControllerWithReason(controller, $9f03ff573bc23140$var$listenerCancelled);
    });
};
var $9f03ff573bc23140$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($9f03ff573bc23140$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $9f03ff573bc23140$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $9f03ff573bc23140$export$f03a6b845d3fb58b = /* @__PURE__ */ $9f03ff573bc23140$var$assign(/* @__PURE__ */ $9f03ff573bc23140$export$309c7a02b0b0bc62(`${$9f03ff573bc23140$var$alm}/add`), {
    withTypes: ()=>$9f03ff573bc23140$export$f03a6b845d3fb58b
});
var $9f03ff573bc23140$export$b1b8022855fb2b71 = /* @__PURE__ */ $9f03ff573bc23140$export$309c7a02b0b0bc62(`${$9f03ff573bc23140$var$alm}/removeAll`);
var $9f03ff573bc23140$export$b03e9483f936dccb = /* @__PURE__ */ $9f03ff573bc23140$var$assign(/* @__PURE__ */ $9f03ff573bc23140$export$309c7a02b0b0bc62(`${$9f03ff573bc23140$var$alm}/remove`), {
    withTypes: ()=>$9f03ff573bc23140$export$b03e9483f936dccb
});
var $9f03ff573bc23140$var$defaultErrorHandler = (...args)=>{
    console.error(`${$9f03ff573bc23140$var$alm}/error`, ...args);
};
var $9f03ff573bc23140$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $9f03ff573bc23140$var$defaultErrorHandler } = middlewareOptions;
    $9f03ff573bc23140$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $9f03ff573bc23140$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $9f03ff573bc23140$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $9f03ff573bc23140$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $9f03ff573bc23140$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $9f03ff573bc23140$var$getListenerEntryPropsFrom(options);
        const entry = $9f03ff573bc23140$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $9f03ff573bc23140$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $9f03ff573bc23140$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $9f03ff573bc23140$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $9f03ff573bc23140$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $9f03ff573bc23140$var$createDelay(internalTaskController.signal),
                pause: $9f03ff573bc23140$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $9f03ff573bc23140$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $9f03ff573bc23140$var$abortControllerWithReason(controller, $9f03ff573bc23140$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $9f03ff573bc23140$var$abortControllerWithReason(internalTaskController, $9f03ff573bc23140$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $9f03ff573bc23140$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $9f03ff573bc23140$export$cb1bdac908fed7f)) $9f03ff573bc23140$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $9f03ff573bc23140$var$abortControllerWithReason(internalTaskController, $9f03ff573bc23140$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $9f03ff573bc23140$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $8Ituc.isAction)(action)) return next(action);
                if ($9f03ff573bc23140$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($9f03ff573bc23140$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($9f03ff573bc23140$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $9f03ff573bc23140$var$INTERNAL_NIL_TOKEN) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $9f03ff573bc23140$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $9f03ff573bc23140$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $9f03ff573bc23140$var$createMiddlewareEntry = (middleware)=>({
        id: $9f03ff573bc23140$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $9f03ff573bc23140$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $9f03ff573bc23140$export$4bb1606a79445586 = ()=>{
    const instanceId = $9f03ff573bc23140$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($9f03ff573bc23140$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $9f03ff573bc23140$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $9f03ff573bc23140$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$9f03ff573bc23140$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $8Ituc.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $9f03ff573bc23140$export$9dd1fb32974da385(withMiddleware, $9f03ff573bc23140$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $9f03ff573bc23140$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $9f03ff573bc23140$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$9f03ff573bc23140$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $9f03ff573bc23140$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $9f03ff573bc23140$var$isStateProxy = (value)=>!!value && !!value[$9f03ff573bc23140$var$ORIGINAL_STATE];
var $9f03ff573bc23140$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $9f03ff573bc23140$var$createStateProxy = (state, reducerMap)=>$9f03ff573bc23140$var$emplace($9f03ff573bc23140$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $9f03ff573bc23140$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $9f03ff573bc23140$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($9f03ff573bc23140$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $9f03ff573bc23140$var$original = (state)=>{
    if (!$9f03ff573bc23140$var$isStateProxy(state)) throw new Error($9f03ff573bc23140$export$378fa86b259c0280(25));
    return state[$9f03ff573bc23140$var$ORIGINAL_STATE];
};
var $9f03ff573bc23140$var$noopReducer = (state = {})=>state;
function $9f03ff573bc23140$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($9f03ff573bc23140$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $8Ituc.combineReducers)(reducerMap) : $9f03ff573bc23140$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $6qd2L;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($9f03ff573bc23140$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $9f03ff573bc23140$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $9f03ff573bc23140$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("8Ituc", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $65894e1d6bc7b1c7$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "createStore", function () { return $65894e1d6bc7b1c7$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $65894e1d6bc7b1c7$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $65894e1d6bc7b1c7$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $65894e1d6bc7b1c7$export$9ff26e0402cc7b7; });
$parcel$export(module.exports, "isAction", function () { return $65894e1d6bc7b1c7$export$b956e38827fca970; });
// src/utils/formatProdErrorMessage.ts
function $65894e1d6bc7b1c7$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $65894e1d6bc7b1c7$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $65894e1d6bc7b1c7$var$symbol_observable_default = $65894e1d6bc7b1c7$var$$$observable;
// src/utils/actionTypes.ts
var $65894e1d6bc7b1c7$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $65894e1d6bc7b1c7$var$ActionTypes = {
    INIT: `@@redux/INIT${$65894e1d6bc7b1c7$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$65894e1d6bc7b1c7$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$65894e1d6bc7b1c7$var$randomString()}`
};
var $65894e1d6bc7b1c7$export$4219e499db7ca678 = $65894e1d6bc7b1c7$var$ActionTypes;
// src/utils/isPlainObject.ts
function $65894e1d6bc7b1c7$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $65894e1d6bc7b1c7$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($65894e1d6bc7b1c7$var$isDate(val)) return "date";
    if ($65894e1d6bc7b1c7$var$isError(val)) return "error";
    const constructorName = $65894e1d6bc7b1c7$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $65894e1d6bc7b1c7$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $65894e1d6bc7b1c7$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $65894e1d6bc7b1c7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $65894e1d6bc7b1c7$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $65894e1d6bc7b1c7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(1));
        return enhancer($65894e1d6bc7b1c7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$65894e1d6bc7b1c7$export$53b83ca8eaab0383(action)) throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $65894e1d6bc7b1c7$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$65894e1d6bc7b1c7$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $65894e1d6bc7b1c7$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$65894e1d6bc7b1c7$var$symbol_observable_default]: observable
    };
    return store;
}
function $65894e1d6bc7b1c7$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $65894e1d6bc7b1c7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $65894e1d6bc7b1c7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $65894e1d6bc7b1c7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $65894e1d6bc7b1c7$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$65894e1d6bc7b1c7$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$65894e1d6bc7b1c7$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $65894e1d6bc7b1c7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $65894e1d6bc7b1c7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $65894e1d6bc7b1c7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $65894e1d6bc7b1c7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(13));
    });
}
function $65894e1d6bc7b1c7$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $65894e1d6bc7b1c7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $65894e1d6bc7b1c7$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $65894e1d6bc7b1c7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $65894e1d6bc7b1c7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $65894e1d6bc7b1c7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $65894e1d6bc7b1c7$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $65894e1d6bc7b1c7$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($65894e1d6bc7b1c7$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $65894e1d6bc7b1c7$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $65894e1d6bc7b1c7$export$b956e38827fca970(action) {
    return $65894e1d6bc7b1c7$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("6kquR", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $49b92a035e6b7890$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $49b92a035e6b7890$export$16e3aed3edb85946; });
$parcel$export(module.exports, "current", function () { return $49b92a035e6b7890$export$97aac956da55dae9; });
$parcel$export(module.exports, "produce", function () { return $49b92a035e6b7890$export$b46cabe22e78bc00; });
var $49b92a035e6b7890$var$__defProp = Object.defineProperty;
var $49b92a035e6b7890$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $49b92a035e6b7890$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $49b92a035e6b7890$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $49b92a035e6b7890$var$__defNormalProp = (obj, key, value)=>key in obj ? $49b92a035e6b7890$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $49b92a035e6b7890$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($49b92a035e6b7890$var$__hasOwnProp.call(b, prop)) $49b92a035e6b7890$var$__defNormalProp(a, prop, b[prop]);
    if ($49b92a035e6b7890$var$__getOwnPropSymbols) {
        for (var prop of $49b92a035e6b7890$var$__getOwnPropSymbols(b))if ($49b92a035e6b7890$var$__propIsEnum.call(b, prop)) $49b92a035e6b7890$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $49b92a035e6b7890$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $49b92a035e6b7890$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $49b92a035e6b7890$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $49b92a035e6b7890$var$errors = [];
function $49b92a035e6b7890$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $49b92a035e6b7890$var$getPrototypeOf = Object.getPrototypeOf;
function $49b92a035e6b7890$export$541ac630993a4c84(value) {
    return !!value && !!value[$49b92a035e6b7890$var$DRAFT_STATE];
}
function $49b92a035e6b7890$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $49b92a035e6b7890$var$isPlainObject(value) || Array.isArray(value) || !!value[$49b92a035e6b7890$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$49b92a035e6b7890$export$6ee2082928bcb0ee]) || $49b92a035e6b7890$var$isMap(value) || $49b92a035e6b7890$var$isSet(value);
}
var $49b92a035e6b7890$var$objectCtorString = Object.prototype.constructor.toString();
function $49b92a035e6b7890$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $49b92a035e6b7890$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $49b92a035e6b7890$var$objectCtorString;
}
function $49b92a035e6b7890$export$22e8af3f75a010e3(value) {
    if (!$49b92a035e6b7890$export$541ac630993a4c84(value)) $49b92a035e6b7890$var$die(15, value);
    return value[$49b92a035e6b7890$var$DRAFT_STATE].base_;
}
function $49b92a035e6b7890$var$each(obj, iter) {
    if ($49b92a035e6b7890$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $49b92a035e6b7890$var$getArchtype(thing) {
    const state = thing[$49b92a035e6b7890$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $49b92a035e6b7890$var$isMap(thing) ? 2 /* Map */  : $49b92a035e6b7890$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $49b92a035e6b7890$var$has(thing, prop) {
    return $49b92a035e6b7890$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $49b92a035e6b7890$var$get(thing, prop) {
    return $49b92a035e6b7890$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $49b92a035e6b7890$var$set(thing, propOrOldValue, value) {
    const t = $49b92a035e6b7890$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $49b92a035e6b7890$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $49b92a035e6b7890$var$isMap(target) {
    return target instanceof Map;
}
function $49b92a035e6b7890$var$isSet(target) {
    return target instanceof Set;
}
function $49b92a035e6b7890$var$latest(state) {
    return state.copy_ || state.base_;
}
function $49b92a035e6b7890$var$shallowCopy(base, strict) {
    if ($49b92a035e6b7890$var$isMap(base)) return new Map(base);
    if ($49b92a035e6b7890$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $49b92a035e6b7890$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$49b92a035e6b7890$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($49b92a035e6b7890$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $49b92a035e6b7890$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $49b92a035e6b7890$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $49b92a035e6b7890$export$792f3d81ea979f55(obj, deep = false) {
    if ($49b92a035e6b7890$var$isFrozen(obj) || $49b92a035e6b7890$export$541ac630993a4c84(obj) || !$49b92a035e6b7890$export$16e3aed3edb85946(obj)) return obj;
    if ($49b92a035e6b7890$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $49b92a035e6b7890$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$49b92a035e6b7890$export$792f3d81ea979f55(value, true));
    return obj;
}
function $49b92a035e6b7890$var$dontMutateFrozenCollections() {
    $49b92a035e6b7890$var$die(2);
}
function $49b92a035e6b7890$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $49b92a035e6b7890$var$plugins = {};
function $49b92a035e6b7890$var$getPlugin(pluginKey) {
    const plugin = $49b92a035e6b7890$var$plugins[pluginKey];
    if (!plugin) $49b92a035e6b7890$var$die(0, pluginKey);
    return plugin;
}
function $49b92a035e6b7890$var$loadPlugin(pluginKey, implementation) {
    if (!$49b92a035e6b7890$var$plugins[pluginKey]) $49b92a035e6b7890$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $49b92a035e6b7890$var$currentScope;
function $49b92a035e6b7890$var$getCurrentScope() {
    return $49b92a035e6b7890$var$currentScope;
}
function $49b92a035e6b7890$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $49b92a035e6b7890$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $49b92a035e6b7890$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $49b92a035e6b7890$var$revokeScope(scope) {
    $49b92a035e6b7890$var$leaveScope(scope);
    scope.drafts_.forEach($49b92a035e6b7890$var$revokeDraft);
    scope.drafts_ = null;
}
function $49b92a035e6b7890$var$leaveScope(scope) {
    if (scope === $49b92a035e6b7890$var$currentScope) $49b92a035e6b7890$var$currentScope = scope.parent_;
}
function $49b92a035e6b7890$var$enterScope(immer2) {
    return $49b92a035e6b7890$var$currentScope = $49b92a035e6b7890$var$createScope($49b92a035e6b7890$var$currentScope, immer2);
}
function $49b92a035e6b7890$var$revokeDraft(draft) {
    const state = draft[$49b92a035e6b7890$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $49b92a035e6b7890$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$49b92a035e6b7890$var$DRAFT_STATE].modified_) {
            $49b92a035e6b7890$var$revokeScope(scope);
            $49b92a035e6b7890$var$die(4);
        }
        if ($49b92a035e6b7890$export$16e3aed3edb85946(result)) {
            result = $49b92a035e6b7890$var$finalize(scope, result);
            if (!scope.parent_) $49b92a035e6b7890$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $49b92a035e6b7890$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$49b92a035e6b7890$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $49b92a035e6b7890$var$finalize(scope, baseDraft, []);
    $49b92a035e6b7890$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $49b92a035e6b7890$export$45b790e32b2810ee ? result : void 0;
}
function $49b92a035e6b7890$var$finalize(rootScope, value, path) {
    if ($49b92a035e6b7890$var$isFrozen(value)) return value;
    const state = value[$49b92a035e6b7890$var$DRAFT_STATE];
    if (!state) {
        $49b92a035e6b7890$var$each(value, (key, childValue)=>$49b92a035e6b7890$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $49b92a035e6b7890$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $49b92a035e6b7890$var$each(resultEach, (key, childValue)=>$49b92a035e6b7890$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $49b92a035e6b7890$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $49b92a035e6b7890$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $49b92a035e6b7890$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($49b92a035e6b7890$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$49b92a035e6b7890$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $49b92a035e6b7890$var$finalize(rootScope, childValue, path);
        $49b92a035e6b7890$var$set(targetObject, prop, res);
        if ($49b92a035e6b7890$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($49b92a035e6b7890$export$16e3aed3edb85946(childValue) && !$49b92a035e6b7890$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $49b92a035e6b7890$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $49b92a035e6b7890$var$maybeFreeze(rootScope, childValue);
    }
}
function $49b92a035e6b7890$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $49b92a035e6b7890$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $49b92a035e6b7890$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $49b92a035e6b7890$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $49b92a035e6b7890$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $49b92a035e6b7890$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $49b92a035e6b7890$var$objectTraps = {
    get (state, prop) {
        if (prop === $49b92a035e6b7890$var$DRAFT_STATE) return state;
        const source = $49b92a035e6b7890$var$latest(state);
        if (!$49b92a035e6b7890$var$has(source, prop)) return $49b92a035e6b7890$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$49b92a035e6b7890$export$16e3aed3edb85946(value)) return value;
        if (value === $49b92a035e6b7890$var$peek(state.base_, prop)) {
            $49b92a035e6b7890$var$prepareCopy(state);
            return state.copy_[prop] = $49b92a035e6b7890$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $49b92a035e6b7890$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($49b92a035e6b7890$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $49b92a035e6b7890$var$getDescriptorFromProto($49b92a035e6b7890$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $49b92a035e6b7890$var$peek($49b92a035e6b7890$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$49b92a035e6b7890$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($49b92a035e6b7890$var$is(value, current2) && (value !== void 0 || $49b92a035e6b7890$var$has(state.base_, prop))) return true;
            $49b92a035e6b7890$var$prepareCopy(state);
            $49b92a035e6b7890$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($49b92a035e6b7890$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $49b92a035e6b7890$var$prepareCopy(state);
            $49b92a035e6b7890$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $49b92a035e6b7890$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $49b92a035e6b7890$var$die(11);
    },
    getPrototypeOf (state) {
        return $49b92a035e6b7890$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $49b92a035e6b7890$var$die(12);
    }
};
var $49b92a035e6b7890$var$arrayTraps = {};
$49b92a035e6b7890$var$each($49b92a035e6b7890$var$objectTraps, (key, fn)=>{
    $49b92a035e6b7890$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$49b92a035e6b7890$var$arrayTraps.deleteProperty = function(state, prop) {
    return $49b92a035e6b7890$var$arrayTraps.set.call(this, state, prop, void 0);
};
$49b92a035e6b7890$var$arrayTraps.set = function(state, prop, value) {
    return $49b92a035e6b7890$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $49b92a035e6b7890$var$peek(draft, prop) {
    const state = draft[$49b92a035e6b7890$var$DRAFT_STATE];
    const source = state ? $49b92a035e6b7890$var$latest(state) : draft;
    return source[prop];
}
function $49b92a035e6b7890$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $49b92a035e6b7890$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $49b92a035e6b7890$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $49b92a035e6b7890$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $49b92a035e6b7890$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $49b92a035e6b7890$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $49b92a035e6b7890$var$markChanged(state.parent_);
    }
}
function $49b92a035e6b7890$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $49b92a035e6b7890$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $49b92a035e6b7890$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $49b92a035e6b7890$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $49b92a035e6b7890$var$die(7);
            let result;
            if ($49b92a035e6b7890$export$16e3aed3edb85946(base)) {
                const scope = $49b92a035e6b7890$var$enterScope(this);
                const proxy = $49b92a035e6b7890$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $49b92a035e6b7890$var$revokeScope(scope);
                    else $49b92a035e6b7890$var$leaveScope(scope);
                }
                $49b92a035e6b7890$var$usePatchesInScope(scope, patchListener);
                return $49b92a035e6b7890$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $49b92a035e6b7890$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $49b92a035e6b7890$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $49b92a035e6b7890$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $49b92a035e6b7890$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$49b92a035e6b7890$export$16e3aed3edb85946(base)) $49b92a035e6b7890$var$die(8);
        if ($49b92a035e6b7890$export$541ac630993a4c84(base)) base = $49b92a035e6b7890$export$97aac956da55dae9(base);
        const scope = $49b92a035e6b7890$var$enterScope(this);
        const proxy = $49b92a035e6b7890$var$createProxy(base, void 0);
        proxy[$49b92a035e6b7890$var$DRAFT_STATE].isManual_ = true;
        $49b92a035e6b7890$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$49b92a035e6b7890$var$DRAFT_STATE];
        if (!state || !state.isManual_) $49b92a035e6b7890$var$die(9);
        const { scope_: scope } = state;
        $49b92a035e6b7890$var$usePatchesInScope(scope, patchListener);
        return $49b92a035e6b7890$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $49b92a035e6b7890$var$getPlugin("Patches").applyPatches_;
        if ($49b92a035e6b7890$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $49b92a035e6b7890$var$createProxy(value, parent) {
    const draft = $49b92a035e6b7890$var$isMap(value) ? $49b92a035e6b7890$var$getPlugin("MapSet").proxyMap_(value, parent) : $49b92a035e6b7890$var$isSet(value) ? $49b92a035e6b7890$var$getPlugin("MapSet").proxySet_(value, parent) : $49b92a035e6b7890$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $49b92a035e6b7890$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $49b92a035e6b7890$export$97aac956da55dae9(value) {
    if (!$49b92a035e6b7890$export$541ac630993a4c84(value)) $49b92a035e6b7890$var$die(10, value);
    return $49b92a035e6b7890$var$currentImpl(value);
}
function $49b92a035e6b7890$var$currentImpl(value) {
    if (!$49b92a035e6b7890$export$16e3aed3edb85946(value) || $49b92a035e6b7890$var$isFrozen(value)) return value;
    const state = value[$49b92a035e6b7890$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $49b92a035e6b7890$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $49b92a035e6b7890$var$shallowCopy(value, true);
    $49b92a035e6b7890$var$each(copy, (key, childValue)=>{
        $49b92a035e6b7890$var$set(copy, key, $49b92a035e6b7890$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $49b92a035e6b7890$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $49b92a035e6b7890$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $49b92a035e6b7890$var$get(base_, key);
            const value = $49b92a035e6b7890$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $49b92a035e6b7890$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $49b92a035e6b7890$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $49b92a035e6b7890$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $49b92a035e6b7890$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $49b92a035e6b7890$var$die(errorOffset + 3);
                base = $49b92a035e6b7890$var$get(base, p);
                if (typeof base !== "object") $49b92a035e6b7890$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $49b92a035e6b7890$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $49b92a035e6b7890$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $49b92a035e6b7890$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$49b92a035e6b7890$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($49b92a035e6b7890$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($49b92a035e6b7890$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($49b92a035e6b7890$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($49b92a035e6b7890$var$has(obj, $49b92a035e6b7890$export$6ee2082928bcb0ee)) cloned[$49b92a035e6b7890$export$6ee2082928bcb0ee] = obj[$49b92a035e6b7890$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($49b92a035e6b7890$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $49b92a035e6b7890$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $49b92a035e6b7890$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$49b92a035e6b7890$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $49b92a035e6b7890$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $49b92a035e6b7890$var$latest(this[$49b92a035e6b7890$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $49b92a035e6b7890$var$latest(this[$49b92a035e6b7890$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$49b92a035e6b7890$var$latest(state).has(key) || $49b92a035e6b7890$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $49b92a035e6b7890$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $49b92a035e6b7890$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($49b92a035e6b7890$var$latest(state).size) {
                prepareMapCopy(state);
                $49b92a035e6b7890$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $49b92a035e6b7890$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            $49b92a035e6b7890$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $49b92a035e6b7890$var$latest(state).get(key);
            if (state.finalized_ || !$49b92a035e6b7890$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $49b92a035e6b7890$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $49b92a035e6b7890$var$latest(this[$49b92a035e6b7890$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($49b92a035e6b7890$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$49b92a035e6b7890$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $49b92a035e6b7890$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $49b92a035e6b7890$var$latest(this[$49b92a035e6b7890$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $49b92a035e6b7890$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $49b92a035e6b7890$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($49b92a035e6b7890$var$latest(state).size) {
                prepareSetCopy(state);
                $49b92a035e6b7890$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$49b92a035e6b7890$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($49b92a035e6b7890$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($49b92a035e6b7890$export$16e3aed3edb85946(value)) {
                    const draft = $49b92a035e6b7890$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $49b92a035e6b7890$var$die(3, JSON.stringify($49b92a035e6b7890$var$latest(state)));
    }
    $49b92a035e6b7890$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $49b92a035e6b7890$var$immer = new $49b92a035e6b7890$export$aaadc6ff0f822719();
var $49b92a035e6b7890$export$b46cabe22e78bc00 = $49b92a035e6b7890$var$immer.produce;
var $49b92a035e6b7890$export$4da66d41c9492c78 = $49b92a035e6b7890$var$immer.produceWithPatches.bind($49b92a035e6b7890$var$immer);
var $49b92a035e6b7890$export$573f26f60825c493 = $49b92a035e6b7890$var$immer.setAutoFreeze.bind($49b92a035e6b7890$var$immer);
var $49b92a035e6b7890$export$333ce65961cbe047 = $49b92a035e6b7890$var$immer.setUseStrictShallowCopy.bind($49b92a035e6b7890$var$immer);
var $49b92a035e6b7890$export$a8b8e03e6bbe5473 = $49b92a035e6b7890$var$immer.applyPatches.bind($49b92a035e6b7890$var$immer);
var $49b92a035e6b7890$export$3c3214997190395f = $49b92a035e6b7890$var$immer.createDraft.bind($49b92a035e6b7890$var$immer);
var $49b92a035e6b7890$export$c60f5e69c521b528 = $49b92a035e6b7890$var$immer.finishDraft.bind($49b92a035e6b7890$var$immer);
function $49b92a035e6b7890$export$c05b21e3257751e5(value) {
    return value;
}
function $49b92a035e6b7890$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("3SHkF", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", function () { return $2d380721aae6ab60$export$8402dc26d96f6902; });
$parcel$export(module.exports, "createSelectorCreator", function () { return $2d380721aae6ab60$export$5943f4447f6ef248; });
var $2d380721aae6ab60$var$__defProp = Object.defineProperty;
var $2d380721aae6ab60$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2d380721aae6ab60$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2d380721aae6ab60$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2d380721aae6ab60$var$__defNormalProp = (obj, key, value)=>key in obj ? $2d380721aae6ab60$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2d380721aae6ab60$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2d380721aae6ab60$var$__hasOwnProp.call(b, prop)) $2d380721aae6ab60$var$__defNormalProp(a, prop, b[prop]);
    if ($2d380721aae6ab60$var$__getOwnPropSymbols) {
        for (var prop of $2d380721aae6ab60$var$__getOwnPropSymbols(b))if ($2d380721aae6ab60$var$__propIsEnum.call(b, prop)) $2d380721aae6ab60$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2d380721aae6ab60$var$__publicField = (obj, key, value)=>{
    $2d380721aae6ab60$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $2d380721aae6ab60$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $2d380721aae6ab60$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $2d380721aae6ab60$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $2d380721aae6ab60$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($2d380721aae6ab60$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $2d380721aae6ab60$var$NOT_FOUND = "NOT_FOUND";
function $2d380721aae6ab60$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $2d380721aae6ab60$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $2d380721aae6ab60$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $2d380721aae6ab60$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $2d380721aae6ab60$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $2d380721aae6ab60$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $2d380721aae6ab60$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $2d380721aae6ab60$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $2d380721aae6ab60$var$__spreadValues($2d380721aae6ab60$var$__spreadValues({}, $2d380721aae6ab60$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $2d380721aae6ab60$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $2d380721aae6ab60$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $2d380721aae6ab60$var$$REVISION = 0;
var $2d380721aae6ab60$var$CURRENT_TRACKER = null;
var $2d380721aae6ab60$var$Cell = class {
    constructor(initialValue, isEqual = $2d380721aae6ab60$var$tripleEq){
        $2d380721aae6ab60$var$__publicField(this, "revision", $2d380721aae6ab60$var$$REVISION);
        $2d380721aae6ab60$var$__publicField(this, "_value");
        $2d380721aae6ab60$var$__publicField(this, "_lastValue");
        $2d380721aae6ab60$var$__publicField(this, "_isEqual", $2d380721aae6ab60$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $2d380721aae6ab60$var$CURRENT_TRACKER == null || $2d380721aae6ab60$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$2d380721aae6ab60$var$$REVISION;
    }
};
function $2d380721aae6ab60$var$tripleEq(a, b) {
    return a === b;
}
var $2d380721aae6ab60$var$TrackingCache = class {
    constructor(fn){
        $2d380721aae6ab60$var$__publicField(this, "_cachedValue");
        $2d380721aae6ab60$var$__publicField(this, "_cachedRevision", -1);
        $2d380721aae6ab60$var$__publicField(this, "_deps", []);
        $2d380721aae6ab60$var$__publicField(this, "hits", 0);
        $2d380721aae6ab60$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $2d380721aae6ab60$var$CURRENT_TRACKER;
            $2d380721aae6ab60$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $2d380721aae6ab60$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $2d380721aae6ab60$var$CURRENT_TRACKER == null || $2d380721aae6ab60$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $2d380721aae6ab60$var$getValue(cell) {
    if (!(cell instanceof $2d380721aae6ab60$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $2d380721aae6ab60$var$setValue(storage, value) {
    if (!(storage instanceof $2d380721aae6ab60$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $2d380721aae6ab60$var$createCell(initialValue, isEqual = $2d380721aae6ab60$var$tripleEq) {
    return new $2d380721aae6ab60$var$Cell(initialValue, isEqual);
}
function $2d380721aae6ab60$var$createCache(fn) {
    $2d380721aae6ab60$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $2d380721aae6ab60$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $2d380721aae6ab60$var$neverEq = (a, b)=>false;
function $2d380721aae6ab60$var$createTag() {
    return $2d380721aae6ab60$var$createCell(null, $2d380721aae6ab60$var$neverEq);
}
function $2d380721aae6ab60$var$dirtyTag(tag, value) {
    $2d380721aae6ab60$var$setValue(tag, value);
}
var $2d380721aae6ab60$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $2d380721aae6ab60$var$createTag();
    $2d380721aae6ab60$var$getValue(tag);
};
var $2d380721aae6ab60$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $2d380721aae6ab60$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $2d380721aae6ab60$var$REDUX_PROXY_LABEL = Symbol();
var $2d380721aae6ab60$var$nextId = 0;
var $2d380721aae6ab60$var$proto = Object.getPrototypeOf({});
var $2d380721aae6ab60$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $2d380721aae6ab60$var$__publicField(this, "proxy", new Proxy(this, $2d380721aae6ab60$var$objectProxyHandler));
        $2d380721aae6ab60$var$__publicField(this, "tag", $2d380721aae6ab60$var$createTag());
        $2d380721aae6ab60$var$__publicField(this, "tags", {});
        $2d380721aae6ab60$var$__publicField(this, "children", {});
        $2d380721aae6ab60$var$__publicField(this, "collectionTag", null);
        $2d380721aae6ab60$var$__publicField(this, "id", $2d380721aae6ab60$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $2d380721aae6ab60$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $2d380721aae6ab60$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $2d380721aae6ab60$var$createNode(childValue);
                if (childNode.tag) $2d380721aae6ab60$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $2d380721aae6ab60$var$createTag();
                    tag.value = childValue;
                }
                $2d380721aae6ab60$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $2d380721aae6ab60$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $2d380721aae6ab60$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $2d380721aae6ab60$var$__publicField(this, "proxy", new Proxy([
            this
        ], $2d380721aae6ab60$var$arrayProxyHandler));
        $2d380721aae6ab60$var$__publicField(this, "tag", $2d380721aae6ab60$var$createTag());
        $2d380721aae6ab60$var$__publicField(this, "tags", {});
        $2d380721aae6ab60$var$__publicField(this, "children", {});
        $2d380721aae6ab60$var$__publicField(this, "collectionTag", null);
        $2d380721aae6ab60$var$__publicField(this, "id", $2d380721aae6ab60$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $2d380721aae6ab60$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $2d380721aae6ab60$var$consumeCollection(node);
        return $2d380721aae6ab60$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $2d380721aae6ab60$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $2d380721aae6ab60$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $2d380721aae6ab60$var$objectProxyHandler.has(node, prop);
    }
};
function $2d380721aae6ab60$var$createNode(value) {
    if (Array.isArray(value)) return new $2d380721aae6ab60$var$ArrayTreeNode(value);
    return new $2d380721aae6ab60$var$ObjectTreeNode(value);
}
function $2d380721aae6ab60$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $2d380721aae6ab60$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $2d380721aae6ab60$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $2d380721aae6ab60$var$dirtyCollection(node);
            $2d380721aae6ab60$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $2d380721aae6ab60$var$updateNode(childNode, newChildValue);
        else {
            $2d380721aae6ab60$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $2d380721aae6ab60$var$deleteNode(node) {
    if (node.tag) $2d380721aae6ab60$var$dirtyTag(node.tag, null);
    $2d380721aae6ab60$var$dirtyCollection(node);
    for(const key in node.tags)$2d380721aae6ab60$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$2d380721aae6ab60$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $2d380721aae6ab60$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $2d380721aae6ab60$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $2d380721aae6ab60$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $2d380721aae6ab60$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $2d380721aae6ab60$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $2d380721aae6ab60$export$3f025202a230c6dd = (a, b)=>a === b;
function $2d380721aae6ab60$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $2d380721aae6ab60$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $2d380721aae6ab60$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $2d380721aae6ab60$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $2d380721aae6ab60$var$createSingletonCache(comparator) : $2d380721aae6ab60$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $2d380721aae6ab60$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $2d380721aae6ab60$export$c8f9cf88d9fdee55(func) {
    const node = $2d380721aae6ab60$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $2d380721aae6ab60$var$createCacheKeyComparator($2d380721aae6ab60$export$3f025202a230c6dd);
    const cache = $2d380721aae6ab60$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $2d380721aae6ab60$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $2d380721aae6ab60$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $2d380721aae6ab60$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $2d380721aae6ab60$var$StrongRef;
var $2d380721aae6ab60$var$UNTERMINATED = 0;
var $2d380721aae6ab60$var$TERMINATED = 1;
function $2d380721aae6ab60$var$createCacheNode() {
    return {
        s: $2d380721aae6ab60$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $2d380721aae6ab60$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $2d380721aae6ab60$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $2d380721aae6ab60$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $2d380721aae6ab60$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $2d380721aae6ab60$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $2d380721aae6ab60$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $2d380721aae6ab60$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $2d380721aae6ab60$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $2d380721aae6ab60$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $2d380721aae6ab60$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $2d380721aae6ab60$var$__spreadValues($2d380721aae6ab60$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $2d380721aae6ab60$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $2d380721aae6ab60$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $2d380721aae6ab60$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $2d380721aae6ab60$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $2d380721aae6ab60$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $2d380721aae6ab60$export$595d22ed68ca2841 = /* @__PURE__ */ $2d380721aae6ab60$export$5943f4447f6ef248($2d380721aae6ab60$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $2d380721aae6ab60$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $2d380721aae6ab60$export$595d22ed68ca2841)=>{
    $2d380721aae6ab60$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$2d380721aae6ab60$export$75979cfcd91bf38f
});

});

parcelRegister("g0Eue", function(module, exports) {

$parcel$export(module.exports, "thunk", function () { return $ba7c0d33f9745c29$export$dd164f5517779f15; });
$parcel$export(module.exports, "withExtraArgument", function () { return $ba7c0d33f9745c29$export$16d06542a1949d9e; });
// src/index.ts
function $ba7c0d33f9745c29$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $ba7c0d33f9745c29$export$dd164f5517779f15 = $ba7c0d33f9745c29$var$createThunkMiddleware();
var $ba7c0d33f9745c29$export$16d06542a1949d9e = $ba7c0d33f9745c29$var$createThunkMiddleware;

});




parcelRegister("fOXQN", function(module, exports) {

$parcel$export(module.exports, "AuthJoinModal", function () { return (parcelRequire("45ylR")).AuthJoinModal; });
$parcel$export(module.exports, "AuthLoginModal", function () { return (parcelRequire("cCZY7")).AuthLoginModal; });
$parcel$export(module.exports, "AuthResetModal", function () { return (parcelRequire("kyFLX")).AuthResetModal; });
$parcel$export(module.exports, "AuthSignupModal", function () { return (parcelRequire("4caAj")).AuthSignupModal; });
$parcel$export(module.exports, "AuthVerificationModal", function () { return (parcelRequire("brpxu")).AuthVerificationModal; });
parcelRequire("l89qc");
var $45ylR = parcelRequire("45ylR");
var $cCZY7 = parcelRequire("cCZY7");
var $kyFLX = parcelRequire("kyFLX");
var $4caAj = parcelRequire("4caAj");
var $brpxu = parcelRequire("brpxu");

var $fAzHC = parcelRequire("fAzHC");

var $2sNJT = parcelRequire("2sNJT");
$parcel$exportWildcard(module.exports, $fAzHC);
$parcel$exportWildcard(module.exports, $2sNJT);

});
parcelRegister("l89qc", function(module, exports) {

$parcel$export(module.exports, "AuthJoinModal", function () { return (parcelRequire("45ylR")).AuthJoinModal; });
$parcel$export(module.exports, "AuthLoginModal", function () { return (parcelRequire("cCZY7")).AuthLoginModal; });
$parcel$export(module.exports, "AuthResetModal", function () { return (parcelRequire("kyFLX")).AuthResetModal; });
$parcel$export(module.exports, "AuthSignupModal", function () { return (parcelRequire("4caAj")).AuthSignupModal; });
$parcel$export(module.exports, "AuthVerificationModal", function () { return (parcelRequire("brpxu")).AuthVerificationModal; });

var $45ylR = parcelRequire("45ylR");
parcelRequire("2cl2y");
var $cCZY7 = parcelRequire("cCZY7");
var $kyFLX = parcelRequire("kyFLX");
var $4caAj = parcelRequire("4caAj");
var $brpxu = parcelRequire("brpxu");

});
parcelRegister("45ylR", function(module, exports) {

$parcel$export(module.exports, "AuthJoinModal", function () { return $57e693553c9939e4$export$8661dd77ba90024c; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("hUaLF");
var $aKb6F = parcelRequire("aKb6F");
var $dfnAY = parcelRequire("dfnAY");

var $2OPmO = parcelRequire("2OPmO");
const $57e693553c9939e4$export$8661dd77ba90024c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const joinModalOpen = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectJoinModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $2OPmO.styles)().modal.main,
        children: joinModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $fAzHC.authCloseJoinModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $2OPmO.styles)().modal.content,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $aKb6F.ModalCard), {
                        onCloseClick: ()=>dispatch((0, $fAzHC.authCloseJoinModal)()),
                        onSignupClick: ()=>{
                            dispatch((0, $fAzHC.authCloseJoinModal)());
                            dispatch((0, $fAzHC.authOpenSignupModal)());
                        },
                        onLoginClick: ()=>{
                            dispatch((0, $fAzHC.authCloseJoinModal)());
                            dispatch((0, $fAzHC.authOpenLoginModal)());
                        }
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $dfnAY.ModalFooterDesktop), {
                        onCloseClick: ()=>dispatch((0, $fAzHC.authCloseJoinModal)())
                    })
                ]
            })
        })
    });
};
$57e693553c9939e4$export$8661dd77ba90024c.propTypes = {};

});
parcelRegister("fRVt8", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return (parcelRequire("lYvdp")).Badge; });
$parcel$export(module.exports, "BadgeSelected", function () { return (parcelRequire("bT0C4")).BadgeSelected; });
$parcel$export(module.exports, "ButtonLarge", function () { return (parcelRequire("iwKg3")).ButtonLarge; });
$parcel$export(module.exports, "ButtonMedium", function () { return (parcelRequire("X9mpN")).ButtonMedium; });
$parcel$export(module.exports, "ButtonRound", function () { return (parcelRequire("jES8Z")).ButtonRound; });
$parcel$export(module.exports, "ButtonSmall", function () { return (parcelRequire("f7BhD")).ButtonSmall; });
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("fLw4A")).Checkbox; });
$parcel$export(module.exports, "CheckboxOption", function () { return (parcelRequire("6FETc")).CheckboxOption; });
$parcel$export(module.exports, "ContentHeader", function () { return (parcelRequire("kndgy")).ContentHeader; });
$parcel$export(module.exports, "ContentPlaceholder", function () { return (parcelRequire("46Iw7")).ContentPlaceholder; });
$parcel$export(module.exports, "Divider", function () { return (parcelRequire("d0Azi")).Divider; });
$parcel$export(module.exports, "Error", function () { return (parcelRequire("9TEV9")).Error; });
$parcel$export(module.exports, "InputAmount", function () { return (parcelRequire("f4vJY")).InputAmount; });
$parcel$export(module.exports, "InputArea", function () { return (parcelRequire("i8CSQ")).InputArea; });
$parcel$export(module.exports, "InputBar", function () { return (parcelRequire("cHn6a")).InputBar; });
$parcel$export(module.exports, "InputDescription", function () { return (parcelRequire("9SS8i")).InputDescription; });
$parcel$export(module.exports, "InputLabel", function () { return (parcelRequire("lB36X")).InputLabel; });
$parcel$export(module.exports, "InputLine", function () { return (parcelRequire("eRGKc")).InputLine; });
$parcel$export(module.exports, "InputSelect", function () { return (parcelRequire("e0SLm")).InputSelect; });
$parcel$export(module.exports, "Loader", function () { return (parcelRequire("1sbY5")).Loader; });
$parcel$export(module.exports, "MediaFilePreview", function () { return (parcelRequire("3wbuR")).MediaFilePreview; });
$parcel$export(module.exports, "ModalCardSubtitle", function () { return (parcelRequire("fJR4x")).ModalCardSubtitle; });
$parcel$export(module.exports, "ModalCardTitle", function () { return (parcelRequire("5B11A")).ModalCardTitle; });
$parcel$export(module.exports, "NavigationScrollable", function () { return (parcelRequire("lFRMC")).NavigationScrollable; });
$parcel$export(module.exports, "SkeletonHorizontal", function () { return (parcelRequire("cK2N9")).SkeletonHorizontal; });
$parcel$export(module.exports, "SkeletonVertical", function () { return (parcelRequire("agnse")).SkeletonVertical; });
$parcel$export(module.exports, "Stepper", function () { return (parcelRequire("i2ajo")).Stepper; });
$parcel$export(module.exports, "Subtitle", function () { return (parcelRequire("2eN72")).Subtitle; });
$parcel$export(module.exports, "ErrorFallback", function () { return (parcelRequire("ewr9k")).ErrorFallback; });
$parcel$export(module.exports, "SuspenseContentFallback", function () { return (parcelRequire("ZGlkY")).SuspenseContentFallback; });
$parcel$export(module.exports, "SuspenseMainFallback", function () { return (parcelRequire("b8aBK")).SuspenseMainFallback; });
$parcel$export(module.exports, "AppLayout", function () { return (parcelRequire("91dtq")).AppLayout; });
$parcel$export(module.exports, "ContentContainer", function () { return (parcelRequire("ayD7i")).ContentContainer; });
$parcel$export(module.exports, "ContentLayoutVirtualized", function () { return (parcelRequire("6KTJf")).ContentLayoutVirtualized; });
$parcel$export(module.exports, "MainLayout", function () { return (parcelRequire("kR3Jw")).MainLayout; });
$parcel$export(module.exports, "ModalLayout", function () { return (parcelRequire("jCNqW")).ModalLayout; });
$parcel$export(module.exports, "SectionsLayout", function () { return (parcelRequire("8tjTN")).SectionsLayout; });
$parcel$export(module.exports, "AppHeader", function () { return (parcelRequire("ewnuH")).AppHeader; });
$parcel$export(module.exports, "CardHeaderMobile", function () { return (parcelRequire("2Ww3e")).CardHeaderMobile; });
$parcel$export(module.exports, "ImageComposition", function () { return (parcelRequire("jQTWV")).ImageComposition; });
parcelRequire("7uPn3");
var $lYvdp = parcelRequire("lYvdp");
var $bT0C4 = parcelRequire("bT0C4");
var $iwKg3 = parcelRequire("iwKg3");
var $X9mpN = parcelRequire("X9mpN");
var $jES8Z = parcelRequire("jES8Z");
var $f7BhD = parcelRequire("f7BhD");
var $fLw4A = parcelRequire("fLw4A");
var $6FETc = parcelRequire("6FETc");
var $kndgy = parcelRequire("kndgy");
var $46Iw7 = parcelRequire("46Iw7");
var $d0Azi = parcelRequire("d0Azi");
var $9TEV9 = parcelRequire("9TEV9");
var $f4vJY = parcelRequire("f4vJY");
var $i8CSQ = parcelRequire("i8CSQ");
var $cHn6a = parcelRequire("cHn6a");
var $9SS8i = parcelRequire("9SS8i");
var $lB36X = parcelRequire("lB36X");
var $eRGKc = parcelRequire("eRGKc");
var $e0SLm = parcelRequire("e0SLm");
var $1sbY5 = parcelRequire("1sbY5");
var $3wbuR = parcelRequire("3wbuR");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
var $lFRMC = parcelRequire("lFRMC");
var $cK2N9 = parcelRequire("cK2N9");
var $agnse = parcelRequire("agnse");
var $i2ajo = parcelRequire("i2ajo");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("8OL1B");
var $ewr9k = parcelRequire("ewr9k");
var $ZGlkY = parcelRequire("ZGlkY");
var $b8aBK = parcelRequire("b8aBK");
parcelRequire("7hj6X");
var $91dtq = parcelRequire("91dtq");
var $ayD7i = parcelRequire("ayD7i");
var $6KTJf = parcelRequire("6KTJf");
var $kR3Jw = parcelRequire("kR3Jw");
var $jCNqW = parcelRequire("jCNqW");
var $8tjTN = parcelRequire("8tjTN");
parcelRequire("7fi9y");
var $ewnuH = parcelRequire("ewnuH");
var $2Ww3e = parcelRequire("2Ww3e");
var $jQTWV = parcelRequire("jQTWV");

});
parcelRegister("7uPn3", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return (parcelRequire("lYvdp")).Badge; });
$parcel$export(module.exports, "BadgeSelected", function () { return (parcelRequire("bT0C4")).BadgeSelected; });
$parcel$export(module.exports, "ButtonLarge", function () { return (parcelRequire("iwKg3")).ButtonLarge; });
$parcel$export(module.exports, "ButtonMedium", function () { return (parcelRequire("X9mpN")).ButtonMedium; });
$parcel$export(module.exports, "ButtonRound", function () { return (parcelRequire("jES8Z")).ButtonRound; });
$parcel$export(module.exports, "ButtonSmall", function () { return (parcelRequire("f7BhD")).ButtonSmall; });
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("fLw4A")).Checkbox; });
$parcel$export(module.exports, "CheckboxOption", function () { return (parcelRequire("6FETc")).CheckboxOption; });
$parcel$export(module.exports, "ContentHeader", function () { return (parcelRequire("kndgy")).ContentHeader; });
$parcel$export(module.exports, "ContentPlaceholder", function () { return (parcelRequire("46Iw7")).ContentPlaceholder; });
$parcel$export(module.exports, "Divider", function () { return (parcelRequire("d0Azi")).Divider; });
$parcel$export(module.exports, "Error", function () { return (parcelRequire("9TEV9")).Error; });
$parcel$export(module.exports, "InputAmount", function () { return (parcelRequire("f4vJY")).InputAmount; });
$parcel$export(module.exports, "InputArea", function () { return (parcelRequire("i8CSQ")).InputArea; });
$parcel$export(module.exports, "InputBar", function () { return (parcelRequire("cHn6a")).InputBar; });
$parcel$export(module.exports, "InputDescription", function () { return (parcelRequire("9SS8i")).InputDescription; });
$parcel$export(module.exports, "InputLabel", function () { return (parcelRequire("lB36X")).InputLabel; });
$parcel$export(module.exports, "InputLine", function () { return (parcelRequire("eRGKc")).InputLine; });
$parcel$export(module.exports, "InputSelect", function () { return (parcelRequire("e0SLm")).InputSelect; });
$parcel$export(module.exports, "Loader", function () { return (parcelRequire("1sbY5")).Loader; });
$parcel$export(module.exports, "MediaFilePreview", function () { return (parcelRequire("3wbuR")).MediaFilePreview; });
$parcel$export(module.exports, "ModalCardSubtitle", function () { return (parcelRequire("fJR4x")).ModalCardSubtitle; });
$parcel$export(module.exports, "ModalCardTitle", function () { return (parcelRequire("5B11A")).ModalCardTitle; });
$parcel$export(module.exports, "NavigationScrollable", function () { return (parcelRequire("lFRMC")).NavigationScrollable; });
$parcel$export(module.exports, "Stepper", function () { return (parcelRequire("i2ajo")).Stepper; });
$parcel$export(module.exports, "SkeletonHorizontal", function () { return (parcelRequire("cK2N9")).SkeletonHorizontal; });
$parcel$export(module.exports, "SkeletonVertical", function () { return (parcelRequire("agnse")).SkeletonVertical; });
$parcel$export(module.exports, "Subtitle", function () { return (parcelRequire("2eN72")).Subtitle; });

var $lYvdp = parcelRequire("lYvdp");

var $bT0C4 = parcelRequire("bT0C4");

var $iwKg3 = parcelRequire("iwKg3");

var $X9mpN = parcelRequire("X9mpN");

var $jES8Z = parcelRequire("jES8Z");

var $f7BhD = parcelRequire("f7BhD");

var $fLw4A = parcelRequire("fLw4A");

var $6FETc = parcelRequire("6FETc");

var $kndgy = parcelRequire("kndgy");

var $46Iw7 = parcelRequire("46Iw7");

var $d0Azi = parcelRequire("d0Azi");

var $9TEV9 = parcelRequire("9TEV9");

var $f4vJY = parcelRequire("f4vJY");

var $i8CSQ = parcelRequire("i8CSQ");

var $cHn6a = parcelRequire("cHn6a");

var $9SS8i = parcelRequire("9SS8i");

var $lB36X = parcelRequire("lB36X");

var $eRGKc = parcelRequire("eRGKc");

var $e0SLm = parcelRequire("e0SLm");

var $1sbY5 = parcelRequire("1sbY5");

var $3wbuR = parcelRequire("3wbuR");

var $fJR4x = parcelRequire("fJR4x");

var $5B11A = parcelRequire("5B11A");

var $lFRMC = parcelRequire("lFRMC");

var $i2ajo = parcelRequire("i2ajo");

var $cK2N9 = parcelRequire("cK2N9");

var $agnse = parcelRequire("agnse");

var $2eN72 = parcelRequire("2eN72");

});
parcelRegister("lYvdp", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return $a25d033fa60c00c8$export$37acb3580601e69a; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $5KsTU = parcelRequire("5KsTU");
const $a25d033fa60c00c8$export$37acb3580601e69a = ({ name: name, disabled: disabled, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $5KsTU.styles)(theme).badge.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
            css: [
                (0, $5KsTU.styles)(theme).badge.button.shared,
                disabled ? (0, $5KsTU.styles)(theme).badge.button.disabled : (0, $5KsTU.styles)(theme).badge.button.enabled,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            disabled: disabled,
            type: "button",
            "aria-label": "log out",
            children: name
        })
    });
};
$a25d033fa60c00c8$export$37acb3580601e69a.propTypes = {};

});
parcelRegister("5KsTU", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3aac74e9d6cc1460$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $3aac74e9d6cc1460$export$9dd6ff9ea0189349 = (theme)=>({
        badge: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;height:24px;background-color:", theme.colors.primary.normal, ";", ""),
            button: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-size:", (0, $48E0n.typography).p, ";transition:color 0.2s;", ""),
                enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;color:", theme.colors.secondary.dark, ";&:hover{color:", theme.colors.secondary.dark, ";}", "")
            }
        }
    });

});


parcelRegister("bT0C4", function(module, exports) {

$parcel$export(module.exports, "BadgeSelected", function () { return $8479447b0f392487$export$f260e5b9211df663; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $dASz8 = parcelRequire("dASz8");
const $8479447b0f392487$export$f260e5b9211df663 = ({ name: name, onRemoveClick: onRemoveClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $dASz8.styles)(theme).badge.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dASz8.styles)(theme).badge.close.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $dASz8.styles)(theme).badge.close.button,
                    onClick: (e)=>onRemoveClick(e),
                    type: "button",
                    "aria-label": "log out",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CrossCircle, {
                        css: (0, $dASz8.styles)(theme).badge.close.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dASz8.styles)(theme).badge.name,
                children: name
            })
        ]
    });
};
$8479447b0f392487$export$f260e5b9211df663.propTypes = {};

});
parcelRegister("dASz8", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $681cd1abcdf8e00b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $681cd1abcdf8e00b$export$9dd6ff9ea0189349 = (theme)=>({
        badge: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;height:32px;border-radius:20px;padding:0px 32px;background-color:", theme.colors.accent.normal, ";", ""),
            close: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.user.card.selectedGenre.close, ";position:absolute;right:0;top:-30%;display:flex;width:24px;height:24px;background-color:", theme.colors.primary.normal, ";border-radius:50%;", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:24px;height:24px;cursor:pointer;", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:18px;height:18px;&>path{fill:", theme.colors.accent.normal, ";}", "")
            },
            name: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";font-weight:bold;color:", theme.colors.primary.normal, ";", "")
        }
    });

});


parcelRegister("iwKg3", function(module, exports) {

$parcel$export(module.exports, "ButtonLarge", function () { return $7b1ee950c435fd2d$export$1bd2585f926208da; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $ao3wW = parcelRequire("ao3wW");
const $7b1ee950c435fd2d$export$1bd2585f926208da = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
        css: [
            (0, $ao3wW.styles)(theme).button.main,
            appearance === "primary" && (0, $ao3wW.styles)(theme).button.primary,
            appearance === "secondary" && (0, $ao3wW.styles)(theme).button.secondary,
            attributes.disabled && (0, $ao3wW.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $ao3wW.styles)(theme).button.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $ao3wW.styles)(theme).button.content.children,
                children: children
            })
        })
    });
};
$7b1ee950c435fd2d$export$1bd2585f926208da.propTypes = {};

});
parcelRegister("ao3wW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f780f7c84151e036$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f780f7c84151e036$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f780f7c84151e036$var$_ref = {
    name: "16lvhbt",
    styles: "display:flex;justify-content:center;width:100%;min-width:0"
};
var $f780f7c84151e036$var$_ref2 = {
    name: "rg7b1m",
    styles: "padding:8px 26px;height:46px"
};
var $f780f7c84151e036$var$_ref3 = {
    name: "452cf2",
    styles: "height:52px"
};
const $f780f7c84151e036$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;white-space:nowrap;border-radius:20px;padding:14px 32px;height:56px;width:100%;overflow:hidden;transition:color 0.2s,background-color 0.2s;min-width:0;", (0, $48E0n.mq).tablet($f780f7c84151e036$var$_ref3), " ", (0, $48E0n.mq).mobile($f780f7c84151e036$var$_ref2), ";", ""),
            primary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{background-color:", theme.colors.accent.normalHover, ";}", ""),
            secondary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";background-color:", theme.colors.primary.normal, ";&:hover{background-color:", theme.colors.primary.normalHover, ";}", ""),
            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;color:", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.dark, ";&:hover{background-color:", theme.colors.secondary.dark, ";}", ""),
            content: {
                main: $f780f7c84151e036$var$_ref,
                children: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});


parcelRegister("X9mpN", function(module, exports) {

$parcel$export(module.exports, "ButtonMedium", function () { return $0d1e3aacb59ab1db$export$32edac2c0f3b2a9a; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $6sU2t = parcelRequire("6sU2t");
const $0d1e3aacb59ab1db$export$32edac2c0f3b2a9a = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
        css: [
            (0, $6sU2t.styles)(theme).button.main,
            appearance === "primary" && (0, $6sU2t.styles)(theme).button.primary,
            appearance === "secondary" && (0, $6sU2t.styles)(theme).button.secondary,
            attributes.disabled && (0, $6sU2t.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $6sU2t.styles)(theme).button.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6sU2t.styles)(theme).button.content.children,
                children: children
            })
        })
    });
};
$0d1e3aacb59ab1db$export$32edac2c0f3b2a9a.propTypes = {};

});
parcelRegister("6sU2t", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6a4fdbf6fb961071$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $6a4fdbf6fb961071$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6a4fdbf6fb961071$var$_ref = {
    name: "16lvhbt",
    styles: "display:flex;justify-content:center;width:100%;min-width:0"
};
const $6a4fdbf6fb961071$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;padding:12px 36px;height:44px;width:100%;overflow:hidden;transition:color 0.2s,background-color 0.2s,border 0.2s;min-width:0;& svg>path{transition:fill 0.2s,color 0.2s;}", ""),
            primary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";& svg>path{fill:", theme.colors.primary.normal, ";}&:hover{color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normalHover, ";& svg>path{fill:", theme.colors.primary.normal, ";}}", ""),
            secondary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.secondary.normal, ";& svg>path{fill:", theme.colors.secondary.normal, ";}&:hover{color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";& svg>path{fill:", theme.colors.accent.normal, ";}}", ""),
            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;color:", theme.colors.secondary.dark, ";background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.secondary.dark, ";& svg>path{fill:", theme.colors.secondary.dark, ";}&:hover{color:", theme.colors.secondary.dark, ";border:1px solid ", theme.colors.secondary.dark, ";background-color:", theme.colors.primary.normal, ";& svg>path{fill:", theme.colors.secondary.dark, ";}}", ""),
            content: {
                main: $6a4fdbf6fb961071$var$_ref,
                children: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});


parcelRegister("jES8Z", function(module, exports) {

$parcel$export(module.exports, "ButtonRound", function () { return $783d4988df40fc35$export$6c486db588432ce2; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $5HE0U = parcelRequire("5HE0U");
const $783d4988df40fc35$export$6c486db588432ce2 = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
        css: [
            (0, $5HE0U.styles)(theme).button.main,
            appearance === "primary" && (0, $5HE0U.styles)(theme).button.primary,
            appearance === "secondary" && (0, $5HE0U.styles)(theme).button.secondary,
            attributes.disabled && (0, $5HE0U.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $5HE0U.styles)(theme).button.content,
            children: children
        })
    });
};
$783d4988df40fc35$export$6c486db588432ce2.propTypes = {};

});
parcelRegister("5HE0U", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b001820ba8f02574$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b001820ba8f02574$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b001820ba8f02574$var$_ref = {
    name: "1wnowod",
    styles: "display:flex;align-items:center;justify-content:center"
};
var $b001820ba8f02574$var$_ref2 = {
    name: "ypnlzr",
    styles: "width:50px;height:50px"
};
const $b001820ba8f02574$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;white-space:nowrap;border-radius:50%;overflow:hidden;width:60px;height:60px;transition:color 0.2s,background-color 0.2s;", (0, $48E0n.mq).mobile($b001820ba8f02574$var$_ref2), ";", ""),
            primary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{background-color:", theme.colors.accent.normalHover, ";}", ""),
            secondary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";background-color:", theme.colors.primary.normal, ";&:hover{background-color:", theme.colors.primary.normalHover, ";}", ""),
            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;color:", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.dark, ";&:hover{background-color:", theme.colors.secondary.dark, ";}", ""),
            content: $b001820ba8f02574$var$_ref
        }
    });

});


parcelRegister("f7BhD", function(module, exports) {

$parcel$export(module.exports, "ButtonSmall", function () { return $5748e0f447ca5a9b$export$80dfd3a1a7d0749e; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $a8MkA = parcelRequire("a8MkA");
const $5748e0f447ca5a9b$export$80dfd3a1a7d0749e = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
        css: [
            (0, $a8MkA.styles)(theme).button.shared,
            appearance === "primary" && (0, $a8MkA.styles)(theme).button.primary,
            appearance === "secondary" && (0, $a8MkA.styles)(theme).button.secondary,
            attributes.disabled && (0, $a8MkA.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: children
    });
};

});
parcelRegister("a8MkA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a395cd3c0564f185$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $a395cd3c0564f185$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:8px 26px;width:100%;transition:border 0.2s,color 0.2s,background-color 0.2s;", ""),
            primary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.accent.normal, ";}", ""),
            secondary: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.secondary.light, ";background-color:", theme.colors.primary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;color:", theme.colors.secondary.darkHover, ";background-color:", theme.colors.secondary.darker, ";&:hover{border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.darker, ";color:", theme.colors.secondary.darkHover, ";}", "")
        }
    });

});


parcelRegister("fLw4A", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $49e2967c92178f30$export$48513f6b9f8ce62d; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $53BFC = parcelRequire("53BFC");
const $49e2967c92178f30$export$48513f6b9f8ce62d = ({ name: name, label: label, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $53BFC.styles)(theme).checkbox.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
            css: (0, $53BFC.styles)(theme).checkbox.label.main,
            htmlFor: name,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                    css: (0, $53BFC.styles)(theme).checkbox.input,
                    id: name,
                    ...attributes,
                    type: "checkbox"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: [
                        (0, $53BFC.styles)(theme).checkbox.label.mark.shared,
                        attributes.checked ? (0, $53BFC.styles)(theme).checkbox.label.mark.checked : (0, $53BFC.styles)(theme).checkbox.label.mark.unchecked,
                        "",
                        ""
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: (0, $53BFC.styles)(theme).checkbox.label.text,
                    children: label
                })
            ]
        })
    });
};
$49e2967c92178f30$export$48513f6b9f8ce62d.propTypes = {};

});
parcelRegister("53BFC", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fb98c87fc7316c9c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $fb98c87fc7316c9c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fb98c87fc7316c9c$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $fb98c87fc7316c9c$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
var $fb98c87fc7316c9c$var$_ref3 = {
    name: "10556yz",
    styles: "display:inline-block;position:relative;width:30px;height:30px;border-radius:8px;cursor:pointer"
};
var $fb98c87fc7316c9c$var$_ref4 = {
    name: "1h11b77",
    styles: "display:flex;width:30px;height:30px"
};
const $fb98c87fc7316c9c$export$9dd6ff9ea0189349 = (theme)=>({
        checkbox: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            label: {
                main: $fb98c87fc7316c9c$var$_ref4,
                mark: {
                    shared: $fb98c87fc7316c9c$var$_ref3,
                    checked: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";&::after{content:'';position:absolute;left:50%;top:50%;width:8px;height:14px;border:solid ", theme.colors.primary.normal, ";border-width:0 3px 3px 0;transform:translate(-50%,-58%) rotate(45deg);}", ""),
                    unchecked: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.secondary.darkHover, ";", "")
                },
                text: $fb98c87fc7316c9c$var$_ref2
            },
            input: $fb98c87fc7316c9c$var$_ref
        }
    });

});


parcelRegister("6FETc", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", function () { return $a964784ba1f18d56$export$d40cc97ecda916f9; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("fRVt8");
var $fLw4A = parcelRequire("fLw4A");

var $ghsiy = parcelRequire("ghsiy");
const $a964784ba1f18d56$export$d40cc97ecda916f9 = ({ name: name, description: description, icon: Icon, checked: checked, onCheckboxClick: onCheckboxClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $ghsiy.styles)(theme).option.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $ghsiy.styles)(theme).option.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $ghsiy.styles)(theme).option.data.title.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $ghsiy.styles)(theme).option.data.title.icon,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $ghsiy.styles)(theme).option.data.title.name,
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $ghsiy.styles)(theme).option.data.description,
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $ghsiy.styles)(theme).option.checkbox,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fLw4A.Checkbox), {
                    name: name,
                    label: name,
                    checked: checked,
                    onChange: (e)=>onCheckboxClick(e)
                })
            })
        ]
    });
};
$a964784ba1f18d56$export$d40cc97ecda916f9.propTypes = {};

});
parcelRegister("ghsiy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c76252d7efd8a3f4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c76252d7efd8a3f4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c76252d7efd8a3f4$var$_ref = {
    name: "1rit7pc",
    styles: "margin-right:8px;&>svg{width:26px;height:26px;}"
};
var $c76252d7efd8a3f4$var$_ref2 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $c76252d7efd8a3f4$var$_ref3 = {
    name: "3ik5jl",
    styles: "display:flex;flex-direction:column;margin-right:auto"
};
var $c76252d7efd8a3f4$var$_ref4 = {
    name: "zjik7",
    styles: "display:flex"
};
const $c76252d7efd8a3f4$export$9dd6ff9ea0189349 = (theme)=>({
        option: {
            main: $c76252d7efd8a3f4$var$_ref4,
            data: {
                main: $c76252d7efd8a3f4$var$_ref3,
                title: {
                    main: $c76252d7efd8a3f4$var$_ref2,
                    icon: $c76252d7efd8a3f4$var$_ref,
                    name: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";font-weight:bold;margin-right:auto;", "")
                },
                description: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
            },
            checkbox: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("kndgy", function(module, exports) {

$parcel$export(module.exports, "ContentHeader", function () { return $30db6b6020b6fd74$export$b52a1b6380889dfe; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $iYXzl = parcelRequire("iYXzl");
const $30db6b6020b6fd74$export$b52a1b6380889dfe = ({ text: text, placement: placement = "default" })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("h2", {
        css: [
            (0, $iYXzl.styles)(theme).title.text,
            placement === "default" && (0, $iYXzl.styles)(theme).title.placement.default,
            placement === "content" && (0, $iYXzl.styles)(theme).title.placement.content,
            "",
            ""
        ],
        children: text
    });
};
$30db6b6020b6fd74$export$b52a1b6380889dfe.propTypes = {};

});
parcelRegister("iYXzl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fd6373acba28ac4e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fd6373acba28ac4e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fd6373acba28ac4e$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $fd6373acba28ac4e$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";font-weight:bold;color:", theme.colors.secondary.light, ";margin-bottom:0px;", ""),
            placement: {
                default: $fd6373acba28ac4e$var$_ref,
                content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.content, ";margin-bottom:24px;", "")
            }
        }
    });

});


parcelRegister("46Iw7", function(module, exports) {

$parcel$export(module.exports, "ContentPlaceholder", function () { return $232a6d8f5411bbae$export$ae725288d93437df; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $4Fy9j = parcelRequire("4Fy9j");
const $232a6d8f5411bbae$export$ae725288d93437df = ({ title: title, height: height, icon: Icon })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $4Fy9j.styles)(theme).placeholder.main(height),
        children: [
            Icon && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4Fy9j.styles)(theme).placeholder.icon,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4Fy9j.styles)(theme).placeholder.title,
                children: title
            })
        ]
    });
};
$232a6d8f5411bbae$export$ae725288d93437df.propTypes = {};

});
parcelRegister("4Fy9j", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $aef45049af15ce82$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $aef45049af15ce82$export$9dd6ff9ea0189349 = (theme)=>({
        placeholder: {
            main: (height)=>/*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:", height, ";", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("margin-bottom:10px;&>svg{width:40px;height:40px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
            title: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";text-align:center;color:", theme.colors.secondary.light, ";", "")
        }
    });

});


parcelRegister("d0Azi", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $0a392a0325cac494$export$2e0a83ec2e27ecbb; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $joieA = parcelRequire("joieA");
const $0a392a0325cac494$export$2e0a83ec2e27ecbb = ({ maxWidth: maxWidth = "", horizontalMargin: horizontalMargin, verticalMargin: verticalMargin })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: [
            (0, $joieA.styles)(theme).divider.main,
            maxWidth && (0, $joieA.styles)(theme).divider.maxWidth(maxWidth),
            horizontalMargin && (0, $joieA.styles)(theme).divider.horizontalMargin(horizontalMargin),
            verticalMargin && (0, $joieA.styles)(theme).divider.verticalMargin(verticalMargin),
            "",
            ""
        ]
    });
};
$0a392a0325cac494$export$2e0a83ec2e27ecbb.propTypes = {};

});
parcelRegister("joieA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $298cd3ea3c49f6a5$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $298cd3ea3c49f6a5$export$9dd6ff9ea0189349 = (theme)=>({
        divider: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;height:2px;background-color:", theme.colors.secondary.dark, ";", ""),
            maxWidth: (maxWidth)=>/*#__PURE__*/ (0, $4N3Qt.css)("max-width:", maxWidth, ";", ""),
            horizontalMargin: (horizontalMargin)=>/*#__PURE__*/ (0, $4N3Qt.css)("margin-left:", horizontalMargin.left, ";margin-right:", horizontalMargin.right, ";", ""),
            verticalMargin: (verticalMargin)=>/*#__PURE__*/ (0, $4N3Qt.css)("margin-top:", verticalMargin.top, ";margin-bottom:", verticalMargin.bottom, ";", "")
        }
    });

});


parcelRegister("9TEV9", function(module, exports) {

$parcel$export(module.exports, "Error", function () { return $2e7565bcc19aad34$export$edf27be85e5f6da0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $dOiUQ = parcelRequire("dOiUQ");
const $2e7565bcc19aad34$export$edf27be85e5f6da0 = ({ error: error })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: [
            (0, $dOiUQ.styles)(theme).error.shared,
            error ? (0, $dOiUQ.styles)(theme).error.visible : (0, $dOiUQ.styles)(theme).error.hidden,
            "",
            ""
        ],
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
            css: [
                (0, $dOiUQ.styles)(theme).error.text.shared,
                error ? (0, $dOiUQ.styles)(theme).error.text.visible : (0, $dOiUQ.styles)(theme).error.text.hidden,
                "",
                ""
            ],
            children: error
        })
    });
};
$2e7565bcc19aad34$export$edf27be85e5f6da0.propTypes = {};

});
parcelRegister("dOiUQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c3b24c2e17994ec4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c3b24c2e17994ec4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c3b24c2e17994ec4$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $c3b24c2e17994ec4$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $c3b24c2e17994ec4$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $c3b24c2e17994ec4$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $c3b24c2e17994ec4$var$_ref5 = {
    name: "7wk0r4",
    styles: "display:flex;justify-content:center;min-width:0;transition:height 0.2s"
};
const $c3b24c2e17994ec4$export$9dd6ff9ea0189349 = (theme)=>({
        error: {
            shared: $c3b24c2e17994ec4$var$_ref5,
            visible: $c3b24c2e17994ec4$var$_ref4,
            hidden: $c3b24c2e17994ec4$var$_ref3,
            text: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.negative.normal, ";text-align:center;transition:opacity 0.4s;", ""),
                visible: $c3b24c2e17994ec4$var$_ref2,
                hidden: $c3b24c2e17994ec4$var$_ref
            }
        }
    });

});


parcelRegister("f4vJY", function(module, exports) {

$parcel$export(module.exports, "InputAmount", function () { return $cb2525235340d7c0$export$35d22d5200306724; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $iK2DZ = parcelRequire("iK2DZ");
const $cb2525235340d7c0$export$35d22d5200306724 = ({ name: name, label: label, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $iK2DZ.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $iK2DZ.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $iK2DZ.styles)(theme).input.range.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: attributes.value === attributes.min ? (0, $iK2DZ.styles)(theme).input.range.min.active : (0, $iK2DZ.styles)(theme).input.range.min.inactive,
                        children: [
                            "$",
                            attributes.min
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: attributes.value === attributes.max ? (0, $iK2DZ.styles)(theme).input.range.min.active : (0, $iK2DZ.styles)(theme).input.range.min.inactive,
                        children: [
                            "$",
                            attributes.max
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $iK2DZ.styles)(theme).input.data.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                    css: (0, $iK2DZ.styles)(theme).input.data.input,
                    id: name,
                    ...attributes
                })
            })
        ]
    });
};
$cb2525235340d7c0$export$35d22d5200306724.propTypes = {};

});
parcelRegister("iK2DZ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c87585da337dc09c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c87585da337dc09c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c87585da337dc09c$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $c87585da337dc09c$var$_ref2 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $c87585da337dc09c$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $c87585da337dc09c$var$_ref2,
            label: $c87585da337dc09c$var$_ref,
            range: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:space-between;font-size:", (0, $48E0n.typography).h6, ";", ""),
                min: {
                    inactive: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.dark, ";", ""),
                    active: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";font-weight:bold;", "")
                },
                max: {
                    inactive: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.dark, ";", ""),
                    active: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";font-weight:bold;", "")
                }
            },
            data: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                input: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:28px;appearance:none;-webkit-appearance:none;background:transparent;cursor:pointer;&::-webkit-slider-runnable-track{background:", theme.colors.accent.normal, ";height:4px;}&::-moz-range-track{background:", theme.colors.accent.normal, ";height:4px;}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;margin-top:-6px;height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}&::-moz-range-thumb{height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}", "")
            }
        }
    });

});


parcelRegister("i8CSQ", function(module, exports) {

$parcel$export(module.exports, "InputArea", function () { return $9a9dd4612e97d82f$export$2b0b81e3a67b07d2; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $fgMTh = parcelRequire("fgMTh");
const $9a9dd4612e97d82f$export$2b0b81e3a67b07d2 = ({ name: name, label: label, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $fgMTh.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $fgMTh.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $fgMTh.styles)(theme).input.data.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("textarea", {
                    css: [
                        (0, $fgMTh.styles)(theme).input.data.shared,
                        attributes.value ? (0, $fgMTh.styles)(theme).input.data.filled : (0, $fgMTh.styles)(theme).input.data.empty,
                        attributes.disabled && (0, $fgMTh.styles)(theme).input.data.disabled,
                        error && (0, $fgMTh.styles)(theme).input.data.errored,
                        "",
                        ""
                    ],
                    id: name,
                    ...attributes
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $fgMTh.styles)(theme).input.error.shared,
                    errorMessage ? (0, $fgMTh.styles)(theme).input.error.visible : (0, $fgMTh.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: [
                        (0, $fgMTh.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $fgMTh.styles)(theme).input.error.text.visible : (0, $fgMTh.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$9a9dd4612e97d82f$export$2b0b81e3a67b07d2.propTypes = {};

});
parcelRegister("fgMTh", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fc3c35818bad49c8$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fc3c35818bad49c8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fc3c35818bad49c8$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $fc3c35818bad49c8$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $fc3c35818bad49c8$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $fc3c35818bad49c8$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $fc3c35818bad49c8$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $fc3c35818bad49c8$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $fc3c35818bad49c8$var$_ref7 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $fc3c35818bad49c8$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $fc3c35818bad49c8$var$_ref7,
            label: $fc3c35818bad49c8$var$_ref6,
            data: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;resize:none;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;transition:border 0.2s;&:focus{border-bottom:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", ""),
                empty: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                filled: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.dark, ";", ""),
                errored: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.negative.normal, ";color:", theme.colors.secondary.normal, ";", "")
            },
            error: {
                shared: $fc3c35818bad49c8$var$_ref5,
                visible: $fc3c35818bad49c8$var$_ref4,
                hidden: $fc3c35818bad49c8$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $fc3c35818bad49c8$var$_ref2,
                    hidden: $fc3c35818bad49c8$var$_ref
                }
            }
        }
    });

});


parcelRegister("cHn6a", function(module, exports) {

$parcel$export(module.exports, "InputBar", function () { return $f952468a2cb95574$export$e1ae4a06dabc4e34; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $iVIIk = parcelRequire("iVIIk");
const $f952468a2cb95574$export$e1ae4a06dabc4e34 = ({ name: name, label: label, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $iVIIk.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $iVIIk.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $iVIIk.styles)(theme).input.data.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                    css: [
                        (0, $iVIIk.styles)(theme).input.data.shared,
                        attributes.value ? (0, $iVIIk.styles)(theme).input.data.filled : (0, $iVIIk.styles)(theme).input.data.empty,
                        error && (0, $iVIIk.styles)(theme).input.data.errored,
                        "",
                        ""
                    ],
                    id: name,
                    ...attributes
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $iVIIk.styles)(theme).input.error.shared,
                    errorMessage ? (0, $iVIIk.styles)(theme).input.error.visible : (0, $iVIIk.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: [
                        (0, $iVIIk.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $iVIIk.styles)(theme).input.error.text.visible : (0, $iVIIk.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$f952468a2cb95574$export$e1ae4a06dabc4e34.propTypes = {};

});
parcelRegister("iVIIk", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $76446a432bdfbe62$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $76446a432bdfbe62$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $76446a432bdfbe62$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $76446a432bdfbe62$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $76446a432bdfbe62$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $76446a432bdfbe62$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $76446a432bdfbe62$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $76446a432bdfbe62$var$_ref6 = {
    name: "1dvgrzx",
    styles: "height:50px;padding:12px 26px"
};
var $76446a432bdfbe62$var$_ref7 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $76446a432bdfbe62$var$_ref8 = {
    name: "eivff4",
    styles: "display:none"
};
var $76446a432bdfbe62$var$_ref9 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $76446a432bdfbe62$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $76446a432bdfbe62$var$_ref9,
            label: $76446a432bdfbe62$var$_ref8,
            data: {
                main: $76446a432bdfbe62$var$_ref7,
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:56px;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h6, ";color:", theme.colors.secondary.normal, ";border-radius:20px;padding:14px 32px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", (0, $48E0n.mq).mobile($76446a432bdfbe62$var$_ref6), ";", ""),
                empty: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.darkHover, ";", ""),
                filled: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.normal, ";", ""),
                errored: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.negative.normal, ";", "")
            },
            error: {
                shared: $76446a432bdfbe62$var$_ref5,
                visible: $76446a432bdfbe62$var$_ref4,
                hidden: $76446a432bdfbe62$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $76446a432bdfbe62$var$_ref2,
                    hidden: $76446a432bdfbe62$var$_ref
                }
            }
        }
    });

});


parcelRegister("9SS8i", function(module, exports) {

$parcel$export(module.exports, "InputDescription", function () { return $ef6a5f04c4588d91$export$416ae9045a33afd; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $8Q3QQ = parcelRequire("8Q3QQ");
const $ef6a5f04c4588d91$export$416ae9045a33afd = ({ description: description })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8Q3QQ.styles)(theme).option.main,
        children: description
    });
};
$ef6a5f04c4588d91$export$416ae9045a33afd.propTypes = {};

});
parcelRegister("8Q3QQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a3b14652c2632d25$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $a3b14652c2632d25$export$9dd6ff9ea0189349 = (theme)=>({
        option: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("lB36X", function(module, exports) {

$parcel$export(module.exports, "InputLabel", function () { return $1897223c3be8915c$export$76d3231fec538b73; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $tQaP8 = parcelRequire("tQaP8");
const $1897223c3be8915c$export$76d3231fec538b73 = ({ text: text })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $tQaP8.styles)(theme).label.main,
        children: text
    });
};
$1897223c3be8915c$export$76d3231fec538b73.propTypes = {};

});
parcelRegister("tQaP8", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bfcb92b4875c6fad$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $bfcb92b4875c6fad$export$9dd6ff9ea0189349 = (theme)=>({
        label: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});


parcelRegister("eRGKc", function(module, exports) {

$parcel$export(module.exports, "InputLine", function () { return $859de9b74f55010f$export$5214e7c10cea1350; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $9RPSZ = parcelRequire("9RPSZ");
const $859de9b74f55010f$export$5214e7c10cea1350 = ({ name: name, label: label, icon: Icon, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9RPSZ.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $9RPSZ.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $9RPSZ.styles)(theme).input.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                        css: [
                            (0, $9RPSZ.styles)(theme).input.data.shared,
                            attributes.value ? (0, $9RPSZ.styles)(theme).input.data.filled : (0, $9RPSZ.styles)(theme).input.data.empty,
                            attributes.disabled && (0, $9RPSZ.styles)(theme).input.data.disabled,
                            error && (0, $9RPSZ.styles)(theme).input.data.errored,
                            "",
                            ""
                        ],
                        id: name,
                        ...attributes
                    }),
                    Icon && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: [
                            (0, $9RPSZ.styles)(theme).input.data.icon.shared,
                            attributes.value ? (0, $9RPSZ.styles)(theme).input.data.icon.filled : (0, $9RPSZ.styles)(theme).input.data.icon.empty,
                            attributes.disabled && (0, $9RPSZ.styles)(theme).input.data.icon.disabled,
                            error && (0, $9RPSZ.styles)(theme).input.data.icon.errored,
                            "",
                            ""
                        ],
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $9RPSZ.styles)(theme).input.error.shared,
                    errorMessage ? (0, $9RPSZ.styles)(theme).input.error.visible : (0, $9RPSZ.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: [
                        (0, $9RPSZ.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $9RPSZ.styles)(theme).input.error.text.visible : (0, $9RPSZ.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$859de9b74f55010f$export$5214e7c10cea1350.propTypes = {};

});
parcelRegister("9RPSZ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8bc0ec00a09d061d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8bc0ec00a09d061d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8bc0ec00a09d061d$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $8bc0ec00a09d061d$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $8bc0ec00a09d061d$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $8bc0ec00a09d061d$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $8bc0ec00a09d061d$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $8bc0ec00a09d061d$var$_ref6 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $8bc0ec00a09d061d$var$_ref7 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $8bc0ec00a09d061d$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $8bc0ec00a09d061d$var$_ref7,
            label: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";margin-bottom:10px;", ""),
            data: {
                main: $8bc0ec00a09d061d$var$_ref6,
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:28px;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;padding-bottom:2px;padding-right:28px;transition:border 0.2s;&:focus{border-bottom:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", ""),
                empty: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                filled: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.dark, ";", ""),
                errored: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.negative.normal, ";color:", theme.colors.secondary.normal, ";", ""),
                icon: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).components.elements.inputLine.icon, ";position:absolute;right:0;top:0;display:flex;align-items:center;justify-content:center;width:28px;height:28px;&>svg{width:14px;height:14px;&>path{transition:fill 0.2s;}}", ""),
                    empty: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                    filled: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                    disabled: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.secondary.dark, ";}", ""),
                    errored: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.negative.normal, ";}", "")
                }
            },
            error: {
                shared: $8bc0ec00a09d061d$var$_ref5,
                visible: $8bc0ec00a09d061d$var$_ref4,
                hidden: $8bc0ec00a09d061d$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $8bc0ec00a09d061d$var$_ref2,
                    hidden: $8bc0ec00a09d061d$var$_ref
                }
            }
        }
    });

});


parcelRegister("e0SLm", function(module, exports) {

$parcel$export(module.exports, "InputSelect", function () { return $35a008780d83ee00$export$3fdb416c71effd9; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $hCSnA = parcelRequire("hCSnA");
const $35a008780d83ee00$export$3fdb416c71effd9 = ({ placeholder: placeholder, options: options, setValue: setValue })=>{
    const theme = (0, $hXJcm.u)();
    const [isOpen, setIsOpen] = (0, $exYeM.useState)(false);
    const [selectedOption, setSelectedOption] = (0, $exYeM.useState)(placeholder);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $hCSnA.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: [
                    (0, $hCSnA.styles)(theme).input.header.main.shared,
                    isOpen && (0, $hCSnA.styles)(theme).input.header.main.open,
                    "",
                    ""
                ],
                onClick: ()=>setIsOpen((state)=>!state),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $hCSnA.styles)(theme).input.header.option,
                        "aria-label": selectedOption.label,
                        children: selectedOption.label
                    }, `${selectedOption.id}-selected`),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: [
                            (0, $hCSnA.styles)(theme).input.header.icon.shared,
                            isOpen && (0, $hCSnA.styles)(theme).input.header.icon.open,
                            "",
                            ""
                        ],
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CaretDown, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $hCSnA.styles)(theme).input.options.main.shared,
                    isOpen && (0, $hCSnA.styles)(theme).input.options.main.open,
                    "",
                    ""
                ],
                children: options.map((option)=>{
                    const { id: id, label: label, value: value } = option;
                    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: [
                            (0, $hCSnA.styles)(theme).input.options.option.shared,
                            selectedOption.id === id && (0, $hCSnA.styles)(theme).input.options.option.selected,
                            "",
                            ""
                        ],
                        "aria-label": label,
                        onClick: ()=>{
                            setSelectedOption(option);
                            setIsOpen(false);
                            setValue(value);
                        },
                        "aria-hidden": "true",
                        children: label
                    }, id);
                })
            })
        ]
    });
};
$35a008780d83ee00$export$3fdb416c71effd9.propTypes = {};

});
parcelRegister("hCSnA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7fe5575926330c8f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7fe5575926330c8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7fe5575926330c8f$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $7fe5575926330c8f$var$_ref2 = {
    name: "16hjiy4",
    styles: "position:relative;display:flex;flex-direction:column"
};
const $7fe5575926330c8f$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $7fe5575926330c8f$var$_ref2,
            header: {
                main: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;width:100%;height:28px;border-bottom:1px solid ", theme.colors.secondary.normal, ";transition:border 0.2s;", ""),
                    open: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.accent.normal, ";", "")
                },
                option: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;user-select:none;margin-right:28px;cursor:pointer;", ""),
                icon: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;right:0;top:0;display:flex;align-items:center;justify-content:center;width:28px;height:28px;transform:rotate(180deg);transition:transform 0.2s;&>svg{width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                    open: /*#__PURE__*/ (0, $4N3Qt.css)("transform:rotate(0deg);&>svg{&>path{fill:", theme.colors.accent.normal, ";}}", "")
                }
            },
            options: {
                main: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;left:0;top:36px;display:none;width:100%;background-color:", theme.colors.primary.normal, ";padding:6px 0px;animation:0.2s ease 0s backwards ", (0, $48E0n.kf).slideIn.down(10), ";&>div:not(:last-of-type){margin-bottom:8px;}", ""),
                    open: $7fe5575926330c8f$var$_ref
                },
                option: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";width:100%;height:28px;font-size:", (0, $48E0n.typography).p, ";font-weight:bold;user-select:none;cursor:pointer;", ""),
                    selected: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";", "")
                }
            }
        }
    });

});


parcelRegister("1sbY5", function(module, exports) {

$parcel$export(module.exports, "Loader", function () { return $6b6b8ff60fb60de2$export$3b0d6d7590275603; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $aEFYI = parcelRequire("aEFYI");
const $6b6b8ff60fb60de2$export$3b0d6d7590275603 = ({ width: width, height: height, appearance: appearance = "primary" })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $aEFYI.styles)(theme).loader.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: [
                (0, $aEFYI.styles)(theme).loader.bars.shared(width, height),
                appearance === "primary" && (0, $aEFYI.styles)(theme).loader.bars.primary(width, height),
                appearance === "secondary" && (0, $aEFYI.styles)(theme).loader.bars.secondary(width, height),
                appearance === "accent" && (0, $aEFYI.styles)(theme).loader.bars.accent(width, height),
                "",
                ""
            ]
        })
    });
};
$6b6b8ff60fb60de2$export$3b0d6d7590275603.propTypes = {};

});
parcelRegister("aEFYI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fdcef8bc78205998$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fdcef8bc78205998$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fdcef8bc78205998$var$_ref = {
    name: "1wnowod",
    styles: "display:flex;align-items:center;justify-content:center"
};
const $fdcef8bc78205998$export$9dd6ff9ea0189349 = (theme)=>({
        loader: {
            main: $fdcef8bc78205998$var$_ref,
            bars: {
                shared: (width, height)=>{
                    const baseWidth = width / 7;
                    return /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;width:", width, "px;height:", height, "px;animation:1s linear infinite alternate ", (0, $48E0n.kf).load.bars(width, height), ";background-repeat:no-repeat;background-position:0px center,", baseWidth * 1, "px center,", baseWidth * 2, "px center,", baseWidth * 3, "px center,", baseWidth * 4, "px center,", baseWidth * 5, "px center,", baseWidth * 6, "px center;", "");
                },
                primary: (width, height)=>/*#__PURE__*/ (0, $4N3Qt.css)("background-image:linear-gradient(\n            ", theme.colors.primary.normal, " ", height, "px,\n            transparent 0\n          ),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0);", ""),
                secondary: (width, height)=>/*#__PURE__*/ (0, $4N3Qt.css)("background-image:linear-gradient(\n            ", theme.colors.secondary.normal, " ", height, "px,\n            transparent 0\n          ),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0);", ""),
                accent: (width, height)=>/*#__PURE__*/ (0, $4N3Qt.css)("background-image:linear-gradient(\n            ", theme.colors.accent.normal, " ", height, "px,\n            transparent 0\n          ),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0);", "")
            }
        }
    });

});


parcelRegister("3wbuR", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreview", function () { return $b3242d3e4f5d250c$export$b563e8c407c1ac47; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $ekwYU = parcelRequire("ekwYU");
const $b3242d3e4f5d250c$export$b563e8c407c1ac47 = ({ source: source, width: width, height: height, type: type, formats: formats, maxFileSize: maxFileSize, alt: alt = "", onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    const renderPreview = ()=>{
        // if source provided and media type is image
        if (source && type === "image") return /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
            css: (0, $ekwYU.styles)(theme).preview.image.overlay.content,
            loading: "lazy",
            src: source,
            alt: alt,
            width: width,
            height: height
        });
        // if source provided and media type is video
        if (source && type === "video") return /*#__PURE__*/ (0, $5o6z6.jsxs)("video", {
            css: (0, $ekwYU.styles)(theme).preview.image.overlay.content,
            width: width,
            height: height,
            src: source,
            muted: true,
            preload: "metadata",
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("source", {
                    src: source,
                    type: "video/mp4"
                }),
                "Your browser does not support the video tag."
            ]
        });
        // placeholder
        return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $ekwYU.styles)(theme).preview.image.overlay.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ImageDownload, {
                    css: (0, $ekwYU.styles)(theme).preview.image.overlay.icon
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $ekwYU.styles)(theme).preview.image.overlay.text.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $ekwYU.styles)(theme).preview.image.overlay.text.formats,
                            children: formats && formats.join(", ")
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $ekwYU.styles)(theme).preview.image.overlay.text.size,
                            children: maxFileSize && `up to ${maxFileSize / 1024 / 1024}MiB`
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $ekwYU.styles)(theme).preview.main(width, height),
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
            css: (0, $ekwYU.styles)(theme).preview.button,
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "change file",
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $ekwYU.styles)(theme).preview.image.main(width, height),
                children: renderPreview()
            })
        })
    });
};
$b3242d3e4f5d250c$export$b563e8c407c1ac47.propTypes = {};

});
parcelRegister("ekwYU", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $15217cfb41f3160e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $15217cfb41f3160e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $15217cfb41f3160e$var$_ref = {
    name: "18wgrk7",
    styles: "border-radius:50%"
};
var $15217cfb41f3160e$var$_ref2 = {
    name: "bpd7z7",
    styles: "margin-bottom:2px"
};
const $15217cfb41f3160e$export$9dd6ff9ea0189349 = (theme)=>({
        preview: {
            main: (width, height)=>/*#__PURE__*/ (0, $4N3Qt.css)("position:relative;width:", width, ";height:", height, ";border-radius:4px;overflow:hidden;", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:100%;cursor:pointer;", ""),
            image: {
                main: (width, height)=>/*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:", width, ";height:", height, ";background-color:", theme.colors.secondary.darker, ";overflow:hidden;", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px;", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:40px;height:40px;margin-bottom:4px;&>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    text: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";", ""),
                        formats: $15217cfb41f3160e$var$_ref2,
                        size: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                    }
                }
            },
            helpers: {
                round: $15217cfb41f3160e$var$_ref
            }
        }
    });

});


parcelRegister("fJR4x", function(module, exports) {

$parcel$export(module.exports, "ModalCardSubtitle", function () { return $066e6b7a4851976f$export$5c08126300965871; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $gfaHx = parcelRequire("gfaHx");
const $066e6b7a4851976f$export$5c08126300965871 = ({ text: text, accent: accent })=>{
    const theme = (0, $hXJcm.u)();
    // if accent provided
    if (accent) {
        const { accentStart: accentStart, accentEnd: accentEnd, onClick: onClick } = accent;
        const isLongUsername = accentEnd - accentStart > 31;
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gfaHx.styles)(theme).title.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $gfaHx.styles)(theme).title.text,
                children: [
                    text.slice(0, accentStart),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $gfaHx.styles)(theme).title.button,
                        onClick: (e)=>onClick(e),
                        type: "button",
                        "aria-label": "navigate to artist profile",
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                            css: [
                                (0, $gfaHx.styles)(theme).title.accent.main,
                                isLongUsername && (0, $gfaHx.styles)(theme).title.accent.long,
                                "",
                                ""
                            ],
                            children: text.slice(accentStart, accentEnd)
                        })
                    }),
                    text.slice(accentEnd, text.length)
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gfaHx.styles)(theme).title.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gfaHx.styles)(theme).title.text,
            children: text
        })
    });
};
$066e6b7a4851976f$export$5c08126300965871.propTypes = {};

});
parcelRegister("gfaHx", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7db2301d8cb0220a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7db2301d8cb0220a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7db2301d8cb0220a$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $7db2301d8cb0220a$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: $7db2301d8cb0220a$var$_ref,
            text: /*#__PURE__*/ (0, $4N3Qt.css)("max-width:0;font-size:", (0, $48E0n.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";max-width:500px;", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-weight:bold;text-align:start;white-space:nowrap;cursor:pointer;", ""),
            accent: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("font-weight:bold;font-size:", (0, $48E0n.typography).h6, ";text-align:center;color:", theme.colors.accent.normal, ";", ""),
                long: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});


parcelRegister("5B11A", function(module, exports) {

$parcel$export(module.exports, "ModalCardTitle", function () { return $ead26f7e07a2b7f0$export$1f5c1177562f0093; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $18WnU = parcelRequire("18WnU");
const $ead26f7e07a2b7f0$export$1f5c1177562f0093 = ({ text: text, icon: Icon })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $18WnU.styles)(theme).title.main,
        children: [
            Icon && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $18WnU.styles)(theme).title.icon,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $18WnU.styles)(theme).title.text,
                children: text
            })
        ]
    });
};
$ead26f7e07a2b7f0$export$1f5c1177562f0093.propTypes = {};

});
parcelRegister("18WnU", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ae25893b3e7809ac$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ae25893b3e7809ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ae25893b3e7809ac$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $ae25893b3e7809ac$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: $ae25893b3e7809ac$var$_ref,
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-right:10px;&>svg{width:28px;height:28px;& path{fill:", theme.colors.accent.normal, ";}}", ""),
            text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h5, ";color:", theme.colors.secondary.normal, ";", "")
        }
    });

});


parcelRegister("lFRMC", function(module, exports) {

$parcel$export(module.exports, "NavigationScrollable", function () { return $30f3c1e69c43f02f$export$476009c3d58af41b; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $1rT04 = parcelRequire("1rT04");
const $30f3c1e69c43f02f$export$476009c3d58af41b = ({ options: options })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $1rT04.styles)(theme).nav.main,
        children: options.map(({ id: id, label: label, enabled: enabled, onClick: onClick })=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1rT04.styles)(theme).nav.option.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: [
                        (0, $1rT04.styles)(theme).nav.option.button.shared,
                        enabled ? (0, $1rT04.styles)(theme).nav.option.button.enabled : (0, $1rT04.styles)(theme).nav.option.button.disabled,
                        "",
                        ""
                    ],
                    type: "button",
                    onClick: (e)=>onClick(e),
                    children: label
                })
            }, `navigation-scrollable-${id}`))
    });
};

});
parcelRegister("1rT04", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e04da86a01baa4ad$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e04da86a01baa4ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e04da86a01baa4ad$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $e04da86a01baa4ad$export$9dd6ff9ea0189349 = (theme)=>({
        nav: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";display:flex;align-items:center;width:100%;height:54px;scroll-behavior:smooth;overflow-x:scroll;overflow-y:hidden;&>div:not(:last-of-type){margin-right:20px;}", ""),
            option: {
                main: $e04da86a01baa4ad$var$_ref,
                button: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:4px 26px;width:100%;height:32px;transition:border 0.2s,color 0.2s,background-color 0.2s;", ""),
                    enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";", ""),
                    disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.secondary.light, ";background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.accent.normal, ";", "")
                }
            }
        }
    });

});


parcelRegister("i2ajo", function(module, exports) {

$parcel$export(module.exports, "Stepper", function () { return $0d7d294466672c39$export$ed8ca599049e8881; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $lGJVi = parcelRequire("lGJVi");
const $0d7d294466672c39$export$ed8ca599049e8881 = ({ steps: steps, currentStep: currentStep })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $lGJVi.styles)(theme).stepper.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lGJVi.styles)(theme).stepper.progress
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lGJVi.styles)(theme).stepper.steps.main,
                children: steps.map(({ id: id, description: description }, i)=>{
                    const checked = currentStep - 1 > i;
                    const current = currentStep - 1 === i;
                    const following = !checked && !current;
                    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $lGJVi.styles)(theme).stepper.steps.step.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                css: (0, $lGJVi.styles)(theme).stepper.steps.step.icon.main,
                                children: [
                                    checked && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: [
                                            (0, $lGJVi.styles)(theme).stepper.steps.step.icon.circle.shared,
                                            (0, $lGJVi.styles)(theme).stepper.steps.step.icon.circle.checked,
                                            "",
                                            ""
                                        ],
                                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Check, {
                                            css: (0, $lGJVi.styles)(theme).stepper.steps.step.icon.check
                                        })
                                    }),
                                    current && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: [
                                            (0, $lGJVi.styles)(theme).stepper.steps.step.icon.circle.shared,
                                            (0, $lGJVi.styles)(theme).stepper.steps.step.icon.circle.current,
                                            "",
                                            ""
                                        ]
                                    }),
                                    following && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: [
                                            (0, $lGJVi.styles)(theme).stepper.steps.step.icon.circle.shared,
                                            (0, $lGJVi.styles)(theme).stepper.steps.step.icon.circle.following,
                                            "",
                                            ""
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $lGJVi.styles)(theme).stepper.steps.step.description,
                                children: description
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
};
$0d7d294466672c39$export$ed8ca599049e8881.propTypes = {};

});
parcelRegister("lGJVi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e4b5ca218d025aa4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e4b5ca218d025aa4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e4b5ca218d025aa4$var$_ref = {
    name: "u43u09",
    styles: "max-width:78px"
};
var $e4b5ca218d025aa4$var$_ref2 = {
    name: "1ntjm1r",
    styles: "max-width:88px"
};
var $e4b5ca218d025aa4$var$_ref3 = {
    name: "68x97p",
    styles: "width:32px;height:32px"
};
var $e4b5ca218d025aa4$var$_ref4 = {
    name: "bgbjt4",
    styles: "width:36px;height:36px"
};
var $e4b5ca218d025aa4$var$_ref5 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $e4b5ca218d025aa4$var$_ref6 = {
    name: "h9ib7p",
    styles: "flex:1;display:flex;flex-direction:column;align-items:center"
};
var $e4b5ca218d025aa4$var$_ref7 = {
    name: "106ba0x",
    styles: "height:2px;top:15px"
};
var $e4b5ca218d025aa4$var$_ref8 = {
    name: "1i8qned",
    styles: "top:14px"
};
var $e4b5ca218d025aa4$var$_ref9 = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $e4b5ca218d025aa4$export$9dd6ff9ea0189349 = (theme)=>({
        stepper: {
            main: $e4b5ca218d025aa4$var$_ref9,
            progress: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.stepper.progress, ";position:absolute;top:18px;left:12%;width:76%;height:4px;background-color:", theme.colors.accent.normal, ";", (0, $48E0n.mq).tablet($e4b5ca218d025aa4$var$_ref8), " ", (0, $48E0n.mq).mobile($e4b5ca218d025aa4$var$_ref7), ";", ""),
            steps: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.stepper.circle, ";display:flex;position:relative;", ""),
                step: {
                    main: $e4b5ca218d025aa4$var$_ref6,
                    icon: {
                        main: $e4b5ca218d025aa4$var$_ref5,
                        circle: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;border:4px solid transparent;", (0, $48E0n.mq).tablet($e4b5ca218d025aa4$var$_ref4), " ", (0, $48E0n.mq).mobile($e4b5ca218d025aa4$var$_ref3), ";", ""),
                            checked: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.accent.normal, ";border:4px solid ", theme.colors.primary.normal, ";", ""),
                            current: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.accent.normal, ";border:6px solid ", theme.colors.primary.normal, ";", ""),
                            following: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.primary.normal, ";border:2px solid ", theme.colors.accent.normal, ";", "")
                        },
                        check: /*#__PURE__*/ (0, $4N3Qt.css)("width:24px;height:24px;&>path{fill:", theme.colors.primary.normal, ";}", "")
                    },
                    description: /*#__PURE__*/ (0, $4N3Qt.css)("text-align:center;word-break:break-word;max-width:98px;", (0, $48E0n.mq).tablet($e4b5ca218d025aa4$var$_ref2), " ", (0, $48E0n.mq).mobile($e4b5ca218d025aa4$var$_ref), ";", "")
                }
            }
        }
    });

});


parcelRegister("cK2N9", function(module, exports) {

$parcel$export(module.exports, "SkeletonHorizontal", function () { return $ef047203c3ec9073$export$f782bd160760d52d; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $loJXx = parcelRequire("loJXx");
const $ef047203c3ec9073$export$f782bd160760d52d = ({ sections: sections })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $loJXx.styles)(theme).skeleton.main,
        children: sections.map(({ name: name, width: width, height: height, isStatic: isStatic, isDivider: isDivider }, i)=>{
            const isOnlySection = sections.length === 1;
            const isFirstSection = i === 0 && !isOnlySection;
            const isLastSection = i === sections.length - 1 && !isOnlySection;
            const isCenterSection = !isFirstSection && !isLastSection && !isDivider;
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    isDivider && (0, $loJXx.styles)(theme).skeleton.divider(width, height, isStatic),
                    isOnlySection && (0, $loJXx.styles)(theme).skeleton.section.full(width, height, isStatic),
                    isFirstSection && (0, $loJXx.styles)(theme).skeleton.section.start(width, height, isStatic),
                    isLastSection && (0, $loJXx.styles)(theme).skeleton.section.end(width, height, isStatic),
                    isCenterSection && (0, $loJXx.styles)(theme).skeleton.section.center(width, height, isStatic),
                    "",
                    ""
                ]
            }, name);
        })
    });
};
$ef047203c3ec9073$export$f782bd160760d52d.propTypes = {};

});
parcelRegister("loJXx", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0d86e1ee4414207d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $0d86e1ee4414207d$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;width:100%;border-radius:4px;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $48E0n.kf).load.shine(-60, 0), ";", ""),
            section: {
                full: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                start: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-top-left-radius:4px;border-bottom-left-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                center: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;background-color:", theme.colors.primary.darker, ";", ""),
                end: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-top-right-radius:4px;border-bottom-right-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
            },
            divider: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";background-color:", theme.colors.primary.normal, ";", "")
        }
    });

});


parcelRegister("agnse", function(module, exports) {

$parcel$export(module.exports, "SkeletonVertical", function () { return $ee271b09143d1bbf$export$50a8a0b1864d274b; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $8nCyX = parcelRequire("8nCyX");
const $ee271b09143d1bbf$export$50a8a0b1864d274b = ({ containerWidth: containerWidth, sections: sections })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8nCyX.styles)(theme).skeleton.main(containerWidth),
        children: sections.map(({ name: name, width: width, height: height, isStatic: isStatic, isDivider: isDivider }, i)=>{
            const isOnlySection = sections.length === 1;
            const isFirstSection = i === 0 && !isOnlySection;
            const isLastSection = i === sections.length - 1 && !isOnlySection;
            const isCenterSection = !isFirstSection && !isLastSection && !isDivider;
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    isDivider && (0, $8nCyX.styles)(theme).skeleton.divider(width, height, isStatic),
                    isOnlySection && (0, $8nCyX.styles)(theme).skeleton.section.full(width, height, isStatic),
                    isFirstSection && (0, $8nCyX.styles)(theme).skeleton.section.start(width, height, isStatic),
                    isLastSection && (0, $8nCyX.styles)(theme).skeleton.section.end(width, height, isStatic),
                    isCenterSection && (0, $8nCyX.styles)(theme).skeleton.section.center(width, height, isStatic),
                    "",
                    ""
                ]
            }, name);
        })
    });
};
$ee271b09143d1bbf$export$50a8a0b1864d274b.propTypes = {};

});
parcelRegister("8nCyX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3b460b3b9b497037$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $3b460b3b9b497037$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: (width)=>/*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;align-items:center;width:", width, ";border-radius:4px;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $48E0n.kf).load.shine(-60, 0), ";", ""),
            section: {
                full: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                start: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-top-left-radius:4px;border-top-right-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                center: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;background-color:", theme.colors.primary.darker, ";", ""),
                end: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-bottom-left-radius:4px;border-bottom-right-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
            },
            divider: (width, height, isStatic)=>/*#__PURE__*/ (0, $4N3Qt.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";background-color:", theme.colors.primary.normal, ";", "")
        }
    });

});


parcelRegister("2eN72", function(module, exports) {

$parcel$export(module.exports, "Subtitle", function () { return $444c206041542ec5$export$cf345ef34cd72655; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $cQle9 = parcelRequire("cQle9");
const $444c206041542ec5$export$cf345ef34cd72655 = ({ text: text, accent: accent, link: link })=>{
    const theme = (0, $hXJcm.u)();
    const renderTitle = ()=>{
        if (accent) {
            const { accentStart: accentStart, accentEnd: accentEnd } = accent;
            return /*#__PURE__*/ (0, $5o6z6.jsxs)("h2", {
                css: (0, $cQle9.styles)(theme).title.text,
                children: [
                    text.slice(0, accentStart),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $cQle9.styles)(theme).title.accent,
                        children: text.slice(accentStart, accentEnd)
                    }),
                    text.slice(accentEnd, text.length)
                ]
            });
        }
        if (link) {
            const { linkStart: linkStart, linkEnd: linkEnd, href: href } = link;
            return /*#__PURE__*/ (0, $5o6z6.jsxs)("h2", {
                css: (0, $cQle9.styles)(theme).title.text,
                children: [
                    text.slice(0, linkStart),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("a", {
                        css: (0, $cQle9.styles)(theme).title.link,
                        href: href,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: text.slice(linkStart, linkEnd)
                    }),
                    text.slice(linkEnd, text.length)
                ]
            });
        }
        return /*#__PURE__*/ (0, $5o6z6.jsx)("h2", {
            css: (0, $cQle9.styles)(theme).title.text,
            children: text
        });
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cQle9.styles)(theme).title.main,
        children: renderTitle()
    });
};
$444c206041542ec5$export$cf345ef34cd72655.propTypes = {};

});
parcelRegister("cQle9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3154342497ec210f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3154342497ec210f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3154342497ec210f$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
const $3154342497ec210f$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: $3154342497ec210f$var$_ref,
            text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.normal, ";", ""),
            accent: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";", ""),
            link: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";text-decoration:none;transition:color 0.2s;&:hover,&:active{color:", theme.colors.accent.normalHover, ";}&:link,&:visited{}", "")
        }
    });

});



parcelRegister("8OL1B", function(module, exports) {

$parcel$export(module.exports, "ErrorFallback", function () { return (parcelRequire("ewr9k")).ErrorFallback; });
$parcel$export(module.exports, "SuspenseContentFallback", function () { return (parcelRequire("ZGlkY")).SuspenseContentFallback; });
$parcel$export(module.exports, "SuspenseMainFallback", function () { return (parcelRequire("b8aBK")).SuspenseMainFallback; });

var $ewr9k = parcelRequire("ewr9k");

var $ZGlkY = parcelRequire("ZGlkY");

var $b8aBK = parcelRequire("b8aBK");

});
parcelRegister("ewr9k", function(module, exports) {

$parcel$export(module.exports, "ErrorFallback", function () { return $604797dde1ad6761$export$8a7ad05c3ee0c78a; });

var $5o6z6 = parcelRequire("5o6z6");

var $dFWWR = parcelRequire("dFWWR");
const $604797dde1ad6761$export$8a7ad05c3ee0c78a = ()=>/*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $dFWWR.styles)().fallback.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dFWWR.styles)().fallback.title.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("h2", {
                    css: (0, $dFWWR.styles)().fallback.title.text,
                    children: "Ooops, something went wrong!"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dFWWR.styles)().fallback.buttons.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $dFWWR.styles)().fallback.buttons.button,
                    onClick: ()=>window.location.assign(window.location.origin),
                    type: "button",
                    "aria-label": "refresh page",
                    children: "Refresh"
                })
            })
        ]
    });
$604797dde1ad6761$export$8a7ad05c3ee0c78a.propTypes = {};

});
parcelRegister("dFWWR", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3fcdd43d944932b0$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3fcdd43d944932b0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3fcdd43d944932b0$var$_ref = {
    name: "7whenc",
    styles: "display:flex;width:100%"
};
var $3fcdd43d944932b0$var$_ref2 = {
    name: "14y2j0t",
    styles: "margin-bottom:46px"
};
const $3fcdd43d944932b0$export$9dd6ff9ea0189349 = ()=>{
    const theme = (0, $48E0n.getTheme)((0, $48E0n.ThemeName).Dark);
    return {
        fallback: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:100vw;min-height:100vh;background-color:", theme.colors.primary.normal, ";", ""),
            title: {
                main: $3fcdd43d944932b0$var$_ref2,
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h5, ";color:", theme.colors.secondary.normal, ";text-align:center;", "")
            },
            buttons: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($3fcdd43d944932b0$var$_ref), ";", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:8px 26px;cursor:pointer;width:100%;transition:border 0.2s,color 0.2s,background-color 0.2s;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.accent.normal, ";}", "")
            }
        }
    };
};

});


parcelRegister("ZGlkY", function(module, exports) {

$parcel$export(module.exports, "SuspenseContentFallback", function () { return $b68f241eb6395dfa$export$b2db1ccc4d1fb3bd; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("fRVt8");
var $1sbY5 = parcelRequire("1sbY5");

var $gRxzJ = parcelRequire("gRxzJ");
const $b68f241eb6395dfa$export$b2db1ccc4d1fb3bd = ({ position: position = "full" })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: [
            (0, $gRxzJ.styles)(theme).fallback.shared,
            position === "fit" && (0, $gRxzJ.styles)(theme).fallback.fit,
            position === "full" && (0, $gRxzJ.styles)(theme).fallback.full,
            "",
            ""
        ],
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
            width: 80,
            height: 40,
            appearance: "accent"
        })
    });
};
$b68f241eb6395dfa$export$b2db1ccc4d1fb3bd.propTypes = {};

});
parcelRegister("gRxzJ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $882191510afb9439$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $882191510afb9439$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $882191510afb9439$var$_ref = {
    name: "5nlari",
    styles: "min-width:100vw;min-height:100vh"
};
var $882191510afb9439$var$_ref2 = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $882191510afb9439$export$9dd6ff9ea0189349 = (theme)=>({
        fallback: {
            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:", theme.colors.primary.normal, ";", ""),
            fit: $882191510afb9439$var$_ref2,
            full: $882191510afb9439$var$_ref
        }
    });

});


parcelRegister("b8aBK", function(module, exports) {

$parcel$export(module.exports, "SuspenseMainFallback", function () { return $0275c1f933653ae0$export$fd75980ff6fb550b; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("fRVt8");
var $1sbY5 = parcelRequire("1sbY5");

var $cRczQ = parcelRequire("cRczQ");
const $0275c1f933653ae0$export$fd75980ff6fb550b = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cRczQ.styles)().fallback.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
            width: 80,
            height: 40,
            appearance: "accent"
        })
    });
$0275c1f933653ae0$export$fd75980ff6fb550b.propTypes = {};

});
parcelRegister("cRczQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $aa95f3bfbc3759de$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $aa95f3bfbc3759de$export$9dd6ff9ea0189349 = ()=>{
    const theme = (0, $48E0n.getTheme)((0, $48E0n.ThemeName).Dark);
    return {
        fallback: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:100vw;min-height:100vh;background-color:", theme.colors.primary.normal, ";", "")
        }
    };
};

});



parcelRegister("7hj6X", function(module, exports) {

$parcel$export(module.exports, "AppLayout", function () { return (parcelRequire("91dtq")).AppLayout; });
$parcel$export(module.exports, "ContentContainer", function () { return (parcelRequire("ayD7i")).ContentContainer; });
$parcel$export(module.exports, "ContentLayoutVirtualized", function () { return (parcelRequire("6KTJf")).ContentLayoutVirtualized; });
$parcel$export(module.exports, "MainLayout", function () { return (parcelRequire("kR3Jw")).MainLayout; });
$parcel$export(module.exports, "ModalLayout", function () { return (parcelRequire("jCNqW")).ModalLayout; });
$parcel$export(module.exports, "SectionsLayout", function () { return (parcelRequire("8tjTN")).SectionsLayout; });

var $91dtq = parcelRequire("91dtq");

var $ayD7i = parcelRequire("ayD7i");

var $6KTJf = parcelRequire("6KTJf");

var $kR3Jw = parcelRequire("kR3Jw");

var $jCNqW = parcelRequire("jCNqW");

var $8tjTN = parcelRequire("8tjTN");

});
parcelRegister("91dtq", function(module, exports) {

$parcel$export(module.exports, "AppLayout", function () { return $9fd8c650341c2c5e$export$e034111dc0cfe9e7; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $737dB = parcelRequire("737dB");
var $8Jr1i = parcelRequire("8Jr1i");
var $gMvxt = parcelRequire("gMvxt");
var $4Nzlb = parcelRequire("4Nzlb");
var $8f3t2 = parcelRequire("8f3t2");
parcelRequire("fRVt8");
var $ewnuH = parcelRequire("ewnuH");

var $4lAFe = parcelRequire("4lAFe");
const $9fd8c650341c2c5e$export$e034111dc0cfe9e7 = ({ children: children })=>{
    const { pathname: pathname } = (0, $fbE6a.useLocation)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const isLibraryPage = pathname === (0, $9YTSb.Path).Library;
    const isUserLoggedIn = !!profile;
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $4lAFe.styles)().layout.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $4lAFe.styles)().layout.navigation,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $737dB.NavigationApp), {}),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8Jr1i.NavigationAppMobile), {})
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $4lAFe.styles)().layout.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4lAFe.styles)().layout.content.header.app,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ewnuH.AppHeader), {})
                    }),
                    isLibraryPage && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4lAFe.styles)().layout.content.header.library,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gMvxt.NavigationLibrary), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4lAFe.styles)().layout.content.panel.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("main", {
                            css: (0, $4lAFe.styles)().layout.content.panel.view,
                            children: children
                        })
                    }),
                    isUserLoggedIn && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4lAFe.styles)().layout.content.player,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4Nzlb.PlayerAudio), {})
                    }),
                    isUserLoggedIn && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4lAFe.styles)().layout.content.playlist,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8f3t2.PlayerAudioPlaylist), {})
                    })
                ]
            })
        ]
    });
};
$9fd8c650341c2c5e$export$e034111dc0cfe9e7.propTypes = {};

});
parcelRegister("3QeX2", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("fbE6a")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("fbE6a")).useNavigate; });
/**
 * React Router DOM v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $hUt2Z = parcelRequire("hUt2Z");
var $fbE6a = parcelRequire("fbE6a");

var $hUt2Z = parcelRequire("hUt2Z");
function $2cc1d3688dd37f6f$var$_extends() {
    $2cc1d3688dd37f6f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2cc1d3688dd37f6f$var$_extends.apply(this, arguments);
}
function $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $2cc1d3688dd37f6f$var$defaultMethod = "get";
const $2cc1d3688dd37f6f$var$defaultEncType = "application/x-www-form-urlencoded";
function $2cc1d3688dd37f6f$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $2cc1d3688dd37f6f$var$isButtonElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $2cc1d3688dd37f6f$var$isFormElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $2cc1d3688dd37f6f$var$isInputElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $2cc1d3688dd37f6f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$2cc1d3688dd37f6f$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $2cc1d3688dd37f6f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = null;
function $2cc1d3688dd37f6f$var$isFormDataSubmitterSupported() {
    if ($2cc1d3688dd37f6f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = true;
    }
    return $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter;
}
const $2cc1d3688dd37f6f$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $2cc1d3688dd37f6f$var$getFormEncType(encType) {
    if (encType != null && !$2cc1d3688dd37f6f$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($2cc1d3688dd37f6f$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $hUt2Z.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($2cc1d3688dd37f6f$var$isButtonElement(target) || $2cc1d3688dd37f6f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $hUt2Z.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("formenctype")) || $2cc1d3688dd37f6f$var$getFormEncType(form.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$2cc1d3688dd37f6f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($2cc1d3688dd37f6f$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $2cc1d3688dd37f6f$var$defaultMethod;
        action = null;
        encType = $2cc1d3688dd37f6f$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $2cc1d3688dd37f6f$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $2cc1d3688dd37f6f$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $2cc1d3688dd37f6f$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $2cc1d3688dd37f6f$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $2cc1d3688dd37f6f$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $2cc1d3688dd37f6f$export$1f3f55432a00e06d(routes, opts) {
    return (0, $hUt2Z.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hUt2Z.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $fbE6a.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2cc1d3688dd37f6f$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $hUt2Z.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $hUt2Z.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $fbE6a.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2cc1d3688dd37f6f$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $2cc1d3688dd37f6f$var$_extends({}, state, {
        errors: $2cc1d3688dd37f6f$var$deserializeErrors(state.errors)
    });
    return state;
}
function $2cc1d3688dd37f6f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $hUt2Z.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $2cc1d3688dd37f6f$export$7ad602f0e94e62d1 = /*#__PURE__*/ $exYeM.createContext({
    isTransitioning: false
});
const $2cc1d3688dd37f6f$export$148fd98d095596d4 = /*#__PURE__*/ $exYeM.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2cc1d3688dd37f6f$var$START_TRANSITION = "startTransition";
const $2cc1d3688dd37f6f$var$startTransitionImpl = $exYeM[$2cc1d3688dd37f6f$var$START_TRANSITION];
const $2cc1d3688dd37f6f$var$FLUSH_SYNC = "flushSync";
const $2cc1d3688dd37f6f$var$flushSyncImpl = $d2lNW[$2cc1d3688dd37f6f$var$FLUSH_SYNC];
const $2cc1d3688dd37f6f$var$USE_ID = "useId";
const $2cc1d3688dd37f6f$var$useIdImpl = $exYeM[$2cc1d3688dd37f6f$var$USE_ID];
function $2cc1d3688dd37f6f$var$startTransitionSafe(cb) {
    if ($2cc1d3688dd37f6f$var$startTransitionImpl) $2cc1d3688dd37f6f$var$startTransitionImpl(cb);
    else cb();
}
function $2cc1d3688dd37f6f$var$flushSyncSafe(cb) {
    if ($2cc1d3688dd37f6f$var$flushSyncImpl) $2cc1d3688dd37f6f$var$flushSyncImpl(cb);
    else cb();
}
class $2cc1d3688dd37f6f$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2cc1d3688dd37f6f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let [pendingState, setPendingState] = $exYeM.useState();
    let [vtContext, setVtContext] = $exYeM.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $exYeM.useState();
    let [transition, setTransition] = $exYeM.useState();
    let [interruption, setInterruption] = $exYeM.useState();
    let fetcherData = $exYeM.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $exYeM.useCallback((cb)=>{
        if (v7_startTransition) $2cc1d3688dd37f6f$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $exYeM.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $2cc1d3688dd37f6f$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $2cc1d3688dd37f6f$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $exYeM.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $2cc1d3688dd37f6f$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $exYeM.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $exYeM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $exYeM.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement((0, $fbE6a.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement((0, $fbE6a.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $exYeM.createElement((0, $fbE6a.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $2cc1d3688dd37f6f$var$MemoizedDataRoutes = /*#__PURE__*/ $exYeM.memo($2cc1d3688dd37f6f$var$DataRoutes);
function $2cc1d3688dd37f6f$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $fbE6a.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hUt2Z.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $fbE6a.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $2cc1d3688dd37f6f$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $hUt2Z.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $fbE6a.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $2cc1d3688dd37f6f$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $fbE6a.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $2cc1d3688dd37f6f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a = /*#__PURE__*/ $exYeM.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref7, $2cc1d3688dd37f6f$var$_excluded);
    let { basename: basename } = $exYeM.useContext((0, $fbE6a.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($2cc1d3688dd37f6f$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $hUt2Z.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $fbE6a.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $2cc1d3688dd37f6f$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $exYeM.createElement("a", $2cc1d3688dd37f6f$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d = /*#__PURE__*/ $exYeM.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref8, $2cc1d3688dd37f6f$var$_excluded2);
    let path = (0, $fbE6a.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $fbE6a.useLocation)();
    let routerState = $exYeM.useContext((0, $fbE6a.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $exYeM.useContext((0, $fbE6a.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2cc1d3688dd37f6f$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $hUt2Z.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a6c7ac8248d6e38a, $2cc1d3688dd37f6f$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $2cc1d3688dd37f6f$export$a7fed597f4b8afd8 = /*#__PURE__*/ $exYeM.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $2cc1d3688dd37f6f$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref9, $2cc1d3688dd37f6f$var$_excluded3);
    let submit = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    let formAction = $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $exYeM.createElement("form", $2cc1d3688dd37f6f$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $2cc1d3688dd37f6f$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $2cc1d3688dd37f6f$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $2cc1d3688dd37f6f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($2cc1d3688dd37f6f$var$DataRouterHook || ($2cc1d3688dd37f6f$var$DataRouterHook = {}));
var $2cc1d3688dd37f6f$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($2cc1d3688dd37f6f$var$DataRouterStateHook || ($2cc1d3688dd37f6f$var$DataRouterStateHook = {}));
// Internal hooks
function $2cc1d3688dd37f6f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2cc1d3688dd37f6f$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext((0, $fbE6a.UNSAFE_DataRouterContext));
    !ctx && (0, $hUt2Z.UNSAFE_invariant)(false);
    return ctx;
}
function $2cc1d3688dd37f6f$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext((0, $fbE6a.UNSAFE_DataRouterStateContext));
    !state && (0, $hUt2Z.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $2cc1d3688dd37f6f$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $fbE6a.useNavigate)();
    let location = (0, $fbE6a.useLocation)();
    let path = (0, $fbE6a.useResolvedPath)(to, {
        relative: relative
    });
    return $exYeM.useCallback((event)=>{
        if ($2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $hUt2Z.createPath)(location) === (0, $hUt2Z.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $2cc1d3688dd37f6f$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $exYeM.useRef($2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $exYeM.useRef(false);
    let location = (0, $fbE6a.useLocation)();
    let searchParams = $exYeM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $2cc1d3688dd37f6f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $fbE6a.useNavigate)();
    let setSearchParams = $exYeM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $2cc1d3688dd37f6f$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $2cc1d3688dd37f6f$var$fetcherId = 0;
let $2cc1d3688dd37f6f$var$getUniqueFetcherId = ()=>"__" + String(++$2cc1d3688dd37f6f$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $2cc1d3688dd37f6f$export$47c85c6e3a081d3() {
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $exYeM.useContext((0, $fbE6a.UNSAFE_NavigationContext));
    let currentRouteId = (0, $fbE6a.UNSAFE_useRouteId)();
    return $exYeM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2cc1d3688dd37f6f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $2cc1d3688dd37f6f$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $exYeM.useContext((0, $fbE6a.UNSAFE_NavigationContext));
    let routeContext = $exYeM.useContext((0, $fbE6a.UNSAFE_RouteContext));
    !routeContext && (0, $hUt2Z.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $2cc1d3688dd37f6f$var$_extends({}, (0, $fbE6a.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $fbE6a.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $hUt2Z.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $hUt2Z.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $2cc1d3688dd37f6f$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseFetcher);
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $exYeM.useContext($2cc1d3688dd37f6f$export$148fd98d095596d4);
    let route = $exYeM.useContext((0, $fbE6a.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $hUt2Z.UNSAFE_invariant)(false);
    !route && (0, $hUt2Z.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $hUt2Z.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $2cc1d3688dd37f6f$var$useIdImpl ? $2cc1d3688dd37f6f$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $exYeM.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($2cc1d3688dd37f6f$var$getUniqueFetcherId());
    // Registration/cleanup
    $exYeM.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $exYeM.useCallback((href, opts)=>{
        !routeId && (0, $hUt2Z.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    let submit = $exYeM.useCallback((target, opts)=>{
        submitImpl(target, $2cc1d3688dd37f6f$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $exYeM.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a7fed597f4b8afd8, $2cc1d3688dd37f6f$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $hUt2Z.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $exYeM.useMemo(()=>$2cc1d3688dd37f6f$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $2cc1d3688dd37f6f$export$fa996778a3a31087() {
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $2cc1d3688dd37f6f$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $2cc1d3688dd37f6f$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $2cc1d3688dd37f6f$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $exYeM.useContext((0, $fbE6a.UNSAFE_NavigationContext));
    let location = (0, $fbE6a.useLocation)();
    let matches = (0, $fbE6a.useMatches)();
    let navigation = (0, $fbE6a.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $exYeM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $2cc1d3688dd37f6f$var$usePageHide($exYeM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $2cc1d3688dd37f6f$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($2cc1d3688dd37f6f$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $2cc1d3688dd37f6f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($2cc1d3688dd37f6f$var$_extends({}, location, {
                    pathname: (0, $hUt2Z.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($2cc1d3688dd37f6f$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $2cc1d3688dd37f6f$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $fbE6a.useBlocker)(when);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $2cc1d3688dd37f6f$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $exYeM.useContext($2cc1d3688dd37f6f$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $hUt2Z.UNSAFE_invariant)(false);
    let { basename: basename } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.useViewTransitionState);
    let path = (0, $fbE6a.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $hUt2Z.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $hUt2Z.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $hUt2Z.matchPath)(path.pathname, nextPath) != null || (0, $hUt2Z.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("d2lNW", function(module, exports) {
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("h8vP0"));

});


parcelRegister("4lAFe", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6cd463a0865efd65$export$9dd6ff9ea0189349; });
function $6cd463a0865efd65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6cd463a0865efd65$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6cd463a0865efd65$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6cd463a0865efd65$var$_ref3 = {
    name: "36bnqj",
    styles: "display:flex;flex:1"
};
var $6cd463a0865efd65$var$_ref4 = {
    name: "i02vwc",
    styles: "display:flex;flex:1;width:100%"
};
var $6cd463a0865efd65$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6cd463a0865efd65$var$_ref6 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6cd463a0865efd65$var$_ref7 = {
    name: "170x82z",
    styles: "display:flex;flex-direction:column;flex:1;width:100%"
};
var $6cd463a0865efd65$var$_ref8 = {
    name: "zjik7",
    styles: "display:flex"
};
var $6cd463a0865efd65$var$_ref9 = {
    name: "nizj86",
    styles: "display:flex;min-height:100vh"
};
const $6cd463a0865efd65$export$9dd6ff9ea0189349 = ()=>({
        layout: {
            main: $6cd463a0865efd65$var$_ref9,
            navigation: $6cd463a0865efd65$var$_ref8,
            content: {
                main: $6cd463a0865efd65$var$_ref7,
                header: {
                    app: $6cd463a0865efd65$var$_ref6,
                    library: $6cd463a0865efd65$var$_ref5
                },
                panel: {
                    main: $6cd463a0865efd65$var$_ref4,
                    view: $6cd463a0865efd65$var$_ref3
                },
                player: $6cd463a0865efd65$var$_ref2,
                playlist: $6cd463a0865efd65$var$_ref
            }
        }
    });

});


parcelRegister("ayD7i", function(module, exports) {

$parcel$export(module.exports, "ContentContainer", function () { return $dd3eb04198fed9af$export$9d2b4227a95687cc; });

var $5o6z6 = parcelRequire("5o6z6");

var $4N3Qt = parcelRequire("4N3Qt");

var $ltZoW = parcelRequire("ltZoW");
const $dd3eb04198fed9af$export$9d2b4227a95687cc = ({ children: children, overrideCss: overrideCss = {
    main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
} })=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: [
            (0, $ltZoW.styles)().container.main,
            overrideCss?.main,
            "",
            ""
        ],
        children: children
    });
$dd3eb04198fed9af$export$9d2b4227a95687cc.propTypes = {};

});
parcelRegister("ltZoW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8b509108095fc4f9$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $8b509108095fc4f9$export$9dd6ff9ea0189349 = ()=>({
        container: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";width:100%;overflow-y:scroll;", "")
        }
    });

});


parcelRegister("6KTJf", function(module, exports) {

$parcel$export(module.exports, "ContentLayoutVirtualized", function () { return $447f1e4e58818cdc$export$8d3fc14510f0efc9; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $4N3Qt = parcelRequire("4N3Qt");
var $hXJcm = parcelRequire("hXJcm");

var $bisEj = parcelRequire("bisEj");
parcelRequire("5IIxL");
var $9vwUk = parcelRequire("9vwUk");

var $5hLk8 = parcelRequire("5hLk8");

var $fn2yg = parcelRequire("fn2yg");
const $447f1e4e58818cdc$export$8d3fc14510f0efc9 = ({ title: title, icon: Icon, children: children, itemWidth: itemWidth, itemsCount: itemsCount, overrideCss: overrideCss = {
    main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
    header: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        title: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            text: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    },
    navigation: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
        icon: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
    },
    content: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
    },
    container: {
        main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
    }
} })=>{
    const theme = (0, $hXJcm.u)();
    // content navigation
    const [backwardDisabled, setBackwardDisabled] = (0, $exYeM.useState)(true);
    const [forwardDisabled, setForwardDisabled] = (0, $exYeM.useState)(true);
    const containerRef = (0, $exYeM.useRef)(null);
    // configure initial navigation state
    (0, $exYeM.useEffect)(()=>{
        // if items count is 0
        if (itemsCount === 0) {
            // disable backward and forward scrolls
            setBackwardDisabled(true);
            setForwardDisabled(true);
            return;
        }
        // if list node found
        if (containerRef.current?.children.length) {
            // get list node
            const listNode = containerRef.current.children[0];
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = listNode;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (scrollLeft <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (scrollLeft >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    }, [
        itemsCount
    ]);
    // handleBackwardClick - handles content navigation backward click
    const handleBackwardClick = ()=>{
        // if list node found
        if (containerRef.current?.children.length) {
            // get list node
            const listNode = containerRef.current.children[0];
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = listNode;
            // calculate next scroll offset
            const offset = Math.floor(clientWidth / itemWidth) * itemWidth;
            // scroll for exactly n visible items
            listNode.scrollBy(-offset, 0);
            const nextScrollPosition = scrollLeft - offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    // handleForwardClick - handles content navigation forward click
    const handleForwardClick = ()=>{
        // if list node found
        if (containerRef.current?.children.length) {
            // get list node
            const listNode = containerRef.current.children[0];
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = listNode;
            // calculate next scroll offset
            const offset = Math.floor(clientWidth / itemWidth) * itemWidth;
            // scroll for exactly n visible items
            listNode.scrollBy(offset, 0);
            const nextScrollPosition = scrollLeft + offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: [
            (0, $fn2yg.styles)(theme).layout.main,
            overrideCss?.main,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: [
                    (0, $fn2yg.styles)(theme).layout.header.main,
                    overrideCss?.header.main,
                    "",
                    ""
                ],
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: [
                            [
                                (0, $fn2yg.styles)(theme).layout.header.title.main,
                                overrideCss?.header.title.main
                            ],
                            "",
                            ""
                        ],
                        children: [
                            Icon && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: [
                                    (0, $fn2yg.styles)(theme).layout.header.title.icon,
                                    overrideCss?.header.title.icon,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: [
                                    (0, $fn2yg.styles)(theme).layout.header.title.text,
                                    overrideCss?.header.title.text,
                                    "",
                                    ""
                                ],
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: [
                            (0, $fn2yg.styles)(theme).layout.header.navigation.main,
                            overrideCss?.navigation.main,
                            "",
                            ""
                        ],
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9vwUk.NavigationButton), {
                                css: [
                                    (0, $fn2yg.styles)(theme).layout.header.navigation.button,
                                    overrideCss?.navigation.button,
                                    "",
                                    ""
                                ],
                                onClick: ()=>handleBackwardClick(),
                                disabled: backwardDisabled,
                                "aria-label": "navigate backward",
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5hLk8.icons).ArrowLeft, {
                                    css: [
                                        (0, $fn2yg.styles)(theme).layout.header.navigation.icon,
                                        overrideCss?.navigation.icon,
                                        "",
                                        ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9vwUk.NavigationButton), {
                                css: [
                                    (0, $fn2yg.styles)(theme).layout.header.navigation.button,
                                    overrideCss?.navigation.button,
                                    "",
                                    ""
                                ],
                                onClick: ()=>handleForwardClick(),
                                disabled: forwardDisabled,
                                "aria-label": "navigate forward",
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5hLk8.icons).ArrowRight, {
                                    css: [
                                        (0, $fn2yg.styles)(theme).layout.header.navigation.icon,
                                        overrideCss?.navigation.icon,
                                        "",
                                        ""
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $fn2yg.styles)(theme).layout.content.main,
                    overrideCss?.content.main,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: [
                        (0, $fn2yg.styles)(theme).layout.content.container.main,
                        overrideCss?.container.main,
                        "",
                        ""
                    ],
                    ref: containerRef,
                    children: children
                })
            })
        ]
    });
};
$447f1e4e58818cdc$export$8d3fc14510f0efc9.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired
};

});
parcelRegister("bisEj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839799496b62fb71$var$ReactIs, $839799496b62fb71$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jpdgm"))();

});
parcelRegister("jpdgm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $L7tyD = parcelRequire("L7tyD");
function $e20aa3d84dea372f$var$emptyFunction() {}
function $e20aa3d84dea372f$var$emptyFunctionWithReset() {}
$e20aa3d84dea372f$var$emptyFunctionWithReset.resetWarningCache = $e20aa3d84dea372f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $L7tyD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e20aa3d84dea372f$var$emptyFunctionWithReset,
        resetWarningCache: $e20aa3d84dea372f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("L7tyD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $08da306d15728f79$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $08da306d15728f79$var$ReactPropTypesSecret;

});



parcelRegister("5IIxL", function(module, exports) {

$parcel$export(module.exports, "NavigationButton", function () { return (parcelRequire("9vwUk")).NavigationButton; });

var $9vwUk = parcelRequire("9vwUk");

});
parcelRegister("9vwUk", function(module, exports) {

$parcel$export(module.exports, "NavigationButton", function () { return $03ecc6dfb9225f33$export$e2d1bd910e689283; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $jCHBS = parcelRequire("jCHBS");
const $03ecc6dfb9225f33$export$e2d1bd910e689283 = ({ children: children, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
        css: [
            (0, $jCHBS.styles)(theme).button.shared,
            attributes.disabled ? (0, $jCHBS.styles)(theme).button.disabled : (0, $jCHBS.styles)(theme).button.enabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: children
    });
};

});
parcelRegister("jCHBS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6eac686f65b68813$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $6eac686f65b68813$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;&>svg>path{transition:fill 0.2s;}", ""),
            enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;&:hover>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}", "")
        }
    });

});



parcelRegister("5hLk8", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $c2ee8cf049e06aeb$export$df03f54e09e486fa; });

var $iORgF = parcelRequire("iORgF");

var $bNaNE = parcelRequire("bNaNE");
const $c2ee8cf049e06aeb$export$df03f54e09e486fa = {
    ArrowLeft: $iORgF.default,
    ArrowRight: $bNaNE.default
};

});
parcelRegister("iORgF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c84620d9a3ba03$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $01c84620d9a3ba03$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2.133c-5.45 0-9.867 4.418-9.867 9.867 0 5.45 4.418 9.867 9.867 9.867 5.45 0 9.867-4.418 9.867-9.867 0-5.45-4.418-9.867-9.867-9.867ZM.533 12C.533 5.667 5.667.533 12 .533S23.467 5.667 23.467 12 18.333 23.467 12 23.467.533 18.333.533 12Zm13.633-3.766a.8.8 0 0 1 0 1.132L11.53 12l2.635 2.634a.8.8 0 0 1-1.132 1.132l-3.2-3.2a.8.8 0 0 1 0-1.132l3.2-3.2a.8.8 0 0 1 1.132 0Z",
            fill: "#FFF"
        })
    });
var $01c84620d9a3ba03$export$2e2bcd8739ae039 = $01c84620d9a3ba03$var$SvgArrowLeft;

});

parcelRegister("bNaNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1150b347100e48a$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $f1150b347100e48a$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2.133c-5.45 0-9.867 4.418-9.867 9.867 0 5.45 4.418 9.867 9.867 9.867 5.45 0 9.867-4.418 9.867-9.867 0-5.45-4.418-9.867-9.867-9.867ZM.533 12C.533 5.667 5.667.533 12 .533S23.467 5.667 23.467 12 18.333 23.467 12 23.467.533 18.333.533 12Zm9.301-3.766a.8.8 0 0 1 1.132 0l3.2 3.2a.8.8 0 0 1 0 1.132l-3.2 3.2a.8.8 0 0 1-1.132-1.132L12.47 12 9.834 9.366a.8.8 0 0 1 0-1.132Z",
            fill: "#FFF"
        })
    });
var $f1150b347100e48a$export$2e2bcd8739ae039 = $f1150b347100e48a$var$SvgArrowRight;

});


parcelRegister("fn2yg", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e346a8389541e082$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e346a8389541e082$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e346a8389541e082$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $e346a8389541e082$var$_ref2 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $e346a8389541e082$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $e346a8389541e082$var$_ref4 = {
    name: "1exrrsa",
    styles: "display:flex;margin-right:8px;&>svg{width:18px;height:18px;}"
};
var $e346a8389541e082$var$_ref5 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $e346a8389541e082$var$_ref6 = {
    name: "v4gdnl",
    styles: "padding-right:0px"
};
var $e346a8389541e082$var$_ref7 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
const $e346a8389541e082$export$9dd6ff9ea0189349 = (theme)=>({
        layout: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.content, ";margin-bottom:60px;", (0, $48E0n.mq).mobile($e346a8389541e082$var$_ref7), ";", ""),
            header: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:space-between;margin-bottom:24px;", (0, $48E0n.mq).mobile($e346a8389541e082$var$_ref6), ";", ""),
                title: {
                    main: $e346a8389541e082$var$_ref5,
                    text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";font-weight:bold;color:", theme.colors.secondary.light, ";", ""),
                    icon: $e346a8389541e082$var$_ref4
                },
                navigation: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>button:nth-of-type(1){margin-right:28px;}", (0, $48E0n.mq).mobile($e346a8389541e082$var$_ref3), ";", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    icon: $e346a8389541e082$var$_ref2
                }
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.content, ";", ""),
                container: {
                    main: $e346a8389541e082$var$_ref
                }
            }
        }
    });

});


parcelRegister("kR3Jw", function(module, exports) {

$parcel$export(module.exports, "MainLayout", function () { return $058509e0dd533634$export$93af822566053b3e; });

var $5o6z6 = parcelRequire("5o6z6");

var $jdzZ4 = parcelRequire("jdzZ4");
const $058509e0dd533634$export$93af822566053b3e = ({ children: children })=>/*#__PURE__*/ (0, $5o6z6.jsx)("main", {
        css: (0, $jdzZ4.styles)().layout.main,
        children: children
    });
$058509e0dd533634$export$93af822566053b3e.propTypes = {};

});
parcelRegister("jdzZ4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a8badc2aa75e93d5$export$9dd6ff9ea0189349; });
function $a8badc2aa75e93d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a8badc2aa75e93d5$var$_ref = {
    name: "nizj86",
    styles: "display:flex;min-height:100vh"
};
const $a8badc2aa75e93d5$export$9dd6ff9ea0189349 = ()=>({
        layout: {
            main: $a8badc2aa75e93d5$var$_ref
        }
    });

});


parcelRegister("jCNqW", function(module, exports) {

$parcel$export(module.exports, "ModalLayout", function () { return $4f0a9c08cb6d6614$export$84cbdf36c27e9fa7; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $2Zpii = parcelRequire("2Zpii");
const $4f0a9c08cb6d6614$export$84cbdf36c27e9fa7 = ({ background: background = "solid", children: children, onOutsideClick: onOutsideClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: [
            (0, $2Zpii.styles)(theme).modal.main,
            background === "solid" && (0, $2Zpii.styles)(theme).modal.solid,
            background === "opaque" && (0, $2Zpii.styles)(theme).modal.opaque,
            "",
            ""
        ],
        onClick: (e)=>onOutsideClick(e),
        "aria-hidden": "true",
        children: children
    });
};
$4f0a9c08cb6d6614$export$84cbdf36c27e9fa7.propTypes = {};

});
parcelRegister("2Zpii", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $552f9811a832e598$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $552f9811a832e598$export$9dd6ff9ea0189349 = (theme)=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";z-index:", (0, $48E0n.z).app.modal, ";display:flex;flex-direction:column;overflow:hidden;overflow-y:scroll;display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;", ""),
            solid: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.primary.normal, ";", ""),
            opaque: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.primary.normal, "E4;", "")
        }
    });

});


parcelRegister("8tjTN", function(module, exports) {

$parcel$export(module.exports, "SectionsLayout", function () { return $04cdcf219e9d12b2$export$33795262da82cdf8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("7dFt5");
var $7jgQR = parcelRequire("7jgQR");

var $f0PpL = parcelRequire("f0PpL");
const $04cdcf219e9d12b2$export$33795262da82cdf8 = ({ sections: sections })=>{
    const [currentSectionIndex, setCurrentSectionIndex] = (0, $exYeM.useState)(0);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $f0PpL.styles)().sections.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f0PpL.styles)().sections.nav.main,
                children: sections.map(({ id: id, name: name }, idx)=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $f0PpL.styles)().sections.nav.item,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7jgQR.Button), {
                            type: "button",
                            "aria-label": `select ${name}`,
                            active: currentSectionIndex === idx,
                            onClick: ()=>setCurrentSectionIndex(idx),
                            children: name
                        })
                    }, `section-layout-item-${id}`))
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f0PpL.styles)().sections.content,
                children: sections[currentSectionIndex].section
            })
        ]
    });
};
$04cdcf219e9d12b2$export$33795262da82cdf8.propTypes = {};

});
parcelRegister("7dFt5", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return (parcelRequire("7jgQR")).Button; });

var $7jgQR = parcelRequire("7jgQR");

});
parcelRegister("7jgQR", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $fdb309dfca44dcc7$export$353f5b6fc5456de1; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $5yfiO = parcelRequire("5yfiO");
const $fdb309dfca44dcc7$export$353f5b6fc5456de1 = ({ children: children, active: active, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
        css: [
            (0, $5yfiO.styles)(theme).button.main,
            active ? (0, $5yfiO.styles)(theme).button.active : (0, $5yfiO.styles)(theme).button.inactive,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $5yfiO.styles)(theme).button.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5yfiO.styles)(theme).button.content.children,
                children: children
            })
        })
    });
};
$fdb309dfca44dcc7$export$353f5b6fc5456de1.propTypes = {};

});
parcelRegister("5yfiO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $cad0523321e762e1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $cad0523321e762e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cad0523321e762e1$var$_ref = {
    name: "16lvhbt",
    styles: "display:flex;justify-content:center;width:100%;min-width:0"
};
const $cad0523321e762e1$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;white-space:nowrap;cursor:pointer;overflow:hidden;transition:color 0.2s;min-width:0;height:44px;width:100%;", ""),
            active: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";border-bottom:2px solid ", theme.colors.accent.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
            inactive: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.dark, ";border-bottom:2px solid transparent;&:hover{color:", theme.colors.accent.normal, ";}", ""),
            content: {
                main: $cad0523321e762e1$var$_ref,
                children: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});



parcelRegister("f0PpL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c0b2ae07c660874c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c0b2ae07c660874c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c0b2ae07c660874c$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $c0b2ae07c660874c$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $c0b2ae07c660874c$var$_ref3 = {
    name: "7a6dt5",
    styles: "margin:50px 0px"
};
const $c0b2ae07c660874c$export$9dd6ff9ea0189349 = ()=>({
        sections: {
            main: $c0b2ae07c660874c$var$_ref3,
            nav: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-bottom:50px;&>div{", (0, $48E0n.mq).mobile($c0b2ae07c660874c$var$_ref2), ";}&>div:not(:last-of-type){margin-right:32px;}", ""),
                item: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:400px;", (0, $48E0n.mq).tablet($c0b2ae07c660874c$var$_ref), ";", "")
            }
        }
    });

});



parcelRegister("7fi9y", function(module, exports) {

$parcel$export(module.exports, "AppHeader", function () { return (parcelRequire("ewnuH")).AppHeader; });
$parcel$export(module.exports, "CardHeaderMobile", function () { return (parcelRequire("2Ww3e")).CardHeaderMobile; });
$parcel$export(module.exports, "ImageComposition", function () { return (parcelRequire("jQTWV")).ImageComposition; });

var $ewnuH = parcelRequire("ewnuH");

var $2Ww3e = parcelRequire("2Ww3e");

var $jQTWV = parcelRequire("jQTWV");

});
parcelRegister("ewnuH", function(module, exports) {

$parcel$export(module.exports, "AppHeader", function () { return $beff15632fe38fe5$export$9bd256435c34a030; });
// import { FC, useState } from 'react'

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $11Nfd = parcelRequire("11Nfd");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
var $gLoh3 = parcelRequire("gLoh3");
parcelRequire("fRVt8");
var $f7BhD = parcelRequire("f7BhD");
parcelRequire("9T1bV");
var $irRzD = parcelRequire("irRzD");
var $765P1 = parcelRequire("765P1");

var $04Fel = parcelRequire("04Fel");
const $beff15632fe38fe5$export$9bd256435c34a030 = ()=>{
    const theme = (0, $hXJcm.u)();
    const { pathname: pathname } = (0, $fbE6a.useLocation)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const isNavigationOpen = (0, $9CcOD.useAppSelector)((0, $11Nfd.navigationSelectAppNavigationOpen));
    // TODO: consider to make search global or local
    // const searchTerm = useAppSelector(searchSelectTerm)
    // const [searchTerm, setSearchTerm] = useState('')
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("header", {
        css: (0, $04Fel.styles)(theme).header.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $04Fel.styles)(theme).header.logo,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gLoh3.logos).RyddmLogo, {})
            }),
            pathname === (0, $9YTSb.Path).Library || pathname === (0, $9YTSb.Path).Charts ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $04Fel.styles)(theme).header.search
            }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {}),
            profile ? /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $04Fel.styles)(theme).header.actions.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $04Fel.styles)(theme).header.actions.notifications,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $irRzD.Notifications), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $04Fel.styles)(theme).header.actions.avatar,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $765P1.UserMenu), {})
                    })
                ]
            }) : /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $04Fel.styles)(theme).header.buttons,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                            "aria-label": "sign up",
                            appearance: "secondary",
                            onClick: ()=>dispatch((0, $fAzHC.authOpenSignupModal)()),
                            children: "Sign up"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                            "aria-label": "log in",
                            appearance: "primary",
                            onClick: ()=>dispatch((0, $fAzHC.authOpenLoginModal)()),
                            children: "Log in"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $04Fel.styles)(theme).header.menu.main,
                children: [
                    profile && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $04Fel.styles)(theme).header.menu.notifications,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $irRzD.Notifications), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $04Fel.styles)(theme).header.menu.actions.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $04Fel.styles)(theme).header.menu.actions.button,
                            onClick: ()=>dispatch((0, $11Nfd.navigationAppNavigationToggle)()),
                            type: "button",
                            "aria-label": "toggle navigation menu",
                            children: isNavigationOpen ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CrossCircle, {
                                css: [
                                    (0, $04Fel.styles)(theme).header.menu.actions.icon.shared,
                                    (0, $04Fel.styles)(theme).header.menu.actions.icon.close,
                                    "",
                                    ""
                                ]
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MenuLines, {
                                css: [
                                    (0, $04Fel.styles)(theme).header.menu.actions.icon.shared,
                                    (0, $04Fel.styles)(theme).header.menu.actions.icon.open,
                                    "",
                                    ""
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$beff15632fe38fe5$export$9bd256435c34a030.propTypes = {};

});
parcelRegister("9T1bV", function(module, exports) {

$parcel$export(module.exports, "Notifications", function () { return (parcelRequire("irRzD")).Notifications; });
$parcel$export(module.exports, "UserMenu", function () { return (parcelRequire("765P1")).UserMenu; });

var $irRzD = parcelRequire("irRzD");

var $4aOcN = parcelRequire("4aOcN");

var $765P1 = parcelRequire("765P1");

});
parcelRegister("irRzD", function(module, exports) {

$parcel$export(module.exports, "Notifications", function () { return $4617d96c52374308$export$36ba2f559d49a8f6; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $86QaR = parcelRequire("86QaR");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
parcelRequire("dmGpj");
var $uiU92 = parcelRequire("uiU92");
var $6VkZt = parcelRequire("6VkZt");

var $8nelw = parcelRequire("8nelw");
const $4617d96c52374308$export$36ba2f559d49a8f6 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const { pathname: pathname } = (0, $fbE6a.useLocation)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const notificationsUnreadCount = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationsUnreadCount));
    (0, $86QaR.useInterval)(()=>{
        // refetch unread notifications count every 10 seconds
        dispatch((0, $uiU92.notificationGetNotificationsUnreadCount)());
    }, 10000);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $8nelw.styles)(theme).notifications.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $8nelw.styles)(theme).notifications.button,
                onClick: ()=>navigate((0, $9YTSb.Path).Notifications),
                type: "button",
                "aria-label": "navigate to notifications page",
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Bell, {
                    css: [
                        (0, $8nelw.styles)(theme).notifications.icon.shared,
                        pathname.includes((0, $9YTSb.Path).Notifications) ? (0, $8nelw.styles)(theme).notifications.icon.active : (0, $8nelw.styles)(theme).notifications.icon.inactive,
                        "",
                        ""
                    ]
                })
            }),
            notificationsUnreadCount > 0 && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $8nelw.styles)(theme).notifications.count.shared,
                    notificationsUnreadCount < 100 ? (0, $8nelw.styles)(theme).notifications.count.circle : (0, $8nelw.styles)(theme).notifications.count.badge,
                    "",
                    ""
                ],
                children: (0, $fJerj.numbersFormatter)(notificationsUnreadCount)
            })
        ]
    });
};

});
parcelRegister("fNyrl", function(module, exports) {

$parcel$export(module.exports, "mergeArraysAtIndex", function () { return (parcelRequire("9UVKd")).mergeArraysAtIndex; });
$parcel$export(module.exports, "importsLazy", function () { return (parcelRequire("hzuqN")).importsLazy; });
$parcel$export(module.exports, "numbersFormatter", function () { return (parcelRequire("fJerj")).numbersFormatter; });
$parcel$export(module.exports, "audioDurationFormatter", function () { return (parcelRequire("fJerj")).audioDurationFormatter; });
$parcel$export(module.exports, "stringsCutter", function () { return (parcelRequire("3gmqG")).stringsCutter; });
$parcel$export(module.exports, "uuid", function () { return (parcelRequire("ij1oT")).uuid; });
$parcel$export(module.exports, "validateAvatarFile", function () { return (parcelRequire("33ayT")).validateAvatarFile; });
$parcel$export(module.exports, "validateCoverFile", function () { return (parcelRequire("33ayT")).validateCoverFile; });
$parcel$export(module.exports, "validateTrackFile", function () { return (parcelRequire("33ayT")).validateTrackFile; });
$parcel$export(module.exports, "validatePostMediaFile", function () { return (parcelRequire("33ayT")).validatePostMediaFile; });
$parcel$export(module.exports, "validateUsername", function () { return (parcelRequire("33ayT")).validateUsername; });
$parcel$export(module.exports, "validateName", function () { return (parcelRequire("33ayT")).validateName; });
$parcel$export(module.exports, "validateTrackName", function () { return (parcelRequire("33ayT")).validateTrackName; });
$parcel$export(module.exports, "validateEmail", function () { return (parcelRequire("33ayT")).validateEmail; });
$parcel$export(module.exports, "validatePassword", function () { return (parcelRequire("33ayT")).validatePassword; });
$parcel$export(module.exports, "validateRepeatPassword", function () { return (parcelRequire("33ayT")).validateRepeatPassword; });
$parcel$export(module.exports, "validatePostMessage", function () { return (parcelRequire("33ayT")).validatePostMessage; });
$parcel$export(module.exports, "validateCommentMessage", function () { return (parcelRequire("33ayT")).validateCommentMessage; });
$parcel$export(module.exports, "validateTipMessage", function () { return (parcelRequire("33ayT")).validateTipMessage; });
$parcel$export(module.exports, "validateReportComplaint", function () { return (parcelRequire("33ayT")).validateReportComplaint; });

var $9UVKd = parcelRequire("9UVKd");

var $hzuqN = parcelRequire("hzuqN");

var $fJerj = parcelRequire("fJerj");

var $3gmqG = parcelRequire("3gmqG");

var $ij1oT = parcelRequire("ij1oT");

var $33ayT = parcelRequire("33ayT");

});
parcelRegister("9UVKd", function(module, exports) {

$parcel$export(module.exports, "mergeArraysAtIndex", function () { return $be2ebb1feca80a7d$export$fb8c283b853546f6; });
/**
 * Merges two arrays at specified index.
 *
 * Takes two arrays of any type and start index, returns merged array.
 *
 *
 * @param {any[]} arr1 - array of any type.
 * @param {any[]} arr2 - array of any type.
 * @param {number} startIndex - index to start merge from.
 * @returns {any[]} - result of merge of arr1 with arr2 at start index.
 *
 * @example
 * // Returns [1,2,3,undefined,undefined,6,7,8].
 * const cutString = mergeArraysAtIndex([1,2,3], [6,7,8], 4)
 */ const $be2ebb1feca80a7d$export$fb8c283b853546f6 = (arr1, arr2, startIndex)=>{
    // append first array to result
    const result = [
        ...arr1
    ];
    // iterate over array to be merged to
    for(let i = 0; i < arr2.length; i += 1)result[startIndex + i] = arr2[i];
    return result;
};

});

parcelRegister("hzuqN", function(module, exports) {

$parcel$export(module.exports, "importsLazy", function () { return $7997ce3e6d3fe15b$export$7e090d1bf5cee0b1; });

var $exYeM = parcelRequire("exYeM");
function $7997ce3e6d3fe15b$export$7e090d1bf5cee0b1(factory, name) {
    return Object.create({
        [name]: (0, $exYeM.lazy)(()=>factory().then((module)=>({
                    default: module[name]
                })))
    });
}

});

parcelRegister("fJerj", function(module, exports) {

$parcel$export(module.exports, "numbersFormatter", function () { return $dfae1c788154177b$export$873aaf10871ec6f; });
$parcel$export(module.exports, "audioDurationFormatter", function () { return $dfae1c788154177b$export$81713a7a4f77c43b; });
/**
 * Converts a number into a string representation with appropriate characters.
 *
 * Takes number to convert and number of digits to return.
 *
 * @param number - number to convert.
 * @param digits - digits to add to the return (defaults to 1).
 * @returns converted string representation.
 *
 * @example
 * // Returns formatted number (1k).
 * const formattedNum = numbersFormatter(1000);
 */ const $dfae1c788154177b$export$873aaf10871ec6f = (num, digits = 1)=>{
    const lookup = [
        {
            value: 1,
            symbol: ""
        },
        {
            value: 1e3,
            symbol: "k"
        },
        {
            value: 1e6,
            symbol: "M"
        },
        {
            value: 1e9,
            symbol: "G"
        },
        {
            value: 1e12,
            symbol: "T"
        },
        {
            value: 1e15,
            symbol: "P"
        },
        {
            value: 1e18,
            symbol: "E"
        }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const lookupItem = lookup.slice().reverse().find((item)=>num >= item.value);
    return lookupItem ? (num / lookupItem.value).toFixed(digits).replace(rx, "$1") + lookupItem.symbol : "0";
};
const $dfae1c788154177b$export$81713a7a4f77c43b = (durationTime)=>{
    const min = Math.floor(durationTime / 60);
    const sec = Math.floor(durationTime - min * 60);
    // format - mm:ss
    const formatted = [
        min,
        sec
    ].map((n)=>n < 10 ? `0${n}` : n).join(":");
    return formatted;
};

});

parcelRegister("3gmqG", function(module, exports) {

$parcel$export(module.exports, "stringsCutter", function () { return $681ba0dcb1d8c17f$export$b6589b543c0953e5; });
/**
 * Cuts a string to the specified maximum length, adds three dots at the end.
 *
 * Takes max length and string to cut, returns cut string with three dots.
 *
 *
 * @param maxLength - maximum length of the resulting string (excluding the dots).
 * @param str - input string to be cut.
 * @returns cut string with three dots added at the end.
 *
 * @example
 * // Returns cut string (st...).
 * const cutString = stringsCutter("string", 5)
 */ const $681ba0dcb1d8c17f$export$b6589b543c0953e5 = (maxLength, str)=>{
    // Check if the input string is already shorter than or equal to the maximum length
    if (str.length <= maxLength) return str;
    // Cut the string to the specified maximum length and add three dots at the end
    const cutString = `${str.slice(0, maxLength - 3)}...`;
    return cutString;
};

});

parcelRegister("ij1oT", function(module, exports) {

$parcel$export(module.exports, "uuid", function () { return $c5177381abddfd0a$export$31b40729666a4ae0; });
/**
 * Generates RFC4122-compliant uuid v4.
 *
 * Generates uuid version 4 and returns it.
 *
 * @returns uuid version 4.
 *
 * @example
 * // Returns uuid version 4.
 * const uuid = uuid();
 */ const $c5177381abddfd0a$export$31b40729666a4ae0 = ()=>// @ts-ignore: Operator '+' cannot be applied to types 'number[]' and 'number'
    "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16) // eslint-disable-line no-bitwise
    );

});

parcelRegister("33ayT", function(module, exports) {

$parcel$export(module.exports, "validateAvatarFile", function () { return $4640633392778074$export$6893dbd105eee7e0; });
$parcel$export(module.exports, "validateCoverFile", function () { return $4640633392778074$export$18ece6d9894880d1; });
$parcel$export(module.exports, "validateTrackFile", function () { return $4640633392778074$export$4b3b1c63eea947e8; });
$parcel$export(module.exports, "validatePostMediaFile", function () { return $4640633392778074$export$b89238738738a984; });
$parcel$export(module.exports, "validateUsername", function () { return $4640633392778074$export$729c1ad6a2d5e1a2; });
$parcel$export(module.exports, "validateName", function () { return $4640633392778074$export$b135c3f9b9f02308; });
$parcel$export(module.exports, "validateTrackName", function () { return $4640633392778074$export$98b6632e76a5c811; });
$parcel$export(module.exports, "validateEmail", function () { return $4640633392778074$export$18148d12c805c5b0; });
$parcel$export(module.exports, "validatePassword", function () { return $4640633392778074$export$4d2a7159fda5dc93; });
$parcel$export(module.exports, "validateRepeatPassword", function () { return $4640633392778074$export$d85688bc3c102ae0; });
$parcel$export(module.exports, "validatePostMessage", function () { return $4640633392778074$export$c5370cfcf90498c0; });
$parcel$export(module.exports, "validateCommentMessage", function () { return $4640633392778074$export$7ebc7aa6cf84a4e2; });
$parcel$export(module.exports, "validateTipMessage", function () { return $4640633392778074$export$f624e131c2bec5cb; });
$parcel$export(module.exports, "validateReportComplaint", function () { return $4640633392778074$export$49ad54cc2eedbc83; });
parcelRequire("2uUQU");
var $ck17w = parcelRequire("ck17w");
var $P3Zb0 = parcelRequire("P3Zb0");
var $kDwrL = parcelRequire("kDwrL");
var $lyE92 = parcelRequire("lyE92");
var $6U1f3 = parcelRequire("6U1f3");
var $bs6PN = parcelRequire("bs6PN");
const $4640633392778074$export$6893dbd105eee7e0 = (file)=>{
    // validate file type
    if (!file.type.startsWith("image/")) return "File should be in a valid image format.";
    // validate file size
    const maxFileSize = (0, $bs6PN.maxUserAvatarFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $4640633392778074$export$18ece6d9894880d1 = (file)=>{
    // validate file type
    if (!file.type.startsWith("image/")) return "File should be in a valid image format.";
    // validate file size
    const maxFileSize = (0, $6U1f3.maxTrackCoverFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $4640633392778074$export$4b3b1c63eea947e8 = (file)=>{
    // validate file type
    if (!file.type.startsWith("audio/mpeg")) return "File should be in a valid MP3 format.";
    // validate file size
    const maxFileSize = (0, $6U1f3.maxTrackFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $4640633392778074$export$b89238738738a984 = (file)=>{
    // validate file type
    if (!file.type.startsWith("image/") && !file.type.startsWith("video/")) return "File should be in a valid image or video format.";
    // validate file size
    const maxFileSize = (0, $P3Zb0.maxPostMediaFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $4640633392778074$export$729c1ad6a2d5e1a2 = (username)=>{
    // validate min length
    const minUsernameLength = (0, $bs6PN.minUserUsernameLength);
    if (username.length < minUsernameLength) return `Username must be ${minUsernameLength} characters or longer.`;
    // validate max length
    const maxUsernameLength = (0, $bs6PN.maxUserUsernameLength);
    if (username.length > maxUsernameLength) return `Username must be up to ${maxUsernameLength} characters.`;
    // username examples
    // const usernameExamples = [
    //   'user_name',
    //   'user_1234',
    //   'user1234',
    //   '__username',
    //   'username__',
    //   '0_username_1',
    // ]
    // const randomIndex = Math.floor(Math.random() * usernameExamples.length)
    // const exampleName = usernameExamples[randomIndex]
    // validate username
    const reName = /^[a-z0-9_]{3,16}$/;
    const res = String(username).match(reName);
    if (!res) return `Given username contains unacceptable characters or case.`;
    return "";
};
const $4640633392778074$export$b135c3f9b9f02308 = (name)=>{
    // validate min length
    const minNameLength = (0, $bs6PN.minUserNameLength);
    if (name.length < minNameLength) return `Name must be ${minNameLength} characters or longer.`;
    // validate max length
    const masNameLength = (0, $bs6PN.maxUserNameLength);
    if (name.length > masNameLength) return `Name must be up to ${masNameLength} characters.`;
    // name examples
    // const nameExamples = [
    //   'James Smith',
    //   'James-Smith',
    //   'James_Smith',
    //   'James Smith 1',
    //   'James-Smith-1',
    //   'James_Smith_1',
    //   'J.Smith',
    //   'James, Smith',
    // ]
    // const randomIndex = Math.floor(Math.random() * nameExamples.length)
    // const exampleName = `${nameExamples[randomIndex]}`
    // validate name
    const reName = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19_,.'()\- ]{3,100}$/;
    const res = String(name).match(reName);
    if (!res) return `Given name contains unacceptable characters.`;
    return "";
};
const $4640633392778074$export$98b6632e76a5c811 = (name)=>{
    // validate min length
    const minNameLength = (0, $6U1f3.minTrackNameLength);
    if (name.length < minNameLength) return `Track name must be ${minNameLength} characters or longer.`;
    // validate max length
    const masNameLength = (0, $6U1f3.maxTrackNameLength);
    if (name.length > masNameLength) return `Track name must be up to ${masNameLength} characters.`;
    // validate name
    const reName = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19_,.'()\- ]{3,100}$/;
    const res = String(name).match(reName);
    if (!res) return `Given name contains unaccepted characters.`;
    return "";
};
const $4640633392778074$export$18148d12c805c5b0 = (email)=>{
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !String(email).toLowerCase().match(re) ? "Invalid email address." : "";
};
const $4640633392778074$export$4d2a7159fda5dc93 = (password)=>{
    // at least one upper case letter /(?=.*?[A-Z])/
    // at least one lower case letter /(?=.*?[a-z])/
    // at least one digit /(?=.*?[0-9])/
    // at least one special character, /(?=.*?[#?!@$%^&*-])/
    // all together /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
    // minimum eight characters
    const minPasswordLength = (0, $bs6PN.minUserPasswordLength);
    if (password.length < minPasswordLength) return `Password must be ${minPasswordLength} characters or longer.`;
    // at least one number character
    const reNums = /(?=.*?[0-9])/;
    if (!password.match(reNums)) return "Password must contain a number.";
    // at least one special character
    const reSpecial = /(?=.*?[#~?!@$%^&*-])/;
    if (!password.match(reSpecial)) return "Password must contain a symbol (@$!%*#?&).";
    return "";
};
const $4640633392778074$export$d85688bc3c102ae0 = (password, repeat)=>password === repeat ? "" : "Passwords don't match.";
const $4640633392778074$export$c5370cfcf90498c0 = (message)=>{
    // validate min length
    const minMessageLength = (0, $P3Zb0.minPostMessageLength);
    if (message.length < minMessageLength) return `Post message must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $P3Zb0.maxPostMessageLength);
    if (message.length > maxMessageLength) return `Post message must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{3,1000}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Post message contains unaccepted characters.`;
    return "";
};
const $4640633392778074$export$7ebc7aa6cf84a4e2 = (message)=>{
    // validate min length
    const minMessageLength = (0, $ck17w.minCommentMessageLength);
    if (message.length < minMessageLength) return `Comment message must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $ck17w.maxCommentMessageLength);
    if (message.length > maxMessageLength) return `Comment message must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{1,1000}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Comment message contains unaccepted characters.`;
    return "";
};
const $4640633392778074$export$f624e131c2bec5cb = (message)=>{
    // validate min length
    const minMessageLength = (0, $lyE92.minTipMessageLength);
    if (message.length < minMessageLength) return `Tip message must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $lyE92.maxTipMessageLength);
    if (message.length > maxMessageLength) return `Tip message must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{1,256}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Tip message contains unaccepted characters.`;
    return "";
};
const $4640633392778074$export$49ad54cc2eedbc83 = (message)=>{
    // validate min length
    const minMessageLength = (0, $kDwrL.minReportComplaintLength);
    if (message.length < minMessageLength) return `Complaint must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $kDwrL.maxReportComplaintLength);
    if (message.length > maxMessageLength) return `Complaint must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{1,256}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Complaint contains unaccepted characters.`;
    return "";
};

});


parcelRegister("8nelw", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $831dd83425b7bd8c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $831dd83425b7bd8c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $831dd83425b7bd8c$var$_ref = {
    name: "1iefybh",
    styles: "padding:0px 2px;border-radius:20px"
};
var $831dd83425b7bd8c$var$_ref2 = {
    name: "1cuh9u4",
    styles: "width:20px;border-radius:50%"
};
var $831dd83425b7bd8c$var$_ref3 = {
    name: "1sdieky",
    styles: "width:24px;height:24px;&>path{transition:fill 0.2s;}"
};
var $831dd83425b7bd8c$var$_ref4 = {
    name: "e14s2a",
    styles: "position:relative;display:flex;align-items:center;justify-content:center;width:40px;height:40px"
};
const $831dd83425b7bd8c$export$9dd6ff9ea0189349 = (theme)=>({
        notifications: {
            main: $831dd83425b7bd8c$var$_ref4,
            button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:40px;height:40px;cursor:pointer;&:hover>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            icon: {
                shared: $831dd83425b7bd8c$var$_ref3,
                active: /*#__PURE__*/ (0, $4N3Qt.css)("&>path{fill:", theme.colors.accent.normal, ";}", ""),
                inactive: /*#__PURE__*/ (0, $4N3Qt.css)("&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            count: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:-2px;right:2px;display:flex;align-items:center;justify-content:center;height:20px;color:", theme.colors.positive.darker, ";font-weight:bold;background-color:", theme.colors.accent.normal, ";", ""),
                circle: $831dd83425b7bd8c$var$_ref2,
                badge: $831dd83425b7bd8c$var$_ref
            }
        }
    });

});


parcelRegister("4aOcN", function(module, exports) {

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $6WWcN = parcelRequire("6WWcN");
const $01d960d5ec00dde0$export$55d7609a8f1eccd2 = ({ name: name, label: label, icon: Icon, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $6WWcN.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $6WWcN.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                css: (0, $6WWcN.styles)(theme).input.data,
                id: name,
                ...attributes
            }),
            Icon && /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {
                css: (0, $6WWcN.styles)(theme).input.icon
            })
        ]
    });
};

});
parcelRegister("6WWcN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3d2bf4d184090695$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3d2bf4d184090695$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3d2bf4d184090695$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $3d2bf4d184090695$var$_ref2 = {
    name: "5ob2ly",
    styles: "display:flex;position:relative"
};
const $3d2bf4d184090695$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $3d2bf4d184090695$var$_ref2,
            label: $3d2bf4d184090695$var$_ref,
            data: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h6, ";color:", theme.colors.secondary.normal, ";border:1px solid ", theme.colors.secondary.darkHover, ";border-radius:10px;padding:8px 8px 8px 44px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";&~svg>path{fill:", theme.colors.accent.normal, ";}}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:6px;left:10px;width:30px;height:30px;&>path{transition:fill 0.2s;fill:", theme.colors.secondary.darkHover, ";}", "")
        }
    });

});


parcelRegister("765P1", function(module, exports) {

$parcel$export(module.exports, "UserMenu", function () { return $2ffac432989ee089$export$72d0b49a56703654; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $2sNJT = parcelRequire("2sNJT");
parcelRequire("hlEvx");
var $i0noT = parcelRequire("i0noT");

var $fvpXe = parcelRequire("fvpXe");
const $2ffac432989ee089$export$72d0b49a56703654 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $fvpXe.styles)(theme).menu.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $fvpXe.styles)(theme).menu.avatar,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i0noT.Avatar), {})
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $fvpXe.styles)(theme).menu.options.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $fvpXe.styles)(theme).menu.options.divider
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $fvpXe.styles)(theme).menu.options.list.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("ul", {
                            css: (0, $fvpXe.styles)(theme).menu.options.list.ul,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("li", {
                                    css: (0, $fvpXe.styles)(theme).menu.options.list.li,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                        css: [
                                            (0, $fvpXe.styles)(theme).menu.options.list.button.shared,
                                            (0, $fvpXe.styles)(theme).menu.options.list.button.profile,
                                            "",
                                            ""
                                        ],
                                        onClick: ()=>navigate((0, $9YTSb.Path).Profile),
                                        type: "button",
                                        "aria-label": "navigate to profile page",
                                        children: "Profile"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("li", {
                                    css: (0, $fvpXe.styles)(theme).menu.options.list.li,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                        css: [
                                            (0, $fvpXe.styles)(theme).menu.options.list.button.shared,
                                            (0, $fvpXe.styles)(theme).menu.options.list.button.logout,
                                            "",
                                            ""
                                        ],
                                        onClick: ()=>dispatch((0, $2sNJT.authSignout)()),
                                        type: "button",
                                        "aria-label": "log out",
                                        children: "Log out"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("hlEvx", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("i0noT")).Avatar; });

var $i0noT = parcelRequire("i0noT");

});
parcelRegister("i0noT", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $3d684c6b5df3d7b6$export$e2255cf6045e8d47; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");

var $8OCtd = parcelRequire("8OCtd");
const $3d684c6b5df3d7b6$export$e2255cf6045e8d47 = ()=>{
    const theme = (0, $hXJcm.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $exYeM.useState)(false);
    const profileAvatar = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfileAvatar));
    const source = (0, $hrd7b.useFile)(profileAvatar || "");
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8OCtd.styles)(theme).avatar.main,
        children: profileAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
            css: (0, $8OCtd.styles)(theme).avatar.content,
            onError: ()=>setAvatarLoadError(true),
            loading: "lazy",
            width: "40px",
            height: "40px",
            src: source,
            alt: "user avatar"
        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
            css: (0, $8OCtd.styles)(theme).avatar.icon
        })
    });
};

});
parcelRegister("8OCtd", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4cdfe8151cb85dbb$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $4cdfe8151cb85dbb$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background-color:", theme.colors.primary.darker, ";overflow:hidden;", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:20px;height:20px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
        }
    });

});



parcelRegister("fvpXe", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $310be78003574ca1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $310be78003574ca1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $310be78003574ca1$var$_ref = {
    name: "qr8q5p",
    styles: "list-style:none"
};
var $310be78003574ca1$var$_ref2 = {
    name: "1kw2gd3",
    styles: "height:10px;width:100%;background-color:transparent"
};
var $310be78003574ca1$var$_ref3 = {
    name: "2vqn85",
    styles: "position:relative;&:hover div:nth-of-type(2){visibility:visible;opacity:1;}"
};
const $310be78003574ca1$export$9dd6ff9ea0189349 = (theme)=>({
        menu: {
            main: $310be78003574ca1$var$_ref3,
            avatar: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            options: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).app.header.menu, ";position:absolute;top:100%;right:50%;transform:translate(50%, 0%);visibility:hidden;opacity:0;transition:opacity 0.2s;", ""),
                divider: $310be78003574ca1$var$_ref2,
                list: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("width:100px;padding:2px 10px;border-radius:4px;border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.primary.darker, ";", ""),
                    ul: $310be78003574ca1$var$_ref,
                    li: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    button: {
                        shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:24px;cursor:pointer;font-weight:bold;white-space:nowrap;text-align:start;transition:color 0.2s;", ""),
                        profile: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        logout: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.negative.normal, ";&:hover{color:", theme.colors.negative.normalHover, ";}", "")
                    }
                }
            }
        }
    });

});



parcelRegister("04Fel", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fea59c9084c05a74$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fea59c9084c05a74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fea59c9084c05a74$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $fea59c9084c05a74$var$_ref2 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $fea59c9084c05a74$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $fea59c9084c05a74$var$_ref4 = {
    name: "nkt64x",
    styles: "margin-right:10px"
};
var $fea59c9084c05a74$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
var $fea59c9084c05a74$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $fea59c9084c05a74$var$_ref7 = {
    name: "r5hahk",
    styles: "margin-right:20px"
};
var $fea59c9084c05a74$var$_ref8 = {
    name: "eivff4",
    styles: "display:none"
};
var $fea59c9084c05a74$var$_ref9 = {
    name: "eivff4",
    styles: "display:none"
};
var $fea59c9084c05a74$var$_ref10 = {
    name: "15o2f02",
    styles: "&>svg{width:120px;height:20px;}"
};
var $fea59c9084c05a74$var$_ref11 = {
    name: "dzjsdb",
    styles: "display:inline-block;&>svg{width:140px;height:24px;}"
};
const $fea59c9084c05a74$export$9dd6ff9ea0189349 = (theme)=>({
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.sides, ";", (0, $48E0n.helpers).app.header.height, ";", (0, $48E0n.helpers).app.header.width, ";display:flex;align-items:center;justify-content:space-between;background-color:", theme.colors.primary.normal, ";", ""),
            logo: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;margin-right:10px;", (0, $48E0n.mq).tablet($fea59c9084c05a74$var$_ref11), " ", (0, $48E0n.mq).mobile($fea59c9084c05a74$var$_ref10), ";", ""),
            search: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:10px;max-width:236px;", (0, $48E0n.mq).tablet($fea59c9084c05a74$var$_ref9), ";", ""),
            actions: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).tablet($fea59c9084c05a74$var$_ref8), ";", ""),
                notifications: $fea59c9084c05a74$var$_ref7,
                avatar: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            },
            buttons: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>div:nth-of-type(1){margin-right:10px;}", (0, $48E0n.mq).tablet($fea59c9084c05a74$var$_ref6), ";", ""),
            menu: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($fea59c9084c05a74$var$_ref5), ";", ""),
                notifications: $fea59c9084c05a74$var$_ref4,
                actions: {
                    main: $fea59c9084c05a74$var$_ref3,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:40px;height:40px;cursor:pointer;&:hover>svg>path{color:", theme.colors.accent.normal, ";}", ""),
                    icon: {
                        shared: /*#__PURE__*/ (0, $4N3Qt.css)("&>path{transition:color 0.2s;color:", theme.colors.secondary.normal, ";}", ""),
                        close: $fea59c9084c05a74$var$_ref2,
                        open: $fea59c9084c05a74$var$_ref
                    }
                }
            }
        }
    });

});


parcelRegister("2Ww3e", function(module, exports) {

$parcel$export(module.exports, "CardHeaderMobile", function () { return $8e805d1028d85faa$export$a3109477fc4ac830; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $cjjh4 = parcelRequire("cjjh4");
const $8e805d1028d85faa$export$a3109477fc4ac830 = ({ onCloseClick: onCloseClick, hideClose: hideClose = false })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $cjjh4.styles)(theme).header.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {}),
            !hideClose && /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $cjjh4.styles)(theme).header.menu,
                onClick: (e)=>onCloseClick(e),
                type: "button",
                "aria-label": "close modal",
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CrossCircle, {})
            })
        ]
    });
};
$8e805d1028d85faa$export$a3109477fc4ac830.propTypes = {};

});
parcelRegister("cjjh4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bf42dba0d76acef1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $bf42dba0d76acef1$export$9dd6ff9ea0189349 = (theme)=>({
        header: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;flex-shrink:0;display:flex;align-items:center;justify-content:space-between;height:", (0, $48E0n.constants).app.header.desktop.height, ";", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("height:", (0, $48E0n.constants).app.header.mobile.height, ";", "")), ";", ""),
            menu: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;cursor:pointer;width:40px;height:40px;&>svg{width:30px;height:30px;}&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.light, ";}&:hover{&>svg>path{transition:fill 0.2s;fill:", theme.colors.accent.normal, ";}}", "")
        }
    });

});


parcelRegister("jQTWV", function(module, exports) {

$parcel$export(module.exports, "ImageComposition", function () { return $227f268344d7132c$export$1e8c2afbe31cec0; });

var $5o6z6 = parcelRequire("5o6z6");

var $9McFz = parcelRequire("9McFz");

var $joe7z = parcelRequire("joe7z");
const $227f268344d7132c$export$1e8c2afbe31cec0 = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $joe7z.styles)().composition.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $joe7z.styles)().composition.grid.main,
            children: (0, $9McFz.images).map((image, i)=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $joe7z.styles)().composition.grid.item(i),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                        css: (0, $joe7z.styles)().composition.grid.image,
                        src: image.image,
                        alt: "track album cover"
                    })
                }, image.id))
        })
    });
$227f268344d7132c$export$1e8c2afbe31cec0.propTypes = {};

});
parcelRegister("9McFz", function(module, exports) {

$parcel$export(module.exports, "images", function () { return $eb33619624b09cf9$export$6c746a5570b8b35c; });

var $lFYPt = parcelRequire("lFYPt");

var $7ZPcO = parcelRequire("7ZPcO");

var $j83ju = parcelRequire("j83ju");

var $gw4fW = parcelRequire("gw4fW");

var $bVZmb = parcelRequire("bVZmb");

var $cp4Ca = parcelRequire("cp4Ca");

var $azpbj = parcelRequire("azpbj");

var $a2f7O = parcelRequire("a2f7O");

var $d3Dfs = parcelRequire("d3Dfs");
const $eb33619624b09cf9$export$6c746a5570b8b35c = [
    {
        id: "7a134bb7-3842-4eec-bad2-8b2ad32e4038",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($lFYPt)))
    },
    {
        id: "08d0a206-dc40-4a1a-abe7-f9f5e0386625",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPcO)))
    },
    {
        id: "0c956389-91b3-47bb-95be-654c668904c5",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($j83ju)))
    },
    {
        id: "85a10454-08c5-4a96-b377-1030d09f0456",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($gw4fW)))
    },
    {
        id: "f252a756-7dae-4c3c-8669-88b685eec0d8",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bVZmb)))
    },
    {
        id: "9a12ab6a-74e9-4c81-96c4-fc65f3e7b488",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cp4Ca)))
    },
    {
        id: "5a8118f3-c30b-4db4-9ba4-82d2c424cf7f",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($azpbj)))
    },
    {
        id: "97164e2f-73cc-498b-9beb-2b2b6bf0c553",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($a2f7O)))
    },
    {
        id: "a4ca7805-4676-4449-abb6-5eeeb9ef005b",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d3Dfs)))
    }
];

});
parcelRegister("lFYPt", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_01.e2d3afdf.webp";

});

parcelRegister("7ZPcO", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_02.b2e18193.webp";

});

parcelRegister("j83ju", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_03.bee7b8fe.webp";

});

parcelRegister("gw4fW", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_04.7bafb92c.webp";

});

parcelRegister("bVZmb", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_05.7203e2c5.webp";

});

parcelRegister("cp4Ca", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_06.68f2c7fa.webp";

});

parcelRegister("azpbj", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_07.778f41a6.webp";

});

parcelRegister("a2f7O", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_08.99d7fee0.webp";

});

parcelRegister("d3Dfs", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("hz0N3") + "cover_09.1d3a64cb.webp";

});


parcelRegister("joe7z", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7cddba2569230578$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7cddba2569230578$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7cddba2569230578$var$_ref = {
    name: "czcgto",
    styles: "grid-row:1/span 2;grid-column:3/span 2"
};
var $7cddba2569230578$var$_ref2 = {
    name: "olau56",
    styles: "display:grid;grid-template-rows:repeat(2, 145px);grid-template-columns:repeat(6, 145px);grid-gap:10px"
};
var $7cddba2569230578$var$_ref3 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $7cddba2569230578$export$9dd6ff9ea0189349 = ()=>({
        composition: {
            main: $7cddba2569230578$var$_ref3,
            grid: {
                main: $7cddba2569230578$var$_ref2,
                item: (index)=>{
                    switch(index){
                        case 4:
                            return $7cddba2569230578$var$_ref;
                        default:
                            return /*#__PURE__*/ (0, $4N3Qt.css)("", "");
                    }
                },
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px;", "")
            }
        }
    });

});




parcelRegister("hUaLF", function(module, exports) {

$parcel$export(module.exports, "ModalCard", function () { return (parcelRequire("aKb6F")).ModalCard; });
$parcel$export(module.exports, "ModalFooterDesktop", function () { return (parcelRequire("dfnAY")).ModalFooterDesktop; });

var $aKb6F = parcelRequire("aKb6F");

var $dfnAY = parcelRequire("dfnAY");

});
parcelRegister("aKb6F", function(module, exports) {

$parcel$export(module.exports, "ModalCard", function () { return $607cdce26df5bd34$export$265e2dc45c2d5635; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $jQTWV = parcelRequire("jQTWV");
parcelRequire("beWIL");
var $ktDMo = parcelRequire("ktDMo");
var $4UTd6 = parcelRequire("4UTd6");
var $aLoLy = parcelRequire("aLoLy");

var $dwD8W = parcelRequire("dwD8W");
const $607cdce26df5bd34$export$265e2dc45c2d5635 = ({ onCloseClick: onCloseClick, onSignupClick: onSignupClick, onLoginClick: onLoginClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $dwD8W.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dwD8W.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: (e)=>onCloseClick(e)
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dwD8W.styles)(theme).card.composition,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jQTWV.ImageComposition), {})
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dwD8W.styles)(theme).card.description,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ktDMo.CardDescription), {
                    title: "Unlock the world of music",
                    subtitle: "Create your free RYDDM account",
                    accentStart: 17,
                    accentEnd: 22
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $dwD8W.styles)(theme).card.buttons,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $aLoLy.CardSignup), {
                        onSignupClick: (e)=>onSignupClick(e)
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4UTd6.CardLogin), {
                        description: "Already have account?",
                        onLoginClick: (e)=>onLoginClick(e)
                    })
                ]
            })
        ]
    });
};
$607cdce26df5bd34$export$265e2dc45c2d5635.propTypes = {};

});
parcelRegister("beWIL", function(module, exports) {

$parcel$export(module.exports, "CardDescription", function () { return (parcelRequire("ktDMo")).CardDescription; });
$parcel$export(module.exports, "CardLogin", function () { return (parcelRequire("4UTd6")).CardLogin; });
$parcel$export(module.exports, "CardSignup", function () { return (parcelRequire("aLoLy")).CardSignup; });

var $ktDMo = parcelRequire("ktDMo");

var $4UTd6 = parcelRequire("4UTd6");

var $aLoLy = parcelRequire("aLoLy");

});
parcelRegister("ktDMo", function(module, exports) {

$parcel$export(module.exports, "CardDescription", function () { return $e54384de4c241799$export$16e0ed4cb97c00d4; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $kbRVz = parcelRequire("kbRVz");
const $e54384de4c241799$export$16e0ed4cb97c00d4 = ({ title: title, subtitle: subtitle, accentStart: accentStart, accentEnd: accentEnd })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $kbRVz.styles)(theme).description.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kbRVz.styles)(theme).description.title,
                children: title
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $kbRVz.styles)(theme).description.subtitle,
                children: [
                    subtitle.slice(0, accentStart),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $kbRVz.styles)(theme).description.accent,
                        children: subtitle.slice(accentStart, accentEnd)
                    }),
                    subtitle.slice(accentEnd, subtitle.length)
                ]
            })
        ]
    });
};
$e54384de4c241799$export$16e0ed4cb97c00d4.propTypes = {};

});
parcelRegister("kbRVz", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f56cbae8dc854327$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f56cbae8dc854327$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f56cbae8dc854327$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
const $f56cbae8dc854327$export$9dd6ff9ea0189349 = (theme)=>({
        description: {
            main: $f56cbae8dc854327$var$_ref,
            title: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";font-weight:bold;margin-bottom:8px;", ""),
            subtitle: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;", ""),
            accent: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";", "")
        }
    });

});


parcelRegister("4UTd6", function(module, exports) {

$parcel$export(module.exports, "CardLogin", function () { return $28d344f99bb11059$export$418447c82f083ecd; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $fHeIV = parcelRequire("fHeIV");
const $28d344f99bb11059$export$418447c82f083ecd = ({ description: description, onLoginClick: onLoginClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $fHeIV.styles)(theme).login.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                css: (0, $fHeIV.styles)(theme).login.text,
                children: description
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $fHeIV.styles)(theme).login.button,
                onClick: (e)=>onLoginClick(e),
                type: "button",
                "aria-label": "log in",
                children: "Log in"
            })
        ]
    });
};
$28d344f99bb11059$export$418447c82f083ecd.propTypes = {};

});
parcelRegister("fHeIV", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d6b23a5e9e8b36e1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d6b23a5e9e8b36e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d6b23a5e9e8b36e1$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
const $d6b23a5e9e8b36e1$export$9dd6ff9ea0189349 = (theme)=>({
        login: {
            main: $d6b23a5e9e8b36e1$var$_ref,
            text: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-weight:bold;color:", theme.colors.secondary.normal, ";padding:10px 12px;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
        }
    });

});


parcelRegister("aLoLy", function(module, exports) {

$parcel$export(module.exports, "CardSignup", function () { return $f9d424e7fd8bb8f6$export$e9db94a7d0e08e46; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("fRVt8");
var $f7BhD = parcelRequire("f7BhD");

var $1Cn9O = parcelRequire("1Cn9O");
const $f9d424e7fd8bb8f6$export$e9db94a7d0e08e46 = ({ onSignupClick: onSignupClick })=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $1Cn9O.styles)().signup.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $1Cn9O.styles)().signup.button,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                "aria-label": "sign up",
                appearance: "primary",
                onClick: (e)=>onSignupClick(e),
                children: "Sign up"
            })
        })
    });
$f9d424e7fd8bb8f6$export$e9db94a7d0e08e46.propTypes = {};

});
parcelRegister("1Cn9O", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f4f9d355b9d6c1a1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f4f9d355b9d6c1a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f4f9d355b9d6c1a1$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $f4f9d355b9d6c1a1$var$_ref2 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $f4f9d355b9d6c1a1$export$9dd6ff9ea0189349 = ()=>({
        signup: {
            main: $f4f9d355b9d6c1a1$var$_ref2,
            button: /*#__PURE__*/ (0, $4N3Qt.css)("width:180px;flex-shrink:0;", (0, $48E0n.mq).mobile($f4f9d355b9d6c1a1$var$_ref), ";", "")
        }
    });

});



parcelRegister("dwD8W", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $773e0050b2a1ae06$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $773e0050b2a1ae06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $773e0050b2a1ae06$var$_ref = {
    name: "1mqj4ex",
    styles: "margin-top:22px;&>div:nth-of-type(1){margin-bottom:24px;}"
};
var $773e0050b2a1ae06$var$_ref2 = {
    name: "12l3ktq",
    styles: "margin-bottom:auto"
};
var $773e0050b2a1ae06$var$_ref3 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $773e0050b2a1ae06$var$_ref4 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $773e0050b2a1ae06$var$_ref5 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $773e0050b2a1ae06$var$_ref6 = {
    name: "1jxdg1d",
    styles: "width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $773e0050b2a1ae06$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background:linear-gradient(\n        180deg,\n        ", theme.colors.accent.darkHover, " 0%,\n        ", theme.colors.primary.normal, " 100%\n      );animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($773e0050b2a1ae06$var$_ref6), " ", (0, $48E0n.mq).mobile($773e0050b2a1ae06$var$_ref5), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($773e0050b2a1ae06$var$_ref4), ";", ""),
            composition: $773e0050b2a1ae06$var$_ref3,
            description: /*#__PURE__*/ (0, $4N3Qt.css)("margin-bottom:42px;", (0, $48E0n.mq).tablet($773e0050b2a1ae06$var$_ref2), ";", ""),
            buttons: $773e0050b2a1ae06$var$_ref
        }
    });

});


parcelRegister("dfnAY", function(module, exports) {

$parcel$export(module.exports, "ModalFooterDesktop", function () { return $bc0ab7680ae9a99f$export$6afe37ac7af699df; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $5NDvj = parcelRequire("5NDvj");
const $bc0ab7680ae9a99f$export$6afe37ac7af699df = ({ onCloseClick: onCloseClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $5NDvj.styles)(theme).footer.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
            css: (0, $5NDvj.styles)(theme).footer.button,
            onClick: (e)=>onCloseClick(e),
            type: "button",
            "aria-label": "close modal",
            children: "Close"
        })
    });
};
$bc0ab7680ae9a99f$export$6afe37ac7af699df.propTypes = {};

});
parcelRegister("5NDvj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $53d4232275f25b86$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $53d4232275f25b86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $53d4232275f25b86$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
const $53d4232275f25b86$export$9dd6ff9ea0189349 = (theme)=>({
        footer: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:center;animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($53d4232275f25b86$var$_ref), ";", ""),
            button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-size:", (0, $48E0n.typography).h6, ";color:", theme.colors.secondary.dark, ";transition:color 0.2s;padding:10px 12px;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
        }
    });

});



parcelRegister("2OPmO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6ec36acd58bc1c56$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $6ec36acd58bc1c56$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6ec36acd58bc1c56$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $6ec36acd58bc1c56$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($6ec36acd58bc1c56$var$_ref), ";", "")
        }
    });

});


parcelRegister("2cl2y", function(module, exports) {

$parcel$export(module.exports, "AuthLoginModal", function () { return (parcelRequire("cCZY7")).AuthLoginModal; });
$parcel$export(module.exports, "AuthResetModal", function () { return (parcelRequire("kyFLX")).AuthResetModal; });
$parcel$export(module.exports, "AuthSignupModal", function () { return (parcelRequire("4caAj")).AuthSignupModal; });
$parcel$export(module.exports, "AuthVerificationModal", function () { return (parcelRequire("brpxu")).AuthVerificationModal; });

var $cCZY7 = parcelRequire("cCZY7");

var $kyFLX = parcelRequire("kyFLX");

var $4caAj = parcelRequire("4caAj");

var $brpxu = parcelRequire("brpxu");

});
parcelRegister("cCZY7", function(module, exports) {

$parcel$export(module.exports, "AuthLoginModal", function () { return $95caf31a61686fbe$export$e9b16d2f6ca1e4ad; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("3x94W");
var $eMIKR = parcelRequire("eMIKR");

var $jrvp7 = parcelRequire("jrvp7");
const $95caf31a61686fbe$export$e9b16d2f6ca1e4ad = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const loginModalOpen = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectLoginModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $jrvp7.styles)().modal.main,
        children: loginModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>dispatch((0, $fAzHC.authCloseLoginModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eMIKR.LoginCard), {})
        })
    });
};
$95caf31a61686fbe$export$e9b16d2f6ca1e4ad.propTypes = {};

});
parcelRegister("3x94W", function(module, exports) {

$parcel$export(module.exports, "LoginCard", function () { return (parcelRequire("eMIKR")).LoginCard; });
$parcel$export(module.exports, "ResetCard", function () { return (parcelRequire("bEWRX")).ResetCard; });
$parcel$export(module.exports, "SignupCard", function () { return (parcelRequire("fDPPm")).SignupCard; });
$parcel$export(module.exports, "VerificationCard", function () { return (parcelRequire("5IjPV")).VerificationCard; });
parcelRequire("795I9");
var $eMIKR = parcelRequire("eMIKR");
var $bEWRX = parcelRequire("bEWRX");
var $fDPPm = parcelRequire("fDPPm");
var $5IjPV = parcelRequire("5IjPV");

});
parcelRegister("795I9", function(module, exports) {

$parcel$export(module.exports, "LoginCard", function () { return (parcelRequire("eMIKR")).LoginCard; });
$parcel$export(module.exports, "ResetCard", function () { return (parcelRequire("bEWRX")).ResetCard; });
$parcel$export(module.exports, "SignupCard", function () { return (parcelRequire("fDPPm")).SignupCard; });
$parcel$export(module.exports, "VerificationCard", function () { return (parcelRequire("5IjPV")).VerificationCard; });

var $eMIKR = parcelRequire("eMIKR");

var $bEWRX = parcelRequire("bEWRX");

var $fDPPm = parcelRequire("fDPPm");

var $5IjPV = parcelRequire("5IjPV");

});
parcelRegister("eMIKR", function(module, exports) {

$parcel$export(module.exports, "LoginCard", function () { return $f662118c57ec9f26$export$25233b7fe55e5696; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2sNJT = parcelRequire("2sNJT");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
parcelRequire("15Ysq");
var $6Hgxx = parcelRequire("6Hgxx");
var $4JVEl = parcelRequire("4JVEl");
var $c2gse = parcelRequire("c2gse");
var $6UJES = parcelRequire("6UJES");

var $3IegW = parcelRequire("3IegW");
const $f662118c57ec9f26$export$25233b7fe55e5696 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authLoading = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectLoading));
    const authError = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $3IegW.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $3IegW.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $fAzHC.authCloseLoginModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $3IegW.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $c2gse.CardTitle), {
                    title: "Log in to RYDDM",
                    accentStart: 10,
                    accentEnd: 15
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $3IegW.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $3IegW.styles)(theme).card.content.login,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6Hgxx.CardButton), {
                                onClick: ()=>dispatch((0, $2sNJT.authLoginWithGoogle)()),
                                disabled: authLoading,
                                idp: "google",
                                text: "Continue with Google",
                                "aria-label": "login with google"
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6Hgxx.CardButton), {
                                onClick: ()=>dispatch((0, $2sNJT.authLoginWithFacebook)()),
                                disabled: authLoading,
                                idp: "facebook",
                                text: "Continue with Facebook",
                                "aria-label": "login with facebook"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3IegW.styles)(theme).card.content.divider.top,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4JVEl.CardDivider), {
                            text: "or"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3IegW.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6UJES.LoginForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3IegW.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3IegW.styles)(theme).card.content.reset.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $3IegW.styles)(theme).card.content.reset.button,
                            onClick: ()=>{
                                dispatch((0, $fAzHC.authCloseLoginModal)());
                                dispatch((0, $fAzHC.authOpenResetModal)());
                            },
                            type: "button",
                            "aria-label": "reset password",
                            children: "Forgot your password"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3IegW.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4JVEl.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $3IegW.styles)(theme).card.content.signup.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                css: (0, $3IegW.styles)(theme).card.content.signup.title,
                                children: "Dont have an account?"
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                css: (0, $3IegW.styles)(theme).card.content.signup.button,
                                onClick: ()=>{
                                    dispatch((0, $fAzHC.authCloseLoginModal)());
                                    dispatch((0, $fAzHC.authOpenSignupModal)());
                                },
                                type: "button",
                                "aria-label": "sign up",
                                children: "Sign up to RYDDM"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$f662118c57ec9f26$export$25233b7fe55e5696.propTypes = {};

});
parcelRegister("15Ysq", function(module, exports) {

$parcel$export(module.exports, "CardButton", function () { return (parcelRequire("6Hgxx")).CardButton; });
$parcel$export(module.exports, "CardDivider", function () { return (parcelRequire("4JVEl")).CardDivider; });
$parcel$export(module.exports, "CardTitle", function () { return (parcelRequire("c2gse")).CardTitle; });
$parcel$export(module.exports, "LoginForm", function () { return (parcelRequire("6UJES")).LoginForm; });
$parcel$export(module.exports, "ResetForm", function () { return (parcelRequire("6CqyH")).ResetForm; });
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("1UzjS")).SignupForm; });
$parcel$export(module.exports, "VerificationForm", function () { return (parcelRequire("a4kFD")).VerificationForm; });

var $6Hgxx = parcelRequire("6Hgxx");

var $4JVEl = parcelRequire("4JVEl");

var $c2gse = parcelRequire("c2gse");
parcelRequire("gjaIl");
var $6UJES = parcelRequire("6UJES");
var $6CqyH = parcelRequire("6CqyH");
var $1UzjS = parcelRequire("1UzjS");
var $a4kFD = parcelRequire("a4kFD");

});
parcelRegister("6Hgxx", function(module, exports) {

$parcel$export(module.exports, "CardButton", function () { return $7ea8b76821dd114f$export$d4b8376576f53ef0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $9quD5 = parcelRequire("9quD5");

var $i0iak = parcelRequire("i0iak");
const $7ea8b76821dd114f$export$d4b8376576f53ef0 = ({ idp: idp, text: text, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
        css: [
            (0, $i0iak.styles)(theme).button.main,
            attributes.disabled ? (0, $i0iak.styles)(theme).button.disabled : (0, $i0iak.styles)(theme).button.enabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $i0iak.styles)(theme).button.content.icon,
                children: [
                    idp === "google" && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9quD5.icons).GoogleLogo, {}),
                    idp === "facebook" && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9quD5.icons).FacebookLogo, {})
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $i0iak.styles)(theme).button.content.text.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $i0iak.styles)(theme).button.content.text.text,
                    children: text
                })
            })
        ]
    });
};
$7ea8b76821dd114f$export$d4b8376576f53ef0.propTypes = {};

});
parcelRegister("9quD5", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $e87cd3fe86c936c0$export$df03f54e09e486fa; });

var $kykT4 = parcelRequire("kykT4");

var $7Ijba = parcelRequire("7Ijba");
const $e87cd3fe86c936c0$export$df03f54e09e486fa = {
    FacebookLogo: $kykT4.default,
    GoogleLogo: $7Ijba.default
};

});
parcelRegister("kykT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ca97b1c96d60110$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $6ca97b1c96d60110$var$SvgFacebookLogo = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M14.097 20.223c-.082-1.066-.082-2.132-.163-3.28 0-.574-.246-.983-.902-.983-.41 0-.82.081-.902-.492-.082-.738-.246-1.558 0-2.296 0-.082.328-.246.492-.246 1.23.246 1.475-.41 1.475-1.393 0-2.624 2.214-4.017 5.083-3.853.82.082.82.737.82 1.311-.082.574.246 1.394-.82 1.394-.902-.082-1.557.246-1.557 1.312 0 .737.082 1.311.983 1.393 1.312.082 1.066.984 1.066 1.886.082.984-.41 1.312-1.312 1.312-.901 0-1.065.491-1.065 1.311 0 1.804 0 3.525-.082 5.329-.082 1.148-.328 1.23-1.886 1.148-1.066 0-1.23-.492-1.148-1.394-.164-.738-.164-1.558-.082-2.46Z",
                fill: "#0F0F0F"
            })
        ]
    });
var $6ca97b1c96d60110$export$2e2bcd8739ae039 = $6ca97b1c96d60110$var$SvgFacebookLogo;

});

parcelRegister("7Ijba", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f76340a27f04258$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $8f76340a27f04258$var$SvgGoogleLogo = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("g", {
            clipPath: "url('9fd68121b7a37bd5')",
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("circle", {
                    cx: 16,
                    cy: 16,
                    r: 16,
                    fill: "#FFF"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                    d: "M21.248 10.838c-.433.516-.865.826-1.19 1.24-.54.722-.973.825-1.839.31-2.055-1.137-3.786-.62-5.516 1.238-1.298 1.343-1.406 3.409-.433 5.06 1.406 2.273 6.166 2.376 7.68.207.433-.62.216-1.136-.649-1.239-.54-.103-1.19.103-1.839 0-1.081-.103-1.514-.62-1.406-1.652 0-1.033.757-1.136 1.623-1.136 1.514 0 2.92 0 4.434.103 1.623.103 1.731.31 1.407 1.859 0 .207-.217.516-.217.723-.54 2.685-1.514 4.957-4.543 5.783-3.245.826-6.165.104-8.545-2.065-2.596-2.376-2.488-7.643.216-10.121 3.245-3.202 7.68-3.305 10.817-.31Z",
                    fill: "#0F0F0F"
                })
            ]
        })
    });
var $8f76340a27f04258$export$2e2bcd8739ae039 = $8f76340a27f04258$var$SvgGoogleLogo;

});


parcelRegister("i0iak", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4f9f521481673e25$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $4f9f521481673e25$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4f9f521481673e25$var$_ref = {
    name: "62qxo5",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0"
};
var $4f9f521481673e25$var$_ref2 = {
    name: "1c7wyvx",
    styles: "margin-right:26px"
};
var $4f9f521481673e25$var$_ref3 = {
    name: "457mpb",
    styles: "padding:8px 26px"
};
var $4f9f521481673e25$var$_ref4 = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
const $4f9f521481673e25$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;padding:12px 32px;cursor:pointer;width:100%;overflow:hidden;transition:border 0.2s,color 0.2s,background-color 0.2s;", (0, $48E0n.mq).tablet($4f9f521481673e25$var$_ref4), " ", (0, $48E0n.mq).mobile($4f9f521481673e25$var$_ref3), ";", ""),
            enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";border:1px solid ", theme.colors.secondary.normal, ";&:hover{border:1px solid ", theme.colors.accent.normal, ";}&>div:nth-of-type(1)>svg>g>circle{fill:", theme.colors.secondary.normal, ";}&>div:nth-of-type(1)>svg>circle{fill:", theme.colors.secondary.normal, ";}", ""),
            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;color:", theme.colors.secondary.darker, ";border:1px solid ", theme.colors.secondary.darker, ";&>div:nth-of-type(1)>svg>g>circle{fill:", theme.colors.secondary.darker, ";}&>div:nth-of-type(1)>svg>circle{fill:", theme.colors.secondary.darker, ";}", ""),
            content: {
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-right:32px;&>svg{width:32px;height:32px;}", (0, $48E0n.mq).mobile($4f9f521481673e25$var$_ref2), ";", ""),
                text: {
                    main: $4f9f521481673e25$var$_ref,
                    text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")
                }
            }
        }
    });

});


parcelRegister("4JVEl", function(module, exports) {

$parcel$export(module.exports, "CardDivider", function () { return $926b04b96d17ddbc$export$ca04f93e3f5a6e48; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $6xXTu = parcelRequire("6xXTu");
const $926b04b96d17ddbc$export$ca04f93e3f5a6e48 = ({ text: text = "" })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $6xXTu.styles)(theme).divider.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6xXTu.styles)(theme).divider.bar
            }),
            text && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6xXTu.styles)(theme).divider.text.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: (0, $6xXTu.styles)(theme).divider.text.text,
                    children: text
                })
            })
        ]
    });
};
$926b04b96d17ddbc$export$ca04f93e3f5a6e48.propTypes = {};

});
parcelRegister("6xXTu", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $82bddb19d5a2b85c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $82bddb19d5a2b85c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $82bddb19d5a2b85c$var$_ref = {
    name: "5ob2ly",
    styles: "display:flex;position:relative"
};
const $82bddb19d5a2b85c$export$9dd6ff9ea0189349 = (theme)=>({
        divider: {
            main: $82bddb19d5a2b85c$var$_ref,
            bar: /*#__PURE__*/ (0, $4N3Qt.css)("height:2px;width:100%;background-color:", theme.colors.secondary.darker, ";", ""),
            text: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);background-color:", theme.colors.primary.normal, ";", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";font-weight:bold;padding:4px 16px;", "")
            }
        }
    });

});


parcelRegister("c2gse", function(module, exports) {

$parcel$export(module.exports, "CardTitle", function () { return $78265838d408942f$export$474db65c3c394e1c; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $9I5gd = parcelRequire("9I5gd");
const $78265838d408942f$export$474db65c3c394e1c = ({ title: title, accentStart: accentStart = 0, accentEnd: accentEnd = 0 })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9I5gd.styles)(theme).title.main,
        children: [
            title.slice(0, accentStart),
            /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                css: (0, $9I5gd.styles)(theme).title.accent,
                children: title.slice(accentStart, accentEnd)
            }),
            title.slice(accentEnd, title.length)
        ]
    });
};
$78265838d408942f$export$474db65c3c394e1c.propTypes = {};

});
parcelRegister("9I5gd", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d519eb3f623d4873$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $d519eb3f623d4873$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("text-align:center;font-size:", (0, $48E0n.typography).h4, ";font-weight:bold;", ""),
            accent: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";", "")
        }
    });

});


parcelRegister("gjaIl", function(module, exports) {

$parcel$export(module.exports, "LoginForm", function () { return (parcelRequire("6UJES")).LoginForm; });
$parcel$export(module.exports, "ResetForm", function () { return (parcelRequire("6CqyH")).ResetForm; });
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("1UzjS")).SignupForm; });
$parcel$export(module.exports, "VerificationForm", function () { return (parcelRequire("a4kFD")).VerificationForm; });

var $6UJES = parcelRequire("6UJES");

var $6CqyH = parcelRequire("6CqyH");

var $1UzjS = parcelRequire("1UzjS");

var $a4kFD = parcelRequire("a4kFD");

});
parcelRegister("6UJES", function(module, exports) {

$parcel$export(module.exports, "LoginForm", function () { return $291d93fdfb13f366$export$1f58f750f20f344b; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $2sNJT = parcelRequire("2sNJT");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("5L9fE");
var $JcGe6 = parcelRequire("JcGe6");

var $lWPjX = parcelRequire("lWPjX");
const $291d93fdfb13f366$export$1f58f750f20f344b = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authLoading = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectLoading));
    const [email, setEmail] = (0, $exYeM.useState)("");
    const [emailError, setEmailError] = (0, $exYeM.useState)("");
    const [password, setPassword] = (0, $exYeM.useState)("");
    const submitDisabled = password.length < 6 || email.length < 4 || emailError !== "" || authLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lWPjX.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $lWPjX.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $2sNJT.authLoginWithEmailAndPassword)({
                    email: email,
                    password: password
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $lWPjX.styles)().form.content.email,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $JcGe6.FormInput), {
                        name: "email",
                        label: "email",
                        type: "email",
                        placeholder: "Enter your email",
                        value: email,
                        error: emailError.length > 0,
                        errorMessage: emailError,
                        onChange: (e)=>{
                            setEmail(e.target.value);
                        },
                        onBlur: ()=>setEmailError((0, $33ayT.validateEmail)(email)),
                        onFocus: ()=>setEmailError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $lWPjX.styles)().form.content.password,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $JcGe6.FormInput), {
                        name: "password",
                        label: "password",
                        type: "password",
                        placeholder: "Enter your password",
                        value: password,
                        onChange: (e)=>{
                            setPassword(e.target.value);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $lWPjX.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "log in",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: authLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Log in"
                    })
                })
            ]
        })
    });
};
$291d93fdfb13f366$export$1f58f750f20f344b.propTypes = {};

});
parcelRegister("5L9fE", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return (parcelRequire("JcGe6")).FormInput; });

var $JcGe6 = parcelRequire("JcGe6");

});
parcelRegister("JcGe6", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return $a4f8cc4e3ef94e1b$export$fd970bbd10854e43; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");

var $gIF2i = parcelRequire("gIF2i");

var $jQ5Xk = parcelRequire("jQ5Xk");
var $a4f8cc4e3ef94e1b$var$InputType;
(function(InputType) {
    InputType["Text"] = "text";
    InputType["Password"] = "password";
})($a4f8cc4e3ef94e1b$var$InputType || ($a4f8cc4e3ef94e1b$var$InputType = {}));
const $a4f8cc4e3ef94e1b$export$fd970bbd10854e43 = ({ name: name, label: label, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    const [inputType, setInputType] = (0, $exYeM.useState)(attributes.type);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $jQ5Xk.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $jQ5Xk.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $jQ5Xk.styles)(theme).input.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                        css: [
                            (0, $jQ5Xk.styles)(theme).input.data.shared,
                            attributes.value ? (0, $jQ5Xk.styles)(theme).input.data.filled : (0, $jQ5Xk.styles)(theme).input.data.empty,
                            error && (0, $jQ5Xk.styles)(theme).input.data.errored,
                            (inputType === "password" || inputType === "text") && (0, $jQ5Xk.styles)(theme).input.data.withIcon,
                            inputType === "password" && attributes.value && (0, $jQ5Xk.styles)(theme).input.data.password,
                            "",
                            ""
                        ],
                        id: name,
                        ...attributes,
                        type: inputType
                    }),
                    inputType === "password" && /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $jQ5Xk.styles)(theme).input.button.main,
                        onClick: ()=>setInputType("text"),
                        type: "button",
                        "aria-label": "open password",
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gIF2i.icons).EyeClosed, {
                            css: (0, $jQ5Xk.styles)(theme).input.button.icon
                        })
                    }),
                    inputType === "text" && /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $jQ5Xk.styles)(theme).input.button.main,
                        onClick: ()=>setInputType("password"),
                        type: "button",
                        "aria-label": "hide password",
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gIF2i.icons).EyeOpen, {
                            css: (0, $jQ5Xk.styles)(theme).input.button.icon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $jQ5Xk.styles)(theme).input.error.shared,
                    errorMessage ? (0, $jQ5Xk.styles)(theme).input.error.visible : (0, $jQ5Xk.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: [
                        (0, $jQ5Xk.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $jQ5Xk.styles)(theme).input.error.text.visible : (0, $jQ5Xk.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$a4f8cc4e3ef94e1b$export$fd970bbd10854e43.propTypes = {};

});
parcelRegister("gIF2i", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $835a7eeeb3ff9654$export$df03f54e09e486fa; });

var $86yUN = parcelRequire("86yUN");

var $4RYD4 = parcelRequire("4RYD4");
const $835a7eeeb3ff9654$export$df03f54e09e486fa = {
    EyeOpen: $86yUN.default,
    EyeClosed: $4RYD4.default
};

});
parcelRegister("86yUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e839ba83c987dab3$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $e839ba83c987dab3$var$SvgEyeOpen = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 11.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM12.75 15a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 6.25c-4.514 0-7.555 2.704-9.32 4.997l-.031.041c-.4.518-.767.996-1.016 1.56-.267.605-.383 1.264-.383 2.152 0 .888.116 1.547.383 2.152.25.564.617 1.041 1.016 1.56l.032.041C7.445 21.046 10.486 23.75 15 23.75c4.514 0 7.555-2.704 9.32-4.997l.031-.041c.4-.518.767-.996 1.016-1.56.267-.605.383-1.264.383-2.152 0-.888-.116-1.547-.383-2.152-.25-.564-.617-1.042-1.016-1.56l-.032-.041C22.555 8.954 19.514 6.25 15 6.25Zm-8.13 5.912C8.498 10.045 11.15 7.75 15 7.75c3.85 0 6.501 2.295 8.13 4.412.44.57.696.91.865 1.292.158.358.255.795.255 1.546s-.097 1.188-.255 1.546c-.169.382-.426.722-.864 1.292C21.5 19.955 18.85 22.25 15 22.25c-3.85 0-6.501-2.295-8.13-4.412-.44-.57-.696-.91-.865-1.293-.158-.357-.255-.794-.255-1.545 0-.751.097-1.188.255-1.546.169-.382.426-.722.864-1.292Z",
                fill: "#FFF"
            })
        ]
    });
var $e839ba83c987dab3$export$2e2bcd8739ae039 = $e839ba83c987dab3$var$SvgEyeOpen;

});

parcelRegister("4RYD4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $622d43b5d33a8104$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $622d43b5d33a8104$var$SvgEyeClosed = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.295 9.31a.75.75 0 0 1 .394.985L25 10l.69.295v.002l-.002.003-.003.007-.01.024-.039.084a13.871 13.871 0 0 1-.727 1.321 15.05 15.05 0 0 1-1.846 2.394l.968.968a.75.75 0 0 1-1.06 1.061l-1.001-1a11.548 11.548 0 0 1-2.274 1.497l.934 1.435a.75.75 0 1 1-1.258.818l-1.089-1.674c-.78.255-1.623.428-2.532.49V19.5a.75.75 0 0 1-1.5 0v-1.775c-.881-.06-1.7-.225-2.46-.467l-1.074 1.651a.75.75 0 0 1-1.258-.818l.913-1.402a11.502 11.502 0 0 1-2.293-1.49l-.96.96a.75.75 0 0 1-1.061-1.06l.924-.924a15.03 15.03 0 0 1-2.467-3.455 9.464 9.464 0 0 1-.188-.389l-.01-.024-.004-.007v-.003H4.31c0-.001 0-.002.689-.297l-.69.296a.75.75 0 0 1 1.379-.592v.002l.007.014.029.062a12.388 12.388 0 0 0 .65 1.177c.475.761 1.197 1.748 2.18 2.663.867.804 1.928 1.546 3.197 2.034A8.97 8.97 0 0 0 15 16.25a8.963 8.963 0 0 0 3.312-.62c1.262-.496 2.316-1.242 3.175-2.048a13.3 13.3 0 0 0 2.789-3.8l.028-.063.006-.013v-.001m.985-.394a.75.75 0 0 0-.984.394l.984-.394ZM5.69 9.704Z",
            fill: "#FFF"
        })
    });
var $622d43b5d33a8104$export$2e2bcd8739ae039 = $622d43b5d33a8104$var$SvgEyeClosed;

});


parcelRegister("jQ5Xk", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d0968a26ab8a2d1b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d0968a26ab8a2d1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d0968a26ab8a2d1b$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $d0968a26ab8a2d1b$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $d0968a26ab8a2d1b$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $d0968a26ab8a2d1b$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $d0968a26ab8a2d1b$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $d0968a26ab8a2d1b$var$_ref6 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $d0968a26ab8a2d1b$var$_ref7 = {
    name: "abijo8",
    styles: "right:26px"
};
var $d0968a26ab8a2d1b$var$_ref8 = {
    name: "laomuu",
    styles: "padding-right:60px"
};
var $d0968a26ab8a2d1b$var$_ref9 = {
    name: "1dvgrzx",
    styles: "height:50px;padding:12px 26px"
};
var $d0968a26ab8a2d1b$var$_ref10 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $d0968a26ab8a2d1b$var$_ref11 = {
    name: "eivff4",
    styles: "display:none"
};
var $d0968a26ab8a2d1b$var$_ref12 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $d0968a26ab8a2d1b$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $d0968a26ab8a2d1b$var$_ref12,
            label: $d0968a26ab8a2d1b$var$_ref11,
            data: {
                main: $d0968a26ab8a2d1b$var$_ref10,
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:56px;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h6, ";color:", theme.colors.secondary.normal, ";border-radius:20px;padding:14px 32px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", (0, $48E0n.mq).mobile($d0968a26ab8a2d1b$var$_ref9), ";", ""),
                empty: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.darkHover, ";&~button>svg>path{fill:", theme.colors.secondary.darkHover, ";}", ""),
                filled: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.normal, ";&~button>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                errored: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.negative.normal, ";", ""),
                withIcon: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:70px;", (0, $48E0n.mq).mobile($d0968a26ab8a2d1b$var$_ref8), ";", ""),
                password: /*#__PURE__*/ (0, $4N3Qt.css)("letter-spacing:8px;font-size:", (0, $48E0n.typography).h4, ";", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("letter-spacing:6px;font-size:", (0, $48E0n.typography).h5, ";", "")), ";", "")
            },
            button: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;position:absolute;right:32px;top:50%;transform:translate(0%, -50%);&>path{transition:fill 0.2s;fill:", theme.colors.secondary.darkHover, ";}", (0, $48E0n.mq).mobile($d0968a26ab8a2d1b$var$_ref7), ";", ""),
                icon: $d0968a26ab8a2d1b$var$_ref6
            },
            error: {
                shared: $d0968a26ab8a2d1b$var$_ref5,
                visible: $d0968a26ab8a2d1b$var$_ref4,
                hidden: $d0968a26ab8a2d1b$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $d0968a26ab8a2d1b$var$_ref2,
                    hidden: $d0968a26ab8a2d1b$var$_ref
                }
            }
        }
    });

});



parcelRegister("lWPjX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $12472e7902a7900d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $12472e7902a7900d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $12472e7902a7900d$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $12472e7902a7900d$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $12472e7902a7900d$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                email: $12472e7902a7900d$var$_ref2,
                password: $12472e7902a7900d$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("6CqyH", function(module, exports) {

$parcel$export(module.exports, "ResetForm", function () { return $70dbbcef7db152e0$export$f4a155c4515f44cf; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $86QaR = parcelRequire("86QaR");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2sNJT = parcelRequire("2sNJT");
parcelRequire("ewAws");
var $ehFe9 = parcelRequire("ehFe9");
var $vT5yJ = parcelRequire("vT5yJ");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("5L9fE");
var $JcGe6 = parcelRequire("JcGe6");

var $AJU9t = parcelRequire("AJU9t");
const $70dbbcef7db152e0$export$f4a155c4515f44cf = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authLoading = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectLoading));
    const [email, setEmail] = (0, $exYeM.useState)("");
    const [emailError, setEmailError] = (0, $exYeM.useState)("");
    const lastResetSec = (0, $ehFe9.dateGetDifferenceSec)(parseInt((0, $vT5yJ.storageGetSentPasswordResetEmailDate)() || "0", 10));
    const delaySec = 30;
    const initialSendDelay = lastResetSec > delaySec ? 0 : delaySec - lastResetSec;
    const [sendDelay, setSendDelay] = (0, $exYeM.useState)(initialSendDelay);
    (0, $86QaR.useInterval)(()=>{
        if (sendDelay > 0) setSendDelay(sendDelay - 1);
    }, 1000);
    const submitDisabled = email.length < 4 || emailError !== "" || sendDelay > 0 || authLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $AJU9t.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $AJU9t.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                setSendDelay(delaySec);
                dispatch((0, $2sNJT.authSendPasswordResetEmail)({
                    email: email
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $AJU9t.styles)().form.content.email,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $JcGe6.FormInput), {
                        name: "email",
                        label: "email",
                        type: "email",
                        placeholder: "Enter your email",
                        value: email,
                        error: emailError.length > 0,
                        errorMessage: emailError,
                        onChange: (e)=>{
                            setEmail(e.target.value);
                        },
                        onBlur: ()=>setEmailError((0, $33ayT.validateEmail)(email)),
                        onFocus: ()=>setEmailError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $AJU9t.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "Send password reset",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: ((loading, delay)=>{
                            // if loading render the loader
                            if (loading) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                width: 50,
                                height: 20,
                                appearance: "primary"
                            });
                            // if send delayed render the delay count
                            if (delay > 0) return `${delay}`;
                            return `Send`;
                        })(authLoading, sendDelay)
                    })
                })
            ]
        })
    });
};
$70dbbcef7db152e0$export$f4a155c4515f44cf.propTypes = {};

});
parcelRegister("AJU9t", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ab9685ae7bec73e3$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $ab9685ae7bec73e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ab9685ae7bec73e3$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $ab9685ae7bec73e3$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                email: $ab9685ae7bec73e3$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("1UzjS", function(module, exports) {

$parcel$export(module.exports, "SignupForm", function () { return $ca0b2f0ac1db1ad1$export$cc15cfe224a6a69b; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2sNJT = parcelRequire("2sNJT");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("5L9fE");
var $JcGe6 = parcelRequire("JcGe6");

var $camiC = parcelRequire("camiC");
const $ca0b2f0ac1db1ad1$export$cc15cfe224a6a69b = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authLoading = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectLoading));
    const [email, setEmail] = (0, $exYeM.useState)("");
    const [emailError, setEmailError] = (0, $exYeM.useState)("");
    const [password, setPassword] = (0, $exYeM.useState)("");
    const [passwordError, setPasswordError] = (0, $exYeM.useState)("");
    const [repeatPassword, setRepeatPassword] = (0, $exYeM.useState)("");
    const [repeatPasswordError, setRepeatPasswordError] = (0, $exYeM.useState)("");
    const submitDisabled = email.length < 4 || password.length < 6 || repeatPassword.length < 6 || emailError !== "" || passwordError !== "" || repeatPasswordError !== "" || authLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $camiC.styles)().form.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $camiC.styles)().form.title.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $camiC.styles)().form.title.text,
                    children: "Sign up with email and password"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
                css: (0, $camiC.styles)().form.content.main,
                onSubmit: (e)=>{
                    e.preventDefault();
                    dispatch((0, $2sNJT.authSignupWithEmailAndPassword)({
                        email: email,
                        password: password
                    }));
                },
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $camiC.styles)().form.content.email,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $JcGe6.FormInput), {
                            name: "email",
                            label: "email",
                            type: "email",
                            placeholder: "Enter your email",
                            value: email,
                            error: emailError.length > 0,
                            errorMessage: emailError,
                            onChange: (e)=>{
                                setEmail(e.target.value);
                            },
                            onBlur: ()=>setEmailError((0, $33ayT.validateEmail)(email)),
                            onFocus: ()=>setEmailError("")
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $camiC.styles)().form.content.password,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $JcGe6.FormInput), {
                            name: "password",
                            label: "password",
                            type: "password",
                            placeholder: "Create a password",
                            value: password,
                            error: passwordError.length > 0,
                            errorMessage: passwordError,
                            onChange: (e)=>{
                                setPassword(e.target.value);
                            },
                            onBlur: ()=>setPasswordError((0, $33ayT.validatePassword)(password)),
                            onFocus: ()=>setPasswordError("")
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $camiC.styles)().form.content.repeat,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $JcGe6.FormInput), {
                            name: "repeat password",
                            label: "repeat password",
                            type: "password",
                            placeholder: "Repeat password",
                            value: repeatPassword,
                            error: repeatPasswordError.length > 0,
                            errorMessage: repeatPasswordError,
                            onChange: (e)=>{
                                setRepeatPassword(e.target.value);
                            },
                            onBlur: ()=>setRepeatPasswordError((0, $33ayT.validateRepeatPassword)(password, repeatPassword)),
                            onFocus: ()=>setRepeatPasswordError("")
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $camiC.styles)().form.content.submit,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                            type: "submit",
                            "aria-label": "sign up",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: authLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                width: 50,
                                height: 20,
                                appearance: "primary"
                            }) : "Sign up"
                        })
                    })
                ]
            })
        ]
    });
};
$ca0b2f0ac1db1ad1$export$cc15cfe224a6a69b.propTypes = {};

});
parcelRegister("camiC", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $40586dbc57dd479d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $40586dbc57dd479d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $40586dbc57dd479d$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $40586dbc57dd479d$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $40586dbc57dd479d$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $40586dbc57dd479d$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $40586dbc57dd479d$var$_ref5 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $40586dbc57dd479d$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            title: {
                main: $40586dbc57dd479d$var$_ref5,
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;text-align:center;", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                email: $40586dbc57dd479d$var$_ref4,
                password: $40586dbc57dd479d$var$_ref3,
                repeat: $40586dbc57dd479d$var$_ref2,
                terms: $40586dbc57dd479d$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("a4kFD", function(module, exports) {

$parcel$export(module.exports, "VerificationForm", function () { return $e14907553041656d$export$12e8c6671acf18af; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $86QaR = parcelRequire("86QaR");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2sNJT = parcelRequire("2sNJT");
parcelRequire("ewAws");
var $ehFe9 = parcelRequire("ehFe9");
var $vT5yJ = parcelRequire("vT5yJ");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $4nXUT = parcelRequire("4nXUT");
const $e14907553041656d$export$12e8c6671acf18af = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authLoading = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectLoading));
    const lastResetSec = (0, $ehFe9.dateGetDifferenceSec)(parseInt((0, $vT5yJ.storageGetSentVerificationEmailDate)() || "0", 10));
    const delaySec = 30;
    const initialSendDelay = lastResetSec > delaySec ? 0 : delaySec - lastResetSec;
    const [sendDelay, setSendDelay] = (0, $exYeM.useState)(initialSendDelay);
    (0, $86QaR.useInterval)(()=>{
        if (sendDelay > 0) setSendDelay(sendDelay - 1);
    }, 1000);
    const submitDisabled = sendDelay > 0 || authLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $4nXUT.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("form", {
            css: (0, $4nXUT.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                setSendDelay(delaySec);
                dispatch((0, $2sNJT.authSendVerificationEmail)());
            },
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4nXUT.styles)().form.content.submit,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                    type: "submit",
                    "aria-label": "Send password reset",
                    disabled: submitDisabled,
                    appearance: "primary",
                    children: ((loading, delay)=>{
                        // if loading render the loader
                        if (loading) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        });
                        // if send delayed render the delay count
                        if (delay > 0) return `${delay}`;
                        return `Resend`;
                    })(authLoading, sendDelay)
                })
            })
        })
    });
};
$e14907553041656d$export$12e8c6671acf18af.propTypes = {};

});
parcelRegister("4nXUT", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0ff75153d166b6ab$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $0ff75153d166b6ab$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});




parcelRegister("3IegW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $43e28c58c19b7b89$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $43e28c58c19b7b89$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $43e28c58c19b7b89$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $43e28c58c19b7b89$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $43e28c58c19b7b89$var$_ref3 = {
    name: "17vc17s",
    styles: "text-align:center;margin:0"
};
var $43e28c58c19b7b89$var$_ref4 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $43e28c58c19b7b89$var$_ref5 = {
    name: "1hvob47",
    styles: "display:flex;justify-content:center;margin-bottom:32px"
};
var $43e28c58c19b7b89$var$_ref6 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $43e28c58c19b7b89$var$_ref7 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $43e28c58c19b7b89$var$_ref8 = {
    name: "18vsq6y",
    styles: "margin-bottom:50px;&>button:nth-of-type(1){margin-bottom:16px;}"
};
var $43e28c58c19b7b89$var$_ref9 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $43e28c58c19b7b89$var$_ref10 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $43e28c58c19b7b89$var$_ref11 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $43e28c58c19b7b89$var$_ref12 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $43e28c58c19b7b89$var$_ref13 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $43e28c58c19b7b89$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($43e28c58c19b7b89$var$_ref13), " ", (0, $48E0n.mq).mobile($43e28c58c19b7b89$var$_ref12), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($43e28c58c19b7b89$var$_ref11), ";", ""),
            title: $43e28c58c19b7b89$var$_ref10,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($43e28c58c19b7b89$var$_ref9), ";", ""),
                login: $43e28c58c19b7b89$var$_ref8,
                form: $43e28c58c19b7b89$var$_ref7,
                error: $43e28c58c19b7b89$var$_ref6,
                reset: {
                    main: $43e28c58c19b7b89$var$_ref5,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                signup: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:center;", (0, $48E0n.mq).mobile($43e28c58c19b7b89$var$_ref4), ";", ""),
                    title: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:8px;", (0, $48E0n.mq).mobile($43e28c58c19b7b89$var$_ref3), ";", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    top: $43e28c58c19b7b89$var$_ref2,
                    bottom: $43e28c58c19b7b89$var$_ref
                }
            }
        }
    });

});


parcelRegister("bEWRX", function(module, exports) {

$parcel$export(module.exports, "ResetCard", function () { return $e02a33f4b4639e88$export$82ff2ce32135a9e4; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
parcelRequire("15Ysq");
var $4JVEl = parcelRequire("4JVEl");
var $c2gse = parcelRequire("c2gse");
var $6CqyH = parcelRequire("6CqyH");

var $66XF5 = parcelRequire("66XF5");
const $e02a33f4b4639e88$export$82ff2ce32135a9e4 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authError = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $66XF5.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $66XF5.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $fAzHC.authCloseResetModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $66XF5.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $c2gse.CardTitle), {
                    title: "Reset password"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $66XF5.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $66XF5.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6CqyH.ResetForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $66XF5.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $66XF5.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4JVEl.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $66XF5.styles)(theme).card.content.login.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $66XF5.styles)(theme).card.content.login.button,
                            onClick: ()=>{
                                dispatch((0, $fAzHC.authCloseResetModal)());
                                dispatch((0, $fAzHC.authOpenLoginModal)());
                            },
                            type: "button",
                            "aria-label": "log in",
                            children: "Log in to RYDDM"
                        })
                    })
                ]
            })
        ]
    });
};
$e02a33f4b4639e88$export$82ff2ce32135a9e4.propTypes = {};

});
parcelRegister("66XF5", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4692b9598d2940df$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $4692b9598d2940df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4692b9598d2940df$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $4692b9598d2940df$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $4692b9598d2940df$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $4692b9598d2940df$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $4692b9598d2940df$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4692b9598d2940df$var$_ref6 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $4692b9598d2940df$var$_ref7 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $4692b9598d2940df$var$_ref8 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $4692b9598d2940df$var$_ref9 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $4692b9598d2940df$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($4692b9598d2940df$var$_ref9), " ", (0, $48E0n.mq).mobile($4692b9598d2940df$var$_ref8), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($4692b9598d2940df$var$_ref7), ";", ""),
            title: $4692b9598d2940df$var$_ref6,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($4692b9598d2940df$var$_ref5), ";", ""),
                form: $4692b9598d2940df$var$_ref4,
                error: $4692b9598d2940df$var$_ref3,
                login: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:center;", (0, $48E0n.mq).mobile($4692b9598d2940df$var$_ref2), ";", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    bottom: $4692b9598d2940df$var$_ref
                }
            }
        }
    });

});


parcelRegister("fDPPm", function(module, exports) {

$parcel$export(module.exports, "SignupCard", function () { return $bb71723abee47d20$export$8581c745ab20309b; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2sNJT = parcelRequire("2sNJT");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
parcelRequire("15Ysq");
var $6Hgxx = parcelRequire("6Hgxx");
var $4JVEl = parcelRequire("4JVEl");
var $c2gse = parcelRequire("c2gse");
var $1UzjS = parcelRequire("1UzjS");

var $9ThrL = parcelRequire("9ThrL");
const $bb71723abee47d20$export$8581c745ab20309b = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authLoading = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectLoading));
    const authError = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9ThrL.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9ThrL.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $fAzHC.authCloseSignupModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9ThrL.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $c2gse.CardTitle), {
                    title: "Sign up to RYDDM for free",
                    accentStart: 11,
                    accentEnd: 16
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $9ThrL.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $9ThrL.styles)(theme).card.content.signup,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6Hgxx.CardButton), {
                                onClick: ()=>dispatch((0, $2sNJT.authLoginWithGoogle)()),
                                disabled: authLoading,
                                idp: "google",
                                text: "Continue with Google",
                                "aria-label": "login with google"
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6Hgxx.CardButton), {
                                onClick: ()=>dispatch((0, $2sNJT.authLoginWithFacebook)()),
                                disabled: authLoading,
                                idp: "facebook",
                                text: "Continue with Facebook",
                                "aria-label": "login with facebook"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9ThrL.styles)(theme).card.content.divider.top,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4JVEl.CardDivider), {
                            text: "or"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9ThrL.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1UzjS.SignupForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9ThrL.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9ThrL.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4JVEl.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $9ThrL.styles)(theme).card.content.login.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                css: (0, $9ThrL.styles)(theme).card.content.login.title,
                                children: "Already have account?"
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                css: (0, $9ThrL.styles)(theme).card.content.login.button,
                                onClick: ()=>{
                                    dispatch((0, $fAzHC.authCloseSignupModal)());
                                    dispatch((0, $fAzHC.authOpenLoginModal)());
                                },
                                type: "button",
                                "aria-label": "sign up",
                                children: "Log in to RYDDM"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$bb71723abee47d20$export$8581c745ab20309b.propTypes = {};

});
parcelRegister("9ThrL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7051e0af36edb598$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7051e0af36edb598$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7051e0af36edb598$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $7051e0af36edb598$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $7051e0af36edb598$var$_ref3 = {
    name: "17vc17s",
    styles: "text-align:center;margin:0"
};
var $7051e0af36edb598$var$_ref4 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $7051e0af36edb598$var$_ref5 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $7051e0af36edb598$var$_ref6 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $7051e0af36edb598$var$_ref7 = {
    name: "18vsq6y",
    styles: "margin-bottom:50px;&>button:nth-of-type(1){margin-bottom:16px;}"
};
var $7051e0af36edb598$var$_ref8 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7051e0af36edb598$var$_ref9 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $7051e0af36edb598$var$_ref10 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $7051e0af36edb598$var$_ref11 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $7051e0af36edb598$var$_ref12 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $7051e0af36edb598$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($7051e0af36edb598$var$_ref12), " ", (0, $48E0n.mq).mobile($7051e0af36edb598$var$_ref11), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($7051e0af36edb598$var$_ref10), ";", ""),
            title: $7051e0af36edb598$var$_ref9,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($7051e0af36edb598$var$_ref8), ";", ""),
                signup: $7051e0af36edb598$var$_ref7,
                form: $7051e0af36edb598$var$_ref6,
                error: $7051e0af36edb598$var$_ref5,
                login: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:center;", (0, $48E0n.mq).mobile($7051e0af36edb598$var$_ref4), ";", ""),
                    title: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:8px;", (0, $48E0n.mq).mobile($7051e0af36edb598$var$_ref3), ";", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    top: $7051e0af36edb598$var$_ref2,
                    bottom: $7051e0af36edb598$var$_ref
                }
            }
        }
    });

});


parcelRegister("5IjPV", function(module, exports) {

$parcel$export(module.exports, "VerificationCard", function () { return $2cb8534f0e1347f8$export$4fab1ccea936c245; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2sNJT = parcelRequire("2sNJT");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
parcelRequire("15Ysq");
var $4JVEl = parcelRequire("4JVEl");
var $c2gse = parcelRequire("c2gse");
var $a4kFD = parcelRequire("a4kFD");

var $4cgNW = parcelRequire("4cgNW");
const $2cb8534f0e1347f8$export$4fab1ccea936c245 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const authError = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectError));
    const authProfile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $4cgNW.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4cgNW.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>{},
                    hideClose: true
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4cgNW.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $c2gse.CardTitle), {
                    title: "Please check your email"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $4cgNW.styles)(theme).card.subtitle.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $4cgNW.styles)(theme).card.subtitle.text,
                        children: `We've sent a confirmation link to your email:`
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $4cgNW.styles)(theme).card.subtitle.email,
                        children: authProfile?.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $4cgNW.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4cgNW.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $a4kFD.VerificationForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4cgNW.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4cgNW.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4JVEl.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4cgNW.styles)(theme).card.content.login.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $4cgNW.styles)(theme).card.content.login.button,
                            onClick: ()=>dispatch((0, $2sNJT.authSignout)()),
                            type: "button",
                            "aria-label": "log out",
                            children: "Log out"
                        })
                    })
                ]
            })
        ]
    });
};
$2cb8534f0e1347f8$export$4fab1ccea936c245.propTypes = {};

});
parcelRegister("4cgNW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $001b78deaa3ca6a5$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $001b78deaa3ca6a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $001b78deaa3ca6a5$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $001b78deaa3ca6a5$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $001b78deaa3ca6a5$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $001b78deaa3ca6a5$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $001b78deaa3ca6a5$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $001b78deaa3ca6a5$var$_ref6 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $001b78deaa3ca6a5$var$_ref7 = {
    name: "vhzsvc",
    styles: "display:flex;flex-direction:column;text-align:center;margin-bottom:32px"
};
var $001b78deaa3ca6a5$var$_ref8 = {
    name: "j9ove5",
    styles: "margin-bottom:22px"
};
var $001b78deaa3ca6a5$var$_ref9 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $001b78deaa3ca6a5$var$_ref10 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $001b78deaa3ca6a5$var$_ref11 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $001b78deaa3ca6a5$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($001b78deaa3ca6a5$var$_ref11), " ", (0, $48E0n.mq).mobile($001b78deaa3ca6a5$var$_ref10), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($001b78deaa3ca6a5$var$_ref9), ";", ""),
            title: $001b78deaa3ca6a5$var$_ref8,
            subtitle: {
                main: $001b78deaa3ca6a5$var$_ref7,
                text: $001b78deaa3ca6a5$var$_ref6,
                email: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";color:", theme.colors.accent.normal, ";", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($001b78deaa3ca6a5$var$_ref5), ";", ""),
                form: $001b78deaa3ca6a5$var$_ref4,
                error: $001b78deaa3ca6a5$var$_ref3,
                login: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:center;", (0, $48E0n.mq).mobile($001b78deaa3ca6a5$var$_ref2), ";", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    bottom: $001b78deaa3ca6a5$var$_ref
                }
            }
        }
    });

});




parcelRegister("jrvp7", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $48906d18da628486$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $48906d18da628486$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("kyFLX", function(module, exports) {

$parcel$export(module.exports, "AuthResetModal", function () { return $fd42eb51b927569d$export$29305173138505c3; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("3x94W");
var $bEWRX = parcelRequire("bEWRX");

var $4E9Si = parcelRequire("4E9Si");
const $fd42eb51b927569d$export$29305173138505c3 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const resetModalOpen = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectResetModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $4E9Si.styles)().modal.main,
        children: resetModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>dispatch((0, $fAzHC.authCloseResetModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bEWRX.ResetCard), {})
        })
    });
};
$fd42eb51b927569d$export$29305173138505c3.propTypes = {};

});
parcelRegister("4E9Si", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $71b4c4709acb5567$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $71b4c4709acb5567$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("4caAj", function(module, exports) {

$parcel$export(module.exports, "AuthSignupModal", function () { return $7c8ee4ac14bb2b14$export$2cdb240c8b859012; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("3x94W");
var $fDPPm = parcelRequire("fDPPm");

var $jpJ1p = parcelRequire("jpJ1p");
const $7c8ee4ac14bb2b14$export$2cdb240c8b859012 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const signupModalOpen = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectSignupModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $jpJ1p.styles)().modal.main,
        children: signupModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>dispatch((0, $fAzHC.authCloseSignupModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fDPPm.SignupCard), {})
        })
    });
};
$7c8ee4ac14bb2b14$export$2cdb240c8b859012.propTypes = {};

});
parcelRegister("jpJ1p", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $26756f9ca14abec2$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $26756f9ca14abec2$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("brpxu", function(module, exports) {

$parcel$export(module.exports, "AuthVerificationModal", function () { return $eba318d27c30d318$export$2793b46f9b27a7cb; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $86QaR = parcelRequire("86QaR");
parcelRequire("dmGpj");
var $2sNJT = parcelRequire("2sNJT");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("3x94W");
var $5IjPV = parcelRequire("5IjPV");

var $iPaUA = parcelRequire("iPaUA");
const $eba318d27c30d318$export$2793b46f9b27a7cb = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const emailVerified = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectEmailVerified));
    (0, $86QaR.useInterval)(()=>{
        if (!emailVerified) dispatch((0, $2sNJT.authCheckVerificationStatus)());
    }, 4000);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $iPaUA.styles)().modal.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>{},
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5IjPV.VerificationCard), {})
        })
    });
};
$eba318d27c30d318$export$2793b46f9b27a7cb.propTypes = {};

});
parcelRegister("iPaUA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $957f44e8529e716f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $957f44e8529e716f$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});




parcelRegister("fAzHC", function(module, exports) {

$parcel$export(module.exports, "authSlice", function () { return $b944cbd99d3238d8$export$a4617a4027bb509b; });
$parcel$export(module.exports, "authUpdateProfile", function () { return $b944cbd99d3238d8$export$2193180e69fc5c9b; });
$parcel$export(module.exports, "authOpenJoinModal", function () { return $b944cbd99d3238d8$export$a44d995955acf6fe; });
$parcel$export(module.exports, "authCloseJoinModal", function () { return $b944cbd99d3238d8$export$af6daf84c0435a87; });
$parcel$export(module.exports, "authOpenLoginModal", function () { return $b944cbd99d3238d8$export$2f3d09f176ff02e3; });
$parcel$export(module.exports, "authCloseLoginModal", function () { return $b944cbd99d3238d8$export$d5a50ff831f0adc5; });
$parcel$export(module.exports, "authOpenResetModal", function () { return $b944cbd99d3238d8$export$9e56764caac8044c; });
$parcel$export(module.exports, "authCloseResetModal", function () { return $b944cbd99d3238d8$export$90bd896eca8cebff; });
$parcel$export(module.exports, "authOpenSignupModal", function () { return $b944cbd99d3238d8$export$d53f523c53c6f9b2; });
$parcel$export(module.exports, "authCloseSignupModal", function () { return $b944cbd99d3238d8$export$2ab011e3e0b7ad7f; });
$parcel$export(module.exports, "authSetPlatformUnlocked", function () { return $b944cbd99d3238d8$export$5f89e63975dcdea6; });
$parcel$export(module.exports, "authSelectProfile", function () { return $b944cbd99d3238d8$export$3bb8b93c38c5261d; });
$parcel$export(module.exports, "authSelectProfileAvatar", function () { return $b944cbd99d3238d8$export$3ced2c24a889e1ae; });
$parcel$export(module.exports, "authSelectEmailVerified", function () { return $b944cbd99d3238d8$export$81be7dfdceb313f9; });
$parcel$export(module.exports, "authSelectRefreshing", function () { return $b944cbd99d3238d8$export$9ec47880503f4133; });
$parcel$export(module.exports, "authSelectPlatformLocked", function () { return $b944cbd99d3238d8$export$22fef9034c0b6f2d; });
$parcel$export(module.exports, "authSelectJoinModalOpen", function () { return $b944cbd99d3238d8$export$e635316c57f599f7; });
$parcel$export(module.exports, "authSelectLoginModalOpen", function () { return $b944cbd99d3238d8$export$cc86fb31ea9f1a0c; });
$parcel$export(module.exports, "authSelectResetModalOpen", function () { return $b944cbd99d3238d8$export$17b9074ad23d9db3; });
$parcel$export(module.exports, "authSelectSignupModalOpen", function () { return $b944cbd99d3238d8$export$a0ab782f787ce114; });
$parcel$export(module.exports, "authSelectLoading", function () { return $b944cbd99d3238d8$export$c8a5cb343ec50b5d; });
$parcel$export(module.exports, "authSelectError", function () { return $b944cbd99d3238d8$export$46dda0454b918137; });
$parcel$export(module.exports, "authReducer", function () { return $b944cbd99d3238d8$export$b3aa4dbb59e7857d; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $2sNJT = parcelRequire("2sNJT");
const $b944cbd99d3238d8$var$initialState = {
    profile: null,
    emailVerified: false,
    refreshing: true,
    joinModal: {
        open: false
    },
    loginModal: {
        open: false
    },
    resetModal: {
        open: false
    },
    signupModal: {
        open: false
    },
    platformLocked: true,
    error: "",
    loading: false
};
const $b944cbd99d3238d8$export$a4617a4027bb509b = (0, $dEr3t.createSlice)({
    name: "auth",
    initialState: $b944cbd99d3238d8$var$initialState,
    reducers: {
        // update profile
        authUpdateProfile: (state, action)=>({
                ...state,
                profile: action.payload
            }),
        // open join modal
        authOpenJoinModal: (state)=>({
                ...state,
                joinModal: {
                    open: true
                }
            }),
        // close join modal
        authCloseJoinModal: (state)=>({
                ...state,
                joinModal: {
                    open: false
                }
            }),
        // open login modal
        authOpenLoginModal: (state)=>({
                ...state,
                error: "",
                loginModal: {
                    open: true
                }
            }),
        // close login modal
        authCloseLoginModal: (state)=>({
                ...state,
                loginModal: {
                    open: false
                }
            }),
        // open reset modal
        authOpenResetModal: (state)=>({
                ...state,
                error: "",
                resetModal: {
                    open: true
                }
            }),
        // close reset modal
        authCloseResetModal: (state)=>({
                ...state,
                resetModal: {
                    open: false
                }
            }),
        // open signup modal
        authOpenSignupModal: (state)=>({
                ...state,
                error: "",
                signupModal: {
                    open: true
                }
            }),
        // close signup modal
        authCloseSignupModal: (state)=>({
                ...state,
                signupModal: {
                    open: false
                }
            }),
        // unlock platform
        authSetPlatformUnlocked: (state)=>({
                ...state,
                platformLocked: false
            })
    },
    extraReducers: (builder)=>{
        // authenticate user
        builder.addCase((0, $2sNJT.authAuthenticateUser).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authAuthenticateUser).fulfilled, (state, { payload: payload })=>({
                ...state,
                profile: payload.profile,
                emailVerified: payload.emailVerified,
                error: payload.error,
                loading: false
            }));
        // refresh
        builder.addCase((0, $2sNJT.authRefresh).pending, (state)=>({
                ...state,
                loading: true,
                refreshing: true
            })).addCase((0, $2sNJT.authRefresh).fulfilled, (state, { payload: payload })=>({
                ...state,
                profile: payload.profile,
                emailVerified: payload.emailVerified,
                error: payload.error,
                loading: false,
                refreshing: false
            }));
        // sign up with email and password
        builder.addCase((0, $2sNJT.authSignupWithEmailAndPassword).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authSignupWithEmailAndPassword).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // log in with email and password
        builder.addCase((0, $2sNJT.authLoginWithEmailAndPassword).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authLoginWithEmailAndPassword).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // log in with google
        builder.addCase((0, $2sNJT.authLoginWithGoogle).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authLoginWithGoogle).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // log in with facebook
        builder.addCase((0, $2sNJT.authLoginWithFacebook).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authLoginWithFacebook).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // reset password
        builder.addCase((0, $2sNJT.authSendPasswordResetEmail).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authSendPasswordResetEmail).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // verify email
        builder.addCase((0, $2sNJT.authSendVerificationEmail).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authSendVerificationEmail).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // sign out
        builder.addCase((0, $2sNJT.authSignout).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authSignout).fulfilled, (state)=>({
                ...state,
                ...$b944cbd99d3238d8$var$initialState,
                loading: false,
                refreshing: false
            }));
        // check email verification
        builder.addCase((0, $2sNJT.authCheckVerificationStatus).pending, (state)=>({
                ...state
            })).addCase((0, $2sNJT.authCheckVerificationStatus).fulfilled, (state, { payload: payload })=>({
                ...state,
                emailVerified: payload.emailVerified
            }));
        // unlock platform
        builder.addCase((0, $2sNJT.authUnlockPlatform).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $2sNJT.authUnlockPlatform).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
    }
});
const { authUpdateProfile: $b944cbd99d3238d8$export$2193180e69fc5c9b, authOpenJoinModal: $b944cbd99d3238d8$export$a44d995955acf6fe, authCloseJoinModal: $b944cbd99d3238d8$export$af6daf84c0435a87, authOpenLoginModal: $b944cbd99d3238d8$export$2f3d09f176ff02e3, authCloseLoginModal: $b944cbd99d3238d8$export$d5a50ff831f0adc5, authOpenResetModal: $b944cbd99d3238d8$export$9e56764caac8044c, authCloseResetModal: $b944cbd99d3238d8$export$90bd896eca8cebff, authOpenSignupModal: $b944cbd99d3238d8$export$d53f523c53c6f9b2, authCloseSignupModal: $b944cbd99d3238d8$export$2ab011e3e0b7ad7f, authSetPlatformUnlocked: $b944cbd99d3238d8$export$5f89e63975dcdea6 } = $b944cbd99d3238d8$export$a4617a4027bb509b.actions;
const $b944cbd99d3238d8$export$3bb8b93c38c5261d = (state)=>state.auth.profile;
const $b944cbd99d3238d8$export$3ced2c24a889e1ae = (state)=>state.auth.profile?.avatarId;
const $b944cbd99d3238d8$export$81be7dfdceb313f9 = (state)=>state.auth.emailVerified;
const $b944cbd99d3238d8$export$9ec47880503f4133 = (state)=>state.auth.refreshing;
const $b944cbd99d3238d8$export$22fef9034c0b6f2d = (state)=>state.auth.platformLocked;
const $b944cbd99d3238d8$export$e635316c57f599f7 = (state)=>state.auth.joinModal.open;
const $b944cbd99d3238d8$export$cc86fb31ea9f1a0c = (state)=>state.auth.loginModal.open;
const $b944cbd99d3238d8$export$17b9074ad23d9db3 = (state)=>state.auth.resetModal.open;
const $b944cbd99d3238d8$export$a0ab782f787ce114 = (state)=>state.auth.signupModal.open;
const $b944cbd99d3238d8$export$c8a5cb343ec50b5d = (state)=>state.auth.loading;
const $b944cbd99d3238d8$export$46dda0454b918137 = (state)=>state.auth.error;
const $b944cbd99d3238d8$export$b3aa4dbb59e7857d = $b944cbd99d3238d8$export$a4617a4027bb509b.reducer; // export default authSlice.reducer

});

parcelRegister("2sNJT", function(module, exports) {

$parcel$export(module.exports, "authAuthenticateUser", function () { return $4f664df5eb86ca09$export$3914058f8bb10993; });
$parcel$export(module.exports, "authRefresh", function () { return $4f664df5eb86ca09$export$f7c93eeb6ca3335b; });
$parcel$export(module.exports, "authSignupWithEmailAndPassword", function () { return $4f664df5eb86ca09$export$ecb9a44d05b171e6; });
$parcel$export(module.exports, "authLoginWithEmailAndPassword", function () { return $4f664df5eb86ca09$export$bb3e78703faa1054; });
$parcel$export(module.exports, "authLoginWithGoogle", function () { return $4f664df5eb86ca09$export$78ad7a7adb7c19fe; });
$parcel$export(module.exports, "authLoginWithFacebook", function () { return $4f664df5eb86ca09$export$7d108d78f207b530; });
$parcel$export(module.exports, "authSendPasswordResetEmail", function () { return $4f664df5eb86ca09$export$14c18d9c8a72a983; });
$parcel$export(module.exports, "authSendVerificationEmail", function () { return $4f664df5eb86ca09$export$6d4db7f58939d274; });
$parcel$export(module.exports, "authSignout", function () { return $4f664df5eb86ca09$export$609a29e630c259c9; });
$parcel$export(module.exports, "authCheckVerificationStatus", function () { return $4f664df5eb86ca09$export$78b89752e463380f; });
$parcel$export(module.exports, "authUnlockPlatform", function () { return $4f664df5eb86ca09$export$d058694af390bb5a; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $uiU92 = parcelRequire("uiU92");
var $hIwjn = parcelRequire("hIwjn");
var $MokZU = parcelRequire("MokZU");
var $b0u33 = parcelRequire("b0u33");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
var $gQ3GG = parcelRequire("gQ3GG");
var $lLftU = parcelRequire("lLftU");
var $vT5yJ = parcelRequire("vT5yJ");
const $4f664df5eb86ca09$export$3914058f8bb10993 = (0, $dEr3t.createAsyncThunk)("auth/authAuthenticateUser", async (inp, { dispatch: dispatch })=>{
    // get api service
    let api = (0, $jfr0f.apiGetService)();
    try {
        // exchange auth token
        const { token: token } = await api.authApi.exchangeToken({
            authToken: inp.idToken
        });
        // save token to local storage
        (0, $vT5yJ.storageSetAuthToken)(token);
        // update api service with auth token
        api = api.updateApiKey(token);
        // get subscribed user ids
        dispatch((0, $MokZU.subscriptionGetSubscribedUserIds)());
        dispatch((0, $MokZU.subscriptionGetSubscribedAtPeriodEndUserIds)());
        // get unlocked entity ids
        dispatch((0, $b0u33.unlockGetUnlockedPostIds)());
        dispatch((0, $b0u33.unlockGetUnlockedTrackIds)());
        // get liked entity ids
        dispatch((0, $9ybfS.likeGetFollowedUserIds)());
        dispatch((0, $9ybfS.likeGetLikedPostIds)());
        dispatch((0, $9ybfS.likeGetLikedTrackIds)());
        dispatch((0, $9ybfS.likeGetLikedCommentIds)());
        // get notification unread count
        dispatch((0, $uiU92.notificationGetNotificationsUnreadCount)());
        // fetch user profile
        const { user: user } = await api.userApi.getUserProfile();
        // if onboarding is not finished
        if (user?.onboardingStage !== (0, $aeAwZ.EntityOnboardingStage).Finished) {
            const userRole = user?.role;
            const currentOnboardingStage = user?.onboardingStage;
            // set appropriate onboarding step for stepper
            dispatch((0, $hIwjn.onboardingSetCurrentStep)({
                userRole: userRole,
                currentOnboardingStage: currentOnboardingStage
            }));
        }
        // return profile and token in payload
        return {
            profile: user || {},
            emailVerified: inp.emailVerified,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            profile: null,
            emailVerified: false,
            error: message
        };
    }
});
const $4f664df5eb86ca09$export$f7c93eeb6ca3335b = (0, $dEr3t.createAsyncThunk)("auth/authRefresh", async (_, { dispatch: dispatch })=>{
    // get auth token from storage
    const tokenFromStorage = (0, $vT5yJ.storageGetAuthToken)();
    // if no token in local storage
    if (!tokenFromStorage) // return empty payload (sign user out)
    return {
        profile: null,
        emailVerified: false,
        error: ""
    };
    // decode token
    const decodedToken = (0, $lLftU.jwtDecode)(tokenFromStorage);
    // calculate token expiration
    const expiresInDays = (0, $lLftU.jwtGetExpiresInDays)(decodedToken);
    const tokenExpired = expiresInDays <= 0;
    const tokenExpiresSoon = expiresInDays > 0 && expiresInDays <= 7;
    // check if email is verified
    const { emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $gQ3GG.firebaseGetEmailVerified)();
    // if error occurred
    if (errorMessage) // return empty payload (sign user out)
    return {
        profile: null,
        emailVerified: false,
        error: errorMessage
    };
    // get api service
    let api = (0, $jfr0f.apiGetService)();
    // if token is expired
    if (tokenExpired) {
        // clean local storage
        (0, $vT5yJ.storageSetAuthToken)("");
        // return empty payload (sign user out)
        return {
            profile: null,
            emailVerified: false,
            error: ""
        };
    }
    try {
        // if token expires soon (in 7 days or less)
        if (tokenExpiresSoon) {
            // refresh token
            const { token: freshToken } = await api.authApi.refreshToken();
            // update token in local storage
            (0, $vT5yJ.storageSetAuthToken)(freshToken);
            // update token in api service
            api = api.updateApiKey(freshToken);
        }
        // get subscribed user ids
        dispatch((0, $MokZU.subscriptionGetSubscribedUserIds)());
        dispatch((0, $MokZU.subscriptionGetSubscribedAtPeriodEndUserIds)());
        // get unlocked entity ids
        dispatch((0, $b0u33.unlockGetUnlockedPostIds)());
        dispatch((0, $b0u33.unlockGetUnlockedTrackIds)());
        // get liked entity ids
        dispatch((0, $9ybfS.likeGetFollowedUserIds)());
        dispatch((0, $9ybfS.likeGetLikedPostIds)());
        dispatch((0, $9ybfS.likeGetLikedTrackIds)());
        dispatch((0, $9ybfS.likeGetLikedCommentIds)());
        // get notification unread count
        dispatch((0, $uiU92.notificationGetNotificationsUnreadCount)());
        // fetch profile
        const { user: user } = await api.userApi.getUserProfile();
        // if onboarding is not finished
        if (user?.onboardingStage !== (0, $aeAwZ.EntityOnboardingStage).Finished) {
            const userRole = user?.role;
            const currentOnboardingStage = user?.onboardingStage;
            // set appropriate onboarding step for stepper
            dispatch((0, $hIwjn.onboardingSetCurrentStep)({
                userRole: userRole,
                currentOnboardingStage: currentOnboardingStage
            }));
        }
        // return profile and token in payload
        return {
            profile: user || {},
            emailVerified: emailVerified,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            profile: null,
            emailVerified: false,
            error: message
        };
    }
});
const $4f664df5eb86ca09$export$ecb9a44d05b171e6 = (0, $dEr3t.createAsyncThunk)("auth/authSignupWithEmailAndPassword", async (inp, { dispatch: dispatch })=>{
    // firebase sign up with email and password
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $gQ3GG.firebaseSignupWithEmailAndPassword)(inp.email, inp.password);
    // update trigger date
    (0, $vT5yJ.storageSetSentVerificationEmailDate)(Date.now().toString());
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($4f664df5eb86ca09$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $4f664df5eb86ca09$export$bb3e78703faa1054 = (0, $dEr3t.createAsyncThunk)("auth/authLoginWithEmailAndPassword", async (inp, { dispatch: dispatch })=>{
    // firebase login with email and password
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $gQ3GG.firebaseLoginWithEmailAndPassword)(inp.email, inp.password);
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($4f664df5eb86ca09$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $4f664df5eb86ca09$export$78ad7a7adb7c19fe = (0, $dEr3t.createAsyncThunk)("auth/authLoginWithGoogle", async (_, { dispatch: dispatch })=>{
    // firebase login with google
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $gQ3GG.firebaseLoginWithGoogle)();
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($4f664df5eb86ca09$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $4f664df5eb86ca09$export$7d108d78f207b530 = (0, $dEr3t.createAsyncThunk)("auth/authLoginWithFacebook", async (_, { dispatch: dispatch })=>{
    // firebase login with facebook
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $gQ3GG.firebaseLoginWithFacebook)();
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($4f664df5eb86ca09$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $4f664df5eb86ca09$export$14c18d9c8a72a983 = (0, $dEr3t.createAsyncThunk)("auth/authSendPasswordResetEmail", async (inp)=>{
    // firebase send password reset email
    const { errorMessage: errorMessage } = await (0, $gQ3GG.firebaseSendPasswordResetEmail)(inp.email);
    // update trigger date
    (0, $vT5yJ.storageSetSentPasswordResetEmailDate)(Date.now().toString());
    return {
        error: errorMessage
    };
});
const $4f664df5eb86ca09$export$6d4db7f58939d274 = (0, $dEr3t.createAsyncThunk)("auth/authSendVerificationEmail", async ()=>{
    // firebase send verification email
    const { errorMessage: errorMessage } = await (0, $gQ3GG.firebaseSendVerificationEmail)();
    // update trigger date
    (0, $vT5yJ.storageSetSentVerificationEmailDate)(Date.now().toString());
    return {
        error: errorMessage
    };
});
const $4f664df5eb86ca09$export$609a29e630c259c9 = (0, $dEr3t.createAsyncThunk)("auth/authSignout", async ()=>{
    // firebase sign out
    const { errorMessage: errorMessage } = await (0, $gQ3GG.firebaseSignout)();
    // clean up token from local storage
    (0, $vT5yJ.storageSetAuthToken)("");
    // state is reset in authSignout.fulfilled
    // return error message in payload
    return {
        error: errorMessage
    };
});
const $4f664df5eb86ca09$export$78b89752e463380f = (0, $dEr3t.createAsyncThunk)("auth/authCheckVerificationStatus", async ()=>{
    // check email verification status
    const { emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $gQ3GG.firebaseGetEmailVerified)();
    return {
        emailVerified: emailVerified,
        error: errorMessage
    };
});
const $4f664df5eb86ca09$export$d058694af390bb5a = (0, $dEr3t.createAsyncThunk)("auth/authUnlockPlatform", async (inp, { dispatch: dispatch })=>{
    // assert passphrase
    const passphrase = "ryddm2024";
    if (inp.passphrase === passphrase) {
        dispatch((0, $fAzHC.authSetPlatformUnlocked)());
        return {
            error: ""
        };
    }
    return {
        error: "Invalid passphrase"
    };
});

});


parcelRegister("7a12w", function(module, exports) {

$parcel$export(module.exports, "CommentBlockModal", function () { return (parcelRequire("15K74")).CommentBlockModal; });
$parcel$export(module.exports, "CommentCard", function () { return (parcelRequire("lvFQG")).CommentCard; });
$parcel$export(module.exports, "CommentDeleteModal", function () { return (parcelRequire("9nwQh")).CommentDeleteModal; });
$parcel$export(module.exports, "CommentListPost", function () { return (parcelRequire("1BfGm")).CommentListPost; });
parcelRequire("gWvqr");
var $15K74 = parcelRequire("15K74");
var $lvFQG = parcelRequire("lvFQG");
var $9nwQh = parcelRequire("9nwQh");
var $1BfGm = parcelRequire("1BfGm");

var $lWbfW = parcelRequire("lWbfW");

var $kCfD8 = parcelRequire("kCfD8");
$parcel$exportWildcard(module.exports, $lWbfW);
$parcel$exportWildcard(module.exports, $kCfD8);

});
parcelRegister("gWvqr", function(module, exports) {

$parcel$export(module.exports, "CommentBlockModal", function () { return (parcelRequire("15K74")).CommentBlockModal; });
$parcel$export(module.exports, "CommentCard", function () { return (parcelRequire("lvFQG")).CommentCard; });
$parcel$export(module.exports, "CommentDeleteModal", function () { return (parcelRequire("9nwQh")).CommentDeleteModal; });
$parcel$export(module.exports, "CommentListPost", function () { return (parcelRequire("1BfGm")).CommentListPost; });

var $15K74 = parcelRequire("15K74");

var $lvFQG = parcelRequire("lvFQG");

var $9nwQh = parcelRequire("9nwQh");

var $1BfGm = parcelRequire("1BfGm");

});
parcelRegister("15K74", function(module, exports) {

$parcel$export(module.exports, "CommentBlockModal", function () { return $2f1e97d0c5817454$export$ad2878f8a39f20db; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $lWbfW = parcelRequire("lWbfW");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("2rRvn");
var $8RoB5 = parcelRequire("8RoB5");

var $lENHQ = parcelRequire("lENHQ");
const $2f1e97d0c5817454$export$ad2878f8a39f20db = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const blockCommentModalOpen = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentBlockModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lENHQ.styles)().modal.main,
        children: blockCommentModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $lWbfW.commentCloseCommentBlockModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lENHQ.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8RoB5.CommentBlockCard), {})
            })
        })
    });
};
$2f1e97d0c5817454$export$ad2878f8a39f20db.propTypes = {};

});
parcelRegister("2rRvn", function(module, exports) {

$parcel$export(module.exports, "CommentBlockCard", function () { return (parcelRequire("8RoB5")).CommentBlockCard; });

var $8RoB5 = parcelRequire("8RoB5");

});
parcelRegister("8RoB5", function(module, exports) {

$parcel$export(module.exports, "CommentBlockCard", function () { return $65aa78b88a1fffcf$export$ac6e9c123167ba02; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $lWbfW = parcelRequire("lWbfW");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("ajv4R");
var $faKxD = parcelRequire("faKxD");

var $5mOuW = parcelRequire("5mOuW");
const $65aa78b88a1fffcf$export$ac6e9c123167ba02 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const commentBlockError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $5mOuW.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5mOuW.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $lWbfW.commentCloseCommentBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5mOuW.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Block Comment",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5mOuW.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Are you sure you want to block this comment?"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $5mOuW.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5mOuW.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $faKxD.CommentBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5mOuW.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: commentBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$65aa78b88a1fffcf$export$ac6e9c123167ba02.propTypes = {};

});
parcelRegister("ajv4R", function(module, exports) {

$parcel$export(module.exports, "CommentBlockForm", function () { return (parcelRequire("faKxD")).CommentBlockForm; });

var $faKxD = parcelRequire("faKxD");

});
parcelRegister("faKxD", function(module, exports) {

$parcel$export(module.exports, "CommentBlockForm", function () { return $db835d59f78d1ace$export$fd64a2f495d11aa8; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("fNyrl");
var $3gmqG = parcelRequire("3gmqG");
parcelRequire("dmGpj");
var $kCfD8 = parcelRequire("kCfD8");
var $lWbfW = parcelRequire("lWbfW");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $3CxfD = parcelRequire("3CxfD");
const $db835d59f78d1ace$export$fd64a2f495d11aa8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const commentBlockLoading = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentBlockLoading));
    const comment = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentBlockModalComment));
    const { message: message } = comment ?? {};
    const maxCommentMessageDisplayLength = 88;
    const submitDisabled = commentBlockLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $3CxfD.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $3CxfD.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $kCfD8.commentBlock)({
                    id: comment?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $3CxfD.styles)().form.content.message,
                    children: (0, $3gmqG.stringsCutter)(maxCommentMessageDisplayLength, message || "")
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $3CxfD.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block comment",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: commentBlockLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$db835d59f78d1ace$export$fd64a2f495d11aa8.propTypes = {};

});
parcelRegister("3CxfD", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9a373c531ea6d65d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $9a373c531ea6d65d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9a373c531ea6d65d$var$_ref = {
    name: "q0fhfi",
    styles: "text-align:center;word-wrap:break-word;overflow:hidden;margin-bottom:24px"
};
const $9a373c531ea6d65d$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                message: $9a373c531ea6d65d$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("5mOuW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8fe5b0939accab43$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8fe5b0939accab43$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8fe5b0939accab43$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $8fe5b0939accab43$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $8fe5b0939accab43$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $8fe5b0939accab43$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8fe5b0939accab43$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8fe5b0939accab43$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $8fe5b0939accab43$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $8fe5b0939accab43$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $8fe5b0939accab43$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($8fe5b0939accab43$var$_ref8), " ", (0, $48E0n.mq).mobile($8fe5b0939accab43$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($8fe5b0939accab43$var$_ref6), ";", ""),
            title: $8fe5b0939accab43$var$_ref5,
            subtitle: $8fe5b0939accab43$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($8fe5b0939accab43$var$_ref3), ";", ""),
                form: $8fe5b0939accab43$var$_ref2,
                error: $8fe5b0939accab43$var$_ref
            }
        }
    });

});



parcelRegister("lENHQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2f5e114e3ee08eab$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $2f5e114e3ee08eab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2f5e114e3ee08eab$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $2f5e114e3ee08eab$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($2f5e114e3ee08eab$var$_ref), ";", "")
        }
    });

});


parcelRegister("lvFQG", function(module, exports) {

$parcel$export(module.exports, "CommentCard", function () { return $e8242be4aa408a69$export$bc479ee64936fcb7; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $fD6gC = parcelRequire("fD6gC");
const $e8242be4aa408a69$export$bc479ee64936fcb7 = ({ comment: comment, reply: reply = false, isCurrentUserCommentAuthor: isCurrentUserCommentAuthor, isCurrentUserAdmin: isCurrentUserAdmin, isLiked: isLiked, onUserNameClick: onUserNameClick, onLikeClick: onLikeClick, onDislikeClick: onDislikeClick, onReplyClick: onReplyClick, onBlockClick: onBlockClick, onDeleteClick: onDeleteClick, onReportClick: onReportClick })=>{
    const theme = (0, $hXJcm.u)();
    const { userId: commentAuthorUserId, message: message } = comment;
    // comment author
    const { user: commentAuthor, isLoading: isCommentAuthorLoading } = (0, $4y2bm.useUserPublic)(commentAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = commentAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $hrd7b.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $exYeM.useState)(false);
    const renderLikeButtons = ()=>{
        // if comment liked
        if (isLiked) // return dislike button
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $fD6gC.styles)(theme).card.actions.heart.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: [
                    (0, $fD6gC.styles)(theme).card.actions.heart.button.shared,
                    (0, $fD6gC.styles)(theme).card.actions.heart.button.dislike,
                    "",
                    ""
                ],
                onClick: (e)=>onDislikeClick(e),
                type: "button",
                "aria-label": "dislike comment",
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).HeartFilled, {})
            })
        });
        // else return like button
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $fD6gC.styles)(theme).card.actions.heart.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: [
                    (0, $fD6gC.styles)(theme).card.actions.heart.button.shared,
                    (0, $fD6gC.styles)(theme).card.actions.heart.button.like,
                    "",
                    ""
                ],
                onClick: (e)=>onLikeClick(e),
                type: "button",
                "aria-label": "like comment",
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Heart, {})
            })
        });
    };
    const renderActionButtons = ()=>{
        // if current user is comment author
        if (isCurrentUserCommentAuthor) // return delete button
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $fD6gC.styles)(theme).card.actions.delete.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $fD6gC.styles)(theme).card.actions.delete.button,
                onClick: (e)=>onDeleteClick(e),
                type: "button",
                "aria-label": "delete comment",
                children: "Delete"
            })
        });
        // if current user is admin
        if (isCurrentUserAdmin) // return block button
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $fD6gC.styles)(theme).card.actions.block.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $fD6gC.styles)(theme).card.actions.block.button,
                onClick: (e)=>onBlockClick(e),
                type: "button",
                "aria-label": "block comment",
                children: "Block"
            })
        });
        // else return report button
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $fD6gC.styles)(theme).card.actions.report.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $fD6gC.styles)(theme).card.actions.report.button,
                onClick: (e)=>onReportClick(e),
                type: "button",
                "aria-label": "report comment",
                children: "Report"
            })
        });
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $fD6gC.styles)(theme).card.main(reply || false),
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $fD6gC.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $fD6gC.styles)(theme).card.data.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $fD6gC.styles)(theme).card.data.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                            css: (0, $fD6gC.styles)(theme).card.data.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $fD6gC.styles)(theme).card.data.content.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $fD6gC.styles)(theme).card.data.content.name,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: (0, $fD6gC.styles)(theme).card.data.content.name,
                                    onClick: (e)=>onUserNameClick(e),
                                    type: "button",
                                    "aria-label": "explore author profile",
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                        children: isCommentAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $fD6gC.styles)(theme).card.data.content.message,
                                children: message
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $fD6gC.styles)(theme).card.actions.main,
                children: [
                    renderLikeButtons(),
                    ` \u{2014} `,
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $fD6gC.styles)(theme).card.actions.reply.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $fD6gC.styles)(theme).card.actions.reply.button,
                            onClick: (e)=>onReplyClick(e),
                            type: "button",
                            "aria-label": "reply to comment",
                            children: "Reply"
                        })
                    }),
                    ` \u{2014} `,
                    renderActionButtons()
                ]
            })
        ]
    });
};
$e8242be4aa408a69$export$bc479ee64936fcb7.propTypes = {};

});
parcelRegister("fD6gC", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e05b0e2748ca88d1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e05b0e2748ca88d1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e05b0e2748ca88d1$var$_ref = {
    name: "124yqkc",
    styles: "display:flex;margin-left:8px"
};
var $e05b0e2748ca88d1$var$_ref2 = {
    name: "124yqkc",
    styles: "display:flex;margin-left:8px"
};
var $e05b0e2748ca88d1$var$_ref3 = {
    name: "124yqkc",
    styles: "display:flex;margin-left:8px"
};
var $e05b0e2748ca88d1$var$_ref4 = {
    name: "13y0mlm",
    styles: "display:flex;margin:0px 8px"
};
var $e05b0e2748ca88d1$var$_ref5 = {
    name: "13y0mlm",
    styles: "display:flex;margin:0px 8px"
};
var $e05b0e2748ca88d1$var$_ref6 = {
    name: "zjik7",
    styles: "display:flex"
};
var $e05b0e2748ca88d1$var$_ref7 = {
    name: "j523fz",
    styles: "display:flex;align-items:center;margin-left:34px"
};
var $e05b0e2748ca88d1$var$_ref8 = {
    name: "62qxo5",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0"
};
var $e05b0e2748ca88d1$var$_ref9 = {
    name: "zjik7",
    styles: "display:flex"
};
const $e05b0e2748ca88d1$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: (reply)=>/*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:space-between;height:70px;margin-left:", reply ? `40px` : `0px`, ";", ""),
            data: {
                main: $e05b0e2748ca88d1$var$_ref9,
                avatar: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                    image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                content: {
                    main: $e05b0e2748ca88d1$var$_ref8,
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                    message: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
                }
            },
            actions: {
                main: $e05b0e2748ca88d1$var$_ref7,
                heart: {
                    main: $e05b0e2748ca88d1$var$_ref6,
                    button: {
                        shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;display:flex;align-items:center;justify-content:center;width:30px;height:30px;&>svg{width:14px;height:14px;}", ""),
                        dislike: /*#__PURE__*/ (0, $4N3Qt.css)("& svg{&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                        like: /*#__PURE__*/ (0, $4N3Qt.css)("& svg{&>path{fill:", theme.colors.secondary.normal, ";}}", "")
                    }
                },
                reply: {
                    main: $e05b0e2748ca88d1$var$_ref5,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $48E0n.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                read: {
                    main: $e05b0e2748ca88d1$var$_ref4,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $48E0n.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                delete: {
                    main: $e05b0e2748ca88d1$var$_ref3,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $48E0n.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.negative.normal, ";}", "")
                },
                block: {
                    main: $e05b0e2748ca88d1$var$_ref2,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $48E0n.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.negative.normal, ";}", "")
                },
                report: {
                    main: $e05b0e2748ca88d1$var$_ref,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $48E0n.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.negative.normal, ";}", "")
                }
            }
        }
    });

});


parcelRegister("9nwQh", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteModal", function () { return $d9d5a5a24c7a0c97$export$8eb8df218902568a; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $lWbfW = parcelRequire("lWbfW");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("amTcF");
var $apv3A = parcelRequire("apv3A");

var $cO9nN = parcelRequire("cO9nN");
const $d9d5a5a24c7a0c97$export$8eb8df218902568a = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const deleteCommentModalOpen = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentDeleteModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cO9nN.styles)().modal.main,
        children: deleteCommentModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $lWbfW.commentCloseCommentDeleteModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $cO9nN.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $apv3A.CommentDeleteCard), {})
            })
        })
    });
};
$d9d5a5a24c7a0c97$export$8eb8df218902568a.propTypes = {};

});
parcelRegister("amTcF", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteCard", function () { return (parcelRequire("apv3A")).CommentDeleteCard; });

var $apv3A = parcelRequire("apv3A");

});
parcelRegister("apv3A", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteCard", function () { return $6f7081e44799e47a$export$48b3e8bde388a977; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $lWbfW = parcelRequire("lWbfW");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("1HKCc");
var $cb9rw = parcelRequire("cb9rw");

var $5X0DK = parcelRequire("5X0DK");
const $6f7081e44799e47a$export$48b3e8bde388a977 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const commentDeleteError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $5X0DK.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5X0DK.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $lWbfW.commentCloseCommentDeleteModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5X0DK.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Delete Comment",
                    icon: (0, $9IIBp.icons).Trash
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5X0DK.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Are you sure you want to delete your comment?"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $5X0DK.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5X0DK.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cb9rw.CommentDeleteForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5X0DK.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: commentDeleteError
                        })
                    })
                ]
            })
        ]
    });
};
$6f7081e44799e47a$export$48b3e8bde388a977.propTypes = {};

});
parcelRegister("1HKCc", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteForm", function () { return (parcelRequire("cb9rw")).CommentDeleteForm; });

var $cb9rw = parcelRequire("cb9rw");

});
parcelRegister("cb9rw", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteForm", function () { return $3ab2e7d7d9769fdb$export$628243470a18449b; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("fNyrl");
var $3gmqG = parcelRequire("3gmqG");
parcelRequire("dmGpj");
var $kCfD8 = parcelRequire("kCfD8");
var $lWbfW = parcelRequire("lWbfW");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $irbou = parcelRequire("irbou");
const $3ab2e7d7d9769fdb$export$628243470a18449b = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const commentDeleteLoading = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentDeleteLoading));
    const comment = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentDeleteModalComment));
    const { message: message } = comment ?? {};
    const maxCommentMessageDisplayLength = 88;
    const submitDisabled = commentDeleteLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $irbou.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $irbou.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $kCfD8.commentDelete)({
                    id: comment?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $irbou.styles)().form.content.message,
                    children: (0, $3gmqG.stringsCutter)(maxCommentMessageDisplayLength, message || "")
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $irbou.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "delete comment",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: commentDeleteLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Delete"
                    })
                })
            ]
        })
    });
};
$3ab2e7d7d9769fdb$export$628243470a18449b.propTypes = {};

});
parcelRegister("irbou", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b3b3b59160fe2a05$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $b3b3b59160fe2a05$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b3b3b59160fe2a05$var$_ref = {
    name: "q0fhfi",
    styles: "text-align:center;word-wrap:break-word;overflow:hidden;margin-bottom:24px"
};
const $b3b3b59160fe2a05$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                message: $b3b3b59160fe2a05$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("5X0DK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $deaf112b82737e44$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $deaf112b82737e44$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $deaf112b82737e44$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $deaf112b82737e44$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $deaf112b82737e44$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $deaf112b82737e44$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $deaf112b82737e44$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $deaf112b82737e44$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $deaf112b82737e44$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $deaf112b82737e44$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $deaf112b82737e44$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($deaf112b82737e44$var$_ref8), " ", (0, $48E0n.mq).mobile($deaf112b82737e44$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($deaf112b82737e44$var$_ref6), ";", ""),
            title: $deaf112b82737e44$var$_ref5,
            subtitle: $deaf112b82737e44$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($deaf112b82737e44$var$_ref3), ";", ""),
                form: $deaf112b82737e44$var$_ref2,
                error: $deaf112b82737e44$var$_ref
            }
        }
    });

});



parcelRegister("cO9nN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d017b07e48c35a7f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d017b07e48c35a7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d017b07e48c35a7f$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $d017b07e48c35a7f$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($d017b07e48c35a7f$var$_ref), ";", "")
        }
    });

});


parcelRegister("1BfGm", function(module, exports) {

$parcel$export(module.exports, "CommentListPost", function () { return $9bd556da98b568ef$export$b2d989c1a4cff6a; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $lWbfW = parcelRequire("lWbfW");
var $lvFQG = parcelRequire("lvFQG");
var $kCfD8 = parcelRequire("kCfD8");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $l1Cdj = parcelRequire("l1Cdj");
var $6CAIO = parcelRequire("6CAIO");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("5w2wj");
var $bIS98 = parcelRequire("bIS98");
var $lQubB = parcelRequire("lQubB");
var $5FiF3 = parcelRequire("5FiF3");

var $5U67o = parcelRequire("5U67o");
const $9bd556da98b568ef$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const commentLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectCommentLikes));
    const comments = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectComments));
    const comment = comments[index];
    // if comment not fetched
    if (!comment) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "comment-list-post",
                    width: "100%",
                    height: "70px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: currentUserId, role: currentUserRole } = profile ?? {};
    const { id: commentId, userId: commentAuthorUserId, commentId: depth } = comment;
    const isCommentLiked = commentLikes[commentId || ""];
    const isCurrentUserCommentAuthor = currentUserId === commentAuthorUserId;
    const isCurrentUserAdmin = currentUserRole === (0, $aeAwZ.EntityUserRole).Admin;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $5U67o.styles)().comments.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lvFQG.CommentCard), {
            comment: comment,
            reply: !!depth,
            isCurrentUserCommentAuthor: isCurrentUserCommentAuthor,
            isCurrentUserAdmin: isCurrentUserAdmin,
            isLiked: isCommentLiked,
            onUserNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${commentAuthorUserId}`),
            onLikeClick: ()=>dispatch((0, $9ybfS.likeCreateCommentLike)({
                    comment: comment
                })),
            onDislikeClick: ()=>dispatch((0, $9ybfS.likeDeleteCommentLike)({
                    comment: comment
                })),
            onReplyClick: ()=>dispatch((0, $lWbfW.commentAddDepth)({
                    comment: comment
                })),
            onBlockClick: ()=>dispatch((0, $lWbfW.commentOpenCommentBlockModal)({
                    comment: comment
                })),
            onDeleteClick: ()=>dispatch((0, $lWbfW.commentOpenCommentDeleteModal)({
                    comment: comment
                })),
            onReportClick: ()=>dispatch((0, $6CAIO.reportOpenReportCommentModal)({
                    comment: comment
                }))
        })
    });
});
const $9bd556da98b568ef$export$b2d989c1a4cff6a = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const post = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPost));
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post ?? {};
    const { id: profileUserId } = profile ?? {};
    const commentGetCommentsLoading = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentGetCommentsLoading));
    const comments = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectComments));
    const commentsCount = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentsCount));
    const commentsLength = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentsLength));
    const commentsFetched = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentsFetched));
    const commentsDepth = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentsDepth));
    const commentDepthCurrent = commentsDepth[0] || undefined;
    const { id: currentDepthId } = commentDepthCurrent ?? {};
    const commentCardHeight = 70;
    const commentCardMarginBottom = 10;
    const itemHeight = commentCardHeight + commentCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 400;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    // if post is not fetched
    if (!post) // return card post skeleton
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $5U67o.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5FiF3.Title), {
                    text: "Comments"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
                    sections: [
                        {
                            name: "comment-list-post-card",
                            width: "100%",
                            height: "400px",
                            isStatic: false,
                            isDivider: false
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bIS98.Form), {})
            })
        ]
    });
    const isItemLoaded = (index)=>!!comments[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kCfD8.commentGetComments)({
            postId: postId || "",
            commentId: currentDepthId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = profileUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if post is locked
    if (renderLocked) // return placeholder
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $5U67o.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5FiF3.Title), {
                    text: "Comments"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
                    icon: (0, $9IIBp.icons).Lock,
                    height: "400px",
                    title: "Content is locked"
                })
            })
        ]
    });
    // if comments are fetched but length is 0
    if (!commentGetCommentsLoading && commentsFetched && commentsLength === 0) // return placeholder
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $5U67o.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5FiF3.Title), {
                    text: "Comments"
                })
            }),
            commentDepthCurrent && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.comment,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lQubB.ParentComment), {
                    comment: commentDepthCurrent,
                    onUserNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${commentDepthCurrent.userId}`),
                    onBackwardClick: ()=>dispatch((0, $lWbfW.commentRemoveDepth)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
                    icon: (0, $9IIBp.icons).Comment,
                    height: "400px",
                    title: commentDepthCurrent ? "Could not find any replies" : "Could not find any comments"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.form,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bIS98.Form), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $5U67o.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5FiF3.Title), {
                    text: "Comments"
                })
            }),
            commentDepthCurrent && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.comment,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lQubB.ParentComment), {
                    comment: commentDepthCurrent,
                    onUserNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${commentDepthCurrent.userId}`),
                    onBackwardClick: ()=>dispatch((0, $lWbfW.commentRemoveDepth)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: commentsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: commentsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $9bd556da98b568ef$var$Row
                        })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5U67o.styles)().list.form,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bIS98.Form), {})
            })
        ]
    });
};
$9bd556da98b568ef$export$b2d989c1a4cff6a.propTypes = {};

});
parcelRegister("6TqF6", function(module, exports) {

$parcel$export(module.exports, "FixedSizeList", function () { return $504c8fa1d52dc93d$export$ae9e55e1d8a2f4b7; });

var $aJx1R = parcelRequire("aJx1R");

var $bYAPj = parcelRequire("bYAPj");

var $9awBj = parcelRequire("9awBj");

var $jMw7l = parcelRequire("jMw7l");

var $exYeM = parcelRequire("exYeM");

var $3L80X = parcelRequire("3L80X");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $504c8fa1d52dc93d$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $504c8fa1d52dc93d$var$now = $504c8fa1d52dc93d$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $504c8fa1d52dc93d$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $504c8fa1d52dc93d$var$requestTimeout(callback, delay) {
    var start = $504c8fa1d52dc93d$var$now();
    function tick() {
        if ($504c8fa1d52dc93d$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $504c8fa1d52dc93d$var$size = -1; // This utility copied from "dom-helpers" package.
function $504c8fa1d52dc93d$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($504c8fa1d52dc93d$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $504c8fa1d52dc93d$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $504c8fa1d52dc93d$var$size;
}
var $504c8fa1d52dc93d$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $504c8fa1d52dc93d$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($504c8fa1d52dc93d$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $504c8fa1d52dc93d$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $504c8fa1d52dc93d$var$cachedRTLResult = "negative";
            else $504c8fa1d52dc93d$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $504c8fa1d52dc93d$var$cachedRTLResult;
    }
    return $504c8fa1d52dc93d$var$cachedRTLResult;
}
var $504c8fa1d52dc93d$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $504c8fa1d52dc93d$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $504c8fa1d52dc93d$var$devWarningsOverscanCount = null;
var $504c8fa1d52dc93d$var$devWarningsOverscanRowsColumnsCount = null;
var $504c8fa1d52dc93d$var$devWarningsTagName = null;
function $504c8fa1d52dc93d$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $9awBj.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $bYAPj.default)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $bYAPj.default)(_this),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $jMw7l.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $jMw7l.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $jMw7l.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($504c8fa1d52dc93d$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $504c8fa1d52dc93d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $504c8fa1d52dc93d$var$requestTimeout(_this._resetIsScrolling, $504c8fa1d52dc93d$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $504c8fa1d52dc93d$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $504c8fa1d52dc93d$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($504c8fa1d52dc93d$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $504c8fa1d52dc93d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $504c8fa1d52dc93d$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $exYeM.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $exYeM.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $aJx1R.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $exYeM.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $exYeM.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $504c8fa1d52dc93d$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $504c8fa1d52dc93d$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $504c8fa1d52dc93d$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $504c8fa1d52dc93d$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $504c8fa1d52dc93d$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $504c8fa1d52dc93d$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $504c8fa1d52dc93d$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $504c8fa1d52dc93d$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $504c8fa1d52dc93d$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $504c8fa1d52dc93d$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $504c8fa1d52dc93d$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $504c8fa1d52dc93d$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $504c8fa1d52dc93d$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $504c8fa1d52dc93d$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $504c8fa1d52dc93d$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $504c8fa1d52dc93d$var$getEstimatedTotalWidth(props, instanceProps) : $504c8fa1d52dc93d$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $504c8fa1d52dc93d$export$32c206c84102e73c = /*#__PURE__*/ $504c8fa1d52dc93d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $504c8fa1d52dc93d$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $504c8fa1d52dc93d$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $504c8fa1d52dc93d$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $504c8fa1d52dc93d$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $504c8fa1d52dc93d$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $504c8fa1d52dc93d$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $504c8fa1d52dc93d$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $504c8fa1d52dc93d$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $504c8fa1d52dc93d$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $504c8fa1d52dc93d$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $504c8fa1d52dc93d$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $504c8fa1d52dc93d$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $504c8fa1d52dc93d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $504c8fa1d52dc93d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $504c8fa1d52dc93d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $504c8fa1d52dc93d$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $504c8fa1d52dc93d$var$devWarningsDirection = null;
var $504c8fa1d52dc93d$var$devWarningsTagName$1 = null;
function $504c8fa1d52dc93d$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $9awBj.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $bYAPj.default)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $bYAPj.default)(_this),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $jMw7l.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $jMw7l.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $jMw7l.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($504c8fa1d52dc93d$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $504c8fa1d52dc93d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $504c8fa1d52dc93d$var$requestTimeout(_this._resetIsScrolling, $504c8fa1d52dc93d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $504c8fa1d52dc93d$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === "vertical") scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $504c8fa1d52dc93d$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $504c8fa1d52dc93d$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($504c8fa1d52dc93d$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $504c8fa1d52dc93d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $504c8fa1d52dc93d$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $exYeM.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $exYeM.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $aJx1R.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $exYeM.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $exYeM.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $504c8fa1d52dc93d$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $504c8fa1d52dc93d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $504c8fa1d52dc93d$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $504c8fa1d52dc93d$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $504c8fa1d52dc93d$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $504c8fa1d52dc93d$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $504c8fa1d52dc93d$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $504c8fa1d52dc93d$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $504c8fa1d52dc93d$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $504c8fa1d52dc93d$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $504c8fa1d52dc93d$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $504c8fa1d52dc93d$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $504c8fa1d52dc93d$export$d8ac3b6b20be856e = /*#__PURE__*/ $504c8fa1d52dc93d$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $504c8fa1d52dc93d$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $504c8fa1d52dc93d$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $504c8fa1d52dc93d$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $504c8fa1d52dc93d$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $504c8fa1d52dc93d$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $504c8fa1d52dc93d$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $504c8fa1d52dc93d$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $504c8fa1d52dc93d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $504c8fa1d52dc93d$export$f331158cccad7361 = /*#__PURE__*/ $504c8fa1d52dc93d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $504c8fa1d52dc93d$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $504c8fa1d52dc93d$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $504c8fa1d52dc93d$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $504c8fa1d52dc93d$var$_excluded = [
    "style"
], $504c8fa1d52dc93d$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $504c8fa1d52dc93d$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $3L80X.default)(prevProps, $504c8fa1d52dc93d$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $3L80X.default)(nextProps, $504c8fa1d52dc93d$var$_excluded2);
    return !$504c8fa1d52dc93d$var$shallowDiffers(prevStyle, nextStyle) && !$504c8fa1d52dc93d$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $504c8fa1d52dc93d$export$aa365c903ed149ff(nextProps, nextState) {
    return !$504c8fa1d52dc93d$export$b141efd0b0fb9174(this.props, nextProps) || $504c8fa1d52dc93d$var$shallowDiffers(this.state, nextState);
}

});
parcelRegister("bYAPj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b81dd4f51678982$export$2e2bcd8739ae039; });
function $8b81dd4f51678982$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("9awBj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ace560ed589c934$export$2e2bcd8739ae039; });

var $5NwIB = parcelRequire("5NwIB");
function $6ace560ed589c934$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $5NwIB.default)(subClass, superClass);
}

});
parcelRegister("5NwIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438ae88f4b206ba2$export$2e2bcd8739ae039; });
function $438ae88f4b206ba2$export$2e2bcd8739ae039(o, p) {
    $438ae88f4b206ba2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $438ae88f4b206ba2$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("jMw7l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e66b69e563b626e6$export$2e2bcd8739ae039; });
var $e66b69e563b626e6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e66b69e563b626e6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e66b69e563b626e6$var$safeIsNaN(first) && $e66b69e563b626e6$var$safeIsNaN(second)) return true;
    return false;
}
function $e66b69e563b626e6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e66b69e563b626e6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e66b69e563b626e6$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e66b69e563b626e6$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e66b69e563b626e6$export$2e2bcd8739ae039 = $e66b69e563b626e6$var$memoizeOne;

});

parcelRegister("3L80X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039; });
function $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("e6Ukw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a45d5237424b5f6f$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
function $a45d5237424b5f6f$var$isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $a45d5237424b5f6f$var$isRangeVisible(_ref) {
    var lastRenderedStartIndex = _ref.lastRenderedStartIndex, lastRenderedStopIndex = _ref.lastRenderedStopIndex, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function $a45d5237424b5f6f$var$scanForUnloadedRanges(_ref) {
    var isItemLoaded = _ref.isItemLoaded, itemCount = _ref.itemCount, minimumBatchSize = _ref.minimumBatchSize, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    var unloadedRanges = [];
    var rangeStartIndex = null;
    var rangeStopIndex = null;
    for(var _index = startIndex; _index <= stopIndex; _index++){
        var loaded = isItemLoaded(_index);
        if (!loaded) {
            rangeStopIndex = _index;
            if (rangeStartIndex === null) rangeStartIndex = _index;
        } else if (rangeStopIndex !== null) {
            unloadedRanges.push(rangeStartIndex, rangeStopIndex);
            rangeStartIndex = rangeStopIndex = null;
        }
    }
    // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
    // Scan forward to try filling our :minimumBatchSize.
    if (rangeStopIndex !== null) {
        var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), itemCount - 1);
        for(var _index2 = rangeStopIndex + 1; _index2 <= potentialStopIndex; _index2++){
            if (!isItemLoaded(_index2)) rangeStopIndex = _index2;
            else break;
        }
        unloadedRanges.push(rangeStartIndex, rangeStopIndex);
    }
    // Check to see if our first range ended prematurely.
    // In this case we should scan backwards to try filling our :minimumBatchSize.
    if (unloadedRanges.length) while(unloadedRanges[1] - unloadedRanges[0] + 1 < minimumBatchSize && unloadedRanges[0] > 0){
        var _index3 = unloadedRanges[0] - 1;
        if (!isItemLoaded(_index3)) unloadedRanges[0] = _index3;
        else break;
    }
    return unloadedRanges;
}
var $a45d5237424b5f6f$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $a45d5237424b5f6f$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $a45d5237424b5f6f$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $a45d5237424b5f6f$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $a45d5237424b5f6f$var$InfiniteLoader = function(_PureComponent) {
    $a45d5237424b5f6f$var$inherits(InfiniteLoader, _PureComponent);
    function InfiniteLoader() {
        var _ref;
        var _temp, _this, _ret;
        $a45d5237424b5f6f$var$classCallCheck(this, InfiniteLoader);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a45d5237424b5f6f$var$possibleConstructorReturn(this, (_ref = InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._lastRenderedStartIndex = -1, _this._lastRenderedStopIndex = -1, _this._memoizedUnloadedRanges = [], _this._onItemsRendered = function(_ref2) {
            var visibleStartIndex = _ref2.visibleStartIndex, visibleStopIndex = _ref2.visibleStopIndex;
            _this._lastRenderedStartIndex = visibleStartIndex;
            _this._lastRenderedStopIndex = visibleStopIndex;
            _this._ensureRowsLoaded(visibleStartIndex, visibleStopIndex);
        }, _this._setRef = function(listRef) {
            _this._listRef = listRef;
        }, _temp), $a45d5237424b5f6f$var$possibleConstructorReturn(_this, _ret);
    }
    $a45d5237424b5f6f$var$createClass(InfiniteLoader, [
        {
            key: "resetloadMoreItemsCache",
            value: function resetloadMoreItemsCache() {
                var autoReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this._memoizedUnloadedRanges = [];
                if (autoReload) this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {}
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    onItemsRendered: this._onItemsRendered,
                    ref: this._setRef
                });
            }
        },
        {
            key: "_ensureRowsLoaded",
            value: function _ensureRowsLoaded(startIndex, stopIndex) {
                var _props = this.props, isItemLoaded = _props.isItemLoaded, itemCount = _props.itemCount, _props$minimumBatchSi = _props.minimumBatchSize, minimumBatchSize = _props$minimumBatchSi === undefined ? 10 : _props$minimumBatchSi, _props$threshold = _props.threshold, threshold = _props$threshold === undefined ? 15 : _props$threshold;
                var unloadedRanges = $a45d5237424b5f6f$var$scanForUnloadedRanges({
                    isItemLoaded: isItemLoaded,
                    itemCount: itemCount,
                    minimumBatchSize: minimumBatchSize,
                    startIndex: Math.max(0, startIndex - threshold),
                    stopIndex: Math.min(itemCount - 1, stopIndex + threshold)
                });
                // Avoid calling load-rows unless range has changed.
                // This shouldn't be strictly necessary, but is maybe nice to do.
                if (this._memoizedUnloadedRanges.length !== unloadedRanges.length || this._memoizedUnloadedRanges.some(function(startOrStop, index) {
                    return unloadedRanges[index] !== startOrStop;
                })) {
                    this._memoizedUnloadedRanges = unloadedRanges;
                    this._loadUnloadedRanges(unloadedRanges);
                }
            }
        },
        {
            key: "_loadUnloadedRanges",
            value: function _loadUnloadedRanges(unloadedRanges) {
                var _this2 = this;
                // loadMoreRows was renamed to loadMoreItems in v1.0.3; will be removed in v2.0
                var loadMoreItems = this.props.loadMoreItems || this.props.loadMoreRows;
                var _loop = function _loop(i) {
                    var startIndex = unloadedRanges[i];
                    var stopIndex = unloadedRanges[i + 1];
                    var promise = loadMoreItems(startIndex, stopIndex);
                    if (promise != null) promise.then(function() {
                        // Refresh the visible rows if any of them have just been loaded.
                        // Otherwise they will remain in their unloaded visual state.
                        if ($a45d5237424b5f6f$var$isRangeVisible({
                            lastRenderedStartIndex: _this2._lastRenderedStartIndex,
                            lastRenderedStopIndex: _this2._lastRenderedStopIndex,
                            startIndex: startIndex,
                            stopIndex: stopIndex
                        })) {
                            // Handle an unmount while promises are still in flight.
                            if (_this2._listRef == null) return;
                            // Resize cached row sizes for VariableSizeList,
                            // otherwise just re-render the list.
                            if (typeof _this2._listRef.resetAfterIndex === "function") _this2._listRef.resetAfterIndex(startIndex, true);
                            else {
                                // HACK reset temporarily cached item styles to force PureComponent to re-render.
                                // This is pretty gross, but I'm okay with it for now.
                                // Don't judge me.
                                if (typeof _this2._listRef._getItemStyleCache === "function") _this2._listRef._getItemStyleCache(-1);
                                _this2._listRef.forceUpdate();
                            }
                        }
                    });
                };
                for(var i = 0; i < unloadedRanges.length; i += 2)_loop(i);
            }
        }
    ]);
    return InfiniteLoader;
}((0, $exYeM.PureComponent));
var $a45d5237424b5f6f$export$2e2bcd8739ae039 = $a45d5237424b5f6f$var$InfiniteLoader;

});

parcelRegister("5w2wj", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("bIS98")).Form; });
$parcel$export(module.exports, "ParentComment", function () { return (parcelRequire("lQubB")).ParentComment; });
$parcel$export(module.exports, "Title", function () { return (parcelRequire("5FiF3")).Title; });

var $bIS98 = parcelRequire("bIS98");

var $lQubB = parcelRequire("lQubB");

var $5FiF3 = parcelRequire("5FiF3");

});
parcelRegister("bIS98", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $1e44b2c5e6f17d05$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $ck17w = parcelRequire("ck17w");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $kCfD8 = parcelRequire("kCfD8");
var $lWbfW = parcelRequire("lWbfW");
var $l1Cdj = parcelRequire("l1Cdj");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("3xyBH");
var $7UYCv = parcelRequire("7UYCv");

var $bftkJ = parcelRequire("bftkJ");
const $1e44b2c5e6f17d05$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const commentsDepth = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentsDepth));
    const commentDepthCurrent = commentsDepth[0] || undefined;
    const { id: commentId } = commentDepthCurrent ?? {};
    const post = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPost));
    const { id: postId } = post ?? {};
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [messageError, setMessageError] = (0, $exYeM.useState)("");
    const commentCreateLoading = (0, $9CcOD.useAppSelector)((0, $lWbfW.commentSelectCommentCreateLoading));
    const submitDisabled = message.length < (0, $ck17w.minCommentMessageLength) || messageError !== "" || commentCreateLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $bftkJ.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("form", {
            css: (0, $bftkJ.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $kCfD8.commentCreate)({
                    postId: postId || "",
                    message: message,
                    commentId: commentId
                }));
                setMessage("");
                setMessageError("");
            },
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bftkJ.styles)().form.content.message,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7UYCv.FormInput), {
                    name: "comment",
                    label: "comment",
                    type: "text",
                    placeholder: "Enter your comment",
                    maxLength: (0, $ck17w.maxCommentMessageLength),
                    value: message,
                    error: messageError.length > 0,
                    // errorMessage={messageError}
                    sendDisabled: submitDisabled,
                    onChange: (e)=>{
                        setMessage(e.target.value);
                    },
                    onBlur: ()=>{
                        if (message !== "") setMessageError((0, $33ayT.validateCommentMessage)(message));
                    },
                    onFocus: ()=>setMessageError("")
                })
            })
        })
    });
};
$1e44b2c5e6f17d05$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("3xyBH", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return (parcelRequire("7UYCv")).FormInput; });

var $7UYCv = parcelRequire("7UYCv");

});
parcelRegister("7UYCv", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return $2772d18f0421ea64$export$fd970bbd10854e43; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $iokvp = parcelRequire("iokvp");
const $2772d18f0421ea64$export$fd970bbd10854e43 = ({ name: name, label: label, error: error = false, sendDisabled: // errorMessage = '',
sendDisabled = false, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $iokvp.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $iokvp.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $iokvp.styles)(theme).input.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                        css: [
                            (0, $iokvp.styles)(theme).input.data.shared,
                            attributes.value ? (0, $iokvp.styles)(theme).input.data.filled : (0, $iokvp.styles)(theme).input.data.empty,
                            error && (0, $iokvp.styles)(theme).input.data.errored,
                            (0, $iokvp.styles)(theme).input.data.withIcon,
                            "",
                            ""
                        ],
                        id: name,
                        ...attributes
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: [
                            (0, $iokvp.styles)(theme).input.button.shared,
                            sendDisabled ? (0, $iokvp.styles)(theme).input.button.disabled : (0, $iokvp.styles)(theme).input.button.enabled,
                            "",
                            ""
                        ],
                        disabled: sendDisabled,
                        type: "submit",
                        "aria-label": "send comment",
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                            css: (0, $iokvp.styles)(theme).input.button.text,
                            children: "Send"
                        })
                    })
                ]
            })
        ]
    });
};
$2772d18f0421ea64$export$fd970bbd10854e43.propTypes = {};

});
parcelRegister("iokvp", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2598cc72b08c8f76$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $2598cc72b08c8f76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2598cc72b08c8f76$var$_ref = {
    name: "abijo8",
    styles: "right:26px"
};
var $2598cc72b08c8f76$var$_ref2 = {
    name: "1dcvvov",
    styles: "padding-right:64px"
};
var $2598cc72b08c8f76$var$_ref3 = {
    name: "f3hzix",
    styles: "height:36px;padding:12px 26px"
};
var $2598cc72b08c8f76$var$_ref4 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $2598cc72b08c8f76$var$_ref5 = {
    name: "eivff4",
    styles: "display:none"
};
var $2598cc72b08c8f76$var$_ref6 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $2598cc72b08c8f76$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $2598cc72b08c8f76$var$_ref6,
            label: $2598cc72b08c8f76$var$_ref5,
            data: {
                main: $2598cc72b08c8f76$var$_ref4,
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:40px;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.secondary.normal, ";border-radius:6px;padding:8px 32px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", (0, $48E0n.mq).mobile($2598cc72b08c8f76$var$_ref3), ";", ""),
                empty: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.darkHover, ";&~button>svg>path{fill:", theme.colors.secondary.darkHover, ";}", ""),
                filled: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.normal, ";&~button>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                errored: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.negative.normal, ";", ""),
                withIcon: /*#__PURE__*/ (0, $4N3Qt.css)("padding-right:80px;", (0, $48E0n.mq).mobile($2598cc72b08c8f76$var$_ref2), ";", "")
            },
            button: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;position:absolute;right:32px;top:50%;transform:translate(0%, -50%);height:30px;", (0, $48E0n.mq).mobile($2598cc72b08c8f76$var$_ref), ";", ""),
                enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;&>span{color:", theme.colors.secondary.normal, ";}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&>span{color:", theme.colors.secondary.darkHover, ";}&:hover{&>span{color:", theme.colors.secondary.darkHover, ";}}", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";transition:color 0.2s;", "")
            }
        }
    });

});



parcelRegister("bftkJ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1724ed5371032d46$export$9dd6ff9ea0189349; });
function $1724ed5371032d46$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1724ed5371032d46$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $1724ed5371032d46$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $1724ed5371032d46$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $1724ed5371032d46$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $1724ed5371032d46$var$_ref3,
            content: {
                main: $1724ed5371032d46$var$_ref2,
                message: $1724ed5371032d46$var$_ref
            }
        }
    });

});


parcelRegister("lQubB", function(module, exports) {

$parcel$export(module.exports, "ParentComment", function () { return $528f195997e4f1a6$export$2025b53f620908f1; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $bO3HY = parcelRequire("bO3HY");
const $528f195997e4f1a6$export$2025b53f620908f1 = ({ comment: comment, onUserNameClick: onUserNameClick, onBackwardClick: onBackwardClick })=>{
    const theme = (0, $hXJcm.u)();
    const { message: message, userId: commentAuthorUserId } = comment;
    // comment author
    const { user: commentAuthor, isLoading: isCommentAuthorLoading } = (0, $4y2bm.useUserPublic)(commentAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = commentAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $hrd7b.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $exYeM.useState)(false);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $bO3HY.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $bO3HY.styles)(theme).card.left.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bO3HY.styles)(theme).card.left.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $bO3HY.styles)(theme).card.left.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                            css: (0, $bO3HY.styles)(theme).card.left.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bO3HY.styles)(theme).card.left.nav.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $bO3HY.styles)(theme).card.left.nav.button,
                            onClick: (e)=>onBackwardClick(e),
                            type: "button",
                            "aria-label": "navigate to previous comment",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $bO3HY.styles)(theme).card.right.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bO3HY.styles)(theme).card.right.name,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $bO3HY.styles)(theme).card.right.name,
                            onClick: (e)=>onUserNameClick(e),
                            type: "button",
                            "aria-label": "explore author profile",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                children: isCommentAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bO3HY.styles)(theme).card.right.message,
                        children: message
                    })
                ]
            })
        ]
    });
};
$528f195997e4f1a6$export$2025b53f620908f1.propTypes = {};

});
parcelRegister("bO3HY", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d583f771ea51a0df$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d583f771ea51a0df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d583f771ea51a0df$var$_ref = {
    name: "1ojnsow",
    styles: "display:flex;flex-direction:column;min-width:0"
};
var $d583f771ea51a0df$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
var $d583f771ea51a0df$var$_ref3 = {
    name: "18tn8dg",
    styles: "display:flex;flex-direction:column;margin-right:12px"
};
var $d583f771ea51a0df$var$_ref4 = {
    name: "zjik7",
    styles: "display:flex"
};
const $d583f771ea51a0df$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $d583f771ea51a0df$var$_ref4,
            left: {
                main: $d583f771ea51a0df$var$_ref3,
                avatar: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:12px;", ""),
                    image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                nav: {
                    main: $d583f771ea51a0df$var$_ref2,
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;display:flex;align-items:center;justify-content:center;width:30px;height:30px;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}}", "")
                }
            },
            right: {
                main: $d583f771ea51a0df$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                message: /*#__PURE__*/ (0, $4N3Qt.css)("word-wrap:break-word;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});


parcelRegister("5FiF3", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $4f33f81bdc67358b$export$f99233281efd08a0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $gG2YP = parcelRequire("gG2YP");
const $4f33f81bdc67358b$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gG2YP.styles)(theme).label.main,
        children: text
    });
};
$4f33f81bdc67358b$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("gG2YP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3ac0bf71c565f9e4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $3ac0bf71c565f9e4$export$9dd6ff9ea0189349 = (theme)=>({
        label: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("5U67o", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8fd6c435e192c309$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8fd6c435e192c309$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8fd6c435e192c309$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $8fd6c435e192c309$var$_ref2 = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $8fd6c435e192c309$var$_ref3 = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $8fd6c435e192c309$var$_ref4 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
const $8fd6c435e192c309$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";display:flex;flex-direction:column;overflow:hidden;max-width:800px;margin-bottom:50px;", ""),
            title: $8fd6c435e192c309$var$_ref4,
            comment: $8fd6c435e192c309$var$_ref3,
            content: $8fd6c435e192c309$var$_ref2,
            form: $8fd6c435e192c309$var$_ref
        },
        comments: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});



parcelRegister("lWbfW", function(module, exports) {

$parcel$export(module.exports, "commentSlice", function () { return $637b7a1869193f7d$export$6f10542002196596; });
$parcel$export(module.exports, "commentResetState", function () { return $637b7a1869193f7d$export$bf76718181990b6e; });
$parcel$export(module.exports, "commentSetComments", function () { return $637b7a1869193f7d$export$85292e9081798741; });
$parcel$export(module.exports, "commentResetComments", function () { return $637b7a1869193f7d$export$c309ca146d80ecec; });
$parcel$export(module.exports, "commentFilterComment", function () { return $637b7a1869193f7d$export$f6003723296faa6f; });
$parcel$export(module.exports, "commentFilterUserComments", function () { return $637b7a1869193f7d$export$7c60efed55d280ea; });
$parcel$export(module.exports, "commentAddComment", function () { return $637b7a1869193f7d$export$50bedd2684311fb4; });
$parcel$export(module.exports, "commentUpdateComment", function () { return $637b7a1869193f7d$export$632c88bd775bcae9; });
$parcel$export(module.exports, "commentOpenCommentBlockModal", function () { return $637b7a1869193f7d$export$d9f1b5989bbb1f59; });
$parcel$export(module.exports, "commentCloseCommentBlockModal", function () { return $637b7a1869193f7d$export$4481126479d8d975; });
$parcel$export(module.exports, "commentOpenCommentDeleteModal", function () { return $637b7a1869193f7d$export$f5b455630aac12a6; });
$parcel$export(module.exports, "commentCloseCommentDeleteModal", function () { return $637b7a1869193f7d$export$980fbe285aaf28af; });
$parcel$export(module.exports, "commentAddDepth", function () { return $637b7a1869193f7d$export$53b5f7a5216d6b03; });
$parcel$export(module.exports, "commentRemoveDepth", function () { return $637b7a1869193f7d$export$c0b46e92200ba298; });
$parcel$export(module.exports, "commentSelectComments", function () { return $637b7a1869193f7d$export$9391eb82973eda85; });
$parcel$export(module.exports, "commentSelectCommentsLength", function () { return $637b7a1869193f7d$export$32efe9d5e932cf81; });
$parcel$export(module.exports, "commentSelectCommentsCount", function () { return $637b7a1869193f7d$export$e65b8eaba6d91637; });
$parcel$export(module.exports, "commentSelectCommentsFetched", function () { return $637b7a1869193f7d$export$31ae2fc3ac8394fb; });
$parcel$export(module.exports, "commentSelectCommentBlockModalOpen", function () { return $637b7a1869193f7d$export$892bf2334087f1ea; });
$parcel$export(module.exports, "commentSelectCommentBlockModalComment", function () { return $637b7a1869193f7d$export$e9d740ddaf26d801; });
$parcel$export(module.exports, "commentSelectCommentDeleteModalOpen", function () { return $637b7a1869193f7d$export$576690c145ccb8eb; });
$parcel$export(module.exports, "commentSelectCommentDeleteModalComment", function () { return $637b7a1869193f7d$export$ea9afaaaafe09ae5; });
$parcel$export(module.exports, "commentSelectCommentsDepth", function () { return $637b7a1869193f7d$export$4d1c2c156616749c; });
$parcel$export(module.exports, "commentSelectCommentsDepthLength", function () { return $637b7a1869193f7d$export$e8eee21aefba81a2; });
$parcel$export(module.exports, "commentSelectCommentGetCommentsLoading", function () { return $637b7a1869193f7d$export$fbc11414a54c1d5b; });
$parcel$export(module.exports, "commentSelectCommentCreateLoading", function () { return $637b7a1869193f7d$export$905470f2c19d133e; });
$parcel$export(module.exports, "commentSelectCommentUpdateLoading", function () { return $637b7a1869193f7d$export$f651d62a59500408; });
$parcel$export(module.exports, "commentSelectCommentBlockLoading", function () { return $637b7a1869193f7d$export$2496612e297163c8; });
$parcel$export(module.exports, "commentSelectCommentDeleteLoading", function () { return $637b7a1869193f7d$export$3b3a1599d46c45b1; });
$parcel$export(module.exports, "commentReducer", function () { return $637b7a1869193f7d$export$5ff8fec368de6099; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $kCfD8 = parcelRequire("kCfD8");
const $637b7a1869193f7d$var$initialState = {
    comments: [],
    commentsCount: 0,
    commentsFetched: false,
    commentsDepth: [],
    commentBlockModal: {
        comment: undefined,
        open: false
    },
    commentDeleteModal: {
        comment: undefined,
        open: false
    },
    commentGetCommentsLoading: false,
    commentCreateLoading: false,
    commentUpdateLoading: false,
    commentBlockLoading: false,
    commentDeleteLoading: false
};
const $637b7a1869193f7d$export$6f10542002196596 = (0, $dEr3t.createSlice)({
    name: "comment",
    initialState: $637b7a1869193f7d$var$initialState,
    reducers: {
        // reset state
        commentResetState: ()=>({
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: [],
                commentBlockModal: {
                    comment: undefined,
                    open: false
                },
                commentDeleteModal: {
                    comment: undefined,
                    open: false
                },
                commentGetCommentsLoading: false,
                commentCreateLoading: false,
                commentUpdateLoading: false,
                commentBlockLoading: false,
                commentDeleteLoading: false
            }),
        // set comments
        commentSetComments: (state, action)=>{
            const { comments: comments, count: count, offset: offset } = action.payload;
            // mutate count
            state.commentsCount = count;
            // mutate comments array
            state.comments = (0, $9UVKd.mergeArraysAtIndex)(state.comments, comments, offset);
        },
        // reset comments
        commentResetComments: (state)=>({
                ...state,
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: []
            }),
        // add comment
        commentAddComment: (state, action)=>{
            const { comment: comment } = action.payload;
            // add comment
            state.comments = [
                comment,
                ...state.comments
            ];
            state.commentsCount += 1;
        },
        // update comment
        commentUpdateComment: (state, action)=>{
            const { updatedComment: updatedComment } = action.payload;
            // update comment in comments
            const idx = state.comments.findIndex((c)=>c.id === updatedComment.id);
            if (idx !== -1) {
                const currentComment = state.comments[idx];
                state.comments[idx] = {
                    ...currentComment,
                    ...updatedComment
                };
            }
        },
        // filter comment
        commentFilterComment: (state, action)=>{
            const { id: id } = action.payload;
            // check if comment exists in state
            const cIndex = state.comments.findIndex((c)=>c.id === id);
            if (cIndex !== -1) {
                // filter comment
                state.comments = state.comments.filter((c)=>c.id !== id);
                state.commentsCount -= 1;
            }
            // check if comment exists in state
            const dIndex = state.commentsDepth.findIndex((c)=>c.id === id);
            if (dIndex !== -1) // filter comment
            state.commentsDepth = state.commentsDepth.filter((c)=>c.id !== id);
        },
        // filter user comments
        commentFilterUserComments: (state, action)=>{
            const { userId: userId } = action.payload;
            // filter user comments from comments
            const filteredComments = state.comments.filter((c)=>c.userId !== userId);
            const filteredCommentsCount = state.comments.length - filteredComments.length;
            // if filtered comments
            if (filteredCommentsCount > 0) {
                // update comments
                state.comments = filteredComments;
                state.commentsCount -= filteredCommentsCount;
            }
            // filter user comments from comments depth
            const filteredCommentsDepth = state.commentsDepth.filter((c)=>c.userId !== userId);
            const filteredCommentsDepthCount = state.commentsDepth.length - filteredCommentsDepth.length;
            // if filtered comments
            if (filteredCommentsDepthCount > 0) // update comments
            state.commentsDepth = filteredCommentsDepth;
        },
        // open comment block modal
        commentOpenCommentBlockModal: (state, action)=>({
                ...state,
                commentBlockModal: {
                    comment: action.payload.comment,
                    open: true
                }
            }),
        // close comment block modal
        commentCloseCommentBlockModal: (state)=>({
                ...state,
                commentBlockModal: {
                    comment: undefined,
                    open: false
                }
            }),
        // open comment delete modal
        commentOpenCommentDeleteModal: (state, action)=>({
                ...state,
                commentDeleteModal: {
                    comment: action.payload.comment,
                    open: true
                }
            }),
        // close comment delete modal
        commentCloseCommentDeleteModal: (state)=>({
                ...state,
                commentDeleteModal: {
                    comment: undefined,
                    open: false
                }
            }),
        // add depth
        commentAddDepth: (state, action)=>({
                ...state,
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: [
                    action.payload.comment,
                    ...state.commentsDepth
                ]
            }),
        // remove depth
        commentRemoveDepth: (state)=>({
                ...state,
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: [
                    ...state.commentsDepth.slice(1)
                ]
            })
    },
    extraReducers: (builder)=>{
        // get comments
        builder.addCase((0, $kCfD8.commentGetComments).pending, (state)=>({
                ...state,
                commentGetCommentsLoading: true
            })).addCase((0, $kCfD8.commentGetComments).fulfilled, (state)=>({
                ...state,
                commentsFetched: true,
                commentGetCommentsLoading: false
            }));
        // create comment
        builder.addCase((0, $kCfD8.commentCreate).pending, (state)=>({
                ...state,
                commentCreateLoading: true
            })).addCase((0, $kCfD8.commentCreate).fulfilled, (state)=>({
                ...state,
                commentCreateLoading: false
            }));
        // update comment
        builder.addCase((0, $kCfD8.commentUpdate).pending, (state)=>({
                ...state,
                commentUpdateLoading: true
            })).addCase((0, $kCfD8.commentUpdate).fulfilled, (state)=>({
                ...state,
                commentUpdateLoading: false
            }));
        // block comment
        builder.addCase((0, $kCfD8.commentBlock).pending, (state)=>({
                ...state,
                commentBlockLoading: true
            })).addCase((0, $kCfD8.commentBlock).fulfilled, (state)=>({
                ...state,
                commentBlockLoading: false
            }));
        // delete comment
        builder.addCase((0, $kCfD8.commentDelete).pending, (state)=>({
                ...state,
                commentDeleteLoading: true
            })).addCase((0, $kCfD8.commentDelete).fulfilled, (state)=>({
                ...state,
                commentDeleteLoading: false
            }));
    }
});
const { commentResetState: $637b7a1869193f7d$export$bf76718181990b6e, commentSetComments: $637b7a1869193f7d$export$85292e9081798741, commentResetComments: $637b7a1869193f7d$export$c309ca146d80ecec, commentFilterComment: $637b7a1869193f7d$export$f6003723296faa6f, commentFilterUserComments: $637b7a1869193f7d$export$7c60efed55d280ea, commentAddComment: $637b7a1869193f7d$export$50bedd2684311fb4, commentUpdateComment: $637b7a1869193f7d$export$632c88bd775bcae9, commentOpenCommentBlockModal: $637b7a1869193f7d$export$d9f1b5989bbb1f59, commentCloseCommentBlockModal: $637b7a1869193f7d$export$4481126479d8d975, commentOpenCommentDeleteModal: $637b7a1869193f7d$export$f5b455630aac12a6, commentCloseCommentDeleteModal: $637b7a1869193f7d$export$980fbe285aaf28af, commentAddDepth: $637b7a1869193f7d$export$53b5f7a5216d6b03, commentRemoveDepth: $637b7a1869193f7d$export$c0b46e92200ba298 } = $637b7a1869193f7d$export$6f10542002196596.actions;
const $637b7a1869193f7d$export$9391eb82973eda85 = (state)=>state.comment.comments;
const $637b7a1869193f7d$export$32efe9d5e932cf81 = (state)=>state.comment.comments.length;
const $637b7a1869193f7d$export$e65b8eaba6d91637 = (state)=>state.comment.commentsCount;
const $637b7a1869193f7d$export$31ae2fc3ac8394fb = (state)=>state.comment.commentsFetched;
const $637b7a1869193f7d$export$892bf2334087f1ea = (state)=>state.comment.commentBlockModal.open;
const $637b7a1869193f7d$export$e9d740ddaf26d801 = (state)=>state.comment.commentBlockModal.comment;
const $637b7a1869193f7d$export$576690c145ccb8eb = (state)=>state.comment.commentDeleteModal.open;
const $637b7a1869193f7d$export$ea9afaaaafe09ae5 = (state)=>state.comment.commentDeleteModal.comment;
const $637b7a1869193f7d$export$4d1c2c156616749c = (state)=>state.comment.commentsDepth;
const $637b7a1869193f7d$export$e8eee21aefba81a2 = (state)=>state.comment.commentsDepth.length;
const $637b7a1869193f7d$export$fbc11414a54c1d5b = (state)=>state.comment.commentGetCommentsLoading;
const $637b7a1869193f7d$export$905470f2c19d133e = (state)=>state.comment.commentCreateLoading;
const $637b7a1869193f7d$export$f651d62a59500408 = (state)=>state.comment.commentUpdateLoading;
const $637b7a1869193f7d$export$2496612e297163c8 = (state)=>state.comment.commentBlockLoading;
const $637b7a1869193f7d$export$3b3a1599d46c45b1 = (state)=>state.comment.commentDeleteLoading;
const $637b7a1869193f7d$export$5ff8fec368de6099 = $637b7a1869193f7d$export$6f10542002196596.reducer; // export default commentSlice.reducer

});

parcelRegister("kCfD8", function(module, exports) {

$parcel$export(module.exports, "commentGetComments", function () { return $b6e73e616fab7b25$export$b1c2e2a7ed12f293; });
$parcel$export(module.exports, "commentCreate", function () { return $b6e73e616fab7b25$export$18cd8f3c0240b0a7; });
$parcel$export(module.exports, "commentUpdate", function () { return $b6e73e616fab7b25$export$8bc6276e5d81ca08; });
$parcel$export(module.exports, "commentBlock", function () { return $b6e73e616fab7b25$export$c4b788daf331c00; });
$parcel$export(module.exports, "commentDelete", function () { return $b6e73e616fab7b25$export$e5a979b36f99b7ac; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $lWbfW = parcelRequire("lWbfW");
var $6CAIO = parcelRequire("6CAIO");
const $b6e73e616fab7b25$export$b1c2e2a7ed12f293 = (0, $dEr3t.createAsyncThunk)("comment/commentGetComments", async ({ postId: postId, commentId: commentId, limit: limit, offset: offset, search: search }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // if depth exists
        if (commentId) {
            // retrieve replies
            const { comments: comments, count: count } = await api.commentApi.getReplies(commentId, postId, limit, offset, search);
            // set replies
            dispatch((0, $lWbfW.commentSetComments)({
                comments: comments || [],
                count: count || 0,
                offset: offset || 0
            }));
            // return empty payload
            return {
                error: ""
            };
        }
        // retrieve comments
        const { comments: comments, count: count } = await api.commentApi.getComments(postId, limit, offset, search);
        // set comments
        dispatch((0, $lWbfW.commentSetComments)({
            comments: comments || [],
            count: count || 0,
            offset: offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $b6e73e616fab7b25$export$18cd8f3c0240b0a7 = (0, $dEr3t.createAsyncThunk)("comment/commentCreate", async ({ message: message, postId: postId, commentId: commentId }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create comment
        const { comment: comment } = await api.commentApi.createComment({
            message: message,
            postId: postId,
            commentId: commentId
        });
        // add comment to state
        dispatch((0, $lWbfW.commentAddComment)({
            comment: comment || {}
        }));
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully created comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create comment: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $b6e73e616fab7b25$export$8bc6276e5d81ca08 = (0, $dEr3t.createAsyncThunk)("comment/commentUpdate", async ({ comment: comment, message: message }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // update comment
        const { comment: updatedComment } = await api.commentApi.updateComment({
            commentId: comment.id || "",
            message: message
        });
        // update comment in state
        dispatch((0, $lWbfW.commentUpdateComment)({
            updatedComment: {
                ...comment,
                message: updatedComment?.message
            }
        }));
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully updated comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to update comment: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $b6e73e616fab7b25$export$c4b788daf331c00 = (0, $dEr3t.createAsyncThunk)("comment/commentBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // block comment
        await api.commentApi.blockComment({
            commentId: id
        });
        // filter blocked comment
        dispatch((0, $lWbfW.commentFilterComment)({
            id: id
        }));
        // set comment as blocked in the report state
        dispatch((0, $6CAIO.reportSetReportEntityBlocked)());
        // close comment block modal
        dispatch((0, $lWbfW.commentCloseCommentBlockModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully blocked comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to block comment: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $b6e73e616fab7b25$export$e5a979b36f99b7ac = (0, $dEr3t.createAsyncThunk)("comment/commentDelete", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete comment
        await api.commentApi.deleteComment(id);
        // filter deleted comment
        dispatch((0, $lWbfW.commentFilterComment)({
            id: id
        }));
        // close comment delete modal
        dispatch((0, $lWbfW.commentCloseCommentDeleteModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully deleted comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to delete comment: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("2aUn0", function(module, exports) {

$parcel$export(module.exports, "ConnectViewProfile", function () { return (parcelRequire("di4wI")).ConnectViewProfile; });
parcelRequire("jztvn");
var $di4wI = parcelRequire("di4wI");

var $c1P9M = parcelRequire("c1P9M");

var $bQzFA = parcelRequire("bQzFA");
$parcel$exportWildcard(module.exports, $c1P9M);
$parcel$exportWildcard(module.exports, $bQzFA);

});
parcelRegister("jztvn", function(module, exports) {

$parcel$export(module.exports, "ConnectViewProfile", function () { return (parcelRequire("di4wI")).ConnectViewProfile; });

var $di4wI = parcelRequire("di4wI");

});
parcelRegister("di4wI", function(module, exports) {

$parcel$export(module.exports, "ConnectViewProfile", function () { return $13ecb1869454cde7$export$f6b69a8282d35c1d; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bQzFA = parcelRequire("bQzFA");
var $c1P9M = parcelRequire("c1P9M");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("KgOij");
var $gcOxm = parcelRequire("gcOxm");
var $8CPer = parcelRequire("8CPer");
var $1AANc = parcelRequire("1AANc");
var $8xdIK = parcelRequire("8xdIK");

var $4riRI = parcelRequire("4riRI");
const $13ecb1869454cde7$export$f6b69a8282d35c1d = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const connectStatus = (0, $9CcOD.useAppSelector)((0, $c1P9M.connectSelectConnectStatus));
    const { available: availableBalance, pending: pendingBalance } = (0, $9CcOD.useAppSelector)((0, $c1P9M.connectSelectConnectBalance));
    const connectOnboardingLink = (0, $9CcOD.useAppSelector)((0, $c1P9M.connectSelectConnectOnboardingLink));
    const connectGetConnectOnboardingLinkLoading = (0, $9CcOD.useAppSelector)((0, $c1P9M.connectSelectConnectGetConnectOnboardingLinkLoading));
    const connectCreatePayoutLoading = (0, $9CcOD.useAppSelector)((0, $c1P9M.connectSelectConnectCreatePayoutLoading));
    const minPayoutAvailableBalance = 5000;
    const hasEnoughBalance = availableBalance >= minPayoutAvailableBalance;
    const isConnectReady = connectStatus === (0, $aeAwZ.EntityConnectStatus).Complete || connectStatus === (0, $aeAwZ.EntityConnectStatus).Enabled;
    const canPayout = hasEnoughBalance && isConnectReady;
    const updateConnectDisabled = connectGetConnectOnboardingLinkLoading;
    const createPayoutDisabled = !canPayout || connectCreatePayoutLoading;
    (0, $exYeM.useEffect)(()=>{
        // get connect status
        dispatch((0, $bQzFA.connectGetConnectStatus)());
        // get connect balance
        dispatch((0, $bQzFA.connectGetConnectBalance)());
        // get connect onboarding link
        dispatch((0, $bQzFA.connectGetConnectOnboardingLink)());
    }, [
        dispatch
    ]);
    const getBusinessAccountMessage = (status)=>{
        switch(status){
            case (0, $aeAwZ.EntityConnectStatus).Pending:
                return "Set up your business account to unlock full potential.";
            case (0, $aeAwZ.EntityConnectStatus).Restricted:
                return "We need a bit more info to complete your business account setup.";
            case (0, $aeAwZ.EntityConnectStatus).Enabled:
                return "Your business account is almost ready, but we need some extra details from you.";
            case (0, $aeAwZ.EntityConnectStatus).Complete:
                return "Your business account setup is complete.";
            default:
                return "";
        }
    };
    const getUpdateButtonText = (status)=>{
        switch(status){
            case (0, $aeAwZ.EntityConnectStatus).Complete:
                return "Update";
            default:
                return "Set up";
        }
    };
    const getPayoutButtonText = (payoutAvailable)=>payoutAvailable ? "Create payout" : "Create payout (min $50)";
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $4riRI.styles)().card.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $4riRI.styles)().card.content.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $4riRI.styles)().card.content.account.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $4riRI.styles)().card.content.account.status.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4riRI.styles)().card.content.account.status.title,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8xdIK.Title), {
                                        text: "Stripe business account"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4riRI.styles)().card.content.account.status.name,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8CPer.Status), {
                                        status: connectStatus
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4riRI.styles)().card.content.account.status.subtitle,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1AANc.Subtitle), {
                                text: getBusinessAccountMessage(connectStatus)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $4riRI.styles)().card.content.balance.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4riRI.styles)().card.content.balance.title,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8xdIK.Title), {
                                text: "Balance overview"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4riRI.styles)().card.content.balance.pending,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gcOxm.Balance), {
                                amount: pendingBalance,
                                subtitle: "Pending Balance"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4riRI.styles)().card.content.balance.available,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gcOxm.Balance), {
                                amount: availableBalance,
                                subtitle: "Available Balance"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $4riRI.styles)().card.content.buttons.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4riRI.styles)().card.content.buttons.update,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "update connect account",
                                disabled: updateConnectDisabled,
                                appearance: "secondary",
                                onClick: ()=>{
                                    window.location.assign(connectOnboardingLink);
                                },
                                children: connectGetConnectOnboardingLinkLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : getUpdateButtonText(connectStatus)
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4riRI.styles)().card.content.buttons.payout,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "create payout",
                                disabled: createPayoutDisabled,
                                appearance: "primary",
                                onClick: ()=>{
                                    dispatch((0, $bQzFA.connectCreatePayout)());
                                },
                                children: connectCreatePayoutLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : getPayoutButtonText(canPayout)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$13ecb1869454cde7$export$f6b69a8282d35c1d.propTypes = {};

});
parcelRegister("KgOij", function(module, exports) {

$parcel$export(module.exports, "Balance", function () { return (parcelRequire("gcOxm")).Balance; });
$parcel$export(module.exports, "Status", function () { return (parcelRequire("8CPer")).Status; });
$parcel$export(module.exports, "Subtitle", function () { return (parcelRequire("1AANc")).Subtitle; });
$parcel$export(module.exports, "Title", function () { return (parcelRequire("8xdIK")).Title; });

var $gcOxm = parcelRequire("gcOxm");

var $8CPer = parcelRequire("8CPer");

var $1AANc = parcelRequire("1AANc");

var $8xdIK = parcelRequire("8xdIK");

});
parcelRegister("gcOxm", function(module, exports) {

$parcel$export(module.exports, "Balance", function () { return $7279c7753172bf4c$export$276e99f8b64146b2; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $9ez0R = parcelRequire("9ez0R");
const $7279c7753172bf4c$export$276e99f8b64146b2 = ({ amount: amount, subtitle: subtitle })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9ez0R.styles)(theme).balance.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $9ez0R.styles)(theme).balance.amount,
                children: [
                    "$",
                    amount / 100
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9ez0R.styles)(theme).balance.subtitle,
                children: subtitle
            })
        ]
    });
};
$7279c7753172bf4c$export$276e99f8b64146b2.propTypes = {};

});
parcelRegister("9ez0R", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $22dea59e47354cd7$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $22dea59e47354cd7$export$9dd6ff9ea0189349 = (theme)=>({
        balance: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            amount: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h3, ";color:", theme.colors.secondary.light, ";", ""),
            subtitle: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("8CPer", function(module, exports) {

$parcel$export(module.exports, "Status", function () { return $92d2c4ddae3f7732$export$96e9906d6d93a972; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");

var $7dTht = parcelRequire("7dTht");
const $92d2c4ddae3f7732$export$96e9906d6d93a972 = ({ status: status })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7dTht.styles)(theme).status.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: [
                (0, $7dTht.styles)(theme).status.name.shared,
                status === (0, $aeAwZ.EntityConnectStatus).Pending && (0, $7dTht.styles)(theme).status.name.pending,
                status === (0, $aeAwZ.EntityConnectStatus).Restricted && (0, $7dTht.styles)(theme).status.name.restricted,
                status === (0, $aeAwZ.EntityConnectStatus).Enabled && (0, $7dTht.styles)(theme).status.name.enabled,
                status === (0, $aeAwZ.EntityConnectStatus).Complete && (0, $7dTht.styles)(theme).status.name.complete,
                "",
                ""
            ],
            children: status || `---`
        })
    });
};
$92d2c4ddae3f7732$export$96e9906d6d93a972.propTypes = {};

});
parcelRegister("7dTht", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $75cb79a85a5658dc$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $75cb79a85a5658dc$export$9dd6ff9ea0189349 = (theme)=>({
        status: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            name: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;height:30px;border-radius:20px;padding:0px 26px;font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                pending: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";", ""),
                restricted: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";background-color:", theme.colors.negative.normal, ";", ""),
                enabled: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.primary.normal, ";background-color:", theme.colors.positive.light, ";", ""),
                complete: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.primary.normal, ";background-color:", theme.colors.positive.normal, ";", "")
            }
        }
    });

});


parcelRegister("1AANc", function(module, exports) {

$parcel$export(module.exports, "Subtitle", function () { return $91d412f93d7e14e5$export$cf345ef34cd72655; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $22ZF7 = parcelRequire("22ZF7");
const $91d412f93d7e14e5$export$cf345ef34cd72655 = ({ text: text })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $22ZF7.styles)(theme).subtitle.main,
        children: text
    });
};
$91d412f93d7e14e5$export$cf345ef34cd72655.propTypes = {};

});
parcelRegister("22ZF7", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $cc21e16bdd079cd2$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $cc21e16bdd079cd2$export$9dd6ff9ea0189349 = (theme)=>({
        subtitle: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("8xdIK", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $4d2a0580dccb5152$export$f99233281efd08a0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $57AJ8 = parcelRequire("57AJ8");
const $4d2a0580dccb5152$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $57AJ8.styles)(theme).title.main,
        children: text
    });
};
$4d2a0580dccb5152$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("57AJ8", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $42e07cae55fcc2c6$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $42e07cae55fcc2c6$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("4riRI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fea1f12bd5e4a372$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fea1f12bd5e4a372$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fea1f12bd5e4a372$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $fea1f12bd5e4a372$var$_ref2 = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $fea1f12bd5e4a372$var$_ref3 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $fea1f12bd5e4a372$var$_ref4 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $fea1f12bd5e4a372$var$_ref5 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $fea1f12bd5e4a372$var$_ref6 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $fea1f12bd5e4a372$var$_ref7 = {
    name: "r5hahk",
    styles: "margin-right:20px"
};
var $fea1f12bd5e4a372$var$_ref8 = {
    name: "1gty26n",
    styles: "display:flex;margin-bottom:10px;align-items:center"
};
var $fea1f12bd5e4a372$var$_ref9 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $fea1f12bd5e4a372$var$_ref10 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $fea1f12bd5e4a372$var$_ref11 = {
    name: "7a6dt5",
    styles: "margin:50px 0px"
};
const $fea1f12bd5e4a372$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $fea1f12bd5e4a372$var$_ref11,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:400px;", (0, $48E0n.mq).tablet($fea1f12bd5e4a372$var$_ref10), ";", ""),
                account: {
                    main: $fea1f12bd5e4a372$var$_ref9,
                    status: {
                        main: $fea1f12bd5e4a372$var$_ref8,
                        title: $fea1f12bd5e4a372$var$_ref7,
                        name: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        subtitle: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                    }
                },
                balance: {
                    main: $fea1f12bd5e4a372$var$_ref6,
                    title: $fea1f12bd5e4a372$var$_ref5,
                    pending: $fea1f12bd5e4a372$var$_ref4,
                    available: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-bottom:32px;", (0, $48E0n.mq).tablet($fea1f12bd5e4a372$var$_ref3), ";", ""),
                    update: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:130px;}", (0, $48E0n.mq).tablet($fea1f12bd5e4a372$var$_ref2), ";", ""),
                    payout: $fea1f12bd5e4a372$var$_ref
                }
            }
        }
    });

});



parcelRegister("c1P9M", function(module, exports) {

$parcel$export(module.exports, "connectSlice", function () { return $df8b2dcab98f0bc6$export$af9a9e979a6f0d83; });
$parcel$export(module.exports, "connectResetState", function () { return $df8b2dcab98f0bc6$export$16a4a5a1b28ce32e; });
$parcel$export(module.exports, "connectSelectConnectBalance", function () { return $df8b2dcab98f0bc6$export$f26688763a5ab8a2; });
$parcel$export(module.exports, "connectSelectConnectStatus", function () { return $df8b2dcab98f0bc6$export$733e31380b7ddf97; });
$parcel$export(module.exports, "connectSelectConnectOnboardingLink", function () { return $df8b2dcab98f0bc6$export$40352c03dcaa7a5a; });
$parcel$export(module.exports, "connectSelectConnectLoginLink", function () { return $df8b2dcab98f0bc6$export$2c45777af9ccd7b7; });
$parcel$export(module.exports, "connectSelectConnectGetConnectStatusLoading", function () { return $df8b2dcab98f0bc6$export$27f61009dfbdab82; });
$parcel$export(module.exports, "connectSelectConnectGetConnectBalanceLoading", function () { return $df8b2dcab98f0bc6$export$f5d3129eed042924; });
$parcel$export(module.exports, "connectSelectConnectGetConnectOnboardingLinkLoading", function () { return $df8b2dcab98f0bc6$export$91e3d75843a0851b; });
$parcel$export(module.exports, "connectSelectConnectGetConnectLoginLinkLoading", function () { return $df8b2dcab98f0bc6$export$4c7d7d7a3b8795aa; });
$parcel$export(module.exports, "connectSelectConnectCreatePayoutLoading", function () { return $df8b2dcab98f0bc6$export$126a16eeb4842bd2; });
$parcel$export(module.exports, "connectReducer", function () { return $df8b2dcab98f0bc6$export$b3d13d625aab94b1; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $bQzFA = parcelRequire("bQzFA");
const $df8b2dcab98f0bc6$var$initialState = {
    connectStatus: undefined,
    connectBalance: {
        available: 0,
        pending: 0
    },
    connectOnboardingLink: "",
    connectLoginLink: "",
    connectGetConnectStatusLoading: false,
    connectGetConnectBalanceLoading: false,
    connectGetConnectOnboardingLinkLoading: false,
    connectGetConnectLoginLinkLoading: false,
    connectCreatePayoutLoading: false
};
const $df8b2dcab98f0bc6$export$af9a9e979a6f0d83 = (0, $dEr3t.createSlice)({
    name: "connect",
    initialState: $df8b2dcab98f0bc6$var$initialState,
    reducers: {
        // reset state
        connectResetState: ()=>({
                connectStatus: undefined,
                connectBalance: {
                    available: 0,
                    pending: 0
                },
                connectOnboardingLink: "",
                connectLoginLink: "",
                connectGetConnectStatusLoading: false,
                connectGetConnectBalanceLoading: false,
                connectGetConnectOnboardingLinkLoading: false,
                connectGetConnectLoginLinkLoading: false,
                connectCreatePayoutLoading: false
            })
    },
    extraReducers: (builder)=>{
        // get connect status
        builder.addCase((0, $bQzFA.connectGetConnectStatus).pending, (state)=>({
                ...state,
                connectGetConnectStatusLoading: true
            })).addCase((0, $bQzFA.connectGetConnectStatus).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectStatus: payload.status,
                connectGetConnectStatusLoading: false
            }));
        // get connect balance
        builder.addCase((0, $bQzFA.connectGetConnectBalance).pending, (state)=>({
                ...state,
                connectGetConnectBalanceLoading: true
            })).addCase((0, $bQzFA.connectGetConnectBalance).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectBalance: payload.balance,
                connectGetConnectBalanceLoading: false
            }));
        // get connect onboarding link
        builder.addCase((0, $bQzFA.connectGetConnectOnboardingLink).pending, (state)=>({
                ...state,
                connectGetConnectOnboardingLinkLoading: true
            })).addCase((0, $bQzFA.connectGetConnectOnboardingLink).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectOnboardingLink: payload.onboardingLink,
                connectGetConnectOnboardingLinkLoading: false
            }));
        // get connect login link
        builder.addCase((0, $bQzFA.connectGetConnectLoginLink).pending, (state)=>({
                ...state,
                connectGetConnectLoginLinkLoading: true
            })).addCase((0, $bQzFA.connectGetConnectLoginLink).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectLoginLink: payload.loginLink,
                connectGetConnectLoginLinkLoading: false
            }));
        // create payout
        builder.addCase((0, $bQzFA.connectCreatePayout).pending, (state)=>({
                ...state,
                connectCreatePayoutLoading: true
            })).addCase((0, $bQzFA.connectCreatePayout).fulfilled, (state)=>({
                ...state,
                connectCreatePayoutLoading: false
            }));
    }
});
const { connectResetState: $df8b2dcab98f0bc6$export$16a4a5a1b28ce32e } = $df8b2dcab98f0bc6$export$af9a9e979a6f0d83.actions;
const $df8b2dcab98f0bc6$export$f26688763a5ab8a2 = (state)=>state.connect.connectBalance;
const $df8b2dcab98f0bc6$export$733e31380b7ddf97 = (state)=>state.connect.connectStatus;
const $df8b2dcab98f0bc6$export$40352c03dcaa7a5a = (state)=>state.connect.connectOnboardingLink;
const $df8b2dcab98f0bc6$export$2c45777af9ccd7b7 = (state)=>state.connect.connectLoginLink;
const $df8b2dcab98f0bc6$export$27f61009dfbdab82 = (state)=>state.connect.connectGetConnectStatusLoading;
const $df8b2dcab98f0bc6$export$f5d3129eed042924 = (state)=>state.connect.connectGetConnectBalanceLoading;
const $df8b2dcab98f0bc6$export$91e3d75843a0851b = (state)=>state.connect.connectGetConnectOnboardingLinkLoading;
const $df8b2dcab98f0bc6$export$4c7d7d7a3b8795aa = (state)=>state.connect.connectGetConnectLoginLinkLoading;
const $df8b2dcab98f0bc6$export$126a16eeb4842bd2 = (state)=>state.connect.connectCreatePayoutLoading;
const $df8b2dcab98f0bc6$export$b3d13d625aab94b1 = $df8b2dcab98f0bc6$export$af9a9e979a6f0d83.reducer; // export default connectSlice.reducer

});

parcelRegister("bQzFA", function(module, exports) {

$parcel$export(module.exports, "connectGetConnectStatus", function () { return $4771e1906e392726$export$2c07193a2dabf237; });
$parcel$export(module.exports, "connectGetConnectBalance", function () { return $4771e1906e392726$export$e401564139153401; });
$parcel$export(module.exports, "connectGetConnectOnboardingLink", function () { return $4771e1906e392726$export$749ddfa1ff9ad91f; });
$parcel$export(module.exports, "connectGetConnectLoginLink", function () { return $4771e1906e392726$export$9f2d17ed815e9de3; });
$parcel$export(module.exports, "connectCreatePayout", function () { return $4771e1906e392726$export$1c82019f420b4ac9; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $cQu6S = parcelRequire("cQu6S");

var $4GPMh = parcelRequire("4GPMh");
const $4771e1906e392726$export$2c07193a2dabf237 = (0, $dEr3t.createAsyncThunk)("connect/connectGetConnectStatus", async ()=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get connect status
        const { status: status } = await api.connectApi.getConnectStatus();
        // return payload
        return {
            status: status,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            status: undefined,
            error: message
        };
    }
});
const $4771e1906e392726$export$e401564139153401 = (0, $dEr3t.createAsyncThunk)("connect/connectGetConnectBalance", async ()=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get connect balance
        const { availableBalance: availableBalance, pendingBalance: pendingBalance } = await api.connectApi.getConnectBalance();
        // return payload
        return {
            balance: {
                available: availableBalance || 0,
                pending: pendingBalance || 0
            },
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            balance: {
                available: 0,
                pending: 0
            },
            error: message
        };
    }
});
const $4771e1906e392726$export$749ddfa1ff9ad91f = (0, $dEr3t.createAsyncThunk)("connect/connectGetConnectOnboardingLink", async ()=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get connect onboarding link
        const { link: link } = await api.connectApi.getConnectLink((0, $4GPMh.ConnectLinkType).Onboarding);
        // return balance payload
        return {
            onboardingLink: link || "",
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            onboardingLink: "",
            error: message
        };
    }
});
const $4771e1906e392726$export$9f2d17ed815e9de3 = (0, $dEr3t.createAsyncThunk)("connect/connectGetConnectLoginLink", async ()=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get connect update link
        const { link: link } = await api.connectApi.getConnectLoginLink();
        // return payload
        return {
            loginLink: link || "",
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            loginLink: "",
            error: message
        };
    }
});
const $4771e1906e392726$export$1c82019f420b4ac9 = (0, $dEr3t.createAsyncThunk)("connect/connectCreatePayout", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create payout
        await api.connectApi.createConnectPayout();
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully created payout!"
            }
        }));
        // fetch outgoing transactions
        dispatch((0, $cQu6S.transactionGetOutgoingTransactions)({
            limit: 30,
            offset: 0
        }));
        // fetch balance
        dispatch($4771e1906e392726$export$e401564139153401());
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create payout: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});
parcelRegister("4GPMh", function(module, exports) {

$parcel$export(module.exports, "ConnectLinkType", function () { return $c882fe8fdb42a531$export$372751fe44bf95e8; });
var $c882fe8fdb42a531$export$372751fe44bf95e8;
(function(ConnectLinkType) {
    ConnectLinkType["Onboarding"] = "account_onboarding";
    ConnectLinkType["Update"] = "account_update";
})($c882fe8fdb42a531$export$372751fe44bf95e8 || ($c882fe8fdb42a531$export$372751fe44bf95e8 = {}));

});



parcelRegister("fcO4w", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethod", function () { return (parcelRequire("l9fBZ")).CustomerPaymentMethod; });
$parcel$export(module.exports, "CustomerPaymentMethodCreateModal", function () { return (parcelRequire("8gYQi")).CustomerPaymentMethodCreateModal; });
$parcel$export(module.exports, "CustomerPaymentMethodDefault", function () { return (parcelRequire("4hysC")).CustomerPaymentMethodDefault; });
$parcel$export(module.exports, "CustomerPaymentMethodListProfile", function () { return (parcelRequire("5dh2N")).CustomerPaymentMethodListProfile; });
$parcel$export(module.exports, "CustomerViewProfile", function () { return (parcelRequire("1rSIH")).CustomerViewProfile; });
parcelRequire("1WNJ9");
var $l9fBZ = parcelRequire("l9fBZ");
var $8gYQi = parcelRequire("8gYQi");
var $4hysC = parcelRequire("4hysC");
var $5dh2N = parcelRequire("5dh2N");
var $1rSIH = parcelRequire("1rSIH");

var $7YE0x = parcelRequire("7YE0x");

var $ksZn7 = parcelRequire("ksZn7");
$parcel$exportWildcard(module.exports, $7YE0x);
$parcel$exportWildcard(module.exports, $ksZn7);

});
parcelRegister("1WNJ9", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethod", function () { return (parcelRequire("l9fBZ")).CustomerPaymentMethod; });
$parcel$export(module.exports, "CustomerPaymentMethodCreateModal", function () { return (parcelRequire("8gYQi")).CustomerPaymentMethodCreateModal; });
$parcel$export(module.exports, "CustomerPaymentMethodDefault", function () { return (parcelRequire("4hysC")).CustomerPaymentMethodDefault; });
$parcel$export(module.exports, "CustomerPaymentMethodListProfile", function () { return (parcelRequire("5dh2N")).CustomerPaymentMethodListProfile; });
$parcel$export(module.exports, "CustomerViewProfile", function () { return (parcelRequire("1rSIH")).CustomerViewProfile; });

var $l9fBZ = parcelRequire("l9fBZ");

var $8gYQi = parcelRequire("8gYQi");

var $4hysC = parcelRequire("4hysC");

var $5dh2N = parcelRequire("5dh2N");

var $1rSIH = parcelRequire("1rSIH");

});
parcelRegister("l9fBZ", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethod", function () { return $6c3e7cc17522b9b6$export$5c351e716103ae5c; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $cRmR4 = parcelRequire("cRmR4");
var $9IIBp = parcelRequire("9IIBp");

var $633Z2 = parcelRequire("633Z2");
const $6c3e7cc17522b9b6$export$5c351e716103ae5c = ({ customerPaymentMethod: customerPaymentMethod, selected: selected, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    const { brand: brand, last4: last4, isDefault: isDefault } = customerPaymentMethod;
    const getPaymentMethodIcon = (cardBrand)=>{
        switch(cardBrand){
            case "amex":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Amex, {});
            case "diners":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Diners, {});
            case "discover":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Discover, {});
            case "eftpos_au":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Eft, {});
            case "jcb":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Jcb, {});
            case "mastercard":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Mastercard, {});
            case "unionpay":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).UnionPay, {});
            case "visa":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Visa, {});
            default:
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Card, {});
        }
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $633Z2.styles)(theme).method.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $633Z2.styles)(theme).method.type,
                children: getPaymentMethodIcon(brand || "")
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: [
                    (0, $633Z2.styles)(theme).method.data.main.shared,
                    selected && (0, $633Z2.styles)(theme).method.data.main.selected,
                    "",
                    ""
                ],
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $633Z2.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $633Z2.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $633Z2.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    last4 ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $633Z2.styles)(theme).method.data.digits,
                        children: last4
                    }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $633Z2.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $633Z2.styles)(theme).method.default,
                children: isDefault && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CheckCircle, {})
            })
        ]
    });
};
$6c3e7cc17522b9b6$export$5c351e716103ae5c.propTypes = {};

});
parcelRegister("633Z2", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e0d53d2c278da98e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e0d53d2c278da98e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e0d53d2c278da98e$var$_ref = {
    name: "1efi8gv",
    styles: "font-weight:bold"
};
var $e0d53d2c278da98e$var$_ref2 = {
    name: "nkt64x",
    styles: "margin-right:10px"
};
var $e0d53d2c278da98e$var$_ref3 = {
    name: "5trhql",
    styles: "margin-right:14px"
};
var $e0d53d2c278da98e$var$_ref4 = {
    name: "5trhql",
    styles: "margin-right:14px"
};
var $e0d53d2c278da98e$var$_ref5 = {
    name: "tov9r9",
    styles: "display:flex;align-items:center;height:30px"
};
const $e0d53d2c278da98e$export$9dd6ff9ea0189349 = (theme)=>({
        method: {
            main: $e0d53d2c278da98e$var$_ref5,
            type: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;width:46px;margin-right:32px;", (0, $48E0n.mq).mobile($e0d53d2c278da98e$var$_ref4), " &>svg{height:30px;}", ""),
            data: {
                main: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;cursor:pointer;transition:color 0.2s;margin-right:32px;", (0, $48E0n.mq).mobile($e0d53d2c278da98e$var$_ref3), " color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}&>div:not(:last-of-type){margin-right:16px;", (0, $48E0n.mq).mobile($e0d53d2c278da98e$var$_ref2), ";}", ""),
                    selected: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.accent.normal, ";", "")
                },
                circles: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";", ""),
                digits: $e0d53d2c278da98e$var$_ref
            },
            default: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;width:20px;height:20px;&>svg{width:20px;height:20px;&>path{fill:", theme.colors.positive.normal, ";}}", "")
        }
    });

});


parcelRegister("8gYQi", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateModal", function () { return $1af6729289f5369d$export$9ff1c52ff7c37b3f; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $7YE0x = parcelRequire("7YE0x");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("8PjTU");
var $gcbp4 = parcelRequire("gcbp4");

var $lAoBS = parcelRequire("lAoBS");
const $1af6729289f5369d$export$9ff1c52ff7c37b3f = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const customerPaymentMethodCreateModalOpen = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethodCreateModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lAoBS.styles)().modal.main,
        children: customerPaymentMethodCreateModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $7YE0x.customerCloseCustomerPaymentMethodCreateModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lAoBS.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gcbp4.CustomerPaymentMethodCreateCard), {})
            })
        })
    });
};
$1af6729289f5369d$export$9ff1c52ff7c37b3f.propTypes = {};

});
parcelRegister("8PjTU", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateCard", function () { return (parcelRequire("gcbp4")).CustomerPaymentMethodCreateCard; });

var $gcbp4 = parcelRequire("gcbp4");

});
parcelRegister("gcbp4", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateCard", function () { return $d1154f5bec56e8e8$export$a2fba47527901994; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $3UZjT = parcelRequire("3UZjT");
parcelRequire("dlJNO");
var $7Hbcq = parcelRequire("7Hbcq");
parcelRequire("2uUQU");
var $9VYkD = parcelRequire("9VYkD");
var $eJGWm = parcelRequire("eJGWm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $7YE0x = parcelRequire("7YE0x");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
parcelRequire("1SE81");
var $cckVl = parcelRequire("cckVl");
parcelRequire("lImjc");
var $ksWEl = parcelRequire("ksWEl");

var $bcZxr = parcelRequire("bcZxr");
const $d1154f5bec56e8e8$var$stripePromise = (0, $7Hbcq.loadStripe)("staging" === (0, $9VYkD.Environment).Production ? (0, $eJGWm.stripePublishableKeyProd) : (0, $eJGWm.stripePublishableKeyStag));
const $d1154f5bec56e8e8$export$a2fba47527901994 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const clientSecret = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethodCreateModalClientSecret));
    const customerPaymentMethodCreateError = "";
    const options = {
        clientSecret: clientSecret,
        appearance: (0, $cckVl.stripeAppearance)(theme)
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $bcZxr.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bcZxr.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $7YE0x.customerCloseCustomerPaymentMethodCreateModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $bcZxr.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bcZxr.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3UZjT.Elements), {
                            stripe: $d1154f5bec56e8e8$var$stripePromise,
                            options: options,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ksWEl.CustomerPaymentMethodCreateForm), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bcZxr.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: customerPaymentMethodCreateError
                        })
                    })
                ]
            })
        ]
    });
};
$d1154f5bec56e8e8$export$a2fba47527901994.propTypes = {};

});
parcelRegister("3UZjT", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("exYeM")));
})(module.exports, function(exports1, React) {
    "use strict";
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = "Invariant Violation";
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === "object";
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === "function";
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
    };
    var PLAIN_OBJECT_STR = "[object Object]";
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details."; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: "async",
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: "empty"
        };
        return {
            tag: "sync",
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: "react-stripe-js",
            version: "2.7.3"
        });
        stripe.registerAppInfo({
            name: "react-stripe-js",
            version: "2.7.3",
            url: "https://stripe.com/docs/stripe-js/react"
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = "ElementsContext";
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === "sync" && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                "clientSecret",
                "fonts"
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase("calls useElements()"), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase("mounts <ElementsConsumer>"); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded = [
        "on",
        "session"
    ];
    var CustomCheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutSdkContext.displayName = "CustomCheckoutSdkContext";
    var parseCustomCheckoutSdkContext = function parseCustomCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CustomCheckoutProvider> provider."));
        return ctx;
    };
    var CustomCheckoutContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutContext.displayName = "CustomCheckoutContext";
    var extractCustomCheckoutContextValue = function extractCustomCheckoutContextValue(customCheckoutSdk, sessionState) {
        if (!customCheckoutSdk) return null;
        customCheckoutSdk.on;
        customCheckoutSdk.session;
        var actions = _objectWithoutProperties(customCheckoutSdk, _excluded);
        if (!sessionState) return _objectSpread2(_objectSpread2({}, actions), customCheckoutSdk.session());
        return _objectSpread2(_objectSpread2({}, actions), sessionState);
    };
    var INVALID_STRIPE_ERROR$1 = "Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.";
    var CustomCheckoutProvider = function CustomCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                customCheckoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, customCheckoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.customCheckoutSdk) return ctx;
                return {
                    stripe: stripe,
                    customCheckoutSdk: customCheckoutSdk
                };
            });
        }; // Ref used to avoid calling initCustomCheckout multiple times when options changes
        var initCustomCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCustomCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCustomCheckoutCalledRef.current = true;
                    stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                        if (customCheckoutSdk) {
                            safeSetContext(stripe, customCheckoutSdk);
                            customCheckoutSdk.on("change", setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === "sync" && parsed.stripe && !initCustomCheckoutCalledRef.current) {
                initCustomCheckoutCalledRef.current = true;
                parsed.stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                    if (customCheckoutSdk) {
                        safeSetContext(parsed.stripe, customCheckoutSdk);
                        customCheckoutSdk.on("change", setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.customCheckoutSdk) return;
            if (options.clientSecret && !isUnknownObject(prevOptions) && !isEqual(options.clientSecret, prevOptions.clientSecret)) console.warn("Unsupported prop change: options.client_secret is not a mutable property.");
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.customCheckoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.customCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var customCheckoutContextValue = React.useMemo(function() {
            return extractCustomCheckoutContextValue(ctx.customCheckoutSdk, session);
        }, [
            ctx.customCheckoutSdk,
            session
        ]);
        if (!ctx.customCheckoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CustomCheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CustomCheckoutContext.Provider, {
            value: customCheckoutContextValue
        }, children));
    };
    CustomCheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            clientSecret: PropTypes.string.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCustomCheckoutSdkContextWithUseCase = function useCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CustomCheckoutSdkContext);
        return parseCustomCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCustomCheckoutSdkContextWithUseCase = function useElementsOrCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var customCheckoutSdkContext = React.useContext(CustomCheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (customCheckoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CustomCheckoutProvider> and <Elements> providers."));
        if (customCheckoutSdkContext) return parseCustomCheckoutSdkContext(customCheckoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCustomCheckout = function useCustomCheckout() {
        // ensure it's in CustomCheckoutProvider
        useCustomCheckoutSdkContextWithUseCase("calls useCustomCheckout()");
        var ctx = React.useContext(CustomCheckoutContext);
        if (!ctx) throw new Error("Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.");
        return ctx;
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = "elements" in ctx ? ctx.elements : null;
            var customCheckoutSdk = "customCheckoutSdk" in ctx ? ctx.customCheckoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, "blur", onBlur);
            useAttachEvent(element, "focus", onFocus);
            useAttachEvent(element, "escape", onEscape);
            useAttachEvent(element, "click", onClick);
            useAttachEvent(element, "loaderror", onLoadError);
            useAttachEvent(element, "loaderstart", onLoaderStart);
            useAttachEvent(element, "networkschange", onNetworksChange);
            useAttachEvent(element, "confirm", onConfirm);
            useAttachEvent(element, "cancel", onCancel);
            useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
            useAttachEvent(element, "shippingratechange", onShippingRateChange);
            useAttachEvent(element, "change", onChange);
            var readyCallback;
            if (onReady) {
                if (type === "expressCheckout") // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, "ready", readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || customCheckoutSdk)) {
                    var newElement = null;
                    if (customCheckoutSdk) newElement = customCheckoutSdk.createElement(type, options);
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                customCheckoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    "paymentRequest"
                ]);
                if (updates) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === "function") try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === "undefined";
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = "EmbeddedCheckoutProviderContext";
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error("<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>");
        return ctx;
    };
    var INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.";
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === "async" && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === "sync" && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.");
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn("Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.");
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.");
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.");
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.");
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.");
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCustomC = useElementsOrCustomCheckoutSdkContextWithUseCase("calls useStripe()"), stripe = _useElementsOrCustomC.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent("auBankAccount", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent("card", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent("cardNumber", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent("cardExpiry", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent("cardCvc", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent("fpxBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent("iban", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent("idealBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent("p24Bank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent("epsBank", isServer);
    var PaymentElement = createElementComponent("payment", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent("expressCheckout", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent("paymentRequestButton", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent("linkAuthentication", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent("address", isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent("shippingAddress", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent("paymentMethodMessaging", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent("affirmMessage", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent("afterpayClearpayMessage", isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CustomCheckoutProvider = CustomCheckoutProvider;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCustomCheckout = useCustomCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});

});

parcelRegister("dlJNO", function(module, exports) {
$parcel$export(module.exports, "loadStripe", function () { return (parcelRequire("7Hbcq")).loadStripe; });
parcelRequire("7Hbcq");

});
parcelRegister("7Hbcq", function(module, exports) {

$parcel$export(module.exports, "loadStripe", function () { return $c55f0f00c083b958$export$de80f7562c3fd6b1; });
var $c55f0f00c083b958$var$V3_URL = "https://js.stripe.com/v3";
var $c55f0f00c083b958$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $c55f0f00c083b958$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $c55f0f00c083b958$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($c55f0f00c083b958$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$c55f0f00c083b958$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $c55f0f00c083b958$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($c55f0f00c083b958$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $c55f0f00c083b958$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "3.4.1",
        startTime: startTime
    });
};
var $c55f0f00c083b958$var$stripePromise = null;
var $c55f0f00c083b958$var$onErrorListener = null;
var $c55f0f00c083b958$var$onLoadListener = null;
var $c55f0f00c083b958$var$onError = function onError(reject) {
    return function() {
        reject(new Error("Failed to load Stripe.js"));
    };
};
var $c55f0f00c083b958$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error("Stripe.js not available"));
    };
};
var $c55f0f00c083b958$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($c55f0f00c083b958$var$stripePromise !== null) return $c55f0f00c083b958$var$stripePromise;
    $c55f0f00c083b958$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($c55f0f00c083b958$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $c55f0f00c083b958$var$findScript();
            if (script && params) console.warn($c55f0f00c083b958$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $c55f0f00c083b958$var$injectScript(params);
            else if (script && $c55f0f00c083b958$var$onLoadListener !== null && $c55f0f00c083b958$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener("load", $c55f0f00c083b958$var$onLoadListener);
                script.removeEventListener("error", $c55f0f00c083b958$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $c55f0f00c083b958$var$injectScript(params);
            }
            $c55f0f00c083b958$var$onLoadListener = $c55f0f00c083b958$var$onLoad(resolve, reject);
            $c55f0f00c083b958$var$onErrorListener = $c55f0f00c083b958$var$onError(reject);
            script.addEventListener("load", $c55f0f00c083b958$var$onLoadListener);
            script.addEventListener("error", $c55f0f00c083b958$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $c55f0f00c083b958$var$stripePromise["catch"](function(error) {
        $c55f0f00c083b958$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $c55f0f00c083b958$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $c55f0f00c083b958$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $c55f0f00c083b958$var$stripePromise$1;
var $c55f0f00c083b958$var$loadCalled = false;
var $c55f0f00c083b958$var$getStripePromise = function getStripePromise() {
    if ($c55f0f00c083b958$var$stripePromise$1) return $c55f0f00c083b958$var$stripePromise$1;
    $c55f0f00c083b958$var$stripePromise$1 = $c55f0f00c083b958$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $c55f0f00c083b958$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
    return $c55f0f00c083b958$var$stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $c55f0f00c083b958$var$getStripePromise();
})["catch"](function(error) {
    if (!$c55f0f00c083b958$var$loadCalled) console.warn(error);
});
var $c55f0f00c083b958$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $c55f0f00c083b958$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $c55f0f00c083b958$var$getStripePromise().then(function(maybeStripe) {
        return $c55f0f00c083b958$var$initStripe(maybeStripe, args, startTime);
    });
};

});


parcelRegister("lImjc", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateForm", function () { return (parcelRequire("ksWEl")).CustomerPaymentMethodCreateForm; });

var $ksWEl = parcelRequire("ksWEl");

});
parcelRegister("ksWEl", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateForm", function () { return $3771b29934b15100$export$d3b1916139689608; });

var $5o6z6 = parcelRequire("5o6z6");

var $3UZjT = parcelRequire("3UZjT");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $ksZn7 = parcelRequire("ksZn7");
var $7YE0x = parcelRequire("7YE0x");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $eXyyd = parcelRequire("eXyyd");
const $3771b29934b15100$export$d3b1916139689608 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const customerCreateCustomerPaymentMethodLoading = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerCreateCustomerPaymentMethodLoading));
    const stripe = (0, $3UZjT.useStripe)();
    const elements = (0, $3UZjT.useElements)();
    const submitDisabled = customerCreateCustomerPaymentMethodLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $eXyyd.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $eXyyd.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                // create customer payment method with payment element
                dispatch((0, $ksZn7.customerCreateCustomerPaymentMethod)({
                    stripe: stripe,
                    elements: elements
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $eXyyd.styles)().form.content.card,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3UZjT.PaymentElement), {})
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $eXyyd.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "checkout",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: customerCreateCustomerPaymentMethodLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Create`
                    })
                })
            ]
        })
    });
};
$3771b29934b15100$export$d3b1916139689608.propTypes = {};

});
parcelRegister("eXyyd", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f7400030cb6b822b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f7400030cb6b822b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f7400030cb6b822b$var$_ref = {
    name: "18wktwv",
    styles: "display:flex;align-items:center;justify-content:left;margin-bottom:32px"
};
var $f7400030cb6b822b$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $f7400030cb6b822b$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                card: $f7400030cb6b822b$var$_ref2,
                checkbox: {
                    main: $f7400030cb6b822b$var$_ref,
                    label: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;font-size:", (0, $48E0n.typography).h6, ";user-select:none;margin-left:16px;", "")
                },
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("bcZxr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ef16fb68b8cd0600$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ef16fb68b8cd0600$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ef16fb68b8cd0600$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ef16fb68b8cd0600$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ef16fb68b8cd0600$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ef16fb68b8cd0600$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ef16fb68b8cd0600$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ef16fb68b8cd0600$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $ef16fb68b8cd0600$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $ef16fb68b8cd0600$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $ef16fb68b8cd0600$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($ef16fb68b8cd0600$var$_ref8), " ", (0, $48E0n.mq).mobile($ef16fb68b8cd0600$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($ef16fb68b8cd0600$var$_ref6), ";", ""),
            title: $ef16fb68b8cd0600$var$_ref5,
            subtitle: $ef16fb68b8cd0600$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($ef16fb68b8cd0600$var$_ref3), ";", ""),
                form: $ef16fb68b8cd0600$var$_ref2,
                error: $ef16fb68b8cd0600$var$_ref
            }
        }
    });

});



parcelRegister("lAoBS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $12f5edff2d51f485$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $12f5edff2d51f485$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $12f5edff2d51f485$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $12f5edff2d51f485$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($12f5edff2d51f485$var$_ref), ";", "")
        }
    });

});


parcelRegister("4hysC", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodDefault", function () { return $ad4ba283e6ce089c$export$903d5dcea0359875; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $cRmR4 = parcelRequire("cRmR4");

var $31MAl = parcelRequire("31MAl");
const $ad4ba283e6ce089c$export$903d5dcea0359875 = ({ brand: brand = "", last4: last4 = "" })=>{
    const theme = (0, $hXJcm.u)();
    const getPaymentMethodIcon = (cardBrand)=>{
        switch(cardBrand){
            case "amex":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Amex, {});
            case "diners":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Diners, {});
            case "discover":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Discover, {});
            case "eftpos_au":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Eft, {});
            case "jcb":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Jcb, {});
            case "mastercard":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Mastercard, {});
            case "unionpay":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).UnionPay, {});
            case "visa":
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Visa, {});
            default:
                return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cRmR4.cards).Card, {});
        }
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $31MAl.styles)(theme).method.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $31MAl.styles)(theme).method.type,
                children: getPaymentMethodIcon(brand || "")
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $31MAl.styles)(theme).method.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $31MAl.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $31MAl.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $31MAl.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    last4 ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $31MAl.styles)(theme).method.data.digits,
                        children: last4
                    }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $31MAl.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    })
                ]
            })
        ]
    });
};
$ad4ba283e6ce089c$export$903d5dcea0359875.propTypes = {};

});
parcelRegister("31MAl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b648a6b6605dd1ee$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b648a6b6605dd1ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b648a6b6605dd1ee$var$_ref = {
    name: "1efi8gv",
    styles: "font-weight:bold"
};
var $b648a6b6605dd1ee$var$_ref2 = {
    name: "nkt64x",
    styles: "margin-right:10px"
};
var $b648a6b6605dd1ee$var$_ref3 = {
    name: "1nwiza9",
    styles: "display:flex;align-items:center;margin-bottom:16px;&>svg{height:40px;}"
};
var $b648a6b6605dd1ee$var$_ref4 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
const $b648a6b6605dd1ee$export$9dd6ff9ea0189349 = (theme)=>({
        method: {
            main: $b648a6b6605dd1ee$var$_ref4,
            type: $b648a6b6605dd1ee$var$_ref3,
            data: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;cursor:pointer;transition:color 0.2s;color:", theme.colors.secondary.normal, ";&>div:not(:last-of-type){margin-right:16px;", (0, $48E0n.mq).mobile($b648a6b6605dd1ee$var$_ref2), ";}", ""),
                circles: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";", ""),
                digits: $b648a6b6605dd1ee$var$_ref
            }
        }
    });

});


parcelRegister("5dh2N", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodListProfile", function () { return $2780746cea8e2bfc$export$c35dd062ff2cce62; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $ksZn7 = parcelRequire("ksZn7");
var $l9fBZ = parcelRequire("l9fBZ");
var $7YE0x = parcelRequire("7YE0x");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $01bjf = parcelRequire("01bjf");
const $2780746cea8e2bfc$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const customerPaymentMethodSelected = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethodSelected));
    const customerPaymentMethods = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethods));
    const customerPaymentMethod = customerPaymentMethods[index];
    // if payment method not fetched
    if (!customerPaymentMethod) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "customer-payment-method-list-payment-method",
                    width: "100%",
                    height: "30px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $01bjf.styles)().pms.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $l9fBZ.CustomerPaymentMethod), {
            customerPaymentMethod: customerPaymentMethod,
            selected: customerPaymentMethodSelected?.id === customerPaymentMethod?.id,
            onClick: ()=>dispatch((0, $7YE0x.customerSelectCustomerPaymentMethod)({
                    customerPaymentMethod: customerPaymentMethod
                }))
        })
    });
});
const $2780746cea8e2bfc$export$c35dd062ff2cce62 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const customerPaymentMethods = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethods));
    const customerPaymentMethodsCount = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethodsCount));
    const customerPaymentMethodsLength = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethodsLength));
    const customerPaymentMethodsFetched = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethodsFetched));
    const paymentMethodCardHeight = 30;
    const paymentMethodCardMarginBottom = 10;
    const itemHeight = paymentMethodCardHeight + paymentMethodCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 160;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!customerPaymentMethods[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $ksZn7.customerGetCustomerPaymentMethods)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if payment methods are fetched but length is 0
    if (customerPaymentMethodsFetched && customerPaymentMethodsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $01bjf.styles)().list.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).CreditCard,
            height: "160px",
            title: "You don't have any payment methods yet"
        })
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $01bjf.styles)().list.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $01bjf.styles)().list.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
                isItemLoaded: isItemLoaded,
                loadMoreItems: loadMoreItems,
                itemCount: customerPaymentMethodsCount || defaultContentCount,
                minimumBatchSize: itemsToFetch,
                threshold: itemThreshold,
                children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                        className: "virtualized-list",
                        height: defaultListHeight,
                        itemSize: itemHeight,
                        itemCount: customerPaymentMethodsCount || defaultContentCount,
                        onItemsRendered: onItemsRendered,
                        ref: ref,
                        width: defaultListWidth,
                        layout: "vertical",
                        children: $2780746cea8e2bfc$var$Row
                    })
            })
        })
    }));
};
$2780746cea8e2bfc$export$c35dd062ff2cce62.propTypes = {};

});
parcelRegister("01bjf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $24592d5e80a52858$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $24592d5e80a52858$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $24592d5e80a52858$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
const $24592d5e80a52858$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: $24592d5e80a52858$var$_ref
            }
        },
        pms: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("1rSIH", function(module, exports) {

$parcel$export(module.exports, "CustomerViewProfile", function () { return $9f2a5c7ff3a700d9$export$1493c81b20626531; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $ksZn7 = parcelRequire("ksZn7");
var $5dh2N = parcelRequire("5dh2N");
var $7YE0x = parcelRequire("7YE0x");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("eADcL");
var $k7TCy = parcelRequire("k7TCy");

var $f8Bww = parcelRequire("f8Bww");
const $9f2a5c7ff3a700d9$export$1493c81b20626531 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const customerPaymentMethodSelected = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerPaymentMethodSelected));
    const customerDeleteCustomerPaymentMethodLoading = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerDeleteCustomerPaymentMethodLoading));
    const customerCreateCustomerPaymentMethodSetupLoading = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerCreateCustomerPaymentMethodSetupLoading));
    const customerSetCustomerPaymentMethodDefaultLoading = (0, $9CcOD.useAppSelector)((0, $7YE0x.customerSelectCustomerSetCustomerPaymentMethodDefaultLoading));
    const isPaymentMethodSelected = customerPaymentMethodSelected !== undefined;
    const isSelectedPaymentMethodDefault = customerPaymentMethodSelected?.isDefault === true;
    const deletePaymentMethodDisabled = !isPaymentMethodSelected || customerDeleteCustomerPaymentMethodLoading;
    const createPaymentMethodDisabled = customerCreateCustomerPaymentMethodSetupLoading;
    const setDefaultPaymentMethodDisabled = !isPaymentMethodSelected || isSelectedPaymentMethodDefault || customerSetCustomerPaymentMethodDefaultLoading;
    (0, $exYeM.useEffect)(()=>{
        // get payment methods
        dispatch((0, $ksZn7.customerGetCustomerPaymentMethods)({
            offset: 0,
            limit: 30
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $f8Bww.styles)().card.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $f8Bww.styles)().card.content.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $f8Bww.styles)().card.content.title,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k7TCy.Title), {
                        text: "Payment methods"
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $f8Bww.styles)().card.content.methods.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5dh2N.CustomerPaymentMethodListProfile), {})
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $f8Bww.styles)().card.content.buttons.main,
                    children: [
                        isPaymentMethodSelected ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $f8Bww.styles)().card.content.buttons.delete,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "delete payment method",
                                disabled: deletePaymentMethodDisabled,
                                appearance: "secondary",
                                onClick: ()=>{
                                    dispatch((0, $ksZn7.customerDeleteCustomerPaymentMethod)({
                                        customerPaymentMethod: customerPaymentMethodSelected || {}
                                    }));
                                },
                                children: customerDeleteCustomerPaymentMethodLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Delete"
                            })
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $f8Bww.styles)().card.content.buttons.create,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "create payment method",
                                disabled: createPaymentMethodDisabled,
                                appearance: "primary",
                                onClick: ()=>dispatch((0, $ksZn7.customerCreateCustomerPaymentMethodSetup)()),
                                children: customerCreateCustomerPaymentMethodSetupLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Create"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $f8Bww.styles)().card.content.buttons.set,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "set payment method as default",
                                disabled: setDefaultPaymentMethodDisabled,
                                appearance: "primary",
                                onClick: ()=>{
                                    dispatch((0, $ksZn7.customerSetCustomerPaymentMethodDefault)({
                                        customerPaymentMethod: customerPaymentMethodSelected || {}
                                    }));
                                },
                                children: customerSetCustomerPaymentMethodDefaultLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Set as Default"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$9f2a5c7ff3a700d9$export$1493c81b20626531.propTypes = {};

});
parcelRegister("eADcL", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return (parcelRequire("k7TCy")).Title; });

var $k7TCy = parcelRequire("k7TCy");

});
parcelRegister("k7TCy", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $82f7e205f4d4aa61$export$f99233281efd08a0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $4RMpo = parcelRequire("4RMpo");
const $82f7e205f4d4aa61$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $4RMpo.styles)(theme).title.main,
        children: text
    });
};
$82f7e205f4d4aa61$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("4RMpo", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5e172dbb454598f4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $5e172dbb454598f4$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("f8Bww", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $393ce4d4dc8d9972$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $393ce4d4dc8d9972$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $393ce4d4dc8d9972$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $393ce4d4dc8d9972$var$_ref2 = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $393ce4d4dc8d9972$var$_ref3 = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $393ce4d4dc8d9972$var$_ref4 = {
    name: "17y49kf",
    styles: "flex-direction:column;width:100%"
};
var $393ce4d4dc8d9972$var$_ref5 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $393ce4d4dc8d9972$var$_ref6 = {
    name: "j9ove5",
    styles: "margin-bottom:22px"
};
var $393ce4d4dc8d9972$var$_ref7 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $393ce4d4dc8d9972$var$_ref8 = {
    name: "7a6dt5",
    styles: "margin:50px 0px"
};
const $393ce4d4dc8d9972$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $393ce4d4dc8d9972$var$_ref8,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("max-width:800px;", (0, $48E0n.mq).tablet($393ce4d4dc8d9972$var$_ref7), ";", ""),
                title: $393ce4d4dc8d9972$var$_ref6,
                methods: {
                    main: $393ce4d4dc8d9972$var$_ref5
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-bottom:32px;width:400px;", (0, $48E0n.mq).tablet($393ce4d4dc8d9972$var$_ref4), ";", ""),
                    delete: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:130px;}", (0, $48E0n.mq).tablet($393ce4d4dc8d9972$var$_ref3), ";", ""),
                    create: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:130px;}", (0, $48E0n.mq).tablet($393ce4d4dc8d9972$var$_ref2), ";", ""),
                    set: $393ce4d4dc8d9972$var$_ref
                }
            }
        }
    });

});



parcelRegister("7YE0x", function(module, exports) {

$parcel$export(module.exports, "customerSlice", function () { return $daa072bb53d2834e$export$2ae3d640159c6d99; });
$parcel$export(module.exports, "customerResetState", function () { return $daa072bb53d2834e$export$e8611f1371357562; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethod", function () { return $daa072bb53d2834e$export$36631dd251fe5c6c; });
$parcel$export(module.exports, "customerSetCustomerPaymentMethods", function () { return $daa072bb53d2834e$export$d3675be8a985ff73; });
$parcel$export(module.exports, "customerOpenCustomerPaymentMethodCreateModal", function () { return $daa072bb53d2834e$export$73439e5c1c8cb7c3; });
$parcel$export(module.exports, "customerCloseCustomerPaymentMethodCreateModal", function () { return $daa072bb53d2834e$export$6ebf30059d388a82; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethods", function () { return $daa072bb53d2834e$export$1c810647799c8d17; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodsLength", function () { return $daa072bb53d2834e$export$79b2f162e22bae6e; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodsCount", function () { return $daa072bb53d2834e$export$f293b366466a19aa; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodsFetched", function () { return $daa072bb53d2834e$export$4a36ad94fa280cd7; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodSelected", function () { return $daa072bb53d2834e$export$e1cdac964ce638d8; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodCreateModalOpen", function () { return $daa072bb53d2834e$export$5f41e97201b93f24; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodCreateModalClientSecret", function () { return $daa072bb53d2834e$export$af4ca5677d61a6b6; });
$parcel$export(module.exports, "customerSelectCustomerGetCustomerPaymentMethodsLoading", function () { return $daa072bb53d2834e$export$ee06c98f7e90ab8e; });
$parcel$export(module.exports, "customerSelectCustomerCreateCustomerPaymentMethodSetupLoading", function () { return $daa072bb53d2834e$export$16c18301d24bcd0d; });
$parcel$export(module.exports, "customerSelectCustomerCreateCustomerPaymentMethodLoading", function () { return $daa072bb53d2834e$export$6e19e431c89cee0d; });
$parcel$export(module.exports, "customerSelectCustomerDeleteCustomerPaymentMethodLoading", function () { return $daa072bb53d2834e$export$7ff1e0cdf406ce47; });
$parcel$export(module.exports, "customerSelectCustomerSetCustomerPaymentMethodDefaultLoading", function () { return $daa072bb53d2834e$export$3756350e3b4b2e28; });
$parcel$export(module.exports, "customerReducer", function () { return $daa072bb53d2834e$export$949d24f84332859b; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $ksZn7 = parcelRequire("ksZn7");
const $daa072bb53d2834e$var$initialState = {
    customerPaymentMethods: [],
    customerPaymentMethodsCount: 0,
    customerPaymentMethodsFetched: false,
    customerPaymentMethodSelected: undefined,
    customerPaymentMethodCreateModal: {
        clientSecret: "",
        open: false
    },
    customerGetCustomerPaymentMethodsLoading: false,
    customerCreateCustomerPaymentMethodSetupLoading: false,
    customerCreateCustomerPaymentMethodLoading: false,
    customerDeleteCustomerPaymentMethodLoading: false,
    customerSetCustomerPaymentMethodDefaultLoading: false
};
const $daa072bb53d2834e$export$2ae3d640159c6d99 = (0, $dEr3t.createSlice)({
    name: "customer",
    initialState: $daa072bb53d2834e$var$initialState,
    reducers: {
        // reset state
        customerResetState: ()=>({
                customerPaymentMethods: [],
                customerPaymentMethodsCount: 0,
                customerPaymentMethodsFetched: false,
                customerPaymentMethodSelected: undefined,
                customerPaymentMethodCreateModal: {
                    clientSecret: "",
                    open: false
                },
                customerGetCustomerPaymentMethodsLoading: false,
                customerCreateCustomerPaymentMethodSetupLoading: false,
                customerCreateCustomerPaymentMethodLoading: false,
                customerDeleteCustomerPaymentMethodLoading: false,
                customerSetCustomerPaymentMethodDefaultLoading: false
            }),
        // select customer payment method
        customerSelectCustomerPaymentMethod: (state, action)=>{
            const { customerPaymentMethod: customerPaymentMethod } = action.payload;
            // mutate selected customer payment method
            // if provided payment method already selected - unselect it
            // else select provided payment method
            state.customerPaymentMethodSelected = state.customerPaymentMethodSelected?.id === customerPaymentMethod?.id ? undefined : customerPaymentMethod;
        },
        // set customer payment methods
        customerSetCustomerPaymentMethods: (state, action)=>{
            const { customerPaymentMethods: customerPaymentMethods, count: count, offset: offset } = action.payload;
            // mutate count
            state.customerPaymentMethodsCount = count;
            // mutate payment methods array
            state.customerPaymentMethods = (0, $9UVKd.mergeArraysAtIndex)(state.customerPaymentMethods, customerPaymentMethods, offset);
        },
        // open customer payment method create modal
        customerOpenCustomerPaymentMethodCreateModal: (state, action)=>({
                ...state,
                customerPaymentMethodCreateModal: {
                    clientSecret: action.payload.clientSecret,
                    open: true
                }
            }),
        // close customer payment method create modal
        customerCloseCustomerPaymentMethodCreateModal: (state)=>({
                ...state,
                customerPaymentMethodCreateModal: {
                    clientSecret: "",
                    open: false
                }
            })
    },
    extraReducers: (builder)=>{
        // get customer payment methods
        builder.addCase((0, $ksZn7.customerGetCustomerPaymentMethods).pending, (state)=>({
                ...state,
                customerGetCustomerPaymentMethodsLoading: true
            })).addCase((0, $ksZn7.customerGetCustomerPaymentMethods).fulfilled, (state)=>({
                ...state,
                customerPaymentMethodsFetched: true,
                customerGetCustomerPaymentMethodsLoading: false
            }));
        // create customer payment method setup
        builder.addCase((0, $ksZn7.customerCreateCustomerPaymentMethodSetup).pending, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodSetupLoading: true
            })).addCase((0, $ksZn7.customerCreateCustomerPaymentMethodSetup).fulfilled, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodSetupLoading: false
            }));
        // create customer payment method
        builder.addCase((0, $ksZn7.customerCreateCustomerPaymentMethod).pending, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodLoading: true
            })).addCase((0, $ksZn7.customerCreateCustomerPaymentMethod).fulfilled, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodLoading: false
            }));
        // delete customer payment method
        builder.addCase((0, $ksZn7.customerDeleteCustomerPaymentMethod).pending, (state)=>({
                ...state,
                customerDeleteCustomerPaymentMethodLoading: true
            })).addCase((0, $ksZn7.customerDeleteCustomerPaymentMethod).fulfilled, (state)=>({
                ...state,
                customerDeleteCustomerPaymentMethodLoading: false
            }));
        // set customer payment method default
        builder.addCase((0, $ksZn7.customerSetCustomerPaymentMethodDefault).pending, (state)=>({
                ...state,
                customerSetCustomerPaymentMethodDefaultLoading: true
            })).addCase((0, $ksZn7.customerSetCustomerPaymentMethodDefault).fulfilled, (state, { payload: payload })=>({
                ...state,
                customerSetCustomerPaymentMethodDefaultLoading: false,
                error: payload.error
            }));
    }
});
const { customerResetState: $daa072bb53d2834e$export$e8611f1371357562, customerSelectCustomerPaymentMethod: $daa072bb53d2834e$export$36631dd251fe5c6c, customerSetCustomerPaymentMethods: $daa072bb53d2834e$export$d3675be8a985ff73, customerOpenCustomerPaymentMethodCreateModal: $daa072bb53d2834e$export$73439e5c1c8cb7c3, customerCloseCustomerPaymentMethodCreateModal: $daa072bb53d2834e$export$6ebf30059d388a82 } = $daa072bb53d2834e$export$2ae3d640159c6d99.actions;
const $daa072bb53d2834e$export$1c810647799c8d17 = (state)=>state.customer.customerPaymentMethods;
const $daa072bb53d2834e$export$79b2f162e22bae6e = (state)=>state.customer.customerPaymentMethods.length;
const $daa072bb53d2834e$export$f293b366466a19aa = (state)=>state.customer.customerPaymentMethodsCount;
const $daa072bb53d2834e$export$4a36ad94fa280cd7 = (state)=>state.customer.customerPaymentMethodsFetched;
const $daa072bb53d2834e$export$e1cdac964ce638d8 = (state)=>state.customer.customerPaymentMethodSelected;
const $daa072bb53d2834e$export$5f41e97201b93f24 = (state)=>state.customer.customerPaymentMethodCreateModal.open;
const $daa072bb53d2834e$export$af4ca5677d61a6b6 = (state)=>state.customer.customerPaymentMethodCreateModal.clientSecret;
const $daa072bb53d2834e$export$ee06c98f7e90ab8e = (state)=>state.customer.customerGetCustomerPaymentMethodsLoading;
const $daa072bb53d2834e$export$16c18301d24bcd0d = (state)=>state.customer.customerCreateCustomerPaymentMethodSetupLoading;
const $daa072bb53d2834e$export$6e19e431c89cee0d = (state)=>state.customer.customerCreateCustomerPaymentMethodLoading;
const $daa072bb53d2834e$export$7ff1e0cdf406ce47 = (state)=>state.customer.customerDeleteCustomerPaymentMethodLoading;
const $daa072bb53d2834e$export$3756350e3b4b2e28 = (state)=>state.customer.customerSetCustomerPaymentMethodDefaultLoading;
const $daa072bb53d2834e$export$949d24f84332859b = $daa072bb53d2834e$export$2ae3d640159c6d99.reducer; // export default customerSlice.reducer

});

parcelRegister("ksZn7", function(module, exports) {

$parcel$export(module.exports, "customerGetCustomerPaymentMethods", function () { return $f24cfb7a84de9d69$export$aae3832a27512d82; });
$parcel$export(module.exports, "customerCreateCustomerPaymentMethodSetup", function () { return $f24cfb7a84de9d69$export$ac39972811fd4372; });
$parcel$export(module.exports, "customerCreateCustomerPaymentMethod", function () { return $f24cfb7a84de9d69$export$a511c4c6d7bd397d; });
$parcel$export(module.exports, "customerDeleteCustomerPaymentMethod", function () { return $f24cfb7a84de9d69$export$8e61ca7747be6855; });
$parcel$export(module.exports, "customerSetCustomerPaymentMethodDefault", function () { return $f24cfb7a84de9d69$export$61f68d108929c87; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("2uUQU");
var $9VYkD = parcelRequire("9VYkD");
var $8kVRe = parcelRequire("8kVRe");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $7YE0x = parcelRequire("7YE0x");
const $f24cfb7a84de9d69$export$aae3832a27512d82 = (0, $dEr3t.createAsyncThunk)("customer/customerGetCustomerPaymentMethods", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get payment methods
        const { customerPaymentMethods: customerPaymentMethods, count: count } = await api.customerApi.getCustomerPaymentMethods(inp.limit, inp.offset);
        // set payment methods
        dispatch((0, $7YE0x.customerSetCustomerPaymentMethods)({
            customerPaymentMethods: customerPaymentMethods || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $f24cfb7a84de9d69$export$ac39972811fd4372 = (0, $dEr3t.createAsyncThunk)("customer/customerCreateCustomerPaymentMethodSetup", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create customer payment method setup
        const { clientSecret: clientSecret } = await api.customerApi.createCustomerPaymentMethodSetup();
        // open customer payment method create modal
        dispatch((0, $7YE0x.customerOpenCustomerPaymentMethodCreateModal)({
            clientSecret: clientSecret || ""
        }));
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to setup customer payment method creation: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $f24cfb7a84de9d69$export$a511c4c6d7bd397d = (0, $dEr3t.createAsyncThunk)("customer/customerCreateCustomerPaymentMethod", async (inp, { dispatch: dispatch })=>{
    // if stripe is not loaded
    if (!inp.stripe || !inp.elements) // return error message in payload
    return {
        error: "Stripe is failed to load"
    };
    // define redirect url
    const redirectUrl = "staging" === (0, $9VYkD.Environment).Production ? (0, $8kVRe.Platform).ProductionURL : (0, $8kVRe.Platform).StagingURL;
    try {
        // confirm stripe setup
        const { error: error } = await inp.stripe.confirmSetup({
            elements: inp.elements,
            redirect: "if_required",
            confirmParams: {
                return_url: redirectUrl
            }
        });
        // if error returned
        if (error) {
            // launch error alert
            dispatch((0, $joOpk.alertAddMessage)({
                message: {
                    id: (0, $ij1oT.uuid)(),
                    type: (0, $ic5m0.AlertMessageType).Error,
                    message: `Payment method creation failed: ${error.message}`
                }
            }));
            // return error message in payload
            return {
                error: error.message || ""
            };
        }
        // launch success alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: `Payment method creation succeeded!`
            }
        }));
        // close customer payment method create modal
        dispatch((0, $7YE0x.customerCloseCustomerPaymentMethodCreateModal)());
        const resetAfterMs = 3000;
        setTimeout(()=>{
            // reset customer state
            dispatch((0, $7YE0x.customerResetState)());
        }, resetAfterMs);
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Payment method creation failed: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $f24cfb7a84de9d69$export$8e61ca7747be6855 = (0, $dEr3t.createAsyncThunk)("customer/customerDeleteCustomerPaymentMethod", async ({ customerPaymentMethod: customerPaymentMethod }, { dispatch: dispatch })=>{
    const { id: customerPaymentMethodId } = customerPaymentMethod;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete payment method
        await api.customerApi.deleteCustomerPaymentMethod(customerPaymentMethodId || "");
        // reset customer state
        dispatch((0, $7YE0x.customerResetState)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: `Successfully deleted payment method!`
            }
        }));
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to delete payment method: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $f24cfb7a84de9d69$export$61f68d108929c87 = (0, $dEr3t.createAsyncThunk)("customer/customerSetCustomerPaymentMethodDefault", async ({ customerPaymentMethod: customerPaymentMethod }, { dispatch: dispatch })=>{
    const { id: customerPaymentMethodId } = customerPaymentMethod;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // set payment method as default
        await api.customerApi.setCustomerPaymentMethodDefault({
            customerPaymentMethodId: customerPaymentMethodId || ""
        });
        // reset customer state
        dispatch((0, $7YE0x.customerResetState)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: `Successfully updated default payment method!`
            }
        }));
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to update default payment method: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("kBQdL", function(module, exports) {
// export {} from './components'

var $5Dw49 = parcelRequire("5Dw49");

var $9ybfS = parcelRequire("9ybfS");
$parcel$exportWildcard(module.exports, $5Dw49);
$parcel$exportWildcard(module.exports, $9ybfS);

});
parcelRegister("5Dw49", function(module, exports) {

$parcel$export(module.exports, "likeSlice", function () { return $b7403d17afb89743$export$13fa8af9cb8f6311; });
$parcel$export(module.exports, "likeResetState", function () { return $b7403d17afb89743$export$6271733e0f9f33c5; });
$parcel$export(module.exports, "likeSetUserFollows", function () { return $b7403d17afb89743$export$877182111b837392; });
$parcel$export(module.exports, "likeAddUserFollow", function () { return $b7403d17afb89743$export$424f7d1030c3fdbe; });
$parcel$export(module.exports, "likeRemoveUserFollow", function () { return $b7403d17afb89743$export$a87fb37e450feb31; });
$parcel$export(module.exports, "likeSetPostLikes", function () { return $b7403d17afb89743$export$5fa4205fa6c9ecea; });
$parcel$export(module.exports, "likeAddPostLike", function () { return $b7403d17afb89743$export$a09892d23cff9d4e; });
$parcel$export(module.exports, "likeRemovePostLike", function () { return $b7403d17afb89743$export$493af460e6693ad8; });
$parcel$export(module.exports, "likeSetTrackLikes", function () { return $b7403d17afb89743$export$38c392102127a134; });
$parcel$export(module.exports, "likeAddTrackLike", function () { return $b7403d17afb89743$export$32742a415871bb6f; });
$parcel$export(module.exports, "likeRemoveTrackLike", function () { return $b7403d17afb89743$export$5704115526859999; });
$parcel$export(module.exports, "likeSetCommentLikes", function () { return $b7403d17afb89743$export$a91b348ca84c5784; });
$parcel$export(module.exports, "likeAddCommentLike", function () { return $b7403d17afb89743$export$5ae5e0cbc7535348; });
$parcel$export(module.exports, "likeRemoveCommentLike", function () { return $b7403d17afb89743$export$ecf26279cd48d6c9; });
$parcel$export(module.exports, "likeSelectUserFollows", function () { return $b7403d17afb89743$export$547fac48fda98a21; });
$parcel$export(module.exports, "likeSelectPostLikes", function () { return $b7403d17afb89743$export$3c54bf73a85e6628; });
$parcel$export(module.exports, "likeSelectTrackLikes", function () { return $b7403d17afb89743$export$ac21df2c015e092e; });
$parcel$export(module.exports, "likeSelectCommentLikes", function () { return $b7403d17afb89743$export$d447f3e45611dbfc; });
$parcel$export(module.exports, "likeSelectLikeGetFollowedUserIdsLoading", function () { return $b7403d17afb89743$export$2eee4f66368f7600; });
$parcel$export(module.exports, "likeSelectLikeGetLikedPostIdsLoading", function () { return $b7403d17afb89743$export$e81e1f6ecbfcd908; });
$parcel$export(module.exports, "likeSelectLikeGetLikedTrackIdsLoading", function () { return $b7403d17afb89743$export$f79bd85604abc97a; });
$parcel$export(module.exports, "likeSelectLikeGetLikedCommentIdsLoading", function () { return $b7403d17afb89743$export$42a0f2775253af0c; });
$parcel$export(module.exports, "likeReducer", function () { return $b7403d17afb89743$export$fe1f313dc70c6a75; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $9ybfS = parcelRequire("9ybfS");
const $b7403d17afb89743$var$initialState = {
    userFollows: {},
    trackLikes: {},
    postLikes: {},
    commentLikes: {},
    likeGetFollowedUserIdsLoading: false,
    likeGetLikedPostIdsLoading: false,
    likeGetLikedTrackIdsLoading: false,
    likeGetLikedCommentIdsLoading: false
};
const $b7403d17afb89743$export$13fa8af9cb8f6311 = (0, $dEr3t.createSlice)({
    name: "like",
    initialState: $b7403d17afb89743$var$initialState,
    reducers: {
        // reset state
        likeResetState: ()=>({
                userFollows: {},
                trackLikes: {},
                postLikes: {},
                commentLikes: {},
                likeGetFollowedUserIdsLoading: false,
                likeGetLikedPostIdsLoading: false,
                likeGetLikedTrackIdsLoading: false,
                likeGetLikedCommentIdsLoading: false
            }),
        // set user follows
        likeSetUserFollows: (state, action)=>{
            const { followedUserIds: followedUserIds } = action.payload;
            // define user follows map
            const userFollows = {};
            // iterate over each followed user id
            followedUserIds.forEach((id)=>{
                // add id to the map
                userFollows[id] = true;
            });
            // update state
            state.userFollows = userFollows;
        },
        // add user follow
        likeAddUserFollow: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userFollows[userId] = true;
        },
        // remove user follow
        likeRemoveUserFollow: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userFollows[userId] = false;
        },
        // set post likes
        likeSetPostLikes: (state, action)=>{
            const { likedPostIds: likedPostIds } = action.payload;
            // define post likes map
            const postLikes = {};
            // iterate over each liked post id
            likedPostIds.forEach((id)=>{
                // add id to the map
                postLikes[id] = true;
            });
            // update state
            state.postLikes = postLikes;
        },
        // add post like
        likeAddPostLike: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postLikes[postId] = true;
        },
        // remove post like
        likeRemovePostLike: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postLikes[postId] = false;
        },
        // set track likes
        likeSetTrackLikes: (state, action)=>{
            const { likedTrackIds: likedTrackIds } = action.payload;
            // define track likes map
            const trackLikes = {};
            // iterate over each liked track id
            likedTrackIds.forEach((id)=>{
                // add id to the map
                trackLikes[id] = true;
            });
            // update state
            state.trackLikes = trackLikes;
        },
        // add track like
        likeAddTrackLike: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackLikes[trackId] = true;
        },
        // remove track like
        likeRemoveTrackLike: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackLikes[trackId] = false;
        },
        // set comment likes
        likeSetCommentLikes: (state, action)=>{
            const { likedCommentIds: likedCommentIds } = action.payload;
            // define comment likes map
            const commentLikes = {};
            // iterate over each liked comment id
            likedCommentIds.forEach((id)=>{
                // add id to the map
                commentLikes[id] = true;
            });
            // update state
            state.commentLikes = commentLikes;
        },
        // add comment like
        likeAddCommentLike: (state, action)=>{
            const { commentId: commentId } = action.payload;
            // update state
            state.commentLikes[commentId] = true;
        },
        // remove liked comment
        likeRemoveCommentLike: (state, action)=>{
            const { commentId: commentId } = action.payload;
            // update state
            state.commentLikes[commentId] = false;
        }
    },
    extraReducers: (builder)=>{
        // get followed user ids
        builder.addCase((0, $9ybfS.likeGetFollowedUserIds).pending, (state)=>({
                ...state,
                likeGetFollowedUserIdsLoading: true
            })).addCase((0, $9ybfS.likeGetFollowedUserIds).fulfilled, (state)=>({
                ...state,
                likeGetFollowedUserIdsLoading: false
            }));
        // get liked post ids
        builder.addCase((0, $9ybfS.likeGetLikedPostIds).pending, (state)=>({
                ...state,
                likeGetLikedPostIdsLoading: true
            })).addCase((0, $9ybfS.likeGetLikedPostIds).fulfilled, (state)=>({
                ...state,
                likeGetLikedPostIdsLoading: false
            }));
        // get liked track ids
        builder.addCase((0, $9ybfS.likeGetLikedTrackIds).pending, (state)=>({
                ...state,
                likeGetLikedTrackIdsLoading: true
            })).addCase((0, $9ybfS.likeGetLikedTrackIds).fulfilled, (state)=>({
                ...state,
                likeGetLikedTrackIdsLoading: false
            }));
        // get liked comment ids
        builder.addCase((0, $9ybfS.likeGetLikedCommentIds).pending, (state)=>({
                ...state,
                likeGetLikedCommentIdsLoading: true
            })).addCase((0, $9ybfS.likeGetLikedCommentIds).fulfilled, (state)=>({
                ...state,
                likeGetLikedCommentIdsLoading: false
            }));
    }
});
const { likeResetState: $b7403d17afb89743$export$6271733e0f9f33c5, likeSetUserFollows: $b7403d17afb89743$export$877182111b837392, likeAddUserFollow: $b7403d17afb89743$export$424f7d1030c3fdbe, likeRemoveUserFollow: $b7403d17afb89743$export$a87fb37e450feb31, likeSetPostLikes: $b7403d17afb89743$export$5fa4205fa6c9ecea, likeAddPostLike: $b7403d17afb89743$export$a09892d23cff9d4e, likeRemovePostLike: $b7403d17afb89743$export$493af460e6693ad8, likeSetTrackLikes: $b7403d17afb89743$export$38c392102127a134, likeAddTrackLike: $b7403d17afb89743$export$32742a415871bb6f, likeRemoveTrackLike: $b7403d17afb89743$export$5704115526859999, likeSetCommentLikes: $b7403d17afb89743$export$a91b348ca84c5784, likeAddCommentLike: $b7403d17afb89743$export$5ae5e0cbc7535348, likeRemoveCommentLike: $b7403d17afb89743$export$ecf26279cd48d6c9 } = $b7403d17afb89743$export$13fa8af9cb8f6311.actions;
const $b7403d17afb89743$export$547fac48fda98a21 = (state)=>state.like.userFollows;
const $b7403d17afb89743$export$3c54bf73a85e6628 = (state)=>state.like.postLikes;
const $b7403d17afb89743$export$ac21df2c015e092e = (state)=>state.like.trackLikes;
const $b7403d17afb89743$export$d447f3e45611dbfc = (state)=>state.like.commentLikes;
const $b7403d17afb89743$export$2eee4f66368f7600 = (state)=>state.like.likeGetFollowedUserIdsLoading;
const $b7403d17afb89743$export$e81e1f6ecbfcd908 = (state)=>state.like.likeGetLikedPostIdsLoading;
const $b7403d17afb89743$export$f79bd85604abc97a = (state)=>state.like.likeGetLikedTrackIdsLoading;
const $b7403d17afb89743$export$42a0f2775253af0c = (state)=>state.like.likeGetLikedCommentIdsLoading;
const $b7403d17afb89743$export$fe1f313dc70c6a75 = $b7403d17afb89743$export$13fa8af9cb8f6311.reducer; // export default likeSlice.reducer

});

parcelRegister("9ybfS", function(module, exports) {

$parcel$export(module.exports, "likeGetFollowedUserIds", function () { return $ecd35e448292d73b$export$289794adea63932b; });
$parcel$export(module.exports, "likeCreateUserFollow", function () { return $ecd35e448292d73b$export$199321f08b9f1617; });
$parcel$export(module.exports, "likeDeleteUserFollow", function () { return $ecd35e448292d73b$export$6ca782b6e3563c9e; });
$parcel$export(module.exports, "likeGetLikedPostIds", function () { return $ecd35e448292d73b$export$c30c4c16f8f42888; });
$parcel$export(module.exports, "likeCreatePostLike", function () { return $ecd35e448292d73b$export$65ab8fbbffe02866; });
$parcel$export(module.exports, "likeDeletePostLike", function () { return $ecd35e448292d73b$export$d5e7d1f5ec64e1a8; });
$parcel$export(module.exports, "likeGetLikedTrackIds", function () { return $ecd35e448292d73b$export$bc2a263fe8589666; });
$parcel$export(module.exports, "likeCreateTrackLike", function () { return $ecd35e448292d73b$export$c6d6a0e482d9499f; });
$parcel$export(module.exports, "likeDeleteTrackLike", function () { return $ecd35e448292d73b$export$9f5046deb7b0a112; });
$parcel$export(module.exports, "likeGetLikedCommentIds", function () { return $ecd35e448292d73b$export$89f3d6e510de3e93; });
$parcel$export(module.exports, "likeCreateCommentLike", function () { return $ecd35e448292d73b$export$f9856df8a32b83e4; });
$parcel$export(module.exports, "likeDeleteCommentLike", function () { return $ecd35e448292d73b$export$1ccf5b66fb2f62cd; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("dmGpj");
var $5Dw49 = parcelRequire("5Dw49");
var $l1Cdj = parcelRequire("l1Cdj");
var $1bnO9 = parcelRequire("1bnO9");
var $kkIKc = parcelRequire("kkIKc");
const $ecd35e448292d73b$export$289794adea63932b = (0, $dEr3t.createAsyncThunk)("like/likeGetFollowedUserIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve followed user ids
        const { followedUserIds: followedUserIds } = await api.likeApi.getFollowedUserIds();
        // set user follows
        dispatch((0, $5Dw49.likeSetUserFollows)({
            followedUserIds: followedUserIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$199321f08b9f1617 = (0, $dEr3t.createAsyncThunk)("like/likeCreateUserFollow", async ({ user: user }, { dispatch: dispatch })=>{
    const { id: userId } = user;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create user follow
        await api.likeApi.createUserFollow({
            userId: userId || ""
        });
        // add user follow
        dispatch((0, $5Dw49.likeAddUserFollow)({
            userId: userId || ""
        }));
        // append user to followed artists
        dispatch((0, $kkIKc.userAppendFollowedArtist)({
            artist: user
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$6ca782b6e3563c9e = (0, $dEr3t.createAsyncThunk)("like/likeDeleteUserFollow", async ({ user: user }, { dispatch: dispatch })=>{
    const { id: userId } = user;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete user follow
        await api.likeApi.deleteUserFollow(userId || "");
        // remove user follow
        dispatch((0, $5Dw49.likeRemoveUserFollow)({
            userId: userId || ""
        }));
        // filter user from followed artists
        dispatch((0, $kkIKc.userFilterFollowedArtist)({
            artist: user
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$c30c4c16f8f42888 = (0, $dEr3t.createAsyncThunk)("like/likeGetLikedPostIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve liked post ids
        const { likedPostIds: likedPostIds } = await api.likeApi.getLikedPostIds();
        // set post likes
        dispatch((0, $5Dw49.likeSetPostLikes)({
            likedPostIds: likedPostIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$65ab8fbbffe02866 = (0, $dEr3t.createAsyncThunk)("like/likeCreatePostLike", async ({ post: post }, { dispatch: dispatch })=>{
    const { id: postId } = post;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create post like
        await api.likeApi.createPostLike({
            postId: postId || ""
        });
        // add post like
        dispatch((0, $5Dw49.likeAddPostLike)({
            postId: postId || ""
        }));
        // append post to liked posts
        dispatch((0, $l1Cdj.postAppendLikedPost)({
            post: post
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$d5e7d1f5ec64e1a8 = (0, $dEr3t.createAsyncThunk)("like/likeDeletePostLike", async ({ post: post }, { dispatch: dispatch })=>{
    const { id: postId } = post;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete post like
        await api.likeApi.deletePostLike(postId || "");
        // remove post like
        dispatch((0, $5Dw49.likeRemovePostLike)({
            postId: postId || ""
        }));
        // filter post from liked posts
        dispatch((0, $l1Cdj.postFilterLikedPost)({
            post: post
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$bc2a263fe8589666 = (0, $dEr3t.createAsyncThunk)("like/likeGetLikedTrackIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve liked track ids
        const { likedTrackIds: likedTrackIds } = await api.likeApi.getLikedTrackIds();
        // set track likes
        dispatch((0, $5Dw49.likeSetTrackLikes)({
            likedTrackIds: likedTrackIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$c6d6a0e482d9499f = (0, $dEr3t.createAsyncThunk)("like/likeCreateTrackLike", async ({ track: track }, { dispatch: dispatch })=>{
    const { id: trackId } = track;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create track like
        await api.likeApi.createTrackLike({
            trackId: trackId || ""
        });
        // add track like
        dispatch((0, $5Dw49.likeAddTrackLike)({
            trackId: trackId || ""
        }));
        // append track to liked tracks
        dispatch((0, $1bnO9.trackAppendLikedTrack)({
            track: track
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$9f5046deb7b0a112 = (0, $dEr3t.createAsyncThunk)("like/likeDeleteTrackLike", async ({ track: track }, { dispatch: dispatch })=>{
    const { id: trackId } = track;
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete track like
        await api.likeApi.deleteTrackLike(trackId || "");
        // remove track like
        dispatch((0, $5Dw49.likeRemoveTrackLike)({
            trackId: trackId || ""
        }));
        // filter track from liked tracks
        dispatch((0, $1bnO9.trackFilterLikedTrack)({
            track: track
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$89f3d6e510de3e93 = (0, $dEr3t.createAsyncThunk)("like/likeGetLikedCommentIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve liked comment ids
        const { likedCommentIds: likedCommentIds } = await api.likeApi.getLikedCommentIds();
        // set comment likes
        dispatch((0, $5Dw49.likeSetCommentLikes)({
            likedCommentIds: likedCommentIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$f9856df8a32b83e4 = (0, $dEr3t.createAsyncThunk)("like/likeCreateCommentLike", async ({ comment: comment }, { dispatch: dispatch })=>{
    const { id: commentId, postId: postId } = comment;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create comment like
        await api.likeApi.createCommentLike({
            commentId: commentId || "",
            postId: postId || ""
        });
        // add comment like
        dispatch((0, $5Dw49.likeAddCommentLike)({
            commentId: commentId || ""
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $ecd35e448292d73b$export$1ccf5b66fb2f62cd = (0, $dEr3t.createAsyncThunk)("like/likeDeleteCommentLike", async ({ comment: comment }, { dispatch: dispatch })=>{
    const { id: commentId } = comment;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete comment like
        await api.likeApi.deleteCommentLike(commentId || "");
        // remove comment like
        dispatch((0, $5Dw49.likeRemoveCommentLike)({
            commentId: commentId || ""
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("3vEK1", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return (parcelRequire("737dB")).NavigationApp; });
$parcel$export(module.exports, "NavigationAppMobile", function () { return (parcelRequire("8Jr1i")).NavigationAppMobile; });
$parcel$export(module.exports, "NavigationLibrary", function () { return (parcelRequire("gMvxt")).NavigationLibrary; });
parcelRequire("hYQ4Z");
var $737dB = parcelRequire("737dB");
var $8Jr1i = parcelRequire("8Jr1i");
var $gMvxt = parcelRequire("gMvxt");

var $11Nfd = parcelRequire("11Nfd");
$parcel$exportWildcard(module.exports, $11Nfd);

});
parcelRegister("hYQ4Z", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return (parcelRequire("737dB")).NavigationApp; });
$parcel$export(module.exports, "NavigationAppMobile", function () { return (parcelRequire("8Jr1i")).NavigationAppMobile; });
$parcel$export(module.exports, "NavigationLibrary", function () { return (parcelRequire("gMvxt")).NavigationLibrary; });
parcelRequire("vw3Oh");
var $737dB = parcelRequire("737dB");
var $8Jr1i = parcelRequire("8Jr1i");

var $gMvxt = parcelRequire("gMvxt");

});
parcelRegister("vw3Oh", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return (parcelRequire("737dB")).NavigationApp; });
$parcel$export(module.exports, "NavigationAppMobile", function () { return (parcelRequire("8Jr1i")).NavigationAppMobile; });

var $737dB = parcelRequire("737dB");

var $8Jr1i = parcelRequire("8Jr1i");

});
parcelRegister("737dB", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return $abbc07cb2e01396e$export$42d4318a67277c83; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
parcelRequire("4is25");
var $gLoh3 = parcelRequire("gLoh3");
parcelRequire("bJOXx");
var $5uMiO = parcelRequire("5uMiO");
parcelRequire("ISX69");
var $inVJ0 = parcelRequire("inVJ0");
var $5R06k = parcelRequire("5R06k");

var $aAeuw = parcelRequire("aAeuw");
const $abbc07cb2e01396e$export$42d4318a67277c83 = ()=>{
    const theme = (0, $hXJcm.u)();
    const { pathname: pathname } = (0, $fbE6a.useLocation)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const navLinks = (0, $5uMiO.getNavLinks)(profile);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $aAeuw.styles)(theme).navigation.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $aAeuw.styles)(theme).navigation.logo,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gLoh3.logos).RyddmLogo, {})
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("nav", {
                css: (0, $aAeuw.styles)(theme).navigation.links,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("ul", {
                    children: navLinks.map(({ name: name, path: path, icon: icon })=>/*#__PURE__*/ (0, $5o6z6.jsx)("li", {
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5R06k.NavLink), {
                                to: path,
                                name: name,
                                icon: icon,
                                onClick: ()=>dispatch((0, $jhoVP.playerAudioSetClosed)()),
                                active: pathname === path
                            })
                        }, `${name}-${path}`))
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $aAeuw.styles)(theme).navigation.footer,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $inVJ0.NavFooter), {})
            })
        ]
    });
};
$abbc07cb2e01396e$export$42d4318a67277c83.propTypes = {};

});
parcelRegister("bJOXx", function(module, exports) {

$parcel$export(module.exports, "getNavLinks", function () { return (parcelRequire("5uMiO")).getNavLinks; });

var $5uMiO = parcelRequire("5uMiO");

});
parcelRegister("5uMiO", function(module, exports) {

$parcel$export(module.exports, "getNavLinks", function () { return $ab5c25833419ad3e$export$f9d18ce6e26966fa; });
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");

var $4RU09 = parcelRequire("4RU09");
const $ab5c25833419ad3e$var$publicNavLinks = [
    {
        name: "Home",
        path: (0, $9YTSb.Path).Home,
        icon: (0, $4RU09.icons).HomeIcon
    }
];
const $ab5c25833419ad3e$var$fanNavLinks = [
    {
        name: "Home",
        path: (0, $9YTSb.Path).Feed,
        icon: (0, $4RU09.icons).HomeIcon
    },
    {
        name: "Library",
        path: (0, $9YTSb.Path).Library,
        icon: (0, $4RU09.icons).LibraryIcon
    },
    {
        name: "Charts",
        path: (0, $9YTSb.Path).Charts,
        icon: (0, $4RU09.icons).ChartsIcon
    },
    {
        name: "Profile",
        path: (0, $9YTSb.Path).Profile,
        icon: (0, $4RU09.icons).ProfileIcon
    }
];
const $ab5c25833419ad3e$var$artistNavLinks = [
    {
        name: "Home",
        path: (0, $9YTSb.Path).Feed,
        icon: (0, $4RU09.icons).HomeIcon
    },
    {
        name: "Library",
        path: (0, $9YTSb.Path).Library,
        icon: (0, $4RU09.icons).LibraryIcon
    },
    {
        name: "Charts",
        path: (0, $9YTSb.Path).Charts,
        icon: (0, $4RU09.icons).ChartsIcon
    },
    {
        name: "Studio",
        path: (0, $9YTSb.Path).Studio,
        icon: (0, $4RU09.icons).StudioIcon
    },
    {
        name: "Profile",
        path: (0, $9YTSb.Path).Profile,
        icon: (0, $4RU09.icons).ProfileIcon
    }
];
const $ab5c25833419ad3e$var$adminNavLinks = [
    {
        name: "Home",
        path: (0, $9YTSb.Path).Feed,
        icon: (0, $4RU09.icons).HomeIcon
    },
    {
        name: "Library",
        path: (0, $9YTSb.Path).Library,
        icon: (0, $4RU09.icons).LibraryIcon
    },
    {
        name: "Charts",
        path: (0, $9YTSb.Path).Charts,
        icon: (0, $4RU09.icons).ChartsIcon
    },
    {
        name: "Reports",
        path: (0, $9YTSb.Path).Reports,
        icon: (0, $4RU09.icons).ReportsIcon
    },
    {
        name: "Profile",
        path: (0, $9YTSb.Path).Profile,
        icon: (0, $4RU09.icons).ProfileIcon
    }
];
const $ab5c25833419ad3e$export$f9d18ce6e26966fa = (user)=>{
    // if fan
    if (user && user.role === (0, $aeAwZ.EntityUserRole).Fan && user.onboardingStage === (0, $aeAwZ.EntityOnboardingStage).Finished) return $ab5c25833419ad3e$var$fanNavLinks;
    // if artist
    if (user && user.role === (0, $aeAwZ.EntityUserRole).Artist && user.onboardingStage === (0, $aeAwZ.EntityOnboardingStage).Finished) return $ab5c25833419ad3e$var$artistNavLinks;
    // if admin
    if (user && user.role === (0, $aeAwZ.EntityUserRole).Admin && user.onboardingStage === (0, $aeAwZ.EntityOnboardingStage).Finished) return $ab5c25833419ad3e$var$adminNavLinks;
    return $ab5c25833419ad3e$var$publicNavLinks;
};

});
parcelRegister("4RU09", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $c8e5c2d8d43d8481$export$df03f54e09e486fa; });

var $lUnB8 = parcelRequire("lUnB8");

var $86KZ7 = parcelRequire("86KZ7");

var $lBa5W = parcelRequire("lBa5W");

var $3xX3X = parcelRequire("3xX3X");

var $82qqk = parcelRequire("82qqk");

var $5ykUf = parcelRequire("5ykUf");
const $c8e5c2d8d43d8481$export$df03f54e09e486fa = {
    HomeIcon: $lUnB8.default,
    LibraryIcon: $86KZ7.default,
    ChartsIcon: $lBa5W.default,
    ProfileIcon: $3xX3X.default,
    StudioIcon: $82qqk.default,
    ReportsIcon: $5ykUf.default
};

});
parcelRegister("lUnB8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0c5f1fbef15b08$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $cb0c5f1fbef15b08$var$SvgHome = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M8 16.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H8Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 .25c-.708 0-1.351.203-2.05.542-.674.328-1.454.812-2.427 1.416L4.456 3.491c-.92.572-1.659 1.03-2.227 1.465-.589.45-1.041.91-1.368 1.507C.535 7.058.39 7.692.318 8.44.25 9.167.25 10.054.25 11.167v1.613c0 1.904 0 3.407.153 4.582.156 1.205.486 2.178 1.23 2.947.747.773 1.697 1.119 2.875 1.282 1.14.159 2.598.159 4.434.159h4.116c1.836 0 3.294 0 4.434-.159 1.177-.163 2.128-.509 2.876-1.282.743-.769 1.073-1.742 1.23-2.947.152-1.175.152-2.678.152-4.582v-1.613c0-1.113 0-2-.068-2.726-.07-.75-.217-1.383-.543-1.978-.327-.597-.78-1.056-1.368-1.507-.568-.436-1.306-.893-2.227-1.465l-2.067-1.283c-.973-.604-1.753-1.088-2.428-1.416C12.352.452 11.71.25 11 .25ZM7.28 3.504c1.015-.63 1.73-1.072 2.327-1.363.581-.283.993-.391 1.393-.391s.812.108 1.393.391c.598.29 1.312.733 2.327 1.363l2 1.241c.961.597 1.636 1.016 2.14 1.402.489.375.77.684.963 1.036.193.353.306.766.365 1.398.061.648.062 1.465.062 2.623v1.521c0 1.97-.002 3.376-.14 4.443-.136 1.048-.393 1.656-.82 2.099-.425.439-1.003.7-2.004.839-1.026.142-2.379.144-4.286.144H9c-1.908 0-3.26-.002-4.286-.144-1.001-.14-1.579-.4-2.003-.84-.428-.442-.685-1.05-.82-2.098-.14-1.067-.141-2.472-.141-4.443v-1.521c0-1.158 0-1.975.062-2.623.059-.632.172-1.045.365-1.398.193-.352.474-.661.964-1.036.503-.386 1.178-.805 2.139-1.402l2-1.24Z",
                fill: "#FFF"
            })
        ]
    });
var $cb0c5f1fbef15b08$export$2e2bcd8739ae039 = $cb0c5f1fbef15b08$var$SvgHome;

});

parcelRegister("86KZ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cdb4f0750fb5100$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $7cdb4f0750fb5100$var$SvgLibrary = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.611.584a2.75 2.75 0 0 1 3.139 2.722v1.377a3.75 3.75 0 0 1 2 3.317v10A3.75 3.75 0 0 1 14 21.75H4A3.75 3.75 0 0 1 .25 18V3.929c0-.906.666-1.675 1.564-1.803L12.61.584ZM1.75 5.75V18A2.25 2.25 0 0 0 4 20.25h10A2.25 2.25 0 0 0 16.25 18V8A2.25 2.25 0 0 0 14 5.75H1.75Zm.321-1.5H14.25v-.944a1.25 1.25 0 0 0-1.427-1.237L2.026 3.61a.321.321 0 0 0 .045.639ZM4.25 11a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
            fill: "#FFF"
        })
    });
var $7cdb4f0750fb5100$export$2e2bcd8739ae039 = $7cdb4f0750fb5100$var$SvgLibrary;

});

parcelRegister("lBa5W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eea54126ea6b942a$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $eea54126ea6b942a$var$SvgCharts = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M10.25 1A.75.75 0 0 1 11 .25C16.937.25 21.75 5.063 21.75 11S16.937 21.75 11 21.75.25 16.937.25 11a10.72 10.72 0 0 1 3.225-7.677.75.75 0 1 1 1.05 1.071A9.22 9.22 0 0 0 1.75 11 9.25 9.25 0 1 0 11 1.75a.75.75 0 0 1-.75-.75Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M10.25 4a.75.75 0 0 1 .75-.75A7.75 7.75 0 1 1 3.25 11a.75.75 0 0 1 1.5 0A6.25 6.25 0 1 0 11 4.75a.75.75 0 0 1-.75-.75Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M11 6.25a.75.75 0 0 0 0 1.5 3.25 3.25 0 0 1 0 6.5.75.75 0 0 0 0 1.5 4.75 4.75 0 1 0 0-9.5Z",
                fill: "#FFF"
            })
        ]
    });
var $eea54126ea6b942a$export$2e2bcd8739ae039 = $eea54126ea6b942a$var$SvgCharts;

});

parcelRegister("3xX3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5c366e1c9c2c532$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $c5c366e1c9c2c532$var$SvgProfile = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 .25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM5.75 5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM9 11.25c-2.314 0-4.445.526-6.025 1.414C1.42 13.54.25 14.866.25 16.5v.102c-.001 1.162-.003 2.62 1.276 3.662.63.512 1.51.877 2.7 1.117 1.193.242 2.748.369 4.774.369s3.58-.127 4.774-.369c1.19-.24 2.07-.605 2.7-1.117 1.279-1.042 1.277-2.5 1.276-3.662V16.5c0-1.634-1.17-2.96-2.726-3.836-1.579-.888-3.71-1.414-6.024-1.414ZM1.75 16.5c0-.851.621-1.775 1.96-2.528 1.317-.74 3.185-1.222 5.29-1.222s3.973.482 5.289 1.222c1.34.753 1.96 1.677 1.96 2.528 0 1.308-.04 2.044-.723 2.6-.37.302-.99.597-2.05.811-1.057.214-2.502.339-4.476.339-1.974 0-3.42-.125-4.476-.339-1.06-.214-1.68-.509-2.05-.81-.684-.557-.724-1.293-.724-2.601Z",
            fill: "#FFF"
        })
    });
var $c5c366e1c9c2c532$export$2e2bcd8739ae039 = $c5c366e1c9c2c532$var$SvgProfile;

});

parcelRegister("82qqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af2dca93006d20cd$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $af2dca93006d20cd$var$SvgStudio = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.943.25h.114c2.309 0 4.118 0 5.53.19 1.444.194 2.584.6 3.479 1.494.895.895 1.3 2.035 1.494 3.48.19 1.411.19 3.22.19 5.529v.114c0 2.309 0 4.118-.19 5.53-.194 1.444-.6 2.584-1.494 3.479-.895.895-2.035 1.3-3.48 1.494-1.411.19-3.22.19-5.529.19h-.114c-2.309 0-4.118 0-5.53-.19-1.444-.194-2.584-.6-3.479-1.494-.895-.895-1.3-2.035-1.494-3.48-.19-1.411-.19-3.22-.19-5.529v-.114c0-2.309 0-4.118.19-5.53.194-1.444.6-2.584 1.494-3.479C2.83 1.04 3.97.634 5.414.44 6.825.25 8.634.25 10.943.25Zm-5.33 1.676c-1.278.172-2.049.5-2.618 1.069-.57.57-.897 1.34-1.069 2.619-.174 1.3-.176 3.008-.176 5.386s.002 4.086.176 5.386c.172 1.279.5 2.05 1.069 2.62.57.569 1.34.896 2.619 1.068 1.3.174 3.008.176 5.386.176s4.086-.002 5.386-.176c1.279-.172 2.05-.5 2.62-1.069.569-.57.896-1.34 1.068-2.619.174-1.3.176-3.008.176-5.386s-.002-4.086-.176-5.386c-.172-1.279-.5-2.05-1.069-2.62-.57-.569-1.34-.896-2.619-1.068-1.3-.174-3.008-.176-5.386-.176s-4.086.002-5.386.176ZM11 5.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Zm-5 2a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 6 7.25Zm10 1a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Z",
            fill: "#FFF"
        })
    });
var $af2dca93006d20cd$export$2e2bcd8739ae039 = $af2dca93006d20cd$var$SvgStudio;

});

parcelRegister("5ykUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de60139fd5dc154d$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $de60139fd5dc154d$var$SvgReports = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        viewBox: "0 0 511.999 463.377",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M289.639 9.137c12.411 7.25 23.763 18.883 33.037 34.913l.97 1.813 1.118 1.941 174.174 302.48c33.712 56.407-1.203 113.774-66.174 112.973v.12H73.485c-.895 0-1.78-.04-2.657-.112-59.104-.799-86.277-54.995-61.909-106.852.842-1.805 1.816-3.475 2.816-5.201L189.482 43.959l-.053-.032c9.22-15.786 20.717-27.457 33.411-34.805C243.788-3 268.711-3.086 289.639 9.137zM255.7 339.203c13.04 0 23.612 10.571 23.612 23.612 0 13.041-10.572 23.613-23.612 23.613-13.041 0-23.613-10.572-23.613-23.613s10.572-23.612 23.613-23.612zm17.639-35.379c-.794 19.906-34.506 19.931-35.278-.006-3.41-34.108-12.129-111.541-11.853-143.591.284-9.874 8.469-15.724 18.939-17.955 3.231-.686 6.781-1.024 10.357-1.019 3.595.008 7.153.362 10.387 1.051 10.818 2.303 19.309 8.392 19.309 18.446l-.043 1.005-11.818 142.069zM37.596 369.821 216.864 59.942c21.738-37.211 56.225-38.289 78.376 0l176.298 306.166c17.177 28.285 10.04 66.236-38.774 65.488H73.485c-33.017.756-52.841-25.695-35.889-61.775z",
            fill: "#FFF"
        })
    });
var $de60139fd5dc154d$export$2e2bcd8739ae039 = $de60139fd5dc154d$var$SvgReports;

});




parcelRegister("ISX69", function(module, exports) {

$parcel$export(module.exports, "NavFooter", function () { return (parcelRequire("inVJ0")).NavFooter; });
$parcel$export(module.exports, "NavLink", function () { return (parcelRequire("5R06k")).NavLink; });

var $inVJ0 = parcelRequire("inVJ0");

var $5R06k = parcelRequire("5R06k");

});
parcelRegister("inVJ0", function(module, exports) {

$parcel$export(module.exports, "NavFooter", function () { return $e7265cf91530f53a$export$43e7f44f055ed22f; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $8YIJn = parcelRequire("8YIJn");
parcelRequire("8uCbu");
var $awM7v = parcelRequire("awM7v");

var $2Uj8f = parcelRequire("2Uj8f");
const $e7265cf91530f53a$export$43e7f44f055ed22f = ()=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("footer", {
        css: (0, $2Uj8f.styles)(theme).footer.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $2Uj8f.styles)(theme).footer.terms,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $awM7v.Link), {
                        name: "Terms of use",
                        href: (0, $8YIJn.ExternalLinks).TermsOfUse
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $2Uj8f.styles)(theme).footer.divider,
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $awM7v.Link), {
                        name: "Privacy Policy",
                        href: (0, $8YIJn.ExternalLinks).PrivacyPolicy
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $2Uj8f.styles)(theme).footer.contacts,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $awM7v.Link), {
                        name: "FAQs",
                        href: (0, $8YIJn.ExternalLinks).FAQ
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $2Uj8f.styles)(theme).footer.divider,
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $awM7v.Link), {
                        name: "Support",
                        href: (0, $8YIJn.ExternalLinks).Support
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $2Uj8f.styles)(theme).footer.divider,
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $awM7v.Link), {
                        name: "Contact us",
                        href: (0, $8YIJn.ExternalLinks).Contacts
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $2Uj8f.styles)(theme).footer.copyright,
                children: [
                    "\xa9 2021-",
                    new Date().getFullYear(),
                    " Ryddm Inc. All Rights Reserved"
                ]
            })
        ]
    });
};
$e7265cf91530f53a$export$43e7f44f055ed22f.propTypes = {};

});
parcelRegister("8uCbu", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return (parcelRequire("awM7v")).Link; });

var $awM7v = parcelRequire("awM7v");

});
parcelRegister("awM7v", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $36e6928781aa8f54$export$a6c7ac8248d6e38a; });

var $5o6z6 = parcelRequire("5o6z6");

var $bisEj = parcelRequire("bisEj");

var $hXJcm = parcelRequire("hXJcm");

var $2iJP7 = parcelRequire("2iJP7");
const $36e6928781aa8f54$export$a6c7ac8248d6e38a = ({ name: name, href: href })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("a", {
        css: (0, $2iJP7.styles)(theme).link,
        href: href,
        rel: "noopener noreferrer",
        target: "_blank",
        children: name
    });
};
$36e6928781aa8f54$export$a6c7ac8248d6e38a.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired
};

});
parcelRegister("2iJP7", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $70a385b7432ad5d1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $70a385b7432ad5d1$export$9dd6ff9ea0189349 = (theme)=>({
        link: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.dark, ";transition:color 0.2s;text-decoration:none;cursor:pointer;&:link,&:visited{}&:hover,&:active{color:", theme.colors.secondary.darkHover, ";}", "")
    });

});



parcelRegister("2Uj8f", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $429b75e4ced42d4b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $429b75e4ced42d4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $429b75e4ced42d4b$var$_ref = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $429b75e4ced42d4b$var$_ref2 = {
    name: "bpd7z7",
    styles: "margin-bottom:2px"
};
const $429b75e4ced42d4b$export$9dd6ff9ea0189349 = (theme)=>({
        footer: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            terms: $429b75e4ced42d4b$var$_ref2,
            contacts: $429b75e4ced42d4b$var$_ref,
            copyright: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.light, ";", ""),
            divider: /*#__PURE__*/ (0, $4N3Qt.css)("margin:0px 4px;color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("5R06k", function(module, exports) {

$parcel$export(module.exports, "NavLink", function () { return $07e9cab0509d10a9$export$b0d92dbee9b5b60d; });

var $5o6z6 = parcelRequire("5o6z6");

var $bisEj = parcelRequire("bisEj");

var $hXJcm = parcelRequire("hXJcm");

var $3QeX2 = parcelRequire("3QeX2");

var $avQTn = parcelRequire("avQTn");
const $07e9cab0509d10a9$export$b0d92dbee9b5b60d = ({ to: to, name: name, active: active, onClick: onClick, icon: Icon })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3QeX2.Link), {
        css: [
            (0, $avQTn.styles)(theme).link.main,
            active && (0, $avQTn.styles)(theme).link.active,
            "",
            ""
        ],
        to: to,
        onClick: (e)=>onClick(e),
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $avQTn.styles)(theme).link.body,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $avQTn.styles)(theme).link.icon,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $avQTn.styles)(theme).link.text,
                    children: name
                })
            ]
        })
    });
};
$07e9cab0509d10a9$export$b0d92dbee9b5b60d.propTypes = {
    to: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool.isRequired
};

});
parcelRegister("avQTn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0dcfe8e6227cc762$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $0dcfe8e6227cc762$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0dcfe8e6227cc762$var$_ref = {
    name: "s079uh",
    styles: "margin-top:2px"
};
var $0dcfe8e6227cc762$var$_ref2 = {
    name: "18zs2kf",
    styles: "display:flex;width:22px;align-items:center;justify-content:center;margin-right:12px;&>svg{width:22px;height:22px;}&>svg>path{transition:fill 0.2s;}"
};
var $0dcfe8e6227cc762$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
const $0dcfe8e6227cc762$export$9dd6ff9ea0189349 = (theme)=>({
        link: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.light, ";font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;cursor:pointer;text-decoration:none;transition:color 0.2s;display:inline-block;&:link,&:visited{}&:hover,&:active{color:", theme.colors.accent.normal, ";&>div>div>svg>path{fill:", theme.colors.accent.normal, ";}}", ""),
            active: /*#__PURE__*/ (0, $4N3Qt.css)("&:link,&:visited{color:", theme.colors.accent.normal, ";}&>div>div>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            body: $0dcfe8e6227cc762$var$_ref3,
            icon: $0dcfe8e6227cc762$var$_ref2,
            text: $0dcfe8e6227cc762$var$_ref
        }
    });

});



parcelRegister("aAeuw", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f72ad949e67243fe$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f72ad949e67243fe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f72ad949e67243fe$var$_ref = {
    name: "1sfqy6m",
    styles: "flex:1;margin-bottom:auto;padding:20px 20px;&>ul{list-style-type:none;&>li:not(:last-of-type){margin-bottom:6px;}}"
};
var $f72ad949e67243fe$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
const $f72ad949e67243fe$export$9dd6ff9ea0189349 = (theme)=>({
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;flex:1;width:", (0, $48E0n.constants).app.navigation.desktop.width, ";height:", (0, $48E0n.constants).app.navigation.desktop.height, ";background-color:", theme.colors.primary.darker, ";", (0, $48E0n.mq).tablet($f72ad949e67243fe$var$_ref2), ";", ""),
            logo: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;height:", (0, $48E0n.constants).app.header.desktop.height, ";padding:20px 20px;&>svg{width:140px;height:24px;}", ""),
            links: $f72ad949e67243fe$var$_ref,
            footer: /*#__PURE__*/ (0, $4N3Qt.css)("padding:20px 20px 40px 20px;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("8Jr1i", function(module, exports) {

$parcel$export(module.exports, "NavigationAppMobile", function () { return $af3f0156b19d5741$export$bd6a2b6da3ead20e; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2sNJT = parcelRequire("2sNJT");
var $11Nfd = parcelRequire("11Nfd");
var $jhoVP = parcelRequire("jhoVP");
parcelRequire("fRVt8");
var $f7BhD = parcelRequire("f7BhD");
var $2Ww3e = parcelRequire("2Ww3e");
parcelRequire("bJOXx");
var $5uMiO = parcelRequire("5uMiO");
parcelRequire("ISX69");
var $inVJ0 = parcelRequire("inVJ0");
var $5R06k = parcelRequire("5R06k");

var $kay72 = parcelRequire("kay72");
const $af3f0156b19d5741$export$bd6a2b6da3ead20e = ()=>{
    const theme = (0, $hXJcm.u)();
    const { pathname: pathname } = (0, $fbE6a.useLocation)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const isNavigationOpen = (0, $9CcOD.useAppSelector)((0, $11Nfd.navigationSelectAppNavigationOpen));
    const navLinks = (0, $5uMiO.getNavLinks)(profile);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: [
            (0, $kay72.styles)(theme).navigation.main.shared,
            isNavigationOpen ? (0, $kay72.styles)(theme).navigation.main.open : (0, $kay72.styles)(theme).navigation.main.closed,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                onCloseClick: ()=>dispatch((0, $11Nfd.navigationAppNavigationClose)())
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("nav", {
                css: (0, $kay72.styles)(theme).navigation.links,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("ul", {
                    children: navLinks.map(({ name: name, path: path, icon: icon })=>/*#__PURE__*/ (0, $5o6z6.jsx)("li", {
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                css: (0, $kay72.styles)(theme).navigation.menu,
                                onClick: ()=>dispatch((0, $11Nfd.navigationAppNavigationClose)()),
                                type: "button",
                                "aria-label": `navigate to ${name}`,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5R06k.NavLink), {
                                    to: path,
                                    name: name,
                                    icon: icon,
                                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetClosed)()),
                                    active: pathname === path
                                })
                            })
                        }, `${name}-${path}`))
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kay72.styles)(theme).navigation.auth,
                children: profile ? // if authenticated
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                    "aria-label": "log out",
                    appearance: "secondary",
                    onClick: ()=>{
                        dispatch((0, $2sNJT.authSignout)());
                        dispatch((0, $11Nfd.navigationAppNavigationClose)());
                    },
                    children: "Log out"
                }) : // if unauthenticated
                /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                            "aria-label": "log in",
                            appearance: "secondary",
                            onClick: ()=>{
                                dispatch((0, $fAzHC.authOpenLoginModal)());
                                dispatch((0, $11Nfd.navigationAppNavigationClose)());
                            },
                            children: "Log in"
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                            "aria-label": "sign up",
                            appearance: "primary",
                            onClick: ()=>{
                                dispatch((0, $fAzHC.authOpenSignupModal)());
                                dispatch((0, $11Nfd.navigationAppNavigationClose)());
                            },
                            children: "Sign up"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kay72.styles)(theme).navigation.footer,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $inVJ0.NavFooter), {})
            })
        ]
    });
};
$af3f0156b19d5741$export$bd6a2b6da3ead20e.propTypes = {};

});
parcelRegister("kay72", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fcd587a73b582e1c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fcd587a73b582e1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fcd587a73b582e1c$var$_ref = {
    name: "1fuw0zz",
    styles: "display:flex;justify-content:center;padding:0px 10px;&>footer{text-align:center;}"
};
var $fcd587a73b582e1c$var$_ref2 = {
    name: "1jex98y",
    styles: "display:flex;flex-direction:column;align-items:center;padding:0px 10px;margin-bottom:40px;&>button{max-width:300px;}&>button:nth-of-type(1){margin-bottom:20px;}"
};
var $fcd587a73b582e1c$var$_ref3 = {
    name: "kx0plp",
    styles: "left:100vw;top:0;opacity:0"
};
var $fcd587a73b582e1c$var$_ref4 = {
    name: "196alpc",
    styles: "left:0;top:0;opacity:1"
};
var $fcd587a73b582e1c$var$_ref5 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $fcd587a73b582e1c$var$_ref6 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $fcd587a73b582e1c$export$9dd6ff9ea0189349 = (theme)=>({
        navigation: {
            main: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";z-index:", (0, $48E0n.z).app.navigation.mobile, ";display:none;position:fixed;padding-top:0px;width:100%;height:100%;background-color:", theme.colors.primary.darker, ";overflow:hidden;overflow-y:scroll;transition:left 0.2s,opacity 0.4s;", (0, $48E0n.mq).tablet($fcd587a73b582e1c$var$_ref6), " ", (0, $48E0n.mq).mobile($fcd587a73b582e1c$var$_ref5), ";", ""),
                open: $fcd587a73b582e1c$var$_ref4,
                closed: $fcd587a73b582e1c$var$_ref3
            },
            menu: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;cursor:pointer;&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.light, ";}&:hover{&>svg>path{transition:fill 0.2s;fill:", theme.colors.accent.normal, ";}}", ""),
            links: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1;display:flex;justify-content:center;background-color:", theme.colors.primary.darker, ";margin-bottom:40px;&>ul{list-style-type:none;&>li:not(:last-of-type){margin-bottom:24px;}}", ""),
            auth: $fcd587a73b582e1c$var$_ref2,
            footer: $fcd587a73b582e1c$var$_ref
        }
    });

});



parcelRegister("gMvxt", function(module, exports) {

$parcel$export(module.exports, "NavigationLibrary", function () { return $9ea3d7092ad90bdb$export$7656d61f506178a4; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $11Nfd = parcelRequire("11Nfd");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("huFs3");
var $3B9CE = parcelRequire("3B9CE");

var $aXrbz = parcelRequire("aXrbz");
const $9ea3d7092ad90bdb$export$7656d61f506178a4 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const { likedTracks: likedTracks, likedPosts: likedPosts, followedArtists: followedArtists, unlockedTracks: unlockedTracks, unlockedPosts: unlockedPosts, subscribedArtists: subscribedArtists } = (0, $9CcOD.useAppSelector)((0, $11Nfd.navigationSelectLibraryCategories));
    // content navigation desktop
    const [backwardDisabled, setBackwardDisabled] = (0, $exYeM.useState)(true);
    const [forwardDisabled, setForwardDisabled] = (0, $exYeM.useState)(false);
    const contentRef = (0, $exYeM.useRef)(null);
    const categories = [
        {
            id: "2cc48f49-5bf6-40ab-9522-32bb5c0408bd",
            name: "Liked Tracks",
            label: "select liked tracks",
            selected: likedTracks,
            onClick: ()=>dispatch((0, $11Nfd.navigationLibraryCategoriesToggleLikedTracks)())
        },
        {
            id: "074437af-af73-4f93-b69b-34e25b7195bd",
            name: "Liked Posts",
            label: "select liked posts",
            selected: likedPosts,
            onClick: ()=>dispatch((0, $11Nfd.navigationLibraryCategoriesToggleLikedPosts)())
        },
        {
            id: "dfe24625-0bba-4085-8933-51e6139761a2",
            name: "Followed Artists",
            label: "select followed artists",
            selected: followedArtists,
            onClick: ()=>dispatch((0, $11Nfd.navigationLibraryCategoriesToggleFollowedArtists)())
        },
        {
            id: "705b9609-f357-46ee-b6f9-9e4fe26200e0",
            name: "Unlocked Tracks",
            label: "select unlocked tracks",
            selected: unlockedTracks,
            onClick: ()=>dispatch((0, $11Nfd.navigationLibraryCategoriesToggleUnlockedTracks)())
        },
        {
            id: "9aebdb24-2da7-40a1-8d2c-062d4d2a847a",
            name: "Unlocked Posts",
            label: "select unlocked posts",
            selected: unlockedPosts,
            onClick: ()=>dispatch((0, $11Nfd.navigationLibraryCategoriesToggleUnlockedPosts)())
        },
        {
            id: "9129888d-fd0a-47c3-a7e3-0d21634dda10",
            name: "Subscribed Artists",
            label: "select subscribed artists",
            selected: subscribedArtists,
            onClick: ()=>dispatch((0, $11Nfd.navigationLibraryCategoriesToggleSubscribedArtists)())
        }
    ];
    // configure initial navigation state
    (0, $exYeM.useEffect)(()=>{
        // if node exists
        if (contentRef.current) {
            // get current node
            const { current: current } = contentRef;
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = current;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (scrollLeft <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (scrollLeft >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    }, []);
    // handleBackwardClick - handles categories navigation backward click
    const handleBackwardClick = ()=>{
        // if node exists
        if (contentRef.current) {
            // get current node
            const { current: current } = contentRef;
            // get node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = current;
            // calculate next scroll offset
            const navigationButtonWidth = 60;
            const offset = clientWidth - navigationButtonWidth * 2;
            // scroll for exactly n visible items
            current.scrollBy(-offset, 0);
            const nextScrollPosition = scrollLeft - offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    // handleForwardClick - handles categories navigation forward click
    const handleForwardClick = ()=>{
        // if node exists
        if (contentRef.current) {
            // get current node
            const { current: current } = contentRef;
            // get node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = current;
            // calculate next scroll offset
            const navigationButtonWidth = 60;
            const offset = clientWidth - navigationButtonWidth * 2;
            // scroll for exactly n visible items
            current.scrollBy(offset, 0);
            const nextScrollPosition = scrollLeft + offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $aXrbz.styles)(theme).navigation.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $aXrbz.styles)(theme).navigation.overlay.shared,
                    (0, $aXrbz.styles)(theme).navigation.overlay.backward,
                    backwardDisabled && (0, $aXrbz.styles)(theme).navigation.overlay.disabled,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $aXrbz.styles)(theme).navigation.overlay.button,
                    type: "button",
                    "aria-label": "scroll backward",
                    disabled: backwardDisabled,
                    onClick: ()=>handleBackwardClick(),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {
                        css: (0, $aXrbz.styles)(theme).navigation.overlay.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $aXrbz.styles)(theme).navigation.content,
                ref: contentRef,
                children: categories.map(({ id: id, name: name, label: label, selected: selected, onClick: onClick })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $3B9CE.Category), {
                        name: name,
                        label: label,
                        selected: selected,
                        onClick: ()=>onClick()
                    }, id))
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $aXrbz.styles)(theme).navigation.overlay.shared,
                    (0, $aXrbz.styles)(theme).navigation.overlay.forward,
                    forwardDisabled && (0, $aXrbz.styles)(theme).navigation.overlay.disabled,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $aXrbz.styles)(theme).navigation.overlay.button,
                    type: "button",
                    "aria-label": "scroll backward",
                    disabled: forwardDisabled,
                    onClick: ()=>handleForwardClick(),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowRight, {
                        css: (0, $aXrbz.styles)(theme).navigation.overlay.icon
                    })
                })
            })
        ]
    });
};
$9ea3d7092ad90bdb$export$7656d61f506178a4.propTypes = {};

});
parcelRegister("huFs3", function(module, exports) {

$parcel$export(module.exports, "Category", function () { return (parcelRequire("3B9CE")).Category; });

var $3B9CE = parcelRequire("3B9CE");

});
parcelRegister("3B9CE", function(module, exports) {

$parcel$export(module.exports, "Category", function () { return $d10953b283fa5510$export$3a8840c5b2ecf003; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $7gDpg = parcelRequire("7gDpg");
const $d10953b283fa5510$export$3a8840c5b2ecf003 = ({ name: name, label: label, selected: selected = false, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7gDpg.styles)(theme).category.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
            css: [
                (0, $7gDpg.styles)(theme).category.button.shared,
                selected ? (0, $7gDpg.styles)(theme).category.button.selected : (0, $7gDpg.styles)(theme).category.button.unselected,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": label,
            children: name
        })
    });
};
$d10953b283fa5510$export$3a8840c5b2ecf003.propTypes = {};

});
parcelRegister("7gDpg", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a0106224a4e118a5$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $a0106224a4e118a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a0106224a4e118a5$var$_ref = {
    name: "1u4hpl4",
    styles: "display:inline"
};
const $a0106224a4e118a5$export$9dd6ff9ea0189349 = (theme)=>({
        category: {
            main: $a0106224a4e118a5$var$_ref,
            button: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";height:40px;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;white-space:nowrap;line-height:1;border-radius:20px;border:1px solid transparent;padding:8px 26px;cursor:pointer;transition:color 0.2s,background-color 0.2s,border 0.2s;", ""),
                selected: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";", ""),
                unselected: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});



parcelRegister("aXrbz", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3a82374090d55036$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3a82374090d55036$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3a82374090d55036$var$_ref = {
    name: "lcsd53",
    styles: "width:100vw"
};
var $3a82374090d55036$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
var $3a82374090d55036$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
const $3a82374090d55036$export$9dd6ff9ea0189349 = (theme)=>({
        navigation: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).library.header.height, ";", (0, $48E0n.helpers).library.header.width, ";position:relative;", ""),
            overlay: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).library.navigation.arrows, ";position:absolute;display:flex;align-items:center;justify-content:center;width:60px;height:64px;", (0, $48E0n.mq).mobile($3a82374090d55036$var$_ref3), ";", ""),
                backward: /*#__PURE__*/ (0, $4N3Qt.css)("top:0;left:0;background:linear-gradient(\n          90deg,\n          ", theme.colors.primary.normal, " 50%,\n          ", theme.colors.primary.normal, "00 100%\n        );", ""),
                forward: /*#__PURE__*/ (0, $4N3Qt.css)("top:0;right:0;background:linear-gradient(\n          270deg,\n          ", theme.colors.primary.normal, " 50%,\n          ", theme.colors.primary.normal, "00 100%\n        );", ""),
                disabled: $3a82374090d55036$var$_ref2,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:40px;height:40px;cursor:pointer;&:hover>svg{color:", theme.colors.accent.normal, ";}", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:20px;height:20px;transition:color 0.2s;color:", theme.colors.secondary.normal, ";", "")
            },
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.sides, ";display:flex;align-items:center;width:100%;height:64px;scroll-behavior:smooth;overflow-x:scroll;overflow-y:hidden;&>div:not(:last-of-type){margin-right:18px;}", (0, $48E0n.mq).tablet($3a82374090d55036$var$_ref), ";", "")
        }
    });

});



parcelRegister("11Nfd", function(module, exports) {

$parcel$export(module.exports, "navigationSlice", function () { return $b3e5c7daafcebd32$export$de790b4dea75d828; });
$parcel$export(module.exports, "navigationAppNavigationToggle", function () { return $b3e5c7daafcebd32$export$af9b100e53a4319a; });
$parcel$export(module.exports, "navigationAppNavigationClose", function () { return $b3e5c7daafcebd32$export$9533b90f4dbbbe61; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleLikedTracks", function () { return $b3e5c7daafcebd32$export$f336f935c1afd49; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleLikedPosts", function () { return $b3e5c7daafcebd32$export$3c4c9d7436519edc; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleUnlockedTracks", function () { return $b3e5c7daafcebd32$export$b9439e277be4ef7c; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleUnlockedPosts", function () { return $b3e5c7daafcebd32$export$853b5990905e4b4a; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleFollowedArtists", function () { return $b3e5c7daafcebd32$export$3ab5ea438c43ace8; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleSubscribedArtists", function () { return $b3e5c7daafcebd32$export$671962ec6c02e8d7; });
$parcel$export(module.exports, "navigationSelectAppNavigationOpen", function () { return $b3e5c7daafcebd32$export$1e1838785d7d9c6; });
$parcel$export(module.exports, "navigationSelectLibraryCategories", function () { return $b3e5c7daafcebd32$export$1183892afe6282; });
$parcel$export(module.exports, "navigationReducer", function () { return $b3e5c7daafcebd32$export$dcbfb7a8294dae22; });

var $dEr3t = parcelRequire("dEr3t");
const $b3e5c7daafcebd32$var$initialState = {
    app: {
        navigation: {
            open: false
        }
    },
    library: {
        categories: {
            likedTracks: true,
            likedPosts: false,
            unlockedTracks: false,
            unlockedPosts: false,
            followedArtists: false,
            subscribedArtists: false
        }
    }
};
const $b3e5c7daafcebd32$export$de790b4dea75d828 = (0, $dEr3t.createSlice)({
    name: "navigation",
    initialState: $b3e5c7daafcebd32$var$initialState,
    reducers: {
        // app navigation
        navigationAppNavigationToggle: (state)=>({
                ...state,
                app: {
                    navigation: {
                        open: !state.app.navigation.open
                    }
                }
            }),
        navigationAppNavigationClose: (state)=>({
                ...state,
                app: {
                    navigation: {
                        open: false
                    }
                }
            }),
        // library navigation
        navigationLibraryCategoriesToggleLikedTracks: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        likedTracks: !state.library.categories.likedTracks
                    }
                }
            }),
        navigationLibraryCategoriesToggleLikedPosts: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        likedPosts: !state.library.categories.likedPosts
                    }
                }
            }),
        navigationLibraryCategoriesToggleUnlockedTracks: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        unlockedTracks: !state.library.categories.unlockedTracks
                    }
                }
            }),
        navigationLibraryCategoriesToggleUnlockedPosts: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        unlockedPosts: !state.library.categories.unlockedPosts
                    }
                }
            }),
        navigationLibraryCategoriesToggleFollowedArtists: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        followedArtists: !state.library.categories.followedArtists
                    }
                }
            }),
        navigationLibraryCategoriesToggleSubscribedArtists: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        subscribedArtists: !state.library.categories.subscribedArtists
                    }
                }
            })
    }
});
const { navigationAppNavigationToggle: $b3e5c7daafcebd32$export$af9b100e53a4319a, navigationAppNavigationClose: $b3e5c7daafcebd32$export$9533b90f4dbbbe61, navigationLibraryCategoriesToggleLikedTracks: $b3e5c7daafcebd32$export$f336f935c1afd49, navigationLibraryCategoriesToggleLikedPosts: $b3e5c7daafcebd32$export$3c4c9d7436519edc, navigationLibraryCategoriesToggleUnlockedTracks: $b3e5c7daafcebd32$export$b9439e277be4ef7c, navigationLibraryCategoriesToggleUnlockedPosts: $b3e5c7daafcebd32$export$853b5990905e4b4a, navigationLibraryCategoriesToggleFollowedArtists: $b3e5c7daafcebd32$export$3ab5ea438c43ace8, navigationLibraryCategoriesToggleSubscribedArtists: $b3e5c7daafcebd32$export$671962ec6c02e8d7 } = $b3e5c7daafcebd32$export$de790b4dea75d828.actions;
const $b3e5c7daafcebd32$export$1e1838785d7d9c6 = (state)=>state.navigation.app.navigation.open;
const $b3e5c7daafcebd32$export$1183892afe6282 = (state)=>state.navigation.library.categories;
const $b3e5c7daafcebd32$export$dcbfb7a8294dae22 = $b3e5c7daafcebd32$export$de790b4dea75d828.reducer; // export default navigationSlice.reducer

});


parcelRegister("3OccL", function(module, exports) {

$parcel$export(module.exports, "NotificationCard", function () { return (parcelRequire("37A8n")).NotificationCard; });
$parcel$export(module.exports, "NotificationListNotifications", function () { return (parcelRequire("azYiI")).NotificationListNotifications; });
$parcel$export(module.exports, "NotificationViewNotification", function () { return (parcelRequire("1abff")).NotificationViewNotification; });
parcelRequire("8fGoR");
var $37A8n = parcelRequire("37A8n");
var $azYiI = parcelRequire("azYiI");
var $1abff = parcelRequire("1abff");

var $6VkZt = parcelRequire("6VkZt");

var $uiU92 = parcelRequire("uiU92");
$parcel$exportWildcard(module.exports, $6VkZt);
$parcel$exportWildcard(module.exports, $uiU92);

});
parcelRegister("8fGoR", function(module, exports) {

$parcel$export(module.exports, "NotificationCard", function () { return (parcelRequire("37A8n")).NotificationCard; });
$parcel$export(module.exports, "NotificationListNotifications", function () { return (parcelRequire("azYiI")).NotificationListNotifications; });
$parcel$export(module.exports, "NotificationViewNotification", function () { return (parcelRequire("1abff")).NotificationViewNotification; });

var $37A8n = parcelRequire("37A8n");

var $azYiI = parcelRequire("azYiI");

var $1abff = parcelRequire("1abff");

});
parcelRegister("37A8n", function(module, exports) {

$parcel$export(module.exports, "NotificationCard", function () { return $13971e3fec9a4d0f$export$c86fc4367bcc624a; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $8a4Bv = parcelRequire("8a4Bv");
parcelRequire("dmGpj");
var $uiU92 = parcelRequire("uiU92");

var $i6DA6 = parcelRequire("i6DA6");
parcelRequire("8Jc1e");
var $6KRFD = parcelRequire("6KRFD");

var $i5a8g = parcelRequire("i5a8g");
const $13971e3fec9a4d0f$export$c86fc4367bcc624a = ({ notification: notification, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const { id: notificationId, sourceUserIds: sourceUserIds, sourceUserIdsCount: sourceUserIdsCount, event: event, read: read } = notification;
    const isSourcesPresent = !!(sourceUserIds && sourceUserIds.length > 0);
    const isSingleSource = !!(sourceUserIds && sourceUserIds.length === 1);
    const isDoubleSource = !!(sourceUserIds && sourceUserIds.length === 2);
    const isTripleSource = !!(sourceUserIds && sourceUserIds.length === 3);
    // source users
    const { users: sourceUsers, isLoading: isSourceUsersLoading } = (0, $8a4Bv.useUsers)(sourceUserIds || []);
    const userLoadingPlaceholder = "Loading...";
    (0, $exYeM.useEffect)(()=>{
        // if notification is not read
        if (!read) // flag notification as read
        dispatch((0, $uiU92.notificationReadNotification)({
            notificationId: notificationId || ""
        }));
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $i5a8g.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $i5a8g.styles)(theme).card.data.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $i5a8g.styles)(theme).card.data.source.main,
                    children: isSourcesPresent ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: [
                            (0, $i5a8g.styles)(theme).card.data.source.avatars.shared,
                            isSingleSource && (0, $i5a8g.styles)(theme).card.data.source.avatars.single,
                            isDoubleSource && (0, $i5a8g.styles)(theme).card.data.source.avatars.double,
                            isTripleSource && (0, $i5a8g.styles)(theme).card.data.source.avatars.triple,
                            "",
                            ""
                        ],
                        children: sourceUsers && sourceUsers.map(({ id: id, avatarId: avatarId })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KRFD.Avatar), {
                                avatarId: avatarId
                            }, `notification-avatar-${id}`))
                    }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $i5a8g.styles)(theme).card.data.source.icon,
                        children: event && /*#__PURE__*/ (0, $exYeM.createElement)((0, $i6DA6.getNotificationIcon)(event))
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $i5a8g.styles)(theme).card.data.info.main,
                    children: [
                        isSourcesPresent && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $i5a8g.styles)(theme).card.data.info.sources,
                            children: isSourceUsersLoading ? userLoadingPlaceholder : (0, $i6DA6.formantNotificationSources)(sourceUsers || [])
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $i5a8g.styles)(theme).card.data.info.titles,
                            children: [
                                (0, $i6DA6.getNotificationOthers)(sourceUserIds || [], sourceUserIdsCount || 0),
                                " ",
                                event && (0, $i6DA6.getNotificationTitle)(event)
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$13971e3fec9a4d0f$export$c86fc4367bcc624a.propTypes = {};

});
parcelRegister("i6DA6", function(module, exports) {

$parcel$export(module.exports, "getNotificationTitle", function () { return $8920361b0b4c2c7c$export$58a9eeee76364ebb; });
$parcel$export(module.exports, "getNotificationOthers", function () { return $8920361b0b4c2c7c$export$2537101bd1e6339; });
$parcel$export(module.exports, "formantNotificationSources", function () { return $8920361b0b4c2c7c$export$b6cfc697d69eb4d8; });
$parcel$export(module.exports, "getNotificationIcon", function () { return $8920361b0b4c2c7c$export$2c1c27587878a0c4; });
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
const $8920361b0b4c2c7c$export$58a9eeee76364ebb = (event)=>{
    // USER
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppUserFollowCreated) return "started following you";
    // TRACK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackCreated) return "released new track";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackBlocked) return "Your track is blocked";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackLikeCreated) return "liked your track";
    // POST
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostCreated) return "shared new post";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostBlocked) return "Your post is blocked";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostLikeCreated) return "liked your post";
    // COMMENT
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentCreated) return "commented on your post";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentReplyCreated) return "replied to your comment";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentBlocked) return "Your comment is blocked";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentLikeCreated) return "liked your comment";
    // TIP
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentSucceeded) return "Tip payment succeeded";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentFailed) return "Tip payment failed";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipCreated) return "has sent you a tip";
    // TRACK UNLOCK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return "Unlock payment succeeded";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentFailed) return "Unlock payment failed";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockCreated) return "unlocked your track";
    // POST UNLOCK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return "Unlock payment succeeded";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentFailed) return "Unlock payment failed";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockCreated) return "unlocked your post";
    // SUBSCRIPTION
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return "Subscription payment succeeded";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentFailed) return "Subscription payment failed";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionCreated) return "subscribed to you";
    // PAYOUT
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPayoutPaid) return "Payout payment succeeded";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPayoutFailed) return "Payout payment failed";
    return "";
};
const $8920361b0b4c2c7c$export$2537101bd1e6339 = (sourceUserIds, sourceUserIdsCount)=>{
    if (sourceUserIds.length >= 3 && sourceUserIdsCount > 3) return `and ${(0, $fJerj.numbersFormatter)(sourceUserIdsCount - sourceUserIds.length)} other(s)`;
    return "";
};
const $8920361b0b4c2c7c$export$b6cfc697d69eb4d8 = (sourceUsers)=>sourceUsers.reduce((prev, { username: username })=>prev === "" ? `@${username}` : `${prev}, @${username}`, "");
const $8920361b0b4c2c7c$export$2c1c27587878a0c4 = (event)=>{
    // TRACK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackBlocked) return (0, $9IIBp.icons).AlertTriangle;
    // POST
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostBlocked) return (0, $9IIBp.icons).AlertTriangle;
    // COMMENT
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentBlocked) return (0, $9IIBp.icons).AlertTriangle;
    // TIP
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentSucceeded) return (0, $9IIBp.icons).DollarCircle;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentFailed) return (0, $9IIBp.icons).AlertTriangle;
    // UNLOCK TRACK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return (0, $9IIBp.icons).Unlock;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentFailed) return (0, $9IIBp.icons).AlertTriangle;
    // UNLOCK POST
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return (0, $9IIBp.icons).Unlock;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentFailed) return (0, $9IIBp.icons).AlertTriangle;
    // SUBSCRIPTION
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return (0, $9IIBp.icons).Unlock;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentFailed) return (0, $9IIBp.icons).AlertTriangle;
    // PAYOUT
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPayoutPaid) return (0, $9IIBp.icons).DollarCircle;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPayoutFailed) return (0, $9IIBp.icons).AlertTriangle;
    return (0, $9IIBp.icons).CheckCircle;
};

});

parcelRegister("8Jc1e", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("6KRFD")).Avatar; });

var $6KRFD = parcelRequire("6KRFD");

});
parcelRegister("6KRFD", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $223b7aea2deba483$export$e2255cf6045e8d47; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");

var $jbR38 = parcelRequire("jbR38");
const $223b7aea2deba483$export$e2255cf6045e8d47 = ({ avatarId: avatarId = "" })=>{
    const theme = (0, $hXJcm.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $exYeM.useState)(false);
    const hasAvatar = !!avatarId;
    const source = (0, $hrd7b.useFile)(avatarId || "");
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $jbR38.styles)(theme).avatar.main,
        children: hasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
            css: (0, $jbR38.styles)(theme).avatar.content,
            onError: ()=>setAvatarLoadError(true),
            loading: "lazy",
            width: "60px",
            height: "60px",
            src: source,
            alt: "source user avatar"
        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
            css: (0, $jbR38.styles)(theme).avatar.icon
        })
    });
};

});
parcelRegister("jbR38", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1147216b6721e345$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $1147216b6721e345$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:60px;height:60px;border-radius:50%;background-color:", theme.colors.primary.darker, ";overflow:hidden;", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:30px;height:30px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
        }
    });

});



parcelRegister("i5a8g", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $db543966497ff15e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $db543966497ff15e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $db543966497ff15e$var$_ref = {
    name: "79ibxp",
    styles: "display:flex;flex-direction:column;width:100%;min-width:0"
};
var $db543966497ff15e$var$_ref2 = {
    name: "bxnacs",
    styles: "position:relative;display:flex;align-items:center;&>div{position:absolute;width:30px;height:30px;}&>div:nth-of-type(1){z-index:3;left:0px;}&>div:nth-of-type(2){z-index:2;left:15px;}&>div:nth-of-type(3){z-index:1;right:0px;}"
};
var $db543966497ff15e$var$_ref3 = {
    name: "18az8xz",
    styles: "position:relative;display:flex;align-items:center;&>div{position:absolute;width:40px;height:40px;}&>div:nth-of-type(1){z-index:2;left:0px;}&>div:nth-of-type(2){z-index:1;right:0px;}"
};
var $db543966497ff15e$var$_ref4 = {
    name: "pn23tk",
    styles: "width:60px;height:60px"
};
var $db543966497ff15e$var$_ref5 = {
    name: "18dc9ig",
    styles: "display:flex;flex:0 0 60px;margin-right:20px"
};
var $db543966497ff15e$var$_ref6 = {
    name: "12t4mdo",
    styles: "display:flex;align-items:center;height:60px"
};
var $db543966497ff15e$var$_ref7 = {
    name: "1y1se14",
    styles: "display:flex;flex-direction:column;justify-content:space-between;height:60px;cursor:pointer"
};
const $db543966497ff15e$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $db543966497ff15e$var$_ref7,
            data: {
                main: $db543966497ff15e$var$_ref6,
                source: {
                    main: $db543966497ff15e$var$_ref5,
                    avatars: {
                        shared: $db543966497ff15e$var$_ref4,
                        single: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        double: $db543966497ff15e$var$_ref3,
                        triple: $db543966497ff15e$var$_ref2
                    },
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:60px;height:60px;&>svg{width:32px;height:32px;&>path{fill:", theme.colors.secondary.normal, ";}}", "")
                },
                info: {
                    main: $db543966497ff15e$var$_ref,
                    sources: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", ""),
                    titles: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")
                }
            }
        }
    });

});


parcelRegister("azYiI", function(module, exports) {

$parcel$export(module.exports, "NotificationListNotifications", function () { return $9824cd98ab3fba90$export$9f7bd6309114da4c; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $37A8n = parcelRequire("37A8n");
var $uiU92 = parcelRequire("uiU92");
var $6VkZt = parcelRequire("6VkZt");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
var $46Iw7 = parcelRequire("46Iw7");
var $1sbY5 = parcelRequire("1sbY5");
var $lFRMC = parcelRequire("lFRMC");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $8QCBl = parcelRequire("8QCBl");
const $9824cd98ab3fba90$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const notifications = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotifications));
    const notification = notifications[index];
    // if notification not fetched
    if (!notification) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "notification-list-notifications-notification",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: notificationId } = notification;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8QCBl.styles)().notification.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $37A8n.NotificationCard), {
            notification: notification,
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Notifications}${(0, $9YTSb.Path).Notification}/${notificationId}`)
        })
    });
});
const $9824cd98ab3fba90$export$9f7bd6309114da4c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const notificationGetNotificationsLoading = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationGetNotificationsLoading));
    const notifications = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotifications));
    const notificationsCount = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationsCount));
    const notificationsLength = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationsLength));
    const notificationsFetched = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationsFetched));
    const notificationsFilter = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationsFilter));
    const notificationReadNotificationsLoading = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationReadNotificationsLoading));
    const notificationCardHeight = 60;
    const notificationCardMarginBottom = 20;
    const itemHeight = notificationCardHeight + notificationCardMarginBottom;
    const itemsToFit = 6;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = itemsToFit * itemHeight;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!notifications[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $uiU92.notificationGetNotifications)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders notification list navigation
    const renderNotificationListNavigation = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $8QCBl.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lFRMC.NavigationScrollable), {
                options: [
                    {
                        id: "ebb827c4-2091-4dc2-8f5d-621ce926677d",
                        label: "User",
                        enabled: notificationsFilter === (0, $aeAwZ.EntityNotificationEntityType).User,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $6VkZt.notificationSetNotificationsFilter)({
                                filter: (0, $aeAwZ.EntityNotificationEntityType).User
                            }));
                            // refetch notifications
                            dispatch((0, $uiU92.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "8dceb189-e6e8-4f1c-85a0-31fcde6fe99d",
                        label: "Track",
                        enabled: notificationsFilter === (0, $aeAwZ.EntityNotificationEntityType).Track,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $6VkZt.notificationSetNotificationsFilter)({
                                filter: (0, $aeAwZ.EntityNotificationEntityType).Track
                            }));
                            // refetch notifications
                            dispatch((0, $uiU92.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "37740ab4-aea0-4c54-8448-400a1fab5096",
                        label: "Post",
                        enabled: notificationsFilter === (0, $aeAwZ.EntityNotificationEntityType).Post,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $6VkZt.notificationSetNotificationsFilter)({
                                filter: (0, $aeAwZ.EntityNotificationEntityType).Post
                            }));
                            // refetch notifications
                            dispatch((0, $uiU92.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "b5200260-910e-43f5-aa44-8c7883dee6ae",
                        label: "Comment",
                        enabled: notificationsFilter === (0, $aeAwZ.EntityNotificationEntityType).Comment,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $6VkZt.notificationSetNotificationsFilter)({
                                filter: (0, $aeAwZ.EntityNotificationEntityType).Comment
                            }));
                            // refetch notifications
                            dispatch((0, $uiU92.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "cb4d6974-7986-4054-b7b4-ba644cd2d0f6",
                        label: "Tip",
                        enabled: notificationsFilter === (0, $aeAwZ.EntityNotificationEntityType).Tip,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $6VkZt.notificationSetNotificationsFilter)({
                                filter: (0, $aeAwZ.EntityNotificationEntityType).Tip
                            }));
                            // refetch notifications
                            dispatch((0, $uiU92.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "e26df361-c035-42c7-82d9-18ceab7d9d56",
                        label: "Unlock",
                        enabled: notificationsFilter === (0, $aeAwZ.EntityNotificationEntityType).Unlock,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $6VkZt.notificationSetNotificationsFilter)({
                                filter: (0, $aeAwZ.EntityNotificationEntityType).Unlock
                            }));
                            // refetch notifications
                            dispatch((0, $uiU92.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "1a2c0ce2-edff-4878-a25d-8bca6509d185",
                        label: "Sub",
                        enabled: notificationsFilter === (0, $aeAwZ.EntityNotificationEntityType).Subscription,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $6VkZt.notificationSetNotificationsFilter)({
                                filter: (0, $aeAwZ.EntityNotificationEntityType).Subscription
                            }));
                            // refetch notifications
                            dispatch((0, $uiU92.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    }
                ]
            })
        });
    // if notifications are fetched but length is 0
    if (!notificationGetNotificationsLoading && notificationsFetched && notificationsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $8QCBl.styles)().list.main,
        children: [
            renderNotificationListNavigation(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8QCBl.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
                    icon: (0, $9IIBp.icons).Bell,
                    height: `${defaultListHeight}px`,
                    title: "There are no notifications"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $8QCBl.styles)().list.main,
        children: [
            renderNotificationListNavigation(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8QCBl.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: notificationsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: notificationsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $9824cd98ab3fba90$var$Row
                        })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8QCBl.styles)().list.actions.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                    type: "button",
                    "aria-label": "read all notifications",
                    disabled: notificationReadNotificationsLoading,
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $uiU92.notificationReadNotifications)()),
                    children: notificationReadNotificationsLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                        width: 56,
                        height: 16,
                        appearance: "secondary"
                    }) : `Read all`
                })
            })
        ]
    }));
};
$9824cd98ab3fba90$export$9f7bd6309114da4c.propTypes = {};

});
parcelRegister("8QCBl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c9e6105c47251ee0$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c9e6105c47251ee0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c9e6105c47251ee0$var$_ref = {
    name: "vziczn",
    styles: "justify-content:flex-start;&>button{width:100%;}"
};
var $c9e6105c47251ee0$var$_ref2 = {
    name: "1f5vy9b",
    styles: "max-width:800px;margin-bottom:24px"
};
const $c9e6105c47251ee0$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            content: {
                main: $c9e6105c47251ee0$var$_ref2
            },
            actions: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:flex-end;max-width:800px;&>button{width:140px;height:32px;}", (0, $48E0n.mq).mobile($c9e6105c47251ee0$var$_ref), ";", "")
            }
        },
        notification: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("1abff", function(module, exports) {

$parcel$export(module.exports, "NotificationViewNotification", function () { return $0eb99af86e2131c5$export$73f3139b9805d66d; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
var $bMcg5 = parcelRequire("bMcg5");
var $2qAsB = parcelRequire("2qAsB");
var $hiFdq = parcelRequire("hiFdq");
var $f7MpX = parcelRequire("f7MpX");
var $8a4Bv = parcelRequire("8a4Bv");
parcelRequire("dmGpj");
var $6VkZt = parcelRequire("6VkZt");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $3ui6M = parcelRequire("3ui6M");
parcelRequire("7H6vq");
var $cOb5F = parcelRequire("cOb5F");
var $hBZAB = parcelRequire("hBZAB");
var $1Obsu = parcelRequire("1Obsu");
var $h0syc = parcelRequire("h0syc");
var $5NFX3 = parcelRequire("5NFX3");
var $3QQ0o = parcelRequire("3QQ0o");
var $dWB6j = parcelRequire("dWB6j");

var $lLkJO = parcelRequire("lLkJO");
const $0eb99af86e2131c5$export$73f3139b9805d66d = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const notification = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotification));
    const notificationFetched = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationFetched));
    const { sourceUserIds: sourceUserIds, sourceUserIdsCount: sourceUserIdsCount, entityType: entityType, entityId: entityId, parentEntityId: parentEntityId, event: event } = notification ?? {};
    // source users
    const { users: sourceUsers, isLoading: isSourceUsersLoading } = (0, $8a4Bv.useUsers)(sourceUserIds || []);
    const userLoadingPlaceholder = "Loading...";
    // notification types
    const isTrackNotification = entityType === (0, $aeAwZ.EntityNotificationEntityType).Track;
    const isPostNotification = entityType === (0, $aeAwZ.EntityNotificationEntityType).Post;
    const isCommentNotification = entityType === (0, $aeAwZ.EntityNotificationEntityType).Comment;
    const isTipNotification = entityType === (0, $aeAwZ.EntityNotificationEntityType).Tip;
    const isUnlockNotification = entityType === (0, $aeAwZ.EntityNotificationEntityType).Unlock;
    const isSubscriptionNotification = entityType === (0, $aeAwZ.EntityNotificationEntityType).Subscription;
    const isConnectPayoutNotification = entityType === (0, $aeAwZ.EntityNotificationEntityType).ConnectPayout;
    // notification tip
    const { tip: notificationTip, isLoading: isNotificationTipLoading } = (0, $hiFdq.useTip)(isTipNotification ? entityId || "" : "");
    // notification unlock
    const { unlock: notificationUnlock, isLoading: isNotificationUnlockLoading } = (0, $f7MpX.useUnlock)(isUnlockNotification ? entityId || "" : "");
    // notification subscription
    const { subscription: notificationSubscription, isLoading: isNotificationSubscriptionLoading } = (0, $2qAsB.useSubscription)(isSubscriptionNotification ? entityId || "" : "");
    // notification connect payout
    const { connectPayout: notificationConnectPayout, isLoading: isNotificationConnectPayoutLoading } = (0, $bMcg5.useConnectPayout)(isConnectPayoutNotification ? entityId || "" : "");
    const isTipControlsDisabled = isNotificationTipLoading || !notificationTip;
    const isUnlockControlsDisabled = isNotificationUnlockLoading || !notificationUnlock;
    const isSubscriptionControlsDisabled = isNotificationSubscriptionLoading || !notificationSubscription;
    // if notification not found
    if (notificationFetched && !notification) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lLkJO.styles)().view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).AlertTriangle,
            height: "80px",
            title: "Could not find notification"
        })
    });
    const renderNotificationSourceUsers = ()=>{
        // if source users loading
        if (isSourceUsersLoading) // return placeholder
        return /*#__PURE__*/ (0, $5o6z6.jsxs)("span", {
            children: [
                userLoadingPlaceholder,
                " "
            ]
        });
        // if source users loaded
        if (sourceUsers) // render source users
        return sourceUsers.map(({ id: userId, username: username }, idx)=>{
            const isLastSource = sourceUsers.length - 1 === idx;
            return /*#__PURE__*/ (0, $5o6z6.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1Obsu.SourceUser), {
                        label: "source user",
                        username: username || "unknown",
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${userId}`)
                    }),
                    isLastSource ? " " : ", "
                ]
            }, `notification-view-notification-source-${userId}`);
        });
        return /*#__PURE__*/ (0, $5o6z6.jsx)("span", {});
    };
    // if notification found
    if (notificationFetched && notification) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lLkJO.styles)().view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $lLkJO.styles)().view.content.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $lLkJO.styles)().view.content.identifier,
                    children: [
                        renderNotificationSourceUsers(),
                        (0, $3ui6M.getNotificationOthers)(sourceUserIds || [], sourceUserIdsCount || 0),
                        " ",
                        event && (0, $3ui6M.getNotificationTitle)(event, {
                            tip: notificationTip,
                            isTipLoading: isNotificationTipLoading,
                            unlock: notificationUnlock,
                            isUnlockLoading: isNotificationUnlockLoading,
                            subscription: notificationSubscription,
                            isSubscriptionLoading: isNotificationSubscriptionLoading,
                            connectPayout: notificationConnectPayout,
                            isConnectPayoutLoading: isNotificationConnectPayoutLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $lLkJO.styles)().view.content.navigation,
                    children: [
                        isTrackNotification && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3QQ0o.TrackControls), {
                            trackId: entityId || ""
                        }),
                        isPostNotification && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $hBZAB.PostControls), {
                            postId: entityId || ""
                        }),
                        isCommentNotification && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cOb5F.CommentControls), {
                            commentId: entityId || "",
                            parentCommentId: parentEntityId || ""
                        }),
                        isTipNotification && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5NFX3.TipControls), {
                            event: notification.event,
                            tip: notificationTip,
                            isDisabled: isTipControlsDisabled
                        }),
                        isUnlockNotification && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $dWB6j.UnlockControls), {
                            event: notification.event,
                            unlock: notificationUnlock,
                            isDisabled: isUnlockControlsDisabled
                        }),
                        isSubscriptionNotification && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $h0syc.SubscriptionControls), {
                            event: notification.event,
                            subscription: notificationSubscription,
                            isDisabled: isSubscriptionControlsDisabled
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lLkJO.styles)().view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "notification-view-notifications-notification",
                    width: "100%",
                    height: "80px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$0eb99af86e2131c5$export$73f3139b9805d66d.propTypes = {};

});
parcelRegister("3ui6M", function(module, exports) {

$parcel$export(module.exports, "getNotificationTitle", function () { return $0b5a5fc1973bf0d8$export$58a9eeee76364ebb; });
$parcel$export(module.exports, "getNotificationOthers", function () { return $0b5a5fc1973bf0d8$export$2537101bd1e6339; });
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
const $0b5a5fc1973bf0d8$export$58a9eeee76364ebb = (event, { tip: tip, isTipLoading: isTipLoading, unlock: unlock, isUnlockLoading: isUnlockLoading, subscription: subscription, isSubscriptionLoading: isSubscriptionLoading, connectPayout: connectPayout, isConnectPayoutLoading: isConnectPayoutLoading })=>{
    // USER
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppUserFollowCreated) return "started following you";
    // TRACK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackCreated) return "released new track";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackBlocked) return "Your track is blocked";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackLikeCreated) return "liked your track";
    // POST
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostCreated) return "shared new post";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostBlocked) return "Your post is blocked";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostLikeCreated) return "liked your post";
    // COMMENT
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentCreated) return "commented on your post";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentReplyCreated) return "replied to your comment";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentBlocked) return "Your comment is blocked";
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppCommentLikeCreated) return "liked your comment";
    // TIP
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentSucceeded) return `Your $${isTipLoading ? "..." : (tip?.amount || 0) / 100} tip payment has succeeded`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentFailed) return `Your $${isTipLoading ? "..." : (tip?.amount || 0) / 100} tip payment has failed`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipCreated) return ` has sent you $${isTipLoading ? "..." : (tip?.amount || 0) / 100} tip`;
    // TRACK UNLOCK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100} track unlock payment has succeeded`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentFailed) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100}  track unlock payment has failed`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockCreated) return ` has unlocked your track for $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100} `;
    // POST UNLOCK
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100}  post unlock payment has succeeded`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentFailed) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100}  post unlock payment has failed`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockCreated) return ` has unlocked your post for $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100} `;
    // SUBSCRIPTION
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return `Your $${isSubscriptionLoading ? "..." : (subscription?.subscriptionPrice || 0) / 100} subscription payment has succeeded`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentFailed) return `Your $${isSubscriptionLoading ? "..." : (subscription?.subscriptionPrice || 0) / 100} subscription payment has failed`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionCreated) return ` has subscribed to you for $${isSubscriptionLoading ? "..." : (subscription?.subscriptionPrice || 0) / 100}`;
    // PAYOUT
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPayoutPaid) return `Your $${isConnectPayoutLoading ? "..." : (connectPayout?.amount || 0) / 100} payout has succeeded`;
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppPayoutFailed) return `Your $${isConnectPayoutLoading ? "..." : (connectPayout?.amount || 0) / 100} payout has succeeded`;
    return "";
};
const $0b5a5fc1973bf0d8$export$2537101bd1e6339 = (sourceUserIds, sourceUserIdsCount)=>{
    if (sourceUserIds.length >= 3 && sourceUserIdsCount > 3) return `and ${(0, $fJerj.numbersFormatter)(sourceUserIdsCount - sourceUserIds.length)} other(s)`;
    return "";
};

});

parcelRegister("7H6vq", function(module, exports) {

$parcel$export(module.exports, "CommentControls", function () { return (parcelRequire("cOb5F")).CommentControls; });
$parcel$export(module.exports, "PostControls", function () { return (parcelRequire("hBZAB")).PostControls; });
$parcel$export(module.exports, "SubscriptionControls", function () { return (parcelRequire("h0syc")).SubscriptionControls; });
$parcel$export(module.exports, "TipControls", function () { return (parcelRequire("5NFX3")).TipControls; });
$parcel$export(module.exports, "TrackControls", function () { return (parcelRequire("3QQ0o")).TrackControls; });
$parcel$export(module.exports, "UnlockControls", function () { return (parcelRequire("dWB6j")).UnlockControls; });
$parcel$export(module.exports, "SourceUser", function () { return (parcelRequire("1Obsu")).SourceUser; });
parcelRequire("3PiDw");
var $cOb5F = parcelRequire("cOb5F");
var $hBZAB = parcelRequire("hBZAB");
var $h0syc = parcelRequire("h0syc");
var $5NFX3 = parcelRequire("5NFX3");
var $3QQ0o = parcelRequire("3QQ0o");
var $dWB6j = parcelRequire("dWB6j");

var $1Obsu = parcelRequire("1Obsu");

});
parcelRegister("3PiDw", function(module, exports) {

$parcel$export(module.exports, "CommentControls", function () { return (parcelRequire("cOb5F")).CommentControls; });
$parcel$export(module.exports, "PostControls", function () { return (parcelRequire("hBZAB")).PostControls; });
$parcel$export(module.exports, "SubscriptionControls", function () { return (parcelRequire("h0syc")).SubscriptionControls; });
$parcel$export(module.exports, "TipControls", function () { return (parcelRequire("5NFX3")).TipControls; });
$parcel$export(module.exports, "TrackControls", function () { return (parcelRequire("3QQ0o")).TrackControls; });
$parcel$export(module.exports, "UnlockControls", function () { return (parcelRequire("dWB6j")).UnlockControls; });

var $cOb5F = parcelRequire("cOb5F");

var $hBZAB = parcelRequire("hBZAB");

var $h0syc = parcelRequire("h0syc");

var $5NFX3 = parcelRequire("5NFX3");

var $3QQ0o = parcelRequire("3QQ0o");

var $dWB6j = parcelRequire("dWB6j");

});
parcelRegister("cOb5F", function(module, exports) {

$parcel$export(module.exports, "CommentControls", function () { return $29415ea62f131bf8$export$5106dd4e859a791e; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $5F6ta = parcelRequire("5F6ta");
parcelRequire("dmGpj");
var $lWbfW = parcelRequire("lWbfW");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("6NpFY");
var $iJDkE = parcelRequire("iJDkE");
const $29415ea62f131bf8$export$5106dd4e859a791e = ({ commentId: commentId, parentCommentId: parentCommentId })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    // comment
    const { comment: comment, isLoading: isLoading } = (0, $5F6ta.useComment)(commentId);
    // parent comment
    const { comment: parentComment, isLoading: parentCommentLoading } = (0, $5F6ta.useComment)(parentCommentId);
    const isReply = !!parentCommentId;
    const isDisabled = isLoading || !comment;
    const isParentDisabled = isDisabled || parentCommentLoading || !parentComment;
    // if reply
    if (isReply) // return comment and reply controls
    return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                appearance: "neutral",
                label: "navigate to comment",
                icon: (0, $9IIBp.icons).Scope,
                text: "View comment",
                disabled: isParentDisabled,
                onClick: ()=>{
                    // add parent comment to comment depth
                    dispatch((0, $lWbfW.commentAddDepth)({
                        comment: parentComment
                    }));
                    // navigate to post page
                    navigate(`${(0, $9YTSb.Path).Post}/${parentComment?.postId}`);
                }
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                appearance: "neutral",
                label: "navigate to reply",
                icon: (0, $9IIBp.icons).Scope,
                text: "View reply",
                disabled: isDisabled,
                onClick: ()=>{
                    // add parent comment to comment depth
                    dispatch((0, $lWbfW.commentAddDepth)({
                        comment: parentComment
                    }));
                    // add reply comment to comment depth
                    dispatch((0, $lWbfW.commentAddDepth)({
                        comment: comment
                    }));
                    // navigate to post page
                    navigate(`${(0, $9YTSb.Path).Post}/${comment?.postId}`);
                }
            })
        ]
    });
    // return comment controls
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
        appearance: "neutral",
        label: "navigate to comment page",
        icon: (0, $9IIBp.icons).Scope,
        text: "View comment",
        disabled: isDisabled,
        onClick: ()=>{
            // add comment to comment depth
            dispatch((0, $lWbfW.commentAddDepth)({
                comment: comment
            }));
            // navigate to post page
            navigate(`${(0, $9YTSb.Path).Post}/${comment?.postId}`);
        }
    });
};
$29415ea62f131bf8$export$5106dd4e859a791e.propTypes = {};

});
parcelRegister("6NpFY", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return (parcelRequire("iJDkE")).Control; });
$parcel$export(module.exports, "TipMessage", function () { return (parcelRequire("8mTvD")).TipMessage; });

var $iJDkE = parcelRequire("iJDkE");

var $8mTvD = parcelRequire("8mTvD");

});
parcelRegister("iJDkE", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return $9cbf1e9fd3046af1$export$7a7fa4424cb20976; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $65Zbu = parcelRequire("65Zbu");
const $9cbf1e9fd3046af1$export$7a7fa4424cb20976 = ({ appearance: appearance = "neutral", label: label, icon: Icon, text: text, disabled: disabled, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $65Zbu.styles)(theme).control.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
            css: [
                (0, $65Zbu.styles)(theme).control.content.main,
                appearance === "positive" && (0, $65Zbu.styles)(theme).control.content.positive,
                appearance === "negative" && (0, $65Zbu.styles)(theme).control.content.negative,
                appearance === "neutral" && (0, $65Zbu.styles)(theme).control.content.neutral,
                disabled && (0, $65Zbu.styles)(theme).control.content.disabled,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": label,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: [
                        (0, $65Zbu.styles)(theme).control.content.icon.main,
                        appearance === "positive" && (0, $65Zbu.styles)(theme).control.content.icon.positive,
                        appearance === "negative" && (0, $65Zbu.styles)(theme).control.content.icon.negative,
                        appearance === "neutral" && (0, $65Zbu.styles)(theme).control.content.icon.neutral,
                        disabled && (0, $65Zbu.styles)(theme).control.content.icon.disabled,
                        "",
                        ""
                    ],
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: [
                        (0, $65Zbu.styles)(theme).control.content.text.main,
                        appearance === "positive" && (0, $65Zbu.styles)(theme).control.content.text.positive,
                        appearance === "negative" && (0, $65Zbu.styles)(theme).control.content.text.negative,
                        appearance === "neutral" && (0, $65Zbu.styles)(theme).control.content.text.neutral,
                        disabled && (0, $65Zbu.styles)(theme).control.content.text.disabled,
                        "",
                        ""
                    ],
                    children: text
                })
            ]
        })
    });
};
$9cbf1e9fd3046af1$export$7a7fa4424cb20976.propTypes = {};

});
parcelRegister("65Zbu", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8bd284b44d8a4bfb$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8bd284b44d8a4bfb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8bd284b44d8a4bfb$var$_ref = {
    name: "a8rt8v",
    styles: "display:flex;margin-right:10px;&>svg{width:22px;height:22px;}&>svg>path{transition:fill 0.2s;}"
};
var $8bd284b44d8a4bfb$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
const $8bd284b44d8a4bfb$export$9dd6ff9ea0189349 = (theme)=>({
        control: {
            main: $8bd284b44d8a4bfb$var$_ref2,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;cursor:pointer;min-width:130px;", ""),
                positive: /*#__PURE__*/ (0, $4N3Qt.css)("&:hover{&>div>svg>path{fill:", theme.colors.positive.dark, ";}&>div{color:", theme.colors.positive.dark, ";}}", ""),
                negative: /*#__PURE__*/ (0, $4N3Qt.css)("&:hover{&>div>svg>path{fill:", theme.colors.negative.dark, ";}&>div{color:", theme.colors.negative.dark, ";}}", ""),
                neutral: /*#__PURE__*/ (0, $4N3Qt.css)("&:hover{&>div>svg>path{fill:", theme.colors.accent.normal, ";}&>div{color:", theme.colors.accent.normal, ";}}", ""),
                disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&:hover{&>div>svg>path{fill:", theme.colors.secondary.dark, ";}&>div{color:", theme.colors.secondary.dark, ";}}", ""),
                icon: {
                    main: $8bd284b44d8a4bfb$var$_ref,
                    positive: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.positive.normal, ";}", ""),
                    negative: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.negative.normal, ";}", ""),
                    neutral: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    disabled: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.secondary.dark, ";}", "")
                },
                text: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("white-space:nowrap;font-size:", (0, $48E0n.typography).p, ";text-decoration:underline;transition:color 0.2s;", ""),
                    positive: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.positive.normal, ";", ""),
                    negative: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.negative.normal, ";", ""),
                    neutral: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";", ""),
                    disabled: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.dark, ";", "")
                }
            }
        }
    });

});


parcelRegister("8mTvD", function(module, exports) {

$parcel$export(module.exports, "TipMessage", function () { return $26371e962849b790$export$7b0b0f20c484716f; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $j91DO = parcelRequire("j91DO");
const $26371e962849b790$export$7b0b0f20c484716f = ({ message: message })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("p", {
        css: (0, $j91DO.styles)(theme).message.main,
        children: [
            '"',
            message,
            '"'
        ]
    });
};
$26371e962849b790$export$7b0b0f20c484716f.propTypes = {};

});
parcelRegister("j91DO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $efbd7eac520500bb$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $efbd7eac520500bb$export$9dd6ff9ea0189349 = (theme)=>({
        message: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("word-break:break-all;color:", theme.colors.secondary.normal, ";font-size:", (0, $48E0n.typography).h6, ";", "")
        }
    });

});




parcelRegister("hBZAB", function(module, exports) {

$parcel$export(module.exports, "PostControls", function () { return $c03095d09e584ee9$export$8580fa483187194a; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $lBv1N = parcelRequire("lBv1N");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("6NpFY");
var $iJDkE = parcelRequire("iJDkE");
const $c03095d09e584ee9$export$8580fa483187194a = ({ postId: postId })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    // post
    const { post: post, isLoading: isLoading } = (0, $lBv1N.usePost)(postId);
    const isDisabled = isLoading || !post;
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
        appearance: "neutral",
        label: "navigate to post page",
        icon: (0, $9IIBp.icons).Scope,
        text: "View post",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`)
    });
};
$c03095d09e584ee9$export$8580fa483187194a.propTypes = {};

});

parcelRegister("h0syc", function(module, exports) {

$parcel$export(module.exports, "SubscriptionControls", function () { return $436fbee3df5158de$export$850f1baa8903d334; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("6NpFY");
var $iJDkE = parcelRequire("iJDkE");
const $436fbee3df5158de$export$850f1baa8903d334 = ({ event: event, subscription: subscription, isDisabled: isDisabled })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    // if notification event is subscription created
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionCreated) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {});
    // if notification event is subscription payment failed
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentFailed) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
        appearance: "neutral",
        label: "navigate to target user page",
        icon: (0, $9IIBp.icons).UserCircle,
        text: "View user",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${subscription?.targetUserId}`)
    });
    // if notification event is subscription payment succeeded
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
        appearance: "neutral",
        label: "navigate to target user page",
        icon: (0, $9IIBp.icons).UserCircle,
        text: "View user",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${subscription?.targetUserId}`)
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {});
};
$436fbee3df5158de$export$850f1baa8903d334.propTypes = {};

});

parcelRegister("5NFX3", function(module, exports) {

$parcel$export(module.exports, "TipControls", function () { return $62e1fb8961eab5e5$export$6a429fa6ff25b3d0; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $6VkZt = parcelRequire("6VkZt");
var $dcnhf = parcelRequire("dcnhf");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("6NpFY");
var $iJDkE = parcelRequire("iJDkE");
var $8mTvD = parcelRequire("8mTvD");
const $62e1fb8961eab5e5$export$6a429fa6ff25b3d0 = ({ event: event, tip: tip, isDisabled: isDisabled })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const notificationTipRetried = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationTipRetried));
    // if notification event is tip created
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipCreated) {
        // if tip message present
        if (tip?.message) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8mTvD.TipMessage), {
            message: tip?.message
        });
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {});
    }
    // if notification event is tip payment failed
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentFailed) {
        const isTipRetryDisabled = isDisabled || tip?.status !== (0, $aeAwZ.EntityTipStatus).Failed || notificationTipRetried;
        return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                    appearance: "neutral",
                    label: "navigate to target user page",
                    icon: (0, $9IIBp.icons).UserCircle,
                    text: "View user",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${tip?.targetUserId}`)
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                    appearance: "neutral",
                    label: "retry tip",
                    icon: (0, $9IIBp.icons).DollarCircle,
                    text: "Retry",
                    disabled: isTipRetryDisabled,
                    onClick: ()=>{
                        dispatch((0, $dcnhf.tipCreateTip)({
                            amount: (tip?.amount || 0) / 100,
                            message: tip?.message,
                            artistId: tip?.targetUserId || ""
                        }));
                    }
                })
            ]
        });
    }
    // if notification event is tip payment succeeded
    if (event === (0, $aeAwZ.EntityNotificationEvent).AppTipPaymentSucceeded) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
        appearance: "neutral",
        label: "navigate to target user page",
        icon: (0, $9IIBp.icons).UserCircle,
        text: "View user",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${tip?.targetUserId}`)
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {});
};
$62e1fb8961eab5e5$export$6a429fa6ff25b3d0.propTypes = {};

});

parcelRegister("3QQ0o", function(module, exports) {

$parcel$export(module.exports, "TrackControls", function () { return $ffee42a6736f2be9$export$3e7fab28a8882038; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $yKMRU = parcelRequire("yKMRU");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("6NpFY");
var $iJDkE = parcelRequire("iJDkE");
const $ffee42a6736f2be9$export$3e7fab28a8882038 = ({ trackId: trackId })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    // track
    const { track: track, isLoading: isLoading } = (0, $yKMRU.useTrack)(trackId);
    const isDisabled = isLoading || !track;
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
        appearance: "neutral",
        label: "play track",
        icon: (0, $9IIBp.icons).PlayCircleBold,
        text: "Play track",
        disabled: isDisabled,
        onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                track: track
            }))
    });
};
$ffee42a6736f2be9$export$3e7fab28a8882038.propTypes = {};

});

parcelRegister("dWB6j", function(module, exports) {

$parcel$export(module.exports, "UnlockControls", function () { return $ae4eb65edb900261$export$2f91fb6583916e4f; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $lBv1N = parcelRequire("lBv1N");
var $yKMRU = parcelRequire("yKMRU");
parcelRequire("dmGpj");
var $6VkZt = parcelRequire("6VkZt");
var $jhoVP = parcelRequire("jhoVP");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("6NpFY");
var $iJDkE = parcelRequire("iJDkE");
const $ae4eb65edb900261$export$2f91fb6583916e4f = ({ event: event, unlock: unlock, isDisabled: isDisabled })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const notificationUnlockRetried = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationUnlockRetried));
    const isTrackUnlock = unlock?.entityType === (0, $aeAwZ.EntityUnlockEntityType).Track;
    const isPostUnlock = unlock?.entityType === (0, $aeAwZ.EntityUnlockEntityType).Post;
    // unlock track
    const { track: track, isLoading: isTrackLoading } = (0, $yKMRU.useTrack)(isTrackUnlock ? unlock.entityId || "" : "");
    const isTrackControlDisabled = isTrackLoading || !track;
    // unlock post
    const { post: post, isLoading: isPostLoading } = (0, $lBv1N.usePost)(isPostUnlock ? unlock.entityId || "" : "");
    const isPostControlDisabled = isPostLoading || !post;
    // if unlock type is track
    if (unlock?.entityType === (0, $aeAwZ.EntityUnlockEntityType).Track) {
        // if notification event is track unlock created
        if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockCreated) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
            appearance: "neutral",
            label: "play track",
            icon: (0, $9IIBp.icons).PlayCircleBold,
            text: "Play track",
            disabled: isTrackControlDisabled,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                }))
        });
        // if notification event is track unlock payment failed
        if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentFailed) {
            const isUnlockRetryDisabled = isDisabled || isTrackControlDisabled || unlock?.status !== (0, $aeAwZ.EntityUnlockStatus).Failed || notificationUnlockRetried;
            return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                        appearance: "neutral",
                        label: "navigate to target user page",
                        icon: (0, $9IIBp.icons).UserCircle,
                        text: "View user",
                        disabled: isDisabled,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${unlock?.targetUserId}`)
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                        appearance: "neutral",
                        label: "retry track unlock",
                        icon: (0, $9IIBp.icons).DollarCircle,
                        text: "Retry",
                        disabled: isUnlockRetryDisabled,
                        onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                                track: track
                            }))
                    })
                ]
            });
        }
        // if notification event is track unlock payment succeeded
        if (event === (0, $aeAwZ.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                    appearance: "neutral",
                    label: "navigate to target user page",
                    icon: (0, $9IIBp.icons).UserCircle,
                    text: "View user",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${unlock?.targetUserId}`)
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                    appearance: "neutral",
                    label: "play track",
                    icon: (0, $9IIBp.icons).PlayCircleBold,
                    text: "Play track",
                    disabled: isTrackControlDisabled,
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                            track: track
                        }))
                })
            ]
        });
    }
    // if post unlock
    if (unlock?.entityType === (0, $aeAwZ.EntityUnlockEntityType).Post) {
        // if notification event is post unlock created
        if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockCreated) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
            appearance: "neutral",
            label: "navigate to post page",
            icon: (0, $9IIBp.icons).Scope,
            text: "View post",
            disabled: isDisabled,
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${unlock?.entityId}`)
        });
        // if notification event is post unlock payment failed
        if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentFailed) {
            const isUnlockRetryDisabled = isDisabled || isPostControlDisabled || unlock?.status !== (0, $aeAwZ.EntityUnlockStatus).Failed || notificationUnlockRetried;
            return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                        appearance: "neutral",
                        label: "navigate to target user page",
                        icon: (0, $9IIBp.icons).UserCircle,
                        text: "View user",
                        disabled: isDisabled,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${unlock?.targetUserId}`)
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                        appearance: "neutral",
                        label: "retry post unlock",
                        icon: (0, $9IIBp.icons).DollarCircle,
                        text: "Retry",
                        disabled: isUnlockRetryDisabled,
                        onClick: ()=>{
                            dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                                post: post
                            }));
                        }
                    })
                ]
            });
        }
        // if notification event is post unlock payment succeeded
        if (event === (0, $aeAwZ.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                    appearance: "neutral",
                    label: "navigate to target user page",
                    icon: (0, $9IIBp.icons).UserCircle,
                    text: "View user",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${unlock?.targetUserId}`)
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iJDkE.Control), {
                    appearance: "neutral",
                    label: "navigate to post page",
                    icon: (0, $9IIBp.icons).Scope,
                    text: "View post",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${unlock?.entityId}`)
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {});
};
$ae4eb65edb900261$export$2f91fb6583916e4f.propTypes = {};

});


parcelRegister("1Obsu", function(module, exports) {

$parcel$export(module.exports, "SourceUser", function () { return $621a542d2c25730e$export$fffa57a226281f84; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $lIOb1 = parcelRequire("lIOb1");
const $621a542d2c25730e$export$fffa57a226281f84 = ({ label: label, username: username, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
        css: (0, $lIOb1.styles)(theme).source.main,
        onClick: (e)=>onClick(e),
        type: "button",
        "aria-label": label,
        children: [
            "@",
            username
        ]
    });
};
$621a542d2c25730e$export$fffa57a226281f84.propTypes = {};

});
parcelRegister("lIOb1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a814be89e104b50c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $a814be89e104b50c$export$9dd6ff9ea0189349 = (theme)=>({
        source: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;word-break:break-all;color:", theme.colors.secondary.normal, ";font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
        }
    });

});



parcelRegister("lLkJO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b309173531478eae$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b309173531478eae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b309173531478eae$var$_ref = {
    name: "1ufrsmv",
    styles: "display:flex;flex-wrap:wrap;min-height:22px;&>div:not(:last-of-type){margin-right:16px;}"
};
var $b309173531478eae$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $b309173531478eae$var$_ref3 = {
    name: "1pbcbhk",
    styles: "max-width:800px;min-height:80px"
};
const $b309173531478eae$export$9dd6ff9ea0189349 = ()=>({
        view: {
            main: $b309173531478eae$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("&:not(:last-of-type){margin-bottom:10px;}", (0, $48E0n.mq).tablet($b309173531478eae$var$_ref2), ";", ""),
                identifier: /*#__PURE__*/ (0, $4N3Qt.css)("margin-bottom:16px;font-size:", (0, $48E0n.typography).h6, ";", ""),
                navigation: $b309173531478eae$var$_ref
            }
        }
    });

});



parcelRegister("6VkZt", function(module, exports) {

$parcel$export(module.exports, "notificationSlice", function () { return $ca37020a655b43c7$export$572e8dc57d3bd5f2; });
$parcel$export(module.exports, "notificationResetState", function () { return $ca37020a655b43c7$export$1f6a9f51115409e6; });
$parcel$export(module.exports, "notificationSetNotifications", function () { return $ca37020a655b43c7$export$14e5b8d882d13664; });
$parcel$export(module.exports, "notificationResetNotifications", function () { return $ca37020a655b43c7$export$53de810204552d28; });
$parcel$export(module.exports, "notificationSetNotificationsUnreadCount", function () { return $ca37020a655b43c7$export$a66b58f06a9e5432; });
$parcel$export(module.exports, "notificationSetNotification", function () { return $ca37020a655b43c7$export$5b89393bb7418c25; });
$parcel$export(module.exports, "notificationSetNotificationTipRetried", function () { return $ca37020a655b43c7$export$582446818c78df42; });
$parcel$export(module.exports, "notificationSetNotificationUnlockRetried", function () { return $ca37020a655b43c7$export$2c939389ab046c9; });
$parcel$export(module.exports, "notificationResetNotification", function () { return $ca37020a655b43c7$export$8981b508292c55ed; });
$parcel$export(module.exports, "notificationSetNotificationConfig", function () { return $ca37020a655b43c7$export$5bc685f8ce3e7467; });
$parcel$export(module.exports, "notificationSetNotificationsFilter", function () { return $ca37020a655b43c7$export$497199f322817fab; });
$parcel$export(module.exports, "notificationSelectNotifications", function () { return $ca37020a655b43c7$export$aadcc86a5d49f95c; });
$parcel$export(module.exports, "notificationSelectNotificationsLength", function () { return $ca37020a655b43c7$export$bac113b2128234e1; });
$parcel$export(module.exports, "notificationSelectNotificationsCount", function () { return $ca37020a655b43c7$export$21a43f80b2d9ea6f; });
$parcel$export(module.exports, "notificationSelectNotificationsFetched", function () { return $ca37020a655b43c7$export$3892c4159a4a8532; });
$parcel$export(module.exports, "notificationSelectNotificationsUnreadCount", function () { return $ca37020a655b43c7$export$ea4ea155cf365968; });
$parcel$export(module.exports, "notificationSelectNotification", function () { return $ca37020a655b43c7$export$3904e7f0a18f08e1; });
$parcel$export(module.exports, "notificationSelectNotificationFetched", function () { return $ca37020a655b43c7$export$4b12dc030489735d; });
$parcel$export(module.exports, "notificationSelectNotificationTipRetried", function () { return $ca37020a655b43c7$export$6d40f962e1e8580a; });
$parcel$export(module.exports, "notificationSelectNotificationUnlockRetried", function () { return $ca37020a655b43c7$export$654cd803729c5d0f; });
$parcel$export(module.exports, "notificationSelectNotificationConfig", function () { return $ca37020a655b43c7$export$2b747478b432f84b; });
$parcel$export(module.exports, "notificationSelectNotificationConfigFetched", function () { return $ca37020a655b43c7$export$947e5de144145b21; });
$parcel$export(module.exports, "notificationSelectNotificationsFilter", function () { return $ca37020a655b43c7$export$96b9b2fc6d95cee4; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationsLoading", function () { return $ca37020a655b43c7$export$104a48df097aa8d2; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationsUnreadCountLoading", function () { return $ca37020a655b43c7$export$2bbc3810a61d96d7; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationLoading", function () { return $ca37020a655b43c7$export$f73a84e5b85dacd3; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationConfigLoading", function () { return $ca37020a655b43c7$export$1f984d75920c93b7; });
$parcel$export(module.exports, "notificationSelectNotificationUpdateNotificationConfigLoading", function () { return $ca37020a655b43c7$export$a6f86ccd3f47ba2d; });
$parcel$export(module.exports, "notificationSelectNotificationReadNotificationsLoading", function () { return $ca37020a655b43c7$export$e4a345ae4781fb54; });
$parcel$export(module.exports, "notificationReducer", function () { return $ca37020a655b43c7$export$1e8c7d75bf62e791; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $uiU92 = parcelRequire("uiU92");
const $ca37020a655b43c7$var$initialState = {
    notifications: [],
    notificationsCount: 0,
    notificationsFetched: false,
    notificationsUnreadCount: 0,
    notification: undefined,
    notificationFetched: false,
    notificationTipRetried: false,
    notificationUnlockRetried: false,
    notificationConfig: undefined,
    notificationConfigFetched: false,
    notificationsFilter: undefined,
    notificationGetNotificationsLoading: false,
    notificationGetNotificationsUnreadCountLoading: false,
    notificationGetNotificationLoading: false,
    notificationGetNotificationConfigLoading: false,
    notificationUpdateNotificationConfigLoading: false,
    notificationReadNotificationsLoading: false
};
const $ca37020a655b43c7$export$572e8dc57d3bd5f2 = (0, $dEr3t.createSlice)({
    name: "notification",
    initialState: $ca37020a655b43c7$var$initialState,
    reducers: {
        // reset state
        notificationResetState: ()=>({
                notifications: [],
                notificationsCount: 0,
                notificationsFetched: false,
                notificationsUnreadCount: 0,
                notification: undefined,
                notificationFetched: false,
                notificationTipRetried: false,
                notificationUnlockRetried: false,
                notificationConfig: undefined,
                notificationConfigFetched: false,
                notificationsFilter: undefined,
                notificationGetNotificationsLoading: false,
                notificationGetNotificationsUnreadCountLoading: false,
                notificationGetNotificationLoading: false,
                notificationGetNotificationConfigLoading: false,
                notificationUpdateNotificationConfigLoading: false,
                notificationReadNotificationsLoading: false
            }),
        // set notifications
        notificationSetNotifications: (state, action)=>{
            const { notifications: notifications, count: count, offset: offset } = action.payload;
            // mutate count
            state.notificationsCount = count;
            // mutate notifications array
            state.notifications = (0, $9UVKd.mergeArraysAtIndex)(state.notifications, notifications, offset);
        },
        // reset notifications
        notificationResetNotifications: (state)=>({
                ...state,
                notifications: [],
                notificationsCount: 0,
                notificationsFetched: false
            }),
        // set notifications unread count
        notificationSetNotificationsUnreadCount: (state, action)=>{
            const { count: count } = action.payload;
            // update notifications unread count state
            state.notificationsUnreadCount = count;
        },
        // set notification
        notificationSetNotification: (state, action)=>{
            const { notification: notification } = action.payload;
            // update notification state
            state.notification = notification;
        },
        // set notification tip retried
        notificationSetNotificationTipRetried: (state)=>({
                ...state,
                notificationTipRetried: true
            }),
        // set notification unlock retried
        notificationSetNotificationUnlockRetried: (state)=>({
                ...state,
                notificationUnlockRetried: true
            }),
        // reset notification
        notificationResetNotification: (state)=>({
                ...state,
                notification: undefined,
                notificationFetched: false,
                notificationTipRetried: false,
                notificationUnlockRetried: false
            }),
        // set notification config
        notificationSetNotificationConfig: (state, action)=>{
            const { notificationConfig: notificationConfig } = action.payload;
            // update notification config state
            state.notificationConfig = notificationConfig;
        },
        // set notifications filter
        notificationSetNotificationsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup notifications
            state.notifications = [];
            state.notificationsCount = 0;
            // mutate notifications filter
            state.notificationsFilter = state.notificationsFilter === filter ? undefined : filter;
        }
    },
    extraReducers: (builder)=>{
        // get notifications
        builder.addCase((0, $uiU92.notificationGetNotifications).pending, (state)=>({
                ...state,
                notificationGetNotificationsLoading: true
            })).addCase((0, $uiU92.notificationGetNotifications).fulfilled, (state)=>({
                ...state,
                notificationsFetched: true,
                notificationGetNotificationsLoading: false
            }));
        // get notifications unread count
        builder.addCase((0, $uiU92.notificationGetNotificationsUnreadCount).pending, (state)=>({
                ...state,
                notificationGetNotificationsUnreadCountLoading: true
            })).addCase((0, $uiU92.notificationGetNotificationsUnreadCount).fulfilled, (state)=>({
                ...state,
                notificationGetNotificationsUnreadCountLoading: false
            }));
        // get notification
        builder.addCase((0, $uiU92.notificationGetNotification).pending, (state)=>({
                ...state,
                notificationGetNotificationLoading: true
            })).addCase((0, $uiU92.notificationGetNotification).fulfilled, (state)=>({
                ...state,
                notificationFetched: true,
                notificationGetNotificationLoading: false
            }));
        // get notifications config
        builder.addCase((0, $uiU92.notificationGetNotificationConfig).pending, (state)=>({
                ...state,
                notificationGetNotificationConfigLoading: true
            })).addCase((0, $uiU92.notificationGetNotificationConfig).fulfilled, (state)=>({
                ...state,
                notificationGetNotificationConfigLoading: false
            }));
        // update notifications config
        builder.addCase((0, $uiU92.notificationUpdateNotificationConfig).pending, (state)=>({
                ...state,
                notificationUpdateNotificationConfigLoading: true
            })).addCase((0, $uiU92.notificationUpdateNotificationConfig).fulfilled, (state)=>({
                ...state,
                notificationUpdateNotificationConfigLoading: false
            }));
        // read notifications
        builder.addCase((0, $uiU92.notificationReadNotifications).pending, (state)=>({
                ...state,
                notificationReadNotificationsLoading: true
            })).addCase((0, $uiU92.notificationReadNotifications).fulfilled, (state)=>({
                ...state,
                notificationReadNotificationsLoading: false
            }));
    }
});
const { notificationResetState: $ca37020a655b43c7$export$1f6a9f51115409e6, notificationSetNotifications: $ca37020a655b43c7$export$14e5b8d882d13664, notificationResetNotifications: $ca37020a655b43c7$export$53de810204552d28, notificationSetNotificationsUnreadCount: $ca37020a655b43c7$export$a66b58f06a9e5432, notificationSetNotification: $ca37020a655b43c7$export$5b89393bb7418c25, notificationSetNotificationTipRetried: $ca37020a655b43c7$export$582446818c78df42, notificationSetNotificationUnlockRetried: $ca37020a655b43c7$export$2c939389ab046c9, notificationResetNotification: $ca37020a655b43c7$export$8981b508292c55ed, notificationSetNotificationConfig: $ca37020a655b43c7$export$5bc685f8ce3e7467, notificationSetNotificationsFilter: $ca37020a655b43c7$export$497199f322817fab } = $ca37020a655b43c7$export$572e8dc57d3bd5f2.actions;
const $ca37020a655b43c7$export$aadcc86a5d49f95c = (state)=>state.notification.notifications;
const $ca37020a655b43c7$export$bac113b2128234e1 = (state)=>state.notification.notifications.length;
const $ca37020a655b43c7$export$21a43f80b2d9ea6f = (state)=>state.notification.notificationsCount;
const $ca37020a655b43c7$export$3892c4159a4a8532 = (state)=>state.notification.notificationsFetched;
const $ca37020a655b43c7$export$ea4ea155cf365968 = (state)=>state.notification.notificationsUnreadCount;
const $ca37020a655b43c7$export$3904e7f0a18f08e1 = (state)=>state.notification.notification;
const $ca37020a655b43c7$export$4b12dc030489735d = (state)=>state.notification.notificationFetched;
const $ca37020a655b43c7$export$6d40f962e1e8580a = (state)=>state.notification.notificationTipRetried;
const $ca37020a655b43c7$export$654cd803729c5d0f = (state)=>state.notification.notificationUnlockRetried;
const $ca37020a655b43c7$export$2b747478b432f84b = (state)=>state.notification.notificationConfig;
const $ca37020a655b43c7$export$947e5de144145b21 = (state)=>state.notification.notificationConfigFetched;
const $ca37020a655b43c7$export$96b9b2fc6d95cee4 = (state)=>state.notification.notificationsFilter;
const $ca37020a655b43c7$export$104a48df097aa8d2 = (state)=>state.notification.notificationGetNotificationsLoading;
const $ca37020a655b43c7$export$2bbc3810a61d96d7 = (state)=>state.notification.notificationGetNotificationsUnreadCountLoading;
const $ca37020a655b43c7$export$f73a84e5b85dacd3 = (state)=>state.notification.notificationGetNotificationLoading;
const $ca37020a655b43c7$export$1f984d75920c93b7 = (state)=>state.notification.notificationGetNotificationConfigLoading;
const $ca37020a655b43c7$export$a6f86ccd3f47ba2d = (state)=>state.notification.notificationUpdateNotificationConfigLoading;
const $ca37020a655b43c7$export$e4a345ae4781fb54 = (state)=>state.notification.notificationReadNotificationsLoading;
const $ca37020a655b43c7$export$1e8c7d75bf62e791 = $ca37020a655b43c7$export$572e8dc57d3bd5f2.reducer; // export default notificationSlice.reducer

});

parcelRegister("uiU92", function(module, exports) {

$parcel$export(module.exports, "notificationGetNotifications", function () { return $9b51e5027217f510$export$2198b65d0697d0b9; });
$parcel$export(module.exports, "notificationGetNotificationsUnreadCount", function () { return $9b51e5027217f510$export$9f63eafc05b4f789; });
$parcel$export(module.exports, "notificationGetNotification", function () { return $9b51e5027217f510$export$a2ff9aa993fbdd42; });
$parcel$export(module.exports, "notificationGetNotificationConfig", function () { return $9b51e5027217f510$export$fe8949cf20419680; });
$parcel$export(module.exports, "notificationUpdateNotificationConfig", function () { return $9b51e5027217f510$export$cb7731663c4ace95; });
$parcel$export(module.exports, "notificationReadNotification", function () { return $9b51e5027217f510$export$b23ffc7af13cdd30; });
$parcel$export(module.exports, "notificationReadNotifications", function () { return $9b51e5027217f510$export$7b28611e0695d6eb; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("dmGpj");
var $6VkZt = parcelRequire("6VkZt");
const $9b51e5027217f510$export$2198b65d0697d0b9 = (0, $dEr3t.createAsyncThunk)("notification/notificationGetNotifications", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get notifications filter
    const filter = getState().notification.notificationsFilter;
    // define entity type
    let entityType;
    // assert entity type
    switch(filter){
        case (0, $aeAwZ.EntityNotificationEntityType).User:
            entityType = "user";
            break;
        case (0, $aeAwZ.EntityNotificationEntityType).Track:
            entityType = "track";
            break;
        case (0, $aeAwZ.EntityNotificationEntityType).Post:
            entityType = "post";
            break;
        case (0, $aeAwZ.EntityNotificationEntityType).Comment:
            entityType = "comment";
            break;
        case (0, $aeAwZ.EntityNotificationEntityType).Tip:
            entityType = "tip";
            break;
        case (0, $aeAwZ.EntityNotificationEntityType).Unlock:
            entityType = "unlock";
            break;
        case (0, $aeAwZ.EntityNotificationEntityType).Subscription:
            entityType = "subscription";
            break;
        default:
            entityType = undefined;
    }
    try {
        // retrieve notifications
        const { notifications: notifications, count: count } = await api.notificationApi.getAppNotifications(entityType, inp.limit, inp.offset);
        // set notifications
        dispatch((0, $6VkZt.notificationSetNotifications)({
            notifications: notifications || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9b51e5027217f510$export$9f63eafc05b4f789 = (0, $dEr3t.createAsyncThunk)("notification/notificationGetNotificationsUnreadCount", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve notifications unread count
        const { count: count } = await api.notificationApi.getAppNotificationsUnreadCount();
        // set notifications unread count
        dispatch((0, $6VkZt.notificationSetNotificationsUnreadCount)({
            count: count || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9b51e5027217f510$export$a2ff9aa993fbdd42 = (0, $dEr3t.createAsyncThunk)("notification/notificationGetNotification", async ({ notificationId: notificationId }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve notification
        const { notification: notification } = await api.notificationApi.getAppNotification(notificationId);
        // set notification
        dispatch((0, $6VkZt.notificationSetNotification)({
            notification: notification || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9b51e5027217f510$export$fe8949cf20419680 = (0, $dEr3t.createAsyncThunk)("notification/notificationGetNotificationConfig", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get notification config
        const { notificationConfig: notificationConfig } = await api.notificationApi.getNotificationConfig();
        // set notification config
        dispatch((0, $6VkZt.notificationSetNotificationConfig)({
            notificationConfig: notificationConfig || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9b51e5027217f510$export$cb7731663c4ace95 = (0, $dEr3t.createAsyncThunk)("notification/notificationUpdateNotificationConfig", async ({ scope: scope }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // update notifications configuration
        const { notificationConfig: notificationConfig } = await api.notificationApi.updateNotificationConfig({
            scope: scope
        });
        // set notification config
        dispatch((0, $6VkZt.notificationSetNotificationConfig)({
            notificationConfig: notificationConfig || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9b51e5027217f510$export$b23ffc7af13cdd30 = (0, $dEr3t.createAsyncThunk)("notification/notificationReadNotification", async ({ notificationId: notificationId })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve notification
        await api.notificationApi.readAppNotification({
            notificationId: notificationId
        });
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9b51e5027217f510$export$7b28611e0695d6eb = (0, $dEr3t.createAsyncThunk)("notification/notificationReadNotifications", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve notification
        await api.notificationApi.readAppNotifications();
        // update notifications unread count
        dispatch($9b51e5027217f510$export$9f63eafc05b4f789());
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("goDss", function(module, exports) {

$parcel$export(module.exports, "Onboarding", function () { return (parcelRequire("5qhbt")).Onboarding; });
parcelRequire("8n9Di");
var $5qhbt = parcelRequire("5qhbt");

var $bLoEn = parcelRequire("bLoEn");

var $hIwjn = parcelRequire("hIwjn");
$parcel$exportWildcard(module.exports, $bLoEn);
$parcel$exportWildcard(module.exports, $hIwjn);

});
parcelRegister("8n9Di", function(module, exports) {

$parcel$export(module.exports, "Onboarding", function () { return (parcelRequire("5qhbt")).Onboarding; });

var $5qhbt = parcelRequire("5qhbt");

});
parcelRegister("5qhbt", function(module, exports) {

$parcel$export(module.exports, "Onboarding", function () { return $f12a5d7eb1b98c2b$export$70238cd3868b67c9; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $9kzze = parcelRequire("9kzze");
var $fAzHC = parcelRequire("fAzHC");
var $bLoEn = parcelRequire("bLoEn");
parcelRequire("fRVt8");
var $ewr9k = parcelRequire("ewr9k");
var $i2ajo = parcelRequire("i2ajo");
parcelRequire("lTgRL");
var $TEyW5 = parcelRequire("TEyW5");
var $upilA = parcelRequire("upilA");
var $92Q9V = parcelRequire("92Q9V");
var $4USRv = parcelRequire("4USRv");
var $4BGuF = parcelRequire("4BGuF");
var $7aw43 = parcelRequire("7aw43");
var $gkp9Q = parcelRequire("gkp9Q");
var $dcRPS = parcelRequire("dcRPS");

var $6DY4p = parcelRequire("6DY4p");

var $c8YN1 = parcelRequire("c8YN1");
const $f12a5d7eb1b98c2b$export$70238cd3868b67c9 = ()=>{
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const step = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectStep));
    const isProfileRoleSelected = !!profile?.role;
    const profileRole = profile?.role || "";
    const profileOnboardingStage = profile?.onboardingStage || "";
    const getCurrentStage = ()=>{
        const fanOnboardingStages = {
            [(0, $aeAwZ.EntityOnboardingStage).CreateProfile]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $92Q9V.CreateProfile), {}),
            [(0, $aeAwZ.EntityOnboardingStage).SelectGenres]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7aw43.SelectGenres), {}),
            [(0, $aeAwZ.EntityOnboardingStage).FollowArtists]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4BGuF.FollowArtists), {}),
            [(0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $upilA.ConfigureNotifications), {}),
            [(0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $TEyW5.AcceptTermsAndConditions), {})
        };
        const artistOnboardingStages = {
            [(0, $aeAwZ.EntityOnboardingStage).CreateProfile]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $92Q9V.CreateProfile), {}),
            [(0, $aeAwZ.EntityOnboardingStage).UploadTracks]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $dcRPS.UploadTracks), {}),
            [(0, $aeAwZ.EntityOnboardingStage).EnableMonetization]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4USRv.EnableMonetization), {}),
            [(0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $upilA.ConfigureNotifications), {}),
            [(0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions]: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $TEyW5.AcceptTermsAndConditions), {})
        };
        // if role is fan
        if (profileRole && profileRole === (0, $aeAwZ.EntityUserRole).Fan && profileOnboardingStage) // return appropriate stage for fan
        return fanOnboardingStages[profileOnboardingStage];
        // if role is artist
        if (profileRole && profileRole === (0, $aeAwZ.EntityUserRole).Artist && profileOnboardingStage) // return appropriate stage for artist
        return artistOnboardingStages[profileOnboardingStage];
        return null;
    };
    const renderOnboarding = ()=>{
        // get current onboarding stage
        const currentStage = getCurrentStage();
        // if role is not selected
        if (!isProfileRoleSelected) // return select role stage
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $c8YN1.styles)().onboarding.role,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gkp9Q.SelectRole), {})
        });
        // if role is selected and role is 'fan'
        if (isProfileRoleSelected && profileRole === (0, $aeAwZ.EntityUserRole).Fan && currentStage !== null) // return fan stage
        return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $c8YN1.styles)().onboarding.stage,
            children: [
                currentStage,
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i2ajo.Stepper), {
                    steps: (0, $6DY4p.fanOnboardingSteps),
                    currentStep: step
                })
            ]
        });
        // if role is selected and role is 'artist'
        if (isProfileRoleSelected && profileRole === (0, $aeAwZ.EntityUserRole).Artist && currentStage !== null) // return artist stage
        return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $c8YN1.styles)().onboarding.stage,
            children: [
                currentStage,
                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i2ajo.Stepper), {
                    steps: (0, $6DY4p.artistOnboardingSteps),
                    currentStep: step
                })
            ]
        });
        return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ewr9k.ErrorFallback), {});
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $c8YN1.styles)().onboarding.main,
        children: [
            renderOnboarding(),
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9kzze.AlertModal), {})
        ]
    });
};
$f12a5d7eb1b98c2b$export$70238cd3868b67c9.propTypes = {};

});
parcelRegister("lTgRL", function(module, exports) {

$parcel$export(module.exports, "AcceptTermsAndConditions", function () { return (parcelRequire("TEyW5")).AcceptTermsAndConditions; });
$parcel$export(module.exports, "ConfigureNotifications", function () { return (parcelRequire("upilA")).ConfigureNotifications; });
$parcel$export(module.exports, "CreateProfile", function () { return (parcelRequire("92Q9V")).CreateProfile; });
$parcel$export(module.exports, "EnableMonetization", function () { return (parcelRequire("4USRv")).EnableMonetization; });
$parcel$export(module.exports, "FollowArtists", function () { return (parcelRequire("4BGuF")).FollowArtists; });
$parcel$export(module.exports, "SelectGenres", function () { return (parcelRequire("7aw43")).SelectGenres; });
$parcel$export(module.exports, "SelectRole", function () { return (parcelRequire("gkp9Q")).SelectRole; });
$parcel$export(module.exports, "UploadTracks", function () { return (parcelRequire("dcRPS")).UploadTracks; });

var $TEyW5 = parcelRequire("TEyW5");

var $upilA = parcelRequire("upilA");

var $92Q9V = parcelRequire("92Q9V");

var $4USRv = parcelRequire("4USRv");

var $4BGuF = parcelRequire("4BGuF");

var $7aw43 = parcelRequire("7aw43");

var $gkp9Q = parcelRequire("gkp9Q");

var $dcRPS = parcelRequire("dcRPS");

});
parcelRegister("TEyW5", function(module, exports) {

$parcel$export(module.exports, "AcceptTermsAndConditions", function () { return $18e1f6235ffd7e7b$export$54b64605ce78aed1; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("2uUQU");
var $8YIJn = parcelRequire("8YIJn");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");
var $9TEV9 = parcelRequire("9TEV9");
var $jQTWV = parcelRequire("jQTWV");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("3pyke");
var $6dGJY = parcelRequire("6dGJY");

var $gOn6d = parcelRequire("gOn6d");
const $18e1f6235ffd7e7b$export$54b64605ce78aed1 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingError = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $gOn6d.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $gOn6d.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $hIwjn.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {
                        css: (0, $gOn6d.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $gOn6d.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gOn6d.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2eN72.Subtitle), {
                            text: "By continuing you agree to RYDDM terms and conditions",
                            link: {
                                linkStart: 33,
                                linkEnd: 53,
                                href: (0, $8YIJn.ExternalLinks).TermsOfUse
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gOn6d.styles)().stage.content.composition,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jQTWV.ImageComposition), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gOn6d.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6dGJY.Form), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gOn6d.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$18e1f6235ffd7e7b$export$54b64605ce78aed1.propTypes = {};

});
parcelRegister("3pyke", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("6dGJY")).Form; });

var $6dGJY = parcelRequire("6dGJY");

});
parcelRegister("6dGJY", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $def7b6debadf2f8e$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $i7Fdv = parcelRequire("i7Fdv");
const $def7b6debadf2f8e$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    const submitDisabled = onboardingLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $i7Fdv.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("form", {
            css: (0, $i7Fdv.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $hIwjn.onboardingSetNextStage)());
            },
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $i7Fdv.styles)().form.content.submit,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                    type: "submit",
                    "aria-label": "accept terms of use",
                    disabled: submitDisabled,
                    appearance: "primary",
                    children: onboardingLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                        width: 50,
                        height: 20,
                        appearance: "primary"
                    }) : "Continue"
                })
            })
        })
    });
};
$def7b6debadf2f8e$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("i7Fdv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7510fb23d16211c0$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7510fb23d16211c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7510fb23d16211c0$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7510fb23d16211c0$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7510fb23d16211c0$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7510fb23d16211c0$var$_ref4 = {
    name: "1u8bg7q",
    styles: "width:380px"
};
var $7510fb23d16211c0$var$_ref5 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $7510fb23d16211c0$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $7510fb23d16211c0$var$_ref5,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:510px;", (0, $48E0n.mq).tablet($7510fb23d16211c0$var$_ref4), " ", (0, $48E0n.mq).mobile($7510fb23d16211c0$var$_ref3), ";", ""),
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("align-self:center;", (0, $48E0n.mq).mobile($7510fb23d16211c0$var$_ref2), " &>button{width:380px;", (0, $48E0n.mq).mobile($7510fb23d16211c0$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("gOn6d", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $92f3a2e7688d598d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $92f3a2e7688d598d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $92f3a2e7688d598d$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $92f3a2e7688d598d$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $92f3a2e7688d598d$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $92f3a2e7688d598d$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $92f3a2e7688d598d$var$_ref5 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $92f3a2e7688d598d$var$_ref6 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $92f3a2e7688d598d$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $92f3a2e7688d598d$var$_ref6,
            backward: {
                button: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $92f3a2e7688d598d$var$_ref5
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:760px;", (0, $48E0n.mq).mobile($92f3a2e7688d598d$var$_ref4), ";", ""),
                title: $92f3a2e7688d598d$var$_ref3,
                composition: $92f3a2e7688d598d$var$_ref2,
                form: $92f3a2e7688d598d$var$_ref,
                error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("upilA", function(module, exports) {

$parcel$export(module.exports, "ConfigureNotifications", function () { return $4cb640508440b24a$export$491071bcdb2df82c; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");
var $9TEV9 = parcelRequire("9TEV9");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("4TWKm");
var $8KdNO = parcelRequire("8KdNO");

var $9MxL1 = parcelRequire("9MxL1");
const $4cb640508440b24a$export$491071bcdb2df82c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingError = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9MxL1.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9MxL1.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    onClick: ()=>dispatch((0, $hIwjn.onboardingSetPrevStage)()),
                    appearance: "secondary",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {
                        css: (0, $9MxL1.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $9MxL1.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9MxL1.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2eN72.Subtitle), {
                            text: "Customize notifications settings to match your preferences!"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9MxL1.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8KdNO.Form), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9MxL1.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$4cb640508440b24a$export$491071bcdb2df82c.propTypes = {};

});
parcelRegister("4TWKm", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("8KdNO")).Form; });

var $8KdNO = parcelRequire("8KdNO");

});
parcelRegister("8KdNO", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $8a7d573996655fa5$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $uiU92 = parcelRequire("uiU92");
var $6VkZt = parcelRequire("6VkZt");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $fLw4A = parcelRequire("fLw4A");
var $1sbY5 = parcelRequire("1sbY5");

var $1Sfeq = parcelRequire("1Sfeq");
const $8a7d573996655fa5$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    const notificationConfig = (0, $9CcOD.useAppSelector)((0, $6VkZt.notificationSelectNotificationConfig));
    const initialScope = notificationConfig?.scope;
    const [notificationConfigScope, setNotificationConfigScope] = (0, $exYeM.useState)((0, $aeAwZ.EntityNotificationConfigScope).Enabled);
    (0, $exYeM.useEffect)(()=>{
        // get notifications config
        dispatch((0, $uiU92.notificationGetNotificationConfig)());
        // update local state with initial scope
        if (initialScope) setNotificationConfigScope(initialScope);
    }, [
        dispatch,
        initialScope
    ]);
    const submitDisabled = onboardingLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $1Sfeq.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $1Sfeq.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $hIwjn.onboardingSetNextStage)());
                dispatch((0, $uiU92.notificationUpdateNotificationConfig)({
                    scope: notificationConfigScope
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $1Sfeq.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fLw4A.Checkbox), {
                            name: "notifications-enabled",
                            label: "enable all notifications",
                            checked: notificationConfigScope === (0, $aeAwZ.EntityNotificationConfigScope).Enabled,
                            onChange: ()=>{
                                setNotificationConfigScope((0, $aeAwZ.EntityNotificationConfigScope).Enabled);
                            }
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $1Sfeq.styles)().form.content.checkbox.label,
                            children: `I'd like to receive all notifications.`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $1Sfeq.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fLw4A.Checkbox), {
                            name: "notifications-custom",
                            label: "receive only important notifications",
                            checked: notificationConfigScope === (0, $aeAwZ.EntityNotificationConfigScope).Custom,
                            onChange: ()=>{
                                setNotificationConfigScope((0, $aeAwZ.EntityNotificationConfigScope).Custom);
                            }
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $1Sfeq.styles)().form.content.checkbox.label,
                            children: "I prefer to receive only important notifications."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $1Sfeq.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fLw4A.Checkbox), {
                            name: "notifications-disabled",
                            label: "do not receive any notifications",
                            checked: notificationConfigScope === (0, $aeAwZ.EntityNotificationConfigScope).Disabled,
                            onChange: ()=>{
                                setNotificationConfigScope((0, $aeAwZ.EntityNotificationConfigScope).Disabled);
                            }
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $1Sfeq.styles)().form.content.checkbox.label,
                            children: `I'd rather not receive notifications at the moment.`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $1Sfeq.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "configure notifications",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Next"
                    })
                })
            ]
        })
    });
};
$8a7d573996655fa5$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("1Sfeq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $dd4150b1d411b842$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $dd4150b1d411b842$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $dd4150b1d411b842$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $dd4150b1d411b842$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $dd4150b1d411b842$var$_ref3 = {
    name: "pgjgom",
    styles: "display:flex;align-items:center;justify-content:left;margin-bottom:24px"
};
var $dd4150b1d411b842$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $dd4150b1d411b842$var$_ref5 = {
    name: "1u8bg7q",
    styles: "width:380px"
};
var $dd4150b1d411b842$var$_ref6 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $dd4150b1d411b842$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $dd4150b1d411b842$var$_ref6,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:510px;", (0, $48E0n.mq).tablet($dd4150b1d411b842$var$_ref5), " ", (0, $48E0n.mq).mobile($dd4150b1d411b842$var$_ref4), ";", ""),
                checkbox: {
                    main: $dd4150b1d411b842$var$_ref3,
                    label: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;font-size:", (0, $48E0n.typography).h6, ";margin-left:16px;", "")
                },
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("align-self:center;margin-top:36px;", (0, $48E0n.mq).mobile($dd4150b1d411b842$var$_ref2), " &>button{width:380px;", (0, $48E0n.mq).mobile($dd4150b1d411b842$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("9MxL1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $faa96a785c4baeb1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $faa96a785c4baeb1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $faa96a785c4baeb1$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $faa96a785c4baeb1$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $faa96a785c4baeb1$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $faa96a785c4baeb1$var$_ref4 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $faa96a785c4baeb1$var$_ref5 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $faa96a785c4baeb1$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $faa96a785c4baeb1$var$_ref5,
            backward: {
                button: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $faa96a785c4baeb1$var$_ref4
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:760px;", (0, $48E0n.mq).mobile($faa96a785c4baeb1$var$_ref3), ";", ""),
                title: $faa96a785c4baeb1$var$_ref2,
                form: $faa96a785c4baeb1$var$_ref,
                error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("92Q9V", function(module, exports) {

$parcel$export(module.exports, "CreateProfile", function () { return $78ddc3bed6e08a86$export$50f914132f8ce5ba; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $2sNJT = parcelRequire("2sNJT");
var $bLoEn = parcelRequire("bLoEn");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");
var $9TEV9 = parcelRequire("9TEV9");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("dMKg0");
var $98rdT = parcelRequire("98rdT");

var $gqyJq = parcelRequire("gqyJq");
const $78ddc3bed6e08a86$export$50f914132f8ce5ba = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingError = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $gqyJq.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $gqyJq.styles)().stage.backward.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    css: (0, $gqyJq.styles)().stage.backward.button,
                    "aria-label": "sign out",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $2sNJT.authSignout)()),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).SignOut, {
                        css: (0, $gqyJq.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $gqyJq.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gqyJq.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2eN72.Subtitle), {
                            text: "Personalize your profile to make it uniquely yours!"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gqyJq.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $98rdT.Form), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gqyJq.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$78ddc3bed6e08a86$export$50f914132f8ce5ba.propTypes = {};

});
parcelRegister("dMKg0", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("98rdT")).Form; });

var $98rdT = parcelRequire("98rdT");

});
parcelRegister("98rdT", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $8f04237f83402061$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $bs6PN = parcelRequire("bs6PN");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $cHn6a = parcelRequire("cHn6a");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("cE4ky");
var $cwZGE = parcelRequire("cwZGE");

var $4zPB0 = parcelRequire("4zPB0");
const $8f04237f83402061$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const onboardingError = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectError));
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    // avatar state
    const userHasAvatar = !!profile?.avatarId;
    const profileAvatar = (0, $hrd7b.useFile)(profile?.avatarId || "");
    const [avatar, setAvatar] = (0, $exYeM.useState)(null);
    const [avatarPreview, setAvatarPreview] = (0, $exYeM.useState)(userHasAvatar ? profileAvatar : "");
    const fileInputRef = (0, $exYeM.useRef)(null);
    // name state
    const [name, setName] = (0, $exYeM.useState)(profile?.name || "");
    const [nameError, setNameError] = (0, $exYeM.useState)("");
    // username state
    const [username, setUsername] = (0, $exYeM.useState)(profile?.username || "");
    const [usernameError, setUsernameError] = (0, $exYeM.useState)("");
    const submitDisabled = name.length < (0, $bs6PN.minUserNameLength) || username.length < (0, $bs6PN.minUserUsernameLength) || nameError !== "" || usernameError !== "" || onboardingError !== "" || onboardingLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const onEditClick = ()=>{
        fileInputRef.current?.click();
        dispatch((0, $bLoEn.onboardingSetError)(""));
    };
    const onFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validateAvatarFile)(file);
            if (error) {
                dispatch((0, $bLoEn.onboardingSetError)(error));
                return;
            }
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
            // set file as a preview
            setAvatarPreview(URL.createObjectURL(file));
            // store file in state
            setAvatar(file);
        }
    };
    (0, $exYeM.useEffect)(()=>()=>{
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
        });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $4zPB0.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $4zPB0.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $hIwjn.onboardingUpdateProfile)({
                    name: name,
                    username: username,
                    avatar: avatar
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $4zPB0.styles)().form.content.avatar.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                            css: (0, $4zPB0.styles)().form.content.avatar.label,
                            htmlFor: "avatar",
                            children: [
                                "avatar",
                                /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                    css: (0, $4zPB0.styles)().form.content.avatar.input,
                                    name: "avatar",
                                    type: "file",
                                    id: "avatar",
                                    ref: fileInputRef,
                                    accept: "image/jpeg,image/webp,image/png",
                                    onChange: (e)=>onFileChange(e)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cwZGE.Avatar), {
                            onEditClick: ()=>onEditClick(),
                            source: avatarPreview
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4zPB0.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cHn6a.InputBar), {
                        name: "name",
                        label: "name",
                        type: "text",
                        placeholder: "Enter your name",
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $bs6PN.minUserNameLength),
                        max: (0, $bs6PN.maxUserNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $33ayT.validateName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                !profile?.username && // render username input if user has no username
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4zPB0.styles)().form.content.username,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cHn6a.InputBar), {
                        name: "username",
                        label: "username",
                        type: "text",
                        placeholder: "Enter your username",
                        value: username,
                        error: usernameError.length > 0,
                        errorMessage: usernameError,
                        min: (0, $bs6PN.minUserUsernameLength),
                        max: (0, $bs6PN.maxUserUsernameLength),
                        onChange: (e)=>{
                            setUsername(e.target.value);
                        },
                        onBlur: ()=>setUsernameError((0, $33ayT.validateUsername)(username)),
                        onFocus: ()=>{
                            setUsernameError("");
                            dispatch((0, $bLoEn.onboardingSetError)(""));
                        }
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4zPB0.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create profile",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Create"
                    })
                })
            ]
        })
    });
};
$8f04237f83402061$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("cE4ky", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("cwZGE")).Avatar; });

var $cwZGE = parcelRequire("cwZGE");

});
parcelRegister("cwZGE", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $612d63a767ed8a1f$export$e2255cf6045e8d47; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $dAQSl = parcelRequire("dAQSl");
const $612d63a767ed8a1f$export$e2255cf6045e8d47 = ({ source: source, onEditClick: onEditClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $dAQSl.styles)(theme).avatar.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dAQSl.styles)(theme).avatar.image.main,
                children: source ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $dAQSl.styles)(theme).avatar.image.content,
                    loading: "lazy",
                    width: "120px",
                    height: "120px",
                    src: source,
                    alt: "user avatar"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                    css: (0, $dAQSl.styles)(theme).avatar.image.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dAQSl.styles)(theme).avatar.edit.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $dAQSl.styles)(theme).avatar.edit.button,
                    onClick: (e)=>onEditClick(e),
                    type: "button",
                    "aria-label": "change user avatar",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Edit, {
                        css: (0, $dAQSl.styles)(theme).avatar.edit.icon
                    })
                })
            })
        ]
    });
};
$612d63a767ed8a1f$export$e2255cf6045e8d47.propTypes = {};

});
parcelRegister("dAQSl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8fa432c4b4179ec8$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8fa432c4b4179ec8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8fa432c4b4179ec8$var$_ref = {
    name: "eveydc",
    styles: "position:relative;width:120px;height:120px"
};
const $8fa432c4b4179ec8$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: $8fa432c4b4179ec8$var$_ref,
            image: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:120px;height:120px;background-color:", theme.colors.secondary.darker, ";border-radius:50%;overflow:hidden;", ""),
                content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            edit: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;bottom:4px;right:2px;width:36px;height:36px;border-radius:50%;overflow:hidden;transition:background-color 0.2s;background-color:", theme.colors.secondary.dark, ";&:hover{background-color:", theme.colors.secondary.darkHover, ";}", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:100%;cursor:pointer;", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:18px;height:18px;&>path{fill:", theme.colors.primary.normal, ";}", "")
            }
        }
    });

});



parcelRegister("4zPB0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $cb831254ce275e76$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $cb831254ce275e76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cb831254ce275e76$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $cb831254ce275e76$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $cb831254ce275e76$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $cb831254ce275e76$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $cb831254ce275e76$var$_ref5 = {
    name: "9tjjy6",
    styles: "display:flex;align-items:center;justify-content:center;margin-bottom:32px"
};
const $cb831254ce275e76$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                avatar: {
                    main: $cb831254ce275e76$var$_ref5,
                    label: $cb831254ce275e76$var$_ref4,
                    input: $cb831254ce275e76$var$_ref3
                },
                name: $cb831254ce275e76$var$_ref2,
                username: $cb831254ce275e76$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("gqyJq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8b7c72f2b033cb77$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8b7c72f2b033cb77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8b7c72f2b033cb77$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $8b7c72f2b033cb77$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $8b7c72f2b033cb77$var$_ref3 = {
    name: "i38kcj",
    styles: "display:flex;align-items:center;flex-direction:column"
};
var $8b7c72f2b033cb77$var$_ref4 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $8b7c72f2b033cb77$var$_ref5 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $8b7c72f2b033cb77$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $8b7c72f2b033cb77$var$_ref5,
            backward: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                icon: $8b7c72f2b033cb77$var$_ref4
            },
            content: {
                main: $8b7c72f2b033cb77$var$_ref3,
                title: $8b7c72f2b033cb77$var$_ref2,
                form: /*#__PURE__*/ (0, $4N3Qt.css)("margin-bottom:32px;width:380px;", (0, $48E0n.mq).mobile($8b7c72f2b033cb77$var$_ref), ";", ""),
                error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("4USRv", function(module, exports) {

$parcel$export(module.exports, "EnableMonetization", function () { return $ff7db8bf24870bde$export$6e396ef3fbeea87f; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");
var $9TEV9 = parcelRequire("9TEV9");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("l6MsE");
var $boOLA = parcelRequire("boOLA");
var $l8N4P = parcelRequire("l8N4P");

var $e4asN = parcelRequire("e4asN");
const $ff7db8bf24870bde$export$6e396ef3fbeea87f = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingError = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $e4asN.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $e4asN.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $hIwjn.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {
                        css: (0, $e4asN.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $e4asN.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e4asN.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2eN72.Subtitle), {
                            text: "Enable payouts by configuring your business account!"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e4asN.styles)().stage.content.features,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $boOLA.Features), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e4asN.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $l8N4P.Form), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e4asN.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$ff7db8bf24870bde$export$6e396ef3fbeea87f.propTypes = {};

});
parcelRegister("l6MsE", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return (parcelRequire("boOLA")).Features; });
$parcel$export(module.exports, "Form", function () { return (parcelRequire("l8N4P")).Form; });

var $boOLA = parcelRequire("boOLA");

var $l8N4P = parcelRequire("l8N4P");

});
parcelRegister("boOLA", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return $7ca2817d380594ec$export$617d79dae526d2cf; });

var $5o6z6 = parcelRequire("5o6z6");

var $iZDEU = parcelRequire("iZDEU");
parcelRequire("4fDbN");
var $fn9s0 = parcelRequire("fn9s0");

var $3pAYJ = parcelRequire("3pAYJ");
const $7ca2817d380594ec$export$617d79dae526d2cf = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $3pAYJ.styles)().features.main,
        children: (0, $iZDEU.monetizationFeatures).map((feature)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $fn9s0.Feature), {
                ...feature
            }, feature.id))
    });
$7ca2817d380594ec$export$617d79dae526d2cf.propTypes = {};

});
parcelRegister("iZDEU", function(module, exports) {

$parcel$export(module.exports, "monetizationFeatures", function () { return $54fdb056eef7782b$export$bed2e1e36bed53e1; });

var $hBScV = parcelRequire("hBScV");
const $54fdb056eef7782b$export$bed2e1e36bed53e1 = [
    {
        id: "218f6074-bcad-4c04-ad8c-cb0d25d612db",
        icon: (0, $hBScV.icons).Dollar,
        title: "Unlock Earnings",
        description: "Enable payouts by configuring your business account"
    },
    {
        id: "faaa776c-fb02-464f-b1dd-ba63b08fd5d4",
        icon: (0, $hBScV.icons).Stars,
        title: "Build Your Brand",
        description: "Unlock advanced profile controls and promote your brand"
    },
    {
        id: "69203fe8-5a0a-4a41-b2a7-8310701726ab",
        icon: (0, $hBScV.icons).Rocket,
        title: "Maximize Your Potential",
        description: "Fans are eagerly anticipating your incredible content"
    }
];

});
parcelRegister("hBScV", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $bea7ff11007be011$export$df03f54e09e486fa; });

var $588dZ = parcelRequire("588dZ");

var $dDegB = parcelRequire("dDegB");

var $9n6Pd = parcelRequire("9n6Pd");
const $bea7ff11007be011$export$df03f54e09e486fa = {
    Dollar: $588dZ.default,
    Rocket: $dDegB.default,
    Stars: $9n6Pd.default
};

});
parcelRegister("588dZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2444e1270086712$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $d2444e1270086712$var$SvgDollar = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 7.667C13.187 7.667 7.665 13.188 7.665 20c0 6.811 5.522 12.333 12.333 12.333 6.812 0 12.334-5.521 12.334-12.333S26.81 7.667 19.999 7.667ZM5.665 20c0-7.916 6.417-14.333 14.333-14.333S34.333 12.084 34.333 20s-6.418 14.333-14.334 14.333c-7.916 0-14.333-6.417-14.333-14.333Zm14.333-9a1 1 0 0 1 1 1v.422c2.174.39 4 2.023 4 4.245a1 1 0 1 1-2 0c0-1.126-1.164-2.334-3-2.334-1.835 0-3 1.208-3 2.334C17 17.792 18.164 19 20 19c2.583 0 5 1.777 5 4.333 0 2.222-1.826 3.855-4 4.245V28a1 1 0 0 1-2 0v-.422c-2.174-.39-4-2.023-4-4.245a1 1 0 0 1 2 0c0 1.126 1.165 2.334 3 2.334 1.836 0 3-1.208 3-2.334C23 22.208 21.835 21 20 21c-2.583 0-5-1.777-5-4.333 0-2.222 1.826-3.856 4-4.245V12a1 1 0 0 1 1-1Z",
            fill: "#FFF"
        })
    });
var $d2444e1270086712$export$2e2bcd8739ae039 = $d2444e1270086712$var$SvgDollar;

});

parcelRegister("dDegB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a747885a17c5ec17$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $a747885a17c5ec17$var$SvgRocket = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M8.003 20.475a1 1 0 0 1 0 1.415l-.206.204a.447.447 0 0 0 0 .633.451.451 0 0 0 .638 0l2.255-2.253a1 1 0 0 1 1.414 1.416l-2.256 2.252a2.451 2.451 0 0 1-3.464 0 2.447 2.447 0 0 1 0-3.463l.205-.204a1 1 0 0 1 1.414 0ZM14.475 21.804a1 1 0 0 1 0 1.414l-2.822 2.822a1 1 0 1 1-1.414-1.414l2.822-2.822a1 1 0 0 1 1.414 0ZM18.176 25.5a1 1 0 0 1 0 1.414l-2.803 2.804a1 1 0 0 1-1.414-1.415l2.803-2.803a1 1 0 0 1 1.414 0ZM13.962 26.028a1 1 0 0 1-.015 1.414l-2.28 2.23a1 1 0 0 1-1.398-1.43l2.28-2.23a1 1 0 0 1 1.413.016ZM19.474 27.901a1 1 0 0 1 0 1.415l-2.256 2.253a.447.447 0 0 0 0 .633.451.451 0 0 0 .637 0l.205-.205a1 1 0 1 1 1.414 1.415l-.206.205a2.451 2.451 0 0 1-3.463 0 2.447 2.447 0 0 1 0-3.463L18.06 27.9a1 1 0 0 1 1.415 0Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.989 5.667h.905c1.005 0 1.857 0 2.538.09.723.098 1.4.314 1.946.858.548.545.766 1.22.863 1.943.092.678.092 1.528.092 2.528v.903c0 1.201.001 2.081-.334 2.887s-.96 1.427-1.814 2.276l-.126.126-3.022 3.009.053.08c.454.702.826 1.276 1.096 1.773.28.517.485 1.01.567 1.56.13.874.012 1.773-.333 2.597-.131.314-.355.638-.578.924-.234.302-.52.63-.825.962a66.971 66.971 0 0 1-1.977 2.025l-.01.01-.097.096c-.9.896-2.459.608-2.94-.598-.265-.664-.369-.92-.498-1.154a4.607 4.607 0 0 0-.414-.627c-.163-.207-.354-.4-.845-.89l-.564-.493a2.68 2.68 0 0 1-.287.015c-.772 0-1.404-.323-1.985-.765-.546-.414-1.15-1.015-1.86-1.723l-1.688-1.68c-.71-.708-1.313-1.309-1.73-1.852-.444-.58-.77-1.21-.77-1.983 0-.116.008-.23.022-.343l-.916-.913c-.057-.056-.078-.078-.1-.098a4.634 4.634 0 0 0-1.462-.958l-.13-.052-.44-.174a1.885 1.885 0 0 1-.638-3.09l.01-.009c.643-.64 1.37-1.365 2.034-1.97.333-.303.662-.587.965-.82.288-.222.612-.445.927-.575a4.925 4.925 0 0 1 2.602-.33c.55.08 1.044.283 1.563.563.499.268 1.075.639 1.78 1.091l.087.057 3.026-3.014.126-.125c.853-.851 1.477-1.472 2.285-1.806.807-.333 1.688-.332 2.896-.331Zm-.4 16.062c.375.58.644 1.005.84 1.365.22.407.31.669.345.9a2.878 2.878 0 0 1-.2 1.532c-.024.06-.113.212-.312.469-.186.24-.43.522-.717.834-.54.588-1.19 1.239-1.81 1.856-.184-.459-.319-.78-.487-1.086a6.608 6.608 0 0 0-.593-.898c-.25-.319-.537-.604-.986-1.05l-.048-.05c.045-.037.09-.074.135-.113.439-.38.931-.87 1.497-1.433l2.336-2.326Zm.578-14.062c-1.463 0-1.917.017-2.312.18-.395.163-.727.47-1.762 1.5L17.311 16.1c-.58.577-1.014 1.01-1.34 1.383-.33.374-.487.62-.561.804a.716.716 0 0 0-.058.277c0 .157.05.365.357.766.326.424.831.93 1.602 1.699l.09.09 1.685-1.677a1 1 0 1 1 1.411 1.417L18.82 22.53l.085.085c.771.768 1.28 1.271 1.706 1.595.403.306.613.357.775.357a.718.718 0 0 0 .256-.048c.182-.067.427-.217.808-.545.38-.327.822-.767 1.416-1.36l6.782-6.753c1.035-1.03 1.342-1.361 1.505-1.753.163-.39.18-.84.18-2.297v-.657c0-1.086-.002-1.8-.073-2.328-.067-.5-.18-.682-.292-.794-.113-.112-.297-.225-.8-.292-.533-.071-1.25-.073-2.34-.073h-.66Zm.295 3.843a3.26 3.26 0 0 0-4.597 0 3.237 3.237 0 0 0 0 4.59 3.26 3.26 0 0 0 4.598 0 3.237 3.237 0 0 0 0-4.59Zm-3.186 1.418a1.26 1.26 0 0 1 1.775 0c.488.485.488 1.27 0 1.755a1.26 1.26 0 0 1-1.775 0 1.237 1.237 0 0 1 0-1.755Zm-7.071-.54a22.291 22.291 0 0 0-1.364-.832c-.41-.22-.673-.311-.907-.346a2.925 2.925 0 0 0-1.545.2c-.061.025-.215.113-.472.311-.242.186-.525.43-.838.715a61.152 61.152 0 0 0-1.855 1.794l.278.11.007.003.149.06c.778.32 1.488.785 2.092 1.37l.114.114.454.45.149-.173c.376-.429.858-.909 1.411-1.46l2.327-2.316Z",
                fill: "#FFF"
            })
        ]
    });
var $a747885a17c5ec17$export$2e2bcd8739ae039 = $a747885a17c5ec17$var$SvgRocket;

});

parcelRegister("9n6Pd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e94867cc3417a8a5$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $e94867cc3417a8a5$var$SvgStars = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.307 6.537a.667.667 0 0 0-1.309.005v.002l-.003.013a4.904 4.904 0 0 1-.06.269 9.152 9.152 0 0 1-.204.708c-.193.58-.456 1.147-.758 1.45-.301.304-.867.571-1.445.768a9.141 9.141 0 0 1-.976.271l-.012.003h-.003a.667.667 0 0 0 .005 1.309h.002l.013.003a4.518 4.518 0 0 1 .269.06c.182.045.434.113.708.204.58.194 1.147.456 1.45.758.304.302.571.868.768 1.445a9.146 9.146 0 0 1 .271.976l.003.013v.002a.667.667 0 0 0 1.309-.004v-.003l.003-.012.012-.056a9.131 9.131 0 0 1 .253-.922c.193-.579.455-1.147.757-1.45.302-.304.868-.57 1.445-.768a9.118 9.118 0 0 1 .976-.27l.013-.003h.002a.667.667 0 0 0-.004-1.31h-.003l-.012-.003a9.141 9.141 0 0 1-.978-.265c-.579-.192-1.147-.455-1.45-.757-.304-.301-.57-.867-.768-1.445a9.113 9.113 0 0 1-.27-.976l-.003-.012v-.003Zm1.221 4.123c-.404-.19-.81-.433-1.119-.74-.31-.309-.556-.712-.749-1.115-.19.404-.433.81-.74 1.12-.309.31-.712.556-1.115.748.404.19.81.433 1.12.741.31.308.556.712.748 1.114.19-.404.433-.81.741-1.119.308-.31.712-.556 1.114-.749ZM29.333 8.333a1 1 0 0 1 1 1v.334h.334a1 1 0 0 1 0 2h-.334V12a1 1 0 1 1-2 0v-.333H28a1 1 0 1 1 0-2h.333v-.334a1 1 0 0 1 1-1Zm-9.35 3.907c-.438.572-.935 1.46-1.67 2.776l-.37.667-.072.128c-.335.603-.638 1.148-1.127 1.52-.496.377-1.1.512-1.752.658l-.139.031-.72.164c-1.429.323-2.383.541-3.032.797-.631.25-.716.434-.748.537-.035.113-.064.335.314.936.386.613 1.039 1.38 2.01 2.517l.492.575.092.106c.45.524.85.992 1.035 1.584.183.589.122 1.206.053 1.906l-.014.142-.074.767c-.147 1.515-.244 2.542-.211 3.277.032.735.186.883.257.937.055.042.202.15.858-.039.67-.192 1.566-.6 2.902-1.216l.676-.311.132-.061c.607-.281 1.173-.543 1.792-.543s1.184.262 1.791.543l.133.06.675.312c1.337.615 2.232 1.024 2.902 1.216.657.188.803.08.858.04.071-.055.225-.203.258-.938.033-.735-.065-1.762-.211-3.277l-.075-.767-.014-.142c-.069-.7-.13-1.317.054-1.905.184-.593.585-1.06 1.035-1.585l.091-.106.492-.575c.972-1.137 1.625-1.904 2.01-2.517.379-.6.35-.823.314-.936-.032-.103-.117-.288-.747-.537-.65-.256-1.604-.474-3.032-.797l-.721-.164a78.83 78.83 0 0 0-.139-.03c-.653-.147-1.256-.282-1.751-.659-.49-.372-.793-.917-1.128-1.52l-.071-.128-.371-.667c-.734-1.316-1.232-2.204-1.67-2.776-.438-.57-.626-.573-.683-.573-.057 0-.246.002-.684.573Zm-1.588-1.216c.549-.716 1.256-1.357 2.272-1.357 1.016 0 1.722.641 2.27 1.357.538.702 1.106 1.72 1.79 2.946l.41.739c.452.81.55.944.662 1.03.106.08.244.132 1.122.33l.804.183c1.323.299 2.43.55 3.241.869.846.333 1.624.84 1.924 1.803.296.953-.043 1.82-.531 2.596-.473.751-1.225 1.63-2.13 2.689l-.545.636c-.594.695-.69.837-.736.985-.048.153-.049.336.041 1.261l.082.847c.137 1.415.25 2.585.21 3.48-.04.913-.248 1.835-1.046 2.44-.813.618-1.753.539-2.618.29-.835-.238-1.871-.716-3.11-1.286l-.753-.347c-.826-.38-.965-.42-1.087-.42-.123 0-.262.04-1.088.42l-.753.347c-1.239.57-2.274 1.048-3.11 1.287-.865.248-1.805.327-2.618-.29-.797-.606-1.006-1.528-1.046-2.442-.04-.894.073-2.064.21-3.479l.082-.847c.09-.925.09-1.108.042-1.26-.046-.15-.143-.29-.737-.986l-.544-.636c-.906-1.059-1.658-1.938-2.13-2.69-.49-.776-.828-1.642-.531-2.595.3-.964 1.077-1.47 1.923-1.803.81-.32 1.918-.57 3.241-.87l.804-.181c.878-.199 1.017-.252 1.122-.332.112-.085.21-.22.661-1.03l.412-.738c.684-1.226 1.25-2.244 1.788-2.946Z",
            fill: "#FFF"
        })
    });
var $e94867cc3417a8a5$export$2e2bcd8739ae039 = $e94867cc3417a8a5$var$SvgStars;

});



parcelRegister("4fDbN", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return (parcelRequire("fn9s0")).Feature; });

var $fn9s0 = parcelRequire("fn9s0");

});
parcelRegister("fn9s0", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $3d5fa1e41b01e8f1$export$6e91cf7616333d5; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $22MpM = parcelRequire("22MpM");
const $3d5fa1e41b01e8f1$export$6e91cf7616333d5 = ({ icon: Icon, title: title, description: description })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $22MpM.styles)(theme).feature.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $22MpM.styles)(theme).feature.icon,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $22MpM.styles)(theme).feature.title,
                children: title
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $22MpM.styles)(theme).feature.description,
                children: description
            })
        ]
    });
};
$3d5fa1e41b01e8f1$export$6e91cf7616333d5.propTypes = {};

});
parcelRegister("22MpM", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b8e7c0b29f62842c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b8e7c0b29f62842c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b8e7c0b29f62842c$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $b8e7c0b29f62842c$export$9dd6ff9ea0189349 = (theme)=>({
        feature: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("text-align:center;width:228px;padding:0px 1px;", (0, $48E0n.mq).mobile($b8e7c0b29f62842c$var$_ref), ";", ""),
            icon: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            title: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;margin-bottom:8px;", ""),
            description: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";", "")
        }
    });

});



parcelRegister("3pAYJ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e3fdf14713e92460$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e3fdf14713e92460$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e3fdf14713e92460$var$_ref = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
const $e3fdf14713e92460$export$9dd6ff9ea0189349 = ()=>({
        features: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:space-between;flex-wrap:wrap;&>div:not(:last-of-type){margin-bottom:32px;}", (0, $48E0n.mq).tablet($e3fdf14713e92460$var$_ref), ";", "")
        }
    });

});


parcelRegister("l8N4P", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $3e771a0d5998c03e$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $hIwjn = parcelRequire("hIwjn");
var $bLoEn = parcelRequire("bLoEn");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $dBeAh = parcelRequire("dBeAh");
const $3e771a0d5998c03e$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    const onboardingConnectLink = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectConnectLink));
    const submitDisabled = onboardingLoading;
    (0, $exYeM.useEffect)(()=>{
        dispatch((0, $hIwjn.onboardingGetConnectLink)());
    }, [
        dispatch
    ]);
    const onEnableClick = ()=>{
        const newWindow = window.open(onboardingConnectLink, "_self", // '_blank'
        "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $dBeAh.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $dBeAh.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $hIwjn.onboardingSetNextStage)());
            },
            children: [
                onboardingConnectLink && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $dBeAh.styles)().form.content.enable,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "button",
                        onClick: ()=>onEnableClick(),
                        "aria-label": "enable monetization",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: "Enable"
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $dBeAh.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "proceed to next onboarding stage",
                        disabled: submitDisabled,
                        appearance: "secondary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Next"
                    })
                })
            ]
        })
    });
};
$3e771a0d5998c03e$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("dBeAh", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $032a54ed25553b58$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $032a54ed25553b58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $032a54ed25553b58$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $032a54ed25553b58$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $032a54ed25553b58$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $032a54ed25553b58$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $032a54ed25553b58$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $032a54ed25553b58$var$_ref6 = {
    name: "1u8bg7q",
    styles: "width:380px"
};
var $032a54ed25553b58$var$_ref7 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $032a54ed25553b58$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $032a54ed25553b58$var$_ref7,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:510px;", (0, $48E0n.mq).tablet($032a54ed25553b58$var$_ref6), " ", (0, $48E0n.mq).mobile($032a54ed25553b58$var$_ref5), ";", ""),
                enable: /*#__PURE__*/ (0, $4N3Qt.css)("align-self:center;margin-bottom:20px;", (0, $48E0n.mq).mobile($032a54ed25553b58$var$_ref4), " &>button{width:380px;", (0, $48E0n.mq).mobile($032a54ed25553b58$var$_ref3), ";}", ""),
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("align-self:center;", (0, $48E0n.mq).mobile($032a54ed25553b58$var$_ref2), " &>button{width:380px;", (0, $48E0n.mq).mobile($032a54ed25553b58$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("e4asN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5d3256daf0e3301e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $5d3256daf0e3301e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5d3256daf0e3301e$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $5d3256daf0e3301e$var$_ref2 = {
    name: "qu9742",
    styles: "margin-bottom:100px"
};
var $5d3256daf0e3301e$var$_ref3 = {
    name: "qu9742",
    styles: "margin-bottom:100px"
};
var $5d3256daf0e3301e$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $5d3256daf0e3301e$var$_ref5 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $5d3256daf0e3301e$var$_ref6 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $5d3256daf0e3301e$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $5d3256daf0e3301e$var$_ref6,
            backward: {
                button: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $5d3256daf0e3301e$var$_ref5
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:760px;", (0, $48E0n.mq).mobile($5d3256daf0e3301e$var$_ref4), ";", ""),
                title: $5d3256daf0e3301e$var$_ref3,
                features: $5d3256daf0e3301e$var$_ref2,
                form: $5d3256daf0e3301e$var$_ref,
                error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("4BGuF", function(module, exports) {

$parcel$export(module.exports, "FollowArtists", function () { return $7d1da7d74f4baed7$export$c75212fe28cc57d5; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $goTxv = parcelRequire("goTxv");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");
var $9TEV9 = parcelRequire("9TEV9");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("cOJTf");
var $fOBGe = parcelRequire("fOBGe");

var $3XRhd = parcelRequire("3XRhd");
const $7d1da7d74f4baed7$export$c75212fe28cc57d5 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingError = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $3XRhd.styles)(theme).stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $3XRhd.styles)(theme).stage.backward.button,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $hIwjn.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {
                        css: (0, $3XRhd.styles)(theme).stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $3XRhd.styles)(theme).stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3XRhd.styles)(theme).stage.content.title,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2eN72.Subtitle), {
                            text: "Go ahead and follow the artists we think you'll like!"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $3XRhd.styles)(theme).stage.content.artists.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $3XRhd.styles)(theme).stage.content.artists.overlay.top
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $goTxv.ArtistListOnboardingRecommended), {}),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $3XRhd.styles)(theme).stage.content.artists.overlay.bot
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3XRhd.styles)(theme).stage.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fOBGe.Form), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3XRhd.styles)(theme).stage.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$7d1da7d74f4baed7$export$c75212fe28cc57d5.propTypes = {};

});
parcelRegister("cOJTf", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("fOBGe")).Form; });

var $fOBGe = parcelRequire("fOBGe");

});
parcelRegister("fOBGe", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $4d65c0ef87bfaf27$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $cmxJ7 = parcelRequire("cmxJ7");
const $4d65c0ef87bfaf27$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    const submitDisabled = onboardingLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cmxJ7.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("form", {
            css: (0, $cmxJ7.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $hIwjn.onboardingSetNextStage)());
            },
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $cmxJ7.styles)().form.content.submit,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                    type: "submit",
                    "aria-label": "follow artists",
                    disabled: submitDisabled,
                    appearance: "primary",
                    children: onboardingLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                        width: 50,
                        height: 20,
                        appearance: "primary"
                    }) : "Next"
                })
            })
        })
    });
};
$4d65c0ef87bfaf27$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("cmxJ7", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ffeb5038546d6b6d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ffeb5038546d6b6d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ffeb5038546d6b6d$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ffeb5038546d6b6d$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ffeb5038546d6b6d$var$_ref3 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $ffeb5038546d6b6d$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: $ffeb5038546d6b6d$var$_ref3,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($ffeb5038546d6b6d$var$_ref2), " &>button{width:380px;", (0, $48E0n.mq).mobile($ffeb5038546d6b6d$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("3XRhd", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $51e0207713f453cb$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $51e0207713f453cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $51e0207713f453cb$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $51e0207713f453cb$var$_ref2 = {
    name: "fbo2gl",
    styles: "display:flex;flex-direction:column;align-items:center;position:relative;margin-bottom:50px"
};
var $51e0207713f453cb$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $51e0207713f453cb$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $51e0207713f453cb$var$_ref5 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $51e0207713f453cb$var$_ref6 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $51e0207713f453cb$export$9dd6ff9ea0189349 = (theme)=>({
        stage: {
            main: $51e0207713f453cb$var$_ref6,
            backward: {
                button: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $51e0207713f453cb$var$_ref5
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:760px;", (0, $48E0n.mq).mobile($51e0207713f453cb$var$_ref4), ";", ""),
                title: $51e0207713f453cb$var$_ref3,
                artists: {
                    main: $51e0207713f453cb$var$_ref2,
                    overlay: {
                        top: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.followArtists.overlay, ";position:absolute;left:0;top:0;width:100%;height:60px;background:linear-gradient(\n              180deg,\n              ", theme.colors.primary.normal, " 0%,\n              ", theme.colors.primary.normal, "00 75.79%\n            );", ""),
                        bot: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.followArtists.overlay, ";position:absolute;left:0;bottom:0;width:100%;height:60px;background:linear-gradient(\n              180deg,\n              ", theme.colors.primary.normal, "00 25.21%,\n              ", theme.colors.primary.normal, " 100%\n            );", "")
                    }
                },
                form: $51e0207713f453cb$var$_ref,
                error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("7aw43", function(module, exports) {

$parcel$export(module.exports, "SelectGenres", function () { return $3844604a2faaeab0$export$9620f4783b9264db; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");
var $9TEV9 = parcelRequire("9TEV9");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("9RoVQ");
var $bNcCK = parcelRequire("bNcCK");

var $17Vk9 = parcelRequire("17Vk9");
const $3844604a2faaeab0$export$9620f4783b9264db = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingError = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectError));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $17Vk9.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $17Vk9.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $hIwjn.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {
                        css: (0, $17Vk9.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $17Vk9.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $17Vk9.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2eN72.Subtitle), {
                            text: "Pick the top three music genres you enjoy the most!"
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $17Vk9.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bNcCK.Form), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $17Vk9.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$3844604a2faaeab0$export$9620f4783b9264db.propTypes = {};

});
parcelRegister("9RoVQ", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("bNcCK")).Form; });

var $bNcCK = parcelRequire("bNcCK");

});
parcelRegister("bNcCK", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $c96e18a76fa88ca7$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $jQMGL = parcelRequire("jQMGL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("gFBZu");
var $4uIFk = parcelRequire("4uIFk");

var $cj0ht = parcelRequire("cj0ht");
const $c96e18a76fa88ca7$export$a7fed597f4b8afd8 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const [selectedGenres, setSelectedGenres] = (0, $exYeM.useState)(profile?.preferredGenres || []);
    const submitDisabled = selectedGenres.length <= 0 || selectedGenres.length > (0, $jQMGL.maxUserPreferredGenresCount) || onboardingLoading;
    const onGenreClick = (selected, genre)=>{
        if (selected) setSelectedGenres((state)=>[
                ...state.filter((el)=>el !== genre)
            ]);
        if (!selected && selectedGenres.length < (0, $jQMGL.maxUserPreferredGenresCount)) setSelectedGenres((state)=>[
                ...state,
                genre
            ]);
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $cj0ht.styles)(theme).form.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $cj0ht.styles)(theme).form.genres.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $cj0ht.styles)(theme).form.genres.rows.main,
                        children: (0, $jQMGL.musicGenres).map((genre)=>{
                            const selected = selectedGenres.includes(genre);
                            return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4uIFk.Genre), {
                                genre: genre,
                                onClick: ()=>onGenreClick(selected, genre),
                                selected: selected
                            }, `onboarding-genres-${genre}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $cj0ht.styles)(theme).form.genres.selected.main,
                        children: [
                            "Selected",
                            " ",
                            /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                css: (0, $cj0ht.styles)(theme).form.genres.selected.num,
                                children: selectedGenres.length
                            }),
                            " ",
                            "out of",
                            " ",
                            /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                css: (0, $cj0ht.styles)(theme).form.genres.selected.num,
                                children: (0, $jQMGL.maxUserPreferredGenresCount)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("form", {
                css: (0, $cj0ht.styles)(theme).form.content.main,
                onSubmit: (e)=>{
                    e.preventDefault();
                    dispatch((0, $hIwjn.onboardingUpdateGenres)({
                        preferredGenres: selectedGenres
                    }));
                },
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $cj0ht.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "select genres",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Select"
                    })
                })
            })
        ]
    });
};
$c96e18a76fa88ca7$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("gFBZu", function(module, exports) {

$parcel$export(module.exports, "Genre", function () { return (parcelRequire("4uIFk")).Genre; });

var $4uIFk = parcelRequire("4uIFk");

});
parcelRegister("4uIFk", function(module, exports) {

$parcel$export(module.exports, "Genre", function () { return $1b28f0d85a67075b$export$8676b75cc81ea732; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $cJe7U = parcelRequire("cJe7U");
const $1b28f0d85a67075b$export$8676b75cc81ea732 = ({ genre: genre, selected: selected = false, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cJe7U.styles)(theme).genre.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
            css: [
                (0, $cJe7U.styles)(theme).genre.button.shared,
                selected ? (0, $cJe7U.styles)(theme).genre.button.selected : (0, $cJe7U.styles)(theme).genre.button.unselected,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "select genre",
            children: genre
        })
    });
};
$1b28f0d85a67075b$export$8676b75cc81ea732.propTypes = {};

});
parcelRegister("cJe7U", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $528622d5e69be826$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $528622d5e69be826$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $528622d5e69be826$var$_ref = {
    name: "1u4hpl4",
    styles: "display:inline"
};
const $528622d5e69be826$export$9dd6ff9ea0189349 = (theme)=>({
        genre: {
            main: $528622d5e69be826$var$_ref,
            button: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:8px 26px;cursor:pointer;transition:color 0.2s,background-color 0.2s,border 0.2s;", ""),
                selected: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";", ""),
                unselected: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});



parcelRegister("cj0ht", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3b59641c755a9606$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3b59641c755a9606$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3b59641c755a9606$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $3b59641c755a9606$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $3b59641c755a9606$var$_ref3 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
var $3b59641c755a9606$var$_ref4 = {
    name: "1efi8gv",
    styles: "font-weight:bold"
};
var $3b59641c755a9606$var$_ref5 = {
    name: "1jivb86",
    styles: "display:flex;justify-content:center;flex-wrap:wrap;margin-bottom:32px;max-width:572px;&>div{margin-left:8px;margin-right:8px;margin-bottom:16px;}"
};
var $3b59641c755a9606$var$_ref6 = {
    name: "1ohaauq",
    styles: "display:flex;flex-direction:column;align-items:center;margin-bottom:50px"
};
const $3b59641c755a9606$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            genres: {
                main: $3b59641c755a9606$var$_ref6,
                rows: {
                    main: $3b59641c755a9606$var$_ref5
                },
                selected: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";text-align:center;", ""),
                    num: $3b59641c755a9606$var$_ref4
                }
            },
            content: {
                main: $3b59641c755a9606$var$_ref3,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($3b59641c755a9606$var$_ref2), " &>button{width:380px;", (0, $48E0n.mq).mobile($3b59641c755a9606$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("17Vk9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $19b766b9f5a56e96$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $19b766b9f5a56e96$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $19b766b9f5a56e96$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $19b766b9f5a56e96$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $19b766b9f5a56e96$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $19b766b9f5a56e96$var$_ref4 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $19b766b9f5a56e96$var$_ref5 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $19b766b9f5a56e96$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $19b766b9f5a56e96$var$_ref5,
            backward: {
                button: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $19b766b9f5a56e96$var$_ref4
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:760px;", (0, $48E0n.mq).mobile($19b766b9f5a56e96$var$_ref3), ";", ""),
                title: $19b766b9f5a56e96$var$_ref2,
                form: $19b766b9f5a56e96$var$_ref,
                error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("gkp9Q", function(module, exports) {

$parcel$export(module.exports, "SelectRole", function () { return $02a7bc08c62931b5$export$63dfc77bab1afa54; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $2sNJT = parcelRequire("2sNJT");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");

var $gLiqA = parcelRequire("gLiqA");
parcelRequire("9zqxJ");
var $kqihJ = parcelRequire("kqihJ");

var $lm3c2 = parcelRequire("lm3c2");
const $02a7bc08c62931b5$export$63dfc77bab1afa54 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    const [fanRoleHover, setFanRoleHover] = (0, $exYeM.useState)(true);
    const [artistRoleHover, setArtistRoleHover] = (0, $exYeM.useState)(false);
    const onFanRoleMouseEnter = ()=>{
        setFanRoleHover(true);
        setArtistRoleHover(false);
    };
    const onFanRoleMouseLeave = ()=>{
        setFanRoleHover(true);
        setArtistRoleHover(false);
    };
    const onArtistRoleMouseEnter = ()=>{
        setArtistRoleHover(true);
        setFanRoleHover(false);
    };
    const onArtistRoleMouseLeave = ()=>{
        setArtistRoleHover(true);
        setFanRoleHover(false);
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $lm3c2.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lm3c2.styles)().stage.backward.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    css: (0, $lm3c2.styles)().stage.backward.button,
                    "aria-label": "sign out",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $2sNJT.authSignout)()),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).SignOut, {
                        css: (0, $lm3c2.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $lm3c2.styles)().stage.role.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $lm3c2.styles)().stage.role.fan,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $kqihJ.Role), {
                            name: "Fan",
                            appearance: "primary",
                            features: (0, $gLiqA.fanRoleFeatures),
                            visible: fanRoleHover,
                            loading: onboardingLoading,
                            onRoleMouseEnter: ()=>onFanRoleMouseEnter(),
                            onRoleMouseLeave: ()=>onFanRoleMouseLeave(),
                            onNextClick: ()=>{
                                dispatch((0, $hIwjn.onboardingUpdateRole)({
                                    role: (0, $aeAwZ.EntityUserRole).Fan
                                }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $lm3c2.styles)().stage.role.artist,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $kqihJ.Role), {
                            name: "Artist",
                            appearance: "secondary",
                            features: (0, $gLiqA.artistRoleFeatures),
                            visible: artistRoleHover,
                            loading: onboardingLoading,
                            onRoleMouseEnter: ()=>onArtistRoleMouseEnter(),
                            onRoleMouseLeave: ()=>onArtistRoleMouseLeave(),
                            onNextClick: ()=>{
                                dispatch((0, $hIwjn.onboardingUpdateRole)({
                                    role: (0, $aeAwZ.EntityUserRole).Artist
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$02a7bc08c62931b5$export$63dfc77bab1afa54.propTypes = {};

});
parcelRegister("gLiqA", function(module, exports) {

$parcel$export(module.exports, "fanRoleFeatures", function () { return $4c327ea92f8cc414$export$dcb16797db17b4cd; });
$parcel$export(module.exports, "artistRoleFeatures", function () { return $4c327ea92f8cc414$export$9fef70fa27af7bc2; });
// icons

var $a3uYB = parcelRequire("a3uYB");
const $4c327ea92f8cc414$export$dcb16797db17b4cd = [
    {
        id: "8fbadf0c-f417-4331-8180-326ccc489975",
        title: "DISPERSE IN EXCLUSIVE CONTENT",
        description: "Immerse yourself in a rich variety of exclusive audio tracks and media posts, carefully crafted by top creators from around the world.",
        icon: (0, $a3uYB.icons).FireIcon
    },
    {
        id: "9e1c9469-7619-4e03-bb07-728ae9dcc3b4",
        title: "SUPPORT YOUR CREATORS",
        description: "Show your appreciation by becoming a valued patron, unlocking exclusive content, enjoying subscription perks, and offering tips to support the artists you admire.",
        icon: (0, $a3uYB.icons).GrowIcon
    },
    {
        id: "737469ca-8263-49a5-9752-3d3d9a99ce11",
        title: "NEVER MISS A BEAT",
        description: "Stay updated and never miss out!! Stay in the loop with instant notifications whenever your favourite artists drop new tracks or media posts.",
        icon: (0, $a3uYB.icons).NotificationIcon
    }
];
const $4c327ea92f8cc414$export$9fef70fa27af7bc2 = [
    {
        id: "c9fee612-e208-4360-8a9e-bf34a97c7b9c",
        title: "SHARE CONTENT AND EARN",
        description: "Earn more money than ever before by sharing exclusive music, video clips, photo, or text. Just share content with your fans and get paid directly.",
        icon: (0, $a3uYB.icons).FireIcon
    },
    {
        id: "9f765252-cf75-4667-8089-c567a956e0de",
        title: "GROW FROM THE VERY BEGINNING",
        description: "Our algorithms are concentrated for artist growth and help promote new music to listeners with similar taste!",
        icon: (0, $a3uYB.icons).GrowIcon
    },
    {
        id: "9e45d811-42eb-4b14-bbc1-4e67987531ad",
        title: "RETAIN ENGAGEMENT",
        description: "Fans will be notified with every release and post that you publish! Show demos and snippets to subscribers far ahead of the release to be closer to them.",
        icon: (0, $a3uYB.icons).NotificationIcon
    }
];

});
parcelRegister("a3uYB", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $bd21c29c544298f1$export$df03f54e09e486fa; });

var $gzReY = parcelRequire("gzReY");

var $2Lea9 = parcelRequire("2Lea9");

var $cYfUK = parcelRequire("cYfUK");
const $bd21c29c544298f1$export$df03f54e09e486fa = {
    FireIcon: $gzReY.default,
    GrowIcon: $2Lea9.default,
    NotificationIcon: $cYfUK.default
};

});
parcelRegister("gzReY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49a8c795d58961b9$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $49a8c795d58961b9$var$SvgFire = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 48 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.693 3.763C17.77 1.067 21.32-.6 24.073 1.498c4.586 3.494 10.34 8.63 14.967 14.505 4.586 5.822 8.294 12.656 8.294 19.497 0 6.115-1.894 10.66-4.636 13.915-2.715 3.223-6.166 5.07-9.147 5.997-1.53.477-2.93-.225-3.61-1.367a3.375 3.375 0 0 1 .156-3.657c2.286-3.285 4.703-8.01 4.703-12.221 0-2.09-.9-4.563-2.355-7.101-1.094-1.909-2.434-3.74-3.74-5.309-.27 3.741-1.084 8.442-3.606 12.329-1.146 1.766-3.694 1.963-5.05.248a41.279 41.279 0 0 1-1.294-1.76c-.21-.293-.408-.572-.601-.834-1.829 1.821-3.531 4-3.531 6.427 0 2.143 1.07 5.073 2.335 7.555a3.46 3.46 0 0 1-.426 3.806c-.876 1.037-2.47 1.57-3.983.694C7.365 51.22.667 44.81.667 35.5c0-2.525.856-5.137 2.054-7.689 1.206-2.568 2.841-5.244 4.559-7.918.595-.926 1.199-1.852 1.802-2.775 2.945-4.514 5.866-8.99 7.61-13.355Zm4.37.85a1.116 1.116 0 0 0-.656.634c-1.907 4.773-5.1 9.659-8.046 14.167-.586.897-1.162 1.778-1.716 2.64-1.704 2.655-3.217 5.144-4.303 7.457-1.095 2.331-1.675 4.319-1.675 5.989 0 6.119 3.75 10.87 7.688 13.809-.946-2.243-1.732-4.83-1.732-7.142 0-4.615 3.465-8.1 5.401-9.933 1.254-1.188 3.42-1.294 4.682.263.457.564.903 1.189 1.309 1.76l.048.067c.114.16.224.316.333.467 1.783-3.398 2.283-7.543 2.407-10.954a3.324 3.324 0 0 1 2.063-2.979 3.2 3.2 0 0 1 3.61.837l-1.483 1.341 1.483-1.34c1.777 1.965 3.825 4.563 5.44 7.38 1.593 2.78 2.884 5.978 2.884 9.09 0 4.514-2.047 9.094-4.116 12.503 1.738-.851 3.492-2.095 4.955-3.831 2.098-2.491 3.695-6.108 3.695-11.338 0-5.485-3.034-11.432-7.437-17.022C31.536 12.941 26.052 8.034 21.65 4.68c-.146-.111-.334-.154-.587-.067Z",
            fill: "#FFF"
        })
    });
var $49a8c795d58961b9$export$2e2bcd8739ae039 = $49a8c795d58961b9$var$SvgFire;

});

parcelRegister("2Lea9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cba758487defedf$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $3cba758487defedf$var$SvgGrow = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 58 58",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.131.333h-.263c-1.773 0-3.3 0-4.524.165-1.31.176-2.568.573-3.587 1.593-1.02 1.02-1.417 2.276-1.593 3.587C18.999 6.9 19 8.428 19 10.202v6.473a5.99 5.99 0 0 0-2-.342H9a6 6 0 0 0-6 6v31.334h-.667a2 2 0 1 0 0 4h53.333a2 2 0 1 0 0-4H55v-18a6 6 0 0 0-6-6h-8a5.99 5.99 0 0 0-2 .341V10.202c0-1.773 0-3.3-.165-4.524-.176-1.311-.573-2.568-1.593-3.587C36.223 1.07 34.966.674 33.655.498c-1.223-.165-2.75-.165-4.524-.165ZM51 53.667v-18a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v18h12Zm-16 0V10.333c0-1.942-.005-3.197-.129-4.122-.117-.868-.305-1.14-.457-1.292-.152-.152-.424-.34-1.292-.457-.925-.124-2.18-.129-4.122-.129-1.942 0-3.198.005-4.123.129-.867.117-1.14.305-1.291.457-.153.152-.341.424-.458 1.292-.124.925-.128 2.18-.128 4.122v43.334h12Zm-16 0V22.333a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v31.334h12Z",
            fill: "#FFF"
        })
    });
var $3cba758487defedf$export$2e2bcd8739ae039 = $3cba758487defedf$var$SvgGrow;

});

parcelRegister("cYfUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43f7c5867b221c2f$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $43f7c5867b221c2f$var$SvgNotification = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 54 59",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M29 13.5a2 2 0 0 0-4 0v10.667a2 2 0 1 0 4 0V13.5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.333 21.5C6.333 10.086 15.586.833 27 .833c11.414 0 20.666 9.253 20.666 20.667v1.878c0 1.858.55 3.675 1.581 5.221l3.063 4.595c3.555 5.332.841 12.58-5.342 14.266a75.9 75.9 0 0 1-6.09 1.395l-.006.014c-2.05 5.471-7.531 9.298-13.872 9.298-6.342 0-11.822-3.827-13.873-9.298l-.005-.014A75.888 75.888 0 0 1 7.03 47.46c-6.183-1.686-8.897-8.934-5.342-14.266l3.063-4.595a9.413 9.413 0 0 0 1.581-5.221V21.5Zm11.663 28.099a75.901 75.901 0 0 0 18.008 0c-1.896 2.724-5.194 4.568-9.004 4.568-3.811 0-7.108-1.844-9.004-4.568ZM27 4.833c-9.205 0-16.667 7.462-16.667 16.667v1.878c0 2.648-.784 5.237-2.253 7.44l-3.063 4.595c-2.04 3.06-.482 7.22 3.067 8.188a71.891 71.891 0 0 0 37.832 0c3.549-.968 5.107-5.128 3.066-8.188l-3.063-4.595a13.414 13.414 0 0 1-2.253-7.44V21.5c0-9.205-7.461-16.667-16.666-16.667Z",
                fill: "#FFF"
            })
        ]
    });
var $43f7c5867b221c2f$export$2e2bcd8739ae039 = $43f7c5867b221c2f$var$SvgNotification;

});



parcelRegister("9zqxJ", function(module, exports) {

$parcel$export(module.exports, "Role", function () { return (parcelRequire("kqihJ")).Role; });

var $kqihJ = parcelRequire("kqihJ");

});
parcelRegister("kqihJ", function(module, exports) {

$parcel$export(module.exports, "Role", function () { return $828a9368a3d6bb8b$export$46919bad18fb2f76; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("4iZVT");
var $bVeTg = parcelRequire("bVeTg");
var $1hAVI = parcelRequire("1hAVI");

var $dh7Ar = parcelRequire("dh7Ar");
const $828a9368a3d6bb8b$export$46919bad18fb2f76 = ({ name: name, features: features, visible: visible, loading: loading, onRoleMouseEnter: onRoleMouseEnter, onRoleMouseLeave: onRoleMouseLeave, onNextClick: onNextClick, appearance: appearance = "primary" })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: [
            (0, $dh7Ar.styles)(theme).role.main.shared(visible),
            appearance === "primary" && (0, $dh7Ar.styles)(theme).role.main.primary,
            appearance === "secondary" && (0, $dh7Ar.styles)(theme).role.main.secondary,
            "",
            ""
        ],
        onMouseEnter: (e)=>onRoleMouseEnter(e),
        onMouseLeave: (e)=>onRoleMouseLeave(e),
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $dh7Ar.styles)(theme).role.content.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $dh7Ar.styles)(theme).role.content.title,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1hAVI.Title), {
                        text: name,
                        appearance: appearance
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $dh7Ar.styles)(theme).role.content.features,
                    children: features.map((feature)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $bVeTg.Feature), {
                            ...feature,
                            appearance: appearance
                        }, feature.id))
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $dh7Ar.styles)(theme).role.content.next,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        onClick: (e)=>onNextClick(e),
                        "aria-label": `select role ${name}`,
                        disabled: loading,
                        appearance: appearance === "primary" ? "secondary" : "primary",
                        children: loading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Become a ${name}`
                    })
                })
            ]
        })
    });
};
$828a9368a3d6bb8b$export$46919bad18fb2f76.propTypes = {};

});
parcelRegister("4iZVT", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return (parcelRequire("bVeTg")).Feature; });
$parcel$export(module.exports, "Title", function () { return (parcelRequire("1hAVI")).Title; });

var $bVeTg = parcelRequire("bVeTg");

var $1hAVI = parcelRequire("1hAVI");

});
parcelRegister("bVeTg", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $b71986d07cec0ea5$export$6e91cf7616333d5; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $iUAGm = parcelRequire("iUAGm");
const $b71986d07cec0ea5$export$6e91cf7616333d5 = ({ title: title, description: description, icon: Icon, appearance: appearance = "primary" })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $iUAGm.styles)(theme).feature.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $iUAGm.styles)(theme).feature.icon.main,
                children: Icon && /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {
                    css: [
                        (0, $iUAGm.styles)(theme).feature.icon.content.shared,
                        appearance === "primary" && (0, $iUAGm.styles)(theme).feature.icon.content.primary,
                        appearance === "secondary" && (0, $iUAGm.styles)(theme).feature.icon.content.secondary,
                        "",
                        ""
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: [
                    (0, $iUAGm.styles)(theme).feature.content.main.shared,
                    appearance === "primary" && (0, $iUAGm.styles)(theme).feature.content.main.primary,
                    appearance === "secondary" && (0, $iUAGm.styles)(theme).feature.content.main.secondary,
                    "",
                    ""
                ],
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $iUAGm.styles)(theme).feature.content.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $iUAGm.styles)(theme).feature.content.description,
                        children: description
                    })
                ]
            })
        ]
    });
};
$b71986d07cec0ea5$export$6e91cf7616333d5.propTypes = {};

});
parcelRegister("iUAGm", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3a292184258fff6e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3a292184258fff6e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3a292184258fff6e$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
var $3a292184258fff6e$var$_ref2 = {
    name: "xjpx28",
    styles: "width:58px;height:58px"
};
var $3a292184258fff6e$var$_ref3 = {
    name: "1o8qm9w",
    styles: "align-self:center;margin-right:0px;margin-bottom:20px"
};
var $3a292184258fff6e$var$_ref4 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $3a292184258fff6e$export$9dd6ff9ea0189349 = (theme)=>({
        feature: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).mobile($3a292184258fff6e$var$_ref4), ";", ""),
            icon: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:80px;height:80px;margin-right:24px;", (0, $48E0n.mq).mobile($3a292184258fff6e$var$_ref3), ";", ""),
                content: {
                    shared: $3a292184258fff6e$var$_ref2,
                    primary: /*#__PURE__*/ (0, $4N3Qt.css)("&>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    secondary: /*#__PURE__*/ (0, $4N3Qt.css)("&>path{fill:", theme.colors.accent.normal, ";}", "")
                }
            },
            content: {
                main: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($3a292184258fff6e$var$_ref), ";", ""),
                    primary: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.primary.normal, ";", ""),
                    secondary: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";", "")
                },
                title: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;text-transform:uppercase;", ""),
                description: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("1hAVI", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $aeb2a91076966a5d$export$f99233281efd08a0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $1ZjzU = parcelRequire("1ZjzU");
const $aeb2a91076966a5d$export$f99233281efd08a0 = ({ text: text, appearance: appearance = "primary" })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $1ZjzU.styles)(theme).title.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("h1", {
            css: [
                (0, $1ZjzU.styles)(theme).title.text.shared,
                appearance === "primary" && (0, $1ZjzU.styles)(theme).title.text.primary,
                appearance === "secondary" && (0, $1ZjzU.styles)(theme).title.text.secondary,
                "",
                ""
            ],
            children: text
        })
    });
};
$aeb2a91076966a5d$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("1ZjzU", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c8a48ffae649b5b9$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $c8a48ffae649b5b9$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            text: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h3, ";font-weight:bold;text-align:center;", ""),
                primary: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.primary.normal, ";", ""),
                secondary: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});



parcelRegister("dh7Ar", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $213f9fcb30bbc0b8$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $213f9fcb30bbc0b8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $213f9fcb30bbc0b8$var$_ref = {
    name: "1azpx8r",
    styles: "margin-bottom:20px"
};
var $213f9fcb30bbc0b8$var$_ref2 = {
    name: "1omtx6o",
    styles: "&>div:not(:last-of-type){margin-bottom:20px;}"
};
var $213f9fcb30bbc0b8$var$_ref3 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $213f9fcb30bbc0b8$var$_ref4 = {
    name: "1k0e75g",
    styles: "display:flex;flex-direction:column;max-width:740px;width:100%"
};
var $213f9fcb30bbc0b8$var$_ref5 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $213f9fcb30bbc0b8$var$_ref6 = {
    name: "1hy92ex",
    styles: "opacity:0.1"
};
const $213f9fcb30bbc0b8$export$9dd6ff9ea0189349 = (theme)=>({
        role: {
            main: {
                shared: (hover)=>/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.full, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;transition:opacity 0.4s;", !hover && $213f9fcb30bbc0b8$var$_ref6, " ", (0, $48E0n.mq).tablet($213f9fcb30bbc0b8$var$_ref5), ";", ""),
                primary: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.accent.normal, ";", ""),
                secondary: /*#__PURE__*/ (0, $4N3Qt.css)("background-color:", theme.colors.primary.darker, ";", "")
            },
            content: {
                main: $213f9fcb30bbc0b8$var$_ref4,
                title: /*#__PURE__*/ (0, $4N3Qt.css)("margin-bottom:60px;", (0, $48E0n.mq).mobile($213f9fcb30bbc0b8$var$_ref3), ";", ""),
                features: /*#__PURE__*/ (0, $4N3Qt.css)("margin-bottom:60px;&>div:not(:last-of-type){margin-bottom:50px;}", (0, $48E0n.mq).mobile($213f9fcb30bbc0b8$var$_ref2), ";", ""),
                next: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:center;&>button{max-width:380px;}", (0, $48E0n.mq).mobile($213f9fcb30bbc0b8$var$_ref), ";", "")
            }
        }
    });

});



parcelRegister("lm3c2", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d0b3495e0df82bbc$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d0b3495e0df82bbc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d0b3495e0df82bbc$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $d0b3495e0df82bbc$var$_ref2 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
const $d0b3495e0df82bbc$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";width:100%;height:100%;overflow:hidden;overflow-y:scroll;", ""),
            backward: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                icon: $d0b3495e0df82bbc$var$_ref2
            },
            role: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:grid;grid-template-rows:repeat(1, 1fr);grid-template-columns:repeat(2, 1fr);width:100%;height:100%;", (0, $48E0n.mq).tablet($d0b3495e0df82bbc$var$_ref), ";", ""),
                fan: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                artist: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});


parcelRegister("dcRPS", function(module, exports) {

$parcel$export(module.exports, "UploadTracks", function () { return $dd94fbd6a0654f57$export$ead49df769534942; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $hIwjn = parcelRequire("hIwjn");
var $fZeVI = parcelRequire("fZeVI");
var $gROQP = parcelRequire("gROQP");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $jES8Z = parcelRequire("jES8Z");
var $9TEV9 = parcelRequire("9TEV9");
var $2eN72 = parcelRequire("2eN72");
parcelRequire("6elJL");
var $1Qyaj = parcelRequire("1Qyaj");
var $jxuki = parcelRequire("jxuki");

var $5V3CB = parcelRequire("5V3CB");
const $dd94fbd6a0654f57$export$ead49df769534942 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackCreateLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackCreateLoading));
    const uploadedTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksLength));
    const onboardingError = "";
    const trackCreateError = "";
    (0, $exYeM.useEffect)(()=>{
        // fetch profile tracks
        dispatch((0, $fZeVI.trackGetUploadedTracks)({}));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $5V3CB.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $5V3CB.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jES8Z.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $hIwjn.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ArrowLeft, {
                        css: (0, $5V3CB.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $5V3CB.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5V3CB.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2eN72.Subtitle), {
                            text: "Upload your first track to RYDDM!"
                        })
                    }),
                    !trackCreateLoading && uploadedTracksLength > 0 && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $5V3CB.styles)().stage.content.tracks,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gROQP.TrackListOnboardingUploaded), {}),
                            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1Qyaj.Divider), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5V3CB.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jxuki.Form), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5V3CB.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: onboardingError || trackCreateError
                        })
                    })
                ]
            })
        ]
    });
};
$dd94fbd6a0654f57$export$ead49df769534942.propTypes = {};

});
parcelRegister("6elJL", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return (parcelRequire("1Qyaj")).Divider; });
$parcel$export(module.exports, "Form", function () { return (parcelRequire("jxuki")).Form; });

var $1Qyaj = parcelRequire("1Qyaj");

var $jxuki = parcelRequire("jxuki");

});
parcelRegister("1Qyaj", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $12c9e4bc1c906301$export$2e0a83ec2e27ecbb; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $86ekc = parcelRequire("86ekc");
const $12c9e4bc1c906301$export$2e0a83ec2e27ecbb = ()=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $86ekc.styles)(theme).divider.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $86ekc.styles)(theme).divider.bar
        })
    });
};
$12c9e4bc1c906301$export$2e0a83ec2e27ecbb.propTypes = {};

});
parcelRegister("86ekc", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4e032cc37ff0b9b3$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $4e032cc37ff0b9b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4e032cc37ff0b9b3$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $4e032cc37ff0b9b3$export$9dd6ff9ea0189349 = (theme)=>({
        divider: {
            main: $4e032cc37ff0b9b3$var$_ref,
            bar: /*#__PURE__*/ (0, $4N3Qt.css)("height:1px;width:100%;background-color:", theme.colors.secondary.darkHover, ";", "")
        }
    });

});


parcelRegister("jxuki", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $9891502792390d37$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $6U1f3 = parcelRequire("6U1f3");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $bLoEn = parcelRequire("bLoEn");
var $hIwjn = parcelRequire("hIwjn");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $f7BhD = parcelRequire("f7BhD");
var $9TEV9 = parcelRequire("9TEV9");
var $cHn6a = parcelRequire("cHn6a");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("7bHYK");
var $3TNvJ = parcelRequire("3TNvJ");
var $9I8Ir = parcelRequire("9I8Ir");

var $4TsdH = parcelRequire("4TsdH");
const $9891502792390d37$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const onboardingLoading = (0, $9CcOD.useAppSelector)((0, $bLoEn.onboardingSelectLoading));
    const uploadedTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksLength));
    const trackCreateLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackCreateLoading));
    // cover state
    const [cover, setCover] = (0, $exYeM.useState)(undefined);
    const [coverPreview, setCoverPreview] = (0, $exYeM.useState)("");
    const coverFileInputRef = (0, $exYeM.useRef)(null);
    const [coverError, setCoverError] = (0, $exYeM.useState)("");
    // track state
    const [track, setTrack] = (0, $exYeM.useState)(undefined);
    const [trackFileName, setTrackFileName] = (0, $exYeM.useState)("");
    const trackFileInputRef = (0, $exYeM.useRef)(null);
    const [trackError, setTrackError] = (0, $exYeM.useState)("");
    // name state
    const [name, setName] = (0, $exYeM.useState)("");
    const [nameError, setNameError] = (0, $exYeM.useState)("");
    const submitDisabled = onboardingLoading || trackCreateLoading;
    const uploadDisabled = name.length < (0, $6U1f3.minTrackNameLength) || name.length > (0, $6U1f3.maxTrackNameLength) || track === undefined || coverError !== "" || trackError !== "" || nameError !== "" || trackCreateLoading || onboardingLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setCover(undefined);
        setTrack(undefined);
        setName("");
        setTrackFileName("");
        // if cover preview was set
        if (coverPreview) {
            // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            setCoverPreview("");
        }
    };
    const onCoverClick = ()=>{
        coverFileInputRef.current?.click();
        setCoverError("");
    };
    const onTrackClick = ()=>{
        trackFileInputRef.current?.click();
        setTrackError("");
    };
    const onCoverFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validateCoverFile)(file);
            if (error) {
                setCoverError(error);
                return;
            }
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            // set file as a preview
            setCoverPreview(URL.createObjectURL(file));
            // store file in state
            setCover(file);
        }
    };
    const onTrackFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validateTrackFile)(file);
            if (error) {
                setTrackError(error);
                return;
            }
            // store file name in state
            setTrackFileName(file.name);
            // store file in state
            setTrack(file);
        }
    };
    (0, $exYeM.useEffect)(()=>()=>{
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
        });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $4TsdH.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $4TsdH.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $hIwjn.onboardingSetNextStage)());
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $4TsdH.styles)().form.content.inputs.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $4TsdH.styles)().form.content.inputs.cover.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                                    css: (0, $4TsdH.styles)().form.content.inputs.cover.label,
                                    htmlFor: "cover",
                                    children: [
                                        "cover",
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                            css: (0, $4TsdH.styles)().form.content.inputs.cover.input,
                                            name: "cover",
                                            type: "file",
                                            id: "cover",
                                            ref: coverFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png",
                                            onChange: (e)=>onCoverFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3TNvJ.Cover), {
                                    onClick: ()=>onCoverClick(),
                                    source: coverPreview
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $4TsdH.styles)().form.content.inputs.track.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4TsdH.styles)().form.content.inputs.track.name.main,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cHn6a.InputBar), {
                                        name: "name",
                                        label: "name",
                                        type: "text",
                                        placeholder: "Enter track name",
                                        value: name,
                                        error: nameError.length > 0,
                                        errorMessage: nameError,
                                        min: (0, $6U1f3.minTrackNameLength),
                                        max: (0, $6U1f3.maxTrackNameLength),
                                        onChange: (e)=>{
                                            setName(e.target.value);
                                        },
                                        onBlur: ()=>setNameError((0, $33ayT.validateTrackName)(name)),
                                        onFocus: ()=>setNameError("")
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $4TsdH.styles)().form.content.inputs.track.file.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                                            css: (0, $4TsdH.styles)().form.content.inputs.track.file.label,
                                            htmlFor: "track",
                                            children: [
                                                "track",
                                                /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                                    css: (0, $4TsdH.styles)().form.content.inputs.track.file.input,
                                                    name: "track",
                                                    type: "file",
                                                    id: "track",
                                                    ref: trackFileInputRef,
                                                    accept: ".mp3",
                                                    onChange: (e)=>onTrackFileChange(e)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9I8Ir.Track), {
                                            onClick: ()=>onTrackClick(),
                                            fileName: trackFileName
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4TsdH.styles)().form.content.inputs.upload,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                                type: "button",
                                "aria-label": "upload track",
                                appearance: "primary",
                                disabled: uploadDisabled,
                                onClick: ()=>{
                                    dispatch((0, $fZeVI.trackCreate)({
                                        name: name,
                                        genres: [],
                                        track: track,
                                        cover: cover
                                    }));
                                    cleanupState();
                                },
                                children: trackCreateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                    width: 40,
                                    height: 20,
                                    appearance: "primary"
                                }) : "Upload"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4TsdH.styles)().form.content.error,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                        error: coverError || trackError
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4TsdH.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "proceed to next onboarding stage",
                        disabled: submitDisabled,
                        appearance: uploadedTracksLength > 0 ? "primary" : "secondary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Next"
                    })
                })
            ]
        })
    });
};
$9891502792390d37$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("7bHYK", function(module, exports) {

$parcel$export(module.exports, "Cover", function () { return (parcelRequire("3TNvJ")).Cover; });
$parcel$export(module.exports, "Track", function () { return (parcelRequire("9I8Ir")).Track; });

var $3TNvJ = parcelRequire("3TNvJ");

var $9I8Ir = parcelRequire("9I8Ir");

});
parcelRegister("3TNvJ", function(module, exports) {

$parcel$export(module.exports, "Cover", function () { return $ec1dc63f10bd6f71$export$64da1bd56a7c875f; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $kx9KQ = parcelRequire("kx9KQ");
const $ec1dc63f10bd6f71$export$64da1bd56a7c875f = ({ source: source, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $kx9KQ.styles)(theme).cover.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
            css: (0, $kx9KQ.styles)(theme).cover.button,
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "change track cover",
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kx9KQ.styles)(theme).cover.image.main,
                children: source ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $kx9KQ.styles)(theme).cover.image.content,
                    loading: "lazy",
                    width: "136px",
                    height: "136px",
                    src: source,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).ImageDownload, {
                    css: (0, $kx9KQ.styles)(theme).cover.image.icon
                })
            })
        })
    });
};
$ec1dc63f10bd6f71$export$64da1bd56a7c875f.propTypes = {};

});
parcelRegister("kx9KQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4c67bc55ca5790a8$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $4c67bc55ca5790a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4c67bc55ca5790a8$var$_ref = {
    name: "ic1kkf",
    styles: "position:relative;width:136px;height:136px;border-radius:4px;overflow:hidden"
};
const $4c67bc55ca5790a8$export$9dd6ff9ea0189349 = (theme)=>({
        cover: {
            main: $4c67bc55ca5790a8$var$_ref,
            button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:100%;cursor:pointer;", ""),
            image: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:136px;height:136px;background-color:", theme.colors.secondary.darker, ";overflow:hidden;", ""),
                content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px;", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:40px;height:40px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            }
        }
    });

});


parcelRegister("9I8Ir", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $9810cea14f515183$export$13921ac0cc260818; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $cY3Fz = parcelRequire("cY3Fz");
const $9810cea14f515183$export$13921ac0cc260818 = ({ fileName: fileName, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cY3Fz.styles)(theme).track.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
            css: [
                (0, $cY3Fz.styles)(theme).track.button.shared,
                fileName ? (0, $cY3Fz.styles)(theme).track.button.filled : (0, $cY3Fz.styles)(theme).track.button.empty,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "change track file",
            children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $cY3Fz.styles)(theme).track.button.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $cY3Fz.styles)(theme).track.button.content.name,
                        children: fileName || `Select track (.mp3)`
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $cY3Fz.styles)(theme).track.button.content.icon,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Upload, {})
                    })
                ]
            })
        })
    });
};
$9810cea14f515183$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("cY3Fz", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $53b21bc12a30cb22$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $53b21bc12a30cb22$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $53b21bc12a30cb22$var$_ref = {
    name: "gjwf77",
    styles: "display:flex;align-items:center;margin-left:6px;&>svg{width:24px;height:24px;}"
};
var $53b21bc12a30cb22$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
var $53b21bc12a30cb22$var$_ref3 = {
    name: "1dvgrzx",
    styles: "height:50px;padding:12px 26px"
};
var $53b21bc12a30cb22$var$_ref4 = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $53b21bc12a30cb22$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $53b21bc12a30cb22$var$_ref4,
            button: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:56px;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).h6, ";border-radius:20px;padding:14px 32px;transition:border 0.2s,color 0.2s;cursor:pointer;", (0, $48E0n.mq).mobile($53b21bc12a30cb22$var$_ref3), ";", ""),
                empty: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.darkHover, ";color:", theme.colors.secondary.darkHover, ";", ""),
                filled: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.normal, ";color:", theme.colors.secondary.normal, ";", ""),
                content: {
                    main: $53b21bc12a30cb22$var$_ref2,
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";margin-right:auto;", ""),
                    icon: $53b21bc12a30cb22$var$_ref
                }
            }
        }
    });

});



parcelRegister("4TsdH", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $889c55db31b08b5e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $889c55db31b08b5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $889c55db31b08b5e$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $889c55db31b08b5e$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $889c55db31b08b5e$var$_ref3 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $889c55db31b08b5e$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $889c55db31b08b5e$var$_ref5 = {
    name: "eivff4",
    styles: "display:none"
};
var $889c55db31b08b5e$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $889c55db31b08b5e$var$_ref7 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $889c55db31b08b5e$var$_ref8 = {
    name: "zs54pd",
    styles: "margin-right:0px;margin-bottom:24px"
};
var $889c55db31b08b5e$var$_ref9 = {
    name: "eivff4",
    styles: "display:none"
};
var $889c55db31b08b5e$var$_ref10 = {
    name: "eivff4",
    styles: "display:none"
};
var $889c55db31b08b5e$var$_ref11 = {
    name: "zs54pd",
    styles: "margin-right:0px;margin-bottom:24px"
};
var $889c55db31b08b5e$var$_ref12 = {
    name: "1f9uc99",
    styles: "flex-direction:column;align-items:center"
};
var $889c55db31b08b5e$var$_ref13 = {
    name: "b6wrti",
    styles: "display:flex;flex-direction:column;width:100%"
};
var $889c55db31b08b5e$var$_ref14 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $889c55db31b08b5e$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $889c55db31b08b5e$var$_ref14,
            content: {
                main: $889c55db31b08b5e$var$_ref13,
                inputs: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-bottom:16px;justify-content:center;", (0, $48E0n.mq).tablet($889c55db31b08b5e$var$_ref12), ";", ""),
                    cover: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;margin-right:24px;", (0, $48E0n.mq).tablet($889c55db31b08b5e$var$_ref11), ";", ""),
                        label: $889c55db31b08b5e$var$_ref10,
                        input: $889c55db31b08b5e$var$_ref9
                    },
                    track: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:100%;max-width:380px;margin-right:24px;", (0, $48E0n.mq).tablet($889c55db31b08b5e$var$_ref8), ";", ""),
                        name: {
                            main: $889c55db31b08b5e$var$_ref7
                        },
                        file: {
                            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                            label: $889c55db31b08b5e$var$_ref6,
                            input: $889c55db31b08b5e$var$_ref5
                        }
                    },
                    upload: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:136px;", (0, $48E0n.mq).mobile($889c55db31b08b5e$var$_ref4), ";", "")
                },
                error: $889c55db31b08b5e$var$_ref3,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("align-self:center;", (0, $48E0n.mq).mobile($889c55db31b08b5e$var$_ref2), " &>button{width:380px;", (0, $48E0n.mq).mobile($889c55db31b08b5e$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("5V3CB", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $860a3bb57de86f2f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $860a3bb57de86f2f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $860a3bb57de86f2f$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $860a3bb57de86f2f$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $860a3bb57de86f2f$var$_ref3 = {
    name: "52b1oc",
    styles: "padding:0px"
};
var $860a3bb57de86f2f$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $860a3bb57de86f2f$var$_ref5 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $860a3bb57de86f2f$var$_ref6 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $860a3bb57de86f2f$var$_ref7 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $860a3bb57de86f2f$var$_ref8 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $860a3bb57de86f2f$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $860a3bb57de86f2f$var$_ref8,
            backward: {
                button: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $860a3bb57de86f2f$var$_ref7
            },
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:760px;", (0, $48E0n.mq).mobile($860a3bb57de86f2f$var$_ref6), ";", ""),
                title: $860a3bb57de86f2f$var$_ref5,
                tracks: /*#__PURE__*/ (0, $4N3Qt.css)("padding:0px 30px;&>div:nth-of-type(1){margin-bottom:32px;}&>div:nth-of-type(2){margin-bottom:32px;", (0, $48E0n.mq).mobile($860a3bb57de86f2f$var$_ref4), ";}", (0, $48E0n.mq).tablet($860a3bb57de86f2f$var$_ref3), " ", (0, $48E0n.mq).mobile($860a3bb57de86f2f$var$_ref2), ";", ""),
                form: $860a3bb57de86f2f$var$_ref,
                error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("6DY4p", function(module, exports) {

$parcel$export(module.exports, "fanOnboardingSteps", function () { return $e46e05859c68c999$export$5c1b8a6a4ebd5db; });
$parcel$export(module.exports, "artistOnboardingSteps", function () { return $e46e05859c68c999$export$8b34b26852c483c1; });
const $e46e05859c68c999$export$5c1b8a6a4ebd5db = [
    {
        id: "eb52306b-ff26-4f4a-8c00-77818ba31f33",
        description: "Create Profile"
    },
    {
        id: "19841cbf-0af9-494a-8e0a-68e9a967330a",
        description: "Select Genres"
    },
    {
        id: "4698fbb5-95bf-4f17-ad6e-d5a787acdc50",
        description: "Follow Artists"
    },
    {
        id: "f066d4bf-7db4-4407-a191-f07f5b0bbee8",
        description: "Configure Notifications"
    }
];
const $e46e05859c68c999$export$8b34b26852c483c1 = [
    {
        id: "2aa1e99c-af39-4c77-8707-3eef32015eb7",
        description: "Create Profile"
    },
    {
        id: "a28a9eca-23a5-40c5-ad18-02ab40821bb1",
        description: "Upload Tracks"
    },
    {
        id: "525901d6-6cef-452c-9ce7-675c06e4c72f",
        description: "Enable Monetization"
    },
    {
        id: "14ec6508-41d9-4641-8e64-3560e462da70",
        description: "Configure Notifications"
    }
];

});

parcelRegister("c8YN1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $27277f95ceb5d0ae$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $27277f95ceb5d0ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $27277f95ceb5d0ae$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
var $27277f95ceb5d0ae$var$_ref2 = {
    name: "9w34mz",
    styles: "display:flex;width:100%;height:100%;position:fixed;left:0;right:0"
};
const $27277f95ceb5d0ae$export$9dd6ff9ea0189349 = ()=>({
        onboarding: {
            main: $27277f95ceb5d0ae$var$_ref2,
            stage: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;width:100%;height:100%;overflow:hidden;overflow-y:scroll;&>div:nth-of-type(2){width:100%;max-width:760px;margin:0 auto;}", ""),
            role: $27277f95ceb5d0ae$var$_ref
        }
    });

});



parcelRegister("bLoEn", function(module, exports) {

$parcel$export(module.exports, "onboardingSlice", function () { return $720b7f1df51f8d87$export$b6177dfe2a583549; });
$parcel$export(module.exports, "onboardingSetError", function () { return $720b7f1df51f8d87$export$42ed5835b75dfec2; });
$parcel$export(module.exports, "onboardingSelectStep", function () { return $720b7f1df51f8d87$export$bd1d5b2cdc081f94; });
$parcel$export(module.exports, "onboardingSelectConnectLink", function () { return $720b7f1df51f8d87$export$7fd9a685a7b05236; });
$parcel$export(module.exports, "onboardingSelectError", function () { return $720b7f1df51f8d87$export$6cdeab2c12935ae9; });
$parcel$export(module.exports, "onboardingSelectLoading", function () { return $720b7f1df51f8d87$export$879fd1bbe61011a4; });
$parcel$export(module.exports, "onboardingReducer", function () { return $720b7f1df51f8d87$export$4b19e5acc18169e1; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $hIwjn = parcelRequire("hIwjn");
const $720b7f1df51f8d87$var$initialState = {
    step: 0,
    connectLink: "",
    error: "",
    loading: false
};
const $720b7f1df51f8d87$export$b6177dfe2a583549 = (0, $dEr3t.createSlice)({
    name: "onboarding",
    initialState: $720b7f1df51f8d87$var$initialState,
    reducers: {
        // set error
        onboardingSetError: (state, action)=>({
                ...state,
                error: action.payload
            })
    },
    extraReducers: (builder)=>{
        // set current onboarding step (on refresh)
        builder.addCase((0, $hIwjn.onboardingSetCurrentStep).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $hIwjn.onboardingSetCurrentStep).fulfilled, (state, { payload: payload })=>({
                ...state,
                step: payload.step,
                error: payload.error,
                loading: false
            }));
        // set next onboarding stage
        builder.addCase((0, $hIwjn.onboardingSetNextStage).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $hIwjn.onboardingSetNextStage).fulfilled, (state, { payload: payload })=>({
                ...state,
                step: payload.step,
                error: payload.error,
                loading: false
            }));
        // set prev onboarding stage
        builder.addCase((0, $hIwjn.onboardingSetPrevStage).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $hIwjn.onboardingSetPrevStage).fulfilled, (state, { payload: payload })=>({
                ...state,
                step: payload.step,
                error: payload.error,
                loading: false
            }));
        // select user role
        builder.addCase((0, $hIwjn.onboardingUpdateRole).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $hIwjn.onboardingUpdateRole).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // create profile
        builder.addCase((0, $hIwjn.onboardingUpdateProfile).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $hIwjn.onboardingUpdateProfile).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // select genres
        builder.addCase((0, $hIwjn.onboardingUpdateGenres).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $hIwjn.onboardingUpdateGenres).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // get connect link
        builder.addCase((0, $hIwjn.onboardingGetConnectLink).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $hIwjn.onboardingGetConnectLink).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectLink: payload.connectLink,
                error: payload.error,
                loading: false
            }));
    }
});
const { onboardingSetError: $720b7f1df51f8d87$export$42ed5835b75dfec2 } = $720b7f1df51f8d87$export$b6177dfe2a583549.actions;
const $720b7f1df51f8d87$export$bd1d5b2cdc081f94 = (state)=>state.onboarding.step;
const $720b7f1df51f8d87$export$7fd9a685a7b05236 = (state)=>state.onboarding.connectLink;
const $720b7f1df51f8d87$export$6cdeab2c12935ae9 = (state)=>state.onboarding.error;
const $720b7f1df51f8d87$export$879fd1bbe61011a4 = (state)=>state.onboarding.loading;
const $720b7f1df51f8d87$export$4b19e5acc18169e1 = $720b7f1df51f8d87$export$b6177dfe2a583549.reducer; // export default onboardingSlice.reducer

});

parcelRegister("hIwjn", function(module, exports) {

$parcel$export(module.exports, "onboardingSetCurrentStep", function () { return $0054b83f18bb8791$export$802df2ef8e11c200; });
$parcel$export(module.exports, "onboardingSetNextStage", function () { return $0054b83f18bb8791$export$c28b048557b38e68; });
$parcel$export(module.exports, "onboardingSetPrevStage", function () { return $0054b83f18bb8791$export$6bc8ff36d21b8859; });
$parcel$export(module.exports, "onboardingUpdateRole", function () { return $0054b83f18bb8791$export$3e34293436e76993; });
$parcel$export(module.exports, "onboardingUpdateProfile", function () { return $0054b83f18bb8791$export$87335f1395fc90b2; });
$parcel$export(module.exports, "onboardingUpdateGenres", function () { return $0054b83f18bb8791$export$f002bc156cbabc67; });
$parcel$export(module.exports, "onboardingGetConnectLink", function () { return $0054b83f18bb8791$export$51345a47a25d6a2; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
var $vT5yJ = parcelRequire("vT5yJ");

var $eyozd = parcelRequire("eyozd");

var $jQ76R = parcelRequire("jQ76R");
const $0054b83f18bb8791$export$802df2ef8e11c200 = (0, $dEr3t.createAsyncThunk)("onboarding/onboardingSetCurrentStep", async (inp)=>{
    // get current onboarding step utilizing provided user role and onboarding stage
    const { currentOnboardingStep: currentOnboardingStep } = (0, $jQ76R.onboardingGetCurrentStep)(inp.userRole, inp.currentOnboardingStage);
    return {
        step: currentOnboardingStep,
        error: ""
    };
});
const $0054b83f18bb8791$export$c28b048557b38e68 = (0, $dEr3t.createAsyncThunk)("onboarding/onboardingSetNextStage", async (_, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get current user
    const { profile: profile } = getState().auth;
    // get current step
    const currentOnboardingStep = getState().onboarding.step;
    const userRole = profile?.role;
    const currentOnboardingStage = profile?.onboardingStage;
    const { nextOnboardingStage: nextOnboardingStage, nextOnboardingStep: nextOnboardingStep } = (0, $jQ76R.onboardingGetNextStage)(userRole, currentOnboardingStage, currentOnboardingStep);
    try {
        // update onboarding stage
        const { user: user } = await api.userApi.updateUserProfileOnboardingStage({
            onboardingStage: nextOnboardingStage
        });
        // update profile
        dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        // return payload
        return {
            step: nextOnboardingStep,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            step: currentOnboardingStep,
            error: message
        };
    }
});
const $0054b83f18bb8791$export$6bc8ff36d21b8859 = (0, $dEr3t.createAsyncThunk)("onboarding/onboardingSetPrevStage", async (_, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get current user
    const { profile: profile } = getState().auth;
    // get current step
    const currentOnboardingStep = getState().onboarding.step;
    const userRole = profile?.role;
    const currentOnboardingStage = profile?.onboardingStage;
    const { prevOnboardingStage: prevOnboardingStage, prevOnboardingStep: prevOnboardingStep } = (0, $jQ76R.onboardingGetPrevStage)(userRole, currentOnboardingStage, currentOnboardingStep);
    try {
        // update onboarding stage
        const { user: user } = await api.userApi.updateUserProfileOnboardingStage({
            onboardingStage: prevOnboardingStage
        });
        // update profile
        dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        // return payload
        return {
            step: prevOnboardingStep,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            step: currentOnboardingStep,
            error: message
        };
    }
});
const $0054b83f18bb8791$export$3e34293436e76993 = (0, $dEr3t.createAsyncThunk)("onboarding/onboardingUpdateRole", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // update user role
        const { user: user } = await api.userApi.updateUserProfileRole({
            role: inp.role
        });
        // refresh token
        const { token: freshToken } = await api.authApi.refreshToken();
        // update token in local storage
        (0, $vT5yJ.storageSetAuthToken)(freshToken);
        // update token in api service
        api.updateApiKey(freshToken);
        // update profile
        dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        // update onboarding stage
        dispatch($0054b83f18bb8791$export$c28b048557b38e68());
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $0054b83f18bb8791$export$87335f1395fc90b2 = (0, $dEr3t.createAsyncThunk)("onboarding/onboardingUpdateProfile", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // if avatar provided
        if (inp.avatar) {
            // create form data
            const formData = new FormData();
            // append avatar
            formData.append("file", inp.avatar);
            // update user avatar
            const { user: user } = await api.userApi.updateUserProfileAvatar({
                body: formData
            });
            // update profile
            dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        }
        // if name provided
        if (inp.name) {
            // update user name
            const { user: user } = await api.userApi.updateUserProfile({
                name: inp.name
            });
            // update profile
            dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        }
        // get current profile
        const { profile: profile } = getState().auth;
        // if user not have username and provided username
        if (inp.username && !profile?.username) {
            // check username availability
            const unRes = await api.userApi.getUserProfileUsernameAvailable(inp.username);
            // if username is not available
            if (!unRes.usernameAvailable) return {
                error: "this username is not available"
            };
            // update user username
            const { user: user } = await api.userApi.updateUserProfileUsername({
                username: inp.username
            });
            // update profile
            dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        }
        // update onboarding stage
        dispatch($0054b83f18bb8791$export$c28b048557b38e68());
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $0054b83f18bb8791$export$f002bc156cbabc67 = (0, $dEr3t.createAsyncThunk)("onboarding/onboardingUpdateGenres", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // update user preferred genres
        const { user: user } = await api.userApi.updateUserProfile({
            preferredGenres: inp.preferredGenres
        });
        // update profile
        dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        // update onboarding stage
        dispatch($0054b83f18bb8791$export$c28b048557b38e68());
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $0054b83f18bb8791$export$51345a47a25d6a2 = (0, $dEr3t.createAsyncThunk)("onboarding/onboardingGetConnectLink", async ()=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // get connect link
        const res = await api.connectApi.getConnectLink((0, $eyozd.ConnectLinkType).Onboarding);
        // return empty payload
        return {
            connectLink: res.link || "",
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            connectLink: "",
            error: message
        };
    }
});

});
parcelRegister("eyozd", function(module, exports) {

$parcel$export(module.exports, "OnboardingStep", function () { return $ed59273510bee862$export$4aeefa8fda57befc; });
$parcel$export(module.exports, "ConnectLinkType", function () { return $ed59273510bee862$export$372751fe44bf95e8; });
var $ed59273510bee862$export$4aeefa8fda57befc;
(function(OnboardingStep) {
    OnboardingStep[OnboardingStep["Initial"] = 0] = "Initial";
    OnboardingStep[OnboardingStep["First"] = 1] = "First";
    OnboardingStep[OnboardingStep["Second"] = 2] = "Second";
    OnboardingStep[OnboardingStep["Third"] = 3] = "Third";
    OnboardingStep[OnboardingStep["Fourth"] = 4] = "Fourth";
    OnboardingStep[OnboardingStep["Fifth"] = 5] = "Fifth";
    OnboardingStep[OnboardingStep["Sixth"] = 6] = "Sixth";
})($ed59273510bee862$export$4aeefa8fda57befc || ($ed59273510bee862$export$4aeefa8fda57befc = {}));
var $ed59273510bee862$export$372751fe44bf95e8;
(function(ConnectLinkType) {
    ConnectLinkType["Onboarding"] = "account_onboarding";
    ConnectLinkType["Update"] = "account_update";
})($ed59273510bee862$export$372751fe44bf95e8 || ($ed59273510bee862$export$372751fe44bf95e8 = {}));

});

parcelRegister("jQ76R", function(module, exports) {

$parcel$export(module.exports, "onboardingGetCurrentStep", function () { return $7b72018c4237cfd4$export$8f53d0172002b66d; });
$parcel$export(module.exports, "onboardingGetNextStage", function () { return $7b72018c4237cfd4$export$ba0b7075632a985a; });
$parcel$export(module.exports, "onboardingGetPrevStage", function () { return $7b72018c4237cfd4$export$2438ce0289ef0330; });
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");

var $eyozd = parcelRequire("eyozd");
const $7b72018c4237cfd4$export$8f53d0172002b66d = (userRole, currentOnboardingStage)=>{
    let currentOnboardingStep;
    // based on user role and current onboarding stage
    // assert current onboarding step
    switch(userRole){
        case (0, $aeAwZ.EntityUserRole).Fan:
            switch(currentOnboardingStage){
                case (0, $aeAwZ.EntityOnboardingStage).SelectRole:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Initial;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).CreateProfile:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).First;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).SelectGenres:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Second;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).FollowArtists:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Third;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Fourth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Fifth;
                    break;
                default:
                    return {
                        currentOnboardingStep: (0, $eyozd.OnboardingStep).Initial
                    };
            }
            break;
        case (0, $aeAwZ.EntityUserRole).Artist:
            switch(currentOnboardingStage){
                case (0, $aeAwZ.EntityOnboardingStage).SelectRole:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Initial;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).CreateProfile:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).First;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).UploadTracks:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Second;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).EnableMonetization:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Third;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Fourth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions:
                    currentOnboardingStep = (0, $eyozd.OnboardingStep).Fifth;
                    break;
                default:
                    return {
                        currentOnboardingStep: (0, $eyozd.OnboardingStep).Initial
                    };
            }
            break;
        default:
            return {
                currentOnboardingStep: (0, $eyozd.OnboardingStep).Initial
            };
    }
    return {
        currentOnboardingStep: currentOnboardingStep
    };
};
const $7b72018c4237cfd4$export$ba0b7075632a985a = (userRole, currentOnboardingStage, currentOnboardingStep)=>{
    let nextOnboardingStage;
    let nextOnboardingStep;
    // based on user role and current onboarding stage
    // assert next onboarding stage and onboarding step
    switch(userRole){
        case (0, $aeAwZ.EntityUserRole).Fan:
            switch(currentOnboardingStage){
                case (0, $aeAwZ.EntityOnboardingStage).SelectRole:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).CreateProfile;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).First;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).CreateProfile:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).SelectGenres;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Second;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).SelectGenres:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).FollowArtists;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Third;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).FollowArtists:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Fourth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Fifth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).Finished;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Sixth;
                    break;
                default:
                    return {
                        nextOnboardingStage: currentOnboardingStage,
                        nextOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        case (0, $aeAwZ.EntityUserRole).Artist:
            switch(currentOnboardingStage){
                case (0, $aeAwZ.EntityOnboardingStage).SelectRole:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).CreateProfile;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).First;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).CreateProfile:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).UploadTracks;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Second;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).UploadTracks:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).EnableMonetization;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Third;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).EnableMonetization:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Fourth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Fifth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions:
                    nextOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).Finished;
                    nextOnboardingStep = (0, $eyozd.OnboardingStep).Sixth;
                    break;
                default:
                    return {
                        nextOnboardingStage: currentOnboardingStage,
                        nextOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        default:
            return {
                nextOnboardingStage: currentOnboardingStage,
                nextOnboardingStep: currentOnboardingStep
            };
    }
    return {
        nextOnboardingStage: nextOnboardingStage,
        nextOnboardingStep: nextOnboardingStep
    };
};
const $7b72018c4237cfd4$export$2438ce0289ef0330 = (userRole, currentOnboardingStage, currentOnboardingStep)=>{
    let prevOnboardingStage;
    let prevOnboardingStep;
    // based on user role and current onboarding stage
    // assert prev onboarding stage and onboarding step
    switch(userRole){
        case (0, $aeAwZ.EntityUserRole).Fan:
            switch(currentOnboardingStage){
                case (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).Fourth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).FollowArtists;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).Third;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).FollowArtists:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).SelectGenres;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).Second;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).SelectGenres:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).CreateProfile;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).First;
                    break;
                default:
                    return {
                        prevOnboardingStage: currentOnboardingStage,
                        prevOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        case (0, $aeAwZ.EntityUserRole).Artist:
            switch(currentOnboardingStage){
                case (0, $aeAwZ.EntityOnboardingStage).AcceptTermsAndConditions:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).Fourth;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).ConfigureNotifications:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).EnableMonetization;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).Third;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).EnableMonetization:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).UploadTracks;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).Second;
                    break;
                case (0, $aeAwZ.EntityOnboardingStage).UploadTracks:
                    prevOnboardingStage = (0, $aeAwZ.EntityOnboardingStage).CreateProfile;
                    prevOnboardingStep = (0, $eyozd.OnboardingStep).First;
                    break;
                default:
                    return {
                        prevOnboardingStage: currentOnboardingStage,
                        prevOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        default:
            return {
                prevOnboardingStage: currentOnboardingStage,
                prevOnboardingStep: currentOnboardingStep
            };
    }
    return {
        prevOnboardingStage: prevOnboardingStage,
        prevOnboardingStep: prevOnboardingStep
    };
};

});



parcelRegister("1kSzD", function(module, exports) {

$parcel$export(module.exports, "PaymentModal", function () { return (parcelRequire("9QeaP")).PaymentModal; });
parcelRequire("7aGld");
var $9QeaP = parcelRequire("9QeaP");

var $3Mk3a = parcelRequire("3Mk3a");

var $j6i5c = parcelRequire("j6i5c");

var $BzF07 = parcelRequire("BzF07");
$parcel$exportWildcard(module.exports, $3Mk3a);
$parcel$exportWildcard(module.exports, $j6i5c);
$parcel$exportWildcard(module.exports, $BzF07);

});
parcelRegister("7aGld", function(module, exports) {

$parcel$export(module.exports, "PaymentModal", function () { return (parcelRequire("9QeaP")).PaymentModal; });

var $9QeaP = parcelRequire("9QeaP");

});
parcelRegister("9QeaP", function(module, exports) {

$parcel$export(module.exports, "PaymentModal", function () { return $400d27a9c8cbda05$export$3ff09aa788237818; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $j6i5c = parcelRequire("j6i5c");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("bHNED");
var $7kYGb = parcelRequire("7kYGb");

var $lxwjf = parcelRequire("lxwjf");
const $400d27a9c8cbda05$export$3ff09aa788237818 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const paymentModalOpen = (0, $9CcOD.useAppSelector)((0, $j6i5c.paymentSelectPaymentModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lxwjf.styles)().modal.main,
        children: paymentModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $j6i5c.paymentClosePaymentModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lxwjf.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7kYGb.PaymentCard), {})
            })
        })
    });
};
$400d27a9c8cbda05$export$3ff09aa788237818.propTypes = {};

});
parcelRegister("bHNED", function(module, exports) {

$parcel$export(module.exports, "PaymentCard", function () { return (parcelRequire("7kYGb")).PaymentCard; });

var $7kYGb = parcelRequire("7kYGb");

});
parcelRegister("7kYGb", function(module, exports) {

$parcel$export(module.exports, "PaymentCard", function () { return $3c5c9babf6b88e57$export$5af683685858e056; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $3UZjT = parcelRequire("3UZjT");
parcelRequire("dlJNO");
var $7Hbcq = parcelRequire("7Hbcq");
parcelRequire("2uUQU");
var $9VYkD = parcelRequire("9VYkD");
var $eJGWm = parcelRequire("eJGWm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $j6i5c = parcelRequire("j6i5c");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
parcelRequire("1SE81");
var $cckVl = parcelRequire("cckVl");
parcelRequire("2opDq");
var $gDm8g = parcelRequire("gDm8g");

var $6mgmP = parcelRequire("6mgmP");
const $3c5c9babf6b88e57$var$stripePromise = (0, $7Hbcq.loadStripe)("staging" === (0, $9VYkD.Environment).Production ? (0, $eJGWm.stripePublishableKeyProd) : (0, $eJGWm.stripePublishableKeyStag));
const $3c5c9babf6b88e57$export$5af683685858e056 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const clientSecret = (0, $9CcOD.useAppSelector)((0, $j6i5c.paymentSelectPaymentModalClientSecret));
    const paymentCreatePaymentError = "";
    const options = {
        clientSecret: clientSecret,
        appearance: (0, $cckVl.stripeAppearance)(theme)
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $6mgmP.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6mgmP.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $j6i5c.paymentClosePaymentModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $6mgmP.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $6mgmP.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3UZjT.Elements), {
                            stripe: $3c5c9babf6b88e57$var$stripePromise,
                            options: options,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gDm8g.PaymentForm), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $6mgmP.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: paymentCreatePaymentError
                        })
                    })
                ]
            })
        ]
    });
};
$3c5c9babf6b88e57$export$5af683685858e056.propTypes = {};

});
parcelRegister("2opDq", function(module, exports) {

$parcel$export(module.exports, "PaymentForm", function () { return (parcelRequire("gDm8g")).PaymentForm; });

var $gDm8g = parcelRequire("gDm8g");

});
parcelRegister("gDm8g", function(module, exports) {

$parcel$export(module.exports, "PaymentForm", function () { return $ddbe7363223aee4f$export$b6ded7c5f3fd9245; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $3UZjT = parcelRequire("3UZjT");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $4hysC = parcelRequire("4hysC");
var $BzF07 = parcelRequire("BzF07");
var $j6i5c = parcelRequire("j6i5c");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $fLw4A = parcelRequire("fLw4A");
var $1sbY5 = parcelRequire("1sbY5");

var $icOmE = parcelRequire("icOmE");
const $ddbe7363223aee4f$export$b6ded7c5f3fd9245 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const paymentCreatePaymentLoading = (0, $9CcOD.useAppSelector)((0, $j6i5c.paymentSelectPaymentCreatePaymentLoading));
    const paymentCreateDefaultPaymentLoading = (0, $9CcOD.useAppSelector)((0, $j6i5c.paymentSelectPaymentCreateDefaultPaymentLoading));
    const defaultPaymentMethod = (0, $9CcOD.useAppSelector)((0, $j6i5c.paymentSelectPaymentModalDefaultCustomerPaymentMethod));
    const { brand: brand, last4: last4 } = defaultPaymentMethod ?? {};
    const [useDefaultPaymentMethod, setUseDefaultPaymentMethod] = (0, $exYeM.useState)(!!defaultPaymentMethod);
    const stripe = (0, $3UZjT.useStripe)();
    const elements = (0, $3UZjT.useElements)();
    const paymentLoading = paymentCreatePaymentLoading || paymentCreateDefaultPaymentLoading;
    const submitDisabled = paymentLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $icOmE.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $icOmE.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                // if user has default payment method and wants to use it for payment
                if (defaultPaymentMethod && useDefaultPaymentMethod) // create default payment
                dispatch((0, $BzF07.paymentCreateDefaultPayment)({
                    stripe: stripe
                }));
                else // create payment with payment element
                dispatch((0, $BzF07.paymentCreatePayment)({
                    stripe: stripe,
                    elements: elements
                }));
            },
            children: [
                useDefaultPaymentMethod ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $icOmE.styles)().form.content.card,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4hysC.CustomerPaymentMethodDefault), {
                        brand: brand,
                        last4: last4
                    })
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $icOmE.styles)().form.content.card,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3UZjT.PaymentElement), {})
                }),
                defaultPaymentMethod && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $icOmE.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fLw4A.Checkbox), {
                            name: "use-default-payment-method",
                            label: "Use default payment method",
                            checked: useDefaultPaymentMethod,
                            disabled: paymentLoading,
                            onChange: (e)=>setUseDefaultPaymentMethod(e.target.checked)
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $icOmE.styles)().form.content.checkbox.label,
                            onClick: paymentLoading ? ()=>{} : ()=>setUseDefaultPaymentMethod((state)=>!state),
                            "aria-hidden": "true",
                            children: "Use default payment method"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $icOmE.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "checkout",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: paymentLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Checkout`
                    })
                })
            ]
        })
    });
};
$ddbe7363223aee4f$export$b6ded7c5f3fd9245.propTypes = {};

});
parcelRegister("icOmE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ccc73a0fbd77e7aa$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ccc73a0fbd77e7aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ccc73a0fbd77e7aa$var$_ref = {
    name: "18wktwv",
    styles: "display:flex;align-items:center;justify-content:left;margin-bottom:32px"
};
var $ccc73a0fbd77e7aa$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $ccc73a0fbd77e7aa$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                card: $ccc73a0fbd77e7aa$var$_ref2,
                checkbox: {
                    main: $ccc73a0fbd77e7aa$var$_ref,
                    label: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;font-size:", (0, $48E0n.typography).h6, ";user-select:none;margin-left:16px;", "")
                },
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("6mgmP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $301fe9fa43d269a9$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $301fe9fa43d269a9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $301fe9fa43d269a9$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $301fe9fa43d269a9$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $301fe9fa43d269a9$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $301fe9fa43d269a9$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $301fe9fa43d269a9$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $301fe9fa43d269a9$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $301fe9fa43d269a9$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $301fe9fa43d269a9$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $301fe9fa43d269a9$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($301fe9fa43d269a9$var$_ref8), " ", (0, $48E0n.mq).mobile($301fe9fa43d269a9$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($301fe9fa43d269a9$var$_ref6), ";", ""),
            title: $301fe9fa43d269a9$var$_ref5,
            subtitle: $301fe9fa43d269a9$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($301fe9fa43d269a9$var$_ref3), ";", ""),
                form: $301fe9fa43d269a9$var$_ref2,
                error: $301fe9fa43d269a9$var$_ref
            }
        }
    });

});



parcelRegister("lxwjf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2d4c9fc996940f67$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $2d4c9fc996940f67$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2d4c9fc996940f67$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $2d4c9fc996940f67$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($2d4c9fc996940f67$var$_ref), ";", "")
        }
    });

});



parcelRegister("3Mk3a", function(module, exports) {

$parcel$export(module.exports, "PaymentOperationType", function () { return $b672a094f74957bc$export$a9d3ed3ed13e41a3; });
var $b672a094f74957bc$export$a9d3ed3ed13e41a3;
(function(PaymentOperationType) {
    PaymentOperationType["Tip"] = "tip";
    PaymentOperationType["Subscription"] = "subscription";
    PaymentOperationType["PostUnlock"] = "post_unlock";
    PaymentOperationType["TrackUnlock"] = "track_unlock";
})($b672a094f74957bc$export$a9d3ed3ed13e41a3 || ($b672a094f74957bc$export$a9d3ed3ed13e41a3 = {}));

});

parcelRegister("j6i5c", function(module, exports) {

$parcel$export(module.exports, "paymentSlice", function () { return $7be1d337a86fa1cb$export$c99e1c5455ba6a3f; });
$parcel$export(module.exports, "paymentResetState", function () { return $7be1d337a86fa1cb$export$86d8df7797d1b519; });
$parcel$export(module.exports, "paymentOpenPaymentModal", function () { return $7be1d337a86fa1cb$export$78be0d48ae3cf851; });
$parcel$export(module.exports, "paymentClosePaymentModal", function () { return $7be1d337a86fa1cb$export$8d1e5b89d114f684; });
$parcel$export(module.exports, "paymentSelectPaymentModalOpen", function () { return $7be1d337a86fa1cb$export$31099d7429224230; });
$parcel$export(module.exports, "paymentSelectPaymentModalClientSecret", function () { return $7be1d337a86fa1cb$export$69491cbfbe624e40; });
$parcel$export(module.exports, "paymentSelectPaymentModalDefaultCustomerPaymentMethod", function () { return $7be1d337a86fa1cb$export$d9b5a57eab6c8137; });
$parcel$export(module.exports, "paymentSelectPaymentCreatePaymentLoading", function () { return $7be1d337a86fa1cb$export$78afbc418af41ea6; });
$parcel$export(module.exports, "paymentSelectPaymentCreateDefaultPaymentLoading", function () { return $7be1d337a86fa1cb$export$a12ef377435f930c; });
$parcel$export(module.exports, "paymentReducer", function () { return $7be1d337a86fa1cb$export$51709e6bb40a75d3; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $BzF07 = parcelRequire("BzF07");
const $7be1d337a86fa1cb$var$initialState = {
    paymentModal: {
        clientSecret: "",
        defaultCustomerPaymentMethod: undefined,
        operationType: undefined,
        operationSubject: undefined,
        open: false
    },
    paymentCreatePaymentLoading: false,
    paymentCreateDefaultPaymentLoading: false
};
const $7be1d337a86fa1cb$export$c99e1c5455ba6a3f = (0, $dEr3t.createSlice)({
    name: "payment",
    initialState: $7be1d337a86fa1cb$var$initialState,
    reducers: {
        // reset state
        paymentResetState: ()=>({
                paymentModal: {
                    clientSecret: "",
                    defaultCustomerPaymentMethod: undefined,
                    operationType: undefined,
                    operationSubject: undefined,
                    open: false
                },
                paymentCreatePaymentLoading: false,
                paymentCreateDefaultPaymentLoading: false
            }),
        // open payment modal
        paymentOpenPaymentModal: (state, action)=>({
                ...state,
                paymentModal: {
                    clientSecret: action.payload.clientSecret,
                    defaultCustomerPaymentMethod: action.payload.defaultCustomerPaymentMethod,
                    operationType: action.payload.operationType,
                    operationSubject: action.payload.operationSubject,
                    open: true
                }
            }),
        // close payment modal
        paymentClosePaymentModal: (state)=>({
                ...state,
                paymentModal: {
                    clientSecret: "",
                    defaultCustomerPaymentMethod: undefined,
                    operationType: undefined,
                    operationSubject: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // create payment
        builder.addCase((0, $BzF07.paymentCreatePayment).pending, (state)=>({
                ...state,
                paymentCreatePaymentLoading: true
            })).addCase((0, $BzF07.paymentCreatePayment).fulfilled, (state)=>({
                ...state,
                paymentCreatePaymentLoading: false
            }));
        // create default payment (payment utilizing default payment method)
        builder.addCase((0, $BzF07.paymentCreateDefaultPayment).pending, (state)=>({
                ...state,
                paymentCreateDefaultPaymentLoading: true
            })).addCase((0, $BzF07.paymentCreateDefaultPayment).fulfilled, (state)=>({
                ...state,
                paymentCreateDefaultPaymentLoading: false
            }));
    }
});
const { paymentResetState: $7be1d337a86fa1cb$export$86d8df7797d1b519, paymentOpenPaymentModal: $7be1d337a86fa1cb$export$78be0d48ae3cf851, paymentClosePaymentModal: $7be1d337a86fa1cb$export$8d1e5b89d114f684 } = $7be1d337a86fa1cb$export$c99e1c5455ba6a3f.actions;
const $7be1d337a86fa1cb$export$31099d7429224230 = (state)=>state.payment.paymentModal.open;
const $7be1d337a86fa1cb$export$69491cbfbe624e40 = (state)=>state.payment.paymentModal.clientSecret;
const $7be1d337a86fa1cb$export$d9b5a57eab6c8137 = (state)=>state.payment.paymentModal.defaultCustomerPaymentMethod;
const $7be1d337a86fa1cb$export$78afbc418af41ea6 = (state)=>state.payment.paymentCreatePaymentLoading;
const $7be1d337a86fa1cb$export$a12ef377435f930c = (state)=>state.payment.paymentCreateDefaultPaymentLoading;
const $7be1d337a86fa1cb$export$51709e6bb40a75d3 = $7be1d337a86fa1cb$export$c99e1c5455ba6a3f.reducer; // export default paymentSlice.reducer

});

parcelRegister("BzF07", function(module, exports) {

$parcel$export(module.exports, "paymentCreatePayment", function () { return $d73ca8cddf4f160a$export$d96f3783041f7c6e; });
$parcel$export(module.exports, "paymentCreateDefaultPayment", function () { return $d73ca8cddf4f160a$export$16d6e099535c8a19; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2uUQU");
var $9VYkD = parcelRequire("9VYkD");
var $8kVRe = parcelRequire("8kVRe");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $6VkZt = parcelRequire("6VkZt");
var $j6i5c = parcelRequire("j6i5c");
var $3Mk3a = parcelRequire("3Mk3a");
var $jhoVP = parcelRequire("jhoVP");
var $l1Cdj = parcelRequire("l1Cdj");
var $gfND9 = parcelRequire("gfND9");
var $1bnO9 = parcelRequire("1bnO9");
var $9vtCE = parcelRequire("9vtCE");
var $eFMHm = parcelRequire("eFMHm");
var $kkIKc = parcelRequire("kkIKc");
const $d73ca8cddf4f160a$export$d96f3783041f7c6e = (0, $dEr3t.createAsyncThunk)("payment/paymentCreatePayment", async (inp, { dispatch: dispatch, getState: getState })=>{
    // if stripe is not loaded
    if (!inp.stripe || !inp.elements) // return error message in payload
    return {
        error: "Stripe is failed to load"
    };
    // get client secret, operation type and operation subject
    const { operationType: operationType, operationSubject: operationSubject } = getState().payment.paymentModal;
    // define redirect url
    const redirectUrl = "staging" === (0, $9VYkD.Environment).Production ? (0, $8kVRe.Platform).ProductionURL : (0, $8kVRe.Platform).StagingURL;
    try {
        // confirm stripe payment
        const { error: error } = await inp.stripe.confirmPayment({
            elements: inp.elements,
            redirect: "if_required",
            confirmParams: {
                return_url: redirectUrl
            }
        });
        // if error returned
        if (error) {
            // launch error alert
            dispatch((0, $joOpk.alertAddMessage)({
                message: {
                    id: (0, $ij1oT.uuid)(),
                    type: (0, $ic5m0.AlertMessageType).Error,
                    message: `Payment failed: ${error.message}`
                }
            }));
            // return error message in payload
            return {
                error: error.message || ""
            };
        }
        // launch success alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: `Payment succeeded!`
            }
        }));
        // close payment modal
        dispatch((0, $j6i5c.paymentClosePaymentModal)());
        // reset transaction state
        dispatch((0, $9vtCE.transactionResetState)());
        // get notification state
        const { notification: notification } = getState().notification;
        // update application state based on operation type
        switch(operationType){
            // on tip operation type
            case (0, $3Mk3a.PaymentOperationType).Tip:
                // if notification exists - then tip payment was retried from notification view
                if (notification) dispatch((0, $6VkZt.notificationSetNotificationTipRetried)());
                break;
            // on subscription operation type
            case (0, $3Mk3a.PaymentOperationType).Subscription:
                // add subscription to user subscriptions
                dispatch((0, $gfND9.subscriptionAddUserSubscription)({
                    userId: operationSubject?.id || ""
                }));
                // append user to subscribed artists list
                dispatch((0, $kkIKc.userAppendSubscribedArtist)({
                    artist: operationSubject
                }));
                break;
            // on post unlock operation type
            case (0, $3Mk3a.PaymentOperationType).PostUnlock:
                // add unlock to post unlocks
                dispatch((0, $eFMHm.unlockAddPostUnlock)({
                    postId: operationSubject?.id || ""
                }));
                // append post to unlocked posts list
                dispatch((0, $l1Cdj.postAppendUnlockedPost)({
                    post: operationSubject
                }));
                // TODO:
                // - implement open unlocked post
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $6VkZt.notificationSetNotificationUnlockRetried)());
                break;
            // on track unlock operation type
            case (0, $3Mk3a.PaymentOperationType).TrackUnlock:
                // add unlock to track unlocks
                dispatch((0, $eFMHm.unlockAddTrackUnlock)({
                    trackId: operationSubject?.id || ""
                }));
                // append track to unlocked tracks list
                dispatch((0, $1bnO9.trackAppendUnlockedTrack)({
                    track: operationSubject
                }));
                // play unlocked track
                dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: operationSubject
                }));
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $6VkZt.notificationSetNotificationUnlockRetried)());
                break;
            default:
        }
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        // return error message in payload
        return {
            error: err.message || ""
        };
    }
});
const $d73ca8cddf4f160a$export$16d6e099535c8a19 = (0, $dEr3t.createAsyncThunk)("payment/paymentCreateDefaultPayment", async (inp, { dispatch: dispatch, getState: getState })=>{
    // if stripe is not loaded
    if (!inp.stripe) // return error message in payload
    return {
        error: "Stripe is failed to load"
    };
    // get client secret, operation type, and operation subject
    const { clientSecret: clientSecret, defaultCustomerPaymentMethod: defaultCustomerPaymentMethod, operationType: operationType, operationSubject: operationSubject } = getState().payment.paymentModal;
    try {
        // confirm stripe payment
        const { error: error } = await inp.stripe.confirmCardPayment(clientSecret, {
            payment_method: defaultCustomerPaymentMethod?.paymentMethodId
        });
        // if error returned
        if (error) {
            // launch error alert
            dispatch((0, $joOpk.alertAddMessage)({
                message: {
                    id: (0, $ij1oT.uuid)(),
                    type: (0, $ic5m0.AlertMessageType).Error,
                    message: `Payment failed: ${error.message}`
                }
            }));
            // return error message in payload
            return {
                error: error.message || ""
            };
        }
        // launch success alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: `Payment succeeded!`
            }
        }));
        // close payment modal
        dispatch((0, $j6i5c.paymentClosePaymentModal)());
        // reset transaction state
        dispatch((0, $9vtCE.transactionResetState)());
        // get notification state
        const { notification: notification } = getState().notification;
        // update application state based on operation type
        switch(operationType){
            // on tip operation type
            case (0, $3Mk3a.PaymentOperationType).Tip:
                // if notification exists - then tip payment was retried from notification view
                if (notification) dispatch((0, $6VkZt.notificationSetNotificationTipRetried)());
                break;
            // on subscription operation type
            case (0, $3Mk3a.PaymentOperationType).Subscription:
                // add subscription to user subscriptions
                dispatch((0, $gfND9.subscriptionAddUserSubscription)({
                    userId: operationSubject?.id || ""
                }));
                // append user to subscribed artists list
                dispatch((0, $kkIKc.userAppendSubscribedArtist)({
                    artist: operationSubject
                }));
                break;
            // on post unlock operation type
            case (0, $3Mk3a.PaymentOperationType).PostUnlock:
                // add unlock to post unlocks
                dispatch((0, $eFMHm.unlockAddPostUnlock)({
                    postId: operationSubject?.id || ""
                }));
                // append post to unlocked posts list
                dispatch((0, $l1Cdj.postAppendUnlockedPost)({
                    post: operationSubject
                }));
                // TODO:
                // - implement open unlocked post
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $6VkZt.notificationSetNotificationUnlockRetried)());
                break;
            // on track unlock operation type
            case (0, $3Mk3a.PaymentOperationType).TrackUnlock:
                // add unlock to track unlocks
                dispatch((0, $eFMHm.unlockAddTrackUnlock)({
                    trackId: operationSubject?.id || ""
                }));
                // append track to unlocked tracks list
                dispatch((0, $1bnO9.trackAppendUnlockedTrack)({
                    track: operationSubject
                }));
                // play unlocked track
                dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: operationSubject
                }));
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $6VkZt.notificationSetNotificationUnlockRetried)());
                break;
            default:
        }
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        // return error message in payload
        return {
            error: err.message || ""
        };
    }
});

});


parcelRegister("c3PRj", function(module, exports) {

$parcel$export(module.exports, "PlayerAudio", function () { return (parcelRequire("4Nzlb")).PlayerAudio; });
$parcel$export(module.exports, "PlayerAudioPlaylist", function () { return (parcelRequire("8f3t2")).PlayerAudioPlaylist; });
parcelRequire("5pWJP");
var $4Nzlb = parcelRequire("4Nzlb");
var $8f3t2 = parcelRequire("8f3t2");

var $jhoVP = parcelRequire("jhoVP");
$parcel$exportWildcard(module.exports, $jhoVP);

});
parcelRegister("5pWJP", function(module, exports) {

$parcel$export(module.exports, "PlayerAudio", function () { return (parcelRequire("4Nzlb")).PlayerAudio; });
$parcel$export(module.exports, "PlayerAudioPlaylist", function () { return (parcelRequire("8f3t2")).PlayerAudioPlaylist; });

var $4Nzlb = parcelRequire("4Nzlb");

var $8f3t2 = parcelRequire("8f3t2");

});
parcelRegister("4Nzlb", function(module, exports) {

$parcel$export(module.exports, "PlayerAudio", function () { return $40a105266553e055$export$778cf6b6a2da7a23; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");
var $hn1ob = parcelRequire("hn1ob");
parcelRequire("aUeN3");
var $aW612 = parcelRequire("aW612");
var $7tB1n = parcelRequire("7tB1n");
var $6PRHQ = parcelRequire("6PRHQ");
var $eN6Te = parcelRequire("eN6Te");

var $aY7Jv = parcelRequire("aY7Jv");
const $40a105266553e055$export$778cf6b6a2da7a23 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const isAudioRepeatActive = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectRepeat));
    const isAudioRandomActive = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectRandom));
    const playlistLength = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectPlaylistLength));
    const currentTrack = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrack));
    const currentTrackAction = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrackAction));
    // track
    const { id: currentTrackId, name: trackName, coverId: coverId, trackId: trackId, userId: trackAuthorUserId } = currentTrack ?? {};
    const trackHasCover = !!coverId;
    const coverSrc = (0, $hrd7b.useFile)(coverId || "");
    const audioSrc = (0, $hrd7b.useFile)(trackId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(trackAuthorUserId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const trackAuthorName = isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder;
    // refs
    const audioRef = (0, $exYeM.useRef)(null);
    // audio states
    const [audioDuration, setAudioDuration] = (0, $exYeM.useState)(0);
    const [audioProgress, setAudioProgress] = (0, $exYeM.useState)(0);
    const [audioBuffered, setAudioBuffered] = (0, $exYeM.useState)(0);
    // control states
    const [audioVolume, setAudioVolume] = (0, $exYeM.useState)(1);
    // on player touch states
    const [touchStartPosition, setTouchStartPosition] = (0, $exYeM.useState)({
        x: 0,
        y: 0
    });
    (0, $exYeM.useEffect)(()=>{
        // if media session present
        if ("mediaSession" in navigator) {
            // create media session metadata
            navigator.mediaSession.metadata = new MediaMetadata({
                title: trackName,
                artist: trackAuthorName,
                album: "-",
                artwork: trackHasCover ? [
                    {
                        src: coverSrc,
                        sizes: "96x96",
                        type: "image/webp"
                    }
                ] : undefined
            });
            navigator.mediaSession.setActionHandler("play", ()=>{
                // play functionality
                if (audioRef.current) audioRef.current.play();
            });
            navigator.mediaSession.setActionHandler("pause", ()=>{
                // pause functionality
                if (audioRef.current) audioRef.current.pause();
            });
            navigator.mediaSession.setActionHandler("previoustrack", ()=>{
                // prev functionality
                dispatch((0, $jhoVP.playerAudioSetPrevTrack)());
            });
            navigator.mediaSession.setActionHandler("nexttrack", ()=>{
                // next functionality
                dispatch((0, $jhoVP.playerAudioSetNextTrack)());
            });
        }
        return ()=>{
        // cleanup
        };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        currentTrack
    ]);
    const handleBufferProgress = (currentTime, duration, buffered)=>{
        // if duration is greater than 0
        if (duration > 0) {
            // iterate from 0 to buffered length
            for(let i = 0; i < buffered.length; i += 1)// if start time of the buffered range at the current index
            // is less than the current playback time
            if (buffered.start(buffered.length - 1 - i) < currentTime) {
                // calculate the end time of buffered range
                const bufferedLength = buffered.end(buffered.length - 1 - i);
                setAudioBuffered(bufferedLength);
                break;
            }
        }
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $aY7Jv.styles)(theme).player.main,
        onTouchStart: (e)=>{
            const { clientX: clientX, clientY: clientY } = e.changedTouches[0];
            setTouchStartPosition({
                x: clientX,
                y: clientY
            });
        },
        onTouchEnd: (e)=>{
            const { clientY: clientY } = e.changedTouches[0];
            // calculate touch distance
            const touchDistance = touchStartPosition.y - clientY;
            // set min touch threshold
            const minTouchThreshold = 100;
            // if touch distance is greater or equal min threshold
            if (touchDistance >= minTouchThreshold) dispatch((0, $jhoVP.playerAudioSetOpen)());
        },
        children: [
            currentTrack && /* eslint-disable-next-line jsx-a11y/media-has-caption */ /*#__PURE__*/ (0, $5o6z6.jsx)("audio", {
                ref: audioRef,
                preload: "metadata",
                // controls
                autoPlay: true,
                onDurationChange: (e)=>setAudioDuration(e.currentTarget.duration),
                onCanPlay: (e)=>{
                    dispatch((0, $jhoVP.playerAudioSetCurrentTrackReady)({
                        state: true
                    }));
                    e.currentTarget.volume = audioVolume;
                },
                onPlaying: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrackPlaying)({
                        state: true
                    })),
                onPause: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrackPlaying)({
                        state: false
                    })),
                onEnded: ()=>{
                    // create track stream
                    dispatch((0, $hn1ob.streamCreateTrackStream)({
                        track: currentTrack
                    }));
                    // if repeat active
                    if (isAudioRepeatActive) {
                        // repeat current song
                        dispatch((0, $jhoVP.playerAudioSetRepeatTrack)());
                        return;
                    }
                    // if random active
                    if (isAudioRandomActive) {
                        // play random song
                        dispatch((0, $jhoVP.playerAudioSetRandomTrack)());
                        return;
                    }
                    // if playlist length is greater than 1
                    if (playlistLength > 1) // play next track
                    dispatch((0, $jhoVP.playerAudioSetNextTrack)());
                },
                onTimeUpdate: (e)=>{
                    const { currentTime: currentTime, duration: duration, buffered: buffered } = e.currentTarget;
                    setAudioProgress(currentTime);
                    handleBufferProgress(currentTime, duration, buffered);
                },
                onProgress: (e)=>{
                    const { currentTime: currentTime, duration: duration, buffered: buffered } = e.currentTarget;
                    handleBufferProgress(currentTime, duration, buffered);
                },
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("source", {
                    type: "audio/mpeg",
                    src: audioSrc
                })
            }, `${currentTrackId}-${currentTrackAction}`),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $aY7Jv.styles)(theme).player.progress.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eN6Te.Progress), {
                    duration: audioDuration,
                    progress: audioProgress,
                    buffered: audioBuffered,
                    onChange: (e)=>{
                        // get current progress value
                        const progressValue = e.currentTarget.valueAsNumber;
                        // if audio ref
                        if (audioRef.current) // update progress value on audio ref
                        audioRef.current.currentTime = progressValue;
                        // update progress value state
                        setAudioProgress(progressValue);
                    }
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $aY7Jv.styles)(theme).player.panel.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $aY7Jv.styles)(theme).player.panel.audio.main,
                        children: currentTrack && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7tB1n.CurrentTrack), {
                            track: currentTrack,
                            trackAuthorName: trackAuthorName,
                            progress: audioProgress,
                            duration: audioDuration,
                            onAuthorNameClick: ()=>{
                                navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`);
                                dispatch((0, $jhoVP.playerAudioSetClosed)());
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $aY7Jv.styles)(theme).player.panel.controls.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $aW612.Controls), {
                            onPauseClick: ()=>{
                                // if audio ref
                                if (audioRef.current) // pause audio
                                audioRef.current.pause();
                            },
                            onPlayClick: ()=>{
                                // if audio ref
                                if (audioRef.current) // play audio
                                audioRef.current.play();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $aY7Jv.styles)(theme).player.panel.nav.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6PRHQ.Navigation), {
                            volume: audioVolume,
                            onVolumeChange: (e)=>{
                                // get current volume value
                                const volumeValue = e.currentTarget.valueAsNumber;
                                // if audio ref
                                if (audioRef.current) // update volume value on audio ref
                                audioRef.current.volume = volumeValue;
                                // update volume value state
                                setAudioVolume(volumeValue);
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$40a105266553e055$export$778cf6b6a2da7a23.propTypes = {}; // media loading process
 // loadstart - media loading has started and the browser is connecting to the media
 // durationchange - fires when the duration of the media is already available
 // loadedmetadata - fires when all media metadata has been loaded
 // loadeddata - this event is fired when the first bit of media arrives
 // progress - the event indicating that media downloading is still in progress
 // canplay - fires when the media is ready to be played
 // canplaythrough - this event lets us know that the media can be played all the way through

});
parcelRegister("aUeN3", function(module, exports) {

$parcel$export(module.exports, "Controls", function () { return (parcelRequire("aW612")).Controls; });
$parcel$export(module.exports, "CurrentTrack", function () { return (parcelRequire("7tB1n")).CurrentTrack; });
$parcel$export(module.exports, "Navigation", function () { return (parcelRequire("6PRHQ")).Navigation; });
$parcel$export(module.exports, "Progress", function () { return (parcelRequire("eN6Te")).Progress; });

var $aW612 = parcelRequire("aW612");

var $7tB1n = parcelRequire("7tB1n");

var $6PRHQ = parcelRequire("6PRHQ");

var $eN6Te = parcelRequire("eN6Te");

});
parcelRegister("aW612", function(module, exports) {

$parcel$export(module.exports, "Controls", function () { return $b814f473af09ca63$export$c7c44baae9d9f25f; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");
parcelRequire("fRVt8");
var $1sbY5 = parcelRequire("1sbY5");

var $8wFuI = parcelRequire("8wFuI");

var $571qj = parcelRequire("571qj");
const $b814f473af09ca63$export$c7c44baae9d9f25f = ({ onPauseClick: onPauseClick, onPlayClick: onPlayClick })=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const isAudioRepeatActive = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectRepeat));
    const isAudioRandomActive = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectRandom));
    const currentTrack = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrack));
    const currentTrackReady = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrackReady));
    const currentTrackPlaying = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrackPlaying));
    const renderPlayPauseControls = ()=>{
        // if track is set but is not loaded
        if (currentTrack && !currentTrackReady) // render loader
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $571qj.styles)(theme).controls.play.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                width: 30,
                height: 30,
                appearance: "secondary"
            })
        });
        // if track is playing - render pause button
        if (currentTrack && currentTrackPlaying) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $571qj.styles)(theme).controls.pause.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $571qj.styles)(theme).controls.pause.button,
                onClick: (e)=>onPauseClick(e),
                disabled: !currentTrackReady,
                type: "button",
                "aria-label": "pause audio",
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8wFuI.icons).AudioPause, {})
            })
        });
        // else render play button
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $571qj.styles)(theme).controls.play.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: (0, $571qj.styles)(theme).controls.play.button,
                onClick: (e)=>onPlayClick(e),
                disabled: !currentTrackReady,
                type: "button",
                "aria-label": "play audio",
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8wFuI.icons).AudioPlay, {})
            })
        });
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $571qj.styles)(theme).controls.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $571qj.styles)(theme).controls.repeat.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: [
                        (0, $571qj.styles)(theme).controls.repeat.button.shared,
                        isAudioRepeatActive ? (0, $571qj.styles)(theme).controls.repeat.button.active : (0, $571qj.styles)(theme).controls.repeat.button.inactive,
                        "",
                        ""
                    ],
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioToggleRepeat)()),
                    type: "button",
                    "aria-label": "activate repeat audio",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8wFuI.icons).AudioRepeat, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $571qj.styles)(theme).controls.prev.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $571qj.styles)(theme).controls.prev.button,
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetPrevTrack)()),
                    type: "button",
                    "aria-label": "set previous audio",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8wFuI.icons).AudioPrev, {})
                })
            }),
            renderPlayPauseControls(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $571qj.styles)(theme).controls.next.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $571qj.styles)(theme).controls.next.button,
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetNextTrack)()),
                    type: "button",
                    "aria-label": "set next audio",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8wFuI.icons).AudioNext, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $571qj.styles)(theme).controls.random.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: [
                        (0, $571qj.styles)(theme).controls.random.button.shared,
                        isAudioRandomActive ? (0, $571qj.styles)(theme).controls.random.button.active : (0, $571qj.styles)(theme).controls.random.button.inactive,
                        "",
                        ""
                    ],
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioToggleRandom)()),
                    type: "button",
                    "aria-label": "activate random audio",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8wFuI.icons).AudioRandom, {})
                })
            })
        ]
    });
};
$b814f473af09ca63$export$c7c44baae9d9f25f.propTypes = {};

});
parcelRegister("8wFuI", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $7aba0900086ba242$export$df03f54e09e486fa; });

var $cDIiA = parcelRequire("cDIiA");

var $7V57I = parcelRequire("7V57I");

var $9NU2j = parcelRequire("9NU2j");

var $uICXH = parcelRequire("uICXH");

var $alVAF = parcelRequire("alVAF");

var $hhBpr = parcelRequire("hhBpr");
const $7aba0900086ba242$export$df03f54e09e486fa = {
    AudioNext: $cDIiA.default,
    AudioPause: $7V57I.default,
    AudioPlay: $9NU2j.default,
    AudioPrev: $uICXH.default,
    AudioRandom: $alVAF.default,
    AudioRepeat: $hhBpr.default
};

});
parcelRegister("cDIiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $922e3903ebd44db4$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $922e3903ebd44db4$var$SvgAudioNext = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M11.7 4.837C14.567 7.029 16 8.125 16 10c0 1.875-1.433 2.97-4.3 5.163a40.949 40.949 0 0 1-2.297 1.65c-.633.416-1.35.847-2.091 1.27-2.86 1.63-4.29 2.446-5.572 1.543-1.283-.902-1.4-2.792-1.632-6.57A50.77 50.77 0 0 1 0 10c0-.94.042-1.987.108-3.055C.34 3.165.458 1.277 1.74.374 3.022-.529 4.452.287 7.312 1.917a38.95 38.95 0 0 1 2.091 1.27 40.96 40.96 0 0 1 2.297 1.65Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 2.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z",
                fill: "#FFF"
            })
        ]
    });
var $922e3903ebd44db4$export$2e2bcd8739ae039 = $922e3903ebd44db4$var$SvgAudioNext;

});

parcelRegister("7V57I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $860b238d38ac7f08$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $860b238d38ac7f08$var$SvgAudioPause = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M0 4C0 2.114 0 1.172.586.586 1.172 0 2.114 0 4 0c1.886 0 2.828 0 3.414.586C8 1.172 8 2.114 8 4v12c0 1.886 0 2.828-.586 3.414C6.828 20 5.886 20 4 20c-1.886 0-2.828 0-3.414-.586C0 18.828 0 17.886 0 16V4ZM12 4c0-1.886 0-2.828.586-3.414C13.172 0 14.114 0 16 0c1.886 0 2.828 0 3.414.586C20 1.172 20 2.114 20 4v12c0 1.886 0 2.828-.586 3.414C18.828 20 17.886 20 16 20c-1.886 0-2.828 0-3.414-.586C12 18.828 12 17.886 12 16V4Z",
            fill: "#FFF"
        })
    });
var $860b238d38ac7f08$export$2e2bcd8739ae039 = $860b238d38ac7f08$var$SvgAudioPause;

});

parcelRegister("9NU2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $310c944f31f99878$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $310c944f31f99878$var$SvgAudioPlay = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            d: "M13.163 4.837C16.388 7.03 18 8.125 18 10c0 1.875-1.612 2.97-4.837 5.163a46.431 46.431 0 0 1-2.585 1.65c-.711.416-1.518.847-2.352 1.27-3.217 1.63-4.826 2.446-6.269 1.543-1.442-.902-1.574-2.792-1.836-6.57A45.156 45.156 0 0 1 0 10c0-.94.047-1.987.121-3.055.262-3.779.394-5.668 1.836-6.57C3.4-.529 5.01.286 8.226 1.916c.834.423 1.64.854 2.352 1.27a46.385 46.385 0 0 1 2.585 1.65Z",
            fill: "#FFF"
        })
    });
var $310c944f31f99878$export$2e2bcd8739ae039 = $310c944f31f99878$var$SvgAudioPlay;

});

parcelRegister("uICXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c94db3a7e9e4c2e1$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $c94db3a7e9e4c2e1$var$SvgAudioPrev = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M9.3 4.837C6.433 7.029 5 8.125 5 10c0 1.875 1.433 2.97 4.3 5.163a40.96 40.96 0 0 0 2.297 1.65c.633.416 1.35.847 2.091 1.27 2.86 1.63 4.29 2.446 5.572 1.543 1.283-.902 1.4-2.792 1.632-6.57.066-1.07.108-2.117.108-3.056 0-.94-.042-1.987-.108-3.055-.233-3.78-.35-5.668-1.632-6.571-1.282-.903-2.712-.087-5.572 1.543a38.94 38.94 0 0 0-2.091 1.27A40.97 40.97 0 0 0 9.3 4.837Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1 2.25A.75.75 0 0 0 .25 3v15a.75.75 0 0 0 1.5 0V3A.75.75 0 0 0 1 2.25Z",
                fill: "#FEFEFE"
            })
        ]
    });
var $c94db3a7e9e4c2e1$export$2e2bcd8739ae039 = $c94db3a7e9e4c2e1$var$SvgAudioPrev;

});

parcelRegister("alVAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $889e0670ba00868d$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $889e0670ba00868d$var$SvgAudioRandom = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.974.976a.6.6 0 0 1 .849 0l1.6 1.6a.6.6 0 0 1 0 .848l-1.6 1.6a.6.6 0 1 1-.849-.848l.576-.576h-1.434c-.675 0-1.139 0-1.504.036-.352.034-.565.097-.742.197-.176.1-.34.25-.55.535-.219.294-.458.692-.805 1.27L8.496 9.004c-.329.548-.597.996-.854 1.343-.269.363-.55.653-.924.864-.374.212-.768.304-1.217.348-.43.042-.952.042-1.591.042H.998a.6.6 0 1 1 0-1.2h2.883c.675 0 1.139 0 1.504-.036.352-.035.565-.098.741-.198.177-.1.34-.25.551-.534.219-.295.458-.692.805-1.271l2.019-3.365c.328-.547.597-.995.854-1.342.269-.363.55-.653.924-.865.374-.211.768-.304 1.217-.347.43-.042.952-.042 1.591-.042h1.463l-.576-.576a.6.6 0 0 1 0-.848Zm-9.39 2.657c-.157-.03-.335-.033-.851-.033H.998a.6.6 0 1 1 0-1.2H4.791c.436 0 .737 0 1.022.055a3 3 0 0 1 1.657.938c.194.216.349.474.573.848l.03.05a.6.6 0 1 1-1.03.617c-.265-.442-.358-.593-.465-.712a1.8 1.8 0 0 0-.995-.563Zm4.546 5.252a.6.6 0 0 1 .823.206c.266.443.36.594.466.713.262.29.61.488.994.563.157.03.335.033.851.033h2.286l-.576-.576a.6.6 0 0 1 .849-.848l1.6 1.6a.6.6 0 0 1 0 .848l-1.6 1.6a.6.6 0 1 1-.849-.848l.576-.576h-2.344c-.436 0-.737 0-1.022-.056a3 3 0 0 1-1.657-.938c-.194-.215-.349-.473-.573-.848l-.03-.05a.6.6 0 0 1 .206-.823Z",
            fill: "#FFF"
        })
    });
var $889e0670ba00868d$export$2e2bcd8739ae039 = $889e0670ba00868d$var$SvgAudioRandom;

});

parcelRegister("hhBpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2fe35c0c638ab4d$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $e2fe35c0c638ab4d$var$SvgAudioRepeat = (props)=>/*#__PURE__*/ (0, $5o6z6.jsx)("svg", {
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.174.376a.6.6 0 0 1 .849 0l1.6 1.6A.6.6 0 0 1 8.198 3h-1.6a5 5 0 1 0 0 10h.4a.6.6 0 1 1 0 1.2h-.4a6.2 6.2 0 0 1 0-12.4h.152l-.576-.576a.6.6 0 0 1 0-.848ZM10.398 2.4a.6.6 0 0 1 .6-.6h.4a6.2 6.2 0 1 1 0 12.4h-.151l.576.576a.6.6 0 0 1-.849.848l-1.6-1.6A.6.6 0 0 1 9.798 13h1.6a5 5 0 1 0 0-10h-.4a.6.6 0 0 1-.6-.6Z",
            fill: "#FEFEFE"
        })
    });
var $e2fe35c0c638ab4d$export$2e2bcd8739ae039 = $e2fe35c0c638ab4d$var$SvgAudioRepeat;

});


parcelRegister("571qj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c306957dbce5bafa$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c306957dbce5bafa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c306957dbce5bafa$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $c306957dbce5bafa$var$_ref2 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $c306957dbce5bafa$var$_ref3 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $c306957dbce5bafa$var$_ref4 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $c306957dbce5bafa$var$_ref5 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $c306957dbce5bafa$var$_ref6 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $c306957dbce5bafa$var$_ref7 = {
    name: "1k0ud4i",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;&>div:not(:last-of-type){margin-right:24px;}"
};
const $c306957dbce5bafa$export$9dd6ff9ea0189349 = (theme)=>({
        controls: {
            main: $c306957dbce5bafa$var$_ref7,
            repeat: {
                main: $c306957dbce5bafa$var$_ref6,
                button: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    active: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    inactive: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                }
            },
            prev: {
                main: $c306957dbce5bafa$var$_ref5,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            play: {
                main: $c306957dbce5bafa$var$_ref4,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            pause: {
                main: $c306957dbce5bafa$var$_ref3,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            next: {
                main: $c306957dbce5bafa$var$_ref2,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            random: {
                main: $c306957dbce5bafa$var$_ref,
                button: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    active: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    inactive: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                }
            }
        }
    });

});


parcelRegister("7tB1n", function(module, exports) {

$parcel$export(module.exports, "CurrentTrack", function () { return $e71ea5112dd93be5$export$f01c3456559809ce; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $fnSQq = parcelRequire("fnSQq");
const $e71ea5112dd93be5$export$f01c3456559809ce = ({ track: track, trackAuthorName: trackAuthorName, progress: progress, duration: duration, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    // track
    const { coverId: coverId, name: trackName } = track ?? {};
    const trackHasCover = !!coverId;
    const coverSrc = (0, $hrd7b.useFile)(coverId || "");
    const elapsedTime = (0, $fJerj.audioDurationFormatter)(progress);
    const durationTime = (0, $fJerj.audioDurationFormatter)(duration);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $fnSQq.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $fnSQq.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $fnSQq.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "56px",
                    height: "56px",
                    src: coverSrc,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $fnSQq.styles)(theme).track.cover.placeholder,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $fnSQq.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $fnSQq.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $fnSQq.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: trackAuthorName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $fnSQq.styles)(theme).track.description.duration,
                        children: [
                            elapsedTime,
                            " / ",
                            durationTime
                        ]
                    })
                ]
            })
        ]
    });
};
$e71ea5112dd93be5$export$f01c3456559809ce.propTypes = {};

});
parcelRegister("fnSQq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0ac0a1463f863b30$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $0ac0a1463f863b30$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0ac0a1463f863b30$var$_ref = {
    name: "1ojnsow",
    styles: "display:flex;flex-direction:column;min-width:0"
};
var $0ac0a1463f863b30$var$_ref2 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $0ac0a1463f863b30$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $0ac0a1463f863b30$var$_ref2,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:56px;height:56px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $0ac0a1463f863b30$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                duration: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
            }
        }
    });

});


parcelRegister("6PRHQ", function(module, exports) {

$parcel$export(module.exports, "Navigation", function () { return $9eab2374d55e6922$export$b8a61e5c71402559; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");

var $59Td7 = parcelRequire("59Td7");

var $3AJGf = parcelRequire("3AJGf");
const $9eab2374d55e6922$export$b8a61e5c71402559 = ({ volume: volume, onVolumeChange: onVolumeChange })=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const isAudioPlayerOpen = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectOpen));
    const [isVolumeOpen, setIsVolumeOpen] = (0, $exYeM.useState)(false);
    const label = "Audio Player Volume";
    const name = "audio-player-progress";
    const renderVolumeIcon = ()=>{
        // if volume is muted
        if (volume === 0) // render muted icon
        return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $59Td7.icons).AudioVolumeMute, {});
        // if volume is low
        if (volume <= 0.5) // render min icon
        return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $59Td7.icons).AudioVolumeMin, {});
        // else render max icon
        return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $59Td7.icons).AudioVolumeMax, {});
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $3AJGf.styles)(theme).nav.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $3AJGf.styles)(theme).nav.volume.main,
                onMouseLeave: ()=>setIsVolumeOpen(false),
                children: [
                    isVolumeOpen && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $3AJGf.styles)(theme).nav.volume.control.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                                css: (0, $3AJGf.styles)(theme).nav.volume.control.label,
                                htmlFor: name,
                                children: label
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                css: (0, $3AJGf.styles)(theme).nav.volume.control.input(volume * 100),
                                "aria-label": "audio player volume",
                                id: name,
                                name: name,
                                type: "range",
                                min: 0,
                                step: 0.05,
                                max: 1,
                                value: volume,
                                onChange: (e)=>onVolumeChange(e)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: [
                            (0, $3AJGf.styles)(theme).nav.volume.button.shared,
                            isVolumeOpen ? (0, $3AJGf.styles)(theme).nav.volume.button.open : (0, $3AJGf.styles)(theme).nav.volume.button.closed,
                            "",
                            ""
                        ],
                        onClick: ()=>setIsVolumeOpen((state)=>!state),
                        type: "button",
                        "aria-label": "open audio volume control",
                        children: renderVolumeIcon()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $3AJGf.styles)(theme).nav.open.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: [
                        (0, $3AJGf.styles)(theme).nav.open.button.shared,
                        isAudioPlayerOpen ? (0, $3AJGf.styles)(theme).nav.open.button.open : (0, $3AJGf.styles)(theme).nav.open.button.closed,
                        "",
                        ""
                    ],
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioToggleOpen)()),
                    type: "button",
                    "aria-label": "open audio player",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $59Td7.icons).AudioNav, {})
                })
            })
        ]
    });
};
$9eab2374d55e6922$export$b8a61e5c71402559.propTypes = {};

});
parcelRegister("59Td7", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $67a72a09f85aea79$export$df03f54e09e486fa; });

var $2Fr4U = parcelRequire("2Fr4U");

var $hRWj7 = parcelRequire("hRWj7");

var $32mrX = parcelRequire("32mrX");

var $gS0Rz = parcelRequire("gS0Rz");
const $67a72a09f85aea79$export$df03f54e09e486fa = {
    AudioNav: $2Fr4U.default,
    AudioVolumeMax: $hRWj7.default,
    AudioVolumeMin: $32mrX.default,
    AudioVolumeMute: $gS0Rz.default
};

});
parcelRegister("2Fr4U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3e4957ee5eda81c$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $f3e4957ee5eda81c$var$SvgAudioNav = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.25 1A.75.75 0 0 1 1 .25h18a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 1Zm0 4A.75.75 0 0 1 1 4.25h18a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 5Zm0 4A.75.75 0 0 1 1 8.25h8a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 9Zm0 4a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 13Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M16.875 9.118c1.654.955 2.48 1.433 2.602 2.121a1.5 1.5 0 0 1 0 .521c-.121.69-.948 1.167-2.602 2.122-1.654.954-2.48 1.432-3.138 1.193a1.499 1.499 0 0 1-.451-.26c-.536-.45-.536-1.405-.536-3.315s0-2.865.536-3.314a1.5 1.5 0 0 1 .451-.26c.657-.24 1.484.238 3.138 1.192Z",
                fill: "#FFF"
            })
        ]
    });
var $f3e4957ee5eda81c$export$2e2bcd8739ae039 = $f3e4957ee5eda81c$var$SvgAudioNav;

});

parcelRegister("hRWj7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0c43eeab7d8de6$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $fb0c43eeab7d8de6$var$SvgAudioVolumeMax = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M.003 7.715C.04 5.873.059 4.952.671 4.164c.112-.144.275-.315.413-.431.752-.636 1.746-.636 3.733-.636.71 0 1.065 0 1.403-.092.07-.02.14-.042.209-.067.33-.121.627-.33 1.22-.746C9.987.547 11.156-.275 12.138.082c.188.069.37.168.533.29.848.635.913 2.115 1.042 5.073A71.13 71.13 0 0 1 13.793 8c0 .522-.032 1.46-.08 2.555-.13 2.958-.194 4.438-1.042 5.073-.163.122-.345.221-.533.29-.982.357-2.15-.465-4.49-2.11-.592-.416-.889-.625-1.22-.746a2.61 2.61 0 0 0-.208-.066c-.338-.093-.693-.093-1.403-.093-1.987 0-2.98 0-3.733-.636a3.145 3.145 0 0 1-.413-.43c-.612-.79-.63-1.71-.668-3.552a14.06 14.06 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.49 1.552a.66.66 0 0 1 .97.094l-.529.471.53-.47.002.002.003.004.007.009a2.572 2.572 0 0 1 .079.112c.047.071.111.173.186.305.149.264.339.652.526 1.171C19.64 4.291 20 5.851 20 8c0 2.15-.36 3.71-.736 4.75-.187.52-.377.907-.526 1.172a4.655 4.655 0 0 1-.265.417l-.007.009-.003.003-.001.002s-.001.001-.531-.47l.53.471a.66.66 0 0 1-.971.094.77.77 0 0 1-.09-1.035l.03-.041c.026-.04.07-.11.125-.207a6.28 6.28 0 0 0 .422-.943c.314-.871.644-2.252.644-4.222 0-1.97-.33-3.35-.644-4.222a6.28 6.28 0 0 0-.422-.942 3.152 3.152 0 0 0-.157-.253M15.757 4.416c.333-.197.753-.07.938.286l-.603.357.603-.357v.001l.001.001.002.003.003.007.01.018.024.053c.018.042.042.099.07.17.053.145.12.35.185.62.13.54.252 1.337.252 2.425 0 1.089-.122 1.886-.252 2.426-.065.27-.132.475-.186.619a3.04 3.04 0 0 1-.094.223l-.009.018-.003.007-.002.003v.002s-.001.001-.604-.356l.603.357c-.185.355-.605.483-.938.286-.33-.196-.45-.638-.272-.991l.004-.01.035-.085c.032-.086.08-.23.13-.438.1-.416.208-1.09.208-2.06 0-.971-.108-1.645-.208-2.06a3.757 3.757 0 0 0-.165-.524l-.004-.01c-.179-.354-.058-.795.272-.991Z",
                fill: "#FFF"
            })
        ]
    });
var $fb0c43eeab7d8de6$export$2e2bcd8739ae039 = $fb0c43eeab7d8de6$var$SvgAudioVolumeMax;

});

parcelRegister("32mrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6fe6a116ab6fa0c$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $b6fe6a116ab6fa0c$var$SvgAudioVolumeMin = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M.003 7.715C.043 5.873.062 4.952.7 4.164c.117-.144.288-.315.432-.431.785-.636 1.822-.636 3.897-.636.741 0 1.112 0 1.465-.092.073-.02.146-.042.218-.067.345-.121.654-.33 1.273-.746C10.427.547 11.647-.275 12.672.082c.196.069.387.168.556.29.886.635.954 2.115 1.088 5.073.05 1.096.084 2.033.084 2.555 0 .522-.034 1.46-.084 2.555-.135 2.958-.202 4.438-1.088 5.073-.17.122-.36.221-.556.29-1.025.357-2.245-.465-4.687-2.11-.619-.416-.928-.625-1.273-.746a2.815 2.815 0 0 0-.218-.066c-.353-.093-.724-.093-1.465-.093-2.075 0-3.112 0-3.897-.636a3.21 3.21 0 0 1-.432-.43c-.638-.79-.658-1.71-.697-3.552a13.468 13.468 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.45 4.416a.712.712 0 0 1 .98.286l-.63.357.63-.357v.002l.002.003.004.007.01.018a1.975 1.975 0 0 1 .098.224c.056.144.126.349.193.619.136.54.263 1.337.263 2.425 0 1.089-.127 1.886-.263 2.426-.067.27-.137.475-.193.619a2.921 2.921 0 0 1-.099.223l-.009.018-.004.007-.001.003v.002s-.002.001-.631-.356l.63.357a.712.712 0 0 1-.98.286.744.744 0 0 1-.284-.991l.005-.01c.006-.014.019-.043.035-.085.034-.086.084-.23.137-.438.104-.416.217-1.09.217-2.06 0-.971-.113-1.645-.217-2.06a3.657 3.657 0 0 0-.172-.524l-.005-.01a.744.744 0 0 1 .284-.991Z",
                fill: "#FFF"
            })
        ]
    });
var $b6fe6a116ab6fa0c$export$2e2bcd8739ae039 = $b6fe6a116ab6fa0c$var$SvgAudioVolumeMin;

});

parcelRegister("gS0Rz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $705caf5f41afebcd$export$2e2bcd8739ae039; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("exYeM");
const $705caf5f41afebcd$var$SvgAudioVolumeMute = (props)=>/*#__PURE__*/ (0, $5o6z6.jsxs)("svg", {
        viewBox: "0 0 21 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                d: "M.003 7.715c.04-1.842.06-2.763.718-3.551.12-.144.296-.315.444-.431.809-.636 1.876-.636 4.012-.636.763 0 1.144 0 1.508-.092.076-.02.15-.042.224-.067.355-.121.674-.33 1.31-.746C10.734.547 11.99-.275 13.046.082c.202.069.398.168.573.29.911.635.98 2.115 1.12 5.073.05 1.096.085 2.033.085 2.555a66.3 66.3 0 0 1-.086 2.555c-.138 2.958-.208 4.438-1.12 5.073-.174.122-.37.221-.572.29-1.055.357-2.312-.465-4.825-2.11-.637-.416-.956-.625-1.31-.746a2.962 2.962 0 0 0-.225-.066c-.364-.093-.745-.093-1.508-.093-2.136 0-3.203 0-4.012-.636a3.259 3.259 0 0 1-.444-.43c-.658-.79-.678-1.71-.718-3.552a13.084 13.084 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.782 5.52a.745.745 0 0 1 1.048 0l1.452 1.44 1.453-1.44a.745.745 0 0 1 1.048 0c.29.286.29.752 0 1.04L19.33 8l1.453 1.441c.29.287.29.753 0 1.04a.745.745 0 0 1-1.048 0l-1.453-1.44-1.452 1.44a.745.745 0 0 1-1.048 0 .731.731 0 0 1 0-1.04l1.452-1.44-1.452-1.442a.731.731 0 0 1 0-1.04Z",
                fill: "#FFF"
            })
        ]
    });
var $705caf5f41afebcd$export$2e2bcd8739ae039 = $705caf5f41afebcd$var$SvgAudioVolumeMute;

});


parcelRegister("3AJGf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5d6ed490ec431253$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $5d6ed490ec431253$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5d6ed490ec431253$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $5d6ed490ec431253$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
var $5d6ed490ec431253$var$_ref3 = {
    name: "1xuln4b",
    styles: "position:relative;width:30px;height:30px"
};
var $5d6ed490ec431253$var$_ref4 = {
    name: "1sgy8tm",
    styles: "display:flex;align-items:center;justify-content:flex-end;height:100%;&>div:not(:last-of-type){margin-right:24px;}"
};
const $5d6ed490ec431253$export$9dd6ff9ea0189349 = (theme)=>({
        nav: {
            main: $5d6ed490ec431253$var$_ref4,
            volume: {
                main: $5d6ed490ec431253$var$_ref3,
                button: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    open: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    closed: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                },
                control: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;right:-220%;top:-328%;background-color:", theme.colors.primary.darker, ";padding:8px 12px;border-radius:4px;width:160px;height:36px;transform:rotate(-90deg);", ""),
                    label: $5d6ed490ec431253$var$_ref2,
                    input: (volumeWidthPercent)=>/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:20px;appearance:none;-webkit-appearance:none;background:transparent;cursor:pointer;&::-webkit-slider-runnable-track{background:linear-gradient(\n              to right,\n              ", theme.colors.accent.normal, " 0% ", volumeWidthPercent, "%,\n              ", theme.colors.secondary.normal, " ", volumeWidthPercent, "%\n                ", 100 - volumeWidthPercent, "%\n            );height:4px;}&::-moz-range-track{background:linear-gradient(\n              to right,\n              ", theme.colors.accent.normal, " 0% ", volumeWidthPercent, "%,\n              ", theme.colors.secondary.normal, " ", volumeWidthPercent, "%\n                ", 100 - volumeWidthPercent, "%\n            );height:4px;}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;margin-top:-6px;height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}&::-moz-range-thumb{height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}", "")
                }
            },
            open: {
                main: $5d6ed490ec431253$var$_ref,
                button: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    open: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    closed: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                }
            }
        }
    });

});


parcelRegister("eN6Te", function(module, exports) {

$parcel$export(module.exports, "Progress", function () { return $ff4e350ad70e1126$export$b25a304ec7d746bb; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $gxHtR = parcelRequire("gxHtR");
const $ff4e350ad70e1126$export$b25a304ec7d746bb = ({ duration: duration, progress: progress, buffered: buffered, ...attributes })=>{
    const theme = (0, $hXJcm.u)();
    const progressWidth = Number.isNaN(progress / duration) ? 0 : progress / duration;
    const progressWidthPercent = (progressWidth + 0.0018) * 100;
    // const progressWidthPercent = Math.round(progressWidth * 100)
    // const bufferedWidth = Number.isNaN(buffered / duration) ? 0 : buffered / duration
    // const bufferedWidthPercent = Math.round(bufferedWidth * 100)
    const label = "Audio Player Progress";
    const name = "audio-player-progress";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $gxHtR.styles)(theme).progress.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("label", {
                css: (0, $gxHtR.styles)(theme).progress.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                css: (0, $gxHtR.styles)(theme).progress.input(progressWidthPercent),
                id: name,
                name: name,
                type: "range",
                min: 0,
                max: duration,
                value: progress,
                ...attributes
            })
        ]
    });
};
$ff4e350ad70e1126$export$b25a304ec7d746bb.propTypes = {};

});
parcelRegister("gxHtR", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $406502a1544daec4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $406502a1544daec4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $406502a1544daec4$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $406502a1544daec4$var$_ref2 = {
    name: "xb48oe",
    styles: "position:relative;height:100%;top:-6px"
};
const $406502a1544daec4$export$9dd6ff9ea0189349 = (theme)=>({
        progress: {
            main: $406502a1544daec4$var$_ref2,
            label: $406502a1544daec4$var$_ref,
            input: (progressWidthPercent)=>/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100.2%;height:16px;appearance:none;-webkit-appearance:none;background:transparent;cursor:pointer;&::-webkit-slider-runnable-track{background:linear-gradient(\n          to right,\n          ", theme.colors.accent.normal, " 0% ", progressWidthPercent, "%,\n          ", theme.colors.secondary.normal, " ", progressWidthPercent, "%\n            ", 100 - progressWidthPercent, "%\n        );height:4px;}&::-moz-range-track{background:linear-gradient(\n          to right,\n          ", theme.colors.accent.normal, " 0% ", progressWidthPercent, "%,\n          ", theme.colors.secondary.normal, " ", progressWidthPercent, "%\n            ", 100 - progressWidthPercent, "%\n        );height:4px;}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;margin-top:-8px;height:20px;width:20px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}&::-moz-range-thumb{height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}", "")
        }
    }); /*

(scale: number) => css`
      position: absolute;
      left: 0;
      top: 6px;

      background-color: red;

      height: 100%;
      width: 100%;

      transform: scaleX(${scale});
      transform-origin: left;
    `,

*/ 

});



parcelRegister("aY7Jv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $53397c296af908ec$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $53397c296af908ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $53397c296af908ec$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $53397c296af908ec$var$_ref2 = {
    name: "2et80v",
    styles: "margin-left:30px"
};
var $53397c296af908ec$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $53397c296af908ec$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $53397c296af908ec$var$_ref5 = {
    name: "1yrybnr",
    styles: "&>div{display:none;}"
};
var $53397c296af908ec$var$_ref6 = {
    name: "9b9j84",
    styles: "height:4%"
};
const $53397c296af908ec$export$9dd6ff9ea0189349 = (theme)=>({
        player: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.player.height, ";", (0, $48E0n.helpers).app.player.width, ";position:relative;z-index:", (0, $48E0n.z).features.audio.player, ";display:flex;flex-direction:column;background-color:", theme.colors.primary.darker, ";", ""),
            progress: {
                main: $53397c296af908ec$var$_ref6
            },
            panel: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.sides, ";display:flex;display:flex;height:94%;", ""),
                audio: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("width:33.333%;display:flex;align-items:center;justify-content:flex-start;", (0, $48E0n.mq).tablet($53397c296af908ec$var$_ref5), " ", (0, $48E0n.mq).mobile($53397c296af908ec$var$_ref4), ";", "")
                },
                controls: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("width:246px;margin:0 auto;", (0, $48E0n.mq).mobile($53397c296af908ec$var$_ref3), ";", "")
                },
                nav: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("width:33.333%;margin-left:10px;", (0, $48E0n.mq).tablet($53397c296af908ec$var$_ref2), " ", (0, $48E0n.mq).mobile($53397c296af908ec$var$_ref), ";", "")
                }
            }
        }
    });

});


parcelRegister("8f3t2", function(module, exports) {

$parcel$export(module.exports, "PlayerAudioPlaylist", function () { return $899d73a4034889b6$export$5402ad09f300f963; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");
var $bR4Bv = parcelRequire("bR4Bv");
var $8HzZA = parcelRequire("8HzZA");

var $diasm = parcelRequire("diasm");
const $899d73a4034889b6$export$5402ad09f300f963 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const isAudioPlayerOpen = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectOpen));
    const currentTrack = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrack));
    // on playlist touch states
    const [touchStartPosition, setTouchStartPosition] = (0, $exYeM.useState)({
        x: 0,
        y: 0
    });
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: [
            (0, $diasm.styles)(theme).playlist.main,
            isAudioPlayerOpen ? (0, $diasm.styles)(theme).playlist.open : (0, $diasm.styles)(theme).playlist.closed,
            "",
            ""
        ],
        onTouchStart: (e)=>{
            const { clientX: clientX, clientY: clientY } = e.changedTouches[0];
            setTouchStartPosition({
                x: clientX,
                y: clientY
            });
        },
        onTouchEnd: (e)=>{
            const { clientY: clientY } = e.changedTouches[0];
            // calculate touch distance
            const touchDistance = clientY - touchStartPosition.y;
            // set min touch threshold
            const minTouchThreshold = 200;
            // if touch distance is greater or equal min threshold
            if (touchDistance >= minTouchThreshold) dispatch((0, $jhoVP.playerAudioSetClosed)());
        },
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $diasm.styles)(theme).playlist.current,
                children: currentTrack && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8HzZA.TrackViewAudioPlaylist), {})
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $diasm.styles)(theme).playlist.tracks,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bR4Bv.TrackListAudioPlaylist), {})
            })
        ]
    });
};
$899d73a4034889b6$export$5402ad09f300f963.propTypes = {};

});
parcelRegister("diasm", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $48da1caea32569a4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $48da1caea32569a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $48da1caea32569a4$var$_ref = {
    name: "13udsys",
    styles: "height:100%"
};
var $48da1caea32569a4$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $48da1caea32569a4$var$_ref3 = {
    name: "evk0yx",
    styles: "top:100vh;opacity:0"
};
const $48da1caea32569a4$export$9dd6ff9ea0189349 = (theme)=>({
        playlist: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.sides, ";", (0, $48E0n.helpers).app.playlist.height, ";", (0, $48E0n.helpers).app.playlist.width, ";z-index:", (0, $48E0n.z).features.audio.playlist, ";display:flex;flex-direction:column;position:fixed;overflow:hidden;overflow-y:scroll;transition:top 0.2s,opacity 0.4s;background-color:", theme.colors.primary.normal, ";", ""),
            open: /*#__PURE__*/ (0, $4N3Qt.css)("top:", (0, $48E0n.constants).app.header.desktop.height, ";", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("top:", (0, $48E0n.constants).app.header.mobile.height, ";", "")), " opacity:1;", ""),
            closed: $48da1caea32569a4$var$_ref3,
            current: /*#__PURE__*/ (0, $4N3Qt.css)("&>div{margin-bottom:50px;", (0, $48E0n.mq).mobile($48da1caea32569a4$var$_ref2), ";}", ""),
            tracks: $48da1caea32569a4$var$_ref
        }
    });

});



parcelRegister("jhoVP", function(module, exports) {

$parcel$export(module.exports, "playerSlice", function () { return $c2110e1812f42892$export$6e3f0fced909207; });
$parcel$export(module.exports, "playerAudioSetCurrentTrack", function () { return $c2110e1812f42892$export$c7935c9a76cf15f1; });
$parcel$export(module.exports, "playerAudioSetCurrentTrackReady", function () { return $c2110e1812f42892$export$c76f55635b37d0a0; });
$parcel$export(module.exports, "playerAudioSetCurrentTrackPlaying", function () { return $c2110e1812f42892$export$4435ec57ae5f3ab9; });
$parcel$export(module.exports, "playerAudioSetNextTrack", function () { return $c2110e1812f42892$export$773b2114c78c003e; });
$parcel$export(module.exports, "playerAudioSetPrevTrack", function () { return $c2110e1812f42892$export$aa19b6c6d1d860c3; });
$parcel$export(module.exports, "playerAudioSetRepeatTrack", function () { return $c2110e1812f42892$export$11bf1292d535949e; });
$parcel$export(module.exports, "playerAudioSetRandomTrack", function () { return $c2110e1812f42892$export$d2acfe9cc261e87a; });
$parcel$export(module.exports, "playerAudioToggleRepeat", function () { return $c2110e1812f42892$export$f47fed164c8dcf6f; });
$parcel$export(module.exports, "playerAudioToggleRandom", function () { return $c2110e1812f42892$export$1616f3dcb976fd63; });
$parcel$export(module.exports, "playerAudioToggleOpen", function () { return $c2110e1812f42892$export$51610af521ec7afd; });
$parcel$export(module.exports, "playerAudioSetOpen", function () { return $c2110e1812f42892$export$4d2aedf91566643; });
$parcel$export(module.exports, "playerAudioSetClosed", function () { return $c2110e1812f42892$export$a1edf3642649277f; });
$parcel$export(module.exports, "playerAudioFilterPlaylistTrack", function () { return $c2110e1812f42892$export$75030b4f0ff63aaf; });
$parcel$export(module.exports, "playerAudioFilterPlaylistUserTracks", function () { return $c2110e1812f42892$export$3dc5256278aacd89; });
$parcel$export(module.exports, "playerAudioUpdatePlaylistTrack", function () { return $c2110e1812f42892$export$56a02b674638e7d4; });
$parcel$export(module.exports, "playerAudioSelectPlaylist", function () { return $c2110e1812f42892$export$47d928be6f4dcc98; });
$parcel$export(module.exports, "playerAudioSelectPlaylistLength", function () { return $c2110e1812f42892$export$6a9b1fbd3c83f3fe; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrack", function () { return $c2110e1812f42892$export$57968c275f4eaaf5; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrackAction", function () { return $c2110e1812f42892$export$89a2733de17cebde; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrackReady", function () { return $c2110e1812f42892$export$14cc090a206fb988; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrackPlaying", function () { return $c2110e1812f42892$export$af20843d4124aca4; });
$parcel$export(module.exports, "playerAudioSelectRepeat", function () { return $c2110e1812f42892$export$aab427a8ffd01b7d; });
$parcel$export(module.exports, "playerAudioSelectRandom", function () { return $c2110e1812f42892$export$b40204deaea2321b; });
$parcel$export(module.exports, "playerAudioSelectOpen", function () { return $c2110e1812f42892$export$109045197ee506ec; });
$parcel$export(module.exports, "playerReducer", function () { return $c2110e1812f42892$export$e21df831734792fb; });

var $dEr3t = parcelRequire("dEr3t");
const $c2110e1812f42892$var$initialState = {
    audio: {
        playlist: [],
        current: {
            action: 0,
            ready: false,
            playing: false,
            index: -1
        },
        repeat: false,
        random: false,
        open: false
    },
    video: {}
};
const $c2110e1812f42892$export$6e3f0fced909207 = (0, $dEr3t.createSlice)({
    name: "player",
    initialState: $c2110e1812f42892$var$initialState,
    reducers: {
        // set audio player current track
        playerAudioSetCurrentTrack: (state, action)=>{
            const { track: track } = action.payload;
            // check if track exists in playlist
            const idx = state.audio.playlist.findIndex((t)=>t.id === track.id);
            // if track is already in playlist
            if (idx !== -1) {
                // reset ready state
                state.audio.current.ready = false;
                // increment current action
                state.audio.current.action += 1;
                // set current index as index of track in the playlist
                state.audio.current.index = idx;
            }
            // if track is not in playlist
            if (idx === -1) {
                // add track to playlist
                state.audio.playlist.push(track);
                // reset ready state
                state.audio.current.ready = false;
                // increment current action
                state.audio.current.action += 1;
                // set current index as last playlist index
                state.audio.current.index = state.audio.playlist.length - 1;
            }
        },
        // set audio player current track ready
        playerAudioSetCurrentTrackReady: (state, action)=>{
            // set ready state
            state.audio.current.ready = action.payload.state;
        },
        // set audio player current track playing
        playerAudioSetCurrentTrackPlaying: (state, action)=>{
            // set playing state
            state.audio.current.playing = action.payload.state;
        },
        // set audio player next track
        playerAudioSetNextTrack: (state)=>{
            // get current track index
            const { index: currentTrackIndex } = state.audio.current;
            // get last playlist index
            const lastPlaylistIndex = state.audio.playlist.length - 1;
            // get first playlist index
            const firstPlaylistIndex = 0;
            // if current track has index and playlist last index is >= 0
            if (currentTrackIndex !== undefined && lastPlaylistIndex >= 0) {
                // get next playlist index
                const nextPlaylistIndex = currentTrackIndex + 1;
                switch(true){
                    case lastPlaylistIndex === firstPlaylistIndex:
                        // if last playlist index equals first playlist index
                        // there is just one track in playlist
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as last playlist index
                        state.audio.current.index = lastPlaylistIndex;
                        break;
                    case currentTrackIndex >= lastPlaylistIndex:
                        // if current track index is greater or equal to last playlist index
                        // playlist is over, start from the first index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as first playlist index
                        state.audio.current.index = firstPlaylistIndex;
                        break;
                    default:
                        // else just set next playlist index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as next playlist index
                        state.audio.current.index = nextPlaylistIndex;
                        break;
                }
            }
        },
        // set audio player prev track
        playerAudioSetPrevTrack: (state)=>{
            // get current track index
            const { index: currentTrackIndex } = state.audio.current;
            // get last playlist index
            const lastPlaylistIndex = state.audio.playlist.length - 1;
            // get first playlist index
            const firstPlaylistIndex = 0;
            // if current track has index and playlist last index is >= 0
            if (currentTrackIndex !== undefined && lastPlaylistIndex >= 0) {
                // get prev playlist index
                const prevPlaylistIndex = currentTrackIndex - 1;
                switch(true){
                    case lastPlaylistIndex === firstPlaylistIndex:
                        // if last playlist index equals first playlist index
                        // there is just one track in playlist
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as last playlist index
                        state.audio.current.index = lastPlaylistIndex;
                        break;
                    case currentTrackIndex <= firstPlaylistIndex:
                        // if current track index is less or equal to first playlist index
                        // playlist is over, start from the last index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as last playlist index
                        state.audio.current.index = lastPlaylistIndex;
                        break;
                    default:
                        // else just set prev playlist index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as prev playlist index
                        state.audio.current.index = prevPlaylistIndex;
                        break;
                }
            }
        },
        // set audio player repeat track
        playerAudioSetRepeatTrack: (state)=>{
            const currentPlaylistIndex = state.audio.current.index;
            // increment current action
            state.audio.current.action += 1;
            // set current index as current index
            state.audio.current.index = currentPlaylistIndex;
        },
        // set audio player random track
        playerAudioSetRandomTrack: (state)=>{
            // get playlist length
            const playlistLength = state.audio.playlist.length;
            // get random index
            const randomPlaylistIndex = Math.floor(Math.random() * playlistLength);
            // if random playlist index is defined (0 - n)
            if (randomPlaylistIndex !== undefined) {
                // reset ready state
                state.audio.current.ready = false;
                // increment current action
                state.audio.current.action += 1;
                // set current index as random playlist index
                state.audio.current.index = randomPlaylistIndex;
            }
        },
        // toggle audio player repeat
        playerAudioToggleRepeat: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    repeat: !state.audio.repeat
                }
            }),
        // toggle audio player random
        playerAudioToggleRandom: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    random: !state.audio.random
                }
            }),
        // toggle audio player open
        playerAudioToggleOpen: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    open: !state.audio.open
                }
            }),
        // set audio player open
        playerAudioSetOpen: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    open: true
                }
            }),
        // set audio player closed
        playerAudioSetClosed: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    open: false
                }
            }),
        // filter track
        playerAudioFilterPlaylistTrack: (state, action)=>{
            const { id: id } = action.payload;
            // check if track exists in playlist
            const idx = state.audio.playlist.findIndex((t)=>t.id === id);
            if (idx !== -1) {
                // if track currently playing
                if (idx === state.audio.current.index) // reset current track state
                state.audio.current = {
                    ...state.audio.current,
                    ready: false,
                    playing: false,
                    index: -1
                };
                // filter track from playlist
                state.audio.playlist = state.audio.playlist.filter((t)=>t.id !== id);
            }
        },
        // filter user tracks
        playerAudioFilterPlaylistUserTracks: (state, action)=>{
            const { userId: userId } = action.payload;
            // define user tracks map
            const userTracksMap = {};
            // iterate over each track in playlist
            state.audio.playlist.forEach((t, idx)=>{
                // if track belongs to user
                if (t.userId === userId) // add track to map
                userTracksMap[idx] = true;
            });
            // if user track currently playing
            if (userTracksMap[state.audio.current.index]) // reset current track state
            state.audio.current = {
                ...state.audio.current,
                ready: false,
                playing: false,
                index: -1
            };
            // filter user track from playlist
            state.audio.playlist = state.audio.playlist.filter((t)=>t.userId !== userId);
        },
        // update track in audio player playlist
        playerAudioUpdatePlaylistTrack: (state, action)=>{
            const { updatedTrack: updatedTrack } = action.payload;
            // update track in playlist
            const idx = state.audio.playlist.findIndex((t)=>t.id === updatedTrack.id);
            if (idx !== -1) {
                const currentTrack = state.audio.playlist[idx];
                state.audio.playlist[idx] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
        }
    }
});
const { playerAudioSetCurrentTrack: $c2110e1812f42892$export$c7935c9a76cf15f1, playerAudioSetCurrentTrackReady: $c2110e1812f42892$export$c76f55635b37d0a0, playerAudioSetCurrentTrackPlaying: $c2110e1812f42892$export$4435ec57ae5f3ab9, playerAudioSetNextTrack: $c2110e1812f42892$export$773b2114c78c003e, playerAudioSetPrevTrack: $c2110e1812f42892$export$aa19b6c6d1d860c3, playerAudioSetRepeatTrack: $c2110e1812f42892$export$11bf1292d535949e, playerAudioSetRandomTrack: $c2110e1812f42892$export$d2acfe9cc261e87a, playerAudioToggleRepeat: $c2110e1812f42892$export$f47fed164c8dcf6f, playerAudioToggleRandom: $c2110e1812f42892$export$1616f3dcb976fd63, playerAudioToggleOpen: $c2110e1812f42892$export$51610af521ec7afd, playerAudioSetOpen: $c2110e1812f42892$export$4d2aedf91566643, playerAudioSetClosed: $c2110e1812f42892$export$a1edf3642649277f, playerAudioFilterPlaylistTrack: $c2110e1812f42892$export$75030b4f0ff63aaf, playerAudioFilterPlaylistUserTracks: $c2110e1812f42892$export$3dc5256278aacd89, playerAudioUpdatePlaylistTrack: $c2110e1812f42892$export$56a02b674638e7d4 } = $c2110e1812f42892$export$6e3f0fced909207.actions;
const $c2110e1812f42892$export$47d928be6f4dcc98 = (state)=>state.player.audio.playlist;
const $c2110e1812f42892$export$6a9b1fbd3c83f3fe = (state)=>state.player.audio.playlist.length;
const $c2110e1812f42892$export$57968c275f4eaaf5 = (state)=>state.player.audio.playlist[state.player.audio.current.index];
const $c2110e1812f42892$export$89a2733de17cebde = (state)=>state.player.audio.current.action;
const $c2110e1812f42892$export$14cc090a206fb988 = (state)=>state.player.audio.current.ready;
const $c2110e1812f42892$export$af20843d4124aca4 = (state)=>state.player.audio.current.playing;
const $c2110e1812f42892$export$aab427a8ffd01b7d = (state)=>state.player.audio.repeat;
const $c2110e1812f42892$export$b40204deaea2321b = (state)=>state.player.audio.random;
const $c2110e1812f42892$export$109045197ee506ec = (state)=>state.player.audio.open;
const $c2110e1812f42892$export$e21df831734792fb = $c2110e1812f42892$export$6e3f0fced909207.reducer; // export default playerSlice.reducer

});


parcelRegister("6BgJ6", function(module, exports) {

$parcel$export(module.exports, "PostBlockModal", function () { return (parcelRequire("lijeO")).PostBlockModal; });
$parcel$export(module.exports, "PostCard", function () { return (parcelRequire("6kdLg")).PostCard; });
$parcel$export(module.exports, "PostCardLocked", function () { return (parcelRequire("f0LKE")).PostCardLocked; });
$parcel$export(module.exports, "PostCardProduct", function () { return (parcelRequire("2DEaW")).PostCardProduct; });
$parcel$export(module.exports, "PostCardPublic", function () { return (parcelRequire("5hO4P")).PostCardPublic; });
$parcel$export(module.exports, "PostCardUploaded", function () { return (parcelRequire("3O7fS")).PostCardUploaded; });
$parcel$export(module.exports, "PostDeleteModal", function () { return (parcelRequire("hGv1o")).PostDeleteModal; });
$parcel$export(module.exports, "PostListFeedPopular", function () { return (parcelRequire("4uBSx")).PostListFeedPopular; });
$parcel$export(module.exports, "PostListFeedRecommended", function () { return (parcelRequire("9mnCV")).PostListFeedRecommended; });
$parcel$export(module.exports, "PostListHomePublic", function () { return (parcelRequire("asBNd")).PostListHomePublic; });
$parcel$export(module.exports, "PostListLibraryLiked", function () { return (parcelRequire("dGMDg")).PostListLibraryLiked; });
$parcel$export(module.exports, "PostListLibraryUnlocked", function () { return (parcelRequire("2Yzy7")).PostListLibraryUnlocked; });
$parcel$export(module.exports, "PostListStudioUploaded", function () { return (parcelRequire("gwXHL")).PostListStudioUploaded; });
$parcel$export(module.exports, "PostListUserExclusive", function () { return (parcelRequire("lAVsn")).PostListUserExclusive; });
$parcel$export(module.exports, "PostListUserLatest", function () { return (parcelRequire("5nmHP")).PostListUserLatest; });
$parcel$export(module.exports, "PostListUserPopular", function () { return (parcelRequire("eOOcW")).PostListUserPopular; });
$parcel$export(module.exports, "PostViewCreateStudio", function () { return (parcelRequire("7MMhY")).PostViewCreateStudio; });
$parcel$export(module.exports, "PostViewEditStudio", function () { return (parcelRequire("cAgHk")).PostViewEditStudio; });
$parcel$export(module.exports, "PostViewMediaPost", function () { return (parcelRequire("1feYX")).PostViewMediaPost; });
$parcel$export(module.exports, "postUtilGetPostCardSkeletonSections", function () { return (parcelRequire("8c9Sv")).postUtilGetPostCardSkeletonSections; });
parcelRequire("7yItn");
var $lijeO = parcelRequire("lijeO");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $2DEaW = parcelRequire("2DEaW");
var $5hO4P = parcelRequire("5hO4P");
var $3O7fS = parcelRequire("3O7fS");
var $hGv1o = parcelRequire("hGv1o");
var $4uBSx = parcelRequire("4uBSx");
var $9mnCV = parcelRequire("9mnCV");
var $asBNd = parcelRequire("asBNd");
var $dGMDg = parcelRequire("dGMDg");
var $2Yzy7 = parcelRequire("2Yzy7");
var $gwXHL = parcelRequire("gwXHL");
var $lAVsn = parcelRequire("lAVsn");
var $5nmHP = parcelRequire("5nmHP");
var $eOOcW = parcelRequire("eOOcW");
var $7MMhY = parcelRequire("7MMhY");
var $cAgHk = parcelRequire("cAgHk");
var $1feYX = parcelRequire("1feYX");

var $8c9Sv = parcelRequire("8c9Sv");

var $l1Cdj = parcelRequire("l1Cdj");

var $g5prJ = parcelRequire("g5prJ");
$parcel$exportWildcard(module.exports, $l1Cdj);
$parcel$exportWildcard(module.exports, $g5prJ);

});
parcelRegister("7yItn", function(module, exports) {

$parcel$export(module.exports, "PostBlockModal", function () { return (parcelRequire("lijeO")).PostBlockModal; });
$parcel$export(module.exports, "PostCard", function () { return (parcelRequire("6kdLg")).PostCard; });
$parcel$export(module.exports, "PostCardLocked", function () { return (parcelRequire("f0LKE")).PostCardLocked; });
$parcel$export(module.exports, "PostCardProduct", function () { return (parcelRequire("2DEaW")).PostCardProduct; });
$parcel$export(module.exports, "PostCardPublic", function () { return (parcelRequire("5hO4P")).PostCardPublic; });
$parcel$export(module.exports, "PostCardUploaded", function () { return (parcelRequire("3O7fS")).PostCardUploaded; });
$parcel$export(module.exports, "PostDeleteModal", function () { return (parcelRequire("hGv1o")).PostDeleteModal; });
$parcel$export(module.exports, "PostListFeedPopular", function () { return (parcelRequire("4uBSx")).PostListFeedPopular; });
$parcel$export(module.exports, "PostListFeedRecommended", function () { return (parcelRequire("9mnCV")).PostListFeedRecommended; });
$parcel$export(module.exports, "PostListHomePublic", function () { return (parcelRequire("asBNd")).PostListHomePublic; });
$parcel$export(module.exports, "PostListLibraryLiked", function () { return (parcelRequire("dGMDg")).PostListLibraryLiked; });
$parcel$export(module.exports, "PostListLibraryUnlocked", function () { return (parcelRequire("2Yzy7")).PostListLibraryUnlocked; });
$parcel$export(module.exports, "PostListStudioUploaded", function () { return (parcelRequire("gwXHL")).PostListStudioUploaded; });
$parcel$export(module.exports, "PostListUserExclusive", function () { return (parcelRequire("lAVsn")).PostListUserExclusive; });
$parcel$export(module.exports, "PostListUserLatest", function () { return (parcelRequire("5nmHP")).PostListUserLatest; });
$parcel$export(module.exports, "PostListUserPopular", function () { return (parcelRequire("eOOcW")).PostListUserPopular; });
$parcel$export(module.exports, "PostViewCreateStudio", function () { return (parcelRequire("7MMhY")).PostViewCreateStudio; });
$parcel$export(module.exports, "PostViewEditStudio", function () { return (parcelRequire("cAgHk")).PostViewEditStudio; });
$parcel$export(module.exports, "PostViewMediaPost", function () { return (parcelRequire("1feYX")).PostViewMediaPost; });

var $lijeO = parcelRequire("lijeO");

var $6kdLg = parcelRequire("6kdLg");

var $f0LKE = parcelRequire("f0LKE");

var $2DEaW = parcelRequire("2DEaW");

var $5hO4P = parcelRequire("5hO4P");

var $3O7fS = parcelRequire("3O7fS");

var $hGv1o = parcelRequire("hGv1o");

var $4uBSx = parcelRequire("4uBSx");

var $9mnCV = parcelRequire("9mnCV");

var $asBNd = parcelRequire("asBNd");

var $dGMDg = parcelRequire("dGMDg");

var $2Yzy7 = parcelRequire("2Yzy7");

var $gwXHL = parcelRequire("gwXHL");

var $lAVsn = parcelRequire("lAVsn");

var $5nmHP = parcelRequire("5nmHP");

var $eOOcW = parcelRequire("eOOcW");

var $7MMhY = parcelRequire("7MMhY");

var $cAgHk = parcelRequire("cAgHk");

var $1feYX = parcelRequire("1feYX");

});
parcelRegister("lijeO", function(module, exports) {

$parcel$export(module.exports, "PostBlockModal", function () { return $7ee2818339c47a2b$export$8cf4e90fd23f7e6; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $l1Cdj = parcelRequire("l1Cdj");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("6pNGV");
var $mUzUS = parcelRequire("mUzUS");

var $56wXP = parcelRequire("56wXP");
const $7ee2818339c47a2b$export$8cf4e90fd23f7e6 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const postBlockModalOpen = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostBlockModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $56wXP.styles)().modal.main,
        children: postBlockModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $l1Cdj.postClosePostBlockModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $56wXP.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $mUzUS.PostBlockCard), {})
            })
        })
    });
};
$7ee2818339c47a2b$export$8cf4e90fd23f7e6.propTypes = {};

});
parcelRegister("6pNGV", function(module, exports) {

$parcel$export(module.exports, "PostBlockCard", function () { return (parcelRequire("mUzUS")).PostBlockCard; });

var $mUzUS = parcelRequire("mUzUS");

});
parcelRegister("mUzUS", function(module, exports) {

$parcel$export(module.exports, "PostBlockCard", function () { return $453c08f6a3edeac2$export$d0aa73622ca1e1d5; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $l1Cdj = parcelRequire("l1Cdj");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("5bXxE");
var $8FFwM = parcelRequire("8FFwM");

var $lNxKn = parcelRequire("lNxKn");
const $453c08f6a3edeac2$export$d0aa73622ca1e1d5 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const postBlockError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $lNxKn.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lNxKn.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $l1Cdj.postClosePostBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lNxKn.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Block Post",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $lNxKn.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Are you sure you want to block this post?"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $lNxKn.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $lNxKn.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8FFwM.PostBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $lNxKn.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: postBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$453c08f6a3edeac2$export$d0aa73622ca1e1d5.propTypes = {};

});
parcelRegister("5bXxE", function(module, exports) {

$parcel$export(module.exports, "PostBlockForm", function () { return (parcelRequire("8FFwM")).PostBlockForm; });

var $8FFwM = parcelRequire("8FFwM");

});
parcelRegister("8FFwM", function(module, exports) {

$parcel$export(module.exports, "PostBlockForm", function () { return $e72b65ae546dae0f$export$d796800ab322d21c; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $g5prJ = parcelRequire("g5prJ");
var $6kdLg = parcelRequire("6kdLg");
var $l1Cdj = parcelRequire("l1Cdj");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $cOZ25 = parcelRequire("cOZ25");
const $e72b65ae546dae0f$export$d796800ab322d21c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const postBlockLoading = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostBlockLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const post = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostBlockModalPost));
    const submitDisabled = postBlockLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cOZ25.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $cOZ25.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $g5prJ.postBlock)({
                    id: post?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $cOZ25.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
                        post: post || {},
                        currentUserId: profile?.id || "",
                        onClick: ()=>()=>{},
                        onAuthorNameClick: ()=>()=>{},
                        onAuthorUsernameClick: ()=>()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $cOZ25.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block post",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: postBlockLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$e72b65ae546dae0f$export$d796800ab322d21c.propTypes = {};

});
parcelRegister("cOZ25", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a745cc1048699450$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $a745cc1048699450$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a745cc1048699450$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $a745cc1048699450$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                track: $a745cc1048699450$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("lNxKn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bf9724cb15960639$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $bf9724cb15960639$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bf9724cb15960639$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $bf9724cb15960639$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $bf9724cb15960639$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $bf9724cb15960639$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $bf9724cb15960639$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $bf9724cb15960639$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $bf9724cb15960639$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $bf9724cb15960639$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $bf9724cb15960639$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($bf9724cb15960639$var$_ref8), " ", (0, $48E0n.mq).mobile($bf9724cb15960639$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($bf9724cb15960639$var$_ref6), ";", ""),
            title: $bf9724cb15960639$var$_ref5,
            subtitle: $bf9724cb15960639$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($bf9724cb15960639$var$_ref3), ";", ""),
                form: $bf9724cb15960639$var$_ref2,
                error: $bf9724cb15960639$var$_ref
            }
        }
    });

});



parcelRegister("56wXP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $eb993a5a9f8614e3$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $eb993a5a9f8614e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $eb993a5a9f8614e3$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $eb993a5a9f8614e3$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($eb993a5a9f8614e3$var$_ref), ";", "")
        }
    });

});


parcelRegister("6kdLg", function(module, exports) {

$parcel$export(module.exports, "PostCard", function () { return $a3301fc4fc355c9c$export$56c928be863719c7; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
var $d1vGL = parcelRequire("d1vGL");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("dmGpj");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
var $3gmqG = parcelRequire("3gmqG");
parcelRequire("jAjok");
var $3UMLM = parcelRequire("3UMLM");
var $5EgzY = parcelRequire("5EgzY");

var $7tCl9 = parcelRequire("7tCl9");
const $a3301fc4fc355c9c$export$56c928be863719c7 = ({ post: post, currentUserId: currentUserId, onClick: onClick, onAuthorNameClick: onAuthorNameClick, onAuthorUsernameClick: onAuthorUsernameClick })=>{
    const theme = (0, $hXJcm.u)();
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const [mediaLoadError, setMediaLoadError] = (0, $exYeM.useState)(false);
    const [headerAvatarError, setHeaderAvatarError] = (0, $exYeM.useState)(false);
    const { id: postId, userId: userId, trackIds: trackIds, message: message, mediaType: mediaType, mediaId: mediaId, likesCount: likesCount } = post;
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $d1vGL.useTracks)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const authorHasAvatar = !!authorAvatarId;
    const avatarSource = (0, $hrd7b.useFile)(authorAvatarId || "");
    const postHasMedia = !!mediaId;
    const postMedia = (0, $hrd7b.useFile)(mediaId || "");
    const maxPostDescriptionLength = 84;
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $7tCl9.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $7tCl9.styles)(theme).card.header.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $7tCl9.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $7tCl9.styles)(theme).card.header.content.avatar.main,
                            children: authorHasAvatar && !headerAvatarError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                                css: (0, $7tCl9.styles)(theme).card.header.content.avatar.image,
                                onError: ()=>setHeaderAvatarError(true),
                                loading: "lazy",
                                width: "30px",
                                height: "30px",
                                src: avatarSource,
                                alt: "post author avatar"
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                                css: (0, $7tCl9.styles)(theme).card.header.content.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $7tCl9.styles)(theme).card.header.content.author.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: (0, $7tCl9.styles)(theme).card.header.content.author.name,
                                    onClick: (e)=>onAuthorNameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: (0, $7tCl9.styles)(theme).card.header.content.author.username,
                                    onClick: (e)=>onAuthorUsernameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $7tCl9.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $7tCl9.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).HeartFilled, {})
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $7tCl9.styles)(theme).card.header.content.likes.likes,
                                    children: (0, $fJerj.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $7tCl9.styles)(theme).card.media.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: postHasMedia && !mediaLoadError ? /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                    children: [
                        mediaType && mediaType === (0, $aeAwZ.EntityPostMediaType).Image && /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $7tCl9.styles)(theme).card.media.image,
                            onError: ()=>setMediaLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "150px",
                            src: postMedia,
                            alt: "post media"
                        }),
                        mediaType && mediaType === (0, $aeAwZ.EntityPostMediaType).Video && /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("video", {
                                    css: (0, $7tCl9.styles)(theme).card.media.video.main,
                                    onError: ()=>setMediaLoadError(true),
                                    width: "180",
                                    muted: true,
                                    preload: "metadata",
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("source", {
                                            src: postMedia,
                                            type: "video/mp4"
                                        }),
                                        "Your browser does not support the video tag."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $7tCl9.styles)(theme).card.media.video.play,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $7tCl9.styles)(theme).card.media.placeholder,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Ryddm, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $7tCl9.styles)(theme).card.content.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $7tCl9.styles)(theme).card.content.description,
                        children: (0, $3gmqG.stringsCutter)(maxPostDescriptionLength, message || "")
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $7tCl9.styles)(theme).card.content.tracks,
                        children: isPostTracksLoading ? tracksLoadingPlaceholder : postTracks && postTracks.map((track)=>{
                            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
                            const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
                            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
                            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
                            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
                            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
                            if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5EgzY.TrackLocked), {
                                track: track
                            }, `post-${postId}-track-${track.id}`);
                            return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3UMLM.Track), {
                                track: track
                            }, `post-${postId}-track-${track.id}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $7tCl9.styles)(theme).card.footer,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true"
            })
        ]
    });
};
$a3301fc4fc355c9c$export$56c928be863719c7.propTypes = {};

});
parcelRegister("jAjok", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return (parcelRequire("3UMLM")).Track; });
$parcel$export(module.exports, "TrackLocked", function () { return (parcelRequire("5EgzY")).TrackLocked; });

var $3UMLM = parcelRequire("3UMLM");

var $5EgzY = parcelRequire("5EgzY");

});
parcelRegister("3UMLM", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $1b0c3a63ee9ddcda$export$13921ac0cc260818; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $jFeNS = parcelRequire("jFeNS");
const $1b0c3a63ee9ddcda$export$13921ac0cc260818 = ({ track: track })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    const trackHasCover = !!coverId;
    const coverSource = (0, $hrd7b.useFile)(coverId || "");
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $jFeNS.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $jFeNS.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $jFeNS.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "30px",
                    height: "30px",
                    src: coverSource,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {
                    css: (0, $jFeNS.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $jFeNS.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $jFeNS.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $jFeNS.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $jFeNS.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
            })
        ]
    });
};
$1b0c3a63ee9ddcda$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("jFeNS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a7126ff1e5972b16$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $a7126ff1e5972b16$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a7126ff1e5972b16$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $a7126ff1e5972b16$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $a7126ff1e5972b16$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});


parcelRegister("5EgzY", function(module, exports) {

$parcel$export(module.exports, "TrackLocked", function () { return $42c9a84ca8195285$export$95154993d63756c1; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $a1g4u = parcelRequire("a1g4u");
const $42c9a84ca8195285$export$95154993d63756c1 = ({ track: track })=>{
    const theme = (0, $hXJcm.u)();
    const { userId: userId, name: name } = track;
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $a1g4u.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $a1g4u.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {
                    css: (0, $a1g4u.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $a1g4u.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $a1g4u.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $a1g4u.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $a1g4u.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
            })
        ]
    });
};
$42c9a84ca8195285$export$95154993d63756c1.propTypes = {};

});
parcelRegister("a1g4u", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $cfca1cb884ef6830$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $cfca1cb884ef6830$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cfca1cb884ef6830$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $cfca1cb884ef6830$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $cfca1cb884ef6830$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});



parcelRegister("7tCl9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b41182d8f6ab4047$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b41182d8f6ab4047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b41182d8f6ab4047$var$_ref = {
    name: "1h4mco6",
    styles: "&>div:not(:last-of-type){margin-bottom:8px;}"
};
var $b41182d8f6ab4047$var$_ref2 = {
    name: "k231at",
    styles: "position:relative;height:150px;border-radius:4px"
};
var $b41182d8f6ab4047$var$_ref3 = {
    name: "1kui3n4",
    styles: "display:flex;align-items:center;margin-left:8px"
};
var $b41182d8f6ab4047$var$_ref4 = {
    name: "1kt1pq0",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto"
};
var $b41182d8f6ab4047$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
var $b41182d8f6ab4047$var$_ref6 = {
    name: "2d7q80",
    styles: "flex-grow:0;flex-shrink:0;position:relative;width:180px;height:282px;cursor:pointer;overflow:hidden"
};
const $b41182d8f6ab4047$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $b41182d8f6ab4047$var$_ref6,
            // header
            header: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $b41182d8f6ab4047$var$_ref5,
                    avatar: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;height:30px;width:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                        image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    author: {
                        main: $b41182d8f6ab4047$var$_ref4,
                        name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).c, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).c, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    },
                    likes: {
                        main: $b41182d8f6ab4047$var$_ref3,
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-right:4px;&>svg{width:14px;height:14px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                        likes: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";", "")
                    }
                }
            },
            // media
            media: {
                main: $b41182d8f6ab4047$var$_ref2,
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                video: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                    play: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:60%;left:50%;transform:translate(-50%, -60%);&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.secondary.normal, ";}&>svg>circle{stroke:", theme.colors.secondary.normal, ";}", "")
                },
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("height:100%;background-color:", theme.colors.primary.darker, ";&>svg{position:absolute;top:60%;left:50%;width:30px;height:40px;transform:translate(-50%, -60%);}&>svg>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            // content
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("height:130px;overflow:hidden;padding:8px 8px 0px 8px;border-radius:0px 0px 4px 4px;background-color:", theme.colors.primary.darker, ";", ""),
                description: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";line-height:120%;word-break:break-word;height:62px;overflow:hidden;margin-bottom:8px;", ""),
                tracks: $b41182d8f6ab4047$var$_ref
            },
            // footer
            footer: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.footer, ";position:absolute;bottom:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n        180deg,\n        ", theme.colors.primary.normal, "00 25.21%,\n        ", theme.colors.primary.normal, " 100%\n      );", "")
        }
    });

});


parcelRegister("f0LKE", function(module, exports) {

$parcel$export(module.exports, "PostCardLocked", function () { return $24e90ba1ac0e2fee$export$a7b4b10f2847bb72; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");

var $1ZmNc = parcelRequire("1ZmNc");
const $24e90ba1ac0e2fee$export$a7b4b10f2847bb72 = ({ post: post, onClick: onClick, onAuthorNameClick: onAuthorNameClick, onAuthorUsernameClick: onAuthorUsernameClick })=>{
    const theme = (0, $hXJcm.u)();
    const [headerAvatarError, setHeaderAvatarError] = (0, $exYeM.useState)(false);
    const { userId: userId, likesCount: likesCount } = post;
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    const authorHasAvatar = !!authorAvatarId;
    const avatarSource = (0, $hrd7b.useFile)(authorAvatarId || "");
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $1ZmNc.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1ZmNc.styles)(theme).card.lock.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {
                    css: (0, $1ZmNc.styles)(theme).card.lock.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1ZmNc.styles)(theme).card.overlay.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: (0, $1ZmNc.styles)(theme).card.overlay.button,
                    onClick: (e)=>onClick(e),
                    type: "button",
                    "aria-label": "unlock track",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Unlock, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1ZmNc.styles)(theme).card.header.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $1ZmNc.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $1ZmNc.styles)(theme).card.header.content.avatar.main,
                            children: authorHasAvatar && !headerAvatarError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                                css: (0, $1ZmNc.styles)(theme).card.header.content.avatar.image,
                                onError: ()=>setHeaderAvatarError(true),
                                loading: "lazy",
                                width: "30px",
                                height: "30px",
                                src: avatarSource,
                                alt: "post author avatar"
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                                css: (0, $1ZmNc.styles)(theme).card.header.content.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $1ZmNc.styles)(theme).card.header.content.author.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: (0, $1ZmNc.styles)(theme).card.header.content.author.name,
                                    onClick: (e)=>onAuthorNameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: (0, $1ZmNc.styles)(theme).card.header.content.author.username,
                                    onClick: (e)=>onAuthorUsernameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $1ZmNc.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $1ZmNc.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).HeartFilled, {})
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $1ZmNc.styles)(theme).card.header.content.likes.likes,
                                    children: (0, $fJerj.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1ZmNc.styles)(theme).card.footer,
                "aria-hidden": "true"
            })
        ]
    });
};
$24e90ba1ac0e2fee$export$a7b4b10f2847bb72.propTypes = {};

});
parcelRegister("1ZmNc", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $365af01fe6765378$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $365af01fe6765378$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $365af01fe6765378$var$_ref = {
    name: "1kui3n4",
    styles: "display:flex;align-items:center;margin-left:8px"
};
var $365af01fe6765378$var$_ref2 = {
    name: "1kt1pq0",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto"
};
var $365af01fe6765378$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $365af01fe6765378$var$_ref4 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $365af01fe6765378$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
const $365af01fe6765378$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;position:relative;width:180px;height:282px;background-color:", theme.colors.primary.darker, ";cursor:pointer;overflow:hidden;transition:border 0.2s;&:hover>div{opacity:1;}", ""),
            lock: {
                main: $365af01fe6765378$var$_ref5,
                icon: $365af01fe6765378$var$_ref4
            },
            // overlay
            overlay: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.overlay, ";display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:4px;background-color:", theme.colors.primary.normal, "E4;transition:opacity 0.2s,border 0.2s;opacity:0;", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:30px;height:30px;& path{fill:", theme.colors.accent.normal, ";}}", "")
            },
            // header
            header: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $365af01fe6765378$var$_ref3,
                    avatar: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;height:30px;width:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                        image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    author: {
                        main: $365af01fe6765378$var$_ref2,
                        name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).c, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).c, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    },
                    likes: {
                        main: $365af01fe6765378$var$_ref,
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-right:4px;&>svg{width:14px;height:14px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                        likes: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";", "")
                    }
                }
            },
            // footer
            footer: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.footer, ";position:absolute;bottom:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n        180deg,\n        ", theme.colors.primary.normal, "00 25.21%,\n        ", theme.colors.primary.normal, " 100%\n      );", "")
        }
    });

});


parcelRegister("2DEaW", function(module, exports) {

$parcel$export(module.exports, "PostCardProduct", function () { return $0e37a5fb19e8b6f8$export$3d9c62c05422580c; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $dPYR6 = parcelRequire("dPYR6");
const $0e37a5fb19e8b6f8$export$3d9c62c05422580c = ()=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $dPYR6.styles)(theme).card.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $dPYR6.styles)(theme).card.lock.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {
                css: (0, $dPYR6.styles)(theme).card.lock.icon
            })
        })
    });
};
$0e37a5fb19e8b6f8$export$3d9c62c05422580c.propTypes = {};

});
parcelRegister("dPYR6", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4030051443d60a4f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $4030051443d60a4f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4030051443d60a4f$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $4030051443d60a4f$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
const $4030051443d60a4f$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;position:relative;width:180px;height:282px;background-color:", theme.colors.primary.normal, ";overflow:hidden;transition:border 0.2s;&:hover>div{opacity:1;}", ""),
            lock: {
                main: $4030051443d60a4f$var$_ref2,
                icon: $4030051443d60a4f$var$_ref
            },
            description: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("5hO4P", function(module, exports) {

$parcel$export(module.exports, "PostCardPublic", function () { return $c955c2f98be1c5c4$export$b659014c52e02228; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $1UJJS = parcelRequire("1UJJS");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
var $3gmqG = parcelRequire("3gmqG");
parcelRequire("fRVt8");
var $f7BhD = parcelRequire("f7BhD");
parcelRequire("kyn4R");
var $k5oqn = parcelRequire("k5oqn");
var $lK2Gy = parcelRequire("lK2Gy");

var $4tVaA = parcelRequire("4tVaA");
const $c955c2f98be1c5c4$export$b659014c52e02228 = ({ post: post, overlayAction: overlayAction })=>{
    const theme = (0, $hXJcm.u)();
    const [mediaLoadError, setMediaLoadError] = (0, $exYeM.useState)(false);
    const [overlayAvatarError, setOverlayAvatarError] = (0, $exYeM.useState)(false);
    const [headerAvatarError, setHeaderAvatarError] = (0, $exYeM.useState)(false);
    const [hover, setHover] = (0, $exYeM.useState)(false);
    const { id: postId, userId: userId, trackIds: trackIds, message: message, mediaType: mediaType, mediaId: mediaId, likesCount: likesCount } = post;
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $1UJJS.useTracksPublic)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const authorHasAvatar = !!authorAvatarId;
    const avatarSource = (0, $hrd7b.useFile)(authorAvatarId || "");
    const postHasMedia = !!mediaId;
    const postMedia = (0, $hrd7b.useFile)(mediaId || "");
    const maxPostDescriptionLength = 84;
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $4tVaA.styles)(theme).card.main,
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        children: [
            overlayAction && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $4tVaA.styles)(theme).card.overlay.main(hover),
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4tVaA.styles)(theme).card.overlay.avatar.main,
                        children: authorHasAvatar && !overlayAvatarError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $4tVaA.styles)(theme).card.overlay.avatar.image,
                            onError: ()=>setOverlayAvatarError(true),
                            loading: "lazy",
                            width: "80px",
                            height: "80px",
                            src: avatarSource,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                            css: (0, $4tVaA.styles)(theme).card.overlay.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $4tVaA.styles)(theme).card.overlay.author.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $4tVaA.styles)(theme).card.overlay.author.name,
                                children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $4tVaA.styles)(theme).card.overlay.author.username,
                                children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4tVaA.styles)(theme).card.overlay.follow,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
                            "aria-label": overlayAction.label,
                            appearance: "primary",
                            onClick: (e)=>overlayAction.onClick(e),
                            children: overlayAction.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4tVaA.styles)(theme).card.header.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $4tVaA.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $4tVaA.styles)(theme).card.header.content.avatar.main,
                            children: authorHasAvatar && !headerAvatarError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                                css: (0, $4tVaA.styles)(theme).card.header.content.avatar.image,
                                onError: ()=>setHeaderAvatarError(true),
                                loading: "lazy",
                                width: "30px",
                                height: "30px",
                                src: avatarSource,
                                alt: "post author avatar"
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                                css: (0, $4tVaA.styles)(theme).card.header.content.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $4tVaA.styles)(theme).card.header.content.author.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4tVaA.styles)(theme).card.header.content.author.name,
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4tVaA.styles)(theme).card.header.content.author.username,
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $4tVaA.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4tVaA.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).HeartFilled, {})
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4tVaA.styles)(theme).card.header.content.likes.likes,
                                    children: (0, $fJerj.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4tVaA.styles)(theme).card.media.main,
                children: postHasMedia && !mediaLoadError ? /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                    children: [
                        mediaType && mediaType === (0, $aeAwZ.EntityPostMediaType).Image && /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $4tVaA.styles)(theme).card.media.image,
                            onError: ()=>setMediaLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "150px",
                            src: postMedia,
                            alt: "post media"
                        }),
                        mediaType && mediaType === (0, $aeAwZ.EntityPostMediaType).Video && /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("video", {
                                    css: (0, $4tVaA.styles)(theme).card.media.video.main,
                                    onError: ()=>setMediaLoadError(true),
                                    width: "180",
                                    muted: true,
                                    preload: "metadata",
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("source", {
                                            src: postMedia,
                                            type: "video/mp4"
                                        }),
                                        "Your browser does not support the video tag."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $4tVaA.styles)(theme).card.media.video.play,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4tVaA.styles)(theme).card.media.placeholder,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Ryddm, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $4tVaA.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4tVaA.styles)(theme).card.content.description,
                        children: (0, $3gmqG.stringsCutter)(maxPostDescriptionLength, message || "")
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4tVaA.styles)(theme).card.content.tracks,
                        children: isPostTracksLoading ? tracksLoadingPlaceholder : postTracks && postTracks.map((track)=>{
                            const { visibility: visibility } = track;
                            const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
                            const renderLocked = isContentLocked;
                            if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lK2Gy.TrackLocked), {
                                track: track
                            }, `public-post-${postId}-track-${track.id}`);
                            return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k5oqn.Track), {
                                track: track
                            }, `public-post-${postId}-track-${track.id}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4tVaA.styles)(theme).card.footer
            })
        ]
    });
};
$c955c2f98be1c5c4$export$b659014c52e02228.propTypes = {};

});
parcelRegister("kyn4R", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return (parcelRequire("k5oqn")).Track; });
$parcel$export(module.exports, "TrackLocked", function () { return (parcelRequire("lK2Gy")).TrackLocked; });

var $k5oqn = parcelRequire("k5oqn");

var $lK2Gy = parcelRequire("lK2Gy");

});
parcelRegister("k5oqn", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $bd273f9cb13d546b$export$13921ac0cc260818; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $aGYkJ = parcelRequire("aGYkJ");
const $bd273f9cb13d546b$export$13921ac0cc260818 = ({ track: track })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    const trackHasCover = !!coverId;
    const coverSource = (0, $hrd7b.useFile)(coverId || "");
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $aGYkJ.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $aGYkJ.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $aGYkJ.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "30px",
                    height: "30px",
                    src: coverSource,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {
                    css: (0, $aGYkJ.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $aGYkJ.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $aGYkJ.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $aGYkJ.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $aGYkJ.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
            })
        ]
    });
};
$bd273f9cb13d546b$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("aGYkJ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d08c15b132323116$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d08c15b132323116$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d08c15b132323116$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $d08c15b132323116$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $d08c15b132323116$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});


parcelRegister("lK2Gy", function(module, exports) {

$parcel$export(module.exports, "TrackLocked", function () { return $e487ec1b9d5a2cf2$export$95154993d63756c1; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $1NAwV = parcelRequire("1NAwV");
const $e487ec1b9d5a2cf2$export$95154993d63756c1 = ({ track: track })=>{
    const theme = (0, $hXJcm.u)();
    const { userId: userId, name: name } = track;
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $1NAwV.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1NAwV.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {
                    css: (0, $1NAwV.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $1NAwV.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $1NAwV.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $1NAwV.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1NAwV.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
            })
        ]
    });
};
$e487ec1b9d5a2cf2$export$95154993d63756c1.propTypes = {};

});
parcelRegister("1NAwV", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8caf7762c50776e9$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8caf7762c50776e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8caf7762c50776e9$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $8caf7762c50776e9$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $8caf7762c50776e9$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});



parcelRegister("4tVaA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b0151e25d15a0fdf$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b0151e25d15a0fdf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b0151e25d15a0fdf$var$_ref = {
    name: "1h4mco6",
    styles: "&>div:not(:last-of-type){margin-bottom:8px;}"
};
var $b0151e25d15a0fdf$var$_ref2 = {
    name: "k231at",
    styles: "position:relative;height:150px;border-radius:4px"
};
var $b0151e25d15a0fdf$var$_ref3 = {
    name: "1kui3n4",
    styles: "display:flex;align-items:center;margin-left:8px"
};
var $b0151e25d15a0fdf$var$_ref4 = {
    name: "1kt1pq0",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto"
};
var $b0151e25d15a0fdf$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
var $b0151e25d15a0fdf$var$_ref6 = {
    name: "1nvqbcw",
    styles: "display:flex;flex-direction:column;margin-bottom:24px;text-align:center"
};
var $b0151e25d15a0fdf$var$_ref7 = {
    name: "2d7q80",
    styles: "flex-grow:0;flex-shrink:0;position:relative;width:180px;height:282px;cursor:pointer;overflow:hidden"
};
const $b0151e25d15a0fdf$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $b0151e25d15a0fdf$var$_ref7,
            // overlay
            overlay: {
                main: (hover)=>/*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.overlay, ";display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:4px;border:1px solid ", theme.colors.accent.normal, ";transition:opacity 0.2s,border 0.2s;opacity:", hover ? "1" : "0", ";background-color:", theme.colors.primary.normal, "E4;", ""),
                avatar: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:80px;height:80px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:8px;", ""),
                    image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:30px;height:30px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                author: {
                    main: $b0151e25d15a0fdf$var$_ref6,
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";width:120px;font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;", ""),
                    username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";width:120px;font-size:", (0, $48E0n.typography).sp, ";", "")
                },
                follow: /*#__PURE__*/ (0, $4N3Qt.css)("&>button{font-size:", (0, $48E0n.typography).sp, ";}", "")
            },
            // header
            header: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $b0151e25d15a0fdf$var$_ref5,
                    avatar: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;height:30px;width:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                        image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    author: {
                        main: $b0151e25d15a0fdf$var$_ref4,
                        name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).c, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).c, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    },
                    likes: {
                        main: $b0151e25d15a0fdf$var$_ref3,
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-right:4px;&>svg{width:14px;height:14px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                        likes: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";", "")
                    }
                }
            },
            // media
            media: {
                main: $b0151e25d15a0fdf$var$_ref2,
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                video: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                    play: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:60%;left:50%;transform:translate(-50%, -60%);&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.secondary.normal, ";}&>svg>circle{stroke:", theme.colors.secondary.normal, ";}", "")
                },
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("height:100%;background-color:", theme.colors.primary.darker, ";&>svg{position:absolute;top:60%;left:50%;width:30px;height:40px;transform:translate(-50%, -60%);}&>svg>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            // content
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("height:130px;overflow:hidden;padding:8px 8px 0px 8px;border-radius:0px 0px 4px 4px;background-color:", theme.colors.primary.darker, ";", ""),
                description: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";line-height:120%;word-break:break-word;height:62px;overflow:hidden;margin-bottom:8px;", ""),
                tracks: $b0151e25d15a0fdf$var$_ref
            },
            // footer
            footer: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.footer, ";position:absolute;bottom:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n        180deg,\n        ", theme.colors.primary.normal, "00 25.21%,\n        ", theme.colors.primary.normal, " 100%\n      );", "")
        }
    });

});


parcelRegister("3O7fS", function(module, exports) {

$parcel$export(module.exports, "PostCardUploaded", function () { return $a4c28b32e79c442a$export$6cc25747a9e57d38; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $d1vGL = parcelRequire("d1vGL");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
var $3gmqG = parcelRequire("3gmqG");
parcelRequire("lqGvg");
var $iaIfs = parcelRequire("iaIfs");

var $8WlmT = parcelRequire("8WlmT");
const $a4c28b32e79c442a$export$6cc25747a9e57d38 = ({ post: post, editDisabled: editDisabled = false, deleteDisabled: deleteDisabled = false, onClick: onClick, onEditClick: onEditClick, onDeleteClick: onDeleteClick })=>{
    const theme = (0, $hXJcm.u)();
    const [mediaLoadError, setMediaLoadError] = (0, $exYeM.useState)(false);
    const { id: postId, trackIds: trackIds, message: message, mediaType: mediaType, mediaId: mediaId, visibility: visibility, likesCount: likesCount, unlocksCount: unlocksCount, commentsCount: commentsCount } = post;
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $d1vGL.useTracks)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const postHasMedia = !!mediaId;
    const postMedia = (0, $hrd7b.useFile)(mediaId || "");
    const maxPostDescriptionLength = 84;
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $8WlmT.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8WlmT.styles)(theme).card.header.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $8WlmT.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $8WlmT.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $8WlmT.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Heart, {})
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $8WlmT.styles)(theme).card.header.content.likes.count,
                                    children: (0, $fJerj.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $8WlmT.styles)(theme).card.header.content.comments.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $8WlmT.styles)(theme).card.header.content.comments.icon,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Comment, {})
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $8WlmT.styles)(theme).card.header.content.comments.count,
                                    children: (0, $fJerj.numbersFormatter)(commentsCount || 0)
                                })
                            ]
                        }),
                        visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $8WlmT.styles)(theme).card.header.content.unlocks.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $8WlmT.styles)(theme).card.header.content.unlocks.icon,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $8WlmT.styles)(theme).card.header.content.unlocks.count,
                                    children: (0, $fJerj.numbersFormatter)(unlocksCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8WlmT.styles)(theme).card.media.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: postHasMedia && !mediaLoadError ? /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                    children: [
                        mediaType && mediaType === (0, $aeAwZ.EntityPostMediaType).Image && /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $8WlmT.styles)(theme).card.media.image,
                            onError: ()=>setMediaLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "150px",
                            src: postMedia,
                            alt: "post media"
                        }),
                        mediaType && mediaType === (0, $aeAwZ.EntityPostMediaType).Video && /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("video", {
                                    css: (0, $8WlmT.styles)(theme).card.media.video.main,
                                    onError: ()=>setMediaLoadError(true),
                                    width: "180",
                                    muted: true,
                                    preload: "metadata",
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("source", {
                                            src: postMedia,
                                            type: "video/mp4"
                                        }),
                                        "Your browser does not support the video tag."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $8WlmT.styles)(theme).card.media.video.play,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8WlmT.styles)(theme).card.media.placeholder,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Ryddm, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $8WlmT.styles)(theme).card.content.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $8WlmT.styles)(theme).card.content.description,
                        children: (0, $3gmqG.stringsCutter)(maxPostDescriptionLength, message || "")
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $8WlmT.styles)(theme).card.content.tracks,
                        children: isPostTracksLoading ? tracksLoadingPlaceholder : postTracks && postTracks.map((track)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $iaIfs.Track), {
                                track: track
                            }, `uploaded-post-${postId}-track-${track.id}`))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8WlmT.styles)(theme).card.footer.main,
                onClick: (e)=>e.stopPropagation(),
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $8WlmT.styles)(theme).card.footer.buttons.main,
                    children: [
                        onEditClick && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $8WlmT.styles)(theme).card.footer.buttons.edit.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                css: [
                                    (0, $8WlmT.styles)(theme).card.footer.buttons.edit.button.shared,
                                    editDisabled ? (0, $8WlmT.styles)(theme).card.footer.buttons.edit.button.disabled : (0, $8WlmT.styles)(theme).card.footer.buttons.edit.button.enabled,
                                    "",
                                    ""
                                ],
                                onClick: (e)=>onEditClick(e),
                                disabled: editDisabled,
                                type: "button",
                                "aria-label": "edit post",
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Edit, {
                                    css: (0, $8WlmT.styles)(theme).card.footer.buttons.edit.icon
                                })
                            })
                        }),
                        onDeleteClick && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $8WlmT.styles)(theme).card.footer.buttons.delete.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                css: [
                                    (0, $8WlmT.styles)(theme).card.footer.buttons.delete.button.shared,
                                    deleteDisabled ? (0, $8WlmT.styles)(theme).card.footer.buttons.delete.button.disabled : (0, $8WlmT.styles)(theme).card.footer.buttons.delete.button.enabled,
                                    "",
                                    ""
                                ],
                                onClick: (e)=>onDeleteClick(e),
                                disabled: deleteDisabled,
                                type: "button",
                                "aria-label": "delete post",
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Trash, {
                                    css: (0, $8WlmT.styles)(theme).card.footer.buttons.delete.icon
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$a4c28b32e79c442a$export$6cc25747a9e57d38.propTypes = {};

});
parcelRegister("lqGvg", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return (parcelRequire("iaIfs")).Track; });

var $iaIfs = parcelRequire("iaIfs");

});
parcelRegister("iaIfs", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $d17140dadbc9de23$export$13921ac0cc260818; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $jBATv = parcelRequire("jBATv");
const $d17140dadbc9de23$export$13921ac0cc260818 = ({ track: track })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    const trackHasCover = !!coverId;
    const coverSource = (0, $hrd7b.useFile)(coverId || "");
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $jBATv.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $jBATv.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $jBATv.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "30px",
                    height: "30px",
                    src: coverSource,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {
                    css: (0, $jBATv.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $jBATv.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $jBATv.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $jBATv.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $jBATv.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlayCircle, {})
            })
        ]
    });
};
$d17140dadbc9de23$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("jBATv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7a938e2cbdbdc303$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7a938e2cbdbdc303$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7a938e2cbdbdc303$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $7a938e2cbdbdc303$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $7a938e2cbdbdc303$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});



parcelRegister("8WlmT", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $dea392d1c90233ac$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $dea392d1c90233ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $dea392d1c90233ac$var$_ref = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $dea392d1c90233ac$var$_ref2 = {
    name: "e3viwr",
    styles: "display:flex;justify-content:center;width:100%"
};
var $dea392d1c90233ac$var$_ref3 = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $dea392d1c90233ac$var$_ref4 = {
    name: "e3viwr",
    styles: "display:flex;justify-content:center;width:100%"
};
var $dea392d1c90233ac$var$_ref5 = {
    name: "1h4mco6",
    styles: "&>div:not(:last-of-type){margin-bottom:8px;}"
};
var $dea392d1c90233ac$var$_ref6 = {
    name: "k231at",
    styles: "position:relative;height:150px;border-radius:4px"
};
var $dea392d1c90233ac$var$_ref7 = {
    name: "1swhn0m",
    styles: "display:flex;margin-right:4px;&>svg{width:14px;height:14px;}"
};
var $dea392d1c90233ac$var$_ref8 = {
    name: "p2fe58",
    styles: "display:flex;align-items:center;min-width:0"
};
var $dea392d1c90233ac$var$_ref9 = {
    name: "1prft12",
    styles: "display:flex;margin-right:4px;&>svg{width:12px;height:12px;}"
};
var $dea392d1c90233ac$var$_ref10 = {
    name: "jj94x",
    styles: "display:flex;align-items:center;margin-right:8px;min-width:0"
};
var $dea392d1c90233ac$var$_ref11 = {
    name: "1swhn0m",
    styles: "display:flex;margin-right:4px;&>svg{width:14px;height:14px;}"
};
var $dea392d1c90233ac$var$_ref12 = {
    name: "jj94x",
    styles: "display:flex;align-items:center;margin-right:8px;min-width:0"
};
var $dea392d1c90233ac$var$_ref13 = {
    name: "zjik7",
    styles: "display:flex"
};
var $dea392d1c90233ac$var$_ref14 = {
    name: "2d7q80",
    styles: "flex-grow:0;flex-shrink:0;position:relative;width:180px;height:282px;cursor:pointer;overflow:hidden"
};
const $dea392d1c90233ac$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $dea392d1c90233ac$var$_ref14,
            // header
            header: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $dea392d1c90233ac$var$_ref13,
                    likes: {
                        main: $dea392d1c90233ac$var$_ref12,
                        icon: $dea392d1c90233ac$var$_ref11,
                        count: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";", "")
                    },
                    comments: {
                        main: $dea392d1c90233ac$var$_ref10,
                        icon: $dea392d1c90233ac$var$_ref9,
                        count: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";", "")
                    },
                    unlocks: {
                        main: $dea392d1c90233ac$var$_ref8,
                        icon: $dea392d1c90233ac$var$_ref7,
                        count: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";", "")
                    }
                }
            },
            // media
            media: {
                main: $dea392d1c90233ac$var$_ref6,
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                video: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                    play: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:60%;left:50%;transform:translate(-50%, -60%);&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.secondary.normal, ";}&>svg>circle{stroke:", theme.colors.secondary.normal, ";}", "")
                },
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("height:100%;background-color:", theme.colors.primary.darker, ";&>svg{position:absolute;top:60%;left:50%;width:30px;height:40px;transform:translate(-50%, -60%);}&>svg>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            // content
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("height:130px;overflow:hidden;padding:8px 8px 0px 8px;border-radius:0px 0px 4px 4px;background-color:", theme.colors.primary.darker, ";", ""),
                description: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";line-height:120%;word-break:break-word;height:62px;overflow:hidden;margin-bottom:8px;", ""),
                tracks: $dea392d1c90233ac$var$_ref5
            },
            // footer
            footer: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.post.card.footer, ";display:flex;align-items:flex-end;position:absolute;bottom:0;left:0;width:100%;height:60px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, "00 25.21%,\n          ", theme.colors.primary.normal, " 100%\n        );", ""),
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;background-color:", theme.colors.primary.darker, "aa;border-radius:0px 0px 4px 4px;height:40px;width:100%;", ""),
                    edit: {
                        main: $dea392d1c90233ac$var$_ref4,
                        button: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;", ""),
                            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                            enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                        },
                        icon: $dea392d1c90233ac$var$_ref3
                    },
                    delete: {
                        main: $dea392d1c90233ac$var$_ref2,
                        button: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;", ""),
                            disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                            enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                        },
                        icon: $dea392d1c90233ac$var$_ref
                    }
                }
            }
        }
    });

});


parcelRegister("hGv1o", function(module, exports) {

$parcel$export(module.exports, "PostDeleteModal", function () { return $cfc25e5b33c6bc74$export$396fe6d9b11c10c; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $l1Cdj = parcelRequire("l1Cdj");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("58XFK");
var $ikFSC = parcelRequire("ikFSC");

var $8RMVR = parcelRequire("8RMVR");
const $cfc25e5b33c6bc74$export$396fe6d9b11c10c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const deletePostModalOpen = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostDeleteModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8RMVR.styles)().modal.main,
        children: deletePostModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $l1Cdj.postClosePostDeleteModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8RMVR.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ikFSC.PostDeleteCard), {})
            })
        })
    });
};
$cfc25e5b33c6bc74$export$396fe6d9b11c10c.propTypes = {};

});
parcelRegister("58XFK", function(module, exports) {

$parcel$export(module.exports, "PostDeleteCard", function () { return (parcelRequire("ikFSC")).PostDeleteCard; });

var $ikFSC = parcelRequire("ikFSC");

});
parcelRegister("ikFSC", function(module, exports) {

$parcel$export(module.exports, "PostDeleteCard", function () { return $0806700e68dcb008$export$c143e8fdf6e0e6ca; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $l1Cdj = parcelRequire("l1Cdj");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("28E3O");
var $er1Mv = parcelRequire("er1Mv");

var $9Imvt = parcelRequire("9Imvt");
const $0806700e68dcb008$export$c143e8fdf6e0e6ca = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const postDeleteError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9Imvt.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9Imvt.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $l1Cdj.postClosePostDeleteModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9Imvt.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Delete Post",
                    icon: (0, $9IIBp.icons).Trash
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9Imvt.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Are you sure you want to delete your post?"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $9Imvt.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9Imvt.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $er1Mv.PostDeleteForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $9Imvt.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: postDeleteError
                        })
                    })
                ]
            })
        ]
    });
};
$0806700e68dcb008$export$c143e8fdf6e0e6ca.propTypes = {};

});
parcelRegister("28E3O", function(module, exports) {

$parcel$export(module.exports, "PostDeleteForm", function () { return (parcelRequire("er1Mv")).PostDeleteForm; });

var $er1Mv = parcelRequire("er1Mv");

});
parcelRegister("er1Mv", function(module, exports) {

$parcel$export(module.exports, "PostDeleteForm", function () { return $18c384426755f395$export$2c7e35ae2bc3f407; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $dYlrS = parcelRequire("dYlrS");
const $18c384426755f395$export$2c7e35ae2bc3f407 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const postDeleteLoading = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostDeleteLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const post = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostDeleteModalPost));
    const submitDisabled = postDeleteLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $dYlrS.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $dYlrS.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $g5prJ.postDelete)({
                    id: post?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $dYlrS.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
                        post: post || {},
                        currentUserId: profile?.id || "",
                        onClick: ()=>()=>{},
                        onAuthorNameClick: ()=>()=>{},
                        onAuthorUsernameClick: ()=>()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $dYlrS.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "delete post",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: postDeleteLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Delete"
                    })
                })
            ]
        })
    });
};
$18c384426755f395$export$2c7e35ae2bc3f407.propTypes = {};

});
parcelRegister("dYlrS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0d16234e9c3d527b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $0d16234e9c3d527b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0d16234e9c3d527b$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $0d16234e9c3d527b$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                track: $0d16234e9c3d527b$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("9Imvt", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5279399af4be5cbc$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $5279399af4be5cbc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5279399af4be5cbc$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $5279399af4be5cbc$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $5279399af4be5cbc$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $5279399af4be5cbc$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5279399af4be5cbc$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5279399af4be5cbc$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $5279399af4be5cbc$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $5279399af4be5cbc$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $5279399af4be5cbc$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($5279399af4be5cbc$var$_ref8), " ", (0, $48E0n.mq).mobile($5279399af4be5cbc$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($5279399af4be5cbc$var$_ref6), ";", ""),
            title: $5279399af4be5cbc$var$_ref5,
            subtitle: $5279399af4be5cbc$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($5279399af4be5cbc$var$_ref3), ";", ""),
                form: $5279399af4be5cbc$var$_ref2,
                error: $5279399af4be5cbc$var$_ref
            }
        }
    });

});



parcelRegister("8RMVR", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e30b8b1b66d95a02$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e30b8b1b66d95a02$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e30b8b1b66d95a02$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $e30b8b1b66d95a02$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($e30b8b1b66d95a02$var$_ref), ";", "")
        }
    });

});


parcelRegister("4uBSx", function(module, exports) {

$parcel$export(module.exports, "PostListFeedPopular", function () { return $08a7f231d1baa5d7$export$e936cae6b713be21; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $agnse = parcelRequire("agnse");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $tfFeM = parcelRequire("tfFeM");
const $08a7f231d1baa5d7$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPopularPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-feed-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $tfFeM.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $tfFeM.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $08a7f231d1baa5d7$export$e936cae6b713be21 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const popularPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPopularPosts));
    const popularPostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPopularPostsCount));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!popularPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetPopularPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $4vSc9.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: popularPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: popularPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: popularPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $08a7f231d1baa5d7$var$Row
                })
        })
    });
};
$08a7f231d1baa5d7$export$e936cae6b713be21.propTypes = {};

});
parcelRegister("tfFeM", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b3d8ee241f8f78f1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $b3d8ee241f8f78f1$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("9mnCV", function(module, exports) {

$parcel$export(module.exports, "PostListFeedRecommended", function () { return $8e75c242477c789a$export$43345a646054aff1; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $agnse = parcelRequire("agnse");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $gUMqQ = parcelRequire("gUMqQ");
const $8e75c242477c789a$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectRecommendedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-feed-recommended")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gUMqQ.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gUMqQ.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $8e75c242477c789a$export$43345a646054aff1 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const recommendedPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectRecommendedPosts));
    const recommendedPostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectRecommendedPostsCount));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!recommendedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetRecommendedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $4vSc9.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: recommendedPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: recommendedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: recommendedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $8e75c242477c789a$var$Row
                })
        })
    });
};
$8e75c242477c789a$export$43345a646054aff1.propTypes = {};

});
parcelRegister("gUMqQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7701df554577878b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $7701df554577878b$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("asBNd", function(module, exports) {

$parcel$export(module.exports, "PostListHomePublic", function () { return $b958ec809cb5cda7$export$250dcb62c2923f35; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $f0LKE = parcelRequire("f0LKE");
var $5hO4P = parcelRequire("5hO4P");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $agnse = parcelRequire("agnse");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $92XiT = parcelRequire("92XiT");
const $b958ec809cb5cda7$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPublicPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-home-public")
        })
    });
    const { visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const renderLocked = isContentLocked;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $92XiT.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)()),
            onAuthorNameClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)()),
            onAuthorUsernameClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)())
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $92XiT.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5hO4P.PostCardPublic), {
            post: post,
            overlayAction: {
                name: "Follow",
                label: "follow artist",
                onClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)())
            }
        })
    });
});
const $b958ec809cb5cda7$export$250dcb62c2923f35 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const publicPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPublicPosts));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    // TODO: uncomment once 60 posts created
    // const defaultContentCount = 60
    const defaultContentCount = 12;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!publicPosts[index];
    const loadMoreItems = ()=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetPublicPosts)());
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular Posts",
        overrideCss: (0, $4vSc9.contentLayout).home,
        itemWidth: itemWidth,
        itemsCount: defaultContentCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $b958ec809cb5cda7$var$Row
                })
        })
    });
};
$b958ec809cb5cda7$export$250dcb62c2923f35.propTypes = {};

});
parcelRegister("92XiT", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3ba250eacc4ef2fd$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $3ba250eacc4ef2fd$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("dGMDg", function(module, exports) {

$parcel$export(module.exports, "PostListLibraryLiked", function () { return $fe0c9a9e0740c3ef$export$244b1302f656142c; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $8tcX0 = parcelRequire("8tcX0");
const $fe0c9a9e0740c3ef$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectLikedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-library-liked")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8tcX0.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8tcX0.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $fe0c9a9e0740c3ef$export$244b1302f656142c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const likedPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectLikedPosts));
    const likedPostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectLikedPostsCount));
    const likedPostsLength = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectLikedPostsLength));
    const likedPostsFetched = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectLikedPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!likedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetLikedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if liked posts are fetched but length is 0
    if (likedPostsFetched && likedPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Liked Posts",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Posts,
            height: "294px",
            title: "You haven't liked any post yet"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Liked Posts",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: likedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: likedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $fe0c9a9e0740c3ef$var$Row
                })
        })
    });
};
$fe0c9a9e0740c3ef$export$244b1302f656142c.propTypes = {};

});
parcelRegister("8tcX0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $59dc4738f28921ed$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $59dc4738f28921ed$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("2Yzy7", function(module, exports) {

$parcel$export(module.exports, "PostListLibraryUnlocked", function () { return $39f891d1e6658149$export$797b6c01a2d4a375; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $gw8q9 = parcelRequire("gw8q9");
const $39f891d1e6658149$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUnlockedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-library-unlocked")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gw8q9.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gw8q9.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $39f891d1e6658149$export$797b6c01a2d4a375 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const unlockedPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUnlockedPosts));
    const unlockedPostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUnlockedPostsCount));
    const unlockedPostsLength = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUnlockedPostsLength));
    const unlockedPostsFetched = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUnlockedPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!unlockedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetUnlockedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if unlocked posts are fetched but length is 0
    if (unlockedPostsFetched && unlockedPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Unlocked Posts",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Posts,
            height: "294px",
            title: "You haven't unlocked any post yet"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Unlocked Posts",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: unlockedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: unlockedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $39f891d1e6658149$var$Row
                })
        })
    });
};
$39f891d1e6658149$export$797b6c01a2d4a375.propTypes = {};

});
parcelRegister("gw8q9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a60f72f4a6841485$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $a60f72f4a6841485$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("gwXHL", function(module, exports) {

$parcel$export(module.exports, "PostListStudioUploaded", function () { return $fb994dc2243eebc8$export$776358b8f2e0c990; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $3O7fS = parcelRequire("3O7fS");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $2CIMG = parcelRequire("2CIMG");
const $fb994dc2243eebc8$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const postDeleteLoading = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostDeleteLoading));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUploadedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-studio-uploaded")
        })
    });
    const { id: postId, visibility: visibility } = post;
    // if post is locked or loading - artist should not be able to delete it
    const deleteDisabled = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers || postDeleteLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $2CIMG.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3O7fS.PostCardUploaded), {
            post: post,
            deleteDisabled: deleteDisabled,
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onEditClick: ()=>navigate(`${(0, $9YTSb.Path).Studio}${(0, $9YTSb.Path).Post}/${postId}`),
            onDeleteClick: ()=>dispatch((0, $l1Cdj.postOpenPostDeleteModal)({
                    post: post
                }))
        })
    }, `uploaded-post-${postId}`);
});
const $fb994dc2243eebc8$export$776358b8f2e0c990 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const uploadedPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUploadedPosts));
    const uploadedPostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUploadedPostsCount));
    const uploadedPostsLength = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUploadedPostsLength));
    const uploadedPostsFetched = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUploadedPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!uploadedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetUploadedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if uploaded posts are fetched but length is 0
    if (uploadedPostsFetched && uploadedPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $4vSc9.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: uploadedPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Posts,
            height: "294px",
            title: "Couldn't find any uploaded posts"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $4vSc9.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: uploadedPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: uploadedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: uploadedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $fb994dc2243eebc8$var$Row
                })
        })
    });
};
$fb994dc2243eebc8$export$776358b8f2e0c990.propTypes = {};

});
parcelRegister("2CIMG", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $56622cd2b5c642c3$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $56622cd2b5c642c3$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("lAVsn", function(module, exports) {

$parcel$export(module.exports, "PostListUserExclusive", function () { return $f11149b7320a39e8$export$ef6ea7411239cae5; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $hknzI = parcelRequire("hknzI");
const $f11149b7320a39e8$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistExclusivePosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-user-exclusive")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $hknzI.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $hknzI.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $f11149b7320a39e8$export$ef6ea7411239cae5 = ()=>{
    const { userId: userId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const artistExclusivePosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistExclusivePosts));
    const artistExclusivePostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistExclusivePostsCount));
    const artistExclusivePostsLength = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistExclusivePostsLength));
    const artistExclusivePostsFetched = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistExclusivePostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistExclusivePosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetArtistExclusivePosts)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if exclusive posts are fetched but length is 0
    if (artistExclusivePostsFetched && artistExclusivePostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $9IIBp.icons).Lock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusivePostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Posts,
            height: "294px",
            title: "Couldn't find any exclusive posts"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $9IIBp.icons).Lock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusivePostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistExclusivePostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistExclusivePostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $f11149b7320a39e8$var$Row
                })
        })
    });
};
$f11149b7320a39e8$export$ef6ea7411239cae5.propTypes = {};

});
parcelRegister("hknzI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $54b7d2a5275dccb7$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $54b7d2a5275dccb7$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("5nmHP", function(module, exports) {

$parcel$export(module.exports, "PostListUserLatest", function () { return $d9cd8a2c3026468d$export$c4d71d3afc3cb114; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $51QrD = parcelRequire("51QrD");
const $d9cd8a2c3026468d$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistLatestPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-user-latest")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $51QrD.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $51QrD.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $d9cd8a2c3026468d$export$c4d71d3afc3cb114 = ()=>{
    const { userId: userId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const artistLatestPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistLatestPosts));
    const artistLatestPostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistLatestPostsCount));
    const artistLatestPostsLength = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistLatestPostsLength));
    const artistLatestPostsFetched = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistLatestPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistLatestPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetArtistLatestPosts)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if latest posts are fetched but length is 0
    if (artistLatestPostsFetched && artistLatestPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $9IIBp.icons).Clock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Posts,
            height: "294px",
            title: "Couldn't find any latest posts"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $9IIBp.icons).Clock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistLatestPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistLatestPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $d9cd8a2c3026468d$var$Row
                })
        })
    });
};
$d9cd8a2c3026468d$export$c4d71d3afc3cb114.propTypes = {};

});
parcelRegister("51QrD", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a5c7ae7e1c02ee57$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $a5c7ae7e1c02ee57$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("eOOcW", function(module, exports) {

$parcel$export(module.exports, "PostListUserPopular", function () { return $d57e573b7ab9adf5$export$1d57ee2778df2641; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $6kdLg = parcelRequire("6kdLg");
var $f0LKE = parcelRequire("f0LKE");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $8c9Sv = parcelRequire("8c9Sv");
var $gfND9 = parcelRequire("gfND9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $lnjJS = parcelRequire("lnjJS");
const $d57e573b7ab9adf5$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const posts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistPopularPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $8c9Sv.postUtilGetPostCardSkeletonSections)("post-list-user-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lnjJS.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f0LKE.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lnjJS.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6kdLg.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $d57e573b7ab9adf5$export$1d57ee2778df2641 = ()=>{
    const { userId: userId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const artistPopularPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistPopularPosts));
    const artistPopularPostsCount = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistPopularPostsCount));
    const artistPopularPostsLength = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistPopularPostsLength));
    const artistPopularPostsFetched = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectArtistPopularPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistPopularPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $g5prJ.postGetArtistPopularPosts)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if popular posts are fetched but length is 0
    if (artistPopularPostsFetched && artistPopularPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $9IIBp.icons).Crown,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Posts,
            height: "294px",
            title: "Couldn't find any popular posts"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $9IIBp.icons).Crown,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularPostsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistPopularPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistPopularPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $d57e573b7ab9adf5$var$Row
                })
        })
    });
};
$d57e573b7ab9adf5$export$1d57ee2778df2641.propTypes = {};

});
parcelRegister("lnjJS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d81c0a1b88c92c9b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $d81c0a1b88c92c9b$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("7MMhY", function(module, exports) {

$parcel$export(module.exports, "PostViewCreateStudio", function () { return $c5fc7e476c2975a8$export$596463192fa063d9; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("iBcV7");
var $jON6Q = parcelRequire("jON6Q");

var $be36w = parcelRequire("be36w");
const $c5fc7e476c2975a8$export$596463192fa063d9 = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $be36w.styles)().card.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $be36w.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $be36w.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jON6Q.Form), {})
            })
        })
    });
$c5fc7e476c2975a8$export$596463192fa063d9.propTypes = {};

});
parcelRegister("iBcV7", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("jON6Q")).Form; });

var $jON6Q = parcelRequire("jON6Q");

});
parcelRegister("jON6Q", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $ddf17a9fa711dbd6$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $P3Zb0 = parcelRequire("P3Zb0");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $9a5k4 = parcelRequire("9a5k4");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $g5prJ = parcelRequire("g5prJ");
var $l1Cdj = parcelRequire("l1Cdj");
var $29L7M = parcelRequire("29L7M");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
var $6FETc = parcelRequire("6FETc");
var $9TEV9 = parcelRequire("9TEV9");
var $f4vJY = parcelRequire("f4vJY");
var $i8CSQ = parcelRequire("i8CSQ");
var $9SS8i = parcelRequire("9SS8i");
var $lB36X = parcelRequire("lB36X");
var $1sbY5 = parcelRequire("1sbY5");
var $3wbuR = parcelRequire("3wbuR");

var $5m4VS = parcelRequire("5m4VS");
const $ddf17a9fa711dbd6$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postCreateLoading = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostCreateLoading));
    // connect ready
    const { ready: connectReady } = (0, $9a5k4.useConnectReady)(profile?.id || "");
    // media state
    const [media, setMedia] = (0, $exYeM.useState)(undefined);
    const [mediaPreview, setMediaPreview] = (0, $exYeM.useState)("");
    const [mediaPreviewType, setMediaPreviewType] = (0, $exYeM.useState)("");
    const mediaFileInputRef = (0, $exYeM.useRef)(null);
    const [mediaError, setMediaError] = (0, $exYeM.useState)("");
    // message state
    const [message, setMessage] = (0, $exYeM.useState)("");
    const [messageError, setMessageError] = (0, $exYeM.useState)("");
    // tracks state
    const [tracks, setTracks] = (0, $exYeM.useState)([]);
    // visibility state
    const [visibility, setVisibility] = (0, $exYeM.useState)((0, $aeAwZ.EntityPostVisibility).Public);
    // unlock price state
    const defaultUnlockPrice = Math.ceil((0, $P3Zb0.maxPostUnlockPrice) / 2);
    const [unlockPrice, setUnlockPrice] = (0, $exYeM.useState)(defaultUnlockPrice);
    const submitDisabled = message.length < (0, $P3Zb0.minPostMessageLength) || message.length > (0, $P3Zb0.maxPostMessageLength) || unlockPrice < (0, $P3Zb0.minPostUnlockPrice) || unlockPrice > (0, $P3Zb0.maxPostUnlockPrice) || mediaError !== "" || messageError !== "" || postCreateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setMedia(undefined);
        setMessage("");
        setTracks([]);
        setVisibility((0, $aeAwZ.EntityPostVisibility).Public);
        setUnlockPrice(defaultUnlockPrice);
        // if media preview was set
        if (mediaPreview) {
            // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
            setMediaPreview("");
        }
    };
    const onMediaClick = ()=>{
        mediaFileInputRef.current?.click();
        setMediaError("");
    };
    const onMediaFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validatePostMediaFile)(file);
            if (error) {
                setMediaError(error);
                return;
            }
            // if file of image type
            if (file.type.startsWith("image/")) setMediaPreviewType("image");
            // if file of video type
            if (file.type.startsWith("video/")) setMediaPreviewType("video");
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
            // set file as a preview
            setMediaPreview(URL.createObjectURL(file));
            // store file in state
            setMedia(file);
        }
    };
    (0, $exYeM.useEffect)(()=>()=>{
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
        });
    (0, $exYeM.useEffect)(()=>{
        if (!postCreateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        postCreateLoading
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $5m4VS.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $5m4VS.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $g5prJ.postCreate)({
                    message: message,
                    media: media,
                    tracks: tracks,
                    visibility: visibility,
                    unlockPrice: unlockPrice
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $5m4VS.styles)().form.content.media.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.media.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Media"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $5m4VS.styles)().form.content.media.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                                    css: (0, $5m4VS.styles)().form.content.media.preview.label,
                                    htmlFor: "media",
                                    children: [
                                        "media",
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                            name: "media",
                                            type: "file",
                                            id: "media",
                                            ref: mediaFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png,video/quicktime,video/mp4,video/webm",
                                            onChange: (e)=>onMediaFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $5m4VS.styles)().form.content.media.preview.image,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3wbuR.MediaFilePreview), {
                                        source: mediaPreview,
                                        type: mediaPreviewType,
                                        width: "100%",
                                        height: "200px",
                                        alt: "post media",
                                        onClick: ()=>onMediaClick(),
                                        formats: [
                                            "JPG",
                                            "JPEG",
                                            "PNG",
                                            "WEBP",
                                            "MOV",
                                            "MP4",
                                            "WEBM"
                                        ],
                                        maxFileSize: (0, $P3Zb0.maxPostMediaFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.media.error,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                                error: mediaError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $5m4VS.styles)().form.content.message.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.message.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Message"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.message.input,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i8CSQ.InputArea), {
                                name: "message",
                                label: "message",
                                id: "tip-message",
                                placeholder: "Share your experience with your followers",
                                value: message,
                                maxLength: (0, $P3Zb0.maxPostMessageLength),
                                error: messageError.length > 0,
                                errorMessage: messageError,
                                rows: 6,
                                onChange: (e)=>setMessage(e.target.value),
                                onBlur: ()=>setMessageError((0, $33ayT.validatePostMessage)(message)),
                                onFocus: ()=>setMessageError("")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $5m4VS.styles)().form.content.tracks.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.tracks.list,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $29L7M.TrackListStudioPostUploaded), {
                                postTracks: tracks,
                                addPostTrack: (track)=>tracks.length < (0, $P3Zb0.maxPostTracksCount) ? setTracks((state)=>[
                                            ...state,
                                            track
                                        ]) : ()=>{},
                                removePostTrack: (trackId)=>setTracks((state)=>state.filter((t)=>t.id !== trackId))
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.tracks.description,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9SS8i.InputDescription), {
                                description: `Feel free to include a maximum of ${(0, $P3Zb0.maxPostTracksCount)} tracks in your post.`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $5m4VS.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $5m4VS.styles)().form.content.visibility.inputs,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the post is made publicly accessible to everyone on the platform.",
                                    icon: (0, $9IIBp.icons).Unlock,
                                    checked: visibility === (0, $aeAwZ.EntityPostVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityPostVisibility).Public)
                                }),
                                connectReady && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the post is exclusively accessible to subscribers or individuals who unlock it directly, unlocking the post grants the user access to all the locked tracks it contains.",
                                    icon: (0, $9IIBp.icons).Lock,
                                    checked: visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityPostVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $5m4VS.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $5m4VS.styles)().form.content.price.amount,
                            children: [
                                "$",
                                unlockPrice
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $5m4VS.styles)().form.content.price.input,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f4vJY.InputAmount), {
                                name: "unlock-price",
                                label: "unlock price",
                                type: "range",
                                id: "unlock-price",
                                value: unlockPrice,
                                min: (0, $P3Zb0.minPostUnlockPrice),
                                max: (0, $P3Zb0.maxPostUnlockPrice),
                                onChange: (e)=>setUnlockPrice(parseInt(e.target.value, 10))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $5m4VS.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $5m4VS.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                            type: "submit",
                            "aria-label": "create post",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: postCreateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Create"
                        })
                    })
                })
            ]
        })
    });
};
$ddf17a9fa711dbd6$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("5m4VS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $14d524d2ad77afe0$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $14d524d2ad77afe0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $14d524d2ad77afe0$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $14d524d2ad77afe0$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $14d524d2ad77afe0$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $14d524d2ad77afe0$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $14d524d2ad77afe0$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $14d524d2ad77afe0$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $14d524d2ad77afe0$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $14d524d2ad77afe0$var$_ref8 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $14d524d2ad77afe0$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $14d524d2ad77afe0$var$_ref10 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $14d524d2ad77afe0$var$_ref11 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $14d524d2ad77afe0$var$_ref12 = {
    name: "eivff4",
    styles: "display:none"
};
var $14d524d2ad77afe0$var$_ref13 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $14d524d2ad77afe0$var$_ref14 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $14d524d2ad77afe0$var$_ref15 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $14d524d2ad77afe0$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                media: {
                    main: $14d524d2ad77afe0$var$_ref15,
                    label: $14d524d2ad77afe0$var$_ref14,
                    preview: {
                        main: $14d524d2ad77afe0$var$_ref13,
                        label: $14d524d2ad77afe0$var$_ref12,
                        image: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                    },
                    error: $14d524d2ad77afe0$var$_ref11
                },
                message: {
                    main: $14d524d2ad77afe0$var$_ref10,
                    label: $14d524d2ad77afe0$var$_ref9,
                    input: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                tracks: {
                    main: $14d524d2ad77afe0$var$_ref8,
                    list: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    description: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                visibility: {
                    main: $14d524d2ad77afe0$var$_ref7,
                    label: $14d524d2ad77afe0$var$_ref6,
                    inputs: $14d524d2ad77afe0$var$_ref5
                },
                price: {
                    main: $14d524d2ad77afe0$var$_ref4,
                    label: $14d524d2ad77afe0$var$_ref3,
                    amount: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";line-height:24px;margin-bottom:10px;", ""),
                    input: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).tablet($14d524d2ad77afe0$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:220px;}", (0, $48E0n.mq).tablet($14d524d2ad77afe0$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("be36w", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d3209ce760a9dc41$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d3209ce760a9dc41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d3209ce760a9dc41$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d3209ce760a9dc41$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d3209ce760a9dc41$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $d3209ce760a9dc41$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $d3209ce760a9dc41$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:400px;", (0, $48E0n.mq).tablet($d3209ce760a9dc41$var$_ref2), ";", ""),
                form: $d3209ce760a9dc41$var$_ref
            }
        }
    });

});


parcelRegister("cAgHk", function(module, exports) {

$parcel$export(module.exports, "PostViewEditStudio", function () { return $4c7e9f433d79116d$export$5287db19b393e810; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("gNgfv");
var $1dktG = parcelRequire("1dktG");

var $f4LLL = parcelRequire("f4LLL");
const $4c7e9f433d79116d$export$5287db19b393e810 = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $f4LLL.styles)().card.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $f4LLL.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f4LLL.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1dktG.Form), {})
            })
        })
    });
$4c7e9f433d79116d$export$5287db19b393e810.propTypes = {};

});
parcelRegister("gNgfv", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("1dktG")).Form; });

var $1dktG = parcelRequire("1dktG");

});
parcelRegister("1dktG", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $fa7e25c8cc5918fd$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $P3Zb0 = parcelRequire("P3Zb0");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
var $d1vGL = parcelRequire("d1vGL");
parcelRequire("dmGpj");
var $l1Cdj = parcelRequire("l1Cdj");
var $g5prJ = parcelRequire("g5prJ");
var $29L7M = parcelRequire("29L7M");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
var $6FETc = parcelRequire("6FETc");
var $9TEV9 = parcelRequire("9TEV9");
var $i8CSQ = parcelRequire("i8CSQ");
var $9SS8i = parcelRequire("9SS8i");
var $lB36X = parcelRequire("lB36X");
var $1sbY5 = parcelRequire("1sbY5");
var $3wbuR = parcelRequire("3wbuR");

var $bQrGN = parcelRequire("bQrGN");
const $fa7e25c8cc5918fd$export$a7fed597f4b8afd8 = ()=>{
    const { postId: postId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const postUpdateLoading = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostUpdateLoading));
    const uploadedPosts = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectUploadedPosts));
    const post = uploadedPosts.find((p)=>p.id === postId);
    const { mediaId: mediaId, mediaType: mediaType, trackIds: trackIds, message: currentMessage, visibility: currentVisibility, unlockPrice: currentUnlockPrice } = post ?? {};
    const getMediaPreviewType = ()=>{
        if (mediaType === (0, $aeAwZ.EntityPostMediaType).Image) return "image";
        if (mediaType === (0, $aeAwZ.EntityPostMediaType).Video) return "video";
        return "";
    };
    // post tracks
    const { tracks: postTracks } = (0, $d1vGL.useTracks)(trackIds || []);
    // media state
    const postHasMedia = !!mediaId;
    const postMedia = (0, $hrd7b.useFile)(mediaId || "");
    const [media, setMedia] = (0, $exYeM.useState)(undefined);
    const [mediaPreview, setMediaPreview] = (0, $exYeM.useState)(postHasMedia ? postMedia : "");
    const [mediaPreviewType, setMediaPreviewType] = (0, $exYeM.useState)(getMediaPreviewType());
    const mediaFileInputRef = (0, $exYeM.useRef)(null);
    const [mediaError, setMediaError] = (0, $exYeM.useState)("");
    // message state
    const [message, setMessage] = (0, $exYeM.useState)(currentMessage || "");
    const [messageError, setMessageError] = (0, $exYeM.useState)("");
    // tracks state
    const [tracks, setTracks] = (0, $exYeM.useState)(postTracks || []);
    // visibility state
    const [visibility, setVisibility] = (0, $exYeM.useState)(currentVisibility || (0, $aeAwZ.EntityPostVisibility).Public);
    const messageUnchanged = message === currentMessage;
    const tracksUnchanged = tracks.map((t)=>t.id).join("") === postTracks?.map((t)=>t.id).join("");
    const mediaNotSelected = media === undefined;
    const postDefaultsUnchanged = messageUnchanged && tracksUnchanged && mediaNotSelected;
    const submitDisabled = postDefaultsUnchanged || message.length < (0, $P3Zb0.minPostMessageLength) || message.length > (0, $P3Zb0.maxPostMessageLength) || mediaError !== "" || messageError !== "" || postUpdateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setMedia(undefined);
        setMessage(currentMessage || "");
        setTracks(postTracks || []);
        setVisibility(currentVisibility || (0, $aeAwZ.EntityPostVisibility).Public);
    };
    const onMediaClick = ()=>{
        mediaFileInputRef.current?.click();
        setMediaError("");
    };
    const onMediaFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validatePostMediaFile)(file);
            if (error) {
                setMediaError(error);
                return;
            }
            // if file of image type
            if (file.type.startsWith("image/")) setMediaPreviewType("image");
            // if file of video type
            if (file.type.startsWith("video/")) setMediaPreviewType("video");
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
            // set file as a preview
            setMediaPreview(URL.createObjectURL(file));
            // store file in state
            setMedia(file);
        }
    };
    (0, $exYeM.useEffect)(()=>()=>{
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
        });
    (0, $exYeM.useEffect)(()=>{
        if (!postUpdateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        postUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $bQrGN.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $bQrGN.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $g5prJ.postUpdate)({
                    post: post || {},
                    message: message,
                    media: media,
                    tracks: tracks
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bQrGN.styles)().form.content.media.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.media.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Media"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bQrGN.styles)().form.content.media.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                                    css: (0, $bQrGN.styles)().form.content.media.preview.label,
                                    htmlFor: "media",
                                    children: [
                                        "media",
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                            name: "media",
                                            type: "file",
                                            id: "media",
                                            ref: mediaFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png,video/quicktime,video/mp4,video/webm",
                                            onChange: (e)=>onMediaFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $bQrGN.styles)().form.content.media.preview.image,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3wbuR.MediaFilePreview), {
                                        source: mediaPreview,
                                        type: mediaPreviewType,
                                        width: "100%",
                                        height: "200px",
                                        alt: "post media",
                                        onClick: ()=>onMediaClick(),
                                        formats: [
                                            "JPG",
                                            "JPEG",
                                            "PNG",
                                            "WEBP",
                                            "MOV",
                                            "MP4",
                                            "WEBM"
                                        ],
                                        maxFileSize: (0, $P3Zb0.maxPostMediaFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.media.error,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                                error: mediaError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bQrGN.styles)().form.content.message.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.message.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Message"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.message.input,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i8CSQ.InputArea), {
                                name: "message",
                                label: "message",
                                id: "tip-message",
                                placeholder: "Share your experience with your followers",
                                value: message,
                                maxLength: (0, $P3Zb0.maxPostMessageLength),
                                error: messageError.length > 0,
                                errorMessage: messageError,
                                rows: 6,
                                onChange: (e)=>setMessage(e.target.value),
                                onBlur: ()=>setMessageError((0, $33ayT.validatePostMessage)(message)),
                                onFocus: ()=>setMessageError("")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bQrGN.styles)().form.content.tracks.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.tracks.list,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $29L7M.TrackListStudioPostUploaded), {
                                postTracks: tracks,
                                addPostTrack: (track)=>tracks.length < (0, $P3Zb0.maxPostTracksCount) ? setTracks((state)=>[
                                            ...state,
                                            track
                                        ]) : ()=>{},
                                removePostTrack: (trackId)=>setTracks((state)=>state.filter((t)=>t.id !== trackId))
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.tracks.description,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9SS8i.InputDescription), {
                                description: `Feel free to include a maximum of ${(0, $P3Zb0.maxPostTracksCount)} tracks in your post.`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bQrGN.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bQrGN.styles)().form.content.visibility.inputs,
                            children: [
                                visibility === (0, $aeAwZ.EntityPostVisibility).Public && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the post is made publicly accessible to everyone on the platform.",
                                    icon: (0, $9IIBp.icons).Unlock,
                                    checked: visibility === (0, $aeAwZ.EntityPostVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityPostVisibility).Public)
                                }),
                                visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the post is exclusively accessible to subscribers or individuals who unlock it directly, unlocking the post grants the user access to all the locked tracks it contains.",
                                    icon: (0, $9IIBp.icons).Lock,
                                    checked: visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityPostVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bQrGN.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bQrGN.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bQrGN.styles)().form.content.price.amount,
                            children: [
                                " ",
                                "$",
                                (currentUnlockPrice || 0) / 100
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $bQrGN.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bQrGN.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                            type: "submit",
                            "aria-label": "create post",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: postUpdateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Update"
                        })
                    })
                })
            ]
        })
    });
};
$fa7e25c8cc5918fd$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("bQrGN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $eace3dba5c298a74$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $eace3dba5c298a74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $eace3dba5c298a74$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $eace3dba5c298a74$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $eace3dba5c298a74$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $eace3dba5c298a74$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $eace3dba5c298a74$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $eace3dba5c298a74$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $eace3dba5c298a74$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $eace3dba5c298a74$var$_ref8 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $eace3dba5c298a74$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $eace3dba5c298a74$var$_ref10 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $eace3dba5c298a74$var$_ref11 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $eace3dba5c298a74$var$_ref12 = {
    name: "eivff4",
    styles: "display:none"
};
var $eace3dba5c298a74$var$_ref13 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $eace3dba5c298a74$var$_ref14 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $eace3dba5c298a74$var$_ref15 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $eace3dba5c298a74$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                media: {
                    main: $eace3dba5c298a74$var$_ref15,
                    label: $eace3dba5c298a74$var$_ref14,
                    preview: {
                        main: $eace3dba5c298a74$var$_ref13,
                        label: $eace3dba5c298a74$var$_ref12,
                        image: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                    },
                    error: $eace3dba5c298a74$var$_ref11
                },
                message: {
                    main: $eace3dba5c298a74$var$_ref10,
                    label: $eace3dba5c298a74$var$_ref9,
                    input: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                tracks: {
                    main: $eace3dba5c298a74$var$_ref8,
                    list: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    description: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                visibility: {
                    main: $eace3dba5c298a74$var$_ref7,
                    label: $eace3dba5c298a74$var$_ref6,
                    inputs: $eace3dba5c298a74$var$_ref5
                },
                price: {
                    main: $eace3dba5c298a74$var$_ref4,
                    label: $eace3dba5c298a74$var$_ref3,
                    amount: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";line-height:24px;margin-bottom:10px;", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).tablet($eace3dba5c298a74$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:220px;}", (0, $48E0n.mq).tablet($eace3dba5c298a74$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("f4LLL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7bd2ef89fd8a85ca$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7bd2ef89fd8a85ca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7bd2ef89fd8a85ca$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $7bd2ef89fd8a85ca$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7bd2ef89fd8a85ca$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $7bd2ef89fd8a85ca$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $7bd2ef89fd8a85ca$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:400px;", (0, $48E0n.mq).tablet($7bd2ef89fd8a85ca$var$_ref2), ";", ""),
                form: $7bd2ef89fd8a85ca$var$_ref
            }
        }
    });

});


parcelRegister("1feYX", function(module, exports) {

$parcel$export(module.exports, "PostViewMediaPost", function () { return $9312780b057325ba$export$ef8a9e19b0660e0f; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $9a5k4 = parcelRequire("9a5k4");
var $hrd7b = parcelRequire("hrd7b");
var $gSFbK = parcelRequire("gSFbK");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $l1Cdj = parcelRequire("l1Cdj");
var $6CAIO = parcelRequire("6CAIO");
var $hn1ob = parcelRequire("hn1ob");
var $gfND9 = parcelRequire("gfND9");
var $2zsG4 = parcelRequire("2zsG4");
var $eFMHm = parcelRequire("eFMHm");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $11ovL = parcelRequire("11ovL");
const $9312780b057325ba$export$ef8a9e19b0660e0f = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const postLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectPostLikes));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const post = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPost));
    const postFetched = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPostFetched));
    const { id: profileUserId, role: profileUserRole } = profile ?? {};
    const { // id
    id: postId, // author
    userId: postAuthorUserId, mediaId: // content
    mediaId, mediaType: mediaType, message: message, commentsCount: // data
    commentsCount, likesCount: likesCount, visibility: // visibility
    visibility } = post ?? {};
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $gSFbK.useUser)(postAuthorUserId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $hrd7b.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $exYeM.useState)(false);
    const postHasMedia = !!mediaId;
    const postMedia = (0, $hrd7b.useFile)(mediaId || "");
    const [postMediaLoadError, setPostMediaLoadError] = (0, $exYeM.useState)(false);
    // connect ready
    const { ready: isAuthorCanReceivePayments } = (0, $9a5k4.useConnectReady)(postAuthorUserId || "");
    const followDisabled = false;
    const unfollowDisabled = false;
    const subscribeDisabled = false;
    const unsubscribeDisabled = false;
    const tipDisabled = false;
    const blockDisabled = false;
    const reportDisabled = false;
    const isCurrentUserAdmin = profileUserRole === (0, $aeAwZ.EntityUserRole).Admin;
    const isPostAuthorFollowed = userFollows[postAuthorUserId || ""];
    const isPostLiked = postLikes[postId || ""];
    const isPostCommented = false;
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = profileUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const isCurrentUserSubscribedToContentAuthorAtPeriodEnd = userSubscriptionsAtPeriodEnd[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // on post view
    (0, $exYeM.useEffect)(()=>{
        const tenSeconds = 10000;
        const id = setTimeout(()=>{
            // if post exists and is not locked
            if (post && !renderLocked) // after n seconds create post stream
            dispatch((0, $hn1ob.streamCreatePostStream)({
                post: post
            }));
        }, tenSeconds);
        return ()=>clearInterval(id);
    }, [
        post,
        renderLocked,
        dispatch
    ]);
    // if post is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $11ovL.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Lock,
            height: "504px",
            title: "Content is locked"
        })
    });
    // if post not found
    if (postFetched && !post) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $11ovL.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Posts,
            height: "504px",
            title: "Could not find post"
        })
    });
    const renderPostMedia = ()=>{
        // if post media type is image
        if (mediaType === (0, $aeAwZ.EntityPostMediaType).Image && postHasMedia && !postMediaLoadError) // render image
        return /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
            css: (0, $11ovL.styles)(theme).view.media.image,
            onError: ()=>setPostMediaLoadError(true),
            loading: "lazy",
            src: postMedia,
            alt: "post media content"
        });
        // if post media type is video
        if (mediaType === (0, $aeAwZ.EntityPostMediaType).Video && postHasMedia && !postMediaLoadError) // render video
        return /*#__PURE__*/ (0, $5o6z6.jsxs)("video", {
            css: (0, $11ovL.styles)(theme).view.media.video,
            onError: ()=>setPostMediaLoadError(true),
            src: postMedia,
            controls: true,
            preload: "metadata",
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("source", {
                    src: postMedia,
                    type: "video/mp4"
                }),
                "Your browser does not support the video tag."
            ]
        });
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $11ovL.styles)(theme).view.media.placeholder,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Ryddm, {})
        });
    };
    const renderArtistActionsInput = {
        isCurrentUserFollowingArtist: isPostAuthorFollowed,
        isCurrentUserSubscribedToArtist: isCurrentUserSubscribedToContentAuthor,
        isCurrentUserSubscribedToArtistAtPeriodEnd: isCurrentUserSubscribedToContentAuthorAtPeriodEnd,
        isArtistCanReceivePayments: !!isAuthorCanReceivePayments,
        createUserFollowNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $11ovL.styles)(theme).view.footer.buttons.follow,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "follow author",
                disabled: followDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
                        user: {
                            ...postAuthor
                        }
                    })),
                children: "Follow"
            })
        }),
        deleteUserFollowNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $11ovL.styles)(theme).view.footer.buttons.unfollow,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "unfollow author",
                disabled: unfollowDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
                        user: {
                            ...postAuthor
                        }
                    })),
                children: "Unfollow"
            })
        }),
        createSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $11ovL.styles)(theme).view.footer.buttons.subscribe,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe on author",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCreateModal)({
                        artist: {
                            ...postAuthor
                        }
                    })),
                children: "Subscribe"
            })
        }),
        renewSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $11ovL.styles)(theme).view.footer.buttons.subscribe,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe on author",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionRenewModal)({
                        artist: {
                            ...postAuthor
                        }
                    })),
                children: "Subscribe"
            })
        }),
        cancelSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $11ovL.styles)(theme).view.footer.buttons.unsubscribe,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "unsubscribe from author",
                disabled: unsubscribeDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCancelModal)({
                        artist: {
                            ...postAuthor
                        }
                    })),
                children: "Unsubscribe"
            })
        }),
        defaultNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {})
    };
    // if post found
    if (postFetched && post) return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $11ovL.styles)(theme).view.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $11ovL.styles)(theme).view.media.main,
                children: renderPostMedia()
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $11ovL.styles)(theme).view.message.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: (0, $11ovL.styles)(theme).view.message.text,
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $11ovL.styles)(theme).view.footer.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $11ovL.styles)(theme).view.footer.author.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $11ovL.styles)(theme).view.footer.author.avatar.main,
                                children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                                    css: (0, $11ovL.styles)(theme).view.footer.author.avatar.image,
                                    onError: ()=>setAuthorAvatarLoadError(true),
                                    loading: "lazy",
                                    width: "30px",
                                    height: "30px",
                                    src: authorAvatar,
                                    alt: "post author avatar"
                                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                                    css: (0, $11ovL.styles)(theme).view.footer.author.avatar.icon
                                })
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                css: (0, $11ovL.styles)(theme).view.footer.author.info.main,
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                        css: (0, $11ovL.styles)(theme).view.footer.author.info.name,
                                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
                                        type: "button",
                                        "aria-label": "explore author profile",
                                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                        css: (0, $11ovL.styles)(theme).view.footer.author.info.username,
                                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${postAuthorUserId}`),
                                        type: "button",
                                        "aria-label": "explore author profile",
                                        children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $11ovL.styles)(theme).view.footer.buttons.main,
                        children: [
                            !isCurrentUserContentAuthor && (0, $hZCPc.userUtilRenderArtistActions)(renderArtistActionsInput),
                            !isCurrentUserContentAuthor && isAuthorCanReceivePayments && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $11ovL.styles)(theme).view.footer.buttons.tip,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                    type: "button",
                                    "aria-label": "send tip to author",
                                    disabled: tipDisabled,
                                    appearance: "primary",
                                    onClick: ()=>dispatch((0, $2zsG4.tipOpenTipModal)({
                                            artist: {
                                                ...postAuthor
                                            }
                                        })),
                                    children: "Tip"
                                })
                            }),
                            !isCurrentUserContentAuthor && (isCurrentUserAdmin ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $11ovL.styles)(theme).view.footer.buttons.block,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                    type: "button",
                                    "aria-label": "block post",
                                    disabled: blockDisabled,
                                    appearance: "secondary",
                                    onClick: ()=>dispatch((0, $l1Cdj.postOpenPostBlockModal)({
                                            post: post
                                        })),
                                    children: "Block"
                                })
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $11ovL.styles)(theme).view.footer.buttons.report,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                    type: "button",
                                    "aria-label": "report post",
                                    disabled: reportDisabled,
                                    appearance: "secondary",
                                    onClick: ()=>dispatch((0, $6CAIO.reportOpenReportPostModal)({
                                            post: post
                                        })),
                                    children: "Report"
                                })
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $11ovL.styles)(theme).view.footer.info.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                css: (0, $11ovL.styles)(theme).view.footer.info.comments.main,
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $11ovL.styles)(theme).view.footer.info.comments.buttons,
                                        children: isPostCommented ? /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                            css: [
                                                (0, $11ovL.styles)(theme).view.footer.info.comments.button.shared,
                                                (0, $11ovL.styles)(theme).view.footer.info.comments.button.commented,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>{},
                                            type: "button",
                                            "aria-label": "comment on post",
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CommentFilled, {})
                                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                            css: [
                                                (0, $11ovL.styles)(theme).view.footer.info.comments.button.shared,
                                                (0, $11ovL.styles)(theme).view.footer.info.comments.button.uncommented,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>{},
                                            type: "button",
                                            "aria-label": "comment on post",
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Comment, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $11ovL.styles)(theme).view.footer.info.comments.count,
                                        children: (0, $fJerj.numbersFormatter)(commentsCount || 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                css: (0, $11ovL.styles)(theme).view.footer.info.likes.main,
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $11ovL.styles)(theme).view.footer.info.likes.buttons,
                                        children: isPostLiked ? /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                            css: [
                                                (0, $11ovL.styles)(theme).view.footer.info.likes.button.shared,
                                                (0, $11ovL.styles)(theme).view.footer.info.likes.button.dislike,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>dispatch((0, $9ybfS.likeDeletePostLike)({
                                                    post: post
                                                })),
                                            type: "button",
                                            "aria-label": "dislike post",
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).HeartFilled, {})
                                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                            css: [
                                                (0, $11ovL.styles)(theme).view.footer.info.likes.button.shared,
                                                (0, $11ovL.styles)(theme).view.footer.info.likes.button.like,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>dispatch((0, $9ybfS.likeCreatePostLike)({
                                                    post: post
                                                })),
                                            type: "button",
                                            "aria-label": "like post",
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Heart, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $11ovL.styles)(theme).view.footer.info.likes.count,
                                        children: (0, $fJerj.numbersFormatter)(likesCount || 0)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    // else render skeleton
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $11ovL.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "100%",
            sections: [
                {
                    name: `post-media-view-post-media`,
                    width: "100%",
                    height: "400px",
                    isStatic: true,
                    isDivider: false
                },
                {
                    name: `post-media-view-post-divider`,
                    width: "100%",
                    height: "16px",
                    isStatic: true,
                    isDivider: true
                },
                {
                    name: `post-media-view-post-description`,
                    width: "100%",
                    height: "88.4px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$9312780b057325ba$export$ef8a9e19b0660e0f.propTypes = {};

});
parcelRegister("11ovL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $aa46d9ba6bb1d2ab$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $aa46d9ba6bb1d2ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $aa46d9ba6bb1d2ab$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $aa46d9ba6bb1d2ab$var$_ref2 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $aa46d9ba6bb1d2ab$var$_ref3 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $aa46d9ba6bb1d2ab$var$_ref4 = {
    name: "1tx1l5v",
    styles: "margin-right:auto"
};
var $aa46d9ba6bb1d2ab$var$_ref5 = {
    name: "6og82r",
    styles: "margin-left:0px"
};
var $aa46d9ba6bb1d2ab$var$_ref6 = {
    name: "1calkkd",
    styles: "&>div:not(:last-of-type){margin-right:0px;margin-bottom:12px;}&>div{width:100%;}flex-direction:column"
};
var $aa46d9ba6bb1d2ab$var$_ref7 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $aa46d9ba6bb1d2ab$var$_ref8 = {
    name: "62qxo5",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0"
};
var $aa46d9ba6bb1d2ab$var$_ref9 = {
    name: "bbnk5u",
    styles: "max-width:100%;margin-right:0px;margin-bottom:16px"
};
var $aa46d9ba6bb1d2ab$var$_ref10 = {
    name: "ieoj9s",
    styles: "flex-direction:column;align-items:stretch;flex-wrap:nowrap"
};
var $aa46d9ba6bb1d2ab$var$_ref11 = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $aa46d9ba6bb1d2ab$var$_ref12 = {
    name: "4t7tsq",
    styles: "height:400px;width:100%;margin-bottom:16px"
};
const $aa46d9ba6bb1d2ab$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";overflow:hidden;max-width:800px;", ""),
            media: {
                main: $aa46d9ba6bb1d2ab$var$_ref12,
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px;", ""),
                video: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";border-radius:4px;", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;height:100%;background-color:", theme.colors.primary.darker, ";border-radius:4px;&>svg{width:80px;height:80px;}", "")
            },
            message: {
                main: $aa46d9ba6bb1d2ab$var$_ref11,
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).p, ";font-weight:bold;word-wrap:break-word;", "")
            },
            footer: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;flex-wrap:wrap;width:100%;", (0, $48E0n.mq).tablet($aa46d9ba6bb1d2ab$var$_ref10), ";", ""),
                author: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;min-width:0;max-width:240px;margin-right:12px;", (0, $48E0n.mq).tablet($aa46d9ba6bb1d2ab$var$_ref9), ";", ""),
                    avatar: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:50px;height:50px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                        image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:20px;height:20px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    info: {
                        main: $aa46d9ba6bb1d2ab$var$_ref8,
                        name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-right:12px;&>div:not(:last-of-type){margin-right:12px;}&>div>button{height:34px;}", (0, $48E0n.mq).tablet($aa46d9ba6bb1d2ab$var$_ref7), " ", (0, $48E0n.mq).mobile($aa46d9ba6bb1d2ab$var$_ref6), ";", ""),
                    follow: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    unfollow: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    subscribe: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    unsubscribe: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    tip: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    block: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    report: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                info: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-left:auto;", (0, $48E0n.mq).tablet($aa46d9ba6bb1d2ab$var$_ref5), ";", ""),
                    comments: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;margin-right:8px;", (0, $48E0n.mq).tablet($aa46d9ba6bb1d2ab$var$_ref4), ";", ""),
                        buttons: $aa46d9ba6bb1d2ab$var$_ref3,
                        button: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;", ""),
                            commented: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{width:20px;height:17px;&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            uncommented: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{width:20px;height:17px;&>path{fill:", theme.colors.secondary.normal, ";}}", "")
                        },
                        count: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";", "")
                    },
                    likes: {
                        main: $aa46d9ba6bb1d2ab$var$_ref2,
                        buttons: $aa46d9ba6bb1d2ab$var$_ref,
                        button: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";cursor:pointer;display:flex;align-items:center;justify-content:center;width:30px;height:30px;&>svg{width:20px;height:18px;}", ""),
                            like: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            dislike: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{&>path{fill:", theme.colors.accent.normal, ";}}", "")
                        },
                        count: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";", "")
                    }
                }
            }
        }
    });

});



parcelRegister("8c9Sv", function(module, exports) {

$parcel$export(module.exports, "postUtilGetPostCardSkeletonSections", function () { return $313f2d457397e80a$export$d657ebf86e206be3; });
const $313f2d457397e80a$export$d657ebf86e206be3 = (sectionName)=>[
        {
            name: `${sectionName}-media`,
            width: "180px",
            height: "146px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider`,
            width: "180px",
            height: "8px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-description`,
            width: "180px",
            height: "128px",
            isStatic: true,
            isDivider: false
        }
    ];

});

parcelRegister("l1Cdj", function(module, exports) {

$parcel$export(module.exports, "postSlice", function () { return $53c11aff027015d9$export$84b5fd1687923cdd; });
$parcel$export(module.exports, "postResetState", function () { return $53c11aff027015d9$export$9dd424aad11dd66c; });
$parcel$export(module.exports, "postSetPublicPosts", function () { return $53c11aff027015d9$export$ce5a046a1fbe931d; });
$parcel$export(module.exports, "postSetPopularPosts", function () { return $53c11aff027015d9$export$2a0820930dbb6cfd; });
$parcel$export(module.exports, "postSetRecommendedPosts", function () { return $53c11aff027015d9$export$f048c5af1e054de2; });
$parcel$export(module.exports, "postSetLikedPosts", function () { return $53c11aff027015d9$export$8bf7790d2c52e250; });
$parcel$export(module.exports, "postSetUnlockedPosts", function () { return $53c11aff027015d9$export$df4ed605a0c4aa35; });
$parcel$export(module.exports, "postSetUploadedPosts", function () { return $53c11aff027015d9$export$4379cd31786d3494; });
$parcel$export(module.exports, "postSetArtistPopularPosts", function () { return $53c11aff027015d9$export$ae5c03bbd62019ff; });
$parcel$export(module.exports, "postSetArtistExclusivePosts", function () { return $53c11aff027015d9$export$dd9dfdbe68071b4a; });
$parcel$export(module.exports, "postSetArtistLatestPosts", function () { return $53c11aff027015d9$export$7e2514e9868c1835; });
$parcel$export(module.exports, "postResetArtistPosts", function () { return $53c11aff027015d9$export$32ce3be0d1041cd2; });
$parcel$export(module.exports, "postSetPost", function () { return $53c11aff027015d9$export$d7e1ac0660aef3e; });
$parcel$export(module.exports, "postResetPost", function () { return $53c11aff027015d9$export$9cdd001f16a9a95e; });
$parcel$export(module.exports, "postAppendLikedPost", function () { return $53c11aff027015d9$export$dbd95498e0105519; });
$parcel$export(module.exports, "postFilterLikedPost", function () { return $53c11aff027015d9$export$cad450d0eee98236; });
$parcel$export(module.exports, "postAppendUnlockedPost", function () { return $53c11aff027015d9$export$d6a4dbcd8796e529; });
$parcel$export(module.exports, "postFilterUnlockedPost", function () { return $53c11aff027015d9$export$3bd892409aa76046; });
$parcel$export(module.exports, "postFilterPost", function () { return $53c11aff027015d9$export$c28d13e5e641a413; });
$parcel$export(module.exports, "postFilterUserPosts", function () { return $53c11aff027015d9$export$a7e1aa97f9558dbc; });
$parcel$export(module.exports, "postUpdatePost", function () { return $53c11aff027015d9$export$5a655b43053213db; });
$parcel$export(module.exports, "postOpenPostBlockModal", function () { return $53c11aff027015d9$export$93499fe2b661300d; });
$parcel$export(module.exports, "postClosePostBlockModal", function () { return $53c11aff027015d9$export$3cab156dba2d530; });
$parcel$export(module.exports, "postOpenPostDeleteModal", function () { return $53c11aff027015d9$export$416f813d58a14263; });
$parcel$export(module.exports, "postClosePostDeleteModal", function () { return $53c11aff027015d9$export$a455e59882114226; });
$parcel$export(module.exports, "postSelectPublicPosts", function () { return $53c11aff027015d9$export$fb241e6d2021ff71; });
$parcel$export(module.exports, "postSelectPublicPostsLength", function () { return $53c11aff027015d9$export$3a701e16151ab41; });
$parcel$export(module.exports, "postSelectPublicPostsCount", function () { return $53c11aff027015d9$export$38c02c2bc52c8194; });
$parcel$export(module.exports, "postSelectPublicPostsFetched", function () { return $53c11aff027015d9$export$39d1973247427310; });
$parcel$export(module.exports, "postSelectPopularPosts", function () { return $53c11aff027015d9$export$afd27ee2e6d98764; });
$parcel$export(module.exports, "postSelectPopularPostsLength", function () { return $53c11aff027015d9$export$2a0d9bc00fa25195; });
$parcel$export(module.exports, "postSelectPopularPostsCount", function () { return $53c11aff027015d9$export$793061c15ff8847d; });
$parcel$export(module.exports, "postSelectPopularPostsFetched", function () { return $53c11aff027015d9$export$785438d13e726074; });
$parcel$export(module.exports, "postSelectRecommendedPosts", function () { return $53c11aff027015d9$export$e620b65a5b60eafa; });
$parcel$export(module.exports, "postSelectRecommendedPostsLength", function () { return $53c11aff027015d9$export$15de216159a2b089; });
$parcel$export(module.exports, "postSelectRecommendedPostsCount", function () { return $53c11aff027015d9$export$ce62f4ef910910ca; });
$parcel$export(module.exports, "postSelectRecommendedPostsFetched", function () { return $53c11aff027015d9$export$f1c376010aab834c; });
$parcel$export(module.exports, "postSelectLikedPosts", function () { return $53c11aff027015d9$export$54dfeb421271f9ac; });
$parcel$export(module.exports, "postSelectLikedPostsLength", function () { return $53c11aff027015d9$export$edfbf0548d8188d9; });
$parcel$export(module.exports, "postSelectLikedPostsCount", function () { return $53c11aff027015d9$export$695d287082716fff; });
$parcel$export(module.exports, "postSelectLikedPostsFetched", function () { return $53c11aff027015d9$export$563f7b0826706eaf; });
$parcel$export(module.exports, "postSelectUnlockedPosts", function () { return $53c11aff027015d9$export$540148e7f3d53bc4; });
$parcel$export(module.exports, "postSelectUnlockedPostsLength", function () { return $53c11aff027015d9$export$7716ea1b0396d86a; });
$parcel$export(module.exports, "postSelectUnlockedPostsCount", function () { return $53c11aff027015d9$export$8c849c4e19d24711; });
$parcel$export(module.exports, "postSelectUnlockedPostsFetched", function () { return $53c11aff027015d9$export$8d77a678a152519c; });
$parcel$export(module.exports, "postSelectUploadedPosts", function () { return $53c11aff027015d9$export$3634f989eea4feba; });
$parcel$export(module.exports, "postSelectUploadedPostsLength", function () { return $53c11aff027015d9$export$9e4dd71b085997ff; });
$parcel$export(module.exports, "postSelectUploadedPostsCount", function () { return $53c11aff027015d9$export$4c358e30e4e77ccd; });
$parcel$export(module.exports, "postSelectUploadedPostsFetched", function () { return $53c11aff027015d9$export$9fbf9933174ed152; });
$parcel$export(module.exports, "postSelectArtistPopularPosts", function () { return $53c11aff027015d9$export$cd1063db3626a4f0; });
$parcel$export(module.exports, "postSelectArtistPopularPostsLength", function () { return $53c11aff027015d9$export$af731748b0e19bb4; });
$parcel$export(module.exports, "postSelectArtistPopularPostsCount", function () { return $53c11aff027015d9$export$f0402047b032ff58; });
$parcel$export(module.exports, "postSelectArtistPopularPostsFetched", function () { return $53c11aff027015d9$export$e1ec845822c2862c; });
$parcel$export(module.exports, "postSelectArtistExclusivePosts", function () { return $53c11aff027015d9$export$18564db38bd46f7a; });
$parcel$export(module.exports, "postSelectArtistExclusivePostsLength", function () { return $53c11aff027015d9$export$1be46c4dd465af22; });
$parcel$export(module.exports, "postSelectArtistExclusivePostsCount", function () { return $53c11aff027015d9$export$adfaba7489ca0479; });
$parcel$export(module.exports, "postSelectArtistExclusivePostsFetched", function () { return $53c11aff027015d9$export$bf021a3494f0a907; });
$parcel$export(module.exports, "postSelectArtistLatestPosts", function () { return $53c11aff027015d9$export$53e191b8cbd5a45; });
$parcel$export(module.exports, "postSelectArtistLatestPostsLength", function () { return $53c11aff027015d9$export$3ba948bda75df569; });
$parcel$export(module.exports, "postSelectArtistLatestPostsCount", function () { return $53c11aff027015d9$export$445ee8b7072a8cd1; });
$parcel$export(module.exports, "postSelectArtistLatestPostsFetched", function () { return $53c11aff027015d9$export$8b247801ccd46b70; });
$parcel$export(module.exports, "postSelectPost", function () { return $53c11aff027015d9$export$3c11521f7f3f87ff; });
$parcel$export(module.exports, "postSelectPostFetched", function () { return $53c11aff027015d9$export$1b02d1fdc8545643; });
$parcel$export(module.exports, "postSelectPostBlockModalOpen", function () { return $53c11aff027015d9$export$7cfe34405cb09bd; });
$parcel$export(module.exports, "postSelectPostBlockModalPost", function () { return $53c11aff027015d9$export$f6706f92b506f19d; });
$parcel$export(module.exports, "postSelectPostDeleteModalOpen", function () { return $53c11aff027015d9$export$d4841c78d863ce4d; });
$parcel$export(module.exports, "postSelectPostDeleteModalPost", function () { return $53c11aff027015d9$export$2a92f752ec3a8a3b; });
$parcel$export(module.exports, "postSelectPostGetPublicPostsLoading", function () { return $53c11aff027015d9$export$a1bff146f511503e; });
$parcel$export(module.exports, "postSelectPostGetPopularPostsLoading", function () { return $53c11aff027015d9$export$85248f85935c038d; });
$parcel$export(module.exports, "postSelectPostGetRecommendedPostsLoading", function () { return $53c11aff027015d9$export$34ed93d124c6b30d; });
$parcel$export(module.exports, "postSelectPostGetLikedPostsLoading", function () { return $53c11aff027015d9$export$8724e993d50686d8; });
$parcel$export(module.exports, "postSelectPostGetUnlockedPostsLoading", function () { return $53c11aff027015d9$export$1ae2c3d187ce2732; });
$parcel$export(module.exports, "postSelectPostGetUploadedPostsLoading", function () { return $53c11aff027015d9$export$55a7c4e7c5c0e2a8; });
$parcel$export(module.exports, "postSelectPostGetArtistPopularPostsLoading", function () { return $53c11aff027015d9$export$c1b04ba9ccb2667c; });
$parcel$export(module.exports, "postSelectPostGetArtistExclusivePostsLoading", function () { return $53c11aff027015d9$export$c312341e7fc27bac; });
$parcel$export(module.exports, "postSelectPostGetArtistLatestPostsLoading", function () { return $53c11aff027015d9$export$2ad5ed8ad1be53f8; });
$parcel$export(module.exports, "postSelectPostGetPostLoading", function () { return $53c11aff027015d9$export$df7914468ca0aeb3; });
$parcel$export(module.exports, "postSelectPostCreateLoading", function () { return $53c11aff027015d9$export$d1a3f987c5fbe290; });
$parcel$export(module.exports, "postSelectPostUpdateLoading", function () { return $53c11aff027015d9$export$6e9d5b4362dbc0d8; });
$parcel$export(module.exports, "postSelectPostBlockLoading", function () { return $53c11aff027015d9$export$207e13237327f2c; });
$parcel$export(module.exports, "postSelectPostDeleteLoading", function () { return $53c11aff027015d9$export$b7fe3c79adb92dd2; });
$parcel$export(module.exports, "postReducer", function () { return $53c11aff027015d9$export$1ea4d99c3899e898; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $g5prJ = parcelRequire("g5prJ");
const $53c11aff027015d9$var$initialState = {
    publicPosts: [],
    publicPostsCount: 0,
    publicPostsFetched: false,
    popularPosts: [],
    popularPostsCount: 0,
    popularPostsFetched: false,
    recommendedPosts: [],
    recommendedPostsCount: 0,
    recommendedPostsFetched: false,
    likedPosts: [],
    likedPostsCount: 0,
    likedPostsFetched: false,
    unlockedPosts: [],
    unlockedPostsCount: 0,
    unlockedPostsFetched: false,
    uploadedPosts: [],
    uploadedPostsCount: 0,
    uploadedPostsFetched: false,
    artistPopularPosts: [],
    artistPopularPostsCount: 0,
    artistPopularPostsFetched: false,
    artistExclusivePosts: [],
    artistExclusivePostsCount: 0,
    artistExclusivePostsFetched: false,
    artistLatestPosts: [],
    artistLatestPostsCount: 0,
    artistLatestPostsFetched: false,
    post: undefined,
    postFetched: false,
    postBlockModal: {
        post: undefined,
        open: false
    },
    postDeleteModal: {
        post: undefined,
        open: false
    },
    postGetPublicPostsLoading: false,
    postGetPopularPostsLoading: false,
    postGetRecommendedPostsLoading: false,
    postGetLikedPostsLoading: false,
    postGetUnlockedPostsLoading: false,
    postGetUploadedPostsLoading: false,
    postGetArtistPopularPostsLoading: false,
    postGetArtistExclusivePostsLoading: false,
    postGetArtistLatestPostsLoading: false,
    postGetPostLoading: false,
    postCreateLoading: false,
    postUpdateLoading: false,
    postBlockLoading: false,
    postDeleteLoading: false
};
const $53c11aff027015d9$export$84b5fd1687923cdd = (0, $dEr3t.createSlice)({
    name: "post",
    initialState: $53c11aff027015d9$var$initialState,
    reducers: {
        // reset state
        postResetState: ()=>({
                publicPosts: [],
                publicPostsCount: 0,
                publicPostsFetched: false,
                popularPosts: [],
                popularPostsCount: 0,
                popularPostsFetched: false,
                recommendedPosts: [],
                recommendedPostsCount: 0,
                recommendedPostsFetched: false,
                likedPosts: [],
                likedPostsCount: 0,
                likedPostsFetched: false,
                unlockedPosts: [],
                unlockedPostsCount: 0,
                unlockedPostsFetched: false,
                profilePosts: [],
                profilePostsCount: 0,
                profilePostsFetched: false,
                uploadedPosts: [],
                uploadedPostsCount: 0,
                uploadedPostsFetched: false,
                artistPopularPosts: [],
                artistPopularPostsCount: 0,
                artistPopularPostsFetched: false,
                artistExclusivePosts: [],
                artistExclusivePostsCount: 0,
                artistExclusivePostsFetched: false,
                artistLatestPosts: [],
                artistLatestPostsCount: 0,
                artistLatestPostsFetched: false,
                post: undefined,
                postFetched: false,
                postBlockModal: {
                    post: undefined,
                    open: false
                },
                postDeleteModal: {
                    post: undefined,
                    open: false
                },
                postGetPublicPostsLoading: false,
                postGetPopularPostsLoading: false,
                postGetRecommendedPostsLoading: false,
                postGetLikedPostsLoading: false,
                postGetUnlockedPostsLoading: false,
                postGetUploadedPostsLoading: false,
                postGetArtistPopularPostsLoading: false,
                postGetArtistExclusivePostsLoading: false,
                postGetArtistLatestPostsLoading: false,
                postGetPostLoading: false,
                postCreateLoading: false,
                postUpdateLoading: false,
                postBlockLoading: false,
                postDeleteLoading: false
            }),
        // set public posts
        postSetPublicPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.publicPostsCount = count;
                // mutate public posts array
                state.publicPosts = (0, $9UVKd.mergeArraysAtIndex)(state.publicPosts, posts, offset);
            }
        },
        // set popular posts
        postSetPopularPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.popularPostsCount = count;
                // mutate popular posts array
                state.popularPosts = (0, $9UVKd.mergeArraysAtIndex)(state.popularPosts, posts, offset);
            }
        },
        // set recommended posts
        postSetRecommendedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.recommendedPostsCount = count;
                // mutate recommended posts array
                state.recommendedPosts = (0, $9UVKd.mergeArraysAtIndex)(state.recommendedPosts, posts, offset);
            }
        },
        // set liked posts
        postSetLikedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.likedPostsCount = count;
                // mutate profile posts array
                state.likedPosts = (0, $9UVKd.mergeArraysAtIndex)(state.likedPosts, posts, offset);
            }
        },
        // set unlocked posts
        postSetUnlockedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.unlockedPostsCount = count;
                // mutate profile posts array
                state.unlockedPosts = (0, $9UVKd.mergeArraysAtIndex)(state.unlockedPosts, posts, offset);
            }
        },
        // set uploaded posts
        postSetUploadedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.uploadedPostsCount = count;
                // mutate uploaded posts array
                state.uploadedPosts = (0, $9UVKd.mergeArraysAtIndex)(state.uploadedPosts, posts, offset);
            }
        },
        // set artist popular posts
        postSetArtistPopularPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistPopularPostsCount = count;
            // mutate artist popular posts array
            state.artistPopularPosts = (0, $9UVKd.mergeArraysAtIndex)(state.artistPopularPosts, posts, offset);
        },
        // set artist exclusive posts
        postSetArtistExclusivePosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistExclusivePostsCount = count;
            // mutate artist exclusive posts array
            state.artistExclusivePosts = (0, $9UVKd.mergeArraysAtIndex)(state.artistExclusivePosts, posts, offset);
        },
        // set artist latest posts
        postSetArtistLatestPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistLatestPostsCount = count;
            // mutate artist latest posts array
            state.artistLatestPosts = (0, $9UVKd.mergeArraysAtIndex)(state.artistLatestPosts, posts, offset);
        },
        // reset artist posts
        postResetArtistPosts: (state)=>({
                ...state,
                artistPopularPosts: [],
                artistPopularPostsCount: 0,
                artistPopularPostsFetched: false,
                artistExclusivePosts: [],
                artistExclusivePostsCount: 0,
                artistExclusivePostsFetched: false,
                artistLatestPosts: [],
                artistLatestPostsCount: 0,
                artistLatestPostsFetched: false
            }),
        // set post
        postSetPost: (state, action)=>{
            const { post: post } = action.payload;
            // update post state
            state.post = post;
        },
        // reset post
        postResetPost: (state)=>({
                ...state,
                post: undefined,
                postFetched: false
            }),
        // append liked post
        postAppendLikedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if liked posts are fetched
            if (state.likedPostsFetched) {
                // append post to liked posts
                state.likedPosts.unshift(post);
                state.likedPostsCount += 1;
            }
        },
        // filter liked posts
        postFilterLikedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if liked posts are fetched
            if (state.likedPostsFetched) {
                // filter post from liked posts
                state.likedPosts = state.likedPosts.filter((p)=>p.id !== post.id);
                state.likedPostsCount -= 1;
            }
        },
        // append unlocked post
        postAppendUnlockedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if unlocked posts are fetched
            if (state.unlockedPostsFetched) {
                // append post to unlocked posts
                state.unlockedPosts.unshift(post);
                state.unlockedPostsCount += 1;
            }
        },
        // filter unlocked post
        postFilterUnlockedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if unlocked posts are fetched
            if (state.unlockedPostsFetched) {
                // filter post from unlocked posts
                state.unlockedPosts = state.unlockedPosts.filter((p)=>p.id !== post.id);
                state.unlockedPostsCount -= 1;
            }
        },
        // filter post
        postFilterPost: (state, action)=>{
            const { id: id } = action.payload;
            // check if post exists in public posts
            const pubIndex = state.publicPosts.findIndex((p)=>p.id === id);
            if (pubIndex !== -1) {
                // filter post
                state.publicPosts = state.publicPosts.filter((p)=>p.id !== id);
                state.publicPostsCount -= 1;
            }
            // check if post exists in popular posts
            const popIndex = state.popularPosts.findIndex((p)=>p.id === id);
            if (popIndex !== -1) {
                // filter post
                state.popularPosts = state.popularPosts.filter((p)=>p.id !== id);
                state.popularPostsCount -= 1;
            }
            // check if post exists in recommended posts
            const recIndex = state.recommendedPosts.findIndex((p)=>p.id === id);
            if (recIndex !== -1) {
                // filter post
                state.recommendedPosts = state.recommendedPosts.filter((p)=>p.id !== id);
                state.recommendedPostsCount -= 1;
            }
            // check if post exists in liked posts
            const lkIndex = state.likedPosts.findIndex((p)=>p.id === id);
            if (lkIndex !== -1) {
                // filter post
                state.likedPosts = state.likedPosts.filter((p)=>p.id !== id);
                state.likedPostsCount -= 1;
            }
            // check if post exists in unlocked posts
            const unlIndex = state.unlockedPosts.findIndex((p)=>p.id === id);
            if (unlIndex !== -1) {
                // filter post
                state.unlockedPosts = state.unlockedPosts.filter((p)=>p.id !== id);
                state.unlockedPostsCount -= 1;
            }
            // check if post exists in uploaded posts
            const uplIndex = state.uploadedPosts.findIndex((p)=>p.id === id);
            if (uplIndex !== -1) {
                // filter post
                state.uploadedPosts = state.uploadedPosts.filter((p)=>p.id !== id);
                state.uploadedPostsCount -= 1;
            }
            // check if post exists in artist popular posts
            const aPopIndex = state.artistPopularPosts.findIndex((p)=>p.id === id);
            if (aPopIndex !== -1) {
                // filter post
                state.artistPopularPosts = state.artistPopularPosts.filter((p)=>p.id !== id);
                state.artistPopularPostsCount -= 1;
            }
            // check if post exists in artist exclusive posts
            const aExIndex = state.artistExclusivePosts.findIndex((p)=>p.id === id);
            if (aExIndex !== -1) {
                // filter post
                state.artistExclusivePosts = state.artistExclusivePosts.filter((p)=>p.id !== id);
                state.artistExclusivePostsCount -= 1;
            }
            // check if post exists in artist latest posts
            const aLatIndex = state.artistLatestPosts.findIndex((p)=>p.id === id);
            if (aLatIndex !== -1) {
                // filter post
                state.artistLatestPosts = state.artistLatestPosts.filter((p)=>p.id !== id);
                state.artistLatestPostsCount -= 1;
            }
        },
        // filter user posts
        postFilterUserPosts: (state, action)=>{
            const { userId: userId } = action.payload;
            // filter user posts from public posts
            const filteredPublicPosts = state.publicPosts.filter((p)=>p.userId !== userId);
            const filteredPublicPostsCount = state.publicPosts.length - filteredPublicPosts.length;
            // if filtered posts
            if (filteredPublicPostsCount > 0) {
                // update posts
                state.publicPosts = filteredPublicPosts;
                state.publicPostsCount -= filteredPublicPostsCount;
            }
            // filter user posts from popular posts
            const filteredPopularPosts = state.popularPosts.filter((p)=>p.userId !== userId);
            const filteredPopularPostsCount = state.popularPosts.length - filteredPopularPosts.length;
            // if filtered posts
            if (filteredPopularPostsCount > 0) {
                // update posts
                state.popularPosts = filteredPopularPosts;
                state.popularPostsCount -= filteredPopularPostsCount;
            }
            // filter user posts from recommended posts
            const filteredRecommendedPosts = state.recommendedPosts.filter((p)=>p.userId !== userId);
            const filteredRecommendedPostsCount = state.recommendedPosts.length - filteredRecommendedPosts.length;
            // if filtered posts
            if (filteredRecommendedPostsCount > 0) {
                // update posts
                state.recommendedPosts = filteredRecommendedPosts;
                state.recommendedPostsCount -= filteredRecommendedPostsCount;
            }
            // filter user posts from liked posts
            const filteredLikedPosts = state.likedPosts.filter((p)=>p.userId !== userId);
            const filteredLikedPostsCount = state.likedPosts.length - filteredLikedPosts.length;
            // if filtered posts
            if (filteredLikedPostsCount > 0) {
                // update posts
                state.likedPosts = filteredLikedPosts;
                state.likedPostsCount -= filteredLikedPostsCount;
            }
            // filter user posts from unlocked posts
            const filteredUnlockedPosts = state.unlockedPosts.filter((p)=>p.userId !== userId);
            const filteredUnlockedPostsCount = state.unlockedPosts.length - filteredUnlockedPosts.length;
            // if filtered posts
            if (filteredUnlockedPostsCount > 0) {
                // update posts
                state.unlockedPosts = filteredUnlockedPosts;
                state.unlockedPostsCount -= filteredUnlockedPostsCount;
            }
            // filter user posts from uploaded posts
            const filteredUploadedPosts = state.uploadedPosts.filter((p)=>p.userId !== userId);
            const filteredUploadedPostsCount = state.uploadedPosts.length - filteredUploadedPosts.length;
            // if filtered posts
            if (filteredUploadedPostsCount > 0) {
                // update posts
                state.uploadedPosts = filteredUploadedPosts;
                state.uploadedPostsCount -= filteredUploadedPostsCount;
            }
            // filter user posts from artist popular posts
            const filteredArtistPopularPosts = state.artistPopularPosts.filter((p)=>p.userId !== userId);
            const filteredArtistPopularPostsCount = state.artistPopularPosts.length - filteredArtistPopularPosts.length;
            // if filtered posts
            if (filteredArtistPopularPostsCount > 0) {
                // update posts
                state.artistPopularPosts = filteredArtistPopularPosts;
                state.artistPopularPostsCount -= filteredArtistPopularPostsCount;
            }
            // filter user posts from artist exclusive posts
            const filteredArtistExclusivePosts = state.artistExclusivePosts.filter((p)=>p.userId !== userId);
            const filteredArtistExclusivePostsCount = state.artistExclusivePosts.length - filteredArtistExclusivePosts.length;
            // if filtered posts
            if (filteredArtistExclusivePostsCount > 0) {
                // update posts
                state.artistExclusivePosts = filteredArtistExclusivePosts;
                state.artistExclusivePostsCount -= filteredArtistExclusivePostsCount;
            }
            // filter user posts from artist latest posts
            const filteredArtistLatestPosts = state.artistLatestPosts.filter((p)=>p.userId !== userId);
            const filteredArtistLatestPostsCount = state.artistLatestPosts.length - filteredArtistLatestPosts.length;
            // if filtered posts
            if (filteredArtistLatestPostsCount > 0) {
                // update posts
                state.artistLatestPosts = filteredArtistLatestPosts;
                state.artistLatestPostsCount -= filteredArtistLatestPostsCount;
            }
        },
        // update post
        postUpdatePost: (state, action)=>{
            const { updatedPost: updatedPost } = action.payload;
            // update post in public posts
            const pubIndex = state.publicPosts.findIndex((p)=>p.id === updatedPost.id);
            if (pubIndex !== -1) {
                const currentPost = state.publicPosts[pubIndex];
                state.publicPosts[pubIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in popular posts
            const popIndex = state.popularPosts.findIndex((p)=>p.id === updatedPost.id);
            if (popIndex !== -1) {
                const currentPost = state.popularPosts[popIndex];
                state.popularPosts[popIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in recommended posts
            const recIndex = state.recommendedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (recIndex !== -1) {
                const currentPost = state.recommendedPosts[recIndex];
                state.recommendedPosts[recIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in liked posts
            const lkIndex = state.likedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (lkIndex !== -1) {
                const currentPost = state.likedPosts[lkIndex];
                state.likedPosts[lkIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in unlocked posts
            const unlIndex = state.unlockedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (unlIndex !== -1) {
                const currentPost = state.unlockedPosts[unlIndex];
                state.unlockedPosts[unlIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in uploaded posts
            const uplIndex = state.uploadedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (uplIndex !== -1) {
                const currentPost = state.uploadedPosts[uplIndex];
                state.uploadedPosts[uplIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in artist popular posts
            const aPopIndex = state.artistPopularPosts.findIndex((p)=>p.id === updatedPost.id);
            if (aPopIndex !== -1) {
                const currentPost = state.artistPopularPosts[aPopIndex];
                state.artistPopularPosts[aPopIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in artist exclusive posts
            const aExIndex = state.artistExclusivePosts.findIndex((p)=>p.id === updatedPost.id);
            if (aExIndex !== -1) {
                const currentPost = state.artistExclusivePosts[aExIndex];
                state.artistExclusivePosts[aExIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in artist latest posts
            const aLatIndex = state.artistLatestPosts.findIndex((p)=>p.id === updatedPost.id);
            if (aLatIndex !== -1) {
                const currentPost = state.artistLatestPosts[aLatIndex];
                state.artistLatestPosts[aLatIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // if post fetched and exists
            if (state.postFetched && state.post) // if post id equal to updated user id
            {
                if (state.post.id === updatedPost.id) // update post
                state.post = updatedPost;
            }
        },
        // open post block modal
        postOpenPostBlockModal: (state, action)=>({
                ...state,
                postBlockModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close post block modal
        postClosePostBlockModal: (state)=>({
                ...state,
                postBlockModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            }),
        // open post delete modal
        postOpenPostDeleteModal: (state, action)=>({
                ...state,
                postDeleteModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close post delete modal
        postClosePostDeleteModal: (state)=>({
                ...state,
                postDeleteModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get public posts
        builder.addCase((0, $g5prJ.postGetPublicPosts).pending, (state)=>({
                ...state,
                postGetPublicPostsLoading: true
            })).addCase((0, $g5prJ.postGetPublicPosts).fulfilled, (state)=>({
                ...state,
                publicPostsFetched: true,
                postGetPublicPostsLoading: false
            }));
        // get popular posts
        builder.addCase((0, $g5prJ.postGetPopularPosts).pending, (state)=>({
                ...state,
                postGetPopularPostsLoading: true
            })).addCase((0, $g5prJ.postGetPopularPosts).fulfilled, (state)=>({
                ...state,
                popularPostsFetched: true,
                postGetPopularPostsLoading: false
            }));
        // get recommended posts
        builder.addCase((0, $g5prJ.postGetRecommendedPosts).pending, (state)=>({
                ...state,
                postGetRecommendedPostsLoading: true
            })).addCase((0, $g5prJ.postGetRecommendedPosts).fulfilled, (state)=>({
                ...state,
                recommendedPostsFetched: true,
                postGetRecommendedPostsLoading: false
            }));
        // get liked posts
        builder.addCase((0, $g5prJ.postGetLikedPosts).pending, (state)=>({
                ...state,
                postGetLikedPostsLoading: true
            })).addCase((0, $g5prJ.postGetLikedPosts).fulfilled, (state)=>({
                ...state,
                likedPostsFetched: true,
                postGetLikedPostsLoading: false
            }));
        // get unlocked posts
        builder.addCase((0, $g5prJ.postGetUnlockedPosts).pending, (state)=>({
                ...state,
                postGetUnlockedPostsLoading: true
            })).addCase((0, $g5prJ.postGetUnlockedPosts).fulfilled, (state)=>({
                ...state,
                unlockedPostsFetched: true,
                postGetUnlockedPostsLoading: false
            }));
        // get uploaded posts
        builder.addCase((0, $g5prJ.postGetUploadedPosts).pending, (state)=>({
                ...state,
                postGetUploadedPostsLoading: true
            })).addCase((0, $g5prJ.postGetUploadedPosts).fulfilled, (state)=>({
                ...state,
                uploadedPostsFetched: true,
                postGetUploadedPostsLoading: false
            }));
        // get artist popular posts
        builder.addCase((0, $g5prJ.postGetArtistPopularPosts).pending, (state)=>({
                ...state,
                postGetArtistPopularPostsLoading: true
            })).addCase((0, $g5prJ.postGetArtistPopularPosts).fulfilled, (state)=>({
                ...state,
                artistPopularPostsFetched: true,
                postGetArtistPopularPostsLoading: false
            }));
        // get artist exclusive posts
        builder.addCase((0, $g5prJ.postGetArtistExclusivePosts).pending, (state)=>({
                ...state,
                postGetArtistExclusivePostsLoading: true
            })).addCase((0, $g5prJ.postGetArtistExclusivePosts).fulfilled, (state)=>({
                ...state,
                artistExclusivePostsFetched: true,
                postGetArtistExclusivePostsLoading: false
            }));
        // get artist latest posts
        builder.addCase((0, $g5prJ.postGetArtistLatestPosts).pending, (state)=>({
                ...state,
                postGetArtistLatestPostsLoading: true
            })).addCase((0, $g5prJ.postGetArtistLatestPosts).fulfilled, (state)=>({
                ...state,
                artistLatestPostsFetched: true,
                postGetArtistLatestPostsLoading: false
            }));
        // get post
        builder.addCase((0, $g5prJ.postGetPost).pending, (state)=>({
                ...state,
                postGetPostLoading: true
            })).addCase((0, $g5prJ.postGetPost).fulfilled, (state)=>({
                ...state,
                postFetched: true,
                postGetPostLoading: false
            }));
        // create post
        builder.addCase((0, $g5prJ.postCreate).pending, (state)=>({
                ...state,
                postCreateLoading: true
            })).addCase((0, $g5prJ.postCreate).fulfilled, (state)=>({
                ...state,
                postCreateLoading: false
            }));
        // update post
        builder.addCase((0, $g5prJ.postUpdate).pending, (state)=>({
                ...state,
                postUpdateLoading: true
            })).addCase((0, $g5prJ.postUpdate).fulfilled, (state)=>({
                ...state,
                postUpdateLoading: false
            }));
        // block post
        builder.addCase((0, $g5prJ.postBlock).pending, (state)=>({
                ...state,
                postBlockLoading: true
            })).addCase((0, $g5prJ.postBlock).fulfilled, (state)=>({
                ...state,
                postBlockLoading: false
            }));
        // delete post
        builder.addCase((0, $g5prJ.postDelete).pending, (state)=>({
                ...state,
                postDeleteLoading: true
            })).addCase((0, $g5prJ.postDelete).fulfilled, (state)=>({
                ...state,
                postDeleteLoading: false
            }));
    }
});
const { postResetState: $53c11aff027015d9$export$9dd424aad11dd66c, postSetPublicPosts: $53c11aff027015d9$export$ce5a046a1fbe931d, postSetPopularPosts: $53c11aff027015d9$export$2a0820930dbb6cfd, postSetRecommendedPosts: $53c11aff027015d9$export$f048c5af1e054de2, postSetLikedPosts: $53c11aff027015d9$export$8bf7790d2c52e250, postSetUnlockedPosts: $53c11aff027015d9$export$df4ed605a0c4aa35, postSetUploadedPosts: $53c11aff027015d9$export$4379cd31786d3494, postSetArtistPopularPosts: $53c11aff027015d9$export$ae5c03bbd62019ff, postSetArtistExclusivePosts: $53c11aff027015d9$export$dd9dfdbe68071b4a, postSetArtistLatestPosts: $53c11aff027015d9$export$7e2514e9868c1835, postResetArtistPosts: $53c11aff027015d9$export$32ce3be0d1041cd2, postSetPost: $53c11aff027015d9$export$d7e1ac0660aef3e, postResetPost: $53c11aff027015d9$export$9cdd001f16a9a95e, postAppendLikedPost: $53c11aff027015d9$export$dbd95498e0105519, postFilterLikedPost: $53c11aff027015d9$export$cad450d0eee98236, postAppendUnlockedPost: $53c11aff027015d9$export$d6a4dbcd8796e529, postFilterUnlockedPost: $53c11aff027015d9$export$3bd892409aa76046, postFilterPost: $53c11aff027015d9$export$c28d13e5e641a413, postFilterUserPosts: $53c11aff027015d9$export$a7e1aa97f9558dbc, postUpdatePost: $53c11aff027015d9$export$5a655b43053213db, postOpenPostBlockModal: $53c11aff027015d9$export$93499fe2b661300d, postClosePostBlockModal: $53c11aff027015d9$export$3cab156dba2d530, postOpenPostDeleteModal: $53c11aff027015d9$export$416f813d58a14263, postClosePostDeleteModal: $53c11aff027015d9$export$a455e59882114226 } = $53c11aff027015d9$export$84b5fd1687923cdd.actions;
const $53c11aff027015d9$export$fb241e6d2021ff71 = (state)=>state.post.publicPosts;
const $53c11aff027015d9$export$3a701e16151ab41 = (state)=>state.post.publicPosts.length;
const $53c11aff027015d9$export$38c02c2bc52c8194 = (state)=>state.post.publicPostsCount;
const $53c11aff027015d9$export$39d1973247427310 = (state)=>state.post.publicPostsFetched;
const $53c11aff027015d9$export$afd27ee2e6d98764 = (state)=>state.post.popularPosts;
const $53c11aff027015d9$export$2a0d9bc00fa25195 = (state)=>state.post.popularPosts.length;
const $53c11aff027015d9$export$793061c15ff8847d = (state)=>state.post.popularPostsCount;
const $53c11aff027015d9$export$785438d13e726074 = (state)=>state.post.popularPostsFetched;
const $53c11aff027015d9$export$e620b65a5b60eafa = (state)=>state.post.recommendedPosts;
const $53c11aff027015d9$export$15de216159a2b089 = (state)=>state.post.recommendedPosts.length;
const $53c11aff027015d9$export$ce62f4ef910910ca = (state)=>state.post.recommendedPostsCount;
const $53c11aff027015d9$export$f1c376010aab834c = (state)=>state.post.recommendedPostsFetched;
const $53c11aff027015d9$export$54dfeb421271f9ac = (state)=>state.post.likedPosts;
const $53c11aff027015d9$export$edfbf0548d8188d9 = (state)=>state.post.likedPosts.length;
const $53c11aff027015d9$export$695d287082716fff = (state)=>state.post.likedPostsCount;
const $53c11aff027015d9$export$563f7b0826706eaf = (state)=>state.post.likedPostsFetched;
const $53c11aff027015d9$export$540148e7f3d53bc4 = (state)=>state.post.unlockedPosts;
const $53c11aff027015d9$export$7716ea1b0396d86a = (state)=>state.post.unlockedPosts.length;
const $53c11aff027015d9$export$8c849c4e19d24711 = (state)=>state.post.unlockedPostsCount;
const $53c11aff027015d9$export$8d77a678a152519c = (state)=>state.post.unlockedPostsFetched;
const $53c11aff027015d9$export$3634f989eea4feba = (state)=>state.post.uploadedPosts;
const $53c11aff027015d9$export$9e4dd71b085997ff = (state)=>state.post.uploadedPosts.length;
const $53c11aff027015d9$export$4c358e30e4e77ccd = (state)=>state.post.uploadedPostsCount;
const $53c11aff027015d9$export$9fbf9933174ed152 = (state)=>state.post.uploadedPostsFetched;
const $53c11aff027015d9$export$cd1063db3626a4f0 = (state)=>state.post.artistPopularPosts;
const $53c11aff027015d9$export$af731748b0e19bb4 = (state)=>state.post.artistPopularPosts.length;
const $53c11aff027015d9$export$f0402047b032ff58 = (state)=>state.post.artistPopularPostsCount;
const $53c11aff027015d9$export$e1ec845822c2862c = (state)=>state.post.artistPopularPostsFetched;
const $53c11aff027015d9$export$18564db38bd46f7a = (state)=>state.post.artistExclusivePosts;
const $53c11aff027015d9$export$1be46c4dd465af22 = (state)=>state.post.artistExclusivePosts.length;
const $53c11aff027015d9$export$adfaba7489ca0479 = (state)=>state.post.artistExclusivePostsCount;
const $53c11aff027015d9$export$bf021a3494f0a907 = (state)=>state.post.artistExclusivePostsFetched;
const $53c11aff027015d9$export$53e191b8cbd5a45 = (state)=>state.post.artistLatestPosts;
const $53c11aff027015d9$export$3ba948bda75df569 = (state)=>state.post.artistLatestPosts.length;
const $53c11aff027015d9$export$445ee8b7072a8cd1 = (state)=>state.post.artistLatestPostsCount;
const $53c11aff027015d9$export$8b247801ccd46b70 = (state)=>state.post.artistLatestPostsFetched;
const $53c11aff027015d9$export$3c11521f7f3f87ff = (state)=>state.post.post;
const $53c11aff027015d9$export$1b02d1fdc8545643 = (state)=>state.post.postFetched;
const $53c11aff027015d9$export$7cfe34405cb09bd = (state)=>state.post.postBlockModal.open;
const $53c11aff027015d9$export$f6706f92b506f19d = (state)=>state.post.postBlockModal.post;
const $53c11aff027015d9$export$d4841c78d863ce4d = (state)=>state.post.postDeleteModal.open;
const $53c11aff027015d9$export$2a92f752ec3a8a3b = (state)=>state.post.postDeleteModal.post;
const $53c11aff027015d9$export$a1bff146f511503e = (state)=>state.post.postGetPublicPostsLoading;
const $53c11aff027015d9$export$85248f85935c038d = (state)=>state.post.postGetPopularPostsLoading;
const $53c11aff027015d9$export$34ed93d124c6b30d = (state)=>state.post.postGetRecommendedPostsLoading;
const $53c11aff027015d9$export$8724e993d50686d8 = (state)=>state.post.postGetLikedPostsLoading;
const $53c11aff027015d9$export$1ae2c3d187ce2732 = (state)=>state.post.postGetUnlockedPostsLoading;
const $53c11aff027015d9$export$55a7c4e7c5c0e2a8 = (state)=>state.post.postGetUploadedPostsLoading;
const $53c11aff027015d9$export$c1b04ba9ccb2667c = (state)=>state.post.postGetArtistPopularPostsLoading;
const $53c11aff027015d9$export$c312341e7fc27bac = (state)=>state.post.postGetArtistExclusivePostsLoading;
const $53c11aff027015d9$export$2ad5ed8ad1be53f8 = (state)=>state.post.postGetArtistLatestPostsLoading;
const $53c11aff027015d9$export$df7914468ca0aeb3 = (state)=>state.post.postGetPostLoading;
const $53c11aff027015d9$export$d1a3f987c5fbe290 = (state)=>state.post.postCreateLoading;
const $53c11aff027015d9$export$6e9d5b4362dbc0d8 = (state)=>state.post.postUpdateLoading;
const $53c11aff027015d9$export$207e13237327f2c = (state)=>state.post.postBlockLoading;
const $53c11aff027015d9$export$b7fe3c79adb92dd2 = (state)=>state.post.postDeleteLoading;
const $53c11aff027015d9$export$1ea4d99c3899e898 = $53c11aff027015d9$export$84b5fd1687923cdd.reducer; // export default postSlice.reducer

});

parcelRegister("g5prJ", function(module, exports) {

$parcel$export(module.exports, "postGetPublicPosts", function () { return $c561c92e4f1caa1f$export$addafaf8bec90092; });
$parcel$export(module.exports, "postGetPopularPosts", function () { return $c561c92e4f1caa1f$export$466fe1d7e3b62322; });
$parcel$export(module.exports, "postGetRecommendedPosts", function () { return $c561c92e4f1caa1f$export$6690bc2052db8b1e; });
$parcel$export(module.exports, "postGetLikedPosts", function () { return $c561c92e4f1caa1f$export$7fc0c1ca72ba4d7d; });
$parcel$export(module.exports, "postGetUnlockedPosts", function () { return $c561c92e4f1caa1f$export$e0b9d84bf1697f29; });
$parcel$export(module.exports, "postGetUploadedPosts", function () { return $c561c92e4f1caa1f$export$9ec7a0da93a2e6f3; });
$parcel$export(module.exports, "postGetArtistPopularPosts", function () { return $c561c92e4f1caa1f$export$549ce51589e9fea8; });
$parcel$export(module.exports, "postGetArtistExclusivePosts", function () { return $c561c92e4f1caa1f$export$78711610cc3df796; });
$parcel$export(module.exports, "postGetArtistLatestPosts", function () { return $c561c92e4f1caa1f$export$c860eac3c8791ff4; });
$parcel$export(module.exports, "postGetPost", function () { return $c561c92e4f1caa1f$export$cf246b2f471283c8; });
$parcel$export(module.exports, "postCreate", function () { return $c561c92e4f1caa1f$export$1c653e50934cd597; });
$parcel$export(module.exports, "postUpdate", function () { return $c561c92e4f1caa1f$export$a787fd5d078d5cef; });
$parcel$export(module.exports, "postBlock", function () { return $c561c92e4f1caa1f$export$788e41b05acb4a0; });
$parcel$export(module.exports, "postDelete", function () { return $c561c92e4f1caa1f$export$37646f6edbc68fd3; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $lWbfW = parcelRequire("lWbfW");
var $l1Cdj = parcelRequire("l1Cdj");
var $6CAIO = parcelRequire("6CAIO");
var $fZeVI = parcelRequire("fZeVI");
const $c561c92e4f1caa1f$export$addafaf8bec90092 = (0, $dEr3t.createAsyncThunk)("post/postGetPublicPosts", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve public posts
        const { posts: posts, count: count } = await api.postApi.getPublicPosts();
        // set public posts
        dispatch((0, $l1Cdj.postSetPublicPosts)({
            posts: posts || [],
            count: count || 0,
            offset: 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$466fe1d7e3b62322 = (0, $dEr3t.createAsyncThunk)("post/postGetPopularPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve popular posts
        const { posts: posts, count: count } = await api.postApi.getPopularPosts(undefined, inp.limit, inp.offset, inp.search);
        // set popular posts
        dispatch((0, $l1Cdj.postSetPopularPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$6690bc2052db8b1e = (0, $dEr3t.createAsyncThunk)("post/postGetRecommendedPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve recommended posts
        const { posts: posts, count: count } = await api.postApi.getRecommendedPosts(inp.limit, inp.offset, inp.search);
        // set recommended posts
        dispatch((0, $l1Cdj.postSetRecommendedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$7fc0c1ca72ba4d7d = (0, $dEr3t.createAsyncThunk)("post/postGetLikedPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve liked posts
        const { posts: posts, count: count } = await api.postApi.getLikedPosts(inp.limit, inp.offset, inp.search);
        // set liked posts
        dispatch((0, $l1Cdj.postSetLikedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$e0b9d84bf1697f29 = (0, $dEr3t.createAsyncThunk)("post/postGetUnlockedPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve unlocked posts
        const { posts: posts, count: count } = await api.postApi.getUnlockedPosts(inp.limit, inp.offset, inp.search);
        // set unlocked posts
        dispatch((0, $l1Cdj.postSetUnlockedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$9ec7a0da93a2e6f3 = (0, $dEr3t.createAsyncThunk)("post/postGetUploadedPosts", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get currently logged in user id
    const { profile: profile } = getState().auth;
    const userId = profile?.id || "";
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getArtistPosts(userId, inp.limit, inp.offset, inp.search);
        // set uploaded posts
        dispatch((0, $l1Cdj.postSetUploadedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$549ce51589e9fea8 = (0, $dEr3t.createAsyncThunk)("post/postGetArtistPopularPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getPopularPosts(inp.artistId, inp.limit, inp.offset, inp.search);
        // set posts
        dispatch((0, $l1Cdj.postSetArtistPopularPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$78711610cc3df796 = (0, $dEr3t.createAsyncThunk)("post/postGetArtistExclusivePosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getExclusivePosts(inp.artistId, inp.limit, inp.offset, inp.search);
        // set posts
        dispatch((0, $l1Cdj.postSetArtistExclusivePosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$c860eac3c8791ff4 = (0, $dEr3t.createAsyncThunk)("post/postGetArtistLatestPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getLatestPosts(inp.artistId, inp.limit, inp.offset, inp.search);
        // set posts
        dispatch((0, $l1Cdj.postSetArtistLatestPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$cf246b2f471283c8 = (0, $dEr3t.createAsyncThunk)("post/postGetPost", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve post
        const { post: post } = await api.postApi.getPost(inp.postId);
        // set post
        dispatch((0, $l1Cdj.postSetPost)({
            post: post || {}
        }));
        // get post tracks
        dispatch((0, $fZeVI.trackGetPostTracks)({
            trackIds: post?.trackIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$1c653e50934cd597 = (0, $dEr3t.createAsyncThunk)("post/postCreate", async ({ message: message, media: media, tracks: tracks, visibility: visibility, unlockPrice: unlockPrice }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append message
        formData.append("message", message);
        // if media provided
        if (media) // append media
        formData.append("media", media);
        // if tracks provided
        if (tracks && tracks.length > 0) // append track ids
        formData.append("trackIds", tracks.map((track)=>track.id).join(","));
        // if visibility provided
        if (visibility) // append visibility
        formData.append("visibility", visibility.toString());
        // if visibility is subscribers
        // and unlock price provided
        if (visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers && unlockPrice) // append unlock price in cents
        // if unlockPrice = 1 (one dollar)
        // 1 * 100 = 100 (hundred cents)
        formData.append("unlockPrice", (unlockPrice * 100).toString());
        // create post
        await api.postApi.createPost({
            body: formData
        });
        // refetch uploaded posts
        dispatch($c561c92e4f1caa1f$export$9ec7a0da93a2e6f3({
            limit: 30,
            offset: 0
        }));
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully created post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create post: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $c561c92e4f1caa1f$export$a787fd5d078d5cef = (0, $dEr3t.createAsyncThunk)("post/postUpdate", async ({ post: post, message: message, media: media, tracks: tracks }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append post id
        formData.append("postId", post.id || "");
        // if message provided
        if (message) // append name
        formData.append("message", message);
        // if media provided
        if (media) // append media
        formData.append("media", media);
        // if tracks provided
        if (tracks && tracks.length > 0) // append track ids
        formData.append("trackIds", tracks.map((track)=>track.id).join(","));
        // update post
        const { post: updatedPost } = await api.postApi.updatePost({
            body: formData
        });
        // update post in post state
        dispatch((0, $l1Cdj.postUpdatePost)({
            updatedPost: updatedPost || {}
        }));
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully updated post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to update post: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $c561c92e4f1caa1f$export$788e41b05acb4a0 = (0, $dEr3t.createAsyncThunk)("post/postBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // block post
        await api.postApi.blockPost({
            postId: id
        });
        // reset post page state
        dispatch((0, $l1Cdj.postResetPost)());
        // reset comments state
        dispatch((0, $lWbfW.commentResetComments)());
        // filter blocked post from posts
        dispatch((0, $l1Cdj.postFilterPost)({
            id: id
        }));
        // set post as blocked in the report state
        dispatch((0, $6CAIO.reportSetReportEntityBlocked)());
        // close block post modal
        dispatch((0, $l1Cdj.postClosePostBlockModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully blocked post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to block post: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c561c92e4f1caa1f$export$37646f6edbc68fd3 = (0, $dEr3t.createAsyncThunk)("post/postDelete", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete post
        await api.postApi.deletePost(id);
        // filter deleted post
        dispatch((0, $l1Cdj.postFilterPost)({
            id: id
        }));
        // refetch uploaded posts
        dispatch($c561c92e4f1caa1f$export$9ec7a0da93a2e6f3({
            limit: 30,
            offset: 0
        }));
        // close delete post modal
        dispatch((0, $l1Cdj.postClosePostDeleteModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully deleted post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to delete post: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("iMkM4", function(module, exports) {

$parcel$export(module.exports, "ReportCard", function () { return (parcelRequire("7koh8")).ReportCard; });
$parcel$export(module.exports, "ReportCommentModal", function () { return (parcelRequire("iBPWd")).ReportCommentModal; });
$parcel$export(module.exports, "ReportComplaintCard", function () { return (parcelRequire("3hKLx")).ReportComplaintCard; });
$parcel$export(module.exports, "ReportComplaintListReport", function () { return (parcelRequire("hWSV8")).ReportComplaintListReport; });
$parcel$export(module.exports, "ReportComplaintViewReportComplaint", function () { return (parcelRequire("bLYI6")).ReportComplaintViewReportComplaint; });
$parcel$export(module.exports, "ReportListReports", function () { return (parcelRequire("1Nttt")).ReportListReports; });
$parcel$export(module.exports, "ReportPostModal", function () { return (parcelRequire("hD9dS")).ReportPostModal; });
$parcel$export(module.exports, "ReportResolveModal", function () { return (parcelRequire("gaaD4")).ReportResolveModal; });
$parcel$export(module.exports, "ReportTrackModal", function () { return (parcelRequire("j3V56")).ReportTrackModal; });
$parcel$export(module.exports, "ReportUserModal", function () { return (parcelRequire("72Vfl")).ReportUserModal; });
$parcel$export(module.exports, "ReportViewReport", function () { return (parcelRequire("4TFxW")).ReportViewReport; });
parcelRequire("onCLp");
var $7koh8 = parcelRequire("7koh8");
var $iBPWd = parcelRequire("iBPWd");
var $3hKLx = parcelRequire("3hKLx");
var $hWSV8 = parcelRequire("hWSV8");
var $bLYI6 = parcelRequire("bLYI6");
var $1Nttt = parcelRequire("1Nttt");
var $hD9dS = parcelRequire("hD9dS");
var $gaaD4 = parcelRequire("gaaD4");
var $j3V56 = parcelRequire("j3V56");
var $72Vfl = parcelRequire("72Vfl");
var $4TFxW = parcelRequire("4TFxW");

var $6CAIO = parcelRequire("6CAIO");

var $9CsFP = parcelRequire("9CsFP");
$parcel$exportWildcard(module.exports, $6CAIO);
$parcel$exportWildcard(module.exports, $9CsFP);

});
parcelRegister("onCLp", function(module, exports) {

$parcel$export(module.exports, "ReportCard", function () { return (parcelRequire("7koh8")).ReportCard; });
$parcel$export(module.exports, "ReportCommentModal", function () { return (parcelRequire("iBPWd")).ReportCommentModal; });
$parcel$export(module.exports, "ReportComplaintCard", function () { return (parcelRequire("3hKLx")).ReportComplaintCard; });
$parcel$export(module.exports, "ReportComplaintListReport", function () { return (parcelRequire("hWSV8")).ReportComplaintListReport; });
$parcel$export(module.exports, "ReportComplaintViewReportComplaint", function () { return (parcelRequire("bLYI6")).ReportComplaintViewReportComplaint; });
$parcel$export(module.exports, "ReportListReports", function () { return (parcelRequire("1Nttt")).ReportListReports; });
$parcel$export(module.exports, "ReportPostModal", function () { return (parcelRequire("hD9dS")).ReportPostModal; });
$parcel$export(module.exports, "ReportResolveModal", function () { return (parcelRequire("gaaD4")).ReportResolveModal; });
$parcel$export(module.exports, "ReportTrackModal", function () { return (parcelRequire("j3V56")).ReportTrackModal; });
$parcel$export(module.exports, "ReportUserModal", function () { return (parcelRequire("72Vfl")).ReportUserModal; });
$parcel$export(module.exports, "ReportViewReport", function () { return (parcelRequire("4TFxW")).ReportViewReport; });

var $7koh8 = parcelRequire("7koh8");

var $iBPWd = parcelRequire("iBPWd");

var $3hKLx = parcelRequire("3hKLx");

var $hWSV8 = parcelRequire("hWSV8");

var $bLYI6 = parcelRequire("bLYI6");

var $1Nttt = parcelRequire("1Nttt");

var $hD9dS = parcelRequire("hD9dS");

var $gaaD4 = parcelRequire("gaaD4");

var $j3V56 = parcelRequire("j3V56");

var $72Vfl = parcelRequire("72Vfl");

var $4TFxW = parcelRequire("4TFxW");

});
parcelRegister("7koh8", function(module, exports) {

$parcel$export(module.exports, "ReportCard", function () { return $d16e12f72d918e48$export$7bf364c5d17ecc34; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $dWcgE = parcelRequire("dWcgE");
const $d16e12f72d918e48$export$7bf364c5d17ecc34 = ({ report: report, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    const { shortId: shortId, entityType: entityType, status: status, createdAt: createdAt } = report;
    const date = new Date(createdAt || "");
    const dateDay = date.getUTCDate().toString().padStart(2, "0");
    const dateMonth = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const dateYear = date.getUTCFullYear();
    // const dateYear = date.getUTCFullYear() % 100
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $dWcgE.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $dWcgE.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $dWcgE.styles)(theme).card.data.icon,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).AlertTriangle, {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $dWcgE.styles)(theme).card.data.identifier,
                        children: `#${shortId}`
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $dWcgE.styles)(theme).card.data.type,
                        children: entityType
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $dWcgE.styles)(theme).card.data.status,
                        children: status
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $dWcgE.styles)(theme).card.data.date,
                        children: `${dateDay}.${dateMonth}.${dateYear}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dWcgE.styles)(theme).card.divider
            })
        ]
    });
};
$d16e12f72d918e48$export$7bf364c5d17ecc34.propTypes = {};

});
parcelRegister("dWcgE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $928eabca99ce7c1e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $928eabca99ce7c1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $928eabca99ce7c1e$var$_ref = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $928eabca99ce7c1e$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $928eabca99ce7c1e$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $928eabca99ce7c1e$var$_ref4 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $928eabca99ce7c1e$var$_ref5 = {
    name: "eivff4",
    styles: "display:none"
};
var $928eabca99ce7c1e$var$_ref6 = {
    name: "1mz29im",
    styles: "display:flex;align-items:center;height:40px"
};
var $928eabca99ce7c1e$var$_ref7 = {
    name: "1y1se14",
    styles: "display:flex;flex-direction:column;justify-content:space-between;height:60px;cursor:pointer"
};
const $928eabca99ce7c1e$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $928eabca99ce7c1e$var$_ref7,
            data: {
                main: $928eabca99ce7c1e$var$_ref6,
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex:0 0 40px;margin-right:10px;", (0, $48E0n.mq).tablet($928eabca99ce7c1e$var$_ref5), " &>svg{height:22px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                identifier: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 100px;margin-right:10px;", (0, $48E0n.mq).mobile($928eabca99ce7c1e$var$_ref4), ";", ""),
                type: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).tablet($928eabca99ce7c1e$var$_ref3), ";", ""),
                status: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).mobile($928eabca99ce7c1e$var$_ref2), ";", ""),
                date: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;", (0, $48E0n.mq).mobile($928eabca99ce7c1e$var$_ref), ";", "")
            },
            divider: /*#__PURE__*/ (0, $4N3Qt.css)("width:100%;height:1px;background-color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("iBPWd", function(module, exports) {

$parcel$export(module.exports, "ReportCommentModal", function () { return $e6a6e50721bc4515$export$49579d848236fc63; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("eTxZX");
var $i3ZkG = parcelRequire("i3ZkG");

var $7bt5T = parcelRequire("7bt5T");
const $e6a6e50721bc4515$export$49579d848236fc63 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportCommentModalOpen = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportCommentModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7bt5T.styles)().modal.main,
        children: reportCommentModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $6CAIO.reportCloseReportCommentModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $7bt5T.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i3ZkG.ReportCommentCard), {})
            })
        })
    });
};
$e6a6e50721bc4515$export$49579d848236fc63.propTypes = {};

});
parcelRegister("eTxZX", function(module, exports) {

$parcel$export(module.exports, "ReportCommentCard", function () { return (parcelRequire("i3ZkG")).ReportCommentCard; });

var $i3ZkG = parcelRequire("i3ZkG");

});
parcelRegister("i3ZkG", function(module, exports) {

$parcel$export(module.exports, "ReportCommentCard", function () { return $221a3cae27b3a723$export$3cf652da30bd6e5e; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("4o1qO");
var $b4Srz = parcelRequire("b4Srz");

var $4EDPj = parcelRequire("4EDPj");
const $221a3cae27b3a723$export$3cf652da30bd6e5e = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportCommentError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $4EDPj.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4EDPj.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $6CAIO.reportCloseReportCommentModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4EDPj.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $4EDPj.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this comment."
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $4EDPj.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4EDPj.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $b4Srz.ReportCommentForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $4EDPj.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: reportCommentError
                        })
                    })
                ]
            })
        ]
    });
};
$221a3cae27b3a723$export$3cf652da30bd6e5e.propTypes = {};

});
parcelRegister("4o1qO", function(module, exports) {

$parcel$export(module.exports, "ReportCommentForm", function () { return (parcelRequire("b4Srz")).ReportCommentForm; });

var $b4Srz = parcelRequire("b4Srz");

});
parcelRegister("b4Srz", function(module, exports) {

$parcel$export(module.exports, "ReportCommentForm", function () { return $624194e704b079ea$export$ae585ae2d51dd87b; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $kDwrL = parcelRequire("kDwrL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9CsFP = parcelRequire("9CsFP");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $i8CSQ = parcelRequire("i8CSQ");
var $e0SLm = parcelRequire("e0SLm");
var $1sbY5 = parcelRequire("1sbY5");

var $5oWoX = parcelRequire("5oWoX");
const $624194e704b079ea$export$ae585ae2d51dd87b = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportCreateCommentReportComplaintLoading = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportCreateCommentReportComplaintLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalComment = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportCommentModalComment));
    const [complaintType, setComplaintType] = (0, $exYeM.useState)("");
    const [complaint, setComplaint] = (0, $exYeM.useState)("");
    const [complaintError, setComplaintError] = (0, $exYeM.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId } = modalComment ?? {};
    const isCurrentUserComment = profileUserId === artistUserId;
    const submitDisabled = complaint.length > (0, $kDwrL.maxReportComplaintLength) || !complaintType || isCurrentUserComment || reportCreateCommentReportComplaintLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $5oWoX.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $5oWoX.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $9CsFP.reportCreateCommentReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $5oWoX.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e0SLm.InputSelect), {
                        placeholder: {
                            id: "report-post-comment-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $kDwrL.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $5oWoX.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i8CSQ.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $kDwrL.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $33ayT.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $5oWoX.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreateCommentReportComplaintLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$624194e704b079ea$export$ae585ae2d51dd87b.propTypes = {};

});
parcelRegister("5oWoX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4a0d1074d6dac0a2$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $4a0d1074d6dac0a2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4a0d1074d6dac0a2$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $4a0d1074d6dac0a2$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $4a0d1074d6dac0a2$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                type: $4a0d1074d6dac0a2$var$_ref2,
                complaint: $4a0d1074d6dac0a2$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("4EDPj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bc8ebcdb6a365475$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $bc8ebcdb6a365475$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bc8ebcdb6a365475$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $bc8ebcdb6a365475$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $bc8ebcdb6a365475$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $bc8ebcdb6a365475$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $bc8ebcdb6a365475$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $bc8ebcdb6a365475$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $bc8ebcdb6a365475$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $bc8ebcdb6a365475$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $bc8ebcdb6a365475$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($bc8ebcdb6a365475$var$_ref8), " ", (0, $48E0n.mq).mobile($bc8ebcdb6a365475$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($bc8ebcdb6a365475$var$_ref6), ";", ""),
            title: $bc8ebcdb6a365475$var$_ref5,
            subtitle: $bc8ebcdb6a365475$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($bc8ebcdb6a365475$var$_ref3), ";", ""),
                form: $bc8ebcdb6a365475$var$_ref2,
                error: $bc8ebcdb6a365475$var$_ref
            }
        }
    });

});



parcelRegister("7bt5T", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b7599a541e883985$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b7599a541e883985$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b7599a541e883985$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $b7599a541e883985$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($b7599a541e883985$var$_ref), ";", "")
        }
    });

});


parcelRegister("3hKLx", function(module, exports) {

$parcel$export(module.exports, "ReportComplaintCard", function () { return $5c05c88f7866270e$export$1484efe53c4fb266; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $fH9TK = parcelRequire("fH9TK");
const $5c05c88f7866270e$export$1484efe53c4fb266 = ({ reportComplaint: reportComplaint, onUserNameClick: onUserNameClick, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    const { userId: reportComplaintAuthorUserId, complaint: complaint, complaintType: complaintType } = reportComplaint;
    // report complaint author
    const { user: reportComplaintAuthor, isLoading: isReportComplaintAuthorLoading } = (0, $4y2bm.useUserPublic)(reportComplaintAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = reportComplaintAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $hrd7b.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $exYeM.useState)(false);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $fH9TK.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $fH9TK.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $fH9TK.styles)(theme).card.data.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $fH9TK.styles)(theme).card.data.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                            css: (0, $fH9TK.styles)(theme).card.data.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $fH9TK.styles)(theme).card.data.content.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $fH9TK.styles)(theme).card.data.content.name,
                                onClick: (e)=>e.stopPropagation(),
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: (0, $fH9TK.styles)(theme).card.data.content.name,
                                    onClick: (e)=>onUserNameClick(e),
                                    type: "button",
                                    "aria-label": "explore author profile",
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                        children: isReportComplaintAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $fH9TK.styles)(theme).card.data.content.complaint,
                                children: complaint
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $fH9TK.styles)(theme).card.type.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $fH9TK.styles)(theme).card.type.text,
                    children: complaintType?.toString().replace("_", " ")
                })
            })
        ]
    });
};
$5c05c88f7866270e$export$1484efe53c4fb266.propTypes = {};

});
parcelRegister("fH9TK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3b5823eedb1c9733$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3b5823eedb1c9733$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3b5823eedb1c9733$var$_ref = {
    name: "1tltq10",
    styles: "display:flex;align-items:center;margin-left:42px"
};
var $3b5823eedb1c9733$var$_ref2 = {
    name: "1gjs2mp",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-bottom:8px"
};
var $3b5823eedb1c9733$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $3b5823eedb1c9733$var$_ref4 = {
    name: "1479joy",
    styles: "display:flex;flex-direction:column;height:70px;cursor:pointer"
};
const $3b5823eedb1c9733$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $3b5823eedb1c9733$var$_ref4,
            data: {
                main: $3b5823eedb1c9733$var$_ref3,
                avatar: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                    image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                content: {
                    main: $3b5823eedb1c9733$var$_ref2,
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                    complaint: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
                }
            },
            type: {
                main: $3b5823eedb1c9733$var$_ref,
                text: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;text-transform:uppercase;color:", theme.colors.negative.normal, ";font-size:", (0, $48E0n.typography).c, ";font-weight:bold;", "")
            }
        }
    });

});


parcelRegister("hWSV8", function(module, exports) {

$parcel$export(module.exports, "ReportComplaintListReport", function () { return $730e7f4df4ac3da0$export$ff07cc9f0adc88a0; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $3hKLx = parcelRequire("3hKLx");
var $9CsFP = parcelRequire("9CsFP");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRw87");
var $9UxEr = parcelRequire("9UxEr");

var $k7vQl = parcelRequire("k7vQl");
const $730e7f4df4ac3da0$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const reportComplaints = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportComplaints));
    const reportComplaint = reportComplaints[index];
    // if report complaint not fetched
    if (!reportComplaint) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-list-report-complaints-complaint",
                    width: "100%",
                    height: "70px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: reportComplaintId, userId: reportComplaintAuthorUserId, reportId: reportId } = reportComplaint;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $k7vQl.styles)().comments.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3hKLx.ReportComplaintCard), {
            reportComplaint: reportComplaint,
            onUserNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${reportComplaintAuthorUserId}`),
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Reports}${(0, $9YTSb.Path).Report}/${reportId}${(0, $9YTSb.Path).Complaint}/${reportComplaintId}`)
        })
    });
});
const $730e7f4df4ac3da0$export$ff07cc9f0adc88a0 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportGetReportComplaintsLoading = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportGetReportComplaintsLoading));
    const reportComplaints = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportComplaints));
    const reportComplaintsCount = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportComplaintsCount));
    const reportComplaintsLength = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportComplaintsLength));
    const reportComplaintsFetched = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportComplaintsFetched));
    const report = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReport));
    const { id: reportId } = report ?? {};
    const reportComplaintCardHeight = 70;
    const reportComplaintCardMarginBottom = 10;
    const itemHeight = reportComplaintCardHeight + reportComplaintCardMarginBottom;
    const itemsToFit = 6;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = itemsToFit * itemHeight;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    // if report is not fetched
    if (!report) // return skeleton
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $k7vQl.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $k7vQl.styles)().list.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9UxEr.Title), {
                    text: "Complaints"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $k7vQl.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
                    sections: [
                        {
                            name: "report-list-report-complaints-load",
                            width: "100%",
                            height: `${defaultListHeight}px`,
                            isStatic: false,
                            isDivider: false
                        }
                    ]
                })
            })
        ]
    });
    const isItemLoaded = (index)=>!!reportComplaints[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $9CsFP.reportGetReportComplaints)({
            reportId: reportId || "",
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if report complaints are fetched but length is 0
    if (!reportGetReportComplaintsLoading && reportComplaintsFetched && reportComplaintsLength === 0) // return placeholder
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $k7vQl.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $k7vQl.styles)().list.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9UxEr.Title), {
                    text: "Complaints"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $k7vQl.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
                    icon: (0, $9IIBp.icons).CheckCircle,
                    height: `${defaultListHeight}px`,
                    title: "Could not find any complaints"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $k7vQl.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $k7vQl.styles)().list.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9UxEr.Title), {
                    text: "Complaints"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $k7vQl.styles)().list.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: reportComplaintsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: reportComplaintsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $730e7f4df4ac3da0$var$Row
                        })
                })
            })
        ]
    });
};
$730e7f4df4ac3da0$export$ff07cc9f0adc88a0.propTypes = {};

});
parcelRegister("fRw87", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return (parcelRequire("9UxEr")).Title; });

var $9UxEr = parcelRequire("9UxEr");

});
parcelRegister("9UxEr", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $7f7271342ba11b53$export$f99233281efd08a0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $7XWHa = parcelRequire("7XWHa");
const $7f7271342ba11b53$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7XWHa.styles)(theme).label.main,
        children: text
    });
};
$7f7271342ba11b53$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("7XWHa", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6f68585bbb139c87$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $6f68585bbb139c87$export$9dd6ff9ea0189349 = (theme)=>({
        label: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("k7vQl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6e3d07143d00bb13$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $6e3d07143d00bb13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6e3d07143d00bb13$var$_ref = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $6e3d07143d00bb13$var$_ref2 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
const $6e3d07143d00bb13$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";display:flex;flex-direction:column;overflow:hidden;max-width:800px;margin-bottom:50px;", ""),
            title: $6e3d07143d00bb13$var$_ref2,
            content: $6e3d07143d00bb13$var$_ref
        },
        comments: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("bLYI6", function(module, exports) {

$parcel$export(module.exports, "ReportComplaintViewReportComplaint", function () { return $bb8def9d38ae805f$export$ac311a35bb6f30cb; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $e1EpZ = parcelRequire("e1EpZ");
const $bb8def9d38ae805f$export$ac311a35bb6f30cb = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const theme = (0, $hXJcm.u)();
    const reportComplaint = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportComplaint));
    const reportComplaintFetched = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportComplaintFetched));
    const { userId: reportComplaintAuthorUserId, complaint: complaint, complaintType: complaintType } = reportComplaint ?? {};
    // report complaint author
    const { user: reportComplaintAuthor, isLoading: isReportComplaintAuthorLoading } = (0, $4y2bm.useUserPublic)(reportComplaintAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = reportComplaintAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $hrd7b.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $exYeM.useState)(false);
    // if report complaint not found
    if (reportComplaintFetched && !reportComplaint) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $e1EpZ.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).AlertTriangle,
            height: "133px",
            title: "Could not find report complaint"
        })
    });
    // if report complaint found
    if (reportComplaintFetched && reportComplaint) return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $e1EpZ.styles)(theme).view.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $e1EpZ.styles)(theme).view.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e1EpZ.styles)(theme).view.data.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $e1EpZ.styles)(theme).view.data.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                            css: (0, $e1EpZ.styles)(theme).view.data.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $e1EpZ.styles)(theme).view.data.content.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $e1EpZ.styles)(theme).view.data.content.name,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: (0, $e1EpZ.styles)(theme).view.data.content.name,
                                    onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${reportComplaintAuthorUserId}`),
                                    type: "button",
                                    "aria-label": "explore author profile",
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                        children: isReportComplaintAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $e1EpZ.styles)(theme).view.data.content.complaint,
                                children: complaint
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $e1EpZ.styles)(theme).view.type.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $e1EpZ.styles)(theme).view.type.text,
                    children: complaintType?.toString().replace("_", " ")
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $e1EpZ.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-complaint-view-report-complaint",
                    width: "100%",
                    height: "133px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$bb8def9d38ae805f$export$ac311a35bb6f30cb.propTypes = {};

});
parcelRegister("e1EpZ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d12311ef919485d8$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d12311ef919485d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d12311ef919485d8$var$_ref = {
    name: "1tltq10",
    styles: "display:flex;align-items:center;margin-left:42px"
};
var $d12311ef919485d8$var$_ref2 = {
    name: "1gjs2mp",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-bottom:8px"
};
var $d12311ef919485d8$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $d12311ef919485d8$var$_ref4 = {
    name: "13sxwxr",
    styles: "display:flex;flex-direction:column;max-width:800px"
};
const $d12311ef919485d8$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: $d12311ef919485d8$var$_ref4,
            data: {
                main: $d12311ef919485d8$var$_ref3,
                avatar: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                    image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                content: {
                    main: $d12311ef919485d8$var$_ref2,
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                    complaint: /*#__PURE__*/ (0, $4N3Qt.css)("word-break:break-all;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
                }
            },
            type: {
                main: $d12311ef919485d8$var$_ref,
                text: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;text-transform:uppercase;color:", theme.colors.negative.normal, ";font-size:", (0, $48E0n.typography).c, ";font-weight:bold;", "")
            }
        }
    });

});


parcelRegister("1Nttt", function(module, exports) {

$parcel$export(module.exports, "ReportListReports", function () { return $6fdff2876529ed28$export$7b3b208f88d54575; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $7koh8 = parcelRequire("7koh8");
var $9CsFP = parcelRequire("9CsFP");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $lFRMC = parcelRequire("lFRMC");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $8YoYE = parcelRequire("8YoYE");
const $6fdff2876529ed28$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const reports = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReports));
    const report = reports[index];
    // if report not fetched
    if (!report) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-list-reports-report",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: reportId } = report;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8YoYE.styles)().report.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7koh8.ReportCard), {
            report: report,
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Reports}${(0, $9YTSb.Path).Report}/${reportId}`)
        })
    });
});
const $6fdff2876529ed28$export$7b3b208f88d54575 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportGetReportsLoading = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportGetReportsLoading));
    const reports = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReports));
    const reportsCount = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportsCount));
    const reportsLength = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportsLength));
    const reportsFetched = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportsFetched));
    const reportsFilter = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportsFilter));
    const reportCardHeight = 60;
    const reportCardMarginBottom = 20;
    const itemHeight = reportCardHeight + reportCardMarginBottom;
    const itemsToFit = 6;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = itemsToFit * itemHeight;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!reports[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $9CsFP.reportGetReports)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders report list navigation
    const renderReportListNavigation = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $8YoYE.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lFRMC.NavigationScrollable), {
                options: [
                    {
                        id: "14971507-83aa-4bf6-a1af-9bfe525f6d32",
                        label: "User",
                        enabled: reportsFilter === (0, $aeAwZ.EntityReportEntityType).User,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $6CAIO.reportSetReportsFilter)({
                                filter: (0, $aeAwZ.EntityReportEntityType).User
                            }));
                            // refetch reports
                            dispatch((0, $9CsFP.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "9ba9f8d0-624b-4698-b024-e0a6fd752d29",
                        label: "Track",
                        enabled: reportsFilter === (0, $aeAwZ.EntityReportEntityType).Track,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $6CAIO.reportSetReportsFilter)({
                                filter: (0, $aeAwZ.EntityReportEntityType).Track
                            }));
                            // refetch reports
                            dispatch((0, $9CsFP.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "d53b86eb-48e7-4abc-aa96-482944eb7a5b",
                        label: "Post",
                        enabled: reportsFilter === (0, $aeAwZ.EntityReportEntityType).Post,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $6CAIO.reportSetReportsFilter)({
                                filter: (0, $aeAwZ.EntityReportEntityType).Post
                            }));
                            // refetch reports
                            dispatch((0, $9CsFP.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "df95c9e0-99c1-4da9-9baf-939f26bc3d09",
                        label: "Comment",
                        enabled: reportsFilter === (0, $aeAwZ.EntityReportEntityType).Comment,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $6CAIO.reportSetReportsFilter)({
                                filter: (0, $aeAwZ.EntityReportEntityType).Comment
                            }));
                            // refetch reports
                            dispatch((0, $9CsFP.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    }
                ]
            })
        });
    // renders report list table header
    const renderReportListTableHeader = ()=>/*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $8YoYE.styles)().list.header.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8YoYE.styles)().list.header.placeholder
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8YoYE.styles)().list.header.identifier,
                    children: "Identifier"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8YoYE.styles)().list.header.type,
                    children: "Type"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8YoYE.styles)().list.header.status,
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8YoYE.styles)().list.header.date,
                    children: "Date"
                })
            ]
        });
    // if reports are fetched but length is 0
    if (!reportGetReportsLoading && reportsFetched && reportsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $8YoYE.styles)().list.main,
        children: [
            renderReportListNavigation(),
            renderReportListTableHeader(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8YoYE.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
                    icon: (0, $9IIBp.icons).CheckCircle,
                    height: `${defaultListHeight}px`,
                    title: "There are no unresolved reports"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $8YoYE.styles)().list.main,
        children: [
            renderReportListNavigation(),
            renderReportListTableHeader(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8YoYE.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: reportsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: reportsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $6fdff2876529ed28$var$Row
                        })
                })
            })
        ]
    }));
};
$6fdff2876529ed28$export$7b3b208f88d54575.propTypes = {};

});
parcelRegister("8YoYE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4a2425729193f101$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $4a2425729193f101$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4a2425729193f101$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
var $4a2425729193f101$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $4a2425729193f101$var$_ref3 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $4a2425729193f101$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $4a2425729193f101$var$_ref5 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $4a2425729193f101$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $4a2425729193f101$var$_ref7 = {
    name: "phodm9",
    styles: "display:flex;max-width:800px;margin-bottom:32px"
};
const $4a2425729193f101$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            header: {
                main: $4a2425729193f101$var$_ref7,
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("flex:0 0 40px;margin-right:10px;", (0, $48E0n.mq).tablet($4a2425729193f101$var$_ref6), ";", ""),
                identifier: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 100px;margin-right:10px;", (0, $48E0n.mq).mobile($4a2425729193f101$var$_ref5), ";", ""),
                type: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).tablet($4a2425729193f101$var$_ref4), ";", ""),
                status: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).mobile($4a2425729193f101$var$_ref3), ";", ""),
                date: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;", (0, $48E0n.mq).mobile($4a2425729193f101$var$_ref2), ";", "")
            },
            content: {
                main: $4a2425729193f101$var$_ref
            }
        },
        report: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("hD9dS", function(module, exports) {

$parcel$export(module.exports, "ReportPostModal", function () { return $01f828b9db3edcdb$export$6610c8fff59d8576; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("1fTj4");
var $6Cyp6 = parcelRequire("6Cyp6");

var $1vJWy = parcelRequire("1vJWy");
const $01f828b9db3edcdb$export$6610c8fff59d8576 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportPostModalOpen = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportPostModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $1vJWy.styles)().modal.main,
        children: reportPostModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $6CAIO.reportCloseReportPostModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1vJWy.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6Cyp6.ReportPostCard), {})
            })
        })
    });
};
$01f828b9db3edcdb$export$6610c8fff59d8576.propTypes = {};

});
parcelRegister("1fTj4", function(module, exports) {

$parcel$export(module.exports, "ReportPostCard", function () { return (parcelRequire("6Cyp6")).ReportPostCard; });

var $6Cyp6 = parcelRequire("6Cyp6");

});
parcelRegister("6Cyp6", function(module, exports) {

$parcel$export(module.exports, "ReportPostCard", function () { return $ecbdefb966e92920$export$27d18a6e1427506; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("a9Vd3");
var $gvT9x = parcelRequire("gvT9x");

var $kcQrc = parcelRequire("kcQrc");
const $ecbdefb966e92920$export$27d18a6e1427506 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportPostError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $kcQrc.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kcQrc.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $6CAIO.reportCloseReportPostModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kcQrc.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kcQrc.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this post."
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $kcQrc.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $kcQrc.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gvT9x.ReportPostForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $kcQrc.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: reportPostError
                        })
                    })
                ]
            })
        ]
    });
};
$ecbdefb966e92920$export$27d18a6e1427506.propTypes = {};

});
parcelRegister("a9Vd3", function(module, exports) {

$parcel$export(module.exports, "ReportPostForm", function () { return (parcelRequire("gvT9x")).ReportPostForm; });

var $gvT9x = parcelRequire("gvT9x");

});
parcelRegister("gvT9x", function(module, exports) {

$parcel$export(module.exports, "ReportPostForm", function () { return $39719edd10d07236$export$82ab98eea2f39c83; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $kDwrL = parcelRequire("kDwrL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9CsFP = parcelRequire("9CsFP");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $i8CSQ = parcelRequire("i8CSQ");
var $e0SLm = parcelRequire("e0SLm");
var $1sbY5 = parcelRequire("1sbY5");

var $5lf7V = parcelRequire("5lf7V");
const $39719edd10d07236$export$82ab98eea2f39c83 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportCreatePostReportComplaintLoading = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportCreatePostReportComplaintLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalPost = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportPostModalPost));
    const [complaintType, setComplaintType] = (0, $exYeM.useState)("");
    const [complaint, setComplaint] = (0, $exYeM.useState)("");
    const [complaintError, setComplaintError] = (0, $exYeM.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId } = modalPost ?? {};
    const isCurrentUserPost = profileUserId === artistUserId;
    const submitDisabled = complaint.length > (0, $kDwrL.maxReportComplaintLength) || !complaintType || isCurrentUserPost || reportCreatePostReportComplaintLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $5lf7V.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $5lf7V.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $9CsFP.reportCreatePostReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $5lf7V.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e0SLm.InputSelect), {
                        placeholder: {
                            id: "report-post-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $kDwrL.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $5lf7V.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i8CSQ.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $kDwrL.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $33ayT.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $5lf7V.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreatePostReportComplaintLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$39719edd10d07236$export$82ab98eea2f39c83.propTypes = {};

});
parcelRegister("5lf7V", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4731ce75dceec9d4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $4731ce75dceec9d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4731ce75dceec9d4$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $4731ce75dceec9d4$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $4731ce75dceec9d4$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                type: $4731ce75dceec9d4$var$_ref2,
                complaint: $4731ce75dceec9d4$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("kcQrc", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8ded1957849f3fec$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8ded1957849f3fec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8ded1957849f3fec$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8ded1957849f3fec$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8ded1957849f3fec$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $8ded1957849f3fec$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8ded1957849f3fec$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8ded1957849f3fec$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $8ded1957849f3fec$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $8ded1957849f3fec$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $8ded1957849f3fec$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($8ded1957849f3fec$var$_ref8), " ", (0, $48E0n.mq).mobile($8ded1957849f3fec$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($8ded1957849f3fec$var$_ref6), ";", ""),
            title: $8ded1957849f3fec$var$_ref5,
            subtitle: $8ded1957849f3fec$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($8ded1957849f3fec$var$_ref3), ";", ""),
                form: $8ded1957849f3fec$var$_ref2,
                error: $8ded1957849f3fec$var$_ref
            }
        }
    });

});



parcelRegister("1vJWy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1d15ca65f113813e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $1d15ca65f113813e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1d15ca65f113813e$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $1d15ca65f113813e$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($1d15ca65f113813e$var$_ref), ";", "")
        }
    });

});


parcelRegister("gaaD4", function(module, exports) {

$parcel$export(module.exports, "ReportResolveModal", function () { return $10e210e084e12f88$export$e373f5a8b050afe; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("fjXHd");
var $5SG2B = parcelRequire("5SG2B");

var $6P5pe = parcelRequire("6P5pe");
const $10e210e084e12f88$export$e373f5a8b050afe = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportResolveModalOpen = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportResolveModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $6P5pe.styles)().modal.main,
        children: reportResolveModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $6CAIO.reportCloseReportResolveModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6P5pe.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5SG2B.ReportResolveCard), {})
            })
        })
    });
};
$10e210e084e12f88$export$e373f5a8b050afe.propTypes = {};

});
parcelRegister("fjXHd", function(module, exports) {

$parcel$export(module.exports, "ReportResolveCard", function () { return (parcelRequire("5SG2B")).ReportResolveCard; });

var $5SG2B = parcelRequire("5SG2B");

});
parcelRegister("5SG2B", function(module, exports) {

$parcel$export(module.exports, "ReportResolveCard", function () { return $077c2160c5568e57$export$15d37b6ae89a7af2; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("hb0OU");
var $bFUCD = parcelRequire("bFUCD");

var $bFdh1 = parcelRequire("bFdh1");
const $077c2160c5568e57$export$15d37b6ae89a7af2 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportResolveError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $bFdh1.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bFdh1.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $6CAIO.reportCloseReportResolveModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bFdh1.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Resolve",
                    icon: (0, $9IIBp.icons).Check
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bFdh1.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Resolve the report once the matter has been thoroughly examined and processed."
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $bFdh1.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bFdh1.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bFUCD.ReportResolveForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bFdh1.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: reportResolveError
                        })
                    })
                ]
            })
        ]
    });
};
$077c2160c5568e57$export$15d37b6ae89a7af2.propTypes = {};

});
parcelRegister("hb0OU", function(module, exports) {

$parcel$export(module.exports, "ReportResolveForm", function () { return (parcelRequire("bFUCD")).ReportResolveForm; });

var $bFUCD = parcelRequire("bFUCD");

});
parcelRegister("bFUCD", function(module, exports) {

$parcel$export(module.exports, "ReportResolveForm", function () { return $dd4a7357e42bc12f$export$4a431c6a63f35209; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $9CsFP = parcelRequire("9CsFP");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $1EM1I = parcelRequire("1EM1I");
const $dd4a7357e42bc12f$export$4a431c6a63f35209 = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportResolveReportLoading = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportResolveReportLoading));
    const modalReport = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportResolveModalReport));
    const { id: reportId, shortId: shortReportId } = modalReport ?? {};
    const submitDisabled = reportResolveReportLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $1EM1I.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $1EM1I.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $9CsFP.reportResolveReport)({
                    reportId: reportId || "",
                    cb: ()=>{
                        // navigate to reports page
                        navigate(`${(0, $9YTSb.Path).Reports}`);
                    }
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $1EM1I.styles)().form.content.report,
                    children: `#${shortReportId}`
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $1EM1I.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportResolveReportLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Resolve`
                    })
                })
            ]
        })
    });
};
$dd4a7357e42bc12f$export$4a431c6a63f35209.propTypes = {};

});
parcelRegister("1EM1I", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9a4be363cdf60789$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $9a4be363cdf60789$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                report: /*#__PURE__*/ (0, $4N3Qt.css)("margin-bottom:24px;text-align:center;font-size:", (0, $48E0n.typography).h5, ";", ""),
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("bFdh1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5839b5d8ec94ec27$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $5839b5d8ec94ec27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5839b5d8ec94ec27$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5839b5d8ec94ec27$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5839b5d8ec94ec27$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $5839b5d8ec94ec27$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5839b5d8ec94ec27$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5839b5d8ec94ec27$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $5839b5d8ec94ec27$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $5839b5d8ec94ec27$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $5839b5d8ec94ec27$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($5839b5d8ec94ec27$var$_ref8), " ", (0, $48E0n.mq).mobile($5839b5d8ec94ec27$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($5839b5d8ec94ec27$var$_ref6), ";", ""),
            title: $5839b5d8ec94ec27$var$_ref5,
            subtitle: $5839b5d8ec94ec27$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($5839b5d8ec94ec27$var$_ref3), ";", ""),
                form: $5839b5d8ec94ec27$var$_ref2,
                error: $5839b5d8ec94ec27$var$_ref
            }
        }
    });

});



parcelRegister("6P5pe", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f57d5aac7a9c6d83$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f57d5aac7a9c6d83$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f57d5aac7a9c6d83$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $f57d5aac7a9c6d83$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($f57d5aac7a9c6d83$var$_ref), ";", "")
        }
    });

});


parcelRegister("j3V56", function(module, exports) {

$parcel$export(module.exports, "ReportTrackModal", function () { return $ffa0631966124ab5$export$234fa7d426a2b82b; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("i9tNd");
var $NScNY = parcelRequire("NScNY");

var $6whnj = parcelRequire("6whnj");
const $ffa0631966124ab5$export$234fa7d426a2b82b = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportTrackModalOpen = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportTrackModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $6whnj.styles)().modal.main,
        children: reportTrackModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $6CAIO.reportCloseReportTrackModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6whnj.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $NScNY.ReportTrackCard), {})
            })
        })
    });
};
$ffa0631966124ab5$export$234fa7d426a2b82b.propTypes = {};

});
parcelRegister("i9tNd", function(module, exports) {

$parcel$export(module.exports, "ReportTrackCard", function () { return (parcelRequire("NScNY")).ReportTrackCard; });

var $NScNY = parcelRequire("NScNY");

});
parcelRegister("NScNY", function(module, exports) {

$parcel$export(module.exports, "ReportTrackCard", function () { return $ac4cd646ebddf6f4$export$659fcbb67532e1ba; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("8xUHd");
var $5VZDd = parcelRequire("5VZDd");

var $6Qsts = parcelRequire("6Qsts");
const $ac4cd646ebddf6f4$export$659fcbb67532e1ba = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportTrackError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $6Qsts.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6Qsts.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $6CAIO.reportCloseReportTrackModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6Qsts.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6Qsts.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this track."
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $6Qsts.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $6Qsts.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5VZDd.ReportTrackForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $6Qsts.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: reportTrackError
                        })
                    })
                ]
            })
        ]
    });
};
$ac4cd646ebddf6f4$export$659fcbb67532e1ba.propTypes = {};

});
parcelRegister("8xUHd", function(module, exports) {

$parcel$export(module.exports, "ReportTrackForm", function () { return (parcelRequire("5VZDd")).ReportTrackForm; });

var $5VZDd = parcelRequire("5VZDd");

});
parcelRegister("5VZDd", function(module, exports) {

$parcel$export(module.exports, "ReportTrackForm", function () { return $7b12450daa2d2b12$export$90d0cf6a279f0b72; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $kDwrL = parcelRequire("kDwrL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9CsFP = parcelRequire("9CsFP");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $i8CSQ = parcelRequire("i8CSQ");
var $e0SLm = parcelRequire("e0SLm");
var $1sbY5 = parcelRequire("1sbY5");

var $eMY4h = parcelRequire("eMY4h");
const $7b12450daa2d2b12$export$90d0cf6a279f0b72 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportCreateTrackReportComplaintLoading = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportCreateTrackReportComplaintLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalTrack = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportTrackModalTrack));
    const [complaintType, setComplaintType] = (0, $exYeM.useState)("");
    const [complaint, setComplaint] = (0, $exYeM.useState)("");
    const [complaintError, setComplaintError] = (0, $exYeM.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId } = modalTrack ?? {};
    const isCurrentUserTrack = profileUserId === artistUserId;
    const submitDisabled = complaint.length > (0, $kDwrL.maxReportComplaintLength) || !complaintType || isCurrentUserTrack || reportCreateTrackReportComplaintLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $eMY4h.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $eMY4h.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $9CsFP.reportCreateTrackReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $eMY4h.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e0SLm.InputSelect), {
                        placeholder: {
                            id: "report-track-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $kDwrL.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $eMY4h.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i8CSQ.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $kDwrL.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $33ayT.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $eMY4h.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreateTrackReportComplaintLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$7b12450daa2d2b12$export$90d0cf6a279f0b72.propTypes = {};

});
parcelRegister("eMY4h", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $dc8e136055a680da$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $dc8e136055a680da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $dc8e136055a680da$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $dc8e136055a680da$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $dc8e136055a680da$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                type: $dc8e136055a680da$var$_ref2,
                complaint: $dc8e136055a680da$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("6Qsts", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $dfab0d2308dee62f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $dfab0d2308dee62f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $dfab0d2308dee62f$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $dfab0d2308dee62f$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $dfab0d2308dee62f$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $dfab0d2308dee62f$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $dfab0d2308dee62f$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $dfab0d2308dee62f$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $dfab0d2308dee62f$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $dfab0d2308dee62f$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $dfab0d2308dee62f$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($dfab0d2308dee62f$var$_ref8), " ", (0, $48E0n.mq).mobile($dfab0d2308dee62f$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($dfab0d2308dee62f$var$_ref6), ";", ""),
            title: $dfab0d2308dee62f$var$_ref5,
            subtitle: $dfab0d2308dee62f$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($dfab0d2308dee62f$var$_ref3), ";", ""),
                form: $dfab0d2308dee62f$var$_ref2,
                error: $dfab0d2308dee62f$var$_ref
            }
        }
    });

});



parcelRegister("6whnj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f9f107a9b6932d27$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f9f107a9b6932d27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f9f107a9b6932d27$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $f9f107a9b6932d27$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($f9f107a9b6932d27$var$_ref), ";", "")
        }
    });

});


parcelRegister("72Vfl", function(module, exports) {

$parcel$export(module.exports, "ReportUserModal", function () { return $aaa3d8465544426f$export$84a46ec975a11172; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("lJzRr");
var $SC6LM = parcelRequire("SC6LM");

var $g2Hhi = parcelRequire("g2Hhi");
const $aaa3d8465544426f$export$84a46ec975a11172 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportUserModalOpen = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportUserModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $g2Hhi.styles)().modal.main,
        children: reportUserModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $6CAIO.reportCloseReportUserModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $g2Hhi.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $SC6LM.ReportUserCard), {})
            })
        })
    });
};
$aaa3d8465544426f$export$84a46ec975a11172.propTypes = {};

});
parcelRegister("lJzRr", function(module, exports) {

$parcel$export(module.exports, "ReportUserCard", function () { return (parcelRequire("SC6LM")).ReportUserCard; });

var $SC6LM = parcelRequire("SC6LM");

});
parcelRegister("SC6LM", function(module, exports) {

$parcel$export(module.exports, "ReportUserCard", function () { return $cff7ef46e5fd9df8$export$8282ae97f8b0dd0; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("5e3nM");
var $lBeW1 = parcelRequire("lBeW1");

var $iNp6b = parcelRequire("iNp6b");
const $cff7ef46e5fd9df8$export$8282ae97f8b0dd0 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportUserError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $iNp6b.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $iNp6b.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $6CAIO.reportCloseReportUserModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $iNp6b.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $iNp6b.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this user."
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $iNp6b.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $iNp6b.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lBeW1.ReportUserForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $iNp6b.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: reportUserError
                        })
                    })
                ]
            })
        ]
    });
};
$cff7ef46e5fd9df8$export$8282ae97f8b0dd0.propTypes = {};

});
parcelRegister("5e3nM", function(module, exports) {

$parcel$export(module.exports, "ReportUserForm", function () { return (parcelRequire("lBeW1")).ReportUserForm; });

var $lBeW1 = parcelRequire("lBeW1");

});
parcelRegister("lBeW1", function(module, exports) {

$parcel$export(module.exports, "ReportUserForm", function () { return $04d21edf6a492a28$export$3dfcd5665feb50c4; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $kDwrL = parcelRequire("kDwrL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9CsFP = parcelRequire("9CsFP");
var $6CAIO = parcelRequire("6CAIO");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $i8CSQ = parcelRequire("i8CSQ");
var $e0SLm = parcelRequire("e0SLm");
var $1sbY5 = parcelRequire("1sbY5");

var $jPJxG = parcelRequire("jPJxG");
const $04d21edf6a492a28$export$3dfcd5665feb50c4 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const reportCreateUserReportComplaintLoading = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportCreateUserReportComplaintLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalUser = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportUserModalUser));
    const [complaintType, setComplaintType] = (0, $exYeM.useState)("");
    const [complaint, setComplaint] = (0, $exYeM.useState)("");
    const [complaintError, setComplaintError] = (0, $exYeM.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { id: currentUserId } = modalUser ?? {};
    const isCurrentUser = profileUserId === currentUserId;
    const submitDisabled = complaint.length > (0, $kDwrL.maxReportComplaintLength) || !complaintType || isCurrentUser || reportCreateUserReportComplaintLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $jPJxG.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $jPJxG.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $9CsFP.reportCreateUserReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $jPJxG.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e0SLm.InputSelect), {
                        placeholder: {
                            id: "report-user-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $kDwrL.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $jPJxG.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i8CSQ.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $kDwrL.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $33ayT.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $jPJxG.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreateUserReportComplaintLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$04d21edf6a492a28$export$3dfcd5665feb50c4.propTypes = {};

});
parcelRegister("jPJxG", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e0d73a8539cd4755$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $e0d73a8539cd4755$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e0d73a8539cd4755$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $e0d73a8539cd4755$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $e0d73a8539cd4755$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                type: $e0d73a8539cd4755$var$_ref2,
                complaint: $e0d73a8539cd4755$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("iNp6b", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2ed75f3dfb1643eb$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $2ed75f3dfb1643eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2ed75f3dfb1643eb$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ed75f3dfb1643eb$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ed75f3dfb1643eb$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2ed75f3dfb1643eb$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ed75f3dfb1643eb$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ed75f3dfb1643eb$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $2ed75f3dfb1643eb$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $2ed75f3dfb1643eb$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $2ed75f3dfb1643eb$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($2ed75f3dfb1643eb$var$_ref8), " ", (0, $48E0n.mq).mobile($2ed75f3dfb1643eb$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($2ed75f3dfb1643eb$var$_ref6), ";", ""),
            title: $2ed75f3dfb1643eb$var$_ref5,
            subtitle: $2ed75f3dfb1643eb$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($2ed75f3dfb1643eb$var$_ref3), ";", ""),
                form: $2ed75f3dfb1643eb$var$_ref2,
                error: $2ed75f3dfb1643eb$var$_ref
            }
        }
    });

});



parcelRegister("g2Hhi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $94ffd5567ab35442$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $94ffd5567ab35442$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $94ffd5567ab35442$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $94ffd5567ab35442$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($94ffd5567ab35442$var$_ref), ";", "")
        }
    });

});


parcelRegister("4TFxW", function(module, exports) {

$parcel$export(module.exports, "ReportViewReport", function () { return $e8b94da6f50f95d3$export$970de5d4d05f74d2; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $5F6ta = parcelRequire("5F6ta");
var $lBv1N = parcelRequire("lBv1N");
var $yKMRU = parcelRequire("yKMRU");
var $gSFbK = parcelRequire("gSFbK");
parcelRequire("dmGpj");
var $lWbfW = parcelRequire("lWbfW");
var $jhoVP = parcelRequire("jhoVP");
var $l1Cdj = parcelRequire("l1Cdj");
var $6CAIO = parcelRequire("6CAIO");
var $1bnO9 = parcelRequire("1bnO9");
var $kkIKc = parcelRequire("kkIKc");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("5d7Kh");
var $diU4z = parcelRequire("diU4z");
var $gJQ6h = parcelRequire("gJQ6h");

var $7B5s3 = parcelRequire("7B5s3");
const $e8b94da6f50f95d3$export$970de5d4d05f74d2 = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const report = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReport));
    const reportFetched = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportFetched));
    const reportEntityBlocked = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportEntityBlocked));
    const reportUserBlocked = (0, $9CcOD.useAppSelector)((0, $6CAIO.reportSelectReportUserBlocked));
    const { shortId: shortId, entityType: entityType, entityId: entityId, entityUserId: entityUserId } = report ?? {};
    const isTrackReport = entityType === (0, $aeAwZ.EntityReportEntityType).Track;
    const isPostReport = entityType === (0, $aeAwZ.EntityReportEntityType).Post;
    const isCommentReport = entityType === (0, $aeAwZ.EntityReportEntityType).Comment;
    // report user
    const { user: reportUser, isLoading: isReportUserLoading } = (0, $gSFbK.useUser)(entityUserId || "");
    // report track
    const { track: reportTrack, isLoading: isReportTrackLoading } = (0, $yKMRU.useTrack)(isTrackReport ? entityId || "" : "");
    // report post
    const { post: reportPost, isLoading: isReportPostLoading } = (0, $lBv1N.usePost)(isPostReport ? entityId || "" : "");
    // report comment
    const { comment: reportComment, isLoading: isReportCommentLoading } = (0, $5F6ta.useComment)(isCommentReport ? entityId || "" : "");
    const isUserControlsDisabled = isReportUserLoading || !reportUser || reportUserBlocked;
    const isTrackControlsDisabled = isReportTrackLoading || !reportTrack || reportEntityBlocked;
    const isPostControlsDisabled = isReportPostLoading || !reportPost || reportEntityBlocked;
    const isCommentControlsDisabled = isReportCommentLoading || !reportComment || reportEntityBlocked;
    // if report not found
    if (reportFetched && !report) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7B5s3.styles)().view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).AlertTriangle,
            height: "119px",
            title: "Could not find report"
        })
    });
    const renderReportContentNavigation = ()=>{
        // if content type is track
        if (isTrackReport) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
            appearance: "neutral",
            label: "play track",
            icon: (0, $9IIBp.icons).PlayCircleBold,
            text: "Play track",
            disabled: isTrackControlsDisabled,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: reportTrack
                }))
        });
        // if content type is post
        if (isPostReport) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
            appearance: "neutral",
            label: "navigate to post page",
            icon: (0, $9IIBp.icons).Scope,
            text: "View post",
            disabled: isPostControlsDisabled,
            onClick: ()=>navigate(`${(0, $9YTSb.Path).Post}/${entityId}`)
        });
        // if content type is comment
        if (isCommentReport) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
            appearance: "neutral",
            label: "navigate to comment",
            icon: (0, $9IIBp.icons).Scope,
            text: "View comment",
            disabled: isCommentControlsDisabled,
            onClick: ()=>{
                // add comment to comment depth
                dispatch((0, $lWbfW.commentAddDepth)({
                    comment: reportComment
                }));
                // navigate to post page
                navigate(`${(0, $9YTSb.Path).Post}/${reportComment?.postId}`);
            }
        });
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {});
    };
    const renderReportContentBlockControl = ()=>{
        // if content type is track
        if (isTrackReport) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
            appearance: "negative",
            label: "block track",
            icon: (0, $9IIBp.icons).CrossSquare,
            text: "Block track",
            disabled: isTrackControlsDisabled,
            onClick: ()=>dispatch((0, $1bnO9.trackOpenTrackBlockModal)({
                    track: reportTrack
                }))
        });
        // if content type is post
        if (isPostReport) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
            appearance: "negative",
            label: "block post",
            icon: (0, $9IIBp.icons).CrossSquare,
            text: "Block post",
            disabled: isPostControlsDisabled,
            onClick: ()=>dispatch((0, $l1Cdj.postOpenPostBlockModal)({
                    post: reportPost
                }))
        });
        // if content type is comment
        if (isCommentReport) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
            appearance: "negative",
            label: "block comment",
            icon: (0, $9IIBp.icons).CrossSquare,
            text: "Block comment",
            disabled: isCommentControlsDisabled,
            onClick: ()=>dispatch((0, $lWbfW.commentOpenCommentBlockModal)({
                    comment: reportComment
                }))
        });
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {});
    };
    // if report found
    if (reportFetched && report) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7B5s3.styles)().view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $7B5s3.styles)().view.content.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $7B5s3.styles)().view.content.identifier,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gJQ6h.Identifier), {
                        identifier: shortId || ""
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $7B5s3.styles)().view.content.navigation,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
                            appearance: "neutral",
                            label: "navigate to user page",
                            icon: (0, $9IIBp.icons).UserCircle,
                            text: "View user",
                            disabled: isUserControlsDisabled,
                            onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${entityUserId}`)
                        }),
                        renderReportContentNavigation()
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $7B5s3.styles)().view.content.controls,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
                            appearance: "negative",
                            label: "block user",
                            icon: (0, $9IIBp.icons).CrossSquare,
                            text: "Block user",
                            disabled: isUserControlsDisabled,
                            onClick: ()=>dispatch((0, $kkIKc.userOpenUserBlockModal)({
                                    user: reportUser
                                }))
                        }),
                        renderReportContentBlockControl(),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $diU4z.Control), {
                            appearance: "positive",
                            label: "resolve report",
                            icon: (0, $9IIBp.icons).CheckSquare,
                            text: "Resolve report",
                            disabled: false,
                            onClick: ()=>dispatch((0, $6CAIO.reportOpenReportResolveModal)({
                                    report: report
                                }))
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7B5s3.styles)().view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-view-reports-report",
                    width: "100%",
                    height: "119px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$e8b94da6f50f95d3$export$970de5d4d05f74d2.propTypes = {};

});
parcelRegister("5d7Kh", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return (parcelRequire("diU4z")).Control; });
$parcel$export(module.exports, "Identifier", function () { return (parcelRequire("gJQ6h")).Identifier; });

var $diU4z = parcelRequire("diU4z");

var $gJQ6h = parcelRequire("gJQ6h");

});
parcelRegister("diU4z", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return $81dcb9eee5db41c1$export$7a7fa4424cb20976; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $etSOM = parcelRequire("etSOM");
const $81dcb9eee5db41c1$export$7a7fa4424cb20976 = ({ appearance: appearance = "neutral", label: label, icon: Icon, text: text, disabled: disabled, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $etSOM.styles)(theme).control.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
            css: [
                (0, $etSOM.styles)(theme).control.content.main,
                appearance === "positive" && (0, $etSOM.styles)(theme).control.content.positive,
                appearance === "negative" && (0, $etSOM.styles)(theme).control.content.negative,
                appearance === "neutral" && (0, $etSOM.styles)(theme).control.content.neutral,
                disabled && (0, $etSOM.styles)(theme).control.content.disabled,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": label,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: [
                        (0, $etSOM.styles)(theme).control.content.icon.main,
                        appearance === "positive" && (0, $etSOM.styles)(theme).control.content.icon.positive,
                        appearance === "negative" && (0, $etSOM.styles)(theme).control.content.icon.negative,
                        appearance === "neutral" && (0, $etSOM.styles)(theme).control.content.icon.neutral,
                        disabled && (0, $etSOM.styles)(theme).control.content.icon.disabled,
                        "",
                        ""
                    ],
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: [
                        (0, $etSOM.styles)(theme).control.content.text.main,
                        appearance === "positive" && (0, $etSOM.styles)(theme).control.content.text.positive,
                        appearance === "negative" && (0, $etSOM.styles)(theme).control.content.text.negative,
                        appearance === "neutral" && (0, $etSOM.styles)(theme).control.content.text.neutral,
                        disabled && (0, $etSOM.styles)(theme).control.content.text.disabled,
                        "",
                        ""
                    ],
                    children: text
                })
            ]
        })
    });
};
$81dcb9eee5db41c1$export$7a7fa4424cb20976.propTypes = {};

});
parcelRegister("etSOM", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $19e24259cee31557$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $19e24259cee31557$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $19e24259cee31557$var$_ref = {
    name: "a8rt8v",
    styles: "display:flex;margin-right:10px;&>svg{width:22px;height:22px;}&>svg>path{transition:fill 0.2s;}"
};
var $19e24259cee31557$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
const $19e24259cee31557$export$9dd6ff9ea0189349 = (theme)=>({
        control: {
            main: $19e24259cee31557$var$_ref2,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;cursor:pointer;min-width:130px;", ""),
                positive: /*#__PURE__*/ (0, $4N3Qt.css)("&:hover{&>div>svg>path{fill:", theme.colors.positive.dark, ";}&>div{color:", theme.colors.positive.dark, ";}}", ""),
                negative: /*#__PURE__*/ (0, $4N3Qt.css)("&:hover{&>div>svg>path{fill:", theme.colors.negative.dark, ";}&>div{color:", theme.colors.negative.dark, ";}}", ""),
                neutral: /*#__PURE__*/ (0, $4N3Qt.css)("&:hover{&>div>svg>path{fill:", theme.colors.accent.normal, ";}&>div{color:", theme.colors.accent.normal, ";}}", ""),
                disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&:hover{&>div>svg>path{fill:", theme.colors.secondary.dark, ";}&>div{color:", theme.colors.secondary.dark, ";}}", ""),
                icon: {
                    main: $19e24259cee31557$var$_ref,
                    positive: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.positive.normal, ";}", ""),
                    negative: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.negative.normal, ";}", ""),
                    neutral: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    disabled: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{fill:", theme.colors.secondary.dark, ";}", "")
                },
                text: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("white-space:nowrap;font-size:", (0, $48E0n.typography).p, ";text-decoration:underline;transition:color 0.2s;", ""),
                    positive: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.positive.normal, ";", ""),
                    negative: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.negative.normal, ";", ""),
                    neutral: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";", ""),
                    disabled: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.dark, ";", "")
                }
            }
        }
    });

});


parcelRegister("gJQ6h", function(module, exports) {

$parcel$export(module.exports, "Identifier", function () { return $c35ebc3c3eca1362$export$989167234458594d; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $Q8oRg = parcelRequire("Q8oRg");
const $c35ebc3c3eca1362$export$989167234458594d = ({ identifier: identifier })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $Q8oRg.styles)(theme).identifier.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $Q8oRg.styles)(theme).identifier.id,
            children: `#${identifier}`
        })
    });
};
$c35ebc3c3eca1362$export$989167234458594d.propTypes = {};

});
parcelRegister("Q8oRg", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $41af3141497734ea$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $41af3141497734ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $41af3141497734ea$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $41af3141497734ea$export$9dd6ff9ea0189349 = (theme)=>({
        identifier: {
            main: $41af3141497734ea$var$_ref,
            id: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h5, ";color:", theme.colors.secondary.normal, ";", "")
        }
    });

});



parcelRegister("7B5s3", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $52750e8eee241b1c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $52750e8eee241b1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $52750e8eee241b1c$var$_ref = {
    name: "x5sgny",
    styles: "flex-wrap:wrap;display:flex;&>div{margin-bottom:12px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $52750e8eee241b1c$var$_ref2 = {
    name: "g3ivle",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:12px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $52750e8eee241b1c$var$_ref3 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $52750e8eee241b1c$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $52750e8eee241b1c$var$_ref5 = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
const $52750e8eee241b1c$export$9dd6ff9ea0189349 = ()=>({
        view: {
            main: $52750e8eee241b1c$var$_ref5,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("&:not(:last-of-type){margin-bottom:10px;}", (0, $48E0n.mq).tablet($52750e8eee241b1c$var$_ref4), ";", ""),
                identifier: $52750e8eee241b1c$var$_ref3,
                navigation: $52750e8eee241b1c$var$_ref2,
                controls: $52750e8eee241b1c$var$_ref
            }
        }
    });

});



parcelRegister("6CAIO", function(module, exports) {

$parcel$export(module.exports, "reportSlice", function () { return $7e14ce7788f2e0f5$export$5e255acad067a54e; });
$parcel$export(module.exports, "reportResetState", function () { return $7e14ce7788f2e0f5$export$4aa41af620e6db1f; });
$parcel$export(module.exports, "reportSetReports", function () { return $7e14ce7788f2e0f5$export$c6dc13d62ffde555; });
$parcel$export(module.exports, "reportSetReport", function () { return $7e14ce7788f2e0f5$export$807a3c817972ddf4; });
$parcel$export(module.exports, "reportSetReportEntityBlocked", function () { return $7e14ce7788f2e0f5$export$cfe0ec2b212f109e; });
$parcel$export(module.exports, "reportSetReportUserBlocked", function () { return $7e14ce7788f2e0f5$export$410f1fa2144476ba; });
$parcel$export(module.exports, "reportResetReport", function () { return $7e14ce7788f2e0f5$export$47e498ae1d1aa7b8; });
$parcel$export(module.exports, "reportFilterReport", function () { return $7e14ce7788f2e0f5$export$ecee843e7ecaaa33; });
$parcel$export(module.exports, "reportSetReportComplaints", function () { return $7e14ce7788f2e0f5$export$6c03dc9270f53f4a; });
$parcel$export(module.exports, "reportResetReportComplaints", function () { return $7e14ce7788f2e0f5$export$a30022f2b3e383f3; });
$parcel$export(module.exports, "reportSetReportComplaint", function () { return $7e14ce7788f2e0f5$export$2ed5726b4c4ec1f6; });
$parcel$export(module.exports, "reportResetReportComplaint", function () { return $7e14ce7788f2e0f5$export$d9d9f1dbb6bc6f52; });
$parcel$export(module.exports, "reportSetReportsFilter", function () { return $7e14ce7788f2e0f5$export$9113d04ca40739a9; });
$parcel$export(module.exports, "reportOpenReportCommentModal", function () { return $7e14ce7788f2e0f5$export$5107dc6e51fafca5; });
$parcel$export(module.exports, "reportCloseReportCommentModal", function () { return $7e14ce7788f2e0f5$export$d0bacaa8e5dd7178; });
$parcel$export(module.exports, "reportOpenReportPostModal", function () { return $7e14ce7788f2e0f5$export$917709ba97acadd3; });
$parcel$export(module.exports, "reportCloseReportPostModal", function () { return $7e14ce7788f2e0f5$export$91590c31a4ff5cac; });
$parcel$export(module.exports, "reportOpenReportTrackModal", function () { return $7e14ce7788f2e0f5$export$d78f822310fc4e7a; });
$parcel$export(module.exports, "reportCloseReportTrackModal", function () { return $7e14ce7788f2e0f5$export$160906f62c8a66e4; });
$parcel$export(module.exports, "reportOpenReportUserModal", function () { return $7e14ce7788f2e0f5$export$5d901314f70977e1; });
$parcel$export(module.exports, "reportCloseReportUserModal", function () { return $7e14ce7788f2e0f5$export$ee2aec68f4e7e51a; });
$parcel$export(module.exports, "reportOpenReportResolveModal", function () { return $7e14ce7788f2e0f5$export$bf2597e67ee8aec9; });
$parcel$export(module.exports, "reportCloseReportResolveModal", function () { return $7e14ce7788f2e0f5$export$5e2f470b9ce9dacf; });
$parcel$export(module.exports, "reportSelectReportCommentModalOpen", function () { return $7e14ce7788f2e0f5$export$d515dbd532d432c2; });
$parcel$export(module.exports, "reportSelectReportCommentModalComment", function () { return $7e14ce7788f2e0f5$export$720ee0b8715fd1c5; });
$parcel$export(module.exports, "reportSelectReportPostModalOpen", function () { return $7e14ce7788f2e0f5$export$4a0f866336d17858; });
$parcel$export(module.exports, "reportSelectReportPostModalPost", function () { return $7e14ce7788f2e0f5$export$90d708d3369e452a; });
$parcel$export(module.exports, "reportSelectReportTrackModalOpen", function () { return $7e14ce7788f2e0f5$export$2f88bbf212f26e07; });
$parcel$export(module.exports, "reportSelectReportTrackModalTrack", function () { return $7e14ce7788f2e0f5$export$52db069a822e66b9; });
$parcel$export(module.exports, "reportSelectReportUserModalOpen", function () { return $7e14ce7788f2e0f5$export$75185cb7f4ea21d8; });
$parcel$export(module.exports, "reportSelectReportUserModalUser", function () { return $7e14ce7788f2e0f5$export$3170ddea3395ccb5; });
$parcel$export(module.exports, "reportSelectReportResolveModalOpen", function () { return $7e14ce7788f2e0f5$export$b7a168a21193a4bf; });
$parcel$export(module.exports, "reportSelectReportResolveModalReport", function () { return $7e14ce7788f2e0f5$export$91163bf7aadb8d46; });
$parcel$export(module.exports, "reportSelectReports", function () { return $7e14ce7788f2e0f5$export$4a09dd8fa937d22; });
$parcel$export(module.exports, "reportSelectReportsLength", function () { return $7e14ce7788f2e0f5$export$12cce4392c74ecfe; });
$parcel$export(module.exports, "reportSelectReportsCount", function () { return $7e14ce7788f2e0f5$export$51bd18952516b6aa; });
$parcel$export(module.exports, "reportSelectReportsFetched", function () { return $7e14ce7788f2e0f5$export$290a4fe7e6503272; });
$parcel$export(module.exports, "reportSelectReport", function () { return $7e14ce7788f2e0f5$export$8831e1786fc175d8; });
$parcel$export(module.exports, "reportSelectReportFetched", function () { return $7e14ce7788f2e0f5$export$94ee103c3bfdff80; });
$parcel$export(module.exports, "reportSelectReportEntityBlocked", function () { return $7e14ce7788f2e0f5$export$6d231fdd5ff17f03; });
$parcel$export(module.exports, "reportSelectReportUserBlocked", function () { return $7e14ce7788f2e0f5$export$e05eb5c987aca6d6; });
$parcel$export(module.exports, "reportSelectReportComplaints", function () { return $7e14ce7788f2e0f5$export$52b27bfc3626b1ff; });
$parcel$export(module.exports, "reportSelectReportComplaintsLength", function () { return $7e14ce7788f2e0f5$export$3436f3ec4ac50328; });
$parcel$export(module.exports, "reportSelectReportComplaintsCount", function () { return $7e14ce7788f2e0f5$export$544fbed6aad5dbf3; });
$parcel$export(module.exports, "reportSelectReportComplaintsFetched", function () { return $7e14ce7788f2e0f5$export$3625a3ea92060238; });
$parcel$export(module.exports, "reportSelectReportComplaint", function () { return $7e14ce7788f2e0f5$export$2ccc54e674651766; });
$parcel$export(module.exports, "reportSelectReportComplaintFetched", function () { return $7e14ce7788f2e0f5$export$5dde5b9b2a0f562c; });
$parcel$export(module.exports, "reportSelectReportsFilter", function () { return $7e14ce7788f2e0f5$export$6259cc22ee5b3e43; });
$parcel$export(module.exports, "reportSelectReportCreateCommentReportComplaintLoading", function () { return $7e14ce7788f2e0f5$export$75d753259f095069; });
$parcel$export(module.exports, "reportSelectReportCreatePostReportComplaintLoading", function () { return $7e14ce7788f2e0f5$export$7a8ed540cd7a9abd; });
$parcel$export(module.exports, "reportSelectReportCreateTrackReportComplaintLoading", function () { return $7e14ce7788f2e0f5$export$5eaf42f513e024a4; });
$parcel$export(module.exports, "reportSelectReportCreateUserReportComplaintLoading", function () { return $7e14ce7788f2e0f5$export$77b66bf40e9ad71c; });
$parcel$export(module.exports, "reportSelectReportResolveReportLoading", function () { return $7e14ce7788f2e0f5$export$7e162aba720a43cd; });
$parcel$export(module.exports, "reportSelectReportGetReportsLoading", function () { return $7e14ce7788f2e0f5$export$a5aafbce27ddaa73; });
$parcel$export(module.exports, "reportSelectReportGetReportLoading", function () { return $7e14ce7788f2e0f5$export$4144046713ce64ec; });
$parcel$export(module.exports, "reportSelectReportGetReportComplaintsLoading", function () { return $7e14ce7788f2e0f5$export$1908d68a71fd2c32; });
$parcel$export(module.exports, "reportSelectReportGetReportComplaintLoading", function () { return $7e14ce7788f2e0f5$export$86fecb91d5a0764f; });
$parcel$export(module.exports, "reportReducer", function () { return $7e14ce7788f2e0f5$export$e6ea844ef27f6d3a; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $9CsFP = parcelRequire("9CsFP");
const $7e14ce7788f2e0f5$var$initialState = {
    reports: [],
    reportsCount: 0,
    reportsFetched: false,
    report: undefined,
    reportFetched: false,
    reportEntityBlocked: false,
    reportUserBlocked: false,
    reportComplaints: [],
    reportComplaintsCount: 0,
    reportComplaintsFetched: false,
    reportComplaint: undefined,
    reportComplaintFetched: false,
    reportsFilter: undefined,
    reportCommentModal: {
        comment: undefined,
        open: false
    },
    reportPostModal: {
        post: undefined,
        open: false
    },
    reportTrackModal: {
        track: undefined,
        open: false
    },
    reportUserModal: {
        user: undefined,
        open: false
    },
    reportResolveModal: {
        report: undefined,
        open: false
    },
    reportCreateCommentReportComplaintLoading: false,
    reportCreatePostReportComplaintLoading: false,
    reportCreateTrackReportComplaintLoading: false,
    reportCreateUserReportComplaintLoading: false,
    reportResolveReportLoading: false,
    reportGetReportsLoading: false,
    reportGetReportLoading: false,
    reportGetReportComplaintsLoading: false,
    reportGetReportComplaintLoading: false
};
const $7e14ce7788f2e0f5$export$5e255acad067a54e = (0, $dEr3t.createSlice)({
    name: "report",
    initialState: $7e14ce7788f2e0f5$var$initialState,
    reducers: {
        // reset state
        reportResetState: ()=>({
                reports: [],
                reportsCount: 0,
                reportsFetched: false,
                report: undefined,
                reportFetched: false,
                reportEntityBlocked: false,
                reportUserBlocked: false,
                reportComplaints: [],
                reportComplaintsCount: 0,
                reportComplaintsFetched: false,
                reportComplaint: undefined,
                reportComplaintFetched: false,
                reportsFilter: undefined,
                reportCommentModal: {
                    comment: undefined,
                    open: false
                },
                reportPostModal: {
                    post: undefined,
                    open: false
                },
                reportTrackModal: {
                    track: undefined,
                    open: false
                },
                reportUserModal: {
                    user: undefined,
                    open: false
                },
                reportResolveModal: {
                    report: undefined,
                    open: false
                },
                reportCreateCommentReportComplaintLoading: false,
                reportCreatePostReportComplaintLoading: false,
                reportCreateTrackReportComplaintLoading: false,
                reportCreateUserReportComplaintLoading: false,
                reportResolveReportLoading: false,
                reportGetReportsLoading: false,
                reportGetReportLoading: false,
                reportGetReportComplaintsLoading: false,
                reportGetReportComplaintLoading: false
            }),
        // set reports
        reportSetReports: (state, action)=>{
            const { reports: reports, count: count, offset: offset } = action.payload;
            // mutate count
            state.reportsCount = count;
            // mutate reports array
            state.reports = (0, $9UVKd.mergeArraysAtIndex)(state.reports, reports, offset);
        },
        // set report
        reportSetReport: (state, action)=>{
            const { report: report } = action.payload;
            // update report state
            state.report = report;
        },
        // set report entity blocked
        reportSetReportEntityBlocked: (state)=>({
                ...state,
                reportEntityBlocked: true
            }),
        // set report user blocked
        reportSetReportUserBlocked: (state)=>({
                ...state,
                reportUserBlocked: true
            }),
        // reset report
        reportResetReport: (state)=>({
                ...state,
                report: undefined,
                reportFetched: false,
                reportEntityBlocked: false,
                reportUserBlocked: false
            }),
        // filter report
        reportFilterReport: (state, action)=>{
            const { id: id } = action.payload;
            // check if report exists in reports
            const index = state.reports.findIndex((r)=>r.id === id);
            if (index !== -1) {
                // filter report
                state.reports = state.reports.filter((r)=>r.id !== id);
                state.reportsCount -= 1;
            }
        },
        // set report complaints
        reportSetReportComplaints: (state, action)=>{
            const { reportComplaints: reportComplaints, count: count, offset: offset } = action.payload;
            // mutate count
            state.reportComplaintsCount = count;
            // mutate report complaints array
            state.reportComplaints = (0, $9UVKd.mergeArraysAtIndex)(state.reportComplaints, reportComplaints, offset);
        },
        // reset report complaints
        reportResetReportComplaints: (state)=>({
                ...state,
                reportComplaints: [],
                reportComplaintsCount: 0,
                reportComplaintsFetched: false
            }),
        // set report complaint
        reportSetReportComplaint: (state, action)=>{
            const { reportComplaint: reportComplaint } = action.payload;
            // update report complaint state
            state.reportComplaint = reportComplaint;
        },
        // reset report complaint
        reportResetReportComplaint: (state)=>({
                ...state,
                reportComplaint: undefined,
                reportComplaintFetched: false
            }),
        // set reports filter
        reportSetReportsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup reports
            state.reports = [];
            state.reportsCount = 0;
            // cleanup report complaints
            state.reportComplaints = [];
            state.reportComplaintsCount = 0;
            // mutate reports filter
            state.reportsFilter = state.reportsFilter === filter ? undefined : filter;
        },
        // open report comment modal
        reportOpenReportCommentModal: (state, action)=>({
                ...state,
                reportCommentModal: {
                    comment: action.payload.comment,
                    open: true
                }
            }),
        // close report comment modal
        reportCloseReportCommentModal: (state)=>({
                ...state,
                reportCommentModal: {
                    comment: undefined,
                    open: false
                },
                error: ""
            }),
        // open report post modal
        reportOpenReportPostModal: (state, action)=>({
                ...state,
                reportPostModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close report post modal
        reportCloseReportPostModal: (state)=>({
                ...state,
                reportPostModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            }),
        // open report track modal
        reportOpenReportTrackModal: (state, action)=>({
                ...state,
                reportTrackModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close report track modal
        reportCloseReportTrackModal: (state)=>({
                ...state,
                reportTrackModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            }),
        // open report user modal
        reportOpenReportUserModal: (state, action)=>({
                ...state,
                reportUserModal: {
                    user: action.payload.user,
                    open: true
                }
            }),
        // close report user modal
        reportCloseReportUserModal: (state)=>({
                ...state,
                reportUserModal: {
                    user: undefined,
                    open: false
                },
                error: ""
            }),
        // open report resolve modal
        reportOpenReportResolveModal: (state, action)=>({
                ...state,
                reportResolveModal: {
                    report: action.payload.report,
                    open: true
                }
            }),
        // close report resolve modal
        reportCloseReportResolveModal: (state)=>({
                ...state,
                reportResolveModal: {
                    report: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // create comment report complaint
        builder.addCase((0, $9CsFP.reportCreateCommentReportComplaint).pending, (state)=>({
                ...state,
                reportCreateCommentReportComplaintLoading: true
            })).addCase((0, $9CsFP.reportCreateCommentReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreateCommentReportComplaintLoading: false
            }));
        // create post report complaint
        builder.addCase((0, $9CsFP.reportCreatePostReportComplaint).pending, (state)=>({
                ...state,
                reportCreatePostReportComplaintLoading: true
            })).addCase((0, $9CsFP.reportCreatePostReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreatePostReportComplaintLoading: false
            }));
        // create track report complaint
        builder.addCase((0, $9CsFP.reportCreateTrackReportComplaint).pending, (state)=>({
                ...state,
                reportCreateTrackReportComplaintLoading: true
            })).addCase((0, $9CsFP.reportCreateTrackReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreateTrackReportComplaintLoading: false
            }));
        // create user report complaint
        builder.addCase((0, $9CsFP.reportCreateUserReportComplaint).pending, (state)=>({
                ...state,
                reportCreateUserReportComplaintLoading: true
            })).addCase((0, $9CsFP.reportCreateUserReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreateUserReportComplaintLoading: false
            }));
        // resolve report
        builder.addCase((0, $9CsFP.reportResolveReport).pending, (state)=>({
                ...state,
                reportResolveReportLoading: true
            })).addCase((0, $9CsFP.reportResolveReport).fulfilled, (state)=>({
                ...state,
                reportResolveReportLoading: false
            }));
        // get reports
        builder.addCase((0, $9CsFP.reportGetReports).pending, (state)=>({
                ...state,
                reportGetReportsLoading: true
            })).addCase((0, $9CsFP.reportGetReports).fulfilled, (state)=>({
                ...state,
                reportsFetched: true,
                reportGetReportsLoading: false
            }));
        // get report
        builder.addCase((0, $9CsFP.reportGetReport).pending, (state)=>({
                ...state,
                reportGetReportLoading: true
            })).addCase((0, $9CsFP.reportGetReport).fulfilled, (state)=>({
                ...state,
                reportFetched: true,
                reportGetReportLoading: false
            }));
        // get report complaints
        builder.addCase((0, $9CsFP.reportGetReportComplaints).pending, (state)=>({
                ...state,
                reportGetReportComplaintsLoading: true
            })).addCase((0, $9CsFP.reportGetReportComplaints).fulfilled, (state)=>({
                ...state,
                reportComplaintsFetched: true,
                reportGetReportComplaintsLoading: false
            }));
        // get report complaint
        builder.addCase((0, $9CsFP.reportGetReportComplaint).pending, (state)=>({
                ...state,
                reportGetReportComplaintLoading: true
            })).addCase((0, $9CsFP.reportGetReportComplaint).fulfilled, (state)=>({
                ...state,
                reportComplaintFetched: true,
                reportGetReportComplaintLoading: false
            }));
    }
});
const { reportResetState: $7e14ce7788f2e0f5$export$4aa41af620e6db1f, reportSetReports: $7e14ce7788f2e0f5$export$c6dc13d62ffde555, reportSetReport: $7e14ce7788f2e0f5$export$807a3c817972ddf4, reportSetReportEntityBlocked: $7e14ce7788f2e0f5$export$cfe0ec2b212f109e, reportSetReportUserBlocked: $7e14ce7788f2e0f5$export$410f1fa2144476ba, reportResetReport: $7e14ce7788f2e0f5$export$47e498ae1d1aa7b8, reportFilterReport: $7e14ce7788f2e0f5$export$ecee843e7ecaaa33, reportSetReportComplaints: $7e14ce7788f2e0f5$export$6c03dc9270f53f4a, reportResetReportComplaints: $7e14ce7788f2e0f5$export$a30022f2b3e383f3, reportSetReportComplaint: $7e14ce7788f2e0f5$export$2ed5726b4c4ec1f6, reportResetReportComplaint: $7e14ce7788f2e0f5$export$d9d9f1dbb6bc6f52, reportSetReportsFilter: $7e14ce7788f2e0f5$export$9113d04ca40739a9, reportOpenReportCommentModal: $7e14ce7788f2e0f5$export$5107dc6e51fafca5, reportCloseReportCommentModal: $7e14ce7788f2e0f5$export$d0bacaa8e5dd7178, reportOpenReportPostModal: $7e14ce7788f2e0f5$export$917709ba97acadd3, reportCloseReportPostModal: $7e14ce7788f2e0f5$export$91590c31a4ff5cac, reportOpenReportTrackModal: $7e14ce7788f2e0f5$export$d78f822310fc4e7a, reportCloseReportTrackModal: $7e14ce7788f2e0f5$export$160906f62c8a66e4, reportOpenReportUserModal: $7e14ce7788f2e0f5$export$5d901314f70977e1, reportCloseReportUserModal: $7e14ce7788f2e0f5$export$ee2aec68f4e7e51a, reportOpenReportResolveModal: $7e14ce7788f2e0f5$export$bf2597e67ee8aec9, reportCloseReportResolveModal: $7e14ce7788f2e0f5$export$5e2f470b9ce9dacf } = $7e14ce7788f2e0f5$export$5e255acad067a54e.actions;
const $7e14ce7788f2e0f5$export$d515dbd532d432c2 = (state)=>state.report.reportCommentModal.open;
const $7e14ce7788f2e0f5$export$720ee0b8715fd1c5 = (state)=>state.report.reportCommentModal.comment;
const $7e14ce7788f2e0f5$export$4a0f866336d17858 = (state)=>state.report.reportPostModal.open;
const $7e14ce7788f2e0f5$export$90d708d3369e452a = (state)=>state.report.reportPostModal.post;
const $7e14ce7788f2e0f5$export$2f88bbf212f26e07 = (state)=>state.report.reportTrackModal.open;
const $7e14ce7788f2e0f5$export$52db069a822e66b9 = (state)=>state.report.reportTrackModal.track;
const $7e14ce7788f2e0f5$export$75185cb7f4ea21d8 = (state)=>state.report.reportUserModal.open;
const $7e14ce7788f2e0f5$export$3170ddea3395ccb5 = (state)=>state.report.reportUserModal.user;
const $7e14ce7788f2e0f5$export$b7a168a21193a4bf = (state)=>state.report.reportResolveModal.open;
const $7e14ce7788f2e0f5$export$91163bf7aadb8d46 = (state)=>state.report.reportResolveModal.report;
const $7e14ce7788f2e0f5$export$4a09dd8fa937d22 = (state)=>state.report.reports;
const $7e14ce7788f2e0f5$export$12cce4392c74ecfe = (state)=>state.report.reports.length;
const $7e14ce7788f2e0f5$export$51bd18952516b6aa = (state)=>state.report.reportsCount;
const $7e14ce7788f2e0f5$export$290a4fe7e6503272 = (state)=>state.report.reportsFetched;
const $7e14ce7788f2e0f5$export$8831e1786fc175d8 = (state)=>state.report.report;
const $7e14ce7788f2e0f5$export$94ee103c3bfdff80 = (state)=>state.report.reportFetched;
const $7e14ce7788f2e0f5$export$6d231fdd5ff17f03 = (state)=>state.report.reportEntityBlocked;
const $7e14ce7788f2e0f5$export$e05eb5c987aca6d6 = (state)=>state.report.reportUserBlocked;
const $7e14ce7788f2e0f5$export$52b27bfc3626b1ff = (state)=>state.report.reportComplaints;
const $7e14ce7788f2e0f5$export$3436f3ec4ac50328 = (state)=>state.report.reportComplaints.length;
const $7e14ce7788f2e0f5$export$544fbed6aad5dbf3 = (state)=>state.report.reportComplaintsCount;
const $7e14ce7788f2e0f5$export$3625a3ea92060238 = (state)=>state.report.reportComplaintsFetched;
const $7e14ce7788f2e0f5$export$2ccc54e674651766 = (state)=>state.report.reportComplaint;
const $7e14ce7788f2e0f5$export$5dde5b9b2a0f562c = (state)=>state.report.reportComplaintFetched;
const $7e14ce7788f2e0f5$export$6259cc22ee5b3e43 = (state)=>state.report.reportsFilter;
const $7e14ce7788f2e0f5$export$75d753259f095069 = (state)=>state.report.reportCreateCommentReportComplaintLoading;
const $7e14ce7788f2e0f5$export$7a8ed540cd7a9abd = (state)=>state.report.reportCreatePostReportComplaintLoading;
const $7e14ce7788f2e0f5$export$5eaf42f513e024a4 = (state)=>state.report.reportCreateTrackReportComplaintLoading;
const $7e14ce7788f2e0f5$export$77b66bf40e9ad71c = (state)=>state.report.reportCreateUserReportComplaintLoading;
const $7e14ce7788f2e0f5$export$7e162aba720a43cd = (state)=>state.report.reportResolveReportLoading;
const $7e14ce7788f2e0f5$export$a5aafbce27ddaa73 = (state)=>state.report.reportGetReportsLoading;
const $7e14ce7788f2e0f5$export$4144046713ce64ec = (state)=>state.report.reportGetReportLoading;
const $7e14ce7788f2e0f5$export$1908d68a71fd2c32 = (state)=>state.report.reportGetReportComplaintsLoading;
const $7e14ce7788f2e0f5$export$86fecb91d5a0764f = (state)=>state.report.reportGetReportComplaintLoading;
const $7e14ce7788f2e0f5$export$e6ea844ef27f6d3a = $7e14ce7788f2e0f5$export$5e255acad067a54e.reducer; // export default reportSlice.reducer

});

parcelRegister("9CsFP", function(module, exports) {

$parcel$export(module.exports, "reportCreateCommentReportComplaint", function () { return $2f270826c16cc4bd$export$d7cbe26bb3456d9c; });
$parcel$export(module.exports, "reportCreatePostReportComplaint", function () { return $2f270826c16cc4bd$export$a71a2ca9a47c6b47; });
$parcel$export(module.exports, "reportCreateTrackReportComplaint", function () { return $2f270826c16cc4bd$export$438c0b3823841eb3; });
$parcel$export(module.exports, "reportCreateUserReportComplaint", function () { return $2f270826c16cc4bd$export$e273bc5cd9838a29; });
$parcel$export(module.exports, "reportResolveReport", function () { return $2f270826c16cc4bd$export$c95dddc860e71bdd; });
$parcel$export(module.exports, "reportGetReports", function () { return $2f270826c16cc4bd$export$ba21c16ccea890ca; });
$parcel$export(module.exports, "reportGetReport", function () { return $2f270826c16cc4bd$export$3eef964a162427f2; });
$parcel$export(module.exports, "reportGetReportComplaints", function () { return $2f270826c16cc4bd$export$bbe2251e57213a83; });
$parcel$export(module.exports, "reportGetReportComplaint", function () { return $2f270826c16cc4bd$export$6c28b1e798254737; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $6CAIO = parcelRequire("6CAIO");
/**
 * Perform type conversion of complaint type.
 *
 * Takes complaint type as a string and converts it to valid EntityReportComplaintType.
 *
 * @param {string} type - Complaint type.
 * @returns {EntityReportComplaintType} - Complaint type as valid EntityReportComplaintType.
 *
 * @example
 * // complaintType is EntityReportComplaintType.Copyright.
 * const complaintType = convertComplaintType('');
 * // complaintType is EntityReportComplaintType.Spam.
 * const complaintType = convertComplaintType('spam');
 */ const $2f270826c16cc4bd$var$convertComplaintType = (type)=>{
    // convert complaint type
    let complaintType;
    switch(type){
        case (0, $aeAwZ.EntityReportComplaintType).ChildAbuse.toString():
            complaintType = (0, $aeAwZ.EntityReportComplaintType).ChildAbuse;
            break;
        case (0, $aeAwZ.EntityReportComplaintType).Copyright.toString():
            complaintType = (0, $aeAwZ.EntityReportComplaintType).Copyright;
            break;
        case (0, $aeAwZ.EntityReportComplaintType).Fake.toString():
            complaintType = (0, $aeAwZ.EntityReportComplaintType).Fake;
            break;
        case (0, $aeAwZ.EntityReportComplaintType).Pornography.toString():
            complaintType = (0, $aeAwZ.EntityReportComplaintType).Pornography;
            break;
        case (0, $aeAwZ.EntityReportComplaintType).Spam.toString():
            complaintType = (0, $aeAwZ.EntityReportComplaintType).Spam;
            break;
        case (0, $aeAwZ.EntityReportComplaintType).Violence.toString():
            complaintType = (0, $aeAwZ.EntityReportComplaintType).Violence;
            break;
        default:
            complaintType = (0, $aeAwZ.EntityReportComplaintType).Copyright;
    }
    return complaintType;
};
const $2f270826c16cc4bd$export$d7cbe26bb3456d9c = (0, $dEr3t.createAsyncThunk)("report/reportCreateCommentReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get comment from modal state
    const modalComment = getState().report.reportCommentModal.comment;
    const { id: commentId, userId: userId } = modalComment ?? {};
    // convert complaint type
    const complaintType = $2f270826c16cc4bd$var$convertComplaintType(inp.complaintType);
    try {
        // create comment report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $aeAwZ.EntityReportEntityType).Comment,
            entityId: commentId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report comment modal
        dispatch((0, $6CAIO.reportCloseReportCommentModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$a71a2ca9a47c6b47 = (0, $dEr3t.createAsyncThunk)("report/reportCreatePostReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get post from modal state
    const modalPost = getState().report.reportPostModal.post;
    const { id: postId, userId: userId } = modalPost ?? {};
    // convert complaint type
    const complaintType = $2f270826c16cc4bd$var$convertComplaintType(inp.complaintType);
    try {
        // create post report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $aeAwZ.EntityReportEntityType).Post,
            entityId: postId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report post modal
        dispatch((0, $6CAIO.reportCloseReportPostModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$438c0b3823841eb3 = (0, $dEr3t.createAsyncThunk)("report/reportCreateTrackReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get track from modal state
    const modalTrack = getState().report.reportTrackModal.track;
    const { id: trackId, userId: userId } = modalTrack ?? {};
    // convert complaint type
    const complaintType = $2f270826c16cc4bd$var$convertComplaintType(inp.complaintType);
    try {
        // create track report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $aeAwZ.EntityReportEntityType).Track,
            entityId: trackId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report track modal
        dispatch((0, $6CAIO.reportCloseReportTrackModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$e273bc5cd9838a29 = (0, $dEr3t.createAsyncThunk)("report/reportCreateUserReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get user from modal state
    const modalUser = getState().report.reportUserModal.user;
    const { id: userId } = modalUser ?? {};
    // convert complaint type
    const complaintType = $2f270826c16cc4bd$var$convertComplaintType(inp.complaintType);
    try {
        // create user report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $aeAwZ.EntityReportEntityType).User,
            entityId: userId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report user modal
        dispatch((0, $6CAIO.reportCloseReportUserModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$c95dddc860e71bdd = (0, $dEr3t.createAsyncThunk)("report/reportResolveReport", async ({ reportId: reportId, cb: cb }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // resolve report
        await api.reportApi.resolveReport({
            reportId: reportId
        });
        // close report resolve modal
        dispatch((0, $6CAIO.reportCloseReportResolveModal)());
        // filter resolved report
        dispatch((0, $6CAIO.reportFilterReport)({
            id: reportId
        }));
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully resolved report!"
            }
        }));
        // if callback provided
        if (cb) cb();
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to resolve report: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$ba21c16ccea890ca = (0, $dEr3t.createAsyncThunk)("report/reportGetReports", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get reports filter
    const filter = getState().report.reportsFilter;
    // define entity type
    let entityType;
    // assert entity type
    switch(filter){
        case (0, $aeAwZ.EntityReportEntityType).Comment:
            entityType = "comment";
            break;
        case (0, $aeAwZ.EntityReportEntityType).Post:
            entityType = "post";
            break;
        case (0, $aeAwZ.EntityReportEntityType).Track:
            entityType = "track";
            break;
        case (0, $aeAwZ.EntityReportEntityType).User:
            entityType = "user";
            break;
        default:
            entityType = undefined;
    }
    try {
        // retrieve reports
        const { reports: reports, count: count } = await api.reportApi.getReports(entityType, inp.limit, inp.offset, inp.search);
        // set reports
        dispatch((0, $6CAIO.reportSetReports)({
            reports: reports || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$3eef964a162427f2 = (0, $dEr3t.createAsyncThunk)("report/reportGetReport", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve report
        const { report: report } = await api.reportApi.getReport(inp.reportId);
        // set report
        dispatch((0, $6CAIO.reportSetReport)({
            report: report || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$bbe2251e57213a83 = (0, $dEr3t.createAsyncThunk)("report/reportGetReportComplaints", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve reports
        const { reportComplaints: reportComplaints, count: count } = await api.reportApi.getReportComplaints(inp.reportId, inp.limit, inp.offset, inp.search);
        // set reports
        dispatch((0, $6CAIO.reportSetReportComplaints)({
            reportComplaints: reportComplaints || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f270826c16cc4bd$export$6c28b1e798254737 = (0, $dEr3t.createAsyncThunk)("report/reportGetReportComplaint", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve report
        const { reportComplaint: reportComplaint } = await api.reportApi.getReportComplaint(inp.reportComplaintId);
        // set report
        dispatch((0, $6CAIO.reportSetReportComplaint)({
            reportComplaint: reportComplaint || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("7TpYV", function(module, exports) {

var $7gLya = parcelRequire("7gLya");
$parcel$exportWildcard(module.exports, $7gLya);

});
parcelRegister("7gLya", function(module, exports) {

$parcel$export(module.exports, "searchSlice", function () { return $b91b588956f0226b$export$6bc4144c8fcccf9; });
$parcel$export(module.exports, "searchSetTerm", function () { return $b91b588956f0226b$export$e05a1876652a1058; });
$parcel$export(module.exports, "searchResetState", function () { return $b91b588956f0226b$export$f07edb5646340b7; });
$parcel$export(module.exports, "searchSelectTerm", function () { return $b91b588956f0226b$export$4b988c5dcde9bbbe; });
$parcel$export(module.exports, "searchReducer", function () { return $b91b588956f0226b$export$2b7921d28693b007; });

var $dEr3t = parcelRequire("dEr3t");
const $b91b588956f0226b$var$initialState = {
    term: ""
};
const $b91b588956f0226b$export$6bc4144c8fcccf9 = (0, $dEr3t.createSlice)({
    name: "search",
    initialState: $b91b588956f0226b$var$initialState,
    reducers: {
        searchSetTerm: (state, action)=>({
                ...state,
                term: action.payload
            }),
        searchResetState: (state)=>({
                ...state,
                term: ""
            })
    }
});
const { searchSetTerm: $b91b588956f0226b$export$e05a1876652a1058, searchResetState: $b91b588956f0226b$export$f07edb5646340b7 } = $b91b588956f0226b$export$6bc4144c8fcccf9.actions;
const $b91b588956f0226b$export$4b988c5dcde9bbbe = (state)=>state.search.term;
const $b91b588956f0226b$export$2b7921d28693b007 = $b91b588956f0226b$export$6bc4144c8fcccf9.reducer; // export default searchSlice.reducer

});


parcelRegister("c3UUM", function(module, exports) {
// export {} from './components'

var $k6Dml = parcelRequire("k6Dml");

var $hn1ob = parcelRequire("hn1ob");
$parcel$exportWildcard(module.exports, $k6Dml);
$parcel$exportWildcard(module.exports, $hn1ob);

});
parcelRegister("k6Dml", function(module, exports) {

$parcel$export(module.exports, "streamSlice", function () { return $a7c2f49959206e9b$export$a2c41b2c787127e9; });
$parcel$export(module.exports, "streamResetState", function () { return $a7c2f49959206e9b$export$f0ef31d06d0835e7; });
$parcel$export(module.exports, "streamSelectStreamCreatePostStreamLoading", function () { return $a7c2f49959206e9b$export$ac9d46d1ec0de990; });
$parcel$export(module.exports, "streamSelectStreamCreateTrackStreamLoading", function () { return $a7c2f49959206e9b$export$6fa328fda71219db; });
$parcel$export(module.exports, "streamReducer", function () { return $a7c2f49959206e9b$export$17d4a5761ee36301; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $hn1ob = parcelRequire("hn1ob");
const $a7c2f49959206e9b$var$initialState = {
    streamCreatePostStreamLoading: false,
    streamCreateTrackStreamLoading: false
};
const $a7c2f49959206e9b$export$a2c41b2c787127e9 = (0, $dEr3t.createSlice)({
    name: "stream",
    initialState: $a7c2f49959206e9b$var$initialState,
    reducers: {
        // reset state
        streamResetState: ()=>({
                streamCreatePostStreamLoading: false,
                streamCreateTrackStreamLoading: false
            })
    },
    extraReducers: (builder)=>{
        // create post stream
        builder.addCase((0, $hn1ob.streamCreatePostStream).pending, (state)=>({
                ...state,
                streamCreatePostStreamLoading: true
            })).addCase((0, $hn1ob.streamCreatePostStream).fulfilled, (state)=>({
                ...state,
                streamCreatePostStreamLoading: false
            }));
        // create track stream
        builder.addCase((0, $hn1ob.streamCreateTrackStream).pending, (state)=>({
                ...state,
                streamCreateTrackStreamLoading: true
            })).addCase((0, $hn1ob.streamCreateTrackStream).fulfilled, (state)=>({
                ...state,
                streamCreateTrackStreamLoading: false
            }));
    }
});
const { streamResetState: $a7c2f49959206e9b$export$f0ef31d06d0835e7 } = $a7c2f49959206e9b$export$a2c41b2c787127e9.actions;
const $a7c2f49959206e9b$export$ac9d46d1ec0de990 = (state)=>state.stream.streamCreatePostStreamLoading;
const $a7c2f49959206e9b$export$6fa328fda71219db = (state)=>state.stream.streamCreateTrackStreamLoading;
const $a7c2f49959206e9b$export$17d4a5761ee36301 = $a7c2f49959206e9b$export$a2c41b2c787127e9.reducer; // export default streamSlice.reducer

});

parcelRegister("hn1ob", function(module, exports) {

$parcel$export(module.exports, "streamCreatePostStream", function () { return $5b98b4f4f57ba386$export$c874df20ecacc37a; });
$parcel$export(module.exports, "streamCreateTrackStream", function () { return $5b98b4f4f57ba386$export$1fe7e6225fc134d2; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
const $5b98b4f4f57ba386$export$c874df20ecacc37a = (0, $dEr3t.createAsyncThunk)("stream/streamCreatePostStream", async ({ post: post })=>{
    const { id: postId } = post;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create post stream
        await api.streamApi.createPostStream({
            postId: postId || ""
        });
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $5b98b4f4f57ba386$export$1fe7e6225fc134d2 = (0, $dEr3t.createAsyncThunk)("stream/streamCreateTrackStream", async ({ track: track })=>{
    const { id: trackId } = track;
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create track stream
        await api.streamApi.createTrackStream({
            trackId: trackId || ""
        });
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("6OD7j", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelModal", function () { return (parcelRequire("2n9th")).SubscriptionCancelModal; });
$parcel$export(module.exports, "SubscriptionCreateModal", function () { return (parcelRequire("7rXpn")).SubscriptionCreateModal; });
$parcel$export(module.exports, "SubscriptionRenewModal", function () { return (parcelRequire("10q5u")).SubscriptionRenewModal; });
parcelRequire("dJ3Hu");
var $2n9th = parcelRequire("2n9th");
var $7rXpn = parcelRequire("7rXpn");
var $10q5u = parcelRequire("10q5u");

var $gfND9 = parcelRequire("gfND9");

var $MokZU = parcelRequire("MokZU");
$parcel$exportWildcard(module.exports, $gfND9);
$parcel$exportWildcard(module.exports, $MokZU);

});
parcelRegister("dJ3Hu", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelModal", function () { return (parcelRequire("2n9th")).SubscriptionCancelModal; });
$parcel$export(module.exports, "SubscriptionCreateModal", function () { return (parcelRequire("7rXpn")).SubscriptionCreateModal; });
$parcel$export(module.exports, "SubscriptionRenewModal", function () { return (parcelRequire("10q5u")).SubscriptionRenewModal; });

var $2n9th = parcelRequire("2n9th");

var $7rXpn = parcelRequire("7rXpn");

var $10q5u = parcelRequire("10q5u");

});
parcelRegister("2n9th", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelModal", function () { return $71dcf8af5d310a8e$export$5a67fdbe08953bb5; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("i9mFt");
var $4uLU6 = parcelRequire("4uLU6");

var $50l79 = parcelRequire("50l79");
const $71dcf8af5d310a8e$export$5a67fdbe08953bb5 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const subscriptionCancelModalOpen = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCancelModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $50l79.styles)().modal.main,
        children: subscriptionCancelModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $gfND9.subscriptionCloseSubscriptionCancelModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $50l79.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4uLU6.SubscriptionCancelCard), {})
            })
        })
    });
};
$71dcf8af5d310a8e$export$5a67fdbe08953bb5.propTypes = {};

});
parcelRegister("i9mFt", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelCard", function () { return (parcelRequire("4uLU6")).SubscriptionCancelCard; });

var $4uLU6 = parcelRequire("4uLU6");

});
parcelRegister("4uLU6", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelCard", function () { return $262a764bfbf76fb9$export$4ceaf13b857fed04; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("7TY18");
var $lHSoi = parcelRequire("lHSoi");

var $8GAei = parcelRequire("8GAei");
const $262a764bfbf76fb9$export$4ceaf13b857fed04 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCancelModalArtist));
    const subscriptionError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 160;
    const subtitleAccentEndIndex = 161 + (username?.length || 0);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $8GAei.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8GAei.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $gfND9.subscriptionCloseSubscriptionCancelModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8GAei.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Unsubscribe",
                    icon: (0, $9IIBp.icons).Lock
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $8GAei.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: `Your subscription isn't just access, it's an investment in a world of exclusive content curated just for you. Are you sure you want to cancel subscription to - @${username}?`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $8GAei.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $8GAei.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lHSoi.SubscriptionCancelForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $8GAei.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: subscriptionError
                        })
                    })
                ]
            })
        ]
    });
};
$262a764bfbf76fb9$export$4ceaf13b857fed04.propTypes = {};

});
parcelRegister("7TY18", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelForm", function () { return (parcelRequire("lHSoi")).SubscriptionCancelForm; });

var $lHSoi = parcelRequire("lHSoi");

});
parcelRegister("lHSoi", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelForm", function () { return $2c41e07da27739b0$export$cb7aa5e79cb4b785; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $5BPlh = parcelRequire("5BPlh");
var $fAzHC = parcelRequire("fAzHC");
var $MokZU = parcelRequire("MokZU");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $lzc1K = parcelRequire("lzc1K");
const $2c41e07da27739b0$export$cb7aa5e79cb4b785 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const subscriptionCancelLoading = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCancelSubscriptionLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCancelModalArtist));
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUser = profileUserId === artistUserId;
    const submitDisabled = isCurrentUser || subscriptionCancelLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $lzc1K.styles)(theme).form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $lzc1K.styles)(theme).form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $MokZU.subscriptionCancelSubscription)());
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $lzc1K.styles)(theme).form.content.product,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5BPlh.ArtistCardProduct), {
                        artist: modalArtist || {},
                        onNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`),
                        onUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`)
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $lzc1K.styles)(theme).form.content.description.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $lzc1K.styles)(theme).form.content.description.text,
                        children: "If you cancel your subscription, you will still have access to the content until the end of the current subscription period."
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $lzc1K.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "unsubscribe",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: subscriptionCancelLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Unsubscribe`
                    })
                })
            ]
        })
    });
};
$2c41e07da27739b0$export$cb7aa5e79cb4b785.propTypes = {};

});
parcelRegister("lzc1K", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d31ed786fec6b31a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d31ed786fec6b31a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d31ed786fec6b31a$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $d31ed786fec6b31a$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                product: $d31ed786fec6b31a$var$_ref,
                description: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";margin-bottom:24px;", ""),
                    text: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    accent: /*#__PURE__*/ (0, $4N3Qt.css)("font-weight:bold;color:", theme.colors.accent.normal, ";", "")
                },
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("8GAei", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $485cc309ec650e76$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $485cc309ec650e76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $485cc309ec650e76$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $485cc309ec650e76$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $485cc309ec650e76$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $485cc309ec650e76$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $485cc309ec650e76$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $485cc309ec650e76$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $485cc309ec650e76$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $485cc309ec650e76$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $485cc309ec650e76$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($485cc309ec650e76$var$_ref8), " ", (0, $48E0n.mq).mobile($485cc309ec650e76$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($485cc309ec650e76$var$_ref6), ";", ""),
            title: $485cc309ec650e76$var$_ref5,
            subtitle: $485cc309ec650e76$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($485cc309ec650e76$var$_ref3), ";", ""),
                form: $485cc309ec650e76$var$_ref2,
                error: $485cc309ec650e76$var$_ref
            }
        }
    });

});



parcelRegister("50l79", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $800d3207ecad20a6$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $800d3207ecad20a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $800d3207ecad20a6$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $800d3207ecad20a6$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($800d3207ecad20a6$var$_ref), ";", "")
        }
    });

});


parcelRegister("7rXpn", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateModal", function () { return $6287aa94bcd65382$export$c78fcad8bc8f9efc; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("1RFVr");
var $kVniv = parcelRequire("kVniv");

var $3ApHC = parcelRequire("3ApHC");
const $6287aa94bcd65382$export$c78fcad8bc8f9efc = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const subscriptionCreateModalOpen = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCreateModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $3ApHC.styles)().modal.main,
        children: subscriptionCreateModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $gfND9.subscriptionCloseSubscriptionCreateModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $3ApHC.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $kVniv.SubscriptionCreateCard), {})
            })
        })
    });
};
$6287aa94bcd65382$export$c78fcad8bc8f9efc.propTypes = {};

});
parcelRegister("1RFVr", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateCard", function () { return (parcelRequire("kVniv")).SubscriptionCreateCard; });

var $kVniv = parcelRequire("kVniv");

});
parcelRegister("kVniv", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateCard", function () { return $b582b9b7642b69ae$export$71949997866b8f3d; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("d8l0a");
var $aXrLk = parcelRequire("aXrLk");

var $izDbp = parcelRequire("izDbp");
const $b582b9b7642b69ae$export$71949997866b8f3d = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCreateModalArtist));
    const subscriptionError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 54;
    const subtitleAccentEndIndex = 55 + (username?.length || 0);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $izDbp.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $izDbp.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $gfND9.subscriptionCloseSubscriptionCreateModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $izDbp.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Subscribe",
                    icon: (0, $9IIBp.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $izDbp.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: `Unlock a world of exclusive content by subscribing to @${username}!`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $izDbp.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $izDbp.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $aXrLk.SubscriptionCreateForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $izDbp.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: subscriptionError
                        })
                    })
                ]
            })
        ]
    });
};
$b582b9b7642b69ae$export$71949997866b8f3d.propTypes = {};

});
parcelRegister("d8l0a", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateForm", function () { return (parcelRequire("aXrLk")).SubscriptionCreateForm; });

var $aXrLk = parcelRequire("aXrLk");

});
parcelRegister("aXrLk", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateForm", function () { return $893fc775bcab2207$export$9ac0eaa010320de1; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $aC0Kg = parcelRequire("aC0Kg");
parcelRequire("dmGpj");
var $5BPlh = parcelRequire("5BPlh");
var $fAzHC = parcelRequire("fAzHC");
var $MokZU = parcelRequire("MokZU");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $b3AGQ = parcelRequire("b3AGQ");
const $893fc775bcab2207$export$9ac0eaa010320de1 = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const subscriptionCreateLoading = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCreateSubscriptionLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionCreateModalArtist));
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUser = profileUserId === artistUserId;
    const submitDisabled = isCurrentUser || subscriptionCreateLoading;
    // subscription price
    const { subscriptionPrice: artistSubscriptionPrice, isLoading: isArtistSubscriptionPriceLoading } = (0, $aC0Kg.useSubscriptionPrice)(artistUserId || "");
    const artistSubscriptionPriceLoadingPlaceholder = "Loading...";
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $b3AGQ.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $b3AGQ.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $MokZU.subscriptionCreateSubscription)());
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $b3AGQ.styles)().form.content.product,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5BPlh.ArtistCardProduct), {
                        artist: modalArtist || {},
                        onNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`),
                        onUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`)
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $b3AGQ.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "subscribe",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: subscriptionCreateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Subscribe for $${isArtistSubscriptionPriceLoading ? artistSubscriptionPriceLoadingPlaceholder : artistSubscriptionPrice && artistSubscriptionPrice / 100}`
                    })
                })
            ]
        })
    });
};
$893fc775bcab2207$export$9ac0eaa010320de1.propTypes = {};

});
parcelRegister("b3AGQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6430fa02d45e9f1e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $6430fa02d45e9f1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6430fa02d45e9f1e$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $6430fa02d45e9f1e$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                product: $6430fa02d45e9f1e$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("izDbp", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c18596024ed31f99$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c18596024ed31f99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c18596024ed31f99$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $c18596024ed31f99$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $c18596024ed31f99$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $c18596024ed31f99$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c18596024ed31f99$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c18596024ed31f99$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $c18596024ed31f99$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $c18596024ed31f99$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $c18596024ed31f99$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($c18596024ed31f99$var$_ref8), " ", (0, $48E0n.mq).mobile($c18596024ed31f99$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($c18596024ed31f99$var$_ref6), ";", ""),
            title: $c18596024ed31f99$var$_ref5,
            subtitle: $c18596024ed31f99$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($c18596024ed31f99$var$_ref3), ";", ""),
                form: $c18596024ed31f99$var$_ref2,
                error: $c18596024ed31f99$var$_ref
            }
        }
    });

});



parcelRegister("3ApHC", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $67537540aeeb136c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $67537540aeeb136c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $67537540aeeb136c$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $67537540aeeb136c$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($67537540aeeb136c$var$_ref), ";", "")
        }
    });

});


parcelRegister("10q5u", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewModal", function () { return $a19e5b25be6f0775$export$8a555acc32002531; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("a7ugN");
var $gg9da = parcelRequire("gg9da");

var $bA4LO = parcelRequire("bA4LO");
const $a19e5b25be6f0775$export$8a555acc32002531 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const subscriptionRenewModalOpen = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionRenewModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $bA4LO.styles)().modal.main,
        children: subscriptionRenewModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $gfND9.subscriptionCloseSubscriptionRenewModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bA4LO.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $gg9da.SubscriptionRenewCard), {})
            })
        })
    });
};
$a19e5b25be6f0775$export$8a555acc32002531.propTypes = {};

});
parcelRegister("a7ugN", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewCard", function () { return (parcelRequire("gg9da")).SubscriptionRenewCard; });

var $gg9da = parcelRequire("gg9da");

});
parcelRegister("gg9da", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewCard", function () { return $3c629635da24bb72$export$aa8da0a6b807e932; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("3Dzvb");
var $7vvoQ = parcelRequire("7vvoQ");

var $gD0G9 = parcelRequire("gD0G9");
const $3c629635da24bb72$export$aa8da0a6b807e932 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionRenewModalArtist));
    const subscriptionError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 54;
    const subtitleAccentEndIndex = 55 + (username?.length || 0);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $gD0G9.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $gD0G9.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $gfND9.subscriptionCloseSubscriptionRenewModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $gD0G9.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Subscribe",
                    icon: (0, $9IIBp.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $gD0G9.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: `Unlock a world of exclusive content by subscribing to @${username}!`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $gD0G9.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gD0G9.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7vvoQ.SubscriptionRenewForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gD0G9.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: subscriptionError
                        })
                    })
                ]
            })
        ]
    });
};
$3c629635da24bb72$export$aa8da0a6b807e932.propTypes = {};

});
parcelRegister("3Dzvb", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewForm", function () { return (parcelRequire("7vvoQ")).SubscriptionRenewForm; });

var $7vvoQ = parcelRequire("7vvoQ");

});
parcelRegister("7vvoQ", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewForm", function () { return $afc194c10a9777f7$export$dc7bf3d983f09351; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $aC0Kg = parcelRequire("aC0Kg");
parcelRequire("dmGpj");
var $5BPlh = parcelRequire("5BPlh");
var $fAzHC = parcelRequire("fAzHC");
var $MokZU = parcelRequire("MokZU");
var $gfND9 = parcelRequire("gfND9");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $riH4L = parcelRequire("riH4L");
const $afc194c10a9777f7$export$dc7bf3d983f09351 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const subscriptionRenewLoading = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionRenewSubscriptionLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectSubscriptionRenewModalArtist));
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUser = profileUserId === artistUserId;
    const submitDisabled = isCurrentUser || subscriptionRenewLoading;
    // subscription price
    const { subscriptionPrice: artistSubscriptionPrice, isLoading: isArtistSubscriptionPriceLoading } = (0, $aC0Kg.useSubscriptionPrice)(artistUserId || "");
    const artistSubscriptionPriceLoadingPlaceholder = "Loading...";
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $riH4L.styles)(theme).form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $riH4L.styles)(theme).form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $MokZU.subscriptionRenewSubscription)());
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $riH4L.styles)(theme).form.content.product,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5BPlh.ArtistCardProduct), {
                        artist: modalArtist || {},
                        onNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`),
                        onUsernameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`)
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $riH4L.styles)(theme).form.content.description.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $riH4L.styles)(theme).form.content.description.text,
                        children: "When you renew your subscription, you will be charged at the end of the current subscription period."
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $riH4L.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "subscribe",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: subscriptionRenewLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Renew subscription for $${isArtistSubscriptionPriceLoading ? artistSubscriptionPriceLoadingPlaceholder : artistSubscriptionPrice && artistSubscriptionPrice / 100}`
                    })
                })
            ]
        })
    });
};
$afc194c10a9777f7$export$dc7bf3d983f09351.propTypes = {};

});
parcelRegister("riH4L", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e65bd88f47ebbcbd$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $e65bd88f47ebbcbd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e65bd88f47ebbcbd$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $e65bd88f47ebbcbd$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                product: $e65bd88f47ebbcbd$var$_ref,
                description: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";margin-bottom:24px;", ""),
                    text: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    accent: /*#__PURE__*/ (0, $4N3Qt.css)("font-weight:bold;color:", theme.colors.accent.normal, ";", "")
                },
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("gD0G9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8cea2a5cfc31bcab$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8cea2a5cfc31bcab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8cea2a5cfc31bcab$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $8cea2a5cfc31bcab$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $8cea2a5cfc31bcab$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $8cea2a5cfc31bcab$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8cea2a5cfc31bcab$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8cea2a5cfc31bcab$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $8cea2a5cfc31bcab$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $8cea2a5cfc31bcab$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $8cea2a5cfc31bcab$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($8cea2a5cfc31bcab$var$_ref8), " ", (0, $48E0n.mq).mobile($8cea2a5cfc31bcab$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($8cea2a5cfc31bcab$var$_ref6), ";", ""),
            title: $8cea2a5cfc31bcab$var$_ref5,
            subtitle: $8cea2a5cfc31bcab$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($8cea2a5cfc31bcab$var$_ref3), ";", ""),
                form: $8cea2a5cfc31bcab$var$_ref2,
                error: $8cea2a5cfc31bcab$var$_ref
            }
        }
    });

});



parcelRegister("bA4LO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $aaa85d07ff39b6de$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $aaa85d07ff39b6de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $aaa85d07ff39b6de$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $aaa85d07ff39b6de$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($aaa85d07ff39b6de$var$_ref), ";", "")
        }
    });

});



parcelRegister("gfND9", function(module, exports) {

$parcel$export(module.exports, "subscriptionSlice", function () { return $f769a091aa811a93$export$ace45a1139be3d5f; });
$parcel$export(module.exports, "subscriptionResetState", function () { return $f769a091aa811a93$export$c6562e8445940d44; });
$parcel$export(module.exports, "subscriptionSetUserSubscriptions", function () { return $f769a091aa811a93$export$be2dfb7f082907ba; });
$parcel$export(module.exports, "subscriptionAddUserSubscription", function () { return $f769a091aa811a93$export$1b658aed8e1f365d; });
$parcel$export(module.exports, "subscriptionRemoveUserSubscription", function () { return $f769a091aa811a93$export$746b64992b0ece49; });
$parcel$export(module.exports, "subscriptionSetUserSubscriptionsAtPeriodEnd", function () { return $f769a091aa811a93$export$896133c746b42699; });
$parcel$export(module.exports, "subscriptionAddUserSubscriptionAtPeriodEnd", function () { return $f769a091aa811a93$export$24dda4823d975610; });
$parcel$export(module.exports, "subscriptionRemoveUserSubscriptionAtPeriodEnd", function () { return $f769a091aa811a93$export$2a9e53329c48b691; });
$parcel$export(module.exports, "subscriptionOpenSubscriptionCreateModal", function () { return $f769a091aa811a93$export$b16abe21e1f36a60; });
$parcel$export(module.exports, "subscriptionCloseSubscriptionCreateModal", function () { return $f769a091aa811a93$export$e9854fd0d09c5426; });
$parcel$export(module.exports, "subscriptionOpenSubscriptionRenewModal", function () { return $f769a091aa811a93$export$85d65c2bf3e9683f; });
$parcel$export(module.exports, "subscriptionCloseSubscriptionRenewModal", function () { return $f769a091aa811a93$export$70ae45590bebb868; });
$parcel$export(module.exports, "subscriptionOpenSubscriptionCancelModal", function () { return $f769a091aa811a93$export$8fd060939331f66e; });
$parcel$export(module.exports, "subscriptionCloseSubscriptionCancelModal", function () { return $f769a091aa811a93$export$5bcaf9cef8723720; });
$parcel$export(module.exports, "subscriptionSelectUserSubscriptions", function () { return $f769a091aa811a93$export$bd426abebc2f2046; });
$parcel$export(module.exports, "subscriptionSelectUserSubscriptionsAtPeriodEnd", function () { return $f769a091aa811a93$export$f1f864a83a1bcd87; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCreateModalOpen", function () { return $f769a091aa811a93$export$6fbda4ca77fe2914; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCreateModalArtist", function () { return $f769a091aa811a93$export$cc31defa5ce72da6; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionRenewModalOpen", function () { return $f769a091aa811a93$export$c36a45d3024cdbd1; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionRenewModalArtist", function () { return $f769a091aa811a93$export$3264c37037a409a0; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCancelModalOpen", function () { return $f769a091aa811a93$export$9ee81645d1343ff7; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCancelModalArtist", function () { return $f769a091aa811a93$export$58482d974df41afc; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionGetSubscribedUserIdsLoading", function () { return $f769a091aa811a93$export$e7b9d8d895eeb3c6; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionGetSubscribedAtPeriodEndUserIdsLoading", function () { return $f769a091aa811a93$export$ac5c6334c19610fe; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCreateSubscriptionLoading", function () { return $f769a091aa811a93$export$fff48570d90e4132; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionRenewSubscriptionLoading", function () { return $f769a091aa811a93$export$c434295ced29f271; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCancelSubscriptionLoading", function () { return $f769a091aa811a93$export$5fdfa6e21aff750f; });
$parcel$export(module.exports, "subscriptionReducer", function () { return $f769a091aa811a93$export$c6124c6f9953c008; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $MokZU = parcelRequire("MokZU");
const $f769a091aa811a93$var$initialState = {
    userSubscriptions: {},
    userSubscriptionsAtPeriodEnd: {},
    subscriptionCreateModal: {
        artist: undefined,
        open: false
    },
    subscriptionRenewModal: {
        artist: undefined,
        open: false
    },
    subscriptionCancelModal: {
        artist: undefined,
        open: false
    },
    subscriptionGetSubscribedUserIdsLoading: false,
    subscriptionGetSubscribedAtPeriodEndUserIdsLoading: false,
    subscriptionCreateSubscriptionLoading: false,
    subscriptionRenewSubscriptionLoading: false,
    subscriptionCancelSubscriptionLoading: false
};
const $f769a091aa811a93$export$ace45a1139be3d5f = (0, $dEr3t.createSlice)({
    name: "subscription",
    initialState: $f769a091aa811a93$var$initialState,
    reducers: {
        // reset state
        subscriptionResetState: ()=>({
                userSubscriptions: {},
                userSubscriptionsAtPeriodEnd: {},
                subscriptionCreateModal: {
                    artist: undefined,
                    open: false
                },
                subscriptionRenewModal: {
                    artist: undefined,
                    open: false
                },
                subscriptionCancelModal: {
                    artist: undefined,
                    open: false
                },
                subscriptionGetSubscribedUserIdsLoading: false,
                subscriptionGetSubscribedAtPeriodEndUserIdsLoading: false,
                subscriptionCreateSubscriptionLoading: false,
                subscriptionRenewSubscriptionLoading: false,
                subscriptionCancelSubscriptionLoading: false
            }),
        // set user subscriptions
        subscriptionSetUserSubscriptions: (state, action)=>{
            const { subscribedUserIds: subscribedUserIds } = action.payload;
            // define user subscriptions map
            const userSubscriptions = {};
            // iterate over each subscribed user id
            subscribedUserIds.forEach((id)=>{
                // add id to the map
                userSubscriptions[id] = true;
            });
            // update state
            state.userSubscriptions = userSubscriptions;
        },
        // add user subscription
        subscriptionAddUserSubscription: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptions[userId] = true;
        },
        // remove user subscription
        subscriptionRemoveUserSubscription: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptions[userId] = false;
        },
        // set user subscriptions at period end
        subscriptionSetUserSubscriptionsAtPeriodEnd: (state, action)=>{
            const { subscribedAtPeriodEndUserIds: subscribedAtPeriodEndUserIds } = action.payload;
            // define user subscriptions at period end map
            const userSubscriptionsAtPeriodEnd = {};
            // iterate over each subscribed user id
            subscribedAtPeriodEndUserIds.forEach((id)=>{
                // add id to the map
                userSubscriptionsAtPeriodEnd[id] = true;
            });
            // update state
            state.userSubscriptionsAtPeriodEnd = userSubscriptionsAtPeriodEnd;
        },
        // add user subscription at period end
        subscriptionAddUserSubscriptionAtPeriodEnd: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptionsAtPeriodEnd[userId] = true;
        },
        // remove user subscription at period end
        subscriptionRemoveUserSubscriptionAtPeriodEnd: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptionsAtPeriodEnd[userId] = false;
        },
        // open subscription create modal
        subscriptionOpenSubscriptionCreateModal: (state, action)=>({
                ...state,
                subscriptionCreateModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close subscription create modal
        subscriptionCloseSubscriptionCreateModal: (state)=>({
                ...state,
                subscriptionCreateModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            }),
        // open subscription renew modal
        subscriptionOpenSubscriptionRenewModal: (state, action)=>({
                ...state,
                subscriptionRenewModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close subscription renew modal
        subscriptionCloseSubscriptionRenewModal: (state)=>({
                ...state,
                subscriptionRenewModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            }),
        // open subscription cancel modal
        subscriptionOpenSubscriptionCancelModal: (state, action)=>({
                ...state,
                subscriptionCancelModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close subscription cancel modal
        subscriptionCloseSubscriptionCancelModal: (state)=>({
                ...state,
                subscriptionCancelModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get subscribed user ids
        builder.addCase((0, $MokZU.subscriptionGetSubscribedUserIds).pending, (state)=>({
                ...state,
                subscriptionGetSubscribedUserIdsLoading: true
            })).addCase((0, $MokZU.subscriptionGetSubscribedUserIds).fulfilled, (state)=>({
                ...state,
                subscriptionGetSubscribedUserIdsLoading: false
            }));
        // get subscribed user ids at period end
        builder.addCase((0, $MokZU.subscriptionGetSubscribedAtPeriodEndUserIds).pending, (state)=>({
                ...state,
                subscriptionGetSubscribedAtPeriodEndUserIdsLoading: true
            })).addCase((0, $MokZU.subscriptionGetSubscribedAtPeriodEndUserIds).fulfilled, (state)=>({
                ...state,
                subscriptionGetSubscribedAtPeriodEndUserIdsLoading: false
            }));
        // create subscription
        builder.addCase((0, $MokZU.subscriptionCreateSubscription).pending, (state)=>({
                ...state,
                subscriptionCreateSubscriptionLoading: true
            })).addCase((0, $MokZU.subscriptionCreateSubscription).fulfilled, (state)=>({
                ...state,
                subscriptionCreateSubscriptionLoading: false
            }));
        // renew subscription
        builder.addCase((0, $MokZU.subscriptionRenewSubscription).pending, (state)=>({
                ...state,
                subscriptionRenewSubscriptionLoading: true
            })).addCase((0, $MokZU.subscriptionRenewSubscription).fulfilled, (state)=>({
                ...state,
                subscriptionRenewSubscriptionLoading: false
            }));
        // cancel subscription
        builder.addCase((0, $MokZU.subscriptionCancelSubscription).pending, (state)=>({
                ...state,
                subscriptionCancelSubscriptionLoading: true
            })).addCase((0, $MokZU.subscriptionCancelSubscription).fulfilled, (state)=>({
                ...state,
                subscriptionCancelSubscriptionLoading: false
            }));
    }
});
const { subscriptionResetState: $f769a091aa811a93$export$c6562e8445940d44, subscriptionSetUserSubscriptions: $f769a091aa811a93$export$be2dfb7f082907ba, subscriptionAddUserSubscription: $f769a091aa811a93$export$1b658aed8e1f365d, subscriptionRemoveUserSubscription: $f769a091aa811a93$export$746b64992b0ece49, subscriptionSetUserSubscriptionsAtPeriodEnd: $f769a091aa811a93$export$896133c746b42699, subscriptionAddUserSubscriptionAtPeriodEnd: $f769a091aa811a93$export$24dda4823d975610, subscriptionRemoveUserSubscriptionAtPeriodEnd: $f769a091aa811a93$export$2a9e53329c48b691, subscriptionOpenSubscriptionCreateModal: $f769a091aa811a93$export$b16abe21e1f36a60, subscriptionCloseSubscriptionCreateModal: $f769a091aa811a93$export$e9854fd0d09c5426, subscriptionOpenSubscriptionRenewModal: $f769a091aa811a93$export$85d65c2bf3e9683f, subscriptionCloseSubscriptionRenewModal: $f769a091aa811a93$export$70ae45590bebb868, subscriptionOpenSubscriptionCancelModal: $f769a091aa811a93$export$8fd060939331f66e, subscriptionCloseSubscriptionCancelModal: $f769a091aa811a93$export$5bcaf9cef8723720 } = $f769a091aa811a93$export$ace45a1139be3d5f.actions;
const $f769a091aa811a93$export$bd426abebc2f2046 = (state)=>state.subscription.userSubscriptions;
const $f769a091aa811a93$export$f1f864a83a1bcd87 = (state)=>state.subscription.userSubscriptionsAtPeriodEnd;
const $f769a091aa811a93$export$6fbda4ca77fe2914 = (state)=>state.subscription.subscriptionCreateModal.open;
const $f769a091aa811a93$export$cc31defa5ce72da6 = (state)=>state.subscription.subscriptionCreateModal.artist;
const $f769a091aa811a93$export$c36a45d3024cdbd1 = (state)=>state.subscription.subscriptionRenewModal.open;
const $f769a091aa811a93$export$3264c37037a409a0 = (state)=>state.subscription.subscriptionRenewModal.artist;
const $f769a091aa811a93$export$9ee81645d1343ff7 = (state)=>state.subscription.subscriptionCancelModal.open;
const $f769a091aa811a93$export$58482d974df41afc = (state)=>state.subscription.subscriptionCancelModal.artist;
const $f769a091aa811a93$export$e7b9d8d895eeb3c6 = (state)=>state.subscription.subscriptionGetSubscribedUserIdsLoading;
const $f769a091aa811a93$export$ac5c6334c19610fe = (state)=>state.subscription.subscriptionGetSubscribedAtPeriodEndUserIdsLoading;
const $f769a091aa811a93$export$fff48570d90e4132 = (state)=>state.subscription.subscriptionCreateSubscriptionLoading;
const $f769a091aa811a93$export$c434295ced29f271 = (state)=>state.subscription.subscriptionRenewSubscriptionLoading;
const $f769a091aa811a93$export$5fdfa6e21aff750f = (state)=>state.subscription.subscriptionCancelSubscriptionLoading;
const $f769a091aa811a93$export$c6124c6f9953c008 = $f769a091aa811a93$export$ace45a1139be3d5f.reducer; // export default subscriptionSlice.reducer

});

parcelRegister("MokZU", function(module, exports) {

$parcel$export(module.exports, "subscriptionGetSubscribedUserIds", function () { return $9adcc9617d6d1315$export$5b8f676c64b64b19; });
$parcel$export(module.exports, "subscriptionGetSubscribedAtPeriodEndUserIds", function () { return $9adcc9617d6d1315$export$d69174a1f37ccdff; });
$parcel$export(module.exports, "subscriptionCreateSubscription", function () { return $9adcc9617d6d1315$export$103165c97cc4ec39; });
$parcel$export(module.exports, "subscriptionRenewSubscription", function () { return $9adcc9617d6d1315$export$34ef3162695b788c; });
$parcel$export(module.exports, "subscriptionCancelSubscription", function () { return $9adcc9617d6d1315$export$979222d832fc413b; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $j6i5c = parcelRequire("j6i5c");
var $3Mk3a = parcelRequire("3Mk3a");
var $gfND9 = parcelRequire("gfND9");
const $9adcc9617d6d1315$export$5b8f676c64b64b19 = (0, $dEr3t.createAsyncThunk)("subscription/subscriptionGetSubscribedUserIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve subscribed user ids
        const { subscribedUserIds: subscribedUserIds } = await api.subscriptionApi.getSubscribedUserIds();
        // set user subscriptions
        dispatch((0, $gfND9.subscriptionSetUserSubscriptions)({
            subscribedUserIds: subscribedUserIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9adcc9617d6d1315$export$d69174a1f37ccdff = (0, $dEr3t.createAsyncThunk)("subscription/subscriptionGetSubscribedAtPeriodEndUserIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve subscribed at period end user ids
        const { subscribedAtPeriodEndUserIds: subscribedAtPeriodEndUserIds } = await api.subscriptionApi.getSubscribedAtPeriodEndUserIds();
        // set user subscriptions
        dispatch((0, $gfND9.subscriptionSetUserSubscriptionsAtPeriodEnd)({
            subscribedAtPeriodEndUserIds: subscribedAtPeriodEndUserIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9adcc9617d6d1315$export$103165c97cc4ec39 = (0, $dEr3t.createAsyncThunk)("subscription/subscriptionCreateSubscription", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().subscription.subscriptionCreateModal.artist;
    const { id: artistId } = modalArtist ?? {};
    try {
        // create subscription
        const { clientSecret: clientSecret } = await api.subscriptionApi.createSubscription({
            userId: artistId || ""
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close subscription create modal
        dispatch((0, $gfND9.subscriptionCloseSubscriptionCreateModal)());
        // open payment modal
        dispatch((0, $j6i5c.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $3Mk3a.PaymentOperationType).Subscription,
            operationSubject: modalArtist
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create subscription: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9adcc9617d6d1315$export$34ef3162695b788c = (0, $dEr3t.createAsyncThunk)("subscription/subscriptionRenewSubscription", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().subscription.subscriptionRenewModal.artist;
    const { id: artistId } = modalArtist ?? {};
    try {
        // renew subscription
        await api.subscriptionApi.renewSubscription({
            userId: artistId || ""
        });
        // remove user subscription at period end
        dispatch((0, $gfND9.subscriptionRemoveUserSubscriptionAtPeriodEnd)({
            userId: artistId || ""
        }));
        // close subscription renew modal
        dispatch((0, $gfND9.subscriptionCloseSubscriptionRenewModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully renewed subscription!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to renew subscription: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $9adcc9617d6d1315$export$979222d832fc413b = (0, $dEr3t.createAsyncThunk)("subscription/subscriptionCancelSubscription", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().subscription.subscriptionCancelModal.artist;
    const { id: artistId } = modalArtist ?? {};
    try {
        // cancel subscription
        await api.subscriptionApi.cancelSubscription({
            userId: artistId || ""
        });
        // add user subscription at period end
        dispatch((0, $gfND9.subscriptionAddUserSubscriptionAtPeriodEnd)({
            userId: artistId || ""
        }));
        // close subscription cancel modal
        dispatch((0, $gfND9.subscriptionCloseSubscriptionCancelModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully canceled subscription!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to cancel subscription: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("7XQMo", function(module, exports) {

var $3AsAO = parcelRequire("3AsAO");
$parcel$exportWildcard(module.exports, $3AsAO);

});
parcelRegister("3AsAO", function(module, exports) {

$parcel$export(module.exports, "themeSlice", function () { return $80f02ef9e8a0214c$export$31c2657a77d5afe6; });
$parcel$export(module.exports, "themeToggle", function () { return $80f02ef9e8a0214c$export$bfcc790a4733fb08; });
$parcel$export(module.exports, "themeSetDark", function () { return $80f02ef9e8a0214c$export$9171f381a59a2216; });
$parcel$export(module.exports, "themeSetLight", function () { return $80f02ef9e8a0214c$export$229a2339108e1fc4; });
$parcel$export(module.exports, "themeSelectCurrentTheme", function () { return $80f02ef9e8a0214c$export$a48c667c917b2365; });
$parcel$export(module.exports, "themeReducer", function () { return $80f02ef9e8a0214c$export$cb5aa33629c05de0; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $80f02ef9e8a0214c$var$initialState = {
    currentTheme: (0, $48E0n.ThemeName).Dark
};
const $80f02ef9e8a0214c$export$31c2657a77d5afe6 = (0, $dEr3t.createSlice)({
    name: "theme",
    initialState: $80f02ef9e8a0214c$var$initialState,
    reducers: {
        themeToggle: (state)=>({
                ...state,
                currentTheme: state.currentTheme === (0, $48E0n.ThemeName).Dark ? (0, $48E0n.ThemeName).Light : (0, $48E0n.ThemeName).Dark
            }),
        themeSetDark: (state)=>({
                ...state,
                currentTheme: (0, $48E0n.ThemeName).Dark
            }),
        themeSetLight: (state)=>({
                ...state,
                currentTheme: (0, $48E0n.ThemeName).Light
            })
    }
});
const { themeToggle: $80f02ef9e8a0214c$export$bfcc790a4733fb08, themeSetDark: $80f02ef9e8a0214c$export$9171f381a59a2216, themeSetLight: $80f02ef9e8a0214c$export$229a2339108e1fc4 } = $80f02ef9e8a0214c$export$31c2657a77d5afe6.actions;
const $80f02ef9e8a0214c$export$a48c667c917b2365 = (state)=>state.theme.currentTheme;
const $80f02ef9e8a0214c$export$cb5aa33629c05de0 = $80f02ef9e8a0214c$export$31c2657a77d5afe6.reducer; // export default themeSlice.reducer

});


parcelRegister("kyVMf", function(module, exports) {

$parcel$export(module.exports, "TipModal", function () { return (parcelRequire("csTPR")).TipModal; });
parcelRequire("6Lxdz");
var $csTPR = parcelRequire("csTPR");

var $2zsG4 = parcelRequire("2zsG4");

var $dcnhf = parcelRequire("dcnhf");
$parcel$exportWildcard(module.exports, $2zsG4);
$parcel$exportWildcard(module.exports, $dcnhf);

});
parcelRegister("6Lxdz", function(module, exports) {

$parcel$export(module.exports, "TipModal", function () { return (parcelRequire("csTPR")).TipModal; });

var $csTPR = parcelRequire("csTPR");

});
parcelRegister("csTPR", function(module, exports) {

$parcel$export(module.exports, "TipModal", function () { return $5046f78dc998c174$export$bb27c6f96dfdd7a2; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $2zsG4 = parcelRequire("2zsG4");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("14YGU");
var $5dyKW = parcelRequire("5dyKW");

var $ctyEn = parcelRequire("ctyEn");
const $5046f78dc998c174$export$bb27c6f96dfdd7a2 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const tipModalOpen = (0, $9CcOD.useAppSelector)((0, $2zsG4.tipSelectTipModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $ctyEn.styles)().modal.main,
        children: tipModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $2zsG4.tipCloseTipModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $ctyEn.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5dyKW.TipCard), {})
            })
        })
    });
};
$5046f78dc998c174$export$bb27c6f96dfdd7a2.propTypes = {};

});
parcelRegister("14YGU", function(module, exports) {

$parcel$export(module.exports, "TipCard", function () { return (parcelRequire("5dyKW")).TipCard; });

var $5dyKW = parcelRequire("5dyKW");

});
parcelRegister("5dyKW", function(module, exports) {

$parcel$export(module.exports, "TipCard", function () { return $0e4b5674437861f4$export$aaefb9d354766010; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $2zsG4 = parcelRequire("2zsG4");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("h6Uvk");
var $fk8QZ = parcelRequire("fk8QZ");

var $eJm69 = parcelRequire("eJm69");
const $0e4b5674437861f4$export$aaefb9d354766010 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $2zsG4.tipSelectTipModalArtist));
    const tipError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 31;
    const subtitleAccentEndIndex = 32 + (username?.length || 0);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $eJm69.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $eJm69.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $2zsG4.tipCloseTipModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $eJm69.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Send Tip",
                    icon: (0, $9IIBp.icons).DollarCircle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $eJm69.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: `Show your appreciation for the @${username} by sending a tip to support their work!`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $eJm69.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $eJm69.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fk8QZ.TipForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $eJm69.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: tipError
                        })
                    })
                ]
            })
        ]
    });
};
$0e4b5674437861f4$export$aaefb9d354766010.propTypes = {};

});
parcelRegister("h6Uvk", function(module, exports) {

$parcel$export(module.exports, "TipForm", function () { return (parcelRequire("fk8QZ")).TipForm; });

var $fk8QZ = parcelRequire("fk8QZ");

});
parcelRegister("fk8QZ", function(module, exports) {

$parcel$export(module.exports, "TipForm", function () { return $b466fffd97563c9c$export$72bbcc7dfc0dee1b; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $lyE92 = parcelRequire("lyE92");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $dcnhf = parcelRequire("dcnhf");
var $2zsG4 = parcelRequire("2zsG4");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $f4vJY = parcelRequire("f4vJY");
var $i8CSQ = parcelRequire("i8CSQ");
var $1sbY5 = parcelRequire("1sbY5");

var $4oWmD = parcelRequire("4oWmD");
const $b466fffd97563c9c$export$72bbcc7dfc0dee1b = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const tipCreateLoading = (0, $9CcOD.useAppSelector)((0, $2zsG4.tipSelectTipCreateTipLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalArtist = (0, $9CcOD.useAppSelector)((0, $2zsG4.tipSelectTipModalArtist));
    const [tipAmount, setTipAmount] = (0, $exYeM.useState)(Math.ceil((0, $lyE92.maxTipAmount) / 2));
    const [tipMessage, setTipMessage] = (0, $exYeM.useState)("");
    const [tipMessageError, setTipMessageError] = (0, $exYeM.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUserTip = profileUserId === artistUserId;
    const submitDisabled = tipMessageError !== "" || tipAmount < (0, $lyE92.minTipAmount) || tipAmount > (0, $lyE92.maxTipAmount) || tipMessage.length > (0, $lyE92.maxTipMessageLength) || isCurrentUserTip || tipCreateLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $4oWmD.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $4oWmD.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $dcnhf.tipCreateTip)({
                    amount: tipAmount,
                    message: tipMessage
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4oWmD.styles)().form.content.amount,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f4vJY.InputAmount), {
                        name: "tip-amount",
                        label: "tip amount",
                        type: "range",
                        id: "tip-amount",
                        value: tipAmount,
                        min: (0, $lyE92.minTipAmount),
                        max: (0, $lyE92.maxTipAmount),
                        onChange: (e)=>setTipAmount(parseInt(e.target.value, 10))
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4oWmD.styles)().form.content.message,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i8CSQ.InputArea), {
                        name: "tip-message",
                        label: "tip message",
                        id: "tip-message",
                        placeholder: "Connect with the artist by sending a message",
                        value: tipMessage,
                        maxLength: (0, $lyE92.maxTipMessageLength),
                        error: tipMessageError.length > 0,
                        errorMessage: tipMessageError,
                        rows: 6,
                        onChange: (e)=>setTipMessage(e.target.value),
                        onBlur: ()=>{
                            if (tipMessage !== "") setTipMessageError((0, $33ayT.validateTipMessage)(tipMessage));
                        },
                        onFocus: ()=>setTipMessageError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $4oWmD.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create tip",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: tipCreateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Tip: $${tipAmount}`
                    })
                })
            ]
        })
    });
};
$b466fffd97563c9c$export$72bbcc7dfc0dee1b.propTypes = {};

});
parcelRegister("4oWmD", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c2c16793297ed323$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $c2c16793297ed323$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c2c16793297ed323$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c2c16793297ed323$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $c2c16793297ed323$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                amount: $c2c16793297ed323$var$_ref2,
                message: $c2c16793297ed323$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("eJm69", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ba7dd1f854a97d4c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ba7dd1f854a97d4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ba7dd1f854a97d4c$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ba7dd1f854a97d4c$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ba7dd1f854a97d4c$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ba7dd1f854a97d4c$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ba7dd1f854a97d4c$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ba7dd1f854a97d4c$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $ba7dd1f854a97d4c$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $ba7dd1f854a97d4c$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $ba7dd1f854a97d4c$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($ba7dd1f854a97d4c$var$_ref8), " ", (0, $48E0n.mq).mobile($ba7dd1f854a97d4c$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($ba7dd1f854a97d4c$var$_ref6), ";", ""),
            title: $ba7dd1f854a97d4c$var$_ref5,
            subtitle: $ba7dd1f854a97d4c$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($ba7dd1f854a97d4c$var$_ref3), ";", ""),
                form: $ba7dd1f854a97d4c$var$_ref2,
                error: $ba7dd1f854a97d4c$var$_ref
            }
        }
    });

});



parcelRegister("ctyEn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c3b6bdb05b051f1a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c3b6bdb05b051f1a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c3b6bdb05b051f1a$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $c3b6bdb05b051f1a$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($c3b6bdb05b051f1a$var$_ref), ";", "")
        }
    });

});



parcelRegister("2zsG4", function(module, exports) {

$parcel$export(module.exports, "tipSlice", function () { return $0d358e3b6317a32a$export$93392c9cfeaaa30f; });
$parcel$export(module.exports, "tipResetState", function () { return $0d358e3b6317a32a$export$ecefc37ebfa23d30; });
$parcel$export(module.exports, "tipOpenTipModal", function () { return $0d358e3b6317a32a$export$46a4ac262f682147; });
$parcel$export(module.exports, "tipCloseTipModal", function () { return $0d358e3b6317a32a$export$ecfbd433f7956014; });
$parcel$export(module.exports, "tipSelectTipModalOpen", function () { return $0d358e3b6317a32a$export$a41ea3ae0e42011; });
$parcel$export(module.exports, "tipSelectTipModalArtist", function () { return $0d358e3b6317a32a$export$407b171f08b12852; });
$parcel$export(module.exports, "tipSelectTipCreateTipLoading", function () { return $0d358e3b6317a32a$export$519187884b4bea71; });
$parcel$export(module.exports, "tipReducer", function () { return $0d358e3b6317a32a$export$d8203854a0e4cb14; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $dcnhf = parcelRequire("dcnhf");
const $0d358e3b6317a32a$var$initialState = {
    tipModal: {
        artist: undefined,
        open: false
    },
    tipCreateTipLoading: false
};
const $0d358e3b6317a32a$export$93392c9cfeaaa30f = (0, $dEr3t.createSlice)({
    name: "tip",
    initialState: $0d358e3b6317a32a$var$initialState,
    reducers: {
        // reset state
        tipResetState: ()=>({
                tipModal: {
                    artist: undefined,
                    open: false
                },
                tipCreateTipLoading: false
            }),
        // open tip modal
        tipOpenTipModal: (state, action)=>({
                ...state,
                tipModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close tip modal
        tipCloseTipModal: (state)=>({
                ...state,
                tipModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // create tip
        builder.addCase((0, $dcnhf.tipCreateTip).pending, (state)=>({
                ...state,
                tipCreateTipLoading: true
            })).addCase((0, $dcnhf.tipCreateTip).fulfilled, (state)=>({
                ...state,
                tipCreateTipLoading: false
            }));
    }
});
const { tipResetState: $0d358e3b6317a32a$export$ecefc37ebfa23d30, tipOpenTipModal: $0d358e3b6317a32a$export$46a4ac262f682147, tipCloseTipModal: $0d358e3b6317a32a$export$ecfbd433f7956014 } = $0d358e3b6317a32a$export$93392c9cfeaaa30f.actions;
const $0d358e3b6317a32a$export$a41ea3ae0e42011 = (state)=>state.tip.tipModal.open;
const $0d358e3b6317a32a$export$407b171f08b12852 = (state)=>state.tip.tipModal.artist;
const $0d358e3b6317a32a$export$519187884b4bea71 = (state)=>state.tip.tipCreateTipLoading;
const $0d358e3b6317a32a$export$d8203854a0e4cb14 = $0d358e3b6317a32a$export$93392c9cfeaaa30f.reducer; // export default tipSlice.reducer

});

parcelRegister("dcnhf", function(module, exports) {

$parcel$export(module.exports, "tipCreateTip", function () { return $fa2d2a78768c439e$export$13c5a3c45baf7f02; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $j6i5c = parcelRequire("j6i5c");
var $3Mk3a = parcelRequire("3Mk3a");
var $2zsG4 = parcelRequire("2zsG4");
const $fa2d2a78768c439e$export$13c5a3c45baf7f02 = (0, $dEr3t.createAsyncThunk)("tip/tipCreateTip", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().tip.tipModal.artist;
    // if artist id is not provided
    if (!inp.artistId) // set artist id as modal artist id
    inp.artistId = modalArtist?.id;
    try {
        // create tip
        const { clientSecret: clientSecret } = await api.tipApi.createTip({
            // create tip accepts amount in cents
            // if inp.amount = 1 (one dollar)
            // 1 * 100 = 100 (hundred cents)
            amount: inp.amount * 100,
            artistId: inp.artistId || "",
            message: inp.message
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close tip modal
        dispatch((0, $2zsG4.tipCloseTipModal)());
        // open payment modal
        dispatch((0, $j6i5c.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $3Mk3a.PaymentOperationType).Tip,
            operationSubject: modalArtist
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to create tip: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("25imx", function(module, exports) {

$parcel$export(module.exports, "TrackBlockModal", function () { return (parcelRequire("1Wjxk")).TrackBlockModal; });
$parcel$export(module.exports, "TrackCard", function () { return (parcelRequire("5gxZZ")).TrackCard; });
$parcel$export(module.exports, "TrackCardBlockSkeleton", function () { return (parcelRequire("ecxlB")).TrackCardBlockSkeleton; });
$parcel$export(module.exports, "TrackCardLocked", function () { return (parcelRequire("k6f9D")).TrackCardLocked; });
$parcel$export(module.exports, "TrackCardUploaded", function () { return (parcelRequire("3Le2Y")).TrackCardUploaded; });
$parcel$export(module.exports, "TrackDeleteModal", function () { return (parcelRequire("634z5")).TrackDeleteModal; });
$parcel$export(module.exports, "TrackListAudioPlaylist", function () { return (parcelRequire("bR4Bv")).TrackListAudioPlaylist; });
$parcel$export(module.exports, "TrackListChartsExclusive", function () { return (parcelRequire("jaeCx")).TrackListChartsExclusive; });
$parcel$export(module.exports, "TrackListChartsLatest", function () { return (parcelRequire("lrrfm")).TrackListChartsLatest; });
$parcel$export(module.exports, "TrackListChartsPopular", function () { return (parcelRequire("2D8xB")).TrackListChartsPopular; });
$parcel$export(module.exports, "TrackListChartsTrending", function () { return (parcelRequire("8kfFB")).TrackListChartsTrending; });
$parcel$export(module.exports, "TrackListFeedPopular", function () { return (parcelRequire("7lOMf")).TrackListFeedPopular; });
$parcel$export(module.exports, "TrackListFeedRecommended", function () { return (parcelRequire("1tP8G")).TrackListFeedRecommended; });
$parcel$export(module.exports, "TrackListHomePublic", function () { return (parcelRequire("9CqFC")).TrackListHomePublic; });
$parcel$export(module.exports, "TrackListLibraryLiked", function () { return (parcelRequire("fEXKS")).TrackListLibraryLiked; });
$parcel$export(module.exports, "TrackListLibraryUnlocked", function () { return (parcelRequire("2E6K3")).TrackListLibraryUnlocked; });
$parcel$export(module.exports, "TrackListOnboardingUploaded", function () { return (parcelRequire("gROQP")).TrackListOnboardingUploaded; });
$parcel$export(module.exports, "TrackListPost", function () { return (parcelRequire("cemn0")).TrackListPost; });
$parcel$export(module.exports, "TrackListStudioPostUploaded", function () { return (parcelRequire("29L7M")).TrackListStudioPostUploaded; });
$parcel$export(module.exports, "TrackListStudioUploaded", function () { return (parcelRequire("kEZUc")).TrackListStudioUploaded; });
$parcel$export(module.exports, "TrackListUserExclusive", function () { return (parcelRequire("bglOr")).TrackListUserExclusive; });
$parcel$export(module.exports, "TrackListUserLatest", function () { return (parcelRequire("aputk")).TrackListUserLatest; });
$parcel$export(module.exports, "TrackListUserPopular", function () { return (parcelRequire("81d13")).TrackListUserPopular; });
$parcel$export(module.exports, "TrackTile", function () { return (parcelRequire("iN4Zv")).TrackTile; });
$parcel$export(module.exports, "TrackTileLocked", function () { return (parcelRequire("jlQ6O")).TrackTileLocked; });
$parcel$export(module.exports, "TrackTileProduct", function () { return (parcelRequire("i113K")).TrackTileProduct; });
$parcel$export(module.exports, "TrackTileSelect", function () { return (parcelRequire("bKRbm")).TrackTileSelect; });
$parcel$export(module.exports, "TrackViewAudioPlaylist", function () { return (parcelRequire("8HzZA")).TrackViewAudioPlaylist; });
$parcel$export(module.exports, "TrackViewCreateStudio", function () { return (parcelRequire("1S0Aa")).TrackViewCreateStudio; });
$parcel$export(module.exports, "TrackViewEditStudio", function () { return (parcelRequire("ivesH")).TrackViewEditStudio; });
$parcel$export(module.exports, "trackUtilGetTrackTileSkeletonSections", function () { return (parcelRequire("ebSIw")).trackUtilGetTrackTileSkeletonSections; });
parcelRequire("lLvcg");
var $1Wjxk = parcelRequire("1Wjxk");
var $5gxZZ = parcelRequire("5gxZZ");
var $ecxlB = parcelRequire("ecxlB");
var $k6f9D = parcelRequire("k6f9D");
var $3Le2Y = parcelRequire("3Le2Y");
var $634z5 = parcelRequire("634z5");
var $bR4Bv = parcelRequire("bR4Bv");
var $jaeCx = parcelRequire("jaeCx");
var $lrrfm = parcelRequire("lrrfm");
var $2D8xB = parcelRequire("2D8xB");
var $8kfFB = parcelRequire("8kfFB");
var $7lOMf = parcelRequire("7lOMf");
var $1tP8G = parcelRequire("1tP8G");
var $9CqFC = parcelRequire("9CqFC");
var $fEXKS = parcelRequire("fEXKS");
var $2E6K3 = parcelRequire("2E6K3");
var $gROQP = parcelRequire("gROQP");
var $cemn0 = parcelRequire("cemn0");
var $29L7M = parcelRequire("29L7M");
var $kEZUc = parcelRequire("kEZUc");
var $bglOr = parcelRequire("bglOr");
var $aputk = parcelRequire("aputk");
var $81d13 = parcelRequire("81d13");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $i113K = parcelRequire("i113K");
var $bKRbm = parcelRequire("bKRbm");
var $8HzZA = parcelRequire("8HzZA");
var $1S0Aa = parcelRequire("1S0Aa");
var $ivesH = parcelRequire("ivesH");

var $ebSIw = parcelRequire("ebSIw");

var $1bnO9 = parcelRequire("1bnO9");

var $fZeVI = parcelRequire("fZeVI");
$parcel$exportWildcard(module.exports, $1bnO9);
$parcel$exportWildcard(module.exports, $fZeVI);

});
parcelRegister("lLvcg", function(module, exports) {

$parcel$export(module.exports, "TrackBlockModal", function () { return (parcelRequire("1Wjxk")).TrackBlockModal; });
$parcel$export(module.exports, "TrackCard", function () { return (parcelRequire("5gxZZ")).TrackCard; });
$parcel$export(module.exports, "TrackCardBlockSkeleton", function () { return (parcelRequire("ecxlB")).TrackCardBlockSkeleton; });
$parcel$export(module.exports, "TrackCardLocked", function () { return (parcelRequire("k6f9D")).TrackCardLocked; });
$parcel$export(module.exports, "TrackCardUploaded", function () { return (parcelRequire("3Le2Y")).TrackCardUploaded; });
$parcel$export(module.exports, "TrackDeleteModal", function () { return (parcelRequire("634z5")).TrackDeleteModal; });
$parcel$export(module.exports, "TrackListAudioPlaylist", function () { return (parcelRequire("bR4Bv")).TrackListAudioPlaylist; });
$parcel$export(module.exports, "TrackListChartsExclusive", function () { return (parcelRequire("jaeCx")).TrackListChartsExclusive; });
$parcel$export(module.exports, "TrackListChartsLatest", function () { return (parcelRequire("lrrfm")).TrackListChartsLatest; });
$parcel$export(module.exports, "TrackListChartsPopular", function () { return (parcelRequire("2D8xB")).TrackListChartsPopular; });
$parcel$export(module.exports, "TrackListChartsTrending", function () { return (parcelRequire("8kfFB")).TrackListChartsTrending; });
$parcel$export(module.exports, "TrackListFeedPopular", function () { return (parcelRequire("7lOMf")).TrackListFeedPopular; });
$parcel$export(module.exports, "TrackListFeedRecommended", function () { return (parcelRequire("1tP8G")).TrackListFeedRecommended; });
$parcel$export(module.exports, "TrackListHomePublic", function () { return (parcelRequire("9CqFC")).TrackListHomePublic; });
$parcel$export(module.exports, "TrackListLibraryLiked", function () { return (parcelRequire("fEXKS")).TrackListLibraryLiked; });
$parcel$export(module.exports, "TrackListLibraryUnlocked", function () { return (parcelRequire("2E6K3")).TrackListLibraryUnlocked; });
$parcel$export(module.exports, "TrackListOnboardingUploaded", function () { return (parcelRequire("gROQP")).TrackListOnboardingUploaded; });
$parcel$export(module.exports, "TrackListPost", function () { return (parcelRequire("cemn0")).TrackListPost; });
$parcel$export(module.exports, "TrackListStudioPostUploaded", function () { return (parcelRequire("29L7M")).TrackListStudioPostUploaded; });
$parcel$export(module.exports, "TrackListStudioUploaded", function () { return (parcelRequire("kEZUc")).TrackListStudioUploaded; });
$parcel$export(module.exports, "TrackListUserExclusive", function () { return (parcelRequire("bglOr")).TrackListUserExclusive; });
$parcel$export(module.exports, "TrackListUserLatest", function () { return (parcelRequire("aputk")).TrackListUserLatest; });
$parcel$export(module.exports, "TrackListUserPopular", function () { return (parcelRequire("81d13")).TrackListUserPopular; });
$parcel$export(module.exports, "TrackTile", function () { return (parcelRequire("iN4Zv")).TrackTile; });
$parcel$export(module.exports, "TrackTileLocked", function () { return (parcelRequire("jlQ6O")).TrackTileLocked; });
$parcel$export(module.exports, "TrackTileProduct", function () { return (parcelRequire("i113K")).TrackTileProduct; });
$parcel$export(module.exports, "TrackTileSelect", function () { return (parcelRequire("bKRbm")).TrackTileSelect; });
$parcel$export(module.exports, "TrackViewAudioPlaylist", function () { return (parcelRequire("8HzZA")).TrackViewAudioPlaylist; });
$parcel$export(module.exports, "TrackViewCreateStudio", function () { return (parcelRequire("1S0Aa")).TrackViewCreateStudio; });
$parcel$export(module.exports, "TrackViewEditStudio", function () { return (parcelRequire("ivesH")).TrackViewEditStudio; });

var $1Wjxk = parcelRequire("1Wjxk");

var $5gxZZ = parcelRequire("5gxZZ");

var $ecxlB = parcelRequire("ecxlB");

var $k6f9D = parcelRequire("k6f9D");

var $3Le2Y = parcelRequire("3Le2Y");

var $634z5 = parcelRequire("634z5");

var $bR4Bv = parcelRequire("bR4Bv");

var $jaeCx = parcelRequire("jaeCx");

var $lrrfm = parcelRequire("lrrfm");

var $2D8xB = parcelRequire("2D8xB");

var $8kfFB = parcelRequire("8kfFB");

var $7lOMf = parcelRequire("7lOMf");

var $1tP8G = parcelRequire("1tP8G");

var $9CqFC = parcelRequire("9CqFC");

var $fEXKS = parcelRequire("fEXKS");

var $2E6K3 = parcelRequire("2E6K3");

var $gROQP = parcelRequire("gROQP");

var $cemn0 = parcelRequire("cemn0");

var $29L7M = parcelRequire("29L7M");

var $kEZUc = parcelRequire("kEZUc");

var $bglOr = parcelRequire("bglOr");

var $aputk = parcelRequire("aputk");

var $81d13 = parcelRequire("81d13");

var $iN4Zv = parcelRequire("iN4Zv");

var $jlQ6O = parcelRequire("jlQ6O");

var $i113K = parcelRequire("i113K");

var $bKRbm = parcelRequire("bKRbm");

var $8HzZA = parcelRequire("8HzZA");

var $1S0Aa = parcelRequire("1S0Aa");

var $ivesH = parcelRequire("ivesH");

});
parcelRegister("1Wjxk", function(module, exports) {

$parcel$export(module.exports, "TrackBlockModal", function () { return $2c26a508b90373a9$export$417df2b15edf8238; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("5tMdm");
var $3Kvs6 = parcelRequire("3Kvs6");

var $6z7Dj = parcelRequire("6z7Dj");
const $2c26a508b90373a9$export$417df2b15edf8238 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackBlockModalOpen = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackBlockModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $6z7Dj.styles)().modal.main,
        children: trackBlockModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $1bnO9.trackCloseTrackBlockModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6z7Dj.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3Kvs6.TrackBlockCard), {})
            })
        })
    });
};
$2c26a508b90373a9$export$417df2b15edf8238.propTypes = {};

});
parcelRegister("5tMdm", function(module, exports) {

$parcel$export(module.exports, "TrackBlockCard", function () { return (parcelRequire("3Kvs6")).TrackBlockCard; });

var $3Kvs6 = parcelRequire("3Kvs6");

});
parcelRegister("3Kvs6", function(module, exports) {

$parcel$export(module.exports, "TrackBlockCard", function () { return $62a28d7c6501667b$export$731b3a29637a70bc; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("cOqov");
var $k8frO = parcelRequire("k8frO");

var $kveQI = parcelRequire("kveQI");
const $62a28d7c6501667b$export$731b3a29637a70bc = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackBlockError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $kveQI.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kveQI.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $1bnO9.trackCloseTrackBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kveQI.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Block Track",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kveQI.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Are you sure you want to block this track?"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $kveQI.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $kveQI.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k8frO.TrackBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $kveQI.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: trackBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$62a28d7c6501667b$export$731b3a29637a70bc.propTypes = {};

});
parcelRegister("cOqov", function(module, exports) {

$parcel$export(module.exports, "TrackBlockForm", function () { return (parcelRequire("k8frO")).TrackBlockForm; });

var $k8frO = parcelRequire("k8frO");

});
parcelRegister("k8frO", function(module, exports) {

$parcel$export(module.exports, "TrackBlockForm", function () { return $6faffd19e50d61b0$export$267c40b4632b9b65; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $hmgcL = parcelRequire("hmgcL");
const $6faffd19e50d61b0$export$267c40b4632b9b65 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackBlockLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackBlockLoading));
    const track = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackBlockModalTrack));
    const submitDisabled = trackBlockLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $hmgcL.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $hmgcL.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $fZeVI.trackBlock)({
                    id: track?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $hmgcL.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
                        track: track || {},
                        onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                                track: track
                            })),
                        onAuthorNameClick: ()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $hmgcL.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block track",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: trackBlockLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$6faffd19e50d61b0$export$267c40b4632b9b65.propTypes = {};

});
parcelRegister("hmgcL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $76bbaafd567281cb$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $76bbaafd567281cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $76bbaafd567281cb$var$_ref = {
    name: "mdhs63",
    styles: "display:flex;justify-content:center;margin-bottom:24px;& div{text-align:center;}& button{text-align:center;}"
};
const $76bbaafd567281cb$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                track: $76bbaafd567281cb$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("kveQI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1b78b92ae8763ec2$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $1b78b92ae8763ec2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1b78b92ae8763ec2$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $1b78b92ae8763ec2$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $1b78b92ae8763ec2$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $1b78b92ae8763ec2$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $1b78b92ae8763ec2$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $1b78b92ae8763ec2$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $1b78b92ae8763ec2$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $1b78b92ae8763ec2$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $1b78b92ae8763ec2$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($1b78b92ae8763ec2$var$_ref8), " ", (0, $48E0n.mq).mobile($1b78b92ae8763ec2$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($1b78b92ae8763ec2$var$_ref6), ";", ""),
            title: $1b78b92ae8763ec2$var$_ref5,
            subtitle: $1b78b92ae8763ec2$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($1b78b92ae8763ec2$var$_ref3), ";", ""),
                form: $1b78b92ae8763ec2$var$_ref2,
                error: $1b78b92ae8763ec2$var$_ref
            }
        }
    });

});



parcelRegister("6z7Dj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4f99bc8d9faff778$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $4f99bc8d9faff778$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4f99bc8d9faff778$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $4f99bc8d9faff778$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($4f99bc8d9faff778$var$_ref), ";", "")
        }
    });

});


parcelRegister("5gxZZ", function(module, exports) {

$parcel$export(module.exports, "TrackCard", function () { return $18ebd333adedf5fc$export$e42608234e0cc529; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $hUsFz = parcelRequire("hUsFz");
const $18ebd333adedf5fc$export$e42608234e0cc529 = ({ track: track, inProgress: inProgress = false, options: options = [], onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $hXJcm.u)();
    const optionsRef = (0, $exYeM.useRef)(null);
    const isMoreThanTwoOptions = (options?.length || 0) > 2;
    const [isOptionsOpen, setIsOptionsOpen] = (0, $exYeM.useState)(false);
    const [isOptionsScrollStart, setIsOptionsScrollStart] = (0, $exYeM.useState)(false);
    const [isOptionsScrollEnd, setIsOptionsScrollEnd] = (0, $exYeM.useState)(false);
    const { coverId: coverId, name: trackName, userId: userId } = track;
    const trackHasCover = !!coverId;
    const source = (0, $hrd7b.useFile)(coverId || "");
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const handleOptionsScrollArrow = (target)=>{
        // if more than two options provided
        if (isMoreThanTwoOptions) {
            // get node client height, scroll height, and scroll offset
            // clientHeight - height of currently visible content
            // scrollHeight - height of total scroll the element
            // scrollTop  - number of pixels scrolled
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = target;
            // last scroll position
            const lastScrollPosition = scrollHeight - clientHeight;
            // if scroll start reached
            if (scrollTop <= 0) {
                setIsOptionsScrollStart(true);
                setIsOptionsScrollEnd(false);
            }
            // if scroll end reached
            if (scrollTop >= lastScrollPosition) {
                setIsOptionsScrollStart(false);
                setIsOptionsScrollEnd(true);
            }
        }
    };
    (0, $exYeM.useEffect)(()=>{
        // if node present
        if (optionsRef.current) handleOptionsScrollArrow(optionsRef.current);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        isOptionsOpen
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $hUsFz.styles)(theme).track.main,
        onMouseLeave: ()=>setIsOptionsOpen(false),
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $hUsFz.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $hUsFz.styles)(theme).track.cover.overlay.main(!!inProgress),
                        children: inProgress ? /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $hUsFz.styles)(theme).track.cover.overlay.button,
                            onClick: ()=>{},
                            type: "button",
                            "aria-label": "currently playing",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Speaker, {})
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $hUsFz.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "play track",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Play, {})
                        })
                    }),
                    trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                        css: (0, $hUsFz.styles)(theme).track.cover.image,
                        onError: ()=>setCoverLoadError(true),
                        loading: "lazy",
                        width: "60px",
                        height: "60px",
                        src: source,
                        alt: "track album cover"
                    }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $hUsFz.styles)(theme).track.cover.placeholder,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $hUsFz.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $hUsFz.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $hUsFz.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $hUsFz.styles)(theme).track.menu.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $hUsFz.styles)(theme).track.menu.button,
                        onClick: ()=>{
                            setIsOptionsOpen((isOpen)=>!isOpen);
                        },
                        type: "button",
                        "aria-label": "toggle track options",
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MenuDots, {
                            css: (0, $hUsFz.styles)(theme).track.menu.icon
                        })
                    }),
                    isOptionsOpen && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $hUsFz.styles)(theme).track.menu.options.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: [
                                    (0, $hUsFz.styles)(theme).track.menu.options.overlay.top.shared,
                                    isOptionsScrollEnd && (0, $hUsFz.styles)(theme).track.menu.options.overlay.top.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CaretDown, {})
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $hUsFz.styles)(theme).track.menu.options.list.main,
                                ref: optionsRef,
                                onScroll: (e)=>{
                                    handleOptionsScrollArrow(e.target);
                                },
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("ul", {
                                    css: (0, $hUsFz.styles)(theme).track.menu.options.list.ul,
                                    children: options && options.map(({ id: id, label: label, name: name, danger: danger, onClick: onOptionClick })=>/*#__PURE__*/ (0, $5o6z6.jsx)("li", {
                                            css: (0, $hUsFz.styles)(theme).track.menu.options.list.li,
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                                css: [
                                                    (0, $hUsFz.styles)(theme).track.menu.options.list.button.shared,
                                                    danger ? (0, $hUsFz.styles)(theme).track.menu.options.list.button.danger : (0, $hUsFz.styles)(theme).track.menu.options.list.button.regular,
                                                    "",
                                                    ""
                                                ],
                                                onClick: (e)=>onOptionClick(e),
                                                type: "button",
                                                "aria-label": label,
                                                children: name
                                            })
                                        }, `track-option-${id}`))
                                })
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: [
                                    (0, $hUsFz.styles)(theme).track.menu.options.overlay.bottom.shared,
                                    isOptionsScrollStart && (0, $hUsFz.styles)(theme).track.menu.options.overlay.bottom.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CaretDown, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$18ebd333adedf5fc$export$e42608234e0cc529.propTypes = {};

});
parcelRegister("hUsFz", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bda10202137c3e55$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $bda10202137c3e55$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bda10202137c3e55$var$_ref = {
    name: "qr8q5p",
    styles: "list-style:none"
};
var $bda10202137c3e55$var$_ref2 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $bda10202137c3e55$var$_ref3 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $bda10202137c3e55$var$_ref4 = {
    name: "1ev2zwe",
    styles: "width:20px;height:6px"
};
var $bda10202137c3e55$var$_ref5 = {
    name: "1o3sllj",
    styles: "position:relative;display:flex;align-items:center;justify-content:center;margin-left:16px"
};
var $bda10202137c3e55$var$_ref6 = {
    name: "642qid",
    styles: "display:flex;flex-direction:column;min-width:0;margin-right:auto"
};
var $bda10202137c3e55$var$_ref7 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $bda10202137c3e55$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $bda10202137c3e55$var$_ref7,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: (inProgress)=>/*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.card.overlay, ";position:absolute;left:0;top:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;transition:opacity 0.2s;opacity:0;", inProgress && "opacity: 1;", " background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:20px;height:20px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $bda10202137c3e55$var$_ref6,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            },
            menu: {
                main: $bda10202137c3e55$var$_ref5,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;cursor:pointer;&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                icon: $bda10202137c3e55$var$_ref4,
                options: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.card.menu, ";position:absolute;right:100%;height:60px;min-width:80px;overflow-y:hidden;margin-right:10px;border-radius:4px;border:1px solid ", theme.colors.secondary.darker, ";", ""),
                    overlay: {
                        top: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, " 0%,\n                ", theme.colors.primary.normal, "00 100%\n              );&>svg{height:10px;width:10px;transform:rotate(180deg);&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $bda10202137c3e55$var$_ref3
                        },
                        bottom: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;bottom:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, "00 0%,\n                ", theme.colors.primary.normal, " 100%\n              );&>svg{height:10px;width:10px;&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $bda10202137c3e55$var$_ref2
                        }
                    },
                    list: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";height:60px;overflow-y:scroll;padding:4px 10px;background-color:", theme.colors.primary.darker, ";", ""),
                        ul: $bda10202137c3e55$var$_ref,
                        li: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        button: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:24px;cursor:pointer;font-weight:bold;white-space:nowrap;text-align:start;transition:color 0.2s;", ""),
                            regular: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                            danger: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.negative.normal, ";&:hover{color:", theme.colors.negative.normalHover, ";}", "")
                        }
                    }
                }
            }
        }
    });

});


parcelRegister("ecxlB", function(module, exports) {

$parcel$export(module.exports, "TrackCardBlockSkeleton", function () { return $6a791e38e1a482c8$export$17e9901570d85c6f; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("fRVt8");
var $cK2N9 = parcelRequire("cK2N9");

var $kXgZv = parcelRequire("kXgZv");
const $6a791e38e1a482c8$export$17e9901570d85c6f = ()=>/*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $kXgZv.styles)().skeleton.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
                sections: [
                    {
                        name: "track-card-block-skeleton-cover-1",
                        width: "60px",
                        height: "60px",
                        isStatic: true,
                        isDivider: false
                    },
                    {
                        name: "track-card-block-skeleton-divider-1",
                        width: "16px",
                        height: "60px",
                        isStatic: true,
                        isDivider: true
                    },
                    {
                        name: "track-card-block-skeleton-description-1",
                        width: "100%",
                        height: "60px",
                        isStatic: false,
                        isDivider: false
                    }
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
                sections: [
                    {
                        name: "track-card-block-skeleton-cover-2",
                        width: "60px",
                        height: "60px",
                        isStatic: true,
                        isDivider: false
                    },
                    {
                        name: "track-card-block-skeleton-divider-2",
                        width: "16px",
                        height: "60px",
                        isStatic: true,
                        isDivider: true
                    },
                    {
                        name: "track-card-block-skeleton-description-2",
                        width: "100%",
                        height: "60px",
                        isStatic: false,
                        isDivider: false
                    }
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
                sections: [
                    {
                        name: "track-card-block-skeleton-cover-3",
                        width: "60px",
                        height: "60px",
                        isStatic: true,
                        isDivider: false
                    },
                    {
                        name: "track-card-block-skeleton-divider-3",
                        width: "16px",
                        height: "60px",
                        isStatic: true,
                        isDivider: true
                    },
                    {
                        name: "track-card-block-skeleton-description-3",
                        width: "100%",
                        height: "60px",
                        isStatic: false,
                        isDivider: false
                    }
                ]
            })
        ]
    });
$6a791e38e1a482c8$export$17e9901570d85c6f.propTypes = {};

});
parcelRegister("kXgZv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9e3cabb7fbf8a107$export$9dd6ff9ea0189349; });
function $9e3cabb7fbf8a107$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9e3cabb7fbf8a107$var$_ref = {
    name: "1itg42i",
    styles: "width:280px;&:not(:last-of-type){margin-right:20px;}&>div:not(:last-of-type){margin-bottom:24px;}"
};
const $9e3cabb7fbf8a107$export$9dd6ff9ea0189349 = ()=>({
        skeleton: {
            main: $9e3cabb7fbf8a107$var$_ref
        }
    });

});


parcelRegister("k6f9D", function(module, exports) {

$parcel$export(module.exports, "TrackCardLocked", function () { return $7098dfa95c0b486b$export$ea3bc8a15e6ef2d4; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $VVfeT = parcelRequire("VVfeT");
const $7098dfa95c0b486b$export$ea3bc8a15e6ef2d4 = ({ track: track, options: options = [], onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $hXJcm.u)();
    const optionsRef = (0, $exYeM.useRef)(null);
    const isMoreThanTwoOptions = (options?.length || 0) > 2;
    const [isOptionsOpen, setIsOptionsOpen] = (0, $exYeM.useState)(false);
    const [isOptionsScrollStart, setIsOptionsScrollStart] = (0, $exYeM.useState)(false);
    const [isOptionsScrollEnd, setIsOptionsScrollEnd] = (0, $exYeM.useState)(false);
    const { name: trackName, userId: userId } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const handleOptionsScrollArrow = (target)=>{
        // if more than two options provided
        if (isMoreThanTwoOptions) {
            // get node client height, scroll height, and scroll offset
            // clientHeight - height of currently visible content
            // scrollHeight - height of total scroll the element
            // scrollTop  - number of pixels scrolled
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = target;
            // last scroll position
            const lastScrollPosition = scrollHeight - clientHeight;
            // if scroll start reached
            if (scrollTop <= 0) {
                setIsOptionsScrollStart(true);
                setIsOptionsScrollEnd(false);
            }
            // if scroll end reached
            if (scrollTop >= lastScrollPosition) {
                setIsOptionsScrollStart(false);
                setIsOptionsScrollEnd(true);
            }
        }
    };
    (0, $exYeM.useEffect)(()=>{
        // if node present
        if (optionsRef.current) handleOptionsScrollArrow(optionsRef.current);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        isOptionsOpen
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $VVfeT.styles)(theme).track.main,
        onMouseLeave: ()=>setIsOptionsOpen(false),
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $VVfeT.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $VVfeT.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $VVfeT.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "unlock track",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Unlock, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $VVfeT.styles)(theme).track.cover.lock.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $VVfeT.styles)(theme).track.cover.lock.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $VVfeT.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $VVfeT.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $VVfeT.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $VVfeT.styles)(theme).track.menu.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $VVfeT.styles)(theme).track.menu.button,
                        onClick: ()=>{
                            setIsOptionsOpen(!isOptionsOpen);
                        },
                        type: "button",
                        "aria-label": "toggle track options",
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MenuDots, {
                            css: (0, $VVfeT.styles)(theme).track.menu.icon
                        })
                    }),
                    isOptionsOpen && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $VVfeT.styles)(theme).track.menu.options.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: [
                                    (0, $VVfeT.styles)(theme).track.menu.options.overlay.top.shared,
                                    isOptionsScrollEnd && (0, $VVfeT.styles)(theme).track.menu.options.overlay.top.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CaretDown, {})
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $VVfeT.styles)(theme).track.menu.options.list.main,
                                ref: optionsRef,
                                onScroll: (e)=>{
                                    handleOptionsScrollArrow(e.target);
                                },
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("ul", {
                                    css: (0, $VVfeT.styles)(theme).track.menu.options.list.ul,
                                    children: options && options.map(({ id: id, label: label, name: name, danger: danger, onClick: onOptionClick })=>/*#__PURE__*/ (0, $5o6z6.jsx)("li", {
                                            css: (0, $VVfeT.styles)(theme).track.menu.options.list.li,
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                                css: [
                                                    (0, $VVfeT.styles)(theme).track.menu.options.list.button.shared,
                                                    danger ? (0, $VVfeT.styles)(theme).track.menu.options.list.button.danger : (0, $VVfeT.styles)(theme).track.menu.options.list.button.regular,
                                                    "",
                                                    ""
                                                ],
                                                onClick: (e)=>onOptionClick(e),
                                                type: "button",
                                                "aria-label": label,
                                                children: name
                                            })
                                        }, `track-option-${id}`))
                                })
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: [
                                    (0, $VVfeT.styles)(theme).track.menu.options.overlay.bottom.shared,
                                    isOptionsScrollStart && (0, $VVfeT.styles)(theme).track.menu.options.overlay.bottom.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CaretDown, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$7098dfa95c0b486b$export$ea3bc8a15e6ef2d4.propTypes = {};

});
parcelRegister("VVfeT", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $06b9246e703b6e1c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $06b9246e703b6e1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $06b9246e703b6e1c$var$_ref = {
    name: "qr8q5p",
    styles: "list-style:none"
};
var $06b9246e703b6e1c$var$_ref2 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $06b9246e703b6e1c$var$_ref3 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $06b9246e703b6e1c$var$_ref4 = {
    name: "1ev2zwe",
    styles: "width:20px;height:6px"
};
var $06b9246e703b6e1c$var$_ref5 = {
    name: "1o3sllj",
    styles: "position:relative;display:flex;align-items:center;justify-content:center;margin-left:16px"
};
var $06b9246e703b6e1c$var$_ref6 = {
    name: "642qid",
    styles: "display:flex;flex-direction:column;min-width:0;margin-right:auto"
};
var $06b9246e703b6e1c$var$_ref7 = {
    name: "1kr0l3f",
    styles: "display:flex;&>svg{width:20px;height:20px;}"
};
var $06b9246e703b6e1c$var$_ref8 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
var $06b9246e703b6e1c$var$_ref9 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $06b9246e703b6e1c$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $06b9246e703b6e1c$var$_ref9,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.card.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:20px;height:20px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                lock: {
                    main: $06b9246e703b6e1c$var$_ref8,
                    icon: $06b9246e703b6e1c$var$_ref7
                }
            },
            description: {
                main: $06b9246e703b6e1c$var$_ref6,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            },
            menu: {
                main: $06b9246e703b6e1c$var$_ref5,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;cursor:pointer;&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                icon: $06b9246e703b6e1c$var$_ref4,
                options: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.card.menu, ";position:absolute;right:100%;height:60px;min-width:80px;overflow-y:hidden;margin-right:10px;border-radius:4px;border:1px solid ", theme.colors.secondary.darker, ";", ""),
                    overlay: {
                        top: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, " 0%,\n                ", theme.colors.primary.normal, "00 100%\n              );&>svg{height:10px;width:10px;transform:rotate(180deg);&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $06b9246e703b6e1c$var$_ref3
                        },
                        bottom: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)("position:absolute;bottom:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, "00 0%,\n                ", theme.colors.primary.normal, " 100%\n              );&>svg{height:10px;width:10px;&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $06b9246e703b6e1c$var$_ref2
                        }
                    },
                    list: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";height:60px;overflow-y:scroll;padding:4px 10px;background-color:", theme.colors.primary.darker, ";", ""),
                        ul: $06b9246e703b6e1c$var$_ref,
                        li: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        button: {
                            shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:24px;cursor:pointer;font-weight:bold;white-space:nowrap;text-align:start;transition:color 0.2s;", ""),
                            regular: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                            danger: /*#__PURE__*/ (0, $4N3Qt.css)("color:", theme.colors.negative.normal, ";&:hover{color:", theme.colors.negative.normalHover, ";}", "")
                        }
                    }
                }
            }
        }
    });

});


parcelRegister("3Le2Y", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploaded", function () { return $8ab2312ac763f949$export$ea0331f1c8aba3f7; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");

var $2y5Gn = parcelRequire("2y5Gn");
const $8ab2312ac763f949$export$ea0331f1c8aba3f7 = ({ track: track, editDisabled: editDisabled = false, deleteDisabled: deleteDisabled = false, onClick: onClick, onEditClick: onEditClick, onDeleteClick: onDeleteClick })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    const { coverId: coverId, name: trackName, genres: genres, visibility: visibility, likesCount: likesCount, unlocksCount: unlocksCount } = track;
    const trackHasCover = !!coverId;
    const source = (0, $hrd7b.useFile)(coverId || "");
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $2y5Gn.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $2y5Gn.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $2y5Gn.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $2y5Gn.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "play track",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Play, {})
                        })
                    }),
                    trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                        css: (0, $2y5Gn.styles)(theme).track.cover.image,
                        onError: ()=>setCoverLoadError(true),
                        loading: "lazy",
                        width: "60px",
                        height: "60px",
                        src: source,
                        alt: "track album cover"
                    }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $2y5Gn.styles)(theme).track.cover.placeholder,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $2y5Gn.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $2y5Gn.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $2y5Gn.styles)(theme).track.description.author,
                        children: genres?.length ? genres?.map((genre, i)=>genres.length - 1 === i ? `${genre}` : `${genre}, `) : `-`
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $2y5Gn.styles)(theme).track.description.stats.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                css: (0, $2y5Gn.styles)(theme).track.description.stats.likes.main,
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $2y5Gn.styles)(theme).track.description.stats.likes.icon,
                                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Heart, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $2y5Gn.styles)(theme).track.description.stats.likes.count,
                                        children: (0, $fJerj.numbersFormatter)(likesCount || 0)
                                    })
                                ]
                            }),
                            visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                css: (0, $2y5Gn.styles)(theme).track.description.stats.unlocks.main,
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $2y5Gn.styles)(theme).track.description.stats.unlocks.icon,
                                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $2y5Gn.styles)(theme).track.description.stats.unlocks.count,
                                        children: (0, $fJerj.numbersFormatter)(unlocksCount || 0)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $2y5Gn.styles)(theme).track.options.main,
                children: [
                    onEditClick && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $2y5Gn.styles)(theme).track.options.edit.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: [
                                (0, $2y5Gn.styles)(theme).track.options.edit.button.shared,
                                editDisabled ? (0, $2y5Gn.styles)(theme).track.options.edit.button.disabled : (0, $2y5Gn.styles)(theme).track.options.edit.button.enabled,
                                "",
                                ""
                            ],
                            onClick: (e)=>onEditClick(e),
                            disabled: editDisabled,
                            type: "button",
                            "aria-label": "edit track",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Edit, {
                                css: (0, $2y5Gn.styles)(theme).track.options.edit.icon
                            })
                        })
                    }),
                    onDeleteClick && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $2y5Gn.styles)(theme).track.options.delete.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: [
                                (0, $2y5Gn.styles)(theme).track.options.delete.button.shared,
                                deleteDisabled ? (0, $2y5Gn.styles)(theme).track.options.delete.button.disabled : (0, $2y5Gn.styles)(theme).track.options.delete.button.enabled,
                                "",
                                ""
                            ],
                            onClick: (e)=>onDeleteClick(e),
                            disabled: deleteDisabled,
                            type: "button",
                            "aria-label": "delete track",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Trash, {
                                css: (0, $2y5Gn.styles)(theme).track.options.delete.icon
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$8ab2312ac763f949$export$ea0331f1c8aba3f7.propTypes = {};

});
parcelRegister("2y5Gn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ceccf99b5c8d2a5e$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ceccf99b5c8d2a5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ceccf99b5c8d2a5e$var$_ref = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $ceccf99b5c8d2a5e$var$_ref2 = {
    name: "18jsklt",
    styles: "margin-left:6px"
};
var $ceccf99b5c8d2a5e$var$_ref3 = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $ceccf99b5c8d2a5e$var$_ref4 = {
    name: "zjik7",
    styles: "display:flex"
};
var $ceccf99b5c8d2a5e$var$_ref5 = {
    name: "1rc9f6v",
    styles: "display:flex;align-items:center;margin-right:4px;&>svg{width:10px;height:10px;}"
};
var $ceccf99b5c8d2a5e$var$_ref6 = {
    name: "14u08z3",
    styles: "display:flex;min-width:0"
};
var $ceccf99b5c8d2a5e$var$_ref7 = {
    name: "1rc9f6v",
    styles: "display:flex;align-items:center;margin-right:4px;&>svg{width:10px;height:10px;}"
};
var $ceccf99b5c8d2a5e$var$_ref8 = {
    name: "1wjhvk5",
    styles: "display:flex;margin-right:8px;min-width:0"
};
var $ceccf99b5c8d2a5e$var$_ref9 = {
    name: "zjik7",
    styles: "display:flex"
};
var $ceccf99b5c8d2a5e$var$_ref10 = {
    name: "156y8ey",
    styles: "display:flex;flex-direction:column;height:60px;min-width:0;margin-right:auto"
};
var $ceccf99b5c8d2a5e$var$_ref11 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $ceccf99b5c8d2a5e$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $ceccf99b5c8d2a5e$var$_ref11,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.card.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:20px;height:20px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $ceccf99b5c8d2a5e$var$_ref10,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";margin-bottom:3px;", ""),
                stats: {
                    main: $ceccf99b5c8d2a5e$var$_ref9,
                    likes: {
                        main: $ceccf99b5c8d2a5e$var$_ref8,
                        icon: $ceccf99b5c8d2a5e$var$_ref7,
                        count: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";", "")
                    },
                    unlocks: {
                        main: $ceccf99b5c8d2a5e$var$_ref6,
                        icon: $ceccf99b5c8d2a5e$var$_ref5,
                        count: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";", "")
                    }
                }
            },
            options: {
                main: $ceccf99b5c8d2a5e$var$_ref4,
                edit: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    button: {
                        shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;", ""),
                        disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                        enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                    },
                    icon: $ceccf99b5c8d2a5e$var$_ref3
                },
                delete: {
                    main: $ceccf99b5c8d2a5e$var$_ref2,
                    button: {
                        shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;", ""),
                        disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                        enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                    },
                    icon: $ceccf99b5c8d2a5e$var$_ref
                }
            }
        }
    });

});


parcelRegister("634z5", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteModal", function () { return $d0980cbc913e6b08$export$82da2a81a14d4a1; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("jLyMN");
var $hKBD9 = parcelRequire("hKBD9");

var $xYcwv = parcelRequire("xYcwv");
const $d0980cbc913e6b08$export$82da2a81a14d4a1 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackDeleteModalOpen = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackDeleteModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $xYcwv.styles)().modal.main,
        children: trackDeleteModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $1bnO9.trackCloseTrackDeleteModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $xYcwv.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $hKBD9.TrackDeleteCard), {})
            })
        })
    });
};
$d0980cbc913e6b08$export$82da2a81a14d4a1.propTypes = {};

});
parcelRegister("jLyMN", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteCard", function () { return (parcelRequire("hKBD9")).TrackDeleteCard; });

var $hKBD9 = parcelRequire("hKBD9");

});
parcelRegister("hKBD9", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteCard", function () { return $395f551f6b5c2b4d$export$e44788248d8aa9e3; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("aYNrB");
var $iGprm = parcelRequire("iGprm");

var $f9dj5 = parcelRequire("f9dj5");
const $395f551f6b5c2b4d$export$e44788248d8aa9e3 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackDeleteError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $f9dj5.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f9dj5.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $1bnO9.trackCloseTrackDeleteModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f9dj5.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Delete Track",
                    icon: (0, $9IIBp.icons).Trash
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f9dj5.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Are you sure you want to delete your track?"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $f9dj5.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $f9dj5.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iGprm.TrackDeleteForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $f9dj5.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: trackDeleteError
                        })
                    })
                ]
            })
        ]
    });
};
$395f551f6b5c2b4d$export$e44788248d8aa9e3.propTypes = {};

});
parcelRegister("aYNrB", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteForm", function () { return (parcelRequire("iGprm")).TrackDeleteForm; });

var $iGprm = parcelRequire("iGprm");

});
parcelRegister("iGprm", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteForm", function () { return $a761456b09e78834$export$2a935b72536776a1; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $bgMVQ = parcelRequire("bgMVQ");
const $a761456b09e78834$export$2a935b72536776a1 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackDeleteLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackDeleteLoading));
    const track = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackDeleteModalTrack));
    const submitDisabled = trackDeleteLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $bgMVQ.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $bgMVQ.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $fZeVI.trackDelete)({
                    id: track?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $bgMVQ.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
                        track: track || {},
                        onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                                track: track
                            })),
                        onAuthorNameClick: ()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $bgMVQ.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "delete track",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: trackDeleteLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Delete"
                    })
                })
            ]
        })
    });
};
$a761456b09e78834$export$2a935b72536776a1.propTypes = {};

});
parcelRegister("bgMVQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9b132258be05fd07$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $9b132258be05fd07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9b132258be05fd07$var$_ref = {
    name: "mdhs63",
    styles: "display:flex;justify-content:center;margin-bottom:24px;& div{text-align:center;}& button{text-align:center;}"
};
const $9b132258be05fd07$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                track: $9b132258be05fd07$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("f9dj5", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $428a3b21c616e78a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $428a3b21c616e78a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $428a3b21c616e78a$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $428a3b21c616e78a$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $428a3b21c616e78a$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $428a3b21c616e78a$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $428a3b21c616e78a$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $428a3b21c616e78a$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $428a3b21c616e78a$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $428a3b21c616e78a$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $428a3b21c616e78a$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($428a3b21c616e78a$var$_ref8), " ", (0, $48E0n.mq).mobile($428a3b21c616e78a$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($428a3b21c616e78a$var$_ref6), ";", ""),
            title: $428a3b21c616e78a$var$_ref5,
            subtitle: $428a3b21c616e78a$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($428a3b21c616e78a$var$_ref3), ";", ""),
                form: $428a3b21c616e78a$var$_ref2,
                error: $428a3b21c616e78a$var$_ref
            }
        }
    });

});



parcelRegister("xYcwv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $24b12dd194b7f112$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $24b12dd194b7f112$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $24b12dd194b7f112$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $24b12dd194b7f112$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($24b12dd194b7f112$var$_ref), ";", "")
        }
    });

});


parcelRegister("bR4Bv", function(module, exports) {

$parcel$export(module.exports, "TrackListAudioPlaylist", function () { return $3bd2eed12fa34bef$export$ec9bc08769ce65b4; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $jhoVP = parcelRequire("jhoVP");
var $6CAIO = parcelRequire("6CAIO");
var $gfND9 = parcelRequire("gfND9");
var $5gxZZ = parcelRequire("5gxZZ");
var $k6f9D = parcelRequire("k6f9D");
var $1bnO9 = parcelRequire("1bnO9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $kczmi = parcelRequire("kczmi");
const $3bd2eed12fa34bef$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectTrackLikes));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const playlist = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectPlaylist));
    const playerAudioCurrentTrack = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrack));
    const playerAudioCurrentTrackPlaying = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrackPlaying));
    const track = playlist[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "track-list-audio-playlist-cover",
                    width: "60px",
                    height: "60px",
                    isStatic: true,
                    isDivider: false
                },
                {
                    name: "track-list-audio-playlist-divider",
                    width: "16px",
                    height: "60px",
                    isStatic: true,
                    isDivider: true
                },
                {
                    name: "track-list-audio-playlist-description",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: currentUserId, role: currentUserRole } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isCurrentUserAdmin = currentUserRole === (0, $aeAwZ.EntityUserRole).Admin;
    const isContentLiked = trackLikes[trackId || ""];
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    const { id: playerAudioCurrentTrackId } = playerAudioCurrentTrack ?? {};
    const isTrackInProgress = trackId === playerAudioCurrentTrackId && playerAudioCurrentTrackPlaying;
    const likeOption = {
        id: (0, $ij1oT.uuid)(),
        label: "like track",
        name: "Like",
        onClick: ()=>dispatch((0, $9ybfS.likeCreateTrackLike)({
                track: track
            }))
    };
    const dislikeOption = {
        id: (0, $ij1oT.uuid)(),
        label: "dislike track",
        name: "Dislike",
        onClick: ()=>dispatch((0, $9ybfS.likeDeleteTrackLike)({
                track: track
            }))
    };
    const playOption = {
        id: (0, $ij1oT.uuid)(),
        label: "play track",
        name: "Play",
        onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                track: track
            }))
    };
    const unlockOption = {
        id: (0, $ij1oT.uuid)(),
        label: "unlock track",
        name: "Unlock",
        onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                track: track
            }))
    };
    const reportOption = {
        id: (0, $ij1oT.uuid)(),
        label: "report track",
        name: "Report",
        danger: true,
        onClick: ()=>dispatch((0, $6CAIO.reportOpenReportTrackModal)({
                track: track
            }))
    };
    const blockOption = {
        id: (0, $ij1oT.uuid)(),
        label: "block track",
        name: "Block",
        danger: true,
        onClick: ()=>dispatch((0, $1bnO9.trackOpenTrackBlockModal)({
                track: track
            }))
    };
    const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
    const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
    // there should never be locked track in playlist
    // the following block will guarantee this
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $kczmi.styles)().list.row,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k6f9D.TrackCardLocked), {
            track: track,
            options: [
                unlockOption,
                likeDislikeOption,
                blockReportOption
            ],
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>{
                navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`);
                dispatch((0, $jhoVP.playerAudioSetClosed)());
            }
        })
    }, `playlist-track-${trackId}`);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $kczmi.styles)().list.row,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5gxZZ.TrackCard), {
            track: track,
            inProgress: isTrackInProgress,
            options: [
                playOption,
                likeDislikeOption,
                blockReportOption
            ],
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>{
                navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`);
                dispatch((0, $jhoVP.playerAudioSetClosed)());
            }
        })
    }, `playlist-track-${trackId}`);
});
const $3bd2eed12fa34bef$export$ec9bc08769ce65b4 = ()=>{
    const playlist = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectPlaylist));
    const playlistLength = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectPlaylistLength));
    const trackCardHeight = 60;
    const trackCardMarginBottom = 24;
    const itemHeight = trackCardHeight + trackCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 420;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!playlist[index];
    const loadMoreItems = ()=>{
    // (startIndex: number, stopIndex: number): void
    };
    // if playlist length is 0
    if (playlistLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $kczmi.styles)().list.placeholder,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "100%",
            title: "There are no tracks in the playlist"
        })
    });
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $kczmi.styles)().list.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: playlistLength || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: defaultListHeight,
                    itemSize: itemHeight,
                    itemCount: playlistLength || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "vertical",
                    children: $3bd2eed12fa34bef$var$Row
                })
        })
    }));
};
$3bd2eed12fa34bef$export$ec9bc08769ce65b4.propTypes = {};

});
parcelRegister("kczmi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f2768e1ec6069a3d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $f2768e1ec6069a3d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f2768e1ec6069a3d$var$_ref = {
    name: "uwo13w",
    styles: "width:100%;&:not(:last-of-type){margin-bottom:24px;}"
};
var $f2768e1ec6069a3d$var$_ref2 = {
    name: "13udsys",
    styles: "height:100%"
};
var $f2768e1ec6069a3d$var$_ref3 = {
    name: "1392zxw",
    styles: "width:100%;max-width:800px"
};
const $f2768e1ec6069a3d$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: $f2768e1ec6069a3d$var$_ref3,
            placeholder: $f2768e1ec6069a3d$var$_ref2,
            row: $f2768e1ec6069a3d$var$_ref
        },
        transactions: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("jaeCx", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsExclusive", function () { return $e538b15169bb7aae$export$e7efe7625e1c2404; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $8Jmfi = parcelRequire("8Jmfi");
const $e538b15169bb7aae$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectExclusiveTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-charts-exclusive")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8Jmfi.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8Jmfi.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $e538b15169bb7aae$export$e7efe7625e1c2404 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const exclusiveTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectExclusiveTracks));
    const exclusiveTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectExclusiveTracksCount));
    const exclusiveTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectExclusiveTracksLength));
    const exclusiveTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectExclusiveTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!exclusiveTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetExclusiveTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if exclusive tracks are fetched but length is 0
    if (exclusiveTracksFetched && exclusiveTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $9IIBp.icons).Lock,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: exclusiveTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $9IIBp.icons).Lock,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: exclusiveTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: exclusiveTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: exclusiveTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $e538b15169bb7aae$var$Row
                })
        })
    });
};
$e538b15169bb7aae$export$e7efe7625e1c2404.propTypes = {};

});
parcelRegister("8Jmfi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6a5ebf6057c9c4d2$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $6a5ebf6057c9c4d2$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("lrrfm", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsLatest", function () { return $13c297b8bc9c7a1a$export$acecfac920d8c76a; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $g0h8x = parcelRequire("g0h8x");
const $13c297b8bc9c7a1a$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLatestTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-charts-latest")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $g0h8x.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $g0h8x.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $13c297b8bc9c7a1a$export$acecfac920d8c76a = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const latestTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLatestTracks));
    const latestTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLatestTracksCount));
    const latestTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLatestTracksLength));
    const latestTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLatestTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!latestTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetLatestTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if latest tracks are fetched but length is 0
    if (latestTracksFetched && latestTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $9IIBp.icons).Time,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: latestTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $9IIBp.icons).Time,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: latestTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: latestTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: latestTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $13c297b8bc9c7a1a$var$Row
                })
        })
    });
};
$13c297b8bc9c7a1a$export$acecfac920d8c76a.propTypes = {};

});
parcelRegister("g0h8x", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a25aa07f1d0a6077$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $a25aa07f1d0a6077$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("2D8xB", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsPopular", function () { return $98c4c6d47244105d$export$30e557df93b79829; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $2Hdbx = parcelRequire("2Hdbx");
const $98c4c6d47244105d$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-charts-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $2Hdbx.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $2Hdbx.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $98c4c6d47244105d$export$30e557df93b79829 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const popularTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracks));
    const popularTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracksCount));
    const popularTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracksLength));
    const popularTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!popularTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetPopularTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if popular tracks are fetched but length is 0
    if (popularTracksFetched && popularTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $9IIBp.icons).Crown,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: popularTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $9IIBp.icons).Crown,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: popularTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: popularTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: popularTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $98c4c6d47244105d$var$Row
                })
        })
    });
};
$98c4c6d47244105d$export$30e557df93b79829.propTypes = {};

});
parcelRegister("2Hdbx", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $73671045f7f24a35$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $73671045f7f24a35$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("8kfFB", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsTrending", function () { return $5f17e109bbb07cf1$export$db7b83a649dd398c; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $9846E = parcelRequire("9846E");
const $5f17e109bbb07cf1$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrendingTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-charts-trending")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $9846E.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $9846E.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $5f17e109bbb07cf1$export$db7b83a649dd398c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trendingTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrendingTracks));
    const trendingTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrendingTracksCount));
    const trendingTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrendingTracksLength));
    const trendingTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrendingTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!trendingTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetTrendingTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if trending tracks are fetched but length is 0
    if (trendingTracksFetched && trendingTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Trending",
        icon: (0, $9IIBp.icons).Fire,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: trendingTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Trending",
        icon: (0, $9IIBp.icons).Fire,
        overrideCss: (0, $4vSc9.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: trendingTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: trendingTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: trendingTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $5f17e109bbb07cf1$var$Row
                })
        })
    });
};
$5f17e109bbb07cf1$export$db7b83a649dd398c.propTypes = {};

});
parcelRegister("9846E", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $048bdf1bcdd8f4c4$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $048bdf1bcdd8f4c4$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("7lOMf", function(module, exports) {

$parcel$export(module.exports, "TrackListFeedPopular", function () { return $a26ed267712a5dbc$export$26b62bc63ee81545; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $jhoVP = parcelRequire("jhoVP");
var $6CAIO = parcelRequire("6CAIO");
var $gfND9 = parcelRequire("gfND9");
var $5gxZZ = parcelRequire("5gxZZ");
var $ecxlB = parcelRequire("ecxlB");
var $k6f9D = parcelRequire("k6f9D");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $2IEZn = parcelRequire("2IEZn");
const $a26ed267712a5dbc$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectTrackLikes));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ecxlB.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $2IEZn.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $aeAwZ.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $9ybfS.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $9ybfS.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $ij1oT.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $ij1oT.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $6CAIO.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $1bnO9.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $2IEZn.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k6f9D.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `popular-track-${trackId}`);
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $2IEZn.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5gxZZ.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `popular-track-${trackId}`);
        })
    });
});
const $a26ed267712a5dbc$export$26b62bc63ee81545 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const popularTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracks));
    const popularTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPopularTracksCount));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(popularTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!popularTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetPopularTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: popularTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $a26ed267712a5dbc$var$Row
                })
        })
    });
};
$a26ed267712a5dbc$export$26b62bc63ee81545.propTypes = {};

});
parcelRegister("2IEZn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $531b4dc184f5c71b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $531b4dc184f5c71b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $531b4dc184f5c71b$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $531b4dc184f5c71b$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $531b4dc184f5c71b$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $48E0n.mq).mobile($531b4dc184f5c71b$var$_ref2), ";", ""),
            row: $531b4dc184f5c71b$var$_ref
        }
    });

});


parcelRegister("1tP8G", function(module, exports) {

$parcel$export(module.exports, "TrackListFeedRecommended", function () { return $627cf1bdb6bfd097$export$19583a68693e044c; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $jhoVP = parcelRequire("jhoVP");
var $6CAIO = parcelRequire("6CAIO");
var $gfND9 = parcelRequire("gfND9");
var $5gxZZ = parcelRequire("5gxZZ");
var $ecxlB = parcelRequire("ecxlB");
var $k6f9D = parcelRequire("k6f9D");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $czro1 = parcelRequire("czro1");
const $627cf1bdb6bfd097$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectTrackLikes));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectRecommendedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ecxlB.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $czro1.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $aeAwZ.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $9ybfS.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $9ybfS.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $ij1oT.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $ij1oT.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $6CAIO.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $1bnO9.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $czro1.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k6f9D.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `recommended-track-${trackId}`);
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $czro1.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5gxZZ.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `recommended-track-${trackId}`);
        })
    });
});
const $627cf1bdb6bfd097$export$19583a68693e044c = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const recommendedTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectRecommendedTracks));
    const recommendedTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectRecommendedTracksCount));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(recommendedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!recommendedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetRecommendedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: recommendedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $627cf1bdb6bfd097$var$Row
                })
        })
    });
};
$627cf1bdb6bfd097$export$19583a68693e044c.propTypes = {};

});
parcelRegister("czro1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $547af0a00a6e6f08$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $547af0a00a6e6f08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $547af0a00a6e6f08$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $547af0a00a6e6f08$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $547af0a00a6e6f08$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $48E0n.mq).mobile($547af0a00a6e6f08$var$_ref2), ";", ""),
            row: $547af0a00a6e6f08$var$_ref
        }
    });

});


parcelRegister("9CqFC", function(module, exports) {

$parcel$export(module.exports, "TrackListHomePublic", function () { return $da7f51750a273ed3$export$ac9d15d4a41675c1; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $5gxZZ = parcelRequire("5gxZZ");
var $ecxlB = parcelRequire("ecxlB");
var $k6f9D = parcelRequire("k6f9D");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $c2DWD = parcelRequire("c2DWD");
const $da7f51750a273ed3$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPublicTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ecxlB.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $c2DWD.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: trackId, visibility: visibility } = track;
            const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
            const renderLocked = isContentLocked;
            const likeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)())
            };
            const playOption = {
                id: (0, $ij1oT.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)())
            };
            const unlockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)())
            };
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $c2DWD.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k6f9D.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeOption
                    ],
                    onClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)()),
                    onAuthorNameClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)())
                })
            }, `public-track-${trackId}`);
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $c2DWD.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5gxZZ.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeOption
                    ],
                    onClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)()),
                    onAuthorNameClick: ()=>dispatch((0, $fAzHC.authOpenJoinModal)())
                })
            }, `public-track-${trackId}`);
        })
    });
});
const $da7f51750a273ed3$export$ac9d15d4a41675c1 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const publicTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPublicTracks));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 60;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    const isItemLoaded = (index)=>!!publicTracks[index];
    const loadMoreItems = ()=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetPublicTracks)());
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular Tracks",
        overrideCss: (0, $4vSc9.contentLayout).home,
        itemWidth: itemWidth,
        itemsCount: defaultItemsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: defaultItemsCount / subsetLength,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: defaultItemsCount / subsetLength,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $da7f51750a273ed3$var$Row
                })
        })
    });
};
$da7f51750a273ed3$export$ac9d15d4a41675c1.propTypes = {};

});
parcelRegister("c2DWD", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $11c3e2a7c5cd0eff$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $11c3e2a7c5cd0eff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $11c3e2a7c5cd0eff$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $11c3e2a7c5cd0eff$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $11c3e2a7c5cd0eff$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $48E0n.mq).mobile($11c3e2a7c5cd0eff$var$_ref2), ";", ""),
            row: $11c3e2a7c5cd0eff$var$_ref
        }
    });

});


parcelRegister("fEXKS", function(module, exports) {

$parcel$export(module.exports, "TrackListLibraryLiked", function () { return $584d5ef684aec3a1$export$d5cae4b9c49533cf; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $jhoVP = parcelRequire("jhoVP");
var $6CAIO = parcelRequire("6CAIO");
var $gfND9 = parcelRequire("gfND9");
var $5gxZZ = parcelRequire("5gxZZ");
var $ecxlB = parcelRequire("ecxlB");
var $k6f9D = parcelRequire("k6f9D");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $dblLu = parcelRequire("dblLu");
const $584d5ef684aec3a1$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectTrackLikes));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLikedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ecxlB.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $dblLu.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $aeAwZ.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $9ybfS.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $9ybfS.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $ij1oT.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $ij1oT.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $6CAIO.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $1bnO9.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dblLu.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k6f9D.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `liked-track-${trackId}`);
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dblLu.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5gxZZ.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `liked-track-${trackId}`);
        })
    });
});
const $584d5ef684aec3a1$export$d5cae4b9c49533cf = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const likedTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLikedTracks));
    const likedTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLikedTracksCount));
    const likedTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLikedTracksLength));
    const likedTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectLikedTracksFetched));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(likedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!likedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetLikedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    // if liked tracks are fetched but length is 0
    if (likedTracksFetched && likedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Liked Tracks",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "228px",
            title: "You haven't liked any track yet"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Liked Tracks",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $584d5ef684aec3a1$var$Row
                })
        })
    });
};
$584d5ef684aec3a1$export$d5cae4b9c49533cf.propTypes = {};

});
parcelRegister("dblLu", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6288995550078844$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $6288995550078844$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6288995550078844$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $6288995550078844$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $6288995550078844$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $48E0n.mq).mobile($6288995550078844$var$_ref2), ";", ""),
            row: $6288995550078844$var$_ref
        }
    });

});


parcelRegister("2E6K3", function(module, exports) {

$parcel$export(module.exports, "TrackListLibraryUnlocked", function () { return $5ebdc2fbd607dce5$export$79691f6799fd6030; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $jhoVP = parcelRequire("jhoVP");
var $6CAIO = parcelRequire("6CAIO");
var $gfND9 = parcelRequire("gfND9");
var $5gxZZ = parcelRequire("5gxZZ");
var $ecxlB = parcelRequire("ecxlB");
var $k6f9D = parcelRequire("k6f9D");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $cwrdW = parcelRequire("cwrdW");
const $5ebdc2fbd607dce5$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectTrackLikes));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUnlockedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ecxlB.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cwrdW.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $aeAwZ.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $9ybfS.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $ij1oT.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $9ybfS.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $ij1oT.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $ij1oT.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $6CAIO.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $ij1oT.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $1bnO9.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $cwrdW.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $k6f9D.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `unlocked-track-${trackId}`);
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $cwrdW.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5gxZZ.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
                })
            }, `unlocked-track-${trackId}`);
        })
    });
});
const $5ebdc2fbd607dce5$export$79691f6799fd6030 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const unlockedTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUnlockedTracks));
    const unlockedTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUnlockedTracksCount));
    const unlockedTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUnlockedTracksLength));
    const unlockedTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUnlockedTracksFetched));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(unlockedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!unlockedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetUnlockedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    // if liked tracks are fetched but length is 0
    if (unlockedTracksFetched && unlockedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Unlocked Tracks",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "228px",
            title: "You haven't unlocked any track yet"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Unlocked Tracks",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $5ebdc2fbd607dce5$var$Row
                })
        })
    });
};
$5ebdc2fbd607dce5$export$79691f6799fd6030.propTypes = {};

});
parcelRegister("cwrdW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1ecdeea77ca12a10$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $1ecdeea77ca12a10$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1ecdeea77ca12a10$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $1ecdeea77ca12a10$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $1ecdeea77ca12a10$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $48E0n.mq).mobile($1ecdeea77ca12a10$var$_ref2), ";", ""),
            row: $1ecdeea77ca12a10$var$_ref
        }
    });

});


parcelRegister("gROQP", function(module, exports) {

$parcel$export(module.exports, "TrackListOnboardingUploaded", function () { return $d4a88b8578031fd0$export$d411a758a723e3fd; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");
parcelRequire("jX3Ob");
var $9IFWP = parcelRequire("9IFWP");
var $arhvu = parcelRequire("arhvu");

var $zPSD4 = parcelRequire("zPSD4");
const $d4a88b8578031fd0$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackDeleteLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackDeleteLoading));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $arhvu.TrackCardUploadedSkeleton), {})
    });
    const { id: trackId } = track;
    // if track is loading - artist should not be able to delete it
    const deleteDisabled = trackDeleteLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $zPSD4.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IFWP.TrackCardUploaded), {
            track: track,
            deleteDisabled: deleteDisabled,
            onDelete: ()=>dispatch((0, $fZeVI.trackDelete)({
                    id: trackId || ""
                }))
        })
    });
});
const $d4a88b8578031fd0$export$d411a758a723e3fd = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const uploadedTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracks));
    const uploadedTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksCount));
    const trackBlockWidth = 330;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 72;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 700;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!uploadedTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetUploadedTracks)({
            limit: 30,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Uploaded Tracks",
        overrideCss: (0, $4vSc9.contentLayout).onboarding,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: uploadedTracksCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: uploadedTracksCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $d4a88b8578031fd0$var$Row
                })
        })
    });
};
$d4a88b8578031fd0$export$d411a758a723e3fd.propTypes = {};

});
parcelRegister("jX3Ob", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploaded", function () { return (parcelRequire("9IFWP")).TrackCardUploaded; });
$parcel$export(module.exports, "TrackCardUploadedSkeleton", function () { return (parcelRequire("arhvu")).TrackCardUploadedSkeleton; });

var $9IFWP = parcelRequire("9IFWP");

var $arhvu = parcelRequire("arhvu");

});
parcelRegister("9IFWP", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploaded", function () { return $334bd5658e0b9fd0$export$ea0331f1c8aba3f7; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $9yZ0O = parcelRequire("9yZ0O");
const $334bd5658e0b9fd0$export$ea0331f1c8aba3f7 = ({ track: track, deleteDisabled: deleteDisabled, onDelete: onDelete })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const trackHasCover = !!coverId;
    const source = (0, $hrd7b.useFile)(coverId || "");
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9yZ0O.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9yZ0O.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $9yZ0O.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "60px",
                    height: "60px",
                    src: source,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {
                    css: (0, $9yZ0O.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $9yZ0O.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $9yZ0O.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                        css: (0, $9yZ0O.styles)(theme).track.description.author,
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9yZ0O.styles)(theme).track.delete.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                    css: [
                        (0, $9yZ0O.styles)(theme).track.delete.button.shared,
                        deleteDisabled ? (0, $9yZ0O.styles)(theme).track.delete.button.disabled : (0, $9yZ0O.styles)(theme).track.delete.button.enabled,
                        "",
                        ""
                    ],
                    onClick: (e)=>onDelete(e),
                    disabled: deleteDisabled,
                    type: "button",
                    "aria-label": "delete track",
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Trash, {
                        css: (0, $9yZ0O.styles)(theme).track.delete.button.icon
                    })
                })
            })
        ]
    });
};
$334bd5658e0b9fd0$export$ea0331f1c8aba3f7.propTypes = {};

});
parcelRegister("9yZ0O", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5bd619355bca3bd7$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $5bd619355bca3bd7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5bd619355bca3bd7$var$_ref = {
    name: "1aynuae",
    styles: "width:20px;height:20px"
};
var $5bd619355bca3bd7$var$_ref2 = {
    name: "1k9kcx9",
    styles: "display:flex;align-items:center;justify-content:center;margin-left:16px"
};
var $5bd619355bca3bd7$var$_ref3 = {
    name: "642qid",
    styles: "display:flex;flex-direction:column;min-width:0;margin-right:auto"
};
var $5bd619355bca3bd7$var$_ref4 = {
    name: "z8hc5m",
    styles: "display:flex;align-items:center;width:330px"
};
const $5bd619355bca3bd7$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $5bd619355bca3bd7$var$_ref4,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: $5bd619355bca3bd7$var$_ref3,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";", "")
            },
            delete: {
                main: $5bd619355bca3bd7$var$_ref2,
                button: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:30px;height:30px;&>svg>path{transition:fill 0.2s,color 0.2s;}", ""),
                    disabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darkHover, ";}&:hover svg>path{fill:", theme.colors.secondary.darkHover, ";}", ""),
                    enabled: /*#__PURE__*/ (0, $4N3Qt.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                    icon: $5bd619355bca3bd7$var$_ref
                }
            }
        }
    });

});


parcelRegister("arhvu", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploadedSkeleton", function () { return $e9d98855d545ae1e$export$db670e5716b3f9cf; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $hmt7D = parcelRequire("hmt7D");
const $e9d98855d545ae1e$export$db670e5716b3f9cf = ()=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $hmt7D.styles)(theme).skeleton.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $hmt7D.styles)(theme).skeleton.cover
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $hmt7D.styles)(theme).skeleton.divider
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $hmt7D.styles)(theme).skeleton.description
            })
        ]
    });
};
$e9d98855d545ae1e$export$db670e5716b3f9cf.propTypes = {};

});
parcelRegister("hmt7D", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7f1acd94de88b919$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $7f1acd94de88b919$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;width:330px;border-radius:4px;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $48E0n.kf).load.shine(-60, 0), ";", ""),
            cover: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;display:flex;width:60px;height:60px;opacity:0.4;border-top-left-radius:4px;border-bottom-left-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
            divider: /*#__PURE__*/ (0, $4N3Qt.css)("height:60px;width:16px;background-color:", theme.colors.primary.normal, ";", ""),
            description: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1;height:60px;opacity:0.4;border-top-right-radius:4px;border-bottom-right-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
        }
    });

});



parcelRegister("zPSD4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b09b89e301c8a11d$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b09b89e301c8a11d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b09b89e301c8a11d$var$_ref = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $b09b89e301c8a11d$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).mobile($b09b89e301c8a11d$var$_ref), ";", "")
        }
    });

});


parcelRegister("cemn0", function(module, exports) {

$parcel$export(module.exports, "TrackListPost", function () { return $74c76de55ac3a71e$export$6f7408809d010bed; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $l1Cdj = parcelRequire("l1Cdj");
var $gfND9 = parcelRequire("gfND9");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $agWEc = parcelRequire("agWEc");
const $74c76de55ac3a71e$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPostTracks));
    const track = tracks?.[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-post")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $agWEc.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $agWEc.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $74c76de55ac3a71e$export$6f7408809d010bed = ()=>{
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const postUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const post = (0, $9CcOD.useAppSelector)((0, $l1Cdj.postSelectPost));
    const postTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPostTracks));
    const postTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectPostTracksFetched));
    const postTracksCount = postTracks?.length || 0;
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!postTracks?.[index];
    const loadMoreItems = ()=>{
    // (startIndex: number, stopIndex: number): void
    };
    const { id: profileUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post ?? {};
    const isContentLocked = visibility === (0, $aeAwZ.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = profileUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if post is locked
    if (renderLocked) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).post.current,
        itemWidth: itemWidth,
        itemsCount: 0,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).Lock,
            height: "230px",
            title: "Content is locked"
        })
    });
    // if post tracks fetched but count is 0
    if (postTracksFetched && postTracksCount === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).post.current,
        itemWidth: itemWidth,
        itemsCount: postTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "This post doesn't have any tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).post.current,
        itemWidth: itemWidth,
        itemsCount: postTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: postTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: postTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $74c76de55ac3a71e$var$Row
                })
        })
    });
};
$74c76de55ac3a71e$export$6f7408809d010bed.propTypes = {};

});
parcelRegister("agWEc", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d5fe99b3f47ff507$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $d5fe99b3f47ff507$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d5fe99b3f47ff507$var$_ref = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $d5fe99b3f47ff507$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).mobile($d5fe99b3f47ff507$var$_ref), ";", "")
        }
    });

});


parcelRegister("29L7M", function(module, exports) {

$parcel$export(module.exports, "TrackListStudioPostUploaded", function () { return $0d49df15a219029b$export$1e70de97f8d41367; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $bKRbm = parcelRequire("bKRbm");
var $ebSIw = parcelRequire("ebSIw");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $gjVMQ = parcelRequire("gjVMQ");
const $0d49df15a219029b$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style, data: data })=>{
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-studio-post-uploaded")
        })
    });
    // parent provided props
    const { postTracks: postTracks, addPostTrack: addPostTrack, removePostTrack: removePostTrack } = data;
    const { id: trackId } = track;
    const isTrackAdded = postTracks.findIndex((t)=>t.id === trackId) !== -1;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gjVMQ.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $bKRbm.TrackTileSelect), {
            track: track,
            selected: isTrackAdded,
            onClick: ()=>isTrackAdded ? removePostTrack(trackId || "") : addPostTrack(track),
            onAuthorNameClick: ()=>{}
        })
    });
});
const $0d49df15a219029b$export$1e70de97f8d41367 = ({ postTracks: postTracks, addPostTrack: addPostTrack, removePostTrack: removePostTrack })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const uploadedTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracks));
    const uploadedTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksCount));
    const uploadedTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksLength));
    const uploadedTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!uploadedTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetUploadedTracks)({
            limit: 30,
            offset: startIndex
        }));
    };
    // if uploaded tracks are fetched but length is 0
    if (uploadedTracksFetched && uploadedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).post.create,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any uploaded tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).post.create,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: uploadedTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: uploadedTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    itemData: {
                        postTracks: postTracks,
                        addPostTrack: addPostTrack,
                        removePostTrack: removePostTrack
                    },
                    children: $0d49df15a219029b$var$Row
                })
        })
    });
};
$0d49df15a219029b$export$1e70de97f8d41367.propTypes = {};

});
parcelRegister("gjVMQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $35ee332e206eb813$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $35ee332e206eb813$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $35ee332e206eb813$var$_ref = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $35ee332e206eb813$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).mobile($35ee332e206eb813$var$_ref), ";", "")
        }
    });

});


parcelRegister("kEZUc", function(module, exports) {

$parcel$export(module.exports, "TrackListStudioUploaded", function () { return $6f23d29f11494362$export$f3239ff3c0d33624; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $jhoVP = parcelRequire("jhoVP");
var $ecxlB = parcelRequire("ecxlB");
var $3Le2Y = parcelRequire("3Le2Y");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $6Ucba = parcelRequire("6Ucba");
const $6f23d29f11494362$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackDeleteLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackDeleteLoading));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ecxlB.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $6Ucba.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: trackId, visibility: visibility } = track;
            // if track is locked or loading - artist should not be able to delete it
            const deleteDisabled = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers || trackDeleteLoading;
            return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $6Ucba.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3Le2Y.TrackCardUploaded), {
                    track: track,
                    deleteDisabled: deleteDisabled,
                    onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onEditClick: ()=>navigate(`${(0, $9YTSb.Path).Studio}${(0, $9YTSb.Path).Track}/${trackId}`),
                    onDeleteClick: ()=>dispatch((0, $1bnO9.trackOpenTrackDeleteModal)({
                            track: track
                        }))
                })
            }, `uploaded-track-${trackId}`);
        })
    });
});
const $6f23d29f11494362$export$f3239ff3c0d33624 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const uploadedTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracks));
    const uploadedTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksCount));
    const uploadedTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksLength));
    const uploadedTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracksFetched));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(uploadedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!uploadedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetUploadedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    // if popular tracks are fetched but length is 0
    if (uploadedTracksFetched && uploadedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: defaultItemsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any uploaded tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $4vSc9.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $6f23d29f11494362$var$Row
                })
        })
    });
};
$6f23d29f11494362$export$f3239ff3c0d33624.propTypes = {};

});
parcelRegister("6Ucba", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fccf0dd304c30e35$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fccf0dd304c30e35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fccf0dd304c30e35$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $fccf0dd304c30e35$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $fccf0dd304c30e35$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $48E0n.mq).mobile($fccf0dd304c30e35$var$_ref2), ";", ""),
            row: $fccf0dd304c30e35$var$_ref
        }
    });

});


parcelRegister("bglOr", function(module, exports) {

$parcel$export(module.exports, "TrackListUserExclusive", function () { return $538269348fca38aa$export$debff8c2e21f4bfa; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $dgiDr = parcelRequire("dgiDr");
const $538269348fca38aa$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistExclusiveTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-user-exclusive")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $dgiDr.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $dgiDr.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $538269348fca38aa$export$debff8c2e21f4bfa = ()=>{
    const { userId: userId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const artistExclusiveTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistExclusiveTracks));
    const artistExclusiveTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistExclusiveTracksCount));
    const artistExclusiveTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistExclusiveTracksLength));
    const artistExclusiveTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistExclusiveTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistExclusiveTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetArtistExclusiveTracks)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if exclusive tracks are fetched but length is 0
    if (artistExclusiveTracksFetched && artistExclusiveTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $9IIBp.icons).Lock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusiveTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any exclusive tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $9IIBp.icons).Lock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusiveTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistExclusiveTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistExclusiveTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $538269348fca38aa$var$Row
                })
        })
    });
};
$538269348fca38aa$export$debff8c2e21f4bfa.propTypes = {};

});
parcelRegister("dgiDr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2fbac221611786e1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $2fbac221611786e1$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("aputk", function(module, exports) {

$parcel$export(module.exports, "TrackListUserLatest", function () { return $a83807a97bc92b38$export$6898c25b2545cad1; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $ibCQ0 = parcelRequire("ibCQ0");
const $a83807a97bc92b38$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistLatestTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-user-latest")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if track is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $ibCQ0.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $ibCQ0.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $a83807a97bc92b38$export$6898c25b2545cad1 = ()=>{
    const { userId: userId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const artistLatestTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistLatestTracks));
    const artistLatestTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistLatestTracksCount));
    const artistLatestTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistLatestTracksLength));
    const artistLatestTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistLatestTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistLatestTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetArtistLatestTracks)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if latest tracks are fetched but length is 0
    if (artistLatestTracksFetched && artistLatestTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $9IIBp.icons).Clock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any latest tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $9IIBp.icons).Clock,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistLatestTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistLatestTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $a83807a97bc92b38$var$Row
                })
        })
    });
};
$a83807a97bc92b38$export$6898c25b2545cad1.propTypes = {};

});
parcelRegister("ibCQ0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e0eb04ad876caad5$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $e0eb04ad876caad5$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("81d13", function(module, exports) {

$parcel$export(module.exports, "TrackListUserPopular", function () { return $5c6e19e2bdac09e9$export$5ae5dcf205976d6b; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
var $iN4Zv = parcelRequire("iN4Zv");
var $jlQ6O = parcelRequire("jlQ6O");
var $ebSIw = parcelRequire("ebSIw");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");

var $f2fQ0 = parcelRequire("f2fQ0");
const $5c6e19e2bdac09e9$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackUnlocks = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const tracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistPopularTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $ebSIw.trackUtilGetTrackTileSkeletonSections)("track-list-user-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if track is locked
    if (renderLocked) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $f2fQ0.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jlQ6O.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $eFMHm.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $f2fQ0.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iN4Zv.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jhoVP.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $5c6e19e2bdac09e9$export$5ae5dcf205976d6b = ()=>{
    const { userId: userId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const artistPopularTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistPopularTracks));
    const artistPopularTracksCount = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistPopularTracksCount));
    const artistPopularTracksLength = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistPopularTracksLength));
    const artistPopularTracksFetched = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectArtistPopularTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistPopularTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $fZeVI.trackGetArtistPopularTracks)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if popular tracks are fetched but length is 0
    if (artistPopularTracksFetched && artistPopularTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $9IIBp.icons).Crown,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any popular tracks"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $9IIBp.icons).Crown,
        overrideCss: (0, $4vSc9.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularTracksCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistPopularTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistPopularTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $5c6e19e2bdac09e9$var$Row
                })
        })
    });
};
$5c6e19e2bdac09e9$export$5ae5dcf205976d6b.propTypes = {};

});
parcelRegister("f2fQ0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0b607ada141b9ee9$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
const $0b607ada141b9ee9$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("iN4Zv", function(module, exports) {

$parcel$export(module.exports, "TrackTile", function () { return $cd3404cd0d7119e7$export$54426ddde2f6035e; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $cUsVX = parcelRequire("cUsVX");
const $cd3404cd0d7119e7$export$54426ddde2f6035e = ({ track: track, onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    const { coverId: coverId, name: trackName, userId: userId } = track;
    const trackHasCover = !!coverId;
    const source = (0, $hrd7b.useFile)(coverId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $cUsVX.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $cUsVX.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $cUsVX.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $cUsVX.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "play track",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Play, {})
                        })
                    }),
                    trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                        css: (0, $cUsVX.styles)(theme).track.cover.image,
                        onError: ()=>setCoverLoadError(true),
                        loading: "lazy",
                        width: "180px",
                        height: "180px",
                        src: source,
                        alt: "track album cover"
                    }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $cUsVX.styles)(theme).track.cover.placeholder,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $cUsVX.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $cUsVX.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $cUsVX.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$cd3404cd0d7119e7$export$54426ddde2f6035e.propTypes = {};

});
parcelRegister("cUsVX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8f982c741d60d9c5$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $8f982c741d60d9c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8f982c741d60d9c5$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $8f982c741d60d9c5$var$_ref2 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $8f982c741d60d9c5$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $8f982c741d60d9c5$var$_ref2,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-bottom:10px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.tile.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:30px;height:30px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>svg{width:30px;height:30px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $8f982c741d60d9c5$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("jlQ6O", function(module, exports) {

$parcel$export(module.exports, "TrackTileLocked", function () { return $af5e1d2cdecaf5cc$export$119f7f506563544d; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $3jS2e = parcelRequire("3jS2e");
const $af5e1d2cdecaf5cc$export$119f7f506563544d = ({ track: track, onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $hXJcm.u)();
    const { name: trackName, userId: userId } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $3jS2e.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $3jS2e.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3jS2e.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: (0, $3jS2e.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "unlock track",
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Unlock, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3jS2e.styles)(theme).track.cover.lock.main,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $3jS2e.styles)(theme).track.cover.lock.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $3jS2e.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $3jS2e.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $3jS2e.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$af5e1d2cdecaf5cc$export$119f7f506563544d.propTypes = {};

});
parcelRegister("3jS2e", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ecefbc2295be6a53$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $ecefbc2295be6a53$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ecefbc2295be6a53$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $ecefbc2295be6a53$var$_ref2 = {
    name: "jpda5q",
    styles: "display:flex;&>svg{width:30px;height:30px;}"
};
var $ecefbc2295be6a53$var$_ref3 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
var $ecefbc2295be6a53$var$_ref4 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $ecefbc2295be6a53$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $ecefbc2295be6a53$var$_ref4,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-bottom:10px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.tile.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:30px;height:30px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                lock: {
                    main: $ecefbc2295be6a53$var$_ref3,
                    icon: $ecefbc2295be6a53$var$_ref2
                }
            },
            description: {
                main: $ecefbc2295be6a53$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("i113K", function(module, exports) {

$parcel$export(module.exports, "TrackTileProduct", function () { return $2371ad85748122a7$export$57508a4e1c467d23; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $20BbE = parcelRequire("20BbE");
const $2371ad85748122a7$export$57508a4e1c467d23 = ({ track: track })=>{
    const theme = (0, $hXJcm.u)();
    const { name: trackName, userId: userId } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $20BbE.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $20BbE.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $20BbE.styles)(theme).track.cover.lock.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $20BbE.styles)(theme).track.cover.lock.icon,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $20BbE.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $20BbE.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $20BbE.styles)(theme).track.description.author,
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$2371ad85748122a7$export$57508a4e1c467d23.propTypes = {};

});
parcelRegister("20BbE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $501e0f8dbdafc21b$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $501e0f8dbdafc21b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $501e0f8dbdafc21b$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $501e0f8dbdafc21b$var$_ref2 = {
    name: "jpda5q",
    styles: "display:flex;&>svg{width:30px;height:30px;}"
};
var $501e0f8dbdafc21b$var$_ref3 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
var $501e0f8dbdafc21b$var$_ref4 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $501e0f8dbdafc21b$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $501e0f8dbdafc21b$var$_ref4,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.normal, ";border-radius:4px;overflow:hidden;margin-bottom:10px;&:hover>div{opacity:1;}", ""),
                lock: {
                    main: $501e0f8dbdafc21b$var$_ref3,
                    icon: $501e0f8dbdafc21b$var$_ref2
                },
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>svg{width:30px;height:30px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $501e0f8dbdafc21b$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.secondary.normal, ";font-weight:bold;text-align:center;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:center;", "")
            }
        }
    });

});


parcelRegister("bKRbm", function(module, exports) {

$parcel$export(module.exports, "TrackTileSelect", function () { return $dbfed1ca79063545$export$d8d9fad53ea1675d; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $bFDaf = parcelRequire("bFDaf");
const $dbfed1ca79063545$export$d8d9fad53ea1675d = ({ track: track, selected: selected, onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $hXJcm.u)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    const { coverId: coverId, name: trackName, userId: userId } = track;
    const trackHasCover = !!coverId;
    const source = (0, $hrd7b.useFile)(coverId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $bFDaf.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bFDaf.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
                    css: (0, $bFDaf.styles)(theme).track.cover.button,
                    onClick: (e)=>onClick(e),
                    type: "button",
                    "aria-label": "play track",
                    children: [
                        selected && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bFDaf.styles)(theme).track.cover.overlay.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bFDaf.styles)(theme).track.cover.overlay.icon,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CheckCircle, {})
                            })
                        }),
                        trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $bFDaf.styles)(theme).track.cover.image,
                            onError: ()=>setCoverLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "180px",
                            src: source,
                            alt: "track album cover"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bFDaf.styles)(theme).track.cover.placeholder,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $bFDaf.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bFDaf.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $bFDaf.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$dbfed1ca79063545$export$d8d9fad53ea1675d.propTypes = {};

});
parcelRegister("bFDaf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3e9628663069d779$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3e9628663069d779$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3e9628663069d779$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $3e9628663069d779$var$_ref2 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $3e9628663069d779$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $3e9628663069d779$var$_ref2,
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-bottom:10px;", ""),
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;width:100%;height:100%;cursor:pointer;", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("z-index:", (0, $48E0n.z).features.track.tile.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;background-color:", theme.colors.primary.normal, "A0;", ""),
                    icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;justify-content:flex-end;margin:10px 10px 0px 0px;&>svg{width:30px;height:30px;&>path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>svg{width:30px;height:30px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $3e9628663069d779$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("8HzZA", function(module, exports) {

$parcel$export(module.exports, "TrackViewAudioPlaylist", function () { return $e28beb13919bb4c3$export$24ab48c69fdb6c27; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $9a5k4 = parcelRequire("9a5k4");
var $hrd7b = parcelRequire("hrd7b");
var $gSFbK = parcelRequire("gSFbK");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $jhoVP = parcelRequire("jhoVP");
var $gfND9 = parcelRequire("gfND9");
var $2zsG4 = parcelRequire("2zsG4");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $bI8qN = parcelRequire("bI8qN");
const $e28beb13919bb4c3$export$24ab48c69fdb6c27 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const [coverLoadError, setCoverLoadError] = (0, $exYeM.useState)(false);
    // profile
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const trackLikes = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectTrackLikes));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const { id: profileUserId } = profile ?? {};
    // track
    const track = (0, $9CcOD.useAppSelector)((0, $jhoVP.playerAudioSelectCurrentTrack));
    const { id: trackId, coverId: coverId, name: trackName, userId: trackAuthorUserId } = track ?? {};
    const trackHasCover = !!coverId;
    const source = (0, $hrd7b.useFile)(coverId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $gSFbK.useUser)(trackAuthorUserId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    // connect ready
    const { ready: connectReady } = (0, $9a5k4.useConnectReady)(trackAuthorUserId || "");
    const likeTrackDisabled = false;
    const dislikeTrackDisabled = false;
    const followAuthorDisabled = false;
    const unfollowAuthorDisabled = false;
    const subscribeToAuthorDisabled = false;
    const unsubscribeFromAuthorDisabled = false;
    const tipAuthorDisabled = false;
    const isTrackAuthorFollowed = userFollows[trackAuthorUserId || ""];
    const isTrackLiked = trackLikes[trackId || ""];
    const isCurrentUserContentAuthor = profileUserId === trackAuthorUserId;
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const isCurrentUserSubscribedToContentAuthorAtPeriodEnd = userSubscriptionsAtPeriodEnd[trackAuthorUserId || ""];
    const isAuthorCanReceivePayments = connectReady && !isCurrentUserContentAuthor;
    const subscribeAction = isCurrentUserSubscribedToContentAuthorAtPeriodEnd ? ()=>// renew subscription
        dispatch((0, $gfND9.subscriptionOpenSubscriptionRenewModal)({
            artist: {
                ...trackAuthor
            }
        })) : ()=>// else create new subscription
        dispatch((0, $gfND9.subscriptionOpenSubscriptionCreateModal)({
            artist: {
                ...trackAuthor
            }
        }));
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $bI8qN.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $bI8qN.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $bI8qN.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "200px",
                    height: "200px",
                    src: source,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $bI8qN.styles)(theme).track.cover.placeholder,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).MusicNote, {})
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $bI8qN.styles)(theme).track.panel.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $bI8qN.styles)(theme).track.panel.description.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.description.name,
                                children: trackName
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                css: (0, $bI8qN.styles)(theme).track.panel.description.author,
                                onClick: ()=>{
                                    navigate(`${(0, $9YTSb.Path).User}/${trackAuthorUserId}`);
                                    dispatch((0, $jhoVP.playerAudioSetClosed)());
                                },
                                type: "button",
                                "aria-label": "explore track author",
                                children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $bI8qN.styles)(theme).track.panel.features.main,
                        children: [
                            isTrackLiked ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.features.dislike.main,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: [
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.shared,
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.accent,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $9ybfS.likeDeleteTrackLike)({
                                            track: track
                                        })),
                                    type: "button",
                                    "aria-label": "dislike track",
                                    disabled: dislikeTrackDisabled,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Heart, {})
                                })
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.features.like.main,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: [
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.shared,
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $9ybfS.likeCreateTrackLike)({
                                            track: track
                                        })),
                                    type: "button",
                                    "aria-label": "like track",
                                    disabled: likeTrackDisabled,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Heart, {})
                                })
                            }),
                            isTrackAuthorFollowed ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.features.unfollow.main,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: [
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.shared,
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.accent,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
                                            user: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "unfollow track author",
                                    disabled: unfollowAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).UserPlus, {})
                                })
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.features.follow.main,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: [
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.shared,
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
                                            user: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "follow track author",
                                    disabled: followAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).UserPlus, {})
                                })
                            }),
                            isAuthorCanReceivePayments && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.features.tip.main,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: [
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.shared,
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $2zsG4.tipOpenTipModal)({
                                            artist: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "send tip to track author",
                                    disabled: tipAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).DollarCircle, {})
                                })
                            }),
                            isAuthorCanReceivePayments && (isCurrentUserSubscribedToContentAuthor && !isCurrentUserSubscribedToContentAuthorAtPeriodEnd ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.features.unsubscribe.main,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: [
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.shared,
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.accent,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCancelModal)({
                                            artist: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "unsubscribe from track author",
                                    disabled: unsubscribeFromAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                                })
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $bI8qN.styles)(theme).track.panel.features.subscribe.main,
                                children: /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                                    css: [
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.shared,
                                        (0, $bI8qN.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: subscribeAction,
                                    type: "button",
                                    "aria-label": "subscribe to track author",
                                    disabled: subscribeToAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                                })
                            }))
                        ]
                    })
                ]
            })
        ]
    });
};
$e28beb13919bb4c3$export$24ab48c69fdb6c27.propTypes = {};

});
parcelRegister("bI8qN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $867b50844b9f8d99$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $867b50844b9f8d99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $867b50844b9f8d99$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $867b50844b9f8d99$var$_ref2 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $867b50844b9f8d99$var$_ref3 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $867b50844b9f8d99$var$_ref4 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $867b50844b9f8d99$var$_ref5 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $867b50844b9f8d99$var$_ref6 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $867b50844b9f8d99$var$_ref7 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $867b50844b9f8d99$var$_ref8 = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
var $867b50844b9f8d99$var$_ref9 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $867b50844b9f8d99$var$_ref10 = {
    name: "pit38s",
    styles: "height:auto"
};
var $867b50844b9f8d99$var$_ref11 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $867b50844b9f8d99$var$_ref12 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $867b50844b9f8d99$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;width:100%;", (0, $48E0n.mq).mobile($867b50844b9f8d99$var$_ref12), ";", ""),
            cover: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:200px;height:200px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:32px;&:hover>div{opacity:1;}", (0, $48E0n.mq).mobile($867b50844b9f8d99$var$_ref11), ";", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            panel: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:100%;height:200px;min-width:0;", (0, $48E0n.mq).mobile($867b50844b9f8d99$var$_ref10), ";", ""),
                description: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;min-width:0;margin-bottom:auto;", (0, $48E0n.mq).mobile($867b50844b9f8d99$var$_ref9), ";", ""),
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).h5, ";font-weight:bold;", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("text-align:center;font-size:", (0, $48E0n.typography).h6, ";", "")), ";", ""),
                    author: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).h6, ";color:", theme.colors.secondary.normal, ";text-align:start;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", (0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)("text-align:center;font-size:", (0, $48E0n.typography).p, ";", "")), ";", "")
                },
                features: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;&>div:not(:last-of-type){margin-right:16px;}", (0, $48E0n.mq).mobile($867b50844b9f8d99$var$_ref8), ";", ""),
                    like: {
                        main: $867b50844b9f8d99$var$_ref7
                    },
                    dislike: {
                        main: $867b50844b9f8d99$var$_ref6
                    },
                    follow: {
                        main: $867b50844b9f8d99$var$_ref5
                    },
                    unfollow: {
                        main: $867b50844b9f8d99$var$_ref4
                    },
                    tip: {
                        main: $867b50844b9f8d99$var$_ref3
                    },
                    subscribe: {
                        main: $867b50844b9f8d99$var$_ref2
                    },
                    unsubscribe: {
                        main: $867b50844b9f8d99$var$_ref
                    },
                    button: {
                        shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                        normal: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", ""),
                        accent: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", "")
                    }
                }
            }
        }
    });

});


parcelRegister("1S0Aa", function(module, exports) {

$parcel$export(module.exports, "TrackViewCreateStudio", function () { return $4ca9fb350ef79280$export$f6671100c2776887; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("jpMJW");
var $b5Xw3 = parcelRequire("b5Xw3");

var $dIx9o = parcelRequire("dIx9o");
const $4ca9fb350ef79280$export$f6671100c2776887 = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $dIx9o.styles)().card.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $dIx9o.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $dIx9o.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $b5Xw3.Form), {})
            })
        })
    });
$4ca9fb350ef79280$export$f6671100c2776887.propTypes = {};

});
parcelRegister("jpMJW", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("b5Xw3")).Form; });

var $b5Xw3 = parcelRequire("b5Xw3");

});
parcelRegister("b5Xw3", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $fb33597517bb25de$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $6U1f3 = parcelRequire("6U1f3");
var $jQMGL = parcelRequire("jQMGL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $9a5k4 = parcelRequire("9a5k4");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $fZeVI = parcelRequire("fZeVI");
var $1bnO9 = parcelRequire("1bnO9");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $lYvdp = parcelRequire("lYvdp");
var $bT0C4 = parcelRequire("bT0C4");
var $X9mpN = parcelRequire("X9mpN");
var $6FETc = parcelRequire("6FETc");
var $9TEV9 = parcelRequire("9TEV9");
var $f4vJY = parcelRequire("f4vJY");
var $lB36X = parcelRequire("lB36X");
var $eRGKc = parcelRequire("eRGKc");
var $1sbY5 = parcelRequire("1sbY5");
var $3wbuR = parcelRequire("3wbuR");
parcelRequire("buA0V");
var $7ji8h = parcelRequire("7ji8h");

var $bWZfK = parcelRequire("bWZfK");
const $fb33597517bb25de$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const trackCreateLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackCreateLoading));
    // connect ready
    const { ready: connectReady } = (0, $9a5k4.useConnectReady)(profile?.id || "");
    // cover state
    const [cover, setCover] = (0, $exYeM.useState)(undefined);
    const [coverPreview, setCoverPreview] = (0, $exYeM.useState)("");
    const coverFileInputRef = (0, $exYeM.useRef)(null);
    const [coverError, setCoverError] = (0, $exYeM.useState)("");
    // track state
    const [track, setTrack] = (0, $exYeM.useState)(undefined);
    const [trackFileName, setTrackFileName] = (0, $exYeM.useState)("");
    const trackFileInputRef = (0, $exYeM.useRef)(null);
    const [trackError, setTrackError] = (0, $exYeM.useState)("");
    // name state
    const [name, setName] = (0, $exYeM.useState)("");
    const [nameError, setNameError] = (0, $exYeM.useState)("");
    // genres state
    const [genres, setGenres] = (0, $exYeM.useState)([]);
    const [musicGenres, setMusicGenres] = (0, $exYeM.useState)((0, $jQMGL.musicGenres));
    // genres search state
    const [search, setSearch] = (0, $exYeM.useState)("");
    // visibility state
    const [visibility, setVisibility] = (0, $exYeM.useState)((0, $aeAwZ.EntityTrackVisibility).Public);
    // unlock price state
    const defaultUnlockPrice = Math.ceil((0, $6U1f3.maxTrackUnlockPrice) / 2);
    const [unlockPrice, setUnlockPrice] = (0, $exYeM.useState)(defaultUnlockPrice);
    const submitDisabled = name.length < (0, $6U1f3.minTrackNameLength) || name.length > (0, $6U1f3.maxTrackNameLength) || unlockPrice < (0, $6U1f3.minTrackUnlockPrice) || unlockPrice > (0, $6U1f3.maxTrackUnlockPrice) || track === undefined || coverError !== "" || trackError !== "" || nameError !== "" || trackCreateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setCover(undefined);
        setTrack(undefined);
        setName("");
        setTrackFileName("");
        setGenres([]);
        setVisibility((0, $aeAwZ.EntityTrackVisibility).Public);
        setUnlockPrice(defaultUnlockPrice);
        // if cover preview was set
        if (coverPreview) {
            // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            setCoverPreview("");
        }
    };
    const onCoverClick = ()=>{
        coverFileInputRef.current?.click();
        setCoverError("");
    };
    const onTrackClick = ()=>{
        trackFileInputRef.current?.click();
        setTrackError("");
    };
    const onCoverFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validateCoverFile)(file);
            if (error) {
                setCoverError(error);
                return;
            }
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            // set file as a preview
            setCoverPreview(URL.createObjectURL(file));
            // store file in state
            setCover(file);
        }
    };
    const onTrackFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validateTrackFile)(file);
            if (error) {
                setTrackError(error);
                return;
            }
            // store file name in state
            setTrackFileName(file.name);
            // store file in state
            setTrack(file);
        }
    };
    (0, $exYeM.useEffect)(()=>()=>{
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
        });
    (0, $exYeM.useEffect)(()=>{
        if (!trackCreateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        trackCreateLoading
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $bWZfK.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $bWZfK.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $fZeVI.trackCreate)({
                    name: name,
                    track: track,
                    cover: cover,
                    genres: genres,
                    visibility: visibility,
                    unlockPrice: unlockPrice
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bWZfK.styles)().form.content.cover.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bWZfK.styles)().form.content.cover.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Cover"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bWZfK.styles)().form.content.cover.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                                    css: (0, $bWZfK.styles)().form.content.cover.preview.label,
                                    htmlFor: "cover",
                                    children: [
                                        "cover",
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                            name: "cover",
                                            type: "file",
                                            id: "cover",
                                            ref: coverFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png",
                                            onChange: (e)=>onCoverFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $bWZfK.styles)().form.content.cover.preview.image,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3wbuR.MediaFilePreview), {
                                        source: coverPreview,
                                        type: "image",
                                        width: "140px",
                                        height: "140px",
                                        alt: "track cover",
                                        onClick: ()=>onCoverClick(),
                                        // formats={['JPG', 'JPEG', 'PNG', 'WEBP']}
                                        maxFileSize: (0, $6U1f3.maxTrackCoverFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bWZfK.styles)().form.content.cover.error,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                                error: coverError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $bWZfK.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eRGKc.InputLine), {
                        name: "name",
                        label: "Name",
                        type: "text",
                        placeholder: "Enter your name",
                        icon: (0, $9IIBp.icons).Edit,
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $6U1f3.minTrackNameLength),
                        max: (0, $6U1f3.maxTrackNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $33ayT.validateTrackName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bWZfK.styles)().form.content.track.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bWZfK.styles)().form.content.track.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Track"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bWZfK.styles)().form.content.track.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                                    css: (0, $bWZfK.styles)().form.content.track.preview.label,
                                    htmlFor: "track",
                                    children: [
                                        "track",
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                            name: "track",
                                            type: "file",
                                            id: "track",
                                            ref: trackFileInputRef,
                                            accept: ".mp3",
                                            onChange: (e)=>onTrackFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $bWZfK.styles)().form.content.track.preview.input,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7ji8h.TrackPreview), {
                                            fileName: trackFileName,
                                            label: "change or select track file",
                                            description: "Select track (.mp3)",
                                            error: trackError.length > 0,
                                            errorMessage: trackError,
                                            onClick: ()=>onTrackClick()
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bWZfK.styles)().form.content.genres.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bWZfK.styles)().form.content.genres.selected.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $bWZfK.styles)().form.content.genres.selected.label,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                        text: "Genre"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $bWZfK.styles)().form.content.genres.selected.genres,
                                    children: genres.map((trackGenre)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $bT0C4.BadgeSelected), {
                                            name: trackGenre,
                                            onRemoveClick: ()=>setGenres((state)=>state.filter((genre)=>genre !== trackGenre))
                                        }, `track-genres-${trackGenre}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bWZfK.styles)().form.content.genres.search.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $bWZfK.styles)().form.content.genres.search.input,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eRGKc.InputLine), {
                                        name: "search",
                                        label: "Select genre",
                                        type: "search",
                                        placeholder: "Find genre",
                                        icon: (0, $9IIBp.icons).Search,
                                        value: search,
                                        onChange: (e)=>{
                                            setSearch(e.target.value);
                                            setMusicGenres((0, $jQMGL.musicGenres).filter((genre)=>genre.toLowerCase().includes(e.target.value)));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $bWZfK.styles)().form.content.genres.search.genres,
                                    children: musicGenres.map((genre)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $lYvdp.Badge), {
                                            name: genre,
                                            disabled: genres.includes(genre) || genres.length >= (0, $jQMGL.maxTrackGenresCount),
                                            onClick: ()=>setGenres((state)=>[
                                                        ...state,
                                                        genre
                                                    ])
                                        }, `music-genres-${genre}`))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bWZfK.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bWZfK.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bWZfK.styles)().form.content.visibility.inputs,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the track is made publicly accessible to everyone on the platform",
                                    icon: (0, $9IIBp.icons).Unlock,
                                    checked: visibility === (0, $aeAwZ.EntityTrackVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityTrackVisibility).Public)
                                }),
                                connectReady && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the track is exclusively accessible to subscribers or individuals who unlock it directly",
                                    icon: (0, $9IIBp.icons).Lock,
                                    checked: visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityTrackVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $bWZfK.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bWZfK.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $bWZfK.styles)().form.content.price.amount,
                            children: [
                                "$",
                                unlockPrice
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $bWZfK.styles)().form.content.price.input,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f4vJY.InputAmount), {
                                name: "unlock-price",
                                label: "unlock price",
                                type: "range",
                                id: "unlock-price",
                                value: unlockPrice,
                                min: (0, $6U1f3.minTrackUnlockPrice),
                                max: (0, $6U1f3.maxTrackUnlockPrice),
                                onChange: (e)=>setUnlockPrice(parseInt(e.target.value, 10))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $bWZfK.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $bWZfK.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                            type: "submit",
                            "aria-label": "upload track",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: trackCreateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Upload"
                        })
                    })
                })
            ]
        })
    });
};
$fb33597517bb25de$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("buA0V", function(module, exports) {

$parcel$export(module.exports, "TrackPreview", function () { return (parcelRequire("7ji8h")).TrackPreview; });

var $7ji8h = parcelRequire("7ji8h");

});
parcelRegister("7ji8h", function(module, exports) {

$parcel$export(module.exports, "TrackPreview", function () { return $33bf2467c53071ec$export$caaa9e2fcf82fb06; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $7yGRd = parcelRequire("7yGRd");
const $33bf2467c53071ec$export$caaa9e2fcf82fb06 = ({ fileName: fileName, label: label, description: description, error: error, errorMessage: errorMessage, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $7yGRd.styles)(theme).preview.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                css: [
                    (0, $7yGRd.styles)(theme).preview.button.shared,
                    fileName ? (0, $7yGRd.styles)(theme).preview.button.filled : (0, $7yGRd.styles)(theme).preview.button.empty,
                    error && (0, $7yGRd.styles)(theme).preview.button.errored,
                    "",
                    ""
                ],
                onClick: (e)=>onClick(e),
                type: "button",
                "aria-label": label,
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $7yGRd.styles)(theme).preview.button.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $7yGRd.styles)(theme).preview.button.content.name,
                            children: fileName || description
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: [
                                (0, $7yGRd.styles)(theme).preview.button.content.icon.shared,
                                fileName ? (0, $7yGRd.styles)(theme).preview.button.content.icon.empty : (0, $7yGRd.styles)(theme).preview.button.content.icon.filled,
                                error && (0, $7yGRd.styles)(theme).preview.button.errored,
                                "",
                                ""
                            ],
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Upload, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: [
                    (0, $7yGRd.styles)(theme).preview.error.shared,
                    errorMessage ? (0, $7yGRd.styles)(theme).preview.error.visible : (0, $7yGRd.styles)(theme).preview.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                    css: [
                        (0, $7yGRd.styles)(theme).preview.error.text.shared,
                        errorMessage ? (0, $7yGRd.styles)(theme).preview.error.text.visible : (0, $7yGRd.styles)(theme).preview.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$33bf2467c53071ec$export$caaa9e2fcf82fb06.propTypes = {};

});
parcelRegister("7yGRd", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $484855831a9a6271$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $484855831a9a6271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $484855831a9a6271$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $484855831a9a6271$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $484855831a9a6271$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $484855831a9a6271$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $484855831a9a6271$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $484855831a9a6271$var$_ref6 = {
    name: "1jk7zt8",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0;width:28px;height:28px;&>svg{width:14px;height:14px;&>path{transition:fill 0.2s;}}"
};
var $484855831a9a6271$var$_ref7 = {
    name: "zjik7",
    styles: "display:flex"
};
var $484855831a9a6271$var$_ref8 = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $484855831a9a6271$export$9dd6ff9ea0189349 = (theme)=>({
        preview: {
            main: $484855831a9a6271$var$_ref8,
            button: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";width:100%;height:28px;font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).p, ";font-weight:bold;padding-bottom:2px;transition:border 0.2s,color 0.2s;cursor:pointer;", ""),
                empty: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.darker, ";", ""),
                filled: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                errored: /*#__PURE__*/ (0, $4N3Qt.css)("border-bottom:1px solid ", theme.colors.negative.normal, ";color:", theme.colors.negative.normal, ";", ""),
                content: {
                    main: $484855831a9a6271$var$_ref7,
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";margin-right:auto;", ""),
                    icon: {
                        shared: $484855831a9a6271$var$_ref6,
                        empty: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{color:", theme.colors.accent.normal, ";}", ""),
                        filled: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{color:", theme.colors.accent.normal, ";}", ""),
                        errored: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg>path{color:", theme.colors.negative.normal, ";}", "")
                    }
                }
            },
            error: {
                shared: $484855831a9a6271$var$_ref5,
                visible: $484855831a9a6271$var$_ref4,
                hidden: $484855831a9a6271$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $484855831a9a6271$var$_ref2,
                    hidden: $484855831a9a6271$var$_ref
                }
            }
        }
    });

});



parcelRegister("bWZfK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a69a69e551a48d2a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $a69a69e551a48d2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a69a69e551a48d2a$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $a69a69e551a48d2a$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $a69a69e551a48d2a$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a69a69e551a48d2a$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $a69a69e551a48d2a$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $a69a69e551a48d2a$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a69a69e551a48d2a$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $a69a69e551a48d2a$var$_ref8 = {
    name: "c1gao8",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:10px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $a69a69e551a48d2a$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a69a69e551a48d2a$var$_ref10 = {
    name: "1omvlk4",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:20px;}&>div:not(:last-of-type){margin-right:20px;}"
};
var $a69a69e551a48d2a$var$_ref11 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a69a69e551a48d2a$var$_ref12 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $a69a69e551a48d2a$var$_ref13 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $a69a69e551a48d2a$var$_ref14 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $a69a69e551a48d2a$var$_ref15 = {
    name: "eivff4",
    styles: "display:none"
};
var $a69a69e551a48d2a$var$_ref16 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a69a69e551a48d2a$var$_ref17 = {
    name: "1e5t4ul",
    styles: "display:flex;flex-direction:column;margin-bottom:50px"
};
var $a69a69e551a48d2a$var$_ref18 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $a69a69e551a48d2a$var$_ref19 = {
    name: "eivff4",
    styles: "display:none"
};
var $a69a69e551a48d2a$var$_ref20 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $a69a69e551a48d2a$var$_ref21 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a69a69e551a48d2a$var$_ref22 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $a69a69e551a48d2a$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                cover: {
                    main: $a69a69e551a48d2a$var$_ref22,
                    label: $a69a69e551a48d2a$var$_ref21,
                    preview: {
                        main: $a69a69e551a48d2a$var$_ref20,
                        label: $a69a69e551a48d2a$var$_ref19,
                        image: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                    },
                    error: $a69a69e551a48d2a$var$_ref18
                },
                track: {
                    main: $a69a69e551a48d2a$var$_ref17,
                    label: $a69a69e551a48d2a$var$_ref16,
                    preview: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        label: $a69a69e551a48d2a$var$_ref15,
                        input: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                    }
                },
                name: $a69a69e551a48d2a$var$_ref14,
                genres: {
                    main: $a69a69e551a48d2a$var$_ref13,
                    selected: {
                        main: $a69a69e551a48d2a$var$_ref12,
                        label: $a69a69e551a48d2a$var$_ref11,
                        genres: $a69a69e551a48d2a$var$_ref10
                    },
                    search: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        input: $a69a69e551a48d2a$var$_ref9,
                        genres: $a69a69e551a48d2a$var$_ref8
                    }
                },
                visibility: {
                    main: $a69a69e551a48d2a$var$_ref7,
                    label: $a69a69e551a48d2a$var$_ref6,
                    inputs: $a69a69e551a48d2a$var$_ref5
                },
                price: {
                    main: $a69a69e551a48d2a$var$_ref4,
                    label: $a69a69e551a48d2a$var$_ref3,
                    amount: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";line-height:24px;margin-bottom:10px;", ""),
                    input: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).tablet($a69a69e551a48d2a$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:220px;}", (0, $48E0n.mq).tablet($a69a69e551a48d2a$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("dIx9o", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $67b2ee58fcce14d6$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $67b2ee58fcce14d6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $67b2ee58fcce14d6$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $67b2ee58fcce14d6$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $67b2ee58fcce14d6$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $67b2ee58fcce14d6$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $67b2ee58fcce14d6$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:400px;", (0, $48E0n.mq).tablet($67b2ee58fcce14d6$var$_ref2), ";", ""),
                form: $67b2ee58fcce14d6$var$_ref
            }
        }
    });

});


parcelRegister("ivesH", function(module, exports) {

$parcel$export(module.exports, "TrackViewEditStudio", function () { return $3187c1d9759ffbcb$export$15771b0fb25d25b3; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("4iFwR");
var $10Juf = parcelRequire("10Juf");

var $kMszX = parcelRequire("kMszX");
const $3187c1d9759ffbcb$export$15771b0fb25d25b3 = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $kMszX.styles)().card.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $kMszX.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kMszX.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $10Juf.Form), {})
            })
        })
    });
$3187c1d9759ffbcb$export$15771b0fb25d25b3.propTypes = {};

});
parcelRegister("4iFwR", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("10Juf")).Form; });

var $10Juf = parcelRequire("10Juf");

});
parcelRegister("10Juf", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $526a6e1202cbad95$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("2uUQU");
var $6U1f3 = parcelRequire("6U1f3");
var $jQMGL = parcelRequire("jQMGL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("dmGpj");
var $1bnO9 = parcelRequire("1bnO9");
var $fZeVI = parcelRequire("fZeVI");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $lYvdp = parcelRequire("lYvdp");
var $bT0C4 = parcelRequire("bT0C4");
var $X9mpN = parcelRequire("X9mpN");
var $6FETc = parcelRequire("6FETc");
var $9TEV9 = parcelRequire("9TEV9");
var $lB36X = parcelRequire("lB36X");
var $eRGKc = parcelRequire("eRGKc");
var $1sbY5 = parcelRequire("1sbY5");
var $3wbuR = parcelRequire("3wbuR");

var $cdQh1 = parcelRequire("cdQh1");
const $526a6e1202cbad95$export$a7fed597f4b8afd8 = ()=>{
    const { trackId: trackId } = (0, $fbE6a.useParams)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const trackUpdateLoading = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectTrackUpdateLoading));
    const uploadedTracks = (0, $9CcOD.useAppSelector)((0, $1bnO9.trackSelectUploadedTracks));
    const track = uploadedTracks.find((t)=>t.id === trackId);
    const { coverId: coverId, name: currentName, genres: currentGenres, visibility: currentVisibility, unlockPrice: currentUnlockPrice } = track ?? {};
    // cover state
    const trackHasCover = !!coverId;
    const trackCover = (0, $hrd7b.useFile)(coverId || "");
    const [cover, setCover] = (0, $exYeM.useState)(undefined);
    const [coverPreview, setCoverPreview] = (0, $exYeM.useState)(trackHasCover ? trackCover : "");
    const coverFileInputRef = (0, $exYeM.useRef)(null);
    const [coverError, setCoverError] = (0, $exYeM.useState)("");
    // name state
    const [name, setName] = (0, $exYeM.useState)(currentName || "");
    const [nameError, setNameError] = (0, $exYeM.useState)("");
    // genres state
    const [genres, setGenres] = (0, $exYeM.useState)(currentGenres || []);
    const [musicGenres, setMusicGenres] = (0, $exYeM.useState)((0, $jQMGL.musicGenres));
    // genres search state
    const [search, setSearch] = (0, $exYeM.useState)("");
    // visibility state
    const [visibility, setVisibility] = (0, $exYeM.useState)(currentVisibility || (0, $aeAwZ.EntityTrackVisibility).Public);
    const nameUnchanged = name === currentName;
    const genresUnchanged = genres.join("") === currentGenres?.join("");
    const coverNotSelected = cover === undefined;
    const trackDefaultsUnchanged = nameUnchanged && genresUnchanged && coverNotSelected;
    const submitDisabled = trackDefaultsUnchanged || name.length < (0, $6U1f3.minTrackNameLength) || name.length > (0, $6U1f3.maxTrackNameLength) || coverError !== "" || nameError !== "" || trackUpdateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setCover(undefined);
        setName(currentName || "");
        setGenres(currentGenres || []);
        setVisibility(currentVisibility || (0, $aeAwZ.EntityTrackVisibility).Public);
    };
    const onCoverClick = ()=>{
        coverFileInputRef.current?.click();
        setCoverError("");
    };
    const onCoverFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validateCoverFile)(file);
            if (error) {
                setCoverError(error);
                return;
            }
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            // set file as a preview
            setCoverPreview(URL.createObjectURL(file));
            // store file in state
            setCover(file);
        }
    };
    (0, $exYeM.useEffect)(()=>()=>{
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
        });
    (0, $exYeM.useEffect)(()=>{
        if (!trackUpdateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        trackUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cdQh1.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $cdQh1.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $fZeVI.trackUpdate)({
                    track: track || {},
                    name: name,
                    cover: cover,
                    genres: genres
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $cdQh1.styles)().form.content.cover.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $cdQh1.styles)().form.content.cover.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Cover"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $cdQh1.styles)().form.content.cover.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                                    css: (0, $cdQh1.styles)().form.content.cover.preview.label,
                                    htmlFor: "cover",
                                    children: [
                                        "cover",
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                            name: "cover",
                                            type: "file",
                                            id: "cover",
                                            ref: coverFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png",
                                            onChange: (e)=>onCoverFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $cdQh1.styles)().form.content.cover.preview.image,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3wbuR.MediaFilePreview), {
                                        source: coverPreview,
                                        type: "image",
                                        width: "140px",
                                        height: "140px",
                                        alt: "track cover",
                                        onClick: ()=>onCoverClick(),
                                        // formats={['JPG', 'JPEG', 'PNG', 'WEBP']}
                                        maxFileSize: (0, $6U1f3.maxTrackCoverFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $cdQh1.styles)().form.content.cover.error,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                                error: coverError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $cdQh1.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eRGKc.InputLine), {
                        name: "name",
                        label: "Name",
                        type: "text",
                        placeholder: "Enter your name",
                        icon: (0, $9IIBp.icons).Edit,
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $6U1f3.minTrackNameLength),
                        max: (0, $6U1f3.maxTrackNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $33ayT.validateTrackName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $cdQh1.styles)().form.content.genres.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $cdQh1.styles)().form.content.genres.selected.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $cdQh1.styles)().form.content.genres.selected.label,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                        text: "Genre"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $cdQh1.styles)().form.content.genres.selected.genres,
                                    children: genres.map((trackGenre)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $bT0C4.BadgeSelected), {
                                            name: trackGenre,
                                            onRemoveClick: ()=>setGenres((state)=>state.filter((genre)=>genre !== trackGenre))
                                        }, `track-genres-${trackGenre}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $cdQh1.styles)().form.content.genres.search.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $cdQh1.styles)().form.content.genres.search.input,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eRGKc.InputLine), {
                                        name: "search",
                                        label: "Select genre",
                                        type: "search",
                                        placeholder: "Find genre",
                                        icon: (0, $9IIBp.icons).Search,
                                        value: search,
                                        onChange: (e)=>{
                                            setSearch(e.target.value);
                                            setMusicGenres((0, $jQMGL.musicGenres).filter((genre)=>genre.toLowerCase().includes(e.target.value)));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $cdQh1.styles)().form.content.genres.search.genres,
                                    children: musicGenres.map((genre)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $lYvdp.Badge), {
                                            name: genre,
                                            disabled: genres.includes(genre) || genres.length >= (0, $jQMGL.maxTrackGenresCount),
                                            onClick: ()=>setGenres((state)=>[
                                                        ...state,
                                                        genre
                                                    ])
                                        }, `music-genres-${genre}`))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $cdQh1.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $cdQh1.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $cdQh1.styles)().form.content.visibility.inputs,
                            children: [
                                visibility === (0, $aeAwZ.EntityTrackVisibility).Public && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the track is made publicly accessible to everyone on the platform",
                                    icon: (0, $9IIBp.icons).Unlock,
                                    checked: visibility === (0, $aeAwZ.EntityTrackVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityTrackVisibility).Public)
                                }),
                                visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6FETc.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the track is exclusively accessible to subscribers or individuals who unlock it directly",
                                    icon: (0, $9IIBp.icons).Lock,
                                    checked: visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $aeAwZ.EntityTrackVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $cdQh1.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $cdQh1.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $cdQh1.styles)().form.content.price.amount,
                            children: [
                                "$",
                                (currentUnlockPrice || 0) / 100
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $cdQh1.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $cdQh1.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                            type: "submit",
                            "aria-label": "update track",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: trackUpdateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Update"
                        })
                    })
                })
            ]
        })
    });
};
$526a6e1202cbad95$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("cdQh1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b9455f7e32e3f550$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b9455f7e32e3f550$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b9455f7e32e3f550$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $b9455f7e32e3f550$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $b9455f7e32e3f550$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $b9455f7e32e3f550$var$_ref4 = {
    name: "j9ove5",
    styles: "margin-bottom:22px"
};
var $b9455f7e32e3f550$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $b9455f7e32e3f550$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $b9455f7e32e3f550$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $b9455f7e32e3f550$var$_ref8 = {
    name: "c1gao8",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:10px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $b9455f7e32e3f550$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $b9455f7e32e3f550$var$_ref10 = {
    name: "1omvlk4",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:20px;}&>div:not(:last-of-type){margin-right:20px;}"
};
var $b9455f7e32e3f550$var$_ref11 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $b9455f7e32e3f550$var$_ref12 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $b9455f7e32e3f550$var$_ref13 = {
    name: "qkomnt",
    styles: "margin-bottom:40px"
};
var $b9455f7e32e3f550$var$_ref14 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $b9455f7e32e3f550$var$_ref15 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $b9455f7e32e3f550$var$_ref16 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $b9455f7e32e3f550$var$_ref17 = {
    name: "eivff4",
    styles: "display:none"
};
var $b9455f7e32e3f550$var$_ref18 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $b9455f7e32e3f550$var$_ref19 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $b9455f7e32e3f550$var$_ref20 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $b9455f7e32e3f550$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                cover: {
                    main: $b9455f7e32e3f550$var$_ref20,
                    label: $b9455f7e32e3f550$var$_ref19,
                    preview: {
                        main: $b9455f7e32e3f550$var$_ref18,
                        label: $b9455f7e32e3f550$var$_ref17,
                        image: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                    },
                    error: $b9455f7e32e3f550$var$_ref16
                },
                name: $b9455f7e32e3f550$var$_ref15,
                username: $b9455f7e32e3f550$var$_ref14,
                genres: {
                    main: $b9455f7e32e3f550$var$_ref13,
                    selected: {
                        main: $b9455f7e32e3f550$var$_ref12,
                        label: $b9455f7e32e3f550$var$_ref11,
                        genres: $b9455f7e32e3f550$var$_ref10
                    },
                    search: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        input: $b9455f7e32e3f550$var$_ref9,
                        genres: $b9455f7e32e3f550$var$_ref8
                    }
                },
                visibility: {
                    main: $b9455f7e32e3f550$var$_ref7,
                    label: $b9455f7e32e3f550$var$_ref6,
                    inputs: $b9455f7e32e3f550$var$_ref5
                },
                price: {
                    main: $b9455f7e32e3f550$var$_ref4,
                    label: $b9455f7e32e3f550$var$_ref3,
                    amount: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h4, ";line-height:24px;margin-bottom:10px;", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).tablet($b9455f7e32e3f550$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:220px;}", (0, $48E0n.mq).tablet($b9455f7e32e3f550$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("kMszX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a290b404611c4013$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $a290b404611c4013$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a290b404611c4013$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $a290b404611c4013$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $a290b404611c4013$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $a290b404611c4013$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $a290b404611c4013$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:400px;", (0, $48E0n.mq).tablet($a290b404611c4013$var$_ref2), ";", ""),
                form: $a290b404611c4013$var$_ref
            }
        }
    });

});



parcelRegister("ebSIw", function(module, exports) {

$parcel$export(module.exports, "trackUtilGetTrackTileSkeletonSections", function () { return $3ea754170a4fd8f8$export$ce2eef85e2d4c0d7; });
const $3ea754170a4fd8f8$export$ce2eef85e2d4c0d7 = (sectionName)=>[
        {
            name: `${sectionName}-media`,
            width: "180px",
            height: "180px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider`,
            width: "180px",
            height: "10px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-description`,
            width: "180px",
            height: "38px",
            isStatic: true,
            isDivider: false
        }
    ];

});

parcelRegister("1bnO9", function(module, exports) {

$parcel$export(module.exports, "trackSlice", function () { return $09ed7a873dc6ee0b$export$a3d6f2521ab23ff4; });
$parcel$export(module.exports, "trackResetState", function () { return $09ed7a873dc6ee0b$export$91afce20dedb32ac; });
$parcel$export(module.exports, "trackSetPublicTracks", function () { return $09ed7a873dc6ee0b$export$2d7ecf5aea6fabe7; });
$parcel$export(module.exports, "trackSetPopularTracks", function () { return $09ed7a873dc6ee0b$export$c911a6cb418acc4a; });
$parcel$export(module.exports, "trackSetExclusiveTracks", function () { return $09ed7a873dc6ee0b$export$ba92f12611d6e509; });
$parcel$export(module.exports, "trackSetLatestTracks", function () { return $09ed7a873dc6ee0b$export$821dde0cff897f4c; });
$parcel$export(module.exports, "trackSetTrendingTracks", function () { return $09ed7a873dc6ee0b$export$85f6b0beeb7c7923; });
$parcel$export(module.exports, "trackSetRecommendedTracks", function () { return $09ed7a873dc6ee0b$export$535c0003673c0bae; });
$parcel$export(module.exports, "trackSetLikedTracks", function () { return $09ed7a873dc6ee0b$export$b1024953c618252f; });
$parcel$export(module.exports, "trackSetUnlockedTracks", function () { return $09ed7a873dc6ee0b$export$4dbbdb417cd9533b; });
$parcel$export(module.exports, "trackSetUploadedTracks", function () { return $09ed7a873dc6ee0b$export$35e8364feff109ed; });
$parcel$export(module.exports, "trackSetArtistPopularTracks", function () { return $09ed7a873dc6ee0b$export$7d7c134223540010; });
$parcel$export(module.exports, "trackSetArtistExclusiveTracks", function () { return $09ed7a873dc6ee0b$export$6429021d85ed6478; });
$parcel$export(module.exports, "trackSetArtistLatestTracks", function () { return $09ed7a873dc6ee0b$export$420feca5c0f2e889; });
$parcel$export(module.exports, "trackResetArtistTracks", function () { return $09ed7a873dc6ee0b$export$d742c877f096cf38; });
$parcel$export(module.exports, "trackSetPostTracks", function () { return $09ed7a873dc6ee0b$export$236c041833b35867; });
$parcel$export(module.exports, "trackResetPostTracks", function () { return $09ed7a873dc6ee0b$export$1c19257305af6d24; });
$parcel$export(module.exports, "trackAppendLikedTrack", function () { return $09ed7a873dc6ee0b$export$2c56715bdb589a3d; });
$parcel$export(module.exports, "trackFilterLikedTrack", function () { return $09ed7a873dc6ee0b$export$105c65e084ab827c; });
$parcel$export(module.exports, "trackAppendUnlockedTrack", function () { return $09ed7a873dc6ee0b$export$5ca905dee28a2d99; });
$parcel$export(module.exports, "trackFilterUnlockedTrack", function () { return $09ed7a873dc6ee0b$export$edb49a15130cb96d; });
$parcel$export(module.exports, "trackFilterTrack", function () { return $09ed7a873dc6ee0b$export$d86d1aaa5820656c; });
$parcel$export(module.exports, "trackFilterUserTracks", function () { return $09ed7a873dc6ee0b$export$85e845fda476ba58; });
$parcel$export(module.exports, "trackUpdateTrack", function () { return $09ed7a873dc6ee0b$export$3c3a856b71c10cd2; });
$parcel$export(module.exports, "trackOpenTrackBlockModal", function () { return $09ed7a873dc6ee0b$export$56e331a908d904d5; });
$parcel$export(module.exports, "trackCloseTrackBlockModal", function () { return $09ed7a873dc6ee0b$export$6811b8863997ba45; });
$parcel$export(module.exports, "trackOpenTrackDeleteModal", function () { return $09ed7a873dc6ee0b$export$2de241ab12382de6; });
$parcel$export(module.exports, "trackCloseTrackDeleteModal", function () { return $09ed7a873dc6ee0b$export$bbe0b92674fa755e; });
$parcel$export(module.exports, "trackSelectPublicTracks", function () { return $09ed7a873dc6ee0b$export$47564cb5d8147207; });
$parcel$export(module.exports, "trackSelectPublicTracksLength", function () { return $09ed7a873dc6ee0b$export$f9b9ca0cc1f5cfce; });
$parcel$export(module.exports, "trackSelectPublicTracksCount", function () { return $09ed7a873dc6ee0b$export$a3ec4174f8290ea1; });
$parcel$export(module.exports, "trackSelectPublicTracksFetched", function () { return $09ed7a873dc6ee0b$export$f039f0f464c79d83; });
$parcel$export(module.exports, "trackSelectPopularTracks", function () { return $09ed7a873dc6ee0b$export$4c37c8f4ddb5ccdd; });
$parcel$export(module.exports, "trackSelectPopularTracksLength", function () { return $09ed7a873dc6ee0b$export$58a8663ddd7bfa52; });
$parcel$export(module.exports, "trackSelectPopularTracksCount", function () { return $09ed7a873dc6ee0b$export$62d4bca2ea171ac2; });
$parcel$export(module.exports, "trackSelectPopularTracksFetched", function () { return $09ed7a873dc6ee0b$export$226bc2dcf7547000; });
$parcel$export(module.exports, "trackSelectExclusiveTracks", function () { return $09ed7a873dc6ee0b$export$e37f1fe62af44d2e; });
$parcel$export(module.exports, "trackSelectExclusiveTracksLength", function () { return $09ed7a873dc6ee0b$export$ce85ccdd80284243; });
$parcel$export(module.exports, "trackSelectExclusiveTracksCount", function () { return $09ed7a873dc6ee0b$export$69d3f01427ab5991; });
$parcel$export(module.exports, "trackSelectExclusiveTracksFetched", function () { return $09ed7a873dc6ee0b$export$c6816f57f96de775; });
$parcel$export(module.exports, "trackSelectLatestTracks", function () { return $09ed7a873dc6ee0b$export$90d97c0db639420a; });
$parcel$export(module.exports, "trackSelectLatestTracksLength", function () { return $09ed7a873dc6ee0b$export$9a6fce8c107f08e9; });
$parcel$export(module.exports, "trackSelectLatestTracksCount", function () { return $09ed7a873dc6ee0b$export$8e8fc430e197b863; });
$parcel$export(module.exports, "trackSelectLatestTracksFetched", function () { return $09ed7a873dc6ee0b$export$401eea2f5ce1ff4b; });
$parcel$export(module.exports, "trackSelectTrendingTracks", function () { return $09ed7a873dc6ee0b$export$b5066207a175173a; });
$parcel$export(module.exports, "trackSelectTrendingTracksLength", function () { return $09ed7a873dc6ee0b$export$43b5c9b6c0d0dadd; });
$parcel$export(module.exports, "trackSelectTrendingTracksCount", function () { return $09ed7a873dc6ee0b$export$a04c165a82b3cbc4; });
$parcel$export(module.exports, "trackSelectTrendingTracksFetched", function () { return $09ed7a873dc6ee0b$export$87f17186a6cf9d3b; });
$parcel$export(module.exports, "trackSelectRecommendedTracks", function () { return $09ed7a873dc6ee0b$export$e5e50bc712e38d93; });
$parcel$export(module.exports, "trackSelectRecommendedTracksLength", function () { return $09ed7a873dc6ee0b$export$4411836d2a84bab1; });
$parcel$export(module.exports, "trackSelectRecommendedTracksCount", function () { return $09ed7a873dc6ee0b$export$f1ac8d7f901cff94; });
$parcel$export(module.exports, "trackSelectRecommendedTracksFetched", function () { return $09ed7a873dc6ee0b$export$bb2b22d1dbb538c5; });
$parcel$export(module.exports, "trackSelectLikedTracks", function () { return $09ed7a873dc6ee0b$export$35df9b11880abfde; });
$parcel$export(module.exports, "trackSelectLikedTracksLength", function () { return $09ed7a873dc6ee0b$export$f2f25b45129fd9bf; });
$parcel$export(module.exports, "trackSelectLikedTracksCount", function () { return $09ed7a873dc6ee0b$export$2146ae74a6c967e9; });
$parcel$export(module.exports, "trackSelectLikedTracksFetched", function () { return $09ed7a873dc6ee0b$export$928b86b46ccdda3b; });
$parcel$export(module.exports, "trackSelectUnlockedTracks", function () { return $09ed7a873dc6ee0b$export$a22acbc5ae261a16; });
$parcel$export(module.exports, "trackSelectUnlockedTracksLength", function () { return $09ed7a873dc6ee0b$export$e8d801ab210db7ab; });
$parcel$export(module.exports, "trackSelectUnlockedTracksCount", function () { return $09ed7a873dc6ee0b$export$a5125418d1c9c810; });
$parcel$export(module.exports, "trackSelectUnlockedTracksFetched", function () { return $09ed7a873dc6ee0b$export$504378086fb25edd; });
$parcel$export(module.exports, "trackSelectUploadedTracks", function () { return $09ed7a873dc6ee0b$export$8207498fbe72f46; });
$parcel$export(module.exports, "trackSelectUploadedTracksLength", function () { return $09ed7a873dc6ee0b$export$22a092517e09c0d; });
$parcel$export(module.exports, "trackSelectUploadedTracksCount", function () { return $09ed7a873dc6ee0b$export$27e0ae462cc2be1e; });
$parcel$export(module.exports, "trackSelectUploadedTracksFetched", function () { return $09ed7a873dc6ee0b$export$a9a4448b2e07780; });
$parcel$export(module.exports, "trackSelectArtistPopularTracks", function () { return $09ed7a873dc6ee0b$export$111a3c3534ddce76; });
$parcel$export(module.exports, "trackSelectArtistPopularTracksLength", function () { return $09ed7a873dc6ee0b$export$1092d17ce779b213; });
$parcel$export(module.exports, "trackSelectArtistPopularTracksCount", function () { return $09ed7a873dc6ee0b$export$2d7a26414c6d58ac; });
$parcel$export(module.exports, "trackSelectArtistPopularTracksFetched", function () { return $09ed7a873dc6ee0b$export$b65214841fdacb75; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracks", function () { return $09ed7a873dc6ee0b$export$7ec3893edfc43a66; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracksLength", function () { return $09ed7a873dc6ee0b$export$ee53d2e211394bc9; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracksCount", function () { return $09ed7a873dc6ee0b$export$62ac15c1e4cbd19e; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracksFetched", function () { return $09ed7a873dc6ee0b$export$5a188b1cb81c365f; });
$parcel$export(module.exports, "trackSelectArtistLatestTracks", function () { return $09ed7a873dc6ee0b$export$d8936ba0cbd1cc2b; });
$parcel$export(module.exports, "trackSelectArtistLatestTracksLength", function () { return $09ed7a873dc6ee0b$export$c3e0fa980513d7e3; });
$parcel$export(module.exports, "trackSelectArtistLatestTracksCount", function () { return $09ed7a873dc6ee0b$export$24fc321fc9d0319a; });
$parcel$export(module.exports, "trackSelectArtistLatestTracksFetched", function () { return $09ed7a873dc6ee0b$export$b10cc2dffa5268ea; });
$parcel$export(module.exports, "trackSelectPostTracks", function () { return $09ed7a873dc6ee0b$export$7cfade53894d2355; });
$parcel$export(module.exports, "trackSelectPostTracksFetched", function () { return $09ed7a873dc6ee0b$export$8bca47c1f4b2b968; });
$parcel$export(module.exports, "trackSelectTrackBlockModalOpen", function () { return $09ed7a873dc6ee0b$export$e30c4435926569f1; });
$parcel$export(module.exports, "trackSelectTrackBlockModalTrack", function () { return $09ed7a873dc6ee0b$export$18e4366d1e17c8e0; });
$parcel$export(module.exports, "trackSelectTrackDeleteModalOpen", function () { return $09ed7a873dc6ee0b$export$6c8a6385741ff7b6; });
$parcel$export(module.exports, "trackSelectTrackDeleteModalTrack", function () { return $09ed7a873dc6ee0b$export$6cb3e01afd8d3c94; });
$parcel$export(module.exports, "trackSelectTrackGetPublicTracksLoading", function () { return $09ed7a873dc6ee0b$export$405ef44e6ed74011; });
$parcel$export(module.exports, "trackSelectTrackGetPopularTracksLoading", function () { return $09ed7a873dc6ee0b$export$ae8b9e001696b5cf; });
$parcel$export(module.exports, "trackSelectTrackGetExclusiveTracksLoading", function () { return $09ed7a873dc6ee0b$export$d2c296bdb2317093; });
$parcel$export(module.exports, "trackSelectTrackGetLatestTracksLoading", function () { return $09ed7a873dc6ee0b$export$d335e3779b1f7f7e; });
$parcel$export(module.exports, "trackSelectTrackGetTrendingTracksLoading", function () { return $09ed7a873dc6ee0b$export$913df1835a6c3f1e; });
$parcel$export(module.exports, "trackSelectTrackGetRecommendedTracksLoading", function () { return $09ed7a873dc6ee0b$export$cfc3b6c697b820ca; });
$parcel$export(module.exports, "trackSelectTrackGetLikedTracksLoading", function () { return $09ed7a873dc6ee0b$export$b8b634e26fb18437; });
$parcel$export(module.exports, "trackSelectTrackGetUnlockedTracksLoading", function () { return $09ed7a873dc6ee0b$export$e693f231ed8581d9; });
$parcel$export(module.exports, "trackSelectTrackGetUploadedTracksLoading", function () { return $09ed7a873dc6ee0b$export$eb68542484efa1fe; });
$parcel$export(module.exports, "trackSelectTrackGetArtistPopularTracksLoading", function () { return $09ed7a873dc6ee0b$export$469daa70a5bdb26f; });
$parcel$export(module.exports, "trackSelectTrackGetArtistExclusiveTracksLoading", function () { return $09ed7a873dc6ee0b$export$a14d11ba620ac874; });
$parcel$export(module.exports, "trackSelectTrackGetArtistLatestTracksLoading", function () { return $09ed7a873dc6ee0b$export$724cd8f38778db29; });
$parcel$export(module.exports, "trackSelectTrackGetPostTracksLoading", function () { return $09ed7a873dc6ee0b$export$9aad2ecb49cd085b; });
$parcel$export(module.exports, "trackSelectTrackCreateLoading", function () { return $09ed7a873dc6ee0b$export$4133c331aede8f7b; });
$parcel$export(module.exports, "trackSelectTrackUpdateLoading", function () { return $09ed7a873dc6ee0b$export$b23ee01741eaf3c9; });
$parcel$export(module.exports, "trackSelectTrackBlockLoading", function () { return $09ed7a873dc6ee0b$export$dc2ec62f755fa49a; });
$parcel$export(module.exports, "trackSelectTrackDeleteLoading", function () { return $09ed7a873dc6ee0b$export$7e1ad1aad8696bcb; });
$parcel$export(module.exports, "trackReducer", function () { return $09ed7a873dc6ee0b$export$e4057e913f54cc7e; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $fZeVI = parcelRequire("fZeVI");
const $09ed7a873dc6ee0b$var$initialState = {
    publicTracks: [],
    publicTracksCount: 0,
    publicTracksFetched: false,
    popularTracks: [],
    popularTracksCount: 0,
    popularTracksFetched: false,
    exclusiveTracks: [],
    exclusiveTracksCount: 0,
    exclusiveTracksFetched: false,
    latestTracks: [],
    latestTracksCount: 0,
    latestTracksFetched: false,
    trendingTracks: [],
    trendingTracksCount: 0,
    trendingTracksFetched: false,
    recommendedTracks: [],
    recommendedTracksCount: 0,
    recommendedTracksFetched: false,
    likedTracks: [],
    likedTracksCount: 0,
    likedTracksFetched: false,
    unlockedTracks: [],
    unlockedTracksCount: 0,
    unlockedTracksFetched: false,
    uploadedTracks: [],
    uploadedTracksCount: 0,
    uploadedTracksFetched: false,
    artistPopularTracks: [],
    artistPopularTracksCount: 0,
    artistPopularTracksFetched: false,
    artistExclusiveTracks: [],
    artistExclusiveTracksCount: 0,
    artistExclusiveTracksFetched: false,
    artistLatestTracks: [],
    artistLatestTracksCount: 0,
    artistLatestTracksFetched: false,
    postTracks: [],
    postTracksFetched: false,
    trackBlockModal: {
        track: undefined,
        open: false
    },
    trackDeleteModal: {
        track: undefined,
        open: false
    },
    trackGetPublicTracksLoading: false,
    trackGetPopularTracksLoading: false,
    trackGetExclusiveTracksLoading: false,
    trackGetLatestTracksLoading: false,
    trackGetTrendingTracksLoading: false,
    trackGetRecommendedTracksLoading: false,
    trackGetLikedTracksLoading: false,
    trackGetUnlockedTracksLoading: false,
    trackGetUploadedTracksLoading: false,
    trackGetArtistPopularTracksLoading: false,
    trackGetArtistExclusiveTracksLoading: false,
    trackGetArtistLatestTracksLoading: false,
    trackGetPostTracksLoading: false,
    trackCreateLoading: false,
    trackUpdateLoading: false,
    trackBlockLoading: false,
    trackDeleteLoading: false
};
const $09ed7a873dc6ee0b$export$a3d6f2521ab23ff4 = (0, $dEr3t.createSlice)({
    name: "track",
    initialState: $09ed7a873dc6ee0b$var$initialState,
    reducers: {
        // reset state
        trackResetState: ()=>({
                publicTracks: [],
                publicTracksCount: 0,
                publicTracksFetched: false,
                popularTracks: [],
                popularTracksCount: 0,
                popularTracksFetched: false,
                exclusiveTracks: [],
                exclusiveTracksCount: 0,
                exclusiveTracksFetched: false,
                latestTracks: [],
                latestTracksCount: 0,
                latestTracksFetched: false,
                trendingTracks: [],
                trendingTracksCount: 0,
                trendingTracksFetched: false,
                recommendedTracks: [],
                recommendedTracksCount: 0,
                recommendedTracksFetched: false,
                likedTracks: [],
                likedTracksCount: 0,
                likedTracksFetched: false,
                unlockedTracks: [],
                unlockedTracksCount: 0,
                unlockedTracksFetched: false,
                profileTracks: [],
                profileTracksCount: 0,
                profileTracksFetched: false,
                uploadedTracks: [],
                uploadedTracksCount: 0,
                uploadedTracksFetched: false,
                artistPopularTracks: [],
                artistPopularTracksCount: 0,
                artistPopularTracksFetched: false,
                artistExclusiveTracks: [],
                artistExclusiveTracksCount: 0,
                artistExclusiveTracksFetched: false,
                artistLatestTracks: [],
                artistLatestTracksCount: 0,
                artistLatestTracksFetched: false,
                postTracks: [],
                postTracksFetched: false,
                trackBlockModal: {
                    track: undefined,
                    open: false
                },
                trackDeleteModal: {
                    track: undefined,
                    open: false
                },
                trackGetPublicTracksLoading: false,
                trackGetPopularTracksLoading: false,
                trackGetExclusiveTracksLoading: false,
                trackGetLatestTracksLoading: false,
                trackGetTrendingTracksLoading: false,
                trackGetRecommendedTracksLoading: false,
                trackGetLikedTracksLoading: false,
                trackGetUnlockedTracksLoading: false,
                trackGetUploadedTracksLoading: false,
                trackGetArtistPopularTracksLoading: false,
                trackGetArtistExclusiveTracksLoading: false,
                trackGetArtistLatestTracksLoading: false,
                trackGetPostTracksLoading: false,
                trackCreateLoading: false,
                trackUpdateLoading: false,
                trackBlockLoading: false,
                trackDeleteLoading: false
            }),
        // set public tracks
        trackSetPublicTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.publicTracksCount = count;
                // mutate public tracks array
                state.publicTracks = (0, $9UVKd.mergeArraysAtIndex)(state.publicTracks, tracks, offset);
            }
        },
        // set popular tracks
        trackSetPopularTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.popularTracksCount = count;
                // mutate popular tracks array
                state.popularTracks = (0, $9UVKd.mergeArraysAtIndex)(state.popularTracks, tracks, offset);
            }
        },
        // set exclusive tracks
        trackSetExclusiveTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.exclusiveTracksCount = count;
                // mutate exclusive tracks array
                state.exclusiveTracks = (0, $9UVKd.mergeArraysAtIndex)(state.exclusiveTracks, tracks, offset);
            }
        },
        // set latest tracks
        trackSetLatestTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.latestTracksCount = count;
                // mutate latest tracks array
                state.latestTracks = (0, $9UVKd.mergeArraysAtIndex)(state.latestTracks, tracks, offset);
            }
        },
        // set trending tracks
        trackSetTrendingTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.trendingTracksCount = count;
                // mutate trending tracks array
                state.trendingTracks = (0, $9UVKd.mergeArraysAtIndex)(state.trendingTracks, tracks, offset);
            }
        },
        // set recommended tracks
        trackSetRecommendedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.recommendedTracksCount = count;
                // mutate recommended tracks array
                state.recommendedTracks = (0, $9UVKd.mergeArraysAtIndex)(state.recommendedTracks, tracks, offset);
            }
        },
        // set liked tracks
        trackSetLikedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.likedTracksCount = count;
                // mutate liked tracks array
                state.likedTracks = (0, $9UVKd.mergeArraysAtIndex)(state.likedTracks, tracks, offset);
            }
        },
        // set unlocked tracks
        trackSetUnlockedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.unlockedTracksCount = count;
                // mutate unlocked tracks array
                state.unlockedTracks = (0, $9UVKd.mergeArraysAtIndex)(state.unlockedTracks, tracks, offset);
            }
        },
        // set uploaded tracks
        trackSetUploadedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.uploadedTracksCount = count;
                // mutate uploaded tracks array
                state.uploadedTracks = (0, $9UVKd.mergeArraysAtIndex)(state.uploadedTracks, tracks, offset);
            }
        },
        // set artist popular tracks
        trackSetArtistPopularTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistPopularTracksCount = count;
            // mutate artist popular tracks array
            state.artistPopularTracks = (0, $9UVKd.mergeArraysAtIndex)(state.artistPopularTracks, tracks, offset);
        },
        // set artist exclusive tracks
        trackSetArtistExclusiveTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistExclusiveTracksCount = count;
            // mutate artist exclusive tracks array
            state.artistExclusiveTracks = (0, $9UVKd.mergeArraysAtIndex)(state.artistExclusiveTracks, tracks, offset);
        },
        // set artist latest tracks
        trackSetArtistLatestTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistLatestTracksCount = count;
            // mutate artist latest tracks array
            state.artistLatestTracks = (0, $9UVKd.mergeArraysAtIndex)(state.artistLatestTracks, tracks, offset);
        },
        // reset artist tracks
        trackResetArtistTracks: (state)=>({
                ...state,
                artistPopularTracks: [],
                artistPopularTracksCount: 0,
                artistPopularTracksFetched: false,
                artistExclusiveTracks: [],
                artistExclusiveTracksCount: 0,
                artistExclusiveTracksFetched: false,
                artistLatestTracks: [],
                artistLatestTracksCount: 0,
                artistLatestTracksFetched: false
            }),
        // set post tracks
        trackSetPostTracks: (state, action)=>{
            const { tracks: tracks } = action.payload;
            // update post tracks state
            state.postTracks = tracks;
        },
        // reset post tracks
        trackResetPostTracks: (state)=>({
                ...state,
                postTracks: [],
                postTracksFetched: false
            }),
        // append liked track
        trackAppendLikedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if liked tracks are fetched
            if (state.likedTracksFetched) {
                // append track to liked tracks
                state.likedTracks.unshift(track);
                state.likedTracksCount += 1;
            }
        },
        // filter liked track
        trackFilterLikedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if liked tracks are fetched
            if (state.likedTracksFetched) {
                // filter track from liked tracks
                state.likedTracks = state.likedTracks.filter((t)=>t.id !== track.id);
                state.likedTracksCount -= 1;
            }
        },
        // append unlocked track
        trackAppendUnlockedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if unlocked tracks are fetched
            if (state.unlockedTracksFetched) {
                // append track to unlocked tracks
                state.unlockedTracks.unshift(track);
                state.unlockedTracksCount += 1;
            }
        },
        // filter unlocked track
        trackFilterUnlockedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if unlocked tracks are fetched
            if (state.unlockedTracksFetched) {
                // filter track from unlocked tracks
                state.unlockedTracks = state.unlockedTracks.filter((t)=>t.id !== track.id);
                state.unlockedTracksCount -= 1;
            }
        },
        // filter track
        trackFilterTrack: (state, action)=>{
            const { id: id } = action.payload;
            // check if track exists in public tracks
            const pubIndex = state.publicTracks.findIndex((t)=>t.id === id);
            if (pubIndex !== -1) {
                // filter track
                state.publicTracks = state.publicTracks.filter((t)=>t.id !== id);
                state.publicTracksCount -= 1;
            }
            // check if track exists in popular tracks
            const popIndex = state.popularTracks.findIndex((t)=>t.id === id);
            if (popIndex !== -1) {
                // filter track
                state.popularTracks = state.popularTracks.filter((t)=>t.id !== id);
                state.popularTracksCount -= 1;
            }
            // check if track exists in exclusive tracks
            const exIndex = state.exclusiveTracks.findIndex((t)=>t.id === id);
            if (exIndex !== -1) {
                // filter track
                state.exclusiveTracks = state.exclusiveTracks.filter((t)=>t.id !== id);
                state.exclusiveTracksCount -= 1;
            }
            // check if track exists in latest tracks
            const laIndex = state.latestTracks.findIndex((t)=>t.id === id);
            if (laIndex !== -1) {
                // filter track
                state.latestTracks = state.latestTracks.filter((t)=>t.id !== id);
                state.latestTracksCount -= 1;
            }
            // check if track exists in trending tracks
            const trIndex = state.trendingTracks.findIndex((t)=>t.id === id);
            if (trIndex !== -1) {
                // filter track
                state.trendingTracks = state.trendingTracks.filter((t)=>t.id !== id);
                state.trendingTracksCount -= 1;
            }
            // check if track exists in recommended tracks
            const recIndex = state.recommendedTracks.findIndex((t)=>t.id === id);
            if (recIndex !== -1) {
                // filter track
                state.recommendedTracks = state.recommendedTracks.filter((t)=>t.id !== id);
                state.recommendedTracksCount -= 1;
            }
            // check if track exists in liked tracks
            const lkIndex = state.likedTracks.findIndex((t)=>t.id === id);
            if (lkIndex !== -1) {
                // filter track
                state.likedTracks = state.likedTracks.filter((t)=>t.id !== id);
                state.likedTracksCount -= 1;
            }
            // check if track exists in unlocked tracks
            const unlIndex = state.unlockedTracks.findIndex((t)=>t.id === id);
            if (unlIndex !== -1) {
                // filter track
                state.unlockedTracks = state.unlockedTracks.filter((t)=>t.id !== id);
                state.unlockedTracksCount -= 1;
            }
            // check if track exists in uploaded tracks
            const uplIndex = state.uploadedTracks.findIndex((t)=>t.id === id);
            if (uplIndex !== -1) {
                // filter track
                state.uploadedTracks = state.uploadedTracks.filter((t)=>t.id !== id);
                state.uploadedTracksCount -= 1;
            }
            // check if track exists in artist popular tracks
            const aPopIndex = state.artistPopularTracks.findIndex((t)=>t.id === id);
            if (aPopIndex !== -1) {
                // filter track
                state.artistPopularTracks = state.artistPopularTracks.filter((t)=>t.id !== id);
                state.artistPopularTracksCount -= 1;
            }
            // check if track exists in artist exclusive tracks
            const aExIndex = state.artistExclusiveTracks.findIndex((t)=>t.id === id);
            if (aExIndex !== -1) {
                // filter track
                state.artistExclusiveTracks = state.artistExclusiveTracks.filter((t)=>t.id !== id);
                state.artistExclusiveTracksCount -= 1;
            }
            // check if track exists in artist latest tracks
            const aLatIndex = state.artistLatestTracks.findIndex((t)=>t.id === id);
            if (aLatIndex !== -1) {
                // filter track
                state.artistLatestTracks = state.artistLatestTracks.filter((t)=>t.id !== id);
                state.artistLatestTracksCount -= 1;
            }
            // check if track exists in post tracks
            const ptIndex = state.postTracks.findIndex((t)=>t.id === id);
            if (ptIndex !== -1) // filter track
            state.postTracks = state.postTracks.filter((t)=>t.id !== id);
        },
        // filter user tracks
        trackFilterUserTracks: (state, action)=>{
            const { userId: userId } = action.payload;
            // filter user tracks from public tracks
            const filteredPublicTracks = state.publicTracks.filter((t)=>t.userId !== userId);
            const filteredPublicTracksCount = state.publicTracks.length - filteredPublicTracks.length;
            // if filtered tracks
            if (filteredPublicTracksCount > 0) {
                // update tracks
                state.publicTracks = filteredPublicTracks;
                state.publicTracksCount -= filteredPublicTracksCount;
            }
            // filter user tracks from popular tracks
            const filteredPopularTracks = state.popularTracks.filter((t)=>t.userId !== userId);
            const filteredPopularTracksCount = state.popularTracks.length - filteredPopularTracks.length;
            // if filtered tracks
            if (filteredPopularTracksCount > 0) {
                // update tracks
                state.popularTracks = filteredPopularTracks;
                state.popularTracksCount -= filteredPopularTracksCount;
            }
            // filter user tracks from exclusive tracks
            const filteredExclusiveTracks = state.exclusiveTracks.filter((t)=>t.userId !== userId);
            const filteredExclusiveTracksCount = state.exclusiveTracks.length - filteredExclusiveTracks.length;
            // if filtered tracks
            if (filteredExclusiveTracksCount > 0) {
                // update tracks
                state.exclusiveTracks = filteredExclusiveTracks;
                state.exclusiveTracksCount -= filteredExclusiveTracksCount;
            }
            // filter user tracks from latest tracks
            const filteredLatestTracks = state.latestTracks.filter((t)=>t.userId !== userId);
            const filteredLatestTracksCount = state.latestTracks.length - filteredLatestTracks.length;
            // if filtered tracks
            if (filteredLatestTracksCount > 0) {
                // update tracks
                state.latestTracks = filteredLatestTracks;
                state.latestTracksCount -= filteredLatestTracksCount;
            }
            // filter user tracks from trending tracks
            const filteredTrendingTracks = state.trendingTracks.filter((t)=>t.userId !== userId);
            const filteredTrendingTracksCount = state.trendingTracks.length - filteredTrendingTracks.length;
            // if filtered tracks
            if (filteredTrendingTracksCount > 0) {
                // update tracks
                state.trendingTracks = filteredTrendingTracks;
                state.trendingTracksCount -= filteredTrendingTracksCount;
            }
            // filter user tracks from recommended tracks
            const filteredRecommendedTracks = state.recommendedTracks.filter((t)=>t.userId !== userId);
            const filteredRecommendedTracksCount = state.recommendedTracks.length - filteredRecommendedTracks.length;
            // if filtered tracks
            if (filteredRecommendedTracksCount > 0) {
                // update tracks
                state.recommendedTracks = filteredRecommendedTracks;
                state.recommendedTracksCount -= filteredRecommendedTracksCount;
            }
            // filter user tracks from liked tracks
            const filteredLikedTracks = state.likedTracks.filter((t)=>t.userId !== userId);
            const filteredLikedTracksCount = state.likedTracks.length - filteredLikedTracks.length;
            // if filtered tracks
            if (filteredLikedTracksCount > 0) {
                // update tracks
                state.likedTracks = filteredLikedTracks;
                state.likedTracksCount -= filteredLikedTracksCount;
            }
            // filter user tracks from unlocked tracks
            const filteredUnlockedTracks = state.unlockedTracks.filter((t)=>t.userId !== userId);
            const filteredUnlockedTracksCount = state.unlockedTracks.length - filteredUnlockedTracks.length;
            // if filtered tracks
            if (filteredUnlockedTracksCount > 0) {
                // update tracks
                state.unlockedTracks = filteredUnlockedTracks;
                state.unlockedTracksCount -= filteredUnlockedTracksCount;
            }
            // filter user tracks from uploaded tracks
            const filteredUploadedTracks = state.uploadedTracks.filter((t)=>t.userId !== userId);
            const filteredUploadedTracksCount = state.uploadedTracks.length - filteredUploadedTracks.length;
            // if filtered tracks
            if (filteredUploadedTracksCount > 0) {
                // update tracks
                state.uploadedTracks = filteredUploadedTracks;
                state.uploadedTracksCount -= filteredUploadedTracksCount;
            }
            // filter user tracks from artist popular tracks
            const filteredArtistPopularTracks = state.artistPopularTracks.filter((t)=>t.userId !== userId);
            const filteredArtistPopularTracksCount = state.artistPopularTracks.length - filteredArtistPopularTracks.length;
            // if filtered tracks
            if (filteredArtistPopularTracksCount > 0) {
                // update tracks
                state.artistPopularTracks = filteredArtistPopularTracks;
                state.artistPopularTracksCount -= filteredArtistPopularTracksCount;
            }
            // filter user tracks from artist exclusive tracks
            const filteredArtistExclusiveTracks = state.artistExclusiveTracks.filter((t)=>t.userId !== userId);
            const filteredArtistExclusiveTracksCount = state.artistExclusiveTracks.length - filteredArtistExclusiveTracks.length;
            // if filtered tracks
            if (filteredArtistExclusiveTracksCount > 0) {
                // update tracks
                state.artistExclusiveTracks = filteredArtistExclusiveTracks;
                state.artistExclusiveTracksCount -= filteredArtistExclusiveTracksCount;
            }
            // filter user tracks from artist latest tracks
            const filteredArtistLatestTracks = state.artistLatestTracks.filter((t)=>t.userId !== userId);
            const filteredArtistLatestTracksCount = state.artistLatestTracks.length - filteredArtistLatestTracks.length;
            // if filtered tracks
            if (filteredArtistLatestTracksCount > 0) {
                // update tracks
                state.artistLatestTracks = filteredArtistLatestTracks;
                state.artistLatestTracksCount -= filteredArtistLatestTracksCount;
            }
            // filter user tracks from post tracks
            const filteredPostTracks = state.postTracks.filter((t)=>t.userId !== userId);
            const filteredPostTracksCount = state.postTracks.length - filteredPostTracks.length;
            // if filtered tracks
            if (filteredPostTracksCount > 0) // update tracks
            state.postTracks = filteredPostTracks;
        },
        // update track
        trackUpdateTrack: (state, action)=>{
            const { updatedTrack: updatedTrack } = action.payload;
            // update track in public tracks
            const pubIndex = state.publicTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (pubIndex !== -1) {
                const currentTrack = state.publicTracks[pubIndex];
                state.publicTracks[pubIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in popular tracks
            const popIndex = state.popularTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (popIndex !== -1) {
                const currentTrack = state.popularTracks[popIndex];
                state.popularTracks[popIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in exclusive tracks
            const exIndex = state.exclusiveTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (exIndex !== -1) {
                const currentTrack = state.exclusiveTracks[exIndex];
                state.exclusiveTracks[exIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in latest tracks
            const laIndex = state.latestTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (laIndex !== -1) {
                const currentTrack = state.latestTracks[laIndex];
                state.latestTracks[laIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in trending tracks
            const trIndex = state.trendingTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (trIndex !== -1) {
                const currentTrack = state.trendingTracks[trIndex];
                state.trendingTracks[trIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in recommended tracks
            const recIndex = state.recommendedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (recIndex !== -1) {
                const currentTrack = state.recommendedTracks[recIndex];
                state.recommendedTracks[recIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in liked tracks
            const lkIndex = state.likedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (lkIndex !== -1) {
                const currentTrack = state.likedTracks[lkIndex];
                state.likedTracks[lkIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in unlocked tracks
            const unlIndex = state.unlockedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (unlIndex !== -1) {
                const currentTrack = state.unlockedTracks[unlIndex];
                state.unlockedTracks[unlIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in uploaded tracks
            const uplIndex = state.uploadedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (uplIndex !== -1) {
                const currentTrack = state.uploadedTracks[uplIndex];
                state.uploadedTracks[uplIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in artist popular tracks
            const aPopIndex = state.artistPopularTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (aPopIndex !== -1) {
                const currentTrack = state.artistPopularTracks[aPopIndex];
                state.artistPopularTracks[aPopIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in artist exclusive tracks
            const aExIndex = state.artistExclusiveTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (aExIndex !== -1) {
                const currentTrack = state.artistExclusiveTracks[aExIndex];
                state.artistExclusiveTracks[aExIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in artist latest tracks
            const aLatIndex = state.artistLatestTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (aLatIndex !== -1) {
                const currentTrack = state.artistLatestTracks[aLatIndex];
                state.artistLatestTracks[aLatIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in post tracks
            const ptIndex = state.postTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (ptIndex !== -1) {
                const currentTrack = state.postTracks[ptIndex];
                state.postTracks[ptIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
        },
        // open track block modal
        trackOpenTrackBlockModal: (state, action)=>({
                ...state,
                trackBlockModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close track block modal
        trackCloseTrackBlockModal: (state)=>({
                ...state,
                trackBlockModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            }),
        // open track delete modal
        trackOpenTrackDeleteModal: (state, action)=>({
                ...state,
                trackDeleteModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close track delete modal
        trackCloseTrackDeleteModal: (state)=>({
                ...state,
                trackDeleteModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get public tracks
        builder.addCase((0, $fZeVI.trackGetPublicTracks).pending, (state)=>({
                ...state,
                trackGetPublicTracksLoading: true
            })).addCase((0, $fZeVI.trackGetPublicTracks).fulfilled, (state)=>({
                ...state,
                publicTracksFetched: true,
                trackGetPublicTracksLoading: false
            }));
        // get popular tracks
        builder.addCase((0, $fZeVI.trackGetPopularTracks).pending, (state)=>({
                ...state,
                trackGetPopularTracksLoading: true
            })).addCase((0, $fZeVI.trackGetPopularTracks).fulfilled, (state)=>({
                ...state,
                popularTracksFetched: true,
                trackGetPopularTracksLoading: false
            }));
        // get exclusive tracks
        builder.addCase((0, $fZeVI.trackGetExclusiveTracks).pending, (state)=>({
                ...state,
                trackGetExclusiveTracksLoading: true
            })).addCase((0, $fZeVI.trackGetExclusiveTracks).fulfilled, (state)=>({
                ...state,
                exclusiveTracksFetched: true,
                trackGetExclusiveTracksLoading: false
            }));
        // get latest tracks
        builder.addCase((0, $fZeVI.trackGetLatestTracks).pending, (state)=>({
                ...state,
                trackGetLatestTracksLoading: true
            })).addCase((0, $fZeVI.trackGetLatestTracks).fulfilled, (state)=>({
                ...state,
                latestTracksFetched: true,
                trackGetLatestTracksLoading: false
            }));
        // get trending tracks
        builder.addCase((0, $fZeVI.trackGetTrendingTracks).pending, (state)=>({
                ...state,
                trackGetTrendingTracksLoading: true
            })).addCase((0, $fZeVI.trackGetTrendingTracks).fulfilled, (state)=>({
                ...state,
                trendingTracksFetched: true,
                trackGetTrendingTracksLoading: false
            }));
        // get recommended tracks
        builder.addCase((0, $fZeVI.trackGetRecommendedTracks).pending, (state)=>({
                ...state,
                trackGetRecommendedTracksLoading: true
            })).addCase((0, $fZeVI.trackGetRecommendedTracks).fulfilled, (state)=>({
                ...state,
                recommendedTracksFetched: true,
                trackGetRecommendedTracksLoading: false
            }));
        // get liked tracks
        builder.addCase((0, $fZeVI.trackGetLikedTracks).pending, (state)=>({
                ...state,
                trackGetLikedTracksLoading: true
            })).addCase((0, $fZeVI.trackGetLikedTracks).fulfilled, (state)=>({
                ...state,
                likedTracksFetched: true,
                trackGetLikedTracksLoading: false
            }));
        // get unlocked tracks
        builder.addCase((0, $fZeVI.trackGetUnlockedTracks).pending, (state)=>({
                ...state,
                trackGetUnlockedTracksLoading: true
            })).addCase((0, $fZeVI.trackGetUnlockedTracks).fulfilled, (state)=>({
                ...state,
                unlockedTracksFetched: true,
                trackGetUnlockedTracksLoading: false
            }));
        // get uploaded tracks
        builder.addCase((0, $fZeVI.trackGetUploadedTracks).pending, (state)=>({
                ...state,
                trackGetUploadedTracksLoading: true
            })).addCase((0, $fZeVI.trackGetUploadedTracks).fulfilled, (state)=>({
                ...state,
                uploadedTracksFetched: true,
                trackGetUploadedTracksLoading: false
            }));
        // get artist popular tracks
        builder.addCase((0, $fZeVI.trackGetArtistPopularTracks).pending, (state)=>({
                ...state,
                trackGetArtistPopularTracksLoading: true
            })).addCase((0, $fZeVI.trackGetArtistPopularTracks).fulfilled, (state)=>({
                ...state,
                artistPopularTracksFetched: true,
                trackGetArtistPopularTracksLoading: false
            }));
        // get artist exclusive tracks
        builder.addCase((0, $fZeVI.trackGetArtistExclusiveTracks).pending, (state)=>({
                ...state,
                trackGetArtistExclusiveTracksLoading: true
            })).addCase((0, $fZeVI.trackGetArtistExclusiveTracks).fulfilled, (state)=>({
                ...state,
                artistExclusiveTracksFetched: true,
                trackGetArtistExclusiveTracksLoading: false
            }));
        // get artist latest tracks
        builder.addCase((0, $fZeVI.trackGetArtistLatestTracks).pending, (state)=>({
                ...state,
                trackGetArtistLatestTracksLoading: true
            })).addCase((0, $fZeVI.trackGetArtistLatestTracks).fulfilled, (state)=>({
                ...state,
                artistLatestTracksFetched: true,
                trackGetArtistLatestTracksLoading: false
            }));
        // get post tracks
        builder.addCase((0, $fZeVI.trackGetPostTracks).pending, (state)=>({
                ...state,
                trackGetPostTracksLoading: true
            })).addCase((0, $fZeVI.trackGetPostTracks).fulfilled, (state)=>({
                ...state,
                postTracksFetched: true,
                trackGetPostTracksLoading: false
            }));
        // create track
        builder.addCase((0, $fZeVI.trackCreate).pending, (state)=>({
                ...state,
                trackCreateLoading: true
            })).addCase((0, $fZeVI.trackCreate).fulfilled, (state)=>({
                ...state,
                trackCreateLoading: false
            }));
        // update track
        builder.addCase((0, $fZeVI.trackUpdate).pending, (state)=>({
                ...state,
                trackUpdateLoading: true
            })).addCase((0, $fZeVI.trackUpdate).fulfilled, (state)=>({
                ...state,
                trackUpdateLoading: false
            }));
        // block track
        builder.addCase((0, $fZeVI.trackBlock).pending, (state)=>({
                ...state,
                trackBlockLoading: true
            })).addCase((0, $fZeVI.trackBlock).fulfilled, (state)=>({
                ...state,
                trackBlockLoading: false
            }));
        // delete track
        builder.addCase((0, $fZeVI.trackDelete).pending, (state)=>({
                ...state,
                trackDeleteLoading: true
            })).addCase((0, $fZeVI.trackDelete).fulfilled, (state)=>({
                ...state,
                trackDeleteLoading: false
            }));
    }
});
const { trackResetState: $09ed7a873dc6ee0b$export$91afce20dedb32ac, trackSetPublicTracks: $09ed7a873dc6ee0b$export$2d7ecf5aea6fabe7, trackSetPopularTracks: $09ed7a873dc6ee0b$export$c911a6cb418acc4a, trackSetExclusiveTracks: $09ed7a873dc6ee0b$export$ba92f12611d6e509, trackSetLatestTracks: $09ed7a873dc6ee0b$export$821dde0cff897f4c, trackSetTrendingTracks: $09ed7a873dc6ee0b$export$85f6b0beeb7c7923, trackSetRecommendedTracks: $09ed7a873dc6ee0b$export$535c0003673c0bae, trackSetLikedTracks: $09ed7a873dc6ee0b$export$b1024953c618252f, trackSetUnlockedTracks: $09ed7a873dc6ee0b$export$4dbbdb417cd9533b, trackSetUploadedTracks: $09ed7a873dc6ee0b$export$35e8364feff109ed, trackSetArtistPopularTracks: $09ed7a873dc6ee0b$export$7d7c134223540010, trackSetArtistExclusiveTracks: $09ed7a873dc6ee0b$export$6429021d85ed6478, trackSetArtistLatestTracks: $09ed7a873dc6ee0b$export$420feca5c0f2e889, trackResetArtistTracks: $09ed7a873dc6ee0b$export$d742c877f096cf38, trackSetPostTracks: $09ed7a873dc6ee0b$export$236c041833b35867, trackResetPostTracks: $09ed7a873dc6ee0b$export$1c19257305af6d24, trackAppendLikedTrack: $09ed7a873dc6ee0b$export$2c56715bdb589a3d, trackFilterLikedTrack: $09ed7a873dc6ee0b$export$105c65e084ab827c, trackAppendUnlockedTrack: $09ed7a873dc6ee0b$export$5ca905dee28a2d99, trackFilterUnlockedTrack: $09ed7a873dc6ee0b$export$edb49a15130cb96d, trackFilterTrack: $09ed7a873dc6ee0b$export$d86d1aaa5820656c, trackFilterUserTracks: $09ed7a873dc6ee0b$export$85e845fda476ba58, trackUpdateTrack: $09ed7a873dc6ee0b$export$3c3a856b71c10cd2, trackOpenTrackBlockModal: $09ed7a873dc6ee0b$export$56e331a908d904d5, trackCloseTrackBlockModal: $09ed7a873dc6ee0b$export$6811b8863997ba45, trackOpenTrackDeleteModal: $09ed7a873dc6ee0b$export$2de241ab12382de6, trackCloseTrackDeleteModal: $09ed7a873dc6ee0b$export$bbe0b92674fa755e } = $09ed7a873dc6ee0b$export$a3d6f2521ab23ff4.actions;
const $09ed7a873dc6ee0b$export$47564cb5d8147207 = (state)=>state.track.publicTracks;
const $09ed7a873dc6ee0b$export$f9b9ca0cc1f5cfce = (state)=>state.track.publicTracks.length;
const $09ed7a873dc6ee0b$export$a3ec4174f8290ea1 = (state)=>state.track.publicTracksCount;
const $09ed7a873dc6ee0b$export$f039f0f464c79d83 = (state)=>state.track.publicTracksFetched;
const $09ed7a873dc6ee0b$export$4c37c8f4ddb5ccdd = (state)=>state.track.popularTracks;
const $09ed7a873dc6ee0b$export$58a8663ddd7bfa52 = (state)=>state.track.popularTracks.length;
const $09ed7a873dc6ee0b$export$62d4bca2ea171ac2 = (state)=>state.track.popularTracksCount;
const $09ed7a873dc6ee0b$export$226bc2dcf7547000 = (state)=>state.track.popularTracksFetched;
const $09ed7a873dc6ee0b$export$e37f1fe62af44d2e = (state)=>state.track.exclusiveTracks;
const $09ed7a873dc6ee0b$export$ce85ccdd80284243 = (state)=>state.track.exclusiveTracks.length;
const $09ed7a873dc6ee0b$export$69d3f01427ab5991 = (state)=>state.track.exclusiveTracksCount;
const $09ed7a873dc6ee0b$export$c6816f57f96de775 = (state)=>state.track.exclusiveTracksFetched;
const $09ed7a873dc6ee0b$export$90d97c0db639420a = (state)=>state.track.latestTracks;
const $09ed7a873dc6ee0b$export$9a6fce8c107f08e9 = (state)=>state.track.latestTracks.length;
const $09ed7a873dc6ee0b$export$8e8fc430e197b863 = (state)=>state.track.latestTracksCount;
const $09ed7a873dc6ee0b$export$401eea2f5ce1ff4b = (state)=>state.track.latestTracksFetched;
const $09ed7a873dc6ee0b$export$b5066207a175173a = (state)=>state.track.trendingTracks;
const $09ed7a873dc6ee0b$export$43b5c9b6c0d0dadd = (state)=>state.track.trendingTracks.length;
const $09ed7a873dc6ee0b$export$a04c165a82b3cbc4 = (state)=>state.track.trendingTracksCount;
const $09ed7a873dc6ee0b$export$87f17186a6cf9d3b = (state)=>state.track.trendingTracksFetched;
const $09ed7a873dc6ee0b$export$e5e50bc712e38d93 = (state)=>state.track.recommendedTracks;
const $09ed7a873dc6ee0b$export$4411836d2a84bab1 = (state)=>state.track.recommendedTracks.length;
const $09ed7a873dc6ee0b$export$f1ac8d7f901cff94 = (state)=>state.track.recommendedTracksCount;
const $09ed7a873dc6ee0b$export$bb2b22d1dbb538c5 = (state)=>state.track.recommendedTracksFetched;
const $09ed7a873dc6ee0b$export$35df9b11880abfde = (state)=>state.track.likedTracks;
const $09ed7a873dc6ee0b$export$f2f25b45129fd9bf = (state)=>state.track.likedTracks.length;
const $09ed7a873dc6ee0b$export$2146ae74a6c967e9 = (state)=>state.track.likedTracksCount;
const $09ed7a873dc6ee0b$export$928b86b46ccdda3b = (state)=>state.track.likedTracksFetched;
const $09ed7a873dc6ee0b$export$a22acbc5ae261a16 = (state)=>state.track.unlockedTracks;
const $09ed7a873dc6ee0b$export$e8d801ab210db7ab = (state)=>state.track.unlockedTracks.length;
const $09ed7a873dc6ee0b$export$a5125418d1c9c810 = (state)=>state.track.unlockedTracksCount;
const $09ed7a873dc6ee0b$export$504378086fb25edd = (state)=>state.track.unlockedTracksFetched;
const $09ed7a873dc6ee0b$export$8207498fbe72f46 = (state)=>state.track.uploadedTracks;
const $09ed7a873dc6ee0b$export$22a092517e09c0d = (state)=>state.track.uploadedTracks.length;
const $09ed7a873dc6ee0b$export$27e0ae462cc2be1e = (state)=>state.track.uploadedTracksCount;
const $09ed7a873dc6ee0b$export$a9a4448b2e07780 = (state)=>state.track.uploadedTracksFetched;
const $09ed7a873dc6ee0b$export$111a3c3534ddce76 = (state)=>state.track.artistPopularTracks;
const $09ed7a873dc6ee0b$export$1092d17ce779b213 = (state)=>state.track.artistPopularTracks.length;
const $09ed7a873dc6ee0b$export$2d7a26414c6d58ac = (state)=>state.track.artistPopularTracksCount;
const $09ed7a873dc6ee0b$export$b65214841fdacb75 = (state)=>state.track.artistPopularTracksFetched;
const $09ed7a873dc6ee0b$export$7ec3893edfc43a66 = (state)=>state.track.artistExclusiveTracks;
const $09ed7a873dc6ee0b$export$ee53d2e211394bc9 = (state)=>state.track.artistExclusiveTracks.length;
const $09ed7a873dc6ee0b$export$62ac15c1e4cbd19e = (state)=>state.track.artistExclusiveTracksCount;
const $09ed7a873dc6ee0b$export$5a188b1cb81c365f = (state)=>state.track.artistExclusiveTracksFetched;
const $09ed7a873dc6ee0b$export$d8936ba0cbd1cc2b = (state)=>state.track.artistLatestTracks;
const $09ed7a873dc6ee0b$export$c3e0fa980513d7e3 = (state)=>state.track.artistLatestTracks.length;
const $09ed7a873dc6ee0b$export$24fc321fc9d0319a = (state)=>state.track.artistLatestTracksCount;
const $09ed7a873dc6ee0b$export$b10cc2dffa5268ea = (state)=>state.track.artistLatestTracksFetched;
const $09ed7a873dc6ee0b$export$7cfade53894d2355 = (state)=>state.track.postTracks;
const $09ed7a873dc6ee0b$export$8bca47c1f4b2b968 = (state)=>state.track.postTracksFetched;
const $09ed7a873dc6ee0b$export$e30c4435926569f1 = (state)=>state.track.trackBlockModal.open;
const $09ed7a873dc6ee0b$export$18e4366d1e17c8e0 = (state)=>state.track.trackBlockModal.track;
const $09ed7a873dc6ee0b$export$6c8a6385741ff7b6 = (state)=>state.track.trackDeleteModal.open;
const $09ed7a873dc6ee0b$export$6cb3e01afd8d3c94 = (state)=>state.track.trackDeleteModal.track;
const $09ed7a873dc6ee0b$export$405ef44e6ed74011 = (state)=>state.track.trackGetPublicTracksLoading;
const $09ed7a873dc6ee0b$export$ae8b9e001696b5cf = (state)=>state.track.trackGetPopularTracksLoading;
const $09ed7a873dc6ee0b$export$d2c296bdb2317093 = (state)=>state.track.trackGetExclusiveTracksLoading;
const $09ed7a873dc6ee0b$export$d335e3779b1f7f7e = (state)=>state.track.trackGetLatestTracksLoading;
const $09ed7a873dc6ee0b$export$913df1835a6c3f1e = (state)=>state.track.trackGetTrendingTracksLoading;
const $09ed7a873dc6ee0b$export$cfc3b6c697b820ca = (state)=>state.track.trackGetRecommendedTracksLoading;
const $09ed7a873dc6ee0b$export$b8b634e26fb18437 = (state)=>state.track.trackGetLikedTracksLoading;
const $09ed7a873dc6ee0b$export$e693f231ed8581d9 = (state)=>state.track.trackGetUnlockedTracksLoading;
const $09ed7a873dc6ee0b$export$eb68542484efa1fe = (state)=>state.track.trackGetUploadedTracksLoading;
const $09ed7a873dc6ee0b$export$469daa70a5bdb26f = (state)=>state.track.trackGetArtistPopularTracksLoading;
const $09ed7a873dc6ee0b$export$a14d11ba620ac874 = (state)=>state.track.trackGetArtistExclusiveTracksLoading;
const $09ed7a873dc6ee0b$export$724cd8f38778db29 = (state)=>state.track.trackGetArtistLatestTracksLoading;
const $09ed7a873dc6ee0b$export$9aad2ecb49cd085b = (state)=>state.track.trackGetPostTracksLoading;
const $09ed7a873dc6ee0b$export$4133c331aede8f7b = (state)=>state.track.trackCreateLoading;
const $09ed7a873dc6ee0b$export$b23ee01741eaf3c9 = (state)=>state.track.trackUpdateLoading;
const $09ed7a873dc6ee0b$export$dc2ec62f755fa49a = (state)=>state.track.trackBlockLoading;
const $09ed7a873dc6ee0b$export$7e1ad1aad8696bcb = (state)=>state.track.trackDeleteLoading;
const $09ed7a873dc6ee0b$export$e4057e913f54cc7e = $09ed7a873dc6ee0b$export$a3d6f2521ab23ff4.reducer; // export default trackSlice.reducer

});

parcelRegister("fZeVI", function(module, exports) {

$parcel$export(module.exports, "trackGetPublicTracks", function () { return $86e431e6cdb3d1af$export$c829cef6efb837e7; });
$parcel$export(module.exports, "trackGetPopularTracks", function () { return $86e431e6cdb3d1af$export$5f38273a75885ecd; });
$parcel$export(module.exports, "trackGetExclusiveTracks", function () { return $86e431e6cdb3d1af$export$18002fac64463f72; });
$parcel$export(module.exports, "trackGetLatestTracks", function () { return $86e431e6cdb3d1af$export$166b521aba3d1598; });
$parcel$export(module.exports, "trackGetTrendingTracks", function () { return $86e431e6cdb3d1af$export$5c955a524c656384; });
$parcel$export(module.exports, "trackGetRecommendedTracks", function () { return $86e431e6cdb3d1af$export$eab441c41d503279; });
$parcel$export(module.exports, "trackGetLikedTracks", function () { return $86e431e6cdb3d1af$export$8e693b38bc8bb563; });
$parcel$export(module.exports, "trackGetUnlockedTracks", function () { return $86e431e6cdb3d1af$export$9a98d14b4f79b4be; });
$parcel$export(module.exports, "trackGetUploadedTracks", function () { return $86e431e6cdb3d1af$export$f9972041e1785b3e; });
$parcel$export(module.exports, "trackGetArtistPopularTracks", function () { return $86e431e6cdb3d1af$export$6f209b44a74f998; });
$parcel$export(module.exports, "trackGetArtistExclusiveTracks", function () { return $86e431e6cdb3d1af$export$62b017e555e2b685; });
$parcel$export(module.exports, "trackGetArtistLatestTracks", function () { return $86e431e6cdb3d1af$export$998d5b1bfd7986a4; });
$parcel$export(module.exports, "trackGetPostTracks", function () { return $86e431e6cdb3d1af$export$3add8b5587e204a7; });
$parcel$export(module.exports, "trackCreate", function () { return $86e431e6cdb3d1af$export$f7e7ada7d7555000; });
$parcel$export(module.exports, "trackUpdate", function () { return $86e431e6cdb3d1af$export$e2f380e887795d02; });
$parcel$export(module.exports, "trackBlock", function () { return $86e431e6cdb3d1af$export$92cf52a6069bc2b9; });
$parcel$export(module.exports, "trackDelete", function () { return $86e431e6cdb3d1af$export$8542f6d1e2cb8f0e; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $jhoVP = parcelRequire("jhoVP");
var $6CAIO = parcelRequire("6CAIO");
var $1bnO9 = parcelRequire("1bnO9");
const $86e431e6cdb3d1af$export$c829cef6efb837e7 = (0, $dEr3t.createAsyncThunk)("track/trackGetPublicTracks", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPublicTracks();
        // set public tracks
        dispatch((0, $1bnO9.trackSetPublicTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$5f38273a75885ecd = (0, $dEr3t.createAsyncThunk)("track/trackGetPopularTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPopularTracks(undefined, inp.limit, inp.offset, inp.search);
        // set popular tracks
        dispatch((0, $1bnO9.trackSetPopularTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$18002fac64463f72 = (0, $dEr3t.createAsyncThunk)("track/trackGetExclusiveTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getExclusiveTracks(undefined, inp.limit, inp.offset, inp.search);
        // set exclusive tracks
        dispatch((0, $1bnO9.trackSetExclusiveTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$166b521aba3d1598 = (0, $dEr3t.createAsyncThunk)("track/trackGetLatestTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getLatestTracks(undefined, inp.limit, inp.offset, inp.search);
        // set latest tracks
        dispatch((0, $1bnO9.trackSetLatestTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$5c955a524c656384 = (0, $dEr3t.createAsyncThunk)("track/trackGetTrendingTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getTrendingTracks(undefined, inp.limit, inp.offset, inp.search);
        // set trending tracks
        dispatch((0, $1bnO9.trackSetTrendingTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$eab441c41d503279 = (0, $dEr3t.createAsyncThunk)("track/trackGetRecommendedTracks", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get user profile
    const { profile: profile } = getState().auth;
    const userPreferredGenres = profile?.preferredGenres?.join(",");
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve recommended tracks
        const { tracks: tracks, count: count } = await api.trackApi.getRecommendedTracks(userPreferredGenres, inp.limit, inp.offset, inp.search);
        // set recommended tracks
        dispatch((0, $1bnO9.trackSetRecommendedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$8e693b38bc8bb563 = (0, $dEr3t.createAsyncThunk)("track/trackGetLikedTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve liked tracks
        const { tracks: tracks, count: count } = await api.trackApi.getLikedTracks(inp.limit, inp.offset, inp.search);
        // set liked tracks
        dispatch((0, $1bnO9.trackSetLikedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$9a98d14b4f79b4be = (0, $dEr3t.createAsyncThunk)("track/trackGetUnlockedTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve liked tracks
        const { tracks: tracks, count: count } = await api.trackApi.getUnlockedTracks(inp.limit, inp.offset, inp.search);
        // set liked tracks
        dispatch((0, $1bnO9.trackSetUnlockedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$f9972041e1785b3e = (0, $dEr3t.createAsyncThunk)("track/trackGetUploadedTracks", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get currently logged in user id
    const { profile: profile } = getState().auth;
    const userId = profile?.id || "";
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getArtistTracks(userId, inp.limit, inp.offset, inp.search);
        // set uploaded tracks
        dispatch((0, $1bnO9.trackSetUploadedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$6f209b44a74f998 = (0, $dEr3t.createAsyncThunk)("track/trackGetArtistPopularTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPopularTracks(inp.artistId, inp.limit, inp.offset, inp.search);
        // set tracks
        dispatch((0, $1bnO9.trackSetArtistPopularTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$62b017e555e2b685 = (0, $dEr3t.createAsyncThunk)("track/trackGetArtistExclusiveTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getExclusiveTracks(inp.artistId, inp.limit, inp.offset, inp.search);
        // set tracks
        dispatch((0, $1bnO9.trackSetArtistExclusiveTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$998d5b1bfd7986a4 = (0, $dEr3t.createAsyncThunk)("track/trackGetArtistLatestTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getLatestTracks(inp.artistId, inp.limit, inp.offset, inp.search);
        // set tracks
        dispatch((0, $1bnO9.trackSetArtistLatestTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$3add8b5587e204a7 = (0, $dEr3t.createAsyncThunk)("track/trackGetPostTracks", async ({ trackIds: trackIds }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks } = await api.trackApi.getTracksByIds(trackIds?.join(","));
        // set post tracks
        dispatch((0, $1bnO9.trackSetPostTracks)({
            tracks: tracks || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$f7e7ada7d7555000 = (0, $dEr3t.createAsyncThunk)("track/trackCreate", async ({ name: name, track: track, cover: cover, genres: genres, visibility: visibility, unlockPrice: unlockPrice }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append name
        formData.append("name", name);
        // if track provided
        if (track) // append track file
        formData.append("track", track);
        // if cover provided
        if (cover) // append cover file
        formData.append("cover", cover);
        // if genres provided
        if (genres && genres.length > 0) // append genres
        formData.append("genres", genres.join(","));
        // if visibility provided
        if (visibility) // append visibility
        formData.append("visibility", visibility.toString());
        // if visibility is subscribers
        // and unlock price provided
        if (visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers && unlockPrice) // append unlock price in cents
        // if unlockPrice = 1 (one dollar)
        // 1 * 100 = 100 (hundred cents)
        formData.append("unlockPrice", (unlockPrice * 100).toString());
        // create track
        await api.trackApi.createTrack({
            body: formData
        });
        // refetch uploaded tracks
        dispatch($86e431e6cdb3d1af$export$f9972041e1785b3e({
            limit: 30,
            offset: 0
        }));
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully uploaded track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to upload track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$e2f380e887795d02 = (0, $dEr3t.createAsyncThunk)("track/trackUpdate", async ({ track: track, name: name, cover: cover, genres: genres }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append track id
        formData.append("trackId", track.id || "");
        // if name provided
        if (name) // append name
        formData.append("name", name);
        // if cover provided
        if (cover) // append cover
        formData.append("cover", cover);
        // if genres provided
        if (genres && genres.length > 0) // append genres
        formData.append("genres", genres.join(","));
        // update track
        const { track: updatedTrack } = await api.trackApi.updateTrack({
            body: formData
        });
        // update track in track state
        dispatch((0, $1bnO9.trackUpdateTrack)({
            updatedTrack: updatedTrack || {}
        }));
        // update track in player state
        dispatch((0, $jhoVP.playerAudioUpdatePlaylistTrack)({
            updatedTrack: updatedTrack || {}
        }));
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully updated track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to update track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$92cf52a6069bc2b9 = (0, $dEr3t.createAsyncThunk)("track/trackBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // block track
        await api.trackApi.blockTrack({
            trackId: id
        });
        // filter blocked track from tracks
        dispatch((0, $1bnO9.trackFilterTrack)({
            id: id
        }));
        // filter blocked track from audio player
        dispatch((0, $jhoVP.playerAudioFilterPlaylistTrack)({
            id: id
        }));
        // set track as blocked in report state
        dispatch((0, $6CAIO.reportSetReportEntityBlocked)());
        // close track block modal
        dispatch((0, $1bnO9.trackCloseTrackBlockModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully blocked track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to block track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $86e431e6cdb3d1af$export$8542f6d1e2cb8f0e = (0, $dEr3t.createAsyncThunk)("track/trackDelete", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // delete track
        await api.trackApi.deleteTrack(id);
        // filter deleted track from tracks
        dispatch((0, $1bnO9.trackFilterTrack)({
            id: id
        }));
        // filter deleted track from audio player
        dispatch((0, $jhoVP.playerAudioFilterPlaylistTrack)({
            id: id
        }));
        // close track delete modal
        dispatch((0, $1bnO9.trackCloseTrackDeleteModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully deleted track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to delete track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("aolzG", function(module, exports) {

$parcel$export(module.exports, "TransactionCard", function () { return (parcelRequire("1HPfN")).TransactionCard; });
$parcel$export(module.exports, "TransactionListProfile", function () { return (parcelRequire("5r2Fv")).TransactionListProfile; });
$parcel$export(module.exports, "TransactionListProfileIncome", function () { return (parcelRequire("8iB69")).TransactionListProfileIncome; });
$parcel$export(module.exports, "TransactionListProfileOutgoing", function () { return (parcelRequire("4xsEl")).TransactionListProfileOutgoing; });
parcelRequire("fjBJb");
var $1HPfN = parcelRequire("1HPfN");
var $5r2Fv = parcelRequire("5r2Fv");
var $8iB69 = parcelRequire("8iB69");
var $4xsEl = parcelRequire("4xsEl");

var $9vtCE = parcelRequire("9vtCE");

var $cQu6S = parcelRequire("cQu6S");
$parcel$exportWildcard(module.exports, $9vtCE);
$parcel$exportWildcard(module.exports, $cQu6S);

});
parcelRegister("fjBJb", function(module, exports) {

$parcel$export(module.exports, "TransactionCard", function () { return (parcelRequire("1HPfN")).TransactionCard; });
$parcel$export(module.exports, "TransactionListProfile", function () { return (parcelRequire("5r2Fv")).TransactionListProfile; });
$parcel$export(module.exports, "TransactionListProfileIncome", function () { return (parcelRequire("8iB69")).TransactionListProfileIncome; });
$parcel$export(module.exports, "TransactionListProfileOutgoing", function () { return (parcelRequire("4xsEl")).TransactionListProfileOutgoing; });

var $1HPfN = parcelRequire("1HPfN");

var $5r2Fv = parcelRequire("5r2Fv");

var $8iB69 = parcelRequire("8iB69");

var $4xsEl = parcelRequire("4xsEl");

});
parcelRegister("1HPfN", function(module, exports) {

$parcel$export(module.exports, "TransactionCard", function () { return $1706a75b3a96928b$export$8037f3c5d034dea2; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $e7Ny8 = parcelRequire("e7Ny8");
const $1706a75b3a96928b$export$8037f3c5d034dea2 = ({ transaction: transaction, direction: direction, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    const { amount: amount, feeAmount: feeAmount, type: type, status: status, createdAt: createdAt, sourceUserId: sourceUserId, targetUserId: targetUserId } = transaction;
    // source user
    const { user: sourceUser, isLoading: isSourceUserLoading } = (0, $4y2bm.useUserPublic)(sourceUserId || "");
    const { username: sourceUserUsername } = sourceUser ?? {};
    // target user
    const { user: targetUser, isLoading: isTargetUserLoading } = (0, $4y2bm.useUserPublic)(targetUserId || "");
    const { username: targetUserUsername } = targetUser ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userUsernamePlaceholder = "unknown";
    const renderSourceUserUsername = ()=>{
        const username = isSourceUserLoading ? userLoadingPlaceholder : `@${sourceUserUsername || userUsernamePlaceholder}`;
        return username;
    };
    const renderTargetUserUsername = ()=>{
        const username = isTargetUserLoading ? userLoadingPlaceholder : `@${targetUserUsername || userUsernamePlaceholder}`;
        return username;
    };
    const date = new Date(createdAt || "");
    const dateDay = date.getUTCDate().toString().padStart(2, "0");
    const dateMonth = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const dateYear = date.getUTCFullYear();
    // const dateYear = date.getUTCFullYear() % 100
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $e7Ny8.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $e7Ny8.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $e7Ny8.styles)(theme).card.data.icon,
                        children: [
                            direction === "income" && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CreditCardOutgoing, {}),
                            direction === "outgoing" && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CreditCardOutgoing, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $e7Ny8.styles)(theme).card.data.source,
                        children: [
                            direction === "income" && renderSourceUserUsername(),
                            direction === "outgoing" && renderTargetUserUsername()
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $e7Ny8.styles)(theme).card.data.amount,
                        children: [
                            direction === "income" && `$${((amount || 0) - (feeAmount || 0)) / 100}`,
                            direction === "outgoing" && `-- $${(amount || 0) / 100}`
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e7Ny8.styles)(theme).card.data.type,
                        children: type
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e7Ny8.styles)(theme).card.data.status,
                        children: status
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $e7Ny8.styles)(theme).card.data.date,
                        children: `${dateDay}.${dateMonth}.${dateYear}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $e7Ny8.styles)(theme).card.divider
            })
        ]
    });
};
$1706a75b3a96928b$export$8037f3c5d034dea2.propTypes = {};

});
parcelRegister("e7Ny8", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9d6e5a64fc18a950$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $9d6e5a64fc18a950$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9d6e5a64fc18a950$var$_ref = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $9d6e5a64fc18a950$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $9d6e5a64fc18a950$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $9d6e5a64fc18a950$var$_ref4 = {
    name: "jxcdj8",
    styles: "flex:1 0 50px;max-width:60px"
};
var $9d6e5a64fc18a950$var$_ref5 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $9d6e5a64fc18a950$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $9d6e5a64fc18a950$var$_ref7 = {
    name: "1mz29im",
    styles: "display:flex;align-items:center;height:40px"
};
var $9d6e5a64fc18a950$var$_ref8 = {
    name: "d0fgu6",
    styles: "display:flex;flex-direction:column;justify-content:space-between;height:60px"
};
const $9d6e5a64fc18a950$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $9d6e5a64fc18a950$var$_ref8,
            data: {
                main: $9d6e5a64fc18a950$var$_ref7,
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex:0 0 40px;margin-right:10px;", (0, $48E0n.mq).tablet($9d6e5a64fc18a950$var$_ref6), " &>svg{height:22px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                source: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 100px;margin-right:10px;", (0, $48E0n.mq).mobile($9d6e5a64fc18a950$var$_ref5), ";", ""),
                amount: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;font-weight:bold;margin-right:10px;", (0, $48E0n.mq).mobile($9d6e5a64fc18a950$var$_ref4), ";", ""),
                type: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).tablet($9d6e5a64fc18a950$var$_ref3), ";", ""),
                status: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).mobile($9d6e5a64fc18a950$var$_ref2), ";", ""),
                date: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";flex:1 0 40px;max-width:80px;", (0, $48E0n.mq).mobile($9d6e5a64fc18a950$var$_ref), ";", "")
            },
            divider: /*#__PURE__*/ (0, $4N3Qt.css)("width:100%;height:1px;background-color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("5r2Fv", function(module, exports) {

$parcel$export(module.exports, "TransactionListProfile", function () { return $3b68a56df28e612e$export$1c0777ee0b836957; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $8iB69 = parcelRequire("8iB69");
var $4xsEl = parcelRequire("4xsEl");
parcelRequire("fRVt8");
var $8tjTN = parcelRequire("8tjTN");
const $3b68a56df28e612e$export$1c0777ee0b836957 = ()=>{
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const isUserArtist = profile?.role === (0, $aeAwZ.EntityUserRole).Artist;
    // if user is artist
    if (isUserArtist) // return artist transaction list
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8tjTN.SectionsLayout), {
        sections: [
            {
                id: "profile-income-transactions",
                name: "Incomes",
                section: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8iB69.TransactionListProfileIncome), {})
            },
            {
                id: "profile-outgoing-transactions",
                name: "Outgoings",
                section: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4xsEl.TransactionListProfileOutgoing), {})
            }
        ]
    });
    // else return fan/admin transaction list (only outgoing)
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8tjTN.SectionsLayout), {
        sections: [
            {
                id: "profile-outgoing-transactions",
                name: "Outgoings",
                section: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4xsEl.TransactionListProfileOutgoing), {})
            }
        ]
    });
};
$3b68a56df28e612e$export$1c0777ee0b836957.propTypes = {};

});

parcelRegister("8iB69", function(module, exports) {

$parcel$export(module.exports, "TransactionListProfileIncome", function () { return $bf650af0e1c47904$export$256622f1daba434; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $1HPfN = parcelRequire("1HPfN");
var $cQu6S = parcelRequire("cQu6S");
var $9vtCE = parcelRequire("9vtCE");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $lFRMC = parcelRequire("lFRMC");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $10ijG = parcelRequire("10ijG");
const $bf650af0e1c47904$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const transactions = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectIncomeTransactions));
    const transaction = transactions[index];
    // if transaction not fetched
    if (!transaction) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "transaction-list-transaction-income",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $10ijG.styles)().transactions.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1HPfN.TransactionCard), {
            direction: "income",
            transaction: transaction,
            onClick: ()=>{}
        })
    });
});
const $bf650af0e1c47904$export$256622f1daba434 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const transactionIncomeLoading = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectTransactionGetIncomeTransactionsLoading));
    const incomeTransactions = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectIncomeTransactions));
    const incomeTransactionsCount = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectIncomeTransactionsCount));
    const incomeTransactionsLength = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectIncomeTransactionsLength));
    const incomeTransactionsFetched = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectIncomeTransactionsFetched));
    const incomeTransactionsFilter = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectIncomeTransactionsFilter));
    const transactionCardHeight = 60;
    const transactionCardMarginBottom = 20;
    const itemHeight = transactionCardHeight + transactionCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 400;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!incomeTransactions[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $cQu6S.transactionGetIncomeTransactions)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders transaction list navigation
    const renderTransactionListNavigation = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $10ijG.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lFRMC.NavigationScrollable), {
                options: [
                    {
                        id: "8117e0a6-74dd-4057-826e-7686c0bacaea",
                        label: "Subscription",
                        enabled: incomeTransactionsFilter === (0, $aeAwZ.EntityTransactionType).Subscription,
                        onClick: ()=>{
                            // set transaction filter
                            dispatch((0, $9vtCE.transactionSetIncomeTransactionsFilter)({
                                filter: (0, $aeAwZ.EntityTransactionType).Subscription
                            }));
                            // refetch transactions
                            dispatch((0, $cQu6S.transactionGetIncomeTransactions)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "5627276c-1ef7-458d-a969-055ffeba8b31",
                        label: "Unlock",
                        enabled: incomeTransactionsFilter === (0, $aeAwZ.EntityTransactionType).Unlock,
                        onClick: ()=>{
                            // set transaction filter
                            dispatch((0, $9vtCE.transactionSetIncomeTransactionsFilter)({
                                filter: (0, $aeAwZ.EntityTransactionType).Unlock
                            }));
                            // refetch transactions
                            dispatch((0, $cQu6S.transactionGetIncomeTransactions)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "7785a9b4-9e85-4ee5-b415-b317c4781a4f",
                        label: "Tip",
                        enabled: incomeTransactionsFilter === (0, $aeAwZ.EntityTransactionType).Tip,
                        onClick: ()=>{
                            // set transaction filter
                            dispatch((0, $9vtCE.transactionSetIncomeTransactionsFilter)({
                                filter: (0, $aeAwZ.EntityTransactionType).Tip
                            }));
                            // refetch transactions
                            dispatch((0, $cQu6S.transactionGetIncomeTransactions)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    }
                ]
            })
        });
    // renders transaction list table header
    const renderTransactionListTableHeader = ()=>/*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $10ijG.styles)().list.header.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $10ijG.styles)().list.header.placeholder
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $10ijG.styles)().list.header.source,
                    children: "Source"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $10ijG.styles)().list.header.amount,
                    children: "Amount"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $10ijG.styles)().list.header.type,
                    children: "Type"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $10ijG.styles)().list.header.status,
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $10ijG.styles)().list.header.date,
                    children: "Date"
                })
            ]
        });
    // if income transactions are fetched but length is 0
    if (!transactionIncomeLoading && incomeTransactionsFetched && incomeTransactionsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $10ijG.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $10ijG.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
                    icon: (0, $9IIBp.icons).CreditCardIncome,
                    height: "400px",
                    title: "You don't have any income transactions yet"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $10ijG.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $10ijG.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: incomeTransactionsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: incomeTransactionsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $bf650af0e1c47904$var$Row
                        })
                })
            })
        ]
    }));
};
$bf650af0e1c47904$export$256622f1daba434.propTypes = {};

});
parcelRegister("10ijG", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fb25dcf997436a24$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $fb25dcf997436a24$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fb25dcf997436a24$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
var $fb25dcf997436a24$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $fb25dcf997436a24$var$_ref3 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $fb25dcf997436a24$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $fb25dcf997436a24$var$_ref5 = {
    name: "jxcdj8",
    styles: "flex:1 0 50px;max-width:60px"
};
var $fb25dcf997436a24$var$_ref6 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $fb25dcf997436a24$var$_ref7 = {
    name: "eivff4",
    styles: "display:none"
};
var $fb25dcf997436a24$var$_ref8 = {
    name: "phodm9",
    styles: "display:flex;max-width:800px;margin-bottom:32px"
};
const $fb25dcf997436a24$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            header: {
                main: $fb25dcf997436a24$var$_ref8,
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("flex:0 0 40px;margin-right:10px;", (0, $48E0n.mq).tablet($fb25dcf997436a24$var$_ref7), ";", ""),
                source: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 100px;margin-right:10px;", (0, $48E0n.mq).mobile($fb25dcf997436a24$var$_ref6), ";", ""),
                amount: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).mobile($fb25dcf997436a24$var$_ref5), ";", ""),
                type: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).tablet($fb25dcf997436a24$var$_ref4), ";", ""),
                status: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).mobile($fb25dcf997436a24$var$_ref3), ";", ""),
                date: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 40px;max-width:80px;", (0, $48E0n.mq).mobile($fb25dcf997436a24$var$_ref2), ";", "")
            },
            content: {
                main: $fb25dcf997436a24$var$_ref
            }
        },
        transactions: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});


parcelRegister("4xsEl", function(module, exports) {

$parcel$export(module.exports, "TransactionListProfileOutgoing", function () { return $2561d052bcc327a9$export$2856e0515b6dfb42; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $1HPfN = parcelRequire("1HPfN");
var $cQu6S = parcelRequire("cQu6S");
var $9vtCE = parcelRequire("9vtCE");
parcelRequire("fRVt8");
var $46Iw7 = parcelRequire("46Iw7");
var $lFRMC = parcelRequire("lFRMC");
var $cK2N9 = parcelRequire("cK2N9");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $9xeXo = parcelRequire("9xeXo");
const $2561d052bcc327a9$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const transactions = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectOutgoingTransactions));
    const transaction = transactions[index];
    // if transaction not fetched
    if (!transaction) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $cK2N9.SkeletonHorizontal), {
            sections: [
                {
                    name: "transaction-list-transaction-income",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $9xeXo.styles)().transactions.main,
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1HPfN.TransactionCard), {
            direction: "outgoing",
            transaction: transaction,
            onClick: ()=>{}
        })
    });
});
const $2561d052bcc327a9$export$2856e0515b6dfb42 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const isUserArtist = profile?.role === (0, $aeAwZ.EntityUserRole).Artist;
    const transactionOutgoingLoading = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectTransactionGetOutgoingTransactionsLoading));
    const outgoingTransactions = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectOutgoingTransactions));
    const outgoingTransactionsCount = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectOutgoingTransactionsCount));
    const outgoingTransactionsLength = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectOutgoingTransactionsLength));
    const outgoingTransactionsFetched = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectOutgoingTransactionsFetched));
    const outgoingTransactionsFilter = (0, $9CcOD.useAppSelector)((0, $9vtCE.transactionSelectOutgoingTransactionsFilter));
    const transactionCardHeight = 60;
    const transactionCardMarginBottom = 20;
    const itemHeight = transactionCardHeight + transactionCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 400;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!outgoingTransactions[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $cQu6S.transactionGetOutgoingTransactions)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders transaction list navigation
    const renderTransactionListNavigation = ()=>{
        const navigationOptions = [
            {
                id: "c817c390-05a0-451f-84f9-3e0f789f65ec",
                label: "Subscription",
                enabled: outgoingTransactionsFilter === (0, $aeAwZ.EntityTransactionType).Subscription,
                onClick: ()=>{
                    // set transaction filter
                    dispatch((0, $9vtCE.transactionSetOutgoingTransactionsFilter)({
                        filter: (0, $aeAwZ.EntityTransactionType).Subscription
                    }));
                    // refetch transactions
                    dispatch((0, $cQu6S.transactionGetOutgoingTransactions)({
                        limit: 30,
                        offset: 0
                    }));
                }
            },
            {
                id: "31f31ae6-6941-4c7e-88ea-91e39567bf07",
                label: "Unlock",
                enabled: outgoingTransactionsFilter === (0, $aeAwZ.EntityTransactionType).Unlock,
                onClick: ()=>{
                    // set transaction filter
                    dispatch((0, $9vtCE.transactionSetOutgoingTransactionsFilter)({
                        filter: (0, $aeAwZ.EntityTransactionType).Unlock
                    }));
                    // refetch transactions
                    dispatch((0, $cQu6S.transactionGetOutgoingTransactions)({
                        limit: 30,
                        offset: 0
                    }));
                }
            },
            {
                id: "cf8fe255-895a-40d0-98e7-0d591cd10450",
                label: "Tip",
                enabled: outgoingTransactionsFilter === (0, $aeAwZ.EntityTransactionType).Tip,
                onClick: ()=>{
                    // set transaction filter
                    dispatch((0, $9vtCE.transactionSetOutgoingTransactionsFilter)({
                        filter: (0, $aeAwZ.EntityTransactionType).Tip
                    }));
                    // refetch transactions
                    dispatch((0, $cQu6S.transactionGetOutgoingTransactions)({
                        limit: 30,
                        offset: 0
                    }));
                }
            }
        ];
        // if user role is artist
        if (isUserArtist) // add payout option to navigation
        navigationOptions.push({
            id: "a83d837d-2a30-4bef-8992-389ebc3ba340",
            label: "Payout",
            enabled: outgoingTransactionsFilter === (0, $aeAwZ.EntityTransactionType).Payout,
            onClick: ()=>{
                // set transaction filter
                dispatch((0, $9vtCE.transactionSetOutgoingTransactionsFilter)({
                    filter: (0, $aeAwZ.EntityTransactionType).Payout
                }));
                // refetch transactions
                dispatch((0, $cQu6S.transactionGetOutgoingTransactions)({
                    limit: 30,
                    offset: 0
                }));
            }
        });
        return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $9xeXo.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lFRMC.NavigationScrollable), {
                options: navigationOptions
            })
        });
    };
    // renders transaction list table header
    const renderTransactionListTableHeader = ()=>/*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $9xeXo.styles)().list.header.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $9xeXo.styles)().list.header.placeholder
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $9xeXo.styles)().list.header.source,
                    children: "Destination"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $9xeXo.styles)().list.header.amount,
                    children: "Amount"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $9xeXo.styles)().list.header.type,
                    children: "Type"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $9xeXo.styles)().list.header.status,
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $9xeXo.styles)().list.header.date,
                    children: "Date"
                })
            ]
        });
    // if outgoing transactions are fetched but length is 0
    if (!transactionOutgoingLoading && outgoingTransactionsFetched && outgoingTransactionsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9xeXo.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9xeXo.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
                    icon: (0, $9IIBp.icons).CreditCardOutgoing,
                    height: "400px",
                    title: "You don't have any outgoing transactions yet"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $9xeXo.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $9xeXo.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: outgoingTransactionsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: outgoingTransactionsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $2561d052bcc327a9$var$Row
                        })
                })
            })
        ]
    }));
};
$2561d052bcc327a9$export$2856e0515b6dfb42.propTypes = {};

});
parcelRegister("9xeXo", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0c72fa2735f35eb1$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $0c72fa2735f35eb1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0c72fa2735f35eb1$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
var $0c72fa2735f35eb1$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $0c72fa2735f35eb1$var$_ref3 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $0c72fa2735f35eb1$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $0c72fa2735f35eb1$var$_ref5 = {
    name: "jxcdj8",
    styles: "flex:1 0 50px;max-width:60px"
};
var $0c72fa2735f35eb1$var$_ref6 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $0c72fa2735f35eb1$var$_ref7 = {
    name: "eivff4",
    styles: "display:none"
};
var $0c72fa2735f35eb1$var$_ref8 = {
    name: "phodm9",
    styles: "display:flex;max-width:800px;margin-bottom:32px"
};
const $0c72fa2735f35eb1$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            header: {
                main: $0c72fa2735f35eb1$var$_ref8,
                placeholder: /*#__PURE__*/ (0, $4N3Qt.css)("flex:0 0 40px;margin-right:10px;", (0, $48E0n.mq).tablet($0c72fa2735f35eb1$var$_ref7), ";", ""),
                source: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 100px;margin-right:10px;", (0, $48E0n.mq).mobile($0c72fa2735f35eb1$var$_ref6), ";", ""),
                amount: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).mobile($0c72fa2735f35eb1$var$_ref5), ";", ""),
                type: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).tablet($0c72fa2735f35eb1$var$_ref4), ";", ""),
                status: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $48E0n.mq).mobile($0c72fa2735f35eb1$var$_ref3), ";", ""),
                date: /*#__PURE__*/ (0, $4N3Qt.css)("flex:1 0 40px;max-width:80px;", (0, $48E0n.mq).mobile($0c72fa2735f35eb1$var$_ref2), ";", "")
            },
            content: {
                main: $0c72fa2735f35eb1$var$_ref
            }
        },
        transactions: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
        }
    });

});



parcelRegister("9vtCE", function(module, exports) {

$parcel$export(module.exports, "transactionSlice", function () { return $be910d325a63e07c$export$50753e6b3a2a3e01; });
$parcel$export(module.exports, "transactionResetState", function () { return $be910d325a63e07c$export$e263c55469ea9e92; });
$parcel$export(module.exports, "transactionSetIncomeTransactions", function () { return $be910d325a63e07c$export$8ec75378a6089245; });
$parcel$export(module.exports, "transactionSetOutgoingTransactions", function () { return $be910d325a63e07c$export$2795f70be06408c7; });
$parcel$export(module.exports, "transactionSetIncomeTransactionsFilter", function () { return $be910d325a63e07c$export$d7af09debfce2e95; });
$parcel$export(module.exports, "transactionSetOutgoingTransactionsFilter", function () { return $be910d325a63e07c$export$97080fea7d80893; });
$parcel$export(module.exports, "transactionSelectIncomeTransactions", function () { return $be910d325a63e07c$export$465304041e1948bf; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsLength", function () { return $be910d325a63e07c$export$7ac222d691bc35e6; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsCount", function () { return $be910d325a63e07c$export$2e7acd40b7647d67; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsFetched", function () { return $be910d325a63e07c$export$87c2a19b37b22098; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactions", function () { return $be910d325a63e07c$export$ff6ea9e9968492e0; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsLength", function () { return $be910d325a63e07c$export$876b82d6defea402; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsCount", function () { return $be910d325a63e07c$export$bc7e9b7692977cfb; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsFetched", function () { return $be910d325a63e07c$export$f71580874830fd7c; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsFilter", function () { return $be910d325a63e07c$export$9ba7c4d71af54507; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsFilter", function () { return $be910d325a63e07c$export$e608d6219c20d059; });
$parcel$export(module.exports, "transactionSelectTransactionGetIncomeTransactionsLoading", function () { return $be910d325a63e07c$export$d3ebba3efb840bfd; });
$parcel$export(module.exports, "transactionSelectTransactionGetOutgoingTransactionsLoading", function () { return $be910d325a63e07c$export$5e8e1a9cca35a3db; });
$parcel$export(module.exports, "transactionReducer", function () { return $be910d325a63e07c$export$7effe25fda542ae1; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $cQu6S = parcelRequire("cQu6S");
const $be910d325a63e07c$var$initialState = {
    incomeTransactions: [],
    incomeTransactionsCount: 0,
    incomeTransactionsFetched: false,
    outgoingTransactions: [],
    outgoingTransactionsCount: 0,
    outgoingTransactionsFetched: false,
    incomeTransactionsFilter: undefined,
    outgoingTransactionsFilter: undefined,
    transactionGetIncomeTransactionsLoading: false,
    transactionGetOutgoingTransactionsLoading: false
};
const $be910d325a63e07c$export$50753e6b3a2a3e01 = (0, $dEr3t.createSlice)({
    name: "transaction",
    initialState: $be910d325a63e07c$var$initialState,
    reducers: {
        // reset state
        transactionResetState: ()=>({
                incomeTransactions: [],
                incomeTransactionsCount: 0,
                incomeTransactionsFetched: false,
                outgoingTransactions: [],
                outgoingTransactionsCount: 0,
                outgoingTransactionsFetched: false,
                incomeTransactionsFilter: undefined,
                outgoingTransactionsFilter: undefined,
                transactionGetIncomeTransactionsLoading: false,
                transactionGetOutgoingTransactionsLoading: false
            }),
        // set income transactions
        transactionSetIncomeTransactions: (state, action)=>{
            const { transactions: transactions, count: count, offset: offset } = action.payload;
            // mutate count
            state.incomeTransactionsCount = count;
            // mutate income transactions array
            state.incomeTransactions = (0, $9UVKd.mergeArraysAtIndex)(state.incomeTransactions, transactions, offset);
        },
        // set outgoing transactions
        transactionSetOutgoingTransactions: (state, action)=>{
            const { transactions: transactions, count: count, offset: offset } = action.payload;
            // mutate count
            state.outgoingTransactionsCount = count;
            // mutate outgoing transactions array
            state.outgoingTransactions = (0, $9UVKd.mergeArraysAtIndex)(state.outgoingTransactions, transactions, offset);
        },
        // set income transactions filter
        transactionSetIncomeTransactionsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup income transactions
            state.incomeTransactionsCount = 0;
            state.incomeTransactions = [];
            // mutate income transactions filter
            state.incomeTransactionsFilter = state.incomeTransactionsFilter === filter ? undefined : filter;
        },
        // set outgoing transactions filter
        transactionSetOutgoingTransactionsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup outgoing transactions
            state.outgoingTransactionsCount = 0;
            state.outgoingTransactions = [];
            // mutate outgoing transactions filter
            state.outgoingTransactionsFilter = state.outgoingTransactionsFilter === filter ? undefined : filter;
        }
    },
    extraReducers: (builder)=>{
        // get income transactions
        builder.addCase((0, $cQu6S.transactionGetIncomeTransactions).pending, (state)=>({
                ...state,
                transactionGetIncomeTransactionsLoading: true
            })).addCase((0, $cQu6S.transactionGetIncomeTransactions).fulfilled, (state)=>({
                ...state,
                incomeTransactionsFetched: true,
                transactionGetIncomeTransactionsLoading: false
            }));
        // get outgoing transactions
        builder.addCase((0, $cQu6S.transactionGetOutgoingTransactions).pending, (state)=>({
                ...state,
                transactionGetOutgoingTransactionsLoading: true
            })).addCase((0, $cQu6S.transactionGetOutgoingTransactions).fulfilled, (state)=>({
                ...state,
                outgoingTransactionsFetched: true,
                transactionGetOutgoingTransactionsLoading: false
            }));
    }
});
const { transactionResetState: $be910d325a63e07c$export$e263c55469ea9e92, transactionSetIncomeTransactions: $be910d325a63e07c$export$8ec75378a6089245, transactionSetOutgoingTransactions: $be910d325a63e07c$export$2795f70be06408c7, transactionSetIncomeTransactionsFilter: $be910d325a63e07c$export$d7af09debfce2e95, transactionSetOutgoingTransactionsFilter: $be910d325a63e07c$export$97080fea7d80893 } = $be910d325a63e07c$export$50753e6b3a2a3e01.actions;
const $be910d325a63e07c$export$465304041e1948bf = (state)=>state.transaction.incomeTransactions;
const $be910d325a63e07c$export$7ac222d691bc35e6 = (state)=>state.transaction.incomeTransactions.length;
const $be910d325a63e07c$export$2e7acd40b7647d67 = (state)=>state.transaction.incomeTransactionsCount;
const $be910d325a63e07c$export$87c2a19b37b22098 = (state)=>state.transaction.incomeTransactionsFetched;
const $be910d325a63e07c$export$ff6ea9e9968492e0 = (state)=>state.transaction.outgoingTransactions;
const $be910d325a63e07c$export$876b82d6defea402 = (state)=>state.transaction.outgoingTransactions.length;
const $be910d325a63e07c$export$bc7e9b7692977cfb = (state)=>state.transaction.outgoingTransactionsCount;
const $be910d325a63e07c$export$f71580874830fd7c = (state)=>state.transaction.outgoingTransactionsFetched;
const $be910d325a63e07c$export$9ba7c4d71af54507 = (state)=>state.transaction.incomeTransactionsFilter;
const $be910d325a63e07c$export$e608d6219c20d059 = (state)=>state.transaction.outgoingTransactionsFilter;
const $be910d325a63e07c$export$d3ebba3efb840bfd = (state)=>state.transaction.transactionGetIncomeTransactionsLoading;
const $be910d325a63e07c$export$5e8e1a9cca35a3db = (state)=>state.transaction.transactionGetOutgoingTransactionsLoading;
const $be910d325a63e07c$export$7effe25fda542ae1 = $be910d325a63e07c$export$50753e6b3a2a3e01.reducer; // export default transactionSlice.reducer

});

parcelRegister("cQu6S", function(module, exports) {

$parcel$export(module.exports, "transactionGetIncomeTransactions", function () { return $2211a6c5d3ed4b34$export$51b0f10822239e5d; });
$parcel$export(module.exports, "transactionGetOutgoingTransactions", function () { return $2211a6c5d3ed4b34$export$416969724ef90929; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("dmGpj");
var $9vtCE = parcelRequire("9vtCE");
const $2211a6c5d3ed4b34$export$51b0f10822239e5d = (0, $dEr3t.createAsyncThunk)("transaction/transactionGetIncomeTransactions", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get income transactions filter
    const filter = getState().transaction.incomeTransactionsFilter;
    // define transaction type
    let transactionType;
    // assert transaction type
    switch(filter){
        case (0, $aeAwZ.EntityTransactionType).Subscription:
            transactionType = "subscription";
            break;
        case (0, $aeAwZ.EntityTransactionType).Tip:
            transactionType = "tip";
            break;
        case (0, $aeAwZ.EntityTransactionType).Unlock:
            transactionType = "unlock";
            break;
        case (0, $aeAwZ.EntityTransactionType).Payout:
            transactionType = "payout";
            break;
        default:
            transactionType = undefined;
    }
    try {
        // retrieve transactions
        const { transactions: transactions, count: count } = await api.transactionApi.getIncomeTransactions(inp.limit, inp.offset, transactionType);
        // set income transactions
        dispatch((0, $9vtCE.transactionSetIncomeTransactions)({
            transactions: transactions || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2211a6c5d3ed4b34$export$416969724ef90929 = (0, $dEr3t.createAsyncThunk)("transaction/transactionGetOutgoingTransactions", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get outgoing transactions filter
    const filter = getState().transaction.outgoingTransactionsFilter;
    // define transaction type
    let transactionType;
    // assert transaction type
    switch(filter){
        case (0, $aeAwZ.EntityTransactionType).Subscription:
            transactionType = "subscription";
            break;
        case (0, $aeAwZ.EntityTransactionType).Tip:
            transactionType = "tip";
            break;
        case (0, $aeAwZ.EntityTransactionType).Unlock:
            transactionType = "unlock";
            break;
        case (0, $aeAwZ.EntityTransactionType).Payout:
            transactionType = "payout";
            break;
        default:
            transactionType = undefined;
    }
    try {
        // retrieve transactions
        const { transactions: transactions, count: count } = await api.transactionApi.getOutgoingTransactions(inp.limit, inp.offset, transactionType);
        // set income transactions
        dispatch((0, $9vtCE.transactionSetOutgoingTransactions)({
            transactions: transactions || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("gJgVd", function(module, exports) {

$parcel$export(module.exports, "UnlockPostModal", function () { return (parcelRequire("kwZ7g")).UnlockPostModal; });
$parcel$export(module.exports, "UnlockTrackModal", function () { return (parcelRequire("ksO5o")).UnlockTrackModal; });
parcelRequire("3w87I");
var $kwZ7g = parcelRequire("kwZ7g");
var $ksO5o = parcelRequire("ksO5o");

var $eFMHm = parcelRequire("eFMHm");

var $b0u33 = parcelRequire("b0u33");
$parcel$exportWildcard(module.exports, $eFMHm);
$parcel$exportWildcard(module.exports, $b0u33);

});
parcelRegister("3w87I", function(module, exports) {

$parcel$export(module.exports, "UnlockPostModal", function () { return (parcelRequire("kwZ7g")).UnlockPostModal; });
$parcel$export(module.exports, "UnlockTrackModal", function () { return (parcelRequire("ksO5o")).UnlockTrackModal; });

var $kwZ7g = parcelRequire("kwZ7g");

var $ksO5o = parcelRequire("ksO5o");

});
parcelRegister("kwZ7g", function(module, exports) {

$parcel$export(module.exports, "UnlockPostModal", function () { return $270544dd0dce07d9$export$1685d719ed39c512; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("lb268");
var $efyVx = parcelRequire("efyVx");

var $2iZYy = parcelRequire("2iZYy");
const $270544dd0dce07d9$export$1685d719ed39c512 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const unlockPostModalOpen = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockPostModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $2iZYy.styles)().modal.main,
        children: unlockPostModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $eFMHm.unlockCloseUnlockPostModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $2iZYy.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $efyVx.UnlockPostCard), {})
            })
        })
    });
};
$270544dd0dce07d9$export$1685d719ed39c512.propTypes = {};

});
parcelRegister("lb268", function(module, exports) {

$parcel$export(module.exports, "UnlockPostCard", function () { return (parcelRequire("efyVx")).UnlockPostCard; });

var $efyVx = parcelRequire("efyVx");

});
parcelRegister("efyVx", function(module, exports) {

$parcel$export(module.exports, "UnlockPostCard", function () { return $a33ae231aa85d31d$export$595b02be5fd36fca; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("dmGpj");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("3RDjP");
var $qt9lU = parcelRequire("qt9lU");

var $eALAY = parcelRequire("eALAY");
const $a33ae231aa85d31d$export$595b02be5fd36fca = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const modalPost = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockPostModalPost));
    const unlockPostError = "";
    const { userId: authorUserId } = modalPost ?? {};
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $4y2bm.useUserPublic)(authorUserId || "");
    const { username: authorUsername } = postAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorUsernamePlaceholder = "unknown";
    const subtitleAccentStartIndex = 52;
    const subtitleAccentEndIndex = 53 + (authorUsername?.length || authorLoadingPlaceholder.length || authorUsernamePlaceholder.length);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $eALAY.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $eALAY.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $eFMHm.unlockCloseUnlockPostModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $eALAY.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Unlock Post",
                    icon: (0, $9IIBp.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $eALAY.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: `Access premium content and express your support for @${isPostAuthorLoading ? authorLoadingPlaceholder : authorUsername || authorUsernamePlaceholder} by unlocking exclusive post.`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${authorUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $eALAY.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $eALAY.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $qt9lU.UnlockPostForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $eALAY.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: unlockPostError
                        })
                    })
                ]
            })
        ]
    });
};
$a33ae231aa85d31d$export$595b02be5fd36fca.propTypes = {};

});
parcelRegister("3RDjP", function(module, exports) {

$parcel$export(module.exports, "UnlockPostForm", function () { return (parcelRequire("qt9lU")).UnlockPostForm; });

var $qt9lU = parcelRequire("qt9lU");

});
parcelRegister("qt9lU", function(module, exports) {

$parcel$export(module.exports, "UnlockPostForm", function () { return $913b5c7d7f7a4603$export$685a8e45433d2d9f; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $d1vGL = parcelRequire("d1vGL");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $2DEaW = parcelRequire("2DEaW");
var $b0u33 = parcelRequire("b0u33");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $cWOeV = parcelRequire("cWOeV");
const $913b5c7d7f7a4603$export$685a8e45433d2d9f = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const unlockCreatePostUnlockLoading = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockCreatePostUnlockLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalPost = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockPostModalPost));
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId, unlockPrice: unlockPrice, mediaType: mediaType, trackIds: trackIds } = modalPost ?? {};
    const isCurrentUserContentUnlock = profileUserId === artistUserId;
    const postHasMediaContent = mediaType === (0, $aeAwZ.EntityPostMediaType).Image || mediaType === (0, $aeAwZ.EntityPostMediaType).Video;
    const postHasTracksContent = trackIds?.length && trackIds.length > 0;
    const displayPostContentDescription = postHasMediaContent || postHasTracksContent;
    const submitDisabled = isCurrentUserContentUnlock || unlockCreatePostUnlockLoading;
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $d1vGL.useTracks)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const tracksCount = postTracks?.length || 0;
    const lockedTracksCount = postTracks?.reduce((acc, t)=>t.visibility === (0, $aeAwZ.EntityTrackVisibility).Subscribers ? acc + 1 : acc, 0);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $cWOeV.styles)(theme).form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $cWOeV.styles)(theme).form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $b0u33.unlockCreatePostUnlock)());
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $cWOeV.styles)(theme).form.content.product,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2DEaW.PostCardProduct), {})
                }),
                displayPostContentDescription && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $cWOeV.styles)(theme).form.content.description.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $cWOeV.styles)(theme).form.content.description.text,
                            children: "This post features a total of:"
                        }),
                        postHasMediaContent && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $cWOeV.styles)(theme).form.content.description.text,
                            children: [
                                "engaging",
                                " ",
                                /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                    css: (0, $cWOeV.styles)(theme).form.content.description.accent,
                                    children: mediaType
                                }),
                                " ",
                                "content"
                            ]
                        }),
                        postHasTracksContent && /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $cWOeV.styles)(theme).form.content.description.text,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                    css: (0, $cWOeV.styles)(theme).form.content.description.accent,
                                    children: isPostTracksLoading ? tracksLoadingPlaceholder : tracksCount
                                }),
                                " ",
                                "tracks, with",
                                " ",
                                /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                                    css: (0, $cWOeV.styles)(theme).form.content.description.accent,
                                    children: isPostTracksLoading ? tracksLoadingPlaceholder : lockedTracksCount
                                }),
                                " ",
                                "of them being exclusive"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $cWOeV.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "unlock post",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: unlockCreatePostUnlockLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Unlock for $${unlockPrice && unlockPrice / 100}`
                    })
                })
            ]
        })
    });
};
$913b5c7d7f7a4603$export$685a8e45433d2d9f.propTypes = {};

});
parcelRegister("cWOeV", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $200c1ad3e12094a2$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $200c1ad3e12094a2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $200c1ad3e12094a2$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $200c1ad3e12094a2$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                product: $200c1ad3e12094a2$var$_ref,
                description: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";margin-bottom:24px;", ""),
                    text: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    accent: /*#__PURE__*/ (0, $4N3Qt.css)("font-weight:bold;color:", theme.colors.accent.normal, ";", "")
                },
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("eALAY", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $297490ba9b47ad9a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $297490ba9b47ad9a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $297490ba9b47ad9a$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $297490ba9b47ad9a$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $297490ba9b47ad9a$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $297490ba9b47ad9a$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $297490ba9b47ad9a$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $297490ba9b47ad9a$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $297490ba9b47ad9a$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $297490ba9b47ad9a$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $297490ba9b47ad9a$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($297490ba9b47ad9a$var$_ref8), " ", (0, $48E0n.mq).mobile($297490ba9b47ad9a$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($297490ba9b47ad9a$var$_ref6), ";", ""),
            title: $297490ba9b47ad9a$var$_ref5,
            subtitle: $297490ba9b47ad9a$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($297490ba9b47ad9a$var$_ref3), ";", ""),
                form: $297490ba9b47ad9a$var$_ref2,
                error: $297490ba9b47ad9a$var$_ref
            }
        }
    });

});



parcelRegister("2iZYy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7dce92832daa037c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7dce92832daa037c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7dce92832daa037c$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $7dce92832daa037c$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($7dce92832daa037c$var$_ref), ";", "")
        }
    });

});


parcelRegister("ksO5o", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackModal", function () { return $ed85a55280975df4$export$1e592ca8ae9cb6b5; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("8MTQ4");
var $icVCV = parcelRequire("icVCV");

var $f1gyA = parcelRequire("f1gyA");
const $ed85a55280975df4$export$1e592ca8ae9cb6b5 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const unlockTrackModalOpen = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockTrackModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $f1gyA.styles)().modal.main,
        children: unlockTrackModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $eFMHm.unlockCloseUnlockTrackModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f1gyA.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $icVCV.UnlockTrackCard), {})
            })
        })
    });
};
$ed85a55280975df4$export$1e592ca8ae9cb6b5.propTypes = {};

});
parcelRegister("8MTQ4", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackCard", function () { return (parcelRequire("icVCV")).UnlockTrackCard; });

var $icVCV = parcelRequire("icVCV");

});
parcelRegister("icVCV", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackCard", function () { return $cb72d91b9d21a9f5$export$c893483e3978e7e0; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $4y2bm = parcelRequire("4y2bm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("dmGpj");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("l5VI7");
var $dMfnP = parcelRequire("dMfnP");

var $jeCRu = parcelRequire("jeCRu");
const $cb72d91b9d21a9f5$export$c893483e3978e7e0 = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const modalTrack = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockTrackModalTrack));
    const unlockTrackError = "";
    const { userId: authorUserId } = modalTrack ?? {};
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $4y2bm.useUserPublic)(authorUserId || "");
    const { username: authorUsername } = trackAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorUsernamePlaceholder = "unknown";
    const subtitleAccentStartIndex = 52;
    const subtitleAccentEndIndex = 53 + (authorUsername?.length || authorLoadingPlaceholder.length || authorUsernamePlaceholder.length);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $jeCRu.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $jeCRu.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $eFMHm.unlockCloseUnlockTrackModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $jeCRu.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Unlock Track",
                    icon: (0, $9IIBp.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $jeCRu.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: `Access premium content and express your support for @${isTrackAuthorLoading ? authorLoadingPlaceholder : authorUsername || authorUsernamePlaceholder} by unlocking exclusive track.`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $9YTSb.Path).User}/${authorUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $jeCRu.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $jeCRu.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $dMfnP.UnlockTrackForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $jeCRu.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: unlockTrackError
                        })
                    })
                ]
            })
        ]
    });
};
$cb72d91b9d21a9f5$export$c893483e3978e7e0.propTypes = {};

});
parcelRegister("l5VI7", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackForm", function () { return (parcelRequire("dMfnP")).UnlockTrackForm; });

var $dMfnP = parcelRequire("dMfnP");

});
parcelRegister("dMfnP", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackForm", function () { return $c12afdfcd2a57feb$export$9f8197e356abe44; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $i113K = parcelRequire("i113K");
var $b0u33 = parcelRequire("b0u33");
var $eFMHm = parcelRequire("eFMHm");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $8XoBa = parcelRequire("8XoBa");
const $c12afdfcd2a57feb$export$9f8197e356abe44 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const unlockCreateTrackUnlockLoading = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockCreateTrackUnlockLoading));
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const modalTrack = (0, $9CcOD.useAppSelector)((0, $eFMHm.unlockSelectUnlockTrackModalTrack));
    const { id: profileUserId } = profile ?? {};
    const { unlockPrice: unlockPrice, userId: artistUserId } = modalTrack ?? {};
    const isCurrentUserContentUnlock = profileUserId === artistUserId;
    const submitDisabled = isCurrentUserContentUnlock || unlockCreateTrackUnlockLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8XoBa.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $8XoBa.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $b0u33.unlockCreateTrackUnlock)());
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8XoBa.styles)().form.content.product,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $i113K.TrackTileProduct), {
                        track: modalTrack || {}
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8XoBa.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "unlock track",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: unlockCreateTrackUnlockLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Unlock for $${unlockPrice && unlockPrice / 100}`
                    })
                })
            ]
        })
    });
};
$c12afdfcd2a57feb$export$9f8197e356abe44.propTypes = {};

});
parcelRegister("8XoBa", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9fb76cd90d2d5f2a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $9fb76cd90d2d5f2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9fb76cd90d2d5f2a$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $9fb76cd90d2d5f2a$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                product: $9fb76cd90d2d5f2a$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("jeCRu", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c6a08a37e611be0f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $c6a08a37e611be0f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c6a08a37e611be0f$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $c6a08a37e611be0f$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $c6a08a37e611be0f$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $c6a08a37e611be0f$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c6a08a37e611be0f$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c6a08a37e611be0f$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $c6a08a37e611be0f$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $c6a08a37e611be0f$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $c6a08a37e611be0f$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($c6a08a37e611be0f$var$_ref8), " ", (0, $48E0n.mq).mobile($c6a08a37e611be0f$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($c6a08a37e611be0f$var$_ref6), ";", ""),
            title: $c6a08a37e611be0f$var$_ref5,
            subtitle: $c6a08a37e611be0f$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($c6a08a37e611be0f$var$_ref3), ";", ""),
                form: $c6a08a37e611be0f$var$_ref2,
                error: $c6a08a37e611be0f$var$_ref
            }
        }
    });

});



parcelRegister("f1gyA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b39a3b00616357dd$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $b39a3b00616357dd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b39a3b00616357dd$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $b39a3b00616357dd$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($b39a3b00616357dd$var$_ref), ";", "")
        }
    });

});



parcelRegister("eFMHm", function(module, exports) {

$parcel$export(module.exports, "unlockSlice", function () { return $24301a4b0c33287f$export$381ce5319c2274da; });
$parcel$export(module.exports, "unlockResetState", function () { return $24301a4b0c33287f$export$35f1884a3da44f69; });
$parcel$export(module.exports, "unlockSetPostUnlocks", function () { return $24301a4b0c33287f$export$2bfaa55cc0ca870d; });
$parcel$export(module.exports, "unlockAddPostUnlock", function () { return $24301a4b0c33287f$export$11e0007326c9d985; });
$parcel$export(module.exports, "unlockRemovePostUnlock", function () { return $24301a4b0c33287f$export$381fca7a8b5f0b4a; });
$parcel$export(module.exports, "unlockSetTrackUnlocks", function () { return $24301a4b0c33287f$export$56e394be1baad6a; });
$parcel$export(module.exports, "unlockAddTrackUnlock", function () { return $24301a4b0c33287f$export$d3ce7022a65cf68b; });
$parcel$export(module.exports, "unlockRemoveTrackUnlock", function () { return $24301a4b0c33287f$export$8c749fae48cabbde; });
$parcel$export(module.exports, "unlockOpenUnlockPostModal", function () { return $24301a4b0c33287f$export$6bf84dbbd6226b5b; });
$parcel$export(module.exports, "unlockCloseUnlockPostModal", function () { return $24301a4b0c33287f$export$1d8ecc069ad7c7f7; });
$parcel$export(module.exports, "unlockOpenUnlockTrackModal", function () { return $24301a4b0c33287f$export$e7859b55a7b4f99c; });
$parcel$export(module.exports, "unlockCloseUnlockTrackModal", function () { return $24301a4b0c33287f$export$8ac968d6a6fbe230; });
$parcel$export(module.exports, "unlockSelectPostUnlocks", function () { return $24301a4b0c33287f$export$784e3adf5ad22d23; });
$parcel$export(module.exports, "unlockSelectTrackUnlocks", function () { return $24301a4b0c33287f$export$bf416d4ed55b04ac; });
$parcel$export(module.exports, "unlockSelectUnlockPostModalOpen", function () { return $24301a4b0c33287f$export$f5cd230b3e742cbc; });
$parcel$export(module.exports, "unlockSelectUnlockPostModalPost", function () { return $24301a4b0c33287f$export$f7ee293c19e0841b; });
$parcel$export(module.exports, "unlockSelectUnlockTrackModalOpen", function () { return $24301a4b0c33287f$export$f3090f5fff7cfeff; });
$parcel$export(module.exports, "unlockSelectUnlockTrackModalTrack", function () { return $24301a4b0c33287f$export$74288cfc472b94ae; });
$parcel$export(module.exports, "unlockSelectUnlockGetUnlockedPostIdsLoading", function () { return $24301a4b0c33287f$export$6e2d9b9989319967; });
$parcel$export(module.exports, "unlockSelectUnlockGetUnlockedTrackIdsLoading", function () { return $24301a4b0c33287f$export$e5e50d8dbe3269a3; });
$parcel$export(module.exports, "unlockSelectUnlockCreatePostUnlockLoading", function () { return $24301a4b0c33287f$export$97bbe41b5cad1b74; });
$parcel$export(module.exports, "unlockSelectUnlockCreateTrackUnlockLoading", function () { return $24301a4b0c33287f$export$2af62a6613a1a5e3; });
$parcel$export(module.exports, "unlockReducer", function () { return $24301a4b0c33287f$export$ec63a4f66cdbe416; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("dmGpj");
var $b0u33 = parcelRequire("b0u33");
const $24301a4b0c33287f$var$initialState = {
    postUnlocks: {},
    trackUnlocks: {},
    unlockPostModal: {
        post: undefined,
        open: false
    },
    unlockTrackModal: {
        track: undefined,
        open: false
    },
    unlockGetUnlockedPostIdsLoading: false,
    unlockGetUnlockedTrackIdsLoading: false,
    unlockCreatePostUnlockLoading: false,
    unlockCreateTrackUnlockLoading: false
};
const $24301a4b0c33287f$export$381ce5319c2274da = (0, $dEr3t.createSlice)({
    name: "unlock",
    initialState: $24301a4b0c33287f$var$initialState,
    reducers: {
        // reset state
        unlockResetState: ()=>({
                postUnlocks: {},
                trackUnlocks: {},
                unlockPostModal: {
                    post: undefined,
                    open: false
                },
                unlockTrackModal: {
                    track: undefined,
                    open: false
                },
                unlockGetUnlockedPostIdsLoading: false,
                unlockGetUnlockedTrackIdsLoading: false,
                unlockCreatePostUnlockLoading: false,
                unlockCreateTrackUnlockLoading: false
            }),
        // set post unlocks
        unlockSetPostUnlocks: (state, action)=>{
            const { unlockedPostIds: unlockedPostIds } = action.payload;
            // define post unlocks map
            const postUnlocks = {};
            // iterate over each unlocked post id
            unlockedPostIds.forEach((id)=>{
                // add id to the map
                postUnlocks[id] = true;
            });
            // update state
            state.postUnlocks = postUnlocks;
        },
        // add post unlock
        unlockAddPostUnlock: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postUnlocks[postId] = true;
        },
        // remove post unlock
        unlockRemovePostUnlock: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postUnlocks[postId] = false;
        },
        // set track unlocks
        unlockSetTrackUnlocks: (state, action)=>{
            const { unlockedTrackIds: unlockedTrackIds } = action.payload;
            // define track unlocks map
            const trackUnlocks = {};
            // iterate over each unlocked track id
            unlockedTrackIds.forEach((id)=>{
                // add id to the map
                trackUnlocks[id] = true;
            });
            // update state
            state.trackUnlocks = trackUnlocks;
        },
        // add track unlock
        unlockAddTrackUnlock: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackUnlocks[trackId] = true;
        },
        // remove track unlock
        unlockRemoveTrackUnlock: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackUnlocks[trackId] = false;
        },
        // open unlock post modal
        unlockOpenUnlockPostModal: (state, action)=>({
                ...state,
                unlockPostModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close unlock post modal
        unlockCloseUnlockPostModal: (state)=>({
                ...state,
                unlockPostModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            }),
        // open unlock track modal
        unlockOpenUnlockTrackModal: (state, action)=>({
                ...state,
                unlockTrackModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close unlock track modal
        unlockCloseUnlockTrackModal: (state)=>({
                ...state,
                unlockTrackModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get unlocked post ids
        builder.addCase((0, $b0u33.unlockGetUnlockedPostIds).pending, (state)=>({
                ...state,
                unlockGetUnlockedPostIdsLoading: true
            })).addCase((0, $b0u33.unlockGetUnlockedPostIds).fulfilled, (state)=>({
                ...state,
                unlockGetUnlockedPostIdsLoading: false
            }));
        // get unlocked track ids
        builder.addCase((0, $b0u33.unlockGetUnlockedTrackIds).pending, (state)=>({
                ...state,
                unlockGetUnlockedTrackIdsLoading: true
            })).addCase((0, $b0u33.unlockGetUnlockedTrackIds).fulfilled, (state)=>({
                ...state,
                unlockGetUnlockedTrackIdsLoading: false
            }));
        // create post unlock
        builder.addCase((0, $b0u33.unlockCreatePostUnlock).pending, (state)=>({
                ...state,
                unlockCreatePostUnlockLoading: true
            })).addCase((0, $b0u33.unlockCreatePostUnlock).fulfilled, (state)=>({
                ...state,
                unlockCreatePostUnlockLoading: false
            }));
        // create track unlock
        builder.addCase((0, $b0u33.unlockCreateTrackUnlock).pending, (state)=>({
                ...state,
                unlockCreateTrackUnlockLoading: true
            })).addCase((0, $b0u33.unlockCreateTrackUnlock).fulfilled, (state)=>({
                ...state,
                unlockCreateTrackUnlockLoading: false
            }));
    }
});
const { unlockResetState: $24301a4b0c33287f$export$35f1884a3da44f69, unlockSetPostUnlocks: $24301a4b0c33287f$export$2bfaa55cc0ca870d, unlockAddPostUnlock: $24301a4b0c33287f$export$11e0007326c9d985, unlockRemovePostUnlock: $24301a4b0c33287f$export$381fca7a8b5f0b4a, unlockSetTrackUnlocks: $24301a4b0c33287f$export$56e394be1baad6a, unlockAddTrackUnlock: $24301a4b0c33287f$export$d3ce7022a65cf68b, unlockRemoveTrackUnlock: $24301a4b0c33287f$export$8c749fae48cabbde, unlockOpenUnlockPostModal: $24301a4b0c33287f$export$6bf84dbbd6226b5b, unlockCloseUnlockPostModal: $24301a4b0c33287f$export$1d8ecc069ad7c7f7, unlockOpenUnlockTrackModal: $24301a4b0c33287f$export$e7859b55a7b4f99c, unlockCloseUnlockTrackModal: $24301a4b0c33287f$export$8ac968d6a6fbe230 } = $24301a4b0c33287f$export$381ce5319c2274da.actions;
const $24301a4b0c33287f$export$784e3adf5ad22d23 = (state)=>state.unlock.postUnlocks;
const $24301a4b0c33287f$export$bf416d4ed55b04ac = (state)=>state.unlock.trackUnlocks;
const $24301a4b0c33287f$export$f5cd230b3e742cbc = (state)=>state.unlock.unlockPostModal.open;
const $24301a4b0c33287f$export$f7ee293c19e0841b = (state)=>state.unlock.unlockPostModal.post;
const $24301a4b0c33287f$export$f3090f5fff7cfeff = (state)=>state.unlock.unlockTrackModal.open;
const $24301a4b0c33287f$export$74288cfc472b94ae = (state)=>state.unlock.unlockTrackModal.track;
const $24301a4b0c33287f$export$6e2d9b9989319967 = (state)=>state.unlock.unlockGetUnlockedPostIdsLoading;
const $24301a4b0c33287f$export$e5e50d8dbe3269a3 = (state)=>state.unlock.unlockGetUnlockedTrackIdsLoading;
const $24301a4b0c33287f$export$97bbe41b5cad1b74 = (state)=>state.unlock.unlockCreatePostUnlockLoading;
const $24301a4b0c33287f$export$2af62a6613a1a5e3 = (state)=>state.unlock.unlockCreateTrackUnlockLoading;
const $24301a4b0c33287f$export$ec63a4f66cdbe416 = $24301a4b0c33287f$export$381ce5319c2274da.reducer; // export default unlockSlice.reducer

});

parcelRegister("b0u33", function(module, exports) {

$parcel$export(module.exports, "unlockGetUnlockedPostIds", function () { return $81bdd5d1d3166800$export$c237ef55467796dd; });
$parcel$export(module.exports, "unlockGetUnlockedTrackIds", function () { return $81bdd5d1d3166800$export$31da728731d1845a; });
$parcel$export(module.exports, "unlockCreatePostUnlock", function () { return $81bdd5d1d3166800$export$cbb0f9d459a738f3; });
$parcel$export(module.exports, "unlockCreateTrackUnlock", function () { return $81bdd5d1d3166800$export$a38bfc0b487a052d; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $j6i5c = parcelRequire("j6i5c");
var $3Mk3a = parcelRequire("3Mk3a");
var $eFMHm = parcelRequire("eFMHm");
const $81bdd5d1d3166800$export$c237ef55467796dd = (0, $dEr3t.createAsyncThunk)("unlock/unlockGetUnlockedPostIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve unlocked post ids
        const { unlockedPostIds: unlockedPostIds } = await api.unlockApi.getUnlockedPostIds();
        // set post unlocks
        dispatch((0, $eFMHm.unlockSetPostUnlocks)({
            unlockedPostIds: unlockedPostIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $81bdd5d1d3166800$export$31da728731d1845a = (0, $dEr3t.createAsyncThunk)("unlock/unlockGetUnlockedTrackIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve unlocked track ids
        const { unlockedTrackIds: unlockedTrackIds } = await api.unlockApi.getUnlockedTrackIds();
        // set track unlocks
        dispatch((0, $eFMHm.unlockSetTrackUnlocks)({
            unlockedTrackIds: unlockedTrackIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $81bdd5d1d3166800$export$cbb0f9d459a738f3 = (0, $dEr3t.createAsyncThunk)("unlock/unlockCreatePostUnlock", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get post from modal state
    const modalPost = getState().unlock.unlockPostModal.post;
    const { id: postId } = modalPost ?? {};
    try {
        // create post unlock
        const { clientSecret: clientSecret } = await api.unlockApi.createPostUnlock({
            postId: postId || ""
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close post unlock modal
        dispatch((0, $eFMHm.unlockCloseUnlockPostModal)());
        // open payment modal
        dispatch((0, $j6i5c.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $3Mk3a.PaymentOperationType).PostUnlock,
            operationSubject: modalPost
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to unlock post: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $81bdd5d1d3166800$export$a38bfc0b487a052d = (0, $dEr3t.createAsyncThunk)("unlock/unlockCreateTrackUnlock", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    // get track from modal state
    const modalTrack = getState().unlock.unlockTrackModal.track;
    const { id: trackId } = modalTrack ?? {};
    try {
        // create track unlock
        const { clientSecret: clientSecret } = await api.unlockApi.createTrackUnlock({
            trackId: trackId || ""
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close unlock track modal
        dispatch((0, $eFMHm.unlockCloseUnlockTrackModal)());
        // open payment modal
        dispatch((0, $j6i5c.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $3Mk3a.PaymentOperationType).TrackUnlock,
            operationSubject: modalTrack
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to unlock track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("6Ew00", function(module, exports) {

$parcel$export(module.exports, "ArtistCard", function () { return (parcelRequire("e8iht")).ArtistCard; });
$parcel$export(module.exports, "ArtistCardProduct", function () { return (parcelRequire("5BPlh")).ArtistCardProduct; });
$parcel$export(module.exports, "ArtistListFeedPopular", function () { return (parcelRequire("4sRbG")).ArtistListFeedPopular; });
$parcel$export(module.exports, "ArtistListFeedRecommended", function () { return (parcelRequire("bd70Z")).ArtistListFeedRecommended; });
$parcel$export(module.exports, "ArtistListHomePublic", function () { return (parcelRequire("akMc8")).ArtistListHomePublic; });
$parcel$export(module.exports, "ArtistListLibraryFollowed", function () { return (parcelRequire("9WEvb")).ArtistListLibraryFollowed; });
$parcel$export(module.exports, "ArtistListLibrarySubscribed", function () { return (parcelRequire("amfQ7")).ArtistListLibrarySubscribed; });
$parcel$export(module.exports, "ArtistListOnboardingRecommended", function () { return (parcelRequire("goTxv")).ArtistListOnboardingRecommended; });
$parcel$export(module.exports, "UserBlockModal", function () { return (parcelRequire("cuf6v")).UserBlockModal; });
$parcel$export(module.exports, "UserViewProfile", function () { return (parcelRequire("3MPL2")).UserViewProfile; });
$parcel$export(module.exports, "UserViewStudio", function () { return (parcelRequire("bHp51")).UserViewStudio; });
$parcel$export(module.exports, "UserViewUser", function () { return (parcelRequire("aTYxz")).UserViewUser; });
$parcel$export(module.exports, "userUtilRenderArtistActions", function () { return (parcelRequire("hZCPc")).userUtilRenderArtistActions; });
$parcel$export(module.exports, "userUtilGetArtistCardSkeletonSections", function () { return (parcelRequire("hZCPc")).userUtilGetArtistCardSkeletonSections; });
parcelRequire("8DWYS");
var $e8iht = parcelRequire("e8iht");
var $5BPlh = parcelRequire("5BPlh");
var $4sRbG = parcelRequire("4sRbG");
var $bd70Z = parcelRequire("bd70Z");
var $akMc8 = parcelRequire("akMc8");
var $9WEvb = parcelRequire("9WEvb");
var $amfQ7 = parcelRequire("amfQ7");
var $goTxv = parcelRequire("goTxv");
var $cuf6v = parcelRequire("cuf6v");
var $3MPL2 = parcelRequire("3MPL2");
var $bHp51 = parcelRequire("bHp51");
var $aTYxz = parcelRequire("aTYxz");

var $hZCPc = parcelRequire("hZCPc");

var $kkIKc = parcelRequire("kkIKc");

var $bmROr = parcelRequire("bmROr");
$parcel$exportWildcard(module.exports, $kkIKc);
$parcel$exportWildcard(module.exports, $bmROr);

});
parcelRegister("8DWYS", function(module, exports) {

$parcel$export(module.exports, "ArtistCard", function () { return (parcelRequire("e8iht")).ArtistCard; });
$parcel$export(module.exports, "ArtistCardProduct", function () { return (parcelRequire("5BPlh")).ArtistCardProduct; });
$parcel$export(module.exports, "ArtistListLibraryFollowed", function () { return (parcelRequire("9WEvb")).ArtistListLibraryFollowed; });
$parcel$export(module.exports, "ArtistListLibrarySubscribed", function () { return (parcelRequire("amfQ7")).ArtistListLibrarySubscribed; });
$parcel$export(module.exports, "ArtistListHomePublic", function () { return (parcelRequire("akMc8")).ArtistListHomePublic; });
$parcel$export(module.exports, "ArtistListFeedPopular", function () { return (parcelRequire("4sRbG")).ArtistListFeedPopular; });
$parcel$export(module.exports, "ArtistListFeedRecommended", function () { return (parcelRequire("bd70Z")).ArtistListFeedRecommended; });
$parcel$export(module.exports, "ArtistListOnboardingRecommended", function () { return (parcelRequire("goTxv")).ArtistListOnboardingRecommended; });
$parcel$export(module.exports, "UserBlockModal", function () { return (parcelRequire("cuf6v")).UserBlockModal; });
$parcel$export(module.exports, "UserViewProfile", function () { return (parcelRequire("3MPL2")).UserViewProfile; });
$parcel$export(module.exports, "UserViewStudio", function () { return (parcelRequire("bHp51")).UserViewStudio; });
$parcel$export(module.exports, "UserViewUser", function () { return (parcelRequire("aTYxz")).UserViewUser; });

var $e8iht = parcelRequire("e8iht");

var $5BPlh = parcelRequire("5BPlh");

var $9WEvb = parcelRequire("9WEvb");

var $amfQ7 = parcelRequire("amfQ7");

var $akMc8 = parcelRequire("akMc8");

var $4sRbG = parcelRequire("4sRbG");

var $bd70Z = parcelRequire("bd70Z");

var $goTxv = parcelRequire("goTxv");

var $cuf6v = parcelRequire("cuf6v");

var $3MPL2 = parcelRequire("3MPL2");

var $bHp51 = parcelRequire("bHp51");

var $aTYxz = parcelRequire("aTYxz");

});
parcelRegister("e8iht", function(module, exports) {

$parcel$export(module.exports, "ArtistCard", function () { return $5181d9866d93f244$export$16c3e13019c01108; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $9a5k4 = parcelRequire("9a5k4");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("dmGpj");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
parcelRequire("fRVt8");
var $f7BhD = parcelRequire("f7BhD");

var $77Ppx = parcelRequire("77Ppx");
const $5181d9866d93f244$export$16c3e13019c01108 = ({ artist: artist, artistActions: artistActions, onNameClick: onNameClick, onUsernameClick: onUsernameClick })=>{
    const theme = (0, $hXJcm.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $exYeM.useState)(false);
    const { id: artistId, avatarId: avatarId, name: name, username: username } = artist;
    const { isFollowed: isFollowed, isSubscribed: isSubscribed, isSubscribedAtPeriodEnd: isSubscribedAtPeriodEnd, isPublic: isPublic, onFollowClick: onFollowClick, onUnfollowClick: onUnfollowClick, onCreateSubscriptionClick: onCreateSubscriptionClick, onRenewSubscriptionClick: onRenewSubscriptionClick, onCancelSubscriptionClick: onCancelSubscriptionClick } = artistActions ?? {};
    // connect ready
    const { ready: connectReady } = (0, $9a5k4.useConnectReady)(isPublic ? "" : artistId || "");
    const artistHasAvatar = !!avatarId;
    const source = (0, $hrd7b.useFile)(avatarId || "");
    const renderArtistActionsInput = {
        isCurrentUserFollowingArtist: !!isFollowed,
        isCurrentUserSubscribedToArtist: !!isSubscribed,
        isCurrentUserSubscribedToArtistAtPeriodEnd: !!isSubscribedAtPeriodEnd,
        isArtistCanReceivePayments: !!connectReady,
        createUserFollowNode: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
            css: (0, $77Ppx.styles)(theme).artist.buttons.button,
            "aria-label": "follow artist",
            appearance: "primary",
            onClick: onFollowClick ? (e)=>onFollowClick(e) : undefined,
            children: "Follow"
        }),
        deleteUserFollowNode: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
            css: (0, $77Ppx.styles)(theme).artist.buttons.button,
            "aria-label": "unfollow artist",
            appearance: "secondary",
            onClick: onUnfollowClick ? (e)=>onUnfollowClick(e) : undefined,
            children: "Unfollow"
        }),
        createSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
            css: (0, $77Ppx.styles)(theme).artist.buttons.button,
            "aria-label": "subscribe",
            appearance: "primary",
            onClick: onCreateSubscriptionClick ? (e)=>onCreateSubscriptionClick(e) : undefined,
            children: "Subscribe"
        }),
        renewSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
            css: (0, $77Ppx.styles)(theme).artist.buttons.button,
            "aria-label": "subscribe",
            appearance: "primary",
            onClick: onRenewSubscriptionClick ? (e)=>onRenewSubscriptionClick(e) : undefined,
            children: "Subscribe"
        }),
        cancelSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $f7BhD.ButtonSmall), {
            css: (0, $77Ppx.styles)(theme).artist.buttons.button,
            "aria-label": "unsubscribe",
            appearance: "secondary",
            onClick: onCancelSubscriptionClick ? (e)=>onCancelSubscriptionClick(e) : undefined,
            children: "Unsubscribe"
        }),
        defaultNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {})
    };
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $77Ppx.styles)(theme).artist.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $77Ppx.styles)(theme).artist.avatar.main,
                children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $77Ppx.styles)(theme).artist.avatar.image,
                    onError: ()=>setAvatarLoadError(true),
                    loading: "lazy",
                    width: "100px",
                    height: "100px",
                    src: source,
                    alt: "artist avatar"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                    css: (0, $77Ppx.styles)(theme).artist.avatar.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $77Ppx.styles)(theme).artist.info.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $77Ppx.styles)(theme).artist.info.name,
                        onClick: (e)=>onNameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
                        css: (0, $77Ppx.styles)(theme).artist.info.username,
                        onClick: (e)=>onUsernameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: [
                            "@",
                            username
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $77Ppx.styles)(theme).artist.followers.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("span", {
                    css: (0, $77Ppx.styles)(theme).artist.followers.count,
                    children: [
                        (0, $fJerj.numbersFormatter)(artist.followersCount || 0),
                        " follower(s)"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $77Ppx.styles)(theme).artist.buttons.main,
                children: artistActions ? (0, $hZCPc.userUtilRenderArtistActions)(renderArtistActionsInput) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {})
            })
        ]
    });
};
$5181d9866d93f244$export$16c3e13019c01108.propTypes = {};

});
parcelRegister("77Ppx", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4b8d94319c2c1d5a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $4b8d94319c2c1d5a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b8d94319c2c1d5a$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
var $4b8d94319c2c1d5a$var$_ref2 = {
    name: "sb8535",
    styles: "margin-bottom:8px;text-align:center"
};
var $4b8d94319c2c1d5a$var$_ref3 = {
    name: "19xw8tk",
    styles: "display:flex;flex-direction:column;align-self:center;text-align:center;width:100px;margin-bottom:12px"
};
const $4b8d94319c2c1d5a$export$9dd6ff9ea0189349 = (theme)=>({
        artist: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:140px;color:", theme.colors.secondary.normal, ";", ""),
            avatar: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;align-self:center;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:12px;", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            info: {
                main: $4b8d94319c2c1d5a$var$_ref3,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            },
            followers: {
                main: $4b8d94319c2c1d5a$var$_ref2,
                count: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";", "")
            },
            buttons: {
                main: $4b8d94319c2c1d5a$var$_ref,
                button: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;padding:6px 16px;max-width:90%;", "")
            }
        }
    });

});


parcelRegister("5BPlh", function(module, exports) {

$parcel$export(module.exports, "ArtistCardProduct", function () { return $7a8b2976e2b6f1f6$export$51270459d03b74e6; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $ggr74 = parcelRequire("ggr74");
const $7a8b2976e2b6f1f6$export$51270459d03b74e6 = ({ artist: artist, onNameClick: onNameClick, onUsernameClick: onUsernameClick })=>{
    const theme = (0, $hXJcm.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $exYeM.useState)(false);
    const { avatarId: avatarId, name: name, username: username } = artist;
    const artistHasAvatar = !!avatarId;
    const source = (0, $hrd7b.useFile)(avatarId || "");
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $ggr74.styles)(theme).artist.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $ggr74.styles)(theme).artist.avatar.main,
                children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $ggr74.styles)(theme).artist.avatar.image,
                    onError: ()=>setAvatarLoadError(true),
                    loading: "lazy",
                    width: "100px",
                    height: "100px",
                    src: source,
                    alt: "artist avatar"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                    css: (0, $ggr74.styles)(theme).artist.avatar.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $ggr74.styles)(theme).artist.info.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                        css: (0, $ggr74.styles)(theme).artist.info.name,
                        onClick: (e)=>onNameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
                        css: (0, $ggr74.styles)(theme).artist.info.username,
                        onClick: (e)=>onUsernameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: [
                            "@",
                            username
                        ]
                    })
                ]
            })
        ]
    });
};
$7a8b2976e2b6f1f6$export$51270459d03b74e6.propTypes = {};

});
parcelRegister("ggr74", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $51cf9416f2777bfe$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $51cf9416f2777bfe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $51cf9416f2777bfe$var$_ref = {
    name: "19xw8tk",
    styles: "display:flex;flex-direction:column;align-self:center;text-align:center;width:100px;margin-bottom:12px"
};
const $51cf9416f2777bfe$export$9dd6ff9ea0189349 = (theme)=>({
        artist: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;width:140px;color:", theme.colors.secondary.normal, ";", ""),
            avatar: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;align-self:center;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:12px;", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            info: {
                main: $51cf9416f2777bfe$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";", (0, $48E0n.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("9WEvb", function(module, exports) {

$parcel$export(module.exports, "ArtistListLibraryFollowed", function () { return $ff606695a3c650ea$export$b26717ecc8534097; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $e8iht = parcelRequire("e8iht");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $gfND9 = parcelRequire("gfND9");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");
const $ff606695a3c650ea$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectFollowedArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $hZCPc.userUtilGetArtistCardSkeletonSections)("artist-list-library-followed")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $ff606695a3c650ea$export$b26717ecc8534097 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const followedArtists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectFollowedArtists));
    const followedArtistsCount = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectFollowedArtistsCount));
    const followedArtistsLength = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectFollowedArtistsLength));
    const followedArtistsFetched = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectFollowedArtistsFetched));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!followedArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $bmROr.userGetFollowedArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if followed artists are fetched but length is 0
    if (followedArtistsFetched && followedArtistsLength === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Followed Artists",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: followedArtistsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).HeartBroken,
            height: "242px",
            title: "You haven't followed any artist yet"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Followed Artists",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: followedArtistsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: followedArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: followedArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $ff606695a3c650ea$var$Row
                })
        })
    });
};
$ff606695a3c650ea$export$b26717ecc8534097.propTypes = {};

});

parcelRegister("amfQ7", function(module, exports) {

$parcel$export(module.exports, "ArtistListLibrarySubscribed", function () { return $2545f4622f0225e6$export$ad83287ed145663d; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $e8iht = parcelRequire("e8iht");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $gfND9 = parcelRequire("gfND9");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");
const $2545f4622f0225e6$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectSubscribedArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $hZCPc.userUtilGetArtistCardSkeletonSections)("artist-list-library-subscribed")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $2545f4622f0225e6$export$ad83287ed145663d = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const subscribedArtists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectSubscribedArtists));
    const subscribedArtistsCount = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectSubscribedArtistsCount));
    const subscribedArtistsLength = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectSubscribedArtistsLength));
    const subscribedArtistsFetched = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectSubscribedArtistsFetched));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!subscribedArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $bmROr.userGetSubscribedArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if subscribed artists are fetched but length is 0
    if (subscribedArtistsFetched && subscribedArtistsLength === 0) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Subscribed Artists",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: subscribedArtistsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).HeartBroken,
            height: "242px",
            title: "You haven't subscribed to any artist yet"
        })
    });
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Subscribed Artists",
        overrideCss: (0, $4vSc9.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: subscribedArtistsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: subscribedArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: subscribedArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $2545f4622f0225e6$var$Row
                })
        })
    });
};
$2545f4622f0225e6$export$ad83287ed145663d.propTypes = {};

});

parcelRegister("akMc8", function(module, exports) {

$parcel$export(module.exports, "ArtistListHomePublic", function () { return $ae427f4bf8b29ae6$export$71eb2018e0fdf5fe; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $e8iht = parcelRequire("e8iht");
var $fAzHC = parcelRequire("fAzHC");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $agnse = parcelRequire("agnse");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");
const $ae427f4bf8b29ae6$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const artists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectPublicArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $hZCPc.userUtilGetArtistCardSkeletonSections)("artist-list-home-public")
        })
    });
    const openJoinModal = ()=>dispatch((0, $fAzHC.authOpenJoinModal)());
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: false,
                isSubscribed: false,
                isSubscribedAtPeriodEnd: false,
                isPublic: true,
                onFollowClick: openJoinModal,
                onUnfollowClick: openJoinModal,
                onCreateSubscriptionClick: openJoinModal,
                onRenewSubscriptionClick: openJoinModal,
                onCancelSubscriptionClick: openJoinModal
            },
            onNameClick: openJoinModal,
            onUsernameClick: openJoinModal
        })
    });
});
const $ae427f4bf8b29ae6$export$71eb2018e0fdf5fe = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const publicArtists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectPublicArtists));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 60;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!publicArtists[index];
    const loadMoreItems = ()=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $bmROr.userGetPublicArtists)());
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Popular Artists",
        overrideCss: (0, $4vSc9.contentLayout).home,
        itemWidth: itemWidth,
        itemsCount: defaultContentCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $ae427f4bf8b29ae6$var$Row
                })
        })
    });
};
$ae427f4bf8b29ae6$export$71eb2018e0fdf5fe.propTypes = {};

});

parcelRegister("4sRbG", function(module, exports) {

$parcel$export(module.exports, "ArtistListFeedPopular", function () { return $a3c228ee8c9bcc3f$export$3fa881b2107d7311; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $e8iht = parcelRequire("e8iht");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $gfND9 = parcelRequire("gfND9");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $agnse = parcelRequire("agnse");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");
const $a3c228ee8c9bcc3f$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectPopularArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $hZCPc.userUtilGetArtistCardSkeletonSections)("artist-list-feed-popular")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $a3c228ee8c9bcc3f$export$3fa881b2107d7311 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const popularArtists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectPopularArtists));
    const popularArtistsCount = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectPopularArtistsCount));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!popularArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $bmROr.userGetPopularArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Artists",
        overrideCss: (0, $4vSc9.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: popularArtistsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: popularArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: popularArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $a3c228ee8c9bcc3f$var$Row
                })
        })
    });
};
$a3c228ee8c9bcc3f$export$3fa881b2107d7311.propTypes = {};

});

parcelRegister("bd70Z", function(module, exports) {

$parcel$export(module.exports, "ArtistListFeedRecommended", function () { return $4f120ed6a111ad14$export$8533cb9112d3bbf8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $6TqF6 = parcelRequire("6TqF6");

var $e6Ukw = parcelRequire("e6Ukw");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $e8iht = parcelRequire("e8iht");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $gfND9 = parcelRequire("gfND9");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("fRVt8");
var $6KTJf = parcelRequire("6KTJf");
var $agnse = parcelRequire("agnse");
parcelRequire("1SE81");
var $4vSc9 = parcelRequire("4vSc9");
const $4f120ed6a111ad14$var$Row = /*#__PURE__*/ (0, $exYeM.memo)(({ index: index, style: style })=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectRecommendedArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $hZCPc.userUtilGetArtistCardSkeletonSections)("artist-list-feed-recommended")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $9YTSb.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e8iht.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $4f120ed6a111ad14$export$8533cb9112d3bbf8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const recommendedArtists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectRecommendedArtists));
    const recommendedArtistsCount = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectRecommendedArtistsCount));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!recommendedArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $bmROr.userGetRecommendedArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $6KTJf.ContentLayoutVirtualized), {
        title: "Artists",
        overrideCss: (0, $4vSc9.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: recommendedArtistsCount,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $e6Ukw.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: recommendedArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $6TqF6.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: recommendedArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $4f120ed6a111ad14$var$Row
                })
        })
    });
};
$4f120ed6a111ad14$export$8533cb9112d3bbf8.propTypes = {};

});

parcelRegister("goTxv", function(module, exports) {

$parcel$export(module.exports, "ArtistListOnboardingRecommended", function () { return $6d58d04e665d1bc3$export$7f2e2147f37d34b1; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
parcelRequire("f2Nbw");
var $djTpy = parcelRequire("djTpy");
var $dBPeL = parcelRequire("dBPeL");

var $8FgAK = parcelRequire("8FgAK");
const $6d58d04e665d1bc3$export$7f2e2147f37d34b1 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const recommendedArtists = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectRecommendedArtists));
    const recommendedArtistsLength = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectRecommendedArtistsLength));
    const userGetRecommendedArtistsLoading = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectUserGetRecommendedArtistsLoading));
    const { id: profileUserId } = profile ?? {};
    const defaultContentLength = 20;
    // [0, 1,..., 19]
    const skeletons = Array.from({
        length: defaultContentLength
    }, (_, i)=>i);
    (0, $exYeM.useEffect)(()=>{
        // if recommended artists is not fetched
        if (recommendedArtistsLength === 0) // fetch artists
        dispatch((0, $bmROr.userGetRecommendedArtists)({
            limit: 29,
            offset: 0
        }));
    }, [
        dispatch,
        recommendedArtistsLength
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8FgAK.styles)().artists.main,
        children: userGetRecommendedArtistsLoading ? skeletons.map((n)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $dBPeL.ArtistSkeleton), {}, `onboarding-rec-artist-skeleton-${n}`)) : recommendedArtists.map((artist)=>{
            const { id: artistUserId } = artist;
            const isCurrentUser = profileUserId === artistUserId;
            const isUserFollowed = userFollows[artistUserId || ""];
            const followArtist = ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
                    user: artist
                }));
            const unfollowArtist = ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
                    user: artist
                }));
            const followUnfollowAction = isUserFollowed ? unfollowArtist : followArtist;
            // if is current user
            if (isCurrentUser) return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $djTpy.Artist), {
                artist: artist,
                followed: isUserFollowed
            }, `onboarding-rec-artist-${artistUserId}`);
            return /*#__PURE__*/ (0, $5o6z6.jsx)((0, $djTpy.Artist), {
                artist: artist,
                followed: isUserFollowed,
                onClick: followUnfollowAction
            }, `onboarding-rec-artist-${artistUserId}`);
        })
    });
};
$6d58d04e665d1bc3$export$7f2e2147f37d34b1.propTypes = {};

});
parcelRegister("f2Nbw", function(module, exports) {

$parcel$export(module.exports, "Artist", function () { return (parcelRequire("djTpy")).Artist; });
$parcel$export(module.exports, "ArtistSkeleton", function () { return (parcelRequire("dBPeL")).ArtistSkeleton; });

var $djTpy = parcelRequire("djTpy");

var $dBPeL = parcelRequire("dBPeL");

});
parcelRegister("djTpy", function(module, exports) {

$parcel$export(module.exports, "Artist", function () { return $cafb0e7fca8eaeca$export$1e2322822297ef53; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $285LB = parcelRequire("285LB");
const $cafb0e7fca8eaeca$export$1e2322822297ef53 = ({ artist: artist, followed: followed, onClick: onClick })=>{
    const theme = (0, $hXJcm.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $exYeM.useState)(false);
    const { name: name, username: username, avatarId: avatarId } = artist;
    const artistHasAvatar = !!avatarId;
    const source = (0, $hrd7b.useFile)(avatarId || "");
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: [
            (0, $285LB.styles)(theme).artist.main.shared,
            followed ? (0, $285LB.styles)(theme).artist.main.followed : (0, $285LB.styles)(theme).artist.main.unfollowed,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $285LB.styles)(theme).artist.avatar.main,
                children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $285LB.styles)(theme).artist.avatar.image,
                    onError: ()=>setAvatarLoadError(true),
                    loading: "lazy",
                    width: "70px",
                    height: "70px",
                    src: source,
                    alt: "artist avatar"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                    css: (0, $285LB.styles)(theme).artist.avatar.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $285LB.styles)(theme).artist.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $285LB.styles)(theme).artist.content.data.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $285LB.styles)(theme).artist.content.data.name,
                                children: name || ""
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsxs)("span", {
                                css: (0, $285LB.styles)(theme).artist.content.data.username,
                                children: [
                                    "@",
                                    username || ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $285LB.styles)(theme).artist.content.follow.main,
                        children: onClick ? /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: [
                                (0, $285LB.styles)(theme).artist.content.follow.button.shared,
                                followed ? (0, $285LB.styles)(theme).artist.content.follow.button.followed : (0, $285LB.styles)(theme).artist.content.follow.button.unfollowed,
                                "",
                                ""
                            ],
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "follow/unfollow artist",
                            children: followed ? "Unfollow" : "Follow"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)("button", {
                            css: [
                                (0, $285LB.styles)(theme).artist.content.follow.button.shared,
                                (0, $285LB.styles)(theme).artist.content.follow.button.disabled,
                                "",
                                ""
                            ],
                            onClick: ()=>{},
                            disabled: true,
                            type: "button",
                            "aria-label": "follow artist",
                            children: "Follow"
                        })
                    })
                ]
            })
        ]
    });
};
$cafb0e7fca8eaeca$export$1e2322822297ef53.propTypes = {};

});
parcelRegister("285LB", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $49105f540f90e2db$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $49105f540f90e2db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $49105f540f90e2db$var$_ref = {
    name: "e72zmh",
    styles: "display:flex;flex-direction:column;justify-content:space-between;min-width:0"
};
var $49105f540f90e2db$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $49105f540f90e2db$export$9dd6ff9ea0189349 = (theme)=>({
        artist: {
            main: {
                shared: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;border:1px solid transparent;border-radius:50px;padding:6px 20px 6px 6px;overflow:hidden;transition:border 0.2s;width:212px;", (0, $48E0n.mq).mobile($49105f540f90e2db$var$_ref2), ";", ""),
                followed: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.accent.normal, ";", ""),
                unfollowed: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.darker, ";", "")
            },
            avatar: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:70px;height:70px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.darker, ";}", "")
            },
            content: {
                main: $49105f540f90e2db$var$_ref,
                data: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;font-size:", (0, $48E0n.typography).sp, ";", ""),
                    name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";line-height:120%;font-weight:bold;", ""),
                    username: /*#__PURE__*/ (0, $4N3Qt.css)("line-height:120%;", (0, $48E0n.helpers).textOverflowEllipsis, ";", "")
                },
                follow: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                    button: {
                        shared: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";font-family:", (0, $48E0n.fonts).primary, ";font-size:", (0, $48E0n.typography).sp, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:4px 20px;width:96px;transition:color 0.2s,background-color 0.2s,border 0.2s;", ""),
                        followed: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";cursor:pointer;", ""),
                        unfollowed: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.darker, ";color:", theme.colors.primary.normal, ";cursor:pointer;&:hover{background-color:", theme.colors.accent.normal, ";}", ""),
                        disabled: /*#__PURE__*/ (0, $4N3Qt.css)("border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.darker, ";color:", theme.colors.primary.normal, ";cursor:not-allowed;&:hover{background-color:", theme.colors.secondary.darker, ";}", "")
                    }
                }
            }
        }
    });

});


parcelRegister("dBPeL", function(module, exports) {

$parcel$export(module.exports, "ArtistSkeleton", function () { return $fd07c210a7238374$export$cb9abc247e4df2c4; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $1e0ML = parcelRequire("1e0ML");
const $fd07c210a7238374$export$cb9abc247e4df2c4 = ()=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $1e0ML.styles)(theme).skeleton.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1e0ML.styles)(theme).skeleton.avatar
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $1e0ML.styles)(theme).skeleton.description.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $1e0ML.styles)(theme).skeleton.description.name
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $1e0ML.styles)(theme).skeleton.description.username
                    })
                ]
            })
        ]
    });
};
$fd07c210a7238374$export$cb9abc247e4df2c4.propTypes = {};

});
parcelRegister("1e0ML", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3f5a1016a4ff6d52$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3f5a1016a4ff6d52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3f5a1016a4ff6d52$var$_ref = {
    name: "ayzun9",
    styles: "width:100%;height:70"
};
var $3f5a1016a4ff6d52$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $3f5a1016a4ff6d52$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;width:212px;border:1px solid ", theme.colors.primary.darker, ";border-radius:50px;padding:6px 20px 6px 6px;overflow:hidden;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $48E0n.kf).load.shine(-60, 0), ";", (0, $48E0n.mq).mobile($3f5a1016a4ff6d52$var$_ref2), ";", ""),
            avatar: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;display:flex;width:70px;height:70px;opacity:0.4;border-radius:50%;margin-right:8px;background-color:", theme.colors.primary.darker, ";", ""),
            description: {
                main: $3f5a1016a4ff6d52$var$_ref,
                name: /*#__PURE__*/ (0, $4N3Qt.css)("width:100%;height:28px;opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";margin-bottom:8px;", ""),
                username: /*#__PURE__*/ (0, $4N3Qt.css)("width:100%;height:24px;opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
            }
        }
    });

});



parcelRegister("8FgAK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7b25688bb4dcc82f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $7b25688bb4dcc82f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7b25688bb4dcc82f$var$_ref = {
    name: "gt7mww",
    styles: "&>div{margin:0px 0px 16px 0px;}"
};
const $7b25688bb4dcc82f$export$9dd6ff9ea0189349 = ()=>({
        artists: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";display:flex;justify-content:center;flex-wrap:wrap;max-height:400px;overflow:hidden;width:100%;overflow:hidden;overflow-y:scroll;padding:40px 0px;&>div{margin:0px 8px 16px 8px;}", (0, $48E0n.mq).mobile($7b25688bb4dcc82f$var$_ref), ";", "")
        }
    });

});


parcelRegister("cuf6v", function(module, exports) {

$parcel$export(module.exports, "UserBlockModal", function () { return $7b7de8bcee230e82$export$d7c0beabdcbbe792; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $kkIKc = parcelRequire("kkIKc");
parcelRequire("fRVt8");
var $jCNqW = parcelRequire("jCNqW");
parcelRequire("asIKk");
var $ej1fB = parcelRequire("ej1fB");

var $f3bBY = parcelRequire("f3bBY");
const $7b7de8bcee230e82$export$d7c0beabdcbbe792 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const userBlockModalOpen = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectUserBlockModalOpen));
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $f3bBY.styles)().modal.main,
        children: userBlockModalOpen && /*#__PURE__*/ (0, $5o6z6.jsx)((0, $jCNqW.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $kkIKc.userCloseUserBlockModal)()),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $f3bBY.styles)().modal.content,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ej1fB.UserBlockCard), {})
            })
        })
    });
};
$7b7de8bcee230e82$export$d7c0beabdcbbe792.propTypes = {};

});
parcelRegister("asIKk", function(module, exports) {

$parcel$export(module.exports, "UserBlockCard", function () { return (parcelRequire("ej1fB")).UserBlockCard; });

var $ej1fB = parcelRequire("ej1fB");

});
parcelRegister("ej1fB", function(module, exports) {

$parcel$export(module.exports, "UserBlockCard", function () { return $b7dee471e208f694$export$6934e1ca7c6ba5a4; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $kkIKc = parcelRequire("kkIKc");
parcelRequire("fRVt8");
var $2Ww3e = parcelRequire("2Ww3e");
var $9TEV9 = parcelRequire("9TEV9");
var $fJR4x = parcelRequire("fJR4x");
var $5B11A = parcelRequire("5B11A");
parcelRequire("jUI89");
var $7dggY = parcelRequire("7dggY");

var $hK3LC = parcelRequire("hK3LC");
const $b7dee471e208f694$export$6934e1ca7c6ba5a4 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const userBlockError = "";
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $hK3LC.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $hK3LC.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2Ww3e.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $kkIKc.userCloseUserBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $hK3LC.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5B11A.ModalCardTitle), {
                    text: "Block User",
                    icon: (0, $9IIBp.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $hK3LC.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fJR4x.ModalCardSubtitle), {
                    text: "Are you sure you want to block this user?"
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $hK3LC.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $hK3LC.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $7dggY.UserBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $hK3LC.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                            error: userBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$b7dee471e208f694$export$6934e1ca7c6ba5a4.propTypes = {};

});
parcelRegister("jUI89", function(module, exports) {

$parcel$export(module.exports, "UserBlockForm", function () { return (parcelRequire("7dggY")).UserBlockForm; });

var $7dggY = parcelRequire("7dggY");

});
parcelRegister("7dggY", function(module, exports) {

$parcel$export(module.exports, "UserBlockForm", function () { return $86b5de038f803695$export$4c860f6a8f42e2b6; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $5BPlh = parcelRequire("5BPlh");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
parcelRequire("fRVt8");
var $iwKg3 = parcelRequire("iwKg3");
var $1sbY5 = parcelRequire("1sbY5");

var $8GpC1 = parcelRequire("8GpC1");
const $86b5de038f803695$export$4c860f6a8f42e2b6 = ()=>{
    const navigate = (0, $fbE6a.useNavigate)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const userBlockLoading = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectUserBlockLoading));
    const user = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectUserBlockModalUser));
    const { id: userId } = user ?? {};
    const submitDisabled = userBlockLoading;
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $8GpC1.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $8GpC1.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $bmROr.userBlock)({
                    id: userId || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8GpC1.styles)().form.content.user,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $5BPlh.ArtistCardProduct), {
                        artist: user || {},
                        onNameClick: ()=>{
                            // navigate to user page
                            navigate(`${(0, $9YTSb.Path).User}/${userId}`);
                            // close modal
                            dispatch((0, $kkIKc.userCloseUserBlockModal)());
                        },
                        onUsernameClick: ()=>{
                            // navigate to user page
                            navigate(`${(0, $9YTSb.Path).User}/${userId}`);
                            // close modal
                            dispatch((0, $kkIKc.userCloseUserBlockModal)());
                        }
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $8GpC1.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $iwKg3.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block user",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: userBlockLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$86b5de038f803695$export$4c860f6a8f42e2b6.propTypes = {};

});
parcelRegister("8GpC1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a0d89ff543c38de9$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
function $a0d89ff543c38de9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a0d89ff543c38de9$var$_ref = {
    name: "mdhs63",
    styles: "display:flex;justify-content:center;margin-bottom:24px;& div{text-align:center;}& button{text-align:center;}"
};
const $a0d89ff543c38de9$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                user: $a0d89ff543c38de9$var$_ref,
                submit: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
            }
        }
    });

});



parcelRegister("hK3LC", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f54dbddcdbad1e04$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f54dbddcdbad1e04$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f54dbddcdbad1e04$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f54dbddcdbad1e04$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f54dbddcdbad1e04$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $f54dbddcdbad1e04$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $f54dbddcdbad1e04$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $f54dbddcdbad1e04$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $f54dbddcdbad1e04$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $f54dbddcdbad1e04$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $f54dbddcdbad1e04$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).hideScrollbar, ";", (0, $48E0n.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $48E0n.kf).slideIn.up(50), ";", (0, $48E0n.mq).tablet($f54dbddcdbad1e04$var$_ref8), " ", (0, $48E0n.mq).mobile($f54dbddcdbad1e04$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $4N3Qt.css)("display:none;", (0, $48E0n.mq).tablet($f54dbddcdbad1e04$var$_ref6), ";", ""),
            title: $f54dbddcdbad1e04$var$_ref5,
            subtitle: $f54dbddcdbad1e04$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:380px;", (0, $48E0n.mq).tablet($f54dbddcdbad1e04$var$_ref3), ";", ""),
                form: $f54dbddcdbad1e04$var$_ref2,
                error: $f54dbddcdbad1e04$var$_ref
            }
        }
    });

});



parcelRegister("f3bBY", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6cd1b6b7ab7cc23f$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $6cd1b6b7ab7cc23f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6cd1b6b7ab7cc23f$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $6cd1b6b7ab7cc23f$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).tablet($6cd1b6b7ab7cc23f$var$_ref), ";", "")
        }
    });

});


parcelRegister("3MPL2", function(module, exports) {

$parcel$export(module.exports, "UserViewProfile", function () { return $238627afe5b95249$export$e2cfce3dd0cbc93d; });

var $5o6z6 = parcelRequire("5o6z6");
parcelRequire("bDLp2");
var $eZEME = parcelRequire("eZEME");

var $kuPHn = parcelRequire("kuPHn");
const $238627afe5b95249$export$e2cfce3dd0cbc93d = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $kuPHn.styles)().view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $kuPHn.styles)().view.content.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $kuPHn.styles)().view.content.form,
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eZEME.Form), {})
            })
        })
    });
$238627afe5b95249$export$e2cfce3dd0cbc93d.propTypes = {};

});
parcelRegister("bDLp2", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("eZEME")).Form; });

var $eZEME = parcelRequire("eZEME");

});
parcelRegister("eZEME", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $dd2f49108cff5c83$export$a7fed597f4b8afd8; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("2uUQU");
var $bs6PN = parcelRequire("bs6PN");
var $jQMGL = parcelRequire("jQMGL");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $bmROr = parcelRequire("bmROr");
var $kkIKc = parcelRequire("kkIKc");
parcelRequire("fNyrl");
var $33ayT = parcelRequire("33ayT");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fRVt8");
var $lYvdp = parcelRequire("lYvdp");
var $bT0C4 = parcelRequire("bT0C4");
var $X9mpN = parcelRequire("X9mpN");
var $9TEV9 = parcelRequire("9TEV9");
var $lB36X = parcelRequire("lB36X");
var $eRGKc = parcelRequire("eRGKc");
var $1sbY5 = parcelRequire("1sbY5");
parcelRequire("7RGmr");
var $2drXC = parcelRequire("2drXC");

var $7yDyl = parcelRequire("7yDyl");
const $dd2f49108cff5c83$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userProfileUpdateLoading = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectUserProfileUpdateLoading));
    // avatar state
    const userHasAvatar = !!profile?.avatarId;
    const profileAvatar = (0, $hrd7b.useFile)(profile?.avatarId || "");
    const [avatar, setAvatar] = (0, $exYeM.useState)(null);
    const [avatarPreview, setAvatarPreview] = (0, $exYeM.useState)(userHasAvatar ? profileAvatar : "");
    const fileInputRef = (0, $exYeM.useRef)(null);
    const [avatarError, setAvatarError] = (0, $exYeM.useState)("");
    // name state
    const [name, setName] = (0, $exYeM.useState)(profile?.name || "");
    const [nameError, setNameError] = (0, $exYeM.useState)("");
    // username state
    const [username] = (0, $exYeM.useState)(profile?.username || "");
    // genres state
    const [preferredGenres, setPreferredGenres] = (0, $exYeM.useState)(profile?.preferredGenres || []);
    const [musicGenres, setMusicGenres] = (0, $exYeM.useState)((0, $jQMGL.musicGenres));
    // genres search state
    const [search, setSearch] = (0, $exYeM.useState)("");
    const nameUnchanged = name === profile?.name;
    const genresUnchanged = preferredGenres.join("") === profile?.preferredGenres?.join("");
    const avatarNotSelected = avatar === null;
    const submitDisabled = name.length < (0, $bs6PN.minUserNameLength) || nameUnchanged && genresUnchanged && avatarNotSelected || nameError !== "" || avatarError !== "" || userProfileUpdateLoading;
    // TODO: add invite friend logic
    const inviteDisabled = true;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const onEditClick = ()=>{
        fileInputRef.current?.click();
        setAvatarError("");
    };
    const onFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $33ayT.validateAvatarFile)(file);
            if (error) {
                setAvatarError(error);
                return;
            }
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
            // set file as a preview
            setAvatarPreview(URL.createObjectURL(file));
            // store file in state
            setAvatar(file);
        }
    };
    (0, $exYeM.useEffect)(()=>()=>{
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
        });
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $7yDyl.styles)().form.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("form", {
            css: (0, $7yDyl.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                setAvatar(null);
                dispatch((0, $bmROr.userProfileUpdate)({
                    avatar: avatar,
                    name: name,
                    preferredGenres: preferredGenres
                }));
            },
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $7yDyl.styles)().form.content.avatar.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("label", {
                            css: (0, $7yDyl.styles)().form.content.avatar.label,
                            htmlFor: "avatar",
                            children: [
                                "avatar",
                                /*#__PURE__*/ (0, $5o6z6.jsx)("input", {
                                    name: "avatar",
                                    type: "file",
                                    id: "avatar",
                                    ref: fileInputRef,
                                    accept: "image/jpeg,image/webp,image/png",
                                    onChange: (e)=>onFileChange(e)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $7yDyl.styles)().form.content.avatar.image,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $2drXC.Avatar), {
                                onEditClick: ()=>onEditClick(),
                                source: avatarPreview
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $7yDyl.styles)().form.content.avatar.error,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9TEV9.Error), {
                                error: avatarError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $7yDyl.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eRGKc.InputLine), {
                        name: "name",
                        label: "Name",
                        type: "text",
                        placeholder: "Enter your name",
                        icon: (0, $9IIBp.icons).Edit,
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $bs6PN.minUserNameLength),
                        max: (0, $bs6PN.maxUserNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $33ayT.validateName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                    css: (0, $7yDyl.styles)().form.content.username,
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eRGKc.InputLine), {
                        name: "username",
                        label: "Username",
                        type: "text",
                        placeholder: "Enter your username",
                        icon: (0, $9IIBp.icons).Edit,
                        value: `@${username}`,
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $7yDyl.styles)().form.content.genres.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $7yDyl.styles)().form.content.genres.selected.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $7yDyl.styles)().form.content.genres.selected.label,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $lB36X.InputLabel), {
                                        text: "Preferred genres"
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $7yDyl.styles)().form.content.genres.selected.genres,
                                    children: preferredGenres.map((preferredGenre)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $bT0C4.BadgeSelected), {
                                            name: preferredGenre,
                                            onRemoveClick: ()=>setPreferredGenres((state)=>state.filter((genre)=>genre !== preferredGenre))
                                        }, `profile-user-genres-${preferredGenre}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $7yDyl.styles)().form.content.genres.search.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $7yDyl.styles)().form.content.genres.search.input,
                                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $eRGKc.InputLine), {
                                        name: "search",
                                        label: "Select genre",
                                        type: "search",
                                        placeholder: "Find genre",
                                        icon: (0, $9IIBp.icons).Search,
                                        value: search,
                                        onChange: (e)=>{
                                            setSearch(e.target.value);
                                            setMusicGenres((0, $jQMGL.musicGenres).filter((genre)=>genre.toLowerCase().includes(e.target.value)));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $7yDyl.styles)().form.content.genres.search.genres,
                                    children: musicGenres.map((genre)=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $lYvdp.Badge), {
                                            name: genre,
                                            disabled: preferredGenres.includes(genre) || preferredGenres.length >= (0, $jQMGL.maxUserPreferredGenresCount),
                                            onClick: ()=>setPreferredGenres((state)=>[
                                                        ...state,
                                                        genre
                                                    ])
                                        }, `profile-genres-${genre}`))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $7yDyl.styles)().form.content.buttons.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $7yDyl.styles)().form.content.buttons.submit,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "submit",
                                "aria-label": "update profile data",
                                disabled: submitDisabled,
                                appearance: "primary",
                                children: userProfileUpdateLoading ? /*#__PURE__*/ (0, $5o6z6.jsx)((0, $1sbY5.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Update"
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $7yDyl.styles)().form.content.buttons.share,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "invite friend",
                                disabled: inviteDisabled,
                                appearance: "secondary",
                                children: "Invite friends to RYDDM"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$dd2f49108cff5c83$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("7RGmr", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("2drXC")).Avatar; });

var $2drXC = parcelRequire("2drXC");

});
parcelRegister("2drXC", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $c5467d0244739a77$export$e2255cf6045e8d47; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $1sOsQ = parcelRequire("1sOsQ");
const $c5467d0244739a77$export$e2255cf6045e8d47 = ({ source: source, onEditClick: onEditClick })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $1sOsQ.styles)(theme).avatar.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1sOsQ.styles)(theme).avatar.content.main,
                children: source ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                    css: (0, $1sOsQ.styles)(theme).avatar.content.image,
                    loading: "lazy",
                    width: "100px",
                    height: "100px",
                    src: source,
                    alt: "user avatar"
                }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                    css: (0, $1sOsQ.styles)(theme).avatar.content.icon
                })
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $1sOsQ.styles)(theme).avatar.edit.main,
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("button", {
                    css: (0, $1sOsQ.styles)(theme).avatar.edit.button,
                    onClick: (e)=>onEditClick(e),
                    type: "button",
                    "aria-label": "change user avatar",
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                            css: (0, $1sOsQ.styles)(theme).avatar.edit.text,
                            children: "Edit avatar"
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("span", {
                            css: (0, $1sOsQ.styles)(theme).avatar.edit.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Edit, {})
                        })
                    ]
                })
            })
        ]
    });
};
$c5467d0244739a77$export$e2255cf6045e8d47.propTypes = {};

});
parcelRegister("1sOsQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f9bad92476f87109$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $f9bad92476f87109$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f9bad92476f87109$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $f9bad92476f87109$var$_ref2 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $f9bad92476f87109$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: $f9bad92476f87109$var$_ref2,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;width:100px;height:100px;background-color:", theme.colors.secondary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:8px;", ""),
                image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            edit: {
                main: $f9bad92476f87109$var$_ref,
                button: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).resetDefaults, ";display:flex;justify-content:center;width:100%;height:100%;cursor:pointer;&:hover span:nth-of-type(1){color:", theme.colors.accent.normal, ";}", ""),
                text: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";color:", theme.colors.secondary.dark, ";transition:color 0.2s;margin-right:8px;", ""),
                icon: /*#__PURE__*/ (0, $4N3Qt.css)("&>svg{width:14px;height:14px;&>path{fill:", theme.colors.accent.normal, ";}}", "")
            }
        }
    });

});



parcelRegister("7yDyl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a3220a3caa6d8034$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $a3220a3caa6d8034$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a3220a3caa6d8034$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $a3220a3caa6d8034$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $a3220a3caa6d8034$var$_ref3 = {
    name: "c1gao8",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:10px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $a3220a3caa6d8034$var$_ref4 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a3220a3caa6d8034$var$_ref5 = {
    name: "1omvlk4",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:20px;}&>div:not(:last-of-type){margin-right:20px;}"
};
var $a3220a3caa6d8034$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $a3220a3caa6d8034$var$_ref7 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $a3220a3caa6d8034$var$_ref8 = {
    name: "qkomnt",
    styles: "margin-bottom:40px"
};
var $a3220a3caa6d8034$var$_ref9 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $a3220a3caa6d8034$var$_ref10 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $a3220a3caa6d8034$var$_ref11 = {
    name: "tu77jx",
    styles: "width:100px;margin-bottom:22px"
};
var $a3220a3caa6d8034$var$_ref12 = {
    name: "eivff4",
    styles: "display:none"
};
var $a3220a3caa6d8034$var$_ref13 = {
    name: "tosu4r",
    styles: "align-items:center;justify-content:center"
};
const $a3220a3caa6d8034$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                avatar: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;margin-bottom:28px;", (0, $48E0n.mq).tablet($a3220a3caa6d8034$var$_ref13), ";", ""),
                    label: $a3220a3caa6d8034$var$_ref12,
                    image: $a3220a3caa6d8034$var$_ref11,
                    error: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                },
                name: $a3220a3caa6d8034$var$_ref10,
                username: $a3220a3caa6d8034$var$_ref9,
                genres: {
                    main: $a3220a3caa6d8034$var$_ref8,
                    selected: {
                        main: $a3220a3caa6d8034$var$_ref7,
                        label: $a3220a3caa6d8034$var$_ref6,
                        genres: $a3220a3caa6d8034$var$_ref5
                    },
                    search: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
                        input: $a3220a3caa6d8034$var$_ref4,
                        genres: $a3220a3caa6d8034$var$_ref3
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;", (0, $48E0n.mq).tablet($a3220a3caa6d8034$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $4N3Qt.css)("margin-right:20px;&>button{width:130px;}", (0, $48E0n.mq).tablet($a3220a3caa6d8034$var$_ref), ";", ""),
                    share: /*#__PURE__*/ (0, $4N3Qt.css)("", "")
                }
            }
        }
    });

});



parcelRegister("kuPHn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3d7a0f6bcf2dc25a$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $3d7a0f6bcf2dc25a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3d7a0f6bcf2dc25a$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $3d7a0f6bcf2dc25a$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $3d7a0f6bcf2dc25a$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $3d7a0f6bcf2dc25a$export$9dd6ff9ea0189349 = ()=>({
        view: {
            main: $3d7a0f6bcf2dc25a$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)("width:400px;", (0, $48E0n.mq).tablet($3d7a0f6bcf2dc25a$var$_ref2), ";", ""),
                form: $3d7a0f6bcf2dc25a$var$_ref
            }
        }
    });

});


parcelRegister("bHp51", function(module, exports) {

$parcel$export(module.exports, "UserViewStudio", function () { return $b7759099f2b8b8bd$export$595db161984b810a; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("3QeX2");
var $fbE6a = parcelRequire("fbE6a");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
var $hrd7b = parcelRequire("hrd7b");
var $2Tvde = parcelRequire("2Tvde");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");
parcelRequire("fNyrl");
var $fJerj = parcelRequire("fJerj");
parcelRequire("1R0zV");
var $jdoo3 = parcelRequire("jdoo3");

var $W1t2D = parcelRequire("W1t2D");
const $b7759099f2b8b8bd$export$595db161984b810a = ()=>{
    const theme = (0, $hXJcm.u)();
    const navigate = (0, $fbE6a.useNavigate)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const [avatarLoadError, setAvatarLoadError] = (0, $exYeM.useState)(false);
    const { id: userId, name: name, username: username, avatarId: avatarId, followersCount: followersCount, subscribersCount: subscribersCount } = profile ?? {};
    // user stats
    const { postsCount: postsCount, tracksCount: tracksCount, isLoading: isUserStatsLoading } = (0, $2Tvde.useUserStats)(userId || "");
    const userStatsLoadingPlaceholder = "Loading...";
    const artistHasAvatar = !!avatarId;
    const source = (0, $hrd7b.useFile)(avatarId || "");
    const createPostDisabled = false;
    const uploadTrackDisabled = false;
    const stats = [
        {
            id: "studio-user-posts-stat",
            name: "Posts",
            count: (0, $fJerj.numbersFormatter)(postsCount || 0)
        },
        {
            id: "studio-user-tracks-stat",
            name: "Tracks",
            count: (0, $fJerj.numbersFormatter)(tracksCount || 0)
        },
        {
            id: "studio-user-followers-stat",
            name: "Followers",
            count: (0, $fJerj.numbersFormatter)(followersCount || 0)
        },
        {
            id: "studio-user-subscribers-stat",
            name: "Subscribers",
            count: (0, $fJerj.numbersFormatter)(subscribersCount || 0)
        }
    ];
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $W1t2D.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $W1t2D.styles)(theme).view.user.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $W1t2D.styles)(theme).view.user.profile.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $W1t2D.styles)(theme).view.user.profile.avatar.main,
                            children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                                css: (0, $W1t2D.styles)(theme).view.user.profile.avatar.image,
                                onError: ()=>setAvatarLoadError(true),
                                loading: "lazy",
                                width: "100px",
                                height: "100px",
                                src: source,
                                alt: "artist avatar"
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                                css: (0, $W1t2D.styles)(theme).view.user.profile.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $W1t2D.styles)(theme).view.user.profile.content.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $W1t2D.styles)(theme).view.user.profile.content.data.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $W1t2D.styles)(theme).view.user.profile.content.data.name,
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                            css: (0, $W1t2D.styles)(theme).view.user.profile.content.data.username,
                                            children: [
                                                "@",
                                                username
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $W1t2D.styles)(theme).view.user.profile.content.stats,
                                    children: isUserStatsLoading ? userStatsLoadingPlaceholder : stats.map(({ id: id, name: statName, count: count })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $jdoo3.Stat), {
                                            name: statName,
                                            count: count
                                        }, id))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $W1t2D.styles)(theme).view.user.buttons.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $W1t2D.styles)(theme).view.user.buttons.create.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "create post",
                                disabled: createPostDisabled,
                                appearance: "secondary",
                                onClick: ()=>navigate(`${(0, $9YTSb.Path).Studio}${(0, $9YTSb.Path).Post}`),
                                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $W1t2D.styles)(theme).view.user.buttons.create.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $W1t2D.styles)(theme).view.user.buttons.create.content.icon,
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlusCircle, {})
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $W1t2D.styles)(theme).view.user.buttons.create.content.text,
                                            children: "Create Post"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $W1t2D.styles)(theme).view.user.buttons.upload.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "upload track",
                                disabled: uploadTrackDisabled,
                                appearance: "secondary",
                                onClick: ()=>navigate(`${(0, $9YTSb.Path).Studio}${(0, $9YTSb.Path).Track}`),
                                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $W1t2D.styles)(theme).view.user.buttons.upload.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $W1t2D.styles)(theme).view.user.buttons.upload.content.icon,
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlusCircle, {})
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $W1t2D.styles)(theme).view.user.buttons.upload.content.text,
                                            children: "Upload Track"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$b7759099f2b8b8bd$export$595db161984b810a.propTypes = {};

});
parcelRegister("1R0zV", function(module, exports) {

$parcel$export(module.exports, "Stat", function () { return (parcelRequire("jdoo3")).Stat; });

var $jdoo3 = parcelRequire("jdoo3");

});
parcelRegister("jdoo3", function(module, exports) {

$parcel$export(module.exports, "Stat", function () { return $adf3e5b658d7be0b$export$cbbc350c1dfc80cb; });

var $5o6z6 = parcelRequire("5o6z6");

var $hXJcm = parcelRequire("hXJcm");

var $agvOK = parcelRequire("agvOK");
const $adf3e5b658d7be0b$export$cbbc350c1dfc80cb = ({ name: name, count: count })=>{
    const theme = (0, $hXJcm.u)();
    return /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
        css: (0, $agvOK.styles)(theme).stat.main,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $agvOK.styles)(theme).stat.count,
                children: count
            }),
            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                css: (0, $agvOK.styles)(theme).stat.name,
                children: name
            })
        ]
    });
};
$adf3e5b658d7be0b$export$cbbc350c1dfc80cb.propTypes = {};

});
parcelRegister("agvOK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $726fbaaae8d73f16$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $726fbaaae8d73f16$export$9dd6ff9ea0189349 = (theme)=>({
        stat: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)("", ""),
            count: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.normal, ";", ""),
            name: /*#__PURE__*/ (0, $4N3Qt.css)("font-size:", (0, $48E0n.typography).sp, ";", "")
        }
    });

});



parcelRegister("W1t2D", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $571d0c90039ba1f6$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $571d0c90039ba1f6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $571d0c90039ba1f6$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $571d0c90039ba1f6$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $571d0c90039ba1f6$var$_ref3 = {
    name: "1t29t6p",
    styles: "width:50%"
};
var $571d0c90039ba1f6$var$_ref4 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $571d0c90039ba1f6$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $571d0c90039ba1f6$var$_ref6 = {
    name: "1t29t6p",
    styles: "width:50%"
};
var $571d0c90039ba1f6$var$_ref7 = {
    name: "126eje2",
    styles: "flex-direction:column;flex-wrap:nowrap;&>div:nth-of-type(1){margin-right:0px;margin-bottom:12px;}"
};
var $571d0c90039ba1f6$var$_ref8 = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
var $571d0c90039ba1f6$var$_ref9 = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
var $571d0c90039ba1f6$var$_ref10 = {
    name: "1ym5mfs",
    styles: "text-align:center;margin-bottom:10px"
};
var $571d0c90039ba1f6$var$_ref11 = {
    name: "e72zmh",
    styles: "display:flex;flex-direction:column;justify-content:space-between;min-width:0"
};
var $571d0c90039ba1f6$var$_ref12 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $571d0c90039ba1f6$var$_ref13 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $571d0c90039ba1f6$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.sides, ";margin-bottom:50px;", ""),
            user: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";", ""),
                profile: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-bottom:24px;", (0, $48E0n.mq).mobile($571d0c90039ba1f6$var$_ref13), ";", ""),
                    avatar: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;align-self:center;flex-shrink:0;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:16px;", (0, $48E0n.mq).mobile($571d0c90039ba1f6$var$_ref12), ";", ""),
                        image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    content: {
                        main: $571d0c90039ba1f6$var$_ref11,
                        data: {
                            main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;min-width:0;", (0, $48E0n.mq).mobile($571d0c90039ba1f6$var$_ref10), ";", ""),
                            name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;", ""),
                            username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";", "")
                        },
                        stats: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;text-align:center;&>div:not(:last-of-type){margin-right:16px;}", (0, $48E0n.mq).mobile($571d0c90039ba1f6$var$_ref9), ";", "")
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-wrap:wrap;&>div:nth-of-type(1){margin-right:20px;margin-bottom:12px;}", (0, $48E0n.mq).tablet($571d0c90039ba1f6$var$_ref8), " ", (0, $48E0n.mq).mobile($571d0c90039ba1f6$var$_ref7), ";", ""),
                    create: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("width:206px;", (0, $48E0n.mq).tablet($571d0c90039ba1f6$var$_ref6), " ", (0, $48E0n.mq).mobile($571d0c90039ba1f6$var$_ref5), ";", ""),
                        content: {
                            main: $571d0c90039ba1f6$var$_ref4,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    upload: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("width:206px;", (0, $48E0n.mq).tablet($571d0c90039ba1f6$var$_ref3), " ", (0, $48E0n.mq).mobile($571d0c90039ba1f6$var$_ref2), ";", ""),
                        content: {
                            main: $571d0c90039ba1f6$var$_ref,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    }
                }
            }
        }
    });

});


parcelRegister("aTYxz", function(module, exports) {

$parcel$export(module.exports, "UserViewUser", function () { return $b626b6e68c81192a$export$419e08052d39e013; });

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $hXJcm = parcelRequire("hXJcm");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
var $9CcOD = parcelRequire("9CcOD");
var $9a5k4 = parcelRequire("9a5k4");
var $hrd7b = parcelRequire("hrd7b");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");
var $9ybfS = parcelRequire("9ybfS");
var $5Dw49 = parcelRequire("5Dw49");
var $6CAIO = parcelRequire("6CAIO");
var $gfND9 = parcelRequire("gfND9");
var $2zsG4 = parcelRequire("2zsG4");
var $kkIKc = parcelRequire("kkIKc");
var $hZCPc = parcelRequire("hZCPc");
parcelRequire("fRVt8");
var $X9mpN = parcelRequire("X9mpN");
var $46Iw7 = parcelRequire("46Iw7");
var $agnse = parcelRequire("agnse");
parcelRequire("4is25");
var $9IIBp = parcelRequire("9IIBp");

var $gglvX = parcelRequire("gglvX");
const $b626b6e68c81192a$export$419e08052d39e013 = ()=>{
    const theme = (0, $hXJcm.u)();
    const dispatch = (0, $glGsK.useAppDispatch)();
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const userFollows = (0, $9CcOD.useAppSelector)((0, $5Dw49.likeSelectUserFollows));
    const userSubscriptions = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $9CcOD.useAppSelector)((0, $gfND9.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const user = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectUser));
    const userFetched = (0, $9CcOD.useAppSelector)((0, $kkIKc.userSelectUserFetched));
    const { id: profileUserId, role: profileUserRole } = profile ?? {};
    const { id: userId, name: name, username: username, avatarId: avatarId, preferredGenres: preferredGenres, role: role } = user ?? {};
    const userHasAvatar = !!avatarId;
    const source = (0, $hrd7b.useFile)(avatarId || "");
    const [avatarLoadError, setAvatarLoadError] = (0, $exYeM.useState)(false);
    // connect ready
    const { ready: isUserCanReceivePayments } = (0, $9a5k4.useConnectReady)(userId || "");
    const followDisabled = false;
    const unfollowDisabled = false;
    const subscribeDisabled = false;
    const unsubscribeDisabled = false;
    const tipDisabled = false;
    const blockDisabled = false;
    const reportDisabled = false;
    const isUserArtist = role === (0, $aeAwZ.EntityUserRole).Artist;
    const isCurrentUserAdmin = profileUserRole === (0, $aeAwZ.EntityUserRole).Admin;
    const isUserFollowed = userFollows[userId || ""];
    const isCurrentUserProfile = profileUserId === userId;
    const isCurrentUserSubscribedToUser = userSubscriptions[userId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[userId || ""];
    // if user not found
    if (userFetched && !user) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gglvX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $46Iw7.ContentPlaceholder), {
            icon: (0, $9IIBp.icons).AlertTriangle,
            height: "180px",
            title: "Could not find user"
        })
    });
    const renderArtistActionsInput = {
        isCurrentUserFollowingArtist: isUserFollowed,
        isCurrentUserSubscribedToArtist: isCurrentUserSubscribedToUser,
        isCurrentUserSubscribedToArtistAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
        isArtistCanReceivePayments: !!isUserCanReceivePayments,
        createUserFollowNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gglvX.styles)(theme).view.user.buttons.follow.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "follow artist",
                disabled: followDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $9ybfS.likeCreateUserFollow)({
                        user: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $gglvX.styles)(theme).view.user.buttons.follow.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.follow.content.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).PlusCircle, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.follow.content.text,
                            children: "Follow"
                        })
                    ]
                })
            })
        }),
        deleteUserFollowNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gglvX.styles)(theme).view.user.buttons.unfollow.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "unfollow artist",
                disabled: unfollowDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $9ybfS.likeDeleteUserFollow)({
                        user: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $gglvX.styles)(theme).view.user.buttons.unfollow.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.unfollow.content.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).CrossCircle, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.unfollow.content.text,
                            children: "Unfollow"
                        })
                    ]
                })
            })
        }),
        createSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe to artist",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCreateModal)({
                        artist: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.text,
                            children: "Subscribe"
                        })
                    ]
                })
            })
        }),
        renewSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe to artist",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionRenewModal)({
                        artist: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.text,
                            children: "Subscribe"
                        })
                    ]
                })
            })
        }),
        cancelSubscriptionNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                type: "button",
                "aria-label": "unsubscribe from artist",
                disabled: unsubscribeDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $gfND9.subscriptionOpenSubscriptionCancelModal)({
                        artist: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.icon,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).Lock, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.subscribe.content.text,
                            children: "Unsubscribe"
                        })
                    ]
                })
            })
        }),
        defaultNode: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {})
    };
    // if user found and user is artist
    if (userFetched && user && isUserArtist) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gglvX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
            css: (0, $gglvX.styles)(theme).view.user.main,
            children: [
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $gglvX.styles)(theme).view.user.profile.main,
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.profile.avatar.main,
                            children: userHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                                css: (0, $gglvX.styles)(theme).view.user.profile.avatar.image,
                                onError: ()=>setAvatarLoadError(true),
                                loading: "lazy",
                                width: "100px",
                                height: "100px",
                                src: source,
                                alt: "user avatar"
                            }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                                css: (0, $gglvX.styles)(theme).view.user.profile.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.profile.content.main,
                            children: [
                                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $gglvX.styles)(theme).view.user.profile.content.data.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.profile.content.data.name,
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.profile.content.data.username,
                                            children: [
                                                "@",
                                                username
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                    css: (0, $gglvX.styles)(theme).view.user.profile.content.genres,
                                    children: preferredGenres?.map((genre, i)=>preferredGenres.length - 1 === i ? `${genre}` : `${genre}, `)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                    css: (0, $gglvX.styles)(theme).view.user.buttons.main,
                    children: [
                        !isCurrentUserProfile && (0, $hZCPc.userUtilRenderArtistActions)(renderArtistActionsInput),
                        !isCurrentUserProfile && isUserCanReceivePayments && /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.tip.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "send tip to artist",
                                disabled: tipDisabled,
                                appearance: "primary",
                                onClick: ()=>dispatch((0, $2zsG4.tipOpenTipModal)({
                                        artist: user
                                    })),
                                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $gglvX.styles)(theme).view.user.buttons.tip.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.buttons.tip.content.icon,
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).DollarCircle, {})
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.buttons.tip.content.text,
                                            children: "Tip"
                                        })
                                    ]
                                })
                            })
                        }),
                        !isCurrentUserProfile && (isCurrentUserAdmin ? /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.block.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "block user",
                                disabled: blockDisabled,
                                appearance: "secondary",
                                onClick: ()=>dispatch((0, $kkIKc.userOpenUserBlockModal)({
                                        user: user
                                    })),
                                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $gglvX.styles)(theme).view.user.buttons.block.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.buttons.block.content.icon,
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).AlertTriangle, {})
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.buttons.block.content.text,
                                            children: "Block"
                                        })
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                            css: (0, $gglvX.styles)(theme).view.user.buttons.report.main,
                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $X9mpN.ButtonMedium), {
                                type: "button",
                                "aria-label": "report user",
                                disabled: reportDisabled,
                                appearance: "secondary",
                                onClick: ()=>dispatch((0, $6CAIO.reportOpenReportUserModal)({
                                        user: user
                                    })),
                                children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                    css: (0, $gglvX.styles)(theme).view.user.buttons.report.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.buttons.report.content.icon,
                                            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).AlertTriangle, {})
                                        }),
                                        /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                            css: (0, $gglvX.styles)(theme).view.user.buttons.report.content.text,
                                            children: "Report"
                                        })
                                    ]
                                })
                            })
                        }))
                    ]
                })
            ]
        })
    });
    // if user found but user is not artist
    if (userFetched && user) return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gglvX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
            css: (0, $gglvX.styles)(theme).view.user.main,
            children: /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                css: (0, $gglvX.styles)(theme).view.user.profile.main,
                children: [
                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                        css: (0, $gglvX.styles)(theme).view.user.profile.avatar.main,
                        children: userHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $5o6z6.jsx)("img", {
                            css: (0, $gglvX.styles)(theme).view.user.profile.avatar.image,
                            onError: ()=>setAvatarLoadError(true),
                            loading: "lazy",
                            width: "100px",
                            height: "100px",
                            src: source,
                            alt: "user avatar"
                        }) : /*#__PURE__*/ (0, $5o6z6.jsx)((0, $9IIBp.icons).User, {
                            css: (0, $gglvX.styles)(theme).view.user.profile.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                        css: (0, $gglvX.styles)(theme).view.user.profile.content.main,
                        children: [
                            /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                css: (0, $gglvX.styles)(theme).view.user.profile.content.data.main,
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                        css: (0, $gglvX.styles)(theme).view.user.profile.content.data.name,
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsxs)("div", {
                                        css: (0, $gglvX.styles)(theme).view.user.profile.content.data.username,
                                        children: [
                                            "@",
                                            username
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
                                css: (0, $gglvX.styles)(theme).view.user.profile.content.genres,
                                children: preferredGenres?.map((genre, i)=>preferredGenres.length - 1 === i ? `${genre}` : `${genre}, `)
                            })
                        ]
                    })
                ]
            })
        })
    });
    // default is progress skeleton
    return /*#__PURE__*/ (0, $5o6z6.jsx)("div", {
        css: (0, $gglvX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $agnse.SkeletonVertical), {
            containerWidth: "100%",
            sections: [
                {
                    name: `user-view-user-profile`,
                    width: "100%",
                    height: "100px",
                    isStatic: true,
                    isDivider: false
                },
                {
                    name: `user-view-user-divider`,
                    width: "100%",
                    height: "24px",
                    isStatic: true,
                    isDivider: true
                },
                {
                    name: `user-view-user-buttons`,
                    width: "100%",
                    height: "56px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$b626b6e68c81192a$export$419e08052d39e013.propTypes = {};

});
parcelRegister("gglvX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2f25c0e9cac2868c$export$9dd6ff9ea0189349; });

var $4N3Qt = parcelRequire("4N3Qt");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
function $2f25c0e9cac2868c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2f25c0e9cac2868c$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $2f25c0e9cac2868c$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2f25c0e9cac2868c$var$_ref3 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $2f25c0e9cac2868c$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2f25c0e9cac2868c$var$_ref5 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $2f25c0e9cac2868c$var$_ref6 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2f25c0e9cac2868c$var$_ref7 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $2f25c0e9cac2868c$var$_ref8 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2f25c0e9cac2868c$var$_ref9 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $2f25c0e9cac2868c$var$_ref10 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2f25c0e9cac2868c$var$_ref11 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $2f25c0e9cac2868c$var$_ref12 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2f25c0e9cac2868c$var$_ref13 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $2f25c0e9cac2868c$var$_ref14 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2f25c0e9cac2868c$var$_ref15 = {
    name: "ci2ctp",
    styles: "flex-direction:column;flex-wrap:nowrap;&>div{margin-right:0px;margin-bottom:12px;}"
};
var $2f25c0e9cac2868c$var$_ref16 = {
    name: "8ipy9y",
    styles: "display:flex;flex-direction:column;min-width:0;margin-bottom:4px"
};
var $2f25c0e9cac2868c$var$_ref17 = {
    name: "1azakc",
    styles: "text-align:center"
};
var $2f25c0e9cac2868c$var$_ref18 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $2f25c0e9cac2868c$var$_ref19 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $2f25c0e9cac2868c$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.padding.sides, ";margin-bottom:50px;", ""),
            user: {
                main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).app.screen.width.full, ";", ""),
                profile: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;margin-bottom:24px;", (0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref19), ";", ""),
                    avatar: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;align-items:center;justify-content:center;align-self:center;flex-shrink:0;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:16px;", (0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref18), ";", ""),
                        image: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $4N3Qt.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    content: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-direction:column;justify-content:space-between;min-width:0;", (0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref17), ";", ""),
                        data: {
                            main: $2f25c0e9cac2868c$var$_ref16,
                            name: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).h6, ";font-weight:bold;", ""),
                            username: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";font-size:", (0, $48E0n.typography).p, ";", "")
                        },
                        genres: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, " font-size:", (0, $48E0n.typography).p, ";", "")
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $4N3Qt.css)("display:flex;flex-wrap:wrap;min-height:56px;&>div{margin-right:20px;margin-bottom:12px;}", (0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref15), ";", ""),
                    follow: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref14), ";", ""),
                        content: {
                            main: $2f25c0e9cac2868c$var$_ref13,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    unfollow: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref12), ";", ""),
                        content: {
                            main: $2f25c0e9cac2868c$var$_ref11,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    subscribe: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref10), ";", ""),
                        content: {
                            main: $2f25c0e9cac2868c$var$_ref9,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{color:", theme.colors.primary.normal, ";}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    unsubscribe: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref8), ";", ""),
                        content: {
                            main: $2f25c0e9cac2868c$var$_ref7,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{color:", theme.colors.primary.normal, ";}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    tip: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref6), ";", ""),
                        content: {
                            main: $2f25c0e9cac2868c$var$_ref5,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.primary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    block: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref4), ";", ""),
                        content: {
                            main: $2f25c0e9cac2868c$var$_ref3,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    report: {
                        main: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile($2f25c0e9cac2868c$var$_ref2), ";", ""),
                        content: {
                            main: $2f25c0e9cac2868c$var$_ref,
                            icon: /*#__PURE__*/ (0, $4N3Qt.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.mq).mobile(/*#__PURE__*/ (0, $4N3Qt.css)((0, $48E0n.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    }
                }
            }
        }
    });

});



parcelRegister("hZCPc", function(module, exports) {

$parcel$export(module.exports, "userUtilRenderArtistActions", function () { return $9972d14fcfc31bc6$export$ec6eaa0dac0d2233; });
$parcel$export(module.exports, "userUtilGetArtistCardSkeletonSections", function () { return $9972d14fcfc31bc6$export$8d0ab8a7361ff3a3; });
const $9972d14fcfc31bc6$export$ec6eaa0dac0d2233 = ({ isCurrentUserFollowingArtist: isCurrentUserFollowingArtist, isCurrentUserSubscribedToArtist: isCurrentUserSubscribedToArtist, isCurrentUserSubscribedToArtistAtPeriodEnd: isCurrentUserSubscribedToArtistAtPeriodEnd, isArtistCanReceivePayments: isArtistCanReceivePayments, createUserFollowNode: createUserFollowNode, deleteUserFollowNode: deleteUserFollowNode, createSubscriptionNode: createSubscriptionNode, renewSubscriptionNode: renewSubscriptionNode, cancelSubscriptionNode: cancelSubscriptionNode, defaultNode: defaultNode })=>{
    // if artist is not followed
    if (!isCurrentUserFollowingArtist) return createUserFollowNode;
    // if user is subscribed to the artist and not at period end
    if (isCurrentUserSubscribedToArtist && !isCurrentUserSubscribedToArtistAtPeriodEnd) return cancelSubscriptionNode;
    // if artist is followed
    if (isCurrentUserFollowingArtist) {
        // if artist can receive payments
        if (isArtistCanReceivePayments) {
            if (isCurrentUserSubscribedToArtistAtPeriodEnd) return renewSubscriptionNode;
            return createSubscriptionNode;
        }
        return deleteUserFollowNode;
    }
    // default return is empty
    return defaultNode;
};
const $9972d14fcfc31bc6$export$8d0ab8a7361ff3a3 = (sectionName)=>[
        {
            name: `${sectionName}-avatar`,
            width: "140px",
            height: "100px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider-1`,
            width: "140px",
            height: "8px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-name`,
            width: "140px",
            height: "40px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider-2`,
            width: "140px",
            height: "8px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-username`,
            width: "140px",
            height: "62px",
            isStatic: true,
            isDivider: false
        }
    ];

});

parcelRegister("kkIKc", function(module, exports) {

$parcel$export(module.exports, "userSlice", function () { return $1c4fff40d91134af$export$c90edb45b5aad092; });
$parcel$export(module.exports, "userResetState", function () { return $1c4fff40d91134af$export$95b091457c7c126e; });
$parcel$export(module.exports, "userSetPublicArtists", function () { return $1c4fff40d91134af$export$5b63080958096df9; });
$parcel$export(module.exports, "userSetPopularArtists", function () { return $1c4fff40d91134af$export$5eb2f87cd41fdf86; });
$parcel$export(module.exports, "userSetRecommendedArtists", function () { return $1c4fff40d91134af$export$1f5a79ff50994618; });
$parcel$export(module.exports, "userSetFollowedArtists", function () { return $1c4fff40d91134af$export$69e1f58eca60607f; });
$parcel$export(module.exports, "userSetSubscribedArtists", function () { return $1c4fff40d91134af$export$a2892c430ed1a1dc; });
$parcel$export(module.exports, "userSetUser", function () { return $1c4fff40d91134af$export$8a05346d028c3871; });
$parcel$export(module.exports, "userResetUser", function () { return $1c4fff40d91134af$export$907f16420e87bb26; });
$parcel$export(module.exports, "userAppendFollowedArtist", function () { return $1c4fff40d91134af$export$c60ff6815309afb6; });
$parcel$export(module.exports, "userFilterFollowedArtist", function () { return $1c4fff40d91134af$export$46307c0efb4b0018; });
$parcel$export(module.exports, "userAppendSubscribedArtist", function () { return $1c4fff40d91134af$export$61164a8d1d941b00; });
$parcel$export(module.exports, "userFilterSubscribedArtist", function () { return $1c4fff40d91134af$export$a3bc626b1e7dba85; });
$parcel$export(module.exports, "userFilterUser", function () { return $1c4fff40d91134af$export$cf1e0592bf859245; });
$parcel$export(module.exports, "userOpenUserBlockModal", function () { return $1c4fff40d91134af$export$44502a74e0f4377f; });
$parcel$export(module.exports, "userCloseUserBlockModal", function () { return $1c4fff40d91134af$export$e0a743ddd61c5462; });
$parcel$export(module.exports, "userOpenUserProfileDeleteModal", function () { return $1c4fff40d91134af$export$f2c1fa6a0df33ec5; });
$parcel$export(module.exports, "userCloseUserProfileDeleteModal", function () { return $1c4fff40d91134af$export$3b082fcf0d20ddfa; });
$parcel$export(module.exports, "userSelectPublicArtists", function () { return $1c4fff40d91134af$export$23c096d559788db4; });
$parcel$export(module.exports, "userSelectPublicArtistsLength", function () { return $1c4fff40d91134af$export$ac031b31259b6e0f; });
$parcel$export(module.exports, "userSelectPublicArtistsCount", function () { return $1c4fff40d91134af$export$2e56e8c690b972f; });
$parcel$export(module.exports, "userSelectPublicArtistsFetched", function () { return $1c4fff40d91134af$export$1df8343bc437635; });
$parcel$export(module.exports, "userSelectPopularArtists", function () { return $1c4fff40d91134af$export$9dc108ae8036577a; });
$parcel$export(module.exports, "userSelectPopularArtistsLength", function () { return $1c4fff40d91134af$export$229458ba2c0d8138; });
$parcel$export(module.exports, "userSelectPopularArtistsCount", function () { return $1c4fff40d91134af$export$d43741d5253f8c58; });
$parcel$export(module.exports, "userSelectPopularArtistsFetched", function () { return $1c4fff40d91134af$export$e6605c226abfd042; });
$parcel$export(module.exports, "userSelectRecommendedArtists", function () { return $1c4fff40d91134af$export$d60b09565f9c16ff; });
$parcel$export(module.exports, "userSelectRecommendedArtistsLength", function () { return $1c4fff40d91134af$export$8aa37f3a9487c7f5; });
$parcel$export(module.exports, "userSelectRecommendedArtistsCount", function () { return $1c4fff40d91134af$export$fd89186b25e7e9fc; });
$parcel$export(module.exports, "userSelectRecommendedArtistsFetched", function () { return $1c4fff40d91134af$export$f0471b42de895c20; });
$parcel$export(module.exports, "userSelectFollowedArtists", function () { return $1c4fff40d91134af$export$b7870a53f8c28063; });
$parcel$export(module.exports, "userSelectFollowedArtistsLength", function () { return $1c4fff40d91134af$export$6bf8fe44ba2ca00; });
$parcel$export(module.exports, "userSelectFollowedArtistsCount", function () { return $1c4fff40d91134af$export$4587d4c4e903cb48; });
$parcel$export(module.exports, "userSelectFollowedArtistsFetched", function () { return $1c4fff40d91134af$export$b7914906285fea5f; });
$parcel$export(module.exports, "userSelectSubscribedArtists", function () { return $1c4fff40d91134af$export$4baaaf9b9c6f3333; });
$parcel$export(module.exports, "userSelectSubscribedArtistsLength", function () { return $1c4fff40d91134af$export$c72d7c987fb6d65e; });
$parcel$export(module.exports, "userSelectSubscribedArtistsCount", function () { return $1c4fff40d91134af$export$f26a972e2195b2b9; });
$parcel$export(module.exports, "userSelectSubscribedArtistsFetched", function () { return $1c4fff40d91134af$export$f699e24c41780cef; });
$parcel$export(module.exports, "userSelectUser", function () { return $1c4fff40d91134af$export$6c301dcdea48ae06; });
$parcel$export(module.exports, "userSelectUserFetched", function () { return $1c4fff40d91134af$export$6b8bdda6b6ce3d08; });
$parcel$export(module.exports, "userSelectUserBlockModalOpen", function () { return $1c4fff40d91134af$export$282d505426892166; });
$parcel$export(module.exports, "userSelectUserBlockModalUser", function () { return $1c4fff40d91134af$export$7b83910b7e617c73; });
$parcel$export(module.exports, "userSelectUserProfileDeleteModalOpen", function () { return $1c4fff40d91134af$export$5e50b65e26f8953e; });
$parcel$export(module.exports, "userSelectUserProfileDeleteModalUser", function () { return $1c4fff40d91134af$export$a8592877e5349ef8; });
$parcel$export(module.exports, "userSelectUserGetPublicArtistsLoading", function () { return $1c4fff40d91134af$export$e4239da408785ee7; });
$parcel$export(module.exports, "userSelectUserGetPopularArtistsLoading", function () { return $1c4fff40d91134af$export$aa012b1299b78ac5; });
$parcel$export(module.exports, "userSelectUserGetRecommendedArtistsLoading", function () { return $1c4fff40d91134af$export$a001f30e1f8b11c8; });
$parcel$export(module.exports, "userSelectUserGetFollowedArtistsLoading", function () { return $1c4fff40d91134af$export$83091f92560881a5; });
$parcel$export(module.exports, "userSelectUserGetSubscribedArtistsLoading", function () { return $1c4fff40d91134af$export$cc13c2995a67ae4d; });
$parcel$export(module.exports, "userSelectUserGetUserLoading", function () { return $1c4fff40d91134af$export$222d0fde7b1003fe; });
$parcel$export(module.exports, "userSelectUserBlockLoading", function () { return $1c4fff40d91134af$export$b7ed8dde37cb55e5; });
$parcel$export(module.exports, "userSelectUserProfileUpdateLoading", function () { return $1c4fff40d91134af$export$e636b7125865f0f8; });
$parcel$export(module.exports, "userSelectUserProfileDeleteLoading", function () { return $1c4fff40d91134af$export$2ab7e93c02dc0694; });
$parcel$export(module.exports, "userReducer", function () { return $1c4fff40d91134af$export$c80d1fc788ac90f9; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("fNyrl");
var $9UVKd = parcelRequire("9UVKd");
parcelRequire("dmGpj");
var $bmROr = parcelRequire("bmROr");
const $1c4fff40d91134af$var$initialState = {
    publicArtists: [],
    publicArtistsCount: 0,
    publicArtistsFetched: false,
    popularArtists: [],
    popularArtistsCount: 0,
    popularArtistsFetched: false,
    recommendedArtists: [],
    recommendedArtistsCount: 0,
    recommendedArtistsFetched: false,
    followedArtists: [],
    followedArtistsCount: 0,
    followedArtistsFetched: false,
    subscribedArtists: [],
    subscribedArtistsCount: 0,
    subscribedArtistsFetched: false,
    user: undefined,
    userFetched: false,
    userBlockModal: {
        user: undefined,
        open: false
    },
    userProfileDeleteModal: {
        user: undefined,
        open: false
    },
    userGetPublicArtistsLoading: false,
    userGetPopularArtistsLoading: false,
    userGetRecommendedArtistsLoading: false,
    userGetFollowedArtistsLoading: false,
    userGetSubscribedArtistsLoading: false,
    userGetUserLoading: false,
    userBlockLoading: false,
    userProfileUpdateLoading: false,
    userProfileDeleteLoading: false
};
const $1c4fff40d91134af$export$c90edb45b5aad092 = (0, $dEr3t.createSlice)({
    name: "user",
    initialState: $1c4fff40d91134af$var$initialState,
    reducers: {
        // reset state
        userResetState: ()=>({
                publicArtists: [],
                publicArtistsCount: 0,
                publicArtistsFetched: false,
                popularArtists: [],
                popularArtistsCount: 0,
                popularArtistsFetched: false,
                recommendedArtists: [],
                recommendedArtistsCount: 0,
                recommendedArtistsFetched: false,
                followedArtists: [],
                followedArtistsCount: 0,
                followedArtistsFetched: false,
                subscribedArtists: [],
                subscribedArtistsCount: 0,
                subscribedArtistsFetched: false,
                user: undefined,
                userFetched: false,
                userBlockModal: {
                    user: undefined,
                    open: false
                },
                userProfileDeleteModal: {
                    user: undefined,
                    open: false
                },
                userGetPublicArtistsLoading: false,
                userGetPopularArtistsLoading: false,
                userGetRecommendedArtistsLoading: false,
                userGetFollowedArtistsLoading: false,
                userGetSubscribedArtistsLoading: false,
                userGetUserLoading: false,
                userBlockLoading: false,
                userProfileUpdateLoading: false,
                userProfileDeleteLoading: false
            }),
        // set public artists
        userSetPublicArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.publicArtistsCount = count;
                // mutate public artists array
                state.publicArtists = (0, $9UVKd.mergeArraysAtIndex)(state.publicArtists, artists, offset);
            }
        },
        // set popular artists
        userSetPopularArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.popularArtistsCount = count;
                // mutate popular artists array
                state.popularArtists = (0, $9UVKd.mergeArraysAtIndex)(state.popularArtists, artists, offset);
            }
        },
        // set recommended artists
        userSetRecommendedArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.recommendedArtistsCount = count;
                // mutate recommended artists array
                state.recommendedArtists = (0, $9UVKd.mergeArraysAtIndex)(state.recommendedArtists, artists, offset);
            }
        },
        // set followed artists
        userSetFollowedArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.followedArtistsCount = count;
                // mutate followed artists array
                state.followedArtists = (0, $9UVKd.mergeArraysAtIndex)(state.followedArtists, artists, offset);
            }
        },
        // set subscribed artists
        userSetSubscribedArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.subscribedArtistsCount = count;
                // mutate subscribers artists array
                state.subscribedArtists = (0, $9UVKd.mergeArraysAtIndex)(state.subscribedArtists, artists, offset);
            }
        },
        // set user
        userSetUser: (state, action)=>{
            const { user: user } = action.payload;
            // update user state
            state.user = user;
        },
        // reset user
        userResetUser: (state)=>({
                ...state,
                user: undefined,
                userFetched: false
            }),
        // append followed artist
        userAppendFollowedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if followed artists are fetched
            if (state.followedArtistsFetched) {
                // append artist to followed artists
                state.followedArtists.unshift(artist);
                state.followedArtistsCount += 1;
            }
        },
        // filter followed artist
        userFilterFollowedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if followed artists are fetched
            if (state.followedArtistsFetched) {
                // filter artist from followed artists
                state.followedArtists = state.followedArtists.filter((a)=>a.id !== artist.id);
                state.followedArtistsCount -= 1;
            }
        },
        // append subscribed artist
        userAppendSubscribedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if subscribed artists are fetched
            if (state.subscribedArtistsFetched) {
                // append artist to subscribed artists
                state.subscribedArtists.unshift(artist);
                state.subscribedArtistsCount += 1;
            }
        },
        // filter subscribed artists
        userFilterSubscribedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if subscribed artists are fetched
            if (state.subscribedArtistsFetched) {
                // filter artist from subscribed artists
                state.subscribedArtists = state.subscribedArtists.filter((a)=>a.id !== artist.id);
                state.subscribedArtistsCount -= 1;
            }
        },
        // filter user
        userFilterUser: (state, action)=>{
            const { id: id } = action.payload;
            // check if user exists in public artists
            const pubIndex = state.publicArtists.findIndex((a)=>a.id === id);
            if (pubIndex !== -1) {
                // filter artist
                state.publicArtists = state.publicArtists.filter((a)=>a.id !== id);
                state.publicArtistsCount -= 1;
            }
            // check if user exists in popular artists
            const popIndex = state.popularArtists.findIndex((a)=>a.id === id);
            if (popIndex !== -1) {
                // filter artist
                state.popularArtists = state.popularArtists.filter((a)=>a.id !== id);
                state.popularArtistsCount -= 1;
            }
            // check if user exists in recommended artists
            const recIndex = state.recommendedArtists.findIndex((a)=>a.id === id);
            if (recIndex !== -1) {
                // filter artist
                state.recommendedArtists = state.recommendedArtists.filter((a)=>a.id !== id);
                state.recommendedArtistsCount -= 1;
            }
            // check if user exists in followed artists
            const folIndex = state.followedArtists.findIndex((a)=>a.id === id);
            if (folIndex !== -1) {
                // filter artist
                state.followedArtists = state.followedArtists.filter((a)=>a.id !== id);
                state.followedArtistsCount -= 1;
            }
            // check if user exists in subscribed artists
            const subIndex = state.subscribedArtists.findIndex((a)=>a.id === id);
            if (subIndex !== -1) {
                // filter artist
                state.subscribedArtists = state.subscribedArtists.filter((a)=>a.id !== id);
                state.subscribedArtistsCount -= 1;
            }
        },
        // open user block modal
        userOpenUserBlockModal: (state, action)=>({
                ...state,
                userBlockModal: {
                    user: action.payload.user,
                    open: true
                }
            }),
        // close user block modal
        userCloseUserBlockModal: (state)=>({
                ...state,
                userBlockModal: {
                    user: undefined,
                    open: false
                },
                error: ""
            }),
        // open user profile delete modal
        userOpenUserProfileDeleteModal: (state, action)=>({
                ...state,
                userProfileDeleteModal: {
                    user: action.payload.user,
                    open: true
                }
            }),
        // close user profile delete modal
        userCloseUserProfileDeleteModal: (state)=>({
                ...state,
                userProfileDeleteModal: {
                    user: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get public artists
        builder.addCase((0, $bmROr.userGetPublicArtists).pending, (state)=>({
                ...state,
                userGetPublicArtistsLoading: true
            })).addCase((0, $bmROr.userGetPublicArtists).fulfilled, (state)=>({
                ...state,
                publicArtistsFetched: true,
                userGetPublicArtistsLoading: false
            }));
        // get popular artists
        builder.addCase((0, $bmROr.userGetPopularArtists).pending, (state)=>({
                ...state,
                userGetPopularArtistsLoading: true
            })).addCase((0, $bmROr.userGetPopularArtists).fulfilled, (state)=>({
                ...state,
                popularArtistsFetched: true,
                userGetPopularArtistsLoading: false
            }));
        // get recommended artists
        builder.addCase((0, $bmROr.userGetRecommendedArtists).pending, (state)=>({
                ...state,
                userGetRecommendedArtistsLoading: true
            })).addCase((0, $bmROr.userGetRecommendedArtists).fulfilled, (state)=>({
                ...state,
                recommendedArtistsFetched: true,
                userGetRecommendedArtistsLoading: false
            }));
        // get followed artists
        builder.addCase((0, $bmROr.userGetFollowedArtists).pending, (state)=>({
                ...state,
                userGetFollowedArtistsLoading: true
            })).addCase((0, $bmROr.userGetFollowedArtists).fulfilled, (state)=>({
                ...state,
                followedArtistsFetched: true,
                userGetFollowedArtistsLoading: false
            }));
        // get subscribed artists
        builder.addCase((0, $bmROr.userGetSubscribedArtists).pending, (state)=>({
                ...state,
                userGetSubscribedArtistsLoading: true
            })).addCase((0, $bmROr.userGetSubscribedArtists).fulfilled, (state)=>({
                ...state,
                subscribedArtistsFetched: true,
                userGetSubscribedArtistsLoading: false
            }));
        // get user
        builder.addCase((0, $bmROr.userGetUser).pending, (state)=>({
                ...state,
                userGetUserLoading: true
            })).addCase((0, $bmROr.userGetUser).fulfilled, (state)=>({
                ...state,
                userFetched: true,
                userGetUserLoading: false
            }));
        // block user
        builder.addCase((0, $bmROr.userBlock).pending, (state)=>({
                ...state,
                userBlockLoading: true
            })).addCase((0, $bmROr.userBlock).fulfilled, (state)=>({
                ...state,
                userBlockLoading: false
            }));
        // update profile
        builder.addCase((0, $bmROr.userProfileUpdate).pending, (state)=>({
                ...state,
                userProfileUpdateLoading: true
            })).addCase((0, $bmROr.userProfileUpdate).fulfilled, (state)=>({
                ...state,
                userProfileUpdateLoading: false
            }));
        // delete profile
        builder.addCase((0, $bmROr.userProfileDelete).pending, (state)=>({
                ...state,
                userProfileDeleteLoading: true
            })).addCase((0, $bmROr.userProfileDelete).fulfilled, (state)=>({
                ...state,
                userProfileDeleteLoading: false
            }));
    }
});
const { userResetState: $1c4fff40d91134af$export$95b091457c7c126e, userSetPublicArtists: $1c4fff40d91134af$export$5b63080958096df9, userSetPopularArtists: $1c4fff40d91134af$export$5eb2f87cd41fdf86, userSetRecommendedArtists: $1c4fff40d91134af$export$1f5a79ff50994618, userSetFollowedArtists: $1c4fff40d91134af$export$69e1f58eca60607f, userSetSubscribedArtists: $1c4fff40d91134af$export$a2892c430ed1a1dc, userSetUser: $1c4fff40d91134af$export$8a05346d028c3871, userResetUser: $1c4fff40d91134af$export$907f16420e87bb26, userAppendFollowedArtist: $1c4fff40d91134af$export$c60ff6815309afb6, userFilterFollowedArtist: $1c4fff40d91134af$export$46307c0efb4b0018, userAppendSubscribedArtist: $1c4fff40d91134af$export$61164a8d1d941b00, userFilterSubscribedArtist: $1c4fff40d91134af$export$a3bc626b1e7dba85, userFilterUser: $1c4fff40d91134af$export$cf1e0592bf859245, userOpenUserBlockModal: $1c4fff40d91134af$export$44502a74e0f4377f, userCloseUserBlockModal: $1c4fff40d91134af$export$e0a743ddd61c5462, userOpenUserProfileDeleteModal: $1c4fff40d91134af$export$f2c1fa6a0df33ec5, userCloseUserProfileDeleteModal: $1c4fff40d91134af$export$3b082fcf0d20ddfa } = $1c4fff40d91134af$export$c90edb45b5aad092.actions;
const $1c4fff40d91134af$export$23c096d559788db4 = (state)=>state.user.publicArtists;
const $1c4fff40d91134af$export$ac031b31259b6e0f = (state)=>state.user.publicArtists.length;
const $1c4fff40d91134af$export$2e56e8c690b972f = (state)=>state.user.publicArtistsCount;
const $1c4fff40d91134af$export$1df8343bc437635 = (state)=>state.user.publicArtistsFetched;
const $1c4fff40d91134af$export$9dc108ae8036577a = (state)=>state.user.popularArtists;
const $1c4fff40d91134af$export$229458ba2c0d8138 = (state)=>state.user.popularArtists.length;
const $1c4fff40d91134af$export$d43741d5253f8c58 = (state)=>state.user.popularArtistsCount;
const $1c4fff40d91134af$export$e6605c226abfd042 = (state)=>state.user.popularArtistsFetched;
const $1c4fff40d91134af$export$d60b09565f9c16ff = (state)=>state.user.recommendedArtists;
const $1c4fff40d91134af$export$8aa37f3a9487c7f5 = (state)=>state.user.recommendedArtists.length;
const $1c4fff40d91134af$export$fd89186b25e7e9fc = (state)=>state.user.recommendedArtistsCount;
const $1c4fff40d91134af$export$f0471b42de895c20 = (state)=>state.user.recommendedArtistsFetched;
const $1c4fff40d91134af$export$b7870a53f8c28063 = (state)=>state.user.followedArtists;
const $1c4fff40d91134af$export$6bf8fe44ba2ca00 = (state)=>state.user.followedArtists.length;
const $1c4fff40d91134af$export$4587d4c4e903cb48 = (state)=>state.user.followedArtistsCount;
const $1c4fff40d91134af$export$b7914906285fea5f = (state)=>state.user.followedArtistsFetched;
const $1c4fff40d91134af$export$4baaaf9b9c6f3333 = (state)=>state.user.subscribedArtists;
const $1c4fff40d91134af$export$c72d7c987fb6d65e = (state)=>state.user.subscribedArtists.length;
const $1c4fff40d91134af$export$f26a972e2195b2b9 = (state)=>state.user.subscribedArtistsCount;
const $1c4fff40d91134af$export$f699e24c41780cef = (state)=>state.user.subscribedArtistsFetched;
const $1c4fff40d91134af$export$6c301dcdea48ae06 = (state)=>state.user.user;
const $1c4fff40d91134af$export$6b8bdda6b6ce3d08 = (state)=>state.user.userFetched;
const $1c4fff40d91134af$export$282d505426892166 = (state)=>state.user.userBlockModal.open;
const $1c4fff40d91134af$export$7b83910b7e617c73 = (state)=>state.user.userBlockModal.user;
const $1c4fff40d91134af$export$5e50b65e26f8953e = (state)=>state.user.userProfileDeleteModal.open;
const $1c4fff40d91134af$export$a8592877e5349ef8 = (state)=>state.user.userProfileDeleteModal.user;
const $1c4fff40d91134af$export$e4239da408785ee7 = (state)=>state.user.userGetPublicArtistsLoading;
const $1c4fff40d91134af$export$aa012b1299b78ac5 = (state)=>state.user.userGetPopularArtistsLoading;
const $1c4fff40d91134af$export$a001f30e1f8b11c8 = (state)=>state.user.userGetRecommendedArtistsLoading;
const $1c4fff40d91134af$export$83091f92560881a5 = (state)=>state.user.userGetFollowedArtistsLoading;
const $1c4fff40d91134af$export$cc13c2995a67ae4d = (state)=>state.user.userGetSubscribedArtistsLoading;
const $1c4fff40d91134af$export$222d0fde7b1003fe = (state)=>state.user.userGetUserLoading;
const $1c4fff40d91134af$export$b7ed8dde37cb55e5 = (state)=>state.user.userBlockLoading;
const $1c4fff40d91134af$export$e636b7125865f0f8 = (state)=>state.user.userProfileUpdateLoading;
const $1c4fff40d91134af$export$2ab7e93c02dc0694 = (state)=>state.user.userProfileDeleteLoading;
const $1c4fff40d91134af$export$c80d1fc788ac90f9 = $1c4fff40d91134af$export$c90edb45b5aad092.reducer; // export default userSlice.reducer

});

parcelRegister("bmROr", function(module, exports) {

$parcel$export(module.exports, "userGetPublicArtists", function () { return $37c259e240928a01$export$c59641d3fa31905d; });
$parcel$export(module.exports, "userGetPopularArtists", function () { return $37c259e240928a01$export$fc7c67c1bfe3c743; });
$parcel$export(module.exports, "userGetRecommendedArtists", function () { return $37c259e240928a01$export$303c74cf3eaba1ff; });
$parcel$export(module.exports, "userGetFollowedArtists", function () { return $37c259e240928a01$export$e1c127ca98d3f61e; });
$parcel$export(module.exports, "userGetSubscribedArtists", function () { return $37c259e240928a01$export$7605b67b67ab9697; });
$parcel$export(module.exports, "userGetUser", function () { return $37c259e240928a01$export$84db7d5abe15d4ae; });
$parcel$export(module.exports, "userBlock", function () { return $37c259e240928a01$export$62a6756e7dee00e1; });
$parcel$export(module.exports, "userProfileUpdate", function () { return $37c259e240928a01$export$eb529496f4bbc066; });
$parcel$export(module.exports, "userProfileDelete", function () { return $37c259e240928a01$export$3478c3bf87ba9dd4; });

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("ewAws");
var $jfr0f = parcelRequire("jfr0f");
parcelRequire("fNyrl");
var $ij1oT = parcelRequire("ij1oT");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $ic5m0 = parcelRequire("ic5m0");
var $fAzHC = parcelRequire("fAzHC");
var $lWbfW = parcelRequire("lWbfW");
var $jhoVP = parcelRequire("jhoVP");
var $l1Cdj = parcelRequire("l1Cdj");
var $6CAIO = parcelRequire("6CAIO");
var $1bnO9 = parcelRequire("1bnO9");
var $kkIKc = parcelRequire("kkIKc");
const $37c259e240928a01$export$c59641d3fa31905d = (0, $dEr3t.createAsyncThunk)("user/userGetPublicArtists", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve public artists
        const { artists: artists, count: count } = await api.userApi.getPublicArtists();
        // set public artists
        dispatch((0, $kkIKc.userSetPublicArtists)({
            artists: artists || [],
            count: count || 0,
            offset: 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$fc7c67c1bfe3c743 = (0, $dEr3t.createAsyncThunk)("user/userGetPopularArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getPopularArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $kkIKc.userSetPopularArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$303c74cf3eaba1ff = (0, $dEr3t.createAsyncThunk)("user/userGetRecommendedArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getRecommendedArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $kkIKc.userSetRecommendedArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$e1c127ca98d3f61e = (0, $dEr3t.createAsyncThunk)("user/userGetFollowedArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getFollowedArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $kkIKc.userSetFollowedArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$7605b67b67ab9697 = (0, $dEr3t.createAsyncThunk)("user/userGetSubscribedArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getSubscribedArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $kkIKc.userSetSubscribedArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$84db7d5abe15d4ae = (0, $dEr3t.createAsyncThunk)("user/userGetUser", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // retrieve user
        const { user: user } = await api.userApi.getUser(inp.userId);
        // set user
        dispatch((0, $kkIKc.userSetUser)({
            user: user || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$62a6756e7dee00e1 = (0, $dEr3t.createAsyncThunk)("user/userBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // block user
        await api.userApi.blockUser({
            userId: id
        });
        // reset user page state
        dispatch((0, $kkIKc.userResetUser)());
        // filter blocked user from users
        dispatch((0, $kkIKc.userFilterUser)({
            id: id
        }));
        // filter blocked user tracks from tracks
        dispatch((0, $1bnO9.trackFilterUserTracks)({
            userId: id
        }));
        // filter blocked user tracks from audio player
        dispatch((0, $jhoVP.playerAudioFilterPlaylistUserTracks)({
            userId: id
        }));
        // filter blocked user posts from posts
        dispatch((0, $l1Cdj.postFilterUserPosts)({
            userId: id
        }));
        // filter blocked user comments from comments
        dispatch((0, $lWbfW.commentFilterUserComments)({
            userId: id
        }));
        // set user as blocked in the report state
        dispatch((0, $6CAIO.reportSetReportUserBlocked)());
        // close user block modal
        dispatch((0, $kkIKc.userCloseUserBlockModal)());
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully blocked user!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to block user: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$eb529496f4bbc066 = (0, $dEr3t.createAsyncThunk)("user/userProfileUpdate", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $jfr0f.apiGetService)();
    try {
        // if avatar provided
        if (inp.avatar) {
            // create form data
            const formData = new FormData();
            // append avatar
            formData.append("file", inp.avatar);
            // update user avatar
            const { user: user } = await api.userApi.updateUserProfileAvatar({
                body: formData
            });
            // update profile
            dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        }
        // if name or preferred genres provided
        if (inp.name || inp.preferredGenres) {
            // update user name and preferred genres
            const { user: user } = await api.userApi.updateUserProfile({
                name: inp.name,
                preferredGenres: inp.preferredGenres
            });
            // update profile
            dispatch((0, $fAzHC.authUpdateProfile)(user || {}));
        }
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully updated user profile!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to update user profile: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37c259e240928a01$export$3478c3bf87ba9dd4 = (0, $dEr3t.createAsyncThunk)("user/userProfileDelete", async (inp, { dispatch: dispatch })=>{
    // get api service
    // const api = apiGetService()
    try {
        // TODO: implement
        // are you sure you want to delete your profile?
        // on confirm click
        // 1. send email with termination code
        // 2. update modal to render input field
        // on delete click
        // 1. delete user profile
        // 2. log user out
        // launch info alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Info,
                message: "Successfully deleted user profile!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $jfr0f.apiHandleError)(err);
        // launch error alert
        dispatch((0, $joOpk.alertAddMessage)({
            message: {
                id: (0, $ij1oT.uuid)(),
                type: (0, $ic5m0.AlertMessageType).Error,
                message: `Failed to delete user profile: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});



parcelRegister("l4haS", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("bAuP4")).then(()=>parcelRequire("hIEnX"));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("5LlF9", function(module, exports) {
module.exports = "#clip0_1023_837";

});


var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";

var $d2lNW = parcelRequire("d2lNW");
var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $d2lNW.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $d2lNW.hydrateRoot;



var $5o6z6 = parcelRequire("5o6z6");

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $3QeX2 = parcelRequire("3QeX2");

var $exYeM = parcelRequire("exYeM");
"use client";
const $547671bb2149111f$export$b16d9fb1a22de840 = (0, $exYeM.createContext)(null);
const $547671bb2149111f$var$initialState = {
    didCatch: false,
    error: null
};
class $547671bb2149111f$export$e926676385687eaf extends (0, $exYeM.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $547671bb2149111f$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($547671bb2149111f$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $547671bb2149111f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($547671bb2149111f$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $exYeM.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $exYeM.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $exYeM.createElement)($547671bb2149111f$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $547671bb2149111f$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $547671bb2149111f$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $547671bb2149111f$export$c052f6604b7d51fe() {
    const context = (0, $exYeM.useContext)($547671bb2149111f$export$b16d9fb1a22de840);
    $547671bb2149111f$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $exYeM.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $exYeM.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $547671bb2149111f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $exYeM.forwardRef)((props, ref)=>(0, $exYeM.createElement)($547671bb2149111f$export$e926676385687eaf, errorBoundaryProps, (0, $exYeM.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



var $5o6z6 = parcelRequire("5o6z6");

var $8is9z = parcelRequire("8is9z");

var $dEr3t = parcelRequire("dEr3t");
parcelRequire("2uUQU");
var $9VYkD = parcelRequire("9VYkD");
parcelRequire("dmGpj");
var $joOpk = parcelRequire("joOpk");
var $fAzHC = parcelRequire("fAzHC");
var $lWbfW = parcelRequire("lWbfW");
var $c1P9M = parcelRequire("c1P9M");
var $7YE0x = parcelRequire("7YE0x");
var $5Dw49 = parcelRequire("5Dw49");
var $11Nfd = parcelRequire("11Nfd");
var $6VkZt = parcelRequire("6VkZt");
var $bLoEn = parcelRequire("bLoEn");
var $j6i5c = parcelRequire("j6i5c");
var $jhoVP = parcelRequire("jhoVP");
var $l1Cdj = parcelRequire("l1Cdj");
var $6CAIO = parcelRequire("6CAIO");
var $7gLya = parcelRequire("7gLya");
var $k6Dml = parcelRequire("k6Dml");
var $gfND9 = parcelRequire("gfND9");
var $3AsAO = parcelRequire("3AsAO");
var $2zsG4 = parcelRequire("2zsG4");
var $1bnO9 = parcelRequire("1bnO9");
var $9vtCE = parcelRequire("9vtCE");
var $eFMHm = parcelRequire("eFMHm");
var $kkIKc = parcelRequire("kkIKc");
const $6aae683978ac43d1$export$6f57813fe9f31bf9 = (0, $dEr3t.configureStore)({
    reducer: {
        alert: (0, $joOpk.alertReducer),
        auth: (0, $fAzHC.authReducer),
        comment: (0, $lWbfW.commentReducer),
        connect: (0, $c1P9M.connectReducer),
        customer: (0, $7YE0x.customerReducer),
        like: (0, $5Dw49.likeReducer),
        navigation: (0, $11Nfd.navigationReducer),
        notification: (0, $6VkZt.notificationReducer),
        onboarding: (0, $bLoEn.onboardingReducer),
        payment: (0, $j6i5c.paymentReducer),
        player: (0, $jhoVP.playerReducer),
        post: (0, $l1Cdj.postReducer),
        report: (0, $6CAIO.reportReducer),
        search: (0, $7gLya.searchReducer),
        stream: (0, $k6Dml.streamReducer),
        subscription: (0, $gfND9.subscriptionReducer),
        theme: (0, $3AsAO.themeReducer),
        tip: (0, $2zsG4.tipReducer),
        track: (0, $1bnO9.trackReducer),
        transaction: (0, $9vtCE.transactionReducer),
        unlock: (0, $eFMHm.unlockReducer),
        user: (0, $kkIKc.userReducer)
    },
    // remove devtools for production
    devTools: "staging" !== (0, $9VYkD.Environment).Production
});


const $88e2632d65f74ddd$export$34db86d2336a2a8e = ({ children: children })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $8is9z.Provider), {
        store: (0, $6aae683978ac43d1$export$6f57813fe9f31bf9),
        children: children
    });



var $5o6z6 = parcelRequire("5o6z6");

var $4N3Qt = parcelRequire("4N3Qt");
var $hXJcm = parcelRequire("hXJcm");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $3AsAO = parcelRequire("3AsAO");
parcelRequire("1SE81");
var $48E0n = parcelRequire("48E0n");
const $dd6ddffbc9d53d56$export$d8964aec282183a3 = ({ children: children })=>{
    const currentTheme = (0, $9CcOD.useAppSelector)((0, $3AsAO.themeSelectCurrentTheme));
    const theme = (0, $48E0n.getTheme)(currentTheme);
    const global = (0, $48E0n.getGlobal)(currentTheme);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $hXJcm.b), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $5o6z6.jsx)((0, $4N3Qt.Global), {
                styles: global
            }),
            children
        ]
    });
};



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");
parcelRequire("11A9z");
var $glGsK = parcelRequire("glGsK");
parcelRequire("dmGpj");
var $2sNJT = parcelRequire("2sNJT");
const $8c93044518b13e15$export$87091915187a1a85 = ({ children: children })=>{
    const dispatch = (0, $glGsK.useAppDispatch)();
    (0, $exYeM.useEffect)(()=>{
        dispatch((0, $2sNJT.authRefresh)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $5o6z6.Fragment), {
        children: [
            " ",
            children,
            " "
        ]
    });
};


parcelRequire("fRVt8");
var $ewr9k = parcelRequire("ewr9k");
var $b8aBK = parcelRequire("b8aBK");
const $bbcdba6b11473fe2$export$c7dacf3845253dcf = ({ children: children })=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
        fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $b8aBK.SuspenseMainFallback), {}),
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $547671bb2149111f$export$e926676385687eaf), {
            FallbackComponent: (0, $ewr9k.ErrorFallback),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $88e2632d65f74ddd$export$34db86d2336a2a8e), {
                children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $dd6ddffbc9d53d56$export$d8964aec282183a3), {
                    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $8c93044518b13e15$export$87091915187a1a85), {
                        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3QeX2.BrowserRouter), {
                            children: children
                        })
                    })
                })
            })
        })
    });





var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2gkJV");
var $aeAwZ = parcelRequire("aeAwZ");
parcelRequire("11A9z");
var $9CcOD = parcelRequire("9CcOD");
parcelRequire("dmGpj");
var $fAzHC = parcelRequire("fAzHC");

var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("fRVt8");
var $91dtq = parcelRequire("91dtq");
var $ZGlkY = parcelRequire("ZGlkY");
parcelRequire("fNyrl");
var $hzuqN = parcelRequire("hzuqN");

// pages
const { ChartsPage: $5497224909375d34$var$ChartsPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ChartsPage");

const { FeedPage: $5497224909375d34$var$FeedPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "FeedPage");

const { LibraryPage: $5497224909375d34$var$LibraryPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "LibraryPage");

const { NotificationsPage: $5497224909375d34$var$NotificationsPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "NotificationsPage");

const { NotificationsNotificationPage: $5497224909375d34$var$NotificationsNotificationPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "NotificationsNotificationPage");

const { PostPage: $5497224909375d34$var$PostPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "PostPage");

const { ProfilePage: $5497224909375d34$var$ProfilePage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ProfilePage");

const { ReportsPage: $5497224909375d34$var$ReportsPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ReportsPage");

const { ReportsReportComplaintPage: $5497224909375d34$var$ReportsReportComplaintPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ReportsReportComplaintPage");

const { ReportsReportPage: $5497224909375d34$var$ReportsReportPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ReportsReportPage");

const { UserPage: $5497224909375d34$var$UserPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "UserPage");
const $5497224909375d34$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $91dtq.AppLayout), {
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
            fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
        })
    });
const $5497224909375d34$export$37e8e188eda774db = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$App, {}),
        children: [
            {
                path: (0, $9YTSb.Path).Library,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$LibraryPage, {})
            },
            {
                path: (0, $9YTSb.Path).Charts,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$ChartsPage, {})
            },
            {
                path: `${(0, $9YTSb.Path).Reports}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$ReportsPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Path).Report}/*`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: `${(0, $9YTSb.Params).ReportID}`,
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$ReportsReportPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: `${(0, $9YTSb.Params).ReportID}${(0, $9YTSb.Path).Complaint}/*`,
                                        element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                                            children: [
                                                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                                    path: `${(0, $9YTSb.Params).ReportComplaintID}`,
                                                    element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$ReportsReportComplaintPage, {})
                                                }),
                                                /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                                        to: "."
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $9YTSb.Path).Profile,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$ProfilePage, {})
            },
            {
                path: `${(0, $9YTSb.Path).Notifications}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$NotificationsPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Path).Notification}/*`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: `${(0, $9YTSb.Params).NotificationID}`,
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$NotificationsNotificationPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $9YTSb.Path).User}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Params).UserID}`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$UserPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $9YTSb.Path).Post}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Params).PostID}`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$PostPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $9YTSb.Path).Feed,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($5497224909375d34$var$FeedPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("fRVt8");
var $91dtq = parcelRequire("91dtq");
var $ZGlkY = parcelRequire("ZGlkY");
parcelRequire("fNyrl");
var $hzuqN = parcelRequire("hzuqN");

// pages
const { ChartsPage: $78c2d275018dfafb$var$ChartsPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ChartsPage");

const { FeedPage: $78c2d275018dfafb$var$FeedPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "FeedPage");

const { LibraryPage: $78c2d275018dfafb$var$LibraryPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "LibraryPage");

const { NotificationsPage: $78c2d275018dfafb$var$NotificationsPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "NotificationsPage");

const { NotificationsNotificationPage: $78c2d275018dfafb$var$NotificationsNotificationPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "NotificationsNotificationPage");

const { PostPage: $78c2d275018dfafb$var$PostPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "PostPage");

const { ProfilePage: $78c2d275018dfafb$var$ProfilePage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ProfilePage");

const { StudioCreatePostPage: $78c2d275018dfafb$var$StudioCreatePostPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "StudioCreatePostPage");

const { StudioCreateTrackPage: $78c2d275018dfafb$var$StudioCreateTrackPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "StudioCreateTrackPage");

const { StudioEditPostPage: $78c2d275018dfafb$var$StudioEditPostPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "StudioEditPostPage");

const { StudioEditTrackPage: $78c2d275018dfafb$var$StudioEditTrackPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "StudioEditTrackPage");

const { StudioPage: $78c2d275018dfafb$var$StudioPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "StudioPage");

const { UserPage: $78c2d275018dfafb$var$UserPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "UserPage");
const $78c2d275018dfafb$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $91dtq.AppLayout), {
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
            fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
        })
    });
const $78c2d275018dfafb$export$3da569daebda94b = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$App, {}),
        children: [
            {
                path: (0, $9YTSb.Path).Library,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$LibraryPage, {})
            },
            {
                path: (0, $9YTSb.Path).Charts,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$ChartsPage, {})
            },
            {
                path: `${(0, $9YTSb.Path).Studio}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$StudioPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Path).Post}/*`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$StudioCreatePostPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: `${(0, $9YTSb.Params).PostID}`,
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$StudioEditPostPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Path).Track}/*`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$StudioCreateTrackPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: `${(0, $9YTSb.Params).TrackID}`,
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$StudioEditTrackPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $9YTSb.Path).Profile,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$ProfilePage, {})
            },
            {
                path: `${(0, $9YTSb.Path).Notifications}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$NotificationsPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Path).Notification}/*`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: `${(0, $9YTSb.Params).NotificationID}`,
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$NotificationsNotificationPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $9YTSb.Path).User}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Params).UserID}`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$UserPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $9YTSb.Path).Post}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Params).PostID}`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$PostPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $9YTSb.Path).Feed,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($78c2d275018dfafb$var$FeedPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("2uUQU");
var $9YTSb = parcelRequire("9YTSb");
parcelRequire("fRVt8");
var $91dtq = parcelRequire("91dtq");
var $ZGlkY = parcelRequire("ZGlkY");
parcelRequire("fNyrl");
var $hzuqN = parcelRequire("hzuqN");

// pages
const { ChartsPage: $11b3e08696e2a8df$var$ChartsPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ChartsPage");

const { FeedPage: $11b3e08696e2a8df$var$FeedPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "FeedPage");

const { LibraryPage: $11b3e08696e2a8df$var$LibraryPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "LibraryPage");

const { NotificationsPage: $11b3e08696e2a8df$var$NotificationsPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "NotificationsPage");

const { NotificationsNotificationPage: $11b3e08696e2a8df$var$NotificationsNotificationPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "NotificationsNotificationPage");

const { PostPage: $11b3e08696e2a8df$var$PostPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "PostPage");

const { ProfilePage: $11b3e08696e2a8df$var$ProfilePage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "ProfilePage");

const { UserPage: $11b3e08696e2a8df$var$UserPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "UserPage");
const $11b3e08696e2a8df$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $91dtq.AppLayout), {
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
            fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
        })
    });
const $11b3e08696e2a8df$export$5e62f40422be0a85 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$App, {}),
        children: [
            {
                path: (0, $9YTSb.Path).Library,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$LibraryPage, {})
            },
            {
                path: (0, $9YTSb.Path).Charts,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$ChartsPage, {})
            },
            {
                path: (0, $9YTSb.Path).Profile,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$ProfilePage, {})
            },
            {
                path: `${(0, $9YTSb.Path).Notifications}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$NotificationsPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Path).Notification}/*`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: `${(0, $9YTSb.Params).NotificationID}`,
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$NotificationsNotificationPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $9YTSb.Path).User}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Params).UserID}`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$UserPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $9YTSb.Path).Post}/*`,
                element: /*#__PURE__*/ (0, $5o6z6.jsxs)((0, $fbE6a.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: `${(0, $9YTSb.Params).PostID}`,
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$PostPage, {})
                        }),
                        /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $9YTSb.Path).Feed,
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($11b3e08696e2a8df$var$FeedPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("fRVt8");
var $ZGlkY = parcelRequire("ZGlkY");
parcelRequire("fNyrl");
var $hzuqN = parcelRequire("hzuqN");

const { LockPage: $cf0063efcaccc0e5$var$LockPage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "LockPage");
const $cf0063efcaccc0e5$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
        fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
            position: "full"
        }),
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
    });
const $cf0063efcaccc0e5$export$2e9c4093195dd337 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($cf0063efcaccc0e5$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($cf0063efcaccc0e5$var$LockPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("fRVt8");
var $kR3Jw = parcelRequire("kR3Jw");
var $ZGlkY = parcelRequire("ZGlkY");
parcelRequire("fNyrl");
var $hzuqN = parcelRequire("hzuqN");

const { Onboarding: $5c50ff004791e796$var$Onboarding } = (0, $hzuqN.importsLazy)(()=>Promise.resolve((parcelRequire("dmGpj"))), "Onboarding");
const $5c50ff004791e796$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $kR3Jw.MainLayout), {
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
            fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
                position: "full"
            }),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
        })
    });
const $5c50ff004791e796$export$aa6e74b9feedcc7d = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($5c50ff004791e796$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($5c50ff004791e796$var$Onboarding, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("fRVt8");
var $91dtq = parcelRequire("91dtq");
var $ZGlkY = parcelRequire("ZGlkY");
parcelRequire("fNyrl");
var $hzuqN = parcelRequire("hzuqN");

const { HomePage: $942477a3364e8e00$var$HomePage } = (0, $hzuqN.importsLazy)(()=>(parcelRequire("l4haS")), "HomePage");
const $942477a3364e8e00$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $91dtq.AppLayout), {
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
            fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
        })
    });
const $942477a3364e8e00$export$a1b9292f6ba50096 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($942477a3364e8e00$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($942477a3364e8e00$var$HomePage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("fRVt8");
var $ZGlkY = parcelRequire("ZGlkY");
parcelRequire("fNyrl");
var $hzuqN = parcelRequire("hzuqN");

const { AuthVerificationModal: $eca95a43310baf8d$var$AuthVerificationModal } = (0, $hzuqN.importsLazy)(()=>Promise.resolve((parcelRequire("dmGpj"))), "AuthVerificationModal");
const $eca95a43310baf8d$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
        fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
            position: "full"
        }),
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
    });
const $eca95a43310baf8d$export$4977544b3720659f = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($eca95a43310baf8d$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)($eca95a43310baf8d$var$AuthVerificationModal, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $5o6z6 = parcelRequire("5o6z6");

var $exYeM = parcelRequire("exYeM");

var $fbE6a = parcelRequire("fbE6a");
parcelRequire("fRVt8");
var $ZGlkY = parcelRequire("ZGlkY");
const $492e8f13d84b4b88$var$App = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $exYeM.Suspense), {
        fallback: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
            position: "full"
        }),
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Outlet), {})
    });
const $492e8f13d84b4b88$export$73d4a3d2a9928475 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5o6z6.jsx)($492e8f13d84b4b88$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $ZGlkY.SuspenseContentFallback), {
                    position: "full"
                })
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $fbE6a.Navigate), {
                    to: "."
                })
            }
        ]
    }
];


const $3de63c50d3e3ff05$export$37d3279522fbf5e2 = ()=>{
    const profile = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectProfile));
    const emailVerified = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectEmailVerified));
    const authRefreshing = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectRefreshing));
    const authPlatformLocked = (0, $9CcOD.useAppSelector)((0, $fAzHC.authSelectPlatformLocked));
    const platformLocked = !authRefreshing && authPlatformLocked;
    const userSignedOut = !authPlatformLocked && !authRefreshing && !profile;
    const emailIsNotVerified = !authPlatformLocked && !authRefreshing && !emailVerified && profile;
    const onboardingIsNotFinished = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage !== (0, $aeAwZ.EntityOnboardingStage).Finished;
    const userIsFan = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage === (0, $aeAwZ.EntityOnboardingStage).Finished && profile.role === (0, $aeAwZ.EntityUserRole).Fan;
    const userIsArtist = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage === (0, $aeAwZ.EntityOnboardingStage).Finished && profile.role === (0, $aeAwZ.EntityUserRole).Artist;
    const userIsAdmin = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage === (0, $aeAwZ.EntityOnboardingStage).Finished && profile.role === (0, $aeAwZ.EntityUserRole).Admin;
    // default to refreshing routes
    let routes = (0, $492e8f13d84b4b88$export$73d4a3d2a9928475);
    // TODO: remove platform lock once no longer needed
    if (platformLocked) // set locked routes
    routes = (0, $cf0063efcaccc0e5$export$2e9c4093195dd337);
    if (userSignedOut) // set public routes
    routes = (0, $942477a3364e8e00$export$a1b9292f6ba50096);
    if (emailIsNotVerified) // set verification routes
    routes = (0, $eca95a43310baf8d$export$4977544b3720659f);
    if (onboardingIsNotFinished) // set onboarding routes
    routes = (0, $5c50ff004791e796$export$aa6e74b9feedcc7d);
    if (userIsFan) // render fan routes
    routes = (0, $11b3e08696e2a8df$export$5e62f40422be0a85);
    if (userIsArtist) // render artist routes
    routes = (0, $78c2d275018dfafb$export$3da569daebda94b);
    if (userIsAdmin) // render admin routes
    routes = (0, $5497224909375d34$export$37e8e188eda774db);
    const element = (0, $fbE6a.useRoutes)([
        ...routes
    ]);
    return element;
};


const $26c28601dd21ca71$export$86fbec116b87613f = ()=>/*#__PURE__*/ (0, $5o6z6.jsx)((0, $bbcdba6b11473fe2$export$c7dacf3845253dcf), {
        children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $3de63c50d3e3ff05$export$37d3279522fbf5e2), {})
    });


const $7d0d880cf2ba634e$var$container = document.getElementById("app");
const $7d0d880cf2ba634e$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)($7d0d880cf2ba634e$var$container);
$7d0d880cf2ba634e$var$root.render(/*#__PURE__*/ (0, $5o6z6.jsx)($exYeM.StrictMode, {
    children: /*#__PURE__*/ (0, $5o6z6.jsx)((0, $26c28601dd21ca71$export$86fbec116b87613f), {})
}));

})();
//# sourceMappingURL=index.11339f37.js.map
